webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1180);
	module.exports = __webpack_require__(850);


/***/ }),
/* 1 */
[3180, 2908],
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(1755);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(1788);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(161);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(617);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(138)(module)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(2828);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(2829);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(2747)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var core = __webpack_require__(100);
	var hide = __webpack_require__(77);
	var redefine = __webpack_require__(78);
	var ctx = __webpack_require__(95);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1185);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1184);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(126);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(126);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(320);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1271), __esModule: true };

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(486);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(766);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(765);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(2833);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(2832);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	function assertString(input) {
	  if (typeof input !== 'string') {
	    throw new TypeError('This library (validator.js) validates strings only');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// import classnames utility
	
	
	// js utility functions
	
	
	// import modified component from material UI
	
	
	// import material UI element with slightly modified source code
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_SourceModMenuItem = __webpack_require__(166);
	
	var _c_SourceModMenuItem2 = _interopRequireDefault(_c_SourceModMenuItem);
	
	var _c_SourceModDropDown = __webpack_require__(202);
	
	var _c_SourceModDropDown2 = _interopRequireDefault(_c_SourceModDropDown);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropdownStyle = {
	  // overflow: 'hidden'
	};
	
	var menuCustomization = {
	  autoWidth: false,
	  menuStyle: {
	    overflowX: 'hidden',
	    width: '100%',
	    backgroundColor: '#fafafa'
	  },
	  labelStyle: {
	    color: 'rgb(33, 35, 38)',
	    maxWidth: '100%',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    fontSize: '16px',
	    height: '48px'
	  },
	  listStyle: {
	    backgroundColor: '#fafafa',
	    fontWeight: 400,
	    width: '100%',
	    color: 'red'
	  },
	  floatingLabelText: {
	    color: 'rgb(33, 35, 38)'
	  },
	  selectedMenuItemStyle: {
	    padding: 0,
	    color: 'rgb(33,35,38)',
	    backgroundColor: '#eee'
	  },
	  popoverStyle: {
	    transition: 'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1), width 1000ms cubic-bezier(0.23, 1, 0.32, 1)'
	  }
	};
	
	var menuItemCustomization = {
	  disableTouchRipple: true,
	  disableFocusRipple: true
	};
	
	var CustomDropDownMenu = (_temp2 = _class = function (_Component) {
	  _inherits(CustomDropDownMenu, _Component);
	
	  function CustomDropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CustomDropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomDropDownMenu.__proto__ || Object.getPrototypeOf(CustomDropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: null,
	      errors: [],
	      dirty: false,
	      primaryText: _this.props.primaryText || 'Select',
	      subElement: null
	    }, _this.validate = function (value, mergeObj) {
	
	      if (_this.props.validation) {
	        var errorsObj = {
	          errors: (0, _modelValidator.validateField)(value, _this.props.validation)
	        };
	        if (errorsObj.errors.length !== _this.state.errors.length) {
	          if (_this.props.onErrorChange) {
	            _this.props.onErrorChange(errorsObj.errors.length > _this.state.errors ? 1 : -1);
	          }
	          _this.setState(function (state) {
	            return _lodash2.default.assign({}, state, errorsObj, mergeObj || {});
	          });
	        } else if (_lodash2.default.size(mergeObj)) {
	          _this.setState(function (state) {
	            return _lodash2.default.assign({}, state, mergeObj);
	          });
	        }
	      } else if (_lodash2.default.size(mergeObj)) {
	        _this.setState(function (state) {
	          return _lodash2.default.assign({}, state, mergeObj);
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CustomDropDownMenu, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // used to keep track of mounting state updates
	      this.detectAndValidateChanges({});
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // sync local state value
	      if (this.props.value !== nextProps.value) {
	        this.validate(nextProps.value, {
	          value: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var receivedValidation = !_lodash2.default.isEqual(this.props.validation, prevProps.validation);
	      if (receivedValidation) {
	        var value = 0;
	        this.validate(value, {
	          value: value
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      if (this.props.onBlur) {
	        this.props.onBlur(event);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event, index, value) {
	      var _this2 = this;
	
	      // handle edge case of user re-selecting select
	      var selectWasSelected = value === null;
	
	      // need to take select into account (if they just selected something else but were on select)
	      var selectPreviouslySelected = _lodash2.default.isNil(this.state.value);
	      var adjIndex = selectPreviouslySelected ? index - 1 : index;
	
	      // send primaryText and subElement values to callback too
	      var menuItem = this.props.menuItems[adjIndex] || {};
	      var primaryText = selectWasSelected ? null : menuItem.primaryText || menuItem.name || value;
	      var subElement = selectWasSelected ? null : menuItem.subElement;
	
	      var adjValue = value === 'Yes' ? true : value === 'No' ? false : value;
	
	      // update local state
	      if (!this.props.hasOwnProperty('value')) {
	        this.validate(value, {
	          value: value,
	          subElement: subElement
	        });
	      } else {
	        this.setState(function (state) {
	          return _lodash2.default.assign({}, state, {
	            value: _lodash2.default.get(_this2.props, 'staticValue', value),
	            subElement: subElement
	          });
	        });
	      }
	
	      if (this.props.onChange) {
	        this.props.onChange(event, adjValue, primaryText, subElement);
	      }
	      if (this.props.onBlur) {
	        this.props.onBlur(event, adjValue, primaryText, subElement);
	      }
	    }
	  }, {
	    key: 'detectAndValidateChanges',
	    value: function detectAndValidateChanges(stateUpdateObj) {
	      var initVal = stateUpdateObj.value || this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : null;
	
	      if (!_lodash2.default.isNil(initVal)) {
	        stateUpdateObj.value = initVal;
	        var currentMenuItem = this.props.menuItems.find(function (menuItem) {
	          return menuItem.value === initVal || menuItem.id === initVal || menuItem === initVal;
	        });
	        if (!currentMenuItem) {
	          // issue warning if no menu item matches the selected menu item;
	          console.warn('value: ' + initVal + ' does not have corresponding menu item'); /* eslint no-console:0 */
	        } else if (currentMenuItem.subElement) {
	          stateUpdateObj.subElement = currentMenuItem.subElement;
	        }
	      }
	
	      // handles validation state update
	      this.validate(initVal, stateUpdateObj);
	    }
	  }, {
	    key: 'checkErrors',
	    value: function checkErrors() {
	      this.setState(function (state) {
	        return state.dirty ? state : _lodash2.default.assign({}, state, { dirty: true });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // take out properties that will be overwritten from 'this.props'
	      var canAutoPosition = this.props.canAutoPosition === undefined ? true : this.props.canAutoPosition;
	
	      var _props = this.props,
	          className = _props.className,
	          value = _props.value,
	          defaultValue = _props.defaultValue,
	          onChange = _props.onChange,
	          onBlur = _props.onBlur,
	          style = _props.style,
	          dataId = _props['data-id'],
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          containerStyle = _props.containerStyle,
	          includeDefault = _props.includeDefault,
	          propsMenuItemCustomization = _props.menuItemCustomization,
	          propsSelectedMenuItemStyle = _props.selectedMenuItemStyle,
	          propsListStyle = _props.listStyle,
	          propsMenuStyle = _props.menuStyle,
	          propsLabelStyle = _props.labelStyle,
	          propsIconStyle = _props.iconStyle,
	          unmodifiedProps = _objectWithoutProperties(_props, ['className', 'value', 'defaultValue', 'onChange', 'onBlur', 'style', 'data-id', 'floatingLabelText', 'floatingLabelStyle', 'containerStyle', 'includeDefault', 'menuItemCustomization', 'selectedMenuItemStyle', 'listStyle', 'menuStyle', 'labelStyle', 'iconStyle']);
	
	      var additionalProps = {
	        onChange: this.onChange.bind(this),
	        style: _lodash2.default.merge({}, style, dropdownStyle)
	      };
	
	      if (_lodash2.default.isNil(this.state.value)) {
	        additionalProps.value = null;
	      } else {
	        additionalProps.value = _typeof(this.state.value) !== 'object' ? this.state.value : this.state.value.hasOwnProperty('value') ? this.state.value.value : this.state.value.hasOwnProperty('id') ? this.state.value.id : null;
	      }
	
	      // list style
	      if (propsListStyle) {
	        additionalProps.listStyle = _lodash2.default.merge({}, menuCustomization.listStyle, propsListStyle);
	      }
	
	      // menu style
	      if (propsMenuStyle) {
	        additionalProps.listStyle = _lodash2.default.merge({}, menuCustomization.menuStyle, propsMenuStyle);
	      }
	
	      if (propsSelectedMenuItemStyle) {
	        additionalProps.selectedMenuItemStyle = _lodash2.default.merge({}, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle);
	      }
	
	      var redfloatingLabelStyle = {};
	      // if dropdown value is null (displaying 'Select') make text gray
	      if (this.state.dirty && this.state.errors.length) {
	        additionalProps.labelStyle = _lodash2.default.merge({}, menuCustomization.labelStyle, propsLabelStyle, {
	          color: 'rgb(244, 67, 54)'
	        });
	        additionalProps.errorText = this.state.errors.join(', ');
	        redfloatingLabelStyle = {
	          color: 'rgb(244, 67, 54)'
	        };
	        additionalProps.iconStyle = {
	          fill: 'rgb(244, 67, 54)'
	        };
	        additionalProps.underlineStyle = {
	          borderTop: 'solid 1px rgb(244, 67, 54)'
	        };
	      } else if (additionalProps.value === null) {
	        additionalProps.labelStyle = _lodash2.default.merge({}, menuCustomization.labelStyle, propsLabelStyle, {
	          color: '#212326',
	          fontWeight: 'normal'
	        });
	      } else if (propsLabelStyle) {
	        additionalProps.labelStyle = _lodash2.default.merge({}, menuCustomization.labelStyle, propsLabelStyle);
	        additionalProps.iconStyle = _lodash2.default.merge({}, menuCustomization.iconStyle, propsIconStyle);
	      }
	      var invalidCurrentItem = !this.props.menuItems.find(function (menuItem) {
	        return menuItem.value === additionalProps.value || menuItem.id === additionalProps.value || menuItem === additionalProps.value;
	      });
	      var startWithSelect = !!~[null, ''].indexOf(additionalProps.value);
	      if (startWithSelect) {
	        additionalProps.selectedMenuItemStyle = _lodash2.default.merge(additionalProps.selectedMenuItemStyle, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle || {}, {
	          padding: 0,
	          backgroundColor: '#fafafa',
	          cursor: 'default'
	        });
	      } else if (propsSelectedMenuItemStyle) {
	        additionalProps.selectedMenuItemStyle = _lodash2.default.merge({}, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('clearfix', 'dropdown-wrapper', className, { disabled: this.props.disabled, optional: this.props.optional }), style: containerStyle },
	        floatingLabelText && _react2.default.createElement(
	          'div',
	          { className: 'floatingLabelText', 'data-id': dataId + ' floatingLabelText', style: floatingLabelStyle || redfloatingLabelStyle || {} },
	          floatingLabelText
	        ),
	        _react2.default.createElement(
	          _c_SourceModDropDown2.default,
	          _extends({ className: 'dropdown',
	            'data-id': dataId,
	            canAutoPosition: canAutoPosition
	          }, menuCustomization, unmodifiedProps, additionalProps),
	          (startWithSelect || includeDefault || invalidCurrentItem) && _react2.default.createElement(_c_SourceModMenuItem2.default, _extends({ value: includeDefault ? null : additionalProps.value,
	            primaryText: this.state.primaryText,
	            'data-id': 'Select'
	          }, menuItemCustomization, propsMenuItemCustomization)),
	          this.props.menuItems.map(function (val, index) {
	            if (typeof val === 'undefined') {
	              return undefined;
	            }
	            var value = void 0;
	            var primaryText = void 0;
	            var hide = false;
	            if (typeof val === 'string' || typeof val === 'number') {
	              value = primaryText = val;
	            } else if (typeof val === 'boolean') {
	              value = primaryText = val === true ? 'Yes' : 'No';
	            } else {
	              if (val.hasOwnProperty('value') || val.hasOwnProperty('id')) {
	                value = val.hasOwnProperty('value') ? val.value : val.id;
	              }
	              if (val.hasOwnProperty('primaryText') || val.hasOwnProperty('name')) {
	                primaryText = val.hasOwnProperty('primaryText') ? val.primaryText : val.name;
	              }
	              if (val.hasOwnProperty('hide')) {
	                hide = val.hasOwnProperty('hide') ? val.hide : false;
	              }
	            }
	
	            return _react2.default.createElement(_c_SourceModMenuItem2.default, _extends({ value: value,
	              style: { display: hide ? 'none' : 'block' },
	              primaryText: primaryText,
	              key: index,
	              'data-id': primaryText
	            }, menuItemCustomization, propsMenuItemCustomization));
	          })
	        ),
	        this.props.children && this.props.children[this.state.subElement] && _react2.default.createElement(
	          'div',
	          { className: 'subElement-container' },
	          _react.Children.map(this.props.children[this.state.subElement], // adding isSubElement prop to child
	          function (child) {
	            return (0, _react.cloneElement)(child, _lodash2.default.merge({ isSubElement: true }, { containerStyle: { width: '100%' }, style: { width: '100%', margin: '-1px' } }, { containerStyle: child.containerStyle || {}, style: child.containerStyle || {} }));
	          })
	        )
	      );
	    }
	  }]);
	
	  return CustomDropDownMenu;
	}(_react.Component), _class.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  value: _react.PropTypes.any,
	  id: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  validation: _react.PropTypes.object,
	  onErrorChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  menuItems: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  listStyle: _react.PropTypes.object,
	  menuStyle: _react.PropTypes.object,
	  containerStyle: _react.PropTypes.object,
	  errorText: _react.PropTypes.string,
	  floatingLabelText: _react.PropTypes.string,
	  floatingLabelStyle: _react.PropTypes.object,
	  labelStyle: _react.PropTypes.object,
	  iconStyle: _react.PropTypes.object,
	  menuItemCustomization: _react.PropTypes.object,
	  selectedMenuItemStyle: _react.PropTypes.object,
	  'data-id': _react.PropTypes.string,
	  children: _react.PropTypes.object,
	  isSubElement: _react.PropTypes.bool,
	  canAutoPosition: _react.PropTypes.bool,
	  includeDefault: _react.PropTypes.bool,
	  subElement: _react.PropTypes.string,
	  primaryText: _react.PropTypes.string,
	  optional: _react.PropTypes.bool,
	  staticValue: _react.PropTypes.object
	}, _class.defaultProps = {
	  menuItems: []
	}, _temp2);
	exports.default = CustomDropDownMenu;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// These are kept in one separate file for developer friendliness,
	// doing this makes it easy to see all that's going on in one application
	// and avoid duplication when collaborating
	
	// Prelim Form actions
	var UPDATE_STATIC_DATA = exports.UPDATE_STATIC_DATA = 'UPDATE_STATIC_DATA';
	var UPDATE_LABELS = exports.UPDATE_LABELS = 'UPDATE_LABELS';
	var UPDATE_PRELIM_FORM = exports.UPDATE_PRELIM_FORM = 'UPDATE_PRELIM_FORM';
	var PRELIM_FORM_SUBMITTED = exports.PRELIM_FORM_SUBMITTED = 'PRELIM_FORM_SUBMITTED';
	
	// Applicant+Admin actions
	var UPDATE_USER = exports.UPDATE_USER = 'UPDATE_USER';
	var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
	var UPDATE_IMPERSONATE_USER = exports.UPDATE_IMPERSONATE_USER = 'UPDATE_IMPERSONATE_USER';
	
	// Applicant actions
	var UPDATE_APPLICANT = exports.UPDATE_APPLICANT = 'UPDATE_APPLICANT';
	var DELETE_FROM_APPLICANT_LIST = exports.DELETE_FROM_APPLICANT_LIST = 'DELETE_FROM_APPLICANT_LIST';
	var UPDATE_TEMP_STATE = exports.UPDATE_TEMP_STATE = 'UPDATE_TEMP_STATE';
	var UPDATE_TECHNOLOGY_SURVEY = exports.UPDATE_TECHNOLOGY_SURVEY = 'UPDATE_TECHNOLOGY_SURVEY';
	
	// Admin actions
	var UPDATE_APPLICANT_LICENSES = exports.UPDATE_APPLICANT_LICENSES = 'UPDATE_APPLICANT_LICENSES';
	var UPDATE_APPLICANTS_LIST = exports.UPDATE_APPLICANTS_LIST = 'UPDATE_APPLICANTS_LIST';
	var UPDATE_EVENT_LIST = exports.UPDATE_EVENT_LIST = 'UPDATE_EVENT_LIST';
	var UPDATE_APPLICANTS_PAGE = exports.UPDATE_APPLICANTS_PAGE = 'UPDATE_APPLICANTS_PAGE';
	var UPDATE_APPLICANT_ADMIN = exports.UPDATE_APPLICANT_ADMIN = 'UPDATE_APPLICANT_ADMIN';
	var UPDATE_CURRENT_APPLICANT_ADMIN = exports.UPDATE_CURRENT_APPLICANT_ADMIN = 'UPDATE_CURRENT_APPLICANT_ADMIN';
	var ADD_APPLICANT_ADMIN = exports.ADD_APPLICANT_ADMIN = 'ADD_APPLICANT_ADMIN';
	var DELETE_APPLICANT_ADMIN = exports.DELETE_APPLICANT_ADMIN = 'DELETE_APPLICANT_ADMIN';
	var CHANGE_NAV_COLUMN_STATE = exports.CHANGE_NAV_COLUMN_STATE = 'CHANGE_NAV_COLUMN_STATE';
	var UPDATE_APPLICANT_BEHAVIORAL_ANS = exports.UPDATE_APPLICANT_BEHAVIORAL_ANS = 'UPDATE_APPLICANT_BEHAVIORAL_ANS';
	var UPDATE_APPLICANT_WORK_OBJECTIVES = exports.UPDATE_APPLICANT_WORK_OBJECTIVES = 'UPDATE_APPLICANT_WORK_OBJECTIVES';
	var UPDATE_APPLICANT_INTERVIEW_RATINGS = exports.UPDATE_APPLICANT_INTERVIEW_RATINGS = 'UPDATE_APPLICANT_INTERVIEW_RATINGS';
	var UPDATE_APPLICANT_ASSESSMENTS = exports.UPDATE_APPLICANT_ASSESSMENTS = 'UPDATE_APPLICANT_ASSESSMENTS';
	var UPDATE_APPLICANT_REFERENCES_INTERVIEWS = exports.UPDATE_APPLICANT_REFERENCES_INTERVIEWS = 'UPDATE_APPLICANT_REFERENCES_INTERVIEWS';
	var UPDATE_PLACEMENT_SPECIALISTS = exports.UPDATE_PLACEMENT_SPECIALISTS = 'UPDATE_PLACEMENT_SPECIALISTS';
	var UPDATE_PINNED_APPLICANTS = exports.UPDATE_PINNED_APPLICANTS = 'UPDATE_PINNED_APPLICANTS';
	var CLEAR_APPLICANT = exports.CLEAR_APPLICANT = 'CLEAR_APPLICANT';
	var FETCH_PINNED_APPLICANTS = exports.FETCH_PINNED_APPLICANTS = 'FETCH_PINNED_APPLICANTS';
	var UPDATE_ALERTS = exports.UPDATE_ALERTS = 'UPDATE_ALERTS';
	var LOAD_PINS = exports.LOAD_PINS = 'LOAD_PINS';
	var UPDATE_PINS = exports.UPDATE_PINS = 'UPDATE_PINS';
	var UPDATE_CONTACTS_TABLE_SEARCH_TERMS = exports.UPDATE_CONTACTS_TABLE_SEARCH_TERMS = 'UPDATE_CONTACTS_TABLE_SEARCH_TERMS';
	var UPDATE_CONTACTS_TABLE_FILTERS = exports.UPDATE_CONTACTS_TABLE_FILTERS = 'UPDATE_CONTACTS_TABLE_FILTERS';
	var UPDATE_COMPANIES_TABLE_SEARCH_TERMS = exports.UPDATE_COMPANIES_TABLE_SEARCH_TERMS = 'UPDATE_COMPANIES_TABLE_SEARCH_TERMS';
	var UPDATE_COMPANIES_TABLE_FILTERS = exports.UPDATE_COMPANIES_TABLE_FILTERS = 'UPDATE_COMPANIES_TABLE_FILTERS';
	var UPDATE_JOB_REQUESTS_FILTERS = exports.UPDATE_JOB_REQUESTS_FILTERS = 'UPDATE_JOB_REQUESTS_FILTERS';
	var UPDATE_JOB_REQUESTS_TERMS = exports.UPDATE_JOB_REQUESTS_TERMS = 'UPDATE_JOB_REQUESTS_TERMS';
	
	// Contact actions
	var UPDATE_CONTACT = exports.UPDATE_CONTACT = 'UPDATE_CONTACT';
	var UPDATE_CONTACT_IN_CONTACT_WORKSHEET = exports.UPDATE_CONTACT_IN_CONTACT_WORKSHEET = 'UPDATE_CONTACT_IN_CONTACT_WORKSHEET';
	var CLEAR_CONTACT_IN_CONTACT_WORKSHEET = exports.CLEAR_CONTACT_IN_CONTACT_WORKSHEET = 'CLEAR_CONTACT_IN_CONTACT_WORKSHEET';
	
	var UPDATE_CONTACTS_LIST = exports.UPDATE_CONTACTS_LIST = 'UPDATE_CONTACTS_LIST';
	var UPDATE_CONTACTS_PAGE = exports.UPDATE_CONTACTS_PAGE = 'UPDATE_CONTACTS_PAGE';
	var UPDATE_CONTACT_EVENT_LIST = exports.UPDATE_CONTACT_EVENT_LIST = 'UPDATE_CONTACT_EVENT_LIST';
	
	// pagination
	var GO_TO_CONTACTS_PAGE = exports.GO_TO_CONTACTS_PAGE = 'GO_TO_CONTACTS_PAGE';
	
	// Company actions
	var UPDATE_COMPANY = exports.UPDATE_COMPANY = 'UPDATE_COMPANY';
	var UPDATE_COMPANIES_LIST = exports.UPDATE_COMPANIES_LIST = 'UPDATE_COMPANIES_LIST';
	var UPDATE_COMPANIES_PAGE = exports.UPDATE_COMPANIES_PAGE = 'UPDATE_COMPANIES_PAGE';
	var UPDATE_COMPANY_CONTACTS = exports.UPDATE_COMPANY_CONTACTS = 'UPDATE_COMPANY_CONTACTS';
	var UPDATE_COMPANY_JOBS = exports.UPDATE_COMPANY_JOBS = 'UPDATE_COMPANY_JOBS';
	var FILTER_COMPANY_JOBS = exports.FILTER_COMPANY_JOBS = 'FILTER_COMPANY_JOBS';
	
	// Browser Data actions
	var GET_SCROLLBAR_WIDTH = exports.GET_SCROLLBAR_WIDTH = 'GET_SCROLLBAR_WIDTH';
	var SET_USERAGENT = exports.SET_USERAGENT = 'SET_USERAGENT';
	
	// Company actions
	var GET_COMPANY_INFO = exports.GET_COMPANY_INFO = 'GET_COMPANY_INFO';
	
	// Client actions
	var UPDATE_CONTACT_PROFILE = exports.UPDATE_CONTACT_PROFILE = 'UPDATE_CONTACT_PROFILE';
	var UPDATE_PROFILE = exports.UPDATE_PROFILE = 'UPDATE_PROFILE';
	
	var CREATE_JOB_REQUEST = exports.CREATE_JOB_REQUEST = 'CREATE_JOB_REQUEST';
	var UPDATE_JOB_REQUEST = exports.UPDATE_JOB_REQUEST = 'UPDATE_JOB_REQUEST';
	var RESET_JOB_REQUEST = exports.RESET_JOB_REQUEST = 'RESET_JOB_REQUEST';
	
	var CREATE_JOB_REQUEST_DOCUMENTS = exports.CREATE_JOB_REQUEST_DOCUMENTS = 'CREATE_JOB_REQUEST_DOCUMENTS';
	var UPDATE_JOB_REQUEST_DOCUMENTS = exports.UPDATE_JOB_REQUEST_DOCUMENTS = 'UPDATE_JOB_REQUEST_DOCUMENTS';
	var RESET_JOB_REQUEST_DOCUMENTS = exports.RESET_JOB_REQUEST_DOCUMENTS = 'RESET_JOB_REQUEST_DOCUMENTS';
	
	var UPDATE_JOB_REQUESTS = exports.UPDATE_JOB_REQUESTS = 'UPDATE_JOB_REQUESTS';
	var UPDATE_COMPANY_JOB_REQUESTS = exports.UPDATE_COMPANY_JOB_REQUESTS = 'UPDATE_COMPANY_JOB_REQUESTS';
	var UPDATE_CLIENT_JOB_REQUESTS = exports.UPDATE_CLIENT_JOB_REQUESTS = 'UPDATE_CLIENT_JOB_REQUESTS';
	
	// Worksheets
	var UPDATE_WORKSHEET = exports.UPDATE_WORKSHEET = 'UPDATE_WORKSHEET';
	var REMOVE_WORKSHEET = exports.REMOVE_WORKSHEET = 'REMOVE_WORKSHEET';
	
	// UI actions
	var SET_NAV_STATE = exports.SET_NAV_STATE = 'SET_NAV_STATE';
	var HIDE_SNACKBAR = exports.HIDE_SNACKBAR = 'HIDE_SNACKBAR';
	var SHOW_SNACKBAR = exports.SHOW_SNACKBAR = 'SHOW_SNACKBAR';
	var SHOW_SPINNER = exports.SHOW_SPINNER = 'SHOW_SPINNER';
	var HIDE_SPINNER = exports.HIDE_SPINNER = 'HIDE_SPINNER';
	var SHOW_CONTROLS = exports.SHOW_CONTROLS = 'SHOW_CONTROLS';
	var HIDE_CONTROLS = exports.HIDE_CONTROLS = 'HIDE_CONTROLS';
	var WARNING_TOAST = exports.WARNING_TOAST = 'WARNING_TOAST';
	
	// Employee
	
	var CREATE_EMPLOYEE = exports.CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
	var REMOVE_EMPLOYEE = exports.REMOVE_EMPLOYEE = 'REMOVE_EMPLOYEE';
	var UPDATE_EMPLOYEE = exports.UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
	var STORE_EMPLOYEES = exports.STORE_EMPLOYEES = 'STORE_EMPLOYEES';

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // action type strings
	
	
	// utilities
	
	
	exports.updateWorksheet = updateWorksheet;
	exports.removeWorksheet = removeWorksheet;
	exports.getScrollBarWidth = getScrollBarWidth;
	exports.updatePrelimForm = updatePrelimForm;
	exports.updateUser = updateUser;
	exports.updateApplicant = updateApplicant;
	exports.clearApplicant = clearApplicant;
	exports.deleteListItem = deleteListItem;
	exports.updateApplicantsList = updateApplicantsList;
	exports.updateContactsList = updateContactsList;
	exports.updateContactsPage = updateContactsPage;
	exports.updateCompaniesList = updateCompaniesList;
	exports.updateCompaniesPage = updateCompaniesPage;
	exports.getCompanyInfo = getCompanyInfo;
	exports.updateApplicantsPage = updateApplicantsPage;
	exports.updateEventList = updateEventList;
	exports.updateContactEventList = updateContactEventList;
	exports.addApplicantAdmin = addApplicantAdmin;
	exports.deleteApplicantAdmin = deleteApplicantAdmin;
	exports.updateCurrentApplicantAdmin = updateCurrentApplicantAdmin;
	exports.updateApplicantAdmin = updateApplicantAdmin;
	exports.updateApplicantBehavioralAnswers = updateApplicantBehavioralAnswers;
	exports.updateApplicantWorkObjectives = updateApplicantWorkObjectives;
	exports.updateApplicantInterviewRatings = updateApplicantInterviewRatings;
	exports.updateApplicantAssessments = updateApplicantAssessments;
	exports.changeNavColumnState = changeNavColumnState;
	exports.updateApplicantAccordionData = updateApplicantAccordionData;
	exports.updateTempState = updateTempState;
	exports.updateApplicantReferencesInterviews = updateApplicantReferencesInterviews;
	exports.updatePlacementSpecialists = updatePlacementSpecialists;
	exports.updatePinnedApplicants = updatePinnedApplicants;
	exports.loadPins = loadPins;
	exports.updateAlerts = updateAlerts;
	exports.setNavState = setNavState;
	exports.updateContactsTableSearchTerms = updateContactsTableSearchTerms;
	exports.updateContactsTableFilters = updateContactsTableFilters;
	exports.updateCompaniesTableSearchTerms = updateCompaniesTableSearchTerms;
	exports.updateCompaniesTableFilters = updateCompaniesTableFilters;
	exports.updateJobRequestFilters = updateJobRequestFilters;
	exports.updateJobRequestTerms = updateJobRequestTerms;
	exports.goToContactsPage = goToContactsPage;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function updateWorksheet(worksheet, path) {
	  return {
	    type: actionTypes.UPDATE_WORKSHEET,
	    worksheet: worksheet,
	    path: path
	  };
	}
	
	function removeWorksheet(worksheet) {
	  return {
	    type: actionTypes.REMOVE_WORKSHEET,
	    worksheet: worksheet
	  };
	}
	
	// Browser data
	function getScrollBarWidth() {
	  return {
	    type: actionTypes.GET_SCROLLBAR_WIDTH
	  };
	}
	
	// Prelim Application
	function updatePrelimForm(updateObj) {
	  return _lodash2.default.merge(updateObj, {
	    type: actionTypes.UPDATE_PRELIM_FORM
	  });
	}
	
	// Applicant/Admin (any user auth)
	function updateUser(user) {
	  return _extends({
	    type: actionTypes.UPDATE_USER
	  }, user);
	}
	
	// Applicant
	function updateApplicant(updatesObj) {
	  // updates obj can include properties user, profile, workExperience...
	  return _extends({
	    type: actionTypes.UPDATE_APPLICANT
	  }, updatesObj);
	}
	
	function clearApplicant() {
	  return {
	    type: actionTypes.CLEAR_APPLICANT
	  };
	}
	
	function deleteListItem(clientId) {
	  return {
	    type: actionTypes.DELETE_FROM_APPLICANT_LIST,
	    clientId: clientId
	  };
	}
	
	// Admin
	function updateApplicantsList(applicants) {
	  return {
	    type: actionTypes.UPDATE_APPLICANTS_LIST,
	    applicants: applicants
	  };
	}
	
	// Admin
	function updateContactsList(contacts) {
	  return {
	    type: actionTypes.UPDATE_CONTACTS_LIST,
	    contacts: contacts
	  };
	}
	
	function updateContactsPage(data) {
	  return {
	    type: actionTypes.UPDATE_CONTACTS_PAGE,
	    data: data
	  };
	}
	
	// Admin
	function updateCompaniesList(companies) {
	  return {
	    type: actionTypes.UPDATE_COMPANIES_LIST,
	    companies: companies
	  };
	}
	
	function updateCompaniesPage(data) {
	  return {
	    type: actionTypes.UPDATE_COMPANIES_PAGE,
	    data: data
	  };
	}
	
	function getCompanyInfo(_ref) {
	  var company = _ref.company,
	      groups = _ref.groups;
	
	  return {
	    type: actionTypes.GET_COMPANY_INFO,
	    company: company,
	    groups: groups
	  };
	}
	function updateApplicantsPage(group, data) {
	  return {
	    type: actionTypes.UPDATE_APPLICANTS_PAGE,
	    group: group,
	    data: data
	  };
	}
	
	function updateEventList(event) {
	  return {
	    type: actionTypes.UPDATE_EVENT_LIST,
	    event: event
	  };
	}
	
	function updateContactEventList(contactEvent) {
	  return {
	    type: actionTypes.UPDATE_CONTACT_EVENT_LIST,
	    contactEvent: contactEvent
	  };
	}
	
	function addApplicantAdmin(applicant) {
	  return {
	    type: actionTypes.ADD_APPLICANT_ADMIN,
	    applicant: applicant
	  };
	}
	
	function deleteApplicantAdmin(applicantId, group) {
	  return {
	    type: actionTypes.DELETE_APPLICANT_ADMIN,
	    applicantId: applicantId,
	    group: group
	  };
	}
	
	function updateCurrentApplicantAdmin(applicant) {
	  return {
	    type: actionTypes.UPDATE_CURRENT_APPLICANT_ADMIN,
	    applicant: applicant
	  };
	}
	
	function updateApplicantAdmin(updatedApplicant, group, arrayIndex, newGroup) {
	  return {
	    type: actionTypes.UPDATE_APPLICANT_ADMIN,
	    group: group,
	    arrayIndex: arrayIndex,
	    updatedApplicant: updatedApplicant,
	    newGroup: newGroup
	  };
	}
	
	function updateApplicantBehavioralAnswers(updatesObj) {
	  return _extends({
	    type: actionTypes.UPDATE_APPLICANT_BEHAVIORAL_ANS
	  }, updatesObj);
	}
	
	function updateApplicantWorkObjectives(updatesObj) {
	  return _extends({
	    type: actionTypes.UPDATE_APPLICANT_WORK_OBJECTIVES
	  }, updatesObj);
	}
	
	function updateApplicantInterviewRatings(updatesObj) {
	  return _extends({
	    type: actionTypes.UPDATE_APPLICANT_INTERVIEW_RATINGS
	  }, updatesObj);
	}
	
	function updateApplicantAssessments(updatesObj) {
	  return _extends({
	    type: actionTypes.UPDATE_APPLICANT_ASSESSMENTS
	  }, updatesObj);
	}
	
	function changeNavColumnState(navColumnState) {
	  return {
	    type: actionTypes.CHANGE_NAV_COLUMN_STATE,
	    navColumnState: navColumnState
	  };
	}
	
	function updateApplicantAccordionData(setStr, value) {
	  return {
	    type: actionTypes.UPDATE_ACCORDION_DATA,
	    setStr: setStr,
	    value: value
	  };
	}
	
	function updateTempState(newTempState) {
	  return {
	    type: actionTypes.UPDATE_TEMP_STATE,
	    newTempState: newTempState
	  };
	}
	
	function updateApplicantReferencesInterviews(interview) {
	  return {
	    type: actionTypes.UPDATE_APPLICANT_REFERENCES_INTERVIEWS,
	    interviews: interview
	  };
	}
	
	function updatePlacementSpecialists(placementSpecialists) {
	  return {
	    type: actionTypes.UPDATE_PLACEMENT_SPECIALISTS,
	    placementSpecialists: placementSpecialists
	  };
	}
	
	function updatePinnedApplicants(applicant) {
	  return {
	    type: actionTypes.UPDATE_PINNED_APPLICANTS,
	    applicant: applicant
	  };
	}
	
	function loadPins(pins) {
	  return {
	    type: actionTypes.LOAD_PINS,
	    pins: pins
	  };
	}
	
	function updateAlerts(alerts) {
	  return {
	    type: actionTypes.UPDATE_ALERTS,
	    alerts: alerts
	  };
	}
	
	function setNavState(navState) {
	  return {
	    type: actionTypes.SET_NAV_STATE,
	    navState: navState
	  };
	}
	
	function updateContactsTableSearchTerms(searchTerms) {
	  return {
	    type: actionTypes.UPDATE_CONTACTS_TABLE_SEARCH_TERMS,
	    searchTerms: searchTerms
	  };
	}
	
	function updateContactsTableFilters(filters) {
	  return {
	    type: actionTypes.UPDATE_CONTACTS_TABLE_FILTERS,
	    filters: filters
	  };
	}
	
	function updateCompaniesTableSearchTerms(searchTerms) {
	  return {
	    type: actionTypes.UPDATE_COMPANIES_TABLE_SEARCH_TERMS,
	    searchTerms: searchTerms
	  };
	}
	
	function updateCompaniesTableFilters(filters) {
	  return {
	    type: actionTypes.UPDATE_COMPANIES_TABLE_FILTERS,
	    filters: filters
	  };
	}
	
	function updateJobRequestFilters(filters) {
	  return {
	    type: actionTypes.UPDATE_JOB_REQUESTS_FILTERS,
	    filters: filters
	  };
	}
	
	function updateJobRequestTerms(searchTerms) {
	  return {
	    type: actionTypes.UPDATE_JOB_REQUESTS_TERMS,
	    searchTerms: searchTerms
	  };
	}
	
	function goToContactsPage(page) {
	  return {
	    type: actionTypes.GO_TO_CONTACTS_PAGE,
	    page: page
	  };
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// unique id generator
	
	
	// js utility library
	
	
	// class names utility
	
	
	// import component from material UI
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(399);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _isServer = __webpack_require__(207);
	
	var _isServer2 = _interopRequireDefault(_isServer);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var textFieldContainerCustomization = {
	  style: {
	    width: 'calc(33% - 14px)',
	    margin: '7px',
	    padding: '0px'
	  }
	};
	
	var textFieldCustomization = {
	  underlineShow: false,
	  style: {
	    width: '100%',
	    verticalAlign: 'middle'
	  },
	  errorStyle: {
	    maxWidth: '100%',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    textAlign: 'left',
	    position: 'absolute',
	    transform: 'translateY(26px)'
	  },
	  floatingLabelStyle: {
	    maxWidth: '100%',
	    whiteSpace: 'nowrap'
	  }
	};
	
	// @muiThemeable() // muiThemeable brings in theme from provider at root, not sure if necessary
	var CustomTextField = (_temp2 = _class = function (_Component) {
	  _inherits(CustomTextField, _Component);
	
	  function CustomTextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CustomTextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomTextField.__proto__ || Object.getPrototypeOf(CustomTextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      focused: false,
	      dirty: false,
	      passwordShow: false,
	      hasValue: false,
	      errors: []
	    }, _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_reactAddonsPureRenderMixin2.default), _this.id = _shortid2.default.generate(), _this.validate = function (value, initialObj) {
	
	      _this.setState(function (state) {
	        return _lodash2.default.assign(state, { hasValue: !_lodash2.default.isEmpty(value) });
	      });
	      if (_this.props.validation) {
	        var updateStateObj = {
	          errors: (0, _modelValidator.validateField)(value, _this.props.validation)
	        };
	
	        if (initialObj) {
	          updateStateObj = _lodash2.default.assign({}, initialObj, updateStateObj);
	        }
	
	        // emit error change to parent if diff is not 0.
	        var errorCountChange = updateStateObj.errors.length - _this.state.errors.length;
	
	        if (_this.props.onErrorChange && errorCountChange) {
	          _this.props.onErrorChange(errorCountChange);
	        }
	
	        // update local error state
	        _this.setState(function (state) {
	          return _lodash2.default.assign({}, state, updateStateObj);
	        });
	        return true;
	      }
	    }, _this.clear = function () {
	      _this.onKeyUp(null, null);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CustomTextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.detectAndValidateChanges();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        this.validate(nextProps.value);
	      }
	      if (this.props.proxyVal !== nextProps.proxyVal) {
	        this.validate(nextProps.proxyVal);
	      }
	    }
	
	    // performance optimization
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'onKeyUp',
	    value: function onKeyUp(event) {
	
	      if (this.props.maxLength) {
	        if (event.target.value.length >= this.props.maxLength) {
	          event.preventDefault();
	          event.target.value = event.target.value.substring(0, this.props.maxLength);
	        }
	      }
	
	      // capitalized sentences.
	      if (this.props.capitalized) {
	        event.target.value = event.target.value.split(' ').map(_lodash2.default.capitalize).join(' ');
	      }
	
	      var newVal = event.keyCode === 32 ? event.target.value : event.target.value && event.target.value.trim && event.target.value.trim();
	
	      if (this.props.onChange) this.props.onChange(event, newVal);
	      if (this.props.onKeyUp) this.props.onKeyUp(event, newVal);
	      if (!this.props.hasOwnProperty('value') && !this.props.hasOwnProperty('proxyVal')) this.validate(newVal);
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      this.setState(function (state) {
	        return _lodash2.default.merge({}, state, { focused: true });
	      });
	      if (this.props.onFocus) {
	        this.props.onFocus(event, event.target.value && event.target.value.trim && event.target.value.trim());
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      var _this2 = this;
	
	      this.setState(function (state) {
	        var updateStateObj = { focused: false };
	        if (!state.dirty) updateStateObj.dirty = true; // set dirty if not already dirty
	        return _lodash2.default.merge({}, state, updateStateObj);
	      }, function () {
	        // this will validate any autofills as react sees them as defaultValue (also must be dirty)
	        _this2.detectAndValidateChanges();
	      });
	
	      if (this.props.onBlur) {
	        this.props.onBlur(event, event.target.value && event.target.value.trim && event.target.value.trim());
	      }
	    }
	  }, {
	    key: 'detectAndValidateChanges',
	    value: function detectAndValidateChanges() {
	      // initializing
	      var initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : this.props.hasOwnProperty('proxyVal') ? this.props.proxyVal : null;
	
	      var hasValidation = this.validate(initVal);
	      if (!hasValidation && initVal) {
	        // even without validation, should still set state to dirty if initial value is populated
	        this.setState(function (state) {
	          return _lodash2.default.assign({}, state, { dirty: true });
	        });
	      }
	    }
	  }, {
	    key: 'checkErrors',
	    value: function checkErrors() {
	      this.setState(function (state) {
	        return state.dirty ? state : _lodash2.default.assign({}, state, { dirty: true });
	      });
	    }
	  }, {
	    key: 'passwordShowToggle',
	    value: function passwordShowToggle() {
	      var _this3 = this;
	
	      this.setState(function (state) {
	        return _lodash2.default.merge({}, state, {
	          passwordShow: !_this3.state.passwordShow
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // take out properties that will be overwritten from 'this.props'
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          fieldStyle = _props.fieldStyle,
	          focusColor = _props.focusColor,
	          errorStyle = _props.errorStyle,
	          errorText = _props.errorText,
	          onKeyUp = _props.onKeyUp,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          validation = _props.validation,
	          dataId = _props['data-id'],
	          unmodifiedProps = _objectWithoutProperties(_props, ['className', 'style', 'fieldStyle', 'focusColor', 'errorStyle', 'errorText', 'onKeyUp', 'onFocus', 'onBlur', 'validation', 'data-id']);
	
	      var textFieldContainerCustomizationStyle = textFieldContainerCustomization.style,
	          textFieldContainerCustomizationOther = _objectWithoutProperties(textFieldContainerCustomization, ['style']);
	
	      var additionalProps = {
	        id: this.props.id || this.id,
	        onKeyUp: this.onKeyUp.bind(this),
	        onFocus: this.onFocus.bind(this),
	        onBlur: this.onBlur.bind(this)
	      };
	
	      // get booleans
	      var errorStr = void 0;
	      var isError = (this.props.isDirty || this.state.dirty) && (typeof this.props.errorText !== 'undefined' || this.state.errors.length); // check passed in error string and local state errors array, only show if value is dirty
	
	      // handle focused state visually
	      if (this.state.focused) {
	        additionalProps.floatingLabelStyle = _lodash2.default.merge({
	          color: focusColor || '#2eb0e3'
	        }, textFieldCustomization.floatingLabelStyle);
	      }
	
	      // handle error state visually
	      if (isError) {
	        additionalProps.floatingLabelStyle = {
	          color: 'rgb(244, 67, 54)'
	        };
	
	        // set error string
	        errorStr = (errorText && [errorText] || []).concat(this.state.errors).join(', '); // combine passed in error string and local state errors array
	      }
	
	      // handle optional state visually
	      if (this.props.optional) {
	        if (!isError) {
	          additionalProps.errorText = '(optional)';
	          additionalProps.errorStyle = _lodash2.default.merge({}, textFieldCustomization.errorStyle, errorStyle, {
	            color: this.state.focused ? focusColor || '#2eb0e3' : '#c9c9c9'
	          });
	        } else {
	          additionalProps.errorText = '(optional) ' + errorStr;
	        }
	      } else if (isError) {
	        additionalProps.autoFocus = true;
	        additionalProps.errorText = errorStr;
	      }
	
	      if (this.props.subText) {
	        additionalProps.errorText = this.props.subText + ' ' + (additionalProps.errorText || '');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: (0, _classnames2.default)('text-field-container', 'clearfix', className, { focused: this.state.focused, error: isError, optional: this.props.optional && !isError, 'has-value': this.state.hasValue }),
	          style: _lodash2.default.merge({}, textFieldContainerCustomizationStyle, style) }, textFieldContainerCustomizationOther),
	        _react2.default.createElement(_TextField2.default, _extends({}, _lodash2.default.merge({}, textFieldCustomization, errorStyle && { errorStyle: errorStyle } || {}, fieldStyle && { style: fieldStyle } || {}), unmodifiedProps, additionalProps, {
	          'data-id': dataId,
	          type: this.props.password && !this.state.passwordShow && 'password' || unmodifiedProps.type || 'text',
	          className: 'text-field',
	          ref: 'textFieldElem'
	        })),
	        this.props.password && _react2.default.createElement(
	          'div',
	          { className: 'password-show-toggle', onClick: this.passwordShowToggle.bind(this), 'data-id': dataId + ' ShowToggle' },
	          this.state.passwordShow ? 'Hide' : 'Show'
	        ),
	        className && focusColor && _react2.default.createElement(
	          'style',
	          null,
	          '\n                .' + className + '.focused .text-field::before {\n                  border-top-color: ' + focusColor + ';\n                }\n              '
	        )
	      );
	    }
	  }]);
	
	  return CustomTextField;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  fieldStyle: _react.PropTypes.object,
	  focusColor: _react.PropTypes.string,
	  subText: _react.PropTypes.string,
	  errorText: _react.PropTypes.string,
	  onErrorChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  errorStyle: _react.PropTypes.object,
	  id: _react.PropTypes.string,
	  password: _react.PropTypes.bool,
	  optional: _react.PropTypes.bool,
	  'data-id': _react.PropTypes.string,
	  isSubElement: _react.PropTypes.bool,
	  validation: _react.PropTypes.object,
	  isDirty: _react.PropTypes.bool,
	  maxLength: _react.PropTypes.number,
	  capitalized: _react.PropTypes.bool,
	  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react2.default.PropTypes.number]),
	  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react2.default.PropTypes.number]),
	  proxyVal: _react.PropTypes.oneOfType([_react.PropTypes.string, _react2.default.PropTypes.number]) // used for masked input since text field has no access to actual value
	}, _temp2);
	exports.default = CustomTextField;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setNavState = setNavState;
	exports.hideSnackBar = hideSnackBar;
	exports.showSnackBar = showSnackBar;
	exports.showSpinner = showSpinner;
	exports.hideSpinner = hideSpinner;
	exports.showControls = showControls;
	exports.hideControls = hideControls;
	exports.warningToast = warningToast;
	
	var _actionTypes = __webpack_require__(20);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// action type strings
	function setNavState(navState) {
	  return {
	    type: _actionTypes.SET_NAV_STATE,
	    navState: navState
	  };
	}
	
	function hideSnackBar() {
	  return {
	    type: _actionTypes.HIDE_SNACKBAR,
	    showSnackBar: false,
	    snackBarText: null,
	    hideSnackBarAction: null
	  };
	}
	
	function showSnackBar() {
	  var snackBarText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var hideSnackBarAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  return {
	    type: _actionTypes.SHOW_SNACKBAR,
	    showSnackBar: true,
	    snackBarText: snackBarText,
	    hideSnackBarAction: hideSnackBarAction
	  };
	}
	
	function showSpinner() {
	  return {
	    type: _actionTypes.SHOW_SPINNER,
	    showSpinner: true
	  };
	}
	
	function hideSpinner() {
	  return {
	    type: _actionTypes.HIDE_SPINNER,
	    showSpinner: false
	  };
	}
	
	function showControls() {
	  return {
	    type: _actionTypes.SHOW_CONTROLS,
	    hideControls: false
	  };
	}
	
	function hideControls() {
	  return {
	    type: _actionTypes.HIDE_CONTROLS,
	    hideControls: true
	  };
	}
	
	function warningToast(message) {
	  return {
	    identifier: _shortid2.default.generate(),
	    type: _actionTypes.WARNING_TOAST,
	    title: 'Warning',
	    message: message
	  };
	}

/***/ }),
/* 27 */
[3118, 38],
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JOB_REQUEST_SEGMENT_TYPES = exports.SEGMENT_TYPES = exports.JOB_REQUEST_STATUS = exports.CONTACT_ROLES = exports.APPLICANT_STATUS = exports.SKILL_AVAILABILITY_ID = undefined;
	exports.lookup = lookup;
	exports.getLookupValue = getLookupValue;
	exports.statusGroupOrDefault = statusGroupOrDefault;
	exports.convertToMenuItems = convertToMenuItems;
	exports.convertContactsToMenuItems = convertContactsToMenuItems;
	exports.convertEmployeeToMenuItems = convertEmployeeToMenuItems;
	exports.skillCategoryTypesByTenant = skillCategoryTypesByTenant;
	
	var _lodash = __webpack_require__(4);
	
	function lookup(staticData, type, criteria, field) {
	  var data = staticData[type];
	  var match = (0, _lodash.find)(data, criteria);
	  return match ? match[field] || match.name || match.primaryText : null;
	}
	
	function getLookupValue(staticData, type, criteria) {
	  return (0, _lodash.find)(staticData[type] || [], criteria);
	}
	
	function statusGroupOrDefault(group, statusGroups) {
	  return group ? group : ((statusGroups || []).sort(function (a, b) {
	    return a.id - b.id;
	  })[0] || { name: 'In Process' }).name;
	}
	
	function convertToMenuItems(lookups) {
	  var valueProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
	  var textProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
	  var subElementProp = arguments[3];
	
	  return lookups.map(function (item, index) {
	    return {
	      value: item[valueProp],
	      primaryText: item[textProp],
	      subElement: item[subElementProp]
	    };
	  });
	}
	
	function convertContactsToMenuItems() {
	  var contacts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return contacts.map(function (contact) {
	    return {
	      name: contact.user.firstName + ' ' + contact.user.lastName,
	      value: contact.profile.id
	    };
	  });
	}
	
	function convertEmployeeToMenuItems() {
	  var employees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return employees.map(function (employee) {
	    return {
	      name: employee.firstName + ' ' + employee.lastName,
	      value: employee.employeeId
	    };
	  });
	}
	
	function skillCategoryTypesByTenant() {
	  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var skillCategoryTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'showInBoth';
	
	  return skillCategoryTypes.filter(function (cat) {
	    return SKILL_AVAILABILITY_ID[show].includes(cat.skillAvailabilityId) && cat.hide === false;
	  });
	}
	
	var SKILL_AVAILABILITY_ID = exports.SKILL_AVAILABILITY_ID = {
	  showInApplication: [null, 1, 3],
	  showInJobRequest: [null, 2, 3],
	  showInBoth: [null, 3],
	  showInNone: []
	};
	
	var APPLICANT_STATUS = exports.APPLICANT_STATUS = {
	  NEW_APPLICANT: 1,
	  PENDING_PRELIMINARY_INTERVIEW: 2,
	  PENDING_APPLICATION: 3,
	  PENDING_ASSESSMENTS: 4,
	  PENDING_APPLICATION_INTERVIEW: 5,
	  PENDING_INFORMATION_UPDATE: 6,
	  UNRESPONSIVE: 7,
	  NOT_QUALIFIED: 8,
	  NOT_INTERESTED: 9,
	  IN_WAITING: 10,
	  QUALIFIED_CANDIDATE: 11,
	  READY_TO_PLACE: 12,
	  PENDING_REFERENCE_CHECKS: 13,
	  ARCHIVED: 14,
	  DNC: 15,
	  UNAVAILABLE: 16,
	  PENDING_REVIEW: 17,
	  QUALIFIED_IN_WAITING: 18,
	  QUALIFIED_CANDIDATE_IN_QUEUE: 19,
	  ACTIVE: 20,
	  PLACED: 21,
	  UNRESPONSIVE_BH: 22,
	  UNAVAILABLE_BH: 23,
	  FULLY_RETIRED: 24,
	  DIRECT_HIRE: 25,
	  NOT_QUALIFIED_BH: 26,
	  NOT_INTERESTED_BH: 27
	};
	
	var CONTACT_ROLES = exports.CONTACT_ROLES = {
	  BILLING: 1,
	  EXECUTIVE: 2,
	  HR: 3,
	  KEY: 4,
	  MAIN: 5,
	  MANAGER: 6,
	  OWNER: 7,
	  REPORTING: 8,
	  SUPERVISOR: 9,
	  TECHNOLOGY: 10,
	  TRAINING: 11,
	  SOCIAL_MEDIA: 12,
	  NEWSLETTER: 13,
	  MARKETING: 14,
	  EDITOR: 15
	};
	
	var JOB_REQUEST_STATUS = exports.JOB_REQUEST_STATUS = {
	  IN_PROCESS: 1,
	  NEW_REQUEST: 2,
	  NA: 3,
	  APPROVED_REQUEST: 4,
	  CANDIDATE_PLACED: 5
	};
	
	var SEGMENT_TYPES = exports.SEGMENT_TYPES = {
	  HEALTH_BENEFITS: 1,
	  LIFE_PRODUCTS: 2,
	  COMMERCIAL_LINES: 3,
	  PERSONAL_LINES: 4,
	  FINANCIAL_PLANNING: 6,
	  OTHER: 7
	};
	
	var JOB_REQUEST_SEGMENT_TYPES = exports.JOB_REQUEST_SEGMENT_TYPES = {
	  COMPANY_WIDE: 1,
	  HEALTH_BENEFITS: 2,
	  LIFE_PRODUCTS: 3,
	  COMMERCIAL_LINES: 4,
	  PERSONAL_LINES: 5,
	  COMMERCIAL_PERSONAL_SPLIT: 6,
	  FINANCIAL_PLANNING: 7,
	  OTHER: 8
	};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Button;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Button(props) {
	  var _props$disabled = props.disabled,
	      disabled = _props$disabled === undefined ? false : _props$disabled,
	      _props$label = props.label,
	      label = _props$label === undefined ? null : _props$label,
	      _props$className = props.className,
	      className = _props$className === undefined ? 'button-main' : _props$className,
	      onClick = props.onClick,
	      otherProps = _objectWithoutProperties(props, ['disabled', 'label', 'className', 'onClick']);
	
	  var currentClass = disabled ? className + ' disabled' : className;
	
	  var handleClick = function handleClick(event) {
	    return !disabled && onClick ? onClick(event) : null;
	  };
	
	  return _react2.default.createElement(
	    'a',
	    _extends({
	      className: currentClass,
	      'data-id': label,
	      onClick: handleClick
	    }, otherProps),
	    _react2.default.createElement(
	      'div',
	      null,
	      label
	    )
	  );
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	// import components from material UI
	// import muiThemeable from 'material-ui/styles/muiThemeable';
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_SourceModFlatButton = __webpack_require__(866);
	
	var _c_SourceModFlatButton2 = _interopRequireDefault(_c_SourceModFlatButton);
	
	var _reactProps = __webpack_require__(238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var flatButtonCustomization = {
	  primary: true,
	  disableTouchRipple: true,
	  disableFocusRipple: true,
	  style: {
	    border: '1px solid #333333',
	    color: '#4a4a4a',
	    width: '100%',
	    height: '25px',
	    lineHeight: 'initial',
	    backgroundColor: 'transparent'
	  },
	  labelStyle: {
	    display: 'block',
	    letterSpacing: '3.5px',
	    top: '-3%',
	    fontSize: '9.5px'
	  },
	  hoverStyle: {
	    border: '1px solid #2eb0e3',
	    color: '#2eb0e3'
	  }
	};
	
	var disabledStyles = {
	  backgroundColor: 'rgb(241,241,241)',
	  border: '1px solid rgb(241,241,241)'
	};
	
	// @muiThemeable()  // muiThemeable brings in theme from provider at root
	var CustomFlatButton = (_temp = _class = function (_Component) {
	  _inherits(CustomFlatButton, _Component);
	
	  function CustomFlatButton() {
	    _classCallCheck(this, CustomFlatButton);
	
	    return _possibleConstructorReturn(this, (CustomFlatButton.__proto__ || Object.getPrototypeOf(CustomFlatButton)).apply(this, arguments));
	  }
	
	  _createClass(CustomFlatButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          label = _props.label,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          disabled = _props.disabled,
	          otherProps = _objectWithoutProperties(_props, ['className', 'label', 'style', 'labelStyle', 'disabled']);
	
	      var flatButtonCustomizationStyle = flatButtonCustomization.style,
	          flatButtonCustomizationLabelStyle = flatButtonCustomization.labelStyle,
	          flatButtonCustomizationOther = _objectWithoutProperties(flatButtonCustomization, ['style', 'labelStyle']);
	
	      return _react2.default.createElement(_c_SourceModFlatButton2.default, _extends({ className: 'flat-button ' + className + ' ' + (disabled ? 'disabled' : ''),
	        'data-id': '' + label + (disabled ? ' Disabled' : ''),
	        label: label,
	        style: _lodash2.default.merge({}, flatButtonCustomizationStyle, disabled ? disabledStyles : {}, style),
	        labelStyle: _lodash2.default.merge({}, flatButtonCustomizationLabelStyle, labelStyle),
	        disabled: disabled
	      }, (0, _reactProps.stripUnknownProps)(flatButtonCustomizationOther), otherProps));
	    }
	  }]);
	
	  return CustomFlatButton;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  label: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  labelStyle: _react.PropTypes.object,
	  disabled: _react.PropTypes.bool
	}, _class.defaultProps = {
	  style: {},
	  labelStyle: {}
	}, _temp);
	exports.default = CustomFlatButton;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(4);
	var validator = __webpack_require__(834);
	
	function formatError(name, value, msg) {
	  return {
	    param: name,
	    msg: msg,
	    value: value
	  };
	}
	
	function isValid(value, validationType, config) {
	  value = value || '';
	
	  // handle required fields
	  if (validationType === 'required') {
	    return validator.isLength(value.toString(), { min: 1 });
	  }
	
	  // handle custom validationType function
	  if (validationType === 'custom') {
	    return config.func(value);
	  }
	
	  return validator[validationType](value.toString(), _.get(config, 'options'));
	}
	
	// ///// making this a static as well to allow grabbing for TextField and DropDown
	function validateField(value, validationSchema) {
	  var errors = [];
	  if (!_.isUndefined(value) && !_.isNull(value) && value.toString().length > 0) {
	
	    _.forIn(validationSchema, function (config, validationType) {
	      if (!_.isBoolean(value) && !isValid(value, validationType, config)) {
	        errors.push(config.message);
	      }
	    });
	  } else {
	    // still want to run custom validation if value is null
	    if (_.get(validationSchema, 'custom')) {
	      if (!isValid(value, 'custom', validationSchema.custom)) {
	        errors.push(validationSchema.custom.message);
	      }
	    }
	
	    // handle required-specific message
	    if (!errors.length && validationSchema.required) {
	      errors.push(validationSchema.required.message);
	    }
	  }
	  return errors;
	}
	
	function validate(target, schema) {
	  var errors = [];
	  _.forIn(schema, function (validations, property) {
	    if (!_.isUndefined(target[property]) && !_.isNull(target[property]) && target[property].toString().length > 0) {
	
	      _.forIn(validations, function (config, validation) {
	        if (!_.isBoolean(target[property]) && !isValid(target[property], validation, config)) {
	          errors.push(formatError(property, target[property], config.message));
	        }
	      });
	    } else if (validations.required) {
	      errors.push(formatError(property, target[property], validations.required.message));
	    }
	  });
	
	  return errors;
	}
	
	function validateFormField(field, model) {
	  if (field && model && !_.isEmpty(_.get(model, field))) {
	    return validateField(_.get(model, field + '.value', _.get(model, field + '.defaultValue')), _.omit(_.get(model, '' + field, {}), ['errors', 'value', 'defaultValue']));
	  }
	  return [];
	}
	
	module.exports.validateField = validateField;
	module.exports.isValid = isValid;
	module.exports.validate = validate;
	module.exports.validateFormField = validateFormField;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2911);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* global Symbol */
	
	
	exports.submitApplicant = submitApplicant;
	exports.authorizeApplication = authorizeApplication;
	exports.loadRestofApplicantProfileInfo = loadRestofApplicantProfileInfo;
	exports.loadApplicantProfileInfo = loadApplicantProfileInfo;
	exports.getProfileById = getProfileById;
	exports.persistApplicantUpdate = persistApplicantUpdate;
	exports.persistListUpdate = persistListUpdate;
	exports.updateApplicantList = updateApplicantList;
	exports.persistSkills = persistSkills;
	exports.persistBackground = persistBackground;
	exports.deleteWorkExperience = deleteWorkExperience;
	exports.search = search;
	exports.goToPage = goToPage;
	exports.retrieve = retrieve;
	exports.searchContacts = searchContacts;
	exports.searchCompanies = searchCompanies;
	exports.updateApplicantAdmin = updateApplicantAdmin;
	exports.updateApplicantStatus = updateApplicantStatus;
	exports.deleteApplicant = deleteApplicant;
	exports.submitEvent = submitEvent;
	exports.getApplicantBehavioralAnswers = getApplicantBehavioralAnswers;
	exports.updateApplicantBehavioralAnswers = updateApplicantBehavioralAnswers;
	exports.getApplicantWorkObjectives = getApplicantWorkObjectives;
	exports.updateApplicantWorkObjectives = updateApplicantWorkObjectives;
	exports.updateApplicantInterviewRatings = updateApplicantInterviewRatings;
	exports.updateApplicantAssessments = updateApplicantAssessments;
	exports.persistReferencesInterviews = persistReferencesInterviews;
	exports.retrievePlacementSpecialists = retrievePlacementSpecialists;
	exports.createProspect = createProspect;
	exports.updateProspect = updateProspect;
	exports.checkAndCreateContact = checkAndCreateContact;
	exports.submitContactEvent = submitContactEvent;
	exports.updatePassword = updatePassword;
	exports.getCompanyById = getCompanyById;
	exports.getAlerts = getAlerts;
	exports.readAlert = readAlert;
	exports.deleteAlert = deleteAlert;
	exports.getApplicantAssessmentTests = getApplicantAssessmentTests;
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _contacts = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _staticData = __webpack_require__(28);
	
	var _bluebird = __webpack_require__(171);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Prelim Application
	function submitApplicant(body) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.post({
	        route: '/api/applicants',
	        body: body
	      }).then(function (_ref) {
	        var responseBody = _ref.body;
	        return dispatch(syncActionCreators.updatePrelimForm({
	          isQualified: responseBody.status === 'success'
	        }));
	      }).catch(function (err) {
	        // if(!err || !~[400].indexOf(err.status)) {
	        //   console.error(err);
	        // }
	
	        // reach here, existing applicant with 'Uninterested' or 'Unresponsive' tried to apply again
	        if (err.body.errors && err.body.errors[0].errorCode === 104) {
	          dispatch(syncActionCreators.updatePrelimForm({
	            isDupQualifiedAndUnresponsive: true,
	            assignedSpecialist: err.body.errors[0].qs
	          }));
	        }
	
	        // reach here, that means try to create account with same email and applicant is In Waiting
	        if (err.body.errors && err.body.errors[0].errorCode === 103) {
	          dispatch(syncActionCreators.updatePrelimForm({
	            isDupAndInWaiting: true,
	            assignedSpecialist: err.body.errors[0].qs
	          }));
	        }
	
	        if (err.body && err.body.errors && err.body.errors[0].errorCode === 102) {
	          dispatch(syncActionCreators.updatePrelimForm({
	            isDupAndUnqualified: true
	          }));
	        }
	
	        // reach here, that means try to create account with same email.
	        if (err.body && err.body.errors && err.body.errors[0].errorCode === 100) {
	          dispatch(syncActionCreators.updatePrelimForm({
	            alreadyExists: true,
	            assignedSpecialist: err.body.errors[0].qs
	          }));
	        }
	      });
	    };
	  };
	}
	
	function authorizeApplication(applicant) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({
	        route: '/api/applicants/' + applicant.profile.id + '/authorize'
	      }).then(function () {
	        dispatch(syncActionCreators.updateApplicant({ profile: { applicantStatus: _staticData.APPLICANT_STATUS.PENDING_ASSESSMENTS, dateAuthorized: new Date().toDateString() } }));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	// Applicant
	
	// loads only Contact Information Section for on Applicant Login
	function loadRestofApplicantProfileInfo(id) {
	  if (_lodash2.default.isNil(id)) {
	    return _bluebird2.default.resolve();
	  }
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return _bluebird2.default.all([simpleIsoFetch.get('/api/applicants/' + id + '/workexperiences'), simpleIsoFetch.get('/api/applicants/' + id + '/employmentgaps'), simpleIsoFetch.get('/api/applicants/' + id + '/skills'), simpleIsoFetch.get('/api/applicants/' + id + '/associations'), simpleIsoFetch.get('/api/applicants/' + id + '/designations'), simpleIsoFetch.get('/api/applicants/' + id + '/education'), simpleIsoFetch.get('/api/applicants/' + id + '/licenses'), simpleIsoFetch.get('/api/applicants/' + id + '/documents'), simpleIsoFetch.get('/api/applicants/' + id + '/references'), simpleIsoFetch.get('/api/applicants/' + id + '/references/interviews'), simpleIsoFetch.get('/api/applicants/' + id + '/behavioral'), simpleIsoFetch.get('/api/applicants/' + id + '/workobjectives'), simpleIsoFetch.get('/api/applicants/' + id + '/ratings'), simpleIsoFetch.get('/api/applicants/' + id + '/assessments'), simpleIsoFetch.get('/api/v2/applicants/' + id + '/technology')]).then(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 15),
	            _ref3$0$body$data$ite = _slicedToArray(_ref3[0].body.data.items, 1),
	            workExperiences = _ref3$0$body$data$ite[0],
	            _ref3$1$body$data$ite = _slicedToArray(_ref3[1].body.data.items, 1),
	            employmentGaps = _ref3$1$body$data$ite[0],
	            skills = _ref3[2].body.data.items,
	            associations = _ref3[3].body.data.items,
	            designations = _ref3[4].body.data.items,
	            _ref3$5$body$data$ite = _slicedToArray(_ref3[5].body.data.items, 1),
	            education = _ref3$5$body$data$ite[0],
	            _ref3$6$body$data$ite = _slicedToArray(_ref3[6].body.data.items, 1),
	            licenses = _ref3$6$body$data$ite[0],
	            _ref3$7$body$data$ite = _slicedToArray(_ref3[7].body.data.items, 1),
	            documents = _ref3$7$body$data$ite[0],
	            _ref3$8$body$data$ite = _slicedToArray(_ref3[8].body.data.items, 1),
	            references = _ref3$8$body$data$ite[0],
	            interviews = _ref3[9].body.data.items,
	            answers = _ref3[10].body.data.items,
	            workObjectives = _ref3[11].body.data.items,
	            ratings = _ref3[12].body.data.items,
	            assessments = _ref3[13].body.data.items,
	            technologySurvey = _ref3[14].body.data;
	
	        return dispatch(syncActionCreators.updateApplicant({
	          workExperiences: workExperiences,
	          employmentGaps: employmentGaps,
	          skills: _lodash2.default.reduce(skills, function (obj, skill) {
	            if (!obj[skill.categoryId]) {
	              obj[skill.categoryId] = {};
	            }
	            obj[skill.categoryId][skill.name] = skill;
	            return obj;
	          }, {}),
	          associations: _lodash2.default.keyBy(associations, 'name'),
	          designations: _lodash2.default.keyBy(designations, 'name'),
	          education: education,
	          licenses: licenses,
	          documents: documents,
	          references: references,
	          interviews: _lodash2.default.keyBy(interviews, 'clientId'),
	          behavioralAnswers: _lodash2.default.keyBy(answers, 'questionId'),
	          workObjectives: _lodash2.default.keyBy(workObjectives, 'questionId'),
	          ratings: _lodash2.default.keyBy(ratings, 'ratingId'),
	          assessments: _lodash2.default.keyBy(assessments, 'testId'),
	          technologySurvey: technologySurvey
	        }));
	      }).catch(function (err) {
	        return _bluebird2.default.reject(err, 'Unable to load rest of applicant profile info');
	      });
	    };
	  };
	}
	
	function loadApplicantProfileInfo(id) {
	  if (_lodash2.default.isNil(id)) {
	    return _bluebird2.default.resolve();
	  }
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return _lodash2.default.isNil(id) ? _bluebird2.default.resolve() : _bluebird2.default.all([simpleIsoFetch.get('/api/applicants/' + id), simpleIsoFetch.get('/api/applicants/' + id + '/user')]).then(function (_ref4) {
	        var _ref5 = _slicedToArray(_ref4, 2),
	            _ref5$0$body$data$ite = _slicedToArray(_ref5[0].body.data.items, 1),
	            profile = _ref5$0$body$data$ite[0],
	            _ref5$1$body$data$ite = _slicedToArray(_ref5[1].body.data.items, 1),
	            applicantUser = _ref5$1$body$data$ite[0];
	
	        dispatch(syncActionCreators.updateApplicant({
	          profile: profile,
	          applicantUser: applicantUser
	        }));
	      }).catch(function (err) {
	        return _bluebird2.default.reject(err, 'Unable to load Applicant Profile Info');
	      });
	    };
	  };
	}
	
	function getProfileById(id) {
	  if (_lodash2.default.isNil(id)) {
	    return _bluebird2.default.resolve();
	  }
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return _lodash2.default.isNil(id) ? _bluebird2.default.resolve() : _bluebird2.default.all([simpleIsoFetch.get('/api/applicants/' + id), simpleIsoFetch.get('/api/applicants/' + id + '/user'), simpleIsoFetch.get('/api/applicants/' + id + '/workexperiences'), simpleIsoFetch.get('/api/applicants/' + id + '/employmentgaps'), simpleIsoFetch.get('/api/applicants/' + id + '/skills'), simpleIsoFetch.get('/api/applicants/' + id + '/associations'), simpleIsoFetch.get('/api/applicants/' + id + '/designations'), simpleIsoFetch.get('/api/applicants/' + id + '/education'), simpleIsoFetch.get('/api/applicants/' + id + '/licenses'), simpleIsoFetch.get('/api/applicants/' + id + '/documents'), simpleIsoFetch.get('/api/applicants/' + id + '/references'), simpleIsoFetch.get('/api/applicants/' + id + '/references/interviews'), simpleIsoFetch.get('/api/applicants/' + id + '/behavioral'), simpleIsoFetch.get('/api/applicants/' + id + '/workobjectives'), simpleIsoFetch.get('/api/applicants/' + id + '/ratings'), simpleIsoFetch.get('/api/applicants/' + id + '/assessments'), simpleIsoFetch.get('/api/applicants/' + id + '/technologysurveys')]).then(function (_ref6) {
	        var _ref7 = _slicedToArray(_ref6, 17),
	            _ref7$0$body$data$ite = _slicedToArray(_ref7[0].body.data.items, 1),
	            profile = _ref7$0$body$data$ite[0],
	            _ref7$1$body$data$ite = _slicedToArray(_ref7[1].body.data.items, 1),
	            applicantUser = _ref7$1$body$data$ite[0],
	            _ref7$2$body$data$ite = _slicedToArray(_ref7[2].body.data.items, 1),
	            workExperiences = _ref7$2$body$data$ite[0],
	            _ref7$3$body$data$ite = _slicedToArray(_ref7[3].body.data.items, 1),
	            employmentGaps = _ref7$3$body$data$ite[0],
	            skills = _ref7[4].body.data.items,
	            associations = _ref7[5].body.data.items,
	            designations = _ref7[6].body.data.items,
	            _ref7$7$body$data$ite = _slicedToArray(_ref7[7].body.data.items, 1),
	            education = _ref7$7$body$data$ite[0],
	            _ref7$8$body$data$ite = _slicedToArray(_ref7[8].body.data.items, 1),
	            licenses = _ref7$8$body$data$ite[0],
	            _ref7$9$body$data$ite = _slicedToArray(_ref7[9].body.data.items, 1),
	            documents = _ref7$9$body$data$ite[0],
	            _ref7$10$body$data$it = _slicedToArray(_ref7[10].body.data.items, 1),
	            references = _ref7$10$body$data$it[0],
	            interviews = _ref7[11].body.data.items,
	            answers = _ref7[12].body.data.items,
	            workObjectives = _ref7[13].body.data.items,
	            ratings = _ref7[14].body.data.items,
	            assessments = _ref7[15].body.data.items,
	            _ref7$16$body$data$it = _slicedToArray(_ref7[16].body.data.items, 1),
	            technologySurvey = _ref7$16$body$data$it[0];
	
	        return dispatch(syncActionCreators.updateApplicant({
	          profile: profile,
	          applicantUser: applicantUser,
	          workExperiences: workExperiences,
	          employmentGaps: employmentGaps,
	          skills: _lodash2.default.reduce(skills, function (obj, skill) {
	            if (!obj[skill.categoryId]) {
	              obj[skill.categoryId] = {};
	            }
	            obj[skill.categoryId][skill.name] = skill;
	            return obj;
	          }, {}),
	          associations: _lodash2.default.keyBy(associations, 'name'),
	          designations: _lodash2.default.keyBy(designations, 'name'),
	          education: education,
	          licenses: licenses,
	          documents: documents,
	          references: references,
	          interviews: _lodash2.default.keyBy(interviews, 'clientId'),
	          behavioralAnswers: _lodash2.default.keyBy(answers, 'questionId'),
	          workObjectives: _lodash2.default.keyBy(workObjectives, 'questionId'),
	          ratings: _lodash2.default.keyBy(ratings, 'ratingId'),
	          assessments: _lodash2.default.keyBy(assessments, 'testId'),
	          technologySurvey: technologySurvey
	        }));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function persistApplicantUpdate(updateObj) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.put('/api/applicants/' + updateObj.profile.id, {
	        body: updateObj
	      }).then(function () {
	        return true;
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function persistListUpdate(route, property, updateObj) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return _bluebird2.default.all(_lodash2.default.map(updateObj[property], function (_ref8, clientId) {
	        var isNew = _ref8.isNew,
	            experience = _objectWithoutProperties(_ref8, ['isNew']);
	
	        return isNew && simpleIsoFetch.post('/api/applicants/' + updateObj.profile.id + '/' + route + '/' + clientId, {
	          body: experience
	        }) || updateObj[property][clientId] === Symbol.for('__delete') && simpleIsoFetch.del('/api/applicants/' + updateObj.profile.id + '/' + route + '/' + clientId) || simpleIsoFetch.put('/api/applicants/' + updateObj.profile.id + '/' + route + '/' + clientId, {
	          body: experience
	        });
	      }).concat(
	      // allow for profile properties to be added in addition to list ones
	      Object.keys(updateObj.profile).length > 1 && simpleIsoFetch.put('/api/applicants/' + updateObj.profile.id, {
	        body: _lodash2.default.pick(updateObj, ['profile', 'user'])
	      }) || [])).then().catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function updateApplicantList(route, property, applicantId, clientId, updateObj) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.put('/api/applicants/' + applicantId + '/' + route + '/' + clientId, {
	        body: updateObj
	      }).then().catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function persistSkills(updateObj) {
	  var skills = _lodash2.default.pickBy(updateObj.skills, function (i) {
	    return !_lodash2.default.isNil(i);
	  });
	  var updates = _lodash2.default.compact(_lodash2.default.map(skills, function (cat) {
	    var list = _lodash2.default.filter(cat, function (s) {
	      return s && !s.deleted;
	    });
	    return list.length ? list : undefined;
	  }));
	  var deletions = _lodash2.default.flatten(_lodash2.default.map(skills, function (cat) {
	    return _lodash2.default.filter(cat, function (s) {
	      return s.deleted === Symbol.for('_deleted_');
	    });
	  }));
	
	  return function (simpleIsoFetch) {
	    return function () {
	      return _bluebird2.default.all(_lodash2.default.map(updates, function (update) {
	        return simpleIsoFetch.post('/api/applicants/' + updateObj.profile.id + '/skills/category/' + update[0].categoryId, {
	          body: update
	        });
	      }), _lodash2.default.map(deletions, function (skill) {
	        return simpleIsoFetch.del('/api/applicants/' + updateObj.profile.id + '/skills/category/' + skill.categoryId, {
	          query: { name: skill.name }
	        });
	      }).concat(_lodash2.default.get(updateObj, 'profile.viewState', null) && simpleIsoFetch.put('/api/applicants/' + updateObj.profile.id, {
	        body: _lodash2.default.pick(updateObj, ['profile', 'user'])
	      }) || [])).then().catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function persistBackground(updateObj, resource) {
	  var updates = _lodash2.default.map(_lodash2.default.filter(updateObj[resource], function (item) {
	    return item && !item.deleted;
	  }), function (i) {
	    return i.name;
	  });
	  var deletions = _lodash2.default.map(_lodash2.default.filter(updateObj[resource], function (item) {
	    return item && item.deleted === Symbol.for('_deleted_');
	  }), function (i) {
	    return i.name;
	  });
	
	  return function (simpleIsoFetch) {
	    return function () {
	      return _bluebird2.default.all([updates.length ? simpleIsoFetch.post('/api/applicants/' + updateObj.profile.id + '/' + resource, {
	        body: updates
	      }) : _bluebird2.default.resolve(), deletions.length ? simpleIsoFetch.del('/api/applicants/' + updateObj.profile.id + '/' + resource, {
	        body: deletions
	      }) : _bluebird2.default.resolve()].concat(_lodash2.default.get(updateObj, 'profile.viewState', null) && simpleIsoFetch.put('/api/applicants/' + updateObj.profile.id, {
	        body: _lodash2.default.pick(updateObj, ['profile', 'user'])
	      }) || [])).then().catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function deleteWorkExperience(profileId, clientId) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      dispatch(syncActionCreators.deleteWorkExperience(clientId));
	      return simpleIsoFetch.del('/api/applicants/' + profileId + '/workExperiences/' + clientId).then().catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	// Admin
	function search(terms, filters) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      return _bluebird2.default.props( // pull names off static 'statusGroup' values and 'maps' through them to make promise object properties
	      (0, _lodash2.default)(getState().user.statusGroups).keyBy().mapValues(function (value, key) {
	        return simpleIsoFetch.get({
	          route: '/api/applicants',
	          query: _extends({
	            group: key,
	            terms: terms
	          }, filters, {
	            mode: 'list'
	          })
	        });
	      }).value()).then(function (PromiseRes) {
	        return dispatch(syncActionCreators.updateApplicantsList(_lodash2.default.mapValues(PromiseRes, function (statusGroup) {
	          return statusGroup.body.data;
	        })));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function goToPage(terms, filters, group, skip, sortBy) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/applicants',
	        query: _extends({
	          group: group,
	          terms: terms,
	          skip: skip
	        }, filters, sortBy, {
	          mode: 'list'
	        })
	      }).then(function (_ref9) {
	        var data = _ref9.body.data;
	        return dispatch(syncActionCreators.updateApplicantsPage(group, data));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	// Admin
	function retrieve(id) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/applicants',
	        query: {
	          id: id,
	          mode: 'detail'
	        }
	      }).then(function (_ref10) {
	        var _ref10$body$data$item = _slicedToArray(_ref10.body.data.items, 1),
	            applicant = _ref10$body$data$item[0];
	
	        return dispatch(syncActionCreators.updateCurrentApplicantAdmin(applicant));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	// Admin
	function searchContacts(terms) {
	  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var skip = arguments[2];
	  var limit = arguments[3];
	
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      return simpleIsoFetch.get({
	        route: '/api/contacts',
	        query: _extends({
	          terms: terms
	        }, filters, {
	          skip: skip,
	          limit: limit
	        })
	      }).then(function (PromiseRes) {
	        dispatch(syncActionCreators.updateContactsPage(PromiseRes.body.data));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	// Admin
	function searchCompanies(terms, filters) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      return simpleIsoFetch.get({
	        route: '/api/companies',
	        query: _extends({
	          terms: terms
	        }, filters)
	      }).then(function (PromiseRes) {
	        dispatch(syncActionCreators.updateCompaniesList(PromiseRes.body.data));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function updateApplicantAdmin(updatedApplicant, group, arrayIndex, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      dispatch(syncActionCreators.updateApplicantAdmin(updatedApplicant, group, arrayIndex));
	
	      // handle conversion of dropdowns to ids
	      var updatedApplicantServer = _lodash2.default.cloneDeep(updatedApplicant);
	      _lodash2.default.forEach(updatedApplicantServer, function (applicantProp) {
	        _lodash2.default.merge(applicantProp, _lodash2.default.mapValues(applicantProp, function (updatingProp) {
	          return updatingProp && updatingProp.hasOwnProperty('name') ? updatingProp.id : updatingProp;
	        }));
	      });
	
	      // handle applicantData json update for server
	      if (updatedApplicantServer.profile.accordionData) {
	        _lodash2.default.merge(updatedApplicantServer.profile.accordionData, getState().admin.applicants[group][arrayIndex].profile.accordionData || {});
	      }
	
	      return simpleIsoFetch.put({
	        route: '/api/applicants/' + updatedApplicant.profile.id,
	        body: updatedApplicantServer
	      }).then(function (data) {
	        if (callback) {
	          return callback(null, data);
	        } else {
	          return data;
	        }
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.error(err);
	        }
	        if (callback) callback(err);
	      });
	    };
	  };
	}
	
	function updateApplicantStatus(applicant, status, group, arrayIndex) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	
	      var statusGroups = getState().staticData.statusGroups;
	      var newGroup = _lodash2.default.find(statusGroups, function (g) {
	        return ~g.statuses.indexOf(status.id);
	      });
	      applicant.profile.applicantStatus = status;
	      applicant.profile.statusGroup = newGroup.name;
	      dispatch(syncActionCreators.updateApplicant(applicant));
	      dispatch(syncActionCreators.updateApplicantAdmin(applicant, group, arrayIndex, newGroup.name));
	
	      simpleIsoFetch.put({
	        route: '/api/applicants/' + applicant.profile.id + '/status/' + status.id
	      }).then().catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function deleteApplicant(applicantId, group) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.del({
	        route: '/api/applicants/' + applicantId
	      }).then(function () {
	        return dispatch(syncActionCreators.deleteApplicantAdmin(applicantId, group));
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function submitEvent(eventRoute, body, eventExtra) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var _getState = getState(),
	          _getState$user = _getState.user,
	          id = _getState$user.id,
	          name = _getState$user.name;
	
	      if (body.applicantId) {
	        if (eventExtra && eventExtra.type == 'edit') {
	          simpleIsoFetch.put({
	            route: '/api/applicants/' + body.applicantId + '/' + eventRoute + '/' + eventExtra.param,
	            body: _lodash2.default.omit(body, ['taskTypeName'])
	          }).then(function (resp) {
	            dispatch(syncActionCreators.updateEventList(_lodash2.default.merge({
	              eventRoute: eventRoute,
	              dateCreated: Date(),
	              createdBy: {
	                userId: id,
	                name: name
	              }
	            }, body)));
	          }, function (err) {
	            console.log(err);
	          });
	        } else {
	          simpleIsoFetch.post({
	            route: '/api/applicants/' + body.applicantId + '/' + eventRoute,
	            body: _lodash2.default.omit(body, ['taskTypeName'])
	          }).then(function (resp) {
	            body.id = resp.body.data.items[0].id;
	            dispatch(syncActionCreators.updateEventList(_lodash2.default.merge({
	              eventRoute: eventRoute,
	              dateCreated: Date(),
	              createdBy: {
	                userId: id,
	                name: name
	              }
	            }, body)));
	          }, function (err) {
	            console.log(err);
	          });
	        }
	      }
	    };
	  };
	}
	
	function getApplicantBehavioralAnswers(applicant) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/applicants/' + applicant.profile.id + '/behavioral'
	      }).then(function (_ref11) {
	        var answers = _ref11.body.data.items;
	
	        var behavioralAnswers = _lodash2.default.keyBy(answers, 'questionId');
	        dispatch(syncActionCreators.updateApplicantBehavioralAnswers({
	          behavioralAnswers: behavioralAnswers
	        }));
	      }).catch(function (err) {
	        console.error(err);
	      });
	    };
	  };
	}
	
	function updateApplicantBehavioralAnswers(applicant, behavioralAnswers, group, arrayIndex) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	
	      dispatch(syncActionCreators.updateApplicantBehavioralAnswers({
	        behavioralAnswers: behavioralAnswers
	      }));
	
	      var body = [];
	      _lodash2.default.each(behavioralAnswers, function (value, key) {
	        body.push({ questionId: key, answer: value.answer });
	      });
	
	      simpleIsoFetch.post({
	        route: '/api/applicants/' + applicant.profile.id + '/behavioral',
	        body: body
	      }).then().catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function getApplicantWorkObjectives(applicant) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/applicants/' + applicant.profile.id + '/workobjectives'
	      }).then(function (_ref12) {
	        var answers = _ref12.body.data.items;
	
	        var workObjectives = _lodash2.default.keyBy(answers, 'questionId');
	        dispatch(syncActionCreators.updateApplicantWorkObjectives({
	          workObjectives: workObjectives
	        }));
	      }).catch(function (err) {
	        console.error(err);
	      });
	    };
	  };
	}
	
	function updateApplicantWorkObjectives(applicant, workObjectives, group, arrayIndex) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	
	      dispatch(syncActionCreators.updateApplicantWorkObjectives({
	        workObjectives: workObjectives
	      }));
	
	      var body = [];
	      _lodash2.default.each(workObjectives, function (value, key) {
	        body.push({ questionId: key, answer: value.answer });
	      });
	
	      simpleIsoFetch.post({
	        route: '/api/applicants/' + applicant.profile.id + '/workobjectives',
	        body: body
	      }).then().catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function updateApplicantInterviewRatings(applicant, ratings, group, arrayIndex) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	
	      dispatch(syncActionCreators.updateApplicantInterviewRatings({
	        ratings: ratings
	      }));
	
	      var body = [];
	      _lodash2.default.each(ratings, function (value, key) {
	        body.push({ ratingId: key, rating: value.rating });
	      });
	
	      simpleIsoFetch.post({
	        route: '/api/applicants/' + applicant.profile.id + '/ratings',
	        body: body
	      }).then().catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	// DEPRECATED
	function updateApplicantAssessments(applicant, assessments) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      dispatch(syncActionCreators.updateApplicantAssessments({
	        assessments: assessments
	      }));
	
	      var body = [];
	      _lodash2.default.each(assessments, function (value, key) {
	        body.push(_extends({ testId: key }, value));
	      });
	
	      simpleIsoFetch.post({
	        route: '/api/applicants/' + applicant.profile.id + '/assessments',
	        body: body
	      }).then().catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function persistReferencesInterviews(applicant, body) {
	  var route = '/api/applicants/' + applicant.profile.id + '/references/interviews';
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      var req = body.isNew ? simpleIsoFetch.post({ route: route, body: body }) : simpleIsoFetch.put({ route: route + '/' + body.clientId, body: body });
	      req.then(function () {
	        dispatch(syncActionCreators.updateApplicantReferencesInterviews(_extends({}, body, { isNew: false, isDirty: false })));
	      }).catch(function (err) {
	        console.error(err);
	      });
	    };
	  };
	}
	
	function retrievePlacementSpecialists() {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.get({
	        route: '/api/admin/employees',
	        query: {
	          roleName: 'Placement Specialist'
	        }
	      }).then(function (_ref13) {
	        var specialists = _ref13.body.data.items;
	        return dispatch(syncActionCreators.updatePlacementSpecialists(specialists));
	      }).catch(function (err) {
	        console.error(err);
	      });
	    };
	  };
	}
	
	function createProspect(body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.post({
	        route: '/api/contacts',
	        body: body
	      }).then(function (resp) {
	        callback.success(resp.body.data.items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function updateProspect(body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.put({
	        route: '/api/contacts/' + body.contactId,
	        body: body
	      }).then(function (resp) {
	        callback.success(resp.body.data.items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function checkAndCreateContact(body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.post({
	        route: '/api/contacts/check',
	        body: body
	      }).then(function (resp) {
	        callback.success(resp.body.data.items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function submitContactEvent(contactEventRoute, body, eventExtra) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var _getState2 = getState(),
	          _getState2$user = _getState2.user,
	          id = _getState2$user.id,
	          name = _getState2$user.name;
	
	      if (body.contactId) {
	        if (eventExtra && eventExtra.type == 'edit') {
	          simpleIsoFetch.put({
	            route: '/api/contacts/' + body.contactId + '/' + contactEventRoute + '/' + eventExtra.param,
	            body: _lodash2.default.omit(body, ['taskTypeName'])
	          }).then(function (resp) {
	            dispatch(syncActionCreators.updateContactEventList(_lodash2.default.merge({
	              contactEventRoute: contactEventRoute,
	              dateCreated: Date(),
	              createdBy: {
	                userId: id,
	                name: name
	              }
	            }, body)));
	          }, function (err) {
	            console.log(err);
	          });
	        } else {
	          simpleIsoFetch.post({
	            route: '/api/contacts/' + body.contactId + '/' + contactEventRoute,
	            body: _lodash2.default.omit(body, ['taskTypeName'])
	          }).then(function (resp) {
	            body.id = resp.body.data.items[0].id;
	            dispatch(syncActionCreators.updateContactEventList(_lodash2.default.merge({
	              contactEventRoute: contactEventRoute,
	              dateCreated: Date(),
	              createdBy: {
	                userId: id,
	                name: name
	              }
	            }, body)));
	          }, function (err) {
	            console.log(err);
	          });
	        }
	      }
	    };
	  };
	}
	
	function updatePassword(body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.put({
	        route: '/api/users/' + body.id,
	        body: body
	      }).then(function (resp) {
	        callback.success(resp);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	// Companies
	function getCompanyById(id, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/companies/' + id
	      }).then(function (res) {
	
	        if (callback && callback.success) {
	          return callback.success(res.body.data);
	        }
	
	        return res.body.data;
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	
	        if (callback && callback.error) {
	          return callback.error(err);
	        }
	
	        return err;
	      });
	    };
	  };
	}
	
	// Alerts
	function getAlerts(callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.get({
	        route: '/api/alerts'
	      }).then(function (_ref14) {
	        var items = _ref14.body.data;
	
	        callback.success(items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function readAlert(alertId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.get({
	        route: '/api/alerts/' + alertId
	      }).then(function (_ref15) {
	        var items = _ref15.body.data;
	
	        callback.success(items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function deleteAlert(alertId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.del({
	        route: '/api/alerts/' + alertId
	      }).then(function (_ref16) {
	        var items = _ref16.body.data;
	
	        callback.success(items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function getApplicantAssessmentTests(id, cb) {
	  if (_lodash2.default.isNil(id)) {
	    return _bluebird2.default.reject('Applicant ID is null');
	  }
	
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.get('/api/applicants/' + id + '/assessments/tests').then(function (_ref17) {
	        var items = _ref17.body.data.items;
	        return cb ? cb(null, items) : items;
	      }).catch(function (err) {
	        return cb ? cb(err) : _bluebird2.default.reject(err);
	      });
	    };
	  };
	}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utility library
	
	
	// class names utility
	
	
	// import component from material UI
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Toggle = __webpack_require__(276);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _isServer = __webpack_require__(207);
	
	var _isServer2 = _interopRequireDefault(_isServer);
	
	var _fixLines = __webpack_require__(234);
	
	var _fixLines2 = _interopRequireDefault(_fixLines);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomTextArea = (_temp = _class = function (_Component) {
	  _inherits(CustomTextArea, _Component);
	
	  function CustomTextArea(props, context) {
	    _classCallCheck(this, CustomTextArea);
	
	    // needed internally by material-ui
	    var _this = _possibleConstructorReturn(this, (CustomTextArea.__proto__ || Object.getPrototypeOf(CustomTextArea)).call(this, props, context));
	
	    _this.toggleExample = function () {
	      return _this.setState({
	        showExample: !_this.state.showExample
	      });
	    };
	
	    _this.clear = function () {
	      return _this.onKeyUp(null, null);
	    };
	
	    if (!_isServer2.default) {
	      _this.validate = _lodash2.default.debounce(_this.validate.bind(_this), 16); // debounce to eye frame rate
	    } else {
	      _this.validate = _this.validate.bind(_this);
	    }
	
	    // setting initial state
	    _this.state = {
	      focused: false,
	      dirty: false,
	      passwordShow: false,
	      errors: [],
	      showExample: false
	    };
	
	    // check for initial value
	    var initVal = props.hasOwnProperty('value') ? props.value : props.hasOwnProperty('defaultValue') ? props.defaultValue : null;
	
	    // textLength stored displaying
	    _this.state.textLength = initVal && initVal.length || 0;
	
	    // run validation
	    var hasValidation = _this.validate(initVal);
	
	    // if no validaton provided, still mark as dirty if intial value provided
	    if (!hasValidation && initVal) {
	      // even without validation, should still set state to dirty if initial value is populated
	      _lodash2.default.assign(_this.state, { dirty: true });
	    }
	    return _this;
	  }
	
	  _createClass(CustomTextArea, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var newTextLengthObj = { textLength: _lodash2.default.get(nextProps.value, 'length', 0) };
	        var hasValidation = this.validate(nextProps.value, newTextLengthObj);
	        if (!hasValidation) {
	          this.setState(_extends({}, this.state, newTextLengthObj));
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      // Not allow to type more characters if max reached.
	      if (this.props.maxLength) {
	        if (event.target.value.length >= this.props.maxLength) {
	          event.preventDefault();
	          event.target.value = event.target.value.substring(0, this.props.maxLength);
	        }
	      }
	
	      event.target.value = (0, _fixLines2.default)(event.target.value);
	      if (this.props.onChange) this.props.onChange(event, event.target.value);
	      if (this.props.onKeyUp) this.props.onKeyUp(event, event.target.value);
	      if (!this.props.hasOwnProperty('value')) {
	        var textLength = _lodash2.default.get(event.target.value, 'length', 0);
	        var hasValidation = this.validate(event.target.value, this.props.showCharacterCount && { textLength: textLength } || {});
	        if (!hasValidation && this.props.showCharacterCount) this.setState(_extends({}, this.state, { textLength: textLength }));
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      event.target.value = (0, _fixLines2.default)(event.target.value);
	      this.setState(_extends({}, this.state, {
	        focused: true
	      }));
	      if (this.props.onFocus) {
	        this.props.onFocus(event, event.target.value && event.target.value.trim && event.target.value.trim() || event.target.value);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      event.target.value = (0, _fixLines2.default)(event.target.value);
	
	      // capitalized sentences.
	      if (this.props.capitalizedSentences) {
	        var text = event.target.value;
	        text = text.charAt(0).toUpperCase() + text.substr(1);
	        text = text.replace(/[\.\?\!]\s+.+?/g, function (str) {
	          return str.substr(0, str.length - 1) + str.charAt(str.length - 1).toUpperCase();
	        });
	        event.target.value = text;
	      }
	
	      var updateStateObj = { focused: false };
	      if (!this.state.dirty) updateStateObj.dirty = true; // set dirty if not already dirty
	      this.setState(_extends({}, this.state, updateStateObj));
	      if (this.props.onBlur) {
	        this.props.onBlur(event, event.target.value && event.target.value.trim && event.target.value.trim() || event.target.value);
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(value, additionalStateUpdate) {
	      var updateStateObj = { errors: [] };
	
	      // Custom validator defined outside.
	      if (this.props.validator) {
	        updateStateObj.errors = this.props.validator(value);
	      } else if (this.props.validation) {
	        updateStateObj.errors = (0, _modelValidator.validateField)(value, this.props.validation);
	      }
	
	      if (additionalStateUpdate) {
	        updateStateObj = _extends({}, additionalStateUpdate, updateStateObj);
	      }
	
	      // emit error change to parent
	      var errorCountChange = updateStateObj.errors.length === this.state.errors.length ? null : updateStateObj.errors.length > this.state.errors.length ? 1 : -1;
	
	      if (this.props.onErrorChange && errorCountChange) {
	        this.props.onErrorChange(errorCountChange);
	      }
	
	      // update local error state
	      this.setState(_extends({}, this.state, updateStateObj));
	      return true;
	    }
	  }, {
	    key: 'checkErrors',
	    value: function checkErrors() {
	      if (!this.state.dirty) this.state.dirty = true; // set dirty if not already dirty
	    }
	
	    // allows clearing from parent if needed for some hacky reason
	
	  }, {
	    key: 'render',
	    value: function render() {
	      // take out properties that will be overwritten from 'this.props'
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          rootStyle = _props.rootStyle,
	          errorStyle = _props.errorStyle,
	          errorText = _props.errorText,
	          descriptionHead = _props.descriptionHead,
	          description = _props.description,
	          descriptionBottom = _props.descriptionBottom,
	          onKeyUp = _props.onKeyUp,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          validation = _props.validation,
	          maxLength = _props.maxLength,
	          exampleText = _props.exampleText,
	          capitalizedSentences = _props.capitalizedSentences,
	          showCharacterCount = _props.showCharacterCount,
	          dataId = _props['data-id'],
	          unmodifiedProps = _objectWithoutProperties(_props, ['className', 'style', 'rootStyle', 'errorStyle', 'errorText', 'descriptionHead', 'description', 'descriptionBottom', 'onKeyUp', 'onFocus', 'onBlur', 'validation', 'maxLength', 'exampleText', 'capitalizedSentences', 'showCharacterCount', 'data-id']);
	
	      var additionalProps = {
	        id: this.id,
	        onChange: this.onChange.bind(this),
	        onFocus: this.onFocus.bind(this),
	        onBlur: this.onBlur.bind(this)
	      };
	
	      // get booleans
	      var errorStr = void 0;
	      var isError = (this.props.isDirty || this.state.dirty) && (typeof this.props.errorText !== 'undefined' || this.state.errors.length); // check passed in error string and local state errors array, only show if value is dirty
	
	      // handle error state visually
	      if (isError) {
	        // set error string
	        errorStr = (errorText && [errorText] || []).concat(this.state.errors).join(', '); // combine passed in error string and local state errors array
	      }
	
	      // handle optional state visually
	      if (this.props.optional) {
	        if (!isError) {
	          additionalProps.errorText = '(optional)';
	          additionalProps.errorStyle = _lodash2.default.merge({}, errorStyle, {
	            color: '#c9c9c9'
	          });
	        } else {
	          additionalProps.errorText = '(optional) ' + errorStr;
	        }
	      } else if (isError) {
	        additionalProps.errorText = errorStr;
	      }
	
	      // Fixed line chars.
	      unmodifiedProps.value = (0, _fixLines2.default)(unmodifiedProps.value);
	      unmodifiedProps.defaultValue = (0, _fixLines2.default)(unmodifiedProps.defaultValue);
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('textarea-container', 'clearfix', className, {
	            focused: this.state.focused,
	            error: isError,
	            optional: this.props.optional && !isError
	          }),
	          style: _extends({}, !exampleText && { textAlign: 'left' } || {}, rootStyle)
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'description' },
	          descriptionHead && _react2.default.createElement(
	            'b',
	            null,
	            descriptionHead,
	            description && ': '
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            description
	          )
	        ),
	        exampleText && _react2.default.createElement(
	          'div',
	          { className: 'example-toggle-container' },
	          'Example',
	          _react2.default.createElement(_Toggle2.default, {
	            'data-id': 'Script',
	            className: 'example-toggle-icon',
	            disableTouchRipple: true,
	            disableFocusRipple: true,
	            labelPosition: 'left',
	            toggled: this.state.showExample,
	            onToggle: this.toggleExample,
	            style: { transition: 'none' },
	            elementStyle: { transition: 'none' },
	            trackStyle: { height: '8px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1)' },
	            thumbStyle: { top: '-2px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1), left .2s cubic-bezier(0.23, 1, 0.32, 1), margin .2s cubic-bezier(0.23, 1, 0.32, 1)' }
	          })
	        ),
	        this.state.showExample && _react2.default.createElement(
	          'div',
	          {
	            'data-id': 'Example',
	            className: 'form-text example-text'
	          },
	          exampleText
	        ),
	        _react2.default.createElement('textarea', _extends({
	          style: _extends({}, style)
	        }, unmodifiedProps, additionalProps, {
	          'data-id': dataId,
	          className: 'textarea'
	        })),
	        _react2.default.createElement(
	          'div',
	          { className: 'below-textarea' },
	          descriptionBottom && _react2.default.createElement(
	            'div',
	            { className: 'bottom-description' },
	            descriptionBottom
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)('error-text', { opaque: errorStr })
	            },
	            errorStr
	          ),
	          this.props.showCharacterCount && _react2.default.createElement(
	            'div',
	            {
	              className: 'character-count'
	            },
	            (this.state.textLength || 0) + '/' + maxLength
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomTextArea;
	}(_react.Component), _class.propTypes = {
	  // labelling
	  id: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  'data-id': _react.PropTypes.string,
	
	  // options
	  optional: _react.PropTypes.bool,
	  showCharacterCount: _react.PropTypes.bool,
	  maxLength: _react.PropTypes.number,
	  capitalizedSentences: _react.PropTypes.bool,
	  exampleText: _react.PropTypes.string,
	  descriptionHead: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  descriptionBottom: _react.PropTypes.string,
	
	  // inline styling if they go that way :(
	  style: _react.PropTypes.object,
	  rootStyle: _react.PropTypes.object,
	  errorStyle: _react.PropTypes.object,
	
	  // determining value
	  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react2.default.PropTypes.number]),
	  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react2.default.PropTypes.number]),
	
	  // validation
	  validation: _react.PropTypes.object,
	  validator: _react.PropTypes.func,
	  onErrorChange: _react.PropTypes.func,
	  errorText: _react.PropTypes.string,
	
	  // change handling
	  onChange: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func
	}, _temp);
	exports.default = CustomTextArea;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(172);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string";
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    "object" !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"})[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(61)))

/***/ }),
/* 41 */
[3162, 257, 156, 29],
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2753)();
	}


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ModalX;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ModalX(props) {
	  var className = props.className,
	      _props$style = props.style,
	      color = _props$style.color,
	      fill = _props$style.fill,
	      otherStyle = _objectWithoutProperties(_props$style, ['color', 'fill']),
	      otherProps = _objectWithoutProperties(props, ['className', 'style']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({ className: 'modal-x ' + className, style: otherStyle, width: '15px', height: '14px', viewBox: '0 0 15 14', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' }, otherProps),
	    _react2.default.createElement(
	      'g',
	      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(-841.000000, -153.000000)', fill: fill || color || '#9B9B9B' },
	        _react2.default.createElement('polygon', { points: '855.750958 165.6 854.275862 167 848.375479 161.4 842.475096 167 841 165.6 846.900383 160 841 154.4 842.475096 153 848.375479 158.6 854.275862 153 855.750958 154.4 849.850575 160' })
	      )
	    )
	  );
	}
	
	ModalX.propTypes = {
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object
	};
	
	ModalX.defaultProps = {
	  style: {}
	};

/***/ }),
/* 44 */
[3123, 34],
/* 45 */
[3141, 27, 518, 104, 44],
/* 46 */
[3157, 103],
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatPhone;
	
	var _phoneify = __webpack_require__(279);
	
	var _phoneify2 = _interopRequireDefault(_phoneify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatPhone(phone) {
	  try {
	    return performFormatting(stripDigits(phone));
	  } catch (err) {
	    console.warn('Error formatting phone number ' + phone + ': ' + err.message);
	  }
	  return '';
	}
	
	function stripDigits(input) {
	  return input && input.replace ? input.replace(/\D/g, '') : input;
	}
	
	function performFormatting(strippedPhone) {
	
	  if (!strippedPhone) {
	    return '';
	  }
	
	  var phoneified = (0, _phoneify2.default)(strippedPhone);
	  if (!phoneified) {
	    throw new Error('Phoneify returned null (see log msg)');
	  }
	
	  return phoneified.countryCodeRemoved ? phoneified.countryCodeRemoved.addTrailingSlashes : '';
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var DOMProperty = __webpack_require__(193);
	var ReactDOMComponentFlags = __webpack_require__(794);
	
	var invariant = __webpack_require__(22);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID == null) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getCompany = getCompany;
	exports.goToPage = goToPage;
	exports.getCompanyJobs = getCompanyJobs;
	exports.getCompanyContacts = getCompanyContacts;
	exports.addCompanyContacts = addCompanyContacts;
	exports.updateCompanyContact = updateCompanyContact;
	exports.updateContactsByCompanyId = updateContactsByCompanyId;
	exports.deleteCompanyContact = deleteCompanyContact;
	exports.updateCompany = updateCompany;
	exports.updateCompanyById = updateCompanyById;
	exports.updateCompanyStatus = updateCompanyStatus;
	exports.getCompanyTech = getCompanyTech;
	exports.createCompanyTech = createCompanyTech;
	exports.updateCompanyTech = updateCompanyTech;
	exports.deleteCompany = deleteCompany;
	
	var _lodash = __webpack_require__(4);
	
	var _companies = __webpack_require__(483);
	
	var _index = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getCompany(id, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var groups = getState().staticData.companyStatusGroups;
	      simpleIsoFetch.get('/api/companies/' + id).then(function (_ref) {
	        var _ref$body$data$items = _slicedToArray(_ref.body.data.items, 1),
	            company = _ref$body$data$items[0];
	
	        return (0, _companies.findGrouping)({ company: company, groups: groups });
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function goToPage(skip, limit, terms, filters) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/companies',
	        query: _extends({
	          terms: terms
	        }, filters, {
	          skip: skip,
	          limit: limit
	        })
	      }).then(function (data) {
	        dispatch(syncActionCreators.updateCompaniesPage(data.body.data));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function getCompanyJobs(id, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get('/api/companies/' + id + '/jobs').then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function getCompanyContacts(id, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get('/api/companies/' + id + '/contacts').then(function (data) {
	        if (callback) callback(null, data);
	
	        return data;
	      }).catch(function (err) {
	        if (callback) return callback(err);
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function addCompanyContacts(body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.post({ route: '/api/companies/' + body.profile.companyId + '/contacts', body: body }).then(function (resp) {
	        if (callback) {
	          return callback(null, resp.body.data.items[0]);
	        }
	        return resp.body.data.items[0];
	      }).catch(function (err) {
	
	        if (callback) return callback(err.body);
	        return Promise.reject(err.body);
	      });
	    };
	  };
	}
	
	function updateCompanyContact(body, callback) {
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({ route: '/api/companies/' + body.profile.companyId + '/contacts/' + body.profile.id, body: body }).then(function (resp) {
	        if (callback) return callback(null, resp.body.data.items[0].profileId);
	
	        return resp.body.data.items[0].profileId;
	      }).catch(function (err) {
	        if (callback) return callback(err);
	        return Promise.reject(err.body.errors);
	      });
	    };
	  };
	}
	
	function updateContactsByCompanyId() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      id = _ref2.id,
	      fields = _ref2.fields;
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({ route: '/api/companies/' + id + '/contacts', body: fields }).then(function (data) {
	        return data;
	      }).catch(function (err) {
	        console.error('[contacts actionCreator] error with updateContactsByCompanyId route', err);
	      });
	    };
	  };
	}
	
	function deleteCompanyContact(companyId, contactId, callback) {
	
	  return function (simpleIsoFetch) {
	    return function () {
	
	      return simpleIsoFetch.del('/api/companies/' + companyId + '/contacts/' + contactId).then(function (resp) {
	        return (0, _lodash.get)(resp, 'body.data');
	      }).then(function (data) {
	        return data ? callback(null, data) : Promise.reject(new Error('Invalid response'));
	      }).catch(function (err) {
	        return callback((0, _lodash.get)(err, 'body.errors', [err]));
	      });
	    };
	  };
	}
	
	function updateCompany(newCompany, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var _newCompany$id = newCompany.id,
	          id = _newCompany$id === undefined ? 0 : _newCompany$id;
	
	      var groups = getState().staticData.companyStatus;
	      var store = getState().admin.companies;
	      var current = (0, _companies.findCompany)({ id: id }, store);
	      return simpleIsoFetch.put('/api/companies/' + id, {
	        body: newCompany
	      }).then(function () {
	        return (0, _lodash.merge)({}, current, newCompany);
	      }).then(function (company) {
	        return (0, _companies.findGrouping)({ company: company, groups: groups });
	      }).then(function (data) {
	        if (callback) return callback(null, data);
	
	        return data;
	      }).catch(function (err) {
	        if (callback) return callback(err);
	
	        return Promise.reject(err.body.errors);
	      });
	    };
	  };
	}
	
	function updateCompanyById(comp, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      simpleIsoFetch.put('/api/companies/' + comp.id, {
	        body: comp
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function updateCompanyStatus(id, companyStatus, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var groups = getState().staticData.companyStatus;
	      var store = getState().admin.companies;
	      var current = (0, _companies.findCompany)({ profile: { id: id } }, store);
	      return simpleIsoFetch.put('/api/companies/' + id + '/status/' + companyStatus).then(function () {
	        return (0, _lodash.merge)({}, current, { companyStatus: companyStatus });
	      }).then(function (company) {
	        return (0, _companies.findGrouping)({ company: company, groups: groups });
	      }).then(function (data) {
	        return callback ? callback(null, data) : data;
	      }).catch(function (err) {
	        return callback ? callback(err) : Promise.reject(err);
	      });
	    };
	  };
	}
	
	// Tech
	
	function getCompanyTech(id, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get('/api/companies/' + id + '/tech').then(function (resp) {
	        return callback(null, resp.body.data);
	      }).catch(callback);
	    };
	  };
	}
	
	function createCompanyTech(tech, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      simpleIsoFetch.post('/api/companies/' + tech.companyId + '/tech', {
	        body: tech
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function updateCompanyTech(tech, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      simpleIsoFetch.put('/api/companies/' + tech.companyId + '/tech', {
	        body: tech
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function deleteCompany(companyId, callback) {
	  return function (simpleIsoFetch) {
	    return function () {
	      simpleIsoFetch.del('/api/companies/' + companyId).then(function (data) {
	        return callback && callback(null, data) || data;
	      }).catch(function (err) {
	        return callback && callback(err) || Promise.reject(err);
	      });
	    };
	  };
	}

/***/ }),
/* 50 */
[3158, 101],
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(135);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(403);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(189);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(2841);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(767);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(2835);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(2854);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(2836);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(2837);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(768);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(2839);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(2834);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(2838);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(2840);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(2853);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(281);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(2842);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(2851);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(773);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(2844);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(2845);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(2849);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(770);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _c_SourceModMaskedInput = __webpack_require__(867);
	
	var _c_SourceModMaskedInput2 = _interopRequireDefault(_c_SourceModMaskedInput);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nonAlphaNumericRegex = /[^A-Za-z0-9]/g;
	
	var whiteSpaceRegex = /\s/g;
	
	var MaskedTextField = (_temp2 = _class = function (_Component) {
	  _inherits(MaskedTextField, _Component);
	
	  function MaskedTextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MaskedTextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MaskedTextField.__proto__ || Object.getPrototypeOf(MaskedTextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: _this.props.value || _this.props.defaultValue || ''
	    }, _this.onChange = function (event) {
	      var newVal = event.target.value.replace(nonAlphaNumericRegex, '').replace(whiteSpaceRegex, '');
	
	      // need this to tell masked input that it's populated
	      _this.setState({
	        value: newVal
	      });
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event, newVal);
	      }
	    }, _this.onFocus = function (event) {
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event, event.target.value.replace(nonAlphaNumericRegex, ''));
	      }
	    }, _this.onBlur = function (event) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event, event.target.value.replace(nonAlphaNumericRegex, ''));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MaskedTextField, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (this.props.value !== newProps.value) {
	        this.setState({
	          value: newProps.value
	        });
	      }
	    }
	  }, {
	    key: 'checkErrors',
	    value: function checkErrors() {
	      if (this.refs['maskedText'].checkErrors) {
	        this.refs['maskedText'].checkErrors();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          mask = _props.mask,
	          value = _props.value,
	          defaultValue = _props.defaultValue,
	          dataId = _props['data-id'],
	          onChange = _props.onChange,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          hideMaskChar = _props.hideMaskChar,
	          other = _objectWithoutProperties(_props, ['mask', 'value', 'defaultValue', 'data-id', 'onChange', 'onBlur', 'onFocus', 'hideMaskChar']);
	
	      return _react2.default.createElement(
	        _c_TextField2.default,
	        _extends({}, other, {
	          proxyVal: this.state.value,
	          onChange: this.onChange,
	          onBlur: this.onBlur,
	          onFocus: this.onFocus,
	          ref: 'maskedText' }),
	        _react2.default.createElement(_c_SourceModMaskedInput2.default, { className: 'masked-input ' + (this.state.value ? 'populated' : ''),
	          'data-id': dataId,
	          value: this.state.value,
	          mask: mask,
	          maskChar: hideMaskChar ? null : ' ' })
	      );
	    }
	  }]);
	
	  return MaskedTextField;
	}(_react.Component), _class.propTypes = {
	  mask: _react.PropTypes.string,
	  hideMaskChar: _react.PropTypes.bool,
	  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react2.default.PropTypes.number]),
	  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react2.default.PropTypes.number]),
	  onErrorChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  validation: _react.PropTypes.object,
	  'data-id': _react.PropTypes.string
	}, _temp2);
	exports.default = MaskedTextField;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	// function to validate individual values
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToggleButton = (_temp2 = _class = function (_Component) {
	  _inherits(ToggleButton, _Component);
	
	  function ToggleButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ToggleButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToggleButton.__proto__ || Object.getPrototypeOf(ToggleButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: null,
	      errors: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ToggleButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // determine if initial value has been fed in
	      var initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : null;
	
	      // used to keep track of mounting state updates
	      var stateUpdateObj = {};
	
	      if (!_lodash2.default.isNil(initVal)) {
	        stateUpdateObj.value = initVal;
	        var currentMenuItem = this.props.menuItems.find(function (menuItem) {
	          return menuItem.value === initVal || menuItem.id === initVal || menuItem === initVal;
	        });
	        if (!currentMenuItem) {
	          console.error('value: ' + initVal + ' does not have corresponding menu item'); /* eslint no-console:0 */
	        } else if (currentMenuItem.subElement) {
	          stateUpdateObj.subElement = currentMenuItem.subElement;
	        }
	      }
	
	      // handles validation state update
	      this.validate(initVal, stateUpdateObj);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // sync local state value
	      if (this.props.value !== nextProps.value) {
	        this.setState({ value: nextProps.value });
	        this.validate(nextProps.value, {
	          value: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(newValue, event) {
	      if (_lodash2.default.isNil(this.props.value)) {
	        this.validate(newValue, { value: newValue });
	      }
	      if (this.props.onChange) {
	        this.props.onChange(event, newValue);
	      }
	      if (this.props.onBlur) {
	        this.props.onBlur(event, newValue);
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(value, additionalStateUpdate) {
	      if (this.props.validation) {
	        var errorsObj = {
	          errors: (0, _modelValidator.validateField)(value, this.props.validation)
	        };
	        if (errorsObj.errors.length !== this.state.errors.length) {
	          if (this.props.onErrorChange) {
	            this.props.onErrorChange(errorsObj.errors.length > this.state.errors ? 1 : -1);
	          }
	          this.setState(_lodash2.default.assign(this.state, errorsObj, additionalStateUpdate || {}));
	        } else if (_lodash2.default.size(additionalStateUpdate)) {
	          this.setState(_lodash2.default.assign(this.state, additionalStateUpdate));
	        }
	      } else if (_lodash2.default.size(additionalStateUpdate)) {
	        this.setState(_lodash2.default.assign(this.state, additionalStateUpdate));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var currentMenuItem = void 0;
	
	      var menuItems = this.props.menuItems.map(function (val, index) {
	        // allow for 'value' and 'id'
	        var currValue = val.hasOwnProperty('value') ? val.value : val.id;
	        var isCurrentMenuItem = _this2.state.value === currValue;
	
	        // set current menu item outside of this scope for subElement mapping
	        if (isCurrentMenuItem) {
	          currentMenuItem = val;
	        }
	
	        return _react2.default.createElement(
	          'li',
	          { key: index,
	            style: { width: 100 / _this2.props.menuItems.length + '%' },
	            className: (0, _classnames2.default)('toggle noTextSelect', { active: isCurrentMenuItem }),
	            'data-id': val.primaryText || val.name,
	            onClick: _this2.onChange.bind(_this2, currValue) },
	          val.primaryText || val.name
	        );
	      });
	
	      var errorTextElement = this.props.errorText && _react2.default.createElement(
	        'div',
	        { className: 'error-message' },
	        this.props.errorText
	      );
	
	      // current subElement
	      var subElement = currentMenuItem && this.props.children && this.props.children[currentMenuItem.subElement] || null;
	
	      var disabledStyle = {
	        'pointerEvents': 'none',
	        'filter': 'grayscale(100%)',
	        'opacity': 0.8
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: this.props.disabled ? disabledStyle : null, className: 'toggle-wrapper ' + (this.props.className || ''), 'data-id': this.props['data-id'], tabIndex: this.props.disabled ? -1 : 0 },
	        _react2.default.createElement(
	          'div',
	          { className: 'floatingLabelText', 'data-id': this.props.floatingLabelText },
	          this.props.floatingLabelText
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: (0, _classnames2.default)('toggle-container', { selected: !_lodash2.default.isNil(this.state.value) }) },
	          menuItems
	        ),
	        errorTextElement,
	        subElement && _react2.default.createElement(
	          'div',
	          { className: 'subElement-container' },
	          _react.Children.map(subElement, // adding isSubElement prop to child
	          function (child) {
	            return (0, _react.cloneElement)(child, _lodash2.default.merge({ isSubElement: true }));
	          })
	        )
	      );
	    }
	  }]);
	
	  return ToggleButton;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  defaultValue: _react.PropTypes.any,
	  children: _react.PropTypes.object,
	  value: _react.PropTypes.any,
	  id: _react.PropTypes.any,
	  'data-id': _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  menuItems: _react.PropTypes.array.isRequired,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  floatingLabelText: _react.PropTypes.string,
	  validation: _react.PropTypes.object,
	  onErrorChange: _react.PropTypes.func
	}, _temp2);
	exports.default = ToggleButton;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(4);
	var validator = __webpack_require__(33);
	
	var BaseModel = function () {
	  function BaseModel(schema) {
	    _classCallCheck(this, BaseModel);
	
	    this._schema = schema;
	    this._errors = null;
	  }
	
	  _createClass(BaseModel, [{
	    key: 'validate',
	
	
	    /**
	     * Validates all the properties of the model against its schema and populates the errors array.
	     * @return {[null]} [No return value]
	     */
	    value: function validate(schema) {
	      this._errors = validator.validate(this, schema || this.schema);
	    }
	
	    /**
	     * Validates a single property against the internal schema or one provided.
	     * @param  {[string]} prop             [Property name]
	     * @param  {[object]} validationSchema [Validation schema]
	     * @return {[Array]}                  [Array of validation errors]
	     */
	
	  }, {
	    key: 'validateField',
	    value: function validateField(prop, validationSchema) {
	      var schema = validationSchema || _.pick(this.schema, [prop]);
	      return validator.validate(this, schema);
	    }
	
	    /**
	     * Returns the list of validation errors encountered last time validate() was run.
	     * @return {[Array]} [Array of validation errors]
	     */
	
	  }, {
	    key: 'validationErrors',
	    value: function validationErrors() {
	      return this._errors.length === 0 ? null : this._errors;
	    }
	
	    /**
	     * Returns the model without the _schema and _errors
	     */
	
	  }, {
	    key: 'schema',
	    get: function get() {
	      return _.cloneDeep(this._schema);
	    }
	  }, {
	    key: 'strippedModel',
	    get: function get() {
	      var model = _.cloneDeep(this);
	      delete model._schema;
	      delete model._errors;
	      return model;
	    }
	  }]);
	
	  return BaseModel;
	}();
	
	module.exports = BaseModel;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global Symbol */
	
	
	exports.getJobRequest = getJobRequest;
	exports.getJobRequestById = getJobRequestById;
	exports.deleteJobRequest = deleteJobRequest;
	exports.getPublicJobRequest = getPublicJobRequest;
	exports.createJobRequest = createJobRequest;
	exports.updateJobRequest = updateJobRequest;
	exports.authorizeJobRequest = authorizeJobRequest;
	exports.getClientJobRequestsList = getClientJobRequestsList;
	exports.getCompanyJobRequestsList = getCompanyJobRequestsList;
	exports.updateContactJobRequests = updateContactJobRequests;
	exports.deleteContactJobRequests = deleteContactJobRequests;
	exports.getAllJobs = getAllJobs;
	exports.getJobRequestPDF = getJobRequestPDF;
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _bluebird = __webpack_require__(171);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getJobRequest(id, jobId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/contacts/' + id + '/jobs/' + jobId
	      }).then(function (resp) {
	        if (callback && callback.success) {
	          return callback.success(resp.body.data.items);
	        }
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) {
	          return callback.error(err);
	        }
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}
	
	function getJobRequestById(jobId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/jobs/' + jobId
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}
	
	function deleteJobRequest(jobId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.del({
	        route: '/api/jobs/' + jobId
	      }).then(function (resp) {
	        if (callback && callback.success) {
	          return callback.success(resp.body.status);
	        }
	        return resp.body.status;
	      }, function (err) {
	        if (callback && callback.error) {
	          return callback.error(err);
	        }
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}
	
	function getPublicJobRequest(jobId, hash, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/jobs/temp/' + hash + '/' + jobId
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}
	
	function createJobRequest(id, body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.post({
	        route: '/api/contacts/' + id + '/jobs',
	        body: body
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	          return err;
	        }
	      });
	    };
	  };
	}
	
	function updateJobRequest(id, body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({
	        route: '/api/contacts/' + id + '/jobs/' + body.id,
	        body: body
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	          return err;
	        }
	      });
	    };
	  };
	}
	
	function authorizeJobRequest(id, jobId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.put({
	        route: '/api/contacts/' + id + '/jobs/' + jobId + '/authorize'
	      }).then(function (resp) {
	        callback.success(resp.body.data.items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	function getClientJobRequestsList(id, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.get({
	        route: '/api/contacts/' + id + '/jobs'
	      }).then(function (resp) {
	        callback.success(resp.body.data.items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function getCompanyJobRequestsList(id, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/companies/' + id + '/jobs'
	      }).then(function (resp) {
	
	        if (callback && callback.success) {
	          return callback.success(resp.body.data.items);
	        }
	
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) {
	          callback.error(err);
	        }
	      }).catch(function (err) {
	
	        if (callback && callback.error) {
	          return callback.error(err);
	        }
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	
	        return err;
	      });
	    };
	  };
	}
	
	function updateContactJobRequests(contactId, body) {
	  var allowedStatuses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var callback = arguments[3];
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({
	        route: '/api/contacts/' + contactId + '/jobs',
	        body: body,
	        query: {
	          allowedStatuses: allowedStatuses
	        }
	      }).then(function (results) {
	        callback.success(results);
	      }).catch(function (err) {
	        callback.error(err);
	      });
	    };
	  };
	}
	
	function deleteContactJobRequests(contactId, body) {
	  var allowedStatuses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var callback = arguments[3];
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.del('/api/contacts/' + contactId + '/jobs', {
	        body: body,
	        query: {
	          allowedStatuses: allowedStatuses
	        }
	      }).then(function (results) {
	        callback.success(results);
	      }).catch(function (err) {
	        callback.error(err);
	      });
	    };
	  };
	}
	
	function getAllJobs(callback) {
	  var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var terms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var filters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var companyId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.get({
	        route: '/api/' + (companyId ? 'companies/' + companyId + '/' : '') + 'jobs',
	        query: _extends({
	          terms: terms
	        }, filters, {
	          skip: skip
	        })
	      }).then(function (resp) {
	        callback.success(resp.body.data.items);
	      }, function (err) {
	        callback.error(err);
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function getJobRequestPDF(jobId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/jobs/' + jobId + '/pdf'
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body);
	        return resp.body;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(2859);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.0' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(1728);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createUser = createUser;
	exports.updateUser = updateUser;
	exports.getUsers = getUsers;
	exports.getUsersByRole = getUsersByRole;
	exports.getUsersById = getUsersById;
	exports.addRole = addRole;
	exports.removeRole = removeRole;
	exports.getPins = getPins;
	exports.updatePins = updatePins;
	
	var _lodash = __webpack_require__(4);
	
	function createUser(profile, cb) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.post({
	        route: '/api/admin/employees',
	        body: profile
	      }).then(function (_ref) {
	        var employees = _ref.body.data.items;
	        return employees;
	      }).then(function (resp) {
	
	        if (cb) {
	          return cb(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (cb) {
	          return cb(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function updateUser(id, profile, cb) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({
	        route: '/api/admin/employees/' + id,
	        body: profile
	      }).then(function (_ref2) {
	        var employees = _ref2.body.data.items;
	        return employees;
	      }).then(function (resp) {
	
	        if (cb) {
	          return cb(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (cb) {
	          return cb(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function getUsers(query, cb) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/admin/employees',
	        query: query
	      }).then(function (_ref3) {
	        var employees = _ref3.body.data.items;
	        return employees;
	      }).then(function (resp) {
	
	        if (cb) {
	          return cb(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (cb) {
	          return cb(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function getUsersByRole(roleName, cb) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/admin/employees',
	        query: {
	          roleName: roleName
	        }
	      }).then(function (_ref4) {
	        var employees = _ref4.body.data.items;
	        return employees;
	      }).then(function (resp) {
	        resp = (0, _lodash.map)(resp, function (e) {
	          return (0, _lodash.extend)({ name: e.firstName + ' ' + e.lastName }, e);
	        });
	        if (cb) {
	          return cb(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (cb) {
	          return cb(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function getUsersById(id, cb) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/admin/employees',
	        query: {
	          id: id
	        }
	      }).then(function (_ref5) {
	        var employee = _ref5.body.data.items;
	        return (0, _lodash.isArray)(employee) ? employee[0] : undefined;
	      }).then(function (resp) {
	        if (cb) {
	          return cb(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (cb) {
	          return cb(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function addRole(body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.post({
	        route: '/api/admin/employees/' + body.userId + '/role',
	        body: body
	      }).then(function (resp) {
	        if (callback) return callback(null, resp.body.data.items);
	
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback) return callback(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	          return err;
	        }
	      });
	    };
	  };
	}
	
	function removeRole(body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.del({
	        route: '/api/admin/employees/' + body.userId + '/role',
	        body: body
	      }).then(function (resp) {
	        if (callback) return callback(null, resp.body.data.items);
	
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback) return callback(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	          return err;
	        }
	      });
	    };
	  };
	}
	
	function getPins(callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/admin/pins'
	      }).then(function (_ref6) {
	        var respData = _ref6.body.data.items;
	        return (0, _lodash.isArray)(respData) ? respData[0] : undefined;
	      }).then(function (resp) {
	        if (callback) {
	          return callback(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (callback) {
	          return callback(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function updatePins(body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({
	        route: '/api/admin/pins',
	        body: body
	      }).then(function (_ref7) {
	        var respData = _ref7.body.data.items;
	        return (0, _lodash.isArray)(respData) ? respData[0] : undefined;
	      }).then(function (resp) {
	        if (callback) {
	          return callback(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (callback) {
	          return callback(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateCompany = updateCompany;
	exports.updateCompanyContacts = updateCompanyContacts;
	exports.updateCompanyJobs = updateCompanyJobs;
	exports.filterCompanyJobs = filterCompanyJobs;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function updateCompany(_ref) {
	  var company = _ref.company,
	      group = _ref.group;
	
	  return {
	    type: actionTypes.UPDATE_COMPANY,
	    company: company,
	    newGroup: group
	  };
	} // action type strings
	function updateCompanyContacts(companyContacts) {
	  return {
	    type: actionTypes.UPDATE_COMPANY_CONTACTS,
	    companyContacts: companyContacts
	  };
	}
	
	function updateCompanyJobs(_ref2) {
	  var companyJobs = _ref2.companyJobs;
	
	  return {
	    type: actionTypes.UPDATE_COMPANY_JOBS,
	    companyJobs: companyJobs
	  };
	}
	
	function filterCompanyJobs(filters) {
	  return {
	    type: actionTypes.FILTER_COMPANY_JOBS,
	    filters: filters
	  };
	}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(3029);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// import classnames utility
	
	
	// import js utility
	
	
	// import material UI elements
	
	
	// import material UI elements with slightly modified source code
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _modelValidator = __webpack_require__(33);
	
	var _Divider = __webpack_require__(271);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _c_SourceModMenuItem = __webpack_require__(166);
	
	var _c_SourceModMenuItem2 = _interopRequireDefault(_c_SourceModMenuItem);
	
	var _c_SourceModDropDown = __webpack_require__(202);
	
	var _c_SourceModDropDown2 = _interopRequireDefault(_c_SourceModDropDown);
	
	var _index = __webpack_require__(69);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var menuCustomization = {
	  autoWidth: false,
	  labelStyle: {
	    color: '#4a4a4a',
	    maxWidth: '100%',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    fontSize: '16px',
	    height: '48px'
	  },
	  listStyle: {
	    backgroundColor: '#fafafa',
	    fontWeight: 100,
	    maxWidth: '384px' // remove from here later
	  },
	  selectedMenuItemStyle: {
	    color: '#4a4a4a'
	  },
	  menuStyle: {
	    backgroundColor: '#fafafa',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    maxWidth: '384px' // remove from here later
	  },
	  popoverStyle: {
	    transition: 'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1), width 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
	    maxWidth: '384px' // remove from here later
	  }
	};
	
	var menuItemCustomization = {
	  disableTouchRipple: true,
	  disableFocusRipple: true,
	  style: {
	    transition: 'width 1000ms cubic-bezier(0.23, 1, 0.32, 1)'
	  }
	};
	
	var CheckList = (_temp = _class = function (_Component) {
	  _inherits(CheckList, _Component);
	
	  function CheckList(props, context) {
	    _classCallCheck(this, CheckList);
	
	    // do this here because createHash needs to be available
	    var _this = _possibleConstructorReturn(this, (CheckList.__proto__ || Object.getPrototypeOf(CheckList)).call(this, props, context));
	
	    _this.validate = function (value, mergeObj) {
	      if (_this.props.validation) {
	        var errorsObj = {
	          errors: (0, _modelValidator.validateField)(value, _this.props.validation)
	        };
	        if (errorsObj.errors.length !== _this.state.errors.length) {
	          if (_this.props.onErrorChange) {
	            _this.props.onErrorChange(errorsObj.errors.length > _this.state.errors ? 1 : -1);
	          }
	          _this.setState(_lodash2.default.assign(_this.state, errorsObj, mergeObj || {}));
	        } else if (_lodash2.default.size(mergeObj)) {
	          _this.setState(_lodash2.default.assign(_this.state, mergeObj));
	        }
	      } else if (_lodash2.default.size(mergeObj)) {
	        _this.setState(_lodash2.default.assign(_this.state, mergeObj));
	      }
	    };
	
	    _this.createHash = function () {
	      var hash = {};
	
	      _this.props.menuItems.forEach(function (menuItem) {
	        hash[menuItem.value || menuItem.id] = menuItem.primaryText || menuItem.name;
	      });
	
	      return hash;
	    };
	
	    _this.state = {
	      checked: [],
	      dirty: false,
	      hash: _this.createHash(),
	      errors: []
	    };
	    return _this;
	  }
	
	  _createClass(CheckList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : [];
	      this.validate(initVal, initVal ? { checked: initVal } : {});
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	
	      if (this.props.menuItems !== nextProps.menuItems) {
	
	        var hash = this.createHash();
	
	        // If a checked item is not part of list. We remove it.
	        var checked = _lodash2.default.intersection(Object.keys(hash).map(Number), this.state.checked);
	
	        this.setState(_lodash2.default.assign(this.state, { hash: hash, checked: checked }));
	      }
	
	      if (this.props.value !== nextProps.value) {
	        this.validate(nextProps.value, { checked: nextProps.value || [] });
	      } else if (this.props.defaultValue !== nextProps.defaultValue) {
	        this.validate(nextProps.defaultValue, { checked: nextProps.defaultValue || [] });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'checkErrors',
	    value: function checkErrors() {
	      if (!this.state.dirty) this.state.dirty = true; // set dirty if not already dirty
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event, index, value) {
	
	      if (!value) {
	        return;
	      }
	
	      // off because of offsetting elements for checklist
	      index = index - 4;
	
	      var primaryText = this.props.menuItems[index].primaryText || value;
	
	      var newCheckedArr = ~this.state.checked.indexOf(value) ? this.state.checked.filter(function (val) {
	        return val !== value;
	      }) : this.state.checked.concat(value);
	
	      // handle validation update + this state change
	      if (!this.props.hasOwnProperty('value')) {
	        this.validate(newCheckedArr, {
	          checked: newCheckedArr
	        });
	      } else {
	        this.setState(_lodash2.default.assign(this.state, {
	          checked: newCheckedArr
	        }));
	      }
	
	      var returnValue = newCheckedArr && newCheckedArr.length ? newCheckedArr : null;
	      if (this.props.onChange) {
	        this.props.onChange(event, returnValue, primaryText, value);
	      }
	
	      if (this.props.onBlur) {
	        this.props.onBlur(event, returnValue, primaryText, value);
	      }
	    }
	  }, {
	    key: 'closeTag',
	    value: function closeTag(value) {
	      // deal with all menuItem input types
	      var index = this.props.menuItems.findIndex(function (menuItem, i) {
	        return (_lodash2.default.isNil(menuItem) ? menuItem : (typeof menuItem === 'undefined' ? 'undefined' : _typeof(menuItem)) !== 'object' ? menuItem : menuItem.hasOwnProperty('id') ? menuItem.id : menuItem.value) === value;
	      });
	
	      // trigger onChange to update view+state
	      this.onChange(null, index + 4, value); // #theWorst, dealing with material-ui inconsistencies, +4 takes into account divider and stuff
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // take out properties that will be overwritten from 'this.props'
	      var _props = this.props,
	          className = _props.className,
	          onChange = _props.onChange,
	          onBlur = _props.onBlur,
	          scrollBarWidth = _props.scrollBarWidth,
	          propsMenuItemCustomization = _props.menuItemCustomization,
	          dataId = _props['data-id'],
	          containerStyle = _props.containerStyle,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          canAutoPosition = _props.canAutoPosition,
	          showCount = _props.showCount,
	          showLabel = _props.showLabel,
	          unmodifiedProps = _objectWithoutProperties(_props, ['className', 'onChange', 'onBlur', 'scrollBarWidth', 'menuItemCustomization', 'data-id', 'containerStyle', 'floatingLabelText', 'floatingLabelStyle', 'canAutoPosition', 'showCount', 'showLabel']);
	
	      var additionalProps = {
	        onChange: this.onChange.bind(this)
	      };
	
	      // to be displayed in label
	      var labelText = '';
	
	      // if dropdown value is null (displaying 'Select') make text gray
	      if (!this.state.checked || !this.state.checked.length || this.state.checked === 'null') {
	        labelText = showLabel ? floatingLabelText : 'Select';
	
	        additionalProps.labelStyle = _lodash2.default.merge({}, menuCustomization.labelStyle, {
	          color: '#212326',
	          fontWeight: 'normal'
	        });
	        additionalProps.menuStyle = _lodash2.default.merge({}, menuCustomization.menuStyle, {
	          paddingRight: scrollBarWidth && scrollBarWidth + 'px' || '15px'
	        });
	      } else {
	        if (this.props.showCount) {
	          labelText = this.state.checked.length + ' Selected';
	        } else if (this.props.showLabel) {
	          labelText = floatingLabelText;
	        } else {
	          labelText = '' + this.state.checked.map(function (c) {
	            return _this2.state.hash[c];
	          }).join(', ');
	        }
	      }
	
	      if (this.props.persistentLabel) {
	        labelText = this.props.persistentLabel;
	      }
	
	      var isError = this.state.dirty && (typeof this.props.errorText !== 'undefined' || this.state.errors.length); // check passed in error string and local state errors array, only show if value is dirty
	
	      if (isError) {
	        additionalProps.labelStyle = _lodash2.default.merge({}, menuCustomization.labelStyle, {
	          color: 'rgb(244, 67, 54)'
	        });
	      }
	
	      var checkedList = !_lodash2.default.isNil(this.state.checked) && !_lodash2.default.isEmpty(this.state.checked) && this.state.checked !== 'null' ? this.state.checked : [];
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('clearfix', 'dropdown-wrapper checklist-wrapper', className, { disabled: this.props.disabled, optional: this.props.optional, error: isError }), style: containerStyle },
	        floatingLabelText && !showLabel && _react2.default.createElement(
	          'div',
	          { className: 'floatingLabelText', 'data-id': dataId + ' floatingLabelText', style: floatingLabelStyle || {} },
	          floatingLabelText
	        ),
	        _react2.default.createElement(
	          _c_SourceModDropDown2.default,
	          _extends({ className: (0, _classnames2.default)('dropdown', { disabled: this.props.disabled }),
	            canAutoPosition: true,
	            checkList: true,
	            value: null,
	            'data-id': dataId
	          }, menuCustomization, unmodifiedProps, additionalProps),
	          _react2.default.createElement(_c_SourceModMenuItem2.default, _extends({ value: null,
	            primaryText: labelText,
	            className: 'checklist-header'
	          }, menuItemCustomization, propsMenuItemCustomization, {
	            style: { backgroundColor: 'transparent', cursor: 'default' } })),
	          _react2.default.createElement(_Divider2.default, { className: 'divider' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'checked-tags-container' },
	            checkedList.map(function (val, index) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'checked-tag-container', key: index },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'checked-tag' },
	                  _this2.state.hash[val],
	                  _react2.default.createElement(_index2.default, {
	                    className: 'checked-tag-item',
	                    'data-id': val + ' Tag',
	                    onClick: _this2.closeTag.bind(_this2, val),
	                    style: {
	                      strokeWidth: 1,
	                      color: '#4a4a4a',
	                      marginLeft: '5px',
	                      width: '10px',
	                      height: '10px'
	                    }
	                  })
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(_Divider2.default, { className: 'divider' }),
	          this.props.menuItems.filter(function (item) {
	            return item.hasOwnProperty('hide') ? !item.hide : true;
	          }).map(function (val, index) {
	            if (typeof val === 'undefined') {
	              return undefined;
	            }
	
	            var value = '';
	            var primaryText = '';
	            if (val === null) {
	              value = null;
	              primaryText = 'Select';
	            } else if (typeof val === 'string' || typeof val === 'number') {
	              value = primaryText = val;
	            } else {
	              value = val.value || val.id;
	              primaryText = val.primaryText || val.name;
	            }
	
	            return _react2.default.createElement(_c_SourceModMenuItem2.default, _extends({ checkBox: true,
	              checked: !!~_this2.state.checked.indexOf(value),
	              value: value,
	              primaryText: primaryText,
	              key: index,
	              'data-id': primaryText
	            }, menuItemCustomization, propsMenuItemCustomization));
	          })
	        )
	      );
	    }
	  }]);
	
	  return CheckList;
	}(_react.Component), _class.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  value: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  validation: _react.PropTypes.object,
	  onErrorChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  menuItems: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string,
	  scrollBarWidth: _react.PropTypes.number,
	  menuItemCustomization: _react.PropTypes.object,
	  containerStyle: _react.PropTypes.object,
	  floatingLabelText: _react.PropTypes.string,
	  floatingLabelStyle: _react.PropTypes.object,
	  canAutoPosition: _react.PropTypes.bool,
	  'data-id': _react.PropTypes.string,
	  showCount: _react.PropTypes.bool,
	  showLabel: _react.PropTypes.bool,
	  persistentLabel: _react.PropTypes.string,
	  optional: _react.PropTypes.bool,
	  errorText: _react.PropTypes.string
	}, _class.defaultProps = {
	  menuItems: []
	}, _temp);
	exports.default = CheckList;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = CloseX;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	CloseX.propTypes = {
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object
	};
	
	CloseX.defaultProps = {
	  style: {}
	};
	
	function CloseX(props) {
	  var className = props.className,
	      _props$style = props.style,
	      color = _props$style.color,
	      fill = _props$style.fill,
	      strokeWidth = _props$style.strokeWidth,
	      otherStyle = _objectWithoutProperties(_props$style, ['color', 'fill', 'strokeWidth']),
	      otherProps = _objectWithoutProperties(props, ['className', 'style']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({ className: 'close-x ' + className, style: otherStyle, width: '8px', height: '8px', viewBox: '0 0 10 10', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' }, otherProps),
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(-1170.000000, -1184.000000)', stroke: fill || color || '#777777', strokeWidth: strokeWidth && '' + strokeWidth || '3' },
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(1171.000000, 1185.000000)' },
	        _react2.default.createElement('path', { d: 'M8,8 L0,0' }),
	        _react2.default.createElement('path', { d: 'M8,0 L0,8' })
	      )
	    )
	  );
	}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RouteTransitionBlocker;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _viewOrderArr = __webpack_require__(212);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// components
	var secondaryButtonStyle = {
	  width: '296px',
	  height: '41px',
	  marginLeft: '25px'
	};
	
	var secondaryButtonLabelStyle = {
	  fontSize: '12px',
	  transform: 'translateY(-.5px)',
	  top: 0
	};
	
	function RouteTransitionBlocker(props) {
	  var text = props.transitionText ? props.transitionText : ['You have not completed the required fields needed to save. <br/>\n    If you exit the page now you will lose the information that hasn\u2019t been saved.'];
	
	  var className = props.className || '';
	
	  return _react2.default.createElement(
	    _r_Modal2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'route-transition-blocker-transition-block-form' + (className && '-' + className) },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { className: 'prompt-text', dangerouslySetInnerHTML: { __html: text } }),
	        props.control && _react2.default.createElement(
	          'div',
	          { className: 'transition-control' },
	          props.control
	        ),
	        _react2.default.createElement(_c_RaisedButton2.default, {
	          label: props.primaryButtonLabel || 'Stay',
	          onClick: props.primaryAction
	        }),
	        _react2.default.createElement(_c_FlatButton2.default, {
	          style: secondaryButtonStyle,
	          labelStyle: secondaryButtonLabelStyle,
	          label: props.secondaryButtonLabel || 'Leave',
	          onClick: props.secondaryAction
	        })
	      ),
	      _react2.default.createElement(_ModalX2.default, { onClick: props.cancelAction })
	    ),
	    _react2.default.createElement('div', { className: 'rectangle-behind-modal-form absolute-center' })
	  );
	}
	
	RouteTransitionBlocker.propTypes = {
	  primaryAction: _react.PropTypes.func,
	  secondaryAction: _react.PropTypes.func,
	  cancelAction: _react.PropTypes.func,
	  transitionText: _react.PropTypes.text,
	  primaryButtonLabel: _react.PropTypes.string,
	  secondaryButtonLabel: _react.PropTypes.string,
	  control: _react.PropTypes.element,
	  className: _react.PropTypes.string
	};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createJobRequest = createJobRequest;
	exports.updateJobRequest = updateJobRequest;
	exports.resetJobRequest = resetJobRequest;
	exports.updateJobRequests = updateJobRequests;
	exports.updateCompanyJobRequests = updateCompanyJobRequests;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function createJobRequest(jobRequest) {
	  return {
	    type: actionTypes.CREATE_JOB_REQUEST,
	    jobRequest: jobRequest
	  };
	} // action type strings
	function updateJobRequest(jobRequest) {
	  return {
	    type: actionTypes.UPDATE_JOB_REQUEST,
	    jobRequest: jobRequest
	  };
	}
	
	function resetJobRequest() {
	  return {
	    type: actionTypes.RESET_JOB_REQUEST
	  };
	}
	
	function updateJobRequests(jobRequests) {
	  return {
	    type: actionTypes.UPDATE_JOB_REQUESTS,
	    jobRequests: jobRequests
	  };
	}
	
	function updateCompanyJobRequests(companyJobRequests) {
	  return {
	    type: actionTypes.UPDATE_COMPANY_JOB_REQUESTS,
	    companyJobRequests: companyJobRequests
	  };
	}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;
	
	var _Table2 = __webpack_require__(1756);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(602);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(603);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(604);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(387);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(605);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(275);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.default = _Table3.default;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _ValidatedForm2 = __webpack_require__(200);
	
	var _ValidatedForm3 = _interopRequireDefault(_ValidatedForm2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(399);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 1900 for calendar min date
	var year1900 = new Date(-5700000000000);
	
	// values for a boolean dropdown or toggle button
	var booleanDropDown = [{
	  value: true,
	  primaryText: 'Yes' }, {
	  value: false,
	  primaryText: 'No'
	}];
	
	var ProgressComponent = (_temp2 = _class = function (_ValidatedForm) {
	  _inherits(ProgressComponent, _ValidatedForm);
	
	  function ProgressComponent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProgressComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProgressComponent.__proto__ || Object.getPrototypeOf(ProgressComponent)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_reactAddonsPureRenderMixin2.default), _this.year1900 = year1900, _this.today = new Date(), _this.booleanDropDown = booleanDropDown, _this.updateProgress = function (nextProps) {
	      var props = nextProps || _this.props;
	      var objPath = 'viewState.progress.applicant.application.' + _this.props.viewModel + '.done';
	
	      // validation vs state and tempState
	      var isValid = !props.errorCount;
	      var viewStateDone = (0, _lodash.get)(props.viewState, 'done', false);
	      var tempStateDone = (0, _lodash.get)(props.tempState, 'profile.' + objPath);
	
	      if (viewStateDone !== isValid) {
	        if (tempStateDone !== isValid) {
	          // if property is not on tempstate and is different from state add it to tempstate
	          props.updateTempState('profile', objPath, null, isValid);
	        }
	      } else if (!(0, _lodash.isNil)(tempStateDone)) {
	        // if property is set on tempstate and is actually the same as tempstate remove it
	        props.updateTempState('profile', objPath, null, undefined);
	      }
	    }, _this.updateTempState = function (parent, prop, event, val, cb) {
	      var value = !(0, _lodash.isUndefined)(val) ? val : (0, _lodash.get)(event, 'target.value');
	
	      if ((0, _lodash.get)(_this.props[_this.props.model], prop) === value) {
	        _this.props.updateTempState(parent, prop, event, undefined, cb);
	      } else {
	        _this.props.updateTempState(parent, prop, event, value, cb);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ProgressComponent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      //this.updateProgress();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	    //this.updateProgress(nextProps);
	
	
	    // performance optimization
	
	  }]);
	
	  return ProgressComponent;
	}(_ValidatedForm3.default), _class.propTypes = {
	  // updateing state
	  tempState: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	
	  // handles viewState
	  viewState: _react.PropTypes.object.isRequired,
	  viewModel: _react.PropTypes.string.isRequired, // string path to view property
	
	  // tracking errors
	  errorCount: _react.PropTypes.number.isRequired,
	
	  // string determining model type
	  model: _react.PropTypes.string.isRequired
	}, _temp2);
	exports.default = ProgressComponent;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(277);
	
	var _TextField = __webpack_require__(448);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _CalendarIcon = __webpack_require__(882);
	
	var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rexMonthYear = /^(0?[1-9]|1?[0-2])\/([0-9]{2}){1,2}$/g;
	var rexYear = /^([0-9]{2}){1,2}$/g;
	
	var DateInput = (_temp = _class = function (_React$Component) {
	  _inherits(DateInput, _React$Component);
	
	  function DateInput(props, context) {
	    _classCallCheck(this, DateInput);
	
	    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props, context));
	
	    _this.onErrorChange = function (value) {
	      if (!_this.props.onErrorChange) {
	        return;
	      }
	
	      // We need to make sure we don't send the same value twice.
	      if (_this.lastNumberErrorSent !== value) {
	        _this.props.onErrorChange(value);
	        _this.lastNumberErrorSent = value;
	      }
	    };
	
	    _this.lastNumberErrorSent = 1;
	
	    _this.handlePickerChange = function (event, newDate) {
	      var newState = (0, _lodash.merge)({}, _this.state);
	      newState.dateValue = newDate;
	      newState.textValue = _this.formatDateString(newState.dateValue, _this.props.dateFormat);
	      newState.isValid = true;
	      newState.isFuture = true;
	      if (_this.props.minDate && newState.isValid) {
	        newState.isValid = newState.isFuture = (0, _moment2.default)(newState.dateValue).isAfter(_this.props.minDate);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event, new Date(newState.dateValue).toUTCString());
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event, new Date(newState.dateValue).toUTCString());
	      }
	
	      if (newState.isValid && newState.isFuture) {
	        _this.onErrorChange(-1);
	      }
	
	      _this.setState(newState);
	    };
	
	    _this.handleTextChange = function (event) {
	      var newState = (0, _lodash.merge)({}, _this.state);
	      newState.textValue = event.target.value;
	      newState.isValid = _this.isValidFormat(newState.textValue);
	      newState.dateValue = newState.isValid ? _this.normalizeValue(newState.textValue) : null;
	
	      // if minDate provided, we need to validate against the minDate.
	      newState.isFuture = true;
	      if (_this.props.minDate && newState.isValid) {
	        newState.isValid = newState.isFuture = (0, _moment2.default)(newState.dateValue).isAfter(_this.props.minDate);
	        newState.dateValue = newState.isValid ? newState.dateValue : null;
	      }
	
	      if (_this.state.isValid && !newState.isValid) {
	        _this.onErrorChange(1);
	      } else if (!_this.state.isValid && newState.isValid) {
	        _this.onErrorChange(-1);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(Object.assign({}, event, { target: { value: newState.dateValue } }));
	      }
	      _this.setState(newState);
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(Object.assign({}, event, { target: { value: _this.state.dateValue } }), _this.state.dateValue);
	      }
	    };
	
	    _this.handleTogglePicker = function () {
	
	      if (_this.props.disabled) {
	        return;
	      }
	
	      _this.refs.datePicker.openDialog();
	    };
	
	    var dateValue = _this.normalizeValue(props.defaultValue);
	    var textValue = _this.formatDateString(dateValue, props.dateFormat);
	
	    _this.state = {
	      dateValue: dateValue,
	      textValue: textValue,
	      isValid: true,
	      isFuture: true
	    };
	    return _this;
	  }
	
	  _createClass(DateInput, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.onErrorChange && this.lastNumberErrorSent) {
	        this.props.onErrorChange(this.lastNumberErrorSent);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var dateValue = this.normalizeValue(nextProps.value, nextProps.defaultValue, this.state.dateValue);
	      var textValue = this.formatDateString(dateValue, nextProps.dateFormat) || '';
	      var newState = { dateValue: dateValue, textValue: textValue };
	      this.setState(newState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.state.isValid && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'isValidFormat',
	    value: function isValidFormat(stringDate) {
	      return this.props.dateFormat === 'Year' ? !!stringDate.match(rexYear) : this.props.dateFormat === 'MonthYear' ? !!stringDate.match(rexMonthYear) : (0, _moment2.default)(stringDate, ['MM/DD/YYYY', 'MM/DD/YY', 'MM/D/YYYY', 'M/DD/YYYY', 'M/D/YYYY', 'M/D/YY'], true).isValid();
	    }
	  }, {
	    key: 'formatDateString',
	    value: function formatDateString(value, format) {
	      if (!(0, _moment2.default)(value).isValid()) {
	        return undefined;
	      }
	
	      switch (format) {
	        case 'Year':
	          return (0, _moment2.default)(value).format('YYYY');
	
	        case 'MonthYear':
	          return (0, _moment2.default)(value).format('MM/YYYY');
	
	        default:
	          return (0, _moment2.default)(value).format('L');
	
	      }
	    }
	  }, {
	    key: 'normalizeValue',
	    value: function normalizeValue(value) {
	      for (var _len = arguments.length, nextValues = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        nextValues[_key - 1] = arguments[_key];
	      }
	
	      // tricksy hobbits: if multiple values passed, normalize the first populated one...
	      if ((0, _lodash.isNil)(value) && nextValues.length > 1) {
	        return this.normalizeValue.apply(this, nextValues);
	      }
	
	      if (typeof value === 'string') {
	        if (value.match(rexMonthYear)) {
	          var _value$split = value.split('/'),
	              _value$split2 = _slicedToArray(_value$split, 2),
	              month = _value$split2[0],
	              year = _value$split2[1];
	
	          return new Date(year, parseInt(month, 10) - 1); // Jan = 0, Dec = 11
	        } else if (value.match(rexYear)) {
	          return new Date(value, 0); // Jan = 0
	        } else if ((0, _moment2.default)(value).isValid()) {
	          return new Date(value);
	        }
	      } else if (value instanceof Date) {
	        return value;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          errorText = _props.errorText,
	          autoOk = _props.autoOk,
	          floatingLabelText = _props.floatingLabelText,
	          hintText = _props.hintText,
	          isDirty = _props.isDirty,
	          minDate = _props.minDate,
	          validation = _props.validation,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          textStyle = _props.textStyle,
	          dataId = _props['data-id'],
	          floatingLabelStyle = _props.floatingLabelStyle,
	          floatingLabelFocusStyle = _props.floatingLabelFocusStyle;
	
	
	      var isEmptyString = function isEmptyString(val) {
	        return typeof val === 'string' && val.length > 0;
	      };
	      var invalidDateErrorMessage = isEmptyString(this.state.textValue) && !this.state.isValid ? 'Invalid date format.' : undefined;
	
	      // if minDate provided, we need to validate against the minDate.
	      if (this.props.minDate && !this.state.isFuture) {
	        invalidDateErrorMessage = 'Please enter a future date.';
	      }
	
	      var defaultClassName = className || 'date-input';
	
	      return _react2.default.createElement(
	        'div',
	        { className: defaultClassName + '-container' },
	        _react2.default.createElement(_TextField2.default, {
	          style: textStyle,
	          'data-id': dataId + '-textfield',
	          className: defaultClassName + '-mask',
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          onChange: this.handleTextChange,
	          onBlur: this.handleBlur,
	          errorText: invalidDateErrorMessage || errorText,
	          value: this.state.textValue,
	          isDirty: isDirty,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelFocusStyle: floatingLabelFocusStyle,
	          validation: validation,
	          disabled: this.props.disabled,
	          floatingLabelStyle: floatingLabelStyle
	        }),
	        !this.props.disabled && _react2.default.createElement(
	          'div',
	          { 'data-id': dataId + '-button', className: defaultClassName + '-icon' },
	          _react2.default.createElement(_CalendarIcon2.default, {
	            disabled: this.props.disabled,
	            onClick: this.handleTogglePicker
	          })
	        ),
	        _react2.default.createElement(_materialUi.DatePicker, {
	          disabled: this.props.disabled,
	          'data-id': dataId + '-datepicker',
	          ref: 'datePicker',
	          className: defaultClassName + '-picker',
	          container: 'inline',
	          autoOk: autoOk,
	          onChange: this.handlePickerChange,
	          onDismiss: this.handleBlur,
	          textFieldStyle: { display: 'none' },
	          value: this.state.dateValue,
	          minDate: minDate
	        })
	      );
	    }
	  }]);
	
	  return DateInput;
	}(_react2.default.Component), _class.propTypes = {
	  onBlur: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onErrorChange: _react.PropTypes.func,
	  dateFormat: _react.PropTypes.oneOf(['Full', 'MonthYear', 'Year']),
	  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.instanceOf(Date)]),
	  textStyle: _react.PropTypes.object,
	  floatingLabelText: _react.PropTypes.string,
	  hintText: _react.PropTypes.string,
	  errorText: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  isDirty: _react.PropTypes.bool,
	  autoOk: _react.PropTypes.bool,
	  minDate: _react.PropTypes.object,
	  validation: _react.PropTypes.object,
	  floatingLabelFixed: _react.PropTypes.bool,
	  floatingLabelStyle: _react.PropTypes.object,
	  floatingLabelFocusStyle: _react.PropTypes.object,
	  disabled: _react.PropTypes.bool,
	  'data-id': _react.PropTypes.string
	}, _class.defaultProps = {
	  dateFormat: 'Full'
	}, _temp);
	exports.default = DateInput;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (input) {
	  var tempDate = new Date(input);
	  return (0, _leftPad2.default)(tempDate.getMonth() + 1, 0, 2) + '/' + (0, _leftPad2.default)(tempDate.getDate(), 0, 2) + '/' + tempDate.getFullYear().toString().slice(2);
	};
	
	exports.fullDate = fullDate;
	exports.monthYear = monthYear;
	exports.resumeDate = resumeDate;
	exports.toYear = toYear;
	
	var _leftPad = __webpack_require__(462);
	
	var _leftPad2 = _interopRequireDefault(_leftPad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fullDate(input) {
	  var tempDate = new Date(input);
	  return (0, _leftPad2.default)(tempDate.getMonth() + 1, 0, 2) + ' / ' + (0, _leftPad2.default)(tempDate.getDate(), 0, 2) + ' / <span class="year">' + tempDate.getFullYear().toString() + '</span>';
	}
	
	function monthYear(input) {
	  var tempDate = new Date(input);
	  return (0, _leftPad2.default)(tempDate.getMonth() + 1, 0, 2) + '/' + tempDate.getFullYear().toString();
	}
	
	function resumeDate(input) {
	  var tempDate = new Date(input);
	  return tempDate.toLocaleDateString('en-us', { month: 'long', year: 'numeric' });
	}
	
	function toYear(input) {
	  var tempDate = new Date(input);
	  return tempDate.getFullYear().toString();
	}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 77 */
[3126, 45, 152, 44],
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var hide = __webpack_require__(77);
	var has = __webpack_require__(76);
	var SRC = __webpack_require__(156)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(100).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var fails = __webpack_require__(34);
	var defined = __webpack_require__(101);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 80 */
[3156, 218, 101],
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(1735);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getContact = getContact;
	exports.updateContact = updateContact;
	exports.updateContactOnboardingEmailDate = updateContactOnboardingEmailDate;
	exports.updateContactOwner = updateContactOwner;
	exports.deleteContact = deleteContact;
	exports.updateContactStatus = updateContactStatus;
	exports.goToPage = goToPage;
	exports.addTag = addTag;
	exports.deleteTag = deleteTag;
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _contacts = __webpack_require__(237);
	
	var _index = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getContact(id, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var groups = getState().staticData.contactStatusGroups;
	      return simpleIsoFetch.get('/api/contacts/' + id).then(function (_ref) {
	        var _ref$body$data$items = _slicedToArray(_ref.body.data.items, 1),
	            contact = _ref$body$data$items[0];
	
	        return (0, _contacts.findGrouping)({ contact: contact, groups: groups });
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function updateContact(newContact, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var _newContact$profile$i = newContact.profile.id,
	          id = _newContact$profile$i === undefined ? 0 : _newContact$profile$i;
	
	      var groups = getState().staticData.contactStatusGroups;
	      var store = getState();
	      var contacts = (0, _lodash.get)(store.admin.contacts, 'items', []);
	      var current = (0, _contacts.findContact)({ profile: { id: id } }, contacts);
	      return simpleIsoFetch.put('/api/contacts/' + id, {
	        body: newContact
	      }).then(function () {
	        return (0, _lodash.merge)({}, current, newContact);
	      }).then(function (contact) {
	        return (0, _contacts.findGrouping)({ contact: contact, groups: groups });
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function updateContactOnboardingEmailDate(newContact, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var _newContact$profile = newContact.profile,
	          _newContact$profile$i2 = _newContact$profile.id,
	          id = _newContact$profile$i2 === undefined ? 0 : _newContact$profile$i2,
	          lastBQPOnboardingEmailSentDate = _newContact$profile.lastBQPOnboardingEmailSentDate;
	
	      var groups = getState().staticData.contactStatusGroups;
	      var store = getState();
	      var contacts = (0, _lodash.get)(store.admin.contacts, 'items', []);
	      var current = (0, _contacts.findContact)({ profile: { id: id } }, contacts);
	      return simpleIsoFetch.put('/api/contacts/' + id + '/updateContactOnboardingEmailDate/' + lastBQPOnboardingEmailSentDate, {
	        body: {
	          contact: {
	            profile: {
	              id: id,
	              lastBQPOnboardingEmailSentDate: lastBQPOnboardingEmailSentDate
	            }
	          }
	        }
	      }).then(function () {
	        return (0, _lodash.merge)({}, current, newContact);
	      }).then(function (contact) {
	        return (0, _contacts.findGrouping)({ contact: contact, groups: groups });
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function updateContactOwner(newContact, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var _newContact$profile$i3 = newContact.profile.id,
	          id = _newContact$profile$i3 === undefined ? 0 : _newContact$profile$i3;
	
	      var groups = getState().staticData.contactStatusGroups;
	      // const store = getState();
	      // const contacts = get(store.admin.contacts, 'items', []);
	      // const current = findContact({profile: {id}}, contacts);
	      var current = newContact;
	      return simpleIsoFetch.put('/api/contacts/' + id, {
	        body: newContact
	      }).then(function () {
	        return (0, _lodash.merge)({}, current, newContact);
	      }).then(function (contact) {
	        return (0, _contacts.findGrouping)({ contact: contact, groups: groups });
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function deleteContact(newContact, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var _newContact$profile$i4 = newContact.profile.id,
	          id = _newContact$profile$i4 === undefined ? 0 : _newContact$profile$i4;
	
	      var groups = getState().staticData.contactStatusGroups;
	      var store = getState();
	      var contacts = (0, _lodash.get)(store.admin.contacts, 'items', []);
	      var current = (0, _contacts.findContact)({ profile: { id: id } }, contacts);
	      return simpleIsoFetch.del('/api/contacts/' + id, {
	        body: newContact
	      }).then(function () {
	        return (0, _lodash.merge)({}, current, newContact);
	      }).then(function (contact) {
	        return (0, _contacts.findGrouping)({ contact: contact, groups: groups });
	      }).then(function (data) {
	        return callback(null, data);
	      }).catch(callback);
	    };
	  };
	}
	
	function updateContactStatus(id, contactStatus, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      var success = (0, _lodash.curry)(callback, 2)(null);
	      var groups = getState().staticData.contactStatusGroups;
	      var store = getState();
	      var contacts = (0, _lodash.get)(store.admin.contacts, 'items', []);
	      var current = (0, _contacts.findContact)({ profile: { id: id } }, contacts);
	      simpleIsoFetch.put('/api/contacts/' + id + '/status/' + contactStatus).then(function () {
	        return (0, _lodash.merge)({}, current, { profile: { contactStatus: contactStatus } });
	      }).then(function (contact) {
	        return (0, _contacts.findGrouping)({ contact: contact, groups: groups });
	      }).then(success).catch(callback);
	    };
	  };
	}
	
	function goToPage(skip, limit, filters, terms) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/contacts',
	        query: _extends({
	          order: 'desc',
	          skip: skip,
	          limit: limit
	        }, filters, {
	          terms: terms
	        })
	      }).then(function (data) {
	        dispatch(syncActionCreators.updateContactsPage(data.body.data));
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    };
	  };
	}
	
	function addTag(id, body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	
	      simpleIsoFetch.post({
	        route: '/api/contacts/' + id + '/tag',
	        body: body
	      }).then(function (_ref2) {
	        var items = _ref2.body.data;
	
	        if (callback) {
	          return callback(null, items);
	        }
	        return items;
	      }, function (err) {
	        return callback(err, null);
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}
	
	function deleteTag(id, body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.del({
	        route: '/api/contacts/' + id + '/tag',
	        body: body
	      }).then(function (_ref3) {
	        var items = _ref3.body.data;
	
	        if (callback) {
	          return callback(null, items);
	        }
	        return items;
	      }, function (err) {
	        return callback(err, null);
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	      });
	    };
	  };
	}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearContactInContactWorksheet = clearContactInContactWorksheet;
	exports.updateContactInContactWorksheet = updateContactInContactWorksheet;
	exports.updateContact = updateContact;
	exports.updateContactProfile = updateContactProfile;
	exports.updateProfile = updateProfile;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function clearContactInContactWorksheet() {
	  return {
	    type: actionTypes.CLEAR_CONTACT_IN_CONTACT_WORKSHEET
	  };
	} // action type strings
	function updateContactInContactWorksheet(_ref) {
	  var contact = _ref.contact;
	
	  return {
	    type: actionTypes.UPDATE_CONTACT_IN_CONTACT_WORKSHEET,
	    contact: contact
	  };
	}
	
	function updateContact(_ref2) {
	  var contact = _ref2.contact;
	
	  return {
	    type: actionTypes.UPDATE_CONTACT,
	    contact: contact
	  };
	}
	
	function updateContactProfile(contact) {
	  console.warn('This function is DEPRECATED please use updateProfile, updateCompany instead.');
	  return {
	    type: actionTypes.UPDATE_CONTACT_PROFILE,
	    contact: contact
	  };
	}
	
	function updateProfile(profile) {
	  return {
	    type: actionTypes.UPDATE_PROFILE,
	    profile: profile
	  };
	}

/***/ }),
/* 85 */
[3143, 219, 152, 80, 104, 76, 518, 44],
/* 86 */
[3146, 76, 50, 353],
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = whitespace;
	
	var fromCode = String.fromCharCode;
	var re = /\s/;
	
	/* Check if the given character code, or the character
	 * code at the first character, is a whitespace character. */
	function whitespace(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  );
	}


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _childUtils = __webpack_require__(188);
	
	var _events = __webpack_require__(278);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(390);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(616);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.props.onClick(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.button.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	      }
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity
	        },
	        children
	      ) : undefined;
	
	      return (0, _childUtils.createChildFragment)({
	        focusRipple: focusRipple,
	        touchRipple: touchRipple,
	        children: touchRipple ? undefined : children
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onTouchTap = _props3.onTouchTap,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null,
	        zIndex: 1 }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: function ref(node) {
	          return _this2.button = node;
	        },
	        disabled: disabled,
	        href: href,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onTouchTap: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onTouchTap: function onTouchTap() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedButton.propTypes = {
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  disableFocusRipple: _react.PropTypes.bool,
	  disableKeyboardFocus: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  focusRippleColor: _react.PropTypes.string,
	  focusRippleOpacity: _react.PropTypes.number,
	  href: _react.PropTypes.string,
	  keyboardFocused: _react.PropTypes.bool,
	  onBlur: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onKeyDown: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onKeyboardFocus: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  style: _react.PropTypes.object,
	  tabIndex: _react.PropTypes.number,
	  touchRippleColor: _react.PropTypes.string,
	  touchRippleOpacity: _react.PropTypes.number,
	  type: _react.PropTypes.string
	} : void 0;
	exports.default = EnhancedButton;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var horizontal = _react.PropTypes.oneOf(['left', 'middle', 'right']);
	var vertical = _react.PropTypes.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _react.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _react.PropTypes.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _react.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  zDepth: _react.PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	// import components from material UI
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _RaisedButton = __webpack_require__(386);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _muiThemeable = __webpack_require__(394);
	
	var _muiThemeable2 = _interopRequireDefault(_muiThemeable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var raisedButtonCustomization = {
	  primary: true,
	  disableTouchRipple: true,
	  disableFocusRipple: true,
	  style: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    minWidth: '296px',
	    height: '41px'
	  },
	  labelStyle: {
	    letterSpacing: '3.5px',
	    fontSize: '12px',
	    verticalAlign: 'initial',
	    top: '-.5px'
	  },
	  disabledBackgroundColor: 'rgb(241,241,241)'
	};
	
	// muiThemeable brings in theme from provider at root
	var CustomRaisedButton = (_dec = (0, _muiThemeable2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CustomRaisedButton, _Component);
	
	  function CustomRaisedButton(props, context) {
	    _classCallCheck(this, CustomRaisedButton);
	
	    return _possibleConstructorReturn(this, (CustomRaisedButton.__proto__ || Object.getPrototypeOf(CustomRaisedButton)).call(this, props, context));
	  }
	
	  _createClass(CustomRaisedButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          label = _props.label,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          otherProps = _objectWithoutProperties(_props, ['className', 'label', 'style', 'labelStyle']);
	
	      var raisedButtonCustomizationStyle = raisedButtonCustomization.style,
	          raisedButtonCustomizationLabelStyle = raisedButtonCustomization.labelStyle,
	          raisedButtonCustomizationOther = _objectWithoutProperties(raisedButtonCustomization, ['style', 'labelStyle']);
	
	      var rootStyleFinal = _extends({}, raisedButtonCustomizationStyle, style);
	
	      return _react2.default.createElement(_RaisedButton2.default, _extends({ className: 'raised-button ' + className + ' ' + (otherProps.disabled ? 'disabled' : ''),
	        'data-id': '' + label + (otherProps.disabled ? ' Disabled' : ''),
	        label: label,
	        style: rootStyleFinal,
	        labelStyle: _extends({}, raisedButtonCustomizationLabelStyle, { lineHeight: '' + rootStyleFinal.height + (typeof rootStyleFinal.height === 'string' && !isNaN(rootStyleFinal.height.slice(-2)) ? 'px' : '') }, labelStyle)
	      }, raisedButtonCustomizationOther, otherProps));
	    }
	  }]);
	
	  return CustomRaisedButton;
	}(_react.Component), _class2.propTypes = {
	  className: _react.PropTypes.string,
	  label: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  labelStyle: _react.PropTypes.object
	}, _class2.defaultProps = {
	  style: {},
	  labelStyle: {}
	}, _temp)) || _class);
	exports.default = CustomRaisedButton;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var COMPANY_STATUS = exports.COMPANY_STATUS = {
	  NEW_PROSPECT: 1,
	  QUALIFIED_PROSPECT: 2,
	  NOT_QUALIFIED_PROSPECT: 3,
	  ACTIVE_ACCOUNT: 4,
	  INACTIVE_ACCOUNT: 5,
	  ARCHIVED: 6,
	  DNC: 10,
	  PRIVATE: 11
	};
	
	var JOB_REQUEST_STATUS = exports.JOB_REQUEST_STATUS = {
	  IN_PROGRESS: 1,
	  NEW_REQUEST: 2,
	  NA: 3,
	  APPROVED: 4,
	  CANDIDATE_PLACED: 5,
	  JOB_CANCELED: 6,
	  ABANDONED: 7
	};
	
	var STATUS_GROUPS = exports.STATUS_GROUPS = {
	  IN_PROCESS: 1,
	  INACTIVE: 2,
	  STANDBY: 3,
	  QUALIFIED: 4,
	  NO_LONGER_PLACEABLE: 5
	};
	
	var CONTACT_STATUS_GROUPS = exports.CONTACT_STATUS_GROUPS = {
	  IN_PROCESS: 1,
	  INACTIVE: 2,
	  STANDBY: 3
	};
	
	var CONTACT_ROLES = exports.CONTACT_ROLES = {
	  BILLING: 1,
	  EXECUTIVE: 2,
	  HR: 3,
	  KEY: 4,
	  MAIN: 5,
	  MANAGER: 6,
	  OWNER: 7,
	  REPORTING: 8,
	  SUPERVISOR: 9,
	  TECHNOLOGY: 10,
	  TRAINING: 11,
	  SOCIAL_MEDIA: 12,
	  NEWSLETTER: 13,
	  MARKETING: 14,
	  EDITOR: 15
	};
	
	var APPLICANT_STATUS = exports.APPLICANT_STATUS = {
	  NEW_APPLICANT: 1,
	  PENDING_PRELIMINARY_INTERVIEW: 2,
	  PENDING_APPLICATION: 3,
	  PENDING_ASSESSMENTS: 4,
	  PENDING_APPLICATION_INTERVIEW: 5,
	  PENDING_INFORMATION_UPDATE: 6,
	  UNRESPONSIVE: 7,
	  NOT_QUALIFIED: 8,
	  NOT_INTERESTED: 9,
	  IN_WAITING: 10,
	  QUALIFIED_CANDIDATE: 11,
	  READY_TO_PLACE: 12,
	  PENDING_REFERENCE_CHECKS: 13,
	  ARCHIVED: 14,
	  DNC: 15,
	  UNAVAILABLE: 16,
	  PENDING_REVIEW: 17,
	  QUALIFIED_IN_WAITING: 18,
	  QUALIFIED_CANDIDATE_IN_QUEUE: 19,
	  ACTIVE: 20,
	  PLACED: 21,
	  UNRESPONSIVE_BH: 22,
	  UNAVAILABLE_BH: 23,
	  FULLY_RETIRED: 24,
	  DIRECT_HIRE: 25,
	  NOT_QUALIFIED_BH: 26,
	  NOT_INTERESTED_BH: 27,
	  PENDING_TECH_EVALUATION: 28,
	  DECEASED: 29,
	  NO_LONGER_PLACEABLE: 30,
	  WAITING_FOR_MATCH: 31
	};
	
	var EMPLOYEE_ROLES = exports.EMPLOYEE_ROLES = {
	  APPLICANT: 1,
	  EMPLOYEE: 2,
	  CLIENT: 3,
	  ADMIN: 4,
	  QUALIFYING_SPECIALIST: 5,
	  REFERENCE_SPECIALIST: 6,
	  PLACEMENT_SPECIALIST: 7,
	  OWNER: 8,
	  SALES: 9,
	  RELATIONSHIP_MANAGER: 10,
	  IT_MANAGER: 11,
	  ACCOUNTING: 12,
	  CLIENT_ADVISER: 13,
	  SUPPORT_ASSISTANT: 14
	};
	
	var employeeTypes = exports.employeeTypes = ['1099', 'W2', '1099 LLC', 'K-1'];

/***/ }),
/* 93 */
[3162, 331, 243, 128],
/* 94 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 95 */
[3122, 58],
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(34);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	// utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addPropsToChildren = __webpack_require__(895);
	
	var _addPropsToChildren2 = _interopRequireDefault(_addPropsToChildren);
	
	var _reactProps = __webpack_require__(238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    scrollBarWidth: store.user.scrollBarWidth,
	    wasNavigatedTo: store.routing.locationBeforeTransitions.action === 'PUSH'
	  };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionHide: false,
	      transitioning: false,
	      isEdge: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      if (this.props.wasNavigatedTo && !this.state.transitionHide && (this.props.fadeModal || this.props.fadeModalChildren)) {
	        this.setState(_lodash2.default.merge(this.state, {
	          isEdge: navigator && /Edge\/\d./i.test(navigator.userAgent), // TEMP FIX FOR EDGE
	          transitionHide: true,
	          transitioning: true
	        }));
	        setTimeout(function () {
	          return _this2.setState(_lodash2.default.merge(_this2.state, {
	            transitionHide: false
	          }));
	        });
	        setTimeout(function () {
	          return _this2.setState(_lodash2.default.merge(_this2.state, {
	            transitioning: false
	          }));
	        }, this.props.transitionDuration);
	      } else if (this.state.transitionHide || this.state.transitioning) {
	        this.setState(_lodash2.default.merge(this.state, {
	          isEdge: navigator && /Edge\/\d./i.test(navigator.userAgent), // TEMP FIX FOR EDGE
	          transitionHide: false,
	          transitioning: false
	        }));
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(e) {
	      var _this3 = this;
	
	      if (this.props.onClose) {
	        if (this.props.fadeModal || this.props.fadeModalChildren) {
	          this.setState(_lodash2.default.merge(this.state, {
	            transitionHide: true,
	            transitioning: true
	          }));
	          setTimeout(function () {
	            _this3.props.onClose(e);
	          }, this.props.transitionDuration);
	        } else {
	          this.props.onClose(e);
	        }
	      }
	    }
	  }, {
	    key: 'hideOnOuterClick',
	    value: function hideOnOuterClick(e) {
	      // only close outside of modal content is clicked
	      if (e.target.dataset.modal) {
	        this.closeModal(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          className = _props.className,
	          modalClass = _props.modalClass,
	          modalContentClass = _props.modalContentClass,
	          onClose = _props.onClose,
	          children = _props.children,
	          scrollBarWidth = _props.scrollBarWidth,
	          noScroll = _props.noScroll,
	          fadeModal = _props.fadeModal,
	          fadeModalChildren = _props.fadeModalChildren,
	          floatDownModalChildren = _props.floatDownModalChildren,
	          outsideUnclickable = _props.outsideUnclickable,
	          childAnimInit = _props.childAnimInit,
	          childStyle = _props.childStyle,
	          transitionDuration = _props.transitionDuration,
	          opacityTransitionIn = _props.opacityTransitionIn,
	          opacityTransitionOut = _props.opacityTransitionOut,
	          transformTransitionIn = _props.transformTransitionIn,
	          transformTransitionOut = _props.transformTransitionOut,
	          wasNavigatedTo = _props.wasNavigatedTo,
	          otherProps = _objectWithoutProperties(_props, ['show', 'className', 'modalClass', 'modalContentClass', 'onClose', 'children', 'scrollBarWidth', 'noScroll', 'fadeModal', 'fadeModalChildren', 'floatDownModalChildren', 'outsideUnclickable', 'childAnimInit', 'childStyle', 'transitionDuration', 'opacityTransitionIn', 'opacityTransitionOut', 'transformTransitionIn', 'transformTransitionOut', 'wasNavigatedTo']);
	
	      // stored for convenience
	
	
	      var transformChildren = ''; // `translate3d(-50%,${floatDownModalChildren && (!show || this.state.transitionHide) && 'calc(-50% - 30px)' || '-50%'},0)`;
	      var calcedShow = show && !this.state.transitionHide;
	
	      var modalShowTransition = 'opacity ' + transitionDuration + 'ms ' + opacityTransitionIn + ', transform ' + transitionDuration + 'ms ' + transformTransitionIn + ', visibility 0s 0s';
	      var modalFadeTransition = 'opacity ' + transitionDuration + 'ms ' + opacityTransitionOut + ', transform ' + transitionDuration + 'ms ' + transformTransitionOut + ', visibility 0s ' + transitionDuration + 'ms';
	
	      // only use scrollbar width if there is a scrollbar showing on the body
	      var conditionalScrollbarWidth = !noScroll && scrollBarWidth || 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-container ' + className, 'data-id': 'Modal' },
	        _react2.default.createElement('div', _extends({ className: (0, _classnames2.default)('modal', modalClass, { 'modal-fade': fadeModal, 'modal-show': calcedShow && fadeModal }),
	          style: !calcedShow && fadeModal && {
	            visibility: 'hidden',
	            opacity: 0,
	            transition: modalFadeTransition
	          } || {
	            transition: modalShowTransition
	          },
	          onMouseDown: !outsideUnclickable && this.hideOnOuterClick.bind(this),
	          onTouchStart: !outsideUnclickable && this.hideOnOuterClick.bind(this),
	          'data-modal': 'true'
	        }, (0, _reactProps.stripUnknownProps)(otherProps))),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('modal-content', 'clearfix', modalContentClass, { 'modal-fade': !this.state.isEdge && fadeModalChildren, 'modal-show': !this.state.isEdge && calcedShow && fadeModalChildren }),
	            style: !this.state.isEdge && !calcedShow && fadeModalChildren && _lodash2.default.merge({}, childStyle, {
	              visibility: 'hidden',
	              opacity: 0,
	              transform: transformChildren,
	              transition: modalFadeTransition
	            }, childAnimInit) || _lodash2.default.merge(!this.state.transitioning && {
	              transform: transformChildren
	            } || {}, childStyle, this.state.transitioning && {
	              transition: modalShowTransition,
	              transform: transformChildren
	            } || {})
	          },
	          children && (0, _addPropsToChildren2.default)(children, { closeModal: this.props.onClose && this.closeModal.bind(this) })
	        ),
	        show && _react2.default.createElement(
	          'style',
	          null,
	          '\n              html, body{\n                overflow: hidden;\n              }\n              body {\n                padding-right: ' + conditionalScrollbarWidth + 'px;\n              }\n              .modal {\n                left: -' + scrollBarWidth + 'px;\n                width: calc(100% + ' + conditionalScrollbarWidth + 'px);\n              }\n              '
	        )
	      );
	    }
	  }]);
	
	  return Modal;
	}(_react.Component), _class2.propTypes = {
	  show: _react.PropTypes.bool,
	  onClose: _react.PropTypes.func,
	  children: _react.PropTypes.any,
	  className: _react.PropTypes.string,
	  modalClass: _react.PropTypes.string,
	  modalContentClass: _react.PropTypes.string,
	  scrollBarWidth: _react.PropTypes.number,
	  noScroll: _react.PropTypes.bool,
	  wasNavigatedTo: _react.PropTypes.bool,
	  fadeModal: _react.PropTypes.bool,
	  fadeModalChildren: _react.PropTypes.bool,
	  outsideUnclickable: _react.PropTypes.bool,
	  childAnimInit: _react.PropTypes.object,
	  childStyle: _react.PropTypes.object,
	  transitionDuration: _react.PropTypes.number,
	  floatDownModalChildren: _react.PropTypes.bool,
	  opacityTransitionIn: _react.PropTypes.string,
	  opacityTransitionOut: _react.PropTypes.string,
	  transformTransitionIn: _react.PropTypes.string,
	  transformTransitionOut: _react.PropTypes.string
	}, _class2.defaultProps = {
	  show: false,
	  children: null,
	  className: '',
	  scrollBarWidth: 15,
	  transitionDuration: 200,
	  opacityTransitionIn: 'cubic-bezier(.02,.75,.41,.96)',
	  opacityTransitionOut: 'cubic-bezier(.92,.18,.81,.77)',
	  transformTransitionIn: 'cubic-bezier(.09,.6,.21,.97)',
	  transformTransitionOut: 'cubic-bezier(.09,.77,.21,.97)'
	}, _temp2)) || _class);
	exports.default = Modal;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ChevronIcon(props) {
	    var _props$color = props.color,
	        color = _props$color === undefined ? '#333333' : _props$color,
	        otherProps = _objectWithoutProperties(props, ['color']);
	
	    return _react2.default.createElement(
	        'svg',
	        { width: '11px', height: '8px', viewBox: '0 0 11 8', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement(
	            'g',
	            { id: '2139---Card-Filter', stroke: 'none', strokeWidth: '2', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(-537.000000, -106.000000)', id: 'Group-Copy', strokeWidth: '2', stroke: '' + color },
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(538.000000, 107.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group-64' },
	                        _react2.default.createElement('path', { d: 'M4.5,6 L9,0', id: 'Shape' }),
	                        _react2.default.createElement('path', { d: 'M0,0 L4.5,6', id: 'Shape' })
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = ChevronIcon;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(95);
	var IObject = __webpack_require__(218);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(46);
	var asc = __webpack_require__(338);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 100 */
57,
/* 101 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 102 */
[3149, 7, 100, 34],
/* 103 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 104 */
[3159, 38],
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(2762);
	exports.encode = exports.stringify = __webpack_require__(2763);


/***/ }),
/* 106 */
66,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(261);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactCurrentOwner = __webpack_require__(137);
	
	var warning = __webpack_require__(25);
	var canDefineProperty = __webpack_require__(806);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.createElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	
	    // Create dummy `key` and `ref` property to `props` to warn users against its use
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingKey.isReactWarning = true;
	
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingRef.isReactWarning = true;
	
	    if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	      if (!props.hasOwnProperty('key')) {
	        Object.defineProperty(props, 'key', {
	          get: warnAboutAccessingKey,
	          configurable: true
	        });
	      }
	      if (!props.hasOwnProperty('ref')) {
	        Object.defineProperty(props, 'ref', {
	          get: warnAboutAccessingRef,
	          configurable: true
	        });
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.cloneElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var CallbackQueue = __webpack_require__(789);
	var PooledClass = __webpack_require__(136);
	var ReactFeatureFlags = __webpack_require__(797);
	var ReactReconciler = __webpack_require__(196);
	var Transaction = __webpack_require__(226);
	
	var invariant = __webpack_require__(22);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2, _dec2, _class3, _class4, _temp4;
	
	// utilities
	// needed because I can't figure out how to make s3 work with fetch
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _simpleIsoFetch = __webpack_require__(227);
	
	var _simpleIsoFetch2 = _interopRequireDefault(_simpleIsoFetch);
	
	var _querystring = __webpack_require__(105);
	
	var _isoPathJoin = __webpack_require__(557);
	
	var _isoPathJoin2 = _interopRequireDefault(_isoPathJoin);
	
	var _superagent = __webpack_require__(440);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// get rid of non-word characters
	var urlSafe = /\W/g;
	
	// file types
	var acceptableExtensionsMap = {
	  image: ['png', 'jpeg', 'gif', 'jpg', 'svg'],
	  video: ['mp4', 'webm'],
	  document: ['pdf', 'doc', 'docx', 'pages'],
	  spreadsheet: ['xls', 'xlsx', 'numbers', 'csv']
	};
	
	var SimpleFileInput = (_dec = (0, _reactRedux.connect)(function (store) {
	  if ((0, _lodash.get)(store, 'user.accountId', '') !== '') {
	    return { accountId: store.user.accountId };
	  }
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(SimpleFileInput, _Component);
	
	  function SimpleFileInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SimpleFileInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleFileInput.__proto__ || Object.getPrototypeOf(SimpleFileInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loadingState: _this.props.initialLoadState || 'pristine'
	    }, _this.uniqueId = _shortid2.default.generate(), _this.getUnique = function () {
	      return (Number(new Date()).toString() + '_' + _shortid2.default.generate()).replace(urlSafe, '_');
	    }, _this.onChange = function (acceptableFileExtensions, event) {
	      // handle cancel
	      if (!event.target.files.length) return;
	
	      // update loader state to loading
	      _this.setLoading();
	
	      // load in input asset
	      _this.assetUpload(event, +new Date(), acceptableFileExtensions);
	    }, _this.assetUpload = function (event, startTime, acceptableFileExtensions) {
	      // file upload vars
	      var fileObj = event.target.files[0],
	          ext = fileObj.name.slice(fileObj.name.lastIndexOf('.')),
	          name = (typeof _this.props.fileName !== 'undefined' ? _this.props.fileName : fileObj.name.slice(0, fileObj.name.lastIndexOf('.'))).replace(urlSafe, '_') + (typeof _this.props.fileAppend !== 'undefined' ? _this.props.fileAppend : '_' + _this.getUnique()) + ext,
	          type = fileObj.type,
	          size = fileObj.size;
	
	      if (!_this.props.accountId) {
	        throw new Error('AccountId is required.');
	      }
	
	      var fileInfoObj = {
	        ext: ext,
	        type: type,
	        size: size,
	        name: name,
	        nameWithFolder: _this.props.remoteFolder ? (0, _isoPathJoin2.default)(_this.props.accountId, _this.props.remoteFolder, name) : (0, _isoPathJoin2.default)(_this.props.accountId, name)
	      };
	
	      // clear input so that same file can be uploaded twice in a row
	      if (global.document) {
	        var domElem = document.getElementById(_this.uniqueId);
	        if (domElem) {
	          domElem.value = '';
	          domElem.type = 'file';
	        }
	      }
	
	      // compose upload state handler
	      var assetUploadStateHandler = _this.assetUploadStateHandlerGen(startTime);
	      var errorHandle = _this.errorHandle.bind(_this, assetUploadStateHandler);
	
	      if (size > _this.props.maxSize) return errorHandle('upload is too large, upload size limit is ' + Math.round(size / 100) / 10 + 'KB');
	      if (acceptableFileExtensions.indexOf(ext.toLowerCase()) === -1) return errorHandle('upload is not acceptable file type, acceptable extensions include ' + acceptableFileExtensions.join(', '));else {
	        // trigger 'onLoadStart' function if provided
	        if (_this.props.onLoadStart && typeof _this.props.onLoadStart === 'function') {
	          _this.props.onLoadStart(null, fileInfoObj);
	        }
	
	        // // Handles immediate return of Data URI
	        if (_this.props.onBlobLoad && typeof _this.props.onBlobLoad === 'function') {
	          var reader = new FileReader();
	          reader.readAsDataURL(fileObj);
	
	          // send blob load error to callback
	          reader.onerror = function (err) {
	            if (!_this.props.onS3Load || !_this.props.signingRoute) assetUploadStateHandler(err, null);
	            _this.props.onBlobLoad(err, null, fileInfoObj);
	          };
	
	          // sends blob to callback
	          reader.onloadend = function (e) {
	            if (!_this.props.onS3Load || !_this.props.signingRoute) assetUploadStateHandler(null, e.target.result);
	            _this.props.onBlobLoad(null, e.target.result, fileInfoObj);
	          };
	        }
	
	        // // Handles S3 storage
	        if (_this.props.onS3Load && typeof _this.props.onS3Load === 'function') {
	          // warn if no upload string provided
	          if (typeof _this.props.signingRoute !== 'string') return console.error('need to supply signing route to use s3!');
	
	          _simpleIsoFetch2.default.post({
	            route: _this.props.signingRoute,
	            body: {
	              name: _this.props.remoteFolder ? (0, _isoPathJoin2.default)(_this.props.accountId, _this.props.remoteFolder, name) : (0, _isoPathJoin2.default)(_this.props.accountId, name),
	              type: type
	            }
	          }).then(function (res) {
	            _superagent2.default.put(res.body.signedRequest, fileObj).set('Content-Type', type).end(function (err, final) {
	              var error = err || final.error;
	
	              if (error) {
	                assetUploadStateHandler(error, null);
	                return _this.props.onS3Load(error, null, fileInfoObj);
	              }
	
	              // run state handler
	              assetUploadStateHandler(null, res.body.url);
	
	              // execute callback with S3 stored file name
	              _this.props.onS3Load(null, res.body.url, fileInfoObj);
	            });
	          }).catch(function (err) {
	            assetUploadStateHandler(err, null);
	            _this.props.onS3Load(err, null, fileInfoObj);
	          });
	        }
	      }
	    }, _this.assetUploadStateHandlerGen = function () {
	      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      return function (err, data) {
	        if (err) {
	          // update loader to failure
	          _this.setState({
	            loadingState: 'failure'
	          });
	        } else if (data) {
	          // update loader with success, wait a minimum amount of time if specified in order to smooth aesthetic
	          var waitTime = Math.max(0, _this.props.minLoadTime - +new Date() + startTime);
	          if (waitTime) {
	            setTimeout(_this.setSuccess, waitTime);
	          } else {
	            _this.setSuccess();
	          }
	        } else {
	          // update loader to failure
	          _this.setState({
	            loadingState: 'failure'
	          });
	        }
	      };
	    }, _this.errorHandle = function (assetUploadStateHandler, err) {
	      if (_this.props.onLoadStart) _this.props.onLoadStart(err, null);
	      if (_this.props.onS3Load) _this.props.onS3Load(err, null);
	      if (_this.props.onBlobLoad) _this.props.onBlobLoad(err, null);
	      assetUploadStateHandler(err, null);
	    }, _this.setLoading = function () {
	      if (_this.state.loadingState !== 'loading') {
	        _this.setState({
	          loadingState: 'loading'
	        });
	      }
	    }, _this.setSuccess = function () {
	      if (_this.state.loadingState !== 'success') {
	        _this.setState({
	          loadingState: 'success'
	        });
	      }
	    }, _this.setFailure = function () {
	      if (_this.state.loadingState !== 'failure') {
	        _this.setState({
	          loadingState: 'failure'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // asset uploading function
	
	
	  // callback fired when upload completes
	
	
	  _createClass(SimpleFileInput, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          inputClass = _props.inputClass,
	          inputStyle = _props.inputStyle,
	          messageClass = _props.messageClass,
	          messageStyle = _props.messageStyle,
	          pristineClass = _props.pristineClass,
	          loadingClass = _props.loadingClass,
	          successClass = _props.successClass,
	          failureClass = _props.failureClass,
	          initialLoadState = _props.initialLoadState,
	          minLoadTime = _props.minLoadTime,
	          maxSize = _props.maxSize,
	          onBlobLoad = _props.onBlobLoad,
	          onS3Load = _props.onS3Load,
	          signingRoute = _props.signingRoute,
	          accept = _props.accept,
	          type = _props.type,
	          otherProps = _objectWithoutProperties(_props, ['className', 'style', 'inputClass', 'inputStyle', 'messageClass', 'messageStyle', 'pristineClass', 'loadingClass', 'successClass', 'failureClass', 'initialLoadState', 'minLoadTime', 'maxSize', 'onBlobLoad', 'onS3Load', 'signingRoute', 'accept', 'type']);
	
	      var acceptableFileExtensions = (accept || acceptableExtensionsMap[type]).map(function (val) {
	        return ("" + val)[0] !== '.' ? '.' + val : val;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          _extends({
	            htmlFor: this.uniqueId,
	            className: 'simple-file-input-container ' + (className || '') + ' ' + this.props[this.state.loadingState + 'Class'],
	            style: style
	          }, otherProps),
	          !this.props.noMessage && _react2.default.createElement(
	            'span',
	            {
	              className: 'simple-file-input-message ' + (messageClass || ''),
	              style: messageStyle
	            },
	            this.props[this.state.loadingState + 'Message']
	          ),
	          this.props.children
	        ),
	        _react2.default.createElement('input', {
	          className: 'simple-file-input-input ' + (inputClass || ''),
	          style: _extends({}, !inputClass && { display: 'none' } || {}, inputStyle),
	          type: 'file',
	          accept: acceptableFileExtensions,
	          onChange: this.onChange.bind(this, acceptableFileExtensions),
	          name: this.uniqueId,
	          id: this.uniqueId
	        })
	      );
	    }
	  }]);
	
	  return SimpleFileInput;
	}(_react.Component), _class2.propTypes = {
	  // styling
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  inputClass: _react.PropTypes.string,
	  inputStyle: _react.PropTypes.object,
	  messageClass: _react.PropTypes.string,
	  messageStyle: _react.PropTypes.object,
	
	  // hide success/failure message
	  noMessage: _react.PropTypes.bool,
	  pristineMessage: _react.PropTypes.string,
	  loadingMessage: _react.PropTypes.string,
	  successMessage: _react.PropTypes.string,
	  failureMessage: _react.PropTypes.string,
	
	  // loading state classes
	  pristineClass: _react.PropTypes.string,
	  loadingClass: _react.PropTypes.string,
	  successClass: _react.PropTypes.string,
	  failureClass: _react.PropTypes.string,
	
	  // initial icon state
	  initialLoadState: _react.PropTypes.oneOf(['pristine', 'loading', 'success', 'failure']),
	
	  // helps smooth aesthetic
	  minLoadTime: _react.PropTypes.number,
	
	  // maximum file size (in bytes)
	  maxSize: _react.PropTypes.number,
	
	  // triggered when upload begins
	  onLoadStart: _react.PropTypes.func,
	
	  // triggered when blob is loaded if provided
	  onBlobLoad: _react.PropTypes.func,
	
	  // triggered when s3 upload is done, if function is provided
	  onS3Load: _react.PropTypes.func,
	  // S3 signature getting route
	  signingRoute: _react.PropTypes.string,
	  // overrides uploaded file's name
	  fileName: _react.PropTypes.string,
	  // overrides default string appended to file name
	  fileAppend: _react.PropTypes.string,
	  // specifies S3 folder path inside of bucket
	  remoteFolder: _react.PropTypes.string,
	
	  // specifies acceptable file types
	  type: _react.PropTypes.oneOf(['image', 'video', 'document', 'spreadsheet']), // abstraction
	  accept: _react.PropTypes.array, // allow user to specify extensions
	  accountId: _react.PropTypes.accountId
	}, _class2.defaultProps = {
	  // 100MB (unit is bytes)
	  maxSize: 100000000,
	
	  // sets minimum amount of time before loader clears
	  minLoadTime: 125,
	
	  // default style objects to empty object
	  style: {},
	  inputStyle: {},
	  messageStyle: {},
	
	  // default state-dependent messages
	  pristineMessage: '',
	  loadingMessage: '',
	  successMessage: 'Upload Success!',
	  failureMessage: 'Upload Failed - Please Try Again',
	
	  // default to font awesome class names
	  pristineClass: 'fa fa-upload',
	  loadingClass: 'fa fa-spinner fa-spin',
	  successClass: 'fa fa-thumbs-o-up',
	  failureClass: 'fa fa-thumbs-o-down'
	}, _temp2)) || _class);
	
	//
	//
	//
	//
	//
	// // Just placing retrieval component here, worrying about getting webpack working later
	//
	//
	//
	//
	//
	
	exports.default = SimpleFileInput;
	var RetrievalButton = (_dec2 = (0, _reactRedux.connect)(function (store) {
	  return { accountId: store.user.accountId };
	}), _dec2(_class3 = (_temp4 = _class4 = function (_Component2) {
	  _inherits(RetrievalButton, _Component2);
	
	  function RetrievalButton() {
	    var _ref2;
	
	    var _temp3, _this2, _ret2;
	
	    _classCallCheck(this, RetrievalButton);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp3 = (_this2 = _possibleConstructorReturn(this, (_ref2 = RetrievalButton.__proto__ || Object.getPrototypeOf(RetrievalButton)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
	      loadingState: _this2.props.initialLoadState || 'notLoading',
	      loaded: false,
	      fileLink: ''
	    }, _this2.componentDidMount = function () {
	      // load in fileName asset on mount
	      if (_this2.props.autoLoad && _this2.props.path) {
	        _this2.assetRetrieve();
	      }
	    }, _this2.componentWillReceiveProps = function (nextProps) {
	      // hacky check for isMounted: pathJoin(this.props.accountId, name)
	
	      if (_this2.props.autoLoad && _this2.props.path !== nextProps.path) {
	        _this2.assetRetrieve(nextProps.path);
	      }
	    }, _this2.onClick = function () {
	      if (!_this2.props.autoLoad) {
	        // load in fileName asset
	        _this2.assetRetrieve();
	      }
	    }, _this2.assetRetrieve = function (path) {
	
	      if (!_this2.props.accountId) {
	        throw new Error('AccountId is required.');
	      }
	
	      path = path || _this2.props.path;
	
	      if (!path) {
	        throw new Error('path prop is missing');
	      }
	
	      if (!_this2.props.signingRoute) {
	        throw new Error('signingRoute prop is missing');
	      }
	
	      var startTime = +new Date();
	
	      // update loader state to loading
	      _this2.setLoading(_this2.props.onLoadStart);
	
	      // compose upload state handler
	      var assetRetrievalStateHandler = _this2.assetRetrievalStateHandlerGen(startTime);
	      var errorHandle = _this2.errorHandle.bind(_this2, assetRetrievalStateHandler);
	
	      _simpleIsoFetch2.default.post({
	        route: _this2.props.signingRoute,
	        body: {
	          name: path
	        }
	      }).then(function (res) {
	        if (_this2.props.onS3Url) _this2.props.onS3Url(null, res.body.signedRequest);
	
	        // update URL with fetched URL
	        _this2.updateUrl(res.body.signedRequest, !_this2.props.autoLoad ? function () {
	          return window.open(res.body.signedRequest, '_blank');
	        } : null);
	
	        // set Loaded to back to false once expired
	        setTimeout(function () {
	          return _this2.setNotLoaded(function () {
	            return _this2.props.autoLoad && _this2.assetRetrieve();
	          });
	        }, Math.max(+(0, _querystring.parse)(res.body.signedRequest).Expires * 1000 - Date.now() - 100, 0) || 900000);
	
	        if (!_this2.props.onS3Res) {
	          assetRetrievalStateHandler(null, res.body.signedRequest);
	        } else {
	          _superagent2.default.get(res.body.signedRequest).end(function (err, fileRes) {
	            var error = err || fileRes.error;
	
	            // handle error and halt execution
	            if (error) return errorHandle(error);
	
	            // execute callback with S3 stored file name
	            if (_this2.props.onS3Res) _this2.props.onS3Res(null, res.text);
	
	            // update state
	            assetRetrievalStateHandler(null, res.text);
	
	            // @TODO handle blob retrieval
	          });
	        }
	      }).catch(function (err) {
	        return errorHandle(err);
	      });
	    }, _this2.assetRetrievalStateHandlerGen = function () {
	      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      return function (err, data) {
	        if (err) {
	          // update loader to failure
	          _this2.setFailure();
	        } else if (data) {
	          // update loader with success, wait a minimum amount of time if specified in order to smooth aesthetic
	          var waitTime = Math.max(0, _this2.props.minLoadTime - +new Date() + startTime);
	          if (waitTime) {
	            setTimeout(_this2.setNotLoading, waitTime);
	          } else {
	            _this2.setNotLoading();
	          }
	        } else {
	          // update loader to failure
	          _this2.setFailure();
	        }
	      };
	    }, _this2.errorHandle = function (assetRetrievalStateHandler, err) {
	      if (_this2.props.onS3Url) _this2.props.onS3Url(err, null);
	      if (_this2.props.onS3Res) _this2.props.onS3Res(err, null);
	      assetRetrievalStateHandler(err, null);
	    }, _this2.updateUrl = function (fileLink, cb) {
	
	      _this2.setState({
	        fileLink: fileLink,
	        loaded: true
	      }, cb);
	    }, _this2.setNotLoaded = function (cb) {
	      if (_this2.state.loaded) {
	        _this2.setState({
	          loaded: false
	        }, cb);
	      } else {
	        cb();
	      }
	    }, _this2.setLoading = function (cb) {
	      if (_this2.state.loadingState !== 'loading') {
	        _this2.setState({
	          loadingState: 'loading'
	        }, cb);
	      } else {
	        cb();
	      }
	    }, _this2.setFailure = function () {
	      if (_this2.state.loadingState !== 'failure') {
	        _this2.setState({
	          loadingState: 'failure'
	        });
	      }
	    }, _this2.setNotLoading = function () {
	      if (_this2.state.loadingState !== 'notLoading') {
	        _this2.setState({
	          loadingState: 'notLoading'
	        });
	      }
	    }, _temp3), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  // asset uploading function
	
	
	  // callback fired when upload completes
	
	
	  _createClass(RetrievalButton, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          style = _props2.style,
	          autoLoad = _props2.autoLoad,
	          noMessage = _props2.noMessage,
	          messageClass = _props2.messageClass,
	          messageStyle = _props2.messageStyle,
	          notLoadingClass = _props2.notLoadingClass,
	          loadingClass = _props2.loadingClass,
	          failureClass = _props2.failureClass,
	          initialLoadState = _props2.initialLoadState,
	          minLoadTime = _props2.minLoadTime,
	          onS3Url = _props2.onS3Url,
	          signingRoute = _props2.signingRoute,
	          otherProps = _objectWithoutProperties(_props2, ['className', 'style', 'autoLoad', 'noMessage', 'messageClass', 'messageStyle', 'notLoadingClass', 'loadingClass', 'failureClass', 'initialLoadState', 'minLoadTime', 'onS3Url', 'signingRoute']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          target: '_blank',
	          className: 'retrieval-button ' + (className || '') + ' ' + this.props[(autoLoad && this.state.loadingState === 'loading' ? 'notLoading' : this.state.loadingState) + 'Class'],
	          style: _extends({}, this.state.loadingState === 'loading' ? {
	            cursor: 'default'
	          } : {
	            cursor: 'pointer'
	          }, {
	            textDecoration: 'none'
	          }, style),
	          onClick: !this.state.loaded && this.onClick,
	          href: this.state.loaded && this.state.fileLink || 'javascript:void(0)' // eslint-disable-line
	        }, otherProps),
	        !noMessage && _react2.default.createElement(
	          'span',
	          {
	            className: 'retrieval-button-message ' + messageClass,
	            style: messageStyle
	          },
	          this.props[this.state.loadingState + 'Message']
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return RetrievalButton;
	}(_react.Component), _class4.propTypes = {
	  // styling
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  messageClass: _react.PropTypes.string,
	  messageStyle: _react.PropTypes.object,
	
	  // loading state classes
	  notLoadingClass: _react.PropTypes.string,
	  loadingClass: _react.PropTypes.string,
	  failureClass: _react.PropTypes.string,
	
	  // loading state messages
	  noMessage: _react.PropTypes.bool,
	  notLoadingMessage: _react.PropTypes.string,
	  successMessage: _react.PropTypes.string,
	  failureMessage: _react.PropTypes.string,
	
	  // initial icon state
	  autoLoad: _react.PropTypes.bool, // loads fileName specified on mount and onchange
	  openOnRetrieve: _react.PropTypes.bool, // determines if file is opened automatically
	  initialLoadState: _react.PropTypes.oneOf(['notLoading', 'loading', '']),
	
	  // helps smooth aesthetic
	  minLoadTime: _react.PropTypes.number,
	
	  // S3 signature getting route
	  signingRoute: _react.PropTypes.string,
	
	  // triggered when loading begins
	  onLoadStart: _react.PropTypes.func,
	  // triggered when s3 url retrieval is done
	  onS3Url: _react.PropTypes.func,
	  // triggered with s3 url get response
	  onS3Res: _react.PropTypes.func,
	  accountId: _react.PropTypes.accountId,
	  path: _react.PropTypes.string
	
	}, _class4.defaultProps = {
	  // 100MB (unit is bytes)
	  maxSize: 100000000,
	
	  // sets minimum amount of time before loader clears
	  minLoadTime: 0,
	
	  // string to append to fileName
	  path: '',
	
	  // default style objects to empty object
	  style: {},
	  inputStyle: {},
	  messageStyle: {},
	
	  // default state-dependent messages
	  notLoadingMessage: '',
	  successMessage: 'Download Success!',
	  failureMessage: 'Download Failed - Please Try Again',
	
	  // default to font awesome class names
	  notLoadingClass: 'fa fa-download',
	  loadingClass: 'fa fa-spinner fa-spin',
	  failureClass: 'fa fa-thumbs-o-down'
	}, _temp4)) || _class3);
	
	
	SimpleFileInput.RetrievalButton = RetrievalButton;
	module.exports = SimpleFileInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(128);
	var core = __webpack_require__(57);
	var ctx = __webpack_require__(322);
	var hide = __webpack_require__(175);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(538);
	var $export = __webpack_require__(7);
	var shared = __webpack_require__(257)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(541))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(44)) {
	  var LIBRARY = __webpack_require__(149);
	  var global = __webpack_require__(29);
	  var fails = __webpack_require__(34);
	  var $export = __webpack_require__(7);
	  var $typed = __webpack_require__(259);
	  var $buffer = __webpack_require__(359);
	  var ctx = __webpack_require__(95);
	  var anInstance = __webpack_require__(147);
	  var propertyDesc = __webpack_require__(152);
	  var hide = __webpack_require__(77);
	  var redefineAll = __webpack_require__(153);
	  var toInteger = __webpack_require__(103);
	  var toLength = __webpack_require__(46);
	  var toIndex = __webpack_require__(536);
	  var toAbsoluteIndex = __webpack_require__(155);
	  var toPrimitive = __webpack_require__(104);
	  var has = __webpack_require__(76);
	  var classof = __webpack_require__(217);
	  var isObject = __webpack_require__(38);
	  var toObject = __webpack_require__(50);
	  var isArrayIter = __webpack_require__(345);
	  var create = __webpack_require__(150);
	  var getPrototypeOf = __webpack_require__(86);
	  var gOPN = __webpack_require__(151).f;
	  var getIterFn = __webpack_require__(361);
	  var uid = __webpack_require__(156);
	  var wks = __webpack_require__(41);
	  var createArrayMethod = __webpack_require__(99);
	  var createArrayIncludes = __webpack_require__(245);
	  var speciesConstructor = __webpack_require__(258);
	  var ArrayIterators = __webpack_require__(362);
	  var Iterators = __webpack_require__(179);
	  var $iterDetect = __webpack_require__(252);
	  var setSpecies = __webpack_require__(154);
	  var arrayFill = __webpack_require__(337);
	  var arrayCopyWithin = __webpack_require__(510);
	  var $DP = __webpack_require__(45);
	  var $GOPD = __webpack_require__(85);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(572);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values and color names.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	
	   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;
	
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(126);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(142);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(486);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(184);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(2772);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(2771);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	/* eslint-disable prefer-spread */
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	 false ? EventListener.propTypes = {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : void 0;
	exports.default = EventListener;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedValue;
	function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
	  if (keepUnprefixed) {
	    return [prefixedValue, value];
	  }
	  return prefixedValue;
	}
	module.exports = exports["default"];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(136);
	
	var emptyFunction = __webpack_require__(65);
	var warning = __webpack_require__(25);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// import classnames utility
	
	
	// js utility functions
	
	
	// import modified component from material UI
	
	
	// import material UI element with slightly modified source code
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_SourceModMenuItem = __webpack_require__(166);
	
	var _c_SourceModMenuItem2 = _interopRequireDefault(_c_SourceModMenuItem);
	
	var _DropDownMenu = __webpack_require__(381);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropdownStyle = {
	  // overflow: 'hidden'
	};
	
	var menuCustomization = {
	  autoWidth: false,
	  menuStyle: {
	    overflowX: 'hidden',
	    width: '100%',
	    backgroundColor: '#fafafa'
	  },
	  labelStyle: {
	    color: 'rgb(33, 35, 38)',
	    maxWidth: '100%',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    fontSize: '16px',
	    height: '48px'
	  },
	  listStyle: {
	    backgroundColor: '#fafafa',
	    fontWeight: 400,
	    width: '100%',
	    color: 'red'
	  },
	  floatingLabelText: {
	    color: 'rgb(33, 35, 38)'
	  },
	  selectedMenuItemStyle: {
	    padding: 0,
	    color: 'rgb(33,35,38)',
	    backgroundColor: '#eee'
	  },
	  popoverStyle: {
	    transition: 'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1), width 1000ms cubic-bezier(0.23, 1, 0.32, 1)'
	  }
	};
	
	var menuItemCustomization = {
	  disableTouchRipple: true,
	  disableFocusRipple: true
	};
	
	var CustomDropDownMenu = (_temp2 = _class = function (_Component) {
	  _inherits(CustomDropDownMenu, _Component);
	
	  function CustomDropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CustomDropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomDropDownMenu.__proto__ || Object.getPrototypeOf(CustomDropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: null,
	      errors: [],
	      dirty: false,
	      primaryText: _this.props.primaryText || _this.props.name || 'Select',
	      subElement: null
	    }, _this.validate = function (value, mergeObj) {
	      if (_this.props.validation) {
	        var errorsObj = {
	          errors: (0, _modelValidator.validateField)(value, _this.props.validation)
	        };
	        if (errorsObj.errors.length !== _this.state.errors.length) {
	          if (_this.props.onErrorChange) {
	            _this.props.onErrorChange(errorsObj.errors.length > _this.state.errors ? 1 : -1);
	          }
	          _this.setState(_lodash2.default.assign({}, _this.state, errorsObj, mergeObj || {}));
	        } else if (_lodash2.default.size(mergeObj)) {
	          _this.setState(_lodash2.default.assign({}, _this.state, mergeObj));
	        }
	      } else if (_lodash2.default.size(mergeObj)) {
	        _this.setState(_lodash2.default.assign({}, _this.state, mergeObj));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CustomDropDownMenu, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : null;
	
	      // used to keep track of mounting state updates
	      var stateUpdateObj = {};
	
	      if (!_lodash2.default.isNil(initVal)) {
	        stateUpdateObj.value = initVal;
	        var currentMenuItem = this.props.menuItems.find(function (menuItem) {
	          return menuItem.value === initVal || menuItem.id === initVal || menuItem === initVal;
	        });
	        if (!currentMenuItem) {
	          console.error('value: ' + initVal + ' does not have corresponding menu item'); /* eslint no-console:0 */
	        } else if (currentMenuItem.subElement) {
	          stateUpdateObj.subElement = currentMenuItem.subElement;
	        }
	      }
	
	      // handles validation state update
	      this.validate(initVal, stateUpdateObj);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // sync local state value
	      if (this.props.value !== nextProps.value) {
	        this.validate(nextProps.value, {
	          value: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event, index, value) {
	      // handle edge case of user re-selecting select
	      var selectWasSelected = value === null;
	
	      // need to take select into account (if they just selected something else but were on select)
	      var selectPreviouslySelected = _lodash2.default.isNil(this.state.value);
	      var adjIndex = selectPreviouslySelected ? index - 1 : index;
	
	      // send primaryText and subElement values to callback too
	      var menuItem = this.props.menuItems[adjIndex] || {};
	      var primaryText = selectWasSelected ? null : menuItem.primaryText || menuItem.name || value;
	      var subElement = selectWasSelected ? null : menuItem.subElement;
	
	      var adjValue = value === 'Yes' ? true : value === 'No' ? false : value;
	
	      function invokeCallbacks() {
	        if (this.props.onChange) {
	          this.props.onChange(event, adjValue, primaryText, subElement);
	        }
	        if (this.props.onBlur) {
	          this.props.onBlur(event, adjValue, primaryText, subElement);
	        }
	      }
	
	      // update local state, invoke callbacks AFTER state is updated
	      if (!this.props.hasOwnProperty('value')) {
	        this.validate(value, {
	          value: value,
	          subElement: subElement
	        });
	        invokeCallbacks.bind(this)();
	      } else {
	        this.setState(_lodash2.default.assign({}, this.state, {
	          value: value,
	          subElement: subElement
	        }), invokeCallbacks);
	      }
	    }
	  }, {
	    key: 'checkErrors',
	    value: function checkErrors() {
	      if (!this.state.dirty) {
	        this.setState({ dirty: true }); // set dirty if not already dirty
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // take out properties that will be overwritten from 'this.props'
	      var canAutoPosition = this.props.canAutoPosition === undefined ? true : this.props.canAutoPosition;
	
	      var _props = this.props,
	          className = _props.className,
	          value = _props.value,
	          defaultValue = _props.defaultValue,
	          onChange = _props.onChange,
	          onBlur = _props.onBlur,
	          style = _props.style,
	          dataId = _props['data-id'],
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          containerStyle = _props.containerStyle,
	          includeDefault = _props.includeDefault,
	          propsMenuItemCustomization = _props.menuItemCustomization,
	          propsSelectedMenuItemStyle = _props.selectedMenuItemStyle,
	          propsListStyle = _props.listStyle,
	          propsMenuStyle = _props.menuStyle,
	          propsLabelStyle = _props.labelStyle,
	          propsIconStyle = _props.iconStyle,
	          unmodifiedProps = _objectWithoutProperties(_props, ['className', 'value', 'defaultValue', 'onChange', 'onBlur', 'style', 'data-id', 'floatingLabelText', 'floatingLabelStyle', 'containerStyle', 'includeDefault', 'menuItemCustomization', 'selectedMenuItemStyle', 'listStyle', 'menuStyle', 'labelStyle', 'iconStyle']);
	
	      var additionalProps = {
	        onChange: this.onChange.bind(this),
	        style: _lodash2.default.merge({}, style, dropdownStyle)
	      };
	
	      if (_lodash2.default.isNil(this.state.value)) {
	        additionalProps.value = null;
	      } else {
	        additionalProps.value = _typeof(this.state.value) !== 'object' ? this.state.value : this.state.value.hasOwnProperty('value') ? this.state.value.value : this.state.value.hasOwnProperty('id') ? this.state.value.id : null;
	      }
	
	      // list style
	      if (propsListStyle) {
	        additionalProps.listStyle = _lodash2.default.merge({}, menuCustomization.listStyle, propsListStyle);
	      }
	
	      // menu style
	      if (propsMenuStyle) {
	        additionalProps.listStyle = _lodash2.default.merge({}, menuCustomization.menuStyle, propsMenuStyle);
	      }
	
	      if (propsSelectedMenuItemStyle) {
	        additionalProps.selectedMenuItemStyle = _lodash2.default.merge({}, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle);
	      }
	
	      additionalProps.iconStyle = {
	        fill: '#161b21'
	      };
	
	      additionalProps.underlineStyle = {
	        borderTop: 'solid 1px #161b21'
	      };
	
	      var redfloatingLabelStyle = {};
	      // if dropdown value is null (displaying 'Select') make text gray
	      if ((this.state.dirty || this.props.isDirty) && this.state.errors.length) {
	        additionalProps.labelStyle = _lodash2.default.merge({}, menuCustomization.labelStyle, propsLabelStyle, {
	          color: 'rgb(244, 67, 54)'
	        });
	        additionalProps.errorText = this.state.errors.join(', ');
	        redfloatingLabelStyle = {
	          color: 'rgb(244, 67, 54)'
	        };
	        additionalProps.iconStyle = {
	          fill: 'rgb(244, 67, 54)'
	        };
	        additionalProps.underlineStyle = {
	          borderTop: 'solid 1px rgb(244, 67, 54)'
	        };
	      } else if (additionalProps.value === null) {
	        additionalProps.labelStyle = _lodash2.default.merge({}, menuCustomization.labelStyle, propsLabelStyle, {
	          color: '#212326',
	          fontWeight: 'normal'
	        });
	      } else if (propsLabelStyle) {
	        additionalProps.labelStyle = _lodash2.default.merge({}, menuCustomization.labelStyle, propsLabelStyle);
	        additionalProps.iconStyle = _lodash2.default.merge({}, menuCustomization.iconStyle, propsIconStyle);
	      }
	
	      if (this.props.iconStyle) {
	        additionalProps.iconStyle = _lodash2.default.merge({}, additionalProps.iconStyle, this.props.iconStyle);
	      }
	
	      if (this.props.underlineStyle) {
	        additionalProps.underlineStyle = _lodash2.default.merge({}, additionalProps.underlineStyle, this.props.underlineStyle);
	      }
	
	      var startWithSelect = !!~[null, ''].indexOf(additionalProps.value);
	      if (startWithSelect) {
	        additionalProps.selectedMenuItemStyle = _lodash2.default.merge(additionalProps.selectedMenuItemStyle, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle || {}, {
	          padding: 0,
	          backgroundColor: '#fafafa',
	          cursor: 'default'
	        });
	      } else if (propsSelectedMenuItemStyle) {
	        additionalProps.selectedMenuItemStyle = _lodash2.default.merge({}, menuCustomization.selectedMenuItemStyle, propsSelectedMenuItemStyle);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('clearfix', 'dropdown-wrapper', className, { disabled: this.props.disabled }), style: containerStyle },
	        floatingLabelText && _react2.default.createElement(
	          'div',
	          { className: 'floatingLabelText', 'data-id': dataId + ' floatingLabelText', style: floatingLabelStyle || redfloatingLabelStyle || {} },
	          floatingLabelText
	        ),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          _extends({ className: 'dropdown',
	            'data-id': dataId,
	            canAutoPosition: canAutoPosition,
	            value: this.state.value || ''
	          }, menuCustomization, unmodifiedProps, additionalProps),
	          _react2.default.createElement(_c_SourceModMenuItem2.default, _extends({ value: '',
	            style: { display: !_lodash2.default.isNil(this.state.value) ? 'none' : 'block' },
	            primaryText: this.props.primaryText,
	            'data-id': this.props.primaryText
	          }, menuItemCustomization, propsMenuItemCustomization)),
	          this.props.menuItems.map(function (val, index) {
	            if (typeof val === 'undefined') {
	              return undefined;
	            }
	            var value = void 0;
	            var primaryText = void 0;
	            var hide = false;
	            if (typeof val === 'string' || typeof val === 'number') {
	              value = primaryText = val;
	            } else if (typeof val === 'boolean') {
	              value = primaryText = val === true ? 'Yes' : 'No';
	            } else {
	              if (val.hasOwnProperty('value') || val.hasOwnProperty('id')) {
	                value = val.hasOwnProperty('value') ? val.value : val.id;
	              }
	              if (val.hasOwnProperty('primaryText') || val.hasOwnProperty('name')) {
	                primaryText = val.hasOwnProperty('primaryText') ? val.primaryText : val.name;
	              }
	              if (val.hasOwnProperty('hide')) {
	                hide = val.hasOwnProperty('hide') ? val.hide : false;
	              }
	            }
	
	            return _react2.default.createElement(_c_SourceModMenuItem2.default, _extends({ value: value,
	              style: { display: hide ? 'none' : 'block' },
	              primaryText: primaryText,
	              key: index,
	              'data-id': primaryText
	            }, menuItemCustomization, propsMenuItemCustomization));
	          })
	        ),
	        this.props.children && this.props.children[this.state.subElement] && _react2.default.createElement(
	          'div',
	          { className: 'subElement-container' },
	          _react.Children.map(this.props.children[this.state.subElement], // adding isSubElement prop to child
	          function (child) {
	            return (0, _react.cloneElement)(child, _lodash2.default.merge({ isSubElement: true }, { containerStyle: { width: '100%' }, style: { width: '100%', margin: '-1px' } }, { containerStyle: child.containerStyle || {}, style: child.containerStyle || {} }));
	          })
	        )
	      );
	    }
	  }]);
	
	  return CustomDropDownMenu;
	}(_react.Component), _class.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  value: _react.PropTypes.any,
	  id: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  validation: _react.PropTypes.object,
	  onErrorChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  menuItems: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  listStyle: _react.PropTypes.object,
	  menuStyle: _react.PropTypes.object,
	  containerStyle: _react.PropTypes.object,
	  errorText: _react.PropTypes.string,
	  floatingLabelText: _react.PropTypes.string,
	  floatingLabelStyle: _react.PropTypes.object,
	  labelStyle: _react.PropTypes.object,
	  iconStyle: _react.PropTypes.object,
	  menuItemCustomization: _react.PropTypes.object,
	  selectedMenuItemStyle: _react.PropTypes.object,
	  'data-id': _react.PropTypes.string,
	  children: _react.PropTypes.object,
	  isSubElement: _react.PropTypes.bool,
	  canAutoPosition: _react.PropTypes.bool,
	  includeDefault: _react.PropTypes.bool,
	  subElement: _react.PropTypes.string,
	  primaryText: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  underlineStyle: _react.PropTypes.object,
	  isDirty: _react.PropTypes.bool
	}, _class.defaultProps = {
	  menuItems: []
	}, _temp2);
	exports.default = CustomDropDownMenu;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = InfoModal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// material
	
	
	// components
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	var flatButtonStyle = {
	  width: '296px',
	  height: '41px',
	  marginRight: '25px'
	};
	
	// utilities
	
	
	var flatButtonLabelStyle = {
	  fontSize: '12px',
	  transform: 'translateY(-.5px)',
	  top: 0
	};
	
	function InfoModal(props) {
	
	  return _react2.default.createElement(
	    _r_Modal2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'transition-block-form' },
	      _react2.default.createElement(
	        'div',
	        null,
	        props.title && _react2.default.createElement(
	          'h1',
	          null,
	          props.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'prompt-text' },
	          props.text,
	          props.children
	        ),
	        _react2.default.createElement(_c_RaisedButton2.default, {
	          label: props.buttonLabel || 'Ok',
	          onClick: props.transitionFunc
	        })
	      ),
	      _react2.default.createElement(_ModalX2.default, { onClick: props.cancelFunc })
	    ),
	    _react2.default.createElement('div', { className: 'rectangle-behind-modal-form absolute-center' })
	  );
	}
	
	InfoModal.propTypes = {
	  transitionFunc: _react.PropTypes.func,
	  cancelFunc: _react.PropTypes.func,
	  text: _react.PropTypes.string,
	  buttonLabel: _react.PropTypes.string,
	  children: _react.PropTypes.object,
	  title: _react.PropTypes.string
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logo = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    account: store.staticData.account,
	    labels: (0, _lodash.get)(store.labels, 'Common', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Logo, _Component);
	
	  function Logo() {
	    _classCallCheck(this, Logo);
	
	    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
	  }
	
	  _createClass(Logo, [{
	    key: 'render',
	    value: function render() {
	
	      var props = this.props;
	      var _props$style = props.style;
	      _props$style = _props$style === undefined ? {} : _props$style;
	      var color = _props$style.color,
	          backgroundColor = _props$style.backgroundColor;
	
	
	      if (props.account && this.props.labels.logo) {
	        return _react2.default.createElement('img', _extends({ src: this.props.labels.logo }, props));
	      }
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({ viewBox: '0 0 276 90', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' }, props),
	        _react2.default.createElement('path', { fill: 'transparent', d: ' M 0.00 0.00 L 276.00 0.00 L 276.00 90.00 L 0.00 90.00 L 0.00 0.00 Z' }),
	        _react2.default.createElement('path', { fill: color || '#2eb0e3', d: ' M 134.10 2.17 C 135.83 2.17 137.55 2.16 139.28 2.16 C 139.28 9.62 139.32 17.07 139.26 24.52 C 141.54 22.03 143.92 19.47 147.06 18.08 C 152.88 15.32 160.61 16.05 165.05 20.98 C 168.61 24.69 169.10 30.10 169.24 34.97 C 169.30 42.45 169.24 49.93 169.25 57.41 C 167.52 57.42 165.80 57.42 164.08 57.43 C 163.99 48.65 164.43 39.84 163.73 31.08 C 163.53 26.64 160.55 22.09 155.90 21.48 C 148.14 19.80 140.28 26.24 139.66 33.99 C 138.92 41.79 139.44 49.64 139.29 57.46 C 137.55 57.46 135.82 57.46 134.09 57.45 C 134.13 39.02 134.11 20.60 134.10 2.17 Z' }),
	        _react2.default.createElement('path', { fill: color || '#2eb0e3', d: ' M 81.01 32.04 C 83.33 22.87 92.48 15.88 102.01 16.50 C 108.13 16.49 113.64 19.96 117.32 24.68 C 117.28 22.30 117.26 19.92 117.24 17.54 C 118.96 17.54 120.68 17.54 122.41 17.54 C 122.39 30.85 122.39 44.15 122.41 57.45 C 120.68 57.46 118.96 57.46 117.24 57.46 C 117.26 55.23 117.28 52.99 117.31 50.76 C 113.39 55.13 107.99 58.43 101.98 58.47 C 94.04 59.03 86.32 54.28 82.71 47.29 C 80.26 42.66 79.80 37.10 81.01 32.04 Z' }),
	        _react2.default.createElement('path', { fill: color || '#2eb0e3', d: ' M 229.71 19.77 C 236.18 15.49 245.10 15.43 251.83 19.16 C 258.52 22.85 262.03 30.38 262.27 37.82 C 250.05 37.91 237.84 37.81 225.62 37.87 C 226.10 42.11 227.28 46.53 230.53 49.53 C 235.60 54.72 244.20 54.87 250.15 51.15 C 252.93 49.53 254.65 46.73 256.49 44.20 C 257.96 44.99 259.43 45.79 260.90 46.59 C 258.23 51.18 254.49 55.43 249.33 57.20 C 242.94 59.33 235.40 59.00 229.64 55.29 C 223.78 51.25 220.16 44.13 220.44 37.01 C 220.51 30.21 224.11 23.60 229.71 19.77 Z' }),
	        _react2.default.createElement('path', { fill: color || '#2eb0e3', d: ' M 13.63 17.54 C 15.44 17.54 17.24 17.54 19.04 17.55 C 23.13 27.17 27.30 36.77 31.32 46.42 C 36.02 36.69 39.78 26.51 44.83 16.95 C 49.44 26.70 53.69 36.62 58.12 46.46 C 62.35 36.83 66.52 27.17 70.73 17.53 C 72.54 17.53 74.36 17.54 76.18 17.55 C 70.05 31.03 64.53 44.79 58.09 58.13 C 53.44 48.50 49.21 38.68 44.81 28.94 C 40.14 38.58 36.33 48.64 31.26 58.08 C 25.22 44.64 19.58 31.02 13.63 17.54 Z' }),
	        _react2.default.createElement('path', { fill: color || '#2eb0e3', d: ' M 176.47 17.55 C 178.34 17.54 180.21 17.54 182.08 17.54 C 186.62 27.20 191.00 36.93 195.66 46.54 C 200.01 36.84 204.53 27.21 208.94 17.54 C 210.83 17.54 212.71 17.54 214.59 17.55 C 208.94 29.58 203.39 41.67 197.83 53.75 C 197.33 54.86 196.58 55.83 195.81 56.78 C 195.57 56.78 195.07 56.78 194.83 56.78 C 188.59 43.76 182.68 30.58 176.47 17.55 Z' }),
	        _react2.default.createElement('path', { fill: backgroundColor || '#ffffff', d: ' M 97.29 22.07 C 106.16 19.22 116.41 25.75 117.42 35.03 C 118.81 42.54 114.27 50.64 106.86 52.85 C 98.98 55.82 89.56 51.20 86.77 43.34 C 83.19 34.95 88.47 24.32 97.29 22.07 Z' }),
	        _react2.default.createElement('path', { fill: backgroundColor || '#ffffff', d: ' M 231.62 24.72 C 237.68 19.74 247.41 20.59 252.75 26.25 C 254.65 28.24 255.51 30.92 256.55 33.40 C 246.42 33.47 236.29 33.47 226.16 33.39 C 227.49 30.25 228.79 26.85 231.62 24.72 Z' }),
	        _react2.default.createElement('path', { fill: color || '#2eb0e3', d: ' M 141.95 61.57 C 166.57 57.53 191.67 57.10 216.52 58.80 C 236.21 60.67 255.79 63.62 275.33 66.66 C 267.10 69.90 258.86 73.11 250.64 76.38 C 235.27 64.55 214.91 62.02 196.09 63.54 C 168.73 64.98 142.50 73.34 116.23 80.42 C 104.72 83.63 93.06 86.68 81.09 87.49 C 74.38 87.96 67.64 88.02 60.92 87.83 C 54.80 87.75 49.13 85.24 43.28 83.79 C 29.10 80.07 14.91 76.37 0.73 72.64 C 24.78 73.37 48.90 73.75 72.90 71.59 C 96.05 69.32 118.99 65.28 141.95 61.57 Z' })
	      );
	    }
	  }]);
	
	  return Logo;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = Logo;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var UserModel = function (_BaseModel) {
	  _inherits(UserModel, _BaseModel);
	
	  function UserModel() {
	    _classCallCheck(this, UserModel);
	
	    return _possibleConstructorReturn(this, (UserModel.__proto__ || Object.getPrototypeOf(UserModel)).call(this, userSchema));
	  }
	
	  _createClass(UserModel, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return userSchema;
	    }
	  }]);
	
	  return UserModel;
	}(BaseModel);
	
	var userSchema = {
	  email: {
	    required: {
	      message: 'This field is required.'
	    },
	    isEmail: {
	      message: 'Must be a valid email.'
	    }
	  },
	  password: {
	    required: {
	      message: 'This field is required.'
	    },
	    matches: {
	      options: /^(?=.*[a-z].*)(?=.*[A-Z].*)(?=.*[0-9].*).{6,}$/,
	      message: 'Must contain: One uppercase, one lowercase, one number, and be at least 6 characters.'
	    }
	  },
	  firstName: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 1, max: 255 },
	      message: 'Max length 255 characters and Min 1 characters'
	    }
	  },
	  lastName: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 1, max: 255 },
	      message: 'Max length 255 characters and Min 1 characters'
	    }
	  },
	  middleName: {
	    isLength: {
	      options: { min: 1, max: 255 },
	      message: 'Max length 255 characters and Min 1 characters'
	    }
	  },
	  nickName: {
	    isLength: {
	      options: { min: 1, max: 255 },
	      message: 'Max length 255 characters and Min 1 characters'
	    }
	  },
	  phoneNumber: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    },
	    matches: {
	      options: /^[2-9]\d{9}$/,
	      message: 'Must be a valid phone number.'
	    }
	  },
	  phoneExtension1: {},
	  phoneNumber1: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    },
	    matches: {
	      options: /^[2-9]\d{9}$/,
	      message: 'Must be a valid phone number.'
	    }
	  },
	  phoneType1: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  phoneNumber2: {
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    },
	    matches: {
	      options: /^[2-9]\d{9}$/,
	      message: 'Must be a valid phone number.'
	    }
	  },
	  phoneType2: {},
	  phoneExtension2: {},
	  phoneNumber3: {
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    },
	    matches: {
	      options: /^[2-9]\d{9}$/,
	      message: 'Must be a valid phone number.'
	    }
	  },
	  phoneType3: {},
	  country: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  address: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  city: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  state: {},
	  timezone: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  zip: {},
	  bestContactTime: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  title: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  department: {},
	  foundUsVia: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  foundUsOther: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = UserModel;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SubmissionBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SubmissionBar(props) {
	  var onNext = props.onNext,
	      onSave = props.onSave,
	      onBack = props.onBack,
	      errors = props.errors,
	      showError = props.showError,
	      hideBack = props.hideBack,
	      finalStep = props.finalStep,
	      submitDisabled = props.submitDisabled;
	
	
	  return _react2.default.createElement(
	    'ul',
	    { className: 'submission-bar' },
	    onBack && _react2.default.createElement(
	      'li',
	      { className: 'submission-bar-item button',
	        'data-id': 'Back',
	        onClick: onBack },
	      'Back'
	    ),
	    !(0, _lodash.isEmpty)(errors) && showError && _react2.default.createElement(
	      'li',
	      { className: 'submission-bar-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'error-message' },
	        errors.join(' ')
	      )
	    ),
	    !hideBack && _react2.default.createElement(
	      'li',
	      {
	        className: 'submission-bar-item right button',
	        'data-id': 'Save',
	        onClick: onSave },
	      'Save'
	    ),
	    _react2.default.createElement(
	      'li',
	      { className: 'submission-bar-item' },
	      _react2.default.createElement(_Button2.default, {
	        'data-id': 'Next',
	        className: 'button-main-large',
	        disabled: submitDisabled,
	        onClick: onNext,
	        label: finalStep ? 'Submit' : 'Next'
	      })
	    )
	  );
	}
	
	SubmissionBar.propTypes = {
	  onNext: _react.PropTypes.func.isRequired,
	  onSave: _react.PropTypes.func.isRequired,
	  onBack: _react.PropTypes.func,
	  errors: _react.PropTypes.array,
	  showError: _react.PropTypes.bool,
	  submitDisabled: _react.PropTypes.bool
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(488);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1186);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(172);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(40);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ }),
/* 128 */
29,
/* 129 */
[3141, 143, 498, 333, 144],
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(41)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(77)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 131 */
[3138, 156, 38, 76, 45, 34],
/* 132 */
[3148, 528, 341],
/* 133 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(614);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(1595);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(1736);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	var _iOSHelpers = __webpack_require__(2744);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function (event) {
	      event.preventDefault();
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.refs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.refs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
	      targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open === this.props.open) {
	        return;
	      }
	
	      if (nextProps.open) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	        this.setState({
	          open: true,
	          closing: false
	        });
	      } else {
	        if (nextProps.animated) {
	          if (this.timeout !== null) return;
	          this.setState({ closing: true });
	          this.timeout = setTimeout(function () {
	            _this2.setState({
	              open: false
	            }, function () {
	              _this2.timeout = null;
	            });
	          }, 500);
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	
	      // The fixed positioning isn't respected on iOS when an input is focused.
	      // We need to compute the position from the top of the page and not the viewport.
	      if ((0, _iOSHelpers.isIOS)() && document.activeElement.tagName === 'INPUT') {
	        a.bottom = (0, _iOSHelpers.getOffsetTop)(el) + a.height;
	      } else {
	        a.bottom = rect.bottom || a.top + a.height;
	      }
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: 'layer',
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Popover.propTypes = {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _react.PropTypes.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _react.PropTypes.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _react.PropTypes.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _react.PropTypes.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = Popover;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	// import cx from 'classnames';
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressComponentList = (_temp = _class = function (_ProgressComponent) {
	  _inherits(ProgressComponentList, _ProgressComponent);
	
	  function ProgressComponentList(props, context) {
	    _classCallCheck(this, ProgressComponentList);
	
	    // increment through alphabet
	    var _this = _possibleConstructorReturn(this, (ProgressComponentList.__proto__ || Object.getPrototypeOf(ProgressComponentList)).call(this, props, context));
	
	    _this.addListItem = function (cb) {
	      var clientId = '' + _this.getIncrementedChar() + _shortid2.default.generate();
	      _this.updateTempState(_this.props.model, clientId, null, {
	        clientId: clientId,
	        isNew: true
	      });
	      if (cb) {
	        cb(clientId);
	      }
	    };
	
	    _this.removeListItem = function (clientId) {
	      if (_lodash2.default.get(_this.props.tempState, _this.props.model + '.' + clientId)) {
	        // will remove property from tempState
	        _this.updateTempState(_this.props.model, clientId, null, undefined);
	      }
	      if (_this.props[_this.props.model][clientId]) {
	        _this.updateTempState(_this.props.model, clientId, null, Symbol.for('__delete'));
	      }
	    };
	
	    _this.handleTextFieldUI = function (clientId, prop, label) {
	      var propPath = [clientId, prop];
	      var tempStatePropPath = [_this.props.model].concat(propPath);
	
	      return {
	        value: _lodash2.default.get(_this.props.tempState, tempStatePropPath, _lodash2.default.get(_this.props[_this.props.model], propPath, '')),
	        floatingLabelText: label,
	        validation: _this.props.validation[prop],
	        onErrorChange: _this.props.errorUpdate,
	        onChange: _this.onChange.bind(_this, clientId, prop)
	      };
	    };
	
	    _this.handleDatePickerUI = function (clientId, prop, label) {
	      var handlerObj = _this.handleTextFieldUI(clientId, prop, label);
	
	      // defult to null instead of string for DatePicker element
	      handlerObj.value = handlerObj.value === '' ? null : handlerObj.value;
	
	      return handlerObj;
	    };
	
	    _this.handleDropDownMenuUI = function (clientId, prop, staticData, label) {
	      var propPath = [clientId, prop];
	      var tempStatePropPath = [_this.props.model].concat(propPath);
	
	      return {
	        value: _lodash2.default.get(_this.props.tempState, tempStatePropPath, _lodash2.default.get(_this.props[_this.props.model], propPath, null)),
	        menuItems: typeof staticData === 'string' ? _this.props.staticData[staticData] : staticData,
	        floatingLabelText: label,
	        validation: _this.props.validation[prop],
	        onErrorChange: _this.props.errorUpdate,
	        onChange: _this.onChange.bind(_this, clientId, prop)
	      };
	    };
	
	    _this.getList = function (atLeastOne, orderByProps, orderByOrder) {
	      var list = (0, _lodash2.default)({}).merge(_this.props[_this.props.model]).filter(function (val, prop) {
	        return _lodash2.default.get(_this.props.tempState, [_this.props.model, prop]) !== Symbol.for('__delete');
	      }).orderBy(orderByProps, orderByOrder).concat( // concatenate work experiences currently getting added and sort them by their clientId (which will be alphabetical based on when they were created)
	      (0, _lodash2.default)(_this.props.tempState[_this.props.model]).pickBy(function (value) {
	        return value.isNew;
	      }).orderBy(['clientId'], ['asc']).value()).value();
	
	      var clientId = '' + _this.getIncrementedChar() + _shortid2.default.generate();
	
	      if (atLeastOne && _lodash2.default.isEmpty(list)) {
	        list.push({
	          clientId: clientId,
	          isNew: true
	        });
	      }
	
	      return list;
	    };
	
	    var inc = 65; // charcode for 'A'
	    _this.getIncrementedChar = function () {
	      return String.fromCharCode(inc++);
	    };
	    return _this;
	  }
	
	  _createClass(ProgressComponentList, [{
	    key: 'onChange',
	    value: function onChange(clientId, prop, event, value) {
	      if (!clientId) {
	        return console.log('need to supply clientId String!');
	      }
	
	      this.setState({ showErrors: false });
	
	      // if id exists on tempstate or model, this is an update, otherwise it's a create
	      if (this.props[this.props.model][clientId] || _lodash2.default.get(this.props.tempState, [this.props.model, clientId])) {
	        this.updateTempState(this.props.model, clientId + '.' + prop, event, value);
	      } else {
	        this.updateTempState(this.props.model, '' + clientId, event, _defineProperty({
	          isNew: true,
	          clientId: clientId
	        }, prop, value));
	      }
	    }
	  }]);
	
	  return ProgressComponentList;
	}(_C_ProgressComponent2.default), _class.propTypes = {
	  profileId: _react.PropTypes.number.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = ProgressComponentList;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Modal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Modal(props) {
	
	  var onClickOut = function onClickOut(event) {
	    return props.onClickOut && props.onClickOut(event);
	  };
	  var onClickIn = function onClickIn(event) {
	    return event.stopPropagation();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'modal-component',
	      'data-id': 'Modal',
	      onClick: onClickOut },
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-content-wrapper',
	        onClick: onClickIn },
	      _react2.default.createElement(
	        'div',
	        { className: 'modal-content' },
	        props.children
	      ),
	      _react2.default.createElement('div', { className: 'rectangle-behind-modal' })
	    )
	  );
	}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1272), __esModule: true };

/***/ }),
/* 143 */
[3118, 176],
/* 144 */
[3123, 174],
/* 145 */
76,
/* 146 */
[3156, 499, 323],
/* 147 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(95);
	var call = __webpack_require__(520);
	var isArrayIter = __webpack_require__(345);
	var anObject = __webpack_require__(27);
	var toLength = __webpack_require__(46);
	var getIterFn = __webpack_require__(361);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 150 */
[3140, 27, 526, 341, 353, 340, 343],
/* 151 */
[3145, 528, 341],
/* 152 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(78);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(29);
	var dP = __webpack_require__(45);
	var DESCRIPTORS = __webpack_require__(44);
	var SPECIES = __webpack_require__(41)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 155 */
[3155, 103],
/* 156 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1617),
	    getValue = __webpack_require__(1640);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(1762);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(184);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is 'retrieve the property 'Component' off of the object exported from the 'react'
	
	
	// helper functions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _querystring = __webpack_require__(105);
	
	var _SearchIcon = __webpack_require__(167);
	
	var _SearchIcon2 = _interopRequireDefault(_SearchIcon);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = (_dec = (0, _reactRedux.connect)(function (store) {
	  var searchQuery = store.routing.locationBeforeTransitions.query.search;
	  var search = searchQuery && [].concat(searchQuery) || [];
	  return { search: search };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props, context) {
	    _classCallCheck(this, Search);
	
	    // asyncActionCreator.search(this.state.searchTags.concat(str))
	    // only run search when there's 50 ms of no other running's of search
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));
	
	    _this.state = {
	      searchTags: []
	    };
	    _this.search = function () {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      // default to empty array
	      _this.props.dispatch((0, _reactRouterRedux.push)(_this.props.baseUrl + '/' + (arr.length ? '?' + (0, _querystring.stringify)({ search: arr }) : '')));
	      _this.props.onTermChange(arr);
	    };
	    _this.debouncedSearch = _lodash2.default.debounce(_this.search, 200);
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var terms = _lodash2.default.isEmpty(this.props.search) ? this.props.defaultValues === undefined ? [] : this.props.defaultValues : this.props.search;
	      this.setState(function () {
	        return { searchTags: terms };
	      }, function () {
	        _this2.debouncedSearch(terms);
	      });
	    }
	  }, {
	    key: 'inputKeyEvents',
	    value: function inputKeyEvents(e) {
	      var _this3 = this;
	
	      if (e.key === 'Enter' || e.key === ' ') {
	        // Enter pressed
	        if (e.target.value.trim()) {
	          // test if input is empty
	
	          var targetValue = e.target.value.trim();
	          this.setState(function (prevState) {
	            var updatedSearch = prevState.searchTags.concat(targetValue);
	            _this3.search(updatedSearch);
	            return { // add tag
	              searchTags: updatedSearch // remove whitespace at the beginning and end of string
	            };
	          }, function () {
	            _this3.refs.search.value = '';
	          });
	        }
	      }
	      if (!e.target.value && this.state.searchTags.length && e.key === 'Backspace') {
	        // Backspace pressed
	        this.removeTag(this.state.searchTags.length - 1);
	      }
	    }
	  }, {
	    key: 'removeTag',
	    value: function removeTag(removalIndex) {
	      var _this4 = this;
	
	      this.setState(function (prevState) {
	        var updatedSearch = prevState.searchTags.filter(function (val, index) {
	          return index !== removalIndex;
	        });
	        _this4.debouncedSearch(updatedSearch);
	        return {
	          searchTags: updatedSearch
	        };
	      });
	    }
	  }, {
	    key: 'searchOnChange',
	    value: function searchOnChange(e) {
	      if (e.target.value.trim().length > 2 || e.key === 'Backspace') {
	        this.debouncedSearch(this.state.searchTags.concat(e.target.value.trim()));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search' },
	        _react2.default.createElement(
	          'div',
	          { className: 'search-input-container' },
	          _react2.default.createElement(_SearchIcon2.default, null),
	          this.state.searchTags.map(function (val, index) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'search-tag', key: index },
	              val,
	              _react2.default.createElement('span', { className: 'close-icon', onClick: _this5.removeTag.bind(_this5, index) })
	            );
	          }),
	          _react2.default.createElement('input', { 'data-id': 'Search',
	            ref: 'search',
	            className: 'search-input',
	            type: 'text',
	            placeholder: this.props.placeHolder,
	            onKeyDown: this.inputKeyEvents.bind(this) })
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  location: _react.PropTypes.object,
	  search: _react.PropTypes.array,
	  onTermChange: _react.PropTypes.func,
	  defaultValues: _react.PropTypes.array,
	  baseUrl: _react.PropTypes.string,
	  placeHolder: _react.PropTypes.string
	}, _class2.defaultProps = {
	  placeHolder: 'Search...'
	}, _temp)) || _class);
	exports.default = Search;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(2963);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _ListItem = __webpack_require__(273);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(187);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'pre-wrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren ? indent : sidePadding,
	      paddingRight: props.checked ? indent : 34,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = (_temp2 = _class = function (_Component) {
	  _inherits(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onTouchTap: function onTouchTap(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onTouchTap) {
	            item.props.onTouchTap(event);
	          }
	        },
	        onRequestClose: _this.handleRequestClose
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkBox = _props.checkBox,
	          checkMark = _props.checkMark,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          value = _props.value,
	          other = _objectWithoutProperties(_props, ['checkBox', 'checkMark', 'checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'value']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = Object.assign(styles.root, style);
	      var mergedInnerDivStyles = Object.assign(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checkMark ? _react2.default.createElement('div', { style: {
	          width: '17.1px',
	          height: '18px',
	          margin: '6px 12px 6px 0'
	        }, className: 'checkMark ' + (checked ? 'checked' : '') }) : null;
	
	      if (leftIconElement && desktop) {
	        var mergedLeftIconStyles = Object.assign(styles.leftIconDesktop, leftIconElement.props.style);
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = rightIcon ? rightIcon : checkBox ? _react2.default.createElement('div', { style: {
	          width: '17.1px',
	          height: '18px',
	          margin: '6px 12px 6px 0',
	          borderRadius: '2px',
	          border: '2px solid #4a4a4a'
	        }, className: 'checkBox ' + (checked ? 'checked' : '') }) : null;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? Object.assign(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? Object.assign(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: { horizontal: 'right', vertical: 'top' },
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onTouchTap = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        _extends({}, other, {
	          disabled: disabled,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react.Component), _class.muiName = 'MenuItem', _class.propTypes = {
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _react.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _react.PropTypes.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the menu item.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * Whether or not you show checkbox
	   */
	  checkBox: _react.PropTypes.bool,
	  /**
	   * Whether or not you show checkmark
	   */
	  checkMark: _react.PropTypes.bool
	}, _class.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	}, _class.defaultProps = {
	  checkBox: false,
	  checkMark: false,
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false
	}, _temp2);
	exports.default = MenuItem;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function SearchIcon(props) {
	  var className = props.className,
	      otherProps = _objectWithoutProperties(props, ['className']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({ width: '19px', height: '18px', viewBox: '0 0 19 18', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', className: 'search-svg-icon ' + className }, otherProps),
	    _react2.default.createElement(
	      'g',
	      { id: '2048---Search-Update', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement(
	        'g',
	        { id: '2048---Search-Update-1', transform: 'translate(-103.000000, -28.000000)', fill: '#151921' },
	        _react2.default.createElement(
	          'g',
	          { id: 'Dash*', transform: 'translate(102.000000, -1.000000)' },
	          _react2.default.createElement(
	            'g',
	            { id: 'Group-7' },
	            _react2.default.createElement('path', { d: 'M14.6759414,31.3161415 C11.5518436,28.2279528 6.46823971,28.2279528 3.3430734,31.3161415 C0.218975532,34.4053864 0.218975532,39.430558 3.3430734,42.5187467 C5.97889743,45.1232177 10.0026158,45.5224432 13.073292,43.7343778 L17.6985382,47 L19.2093023,45.5055448 L15.9057077,40.9345186 C17.7156331,37.8991375 17.310697,33.9216687 14.6759414,31.3161415 L14.6759414,31.3161415 Z M13.1651773,41.0253477 C10.8744571,43.2897377 7.14562618,43.2897377 4.85490599,41.0253477 C2.5641858,38.7609576 2.5641858,35.0749868 4.85490599,32.8105967 C7.14562618,30.5462067 10.8744571,30.5462067 13.1651773,32.8105967 C15.4569659,35.0749868 15.4569659,38.7609576 13.1651773,41.0253477 L13.1651773,41.0253477 Z', id: 'Icons/Search' })
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = SearchIcon;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapFormFields = mapFormFields;
	exports.mapField = mapField;
	exports.updateFormFields = updateFormFields;
	exports.reduceToValues = reduceToValues;
	exports.fieldsHasErrors = fieldsHasErrors;
	exports.validateForm = validateForm;
	exports.formFieldProperties = formFieldProperties;
	exports.markForDeletion = markForDeletion;
	
	var _lodash = __webpack_require__(4);
	
	var _modelValidator = __webpack_require__(33);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var message = 'This is a required field.';
	var required = {
	  message: message
	};
	
	// Helper functions
	/*
	 * Converts { name: 'al', description: 'awesome' }
	 * To { name: { defaultValue: 'al', required: true}, description : { defaultValue: 'awesome' } }
	 */
	function mapFormFields(model) {
	  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var optionals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return [].concat(_toConsumableArray(required), _toConsumableArray(optionals)).reduce(function (target, field) {
	    return mapField(target, model, field, ~required.indexOf(field));
	  }, {});
	}
	
	function mapField(target, source, field) {
	  var isRequired = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (isRequired) {
	    (0, _lodash.set)(target, field + '.required', required);
	  }
	  (0, _lodash.set)(target, field + '.value', (0, _lodash.get)(source, field));
	  return (0, _lodash.set)(target, field + '.defaultValue', (0, _lodash.get)(source, field));
	}
	
	function updateFormFields(model, prop, newValue) {
	  var reverted = (0, _lodash.get)(model, prop + '.defaultValue') === newValue;
	  (0, _lodash.set)(model, prop + '.value', reverted ? undefined : newValue);
	  (0, _lodash.set)(model, prop + '.errors', reverted ? null : (0, _modelValidator.validateFormField)(prop, model));
	  //return model;
	}
	
	/*
	 * Converts { name: { required: true, value: 'al', defaultValue: 'a', errors: [] } }
	 * To { name: 'al' }
	 */
	function reduceToValues(model) {
	  return (0, _lodash.reduce)(model, function (obj, prop, name) {
	    return !(0, _lodash.isUndefined)((0, _lodash.get)(prop, 'value')) ? (0, _lodash.set)(obj, name, (0, _lodash.get)(prop, 'value')) : obj;
	  }, {});
	}
	
	function fieldsHasErrors(model) {
	  return (0, _lodash.reduce)(model, function (hasErrors, obj, prop) {
	    return (0, _lodash.get)(model, prop + '.errors.length', false) || hasErrors;
	  }, false);
	}
	
	function validateForm(form, fields) {
	  (0, _lodash.forEach)(form, function (prop, key) {
	    if (fields.required.includes(key) && (0, _lodash.isNil)(prop.defaultValue) && (0, _lodash.isNil)(prop.value)) {
	      updateFormFields(form, key, prop.value);
	    }
	  });
	}
	
	function formFieldProperties(model, prop, label) {
	  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	      onChange = _ref.onChange,
	      onBlur = _ref.onBlur;
	
	  var field = (0, _lodash.get)(model, '' + prop, {});
	
	  return {
	    'data-id': '' + model + prop,
	    defaultValue: field.defaultValue,
	    floatingLabelText: label,
	    errorText: field.required ? (0, _lodash.get)(field, 'errors[0]') : undefined,
	    onChange: onChange,
	    onBlur: onBlur
	  };
	}
	
	function markForDeletion(model, prop) {
	  (0, _lodash.set)(model, prop + '.deleted', Symbol.for('_deleted_'));
	}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.parentChildList = parentChildList;
	
	var _lodash = __webpack_require__(4);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	    How to use it:
	
	    import {parentChildList} from  '../../../../../../lib/parentChildList';
	
	    ...
	
	    constructor() {
	        this.parentChildHandlers = parentChildList();
	    }
	
	    render() {
	
	        const {parent: industryTypeProps, child: segmentTypeProps} = this.parentChildHandlers({
	            parentProps: this.handleUIDropdown(...),
	            childProps: this.handleUIDropdown(...),
	        });
	
	        <DropDownMenu {...industryTypeProps} />
	        <DropDownMenu {...segmentTypeProps} />
	
	        ...
	    }
	
	    ...
	
	*/
	function parentChildList() {
	    var defaultToValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	
	    var currentOption = void 0;
	
	    return function (_ref) {
	        var parentProps = _ref.parentProps,
	            childProps = _ref.childProps;
	
	
	        function parent() {
	            var _onChange = parentProps.onChange,
	                _onBlur = parentProps.onBlur,
	                value = parentProps.value,
	                defaultValue = parentProps.defaultValue,
	                othersParentProps = _objectWithoutProperties(parentProps, ['onChange', 'onBlur', 'value', 'defaultValue']);
	
	            if (defaultToValue) {
	                currentOption = value || defaultValue;
	            }
	
	            return _extends({}, othersParentProps, {
	                value: value,
	                defaultValue: defaultValue,
	                onChange: function onChange(event, value, primaryText) {
	                    if (_onChange) {
	                        currentOption = value;
	                        setTimeout(function () {
	                            return resetChildValue(event);
	                        }, 300);
	                        return _onChange(event, value, primaryText);
	                    }
	                },
	                onBlur: function onBlur(event, value, primaryText) {
	                    if (_onBlur) {
	                        currentOption = value;
	                        setTimeout(function () {
	                            return resetChildValue(event);
	                        }, 300);
	                        return _onBlur(event, value, primaryText);
	                    }
	                }
	            });
	        }
	
	        function resetChildValue(event) {
	            var onChange = childProps.onChange,
	                onBlur = childProps.onBlur;
	
	
	            if (onChange) {
	                onChange(event, undefined);
	            }
	
	            if (onBlur) {
	                onBlur(event, undefined);
	            }
	        }
	
	        function child() {
	            var menuItems = childProps.menuItems,
	                otherChildProps = _objectWithoutProperties(childProps, ['menuItems']);
	
	            return _extends({}, otherChildProps, {
	                menuItems: (0, _lodash.filter)(menuItems, function (item) {
	
	                    if ((0, _lodash.isArray)(currentOption)) {
	                        return currentOption.includes(item.parentId) || !item.parentId;
	                    }
	
	                    return currentOption === item.parentId || !item.parentId;
	                })
	            });
	        }
	
	        return {
	            parent: parent(),
	            child: child()
	        };
	    };
	}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDataType = getDataType;
	exports.referralsByRole = referralsByRole;
	
	var _configureStore = __webpack_require__(319);
	
	var _lodash = __webpack_require__(4);
	
	function getDataType(name) {
	  var _getState = (0, _configureStore.getState)(),
	      staticData = _getState.staticData;
	
	  return staticData[name];
	}
	
	/**
	 * referralsByRole - Filters referral sources by the desc property
	 *
	 * @param  {array} foundUsViaList A list of referral types
	 * @param  {string} role          A for applicant, C for contact
	 * @return {array}                Array of referral types filtered by role
	 */
	function referralsByRole() {
	  var foundUsViaList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'A';
	
	  if ((0, _lodash.isEmpty)(foundUsViaList)) {
	    return foundUsViaList;
	  }
	  if ((0, _lodash.isNil)(role) || !['A', 'C'].includes(role)) {
	    role = 'A';
	  }
	
	  return foundUsViaList.filter(function (ref) {
	    return [null, role].includes(ref.desc);
	  });
	}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(1245)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 174 */
34,
/* 175 */
[3126, 129, 215, 144],
/* 176 */
38,
/* 177 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 178 */
[3148, 505, 324],
/* 179 */
177,
/* 180 */
[3151, 45, 76, 41],
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var defined = __webpack_require__(101);
	var fails = __webpack_require__(34);
	var spaces = __webpack_require__(357);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(38);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(1532);
	var hasBinary = __webpack_require__(551);
	var sliceBuffer = __webpack_require__(849);
	var after = __webpack_require__(848);
	var utf8 = __webpack_require__(3114);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(1226);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(1228);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221),
	    getRawTag = __webpack_require__(1637),
	    objectToString = __webpack_require__(1665);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dateTimeFormat = dateTimeFormat;
	exports.addDays = addDays;
	exports.addMonths = addMonths;
	exports.addYears = addYears;
	exports.cloneDate = cloneDate;
	exports.cloneAsDate = cloneAsDate;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getWeekArray = getWeekArray;
	exports.localizedWeekday = localizedWeekday;
	exports.formatIso = formatIso;
	exports.isEqualDate = isEqualDate;
	exports.isBeforeDate = isBeforeDate;
	exports.isAfterDate = isAfterDate;
	exports.isBetweenDates = isBetweenDates;
	exports.monthDiff = monthDiff;
	exports.yearDiff = yearDiff;
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function dateTimeFormat(locale, options) {
	   false ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;
	
	  this.format = function (date) {
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
	    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
	      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	    } else if (options.year === 'numeric' && options.month === 'long') {
	      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      return dayAbbreviation[date.getDay()];
	    } else if (options.year === 'numeric') {
	      return date.getFullYear().toString();
	    } else if (options.day === 'numeric') {
	      return date.getDate();
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
	    }
	  };
	}
	
	function addDays(d, days) {
	  var newDate = cloneDate(d);
	  newDate.setDate(d.getDate() + days);
	  return newDate;
	}
	
	function addMonths(d, months) {
	  var newDate = cloneDate(d);
	  newDate.setMonth(d.getMonth() + months);
	  return newDate;
	}
	
	function addYears(d, years) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(d.getFullYear() + years);
	  return newDate;
	}
	
	function cloneDate(d) {
	  return new Date(d.getTime());
	}
	
	function cloneAsDate(d) {
	  var clonedDate = cloneDate(d);
	  clonedDate.setHours(0, 0, 0, 0);
	  return clonedDate;
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	
	function getFirstDayOfWeek() {
	  var now = new Date();
	  return new Date(now.setDate(now.getDate() - now.getDay()));
	}
	
	function getWeekArray(d, firstDayOfWeek) {
	  var dayArray = [];
	  var daysInMonth = getDaysInMonth(d);
	  var weekArray = [];
	  var week = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	  }
	
	  var addWeek = function addWeek(week) {
	    var emptyDays = 7 - week.length;
	    for (var _i = 0; _i < emptyDays; ++_i) {
	      week[weekArray.length ? 'push' : 'unshift'](null);
	    }
	    weekArray.push(week);
	  };
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      addWeek(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      addWeek(week);
	    }
	  });
	
	  return weekArray;
	}
	
	function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	  var firstDayDate = getFirstDayOfWeek();
	
	  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
	}
	
	// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
	function formatIso(date) {
	  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
	}
	
	function isEqualDate(d1, d2) {
	  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	
	function isBeforeDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() < date2.getTime();
	}
	
	function isAfterDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() > date2.getTime();
	}
	
	function isBetweenDates(dateToCheck, startDate, endDate) {
	  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
	}
	
	function monthDiff(d1, d2) {
	  var m = void 0;
	  m = (d1.getFullYear() - d2.getFullYear()) * 12;
	  m += d1.getMonth();
	  m -= d2.getMonth();
	  return m;
	}
	
	function yearDiff(d1, d2) {
	  return ~~(monthDiff(d1, d2) / 12);
	}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(490);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(161);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(388);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(383);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(1734);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div bacause the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	      var selectedIndex = this.getSelectedIndex(nextProps, filteredChildren);
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var childIsDisabled = child.props.disabled;
	
	      var selectedChildStyles = {};
	      if (!childIsDisabled) {
	        var selected = this.isChildSelected(child, this.props);
	
	        if (selected) {
	          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
	        }
	      }
	      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);
	
	      var extraProps = {
	        desktop: this.props.desktop,
	        style: mergedChildStyles
	      };
	      if (!childIsDisabled) {
	        var isFocused = childIndex === this.state.focusIndex;
	        var focusState = 'none';
	        if (isFocused) {
	          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	        }
	
	        (0, _simpleAssign2.default)(extraProps, {
	          focusState: focusState,
	          onTouchTap: function onTouchTap(event) {
	            _this2.handleMenuItemTouchTap(event, child, index);
	            if (child.props.onTouchTap) child.props.onTouchTap(event);
	          },
	          ref: isFocused ? 'focusedMenuItem' : null
	        });
	      }
	      return _react2.default.cloneElement(child, extraProps);
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && new RegExp('^' + keys, 'i').test(primaryText)) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        menuValue = menuValue || [];
	
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = menuValue,
	            _menuValue2 = (0, _toArray3.default)(_menuValue),
	            newMenuValue = _menuValue2.slice(0);
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          desktop = _props.desktop,
	          disableAutoFocus = _props.disableAutoFocus,
	          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          multiple = _props.multiple,
	          onItemTouchTap = _props.onItemTouchTap,
	          onEscKeyDown = _props.onEscKeyDown,
	          onMenuItemFocusChange = _props.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          menuItemStyle = _props.menuItemStyle,
	          style = _props.style,
	          value = _props.value,
	          valueLink = _props.valueLink,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	 false ? Menu.propTypes = {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _react.PropTypes.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _react.PropTypes.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes2.default.stringOrNumber
	} : void 0;
	exports.default = Menu;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createChildFragment = createChildFragment;
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(2765);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createChildFragment(fragments) {
	  var newFragments = {};
	  var validChildrenCount = 0;
	  var firstKey = void 0;
	
	  // Only create non-empty key fragments
	  for (var key in fragments) {
	    var currentChild = fragments[key];
	
	    if (currentChild) {
	      if (validChildrenCount === 0) firstKey = key;
	      newFragments[key] = currentChild;
	      validChildrenCount++;
	    }
	  }
	
	  if (validChildrenCount === 0) return undefined;
	  if (validChildrenCount === 1) return newFragments[firstKey];
	  return (0, _reactAddonsCreateFragment2.default)(newFragments);
	}
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactCurrentOwner = __webpack_require__(780);
	
	var warning = __webpack_require__(25);
	var canDefineProperty = __webpack_require__(783);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(781);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(411);
	var setInnerHTML = __webpack_require__(291);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(425);
	var setTextContent = __webpack_require__(814);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(22);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var EventPluginRegistry = __webpack_require__(412);
	var EventPluginUtils = __webpack_require__(287);
	var ReactErrorUtils = __webpack_require__(418);
	
	var accumulateInto = __webpack_require__(805);
	var forEachAccumulated = __webpack_require__(807);
	var invariant = __webpack_require__(22);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(107);
	var EventPluginHub = __webpack_require__(194);
	var EventPluginUtils = __webpack_require__(287);
	
	var accumulateInto = __webpack_require__(805);
	var forEachAccumulated = __webpack_require__(807);
	var warning = __webpack_require__(25);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(2936);
	var ReactInstrumentation = __webpack_require__(82);
	
	var warning = __webpack_require__(25);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'mountComponent');
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'mountComponent');
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(120);
	
	var getEventTarget = __webpack_require__(428);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getLuma = __webpack_require__(896);
	
	var _getLuma2 = _interopRequireDefault(_getLuma);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatusDropDown = (_temp = _class = function (_Component) {
	  _inherits(StatusDropDown, _Component);
	
	  function StatusDropDown() {
	    _classCallCheck(this, StatusDropDown);
	
	    return _possibleConstructorReturn(this, (StatusDropDown.__proto__ || Object.getPrototypeOf(StatusDropDown)).apply(this, arguments));
	  }
	
	  _createClass(StatusDropDown, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          status = _props.status,
	          menuItems = _props.menuItems,
	          onChange = _props.onChange,
	          smallDisplay = _props.smallDisplay;
	
	
	      var statusTextColor = (0, _getLuma2.default)(status.color) > 160 ? 'black' : 'white';
	
	      return _react2.default.createElement(
	        'div',
	        { className: smallDisplay ? 'status-dropdown-small' : 'status-dropdown' },
	        smallDisplay && _react2.default.createElement('div', { className: 'status-circle', 'data-id': 'Status Icon', style: { backgroundColor: status.color, borderColor: status.color } }),
	        _react2.default.createElement(_c_DropDownMenu2.default, { style: !smallDisplay && { backgroundColor: status.color },
	          'data-id': 'Status Dropdown',
	          value: status.id,
	          staticValue: status.id,
	          menuItems: menuItems,
	          onChange: onChange,
	          labelStyle: !smallDisplay && { color: statusTextColor },
	          iconStyle: !smallDisplay && { fill: statusTextColor }
	        })
	      );
	    }
	  }]);
	
	  return StatusDropDown;
	}(_react.Component), _class.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  status: _react.PropTypes.object,
	  smallDisplay: _react.PropTypes.bool,
	  menuItems: _react.PropTypes.array
	}, _temp);
	exports.default = StatusDropDown;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValidatedForm = function (_React$Component) {
	  _inherits(ValidatedForm, _React$Component);
	
	  function ValidatedForm(props) {
	    _classCallCheck(this, ValidatedForm);
	
	    var _this = _possibleConstructorReturn(this, (ValidatedForm.__proto__ || Object.getPrototypeOf(ValidatedForm)).call(this, props));
	
	    _this.validateForm = _this.validateForm.bind(_this);
	    return _this;
	  }
	
	  _createClass(ValidatedForm, [{
	    key: 'validateUpdate',
	    value: function validateUpdate(model, field, callback) {
	      var _this2 = this;
	
	      return function (event, value) {
	        var state = (0, _lodash.merge)({}, _this2.state);
	        if (!state.validation[field]) {
	          state.validation[field] = {};
	        }
	        state.validation[field].errors = _this2.validateFormField(field, !(0, _lodash.isUndefined)(value) ? value : (0, _lodash.get)(event, 'target.value'));
	        _this2.setState(state);
	        if (callback) {
	          callback(model, field, event, value);
	        }
	      };
	    }
	  }, {
	    key: 'validateFormField',
	    value: function validateFormField(field, value) {
	      if (field && this.state.validation && this.state.validation[field]) {
	        return (0, _modelValidator.validateField)(value, (0, _lodash.omit)(this.state.validation[field], 'errors'));
	      }
	      return [];
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var _this3 = this;
	
	      var state = (0, _lodash.merge)({}, (0, _lodash.get)(this, 'state'));
	      var form = this.formModel;
	      var count = 0;
	      if (state.validation && form) {
	        (0, _lodash.forOwn)(state.validation, function (val, key) {
	          state.validation[key].errors = _this3.validateFormField(key, form[key]);
	          count += state.validation[key].errors.length;
	        });
	
	        this.setState(state);
	      }
	      return count === 0;
	    }
	  }, {
	    key: 'formModel',
	    get: function get() {
	      var props = (0, _lodash.merge)({}, (0, _lodash.get)(this, 'props'));
	      return (0, _lodash.merge)({}, props[props.model], (0, _lodash.get)(props, 'tempState[' + props.model + ']'));
	    }
	  }]);
	
	  return ValidatedForm;
	}(_react2.default.Component);
	
	exports.default = ValidatedForm;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2, _class2, _temp3; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// import customized material UI components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _Logo = __webpack_require__(123);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalForm = (_temp2 = _class = function (_Component) {
	  _inherits(ModalForm, _Component);
	
	  function ModalForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ModalForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalForm.__proto__ || Object.getPrototypeOf(ModalForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = function () {
	      if (_this.props.onClose) {
	        _this.props.onClose();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ModalForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isMessage = _props.message,
	          className = _props.className,
	          style = _props.style,
	          transparent = _props.transparent,
	          prompt = _props.prompt,
	          dataId = _props.dataId,
	          children = _props.children;
	
	      var _props$button = this.props.button,
	          buttonClassName = _props$button.className,
	          buttonLabel = _props$button.label,
	          buttonStyle = _props$button.style,
	          buttonHide = _props$button.hide,
	          buttonOnClick = _props$button.onClick,
	          buttonIsDisabled = _props$button.disabled,
	          otherButtonProps = _objectWithoutProperties(_props$button, ['className', 'label', 'style', 'hide', 'onClick', 'disabled']);
	
	      var _props$afterButtonTex = this.props.afterButtonText,
	          afterButtonTextClassName = _props$afterButtonTex.className,
	          afterButtonTextContent = _props$afterButtonTex.content,
	          afterButtonTextOnClick = _props$afterButtonTex.onClick,
	          otherAfterButtonTextProps = _objectWithoutProperties(_props$afterButtonTex, ['className', 'content', 'onClick']);
	
	      return _react2.default.createElement(
	        _r_Modal2.default,
	        {
	          fadeModal: !!this.props.onClose,
	          fadeModalChildren: !!this.props.onClose,
	          show: true,
	          floatDownModalChildren: true,
	          transformTransitionOut: 'ease-in-out',
	          onClose: this.props.onClose && this.handleClose },
	        _react2.default.createElement(ModalFormMain, { isMessage: isMessage,
	          className: className,
	          style: style,
	          transparent: transparent,
	          prompt: prompt,
	          children: children,
	          buttonClassName: buttonClassName,
	          buttonLabel: buttonLabel,
	          dataId: dataId,
	          buttonStyle: buttonStyle,
	          buttonHide: buttonHide,
	          buttonIsDisabled: buttonIsDisabled,
	          buttonOnClick: buttonOnClick,
	          otherButtonProps: otherButtonProps,
	          afterButtonTextClassName: afterButtonTextClassName,
	          afterButtonTextContent: afterButtonTextContent,
	          afterButtonTextOnClick: afterButtonTextOnClick,
	          otherAfterButtonTextProps: otherAfterButtonTextProps }),
	        _react2.default.createElement('div', { className: 'rectangle-behind-modal-form absolute-center' })
	      );
	    }
	  }]);
	
	  return ModalForm;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  children: _react.PropTypes.any.isRequired,
	  onClose: _react.PropTypes.func,
	  prompt: _react.PropTypes.string,
	  message: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  transparent: _react.PropTypes.bool,
	  dataId: _react.PropTypes.string,
	  button: _react.PropTypes.shape({
	    className: _react.PropTypes.string,
	    label: _react.PropTypes.string,
	    style: _react.PropTypes.object,
	    disabled: _react.PropTypes.bool,
	    hide: _react.PropTypes.bool,
	    onClick: _react.PropTypes.func
	  }),
	  afterButtonText: _react.PropTypes.shape({
	    className: _react.PropTypes.string,
	    content: _react.PropTypes.any,
	    onClick: _react.PropTypes.func
	  })
	}, _class.defaultProps = {
	  button: {},
	  afterButtonText: {}
	}, _temp2);
	
	// hack for incorporating close on key press
	
	exports.default = ModalForm;
	var ModalFormMain = (_temp3 = _class2 = function (_Component2) {
	  _inherits(ModalFormMain, _Component2);
	
	  function ModalFormMain() {
	    _classCallCheck(this, ModalFormMain);
	
	    var _this2 = _possibleConstructorReturn(this, (ModalFormMain.__proto__ || Object.getPrototypeOf(ModalFormMain)).call(this));
	
	    _this2.respondToKeyPress = _this2.respondToKeyPress.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ModalFormMain, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.respondToKeyPress);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.respondToKeyPress);
	    }
	  }, {
	    key: 'respondToKeyPress',
	    value: function respondToKeyPress(event) {
	      // escape key response
	      if (event.keyCode === 27 && this.props.closeModal) {
	        this.props.closeModal();
	      }
	
	      // enter key response
	      if (event.keyCode === 13 && !this.props.buttonIsDisabled && this.props.buttonOnClick) {
	        this.props.buttonOnClick();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('modal-form', 'clearfix', this.props.className, { 'modal-message': this.props.isMessage }), style: this.props.style },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('message-container', { transparent: this.props.transparent }) },
	          !this.props.isMessage && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Logo2.default, { className: 'logo' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'prompt-container' },
	              _react2.default.createElement(
	                'span',
	                { className: 'prompt' },
	                this.props.prompt
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-container' },
	              this.props.children
	            )
	          ) || this.props.children,
	          _react2.default.createElement(_c_RaisedButton2.default, _extends({ className: 'form-submit ' + this.props.buttonClassName,
	            'data-id': this.props.dataId || this.props.buttonLabel,
	            label: this.props.buttonLabel,
	            disabled: this.props.buttonIsDisabled,
	            style: _lodash2.default.merge({ marginTop: '40.5px' }, this.props.buttonHide ? { opacity: 0, visibility: 'hidden' } : {}, this.props.buttonStyle),
	            onClick: this.props.buttonOnClick
	          }, this.props.otherButtonProps)),
	          _react2.default.createElement(
	            'div',
	            _extends({ className: 'after-button-text ' + this.props.afterButtonTextClassName + ' ' + (this.props.afterButtonTextOnClick ? 'clickable' : ''),
	              'data-id': 'After Button Text',
	              onClick: this.props.afterButtonTextOnClick
	            }, this.props.otherAfterButtonTextProps),
	            this.props.afterButtonTextContent
	          )
	        ),
	        !!this.props.closeModal && _react2.default.createElement(_ModalX2.default, { onClick: this.props.closeModal })
	      );
	    }
	  }]);
	
	  return ModalFormMain;
	}(_react.Component), _class2.propTypes = {
	  closeModal: _react.PropTypes.func,
	  children: _react.PropTypes.any,
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  isMessage: _react.PropTypes.bool,
	  transparent: _react.PropTypes.bool,
	  prompt: _react.PropTypes.string,
	  buttonClassName: _react.PropTypes.string,
	  dataId: _react.PropTypes.string,
	  buttonLabel: _react.PropTypes.string,
	  buttonHide: _react.PropTypes.bool,
	  buttonIsDisabled: _react.PropTypes.bool,
	  buttonStyle: _react.PropTypes.object,
	  buttonOnClick: _react.PropTypes.func,
	  otherButtonProps: _react.PropTypes.object,
	  afterButtonTextContent: _react.PropTypes.any,
	  afterButtonTextClassName: _react.PropTypes.string,
	  afterButtonTextOnClick: _react.PropTypes.func,
	  otherAfterButtonTextProps: _react.PropTypes.object
	}, _temp3);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(395);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(187);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(612);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(274);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _reactProps = __webpack_require__(238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var anchorOrigin = {
	  vertical: 'bottom',
	  horizontal: 'left'
	};
	
	var targetOrigin = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'default' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: '#4a4a4a',
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.desktopToolbarHeight - 24) / 2
	    },
	    label: {
	      color: disabled ? '#8d8d8d' : palette.textColor,
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize + spacing.desktopGutterLess + spacing.desktopGutterMini,
	      top: 0
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px rgb(74, 74, 74)',
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = (_temp2 = _class = function (_Component) {
	  _inherits(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DropDownMenu.__proto__ || Object.getPrototypeOf(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.refs.root
	        });
	      }
	    }, _this.handleKeyPress = function (event) {
	      if (event.key === 'Enter') {
	        _this.handleTouchTapControl(event);
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	      _this.setParentFocus(true);
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      _this.props.onChange(event, index, child.props.value);
	
	      if (!_this.props.checkList) {
	        _this.setState({
	          open: false
	        });
	        _this.setParentFocus(true);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  _createClass(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({ open: true, anchorEl: _this2.refs.root });
	        });
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.refs.root
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this3 = this;
	
	      if (this.state.focus) {
	        setTimeout(function () {
	          return _reactDom2.default.findDOMNode(_this3.refs.root).focus();
	        }, 0);
	      }
	    }
	  }, {
	    key: 'setParentFocus',
	    value: function setParentFocus(state) {
	      this.setState({ focus: state });
	    }
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      var _this4 = this;
	
	      var root = this.refs.root;
	
	      root.focus = function () {
	        if (!_this4.props.disabled) {
	          _this4.setState({
	            open: !_this4.state.open,
	            anchorEl: _this4.refs.root
	          });
	        }
	      };
	
	      return root;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.refs.root;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          className = _props.className,
	          dataId = _props['data-id'],
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProps = _props.menuStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          popoverStyle = _props.popoverStyle,
	          popoverClassName = _props.popoverClassName,
	          value = _props.value,
	          disabled = _props.disabled,
	          isMenu = _props.isMenu,
	          canAutoPosition = _props.canAutoPosition,
	          other = _objectWithoutProperties(_props, ['autoWidth', 'children', 'className', 'data-id', 'iconStyle', 'labelStyle', 'listStyle', 'selectedMenuItemStyle', 'maxHeight', 'menuStyle', 'style', 'underlineStyle', 'popoverStyle', 'popoverClassName', 'value', 'disabled', 'isMenu', 'canAutoPosition']);
	
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      // display the label item if checklist.
	
	      if (this.props.checkList && children.length) {
	        displayValue = children[0].props.primaryText;
	      } else {
	        _react2.default.Children.forEach(children, function (child) {
	          if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) !== 'object' || child === null) return; // bug fix for these bias
	          if (value === child.props.value) {
	            // This will need to be improved (in case primaryText is a node)
	            displayValue = child.props.label || child.props.primaryText;
	          }
	        });
	      }
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = Object.assign({
	          width: anchorEl.clientWidth
	        }, menuStyleProps);
	      } else {
	        menuStyle = menuStyleProps;
	      }
	
	      if (isMenu) {
	        anchorOrigin.vertical = 'bottom';
	        anchorOrigin.horizontal = 'right';
	        targetOrigin.horizontal = 'right';
	      }
	      var errorTextElement = this.props.errorText && _react2.default.createElement(
	        'div',
	        { className: 'error-message' },
	        this.props.errorText
	      );
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, (0, _reactProps.stripUnknownProps)(other), {
	          'data-id': dataId,
	          ref: 'root',
	          className: className,
	          tabIndex: this.props.disabled ? -1 : 0,
	          onKeyPress: this.handleKeyPress,
	          onBlur: function onBlur() {
	            return _this5.setParentFocus(false);
	          },
	          style: prepareStyles(Object.assign({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        !isMenu && _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onTouchTap: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'dropdown-label',
	              style: prepareStyles(Object.assign({}, styles.label, open && styles.labelWhenOpen, labelStyle, disabled ? { color: styles.label.color } : {}))
	            },
	            displayValue
	          ),
	          _react2.default.createElement(_arrowDropDown2.default, {
	            className: 'dropdown-caret',
	            style: Object.assign({}, styles.icon, iconStyle)
	          }),
	          _react2.default.createElement('div', {
	            className: 'dropdown-border',
	            style: prepareStyles(Object.assign({}, styles.underline, underlineStyle))
	          })
	        ),
	        isMenu && _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onTouchTap: this.handleTouchTapControl },
	          _react2.default.createElement('div', {
	            className: 'dropdown-label',
	            style: prepareStyles(Object.assign({}, styles.label, open && styles.labelWhenOpen, labelStyle, disabled ? { color: styles.label.color } : {}))
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'dropdown-caret',
	              style: Object.assign({}, styles.icon, iconStyle)
	            },
	            '\u2630'
	          )
	        ),
	        errorTextElement,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            className: popoverClassName ? 'popover ' + popoverClassName : 'popover',
	            style: popoverStyle,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            anchorEl: anchorEl,
	            animation: _PopoverAnimationVertical2.default,
	            open: open,
	            canAutoPosition: canAutoPosition || false,
	            onRequestClose: this.handleRequestCloseMenu },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              'data-id': dataId,
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              selectedMenuItemStyle: selectedMenuItemStyle
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return DropDownMenu;
	}(_react.Component), _class.muiName = 'DropDownMenu', _class.propTypes = {
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} payload The `value` prop of the clicked menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value that is currently selected.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * for styling customization that should natively be available.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * determines whether or not to close when item is clicked
	   */
	  checkList: _react.PropTypes.bool,
	  /**
	   * for test id.
	   */
	  'data-id': _react.PropTypes.string,
	  /**
	   * allow styling of popover.
	   */
	  popoverStyle: _react.PropTypes.object,
	  popoverClassName: _react.PropTypes.string,
	  isMenu: _react.PropTypes.bool,
	  canAutoPosition: _react.PropTypes.bool,
	  errorText: _react.PropTypes.string
	}, _class.defaultProps = {
	  autoWidth: true,
	  disabled: false,
	  openImmediately: false,
	  maxHeight: 500
	}, _class.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	}, _temp2);
	exports.default = DropDownMenu;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function EditIcon(props) {
	    var className = props.className,
	        otherProps = _objectWithoutProperties(props, ["className"]);
	
	    return _react2.default.createElement(
	        "svg",
	        _extends({ width: "30px", height: "30px", viewBox: "0 0 30 30", version: "1.1", xmlns: "http://www.w3.org/2000/svg", className: "profile-icon " + className }, otherProps),
	        _react2.default.createElement(
	            "g",
	            { id: "1160---Upload-of-Assessment-Scores", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { transform: "translate(-790.000000, -438.000000)", id: "Group-28", fill: "#4A4A4A" },
	                _react2.default.createElement(
	                    "g",
	                    { transform: "translate(331.000000, 275.000000)" },
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Group-37", transform: "translate(459.000000, 163.000000)" },
	                        _react2.default.createElement(
	                            "g",
	                            { id: "icon_pencil" },
	                            _react2.default.createElement(
	                                "g",
	                                { id: "Group-30" },
	                                _react2.default.createElement(
	                                    "g",
	                                    { id: "Icons", transform: "translate(7.000000, 7.000000)" },
	                                    _react2.default.createElement(
	                                        "g",
	                                        { id: "Group" },
	                                        _react2.default.createElement("path", { d: "M11.9251613,7.11741935 C11.7930323,7.11741935 11.6609032,7.06683871 11.5602581,6.96619355 C11.3584516,6.7643871 11.3584516,6.43819355 11.5602581,6.2363871 L14.2379355,3.55870968 L11.9256774,1.24645161 L9.248,3.92412903 C9.04619355,4.12593548 8.72,4.12593548 8.51819355,3.92412903 C8.3163871,3.72232258 8.3163871,3.39612903 8.51819355,3.19432258 L11.5607742,0.151741935 C11.7625806,-0.0500645161 12.0887742,-0.0500645161 12.2905806,0.151741935 L15.3331613,3.19432258 C15.5349677,3.39612903 15.5349677,3.72232258 15.3331613,3.92412903 L12.2905806,6.96670968 C12.1894194,7.06683871 12.0572903,7.11741935 11.9251613,7.11741935 L11.9251613,7.11741935 Z", id: "Shape" }),
	                                        _react2.default.createElement("path", { d: "M0.516129032,15.483871 C0.381419355,15.483871 0.249290323,15.4312258 0.151225806,15.3326452 C0.0129032258,15.1943226 -0.0350967742,14.9899355 0.0263225806,14.8046452 L1.51174194,10.3489032 C1.52619355,10.2425806 1.57367742,10.139871 1.65419355,10.0578065 C1.65522581,10.0567742 1.65574194,10.0557419 1.65677419,10.0552258 C1.65729032,10.0547097 1.65729032,10.0541935 1.65780645,10.0541935 L9.2923871,2.41909677 C9.38941935,2.32206452 9.52051613,2.26787097 9.65729032,2.26787097 L9.65729032,2.26787097 C9.79406452,2.26787097 9.92567742,2.32206452 10.0221935,2.41909677 L13.0647742,5.46167742 C13.2665806,5.66348387 13.2665806,5.98967742 13.0647742,6.19148387 L5.45187097,13.8043871 C5.44722581,13.8095484 5.44154839,13.8147097 5.43690323,13.8193548 L5.43070968,13.8255484 C5.3476129,13.9086452 5.24335484,13.9571613 5.13548387,13.972129 L0.679741935,15.4575484 C0.625548387,15.4750968 0.57083871,15.483871 0.516129032,15.483871 L0.516129032,15.483871 Z M2.48825806,10.6828387 L1.33212903,14.1517419 L4.80103226,12.9956129 L11.9700645,5.82658065 L9.65780645,3.51380645 L2.48825806,10.6828387 L2.48825806,10.6828387 Z", id: "Shape" })
	                                    )
	                                ),
	                                _react2.default.createElement("path", { d: "M15,30 C6.729,30 0,23.271 0,15 C0,6.729 6.729,0 15,0 C23.271,0 30,6.729 30,15 C30,23.271 23.271,30 15,30 L15,30 Z M15,2 C7.832,2 2,7.832 2,15 C2,22.168 7.832,28 15,28 C22.168,28 28,22.168 28,15 C28,7.832 22.168,2 15,2 L15,2 Z", id: "Shape" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	EditIcon.propTypes = {
	    className: _react.PropTypes.string
	};
	
	exports.default = EditIcon;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function InfoIcon(props) {
	    var color = props.color,
	        otherProps = _objectWithoutProperties(props, ['color']);
	
	    var defaultColor = '#2EB0E3';
	
	    return _react2.default.createElement(
	        'svg',
	        _extends({ width: '18px', height: '18px', viewBox: '0 0 18 18', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', className: 'info-icon' }, otherProps),
	        _react2.default.createElement(
	            'g',
	            { id: '2513---CRM---Alerts', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	            _react2.default.createElement(
	                'g',
	                { id: '2513---CRM---Alerts---View', transform: 'translate(-832.000000, -29.000000)' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Group', transform: 'translate(818.000000, 15.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group-52', transform: 'translate(15.000000, 15.000000)' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Group-53' },
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Group-54' },
	                                _react2.default.createElement('circle', { id: 'Oval-43-Copy-16', stroke: color || defaultColor, cx: '8', cy: '8', r: '8' }),
	                                _react2.default.createElement(
	                                    'text',
	                                    { id: 'i', fontFamily: 'Lato-Black, Lato', fontSize: '11', fontWeight: '700', fill: color || defaultColor },
	                                    _react2.default.createElement(
	                                        'tspan',
	                                        { x: '6.4325', y: '12' },
	                                        'i'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = InfoIcon;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TackIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TackIcon() {
	
	  return _react2.default.createElement(
	    'svg',
	    { xmlns: 'http://www.w3.org/2000/svg', width: '18px', height: '18px', viewBox: '0 0 18 18', version: '1.1' },
	    _react2.default.createElement(
	      'g',
	      { id: '1544---Pinning', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement(
	        'g',
	        { id: '1544---Pinning-1', transform: 'translate(-1302.000000, -45.000000)', fill: '#DCDCDC' },
	        _react2.default.createElement('path', { xmlns: 'http://www.w3.org/2000/svg', d: 'M1313.92827, 53.83584 L1317.28952,50.457825 C1318.15576, 50.685525 1319.08406,50.61267 1319.91054,50.23854 L1314.69806, 45 C1314.32584,45.83061 1314.2533,46.763505 1314.47987, 47.63412 L1311.1187,51.012135 C1309.54401,50.25861 1307.70797, 50.240835 1306.12088,50.959215 L1309.03173,53.884665 L1302, 63 L1311.06999,55.933155 L1313.98088,58.858605 C1314.69564, 57.26367 1314.67804,55.418355 1313.92827,53.83584 L1313.92827, 53.83584 Z M1308.51555,52.224885 C1308.51555,52.224885 1307.7737, 51.479325 1307.56079,51.27831 C1309.21872,50.79204 1310.30893, 51.472845 1310.30893,51.472845 C1309.29613,51.155145 1308.51555, 52.224885 1308.51555,52.224885 L1308.51555,52.224885 Z', id: 'Shape' })
	      )
	    )
	  );
	}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultOrdering = defaultOrdering;
	exports.YesNoItems = YesNoItems;
	function defaultOrdering(item1, item2) {
	  var name1 = (item1.name || item1.primaryText || '').toLowerCase();
	  var name2 = (item2.name || item2.primaryText || '').toLowerCase();
	
	  if (name1.startsWith('other')) {
	    return 1;
	  }
	
	  if (name2.startsWith('other')) {
	    return -1;
	  }
	
	  if (name1.startsWith('none')) {
	    return -1;
	  }
	
	  if (name2.startsWith('none')) {
	    return 1;
	  }
	
	  if (name1 > name2) {
	    return 1;
	  }
	
	  if (name2 > name1) {
	    return -1;
	  }
	
	  return 0;
	}
	
	function YesNoItems() {
	  return [{
	    value: true,
	    primaryText: 'Yes' }, {
	    value: false,
	    primaryText: 'No'
	  }];
	}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isServer = !(typeof window !== 'undefined' && window.document);
	
	exports.default = isServer;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var JobRequest = function (_BaseModel) {
	  _inherits(JobRequest, _BaseModel);
	
	  function JobRequest() {
	    _classCallCheck(this, JobRequest);
	
	    return _possibleConstructorReturn(this, (JobRequest.__proto__ || Object.getPrototypeOf(JobRequest)).call(this, jobRequestSchema));
	  }
	
	  _createClass(JobRequest, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return jobRequestSchema;
	    }
	  }]);
	
	  return JobRequest;
	}(BaseModel);
	
	var jobRequestSchema = {
	  position: {
	    industryTypeId: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    segmentTypeId: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    positionTypeId: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    licenseRequired: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    dualMonitorsRequired: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    outsideContactRequired: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    numberOfPeople: {
	      required: {
	        message: 'This field is required.'
	      },
	      isInt: {
	        options: { min: 1 },
	        message: 'Must be positive numeric.'
	      }
	    },
	    fromDifferentOffice: {
	      required: {
	        message: 'This field is required.'
	      }
	    }
	  },
	  description: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  workschedule: {
	    jobTypeId: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    numberOfMonths: {},
	    dateEnded: {},
	    dateStarted: {},
	    estimatedHoursPerWeek: {
	      required: {
	        message: 'This field is required.' }
	    },
	    partTimeWahvesConsidered: {},
	    workdays: {
	      required: {
	        message: 'This field is required.' }
	    },
	    offHoursConsidered: {
	      required: {
	        message: 'This field is required.' }
	    },
	    timezone: {
	      required: {
	        message: 'This field is required.' }
	    },
	    startTime: {
	      required: {
	        message: 'This field is required.' }
	    },
	    endTime: {
	      required: {
	        message: 'This field is required.' }
	    }
	  },
	  addcontact: {
	    contacts: {
	      required: {
	        message: 'This field is required.'
	      }
	    }
	  },
	  skillOptions: {
	    categoryId: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    name: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    skillOption: {
	      required: {
	        message: 'This field is required.'
	      }
	    }
	  }
	};
	module.exports = JobRequest;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enableInstructions = enableInstructions;
	exports.enableAssessments = enableAssessments;
	exports.enableTechnologySurvey = enableTechnologySurvey;
	exports.isQualified = isQualified;
	exports.hasInterviewed = hasInterviewed;
	exports.hasSubmitted = hasSubmitted;
	exports.isInactivePipeline = isInactivePipeline;
	
	var _configureStore = __webpack_require__(319);
	
	var _enums = __webpack_require__(92);
	
	function applicantStatuses() {
	  var _getState = (0, _configureStore.getState)(),
	      statuses = _getState.staticData.applicantStatus;
	
	  return statuses;
	}
	
	function enableInstructions() {
	  var statusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return [_enums.APPLICANT_STATUS.PENDING_APPLICATION, _enums.APPLICANT_STATUS.PENDING_ASSESSMENTS, _enums.APPLICANT_STATUS.PENDING_APPLICATION_INTERVIEW, _enums.APPLICANT_STATUS.PENDING_INFORMATION_UPDATE, _enums.APPLICANT_STATUS.IN_WAITING, _enums.APPLICANT_STATUS.PENDING_REVIEW].includes(statusId);
	}
	
	function enableAssessments() {
	  var statusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return [_enums.APPLICANT_STATUS.PENDING_ASSESSMENTS, _enums.APPLICANT_STATUS.PENDING_APPLICATION_INTERVIEW, _enums.APPLICANT_STATUS.PENDING_INFORMATION_UPDATE, _enums.APPLICANT_STATUS.PENDING_REVIEW].includes(statusId);
	}
	
	function enableTechnologySurvey() {
	  var statusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return [_enums.APPLICANT_STATUS.READY_TO_PLACE, _enums.APPLICANT_STATUS.PENDING_TECH_EVALUATION, _enums.APPLICANT_STATUS.PENDING_REFERENCE_CHECKS, _enums.APPLICANT_STATUS.ACTIVE, _enums.APPLICANT_STATUS.PLACED].includes(statusId);
	}
	
	function isQualified() {
	  var statusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return [_enums.APPLICANT_STATUS.QUALIFIED_CANDIDATE, _enums.APPLICANT_STATUS.READY_TO_PLACE, _enums.APPLICANT_STATUS.PENDING_REFERENCE_CHECKS, _enums.APPLICANT_STATUS.QUALIFIED_IN_WAITING, _enums.APPLICANT_STATUS.QUALIFIED_CANDIDATE_IN_QUEUE, _enums.APPLICANT_STATUS.ACTIVE, _enums.APPLICANT_STATUS.PLACED, _enums.APPLICANT_STATUS.PENDING_TECH_EVALUATION].includes(statusId);
	}
	
	function hasInterviewed() {
	  var statusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return ![_enums.APPLICANT_STATUS.NEW_APPLICANT, _enums.APPLICANT_STATUS.PENDING_PRELIMINARY_INTERVIEW, _enums.APPLICANT_STATUS.NOT_QUALIFIED, _enums.APPLICANT_STATUS.NOT_INTERESTED].includes(statusId);
	}
	
	function hasSubmitted() {
	  var applicantProfile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return !!(applicantProfile && applicantProfile.dateAuthorized);
	}
	
	// Determine if Applicant status indicates that they're in the Inactive Pipeline
	
	function isInactivePipeline() {
	  var statusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  // if applicant status is in list of status' where subGroup === 'Inactive' return true
	  // eslint-disable-next-line yoda
	  return true === applicantStatuses().filter(function (status) {
	    return status.subGroup === 'Inactive';
	  }).map(function (status) {
	    return status.id;
	  }).includes(statusId);
	}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Wahve Apply start JS pixel
	var BASE_PIXEL_URL = '//jotrack.s3.amazonaws.com/pzn0/';
	
	// Map pixels to conversionType parameter
	var PIXEL_MAP = [{ id: 'preliminary-application', pixel: 'job-apply-start.js' }, { id: 'preliminary-qualified', pixel: 'job-apply.js' }, { id: 'preliminary-unqualified', pixel: 'job-conversion1.js' }, { id: 'preliminary-dropoff', pixel: 'job-conversion2.js' }, { id: 'full-apply', pixel: 'job-conversion3.js' }, { id: '', pixel: undefined }];
	
	var JoveoTrackingPixel = (_temp = _class = function (_Component) {
	  _inherits(JoveoTrackingPixel, _Component);
	
	  function JoveoTrackingPixel(props, context) {
	    _classCallCheck(this, JoveoTrackingPixel);
	
	    var _this = _possibleConstructorReturn(this, (JoveoTrackingPixel.__proto__ || Object.getPrototypeOf(JoveoTrackingPixel)).call(this, props, context));
	
	    _this.appendScript = function (scriptToAppend) {
	      var script = document.createElement('script');
	      script.src = scriptToAppend;
	      script.async = true;
	      document.body.appendChild(script);
	    };
	
	    _this.removeScript = function (scriptToRemove) {
	      var allsuspects = document.getElementsByTagName('script');
	      for (var i = allsuspects.length; i >= 0; i--) {
	        if (allsuspects[i] && allsuspects[i].getAttribute('src') !== null && allsuspects[i].getAttribute('src').indexOf('' + scriptToRemove) !== -1) {
	          allsuspects[i].parentNode.removeChild(allsuspects[i]);
	        }
	      }
	    };
	
	    var pixel = PIXEL_MAP.find(function (p) {
	      return p.id === _this.props.conversionType;
	    });
	    var url = pixel.pixel ? BASE_PIXEL_URL.concat(pixel.pixel) : undefined;
	
	    _this.state = {
	      trackingURL: url
	    };
	    return _this;
	  }
	
	  _createClass(JoveoTrackingPixel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //  Joveo Tracking Pixel
	      if (this.state.trackingURL) {
	        this.appendScript(this.state.trackingURL);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      //  Joveo Tracking Pixel
	      if (this.state.trackingURL) {
	        this.removeScript(this.state.trackingURL);
	      }
	    }
	
	    // dynamically add script to component
	
	
	    // dynamically remove script to component
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { ref: function ref(el) {
	            return _this2.instance = el;
	          } })
	      );
	    }
	  }]);
	
	  return JoveoTrackingPixel;
	}(_react.Component), _class.propTypes = {
	  conversionType: _react.PropTypes.string,
	  trackingURL: _react.PropTypes.string
	}, _temp);
	exports.default = JoveoTrackingPixel;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(51);
	
	var _lodash = __webpack_require__(4);
	
	var _Logo = __webpack_require__(123);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var copyRightLogoStyle = { color: '#dcdcdc', width: '88px' };
	var Copyright = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Common', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Copyright, _Component);
	
	  function Copyright() {
	    _classCallCheck(this, Copyright);
	
	    return _possibleConstructorReturn(this, (Copyright.__proto__ || Object.getPrototypeOf(Copyright)).apply(this, arguments));
	  }
	
	  _createClass(Copyright, [{
	    key: 'render',
	    value: function render() {
	      var classes = ['copyright-container'];
	      if (this.props.className) {
	        classes.push(this.props.className);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes.join(' ') },
	        _react2.default.createElement(_Logo2.default, { style: copyRightLogoStyle }),
	        _react2.default.createElement(
	          'div',
	          { className: 'copyright-text' },
	          'Copyright \xA9 ',
	          new Date().getFullYear(),
	          '. ',
	          _react2.default.createElement('br', null),
	          (0, _lodash.get)(this.props.labels, 'fullName'),
	          _react2.default.createElement('br', null),
	          'All rights reserved.',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', className: 'link terms-link', 'data-id': 'Terms Link', href: this.props.labels.privacy },
	            ' Privacy Policy'
	          ),
	          _react2.default.createElement('br', null)
	        )
	      );
	    }
	  }]);
	
	  return Copyright;
	}(_react.Component), _class2.propTypes = {
	  className: _react.PropTypes.string,
	  labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = Copyright;

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var viewOrderArr = exports.viewOrderArr = [{
	  display: 'Profile',
	  displaySubmitted: 'Contact Information',
	  hideSubNavSubmitted: false,
	  key: 'Profile',
	  showInactivePipeline: true,
	  showUnqualified: true,
	  subNav: [{
	    display: 'Contact Information',
	    key: 'Contact Information'
	  }, {
	    display: 'Preliminary Information',
	    key: 'Preliminary Information'
	  }]
	}, {
	  display: 'APPLICATION Instructions',
	  key: 'Instructions',
	  showUnqualified: false
	}, {
	  display: 'Preferences',
	  key: 'Preferences',
	  subNav: [{
	    display: 'Availability Information',
	    key: 'Availability Information'
	  }, {
	    display: 'Home Office Setup',
	    key: 'Home Office Setup'
	  }]
	}, {
	  display: 'Experience',
	  key: 'Experience',
	  subNav: [{
	    display: 'Career Summary',
	    key: 'Career Summary'
	  }, {
	    display: 'Work Experience',
	    key: 'Work Experience'
	  }, {
	    display: 'Employment Gaps',
	    key: 'Employment Gaps'
	  }]
	}, {
	  display: 'Skills',
	  key: 'Skills',
	  subNav: [{
	    display: 'Introduction',
	    key: 'Instructions'
	  }, {
	    display: 'Industry Segments',
	    key: 'Industry Segment'
	  }, {
	    display: 'Firm Types',
	    key: 'Types of Firms or Organizations worked for'
	  }, {
	    display: 'Positions',
	    key: 'Positions or Types of Work'
	  }, {
	    display: 'Departments',
	    key: 'Departments'
	  }, {
	    display: 'Special Areas',
	    key: 'Special Areas of Knowledge'
	  }, {
	    display: 'Mgmt Systems',
	    key: 'Management Systems'
	  }, {
	    display: 'Computer Skills',
	    key: 'Computer Skills'
	  }, {
	    display: 'Rating Systems',
	    key: 'Rating Systems'
	  }, {
	    display: 'Languages',
	    key: 'Foreign Languages'
	  }]
	}, {
	  display: 'Summary of Skills',
	  key: 'Summary of Skills',
	  subNav: [{
	    display: 'Summary of Skills',
	    key: 'Summary of Skills'
	  }]
	}, {
	  display: 'Background',
	  key: 'Background',
	  subNav: [{
	    display: 'Education',
	    key: 'Education'
	  }, {
	    display: 'Licenses',
	    key: 'Licenses'
	  }, {
	    display: 'Professional Designations',
	    key: 'Professional Designations'
	  }, {
	    display: 'Professional Associations',
	    key: 'Professional Associations'
	  }, {
	    display: 'Additional Professional References',
	    key: 'Additional Professional References'
	  }]
	}, {
	  display: 'Documents',
	  key: 'Documents'
	}, {
	  display: 'Submit',
	  key: 'Submit',
	  hideSubmitted: true
	}];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logIn = logIn;
	exports.logOut = logOut;
	exports.currentUser = currentUser;
	exports.changePassword = changePassword;
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _sync = __webpack_require__(21);
	
	var _contacts = __webpack_require__(84);
	
	var _companies = __webpack_require__(63);
	
	var _auth = __webpack_require__(1127);
	
	function logIn(credentials) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	
	      dispatch((0, _sync.updateUser)({
	        authFailed: false
	      }));
	      simpleIsoFetch.post({
	        route: '/api/auth',
	        body: credentials
	      }).then(function (_ref) {
	        var body = _ref.body;
	
	        // Check Authentication was successful
	        if (body.status !== 'success') {
	          throw new Error('Authentication failed.'); // Auth failed. Short circuit chain.
	        }
	
	        return body;
	      }).then(function (body) {
	        return (
	          // Get user roles from response body
	          { roles: (0, _lodash.get)(body, 'data.items[1].roles', []), body: body }
	        );
	      }).then(function (_ref2) {
	        var roles = _ref2.roles,
	            body = _ref2.body;
	
	        // Save auth token to localStorage
	        localStorage.setItem('token', body.data.items[0]);
	        dispatch((0, _sync.updateUser)((0, _lodash.merge)({ loggedIn: true }, body.data.items[1])));
	
	        if (~roles.indexOf('Client')) {
	          dispatch((0, _contacts.updateProfile)(body.data.items[2].profile));
	          dispatch((0, _companies.updateCompany)({ company: body.data.items[2].company }));
	        } else if (~roles.indexOf('Applicant')) {
	          dispatch((0, _contacts.updateProfile)(body.data.items[2]));
	          dispatch((0, _sync.updateApplicant)({ applicantProfile: body.data.items[2] }));
	        } else {
	          dispatch((0, _contacts.updateProfile)(body.data.items[2]));
	        }
	      }).catch(function (err) {
	        // console log unexpected
	        // if(!err || err.status !== 400) {
	        //   return console.error(err);
	        // }
	
	        // login failed
	        return dispatch((0, _sync.updateUser)({
	          authFailed: true,
	          loggedIn: false
	        }));
	      });
	    };
	  };
	}
	
	function logOut(body) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      // Clear token from localStorage
	      localStorage.removeItem('token');
	      // Clear user from store
	      dispatch((0, _auth.logout)());
	      // Redirect to landing page
	      // dispatch(push('/'));
	      // Call server to wipe cookie.
	      return simpleIsoFetch.get({
	        route: '/api/auth/logout',
	        body: body
	      });
	    };
	  };
	}
	
	function currentUser(callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.get('/api/auth').then(function (response) {
	        if (response.status !== 200) {
	          throw new Error('Current user not authenticated.');
	        }
	
	        return response;
	      }).then(function (_ref3) {
	        var items = _ref3.body.data.items;
	        return items;
	      }).then(callback.success).catch(callback.error);
	    };
	  };
	}
	
	function changePassword(body) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.post({
	        route: '/api/auth/password',
	        body: body
	      });
	    };
	  };
	}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(485);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 215 */
152,
/* 216 */
[3158, 323],
/* 217 */
[3120, 94, 41],
/* 218 */
[3129, 94],
/* 219 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(115);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addHours = addHours;
	exports.addMinutes = addMinutes;
	exports.addSeconds = addSeconds;
	exports.formatTime = formatTime;
	exports.rad2deg = rad2deg;
	exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
	exports.isInner = isInner;
	function addHours(d, hours) {
	  var newDate = clone(d);
	  newDate.setHours(d.getHours() + hours);
	  return newDate;
	}
	
	function addMinutes(d, minutes) {
	  var newDate = clone(d);
	  newDate.setMinutes(d.getMinutes() + minutes);
	  return newDate;
	}
	
	function addSeconds(d, seconds) {
	  var newDate = clone(d);
	  newDate.setSeconds(d.getMinutes() + seconds);
	  return newDate;
	}
	
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * @param date [Date] A Date object.
	 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
	 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
	 *
	 * @return String A string representing the formatted time.
	 */
	function formatTime(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ampm';
	  var pedantic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!date) return '';
	  var hours = date.getHours();
	  var mins = date.getMinutes().toString();
	
	  if (format === 'ampm') {
	    var isAM = hours < 12;
	    hours = hours % 12;
	    var additional = isAM ? ' am' : ' pm';
	    hours = (hours || 12).toString();
	
	    if (mins.length < 2) mins = '0' + mins;
	
	    if (pedantic) {
	      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	      if (hours === '12' && mins === '00') {
	        return additional === ' pm' ? '12 noon' : '12 midnight';
	      }
	    }
	
	    return hours + (mins === '00' ? '' : ':' + mins) + additional;
	  }
	
	  hours = hours.toString();
	
	  if (hours.length < 2) hours = '0' + hours;
	  if (mins.length < 2) mins = '0' + mins;
	
	  return hours + ':' + mins;
	}
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(event) {
	  var el = event.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  return {
	    offsetX: event.clientX - boundingRect.left,
	    offsetY: event.clientY - boundingRect.top
	  };
	}
	
	function isInner(props) {
	  if (props.type !== 'hour') {
	    return false;
	  }
	  return props.value < 1 || props.value > 12;
	}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(786);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldPureComponentUpdate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _shallowEqual = __webpack_require__(2827);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function shouldPureComponentUpdate(nextProps, nextState) {
	  return !(0, _shallowEqual2['default'])(this.props, nextProps) || !(0, _shallowEqual2['default'])(this.state, nextState);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, Buffer) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // external libraries
	
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _isoPathJoin = __webpack_require__(557);
	
	var _isoPathJoin2 = _interopRequireDefault(_isoPathJoin);
	
	var _querystring = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// server-side/polyfills
	var FormData = global.FormData || __webpack_require__(1547);
	var fetch = global.fetch || __webpack_require__(1584);
	
	// boolean true if on server false if on client
	var isServer = !(typeof window !== 'undefined' && window.document);
	
	// needed as absolute routes are needed server-side until Node.js implements native fetch
	var baseURL = !isServer ? '' : ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).BASE_URL || 'http://localhost:' + ((3000) || 3000);
	
	var unListenFactory = function unListenFactory(arr, func, index) {
		return function () {
			if (arr[index] === func) {
				arr.splice(index, 1);
				return true;
			}
	
			// look through whole array for function, keep track of whether or not it is found
			var found = false;
			arr.filter(function (val, i) {
				if (val === func) {
					found = true;
					return false; // remove from bound functions
				}
				return true;
			});
	
			if (!found && process.NODE_ENV !== 'production') {
				console.warn('tried to unbind function that was not listening');
			}
	
			// return whether or not function that they tried to unbind was found
			return found;
		};
	};
	
	function listenFactory(arrName) {
		return function listenFunction(func) {
			var index = this.bindingsContainer[arrName].push(func); // returns index which can be used to "unbind"
			return unListenFactory(this.bindingsContainer[arrName], func, index);
		};
	}
	
	// request methods which shortcuts will be made for
	var methods = ['get', 'put', 'post', 'del', 'patch'];
	
	var SimpleIsoFetch = function () {
		_createClass(SimpleIsoFetch, null, [{
			key: 'setBaseUrl',
			value: function setBaseUrl(hostUrl, port) {
				// allows for setting base url server-side without environmental variable
				baseURL = hostUrl && '' + hostUrl + (port && ':' + port || '') || 'http://localhost:' + (port || (3000) || 3000);
				return baseURL;
			}
		}, {
			key: 'getBaseUrl',
			value: function getBaseUrl() {
				return baseURL;
			}
		}, {
			key: 'simpleIsoFetchThunk',
			value: function simpleIsoFetchThunk(simpleIsoFetchInstance) {
				return function (store) {
					return function (next) {
						return function (action) {
							return (// eslint-disable-line no-unused-vars
								next(typeof action === 'function' ? action(simpleIsoFetchInstance) : action)
							);
						};
					};
				};
			}
		}, {
			key: 'syncBindingsWithStore',
			value: function syncBindingsWithStore(simpleIsoFetchInstance, store) {
				var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
				    _ref$stateProperty = _ref.stateProperty,
				    stateProperty = _ref$stateProperty === undefined ? 'simpleIsoFetch' : _ref$stateProperty;
	
				// Ensure that the reducer is mounted on the store and functioning properly.
				if (!store.getState()[stateProperty]) {
					throw new Error('Expected the simple-iso-fetch state to be available either as `state.simpleIsoFetch` ' + 'or as the custom expression you can specify as `stateProperty` ' + 'in the `syncBindingsWithStore()` options. ' + 'Ensure you have added the `bindingsReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
				}
	
				store.dispatch({
					type: '@@simpleIsoFetch/INIT_BINDINGS',
					bindings: simpleIsoFetchInstance.bindingsContainer
				});
			}
		}, {
			key: 'bindingsReducer',
			value: function bindingsReducer() {
				var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				var action = arguments[1];
	
				if (!Object.keys(state).length && ~action.type.indexOf('simpleIsoFetch') && !~action.type.indexOf('INIT_BINDINGS')) {
					throw new Error('You need to run syncBindingsWithStore(<simpleIsoFetch instance>,<store>) ' + 'in order to initialize bindings ');
				}
	
				switch (action.type) {
					case '@@simpleIsoFetch/INIT_BINDINGS':
						return action.bindings;
	
					case '@@simpleIsoFetch/BIND_FUNC':
						state[action.bindArr] = state[action.bindArr].concat(action.bindFunc);
						return state;
	
					case '@@simpleIsoFetch/UNBIND_FUNC':
						state[action.bindArr] = state[action.bindArr].filter(function (func) {
							return (
								// check object equivalence
								func !== action.unbindFunc && (
								// check stringified function equivalence
								func.toString() !== action.unbindFunc.toString() || ~func.toString().indexOf('native code')) &&
								// check function name equivalence
								func.name.replace('bound ', '') !== action.unbindFunc.name
							);
						});
						return state;
	
					default:
						return state;
				}
			}
		}, {
			key: 'bindToErrorAction',
			value: function bindToErrorAction(func) {
				return {
					type: '@@simpleIsoFetch/BIND_FUNC',
					bindArr: 'boundToError',
					bindFunc: func
				};
			}
		}, {
			key: 'bindToSuccessAction',
			value: function bindToSuccessAction(func) {
				return {
					type: '@@simpleIsoFetch/BIND_FUNC',
					bindArr: 'boundToSuccess',
					bindFunc: func
				};
			}
		}, {
			key: 'bindToResponseAction',
			value: function bindToResponseAction(func) {
				return {
					type: '@@simpleIsoFetch/BIND_FUNC',
					bindArr: 'boundToResponse',
					bindFunc: func
				};
			}
		}, {
			key: 'unbindFromErrorAction',
			value: function unbindFromErrorAction(func) {
				return {
					type: '@@simpleIsoFetch/UNBIND_FUNC',
					bindArr: 'boundToError',
					unbindFunc: func
				};
			}
		}, {
			key: 'unbindFromSuccessAction',
			value: function unbindFromSuccessAction(func) {
				return {
					type: '@@simpleIsoFetch/UNBIND_FUNC',
					bindArr: 'boundToSuccess',
					unbindFunc: func
				};
			}
		}, {
			key: 'unbindFromResponseAction',
			value: function unbindFromResponseAction(func) {
				return {
					type: '@@simpleIsoFetch/UNBIND_FUNC',
					bindArr: 'boundToResponse',
					unbindFunc: func
				};
			}
		}, {
			key: 'makeRequest',
			value: function makeRequest(o) {
				var reqObjAsSecondArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				return _makeRequest.bind(this)(o, reqObjAsSecondArg);
			}
		}]);
	
		function SimpleIsoFetch(req) {
			var _this = this;
	
			_classCallCheck(this, SimpleIsoFetch);
	
			this.bindingsContainer = {
				boundToError: [], // array of functions to be called upon error
				boundToSuccess: [], // array of functions to be called upon success responses
				boundToResponse: [] // array of functions to be called upon all responses
			};
			this.bindToError = listenFactory('boundToError');
			this.bindToSuccess = listenFactory('boundToSuccess');
			this.bindToResponse = listenFactory('boundToResponse');
	
			this.cookiesObj = req && req.get && req.get('cookie') && { cookie: req.get('cookie') };
			this.makeRequest = this.makeRequest.bind(this);
	
			// add methods for request methods
			methods.forEach(function (method) {
				return (// eslint-disable-line no-return-assign
					_this[method] = function (o) {
						var reqObjAsSecondArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
						return _this.makeRequest(o, _extends({}, reqObjAsSecondArg, { method: method === 'del' ? 'delete' : method }));
					}
				);
			}); // if string is passed just use that as route
		}
	
		// bound functions arrays
	
	
		// binding functions, for if you are not using redux
		// generates function for pushing to 'boundToError'
		// generates function for pushing to 'boundToSuccess'
	
	
		_createClass(SimpleIsoFetch, [{
			key: 'makeRequest',
			// generates function for pushing to 'boundToResponse'
	
			value: function makeRequest(o) {
				var _this2 = this;
	
				var reqObjAsSecondArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				return _makeRequest.call(this, o, reqObjAsSecondArg).then(function (res) {
					return !res.ok ? (_this2.bindingsContainer.boundToResponse.concat(_this2.bindingsContainer.boundToError).forEach(function (boundFunc) {
						return boundFunc(res);
					}), // run bound functions
					Promise.reject(_lodash2.default.merge(res, { statusText: (o.method || '').toUpperCase() + ' \n ' + o.route + ' \n ' + res.status + ' (' + res.statusText + ')' })) // resolve error
					) : (_this2.bindingsContainer.boundToResponse.concat(_this2.bindingsContainer.boundToSuccess).forEach(function (boundFunc) {
						return boundFunc(res);
					}), // run bound functions
					Promise.resolve(res));
				}).catch(function (res) {
					// run error res through bound functions
					_this2.bindingsContainer.boundToResponse.concat(_this2.bindingsContainer.boundToError).forEach(function (boundFunc) {
						return boundFunc(res);
					});
	
					// send error to the '.catch' wherev the api library is being used
					return Promise.reject(res);
				});
			}
		}]);
	
		return SimpleIsoFetch;
	}();
	
	;
	
	// add methods for request methods as statics too!
	methods.forEach(function (method) {
		return (// eslint-disable-line no-return-assign
			SimpleIsoFetch[method] = function (o) {
				var reqObjAsSecondArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
				return SimpleIsoFetch.makeRequest(o, _extends({}, reqObjAsSecondArg, { method: method === 'del' ? 'delete' : method }));
			}
		);
	}); // if string is passed just use that as route
	
	
	function _makeRequest(o) {
		var reqObjAsSecondArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		// allow for first argument to be a route string and for options to be passed in as object in second argument
		o = _extends({}, reqObjAsSecondArg, typeof o === 'string' ? { route: o } : o);
	
		// error if no route is provided
		if (!o.route) return console.error("no 'route' property specified on request");
	
		// make relative routes absolute, isomorphism needs this until Node.js implements native fetch
		if (o.route[0] === '/') o.route = '' + baseURL + o.route;
	
		// provide default values
		o.params = o.params || [];
		if (~['get', 'del'].indexOf(o.method) && o.body) {
			console.error('request body can not be sent on get or delete requests, body has been set to null');
			o = _extends({}, o, { body: null });
		}
	
		o.headers = _lodash2.default.merge({
			Accept: '*/*',
			'Accept-Encoding': 'gzip, deflate, sdch, br',
			'Content-Type': !o.body || typeof o.body === 'string' ? // intelligently determine content type
			'text/plain' : o.body instanceof (isServer ? Buffer : Blob) ? o.body.type : o.body instanceof FormData ? 'multipart/form-data' : 'application/json'
		}, this && this.cookiesObj || {}, o.headers || {});
	
		// convert Node.js Buffers to ArrayBuffers which can be sent in requests
		if (isServer && o.body instanceof Buffer) {
			o.body = o.body.buffer.slice(o.body.byteOffset, o.body.byteOffset + o.body.byteLength);
		}
	
		// transform query object into query string format
		o.query = !o.query ? '' : '?' + (0, _querystring.stringify)(o.query);
	
		var methodResMessage = (o.method || '').toUpperCase();
		var fullUrl = (0, _isoPathJoin2.default)(o.route, o.params, o.query);
		var res = { method: methodResMessage }; // explicity add method to response, otherwise it's not included
		var requestConfig = {
			credentials: o.credentials || 'same-origin',
			redirect: o.redirect || 'follow',
			method: o.method,
			headers: new Headers(o.headers), // 'Headers' is a new native global paired with 'fetch'
	
			// enables cors requests for absolute paths not beginning with current site's href
			// note that cookies can't be set with the response on cors requests
			mode: o.mode || (o.route.slice[0] === '/' || baseURL && o.route.indexOf(baseURL) === 0 ? 'same-origin' : 'cors')
		};
	
		// add given body property to requestConfig if not a GET or DELETE request
		if (o.body) {
			requestConfig.body = o.headers['Content-Type'] === 'application/json' && typeof o.body !== 'string' ? JSON.stringify(o.body) : // fetch expects stringified body jsons, not objects
			o.body;
		}
	
		// actual api call occurs here
		return fetch(fullUrl, requestConfig).then(function (unparsedRes) {
			var responseBodyContentType = unparsedRes.headers.get('Content-Type');
	
			// first add props other than body to response, then determine how to parse response
			return _lodash2.default.merge(res, _lodash2.default.omit(unparsedRes, 'body')), !responseBodyContentType || ~responseBodyContentType.indexOf('text') ? unparsedRes.text() : ~responseBodyContentType.indexOf('json') ? unparsedRes.json() : ~responseBodyContentType.indexOf('form') ? unparsedRes.formData() : o.responseType === 'arrayBuffer' ? // allow user to specify arraybuffer vs blob, don't think you can actually determine difference as it seems like different ways to view same data
			unparsedRes.arrayBuffer : unparsedRes.blob();
		}).then(function (body) {
			return (
				// update body with parsed body
				Promise.resolve(_lodash2.default.merge(res, { body: body }))
			);
		}).catch(function (err) {
			// default to fake normal response on request error so that response handlers can deal with it
			if (!Object.keys(res).length) {
				_lodash2.default.merge({
					url: o.route,
					status: 501,
					statusText: methodWithDefault + ' \n ' + o.route + ' \n ' + res.status + ' (' + err.message + ')'
				}, res);
			}
	
			return Promise.reject(res);
		});
	}
	
	// export SimpleIsoFetch class
	module.exports = SimpleIsoFetch;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(61), __webpack_require__(1259).Buffer))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	function merge() {
	  var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var defaults = arguments[1];
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	  return obj;
	}
	module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SimpleDropDownMenu = __webpack_require__(121);
	
	var _SimpleDropDownMenu2 = _interopRequireDefault(_SimpleDropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rexMonthYear = /^(0?[1-9]|1?[0-2])\/([0-9]{2}){1,2}$/g;
	var rexYear = /^([0-9]{2}){1,2}$/g;
	
	var DateInputDropDown = (_temp = _class = function (_React$Component) {
	  _inherits(DateInputDropDown, _React$Component);
	
	  function DateInputDropDown(props, context) {
	    _classCallCheck(this, DateInputDropDown);
	
	    var _this = _possibleConstructorReturn(this, (DateInputDropDown.__proto__ || Object.getPrototypeOf(DateInputDropDown)).call(this, props, context));
	
	    _this.handleTextChange = function (event, index, value) {
	      var newState = (0, _lodash.merge)({}, _this.state);
	      newState.textValue = _this.monthDropdown.state.value + '/' + _this.yearDropdown.state.value;
	      newState.monthValue = _this.monthDropdown.state.value;
	      newState.yearValue = _this.yearDropdown.state.value;
	
	      newState.isValid = _this.isValidFormat(newState.textValue);
	      newState.dateValue = newState.isValid ? _this.normalizeValue(newState.textValue) : null;
	
	      // if minDate provided, we need to validate against the minDate.
	      newState.isFuture = true;
	      if (_this.props.minDate && newState.isValid) {
	        newState.isValid = newState.isFuture = (0, _moment2.default)(newState.dateValue).isSameOrAfter(_this.props.minDate, 'day');
	        newState.dateValue = newState.isValid ? newState.dateValue : null;
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(Object.assign({}, event, { target: { value: newState.dateValue } }));
	      }
	      _this.setState(newState);
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(Object.assign({}, event, { target: { value: _this.state.dateValue } }));
	      }
	    };
	
	    var dateValue = _this.normalizeValue(props.value || props.defaultValue);
	    var textValue = _this.formatDateString(dateValue, props.dateFormat);
	
	    var monthValue = (0, _moment2.default)(dateValue).format('M');
	    var yearValue = (0, _moment2.default)(dateValue).format('YYYY');
	
	    _this.state = {
	      dateValue: dateValue,
	      textValue: textValue,
	      monthValue: monthValue,
	      yearValue: yearValue,
	      monthArray: (0, _lodash.range)(1, 13),
	      yearArray: (0, _lodash.range)((0, _moment2.default)().add(props.includeFuture ? 10 : 0, 'year').format('YYYY'), 1940, -1),
	      isValid: true,
	      isFuture: true
	    };
	    return _this;
	  }
	
	  _createClass(DateInputDropDown, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // clear dropdowns if value reset to null.
	      if (nextProps.hasOwnProperty('value') && (0, _lodash.isNil)(nextProps.value)) {
	        this.setState({ monthValue: null, yearValue: null });
	      }
	    }
	  }, {
	    key: 'normalizeValue',
	    value: function normalizeValue(value) {
	      if (typeof value === 'string') {
	        if (value.match(rexMonthYear)) {
	          var _value$split = value.split('/'),
	              _value$split2 = _slicedToArray(_value$split, 2),
	              month = _value$split2[0],
	              year = _value$split2[1];
	
	          return new Date(year, parseInt(month) - 1); // Jan = 0, Dec = 11
	        } else if (value.match(rexYear)) {
	          return new Date(value, 0); // Jan = 0
	        } else if ((0, _moment2.default)(value).isValid()) {
	          return new Date(value);
	        }
	      } else if (value instanceof Date) {
	        return value;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'formatDateString',
	    value: function formatDateString(value, format) {
	      if (!(0, _moment2.default)(value).isValid()) {
	        return undefined;
	      }
	
	      switch (format) {
	        case 'Year':
	          return (0, _moment2.default)(value).format('YYYY');
	
	        case 'MonthYear':
	          return (0, _moment2.default)(value).format('MM/YYYY');
	
	        default:
	          return (0, _moment2.default)(value).format('L');
	
	      }
	    }
	  }, {
	    key: 'isValidFormat',
	    value: function isValidFormat(stringDate) {
	      return this.props.dateFormat === 'Year' ? !!stringDate.match(rexYear) : this.props.dateFormat === 'MonthYear' ? !!stringDate.match(rexMonthYear) : (0, _moment2.default)(stringDate, ['MM/DD/YYYY', 'MM/DD/YY', 'MM/D/YYYY', 'M/DD/YYYY', 'M/D/YYYY', 'M/D/YY'], true).isValid();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this,
	          _React$createElement,
	          _React$createElement2;
	
	      var _props = this.props,
	          className = _props.className,
	          errorText = _props.errorText,
	          autoOk = _props.autoOk,
	          includeDefault = _props.includeDefault,
	          floatingLabelText = _props.floatingLabelText,
	          hintText = _props.hintText,
	          isDirty = _props.isDirty,
	          minDate = _props.minDate,
	          labelStyle = _props.labelStyle,
	          underlineStyle = _props.underlineStyle,
	          iconStyle = _props.iconStyle,
	          disabled = _props.disabled,
	          style = _props.style,
	          otherProps = _objectWithoutProperties(_props, ['className', 'errorText', 'autoOk', 'includeDefault', 'floatingLabelText', 'hintText', 'isDirty', 'minDate', 'labelStyle', 'underlineStyle', 'iconStyle', 'disabled', 'style']);
	
	      var defaultErrorMessage = !this.state.isValid ? 'Invalid date format.' : undefined;
	
	      var defaultClassName = className || 'date-input';
	
	      var errorStr = errorText || defaultErrorMessage;
	
	      var errorMessage = void 0;
	
	      var isError = isDirty && (typeof errorStr !== 'undefined' || this.state.errors.length);
	
	      // handle error state visually
	      if (isError) {
	        errorMessage = _react2.default.createElement(
	          'div',
	          { className: 'error-message' },
	          errorStr
	        );
	      }
	
	      // if minDate provided, we need to validate against the minDate.
	      if (this.props.minDate && !this.state.isFuture) {
	        errorMessage = _react2.default.createElement(
	          'div',
	          { className: 'error-message' },
	          'Please enter a date after From Date.'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: defaultClassName + '-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text-prompt-left' },
	          floatingLabelText
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'date-input-dropdowns' },
	          _react2.default.createElement(_SimpleDropDownMenu2.default, (_React$createElement = { className: 'date-month-dropdown'
	          }, _defineProperty(_React$createElement, 'className', defaultClassName + '-month'), _defineProperty(_React$createElement, 'hintText', 'Month'), _defineProperty(_React$createElement, 'ref', function ref(input) {
	            _this2.monthDropdown = input;
	          }), _defineProperty(_React$createElement, 'canAutoPosition', true), _defineProperty(_React$createElement, 'includeDefault', true), _defineProperty(_React$createElement, 'data-id', this.props['data-id'] + '-month'), _defineProperty(_React$createElement, 'onChange', this.handleTextChange), _defineProperty(_React$createElement, 'onBlur', this.handleBlur), _defineProperty(_React$createElement, 'value', parseInt(this.state.monthValue) || ''), _defineProperty(_React$createElement, 'primaryText', 'Month'), _defineProperty(_React$createElement, 'menuItems', this.state.monthArray), _defineProperty(_React$createElement, 'labelStyle', labelStyle), _defineProperty(_React$createElement, 'underlineStyle', underlineStyle), _defineProperty(_React$createElement, 'iconStyle', iconStyle), _defineProperty(_React$createElement, 'disabled', disabled), _defineProperty(_React$createElement, 'style', style), _React$createElement)),
	          _react2.default.createElement(_SimpleDropDownMenu2.default, (_React$createElement2 = { className: 'date-year-dropdown'
	          }, _defineProperty(_React$createElement2, 'className', defaultClassName + '-year'), _defineProperty(_React$createElement2, 'hintText', 'Year'), _defineProperty(_React$createElement2, 'ref', function ref(input) {
	            _this2.yearDropdown = input;
	          }), _defineProperty(_React$createElement2, 'canAutoPosition', true), _defineProperty(_React$createElement2, 'includeDefault', true), _defineProperty(_React$createElement2, 'data-id', this.props['data-id'] + '-year'), _defineProperty(_React$createElement2, 'onChange', this.handleTextChange), _defineProperty(_React$createElement2, 'onBlur', this.handleBlur), _defineProperty(_React$createElement2, 'value', parseInt(this.state.yearValue) || ''), _defineProperty(_React$createElement2, 'primaryText', 'Year'), _defineProperty(_React$createElement2, 'menuItems', this.state.yearArray), _defineProperty(_React$createElement2, 'labelStyle', labelStyle), _defineProperty(_React$createElement2, 'underlineStyle', underlineStyle), _defineProperty(_React$createElement2, 'iconStyle', iconStyle), _defineProperty(_React$createElement2, 'disabled', disabled), _defineProperty(_React$createElement2, 'style', style), _React$createElement2)),
	          errorMessage
	        )
	      );
	    }
	  }]);
	
	  return DateInputDropDown;
	}(_react2.default.Component), _class.propTypes = {
	  onBlur: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  dateFormat: _react.PropTypes.oneOf(['Full', 'MonthYear', 'Year']),
	  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.instanceOf(Date)]),
	  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.instanceOf(Date)]),
	  floatingLabelText: _react.PropTypes.string,
	  hintText: _react.PropTypes.string,
	  errorText: _react.PropTypes.string,
	  includeFuture: _react.PropTypes.bool,
	  minDate: _react.PropTypes.object,
	  includeDefault: _react.PropTypes.bool,
	  'data-id': _react.PropTypes.string,
	  labelStyle: _react.PropTypes.object,
	  underlineStyle: _react.PropTypes.object,
	  iconStyle: _react.PropTypes.object
	}, _class.defaultProps = {
	  dateFormat: 'Full'
	}, _temp);
	exports.default = DateInputDropDown;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint-disable no-unused-vars,react/prop-types */
	// noinspection JSUnusedLocalSymbols,JSUnresolvedVariable
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _RaisedButton = __webpack_require__(386);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _DeleteIcon = __webpack_require__(301);
	
	var _DeleteIcon2 = _interopRequireDefault(_DeleteIcon);
	
	var _SearchIcon = __webpack_require__(167);
	
	var _SearchIcon2 = _interopRequireDefault(_SearchIcon);
	
	var _EditJobIcon = __webpack_require__(885);
	
	var _EditJobIcon2 = _interopRequireDefault(_EditJobIcon);
	
	var _CloneIcon = __webpack_require__(884);
	
	var _CloneIcon2 = _interopRequireDefault(_CloneIcon);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _InfoIcon = __webpack_require__(204);
	
	var _InfoIcon2 = _interopRequireDefault(_InfoIcon);
	
	var _staticData = __webpack_require__(28);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jobrequests = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests2);
	
	var _jobrequestDocuments = __webpack_require__(318);
	
	var jobRequestDocumentsStore = _interopRequireWildcard(_jobrequestDocuments);
	
	var _jobrequestDocuments2 = __webpack_require__(236);
	
	var jobRequestDocumentsApi = _interopRequireWildcard(_jobrequestDocuments2);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _rcPager = __webpack_require__(280);
	
	var _rcPager2 = _interopRequireDefault(_rcPager);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _PreviousIcon = __webpack_require__(233);
	
	var _PreviousIcon2 = _interopRequireDefault(_PreviousIcon);
	
	var _NextIcon = __webpack_require__(232);
	
	var _NextIcon2 = _interopRequireDefault(_NextIcon);
	
	var _parentChildList = __webpack_require__(169);
	
	var _Table = __webpack_require__(72);
	
	var _f_InfoModal = __webpack_require__(122);
	
	var _f_InfoModal2 = _interopRequireDefault(_f_InfoModal);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// noinspection JSCheckFunctionSignatures
	var JobRequestTable = (_dec = (0, _reactRedux.connect)(function (store) {
	  var staticData = store.staticData;
	  var pathname = store.routing.locationBeforeTransitions.pathname;
	  return {
	    staticData: staticData,
	    pathname: pathname,
	    labels: (0, _lodash.get)(store, 'labels.JobRequestDashboard.jobRequestTable', {}),
	    bqpMigrationFeature: store.staticData.featureToggles.find(function (feature) {
	      return feature.hardcodelink === 'BQP_MIGRATION_FEATURE';
	    }).value === true,
	    bqpClientMigrationLabels: store.labels.Client.BqpClientMigration,
	    contact: store.contactProfile,
	    employeeMode: store.user.roles.indexOf('Client') === -1
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(JobRequestTable, _Component);
	
	  function JobRequestTable(props, context) {
	    _classCallCheck(this, JobRequestTable);
	
	    var _this = _possibleConstructorReturn(this, (JobRequestTable.__proto__ || Object.getPrototypeOf(JobRequestTable)).call(this, props, context));
	
	    _this.state = {
	      showHeader: (0, _lodash.get)(_this.props, 'showHeader', true),
	      showSearch: (0, _lodash.get)(_this.props, 'showSearch', true),
	      showFilters: (0, _lodash.get)(_this.props, 'showFilters', true),
	      showContactFilter: (0, _lodash.get)(_this.props, 'showContactFilter', true),
	      columns: _this.props.columns !== undefined ? _this.props.columns : ['Id', 'DateCreated', 'DateSubmitted', 'Title', 'Openings', 'Contact', 'Status', 'Buttons'],
	      sortBy: {
	        field: 'dateCreated',
	        order: 'desc'
	      },
	
	      // jobRequestsList: get(this.props, 'jobRequestsList', []),
	      placementSpecialists: _this.props.staticData.placementSpecialists,
	      filters: {},
	      terms: [],
	      pageSize: 25,
	      currentPage: 0,
	      hasPagination: (0, _lodash.includes)(_this.props, '/admin/jobrequests'), // include pagination just for 'admin/jobrequests' for now
	      showBqpMigrationModal: false
	    };
	
	    _this.getFilterAttributes = function (fieldName, label, listName, menuItems) {
	      return {
	        onChange: _this.onChangeFilter(fieldName),
	        floatingLabelText: label,
	        key: fieldName + ' ' + (0, _lodash.get)(_this.props.filters, fieldName, -1),
	        value: (0, _lodash.get)(_this.props.filters, fieldName, -1),
	        className: 'dropdown-filter',
	        menuItems: menuItems ? menuItems : _this.generateMenuItems(_this.props.staticData, listName)
	      };
	    };
	
	    _this.getJobLink = function (id) {
	
	      if ((0, _lodash.includes)(_this.props.pathname, 'admin')) {
	        return '/admin/jobrequests/' + id;
	      } else if ((0, _lodash.includes)(_this.props.pathname, 'client')) {
	        return '/client/jobrequest/' + id + '/confirmation';
	      }
	    };
	
	    _this.cloneDisabled = function (jobRequest) {
	      var DNC = _this.props.staticData.companyStatus.find(function (status) {
	        return status.name === 'DNC';
	      });
	      return _this.getContact(jobRequest.primaryContactId).company.companyStatus === DNC.id ? 'disabled' : '';
	    };
	
	    _this.disableEditButton = function (jobRequest) {
	
	      if (_this.props.disableEditButton) {
	        return _this.props.disableEditButton(jobRequest);
	      }
	
	      return false;
	    };
	
	    _this.doDelete = function () {
	      var deleteJobRequest = function deleteJobRequest(jobId) {
	        return _this.props.dispatch(jobRequestApi.deleteJobRequest(jobId));
	      };
	      deleteJobRequest(_this.state.deleteId).then(function () {
	        _this.fetchJobRequests(_this.props.searchTerms, _this.props.filters);
	        _this.setState({ showTransitionBlocker: false, deleteId: null });
	      });
	    };
	
	    _this.onChangeSearch = _this.onChangeSearch.bind(_this);
	    _this.onChangeFilter = _this.onChangeFilter.bind(_this);
	    _this.handleSkip = _this.handleSkip.bind(_this);
	    _this.fetchJobRequests = _this.fetchJobRequests.bind(_this);
	    _this.renderCityState = _this.renderCityState.bind(_this);
	
	    _this.getFilterAttributes = _this.getFilterAttributes.bind(_this);
	
	    _this.parentChildHandlers = (0, _parentChildList.parentChildList)();
	
	    return _this;
	  }
	
	  _createClass(JobRequestTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // fetch all jobRequests if we don't have them
	      this.fetchJobRequests(this.props.searchTerms || [], this.props.filters || {});
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var oldFilters = prevProps.filters;
	      var oldTerms = prevProps.searchTerms;
	
	      // only fetch if filters or search terms have changed
	
	      if (!(0, _lodash.isEqual)(oldFilters, this.props.filters) || !(0, _lodash.isEqual)(oldTerms, this.props.searchTerms)) {
	        this.fetchJobRequests(this.props.searchTerms, this.props.filters, this.state.currentPage * this.state.pageSize);
	      }
	    }
	  }, {
	    key: 'onChangeFilter',
	    value: function onChangeFilter(filterName) {
	      var _this2 = this;
	
	      return function (event, key) {
	        var newFilters = (0, _lodash.cloneDeep)(_this2.props.filters) || {};
	
	        if (key < 0 || key === undefined) {
	          newFilters = (0, _lodash.omit)(newFilters, filterName);
	        } else {
	          (0, _lodash.set)(newFilters, filterName, key);
	        }
	
	        if (_this2.props.onJobRequestFilterChange) {
	          _this2.props.onJobRequestFilterChange(newFilters);
	        }
	
	        _this2.setState(_extends({}, _this2.state, { currentPage: 0 }));
	      };
	    }
	  }, {
	    key: 'onChangeSearch',
	    value: function onChangeSearch(event) {
	      var _this3 = this;
	
	      // noinspection JSCheckFunctionSignatures
	      var value = event.target.value ? String(event.target.value) : null;
	      this.setState({ currentPage: 0 }, function () {
	        _this3.props.onJobRequestTermsChange(value || []);
	      });
	    }
	  }, {
	    key: 'getContact',
	    value: function getContact(primaryContactId) {
	      var contact = (0, _lodash.find)(this.props.contacts, function (c) {
	        return c.profile.id === primaryContactId;
	      });
	
	      if (contact) {
	        return contact;
	      }
	    }
	  }, {
	    key: 'loadJob',
	    value: function loadJob(id) {
	      var _this4 = this;
	
	      var path = this.getJobLink(id);
	
	      return function (event) {
	        _this4.props.dispatch(ui.showSpinner());
	        _this4.props.dispatch((0, _reactRouterRedux.push)(path));
	      };
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete(row) {
	      var _this5 = this;
	
	      return function () {
	        if (row.jobRequestStatus === 1) {
	          _this5.setState({ showTransitionBlocker: true, deleteId: row.id });
	        }
	      };
	    }
	  }, {
	    key: 'handleEditJob',
	    value: function handleEditJob(row) {
	      var _this6 = this;
	
	      return function (event) {
	        if (!_this6.props.bqpMigrationFeature || _this6.props.employeeMode) {
	          // save the fact that we've shown the migration modal in this session
	          if (row.jobRequestStatus <= 2) {
	            _this6.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + row.id));
	          }
	        }
	
	        // eslint-disable-next-line no-else-return
	        else {
	            _this6.setState(_extends({}, _this6.state, { showBqpMigrationModal: true }));
	          }
	      };
	    }
	  }, {
	    key: 'handleClone',
	    value: function handleClone(row) {
	      var _this7 = this;
	
	      return function () {
	        if (!_this7.props.bqpMigrationFeature || _this7.props.employeeMode) {
	          // save the fact that we've shown the migration modal in this session
	          var getDocuments = function getDocuments(primaryContactId, jobId) {
	            return _this7.props.dispatch(jobRequestDocumentsApi.getJobRequestDocuments(primaryContactId, jobId));
	          };
	
	          getDocuments(row.primaryContactId, row.id).then(function (documents) {
	
	            // Move JobRequest and documents to store.
	
	            _this7.props.dispatch(jobRequestDocumentsStore.updateJobRequestDocuments(documents));
	            _this7.props.dispatch(jobRequestStore.updateJobRequest(row));
	
	            _this7.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest?clone'));
	          });
	        }
	
	        // eslint-disable-next-line no-else-return
	        else {
	            _this7.setState(_extends({}, _this7.state, { showBqpMigrationModal: true }));
	          }
	      };
	    }
	  }, {
	    key: 'handleSkip',
	    value: function handleSkip(page) {
	      this.setState({ currentPage: page });
	      this.fetchJobRequests(this.props.searchTerms, this.props.filters, page * this.state.pageSize);
	    }
	  }, {
	    key: 'employeesToMenuItems',
	    value: function employeesToMenuItems() {
	      var employees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var menuItems = employees.map(function (employee) {
	        return {
	          primaryText: employee.firstName + ' ' + employee.lastName,
	          value: employee.employeeId
	        };
	      });
	
	      return (0, _lodash.concat)({ value: -1, primaryText: 'All' }, menuItems);
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'contactsToMenuItems',
	    value: function contactsToMenuItems(contacts) {
	      var menuItems = (0, _lodash.map)(contacts, function (contact) {
	        return {
	          value: contact.profile.id,
	          primaryText: contact.user.firstName + ' ' + contact.user.lastName
	        };
	      });
	
	      return (0, _lodash.concat)({ value: -1, primaryText: 'All' }, menuItems);
	    }
	  }, {
	    key: 'generateMenuItems',
	    value: function generateMenuItems(staticData, type) {
	      var object = staticData[type];
	
	      var menuItems = (0, _lodash.map)(object, function (item) {
	        return {
	          value: item.id || item.value,
	          primaryText: item.name || item.primaryText,
	          parentId: item.parentId
	        };
	      });
	
	      return (0, _lodash.concat)({ value: -1, primaryText: 'All' }, menuItems);
	    }
	  }, {
	    key: 'fetchJobRequests',
	    value: function fetchJobRequests() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var skip = arguments[2];
	
	      filters.order = filters.order || this.state.sortBy.order;
	      filters.by = filters.by || this.state.sortBy.field;
	      if (this.props.fetchJobs) this.props.fetchJobs(filters, terms, skip);
	    }
	  }, {
	    key: 'flipColumn',
	    value: function flipColumn(column) {
	      var order = this.props.filters.by === column && this.props.filters.order === 'desc' ? 'asc' : 'desc';
	      var newFilters = (0, _lodash.merge)({}, (0, _lodash.cloneDeep)(this.props.filters), { order: order, by: column });
	
	      if (this.props.onJobRequestFilterChange) {
	        this.props.onJobRequestFilterChange(newFilters);
	      }
	    }
	
	    // Render functions for each column
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderId',
	    value: function renderId(header, row, index) {
	      return this.renderIdWithLink(header, row, index, true);
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderIdNoLink',
	    value: function renderIdNoLink(header, row, index) {
	      return this.renderIdWithLink(header, row, index, false);
	    }
	  }, {
	    key: 'renderIdWithLink',
	    value: function renderIdWithLink(header, row, index, showLink) {
	      if (header) {
	        return this.renderHeader('Job #', 'job-number', 'id', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Job Number' + index, className: 'job-number' },
	        showLink && !this.props.linksInNewTab && _react2.default.createElement(
	          'div',
	          { className: 'text-link', onClick: this.loadJob(row.id) },
	          row.id
	        ),
	        showLink && this.props.linksInNewTab && _react2.default.createElement(
	          'a',
	          { className: 'text-link', target: '_blank', href: this.getJobLink(row.id) },
	          row.id
	        ),
	        !showLink && _react2.default.createElement(
	          'div',
	          null,
	          row.id
	        )
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderDate',
	    value: function renderDate(header, row, index) {
	      // Handle legacy use of 'Date' instead of specifying 'DateCreated' or 'DateSubmitted'
	      return this.renderDateCreated(header, row, index);
	    }
	  }, {
	    key: 'renderDateCreated',
	    value: function renderDateCreated(header, row, index) {
	      if (header) {
	        return this.renderHeader('Date Added', 'date-added', 'dateCreated', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Date Added' + index, className: 'date-added' },
	        (0, _moment2.default)(row.dateCreated).format('L')
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderDateSubmitted',
	    value: function renderDateSubmitted(header, row, index) {
	      if (header) {
	        return this.renderHeader('Date Submitted', 'date-authorized', 'dateAuthorized', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Date Submitted' + index, className: 'date-authorized' },
	        row.dateAuthorized !== null ? (0, _moment2.default)(row.dateAuthorized).format('L') : ''
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(header, row, index) {
	      if (header) {
	        return this.renderHeader('Job Title', 'job-title', 'positionTypeId', true, 2);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { colSpan: 2, key: 'Job Title' + index, 'data-id': 'Job Title' + index, className: 'job-title' },
	        (0, _staticData.lookup)(this.props.staticData, 'positionTypes', { id: row.positionTypeId })
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderOpenings',
	    value: function renderOpenings(header, row, index) {
	      if (header) {
	        return this.renderHeader('Openings');
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Openings' + index, 'data-id': 'Openings' + index, className: 'openings' },
	        row.numberOfPeople
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderContact',
	    value: function renderContact(header, row, index) {
	      if (header) {
	        return this.renderHeader('Contact');
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Contact' + index, 'data-id': 'Contact' + index, className: 'contact' },
	        row.primaryContact && _react2.default.createElement(
	          'span',
	          null,
	          row.primaryContact
	        )
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderCompany',
	    value: function renderCompany(header, row, index) {
	      if (header) {
	        return this.renderHeader('Company', 'company-name');
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Contact' + index, 'data-id': 'Contact' + index, className: 'contact' },
	        row.companyName && _react2.default.createElement(
	          'span',
	          null,
	          row.companyName
	        )
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderStatus',
	    value: function renderStatus(header, row, index, status) {
	      if (header) {
	        return this.renderHeader('Status', 'status', 'jobRequestStatus', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Status #' + index, 'data-id': 'Status #' + index, className: 'status' },
	        _react2.default.createElement('div', { className: 'status-circle', 'data-id': 'Status Icon', style: { backgroundColor: status.color, borderColor: status.color } }),
	        status.name
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(headerText, className) {
	      var columnName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var _this8 = this;
	
	      var isSortable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var colspan = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
	
	      if (!className) {
	        className = (0, _lodash.replace)((0, _lodash.lowerCase)(headerText), ' ', '-');
	      }
	      return _react2.default.createElement(
	        _Table.TableHeaderColumn,
	        { colSpan: colspan, className: (0, _classnames2.default)(className, { 'wv-pointer': isSortable }) },
	        _react2.default.createElement(
	          'div',
	          { onClick: isSortable ? function (e) {
	              return _this8.flipColumn(columnName);
	            } : '' },
	          headerText,
	          isSortable && _react2.default.createElement(
	            'span',
	            { className: (0, _classnames2.default)('wv-chevron', { active: this.props.filters && this.props.filters.by === columnName }, { flipped: this.props.filters && this.props.filters.by === columnName && this.props.filters.order !== 'desc' }) },
	            _react2.default.createElement(_ChevronIcon2.default, null)
	          )
	        )
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderActions',
	    value: function renderActions(header, row, index, status) {
	
	      if (header) {
	        return this.renderHeader('Actions', 'actions', undefined, false, 3);
	      }
	
	      var disabled = this.disableEditButton(row) || status.id > 2;
	      var disableClone = this.cloneDisabled(row);
	      var disableDelete = status.id > 1 || this.props.bqpMigrationFeature && !this.props.employeeMode ? 'disabled' : '';
	
	      // overflow visible hack for tooltips in TableRowColumn
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { colSpan: 3, key: 'Actions ' + index, 'data-id': 'Actions ' + index, className: 'actions', style: { overflow: 'visible' } },
	        _react2.default.createElement(_RaisedButton2.default, { label: 'View',
	          labelStyle: { textTransform: 'None' },
	          icon: _react2.default.createElement(_InfoIcon2.default, { className: 'action-button' }),
	          variant: 'outlined',
	          className: 'action-button',
	          tooltip: 'View',
	          tooltipPosition: 'bottom-center',
	          target: '_blank',
	          href: this.getJobLink(row.id)
	        }),
	        _react2.default.createElement(_RaisedButton2.default, { label: 'Edit',
	          labelStyle: { textTransform: 'None' },
	          icon: _react2.default.createElement(_EditJobIcon2.default, { className: 'action-button' }),
	          variant: 'outlined',
	          'data-id': 'Edit' + index,
	          className: (0, _classnames2.default)('action-button', { disabled: disabled }),
	          tooltip: 'Edit',
	          tooltipPosition: 'bottom-center',
	          onClick: this.handleEditJob(row),
	          primary: false
	
	        }),
	        _react2.default.createElement(_RaisedButton2.default, { label: 'Clone',
	          labelStyle: { textTransform: 'None' },
	          icon: _react2.default.createElement(_CloneIcon2.default, { className: 'action-button' }),
	          variant: 'outlined',
	          'data-id': 'Clone' + index,
	          className: (0, _classnames2.default)('action-button', disableClone),
	          tooltip: 'Copy',
	          tooltipPosition: 'bottom-center',
	          onClick: this.handleClone(row),
	          primary: false
	        }),
	        _react2.default.createElement(_RaisedButton2.default, { label: 'Delete',
	          labelStyle: { textTransform: 'None' },
	          icon: _react2.default.createElement(_DeleteIcon2.default, { className: 'action-button' }),
	          variant: 'outlined',
	          'data-id': 'Delete' + index,
	          className: (0, _classnames2.default)('action-button', disableDelete),
	          tooltip: 'Delete',
	          tooltipPosition: 'bottom-center',
	          onClick: this.handleDelete(row),
	          primary: false
	        })
	      );
	    }
	  }, {
	    key: 'renderCityState',
	    value: function renderCityState(header, row, index, status) {
	      if (header) {
	        return this.renderHeader('City & State', 'city-state');
	      }
	
	      var state = (0, _lodash.find)(this.props.staticData.stateList, function (s) {
	        return s.id === (row.state ? row.state : row.companyState);
	      });
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'CityState' + index, 'data-id': 'CityState' + index, className: 'city-state' },
	        row.city ? row.city + ', ' : row.companyCity ? row.companyCity + ', ' : '',
	        ' ',
	        state ? state.abbreviation : ''
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderFirm',
	    value: function renderFirm(header, row, index, status) {
	      if (header) {
	        return this.renderHeader(this.props.labels.tableRowHeaders.firmType);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Firm' + index, 'data-id': 'Firm' + index, className: 'firm-type' },
	        (0, _staticData.lookup)(this.props.staticData, 'industryTypesList', { id: row.industryTypeId })
	      );
	    }
	
	    // noinspection JSUnusedGlobalSymbols
	
	  }, {
	    key: 'renderIndustry',
	    value: function renderIndustry(header, row, index, status) {
	      if (header) {
	        return this.renderHeader('Industry Segment');
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Segment' + index, 'data-id': 'Segment' + index, className: 'industry-segment' },
	        (0, _staticData.lookup)(this.props.staticData, 'jobRequestSegmentTypes', { id: row.segmentTypeId })
	      );
	    }
	    // save the fact that we've shown the migration modal in this session
	
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState((0, _lodash.merge)(this.state, { showBqpMigrationModal: false }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var company = void 0,
	          clientAdviser = void 0,
	          relationshipManager = void 0;
	      var migrationText = void 0,
	          migrationModalEmailLink = void 0,
	          migrationOtherContacts = void 0;
	
	      if (this.props.bqpMigrationFeature && !this.props.employeeMode) {
	        company = this.props.contact.company;
	        clientAdviser = this.props.staticData.clientAdvisers && this.props.staticData.clientAdvisers.find(function (ca) {
	          return company.clientAdvisorId === ca.employeeId;
	        });
	        relationshipManager = this.props.staticData.relationshipManagers && this.props.staticData.relationshipManagers.find(function (ca) {
	          return company.relationshipManagerId === ca.employeeId;
	        });
	
	        migrationText = this.props.bqpClientMigrationLabels.message;
	        migrationModalEmailLink = _react2.default.createElement(
	          'div',
	          { className: 'migration-modal-font-color' },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:sales@wahve.com' },
	            this.props.bqpClientMigrationLabels.emailLinkText
	          )
	        );
	        migrationOtherContacts = (clientAdviser || relationshipManager) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'If you prefer, you can also reach out to one of your WAHVE team members.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          clientAdviser && _react2.default.createElement(
	            'div',
	            null,
	            'Client Advisor:',
	            _react2.default.createElement(
	              'span',
	              null,
	              ' ' + clientAdviser.firstName + ' ' + clientAdviser.lastName,
	              ', \u2022 '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'migration-modal-font-color' },
	              clientAdviser.phoneNumber && (0, _prettyPhone2.default)(clientAdviser.phoneNumber) + ' \u2022 ',
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:' + clientAdviser.email },
	                clientAdviser.email
	              )
	            )
	          ),
	          relationshipManager && _react2.default.createElement(
	            'div',
	            null,
	            'Relationship Manager:',
	            _react2.default.createElement(
	              'span',
	              null,
	              ' ' + relationshipManager.firstName + ' ' + relationshipManager.lastName,
	              ', \u2022 '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'migration-modal-font-color' },
	              relationshipManager.phoneNumber && (0, _prettyPhone2.default)(relationshipManager.phoneNumber) + ' \u2022 ',
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:' + relationshipManager.email },
	                relationshipManager.email
	              )
	            )
	          )
	        );
	      }
	
	      var jobs = (0, _lodash.get)(this.props, 'jobRequestsList', []);
	
	      var total = jobs.length > 0 ? jobs[0].total_count : 0;
	      var currentCount = this.state.pageSize * (this.state.currentPage + 1);
	      currentCount = currentCount < total ? currentCount : total;
	
	      var _parentChildHandlers = this.parentChildHandlers({
	        parentProps: this.getFilterAttributes('industryTypeId', this.props.labels.filterLabels.firmTypesFilter, 'industryTypesList'),
	        childProps: this.getFilterAttributes('segmentTypeId', 'Industry Segment', 'jobRequestSegmentTypes')
	      }),
	          industryTypeProps = _parentChildHandlers.parent,
	          segmentTypeProps = _parentChildHandlers.child;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-table info-table' },
	        this.state.showSearch && _react2.default.createElement(
	          'header',
	          { className: 'job-request-history-header' },
	          this.state.showHeader && _react2.default.createElement(
	            'div',
	            { className: 'job-request-history-title-container' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'job-request-history-title' },
	              'JOB REQUESTS'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'job-request-history-search-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'job-request-history-search' },
	              _react2.default.createElement(_SearchIcon2.default, null),
	              _react2.default.createElement('input', { onChange: function onChange(event) {
	                  return _this9.onChangeSearch(event);
	                },
	                'data-id': 'Search',
	                ref: 'search',
	                className: 'search-input',
	                type: 'text',
	                placeholder: 'Search by ID...',
	                value: this.props.searchTerms || '' })
	            )
	          )
	        ),
	        this.state.showFilters && _react2.default.createElement(
	          'div',
	          { className: 'job-request-history-filter' },
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            'data-id': 'status-dropdown'
	          }, this.getFilterAttributes('jobRequestStatus', 'Status', 'jobRequestStatus'))),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            'data-id': 'industry-dropdown'
	          }, industryTypeProps)),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            'data-id': 'segment-dropdown'
	          }, segmentTypeProps)),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            'data-id': 'placement-specialist-dropdown'
	          }, this.getFilterAttributes('placementSpecialistId', 'Placement Specialist', 'placementSpecialists', this.employeesToMenuItems(this.state.placementSpecialists))))
	        ),
	        this.state.hasPagination && _react2.default.createElement(
	          'div',
	          { className: 'pager-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pager-info' },
	            'Showing ',
	            _react2.default.createElement(
	              'span',
	              { className: 'count' },
	              currentCount
	            ),
	            ' of ',
	            _react2.default.createElement(
	              'span',
	              { className: 'count' },
	              total
	            )
	          ),
	          _react2.default.createElement(_rcPager2.default, {
	            total: Math.ceil(total / this.state.pageSize),
	            current: this.state.currentPage,
	            onSkipTo: this.handleSkip,
	            previousLabel: _react2.default.createElement(
	              'div',
	              { className: 'prev' },
	              _react2.default.createElement(_PreviousIcon2.default, null),
	              'PREV'
	            ),
	            nextLabel: _react2.default.createElement(
	              'div',
	              { className: 'next' },
	              'NEXT',
	              _react2.default.createElement(_NextIcon2.default, null)
	            )
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'job-request-history-table' },
	          _react2.default.createElement(
	            _Table.Table,
	            { selectable: false,
	              multiSelectable: false,
	              fixedHeader: true,
	              height: this.props.tableHeight || 'calc(100vh - 295px)'
	            },
	            _react2.default.createElement(
	              _Table.TableHeader,
	              { displaySelectAll: false, adjustForCheckbox: false },
	              _react2.default.createElement(
	                _Table.TableRow,
	                null,
	                (0, _lodash.map)(this.state.columns, function (column) {
	                  return _this9['render' + column](true);
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _Table.TableBody,
	              { displayRowCheckbox: false },
	              jobs.length === 0 && _react2.default.createElement(
	                'div',
	                { className: 'table-no-data' },
	                'No Job Requests Available'
	              ),
	              (0, _lodash.map)(jobs, function (row, index) {
	                var status = (0, _staticData.getLookupValue)(_this9.props.staticData, 'jobRequestStatus', { id: row.jobRequestStatus });
	                return _react2.default.createElement(
	                  _Table.TableRow,
	                  { key: '' + row.id, 'data-id': 'Contact ' + row.id },
	                  (0, _lodash.map)(_this9.state.columns, function (column) {
	                    return _this9['render' + column](false, row, index, status);
	                  })
	                );
	              })
	            )
	          )
	        ),
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          secondaryAction: this.doDelete,
	          secondaryButtonLabel: 'Delete',
	          cancelAction: function cancelAction() {
	            return _this9.setState({ showTransitionBlocker: false, deleteId: null });
	          },
	          primaryAction: function primaryAction() {
	            return _this9.setState({ showTransitionBlocker: false, deleteId: null });
	          },
	          primaryButtonLabel: 'Cancel',
	          transitionText: 'Are you sure you want to delete this job request?'
	        }),
	        // show migration modal?
	        this.props.bqpMigrationFeature && this.state.showBqpMigrationModal && !this.props.employeeMode && _react2.default.createElement(
	          'div',
	          { className: 'migration-modal-font-color' },
	          _react2.default.createElement(_f_InfoModal2.default, {
	            buttonLabel: 'close',
	            text: migrationText,
	            children: [migrationModalEmailLink, migrationOtherContacts],
	            cancelFunc: this.closeModal.bind(this),
	            transitionFunc: this.closeModal.bind(this)
	          })
	        )
	      );
	    }
	  }]);
	
	  return JobRequestTable;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  jobRequests: _react.PropTypes.object,
	  jobRequestsList: _react.PropTypes.array,
	  contacts: _react.PropTypes.array,
	  staticData: _react.PropTypes.object,
	  showHeader: _react.PropTypes.bool,
	  showSearch: _react.PropTypes.bool,
	  showFilters: _react.PropTypes.bool,
	  companyId: _react.PropTypes.number,
	  showContactFilter: _react.PropTypes.bool,
	  onJobRequestFilterChange: _react.PropTypes.func,
	  onJobRequestTermsChange: _react.PropTypes.func,
	  fetchJobs: _react.PropTypes.func,
	  columns: _react.PropTypes.array,
	  disableEditButton: _react.PropTypes.func,
	  linksInNewTab: _react.PropTypes.bool,
	  tableHeight: _react.PropTypes.string,
	  filters: _react.PropTypes.object,
	  searchTerms: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
	  labels: _react.PropTypes.object,
	  bqpMigrationFeature: _react.PropTypes.bool,
	  showBqpMigrationModal: _react.PropTypes.bool,
	  bqpClientMigrationLabels: _react.PropTypes.object.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  employeeMode: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = JobRequestTable;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_ButtonGroupItem = __webpack_require__(865);
	
	var _c_ButtonGroupItem2 = _interopRequireDefault(_c_ButtonGroupItem);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonGroup = (_temp2 = _class = function (_Component) {
	  _inherits(ButtonGroup, _Component);
	
	  function ButtonGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      additionalItems: _this.props.value || [],
	      editable: false,
	      addText: '',
	      errors: []
	    }, _this.validate = function (value, mergeObj) {
	      if (_this.props.validation) {
	        var errorsObj = {
	          errors: (0, _modelValidator.validateField)(value, _this.props.validation)
	        };
	        if (errorsObj.errors.length !== _this.state.errors.length) {
	          if (_this.props.onErrorChange) {
	            _this.props.onErrorChange(errorsObj.errors.length > _this.state.errors ? 1 : -1);
	          }
	          _this.setState(_lodash2.default.assign(_this.state, errorsObj, mergeObj || {}));
	        } else if (_lodash2.default.size(mergeObj)) {
	          _this.setState(_lodash2.default.assign(_this.state, mergeObj));
	        }
	      } else if (_lodash2.default.size(mergeObj)) {
	        _this.setState(_lodash2.default.assign(_this.state, mergeObj));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : null;
	      this.validate(initVal);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('' + this.props.value !== '' + nextProps.value) {
	        this.validate(nextProps.value, {
	          additionalItems: _lodash2.default.union(this.state.additionalItems, nextProps.value)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(passedValue, event) {
	      var value = this.props.value.slice();
	      var index = value.indexOf(passedValue);
	      if (index < 0) {
	        value.push(passedValue);
	      } else if (index > -1) {
	        value.splice(index, 1);
	      }
	
	      // handle uncontrolled component validation update
	      if (!this.props.hasOwnProperty('value')) {
	        this.validate(value, {
	          value: value
	        });
	      }
	
	      if (this.props.onChange) {
	        if (passedValue === 'None') {
	          value.length ? this.props.onChange(event, ["None"]) : this.props.onChange(null, []);
	        } else {
	          this.props.onChange(event, value);
	        }
	      }
	      if (this.props.onBlur) {
	        this.props.onBlur(event, value);
	      }
	    }
	  }, {
	    key: 'onEdit',
	    value: function onEdit() {
	      this.setState({ editable: true });
	    }
	  }, {
	    key: 'onAdd',
	    value: function onAdd(event) {
	      var _this2 = this;
	
	      if (event.key === 'Enter') {
	        if (event.target.value) {
	          // Remove . since it's not allowed for custom skills.
	          event.target.value = event.target.value.replace(/\./g, '');
	          var newVal = event.target.value;
	          this.setState({
	            editable: false,
	            addText: ''
	          }, function () {
	            return _this2.onChange(newVal, null);
	          });
	          this.refs.addText.blur();
	        } else if (!event.target.value) {
	          this.setState({ addText: '' });
	          this.refs.addText.blur();
	        }
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      var _this3 = this;
	
	      if (!event.target.value) {
	        this.setState({ editable: false });
	      } else {
	        // Remove . since it's not allowed for custom skills.
	        event.target.value = event.target.value.replace(/\./g, '');
	        var newVal = event.target.value;
	        this.setState({
	          editable: false,
	          addText: ''
	        }, function () {
	          return _this3.onChange(newVal, null);
	        });
	        this.refs.addText.blur();
	      }
	    }
	  }, {
	    key: 'updateText',
	    value: function updateText(event) {
	      this.setState(_extends({}, this.state, { addText: event.target.value }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var items = _lodash2.default.chain(this.props.menuItems).reduce(function (prev, curr) {
	        prev.push(_lodash2.default.get(curr, 'primaryText', curr));
	        return prev;
	      }, []).union(this.state.additionalItems).value();
	
	      var hasNone = this.props.value.includes('None');
	
	      var SHOW_ADD_DEFAULT = true;
	      var showAdd = this.props.showAdd === undefined ? SHOW_ADD_DEFAULT : this.props.showAdd;
	
	      if (hasNone) {
	        items.length = 1;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'button-group-container-wrapper' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'button-group-container' },
	          items.map(function (val, index) {
	            return _react2.default.createElement(_c_ButtonGroupItem2.default, { key: index,
	              value: val,
	              visible: _lodash2.default.isNil(_this4.props.visibleItems) || _this4.props.visibleItems.includes(val),
	              selected: _this4.props.value.includes(val),
	              onClick: _this4.onChange.bind(_this4, val) });
	          }),
	          !hasNone && showAdd && _react2.default.createElement(
	            'li',
	            {
	              className: 'button-group-item add',
	              'data-id': 'ADD',
	              onMouseDown: !this.state.editable && this.onEdit.bind(this) || null },
	            _react2.default.createElement('input', { className: 'adding-button-group-item',
	              placeholder: !this.state.editable && 'ADD' || '',
	              type: 'text',
	              name: 'newItem',
	              ref: 'addText',
	              maxLength: '48',
	              value: this.state.addText,
	              onChange: this.updateText.bind(this),
	              onBlur: this.onBlur.bind(this),
	              onKeyUp: this.onAdd.bind(this) })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ButtonGroup;
	}(_react.Component), _class.propTypes = {
	  defaultValue: _react.PropTypes.array,
	  value: _react.PropTypes.array,
	  id: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  showAdd: _react.PropTypes.bool,
	  menuItems: _react.PropTypes.array.isRequired,
	  visibleItems: _react.PropTypes.array,
	  validation: _react.PropTypes.object,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  onErrorChange: _react.PropTypes.func
	}, _temp2);
	exports.default = ButtonGroup;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NextIcon(props) {
	  return _react2.default.createElement(
	    'svg',
	    { width: '7', height: '12', viewBox: '0 0 7 12', xmlns: 'http://www.w3.org/2000/svg', className: 'next-icon' },
	    _react2.default.createElement(
	      'g',
	      { strokeWidth: '2', stroke: '#333', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' },
	      _react2.default.createElement('path', { d: 'M6 6L1 1.5M1 11l5-4.5' })
	    )
	  );
	}
	
	exports.default = NextIcon;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PreviousIcon(props) {
	  return _react2.default.createElement(
	    'svg',
	    { width: '7', height: '11', viewBox: '0 0 7 11', xmlns: 'http://www.w3.org/2000/svg', className: 'previous-icon' },
	    _react2.default.createElement(
	      'g',
	      { stroke: '#333', strokeWidth: '2', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' },
	      _react2.default.createElement('path', { d: 'M1 5.5L6 1M6 10L1 5.5' })
	    )
	  );
	}
	
	exports.default = PreviousIcon;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fixLines;
	// Knex stored /n in DB for newline characters.
	function fixLines(value) {
	  var newLine = /(\\+)n/g;
	  return value ? value.replace(newLine, '\n') : value;
	}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEmailTemplates = getEmailTemplates;
	exports.createTemplate = createTemplate;
	exports.updateTemplate = updateTemplate;
	exports.deleteTemplate = deleteTemplate;
	exports.sendEmail = sendEmail;
	exports.sendContactEmail = sendContactEmail;
	function getEmailTemplates() {
	  var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var callback = arguments[1];
	
	  if (all === true) {
	    all = 'all';
	  }
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.get('/api/admin/emails/' + all).then(function (_ref) {
	        var templates = _ref.body.data.items;
	
	        if (callback) {
	          return callback(null, templates);
	        }
	        return templates;
	      }).catch(function (err) {
	        if (callback) {
	          return callback(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function createTemplate(body) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.post({ route: '/api/admin/emails/', body: body }).then(function (_ref2) {
	        var templates = _ref2.body.data.items;
	        return templates;
	      });
	    };
	  };
	}
	
	function updateTemplate(id, body) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.put({ route: '/api/admin/emails/' + id, body: body }).then(function (_ref3) {
	        var templates = _ref3.body.data.items;
	        return templates;
	      });
	    };
	  };
	}
	
	function deleteTemplate(id) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.del({ route: '/api/admin/emails/' + id }).then(function (_ref4) {
	        var templates = _ref4.body.data.items;
	        return templates;
	      });
	    };
	  };
	}
	
	function sendEmail(to, cc, subject, html, attachments, callback) {
	  return function (simpleIsoFetch) {
	    return function () {
	      simpleIsoFetch.post({
	        route: '/api/admin/emails/send',
	        body: {
	          to: to,
	          cc: cc,
	          subject: subject,
	          html: html,
	          attachments: attachments
	        }
	      }).then(function () {
	        return callback();
	      }).catch(function (err) {
	        if (callback) {
	          return callback(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function sendContactEmail(contactId, cc, subject, html, attachments, callback) {
	  return function (simpleIsoFetch) {
	    return function () {
	      simpleIsoFetch.post({
	        route: '/api/contacts/' + contactId + '/email',
	        body: {
	          cc: cc,
	          subject: subject,
	          html: html,
	          attachments: attachments
	        }
	      }).then(function () {
	        return callback();
	      }).catch(function (err) {
	        if (callback) {
	          return callback(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getJobRequestDocuments = getJobRequestDocuments;
	exports.createJobRequestDocuments = createJobRequestDocuments;
	exports.updateJobRequestDocuments = updateJobRequestDocuments;
	exports.deleteJobRequestDocuments = deleteJobRequestDocuments;
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _bluebird = __webpack_require__(171);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/* global Symbol */
	function getJobRequestDocuments(contactId, jobId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/contacts/' + contactId + '/jobs/' + jobId + '/documents'
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}
	
	function createJobRequestDocuments(contactId, body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.post({
	        route: '/api/contacts/' + contactId + '/jobs/' + body.jobId + '/documents/' + body.clientId,
	        body: body
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}
	
	function updateJobRequestDocuments(contactId, body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({
	        route: '/api/contacts/' + contactId + '/jobs/' + body.jobId + '/documents/' + body.clientId,
	        body: body
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}
	
	function deleteJobRequestDocuments(contactId, body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.del({
	        route: '/api/contacts/' + contactId + '/jobs/' + body.jobId + '/documents/' + body.clientId,
	        body: body
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body);
	        return resp.body;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	        }
	        return err;
	      });
	    };
	  };
	}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findContact = findContact;
	exports.contactInGroups = contactInGroups;
	exports.findGrouping = findGrouping;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function findContact(criteria, contacts) {
	  return _lodash2.default.filter(contacts, criteria)[0];
	}
	
	function contactInGroups(criteria, contacts) {
	  return _lodash2.default.reduce(contacts, function (list, group, name) {
	    var index = _lodash2.default.findIndex(group, criteria);
	    if (~index) {
	      list.push({ name: name, index: index });
	    }
	    return list;
	  }, []);
	}
	
	function findGrouping(_ref) {
	  var contact = _ref.contact,
	      groups = _ref.groups;
	
	  var group = _lodash2.default.reduce(groups, function (list, group) {
	    if (group.statuses.find(function (status) {
	      return status === contact.profile.contactStatus;
	    })) {
	      list.push(group.name);
	    }
	    return list;
	  }, [])[0];
	  return { contact: contact, group: group };
	}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// See: https://react-legacy.netlify.com/docs/dom-elements.html
	
	exports.stripUnknownProps = stripUnknownProps;
	exports.REACT_KNOWN_ATTRIBUTES = REACT_KNOWN_ATTRIBUTES;
	exports.REACT_KNOWN_ATTRIBUTES_ALL = REACT_KNOWN_ATTRIBUTES_ALL;
	
	var REACT_KNOWN_ATTRIBUTES = {
	    STANDARD: ['accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency', 'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding', 'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className', 'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'controlsList', 'coords', 'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download', 'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang', 'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType', 'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth', 'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted', 'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role', 'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start', 'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width', 'wmode', 'wrap'],
	    RDFA: ['about', 'datatype', 'inlist', 'prefix', 'property', 'resource', 'typeof', 'vocab'],
	    NONSTANDARD: ['autoCapitalize', 'autoCorrect', 'color', 'itemProp', 'itemScope', 'itemType', 'itemRef', 'itemID', 'security', 'unselectable', 'results', 'autoSave'],
	    SVG: ['accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic', 'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth', 'baseFrequency', 'baseProfile', 'baselineShift', 'bbox', 'begin', 'bias', 'by', 'calcMode', 'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation', 'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType', 'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant', 'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode', 'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill', 'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity', 'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName', 'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef', 'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'ideographic', 'imageRendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kernelMatrix', 'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust', 'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight', 'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits', 'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order', 'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness', 'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform', 'patternUnits', 'pointerEvents', 'points', 'pointsAtX', 'pointsAtY', 'pointsAtZ', 'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY', 'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures', 'restart', 'result', 'rotate', 'rx', 'ry', 'scale', 'seed', 'shapeRendering', 'slope', 'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset', 'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity', 'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray', 'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity', 'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY', 'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1', 'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange', 'unitsPerEm', 'vAlphabetic', 'vHanging', 'vIdeographic', 'vMathematical', 'values', 'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'viewBox', 'viewTarget', 'visibility', 'widths', 'wordSpacing', 'writingMode', 'x', 'x1', 'x2', 'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole', 'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlns', 'xmlnsXlink', 'xmlBase', 'xmlLang', 'xmlSpace', 'y', 'y1', 'y2', 'yChannelSelector', 'z', 'zoomAndPan']
	};
	
	var REACT_KNOWN_ATTRIBUTES_ALL = [].concat(_toConsumableArray(REACT_KNOWN_ATTRIBUTES.STANDARD), _toConsumableArray(REACT_KNOWN_ATTRIBUTES.RDFA), _toConsumableArray(REACT_KNOWN_ATTRIBUTES.NONSTANDARD), _toConsumableArray(REACT_KNOWN_ATTRIBUTES.SVG));
	
	function stripUnknownProps(props) {
	
	    var stripped = {};
	    for (var key in REACT_KNOWN_ATTRIBUTES_ALL) {
	        if (props.hasOwnProperty(key)) {
	            stripped[key] = props[key];
	        }
	    }
	    return stripped;
	}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1264), __esModule: true };

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1182);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(239);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 242 */
219,
/* 243 */
156,
/* 244 */
[3174, 1294, 500],
/* 245 */
[3119, 80, 46, 155],
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(29);
	var $export = __webpack_require__(7);
	var redefine = __webpack_require__(78);
	var redefineAll = __webpack_require__(153);
	var meta = __webpack_require__(131);
	var forOf = __webpack_require__(148);
	var anInstance = __webpack_require__(147);
	var isObject = __webpack_require__(38);
	var fails = __webpack_require__(34);
	var $iterDetect = __webpack_require__(252);
	var setToStringTag = __webpack_require__(180);
	var inheritIfRequired = __webpack_require__(344);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(77);
	var redefine = __webpack_require__(78);
	var fails = __webpack_require__(34);
	var defined = __webpack_require__(101);
	var wks = __webpack_require__(41);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(27);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 250 */
[3131, 94],
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(38);
	var cof = __webpack_require__(94);
	var MATCH = __webpack_require__(41)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 252 */
[3136, 41],
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(149) || !__webpack_require__(34)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(29)[K];
	});


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(7);
	var aFunction = __webpack_require__(58);
	var ctx = __webpack_require__(95);
	var forOf = __webpack_require__(148);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(7);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 257 */
[3153, 29],
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(27);
	var aFunction = __webpack_require__(58);
	var SPECIES = __webpack_require__(41)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var hide = __webpack_require__(77);
	var uid = __webpack_require__(156);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 260 */
[3178, 1530],
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = decimal;
	
	/* Check if the given character code, or the character
	 * code at the first character, is decimal. */
	function decimal(character) {
	  var code = typeof character === 'string' ?
	    character.charCodeAt(0) : character;
	
	  return code >= 48 && code <= 57; /* 0-9 */
	}


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1651),
	    listCacheDelete = __webpack_require__(1652),
	    listCacheGet = __webpack_require__(1653),
	    listCacheHas = __webpack_require__(1654),
	    listCacheSet = __webpack_require__(1655);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(578);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1648);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(158);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(377);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(185),
	    getPrototype = __webpack_require__(1636),
	    isObjectLike = __webpack_require__(159);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(1719);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(1722);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(161);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(117);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(626);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(627);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(1732);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var styles = {
	    root: {
	      backgroundColor: (state.isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleNestedListToggle = function (event) {
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      if (this.button) {
	        var buttonEl = _reactDom2.default.findDOMNode(this.button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            this.button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onTouchTap = _props3.onTouchTap,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onTouchTap: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onTouchTap = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: containerElement
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onTouchTap: primaryTogglesNestedList ? this.handleNestedListToggle : onTouchTap,
	            ref: function ref(node) {
	              return _this2.button = node;
	            },
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  containerElement: 'span',
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ListItem.propTypes = {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _react.PropTypes.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The element to use as the container for the ListItem. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * ListItem in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _react.PropTypes.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _react.PropTypes.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Callbak function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /** @ignore */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _react.PropTypes.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _react.PropTypes.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _react.PropTypes.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ListItem;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? PopoverAnimationVertical.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin.isRequired,
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationVertical;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableRowColumn = context.muiTheme.tableRowColumn;
	
	
	  var styles = {
	    root: {
	      paddingLeft: tableRowColumn.spacing,
	      paddingRight: tableRowColumn.spacing,
	      height: tableRowColumn.height,
	      textAlign: 'left',
	      fontSize: 13,
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis'
	    }
	  };
	
	  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
	    styles.textAlign = 'right';
	  }
	
	  return styles;
	}
	
	var TableRowColumn = function (_Component) {
	  (0, _inherits3.default)(TableRowColumn, _Component);
	
	  function TableRowColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRowColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _this.onMouseEnter = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onHover) {
	          _this.props.onHover(event, _this.props.columnNumber);
	        }
	      }
	    }, _this.onMouseLeave = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onHoverExit) {
	          _this.props.onHoverExit(event, _this.props.columnNumber);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRowColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave
	      };
	
	      return _react2.default.createElement(
	        'td',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        children
	      );
	    }
	  }]);
	  return TableRowColumn;
	}(_react.Component);
	
	TableRowColumn.defaultProps = {
	  hoverable: false
	};
	TableRowColumn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableRowColumn.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * @ignore
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _react.PropTypes.number,
	  /**
	   * @ignore
	   * If true, this column responds to hover events.
	   */
	  hoverable: _react.PropTypes.bool,
	  /** @ignore */
	  onClick: _react.PropTypes.func,
	  /** @ignore */
	  onHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Callback function for hover exit event.
	   */
	  onHoverExit: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableRowColumn;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Toggle = __webpack_require__(1773);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.Toggle = exports.TimePicker = exports.TextField = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tab = exports.Tabs = exports.Snackbar = exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = exports.SvgIcon = exports.Subheader = exports.Slider = exports.SelectField = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.MuiThemeProvider = exports.MenuItem = exports.Menu = exports.makeSelectable = exports.ListItem = exports.List = exports.LinearProgress = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.DropDownMenu = exports.Drawer = exports.Divider = exports.Dialog = exports.DatePicker = exports.CircularProgress = exports.Chip = exports.Checkbox = exports.CardText = exports.CardTitle = exports.CardMedia = exports.CardHeader = exports.CardActions = exports.Card = exports.BottomNavigationItem = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppBar = undefined;
	
	var _AppBar2 = __webpack_require__(1692);
	
	var _AppBar3 = _interopRequireDefault(_AppBar2);
	
	var _AutoComplete2 = __webpack_require__(1694);
	
	var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);
	
	var _Avatar2 = __webpack_require__(584);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(1697);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _BottomNavigation2 = __webpack_require__(1699);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(585);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	var _Card2 = __webpack_require__(1701);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(586);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardHeader2 = __webpack_require__(588);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardMedia2 = __webpack_require__(589);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardTitle2 = __webpack_require__(591);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(590);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Checkbox2 = __webpack_require__(379);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Chip2 = __webpack_require__(1704);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _CircularProgress2 = __webpack_require__(1706);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _DatePicker2 = __webpack_require__(1717);
	
	var _DatePicker3 = _interopRequireDefault(_DatePicker2);
	
	var _Dialog2 = __webpack_require__(380);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(271);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(592);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _DropDownMenu2 = __webpack_require__(381);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _FlatButton2 = __webpack_require__(272);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _FloatingActionButton2 = __webpack_require__(1724);
	
	var _FloatingActionButton3 = _interopRequireDefault(_FloatingActionButton2);
	
	var _FontIcon2 = __webpack_require__(382);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _GridList2 = __webpack_require__(1727);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(594);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	var _IconButton2 = __webpack_require__(60);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	var _IconMenu2 = __webpack_require__(1730);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _LinearProgress2 = __webpack_require__(595);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _List2 = __webpack_require__(1733);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(273);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(596);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	var _Menu2 = __webpack_require__(597);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(385);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MuiThemeProvider2 = __webpack_require__(618);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _Paper2 = __webpack_require__(81);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _Popover2 = __webpack_require__(1737);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _RadioButton2 = __webpack_require__(1738);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(599);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	var _RaisedButton2 = __webpack_require__(386);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _RefreshIndicator2 = __webpack_require__(1741);
	
	var _RefreshIndicator3 = _interopRequireDefault(_RefreshIndicator2);
	
	var _SelectField2 = __webpack_require__(1743);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(1745);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _Subheader2 = __webpack_require__(601);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _SvgIcon2 = __webpack_require__(2);
	
	var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);
	
	var _Step2 = __webpack_require__(1749);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(1750);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(1752);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(600);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(1753);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	var _Snackbar2 = __webpack_require__(1748);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	var _Tabs2 = __webpack_require__(1760);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(606);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Table2 = __webpack_require__(72);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(602);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(603);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(604);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(387);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(605);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(275);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	var _TextField2 = __webpack_require__(160);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _TimePicker2 = __webpack_require__(1772);
	
	var _TimePicker3 = _interopRequireDefault(_TimePicker2);
	
	var _Toggle2 = __webpack_require__(276);
	
	var _Toggle3 = _interopRequireDefault(_Toggle2);
	
	var _Toolbar2 = __webpack_require__(1775);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(609);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(610);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(611);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _AppBar3.default;
	exports.AutoComplete = _AutoComplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Chip = _Chip3.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.DatePicker = _DatePicker3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.FloatingActionButton = _FloatingActionButton3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.IconButton = _IconButton3.default;
	exports.IconMenu = _IconMenu3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.Paper = _Paper3.default;
	exports.Popover = _Popover3.default;
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.RefreshIndicator = _RefreshIndicator3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Subheader = _Subheader3.default;
	exports.SvgIcon = _SvgIcon3.default;
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;
	exports.Snackbar = _Snackbar3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.TextField = _TextField3.default;
	exports.TimePicker = _TimePicker3.default;
	exports.Toggle = _Toggle3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	function phoneParsing(number) {
		// checks whether there is a 1 or not at beginning
		number = number.toString();
	    number = number.split('');
	    if(number.length < 10 || number.length > 11) {
	    	console.log('ERROR: Length of input not valid');
	    	return null;
	    }
		if(number.length == 10) {
			number.unshift('1');
		}
		number = number.join('');
		number = number.toString();
	    function noSpacesFunc(number) {
	        // Works as a 'reset' function for other functions
	        return number.toString().replace(/\D/g, '');
	    }
	
	    function removeInitialNumberFunc(number) {
	        number = noSpacesFunc(number);
	        number = number.split('');
	        if (number[0] == 1) {
	            number.splice(0, 1);
	        }
	        return number.join('');
	    }
	
	    function addParenthesesFunc(number) {
	        number = noSpacesFunc(number);
	        number = number.split('');
	        if (number.length == 11) {
	            number.splice(1, 0, ' ');
	            number.splice(5, 0, ' ');
	            number.splice(9, 0, ' ');
	            number.splice(2, 0, '(');
	            number.splice(6, 0, ')');
	        } else if (number.length == 10) {
	            number.splice(3, 0, ' ');
	            number.splice(7, 0, ' ');
	            number.splice(0, 0, '(');
	            number.splice(4, 0, ')');
	        } else {
	            return null;
	        }
	        return number.join('');
	    }
	
	    function addParenthesesWithDashesFunc(number) {
	    	number = addParenthesesFunc(number);
	    	if(number.length == 16) {
		   		number = number.replace(' ', '-');
		   		number = number.replace(' ', '-');
		   		number = number.replace(' ', '-');
	    	} else if (number.length == 14) {
		   		number = number.replace(' ', '-');
		   		number = number.replace(' ', '-');
		   		number = number.replace(' ', '-');
	    	} else {
	    		return null;
	    	}
	    	return number;
	    }
	
	    function addDashesFunc(number) {
	        number = noSpacesFunc(number);
	        number = number.split('');
	        var dash = '-';
	        if (number.length == 11) {
	            number.splice(1, 0, dash);
	            number.splice(5, 0, dash);
	            number.splice(9, 0, dash);
	        } else if (number.length == 10) {
	            number.splice(3, 0, dash);
	            number.splice(7, 0, dash);
	        } else {
	        	return null;
	        }
	        return number.join('');
	    }
	
	    function addDotsFunc(number) {
	    	number = noSpacesFunc(number);
	    	number = number.split('');
	        var dot = '.';
	        if (number.length == 11) {
	            number.splice(1, 0, dot);
	            number.splice(5, 0, dot);
	            number.splice(9, 0, dot);
	        } else if (number.length == 10) {
	            number.splice(3, 0, dot);
	            number.splice(7, 0, dot);
	        } else {
	        	return null;
	        }
	        return number.join('');
	    }
	
	    function addSlashesFunc(number) {
	    	number = noSpacesFunc(number);
	    	number = number.split('');
	        var slash = '/';
	        if (number.length == 11) {
	            number.splice(1, 0, slash);
	            number.splice(5, 0, slash);
	            number.splice(9, 0, slash);
	        } else if (number.length == 10) {
	            number.splice(3, 0, slash);
	            number.splice(7, 0, slash);
	        } else {
	        	return null;
	        }
	        return number.join('');
	    }
	
	    function addTrailingSlashesNoSpaceFunc(number) {
	    	number = noSpacesFunc(number);
	    	number = number.split('');
	    	if(number.length == 11) {
	    		number.splice(1, 0, '(');
	    		number.splice(5, 0, ')');
	    		number.splice(6, 0, ' ');
	    		number.splice(1, 0, ' ');
	    		number.splice(11, 0, '-');
	    	} else if (number.length == 10) {
	    		number.splice(0, 0, '(');
	    		number.splice(4, 0, ')');
	    		number.splice(5, 0, ' ');
	    		number.splice(9, 0, '-');
	    	} else {
	    		return null;
	    	}
	    	return number.join('');
	    }
	
	    // This is for the 'countryCodeRemoved' object
	    var removed = removeInitialNumberFunc(number);
	    var removedParentheses = addParenthesesFunc(removed);
	    var removedDashes = addDashesFunc(removed);
	    var removedParenAndDashes = addParenthesesWithDashesFunc(removed);
	    var removedDots = addDotsFunc(removed);
	    var removedSlashes = addSlashesFunc(removed);
	    var removedTrailingSlashes = addTrailingSlashesNoSpaceFunc(removed);
	
	    //This is for the 'countryCodeIntact' object
	    var addParentheses = addParenthesesFunc(number);
	    var addDashes = addDashesFunc(number);
	    var addParenthesesWithDashes = addParenthesesWithDashesFunc(number);
	    var addDots = addDotsFunc(number);
	    var addSlashes = addSlashesFunc(number);
	    var addTrailingSlashes = addTrailingSlashesNoSpaceFunc(number);
	    // The object that will be returned
	    return parsed = {
	        original: number,
	    	removeInitialNumber: removed,
	    	withPlus: '+' + number,
	    	countryCodeIntact: {
	    		addParentheses: addParentheses,
	    		addDashes: addDashes,
	    		addParenthesesWithDashes: addParenthesesWithDashes,
	    		addDots: addDots,
	    		addSlashes: addSlashes,
	    		addTrailingSlashes: addTrailingSlashes
	    	},
	    	countryCodeRemoved: {
	    		addParentheses: removedParentheses,
	    		addDashes: removedDashes,
	    		addParenthesesWithDashes: removedParenAndDashes,
	    		addDots: removedDots,
	    		addSlashes: removedSlashes,
	    		addTrailingSlashes: removedTrailingSlashes
	    	}
	    };
	}
	
	module.exports = phoneParsing;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2764);

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(282);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(2848);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(135);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(2761);
	
	var _runTransitionHook = __webpack_require__(407);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(164);
	
	var _deprecate = __webpack_require__(406);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var EventConstants = __webpack_require__(107);
	var ReactErrorUtils = __webpack_require__(418);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var EventConstants = __webpack_require__(107);
	var EventPluginRegistry = __webpack_require__(412);
	var ReactEventEmitterMixin = __webpack_require__(2928);
	var ViewportMetrics = __webpack_require__(424);
	
	var getVendorPrefixedEventName = __webpack_require__(811);
	var isEventSupported = __webpack_require__(429);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(197);
	var ViewportMetrics = __webpack_require__(424);
	
	var getEventModifierState = __webpack_require__(427);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	var DOMNamespaces = __webpack_require__(411);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(425);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var newNodes = reusableSVGContainer.firstChild.childNodes;
	    for (var i = 0; i < newNodes.length; i++) {
	      node.appendChild(newNodes[i]);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomFromSeed = __webpack_require__(3032);
	
	var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
	var alphabet;
	var previousSeed;
	
	var shuffled;
	
	function reset() {
	    shuffled = false;
	}
	
	function setCharacters(_alphabet_) {
	    if (!_alphabet_) {
	        if (alphabet !== ORIGINAL) {
	            alphabet = ORIGINAL;
	            reset();
	        }
	        return;
	    }
	
	    if (_alphabet_ === alphabet) {
	        return;
	    }
	
	    if (_alphabet_.length !== ORIGINAL.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
	    }
	
	    var unique = _alphabet_.split('').filter(function(item, ind, arr){
	       return ind !== arr.lastIndexOf(item);
	    });
	
	    if (unique.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
	    }
	
	    alphabet = _alphabet_;
	    reset();
	}
	
	function characters(_alphabet_) {
	    setCharacters(_alphabet_);
	    return alphabet;
	}
	
	function setSeed(seed) {
	    randomFromSeed.seed(seed);
	    if (previousSeed !== seed) {
	        reset();
	        previousSeed = seed;
	    }
	}
	
	function shuffle() {
	    if (!alphabet) {
	        setCharacters(ORIGINAL);
	    }
	
	    var sourceArray = alphabet.split('');
	    var targetArray = [];
	    var r = randomFromSeed.nextValue();
	    var characterIndex;
	
	    while (sourceArray.length > 0) {
	        r = randomFromSeed.nextValue();
	        characterIndex = Math.floor(r * sourceArray.length);
	        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
	    }
	    return targetArray.join('');
	}
	
	function getShuffled() {
	    if (shuffled) {
	        return shuffled;
	    }
	    shuffled = shuffle();
	    return shuffled;
	}
	
	/**
	 * lookup shuffled letter
	 * @param index
	 * @returns {string}
	 */
	function lookup(index) {
	    var alphabetShuffled = getShuffled();
	    return alphabetShuffled[index];
	}
	
	module.exports = {
	    characters: characters,
	    seed: setSeed,
	    lookup: lookup,
	    shuffled: getShuffled
	};


/***/ }),
/* 293 */
[3178, 3035],
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Expose. */
	module.exports = visit;
	
	var is = __webpack_require__(3054);
	
	/* Visit. */
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor;
	    visitor = test;
	    test = null;
	  }
	
	  one(tree);
	
	  /* Visit a single node. */
	  function one(node, index, parent) {
	    var result;
	
	    index = index || (parent ? 0 : null);
	
	    if (!test || node.type === test || is(test, node, index, parent || null)) {
	      result = visitor(node, index, parent || null);
	    }
	
	    if (node.children && result !== false) {
	      return all(node.children, node);
	    }
	
	    return result;
	  }
	
	  /* Visit children in `parent`. */
	  function all(children, parent) {
	    var step = reverse ? -1 : 1;
	    var max = children.length;
	    var min = -1;
	    var index = (reverse ? max : min) + step;
	    var child;
	
	    while (index > min && index < max) {
	      child = children[index];
	
	      if (child && one(child, index, parent) === false) {
	        return false;
	      }
	
	      index += step;
	    }
	
	    return true;
	  }
	}


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactTooltip = __webpack_require__(409);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _strings = __webpack_require__(309);
	
	var _DeleteIcon = __webpack_require__(301);
	
	var _DeleteIcon2 = _interopRequireDefault(_DeleteIcon);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _FlagIcon = __webpack_require__(303);
	
	var _FlagIcon2 = _interopRequireDefault(_FlagIcon);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _CardFilter = __webpack_require__(446);
	
	var _CardFilter2 = _interopRequireDefault(_CardFilter);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts2);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _staticData = __webpack_require__(28);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _rcPager = __webpack_require__(280);
	
	var _rcPager2 = _interopRequireDefault(_rcPager);
	
	var _PreviousIcon = __webpack_require__(233);
	
	var _PreviousIcon2 = _interopRequireDefault(_PreviousIcon);
	
	var _NextIcon = __webpack_require__(232);
	
	var _NextIcon2 = _interopRequireDefault(_NextIcon);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dateOptions = [{ id: -1, name: 'All' }, { id: 'past due', name: 'Past Due' }, { id: 'today', name: 'Today' }, { id: 'tomorrow', name: 'Tomorrow' }, { id: 'this week', name: 'This Week' }, { id: 'next week', name: 'Next Week' }, { id: 'this month', name: 'This Month' }, { id: 'future', name: 'Future' }];
	
	var contactDateOptions = [{ id: -1, name: 'All' }, { id: 'today', name: 'Today' }, { id: 'yesterday', name: 'Yesterday' }, { id: 'past week', name: 'Past Week' }, { id: 'past month', name: 'Past Month' }, { id: 'past year', name: 'Past Year' }];
	
	var jobOptions = [{ id: 'jobsSubmitted', name: 'Submitted', sortBy: 'submitted' }, { id: 'jobsApproved', name: 'Approved', sortBy: 'approved' }, { id: 'jobsPlaced', name: 'Placed', sortBy: 'placed' }, { id: 'jobs', name: 'Total', sortBy: 'total' }];
	
	var ContactTable = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var staticData = store.staticData;
	
	  return {
	    staticData: staticData,
	    contactLabels: (0, _lodash.get)(store.labels, 'ContactTypes', {}),
	    currentUser: store.user
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ContactTable, _Component);
	
	  function ContactTable(props, context) {
	    _classCallCheck(this, ContactTable);
	
	    var _this = _possibleConstructorReturn(this, (ContactTable.__proto__ || Object.getPrototypeOf(ContactTable)).call(this, props, context));
	
	    _this.handleDeleteContact = function () {
	      var _this$props = _this.props,
	          dispatch = _this$props.dispatch,
	          contacts = _this$props.contacts;
	      var deleteContact = _this.state.deleteContact;
	      var user = deleteContact.user,
	          company = deleteContact.company,
	          profile = deleteContact.profile;
	
	      var filteredContacts = contacts.filter(function (c) {
	        return c.user.id !== user.id;
	      });
	      var fullname = (0, _strings.concat)([user.firstName, user.lastName], ' ');
	
	      dispatch(companyApi.deleteCompanyContact(company.id, profile.id, function (err) {
	
	        _this.setState({ showDeleteModal: false });
	
	        if (err) {
	          return dispatch(ui.warningToast((0, _lodash.get)(err, '[0].errorMessage', 'Unable to delete contact.')));
	        }
	
	        dispatch(companyStore.updateCompanyContacts(filteredContacts));
	        dispatch(ui.showSnackBar('Contact ' + fullname + ' deleted.'));
	      }));
	    };
	
	    _this.renderEditAction = function (header, row, index) {
	      if (header) {
	        return _react2.default.createElement(_Table.TableHeaderColumn, { className: 'edit-action' });
	      }
	
	      var onEdit = function onEdit(e) {
	        e.stopPropagation();
	        _this.props.onEdit(row);
	      };
	
	      if (_this.props.shouldDisplayEditAction) {
	        return _react2.default.createElement(
	          _Table.TableRowColumn,
	          { 'data-id': 'Edit Action' + index, className: 'edit-action' },
	          _this.props.shouldDisplayEditAction(row) && _react2.default.createElement(_Button2.default, { className: 'edit-button', onClick: onEdit, label: 'EDIT' })
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Edit Action' + index, className: 'edit-action' },
	        _react2.default.createElement(_Button2.default, { className: 'edit-button', onClick: onEdit, label: 'EDIT' })
	      );
	    };
	
	    _this.state = {
	      clientAdvisers: _this.props.staticData.clientAdvisers,
	      showHeader: _this.props.showHeader !== undefined ? _this.props.showHeader : true,
	      showFilters: (0, _lodash.get)(_this.props, 'showFilters', true),
	      showDeleteModal: false,
	      deleteContact: {},
	      isFlipped: true,
	      columns: _this.props.columns !== undefined ? _this.props.columns : ['Name', 'Phone', 'Title', 'Type', 'Status', 'Email'],
	      sortBy: props.sortBy || {
	        field: 'contactedDate',
	        order: 'desc'
	      },
	      hasPagination: props.location && props.location.includes('/admin/contacts') || (0, _lodash.includes)(props, '/admin/contacts')
	    };
	    _this.hasNoJobsFilter = _this.hasNoJobsFilter.bind(_this);
	    _this.onChangeFilter = _this.onChangeFilter.bind(_this);
	    _this.showDeleteModal = _this.showDeleteModal.bind(_this);
	    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
	    _this.handleDeleteContact = _this.handleDeleteContact.bind(_this);
	    return _this;
	  }
	
	  _createClass(ContactTable, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'handleFilterDefaultValues',
	    value: function handleFilterDefaultValues(filterName) {
	      var defaultVal = filterName === 'tags' ? [] : -1;
	      return (0, _lodash.get)(this.props.filters, filterName, defaultVal);
	    }
	  }, {
	    key: 'hasNoJobsFilter',
	    value: function hasNoJobsFilter() {
	      var filters = this.props.filters;
	      var jobFilters = ['jobsSubmitted', 'jobsApproved', 'jobsPlaced', 'jobs'];
	      return jobFilters.every(function (job) {
	        return (0, _lodash.isNil)(filters[job]) || filters[job] === 0;
	      });
	    }
	  }, {
	    key: 'getJobFilters',
	    value: function getJobFilters() {
	      var jobFilters = (0, _lodash.pick)(this.props.filters, ['jobsSubmitted', 'jobsApproved', 'jobsPlaced', 'jobs']);
	      return Object.keys(jobFilters);
	    }
	  }, {
	    key: 'flipColumn',
	    value: function flipColumn() {
	      var _this2 = this;
	
	      var sortBy = 'total';
	      var jobFilters = this.getJobFilters();
	      var totalJobFilters = jobFilters.length;
	
	      // We sort by total unless there are only 1 filter.
	      if (totalJobFilters === 1) {
	        sortBy = (0, _lodash.find)(jobOptions, { id: jobFilters[0] }).sortBy;
	      }
	
	      this.setState({
	        isFlipped: !this.state.isFlipped,
	        sortBy: { field: sortBy, order: this.state.isFlipped ? 'desc' : 'asc' }
	      }, function () {
	        var fields = { order: (0, _lodash.get)(_this2.state, 'sortBy.order'), by: (0, _lodash.get)(_this2.state, 'sortBy.field') };
	        _this2.props.onSort(fields);
	      });
	    }
	  }, {
	    key: 'onCardFilter',
	    value: function onCardFilter(event, key, text, value) {
	      var data = 0;
	
	      if (key.indexOf(value) >= 0) data = 1;
	      this.props.updateContactsFilter(event, data, value);
	    }
	  }, {
	    key: 'onChangeFilter',
	    value: function onChangeFilter(filterSection, filterName) {
	      var _this3 = this;
	
	      return function (event, key) {
	        if (_this3.props.updateContactsFilter) _this3.props.updateContactsFilter(event, key, filterName);
	      };
	    }
	  }, {
	    key: 'handleContactClick',
	    value: function handleContactClick(row) {
	      var _this4 = this;
	
	      var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      return function () {
	        if (_this4.props.contactLink) {
	          _this4.props.dispatch(ui.showSpinner());
	          _this4.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + row.profile.id + '/' + route));
	        }
	      };
	    }
	  }, {
	    key: 'handleCompanyClick',
	    value: function handleCompanyClick(row) {
	      var _this5 = this;
	
	      var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'details';
	
	      return function () {
	        if (_this5.props.companyLink) {
	          _this5.props.dispatch(ui.showSpinner());
	          _this5.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/' + row.company.id + '/' + route));
	        }
	      };
	    }
	  }, {
	    key: 'onChangeContactType',
	    value: function onChangeContactType(row) {
	      var _this6 = this;
	
	      return function (event, types) {
	        var contact = {
	          user: (0, _lodash.pick)(row.user, ['id']),
	          company: (0, _lodash.pick)(row.company, ['id']),
	          profile: {
	            id: row.profile.id,
	            types: types
	          }
	        };
	        _this6.props.dispatch(contactApi.updateContact(contact, function (err, result) {
	          if (err || !result) {
	            return console.error(err || 'Update failed.');
	          }
	
	          _this6.props.dispatch(contactStore.updateContact(result));
	        }));
	      };
	    }
	  }, {
	    key: 'getFollowUpDate',
	    value: function getFollowUpDate(contact) {
	      var followUpTask = _(contact.profile.tasks).filter(function (task) {
	        return task.taskFollowUpDate;
	      }).sortBy(function (task) {
	        return new Date(task.taskFollowUpDate);
	      }).head();
	
	      return followUpTask ? (0, _moment2.default)(followUpTask.taskFollowUpDate).format('L') : '';
	    }
	  }, {
	    key: 'generateMenuItemsAddNoTag',
	    value: function generateMenuItemsAddNoTag(staticData, type, hideAny) {
	      var NO_TAG_MAGIC_NUMBER = 9999;
	      var menuItems = this.generateMenuItems(staticData, type, hideAny);
	      return (0, _lodash.concat)(menuItems, { value: NO_TAG_MAGIC_NUMBER, primaryText: 'No Tags' });
	    }
	  }, {
	    key: 'generateMenuItems',
	    value: function generateMenuItems(staticData, type, hideAny) {
	      var object = staticData[type];
	
	      var menuItems = (0, _lodash.map)(object, function (item) {
	        return {
	          value: item.id || item.value,
	          primaryText: item.name || item.primaryText
	        };
	      });
	
	      if (hideAny) {
	        return menuItems;
	      }
	
	      return (0, _lodash.concat)({ value: -1, primaryText: 'All' }, menuItems);
	    }
	  }, {
	    key: 'generateContactTypeMenuItems',
	    value: function generateContactTypeMenuItems() {
	      var _this7 = this;
	
	      var menuItems = (0, _lodash.map)(this.props.staticData.contactTypes, function (type) {
	        return {
	          value: type.id,
	          primaryText: (0, _lodash.get)(_this7.props.contactLabels, type.name)
	        };
	      });
	
	      return menuItems;
	    }
	  }, {
	    key: 'employeesToMenuItems',
	    value: function employeesToMenuItems() {
	      var employees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var menuItems = (0, _lodash.map)(employees, function (employee) {
	        return {
	          primaryText: employee.firstName + ' ' + employee.lastName,
	          value: employee.employeeId
	        };
	      });
	
	      return (0, _lodash.concat)([{ value: -1, primaryText: 'All' }, { value: null, primaryText: 'Unassigned' }], menuItems);
	    }
	  }, {
	    key: 'showDeleteModal',
	    value: function showDeleteModal(deleteContact) {
	      var _this8 = this;
	
	      return function () {
	        _this8.setState({ showDeleteModal: true, deleteContact: deleteContact });
	      };
	    }
	  }, {
	    key: 'closeDeleteModal',
	    value: function closeDeleteModal() {
	      this.setState({ showDeleteModal: false });
	    }
	  }, {
	    key: 'renderName',
	
	
	    // column render functions
	    value: function renderName(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'contact-name', className: 'contact-name', style: { width: '150px' } },
	          'Contact'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Contact' + index, className: 'contact-name', style: { width: '150px' } },
	        _react2.default.createElement(
	          'div',
	          { className: this.props.contactLink && 'hover-link', onClick: this.handleContactClick(row, 'details') },
	          row.user.firstName,
	          ' ',
	          row.user.lastName
	        )
	      );
	    }
	  }, {
	    key: 'renderCardName',
	    value: function renderCardName(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'contact-card-name', className: 'contact-name', style: { width: '250px' } },
	          'Contact'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Contact' + index, className: 'contact-name', style: { width: '250px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-name-card hover-link' },
	          _react2.default.createElement('div', { className: 'expand-icon', onClick: this.handleContactClick(row) }),
	          _react2.default.createElement(
	            'div',
	            { className: 'name', onClick: this.handleContactClick(row, 'details') },
	            row.user.firstName,
	            ' ',
	            row.user.lastName
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCompany',
	    value: function renderCompany(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-company', className: 'contact-company', style: { width: '150px' } },
	          'Company'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Company' + index, style: { width: '150px' }, className: 'contact-company-name' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-name-card hover-link', onClick: this.handleCompanyClick(row) },
	          row.company.name
	        )
	      );
	    }
	  }, {
	    key: 'renderPhone',
	    value: function renderPhone(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-phone', className: 'contact-phone', style: { width: '150px' } },
	          'Phone #'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Phone' + index, className: 'contact-phone', style: { width: '150px' } },
	        !!row.user.phoneNumber1 && (0, _prettyPhone2.default)(row.user.phoneNumber1)
	      );
	    }
	  }, {
	    key: 'renderContactDate',
	    value: function renderContactDate(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-contact-date', className: 'contact-date', style: { width: '150px' } },
	          'Contacted'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Contact Date ' + index, className: 'contact-date', style: { width: '150px' } },
	        row.profile.dateCreated ? (0, _moment2.default)(row.profile.dateCreated).format('L') : ''
	      );
	    }
	  }, {
	    key: 'renderFollowUpDate',
	    value: function renderFollowUpDate(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-followupdate', className: 'contact-followup-date' },
	          'Follow Up'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'FollowUp Date' + index, className: 'contact-followup-date' },
	        this.getFollowUpDate(row)
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-title', className: 'contact-title', style: { width: '125px' } },
	          'Title'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Title' + index, className: 'contact-title', style: { width: '125px' } },
	        row.profile.title
	      );
	    }
	  }, {
	    key: 'renderJobCounts',
	    value: function renderJobCounts(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-jobs', className: 'contact-jobs' },
	          '#JRs',
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('chevron', { flipped: this.state.isFlipped }), onClick: this.flipColumn.bind(this) },
	            _react2.default.createElement(_ChevronIcon2.default, null)
	          ),
	          _react2.default.createElement(_CardFilter2.default, {
	            onChange: this.onCardFilter.bind(this),
	            menuItems: jobOptions
	          })
	        );
	      }
	
	      var showAll = this.hasNoJobsFilter();
	      var filters = this.props.filters;
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Jobs ' + index, className: 'contact-jobs' },
	        _react2.default.createElement(
	          'div',
	          { className: 'job-counts' },
	          (showAll || !!filters.jobsSubmitted) && _react2.default.createElement(
	            'div',
	            { 'data-tip': 'Job Requests Submitted', className: (0, _classnames2.default)('submitted-circle', { 'empty-circle': row.profile.jobsSubmitted == 0 }) },
	            row.profile.jobsSubmitted > 99 ? '99+' : row.profile.jobsSubmitted
	          ),
	          (showAll || !!filters.jobsApproved) && _react2.default.createElement(
	            'div',
	            { 'data-tip': 'Job Requests Approved', className: (0, _classnames2.default)('approved-circle', { 'empty-circle': row.profile.jobsApproved == 0 }) },
	            row.profile.jobsApproved > 99 ? '99+' : row.profile.jobsApproved
	          ),
	          (showAll || !!filters.jobsPlaced) && _react2.default.createElement(
	            'div',
	            { 'data-tip': 'Job Requests Placed', className: (0, _classnames2.default)('placed-circle', { 'empty-circle': row.profile.jobsPlaced == 0 }) },
	            row.profile.jobsPlaced > 99 ? '99+' : row.profile.jobsPlaced
	          ),
	          (showAll || !!filters.jobs) && _react2.default.createElement(
	            'div',
	            { 'data-tip': 'Total Job Requests', className: (0, _classnames2.default)('total-circle', { 'empty-circle': row.profile.jobs == 0 }) },
	            row.profile.jobs > 99 ? '99+' : row.profile.jobs
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderType',
	    value: function renderType(header, row, index) {
	      var _this9 = this;
	
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-type-' + index, className: 'contact-type', style: { width: '128px' } },
	          'Type'
	        );
	      }
	      if (this.props.useContactTypeDropdown) {
	        return _react2.default.createElement(
	          _Table.TableRowColumn,
	          { 'data-id': 'Type' + index, className: 'contact-type', style: { width: '128px' } },
	          _react2.default.createElement(_c_CheckList2.default, {
	            'data-id': 'contact-type-dropdown',
	            onChange: this.onChangeContactType(row),
	            defaultValue: row.profile.types,
	            className: 'dropdown-filter',
	            menuItems: this.generateContactTypeMenuItems(),
	            containerStyle: { width: '100%' }
	          })
	        );
	      } else {
	        return _react2.default.createElement(
	          _Table.TableRowColumn,
	          { 'data-id': 'Type' + index, className: 'contact-type', style: { width: '128px' } },
	          (0, _lodash.map)(row.profile.types, function (id) {
	            return (0, _staticData.lookup)(_this9.props.staticData, 'contactTypes', { id: id });
	          }).join(', ')
	        );
	      }
	    }
	  }, {
	    key: 'renderStatus',
	    value: function renderStatus(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-status-' + index, className: 'contact-status', style: { width: '150px' } },
	          'Status'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Status' + index, className: 'contact-status', style: { width: '150px' } },
	        row.color !== undefined && _react2.default.createElement('div', { className: 'status-circle', 'data-id': 'Status Icon', style: { backgroundColor: row.color, borderColor: row.color } }),
	        (0, _staticData.lookup)(this.props.staticData, 'companyStatus', { id: row.company.companyStatus })
	      );
	    }
	  }, {
	    key: 'renderTags',
	    value: function renderTags(header, row, index) {
	      var _this10 = this;
	
	      if (header) {
	        return _react2.default.createElement(_Table.TableHeaderColumn, { key: 'headercol-status-' + index, className: 'contact-status-tags', style: { height: 'auto', width: 'auto', paddingRight: '0' } });
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Tags ' + index, className: 'contact-status-tags', style: { height: 'auto', width: 'auto', paddingRight: '0' } },
	        _react2.default.createElement(
	          'span',
	          { className: 'contact-tags contact-tags-inline' },
	          (0, _lodash.map)(row.profile.tags, function (tag) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'contact-tag', 'data-id': 'Contact tag ' + tag },
	              _react2.default.createElement(_FlagIcon2.default, null),
	              ' ',
	              (0, _staticData.lookup)(_this10.props.staticData, 'contactTags', { id: tag })
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderEmail',
	    value: function renderEmail(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { key: 'headercol-email-' + index, className: 'contact-email', style: { width: '250px' } },
	          'Email'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Email' + index, className: 'contact-email', style: { width: '250px' } },
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:' + row.user.email, target: '_blank' },
	          row.user.email
	        )
	      );
	    }
	  }, {
	    key: 'renderDelete',
	    value: function renderDelete(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(_Table.TableHeaderColumn, { className: 'delete-contact' });
	      }
	
	      var deleteContact = (0, _lodash.omit)(row, ['color']);
	      var disabled = this.props.contacts.length < 2;
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Deletes' + index, className: 'delete-contact', style: { overflow: 'visible' } },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            tooltip: 'Delete',
	            tooltipPosition: 'bottom-center',
	            onClick: this.showDeleteModal(deleteContact) },
	          _react2.default.createElement(_DeleteIcon2.default, { className: (0, _classnames2.default)({ disabled: disabled }) })
	        )
	      );
	    }
	  }, {
	    key: 'renderClientAdviser',
	    value: function renderClientAdviser(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { className: 'contact-adviser' },
	          'Client Adviser'
	        );
	      }
	
	      var adviser = (0, _lodash.find)(this.state.clientAdvisers, { id: row.profile.clientAdvisorId });
	      var adviserName = adviser ? adviser.firstName + ' ' + adviser.lastName : '';
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Adviser' + index, className: 'contact-adviser' },
	        adviserName
	      );
	    }
	  }, {
	    key: 'handleSkip',
	    value: function handleSkip(page) {
	      this.props.handlePageSkip(page);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      var _props = this.props,
	          contacts = _props.contacts,
	          pageSize = _props.pageSize,
	          currentPage = _props.currentPage,
	          total = _props.total;
	
	
	      var currentCount = pageSize * (currentPage + 1);
	      currentCount = currentCount < total ? currentCount : total;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'contact-table info-table ' + (0, _lodash.get)(this.props, 'className', '') },
	        this.state.showDeleteModal && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          transitionText: 'Are you sure you want to delete this contact?',
	          secondaryButtonLabel: 'Delete',
	          primaryButtonLabel: 'Cancel',
	          cancelAction: this.closeDeleteModal,
	          primaryAction: this.closeDeleteModal,
	          secondaryAction: function secondaryAction() {
	            return _this11.handleDeleteContact();
	          }
	        }),
	        this.state.showFilters && _react2.default.createElement(
	          'div',
	          { className: 'contact-filters' },
	          _react2.default.createElement(_c_DropDownMenu2.default, {
	            onChange: this.onChangeFilter('company', 'statuses'),
	            'data-id': 'status-dropdown',
	            floatingLabelText: 'Status',
	            defaultValue: this.handleFilterDefaultValues('statuses'),
	            className: 'dropdown-filter status-dropdown',
	            menuItems: this.generateMenuItems(this.props.staticData, 'companyStatus')
	          }),
	          _react2.default.createElement(_c_CheckList2.default, {
	            onChange: this.onChangeFilter('profile', 'tags', 'tagFilters'),
	            'data-id': 'tag-dropdown',
	            defaultValue: this.handleFilterDefaultValues('tags'),
	            popoverStyle: { width: '300px' },
	            autoWidth: true,
	            floatingLabelText: 'Tag',
	            className: 'dropdown-filter tag-dropdown',
	            menuItems: this.generateMenuItemsAddNoTag(this.props.staticData, 'contactTags', true)
	          }),
	          _react2.default.createElement(_c_DropDownMenu2.default, {
	            onChange: this.onChangeFilter('date', 'followUpDate', 'dateFilters'),
	            'data-id': 'followup-dropdown',
	            defaultValue: this.handleFilterDefaultValues('followUpDate'),
	            floatingLabelText: 'Follow Up Date',
	            className: 'dropdown-filter',
	            menuItems: dateOptions
	          }),
	          _react2.default.createElement(_c_DropDownMenu2.default, {
	            onChange: this.onChangeFilter('date', 'contactedDate', 'dateFilters'),
	            'data-id': 'contacted-dropdown',
	            defaultValue: this.handleFilterDefaultValues('contactedDate'),
	            floatingLabelText: 'Contacted Date',
	            className: 'dropdown-filter',
	            menuItems: contactDateOptions
	          }),
	          _react2.default.createElement(_c_DropDownMenu2.default, {
	            onChange: this.onChangeFilter('user', 'timezone'),
	            'data-id': 'timezone-dropdown',
	            floatingLabelText: 'Time Zone',
	            defaultValue: this.handleFilterDefaultValues('timezone'),
	            className: 'dropdown-filter',
	            menuItems: this.generateMenuItems(this.props.staticData, 'timezoneList')
	          }),
	          _react2.default.createElement(_c_DropDownMenu2.default, {
	            onChange: this.onChangeFilter('profile', 'clientAdvisorId'),
	            'data-id': 'client-advisor-dropdown',
	            floatingLabelText: 'Account Adviser',
	            defaultValue: this.handleFilterDefaultValues('clientAdvisorId'),
	            className: 'dropdown-filter',
	            menuItems: this.employeesToMenuItems(this.state.clientAdvisers)
	          })
	        ),
	        this.state.hasPagination && _react2.default.createElement(
	          'div',
	          { className: 'pager-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pager-info' },
	            'Showing ',
	            _react2.default.createElement(
	              'span',
	              { className: 'count' },
	              currentCount
	            ),
	            ' of ',
	            _react2.default.createElement(
	              'span',
	              { className: 'count' },
	              total
	            )
	          ),
	          _react2.default.createElement(_rcPager2.default, {
	            total: Math.ceil(total / pageSize),
	            current: currentPage,
	            onSkipTo: this.handleSkip.bind(this),
	            previousLabel: _react2.default.createElement(
	              'div',
	              { className: 'prev' },
	              _react2.default.createElement(_PreviousIcon2.default, null),
	              ' PREV'
	            ),
	            nextLabel: _react2.default.createElement(
	              'div',
	              { className: 'next' },
	              'NEXT ',
	              _react2.default.createElement(_NextIcon2.default, null)
	            )
	          })
	        ),
	        _react2.default.createElement(
	          _Table.Table,
	          { onRowSelection: this.props.onRowSelection,
	            className: 'contact-main-table',
	            selectable: !!this.props.useCheckBoxes,
	            multiSelectable: !!this.props.useCheckBoxes,
	            fixedHeader: true,
	            style: { minWidth: this.props.minWidth || '1150px' },
	            headerStyle: { minWidth: this.props.minWidth || '1150px' },
	            bodyStyle: { minWidth: this.props.minWidth || '1150px', height: this.props.height || 'calc(100vh - 229px)' }
	          },
	          _react2.default.createElement(
	            _Table.TableHeader,
	            {
	              displaySelectAll: false,
	              adjustForCheckbox: !!this.props.useCheckBoxes
	            },
	            _react2.default.createElement(
	              _Table.TableRow,
	              null,
	              (0, _lodash.map)(this.state.columns, function (column) {
	                return _this11['render' + column](true);
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableBody,
	            { deselectOnClickaway: false, displayRowCheckbox: !!this.props.useCheckBoxes },
	            (0, _lodash.map)(contacts, function (row, index) {
	              var status = (0, _staticData.getLookupValue)(_this11.props.staticData, 'companyStatus', { id: row.company.companyStatus });
	              row.color = status.color;
	              return _react2.default.createElement(
	                _Table.TableRow,
	                { selected: row.selected, className: row.disabled ? 'disabled' : 'enabled', key: '' + row.profile.id, 'data-id': 'Contact ' + row.user.email },
	                (0, _lodash.map)(_this11.state.columns, function (column) {
	                  return _this11['render' + column](false, row, index);
	                })
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_reactTooltip2.default, null)
	      );
	    }
	  }]);
	
	  return ContactTable;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contacts: _react.PropTypes.array,
	  className: _react.PropTypes.string,
	  staticData: _react.PropTypes.object,
	  contactLink: _react.PropTypes.bool,
	  companyLink: _react.PropTypes.bool,
	  showHeader: _react.PropTypes.bool,
	  columns: _react.PropTypes.array,
	  useContactTypeDropdown: _react.PropTypes.bool,
	  useCheckBoxes: _react.PropTypes.bool,
	  onRowSelection: _react.PropTypes.func,
	  onEdit: _react.PropTypes.func,
	  total: _react.PropTypes.number,
	  onPageChange: _react.PropTypes.func,
	  updateContactsFilter: _react.PropTypes.func,
	  shouldDisplayEditAction: _react.PropTypes.func,
	  minWidth: _react.PropTypes.string,
	  sortBy: _react.PropTypes.object,
	  filters: _react.PropTypes.object,
	  onSort: _react.PropTypes.func,
	  handlePageSkip: _react.PropTypes.func,
	  currentPage: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number,
	  currentUser: _react.PropTypes.object,
	  location: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = ContactTable;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Divider = __webpack_require__(271);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _c_SourceModMenuItem = __webpack_require__(166);
	
	var _c_SourceModMenuItem2 = _interopRequireDefault(_c_SourceModMenuItem);
	
	var _c_SourceModDropDown = __webpack_require__(202);
	
	var _c_SourceModDropDown2 = _interopRequireDefault(_c_SourceModDropDown);
	
	var _index = __webpack_require__(69);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var groupNameStyle = {
	  fontSize: '16px',
	  fontWeight: '500',
	  overflow: 'hidden',
	  padding: '8px',
	  textOverflow: 'ellipsis',
	  whiteSpace: 'nowrap'
	};
	
	function MenuItemGroup(props) {
	
	  var renderGroupName = function renderGroupName(groupName) {
	    return groupName && groupName !== 'undefined' && _react2.default.createElement(
	      'div',
	      { className: 'floatingLabelText', style: groupNameStyle },
	      props.groupName
	    );
	  };
	
	  var onChange = function onChange(item, index) {
	    return function (event) {
	      return props.onChange && props.onChange(event, item, index);
	    };
	  };
	
	  var byName = function byName(item1, item2) {
	    return item1.name.localeCompare(item2.name);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Divider2.default, { className: 'Divider' }),
	    renderGroupName(props.groupName),
	    props.menuItems.sort(byName).filter(function (item) {
	      return item.hasOwnProperty('hide') ? !item.hide : true;
	    }).map(function (item, index) {
	      return _react2.default.createElement(_c_SourceModMenuItem2.default, {
	        checkBox: true,
	        checked: props.selectedItems.includes(item.value || item.id),
	        value: item.value || item.id,
	        primaryText: item.primaryText || item.name,
	        key: index,
	        'data-id': item.primaryText || item.name,
	        onTouchTap: onChange(item, index)
	      });
	    })
	  );
	}
	
	MenuItemGroup.propTypes = {
	  menuItems: _react.PropTypes.array.isRequired,
	  selectedItems: _react.PropTypes.array.isRequired,
	  groupName: _react.PropTypes.string,
	  onChange: _react.PropTypes.func
	};
	
	function MenuItemGroups(props) {
	  var groups = (0, _lodash.groupBy)(props.menuItems, props.groupBy);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    (0, _lodash.map)(groups, function (group, key) {
	      return _react2.default.createElement(MenuItemGroup, {
	        menuItems: group,
	        selectedItems: props.selectedItems,
	        groupName: key,
	        onChange: props.onChange
	      });
	    })
	  );
	}
	
	MenuItemGroups.propTypes = {
	  menuItems: _react.PropTypes.array.isRequired,
	  selectedItems: _react.PropTypes.array.isRequired,
	  groupBy: _react.PropTypes.string,
	  onChange: _react.PropTypes.func
	};
	
	function Tags(props) {
	  var tags = props.selectedItems.map(function (item) {
	    return props.menuItems.find(function (i) {
	      return (i.value || i.id) === item;
	    });
	  }).filter(function (item) {
	    return !!item;
	  });
	
	  var value = function value(tag) {
	    return tag.value || tag.id;
	  };
	  var name = function name(tag) {
	    return tag.primaryText || tag.name;
	  };
	  var removeItem = function removeItem(tag) {
	    return function (event) {
	      return props.onRemove && props.onRemove(event, tag);
	    };
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'checked-tags-container' },
	    _react2.default.createElement(_Divider2.default, { className: 'Divider' }),
	    tags.map(function (tag, index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'checked-tag-container', key: index },
	        _react2.default.createElement(
	          'div',
	          { className: 'checked-tag' },
	          name(tag),
	          _react2.default.createElement(_index2.default, {
	            className: 'checked-tag-item',
	            'data-id': value(tag) + ' Tag',
	            onClick: removeItem(tag),
	            style: {
	              strokeWidth: 1,
	              color: '#4a4a4a',
	              marginLeft: '5px',
	              width: '10px',
	              height: '10px'
	            }
	          })
	        )
	      );
	    })
	  );
	}
	
	Tags.propTypes = {
	  menuItems: _react.PropTypes.array.isRequired,
	  selectedItems: _react.PropTypes.array,
	  onRemove: _react.PropTypes.func
	};
	
	var labelStyle = {
	  color: '#4a4a4a',
	  maxWidth: '100%',
	  whiteSpace: 'nowrap',
	  overflow: 'hidden',
	  textOverflow: 'ellipsis',
	  fontSize: '16px',
	  height: '48px'
	};
	
	var commonWidth = '384px';
	
	var listStyle = {
	  backgroundColor: '#fafafa',
	  fontWeight: 100,
	  maxWidth: commonWidth
	};
	
	var menuStyle = {
	  backgroundColor: '#fafafa',
	  overflowY: 'auto',
	  overflowX: 'hidden',
	  maxWidth: commonWidth
	};
	
	var DropdownChecklist = (_temp = _class = function (_Component) {
	  _inherits(DropdownChecklist, _Component);
	
	  function DropdownChecklist(props) {
	    _classCallCheck(this, DropdownChecklist);
	
	    var _this = _possibleConstructorReturn(this, (DropdownChecklist.__proto__ || Object.getPrototypeOf(DropdownChecklist)).call(this, props));
	
	    _this.onChange = function (event, newValue) {
	      if (_this.props.onChange) {
	        _this.props.onChange(event, newValue);
	      }
	    };
	
	    _this.onBlur = function (event) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event, _this.state.selectedItems);
	      }
	    };
	
	    _this.onToggle = function (event, item) {
	      var newState = _this.newState();
	      var selectedItems = newState.selectedItems;
	
	      if (selectedItems.includes(item.id)) {
	        // WPS-43 - user may not remove all items from list, one must remain.
	        if (selectedItems.length > 1) {
	          newState.selectedItems = selectedItems.filter(function (i) {
	            return i !== item.id;
	          });
	        }
	      } else {
	        newState.selectedItems.push(item.id);
	      }
	
	      _this.setState(newState);
	      return _this.onChange(event, newState.selectedItems);
	    };
	
	    _this.state = {
	      selectedItems: props.value || []
	    };
	    return _this;
	  }
	
	  _createClass(DropdownChecklist, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((0, _lodash.get)(nextProps, 'menuItems.length') !== (0, _lodash.get)(this.props, 'menuItems.length') || !nextProps.value) {
	        var newState = this.newState();
	        newState.selectedItems = nextProps.value || []; // WPS-43 - do not clear segment types when parent changes
	        this.setState(newState);
	        this.onChange(null, newState.selectedItems);
	      }
	    }
	  }, {
	    key: 'newState',
	    value: function newState() {
	      return Object.assign({}, this.state);
	    }
	  }, {
	    key: 'isError',
	    value: function isError() {
	      return this.props.required && this.props.dirty && !this.state.selectedItems.length;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var selectedText = function selectedText() {
	        return _this2.props.menuItems.filter(function (item) {
	          return _this2.state.selectedItems.includes(item.id);
	        }).map(function (item) {
	          return (0, _lodash.get)(item, 'name');
	        }).join(', ') || _this2.props.defaultLabel;
	      };
	
	      var containerStyle = (0, _classnames2.default)('clearfix', 'dropdown-wrapper checklist-wrapper', { disabled: this.props.disabled, optional: !this.props.required, error: this.isError() });
	
	      return _react2.default.createElement(
	        'div',
	        { className: containerStyle },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('floatingLabelText'),
	            'data-id': this.props['data-id'] + ' floatingLabelText',
	            style: this.isError() ? { color: 'rgb(244, 67, 54)' } : null
	          },
	          this.props.textLabel
	        ),
	        _react2.default.createElement(
	          _c_SourceModDropDown2.default,
	          {
	            className: (0, _classnames2.default)('dropdown', { disabled: this.props.disabled }),
	            labelStyle: labelStyle,
	            listStyle: listStyle,
	            menuStyle: menuStyle,
	            popoverStyle: { width: commonWidth },
	            autoWidth: false,
	            canAutoPosition: true,
	            checkList: true,
	            'data-id': this.props['data-id']
	          },
	          _react2.default.createElement(_c_SourceModMenuItem2.default, {
	            primaryText: selectedText(),
	            className: 'checklist-header dropdown-label',
	            value: null
	          }),
	          _react2.default.createElement(Tags, {
	            menuItems: this.props.menuItems,
	            selectedItems: this.state.selectedItems,
	            onRemove: this.onToggle
	          }),
	          _react2.default.createElement(MenuItemGroups, {
	            menuItems: this.props.menuItems,
	            selectedItems: this.state.selectedItems,
	            groupBy: this.props.groupBy,
	            onChange: this.onToggle
	          })
	        )
	      );
	    }
	  }]);
	
	  return DropdownChecklist;
	}(_react.Component), _class.propTypes = {
	  menuItems: _react.PropTypes.array.isRequired,
	  defaultValue: _react.PropTypes.any,
	  value: _react.PropTypes.any,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  textLabel: _react.PropTypes.string,
	  defaultLabel: _react.PropTypes.string,
	  groupBy: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  errorText: _react.PropTypes.string,
	  'data-id': _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  required: _react.PropTypes.bool,
	  dirty: _react.PropTypes.bool
	}, _class.defaultProps = {
	  defaultLabel: 'Select'
	}, _temp);
	exports.default = DropdownChecklist;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactScrollspy = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollColumn = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var searchQuery = store.routing.locationBeforeTransitions.query.search;
	  return {
	    search: searchQuery && [].concat(searchQuery) || []
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ScrollColumn, _Component);
	
	  function ScrollColumn(props, context) {
	    _classCallCheck(this, ScrollColumn);
	
	    return _possibleConstructorReturn(this, (ScrollColumn.__proto__ || Object.getPrototypeOf(ScrollColumn)).call(this, props, context));
	  }
	
	  _createClass(ScrollColumn, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'scroll-column' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement(
	          _reactScrollspy.Scrollspy,
	          { items: this.props.navGroups, currentClassName: 'active' },
	          this.props.navGroups.map(function (section, index) {
	            return _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#' + section },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'label' },
	                  _lodash2.default.replace(section, new RegExp("_", "g"), " ")
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ScrollColumn;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  navGroups: _react.PropTypes.array.isRequired,
	  title: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = ScrollColumn;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(5);
	
	var _sync = __webpack_require__(21);
	
	var _ModalClose = __webpack_require__(857);
	
	var _ModalClose2 = _interopRequireDefault(_ModalClose);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Worksheet = (_dec = (0, _reactRedux.connect)(function (store) {
	  return { trail: store.worksheets.trail };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Worksheet, _Component);
	
	  function Worksheet(props, context) {
	    _classCallCheck(this, Worksheet);
	
	    var _this = _possibleConstructorReturn(this, (Worksheet.__proto__ || Object.getPrototypeOf(Worksheet)).call(this, props, context));
	
	    _this.goBack = function () {
	      var prevWorksheet = _this.props.trail.find(function (p) {
	        return p.worksheet !== _this.props.baseRoute;
	      }) || { path: _this.props.baseRoute };
	      _this.props.dispatch(ui.showSpinner());
	      _this.props.dispatch((0, _sync.removeWorksheet)(_this.props.baseRoute));
	      _this.props.dispatch((0, _reactRouterRedux.push)(prevWorksheet.path));
	    };
	
	    _this.respondToKeyPress = function (event) {
	      // escape key response
	      if (event && event.keyCode === 27) {
	        return _this.goBack();
	      }
	    };
	
	    var dispatch = props.dispatch,
	        baseRoute = props.baseRoute,
	        location = props.location;
	
	
	    _this.updateLocation(dispatch, baseRoute, location);
	    _this.onBack = function () {
	      return _this.respondToKeyPress();
	    };
	    return _this;
	  }
	
	  _createClass(Worksheet, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.location !== this.props.location) {
	        var _props = this.props,
	            dispatch = _props.dispatch,
	            baseRoute = _props.baseRoute,
	            location = _props.location;
	
	
	        this.updateLocation(dispatch, baseRoute, location);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.onBack);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.onBack);
	    }
	  }, {
	    key: 'getComponent',
	    value: function getComponent(key) {
	      return this.props.children.filter(function (c) {
	        return !!c;
	      }).filter(function (c) {
	        return c.key === key;
	      });
	    }
	  }, {
	    key: 'getChildren',
	    value: function getChildren() {
	      return this.props.children.filter(function (c) {
	        return !!c;
	      }).filter(function (c) {
	        return !['Card', 'SubNav', 'Side'].includes(c.key);
	      });
	    }
	  }, {
	    key: 'updateLocation',
	    value: function updateLocation(dispatch, baseRoute, location) {
	      var path = location.pathname.toLowerCase().replace(/\/$/, "");
	      dispatch((0, _sync.updateWorksheet)(baseRoute, path));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var CardComponent = this.getComponent('Card');
	      var hasCardPanel = !!CardComponent.length;
	      var SubNavComponent = this.getComponent('SubNav');
	      var hasSubNavPanel = !!SubNavComponent.length;
	      var SideComponent = this.getComponent('Side');
	      var hasSidePanel = !!SideComponent.length;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'worksheet-component ' + (0, _lodash.get)(this.props, 'className', '') },
	        _react2.default.createElement(Toolbar, {
	          goBack: this.goBack,
	          pin: this.props.pin
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'worksheet-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'worksheet-content-main' },
	            hasCardPanel && _react2.default.createElement(
	              'div',
	              { className: 'worksheet-content-card' },
	              CardComponent
	            ),
	            hasSubNavPanel && _react2.default.createElement(
	              'div',
	              { className: 'worksheet-content-subnav' },
	              SubNavComponent
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'worksheet-content-panels' },
	              this.getChildren()
	            )
	          ),
	          hasSidePanel && _react2.default.createElement(
	            'div',
	            { className: 'worksheet-content-side' },
	            SideComponent
	          )
	        )
	      );
	    }
	  }]);
	
	  return Worksheet;
	}(_react.Component), _class2.propTypes = {
	  baseRoute: _react.PropTypes.string.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  location: _react.PropTypes.object.isRequired,
	  trail: _react.PropTypes.array.isRequired,
	  pin: _react.PropTypes.object,
	  className: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = Worksheet;
	
	
	function Toolbar(props) {
	  var _props$isPinned = props.isPinned,
	      isPinned = _props$isPinned === undefined ? false : _props$isPinned,
	      pin = props.pin,
	      goBack = props.goBack;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'worksheet-toolbar' },
	    pin && _react2.default.createElement(
	      'div',
	      { className: 'worksheet-toolbar-item left' },
	      pin
	    ),
	    goBack && _react2.default.createElement(_ModalClose2.default, {
	      handleClose: goBack
	    })
	  );
	}
	
	Toolbar.propTypes = {
	  isPinned: _react.PropTypes.bool, // For future use
	  pin: _react.PropTypes.func, // For future use
	  goBack: _react.PropTypes.func
	};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PasswordWithValidators;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _f_PasswordValidator = __webpack_require__(869);
	
	var _f_PasswordValidator2 = _interopRequireDefault(_f_PasswordValidator);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// checking password functions
	
	
	// app components
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	var lowerCaseLetterRegex = /[a-z]/;
	
	// import customized material UI element
	
	
	// classnames utility
	
	var upperCaseLetterRegex = /[A-Z]/;
	var oneLowerCase = function oneLowerCase(val) {
	  return val.split('').some(function (letter) {
	    return lowerCaseLetterRegex.test(letter);
	  });
	};
	var oneUpperCase = function oneUpperCase(val) {
	  return val.split('').some(function (letter) {
	    return upperCaseLetterRegex.test(letter);
	  });
	};
	var sixCharacterMin = function sixCharacterMin(val) {
	  return val.length >= 6;
	};
	var oneNumber = function oneNumber(val) {
	  return val.split('').some(function (letter) {
	    return !isNaN(+letter);
	  });
	};
	
	function onChange(propsOnChange, event, password) {
	  propsOnChange(event, password, sixCharacterMin(password) && oneNumber(password) && oneLowerCase(password) && oneUpperCase(password));
	}
	
	function PasswordWithValidators(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'password-with-validations ' + props.className },
	    _react2.default.createElement(_c_TextField2.default, { className: 'full-width',
	      floatingLabelText: 'Password',
	      'data-id': 'Password',
	      password: true,
	      value: props.value,
	      floatingLabelFixed: true,
	      onChange: onChange.bind(this, props.onChange),
	      onFocus: props.onFocus,
	      onBlur: props.onBlur }),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('password-validators-container', 'clearfix', { hide: props.hideWhenEmpty && !props.value }) },
	      _react2.default.createElement(_f_PasswordValidator2.default, { label: 'One lowercase character', valid: oneLowerCase(props.value) }),
	      _react2.default.createElement(_f_PasswordValidator2.default, { label: 'One number', valid: oneNumber(props.value) }),
	      _react2.default.createElement(_f_PasswordValidator2.default, { label: 'One uppercase character', valid: oneUpperCase(props.value) }),
	      _react2.default.createElement(_f_PasswordValidator2.default, { label: 'Six characters minimum', valid: sixCharacterMin(props.value) })
	    )
	  );
	}
	
	PasswordWithValidators.propTypes = {
	  onChange: _react.PropTypes.func,
	  value: _react.PropTypes.string,
	  hideWhenEmpty: _react.PropTypes.bool
	};
	
	PasswordWithValidators.defaultProps = {
	  onChange: function onChange() {
	    return '';
	  },
	  onFocus: function onFocus() {
	    return '';
	  },
	  onBlur: function onBlur() {
	    return '';
	  },
	  value: ''
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSegmentsPositionsDepartments = getSegmentsPositionsDepartments;
	
	var _lodash = __webpack_require__(4);
	
	var _dropdowns = __webpack_require__(206);
	
	function getSegmentsPositionsDepartments(props) {
	  var industryId = props.staticData.account.industryId;
	
	  var segments = props.staticData.segmentTypes.filter(function (x) {
	    return x.industryId === industryId && (0, _lodash.isNil)(x.subElement) && (0, _lodash.isNil)(x.parentId);
	  }).sort(_dropdowns.defaultOrdering);
	
	  // positions
	  var categoryIdPositions = (0, _lodash.get)(props.staticData.skillCategoryTypes.find(function (x) {
	    return x.industryId === industryId && x.hardcodelink === 'POSITIONS';
	  }), 'id', -1);
	  var positions = [];
	  if (categoryIdPositions !== -1) {
	    positions = props.staticData.skillTypes.filter(function (x) {
	      return x.skillCategoryTypeId === categoryIdPositions && x.industryId === industryId;
	    }).sort(_dropdowns.defaultOrdering);
	  }
	
	  // departments
	  var categoryIdDepartments = (0, _lodash.get)(props.staticData.skillCategoryTypes.find(function (x) {
	    return x.industryId === industryId && x.hardcodelink === 'DEPARTMENTS';
	  }), 'id', -1);
	  var departments = [];
	  if (categoryIdDepartments !== -1) {
	    departments = props.staticData.skillTypes.filter(function (x) {
	      return x.skillCategoryTypeId === categoryIdDepartments && x.industryId === industryId;
	    }).sort(_dropdowns.defaultOrdering);
	  }
	
	  return { segments: segments, positions: positions, departments: departments };
	}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function DeleteIcon(props) {
	    var className = props.className,
	        otherProps = _objectWithoutProperties(props, ["className"]);
	
	    return _react2.default.createElement(
	        "svg",
	        _extends({ width: "14px", height: "17px", viewBox: "0 0 14 17", version: "1.1", xmlns: "http://www.w3.org/2000/svg", className: "delete-icon " + className }, otherProps),
	        _react2.default.createElement(
	            "g",
	            { id: "1160---Upload-of-Assessment-Scores", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { id: "1160---Upload-of-Assessment-Scores-4", transform: "translate(-420.000000, -158.000000)", fill: "#333333" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "icon_delete", transform: "translate(420.000000, 158.000000)" },
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Icons" },
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Group" },
	                            _react2.default.createElement("path", { d: "M10.502069,16.9200001 L3.50068967,16.9200001 C2.21360277,16.9200001 1.16689656,15.8732939 1.16689656,14.586207 L1.16689656,4.66758623 C1.16689656,4.34493933 1.42769794,4.08413795 1.75034484,4.08413795 L12.2524138,4.08413795 C12.5750607,4.08413795 12.8358621,4.34493933 12.8358621,4.66758623 L12.8358621,14.586207 C12.8358621,15.8732939 11.7891559,16.9200001 10.502069,16.9200001 L10.502069,16.9200001 Z M2.33379311,5.25103451 L2.33379311,14.586207 C2.33379311,15.2297504 2.85714622,15.7531035 3.50068967,15.7531035 L10.502069,15.7531035 C11.1456125,15.7531035 11.6689656,15.2297504 11.6689656,14.586207 L11.6689656,5.25103451 L2.33379311,5.25103451 L2.33379311,5.25103451 Z", id: "Shape" }),
	                            _react2.default.createElement(
	                                "g",
	                                { id: "Shape" },
	                                _react2.default.createElement("path", { d: "M13.4193104,3.50068967 L0.583448278,3.50068967 C0.26080138,3.50068967 0,3.23988829 0,2.91724139 C0,2.59459449 0.26080138,2.33379311 0.583448278,2.33379311 L13.4193104,2.33379311 C13.7419573,2.33379311 14.0027587,2.59459449 14.0027587,2.91724139 C14.0027587,3.23988829 13.7419573,3.50068967 13.4193104,3.50068967 L13.4193104,3.50068967 Z" }),
	                                _react2.default.createElement("path", { d: "M8.1682759,3.46451588 C7.845629,3.46451588 7.58482762,3.2037145 7.58482762,2.8810676 L7.58482762,1.56830897 C7.58482762,1.35009932 7.40162486,1.16689656 7.18399865,1.16689656 L6.81934348,1.16689656 C6.60113382,1.16689656 6.41793106,1.35009932 6.41793106,1.56830897 L6.41793106,2.80813656 C6.41793106,3.13078346 6.15712968,3.39158484 5.83448278,3.39158484 C5.51183589,3.39158484 5.25103451,3.13078346 5.25103451,2.80813656 L5.25103451,1.56830897 C5.25103451,0.703638624 5.95467313,0 6.81934348,0 L7.18399865,0 C8.04808555,0 8.75172418,0.703638624 8.75172418,1.56830897 L8.75172418,2.8810676 C8.75172418,3.20313105 8.4909228,3.46451588 8.1682759,3.46451588 L8.1682759,3.46451588 Z" })
	                            ),
	                            _react2.default.createElement("path", { d: "M5.54275865,14.0027587 C5.38172692,14.0027587 5.25103451,13.8720663 5.25103451,13.7110345 L5.25103451,7.29310348 C5.25103451,7.13207176 5.38172692,7.00137934 5.54275865,7.00137934 C5.70379037,7.00137934 5.83448278,7.13207176 5.83448278,7.29310348 L5.83448278,13.7110345 C5.83448278,13.8720663 5.70379037,14.0027587 5.54275865,14.0027587 L5.54275865,14.0027587 Z", id: "Shape" }),
	                            _react2.default.createElement("path", { d: "M8.46000004,14.0027587 C8.29896831,14.0027587 8.1682759,13.8720663 8.1682759,13.7110345 L8.1682759,7.29310348 C8.1682759,7.13207176 8.29896831,7.00137934 8.46000004,7.00137934 C8.62103176,7.00137934 8.75172418,7.13207176 8.75172418,7.29310348 L8.75172418,13.7110345 C8.75172418,13.8720663 8.62103176,14.0027587 8.46000004,14.0027587 L8.46000004,14.0027587 Z", id: "Shape" })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	DeleteIcon.propTypes = {
	    className: _react.PropTypes.string
	};
	
	exports.default = DeleteIcon;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function DocumentIcon(props) {
	    var className = props.className,
	        otherProps = _objectWithoutProperties(props, ["className"]);
	
	    return _react2.default.createElement(
	        "svg",
	        _extends({ width: "30px", height: "30px", viewBox: "0 0 30 30", version: "1.1", xmlns: "http://www.w3.org/2000/svg", className: "profile-icon " + className }, otherProps),
	        _react2.default.createElement(
	            "g",
	            { id: "1160---Upload-of-Assessment-Scores", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { transform: "translate(-866.000000, -438.000000)", id: "Group-38-Copy", fill: "#4A4A4A" },
	                _react2.default.createElement(
	                    "g",
	                    { transform: "translate(866.000000, 438.000000)" },
	                    _react2.default.createElement("path", { d: "M15,30 C6.729,30 0,23.271 0,15 C0,6.729 6.729,0 15,0 C23.271,0 30,6.729 30,15 C30,23.271 23.271,30 15,30 L15,30 Z M15,2 C7.832,2 2,7.832 2,15 C2,22.168 7.832,28 15,28 C22.168,28 28,22.168 28,15 C28,7.832 22.168,2 15,2 L15,2 Z", id: "Shape" }),
	                    _react2.default.createElement(
	                        "g",
	                        { id: "icon_blank-file", transform: "translate(10.000000, 8.000000)", strokeWidth: "0.4", stroke: "#4A4A4A" },
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Icons" },
	                            _react2.default.createElement(
	                                "g",
	                                { id: "Group" },
	                                _react2.default.createElement("path", { d: "M10.5416667,14 L0.458333333,14 C0.205333333,14 0,13.804 0,13.5625 L0,0.4375 C0,0.196 0.205333333,0 0.458333333,0 L6.77966667,0 C6.90433333,0 7.02395833,0.0485625 7.110125,0.1343125 L10.872125,3.8714375 C10.9541667,3.9528125 11,4.06175 11,4.174625 L11,13.5625 C11,13.804 10.7946667,14 10.5416667,14 L10.5416667,14 Z M0.916666667,13.125 L10.0833333,13.125 L10.0833333,4.3505 L6.58441667,0.875 L0.916666667,0.875 L0.916666667,13.125 L0.916666667,13.125 Z", id: "Shape" }),
	                                _react2.default.createElement("path", { d: "M10.125,5.375 L6.45833333,5.375 C6.20533333,5.375 6,5.179 6,4.9375 L6,1.4375 C6,1.196 6.20533333,1 6.45833333,1 C6.71133333,1 6.91666667,1.196 6.91666667,1.4375 L6.91666667,4.5 L10.125,4.5 C10.378,4.5 10.5833333,4.696 10.5833333,4.9375 C10.5833333,5.179 10.378,5.375 10.125,5.375 L10.125,5.375 Z", id: "Shape" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	DocumentIcon.propTypes = {
	    className: _react.PropTypes.string
	};
	
	exports.default = DocumentIcon;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function FlagIcon(props) {
	  var color = props.color,
	      otherProps = _objectWithoutProperties(props, ['color']);
	
	  var defaultColor = '#D0011B';
	
	  return _react2.default.createElement(
	    'svg',
	    { width: '11', height: '14', viewBox: '0 0 11 14', xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement(
	      'title',
	      null,
	      '41AA3668-773D-4F3F-A321-27A29525157F'
	    ),
	    _react2.default.createElement('path', { d: 'M1.486 3.23a2.54 2.54 0 0 1 2.54-1.57c.6 0 1.2 0 1.8-.07A2.57 2.57 0 0 0 8.296 0l.53 1.15c.63 1.37 1.26 2.74 1.88 4.11a.69.69 0 0 1 0 .52 2.57 2.57 0 0 1-2.4 1.34c-.77 0-1.55.06-2.32.14a2.29 2.29 0 0 0-1.79 1.13.57.57 0 0 0 0 .62c.59 1.23 1.17 2.46 1.75 3.7l.08.18a.77.77 0 0 1-.28 1 .75.75 0 0 1-1-.45l-3.52-7.46-.92-2a.75.75 0 1 1 1.18-.75z',
	      fillRule: 'nonzero', fill: color || defaultColor })
	  );
	}
	
	exports.default = FlagIcon;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = deepUnset;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// does lodash unset but also deletes parent objects if they are empty
	function deepUnset(obj, propList) {
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	    return console.log('first argument must be object');
	  }
	
	  if (typeof propList === 'string') propList = propList.split('.');else if (!Array.isArray(propList)) return console.log('second argument must be either string or array');else propList = propList.reduce(function (prev, curr) {
	    return prev.concat(curr.split('.'));
	  }, []);
	
	  // remove origin
	  _lodash2.default.unset(obj, propList);
	  propList.pop();
	  while (propList.length && _lodash2.default.chain(obj).get(propList).isEmpty().value()) {
	    _lodash2.default.unset(obj, propList);
	    propList.pop();
	  }
	}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (email) {
	  return _react2.default.createElement(
	    'a',
	    { href: 'mailto:' + email, target: '_top' },
	    email
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatCompanyUrlForHyperlink = formatCompanyUrlForHyperlink;
	exports.extractCompanyUrlFromEmail = extractCompanyUrlFromEmail;
	
	var _lodash = __webpack_require__(4);
	
	function formatCompanyUrlForHyperlink(url) {
	  if (url) {
	    // if url exists, format and return it
	    url = (0, _lodash.startsWith)(url, 'https') ? url.slice(8) : url;
	    url = (0, _lodash.startsWith)(url, 'http') ? url.slice(7) : url;
	  } else {
	    // if url is a falsey value, return empty string
	    url = '';
	  }
	  return url;
	}
	
	function extractCompanyUrlFromEmail(email) {
	  // strip characters before '@'
	  // split remaining domain on '.' and take the last two parts
	
	  // user@domain.com => domain.com
	  // user@mail.domain.com => domain.com
	
	  var parts = email.replace(/.*@/, '').split('.');
	  if (parts.length < 2) return email;
	  return '' + parts[parts.length - 2] + '.' + ('' + parts[parts.length - 1]);
	}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.activeSegmentTypes = activeSegmentTypes;
	
	var _lodash = __webpack_require__(4);
	
	function activeSegmentTypes(segmentTypes, industryTypes, activeIndustryTypes, segmentTypesValue) {
	  var findIndustryById = function findIndustryById(id) {
	    var industry = industryTypes.find(function (i) {
	      return i.id === id;
	    }) || {};
	    return (0, _lodash.get)(industry, 'name');
	  };
	
	  return segmentTypes.filter(function (s) {
	    return (0, _lodash.isNil)(s.parentId) || (activeIndustryTypes || []).includes(s.parentId) || (segmentTypesValue || []).includes(s.id);
	  }).map(function (s) {
	    return _extends({}, s, { parentName: findIndustryById(s.parentId) });
	  });
	}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = localDate;
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function localDate(timestampString) {
	  return _moment2.default.utc(timestampString).format('MM/DD/YY');
	}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.concat = concat;
	exports.maxLength = maxLength;
	exports.isNumeric = isNumeric;
	
	var _lodash = __webpack_require__(4);
	
	function concat(arrayOfStrings) {
	  var withString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
	
	  if (arrayOfStrings instanceof Array) {
	    return arrayOfStrings.map(_lodash.trim).filter(function (s) {
	      return !(0, _lodash.isEmpty)(s);
	    }).join(withString);
	  }
	
	  return '';
	}
	
	function maxLength(str) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	  var omission = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  if (str && typeof str === 'string') {
	    return (0, _lodash.truncate)(str, { length: length, omission: omission });
	  }
	
	  return str;
	}
	
	function isNumeric(str) {
	  return !isNaN(str);
	}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateCountry = updateCountry;
	function updateCountry() {
	  var countryList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return function (value) {
	    var user = {
	      country: value
	    };
	    var otherCountry = countryList.find(function (c) {
	      return c.subElement === 'Other';
	    });
	
	    if (otherCountry && user.country === otherCountry.id) {
	      user.state = null;
	    } else {
	      user.countryOther = null;
	    }
	
	    return user;
	  };
	}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var util = __webpack_require__(3059);
	
	var _require = __webpack_require__(4),
	    merge = _require.merge;
	
	module.exports = {
	  combine: function combine() {
	    return merge.apply(undefined, arguments);
	  },
	  required: function required() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'This field is required.';
	
	    return {
	      required: {
	        message: message
	      }
	    };
	  },
	  matches: function matches(regex) {
	    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Must be valid format';
	
	    return {
	      matches: {
	        options: regex,
	        message: message
	      }
	    };
	  },
	  isEmail: function isEmail() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Must be a valid email.';
	
	    return {
	      isEmail: {
	        message: message
	      }
	    };
	  },
	  isLength: function isLength() {
	    var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var max = arguments[1];
	    var message = arguments[2];
	
	    var defaultMessage = 'Minimum length of %d characters and a maximum of %s.';
	    return {
	      isLength: {
	        options: {
	          min: min,
	          max: max
	        },
	        message: message || util.format(defaultMessage, min, max && '' + max || 'indefinite')
	      }
	    };
	  },
	  isNumeric: function isNumeric() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Must be numeric.';
	
	    return {
	      isNumeric: {
	        message: message
	      }
	    };
	  },
	  isDate: function isDate() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Must be ISO 8601 date format.';
	
	    return {
	      isDate: {
	        message: message
	      }
	    };
	  },
	  isArray: function isArray() {
	    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Must be an array.';
	
	    return {
	      isArray: {
	        options: schema,
	        message: message
	      }
	    };
	  },
	  isBoolean: function isBoolean() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'This field must be a boolean value.';
	
	    return {
	      isBoolean: {
	        message: message
	      }
	    };
	  },
	  isString: function isString() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'This field must be a string value';
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { min: 0 };
	
	    return {
	      isString: {
	        message: message,
	        options: options
	      }
	    };
	  },
	  custom: function custom() {
	    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'custom';
	    var validator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (obj, val) {
	      return true;
	    };
	    var message = arguments[2];
	
	    return _defineProperty({}, name, {
	      options: validator,
	      message: message
	    });
	  },
	  related: function related() {
	    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return {
	      related: fields
	    };
	  }
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var validator = __webpack_require__(834);
	var moment = __webpack_require__(6);
	
	var _require = __webpack_require__(4),
	    get = _require.get,
	    _isArray = _require.isArray,
	    _isBoolean = _require.isBoolean,
	    isEmpty = _require.isEmpty,
	    isNil = _require.isNil;
	
	var schemas = __webpack_require__(311);
	
	var validators = {
	  required: function required(value) {
	    return !isNil(value);
	  },
	  matches: function matches(value, regex) {
	    if (isNil(value)) {
	      return true;
	    }
	
	    return validator.matches('' + value, regex);
	  },
	  isEmail: function isEmail(value, options) {
	    if (isNil(value)) {
	      return true;
	    }
	
	    return validator.isEmail(value, options);
	  },
	  isLength: function isLength(value, options) {
	    if (isNil(value)) {
	      return true;
	    }
	
	    if (value instanceof Array) {
	      return value.length >= options.min && (!options.max || value.length <= options.max);
	    }
	
	    return validator.isLength('' + value, options);
	  },
	  isNumeric: function isNumeric(value) {
	    if (isNil(value)) {
	      return true;
	    }
	
	    return !isEmpty('' + value) && !isNaN('' + value);
	  },
	  isDate: function isDate(value) {
	    if (isNil(value)) {
	      return true;
	    }
	
	    return moment(value).isValid();
	  },
	  isArray: function isArray(value, schema) {
	    if (isNil(value)) {
	      return true;
	    }
	
	    if (isEmpty(schema) || isEmpty(value)) {
	      return _isArray(value);
	    }
	
	    var items = validateObject(value, value.map(function () {
	      return schema;
	    }));
	    return _isArray(value) && items.valid;
	  },
	  isBoolean: function isBoolean(value) {
	    if (isNil(value)) {
	      return true;
	    }
	
	    return _isBoolean(value);
	  },
	  isString: function isString(value, options) {
	    if (isNil(value)) {
	      return true;
	    }
	
	    return typeof value === 'string' && validator.isLength(value, options);
	  }
	};
	
	function validate(value) {
	  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var object = arguments[3];
	
	  if (!method || method === 'related' || typeof method !== 'string') {
	    return true;
	  }
	
	  if (!validators[method]) {
	    return typeof options === 'function' ? options(object, value) : false;
	  }
	
	  return validators[method](value, options);
	}
	
	function validateObject() {
	  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	  if (isNil(object) || isEmpty(object)) {
	    return { valid: false, errors: 'object is null or empty.' };
	  }
	
	  return Object.keys(schema).reduce(function (validation, key) {
	
	    if (isNil(schema[key]) || isEmpty(schema[key])) {
	      return validation;
	    }
	
	    var passes = Object.keys(schema[key]).reduce(function (result, method) {
	      var pass = validate(get(object, key), method, get(schema, key + '.' + method + '.options'), object);
	      if (!pass) {
	        validation.errors[key] = validation.errors[key] || [];
	        validation.errors[key].push(get(schema, key + '.' + method + '.message', '(' + method + '): Invalid value.'));
	      }
	
	      return pass && result;
	    }, true);
	
	    validation.valid = validation.valid && passes;
	    return validation;
	  }, { valid: true, errors: {} });
	}
	
	module.exports = {
	  validate: validate,
	  validateObject: validateObject,
	  schemas: schemas
	};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var ApplicantProfile = function (_BaseModel) {
	  _inherits(ApplicantProfile, _BaseModel);
	
	  function ApplicantProfile() {
	    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : applicantProfileSchema;
	
	    _classCallCheck(this, ApplicantProfile);
	
	    return _possibleConstructorReturn(this, (ApplicantProfile.__proto__ || Object.getPrototypeOf(ApplicantProfile)).call(this, schema));
	  }
	
	  _createClass(ApplicantProfile, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return applicantProfileSchema;
	    }
	  }]);
	
	  return ApplicantProfile;
	}(BaseModel);
	
	var applicantProfileSchema = {
	  // // Prelim Application
	
	  employmentStatus: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  availabilityDate: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  totalYearsExperienceNumeric: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  industryYearsExperienceNumeric: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  workedLastInIndustry: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  industryTypes: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  foundUsVia: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  foundUsOther: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  optIntoNewsletter: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  mostRecentSegment: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  mostRecentPosition: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  mostRecentDepartment: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	
	  // // Admin-side
	
	  // Explanation of questions fields
	  mostRecentWork: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  mostRecentWorkFirmType: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  mostRecentWorkDuration: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  previousTypeOfWork: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  hasWorkedRemotely: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  hasWorkedRemotelyComment: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	
	  // Prelim Interview fields
	  currentEmploymentStatus: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  wantToWorkStatus: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  workFromHomeReason: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  retireReasonId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  returnToWorkReasonId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	
	  // // Applicant-side
	
	  // Availability information
	  // availabilityDate comes from Prelim Application section
	  availabilityHoursPerDay: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  availabilityHoursPerWeek: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  workDays: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 1 },
	      message: 'Must select at least 1'
	    }
	  },
	
	  // Home Office
	  hasDedicatedHomeOffice: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  computerTypeId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  computerOperatingSystemId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  hasHighSpeedInternet: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  internetTypeId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  canUpgradeTechnology: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	
	  // Career Sumary
	  careerSummary: {
	    required: {
	      message: 'This field is required.'
	    }
	  }, // Career Sumary
	  personalityAssessmentComment: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = ApplicantProfile;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndeedConversionCode = (_temp = _class = function (_Component) {
	  _inherits(IndeedConversionCode, _Component);
	
	  function IndeedConversionCode(props, context) {
	    _classCallCheck(this, IndeedConversionCode);
	
	    var _this = _possibleConstructorReturn(this, (IndeedConversionCode.__proto__ || Object.getPrototypeOf(IndeedConversionCode)).call(this, props, context));
	
	    _this.state = {
	      conversionId: 4852622368906859,
	      conversionLabel: _this.props.conversionLabel || ''
	    };
	    return _this;
	  }
	
	  _createClass(IndeedConversionCode, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var script1 = document.createElement('script');
	      script1.type = 'text/javascript';
	
	      script1.innerHTML = '\n      var indeed_conversion_id = \'' + this.state.conversionId + '\';\n      var indeed_conversion_label = \'' + this.state.conversionLabel + '\';\n    ';
	
	      var script2 = document.createElement('script');
	      script2.src = '//conv.indeed.com/applyconversion.js';
	
	      this.instance.appendChild(script1);
	      this.instance.appendChild(script2);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { ref: function ref(el) {
	            return _this2.instance = el;
	          } }),
	        _react2.default.createElement(
	          'noscript',
	          null,
	          _react2.default.createElement('img', { height: '1', width: '1', border: '0', src: '//conv.indeed.com/pagead/conv/' + this.state.conversionId + '/?script=0' })
	        )
	      );
	    }
	  }]);
	
	  return IndeedConversionCode;
	}(_react.Component), _class.propTypes = {
	  conversionLabel: _react.PropTypes.string
	}, _temp);
	exports.default = IndeedConversionCode;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _querystring = __webpack_require__(105);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PandoLogicTrackingPixel = (_temp = _class = function (_Component) {
	  _inherits(PandoLogicTrackingPixel, _Component);
	
	  function PandoLogicTrackingPixel(props, context) {
	    _classCallCheck(this, PandoLogicTrackingPixel);
	
	    var _this = _possibleConstructorReturn(this, (PandoLogicTrackingPixel.__proto__ || Object.getPrototypeOf(PandoLogicTrackingPixel)).call(this, props, context));
	
	    _this.appendScript = function (scriptToAppend) {
	      var script = document.createElement('script');
	      script.src = scriptToAppend;
	      script.async = true;
	      document.body.appendChild(script);
	    };
	
	    _this.removeScript = function (scriptToRemove) {
	      var allsuspects = document.getElementsByTagName('script');
	      for (var i = allsuspects.length; i >= 0; i--) {
	        if (allsuspects[i] && allsuspects[i].getAttribute('src') !== null && allsuspects[i].getAttribute('src').indexOf('' + scriptToRemove) !== -1) {
	          allsuspects[i].parentNode.removeChild(allsuspects[i]);
	        }
	      }
	    };
	
	    _this.state = {
	      trackingURL: 'https://tracking.pandoiq.com/22419',
	      conversionType: _this.props.conversionType || ''
	    };
	    return _this;
	  }
	
	  _createClass(PandoLogicTrackingPixel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //  PandoLogic Tracking Pixel
	      var qsParms = _querystring2.default.parse(window.location.search.substring(1));
	      if (qsParms && qsParms.pando_clickuid) {
	        this.appendScript(this.state.trackingURL);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      //  PandoLogic Tracking Pixel
	      var queryString = _querystring2.default.parse(window.location.search.substring(1));
	      if (queryString && queryString.pando_clickuid) {
	        this.removeScript(this.state.trackingURL);
	      }
	    }
	
	    // dynamically add script to component
	
	
	    // dynamically remove script to component
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { ref: function ref(el) {
	            return _this2.instance = el;
	          } })
	      );
	    }
	  }]);
	
	  return PandoLogicTrackingPixel;
	}(_react.Component), _class.propTypes = {
	  conversionType: _react.PropTypes.string
	}, _temp);
	exports.default = PandoLogicTrackingPixel;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getImpersonation = getImpersonation;
	exports.resetImpersonation = resetImpersonation;
	exports.deleteImpersonation = deleteImpersonation;
	
	var _superagent = __webpack_require__(440);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getImpersonation(callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch, getState) {
	      simpleIsoFetch.get('/api/auth/impersonate').then(function (_ref) {
	        var _ref$body$data$items = _slicedToArray(_ref.body.data.items, 1),
	            impersonateUser = _ref$body$data$items[0];
	
	        return callback(null, impersonateUser);
	      }).catch(callback);
	    };
	  };
	}
	
	function resetImpersonation(impersonateId) {
	  return new Promise(function (resolve, reject) {
	    _superagent2.default.post('/api/auth/impersonate').set('Content-Type', 'application/json').send({ impersonateId: impersonateId }).end(function (err, res) {
	      if (!err && res.statusCode === 204) {
	        return resolve();
	      }
	
	      return reject(err);
	    });
	  });
	}
	
	function deleteImpersonation() {
	  return new Promise(function (resolve, reject) {
	    _superagent2.default.delete('/api/auth/impersonate').set('Content-Type', 'application/json').send().end(function (err, res) {
	      if (!err && res.statusCode === 204) {
	        return resolve();
	      }
	
	      return reject(err);
	    });
	  });
	}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEmployee = createEmployee;
	exports.updateEmployee = updateEmployee;
	exports.removeEmployee = removeEmployee;
	exports.storeEmployees = storeEmployees;
	
	var _actionTypes = __webpack_require__(20);
	
	function createEmployee(employee) {
	  return {
	    type: _actionTypes.CREATE_EMPLOYEE,
	    employee: employee
	  };
	}
	
	function updateEmployee(employee) {
	  return {
	    type: _actionTypes.UPDATE_EMPLOYEE,
	    employee: employee
	  };
	}
	
	function removeEmployee(employeeId) {
	  return {
	    type: _actionTypes.REMOVE_EMPLOYEE,
	    employeeId: employeeId
	  };
	}
	
	function storeEmployees(employees) {
	  return {
	    type: _actionTypes.STORE_EMPLOYEES,
	    employees: employees
	  };
	}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createJobRequestDocuments = createJobRequestDocuments;
	exports.updateJobRequestDocuments = updateJobRequestDocuments;
	exports.resetJobRequestDocuments = resetJobRequestDocuments;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function createJobRequestDocuments(documents) {
	  return {
	    type: actionTypes.CREATE_JOB_REQUEST_DOCUMENTS,
	    documents: documents
	  };
	} // action type strings
	function updateJobRequestDocuments(documents) {
	  return {
	    type: actionTypes.UPDATE_JOB_REQUEST_DOCUMENTS,
	    documents: documents
	  };
	}
	
	function resetJobRequestDocuments() {
	  return {
	    type: actionTypes.RESET_JOB_REQUEST_DOCUMENTS
	  };
	}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getState = getState;
	exports.configureStore = configureStore;
	
	var _redux = __webpack_require__(434);
	
	var _reduxThunk = __webpack_require__(2982);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(1149);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _simpleIsoFetch = __webpack_require__(227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = null;
	
	function getState() {
	  if (store) {
	    return store.getState();
	  }
	}
	
	function configureStore(history, simpleFetch, initialState) {
	  var finalCreateStore = void 0;
	
	  if (true) {
	    finalCreateStore = (0, _redux.applyMiddleware)((0, _simpleIsoFetch.simpleIsoFetchThunk)(simpleFetch), _reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history))(_redux.createStore);
	  } else {
	    var persistState = require('redux-devtools').persistState,
	        DevTools = require('../DevTools').default;
	
	    finalCreateStore = (0, _redux.compose)((0, _redux.applyMiddleware)((0, _simpleIsoFetch.simpleIsoFetchThunk)(simpleFetch), _reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history)), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), // only put in DevTools if user does not have redux devtools chrome extension installed
	    persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
	  }
	
	  store = finalCreateStore(_reducers2.default, initialState);
	
	  if (false) {
	    // Enable Webpack hot module replacement for reducers
	    module.hot.accept('../reducers', function () {
	      var nextReducer = require('../reducers');
	      store.replaceReducer(nextReducer);
	    });
	  }
	
	  return store;
	}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1269), __esModule: true };

/***/ }),
/* 321 */
94,
/* 322 */
[3122, 1276],
/* 323 */
101,
/* 324 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 326 */
[3140, 143, 1292, 324, 330, 497, 1281],
/* 327 */
254,
/* 328 */
[3149, 111, 57, 174],
/* 329 */
[3151, 129, 145, 93],
/* 330 */
[3152, 331, 243],
/* 331 */
[3153, 128],
/* 332 */
103,
/* 333 */
[3159, 176],
/* 334 */
[3160, 128, 57, 325, 335, 129],
/* 335 */
[3161, 93],
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1299);
	var global = __webpack_require__(128);
	var hide = __webpack_require__(175);
	var Iterators = __webpack_require__(177);
	var TO_STRING_TAG = __webpack_require__(93)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(155);
	var toLength = __webpack_require__(46);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1312);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 339 */
[3121, 45, 152],
/* 340 */
[3124, 38, 29],
/* 341 */
324,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(41)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 343 */
[3127, 29],
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(38);
	var setPrototypeOf = __webpack_require__(352).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 345 */
[3130, 179, 41],
/* 346 */
[3134, 150, 152, 180, 77, 41],
/* 347 */
[3135, 149, 7, 78, 77, 76, 179, 346, 180, 86, 41],
/* 348 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var macrotask = __webpack_require__(358).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(94)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(58);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 352 */
[3150, 38, 27, 95, 85],
/* 353 */
[3152, 257, 156],
/* 354 */
[3154, 103, 101],
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(251);
	var defined = __webpack_require__(101);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(103);
	var defined = __webpack_require__(101);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(95);
	var invoke = __webpack_require__(249);
	var html = __webpack_require__(343);
	var cel = __webpack_require__(340);
	var global = __webpack_require__(29);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(94)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(29);
	var DESCRIPTORS = __webpack_require__(44);
	var LIBRARY = __webpack_require__(149);
	var $typed = __webpack_require__(259);
	var hide = __webpack_require__(77);
	var redefineAll = __webpack_require__(153);
	var fails = __webpack_require__(34);
	var anInstance = __webpack_require__(147);
	var toInteger = __webpack_require__(103);
	var toLength = __webpack_require__(46);
	var toIndex = __webpack_require__(536);
	var gOPN = __webpack_require__(151).f;
	var dP = __webpack_require__(45).f;
	var arrayFill = __webpack_require__(337);
	var setToStringTag = __webpack_require__(180);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 360 */
[3160, 29, 100, 149, 537, 45],
/* 361 */
[3163, 217, 41, 179, 100],
/* 362 */
[3165, 130, 521, 179, 80, 347],
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(183);
	var Emitter = __webpack_require__(173);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(1549);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(158),
	    root = __webpack_require__(115);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1656),
	    mapCacheDelete = __webpack_require__(1657),
	    mapCacheGet = __webpack_require__(1658),
	    mapCacheHas = __webpack_require__(1659),
	    mapCacheSet = __webpack_require__(1660);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(369),
	    setCacheAdd = __webpack_require__(1667),
	    setCacheHas = __webpack_require__(1668);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(116),
	    isSymbol = __webpack_require__(377);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1613),
	    isObjectLike = __webpack_require__(159);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(185),
	    isObjectLike = __webpack_require__(159);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1603),
	    baseKeys = __webpack_require__(1620),
	    isArrayLike = __webpack_require__(579);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(1702);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(1718);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(1721);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(384);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(1725);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Subheader = __webpack_require__(601);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? List.propTypes = {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = List;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(161);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(623);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(273);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(187);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onTouchTap: function onTouchTap(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onTouchTap) {
	            item.props.onTouchTap(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          anchorOrigin = _props.anchorOrigin,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: anchorOrigin,
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onTouchTap = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  anchorOrigin: { horizontal: 'right', vertical: 'top' },
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false
	};
	MenuItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? MenuItem.propTypes = {
	  /**
	   * Location of the anchor for the popover of nested `MenuItem`
	   * elements.
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _react.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _react.PropTypes.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the menu item.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = MenuItem;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(384);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(1739);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(615);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;
	
	
	  return {
	    root: {
	      fontWeight: 'normal',
	      fontSize: 12,
	      paddingLeft: tableHeaderColumn.spacing,
	      paddingRight: tableHeaderColumn.spacing,
	      height: tableHeaderColumn.height,
	      textAlign: 'left',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      color: tableHeaderColumn.textColor,
	      position: 'relative'
	    },
	    tooltip: {
	      boxSizing: 'border-box',
	      marginTop: tableHeaderColumn.height / 2
	    }
	  };
	}
	
	var TableHeaderColumn = function (_Component) {
	  (0, _inherits3.default)(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeaderColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onMouseEnter = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: true });
	      }
	    }, _this.onMouseLeave = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: false });
	      }
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipStyle = _props.tooltipStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      };
	
	      var tooltipNode = void 0;
	
	      if (tooltip !== undefined) {
	        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
	          label: tooltip,
	          show: this.state.hovered,
	          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
	        });
	      }
	
	      return _react2.default.createElement(
	        'th',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        tooltipNode,
	        children
	      );
	    }
	  }]);
	  return TableHeaderColumn;
	}(_react.Component);
	
	TableHeaderColumn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableHeaderColumn.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _react.PropTypes.number,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  hoverable: _react.PropTypes.bool,
	  /** @ignore */
	  onClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHoverExit: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The string to supply to the tooltip. If not
	   * string is supplied no tooltip will be shown.
	   */
	  tooltip: _react.PropTypes.string,
	  /**
	   * Additional styling that can be applied to the tooltip.
	   */
	  tooltipStyle: _react.PropTypes.object
	} : void 0;
	exports.default = TableHeaderColumn;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(278);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	 false ? ClickAwayListener.propTypes = {
	  children: _react.PropTypes.element,
	  onClickAway: _react.PropTypes.func
	} : void 0;
	exports.default = ClickAwayListener;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(390);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(616);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange,
	        onMouseUp: showTouchRipple && this.handleMouseUp,
	        onMouseDown: showTouchRipple && this.handleMouseDown,
	        onMouseLeave: showTouchRipple && this.handleMouseLeave,
	        onTouchStart: showTouchRipple && this.handleTouchStart,
	        onTouchEnd: showTouchRipple && this.handleTouchEnd
	      }));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedSwitch.propTypes = {
	  checked: _react.PropTypes.bool,
	  className: _react.PropTypes.string,
	  defaultChecked: _react.PropTypes.bool,
	  disableFocusRipple: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  iconStyle: _react.PropTypes.object,
	  inputStyle: _react.PropTypes.object,
	  inputType: _react.PropTypes.string.isRequired,
	  label: _react.PropTypes.node,
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  labelStyle: _react.PropTypes.object,
	  name: _react.PropTypes.string,
	  onBlur: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseUp: _react.PropTypes.func,
	  onParentShouldUpdate: _react.PropTypes.func,
	  onSwitch: _react.PropTypes.func,
	  onTouchEnd: _react.PropTypes.func,
	  onTouchStart: _react.PropTypes.func,
	  rippleColor: _react.PropTypes.string,
	  rippleStyle: _react.PropTypes.object,
	  style: _react.PropTypes.object,
	  switchElement: _react.PropTypes.element.isRequired,
	  switched: _react.PropTypes.bool.isRequired,
	  thumbStyle: _react.PropTypes.object,
	  trackStyle: _react.PropTypes.object,
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = EnhancedSwitch;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(161);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(162);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(1781);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FocusRipple.propTypes = {
	  color: _react.PropTypes.string,
	  innerStyle: _react.PropTypes.object,
	  opacity: _react.PropTypes.number,
	  show: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FocusRipple;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(223);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _SlideInChild = __webpack_require__(1783);
	
	var _SlideInChild2 = _interopRequireDefault(_SlideInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideIn = function (_Component) {
	  (0, _inherits3.default)(SlideIn, _Component);
	
	  function SlideIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlideIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
	      return _this.props.direction;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlideIn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          direction = _props.direction,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _SlideInChild2.default,
	          {
	            key: child.key,
	            direction: direction,
	            enterDelay: enterDelay,
	            getLeaveDirection: _this2.getLeaveDirection,
	            style: childStyle
	          },
	          child
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return SlideIn;
	}(_react.Component);
	
	SlideIn.defaultProps = {
	  enterDelay: 0,
	  direction: 'left'
	};
	SlideIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SlideIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  direction: _react.PropTypes.oneOf(['left', 'right', 'up', 'down']),
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = SlideIn;

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(214);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(1594);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(117);
	
	var _lightBaseTheme = __webpack_require__(1790);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(1793);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(2741);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(2742);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(2745);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(1784);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(1792);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = muiThemeable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getMuiTheme = __webpack_require__(393);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_THEME = void 0;
	
	function getDefaultTheme() {
	  if (!DEFAULT_THEME) {
	    DEFAULT_THEME = (0, _getMuiTheme2.default)();
	  }
	  return DEFAULT_THEME;
	}
	
	function muiThemeable() {
	  return function (Component) {
	    var MuiComponent = function MuiComponent(props, context) {
	      var _context$muiTheme = context.muiTheme,
	          muiTheme = _context$muiTheme === undefined ? getDefaultTheme() : _context$muiTheme;
	
	
	      return _react2.default.createElement(Component, (0, _extends3.default)({ muiTheme: muiTheme }, props));
	    };
	
	    MuiComponent.contextTypes = {
	      muiTheme: _react.PropTypes.object.isRequired
	    };
	
	    return MuiComponent;
	  };
	}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var characterEntities = __webpack_require__(1586);
	var legacy = __webpack_require__(1585);
	var invalid = __webpack_require__(1587);
	var decimal = __webpack_require__(263);
	var hexadecimal = __webpack_require__(1580);
	var alphanumerical = __webpack_require__(1578);
	
	/* Expose. */
	module.exports = wrapper;
	
	/* Methods. */
	var own = {}.hasOwnProperty;
	var fromCharCode = String.fromCharCode;
	var noop = Function.prototype;
	
	/* Characters. */
	var REPLACEMENT = '\uFFFD';
	var FORM_FEED = '\f';
	var AMPERSAND = '&';
	var OCTOTHORP = '#';
	var SEMICOLON = ';';
	var NEWLINE = '\n';
	var X_LOWER = 'x';
	var X_UPPER = 'X';
	var SPACE = ' ';
	var LESS_THAN = '<';
	var EQUAL = '=';
	var EMPTY = '';
	var TAB = '\t';
	
	/* Default settings. */
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	};
	
	/* Reference types. */
	var NAMED = 'named';
	var HEXADECIMAL = 'hexadecimal';
	var DECIMAL = 'decimal';
	
	/* Map of bases. */
	var BASE = {};
	
	BASE[HEXADECIMAL] = 16;
	BASE[DECIMAL] = 10;
	
	/* Map of types to tests. Each type of character reference
	 * accepts different characters. This test is used to
	 * detect whether a reference has ended (as the semicolon
	 * is not strictly needed). */
	var TESTS = {};
	
	TESTS[NAMED] = alphanumerical;
	TESTS[DECIMAL] = decimal;
	TESTS[HEXADECIMAL] = hexadecimal;
	
	/* Warning messages. */
	var NAMED_NOT_TERMINATED = 1;
	var NUMERIC_NOT_TERMINATED = 2;
	var NAMED_EMPTY = 3;
	var NUMERIC_EMPTY = 4;
	var NAMED_UNKNOWN = 5;
	var NUMERIC_DISALLOWED = 6;
	var NUMERIC_PROHIBITED = 7;
	
	var NUMERIC_REFERENCE = 'Numeric character references';
	var NAMED_REFERENCE = 'Named character references';
	var TERMINATED = ' must be terminated by a semicolon';
	var VOID = ' cannot be empty';
	
	var MESSAGES = {};
	
	MESSAGES[NAMED_NOT_TERMINATED] = NAMED_REFERENCE + TERMINATED;
	MESSAGES[NUMERIC_NOT_TERMINATED] = NUMERIC_REFERENCE + TERMINATED;
	MESSAGES[NAMED_EMPTY] = NAMED_REFERENCE + VOID;
	MESSAGES[NUMERIC_EMPTY] = NUMERIC_REFERENCE + VOID;
	MESSAGES[NAMED_UNKNOWN] = NAMED_REFERENCE + ' must be known';
	MESSAGES[NUMERIC_DISALLOWED] = NUMERIC_REFERENCE + ' cannot be disallowed';
	MESSAGES[NUMERIC_PROHIBITED] = NUMERIC_REFERENCE + ' cannot be outside the ' +
	    'permissible Unicode range';
	
	/* Wrap to ensure clean parameters are given to `parse`. */
	function wrapper(value, options) {
	  var settings = {};
	  var option;
	  var key;
	
	  if (!options) {
	    options = {};
	  }
	
	  for (key in defaults) {
	    option = options[key];
	    settings[key] = option === null || option === undefined ? defaults[key] : option;
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || [];
	    settings.position = settings.position.start;
	  }
	
	  return parse(value, settings);
	}
	
	/* Parse entities. */
	function parse(value, settings) {
	  var additional = settings.additional;
	  var nonTerminated = settings.nonTerminated;
	  var handleText = settings.text;
	  var handleReference = settings.reference;
	  var handleWarning = settings.warning;
	  var textContext = settings.textContext;
	  var referenceContext = settings.referenceContext;
	  var warningContext = settings.warningContext;
	  var pos = settings.position;
	  var indent = settings.indent || [];
	  var length = value.length;
	  var index = 0;
	  var lines = -1;
	  var column = pos.column || 1;
	  var line = pos.line || 1;
	  var queue = EMPTY;
	  var result = [];
	  var entityCharacters;
	  var terminated;
	  var characters;
	  var character;
	  var reference;
	  var following;
	  var warning;
	  var reason;
	  var output;
	  var entity;
	  var begin;
	  var start;
	  var type;
	  var test;
	  var prev;
	  var next;
	  var diff;
	  var end;
	
	  /* Cache the current point. */
	  prev = now();
	
	  /* Wrap `handleWarning`. */
	  warning = handleWarning ? parseError : noop;
	
	  /* Ensure the algorithm walks over the first character
	   * and the end (inclusive). */
	  index--;
	  length++;
	
	  while (++index < length) {
	    /* If the previous character was a newline. */
	    if (character === NEWLINE) {
	      column = indent[lines] || 1;
	    }
	
	    character = at(index);
	
	    /* Handle anything other than an ampersand,
	     * including newlines and EOF. */
	    if (character !== AMPERSAND) {
	      if (character === NEWLINE) {
	        line++;
	        lines++;
	        column = 0;
	      }
	
	      if (character) {
	        queue += character;
	        column++;
	      } else {
	        flush();
	      }
	    } else {
	      following = at(index + 1);
	
	      /* The behaviour depends on the identity of the next
	       * character. */
	      if (
	        following === TAB ||
	        following === NEWLINE ||
	        following === FORM_FEED ||
	        following === SPACE ||
	        following === LESS_THAN ||
	        following === AMPERSAND ||
	        following === EMPTY ||
	        (additional && following === additional)
	      ) {
	        /* Not a character reference. No characters
	         * are consumed, and nothing is returned.
	         * This is not an error, either. */
	        queue += character;
	        column++;
	
	        continue;
	      }
	
	      start = index + 1;
	      begin = start;
	      end = start;
	
	      /* Numerical entity. */
	      if (following !== OCTOTHORP) {
	        type = NAMED;
	      } else {
	        end = ++begin;
	
	        /* The behaviour further depends on the
	         * character after the U+0023 NUMBER SIGN. */
	        following = at(end);
	
	        if (following === X_LOWER || following === X_UPPER) {
	          /* ASCII hex digits. */
	          type = HEXADECIMAL;
	          end = ++begin;
	        } else {
	          /* ASCII digits. */
	          type = DECIMAL;
	        }
	      }
	
	      entityCharacters = EMPTY;
	      entity = EMPTY;
	      characters = EMPTY;
	      test = TESTS[type];
	      end--;
	
	      while (++end < length) {
	        following = at(end);
	
	        if (!test(following)) {
	          break;
	        }
	
	        characters += following;
	
	        /* Check if we can match a legacy named
	         * reference.  If so, we cache that as the
	         * last viable named reference.  This
	         * ensures we do not need to walk backwards
	         * later. */
	        if (type === NAMED && own.call(legacy, characters)) {
	          entityCharacters = characters;
	          entity = legacy[characters];
	        }
	      }
	
	      terminated = at(end) === SEMICOLON;
	
	      if (terminated) {
	        end++;
	
	        if (type === NAMED && own.call(characterEntities, characters)) {
	          entityCharacters = characters;
	          entity = characterEntities[characters];
	        }
	      }
	
	      diff = 1 + end - start;
	
	      if (!terminated && !nonTerminated) {
	        /* Empty. */
	      } else if (!characters) {
	        /* An empty (possible) entity is valid, unless
	         * its numeric (thus an ampersand followed by
	         * an octothorp). */
	        if (type !== NAMED) {
	          warning(NUMERIC_EMPTY, diff);
	        }
	      } else if (type === NAMED) {
	        /* An ampersand followed by anything
	         * unknown, and not terminated, is invalid. */
	        if (terminated && !entity) {
	          warning(NAMED_UNKNOWN, 1);
	        } else {
	          /* If theres something after an entity
	           * name which is not known, cap the
	           * reference. */
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length;
	            diff = 1 + end - begin;
	            terminated = false;
	          }
	
	          /* If the reference is not terminated,
	           * warn. */
	          if (!terminated) {
	            reason = entityCharacters ?
	              NAMED_NOT_TERMINATED :
	              NAMED_EMPTY;
	
	            if (!settings.attribute) {
	              warning(reason, diff);
	            } else {
	              following = at(end);
	
	              if (following === EQUAL) {
	                warning(reason, diff);
	                entity = null;
	              } else if (alphanumerical(following)) {
	                entity = null;
	              } else {
	                warning(reason, diff);
	              }
	            }
	          }
	        }
	
	        reference = entity;
	      } else {
	        if (!terminated) {
	          /* All non-terminated numeric entities are
	           * not rendered, and trigger a warning. */
	          warning(NUMERIC_NOT_TERMINATED, diff);
	        }
	
	        /* When terminated and number, parse as
	         * either hexadecimal or decimal. */
	        reference = parseInt(characters, BASE[type]);
	
	        /* Trigger a warning when the parsed number
	         * is prohibited, and replace with
	         * replacement character. */
	        if (isProhibited(reference)) {
	          warning(NUMERIC_PROHIBITED, diff);
	
	          reference = REPLACEMENT;
	        } else if (reference in invalid) {
	          /* Trigger a warning when the parsed number
	           * is disallowed, and replace by an
	           * alternative. */
	          warning(NUMERIC_DISALLOWED, diff);
	
	          reference = invalid[reference];
	        } else {
	          /* Parse the number. */
	          output = EMPTY;
	
	          /* Trigger a warning when the parsed
	           * number should not be used. */
	          if (isWarning(reference)) {
	            warning(NUMERIC_DISALLOWED, diff);
	          }
	
	          /* Stringify the number. */
	          if (reference > 0xFFFF) {
	            reference -= 0x10000;
	            output += fromCharCode((reference >>> (10 & 0x3FF)) | 0xD800);
	            reference = 0xDC00 | (reference & 0x3FF);
	          }
	
	          reference = output + fromCharCode(reference);
	        }
	      }
	
	      /* If we could not find a reference, queue the
	       * checked characters (as normal characters),
	       * and move the pointer to their end. This is
	       * possible because we can be certain neither
	       * newlines nor ampersands are included. */
	      if (!reference) {
	        characters = value.slice(start - 1, end);
	        queue += characters;
	        column += characters.length;
	        index = end - 1;
	      } else {
	        /* Found it! First eat the queued
	         * characters as normal text, then eat
	         * an entity. */
	        flush();
	
	        prev = now();
	        index = end - 1;
	        column += end - start + 1;
	        result.push(reference);
	        next = now();
	        next.offset++;
	
	        if (handleReference) {
	          handleReference.call(referenceContext, reference, {
	            start: prev,
	            end: next
	          }, value.slice(start - 1, end));
	        }
	
	        prev = next;
	      }
	    }
	  }
	
	  /* Return the reduced nodes, and any possible warnings. */
	  return result.join(EMPTY);
	
	  /* Get current position. */
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    };
	  }
	
	  /* “Throw” a parse-error: a warning. */
	  function parseError(code, offset) {
	    var position = now();
	
	    position.column += offset;
	    position.offset += offset;
	
	    handleWarning.call(warningContext, MESSAGES[code], position, code);
	  }
	
	  /* Get character at position. */
	  function at(position) {
	    return value.charAt(position);
	  }
	
	  /* Flush `queue` (normal text). Macro invoked before
	   * each entity and at the end of `value`.
	   * Does nothing when `queue` is empty. */
	  function flush() {
	    if (queue) {
	      result.push(queue);
	
	      if (handleText) {
	        handleText.call(textContext, queue, {
	          start: prev,
	          end: now()
	        });
	      }
	
	      queue = EMPTY;
	    }
	  }
	}
	
	/* Check if `character` is outside the permissible
	 * unicode range. */
	function isProhibited(code) {
	  return (code >= 0xD800 && code <= 0xDFFF) || (code > 0x10FFFF);
	}
	
	/* Check if `character` is disallowed. */
	function isWarning(code) {
	  if (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000B ||
	    (code >= 0x000D && code <= 0x001F) ||
	    (code >= 0x007F && code <= 0x009F) ||
	    (code >= 0xFDD0 && code <= 0xFDEF) ||
	    (code & 0xFFFF) === 0xFFFF ||
	    (code & 0xFFFF) === 0xFFFE
	  ) {
	    return true;
	  }
	
	  return false;
	}


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	function clamp(val, min, max) {
	  return Math.min(Math.max(val, min), max);
	}
	
	module.exports = clamp;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(184);
	
	module.exports = {
	  shouldComponentUpdate: function(nextProps, nextState) {
	    return (
	      !shallowEqual(this.props, nextProps) ||
	      !shallowEqual(this.state, nextState)
	    );
	  }
	};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = undefined;
	
	var _keys = __webpack_require__(142);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONArrow = __webpack_require__(756);
	
	var _JSONArrow2 = _interopRequireDefault(_JSONArrow);
	
	var _getCollectionEntries = __webpack_require__(2779);
	
	var _getCollectionEntries2 = _interopRequireDefault(_getCollectionEntries);
	
	var _JSONNode = __webpack_require__(757);
	
	var _JSONNode2 = _interopRequireDefault(_JSONNode);
	
	var _ItemRange = __webpack_require__(2773);
	
	var _ItemRange2 = _interopRequireDefault(_ItemRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Renders nested values (eg. objects, arrays, lists, etc.)
	 */
	
	function renderChildNodes(props, from, to) {
	  var nodeType = props.nodeType,
	      data = props.data,
	      collectionLimit = props.collectionLimit,
	      circularCache = props.circularCache,
	      keyPath = props.keyPath,
	      postprocessValue = props.postprocessValue,
	      sortObjectKeys = props.sortObjectKeys;
	
	  var childNodes = [];
	
	  (0, _getCollectionEntries2['default'])(nodeType, data, sortObjectKeys, collectionLimit, from, to).forEach(function (entry) {
	    if (entry.to) {
	      childNodes.push(_react2['default'].createElement(_ItemRange2['default'], (0, _extends3['default'])({}, props, {
	        key: 'ItemRange--' + entry.from + '-' + entry.to,
	        from: entry.from,
	        to: entry.to,
	        renderChildNodes: renderChildNodes
	      })));
	    } else {
	      var key = entry.key,
	          value = entry.value;
	
	      var isCircular = circularCache.indexOf(value) !== -1;
	
	      var node = _react2['default'].createElement(_JSONNode2['default'], (0, _extends3['default'])({}, props, { postprocessValue: postprocessValue, collectionLimit: collectionLimit }, {
	        key: 'Node--' + key,
	        keyPath: [key].concat(keyPath),
	        value: postprocessValue(value),
	        circularCache: [].concat(circularCache, [value]),
	        isCircular: isCircular,
	        hideRoot: false
	      }));
	
	      if (node !== false) {
	        childNodes.push(node);
	      }
	    }
	  });
	
	  return childNodes;
	}
	
	function getStateFromProps(props) {
	  // calculate individual node expansion if necessary
	  var expanded = props.shouldExpandNode && !props.isCircular ? props.shouldExpandNode(props.keyPath, props.data, props.level) : false;
	  return {
	    expanded: expanded
	  };
	}
	
	var JSONNestedNode = (_temp = _class = function (_React$Component) {
	  (0, _inherits3['default'])(JSONNestedNode, _React$Component);
	
	  function JSONNestedNode(props) {
	    (0, _classCallCheck3['default'])(this, JSONNestedNode);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleClick = function () {
	      return _this.setState({ expanded: !_this.state.expanded });
	    };
	
	    _this.state = getStateFromProps(props);
	    return _this;
	  }
	
	  JSONNestedNode.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextState = getStateFromProps(nextProps);
	    if (getStateFromProps(this.props).expanded !== nextState.expanded) {
	      this.setState(nextState);
	    }
	  };
	
	  JSONNestedNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    var _this2 = this;
	
	    return !!(0, _keys2['default'])(nextProps).find(function (key) {
	      return key !== 'circularCache' && (key === 'keyPath' ? nextProps[key].join('/') !== _this2.props[key].join('/') : nextProps[key] !== _this2.props[key]);
	    }) || nextState.expanded !== this.state.expanded;
	  };
	
	  JSONNestedNode.prototype.render = function render() {
	    var _props = this.props,
	        getItemString = _props.getItemString,
	        nodeTypeIndicator = _props.nodeTypeIndicator,
	        nodeType = _props.nodeType,
	        data = _props.data,
	        hideRoot = _props.hideRoot,
	        createItemString = _props.createItemString,
	        styling = _props.styling,
	        collectionLimit = _props.collectionLimit,
	        keyPath = _props.keyPath,
	        labelRenderer = _props.labelRenderer,
	        expandable = _props.expandable;
	    var expanded = this.state.expanded;
	
	    var renderedChildren = expanded || hideRoot && this.props.level === 0 ? renderChildNodes((0, _extends3['default'])({}, this.props, { level: this.props.level + 1 })) : null;
	
	    var itemType = _react2['default'].createElement(
	      'span',
	      styling('nestedNodeItemType', expanded),
	      nodeTypeIndicator
	    );
	    var renderedItemString = getItemString(nodeType, data, itemType, createItemString(data, collectionLimit));
	    var stylingArgs = [keyPath, nodeType, expanded, expandable];
	
	    return hideRoot ? _react2['default'].createElement(
	      'li',
	      styling.apply(undefined, ['rootNode'].concat(stylingArgs)),
	      _react2['default'].createElement(
	        'ul',
	        styling.apply(undefined, ['rootNodeChildren'].concat(stylingArgs)),
	        renderedChildren
	      )
	    ) : _react2['default'].createElement(
	      'li',
	      styling.apply(undefined, ['nestedNode'].concat(stylingArgs)),
	      expandable && _react2['default'].createElement(_JSONArrow2['default'], {
	        styling: styling,
	        nodeType: nodeType,
	        expanded: expanded,
	        onClick: this.handleClick
	      }),
	      _react2['default'].createElement(
	        'label',
	        (0, _extends3['default'])({}, styling.apply(undefined, [['label', 'nestedNodeLabel']].concat(stylingArgs)), {
	          onClick: expandable && this.handleClick
	        }),
	        labelRenderer.apply(undefined, stylingArgs)
	      ),
	      _react2['default'].createElement(
	        'span',
	        (0, _extends3['default'])({}, styling.apply(undefined, ['nestedNodeItemString'].concat(stylingArgs)), {
	          onClick: expandable && this.handleClick
	        }),
	        renderedItemString
	      ),
	      _react2['default'].createElement(
	        'ul',
	        styling.apply(undefined, ['nestedNodeChildren'].concat(stylingArgs)),
	        renderedChildren
	      )
	    );
	  };
	
	  return JSONNestedNode;
	}(_react2['default'].Component), _class.propTypes = {
	  getItemString: _propTypes2['default'].func.isRequired,
	  nodeTypeIndicator: _propTypes2['default'].any,
	  nodeType: _propTypes2['default'].string.isRequired,
	  data: _propTypes2['default'].any,
	  hideRoot: _propTypes2['default'].bool.isRequired,
	  createItemString: _propTypes2['default'].func.isRequired,
	  styling: _propTypes2['default'].func.isRequired,
	  collectionLimit: _propTypes2['default'].number,
	  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
	  labelRenderer: _propTypes2['default'].func.isRequired,
	  shouldExpandNode: _propTypes2['default'].func,
	  level: _propTypes2['default'].number.isRequired,
	  sortObjectKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].bool]),
	  isCircular: _propTypes2['default'].bool,
	  expandable: _propTypes2['default'].bool
	}, _class.defaultProps = {
	  data: [],
	  circularCache: [],
	  level: 0,
	  expandable: true
	}, _temp);
	exports['default'] = JSONNestedNode;

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(282);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(163);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(2846);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(2843);
	
	var _isActive2 = __webpack_require__(2850);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(2847);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(2852);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Scrollspy = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollspy = exports.Scrollspy = function (_React$Component) {
	  _inherits(Scrollspy, _React$Component);
	
	  _createClass(Scrollspy, null, [{
	    key: 'PropTypes',
	    get: function get() {
	      return {
	        items: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string).isRequired,
	        currentClassName: _react2.default.PropTypes.string.isRequired,
	        scrolledPastClassName: _react2.default.PropTypes.string,
	        style: _react2.default.PropTypes.object,
	        componentTag: _react2.default.PropTypes.string,
	        offset: _react2.default.PropTypes.number
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        items: [],
	        currentClassName: '',
	        style: {},
	        componentTag: 'ul',
	        offset: 0
	      };
	    }
	  }]);
	
	  function Scrollspy(props) {
	    _classCallCheck(this, Scrollspy);
	
	    var _this = _possibleConstructorReturn(this, (Scrollspy.__proto__ || Object.getPrototypeOf(Scrollspy)).call(this, props));
	
	    _this.state = {
	      targetItems: [],
	      inViewState: [],
	      isScrolledPast: []
	    };
	
	    // manually bind as ES6 does not apply this
	    // auto binding as React.createClass does
	    _this._handleSpy = _this._handleSpy.bind(_this);
	    return _this;
	  }
	
	  _createClass(Scrollspy, [{
	    key: '_initSpyTarget',
	    value: function _initSpyTarget(items) {
	      var targetItems = items.map(function (item) {
	
	        return document.getElementById(item);
	      });
	
	      return targetItems;
	    }
	  }, {
	    key: '_getElemsViewState',
	    value: function _getElemsViewState(targets) {
	      var elemsInView = [];
	      var elemsOutView = [];
	      var viewStatusList = [];
	
	      var targetItems = targets ? targets : this.state.targetItems;
	
	      var hasInViewAlready = false;
	
	      for (var i = 0, max = targetItems.length; i < max; i++) {
	        var currentContent = targetItems[i];
	        var isInView = hasInViewAlready ? false : this._isInView(currentContent);
	
	        if (isInView) {
	          hasInViewAlready = true;
	          elemsInView.push(currentContent);
	        } else {
	          elemsOutView.push(currentContent);
	        }
	
	        var isLastItem = i === max - 1;
	        var isScrolled = (document.documentElement.scrollTop || document.body.scrollTop) > 0;
	
	        // https://github.com/makotot/react-scrollspy/pull/26#issue-167413769
	        if (this._isAtBottom() && this._isInView(currentContent) && !isInView && isLastItem && isScrolled) {
	          elemsOutView.pop();
	          elemsOutView.push.apply(elemsOutView, _toConsumableArray(elemsInView));
	          elemsInView = [currentContent];
	          viewStatusList.fill(false);
	          isInView = true;
	        }
	
	        viewStatusList.push(isInView);
	      }
	
	      return {
	        inView: elemsInView,
	        outView: elemsOutView,
	        viewStatusList: viewStatusList,
	        scrolledPast: this.props.scrolledPastClassName && this._getScrolledPast(viewStatusList)
	      };
	    }
	  }, {
	    key: '_isInView',
	    value: function _isInView(el) {
	      if (!el) {
	        return false;
	      }
	      var rect = el.getBoundingClientRect();
	      var winH = window.innerHeight;
	      var doc = document;
	      var scrollTop = doc.documentElement.scrollTop || doc.body.scrollTop;
	      var scrollBottom = scrollTop + winH;
	      var elTop = rect.top + scrollTop + this.props.offset;
	      var elBottom = elTop + el.offsetHeight;
	
	      return elTop < scrollBottom && elBottom > scrollTop;
	    }
	  }, {
	    key: '_isAtBottom',
	    value: function _isAtBottom() {
	      var doc = document;
	      var body = doc.body;
	      var scrollTop = doc.documentElement && doc.documentElement.scrollTop || body.scrollTop;
	      var scrollHeight = doc.documentElement && doc.documentElement.scrollHeight || body.scrollHeight;
	      var scrolledToBottom = scrollTop + window.innerHeight >= scrollHeight;
	
	      return scrolledToBottom;
	    }
	  }, {
	    key: '_getScrolledPast',
	    value: function _getScrolledPast(viewStatusList) {
	      if (!viewStatusList.some(function (item) {
	        return item;
	      })) {
	        return viewStatusList;
	      }
	
	      var hasFoundInView = false;
	
	      var scrolledPastItems = viewStatusList.map(function (item) {
	        if (item && !hasFoundInView) {
	          hasFoundInView = true;
	          return false;
	        }
	        return !hasFoundInView;
	      });
	
	      return scrolledPastItems;
	    }
	  }, {
	    key: '_spy',
	    value: function _spy(targets) {
	      var elemensViewState = this._getElemsViewState(targets);
	      this.setState({
	        inViewState: elemensViewState.viewStatusList,
	        isScrolledPast: elemensViewState.scrolledPast
	      });
	    }
	  }, {
	    key: '_handleSpy',
	    value: function _handleSpy() {
	      var timer = void 0;
	
	      if (timer) {
	        clearTimeout(timer);
	        timer = null;
	      }
	      timer = setTimeout(this._spy.bind(this), 100);
	    }
	  }, {
	    key: '_initFromProps',
	    value: function _initFromProps() {
	      var targetItems = this._initSpyTarget(this.props.items);
	
	      this.setState({
	        targetItems: targetItems
	      });
	
	      this._spy(targetItems);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._initFromProps();
	      window.addEventListener('scroll', this._handleSpy);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this._handleSpy);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._initFromProps();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var Tag = this.props.componentTag;
	      var counter = 0;
	      var items = _react2.default.Children.map(this.props.children, function (child, idx) {
	        var _classNames;
	
	        if (!child) {
	          return null;
	        }
	
	        var ChildTag = child.type;
	        var isScrolledPast = _this2.props.scrolledPastClassName && _this2.state.isScrolledPast[idx];
	        var childClass = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, '' + child.props.className, child.props.className), _defineProperty(_classNames, '' + _this2.props.currentClassName, _this2.state.inViewState[idx]), _defineProperty(_classNames, '' + _this2.props.scrolledPastClassName, isScrolledPast), _classNames));
	
	        return _react2.default.createElement(
	          ChildTag,
	          _extends({}, child.props, { className: childClass, key: counter++ }),
	          child.props.children
	        );
	      });
	
	      var itemClass = (0, _classnames2.default)(_defineProperty({}, '' + this.props.className, this.props.className));
	
	      return _react2.default.createElement(
	        Tag,
	        { className: itemClass, style: this.props.style },
	        items
	      );
	    }
	  }]);
	
	  return Scrollspy;
	}(_react2.default.Component);


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decoraters */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__(2887);
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__(2889);
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__(2884);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__(2886);
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__(2885);
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _trackRemoval = __webpack_require__(2888);
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__(2892);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__(2893);
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__(2891);
	
	var _nodeListToArray = __webpack_require__(2894);
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__(2890);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReactTooltip, _Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: 'top', // Direction of tooltip
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      placeholder: '',
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var ariaProps = this.state.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(props);
	
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (isChanged) {
	        this.setState({ ariaProps: newAriaProps });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        var isCaptureMode = _this3.isCapture(target);
	        var effect = _this3.getEffect(target);
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customBindListener(target);
	          return;
	        }
	
	        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	        if (effect === 'float') {
	          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	        }
	        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	      });
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, false);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        _this4.unbindBasicListener(target);
	        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	      });
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and ummount the compont
	     * it is necessary to invloke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      var _this5 = this;
	
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || this.state.show) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props4 = this.props,
	          children = _props4.children,
	          multiline = _props4.multiline,
	          getContent = _props4.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // Generate tootlip content
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0]();
	        } else {
	          content = getContent();
	        }
	      }
	      var placeholder = (0, _getTipContent2.default)(originTooltip, children, content, isMultiline);
	      var isEmptyTip = typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it need to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      this.setState({
	        placeholder: placeholder,
	        isEmptyTip: isEmptyTip,
	        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
	        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
	        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
	        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
	        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
	        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
	        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
	        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
	        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
	        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false
	      }, function () {
	        if (scrollHide) _this5.addScrollListener(e);
	        _this5.updateTooltip(e);
	
	        if (getContent && Array.isArray(getContent)) {
	          _this5.intervalUpdateContent = setInterval(function () {
	            if (_this5.mount) {
	              var _getContent = _this5.props.getContent;
	
	              var _placeholder = (0, _getTipContent2.default)(originTooltip, _getContent[0](), isMultiline);
	              var _isEmptyTip = typeof _placeholder === 'string' && _placeholder === '';
	              _this5.setState({
	                placeholder: _placeholder,
	                isEmptyTip: _isEmptyTip
	              });
	            }
	          }, getContent[1]);
	        }
	      });
	    }
	
	    /**
	     * When mouse hover, updatetooltip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this6 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          show = _state.show,
	          isEmptyTip = _state.isEmptyTip,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	      var placeholder = this.state.placeholder;
	
	      var delayTime = show ? 0 : parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget;
	
	      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          (function () {
	            var isInvisible = !_this6.state.show;
	            _this6.setState({
	              currentEvent: e,
	              currentTarget: eventTarget,
	              show: true
	            }, function () {
	              _this6.updatePosition();
	              if (isInvisible && afterShow) afterShow();
	            });
	          })();
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this7 = this;
	
	      var _state2 = this.state,
	          delayHide = _state2.delayHide,
	          isEmptyTip = _state2.isEmptyTip,
	          disable = _state2.disable;
	      var afterHide = this.props.afterHide;
	
	      if (!this.mount) return;
	      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	      var resetState = function resetState() {
	        var isVisible = _this7.state.show;
	        _this7.setState({
	          show: false
	        }, function () {
	          _this7.removeScrollListener();
	          if (isVisible && afterHide) afterHide();
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * Add scroll eventlistener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(e) {
	      var isCaptureMode = this.isCapture(e.currentTarget);
	      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltip);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this8 = this;
	
	      var _state3 = this.state,
	          currentEvent = _state3.currentEvent,
	          currentTarget = _state3.currentTarget,
	          place = _state3.place,
	          effect = _state3.effect,
	          offset = _state3.offset;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, effect, offset);
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this8.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      if (!document.getElementsByTagName('head')[0].querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        document.getElementsByTagName('head')[0].appendChild(tag);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state4 = this.state,
	          placeholder = _state4.placeholder,
	          extraClass = _state4.extraClass,
	          html = _state4.html,
	          ariaProps = _state4.ariaProps,
	          disable = _state4.disable,
	          isEmptyTip = _state4.isEmptyTip;
	
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: tooltipClass + ' ' + extraClass
	          }, ariaProps, {
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div'
	}, _class2.supportedWrappers = ['div', 'span'], _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(192);
	var Danger = __webpack_require__(2903);
	var ReactMultiChildUpdateTypes = __webpack_require__(801);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(82);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(425);
	var setInnerHTML = __webpack_require__(291);
	var setTextContent = __webpack_require__(814);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactPropTypes = __webpack_require__(803);
	var ReactPropTypeLocations = __webpack_require__(421);
	var ReactPropTypesSecret = __webpack_require__(422);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactNoopUpdateQueue = __webpack_require__(419);
	
	var canDefineProperty = __webpack_require__(806);
	var emptyObject = __webpack_require__(157);
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(22);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentTreeDevtool
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactCurrentOwner = __webpack_require__(137);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	var tree = {};
	var unmountedIDs = {};
	var rootIDs = {};
	
	function updateTree(id, update) {
	  if (!tree[id]) {
	    tree[id] = {
	      element: null,
	      parentID: null,
	      ownerID: null,
	      text: null,
	      childIDs: [],
	      displayName: 'Unknown',
	      isMounted: false,
	      updateCount: 0
	    };
	  }
	  update(tree[id]);
	}
	
	function purgeDeep(id) {
	  var item = tree[id];
	  if (item) {
	    var childIDs = item.childIDs;
	
	    delete tree[id];
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeDevtool.getDisplayName(id);
	  var element = ReactComponentTreeDevtool.getElement(id);
	  var ownerID = ReactComponentTreeDevtool.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeDevtool.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeDevtool: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeDevtool = {
	  onSetDisplayName: function (id, displayName) {
	    updateTree(id, function (item) {
	      return item.displayName = displayName;
	    });
	  },
	  onSetChildren: function (id, nextChildIDs) {
	    updateTree(id, function (item) {
	      item.childIDs = nextChildIDs;
	
	      nextChildIDs.forEach(function (nextChildID) {
	        var nextChild = tree[nextChildID];
	        !nextChild ?  false ? invariant(false, 'Expected devtool events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('68') : void 0;
	        !(nextChild.displayName != null) ?  false ? invariant(false, 'Expected onSetDisplayName() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('69') : void 0;
	        !(nextChild.childIDs != null || nextChild.text != null) ?  false ? invariant(false, 'Expected onSetChildren() or onSetText() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('70') : void 0;
	        !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	        if (nextChild.parentID == null) {
	          nextChild.parentID = id;
	          // TODO: This shouldn't be necessary but mounting a new root during in
	          // componentWillMount currently causes not-yet-mounted components to
	          // be purged from our tree data so their parent ID is missing.
	        }
	        !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onSetParent() and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('72', nextChildID, nextChild.parentID, id) : void 0;
	      });
	    });
	  },
	  onSetOwner: function (id, ownerID) {
	    updateTree(id, function (item) {
	      return item.ownerID = ownerID;
	    });
	  },
	  onSetParent: function (id, parentID) {
	    updateTree(id, function (item) {
	      return item.parentID = parentID;
	    });
	  },
	  onSetText: function (id, text) {
	    updateTree(id, function (item) {
	      return item.text = text;
	    });
	  },
	  onBeforeMountComponent: function (id, element) {
	    updateTree(id, function (item) {
	      return item.element = element;
	    });
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    updateTree(id, function (item) {
	      return item.element = element;
	    });
	  },
	  onMountComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.isMounted = true;
	    });
	  },
	  onMountRootComponent: function (id) {
	    rootIDs[id] = true;
	  },
	  onUpdateComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.updateCount++;
	    });
	  },
	  onUnmountComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.isMounted = false;
	    });
	    unmountedIDs[id] = true;
	    delete rootIDs[id];
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeDevtool._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var id in unmountedIDs) {
	      purgeDeep(id);
	    }
	    unmountedIDs = {};
	  },
	  isMounted: function (id) {
	    var item = tree[id];
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var type = topElement.type;
	      var name = typeof type === 'function' ? type.displayName || type.name : type;
	      var owner = topElement._owner;
	      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeDevtool.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeDevtool.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = tree[id];
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var item = tree[id];
	    return item ? item.displayName : 'Unknown';
	  },
	  getElement: function (id) {
	    var item = tree[id];
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var item = tree[id];
	    return item ? item.ownerID : null;
	  },
	  getParentID: function (id) {
	    var item = tree[id];
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = tree[id];
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var item = tree[id];
	    return item ? item.text : null;
	  },
	  getUpdateCount: function (id) {
	    var item = tree[id];
	    return item ? item.updateCount : 0;
	  },
	  getRootIDs: function () {
	    return Object.keys(rootIDs);
	  },
	  getRegisteredIDs: function () {
	    return Object.keys(tree);
	  }
	};
	
	module.exports = ReactComponentTreeDevtool;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(25);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(261);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactCurrentOwner = __webpack_require__(137);
	var ReactInstanceMap = __webpack_require__(225);
	var ReactInstrumentation = __webpack_require__(82);
	var ReactUpdates = __webpack_require__(109);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactCurrentOwner = __webpack_require__(137);
	var ReactElement = __webpack_require__(108);
	
	var getIteratorFn = __webpack_require__(809);
	var invariant = __webpack_require__(22);
	var KeyEscapeUtils = __webpack_require__(413);
	var warning = __webpack_require__(25);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var emptyFunction = __webpack_require__(65);
	var warning = __webpack_require__(25);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reduxDevtoolsInstrument = __webpack_require__(817);
	
	Object.defineProperty(exports, 'instrument', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reduxDevtoolsInstrument).default;
	  }
	});
	Object.defineProperty(exports, 'ActionCreators', {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.ActionCreators;
	  }
	});
	Object.defineProperty(exports, 'ActionTypes', {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.ActionTypes;
	  }
	});
	
	var _persistState = __webpack_require__(2980);
	
	Object.defineProperty(exports, 'persistState', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_persistState).default;
	  }
	});
	
	var _createDevTools = __webpack_require__(2979);
	
	Object.defineProperty(exports, 'createDevTools', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createDevTools).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(820);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2985);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2984);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2983);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(819);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(821);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = interrupt;
	
	function interrupt(interruptors, tokenizers, ctx, params) {
	  var bools = ['pedantic', 'commonmark'];
	  var count = bools.length;
	  var length = interruptors.length;
	  var index = -1;
	  var interruptor;
	  var config;
	  var fn;
	  var offset;
	  var bool;
	  var ignore;
	
	  while (++index < length) {
	    interruptor = interruptors[index];
	    config = interruptor[1] || {};
	    fn = interruptor[0];
	    offset = -1;
	    ignore = false;
	
	    while (++offset < count) {
	      bool = bools[offset];
	
	      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
	        ignore = true;
	        break;
	      }
	    }
	
	    if (ignore) {
	      continue;
	    }
	
	    if (tokenizers[fn].apply(ctx, params)) {
	      return true;
	    }
	  }
	
	  return false;
	}


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var collapseWhiteSpace = __webpack_require__(1261);
	
	module.exports = normalize;
	
	/* Normalize an identifier.  Collapses multiple white space
	 * characters into a single space, and removes casing. */
	function normalize(value) {
	  return collapseWhiteSpace(value).toLowerCase();
	}


/***/ }),
/* 437 */
/***/ (function(module, exports) {

	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(3034);
	var parser = __webpack_require__(439);
	var Manager = __webpack_require__(828);
	var debug = __webpack_require__(293)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(828);
	exports.Socket = __webpack_require__(830);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(3039)('socket.io-parser');
	var json = __webpack_require__(1589);
	var Emitter = __webpack_require__(3038);
	var binary = __webpack_require__(3037);
	var isBuf = __webpack_require__(831);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(173);
	var requestBase = __webpack_require__(3045);
	var isObject = __webpack_require__(832);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(3046).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only verison of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */),
	        key = parts.shift(),
	        val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this._setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this._parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype._setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype._setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (res.status < 200 || res.status >= 300) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	        new_err.original = err;
	        new_err.response = res;
	        new_err.status = res.status;
	      }
	    } catch(e) {
	      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype._timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	
	Request.prototype._appendQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self._timeoutError();
	      if (self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  }
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  this._appendQueryString();
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn){
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ }),
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = trimTrailingLines;
	
	var line = '\n';
	
	/* Remove final newline characters from `value`. */
	function trimTrailingLines(value) {
	  var val = String(value);
	  var index = val.length;
	
	  while (val.charAt(--index) === line) { /* empty */ }
	
	  return val.slice(0, index + 1);
	}


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFDQN;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(228);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFDQN(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_fqdn_options);
	
	  /* Remove the optional trailing dot before checking validity */
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	  var parts = str.split('.');
	  if (options.require_tld) {
	    var tld = parts.pop();
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    }
	  }
	  for (var part, i = 0; i < parts.length; i++) {
	    part = parts[i];
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    }
	    if (/[\uff01-\uff5e]/.test(part)) {
	      // disallow full-width chars
	      return false;
	    }
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toDate(date) {
	  (0, _assertString2.default)(date);
	  date = Date.parse(date);
	  return !isNaN(date) ? new Date(date) : null;
	}
	module.exports = exports['default'];

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = toString;
	function toString(input) {
	  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input !== null) {
	    if (typeof input.toString === 'function') {
	      input = input.toString();
	    } else {
	      input = '[object Object]';
	    }
	  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
	    input = '';
	  }
	  return String(input);
	}
	module.exports = exports['default'];

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccordionListItem = exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AccordionListItem = __webpack_require__(852);
	
	var _AccordionListItem2 = _interopRequireDefault(_AccordionListItem);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccordionList = (_temp = _class = function (_React$Component) {
	  _inherits(AccordionList, _React$Component);
	
	  function AccordionList(props, context) {
	    _classCallCheck(this, AccordionList);
	
	    var _this = _possibleConstructorReturn(this, (AccordionList.__proto__ || Object.getPrototypeOf(AccordionList)).call(this, props, context));
	
	    _this.state = {
	      openIndex: null
	    };
	    return _this;
	  }
	
	  _createClass(AccordionList, [{
	    key: 'handleToggle',
	    value: function handleToggle(index) {
	      var openIndex = index !== null && index !== this.state.openIndex && index >= 0 && index < _react2.default.Children.count(this.props.children) ? index : null;
	      this.setState({ openIndex: openIndex });
	      if (this.props.onToggle) {
	        this.props.onToggle();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var index = 0;
	      var handler = this.handleToggle.bind(this);
	      var children = _react2.default.Children.map(this.props.children, function (child) {
	        var current = index++;
	        return _react2.default.cloneElement(child, _extends({}, _this2.state, { index: current, onToggle: handler.bind(_this2, current) }));
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'accordion-container' },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('scroll-hide', { collapsed: (0, _lodash.isNil)(this.state.openIndex) }) },
	          children
	        )
	      );
	    }
	  }]);
	
	  return AccordionList;
	}(_react2.default.Component), _class.propTypes = {
	  children: _react2.default.PropTypes.arrayOf(_react.PropTypes.element),
	  onToggle: _react.PropTypes.func
	}, _temp);
	exports.default = AccordionList;
	exports.AccordionListItem = _AccordionListItem2.default;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// import classnames utility
	
	
	// js utility functions
	
	
	// import modified component from material UI
	
	
	// import material UI element with slightly modified source code
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _c_SourceModMenuItem = __webpack_require__(166);
	
	var _c_SourceModMenuItem2 = _interopRequireDefault(_c_SourceModMenuItem);
	
	var _c_SourceModDropDown = __webpack_require__(202);
	
	var _c_SourceModDropDown2 = _interopRequireDefault(_c_SourceModDropDown);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropdownStyle = {
	  overflow: 'hidden'
	};
	
	var menuCustomization = {
	  autoWidth: false,
	  menuStyle: {
	    overflowX: 'hidden',
	    width: '100%',
	    backgroundColor: '#fafafa'
	  },
	  labelStyle: {
	    color: '#4a4a4a',
	    maxWidth: '100%',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    fontSize: '16px',
	    height: '48px'
	  },
	  listStyle: {
	    backgroundColor: '#fafafa',
	    fontWeight: 100,
	    width: '100%'
	  },
	  selectedMenuItemStyle: {
	    padding: 0,
	    color: '#4a4a4a',
	    backgroundColor: '#eee'
	  },
	  popoverStyle: {
	    transition: 'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1), width 1000ms cubic-bezier(0.23, 1, 0.32, 1)'
	  }
	};
	
	var menuItemCustomization = {
	  disableTouchRipple: true,
	  disableFocusRipple: true
	};
	
	var initState = {
	  checked: []
	};
	
	var CardFilter = (_temp2 = _class = function (_Component) {
	  _inherits(CardFilter, _Component);
	
	  function CardFilter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CardFilter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CardFilter.__proto__ || Object.getPrototypeOf(CardFilter)).call.apply(_ref, [this].concat(args))), _this), _this.state = initState, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CardFilter, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Reset filters when resultes changed.
	      if (!(0, _lodash.isEqual)(nextProps.terms, this.props.terms)) {
	        this.setState(initState);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event, index, value) {
	      if (!value) {
	        return;
	      }
	
	      var primaryText = this.props.menuItems[index - 1].name;
	
	      var newCheckedArr = ~this.state.checked.indexOf(value) ? this.state.checked.filter(function (val) {
	        return val !== value;
	      }) : this.state.checked.concat(value);
	
	      this.setState(_extends({}, this.state, { checked: newCheckedArr }));
	
	      if (this.props.onChange) {
	        this.props.onChange(event, newCheckedArr, primaryText, value);
	      }
	
	      if (this.props.onBlur) {
	        this.props.onBlur(event, newCheckedArr, primaryText, value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // take out properties that will be overwritten from 'this.props'
	      var _props = this.props,
	          className = _props.className,
	          onChange = _props.onChange,
	          onBlur = _props.onBlur,
	          style = _props.style,
	          dataId = _props['data-id'],
	          containerStyle = _props.containerStyle,
	          propsMenuItemCustomization = _props.menuItemCustomization,
	          propsSelectedMenuItemStyle = _props.selectedMenuItemStyle,
	          propsListStyle = _props.listStyle,
	          propsMenuStyle = _props.menuStyle,
	          propsLabelStyle = _props.labelStyle,
	          unmodifiedProps = _objectWithoutProperties(_props, ['className', 'onChange', 'onBlur', 'style', 'data-id', 'containerStyle', 'menuItemCustomization', 'selectedMenuItemStyle', 'listStyle', 'menuStyle', 'labelStyle']);
	
	      var additionalProps = {
	        onChange: this.onChange.bind(this),
	        style: (0, _lodash.merge)({}, style, dropdownStyle)
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('clearfix', 'card-filter-wrapper', className), style: containerStyle },
	        _react2.default.createElement(
	          _c_SourceModDropDown2.default,
	          _extends({ className: 'card-filter-dropdown',
	            'data-id': dataId,
	            checkList: true
	          }, menuCustomization, unmodifiedProps, additionalProps),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-filter-by-container status' },
	            _react2.default.createElement(
	              'div',
	              { className: 'label' },
	              'Filter By Status'
	            )
	          ),
	          this.props.menuItems.map(function (val, index) {
	            return _react2.default.createElement(_c_SourceModMenuItem2.default, _extends({ value: val.id,
	              checked: !!~_this2.state.checked.indexOf(val.id) || _this2.props.menuItems.length === 1,
	              checkMark: true,
	              className: 'card-filter-status-item',
	              primaryText: val.name,
	              key: index,
	              'data-id': val.name
	            }, menuItemCustomization, propsMenuItemCustomization));
	          })
	        )
	      );
	    }
	  }]);
	
	  return CardFilter;
	}(_react.Component), _class.propTypes = {
	  id: _react.PropTypes.any,
	  onErrorChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  menuItems: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  listStyle: _react.PropTypes.object,
	  menuStyle: _react.PropTypes.object,
	  containerStyle: _react.PropTypes.object,
	  labelStyle: _react.PropTypes.object,
	  menuItemCustomization: _react.PropTypes.object,
	  selectedMenuItemStyle: _react.PropTypes.object,
	  'data-id': _react.PropTypes.string,
	  children: _react.PropTypes.object,
	  terms: _react.PropTypes.array
	}, _class.defaultProps = {
	  menuItems: []
	}, _temp2);
	exports.default = CardFilter;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckListTextField = (_temp = _class = function (_Component) {
	  _inherits(CheckListTextField, _Component);
	
	  function CheckListTextField(props, context) {
	    _classCallCheck(this, CheckListTextField);
	
	    var _this = _possibleConstructorReturn(this, (CheckListTextField.__proto__ || Object.getPrototypeOf(CheckListTextField)).call(this, props, context));
	
	    _this.handleChange = function (event, value, primaryText) {
	      if (_this.props.onChange) {
	        return _this.props.onChange(event, value, primaryText);
	      }
	    };
	
	    _this.handleBlur = function (event, value, primaryText) {
	      if (_this.props.onBlur) {
	        return _this.props.onBlur(event, value, primaryText);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(CheckListTextField, [{
	    key: 'renderSelectedText',
	    value: function renderSelectedText() {
	      var value = (0, _lodash.get)(this.refs, 'CheckList.state.checked', this.props.defaultValue);
	      if (value && this.props.menuItems) {
	        return this.props.menuItems.reduce(function (text, item) {
	          return value.includes(item.value || item.id) ? (text.length ? text + ',' : text) + ' ' + (item.primaryText || item.name) : text;
	        }, '');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          checkListClassName = _props.checkListClassName,
	          textfieldClassName = _props.textfieldClassName,
	          menuItems = _props.menuItems,
	          floatingLabelText = _props.floatingLabelText,
	          errorText = _props.errorText,
	          defaultValue = _props.defaultValue,
	          defaultOtherValue = _props.defaultOtherValue,
	          otherValue = _props.otherValue,
	          value = _props.value,
	          textfieldContainerClassName = _props.textfieldContainerClassName,
	          checkListContainerClassName = _props.checkListContainerClassName,
	          dataId = _props.dataId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: checkListContainerClassName },
	          _react2.default.createElement(_c_CheckList2.default, {
	            className: checkListClassName,
	            ref: 'CheckList',
	            'data-id': dataId,
	            floatingLabelText: floatingLabelText,
	            showLabel: true,
	            defaultValue: defaultValue,
	            menuItems: menuItems,
	            onChange: this.handleChange,
	            onBlur: this.handleBlur,
	            errorText: errorText
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: textfieldContainerClassName },
	          _react2.default.createElement(_c_TextField2.default, {
	            floatingLabelText: ' ',
	            className: textfieldClassName,
	            'data-id': dataId + 'Display',
	            disabled: true,
	            inputStyle: { textOverflow: 'ellipsis' },
	            value: this.renderSelectedText() })
	        )
	      );
	    }
	  }]);
	
	  return CheckListTextField;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  checkListClassName: _react.PropTypes.string,
	  textfieldClassName: _react.PropTypes.string,
	  menuItems: _react.PropTypes.array,
	  floatingLabelText: _react.PropTypes.string,
	  errorText: _react.PropTypes.string,
	  defaultValue: _react.PropTypes.array,
	  defaultOtherValue: _react.PropTypes.string,
	  value: _react.PropTypes.array,
	  otherValue: _react.PropTypes.object,
	  dataId: _react.PropTypes.string,
	  textfieldContainerClassName: _react.PropTypes.string,
	  checkListContainerClassName: _react.PropTypes.string,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func
	}, _temp);
	exports.default = CheckListTextField;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = CustomTextField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerStyles = {
	  width: '100%',
	  verticalAlign: 'middle'
	};
	
	var textFieldStyles = {
	  underlineShow: false,
	  errorStyle: {
	    color: 'rgb(244, 67, 54) !important',
	    maxWidth: '100%',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    textAlign: 'left',
	    position: 'absolute',
	    transform: 'translateY(26px)'
	  },
	  floatingLabelStyle: {
	    maxWidth: '100%',
	    whiteSpace: 'nowrap'
	  }
	};
	
	function CustomTextField(props) {
	
	  var onBlur = function onBlur(event) {
	    if (props.onBlur) {
	      props.onBlur(event, event.target.value);
	    }
	  };
	
	  var onChange = function onChange(event, value) {
	    if (props.onChange) {
	      props.onChange(event, value || event.target.value);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('text-field-container', 'clearfix', props.errorText && 'error'),
	      style: _extends({}, containerStyles, props.style || {}) },
	    _react2.default.createElement(_TextField2.default, _extends({}, textFieldStyles, props, {
	      className: 'text-field',
	      onBlur: onBlur,
	      onChange: onChange
	    }))
	  );
	}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _SimpleDropDownMenu = __webpack_require__(121);
	
	var _SimpleDropDownMenu2 = _interopRequireDefault(_SimpleDropDownMenu);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _modelValidator = __webpack_require__(33);
	
	var _model = __webpack_require__(995);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    staticData: state.staticData,
	    currentUser: state.user,
	    sysAdminRole: state.staticData.employeeRoles.find(function (r) {
	      return r.hardcodelink === 'SYSTEM_ADMINISTRATOR';
	    }),
	    employeeRole: state.staticData.employeeRoles.find(function (r) {
	      return r.hardcodelink === 'EMPLOYEE';
	    })
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(UserForm, _Component);
	
	  function UserForm() {
	    _classCallCheck(this, UserForm);
	
	    var _this = _possibleConstructorReturn(this, (UserForm.__proto__ || Object.getPrototypeOf(UserForm)).call(this));
	
	    _this.handleUI = _this.handleUI.bind(_this);
	    _this.handleDropDownMenuUI = _this.handleDropDownMenuUI.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.validate = _this.validate.bind(_this);
	
	    _this.statusMenuItems = [{ value: 'enabled', primaryText: 'Active' }, { value: 'pending', primaryText: 'Inactive User' }];
	
	    _this.weightMenuItems = [{ primaryText: 'Select', value: null }, { primaryText: 1, value: 1 }, { primaryText: 2, value: 2 }, { primaryText: 3, value: 3 }, { primaryText: 4, value: 4 }, { primaryText: 5, value: 5 }, { primaryText: 6, value: 6 }, { primaryText: 7, value: 7 }, { primaryText: 8, value: 8 }, { primaryText: 9, value: 9 }, { primaryText: 10, value: 10 }];
	
	    _this.state = {
	      isDirty: false,
	      submitted: false,
	      userForm: {}
	    };
	
	    _this.theRealDefaultRoles = [];
	
	    return _this;
	  }
	
	  _createClass(UserForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // update the state with pre-filled fields if editing a user
	      if (this.props.employee) {
	        this.setState({ userForm: (0, _lodash.pick)(this.props.employee, ['id', 'firstName', 'lastName', 'title', 'email', 'direct_dial', 'cellphoneNumber', 'roles', 'state', 'activeState', 'categories', 'weight', 'defaultRole']) });
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(prop) {
	
	      if (!this.state.submitted) {
	        return;
	      }
	
	      if (prop === 'email' && this.state.emailDuplicate === true) {
	        return 'E-mail is duplicate.';
	      }
	
	      var validation = (0, _modelValidator.validateField)((0, _lodash.get)(this.state.userForm, prop), (0, _model2.default)()[prop]);
	      return validation[0];
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this2 = this;
	
	      return function (event, value) {
	        var userForm = _extends({}, _this2.state.userForm);
	        userForm[prop] = value;
	        _this2.setState({ userForm: userForm });
	      };
	    }
	  }, {
	    key: 'handleUI',
	    value: function handleUI(prop, label) {
	
	      return {
	        'data-id': prop,
	        defaultValue: this.props.employee && this.props.employee[prop],
	        floatingLabelText: label,
	        floatingLabelFixed: true,
	        onBlur: this.handleChange(prop),
	        isDirty: this.state.submitted,
	        errorText: this.validate(prop)
	      };
	    }
	  }, {
	    key: 'handleDropDownMenuUI',
	    value: function handleDropDownMenuUI(prop, menuItems, label) {
	      return _extends({}, this.handleUI(prop, label), {
	        menuItems: menuItems
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;
	
	      var errors = (0, _modelValidator.validate)(this.state.userForm, (0, _model2.default)());
	      this.setState({ submitted: true, emailDuplicate: false });
	
	      if (errors.length > 0) {
	        return;
	      }
	
	      // pass up form fields in state to parent container;
	      var formFields = this.state.userForm;
	      formFields.roles = (0, _lodash.uniq)([2].concat(formFields.roles || [])); // Role 2 is Employee.
	
	      if (this.props.saveFunc) {
	
	        this.props.saveFunc(formFields).then(function () {
	          _this3.props.closeFunc && _this3.props.closeFunc();
	        }).catch(function (err) {
	          var errorMessage = (0, _lodash.get)(err, 'body.errors[0].errorMessage');
	          if (errorMessage === 'EMAIL_DUPLICATE') {
	            _this3.setState({ emailDuplicate: true });
	          }
	          console.error('err catched', errorMessage);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          title = _props.title,
	          closeFunc = _props.closeFunc,
	          staticData = _props.staticData,
	          employees = _props.employees;
	
	
	      var defaultCategories = (0, _lodash.get)(this.state, 'userForm.categories', []);
	
	      var shouldRender = function shouldRender(prop) {
	        return _this4.props.renderFields ? _this4.props.renderFields.includes(prop) : true;
	      };
	      var industryTypesList = (0, _lodash.filter)(staticData.industryTypesList, function (item) {
	        return item.category !== null;
	      });
	      var categoriesMenuItems = (0, _lodash.map)(industryTypesList, function (item) {
	        return (0, _lodash.pick)(item, ['id', 'name']);
	      });
	
	      // don't include Employee or Sysadmin (if current user is not a Sysadmin) in selected roles (state will still retain this value)
	      var defaultRoles = (0, _lodash.get)(this.state, 'userForm.roles', []).filter(function (role) {
	        return role !== _this4.props.employeeRole.id;
	      });
	
	      // remove sysadmin unless current user is a sysadmin
	      if (!this.props.currentUser.roles.includes(this.props.sysAdminRole.name)) {
	        defaultRoles = (0, _lodash.filter)(defaultRoles, function (role) {
	          return role !== _this4.props.sysAdminRole.id;
	        });
	      }
	
	      var filteredRoles = (0, _lodash.filter)(staticData.employeeRoles, function (role) {
	        return role.hardcodelink !== 'APPLICANT' && role.hardcodelink !== 'CLIENT' && role.hardcodelink !== 'EMPLOYEE';
	      });
	
	      // take out sysadmin unless current user is a sysadmin
	      if (!this.props.currentUser.roles.includes(this.props.sysAdminRole.name)) {
	        filteredRoles = (0, _lodash.filter)(filteredRoles, function (role) {
	          return role.hardcodelink !== 'SYSTEM_ADMINISTRATOR';
	        });
	      }
	
	      // populate list of default roles, filtering out those already in use.
	      this.theRealDefaultRoles = staticData.employeeRoles.filter(function (x) {
	        return x.isDefaultRole === true;
	      });
	      var defaultRolesInUse = employees.filter(function (x) {
	        return x.defaultRole !== null && x.id !== (0, _lodash.get)(_this4.props, 'employee.id', -1);
	      }).map(function (y) {
	        return y.defaultRole;
	      });
	      this.theRealDefaultRoles = this.theRealDefaultRoles.filter(function (x) {
	        return defaultRolesInUse.filter(function (y) {
	          return y === x.id;
	        }).length === 0;
	      });
	      this.theRealDefaultRoles.push({ id: null, name: 'None' });
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClickOut: closeFunc },
	        _react2.default.createElement(
	          'div',
	          { className: 'settings-user-create' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'settings-user-create-form ' + (this.props.formClassName ? this.props.formClassName : 'three-columns') },
	            shouldRender('firstName') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_TextField2.default, this.handleUI('firstName', 'First Name'))
	            ),
	            shouldRender('lastName') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_TextField2.default, this.handleUI('lastName', 'Last Name'))
	            ),
	            shouldRender('title') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_TextField2.default, this.handleUI('title', 'Title'))
	            ),
	            shouldRender('email') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_TextField2.default, this.handleUI('email', 'Email'))
	            ),
	            shouldRender('direct_dial') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	                hideMaskChar: true,
	                mask: '(999) 999-9999'
	              }, this.handleUI('direct_dial', 'Contact Number')))
	            ),
	            shouldRender('cellphoneNumber') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	                hideMaskChar: true,
	                mask: '(999) 999-9999'
	              }, this.handleUI('cellphoneNumber', 'Cell Number')))
	            ),
	            shouldRender('roles') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_CheckList2.default, {
	                'data-id': 'role',
	                defaultValue: defaultRoles,
	                floatingLabelText: 'Role',
	                onBlur: this.handleChange('roles'),
	                isDirty: this.state.submitted,
	                errorText: this.validate('roles'),
	                menuItems: filteredRoles
	
	              })
	            ),
	            shouldRender('state') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_SimpleDropDownMenu2.default, _extends({}, this.handleDropDownMenuUI('state', staticData.stateList, 'Location'), {
	                underlineStyle: { margin: '-1px 0px' },
	                iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                labelStyle: { paddingLeft: '0px' }
	              }))
	            ),
	            shouldRender('Status') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropDownMenuUI('activeState', this.statusMenuItems, 'Status'))
	            ),
	            shouldRender('categories') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_c_CheckList2.default, {
	                'data-id': 'categories',
	                defaultValue: defaultCategories,
	                floatingLabelText: 'Category',
	                onBlur: this.handleChange('categories'),
	                isDirty: this.state.submitted,
	                errorText: this.validate('categories'),
	                menuItems: categoriesMenuItems
	              })
	            ),
	            shouldRender('weight') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_SimpleDropDownMenu2.default, _extends({}, this.handleDropDownMenuUI('weight', this.weightMenuItems, 'Weight'), {
	                underlineStyle: { margin: '-1px 0px' },
	                iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                labelStyle: { paddingLeft: '0px' }
	              }))
	            ),
	            shouldRender('defaultRole') && _react2.default.createElement(
	              'div',
	              { className: 'control' },
	              _react2.default.createElement(_SimpleDropDownMenu2.default, _extends({}, this.handleDropDownMenuUI('defaultRole', this.theRealDefaultRoles, 'Default Role'), {
	                underlineStyle: { margin: '-1px 0px' },
	                iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                labelStyle: { paddingLeft: '0px' }
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid grid-actions' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_Button2.default, {
	                  onClick: closeFunc,
	                  'data-id': 'cancel',
	                  className: 'button-secondary button-secondary-cancel',
	                  label: 'CANCEL' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_Button2.default, {
	                  'data-id': 'save-user',
	                  onClick: this.save.bind(this),
	                  className: 'button-main button-main-save-user',
	                  label: 'SAVE' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserForm;
	}(_react.Component), _class2.propTypes = {
	  title: _react.PropTypes.string,
	  closeFunc: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object,
	  saveFunc: _react.PropTypes.func.isRequired,
	  employee: _react.PropTypes.object,
	  employees: _react.PropTypes.object,
	  renderFields: _react.PropTypes.array,
	  formClassName: _react.PropTypes.string,
	  currentUser: _react.PropTypes.object,
	  sysAdminRole: _react.PropTypes.object,
	  employeeRole: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = UserForm;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// class names utility
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FadeOnChange = (_temp2 = _class = function (_Component) {
	  _inherits(FadeOnChange, _Component);
	
	  function FadeOnChange() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FadeOnChange);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FadeOnChange.__proto__ || Object.getPrototypeOf(FadeOnChange)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      faded: false,
	      oldChildren: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FadeOnChange, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      if (this.props.children !== newProps.children) {
	        this.setState({
	          faded: true,
	          oldChildren: this.props.children
	        });
	        setTimeout(function () {
	          return _this2.setState({
	            faded: false,
	            oldChildren: null
	          });
	        }, this.props.duration && this.props.duration / 2 || 125);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      // take out properties that will be overwritten from 'this.props'
	      var _props = this.props,
	          className = _props.className,
	          duration = _props.duration;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('fade-on-change', (_cx = {}, _defineProperty(_cx, className, className), _defineProperty(_cx, 'faded', this.state.faded), _cx)), style: { transition: 'opacity ' + (duration && duration / 2 || 125) + 'ms linear' } },
	        this.state.oldChildren || this.props.children
	      );
	    }
	  }]);
	
	  return FadeOnChange;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  duration: _react.PropTypes.number,
	  children: _react.PropTypes.any
	}, _temp2);
	exports.default = FadeOnChange;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// import calendar icon
	
	
	// js utilities
	
	
	// function to validate individual values
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStarRatingComponent = __webpack_require__(2860);
	
	var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);
	
	var _RatingStar = __webpack_require__(891);
	
	var _RatingStar2 = _interopRequireDefault(_RatingStar);
	
	var _ActiveRatingStar = __webpack_require__(874);
	
	var _ActiveRatingStar2 = _interopRequireDefault(_ActiveRatingStar);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RatingStars = (_temp = _class = function (_Component) {
	  _inherits(RatingStars, _Component);
	
	  function RatingStars(props, context) {
	    _classCallCheck(this, RatingStars);
	
	    var _this = _possibleConstructorReturn(this, (RatingStars.__proto__ || Object.getPrototypeOf(RatingStars)).call(this, props, context));
	
	    _this.state = {
	      value: 0,
	      errors: []
	    };
	    return _this;
	  }
	
	  _createClass(RatingStars, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // check for initial value
	      var initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : null;
	
	      var hasValidation = this.validate(initVal);
	      if (!hasValidation && initVal) {
	        // even without validation, should still set state to dirty if initial value is populated
	        this.setState({ value: initVal });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        this.validate(nextProps.value);
	        this.setState({ value: nextProps.value });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-1);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(newValue) {
	      // if(!this.props.hasOwnProperty('value')) {
	      this.validate(newValue);
	      this.setState({ value: newValue });
	      // }
	      if (this.props.onChange) {
	        this.props.onChange(null, newValue);
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(value) {
	      if (this.props.validation) {
	        var errorsObj = {
	          errors: (0, _modelValidator.validateField)(value, this.props.validation)
	        };
	        if (errorsObj.errors.length !== this.state.errors.length) {
	          if (this.props.onErrorChange) {
	            this.props.onErrorChange(errorsObj.errors.length > this.state.errors ? 1 : -1);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'renderReadOnlyStars',
	    value: function renderReadOnlyStars() {
	      // populate stars
	      var starNodes = [];
	      for (var i = 1; i <= 5; i++) {
	        var starNodeLabel = _react2.default.createElement(
	          'label',
	          { className: 'dv-star-rating-star' },
	          i <= this.state.value && _react2.default.createElement(_ActiveRatingStar2.default, null),
	          i > this.state.value && _react2.default.createElement(_RatingStar2.default, null)
	        );
	        starNodes.push(starNodeLabel);
	      }
	      return starNodes;
	    }
	
	    // Callback to render custom star icon.
	
	  }, {
	    key: 'renderStarIcon',
	    value: function renderStarIcon(stateValue, i, value) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        i <= stateValue && _react2.default.createElement(_ActiveRatingStar2.default, null),
	        i > stateValue && _react2.default.createElement(_RatingStar2.default, null)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'rating-stars-wrapper ' + (this.props.className || ''), tabIndex: '0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'floatingLabelText', 'data-id': this.props.floatingLabelText },
	          this.props.floatingLabelText
	        ),
	        this.props.readOnly && _react2.default.createElement(
	          'div',
	          { style: { display: 'inline-block', position: 'relative' }, className: 'dv-star-rating' },
	          this.renderReadOnlyStars()
	        ),
	        !this.props.readOnly && _react2.default.createElement(_reactStarRatingComponent2.default, {
	          name: this.props.id,
	          starCount: 5,
	          value: this.state.value,
	          onStarClick: this.onChange.bind(this),
	          renderStarIcon: this.renderStarIcon.bind(this, this.state.value),
	          editing: !this.props.disabled
	        })
	      );
	    }
	  }]);
	
	  return RatingStars;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  defaultValue: _react.PropTypes.any,
	  value: _react.PropTypes.any,
	  id: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  floatingLabelText: _react.PropTypes.string,
	  validation: _react.PropTypes.object,
	  onErrorChange: _react.PropTypes.func,
	  readOnly: _react.PropTypes.bool
	}, _temp);
	exports.default = RatingStars;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function CandidateIcon(props) {
	  var className = props.className,
	      otherProps = _objectWithoutProperties(props, ["className"]);
	
	  return _react2.default.createElement(
	    "svg",
	    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "21", height: "21", viewBox: "0 0 20 21", className: "candidate-icon " + className }, otherProps),
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "#FFF", strokeWidth: "2" },
	      _react2.default.createElement("path", { d: "M4.51 9.328C5.49 10.35 6.913 11 8.5 11c1.587 0 3.01-.649 3.99-1.672.848-.884 1.367-2.048 1.367-3.328 0-2.761-2.398-5-5.357-5S3.143 3.239 3.143 6c0 1.28.52 2.444 1.367 3.328z" }),
	      _react2.default.createElement("path", { d: "M4.641 9C2.575 10.27 1 12.66 1 15.176V20h15v-4.824c0-2.515-1.575-4.905-3.641-6.176" })
	    )
	  );
	}
	
	CandidateIcon.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = CandidateIcon;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function CompanyIcon(props) {
	  var className = props.className,
	      otherProps = _objectWithoutProperties(props, ["className"]);
	
	  return _react2.default.createElement(
	    "svg",
	    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "21", height: "23", viewBox: "0 0 20 23", className: "company-icon " + className }, otherProps),
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd", stroke: "#FAFAFA", strokeLinecap: "round", strokeLinejoin: "round" },
	      _react2.default.createElement("path", { strokeWidth: "2", d: "M8 1h10.667v20H8zM1 8h6.667v13.333H1z" }),
	      _react2.default.createElement("path", { d: "M3 12h2v2H3zM3 16h2v2H3zM10 16h2v2h-2zM14 16h2v2h-2zM10 12h2v2h-2zM14 12h2v2h-2zM10 8h2v2h-2zM14 8h2v2h-2zM10 4h2v2h-2zM14 4h2v2h-2z" })
	    )
	  );
	}
	
	CompanyIcon.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = CompanyIcon;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ContactIcon(props) {
	  var className = props.className,
	      showPlus = props.showPlus,
	      otherProps = _objectWithoutProperties(props, ["className", "showPlus"]);
	
	  return _react2.default.createElement(
	    "svg",
	    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "21", height: "26", viewBox: "0 0 20 26", className: "contact-icon " + className }, otherProps),
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FAFAFA", fillRule: "nonzero" },
	        _react2.default.createElement("path", { d: "M19.973 2.021h-1V.027H5.016A2.998 2.998 0 0 0 2.021 3.02v1H.027v1.99H2.02v7.978H.027v1.995H2.02v1a2.998 2.998 0 0 0 2.995 2.995h13.963v-6.984h1V11h-1v-1h1V8.005h-1v-1h1V5.011h-1v-1h.994V2.02zM16.984 17.98H5.016c-.548 0-1-.447-1-1V3.02c0-.548.447-1 1-1h11.968V17.98z" }),
	        _react2.default.createElement("path", { d: "M13.49 7.01a2.998 2.998 0 0 0-2.995-2.994 2.994 2.994 0 1 0 2.995 2.995zm-2.99.995c-.548 0-1-.446-1-1 0-.548.447-1 1-1 .548 0 1 .447 1 1-.005.554-.452 1-1 1z" }),
	        _react2.default.createElement("path", { d: "M14.99 14.99c0-2.75-2.011-4.99-4.49-4.99-2.473 0-4.49 2.24-4.49 4.99v1h8.98v-1zm-6.841-1c.346-1.16 1.266-1.995 2.351-1.995s2.005.835 2.351 1.994H8.15z" })
	      ),
	      showPlus && _react2.default.createElement(
	        "g",
	        { transform: "translate(9 12)" },
	        _react2.default.createElement("circle", { cx: "7", cy: "7", r: "7", fill: "#151921" }),
	        _react2.default.createElement(
	          "g",
	          { stroke: "#FFF", strokeWidth: "2" },
	          _react2.default.createElement("path", { d: "M3 7h8M7 3v8" })
	        )
	      )
	    )
	  );
	}
	
	ContactIcon.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = ContactIcon;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function JobRequestIcon(props) {
	  var className = props.className,
	      showPlus = props.showPlus,
	      otherProps = _objectWithoutProperties(props, ["className", "showPlus"]);
	
	  return _react2.default.createElement(
	    "svg",
	    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "21", height: "26", viewBox: "0 0 20 26", className: "company-icon " + className }, otherProps),
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { fill: "#FAFAFA", fillRule: "nonzero" },
	        _react2.default.createElement("path", { d: "M12.979 1.027v-1H5v1H.016v18.952h17.952V1.027h-4.99zm-5.984.994h3.989v1h-3.99v-1zm8.978 15.958H2.011V3.02H5v1.995h7.979V3.021h2.994V17.98z" }),
	        _react2.default.createElement("path", { d: "M4.005 7.011H6v1.995H4.005zM7.995 7.011h5.984v1.995H7.995zM4.005 11H6v1.995H4.005zM7.995 11h5.984v1.995H7.995zM4.005 14.989H6v1.995H4.005zM7.995 14.989h5.984v1.995H7.995z" })
	      ),
	      showPlus && _react2.default.createElement(
	        "g",
	        { transform: "translate(8 12)" },
	        _react2.default.createElement("circle", { cx: "7", cy: "7", r: "7", fill: "#151921" }),
	        _react2.default.createElement(
	          "g",
	          { stroke: "#FAFAFA", strokeWidth: "2" },
	          _react2.default.createElement("path", { d: "M3 7h8M7 3v8" })
	        )
	      )
	    )
	  );
	}
	
	JobRequestIcon.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = JobRequestIcon;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogoSmall = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    account: store.staticData.account,
	    labels: (0, _lodash.get)(store.labels, 'Common', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(LogoSmall, _Component);
	
	  function LogoSmall() {
	    _classCallCheck(this, LogoSmall);
	
	    return _possibleConstructorReturn(this, (LogoSmall.__proto__ || Object.getPrototypeOf(LogoSmall)).apply(this, arguments));
	  }
	
	  _createClass(LogoSmall, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var collapsed = props.collapsed,
	          _props$style = props.style;
	      _props$style = _props$style === undefined ? {} : _props$style;
	
	      var color = _props$style.color,
	          backgroundColor = _props$style.backgroundColor,
	          otherProps = _objectWithoutProperties(props, ['collapsed', 'style']);
	
	      if (props.account && this.props.labels.logoSmall) {
	
	        if (collapsed) {
	          return _react2.default.createElement('img', _extends({ src: this.props.labels.logoSmallCollapsed }, otherProps));
	        } else {
	          return _react2.default.createElement('img', _extends({ src: this.props.labels.logoSmall }, otherProps));
	        }
	      }
	
	      return _react2.default.createElement(
	        'svg',
	        { width: '226px', height: '60px', viewBox: '0 0 675 80', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', id: 'thingyouhoverover' },
	        _react2.default.createElement(
	          'title',
	          null,
	          ("Branch: release-4.53.0\nCommit: 568e257fa")
	        ),
	        _react2.default.createElement('path', { fill: backgroundColor || '#ffffff', d: ' M 0.00 0.00 L 276.00 0.00 L 276.00 90.00 L 0.00 90.00 L 0.00 0.00 Z' }),
	        _react2.default.createElement('path', { fill: color || '#888', d: ' M 134.10 2.17 C 135.83 2.17 137.55 2.16 139.28 2.16 C 139.28 9.62 139.32 17.07 139.26 24.52 C 141.54 22.03 143.92 19.47 147.06 18.08 C 152.88 15.32 160.61 16.05 165.05 20.98 C 168.61 24.69 169.10 30.10 169.24 34.97 C 169.30 42.45 169.24 49.93 169.25 57.41 C 167.52 57.42 165.80 57.42 164.08 57.43 C 163.99 48.65 164.43 39.84 163.73 31.08 C 163.53 26.64 160.55 22.09 155.90 21.48 C 148.14 19.80 140.28 26.24 139.66 33.99 C 138.92 41.79 139.44 49.64 139.29 57.46 C 137.55 57.46 135.82 57.46 134.09 57.45 C 134.13 39.02 134.11 20.60 134.10 2.17 Z' }),
	        _react2.default.createElement('path', { fill: collapsed ? backgroundColor || '#ffffff' : color || '#888', d: ' M 81.01 32.04 C 83.33 22.87 92.48 15.88 102.01 16.50 C 108.13 16.49 113.64 19.96 117.32 24.68 C 117.28 22.30 117.26 19.92 117.24 17.54 C 118.96 17.54 120.68 17.54 122.41 17.54 C 122.39 30.85 122.39 44.15 122.41 57.45 C 120.68 57.46 118.96 57.46 117.24 57.46 C 117.26 55.23 117.28 52.99 117.31 50.76 C 113.39 55.13 107.99 58.43 101.98 58.47 C 94.04 59.03 86.32 54.28 82.71 47.29 C 80.26 42.66 79.80 37.10 81.01 32.04 Z' }),
	        _react2.default.createElement('path', { fill: color || '#888', d: ' M 229.71 19.77 C 236.18 15.49 245.10 15.43 251.83 19.16 C 258.52 22.85 262.03 30.38 262.27 37.82 C 250.05 37.91 237.84 37.81 225.62 37.87 C 226.10 42.11 227.28 46.53 230.53 49.53 C 235.60 54.72 244.20 54.87 250.15 51.15 C 252.93 49.53 254.65 46.73 256.49 44.20 C 257.96 44.99 259.43 45.79 260.90 46.59 C 258.23 51.18 254.49 55.43 249.33 57.20 C 242.94 59.33 235.40 59.00 229.64 55.29 C 223.78 51.25 220.16 44.13 220.44 37.01 C 220.51 30.21 224.11 23.60 229.71 19.77 Z' }),
	        _react2.default.createElement('path', { fill: color || '#888', d: ' M 13.63 17.54 C 15.44 17.54 17.24 17.54 19.04 17.55 C 23.13 27.17 27.30 36.77 31.32 46.42 C 36.02 36.69 39.78 26.51 44.83 16.95 C 49.44 26.70 53.69 36.62 58.12 46.46 C 62.35 36.83 66.52 27.17 70.73 17.53 C 72.54 17.53 74.36 17.54 76.18 17.55 C 70.05 31.03 64.53 44.79 58.09 58.13 C 53.44 48.50 49.21 38.68 44.81 28.94 C 40.14 38.58 36.33 48.64 31.26 58.08 C 25.22 44.64 19.58 31.02 13.63 17.54 Z' }),
	        _react2.default.createElement('path', { fill: color || '#888', d: ' M 176.47 17.55 C 178.34 17.54 180.21 17.54 182.08 17.54 C 186.62 27.20 191.00 36.93 195.66 46.54 C 200.01 36.84 204.53 27.21 208.94 17.54 C 210.83 17.54 212.71 17.54 214.59 17.55 C 208.94 29.58 203.39 41.67 197.83 53.75 C 197.33 54.86 196.58 55.83 195.81 56.78 C 195.57 56.78 195.07 56.78 194.83 56.78 C 188.59 43.76 182.68 30.58 176.47 17.55 Z' }),
	        _react2.default.createElement('path', { fill: backgroundColor || '#ffffff', d: ' M 97.29 22.07 C 106.16 19.22 116.41 25.75 117.42 35.03 C 118.81 42.54 114.27 50.64 106.86 52.85 C 98.98 55.82 89.56 51.20 86.77 43.34 C 83.19 34.95 88.47 24.32 97.29 22.07 Z' }),
	        _react2.default.createElement('path', { fill: backgroundColor || '#ffffff', d: ' M 231.62 24.72 C 237.68 19.74 247.41 20.59 252.75 26.25 C 254.65 28.24 255.51 30.92 256.55 33.40 C 246.42 33.47 236.29 33.47 226.16 33.39 C 227.49 30.25 228.79 26.85 231.62 24.72 Z' }),
	        _react2.default.createElement('path', { fill: color || '#888', d: ' M 141.95 61.57 C 166.57 57.53 191.67 57.10 216.52 58.80 C 236.21 60.67 255.79 63.62 275.33 66.66 C 267.10 69.90 258.86 73.11 250.64 76.38 C 235.27 64.55 214.91 62.02 196.09 63.54 C 168.73 64.98 142.50 73.34 116.23 80.42 C 104.72 83.63 93.06 86.68 81.09 87.49 C 74.38 87.96 67.64 88.02 60.92 87.83 C 54.80 87.75 49.13 85.24 43.28 83.79 C 29.10 80.07 14.91 76.37 0.73 72.64 C 24.78 73.37 48.90 73.75 72.90 71.59 C 96.05 69.32 118.99 65.28 141.95 61.57 Z' })
	      );
	    }
	  }]);
	
	  return LogoSmall;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = LogoSmall;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function MenuIcon(props) {
	  var className = props.className,
	      isOpen = props.isOpen,
	      otherProps = _objectWithoutProperties(props, ["className", "isOpen"]);
	
	  if (isOpen) {
	    return _react2.default.createElement(
	      "svg",
	      _extends({ xmlns: "http://www.w3.org/2000/svg", width: "21", height: "23", viewBox: "0 0 20 22", className: "menu-icon " + className }, otherProps),
	      _react2.default.createElement(
	        "g",
	        { fill: "none", fillRule: "evenodd", stroke: "#FAFAFA", strokeWidth: "2" },
	        _react2.default.createElement("path", { strokeLinecap: "round", d: "M1 1v20" }),
	        _react2.default.createElement("path", { d: "M3.742 10.943l4.51-2.704c.045-.026.1.006.1.058v5.406a.067.067 0 0 1-.1.058l-4.51-2.704a.067.067 0 0 1 0-.114z" }),
	        _react2.default.createElement("path", { strokeLinecap: "round", d: "M11.667 11H8.333" })
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      "svg",
	      _extends({ xmlns: "http://www.w3.org/2000/svg", width: "21", height: "23", viewBox: "0 0 20 22", className: "menu-icon " + className }, otherProps),
	      _react2.default.createElement(
	        "g",
	        { fill: "none", fillRule: "evenodd", stroke: "#FAFAFA", strokeWidth: "2" },
	        _react2.default.createElement("path", { strokeLinecap: "round", d: "M11.667 1v20" }),
	        _react2.default.createElement("path", { d: "M8.925 10.943l-4.51-2.704a.066.066 0 0 0-.101.058v5.406c0 .052.057.084.1.058l4.51-2.704a.067.067 0 0 0 0-.114z" }),
	        _react2.default.createElement("path", { strokeLinecap: "round", d: "M1 11h3.333" })
	      )
	    );
	  }
	}
	
	MenuIcon.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = MenuIcon;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ProfileIcon(props) {
	  var className = props.className,
	      otherProps = _objectWithoutProperties(props, ["className"]);
	
	  return _react2.default.createElement(
	    "svg",
	    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "18", height: "20", viewBox: "0 0 18 20", className: "profile-icon " + className }, otherProps),
	    _react2.default.createElement("path", { fill: "#333", fillRule: "evenodd", d: "M14.839 7.437l-.259-.26a.934.934 0 0 1-.004-1.314.919.919 0 0 1 1.306-.004l1.846 1.848c.361.362.363.95.004 1.315l-1.847 1.87a.919.919 0 0 1-1.305.004.934.934 0 0 1-.004-1.315l.28-.285h-4.69a.93.93 0 1 1 0-1.86h4.673zm-7.454 9.296v2.058c0 .981-.965 1.528-1.798 1.01l-4.76-2.965C.34 16.533 0 15.916 0 15.342V1.39C0 1.094.088.836.235.636A.374.374 0 0 1 .289.541C.542.21.939 0 1.385 0h10.153a1.39 1.39 0 0 1 1.385 1.391v2.327c0 .514-.413.93-.923.93a.926.926 0 0 1-.923-.93V1.86l-6.913-.004 2.394 1.49c.486.303.827.921.827 1.495v10.033h3.692v-1.859c0-.513.413-.93.923-.93s.923.417.923.93v2.328c0 .77-.621 1.39-1.385 1.39H7.385zm-1.842-1.02V4.925L1.846 2.613V15.33l3.697 2.267v-1.703a.948.948 0 0 1 0-.182z" })
	  );
	}
	
	ProfileIcon.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = ProfileIcon;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable no-unused-vars,react/prop-types */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TransferItemOwnershipDialogIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function TransferItemOwnershipDialogIcon(props) {
	  var className = props.className,
	      otherProps = _objectWithoutProperties(props, ['className']);
	
	  return _react2.default.createElement(
	    'svg',
	    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', fill: 'black' },
	    _react2.default.createElement('path', { d: 'M0 0h30v30H0V0z', fill: 'none' }),
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-13.5V9h-4v2h4v2.5l3.5-3.5zm-6 4L5.5 14 9 17.5V15h4v-2H9z' })
	  );
	}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable no-unused-vars,react/prop-types */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TransferItemOwnershipIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function TransferItemOwnershipIcon(props) {
	  var className = props.className,
	      otherProps = _objectWithoutProperties(props, ['className']);
	
	  return _react2.default.createElement(
	    'svg',
	    { xmlns: 'http://www.w3.org/2000/svg', height: '24', viewBox: '0 0 24 24', width: '24' },
	    _react2.default.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  );
	}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(4);
	
	function sendEvent(category, action, label, value) {
	  if (ga) {
	    ga('send', 'event', category, action, label, value);
	  }
	}
	
	exports.gaEvent = function gaEvent() {
	  var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
	
	  return (0, _lodash.debounce)(sendEvent, wait);
	};

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = leftPad;
	function leftPad(padVal, padChar, amount) {
	  padVal = '' + padVal;
	  if (padVal.length < amount) {
	    padVal = new Array(amount - padVal.length).fill(padChar).concat(padVal).join('');
	  }
	  return padVal;
	}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatAddress;
	
	var _strings = __webpack_require__(309);
	
	function formatAddress() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      address = _ref.address,
	      address2 = _ref.address2,
	      city = _ref.city,
	      stateName = _ref.stateName,
	      countryOther = _ref.countryOther,
	      zip = _ref.zip;
	
	  var line1 = (0, _strings.concat)([address, address2, city], ', ');
	  var line2 = (0, _strings.concat)([countryOther || stateName, zip], ' ');
	  return (0, _strings.concat)([line1, line2], ', ');
	}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (input) {
	  var reg = '\\d(?=(\\d{3})+$)';
	  return input ? '$' + ('' + input).replace(/[^0-9]/g, '').replace(new RegExp(reg, 'g'), '$&,') : '';
	};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatAMPM;
	
	var _leftPad = __webpack_require__(462);
	
	var _leftPad2 = _interopRequireDefault(_leftPad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatAMPM(date) {
	  var hours = date.getHours();
	  var minutes = date.getMinutes();
	  var ampm = hours >= 12 ? 'pm' : 'am';
	  return (hours % 12 || 12) + ':' + (0, _leftPad2.default)(minutes, 0, 2) + ampm; // the hour '0' should be '12'
	}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatTimezone;
	function formatTimezone(value) {
	  // Only display first word for timezone.
	  if (typeof value === 'string') {
	    var words = value.split(/[\s\-]+/);
	    return words.length ? words[0] : value;
	  }
	  return value;
	}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var ApplicantWorkExperience = function (_BaseModel) {
	  _inherits(ApplicantWorkExperience, _BaseModel);
	
	  function ApplicantWorkExperience() {
	    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : applicantWorkExperienceSchema;
	
	    _classCallCheck(this, ApplicantWorkExperience);
	
	    return _possibleConstructorReturn(this, (ApplicantWorkExperience.__proto__ || Object.getPrototypeOf(ApplicantWorkExperience)).call(this, schema));
	  }
	
	  _createClass(ApplicantWorkExperience, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return applicantWorkExperienceSchema;
	    }
	  }]);
	
	  return ApplicantWorkExperience;
	}(BaseModel);
	
	var applicantWorkExperienceSchema = {
	  employerName: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  city: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  state: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  typeOfBusiness: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  title: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  department: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  employmentStart: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  contactEmployer: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	
	  // if can contact employer
	  supervisorName: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  supervisorEmail: {
	    isEmail: {
	      message: 'Must be a valid email.'
	    }
	  },
	  supervisorPhoneNumber: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    },
	    matches: {
	      options: /^[2-9]\d{9}$/,
	      message: 'Must be a valid phone number.'
	    }
	  },
	
	  // if can't contact employer
	  contactEmployerReason: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	
	  // job summary/specifics
	  jobSummary: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  jobSpecifics: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 3 },
	      message: 'Must provide at least 3'
	    }
	  }
	};
	
	module.exports = ApplicantWorkExperience;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getSchema = getSchema;
	
	var _require = __webpack_require__(311),
	    combine = _require.combine,
	    required = _require.required,
	    isNumeric = _require.isNumeric,
	    isLength = _require.isLength,
	    custom = _require.custom,
	    matches = _require.matches;
	
	var _require2 = __webpack_require__(4),
	    isEmpty = _require2.isEmpty;
	
	var requiredMessage = 'This field is required';
	
	var schema = exports.schema = {
	  name: combine(required(), isLength(1, undefined, requiredMessage)),
	  phoneNumber: combine(required(), isLength(10, 10, 'Must be 10 digits'), isNumeric(), matches(/^[2-9]\d{9}$/, 'Must be a valid phone number.')),
	  position: combine(required(), isLength(1, undefined, requiredMessage)),
	  yearsKnown: combine(required(), isNumeric()),
	  company: combine(required(), isLength(1, undefined, requiredMessage)),
	  relationshipId: combine(required(), isLength(1, undefined, requiredMessage))
	};
	
	function getSchema() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$referenceRelatio = _ref.referenceRelationshipTypes,
	      referenceRelationshipTypes = _ref$referenceRelatio === undefined ? [] : _ref$referenceRelatio;
	
	  return _extends({}, schema, {
	    relationshipOther: custom('relationshipOther', function (reference, val) {
	
	      var otherRelationship = referenceRelationshipTypes.find(function (r) {
	        return r.subElement === 'Other';
	      });
	      var relationship = referenceRelationshipTypes.find(function (r) {
	        return r.id === reference.relationshipId;
	      });
	      if (relationship && relationship.id === otherRelationship.id) {
	        return !isEmpty(val);
	      }
	
	      return true;
	    }, requiredMessage)
	  });
	}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	// redux interactions
	
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _socket = __webpack_require__(438);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _ProfileIcon = __webpack_require__(458);
	
	var _ProfileIcon2 = _interopRequireDefault(_ProfileIcon);
	
	var _NotificationBellOff = __webpack_require__(889);
	
	var _NotificationBellOff2 = _interopRequireDefault(_NotificationBellOff);
	
	var _NotificationBellOn = __webpack_require__(890);
	
	var _NotificationBellOn2 = _interopRequireDefault(_NotificationBellOn);
	
	var _Notification = __webpack_require__(859);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var _auth = __webpack_require__(213);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var socket = (0, _socket2.default)(({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).BASE_URL);
	
	var UserMenu = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    user: store.user,
	    alerts: store.alerts,
	    labels: (0, _lodash.get)(store.labels, 'Common', {})
	  };
	}, {
	  logOut: _auth.logOut
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(UserMenu, _React$Component);
	
	  function UserMenu(props, context) {
	    _classCallCheck(this, UserMenu);
	
	    var _this = _possibleConstructorReturn(this, (UserMenu.__proto__ || Object.getPrototypeOf(UserMenu)).call(this, props, context));
	
	    _this.dismissAlert = _this.dismissAlert.bind(_this);
	    _this.navigateAlert = _this.navigateAlert.bind(_this);
	
	    _this.state = {
	      newAlerts: []
	    };
	
	    _this.dismissTimeout = [];
	    _this.logOut = _this.logOut.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // register sockets
	      socket.emit('register employee socket', this.props.user.id);
	      socket.on('alert', function (data) {
	        return _this2.incomingAlert(data);
	      });
	
	      this.loadAlerts();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.dismissTimeout) {
	        (0, _lodash.each)(this.dismissTimeout, function (timeout) {
	          return timeout && clearTimeout(timeout);
	        });
	      }
	
	      socket.emit('deregister employee socket', this.props.user.id);
	    }
	  }, {
	    key: 'loadAlerts',
	    value: function loadAlerts() {
	      var _this3 = this;
	
	      // check current alerts
	      this.props.dispatch(asyncActionCreator.getAlerts({
	        success: function success(data) {
	          _this3.props.dispatch((0, _sync.updateAlerts)(_extends({}, data.items)));
	        }
	      }));
	    }
	  }, {
	    key: 'incomingAlert',
	    value: function incomingAlert(alertData) {
	      var _this4 = this;
	
	      this.setState({ newAlerts: this.state.newAlerts.concat(alertData) });
	      this.loadAlerts();
	
	      this.dismissTimeout[alertData.id](setTimeout(function () {
	        _this4.dismissAlert(alertData.id);
	      }, 5000));
	    }
	  }, {
	    key: 'dismissAlert',
	    value: function dismissAlert(alertId) {
	      var _this5 = this;
	
	      this.setState({ newAlerts: (0, _lodash.filter)(this.state.newAlerts, function (a) {
	          return a.id != alertId;
	        }) });
	
	      this.props.dispatch(asyncActionCreator.readAlert(alertId, {
	        success: function success(data) {
	          return _this5.loadAlerts();
	        }
	      }));
	
	      if (this.dismissTimeout[alertId]) {
	        clearTimeout(this.dismissTimeout[alertId]);
	        this.dismissTimeout[alertId] = null;
	      }
	    }
	  }, {
	    key: 'navigateAlert',
	    value: function navigateAlert(alert, target, route) {
	      var path = '/admin';
	      if (target === 'user') {
	        path = path + ('/' + (alert.alertData.location || alert.alertData.locationName) + '/' + alert.alertData.target + '/details');
	      } else if (target === 'location') {
	        path = path + ('/' + (alert.alertData.location || alert.alertData.locationName));
	      } else if (target === null) {
	        path = route;
	      }
	
	      this.props.dispatch((0, _reactRouterRedux.push)(path));
	    }
	  }, {
	    key: 'logOut',
	    value: function logOut() {
	      var website = this.props.labels.website;
	      this.props.logOut().then(function () {
	        window.location = website;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var logoutTooltip = 'Logout: ' + this.props.user.firstName + ' ' + this.props.user.lastName;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: 'user-menu', 'data-id': 'User Menu' },
	          !!~this.props.user.roles.findIndex(function (role) {
	            return !(0, _lodash.includes)(['Applicant', 'Client'], role);
	          }) && _react2.default.createElement(
	            'div',
	            null,
	            !!Object.keys((0, _lodash.filter)(this.props.alerts, function (a) {
	              return !a.isRead;
	            })).length > 0 && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { style: { width: 'auto', height: 'auto', padding: '0', border: '0' }, 'data-id': 'notification-icon-button', tooltip: 'Notifications', tooltipPosition: 'bottom-center' },
	                _react2.default.createElement(_NotificationBellOn2.default, { 'data-id': 'alerts-pending', onClick: function onClick() {
	                    return _this6.props.dispatch((0, _reactRouterRedux.push)('/admin/alerts'));
	                  } })
	              )
	            ) || _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { style: { width: 'auto', height: 'auto', padding: '0', border: '0' }, 'data-id': 'notification-icon-button', tooltip: 'Notifications', tooltipPosition: 'bottom-center' },
	                _react2.default.createElement(_NotificationBellOff2.default, { 'data-id': 'alerts-pending', onClick: function onClick() {
	                    return _this6.props.dispatch((0, _reactRouterRedux.push)('/admin/alerts'));
	                  } })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { style: { width: 'auto', height: 'auto', padding: '0', border: '0' }, 'data-id': 'logout-icon-button', tooltip: logoutTooltip, tooltipPosition: 'bottom-center' },
	                _react2.default.createElement(_ProfileIcon2.default, { 'data-id': 'logout-icon', onClick: function onClick() {
	                    return _this6.logOut();
	                  } })
	              )
	            )
	          ) || _react2.default.createElement(
	            'h3',
	            { className: 'hover-link', 'data-id': 'logout-text', onClick: function onClick() {
	                return _this6.logOut();
	              } },
	            'LOGOUT'
	          )
	        ),
	        _react2.default.createElement(_Notification2.default, {
	          alerts: this.state.newAlerts,
	          dismiss: this.dismissAlert,
	          navigate: this.navigateAlert
	        })
	      );
	    }
	  }]);
	
	  return UserMenu;
	}(_react2.default.Component), _class2.propTypes = {
	  user: _react.PropTypes.object,
	  alerts: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  logOut: _react.PropTypes.func,
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = UserMenu;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _technology = __webpack_require__(1126);
	
	var surveyApi = _interopRequireWildcard(_technology);
	
	var _technologysurveys = __webpack_require__(1133);
	
	var surveyStore = _interopRequireWildcard(_technologysurveys);
	
	var _ui = __webpack_require__(26);
	
	var uiStore = _interopRequireWildcard(_ui);
	
	var _validator = __webpack_require__(312);
	
	var _applicantTechSurvey = __webpack_require__(903);
	
	var _TechnologySurveyForm = __webpack_require__(1011);
	
	var _TechnologySurveyForm2 = _interopRequireDefault(_TechnologySurveyForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TechnologySurveyContainer = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    user: store.user,
	    labels: (0, _lodash.get)(store.labels, 'ApplicantTechnologySurvey', {}),
	    profile: store.applicantProfile,
	    staticData: store.staticData,
	    technologySurvey: store.technologySurvey
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(TechnologySurveyContainer, _Component);
	
	  function TechnologySurveyContainer(props) {
	    _classCallCheck(this, TechnologySurveyContainer);
	
	    var _this = _possibleConstructorReturn(this, (TechnologySurveyContainer.__proto__ || Object.getPrototypeOf(TechnologySurveyContainer)).call(this, props));
	
	    _this.onChange = function (field, value) {
	      _this.updateSurvey(field, value);
	    };
	
	    _this.onSave = function () {
	      _this.saveSurvey();
	    };
	
	    _this.onSubmit = function () {
	      _this.submitSurvey();
	    };
	
	    _this.onModal = function (note) {
	      _this.displayModal(note);
	    };
	
	    _this.allowSubmit = function () {
	      var _this$validate = _this.validate(_this.state.survey),
	          _this$validate2 = _slicedToArray(_this$validate, 1),
	          valid = _this$validate2[0];
	
	      return !_this.props.technologySurvey.dateCompleted && valid;
	    };
	
	    _this.state = _this.initState(props);
	    _this.localStash = {};
	    return _this;
	  }
	
	  _createClass(TechnologySurveyContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _lodash.isEqual)(nextProps.technologySurvey, this.props.technologySurvey)) {
	        this.setState((0, _lodash.omit)(this.initState(nextProps), ['errors']));
	      }
	    }
	  }, {
	    key: 'initLabels',
	    value: function initLabels(props) {
	      return {
	        computerTypeId: props.adminView ? 'Computer Type' : 'What type of computer do you plan on using as your main workstation?',
	        computerMakeAndModel: props.adminView ? 'Make and model' : 'What is the make and model?',
	        windowsOperatingSystemId: props.adminView ? 'Windows Version' : 'Windows Version',
	        computerOperatingSystemId: props.adminView ? 'PC or Other (Mac, Chromebook, etc.)' : 'Is your computer a PC or Other (Mac, Chromebook, etc.)?',
	        windowsUpdatingRegularly: props.adminView ? 'MS Windows Software updating regularly' : 'Is your MS Windows Software updating regularly and running properly?',
	        computerMemorySizeId: props.adminView ? 'GigaBytes of RAM' : (0, _lodash.get)(props, 'labels.computerMemorySizes', 'GigaBytes of RAM'),
	        hasSecondMonitor: props.adminView ? 'Has a second monitor' : 'Do you have a second monitor?',
	        displayConnectionTypeId: props.adminView ? 'Connection to add an additional monitor' : (0, _lodash.get)(props, 'labels.displayConnectionType'),
	        supportsSecondMonitor: props.adminView ? 'Laptop or PC supports additional monitor' : 'If you currently do not have a dual monitor, will your laptop or PC support one?',
	        hasPrinterScanner: props.adminView ? 'Has printer/scanner' : 'Do you have a printer/scanner?',
	        hasWebcam: props.adminView ? 'Has a webcam' : 'Do you have a webcam (camera & microphone)?',
	        hasMSOfficeInstalled: props.adminView ? 'Microsoft Office installed' : 'Do you have Microsoft Office installed?',
	        msOfficeVersionId: props.adminView ? 'Microsoft Office version' : (0, _lodash.get)(props, 'labels.msOfficeVersion'),
	        includesOutlook: props.adminView ? 'Includes Outlook' : 'Does it include Outlook?',
	        msOfficeUpdatingRegularly: props.adminView ? 'MS Office installed updating regularly' : 'Is your MS Office Software updating regularly and running properly?',
	        hasAntiVirusInstalled: props.adminView ? 'Anti-Virus software installed' : 'Do you have an Anti-Virus software installed you have paid for and is updated and currently protecting your workstation?',
	        antiVirusName: props.adminView ? 'Name of the Anti-Virus Program' : 'What is the name of the Anti-Virus program currently installed?',
	        antiVirusExpired: props.adminView ? 'Anti-Virus expiration date' : 'What date does the Anti-Virus protection expire?',
	        antiVirusRenewedYearly: props.adminView ? 'Agrees to renew Anti-Virus software every year.' : 'You agree that you will renew your Anti-Virus software every year when it expires.',
	        hasFirewallInstalled: props.adminView ? 'Firewall installed' : 'Is a firewall protecting your computer either through the Windows Firewall or your Anti-Virus software?',
	        hasSkypeInstalled: props.adminView ? 'Skype or a similar program' : 'Do you use Skype or a similar type of program?',
	        internetProviderId: props.adminView ? 'Internet Service provider' : (0, _lodash.get)(props, 'labels.internetProvider'),
	        internetProviderOther: 'If other, please specify',
	        internetTypeId: props.adminView ? 'High-speed internet service type' : (0, _lodash.get)(props, 'labels.internetType'),
	        internetDownloadSpeed: props.adminView ? 'Internet download speed' : 'What is the internet download speed?',
	        internetUploadSpeed: props.adminView ? 'Internet upload speed' : 'What is the internet upload speed?',
	        internetAgeId: props.adminView ? 'Cable box/modem age' : 'How long have you had the current cable box/modem that controls your internet?',
	        hasRouter: props.adminView ? 'Wireless router' : 'Do you have a wireless router?',
	        routerAgeId: props.adminView ? 'Wireless router age' : 'How long have you had your wireless router?',
	        routerMakeAndModel: props.adminView ? 'Make and model of your wireless router' : 'What is the make and model of your wireless router?',
	        isRouterLocatedInSameArea: props.adminView ? 'Is your internet equipment in your home office?' : 'Is your internet equipment in your home office?',
	        supportsVOIP: props.adminView ? 'Available Ethernet for (VOIP) phone' : 'Is there an Ethernet port in your modem or router that could be used to plug in an internet (VOIP) phone?',
	        willingToUpgradeRouter: props.adminView ? 'Willing to upgrade you router' : 'If necessary, are you willing to upgrade your router?',
	        windowsOSModal: props.adminView ? '' : 'To find your Windows version click [here].',
	        windowsOSModalMessage: (0, _lodash.get)(props, 'labels.windowsOSModalMessage'),
	        computerMemorySizes: props.adminView ? '' : 'A minimum of 8 GB is required. Higher memory is recommended. To find your memory levels click [here].',
	        computerMemorySizesMessage: 'A minimum of 8 GB is required. Higher memory is recommended. This information can be found by going to Control Panel, System and Security, System.',
	        hasAntiVirus: props.adminView ? '' : 'Free antivirus are not acceptable, click [here] for info.',
	        hasAntiVirusMessage: (0, _lodash.get)(props, 'labels.freeAntiVirusModalMessage'),
	        internetSpeeds: props.adminView ? '' : 'For more information on your internet speed, click [here]. Please enter your results including decimals, ex: 30.62',
	        internetSpeedsMessage: 'You can find the speed by going to https://www.speakeasy.net/speedtest/ on your browser. Hit the big blue “Start” button and wait for the results. Enter your download speed and upload speed into the fields in the technology survey. Your results should be entered per this example. DL 46.5 UL 10.2',
	        upgradeRouter: props.adminView ? '' : 'For more information on upgrading routers, click [here].',
	        upgradeRouterMessage: 'For the best connection possible, outdated equipment should be replaced.\n                                  A cable modem from your internet provider is typically available to be\n                                  swapped out at no charge. Router technology has advanced significantly\n                                  in recent years and new models offer tremendous speed and reliability\n                                  over their predecessors.',
	        titleText: props.adminView ? '' : (0, _lodash.get)(props, 'technologySurvey.dateCompleted', false) ? (0, _lodash.get)(props, 'labels.completedTitleText') : (0, _lodash.get)(props, 'labels.titleText'),
	        instructionText: props.adminView ? '' : (0, _lodash.get)(props, 'labels.InstructionText'),
	        smartPhone: props.adminView ? 'Has Smart Phone' : (0, _lodash.get)(props, 'labels.smartPhone'),
	        smartPhoneMakeAndModel: props.adminView ? 'Smart Phone Make / Model' : (0, _lodash.get)(props, 'labels.smartPhoneMakeAndModel'),
	        cellProvider: props.adminView ? 'Cell Provider' : (0, _lodash.get)(props, 'labels.cellProvider'),
	        hotspot: props.adminView ? 'Has Hotspot' : (0, _lodash.get)(props, 'labels.hotspot'),
	        hasHeadsetWithMicrophone: (0, _lodash.get)(props, 'labels.hasHeadsetWithMicrophone'),
	        hasSpeakersWithMicrophone: (0, _lodash.get)(props, 'labels.hasSpeakersWithMicrophone')
	      };
	    }
	  }, {
	    key: 'initSurvey',
	    value: function initSurvey(technologySurvey) {
	      return Object.assign({}, technologySurvey); // Clone
	    }
	  }, {
	    key: 'initState',
	    value: function initState(props) {
	      return {
	        survey: this.initSurvey(props.technologySurvey),
	        fieldLabels: this.initLabels(props),
	        errors: {},
	        modalMessage: null
	      };
	    }
	  }, {
	    key: 'updateSurvey',
	    value: function updateSurvey(field, value) {
	      var _this2 = this;
	
	      var _newState = this.newState(),
	          survey = _newState.survey,
	          errors = _newState.errors;
	
	      survey[field] = value;
	
	      // handle field dependencies and stash/pop so that we don't lose values on stray clicks...
	      var stash = function stash(key) {
	        return _this2.stash(key, survey[key]);
	      };
	      var pop = function pop(key) {
	        return (0, _lodash.isNil)(survey[key]) ? _this2.pop(key) : survey[key];
	      };
	
	      if (field === 'hasMSOfficeInstalled') {
	        if (survey.hasMSOfficeInstalled) {
	          survey.msOfficeVersionId = pop('msOfficeVersionId');
	          survey.includesOutlook = pop('includesOutlook');
	        } else {
	          survey.msOfficeVersionId = stash('msOfficeVersionId');
	          survey.includesOutlook = stash('includesOutlook');
	        }
	      }
	
	      if (field === 'hasAntiVirusInstalled') {
	        if (survey.hasAntiVirusInstalled) {
	          survey.antiVirusExpired = pop('antiVirusExpired');
	          survey.antiVirusName = pop('antiVirusName');
	        } else {
	          survey.antiVirusExpired = stash('antiVirusExpired');
	          survey.antiVirusName = stash('antiVirusName');
	        }
	      }
	
	      if (field === 'supportsSecondMonitor') {
	        if (survey.supportsSecondMonitor) {
	          survey.displayConnectionTypeId = pop('displayConnectionTypeId');
	        } else {
	          survey.displayConnectionTypeId = stash('displayConnectionTypeId');
	        }
	      }
	
	      if (field === 'hasRouter') {
	        if (survey.hasRouter) {
	          survey.routerAgeId = pop('routerAgeId');
	        } else {
	          survey.routerAgeId = stash('routerAgeId');
	        }
	      }
	
	      if (field === 'smartPhone') {
	        if (survey.smartPhone) {
	          survey.smartPhoneMakeAndModel = pop('smartPhoneMakeAndModel');
	          survey.cellProvider = pop('cellProvider');
	        } else {
	          survey.smartPhoneMakeAndModel = stash('smartPhoneMakeAndModel');
	          survey.cellProvider = stash('cellProvider');
	        }
	      }
	
	      var _validate = this.validate(survey),
	          _validate2 = _slicedToArray(_validate, 2),
	          valid = _validate2[0],
	          newErrors = _validate2[1];
	
	      var fields = [field].concat(_toConsumableArray((0, _lodash.get)(_applicantTechSurvey.schema, field + '.related', [])));
	
	      if (!valid) {
	        this.setState(function () {
	          return { survey: survey, errors: (0, _lodash.merge)({}, (0, _lodash.omit)(errors, fields), (0, _lodash.pick)(newErrors, fields)) };
	        });
	      } else {
	        this.setState(function () {
	          return { survey: survey, errors: (0, _lodash.omit)(errors, fields) };
	        });
	      }
	    }
	  }, {
	    key: 'saveSurvey',
	    value: function saveSurvey() {
	      var _this3 = this;
	
	      var _newState2 = this.newState(),
	          survey = _newState2.survey;
	
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          profile = _props.profile;
	
	      var _validate3 = this.validate(survey),
	          _validate4 = _slicedToArray(_validate3, 2),
	          valid = _validate4[0],
	          errors = _validate4[1];
	
	      if (!valid) {
	        this.setState({ errors: errors });
	      }
	
	      dispatch(surveyApi.saveTechnologySurvey(profile.id, survey, function (err, techSurvey) {
	        if (err) {
	          _this3.displayWarning('Please check all fields are valid.');
	          return;
	        }
	
	        dispatch(surveyStore.updateTechnologySurvey(techSurvey));
	        dispatch(uiStore.showSnackBar('Changes are saved'));
	      }));
	    }
	  }, {
	    key: 'submitSurvey',
	    value: function submitSurvey() {
	      var _this4 = this;
	
	      var _newState3 = this.newState(),
	          survey = _newState3.survey;
	
	      var _props2 = this.props,
	          dispatch = _props2.dispatch,
	          profile = _props2.profile;
	
	      var _validate5 = this.validate(survey),
	          _validate6 = _slicedToArray(_validate5, 1),
	          valid = _validate6[0];
	
	      if (!valid) {
	        this.saveSurvey();
	        return;
	      }
	
	      dispatch(surveyApi.submitTechnologySurvey(profile.id, survey, function (err, techSurvey) {
	        if (err) {
	          _this4.displayWarning(err.message);
	          return;
	        }
	
	        dispatch(surveyStore.updateTechnologySurvey(techSurvey));
	        dispatch(uiStore.showSnackBar('Survey submitted'));
	      }));
	    }
	  }, {
	    key: 'validateWindowsOsField',
	    value: function validateWindowsOsField(_ref) {
	      var survey = _ref.survey,
	          errors = _ref.errors,
	          form = _ref.form;
	
	      var osList = (0, _lodash.get)(this.props, 'staticData.operatingSystemTypes');
	      var osWindows = (0, _lodash.find)(osList, { hardcodelink: 'PC' });
	
	      var needsWindowsId = osWindows && survey.computerOperatingSystemId === (0, _lodash.get)(osWindows, 'id') && (0, _lodash.isNil)(survey.windowsOperatingSystemId) && !(0, _lodash.has)(errors, 'computerOperatingSystemId');
	
	      if (needsWindowsId) {
	        (0, _lodash.set)(errors, 'windowsOperatingSystemId', ['This field is required.']);
	        form.valid = false;
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(survey) {
	      var form = (0, _validator.validateObject)(survey, _applicantTechSurvey.schema);
	      var errors = typeof form.errors === 'string' ? {} : form.errors;
	      this.validateWindowsOsField({ survey: survey, errors: errors, form: form });
	      return [form.valid, errors];
	    }
	  }, {
	    key: 'displayWarning',
	    value: function displayWarning(warning) {
	      var dispatch = this.props.dispatch;
	
	      return dispatch(uiStore.warningToast(warning));
	    }
	  }, {
	    key: 'displayModal',
	    value: function displayModal() {
	      var modalMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.setState({ modalMessage: modalMessage });
	    }
	  }, {
	    key: 'newState',
	    value: function newState() {
	      return Object.assign({}, this.state);
	    }
	  }, {
	    key: 'stash',
	    value: function stash(key, value) {
	      this.localStash[key] = value;
	      return null;
	    }
	  }, {
	    key: 'pop',
	    value: function pop(key) {
	      return this.localStash[key];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          survey = _state.survey,
	          errors = _state.errors,
	          fieldLabels = _state.fieldLabels,
	          modalMessage = _state.modalMessage;
	      var _props3 = this.props,
	          staticData = _props3.staticData,
	          adminView = _props3.adminView;
	
	
	      return _react2.default.createElement(_TechnologySurveyForm2.default, {
	        survey: survey,
	        errors: errors,
	        adminView: adminView,
	        fieldLabels: fieldLabels,
	        staticData: staticData,
	        modalMessage: modalMessage,
	        onChange: this.onChange,
	        onSave: this.onSave,
	        onSubmit: this.onSubmit,
	        onModal: this.onModal,
	        allowSubmit: this.allowSubmit()
	      });
	    }
	  }]);
	
	  return TechnologySurveyContainer;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  technologySurvey: _react.PropTypes.object.isRequired,
	  adminView: _react.PropTypes.bool,
	  labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = TechnologySurveyContainer;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdditionalContactModel = function () {
	  function AdditionalContactModel() {
	    _classCallCheck(this, AdditionalContactModel);
	  }
	
	  _createClass(AdditionalContactModel, null, [{
	    key: 'getModel',
	    value: function getModel() {
	      return model;
	    }
	  }]);
	
	  return AdditionalContactModel;
	}();
	
	exports.default = AdditionalContactModel;
	
	
	var model = {
	  firstName: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  lastName: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  title: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  phoneNumber1: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    },
	    matches: {
	      options: /^[2-9]\d{9}$/,
	      message: 'Must be a valid phone number.'
	    }
	  },
	  email: {
	    required: {
	      message: 'This field is required.'
	    },
	    isEmail: {
	      message: 'Must be a valid email.'
	    }
	  },
	  phoneExtension1: {},
	  address: {},
	  city: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  state: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  zip: {}
	};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _Handset = __webpack_require__(888);
	
	var _Handset2 = _interopRequireDefault(_Handset);
	
	var _ProfileIcon = __webpack_require__(458);
	
	var _ProfileIcon2 = _interopRequireDefault(_ProfileIcon);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicantMenu = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.user,
	    qs: state.applicantProfile.qualifyingspecialist,
	    labels: (0, _lodash.get)(state.labels, 'Common', {})
	  };
	}, {
	  push: _reactRouterRedux.push
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ApplicantMenu, _Component);
	
	  function ApplicantMenu() {
	    _classCallCheck(this, ApplicantMenu);
	
	    var _this = _possibleConstructorReturn(this, (ApplicantMenu.__proto__ || Object.getPrototypeOf(ApplicantMenu)).call(this));
	
	    _this.state = {
	      showSupportInfo: false
	    };
	
	    _this.toggleQSInfo = function () {
	      _this.setState({
	        showSupportInfo: !_this.state.showSupportInfo
	      });
	    };
	
	    _this.hideQSInfo = function () {
	      _this.setState({
	        showSupportInfo: false
	      });
	    };
	
	    _this.handleLogOut = function () {
	
	      if (_this.props.logOut) {
	        _this.props.logOut();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(ApplicantMenu, [{
	    key: 'renderSupport',
	    value: function renderSupport(state, props) {
	      var showSupportInfo = state.showSupportInfo;
	      var qs = props.qs;
	
	
	      if (showSupportInfo && qs) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'support-qs-info', 'data-id': 'Modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'iconContent' },
	              _react2.default.createElement(
	                'a',
	                { className: 'handset-icon', onClick: this.toggleQSInfo },
	                _react2.default.createElement(_Handset2.default, null),
	                'support'
	              )
	            ),
	            _react2.default.createElement(_ModalX2.default, { onClick: this.hideQSInfo })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'qs-content' },
	            _react2.default.createElement(
	              'span',
	              { className: 'qs-name' },
	              props.qs.firstName,
	              ' ',
	              props.qs.lastName
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'qs-type' },
	              'Qualifying Specialist'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'qs-info' },
	            _react2.default.createElement(
	              'span',
	              { style: { whiteSpace: 'nowrap' } },
	              props.qs.email
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _prettyPhone2.default)(props.qs.directDial || '')
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'applicant-menu' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          !(0, _lodash.isNil)(this.props.qs) && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { className: 'handset-icon', 'data-id': 'support', onClick: this.toggleQSInfo },
	              _react2.default.createElement(_Handset2.default, null),
	              'support'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { className: 'log-out-icon', onClick: function onClick() {
	                  return _this2.handleLogOut();
	                } },
	              _react2.default.createElement(_ProfileIcon2.default, null),
	              'log out'
	            )
	          )
	        ),
	        this.renderSupport(this.state, this.props)
	      );
	    }
	  }]);
	
	  return ApplicantMenu;
	}(_react.Component), _class2.propTypes = {
	  push: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  qs: _react.PropTypes.object.isRequired,
	  logOut: _react.PropTypes.func.isRequired,
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = ApplicantMenu;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(753);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _company = __webpack_require__(905);
	
	var _user = __webpack_require__(124);
	
	var _contactProfile = __webpack_require__(907);
	
	var _DropdownChecklist = __webpack_require__(296);
	
	var _DropdownChecklist2 = _interopRequireDefault(_DropdownChecklist);
	
	var _f_InfoModal = __webpack_require__(122);
	
	var _f_InfoModal2 = _interopRequireDefault(_f_InfoModal);
	
	var _InfoIcon = __webpack_require__(204);
	
	var _InfoIcon2 = _interopRequireDefault(_InfoIcon);
	
	var _index = __webpack_require__(211);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _staticData = __webpack_require__(28);
	
	var _formatCompanyUrl = __webpack_require__(306);
	
	var _dropdowns = __webpack_require__(206);
	
	var _parentChildList = __webpack_require__(169);
	
	var _industrySegments = __webpack_require__(307);
	
	var _staticData2 = __webpack_require__(170);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _muiThemeable = __webpack_require__(394);
	
	var _muiThemeable2 = _interopRequireDefault(_muiThemeable);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _SimpleDropDownMenu = __webpack_require__(121);
	
	var _SimpleDropDownMenu2 = _interopRequireDefault(_SimpleDropDownMenu);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var gaEvent = __webpack_require__(461).gaEvent();
	
	// action creators for redux
	
	
	// get validations
	
	
	var validationObj = {};
	
	function validationSchema(component) {
		var iiabaState = {
			custom: {
				func: function func(val) {
					var state = _lodash2.default.get(component, 'state.prospectModel') || {};
					var tradeAssociations = _lodash2.default.get(state, 'company.tradeAssociations', []);
					var iiabaState = _lodash2.default.isString(val) && !val.length ? null : val;
					if (tradeAssociations.length && tradeAssociations.includes(4) && _lodash2.default.isNil(iiabaState)) {
						return false;
					}
	
					return true;
				},
	
				message: 'Please choose a member state.'
			}
		};
	
		var address = {
			required: {
				message: 'This field is required.'
			}
		};
	
		var numberOfOffices = {
			isNumeric: {
				message: 'Must be numeric'
			},
			required: {
				message: 'This field is required.'
			}
		};
	
		var phoneNumber1 = {
			required: {
				message: 'This field is required.'
			},
			isLength: {
				options: { min: 10, max: 10 },
				message: 'Must be 10 digits'
			},
			isNumeric: {
				message: 'Must be numeric'
			},
			matches: {
				options: /^[2-9]\d{9}$/,
				message: 'Must be a valid phone number.'
			}
		};
	
		return {
			user: _lodash2.default.omit((0, _user.getSchema)(), ['password', 'timezone']), // password gets validated in the next step
			profile: (0, _contactProfile.getSchema)(),
			company: _lodash2.default.merge({}, (0, _company.getSchema)(), { iiabaState: iiabaState }, { address: address }, { numberOfOffices: numberOfOffices }, { phoneNumber1: phoneNumber1 })
		};
	}
	
	// js utility library
	
	// import components from material UI
	
	
	// import customized versions of components from material UI
	var ProspectForm = (_dec = (0, _reactRedux.connect)(function (store) {
		return {
			currentUser: store.user,
			contacts: (0, _lodash.get)(store.admin.contacts, 'items', []),
			staticData: store.staticData,
			labels: (0, _lodash.get)(store.labels, 'ProspectForm', {}),
			commonLabels: (0, _lodash.get)(store.labels, 'Common', {}),
			scrollBarWidth: store.browserData.scrollBarWidth
		};
	}), _dec2 = (0, _muiThemeable2.default)(), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
		_inherits(ProspectForm, _Component);
	
		function ProspectForm(props, context) {
			_classCallCheck(this, ProspectForm);
	
			// need to bind functions to self either here or in render
			var _this = _possibleConstructorReturn(this, (ProspectForm.__proto__ || Object.getPrototypeOf(ProspectForm)).call(this, props, context));
	
			_this.state = {
				errorCount: 0,
				prospectModel: {
					user: {},
					profile: {},
					company: {}
				},
				storedModel: null,
				showSuccess: false,
				showErrorMessage: false,
				duplicateEmail: false,
				userData: {},
				formSubmitted: false,
				showSnackbar: false,
				snackBarText: '',
				lastContactId: null,
				editMode: false,
				checkContact: !_this.props.asAdmin
			};
			_this.handleUI = _this.handleUI.bind(_this);
			_this.handleUIParentChildDropdown = _this.handleUIParentChildDropdown.bind(_this);
			_this.submitForm = _this.submitForm.bind(_this);
			_this.loadContact = _this.loadContact.bind(_this);
			_this.hideSnackbar = _this.hideSnackbar.bind(_this);
			_this.onChange = function (parent, child, event, newVal) {
				// eslint-disable-line no-unused-vars
	
				if (parent === 'company' && child === 'segmentTypes' && (0, _lodash.isNil)(newVal)) return; // WPS-43 - do not clear segment types when parent changes
	
				// update field
				// preparing new value in required object format
				var obj = {
					prospectModel: {}
				};
				obj.prospectModel[parent] = {};
				obj.prospectModel[parent][child] = newVal;
	
				// adding hacky solution for adding correct data in each state update.
				// getting current state, adding new data.
				var result = _lodash2.default.merge({}, _this.state);
				result.prospectModel[parent][child] = newVal;
	
				// setting previous state with new data.
				_this.setState(result);
			};
	
			_this.onErrorChange = function (changeInt) {
				var errorCount = _this.state.errorCount + changeInt;
				var showErrorMessage = _this.state.showErrorMessage && !!errorCount;
				_this.setState(_lodash2.default.merge(_this.state, {
					errorCount: errorCount,
					showErrorMessage: showErrorMessage
				}));
			};
	
			validationObj = validationSchema(_this);
	
			_this.parentChildHandlers = (0, _parentChildList.parentChildList)();
	
			return _this;
		}
	
		_createClass(ProspectForm, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
	
				if (this.props.asAdmin && this.state.formSubmitted) {
					this.setState({ formSubmitted: false });
					this.props.dispatch(ui.showSnackBar(this.state.prospectModel.user.firstName + ' ' + this.state.prospectModel.user.lastName + ' has been added'));
					// for now go back to contacts screen
					this.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts'));
				}
			}
		}, {
			key: 'loadContact',
			value: function loadContact() {
				// const contact = findContact({profile: {id: this.state.lastContactId}}, this.props.contacts);
				this.setState({
					prospectModel: this.state.storedModel,
					showSnackbar: false,
					editMode: true
				});
			}
		}, {
			key: 'hideSnackbar',
			value: function hideSnackbar() {
				this.setState({
					showSnackbar: false
				});
			}
		}, {
			key: 'submitForm',
			value: function submitForm() {
				var _this2 = this;
	
				if (this.state.errorCount === 0) {
					if (this.props.asAdmin) {
						this.state.prospectModel.profile.createdBy = this.props.currentUser.id;
					}
	
					// if we're in the first part of the form, check only contact info
					if (this.state.checkContact) {
						var companyDomain = (0, _formatCompanyUrl.extractCompanyUrlFromEmail)(this.state.prospectModel.user.email);
						this.state.prospectModel.company.website = companyDomain;
	
						this.props.dispatch(asyncActionCreators.checkAndCreateContact(this.state.prospectModel, {
							success: function success(data) {
								_this2.setState(_lodash2.default.merge(_this2.state, {
									showSuccess: true,
									userData: data[0],
									formSubmitted: true,
									storedModel: _this2.state.prospectModel
								}));
	
								gaEvent('Client', 'Client Success', 'WAHVE Client');
							},
							error: function error(err) {
	
								var customError = _lodash2.default.get(err, 'body.errors[0]', _lodash2.default.get(err, 'body.data.items[0]'));
								if (_lodash2.default.get(customError, 'errorCode') === 'DUPLICATE_EMAIL') {
									_this2.handleDuplicateEmail(customError);
								} else if (_lodash2.default.get(customError, 'errorCode') === 'NEW_CONTACT') {
									_this2.setState({ checkContact: false }, function () {
										// go to state so that we scroll further down than just the first line
										var companySection = ReactDOM.findDOMNode(_this2.refs.state);
										if (companySection) {
											companySection.scrollIntoView(false);
										}
									});
								}
							}
						}));
					} else {
						// standard submit
						if (this.state.editMode) {
							// set ID vars
							this.state.prospectModel.contactId = this.state.lastContactId;
							this.state.prospectModel.user = { id: this.state.lastContactId };
	
							this.props.dispatch(asyncActionCreators.updateProspect(this.state.prospectModel, {
								success: function success(data) {
									_this2.setState(_lodash2.default.merge(_this2.state, {
										editMode: false,
										userData: data[0],
										formSubmitted: true,
										storedModel: _this2.state.prospectModel
									}));
								},
								error: function error(err) {
									console.log('got error', err);
								}
							}));
						} else {
							var _companyDomain = (0, _formatCompanyUrl.extractCompanyUrlFromEmail)(this.state.prospectModel.user.email);
							this.state.prospectModel.company.website = _companyDomain;
							this.props.dispatch(asyncActionCreators.createProspect(this.state.prospectModel, {
								success: function success(data) {
									data[0].password = '';
									_this2.setState(_lodash2.default.merge(_this2.state, {
										showSuccess: true,
										userData: data[0],
										formSubmitted: true,
										storedModel: _this2.state.prospectModel
									}));
	
									gaEvent('Client', 'Client Success', 'WAHVE Client');
								},
								error: function error(err) {
	
									var customError = _lodash2.default.get(err, 'body.data.items[0]');
	
									if (_lodash2.default.get(customError, 'errorCode') === 'DUPLICATE_EMAIL') {
										_this2.handleDuplicateEmail(customError);
									}
	
									console.log('got error', err);
								}
							}));
						}
					}
				} else {
					for (var refKey in this.refs) {
						if (this.refs[refKey].checkErrors) {
							this.refs[refKey].checkErrors();
						}
					}
					this.setState(_lodash2.default.merge(this.state, {
						showErrorMessage: true
					}));
				}
			}
		}, {
			key: 'handleDuplicateEmail',
			value: function handleDuplicateEmail(customError) {
				var clientAdvisor = customError.clientAdvisor;
				var userFirstName = customError.userFirstName;
				var failExisting = this.props.labels.failExisting;
	
	
				var errorText = '\n\t\tHello ' + userFirstName + '. ' + failExisting;
	
				var updatedState = {
					duplicateEmail: true,
					duplicateEmailText: errorText
				};
	
				if (clientAdvisor !== undefined) {
					if (clientAdvisor.email !== undefined) {
						updatedState.clientAdvisorEmail = clientAdvisor.email;
					}
				}
	
				this.setState(updatedState);
			}
	
			// handleUI removes the 'required' property from fields in the model
			// so that they aren't validated in certain instances
			// should probably rename this to something more useful like configureValidationModel
	
		}, {
			key: 'handleUI',
			value: function handleUI(parent, child) {
	
				var propValidationObj = validationObj[parent][child];
	
				// never validate company.numberOfEmployees
				if (parent === 'company' && child === 'numberOfEmployees') {
					propValidationObj = _lodash2.default.omit(propValidationObj, ['required']);
				}
	
				// Remove 'required' property from several fields when internal user is entering data
				// Necessary because internal user may not have certain information available at this time
				if (this.props.asAdmin) {
	
					if (parent === 'user' && ['timezone'].includes(child)) {
						// Timezone (User)
						propValidationObj = _lodash2.default.omit(propValidationObj, ['required']);
					}
	
					if (parent === 'company' && ['numberOfOffices', 'numberOfEmployees', 'isDivisionOrSubsidiary', 'industryTypes', 'segmentTypes', 'tradeAssociations', 'affiliationTypes', 'address'].includes(child)) {
						// Number of offices (Company)
						// Number of employees (Company)
						// Are you a subsidiary (Company)
						// Industry Types
						// Industry Segments
						// Trade Associations
						// Affiliations
						// Address
						propValidationObj = _lodash2.default.omit(propValidationObj, ['required']);
					}
	
					if (parent === 'profile' && ['foundUsVia', 'initialInquiry'].includes(child)) {
						propValidationObj = _lodash2.default.omit(propValidationObj, ['required']);
					}
				}
	
				// add required field validation for industry other and segment other...
				if (child === 'industryOther' || child === 'segmentOther') {
					propValidationObj = {
						required: {
							message: 'This field is required'
						}
					};
				}
	
				return {
					'data-id': parent + '.' + child,
					floatingLabelText: (0, _lodash.get)(this.props.labels, parent + '.' + child),
					onBlur: this.onChange.bind(this, parent, child),
					onErrorChange: this.onErrorChange,
					ref: child || parent,
					validation: propValidationObj,
					defaultValue: this.state.prospectModel[parent][child] || ''
				};
			}
		}, {
			key: 'handleUIParentChildDropdown',
			value: function handleUIParentChildDropdown(parent, child, menuItems) {
				return _extends({
					menuItems: menuItems
				}, this.handleUI(parent, child));
			}
		}, {
			key: 'handleDropdown',
			value: function handleDropdown(parent, child) {
				var _handleUI = this.handleUI(parent, child),
				    onBlur = _handleUI.onBlur,
				    rest = _objectWithoutProperties(_handleUI, ['onBlur']);
	
				return _extends({
					onChange: onBlur
				}, rest);
			}
		}, {
			key: 'completeProspectForm',
			value: function completeProspectForm() {
	
				if (this.props.asAdmin) {
					this.setState({ showSuccess: false, duplicateEmail: false });
				} else {
					window.location.assign(this.props.commonLabels.website);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var scrollBarWidth = this.props.scrollBarWidth;
				var _props$staticData = this.props.staticData,
				    stateList = _props$staticData.stateList,
				    timezoneList = _props$staticData.timezoneList,
				    segmentTypes = _props$staticData.segmentTypes,
				    industryTypesList = _props$staticData.industryTypesList,
				    tradeAssociations = _props$staticData.tradeAssociations,
				    iiabaStates = _props$staticData.iiabaStates,
				    affiliationTypes = _props$staticData.affiliationTypes,
				    foundUsViaList = _props$staticData.foundUsViaList,
				    contactPhoneTypes = _props$staticData.contactPhoneTypes;
	
	
				var foundUsVia = (0, _staticData2.referralsByRole)(foundUsViaList, 'C');
	
				var _state$prospectModel = this.state.prospectModel,
				    _state$prospectModel$ = _state$prospectModel.company,
				    company = _state$prospectModel$ === undefined ? {} : _state$prospectModel$,
				    _state$prospectModel$2 = _state$prospectModel.profile,
				    profile = _state$prospectModel$2 === undefined ? {} : _state$prospectModel$2;
	
	
				var industrySegmentTypes = (0, _industrySegments.activeSegmentTypes)(segmentTypes, industryTypesList, (0, _lodash.get)(company, 'industryTypes'), (0, _lodash.get)(company, 'segmentTypes'));
	
				var yesNoItems = [{
					primaryText: 'Yes',
					subElement: null,
					value: true
				}, {
					primaryText: 'No',
					subElement: null,
					value: false
				}];
	
				var textForModal = {
					prompt: 'You can create a login to access your Contact Information or you can click on the X to exit.',
					buttonLabel: 'Continue'
				};
	
				var successText = [_react2.default.createElement(
					'h1',
					null,
					(0, _lodash.get)(this.props.labels, 'successHeader')
				), _react2.default.createElement('br', null), _react2.default.createElement('br', null), 'Hello ' + (0, _lodash.get)(this.state, 'prospectModel.user.firstName', '') + '. ', (0, _lodash.get)(this.props.labels, 'successBody')];
	
				var successTextExistingCompany = [_react2.default.createElement(
					'h1',
					null,
					(0, _lodash.get)(this.props.labels, 'successHeader')
				), _react2.default.createElement('br', null), _react2.default.createElement('br', null), 'Hello ' + (0, _lodash.get)(this.state, 'prospectModel.user.firstName', '') + '. ', (0, _lodash.get)(this.props.labels, 'successBodyExisting')];
				var mainPhone = (0, _lodash.find)(contactPhoneTypes, { name: 'Main' });
				var mainPhoneId = (0, _lodash.get)(mainPhone, 'id');
	
				var _parentChildHandlers = this.parentChildHandlers({
					parentProps: this.handleUIParentChildDropdown('company', 'industryTypes', industryTypesList),
					childProps: this.handleUIParentChildDropdown('company', 'segmentTypes', segmentTypes)
				}),
				    industryTypeProps = _parentChildHandlers.parent,
				    segmentTypeProps = _parentChildHandlers.child;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.asAdmin ? '' : 'content-container' },
					this.state.duplicateEmail && _react2.default.createElement(_f_InfoModal2.default, {
						cancelFunc: this.completeProspectForm.bind(this),
						buttonLabel: 'close',
						transitionFunc: this.completeProspectForm.bind(this),
						text: this.state.duplicateEmailText
					}),
					this.state.showSuccess && !this.props.asAdmin && _react2.default.createElement(_f_InfoModal2.default, {
						cancelFunc: this.completeProspectForm.bind(this),
						buttonLabel: 'close',
						transitionFunc: this.completeProspectForm.bind(this),
						text: this.state.checkContact ? successTextExistingCompany : successText }),
					_react2.default.createElement(
						'form',
						{ ref: 'prospectForm', className: 'prospect-form application-form clearfix' },
						_react2.default.createElement(
							'div',
							{ className: 'form-section clearfix' },
							_react2.default.createElement(
								'section',
								{ id: 'Contact_Info' },
								_react2.default.createElement(
									'h1',
									{ className: 'form-section-header' },
									'Contact Information'
								),
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'div',
									{ style: { display: 'flex', lineHeight: '30px' } },
									_react2.default.createElement('img', { width: 40, height: 30, src: 'assets/images/canada-flag.png', alt: 'Canada Flag' }),
									_react2.default.createElement(
										'span',
										{ style: { paddingLeft: '10px' } },
										'For Canadian talent\xA0',
										_react2.default.createElement(
											'a',
											{ href: 'https://wahve.com/find-canadian-talent', className: 'link login-link', 'data-id': 'Canadian Prospects' },
											'click here.'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'box-container-fixed clearfix' },
									_react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('user', 'firstName'), {
											floatingLabelText: 'First Name' }))
									),
									_react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('user', 'lastName'), {
											floatingLabelText: 'Last Name' }))
									),
									_react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('profile', 'title'), {
											floatingLabelText: 'Title' }))
									),
									_react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(_c_TextField2.default, _extends({
											disabled: this.state.editMode
										}, this.handleUI('user', 'email'), {
											floatingLabelText: 'Email Address' }))
									),
									_react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(
											'div',
											{ className: 'box-c' },
											_react2.default.createElement(
												'div',
												{ className: 'box-i' },
												_react2.default.createElement(_c_MaskedTextField2.default, _extends({
													hideMaskChar: true,
													mask: '(999) 999-9999'
												}, this.handleUI('user', 'phoneNumber1'), {
													floatingLabelText: 'Phone Number' }))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box-i' },
												_react2.default.createElement(_c_DropDownMenu2.default, _extends({
													menuItems: contactPhoneTypes
												}, this.handleUI('user', 'phoneType1')))
											)
										)
									),
									(0, _lodash.get)(this.state.prospectModel, 'user.phoneType1') === mainPhoneId && _react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('user', 'phoneExtension1'), {
											floatingLabelText: 'Extension' }))
									),
									_react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('profile', 'department'), {
											floatingLabelText: 'Department' }))
									),
									_react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(_c_DropDownMenu2.default, _extends({
											menuItems: timezoneList
										}, this.handleUI('user', 'timezone'), {
											floatingLabelText: 'Time Zone' }))
									),
									_react2.default.createElement(
										'div',
										{ className: 'box' },
										_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'name'), {
											floatingLabelText: 'Company Name' }))
									)
								)
							)
						),
						!this.state.checkContact && _react2.default.createElement(
							_reactAddonsCssTransitionGroup2.default,
							{
								transitionName: 'prospect-company-transition',
								transitionEnterTimeout: 700,
								transitionLeaveTimeout: 500,
								transitionAppear: true,
								transitionAppearTimeout: 700 },
							_react2.default.createElement(
								'div',
								{ className: 'prospect-company-info', key: 'prospect-company-info' },
								!this.props.asAdmin && _react2.default.createElement(
									'div',
									{ ref: 'infomsg', className: 'contact-company-info-message' },
									_react2.default.createElement(_InfoIcon2.default, null),
									' ',
									this.props.labels.companyInformation,
									' '
								),
								_react2.default.createElement(
									'div',
									{ className: 'form-section clearfix' },
									_react2.default.createElement(
										'section',
										{ id: 'Company_Info' },
										_react2.default.createElement(
											'h1',
											{ className: 'form-section-header' },
											'Company Information'
										),
										_react2.default.createElement(
											'div',
											{ className: 'box-container-fixed' },
											!this.props.asAdmin && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'name'), {
													disabled: true,
													floatingLabelText: 'Company Name'
												}))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'address'), {
													floatingLabelText: 'Street Address' }))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'city'), {
													floatingLabelText: 'City' }))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(
													'div',
													{ className: 'box-c' },
													_react2.default.createElement(
														'div',
														{ className: 'box-i' },
														_react2.default.createElement(_SimpleDropDownMenu2.default, _extends({
															menuItems: stateList,
															underlineStyle: { margin: '-1px 0px' },
															iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
															labelStyle: { paddingLeft: '0px' }
														}, this.handleUI('company', 'state'), {
															floatingLabelText: 'State' }))
													),
													_react2.default.createElement(
														'div',
														{ className: 'box-i' },
														_react2.default.createElement(_c_TextField2.default, _extends({
															type: 'number',
															maxLength: '5'
														}, this.handleUI('company', 'zip'), {
															floatingLabelText: 'Zip' }))
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_MaskedTextField2.default, _extends({
													mask: '(999) 999-9999',
													hideMaskChar: true
												}, this.handleUI('company', 'phoneNumber'), {
													floatingLabelText: 'Phone Number' }))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'numberOfOffices'), {
													floatingLabelText: 'Number of Offices' }))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'numberOfEmployees'), {
													floatingLabelText: 'Number of Employees' }))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_DropDownMenu2.default, _extends({
													menuItems: yesNoItems
												}, this.handleUI('company', 'isDivisionOrSubsidiary'), {
													floatingLabelText: 'Are you a division or subsidiary of another company? ' }))
											),
											company.isDivisionOrSubsidiary && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'parentCompany'), {
													floatingLabelText: 'Parent Company Name'
												}))
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'form-section clearfix' },
									_react2.default.createElement(
										'section',
										{ id: 'Preliminary_Info' },
										_react2.default.createElement(
											'h1',
											{ className: 'form-section-header' },
											'Preliminary Information'
										),
										_react2.default.createElement(
											'div',
											{ className: 'box-container-fixed clearfix' },
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_CheckList2.default, _extends({
													scrollBarWidth: scrollBarWidth
												}, industryTypeProps)),
												this.props.labels.company.industryTypesSubText && _react2.default.createElement(
													'div',
													{ className: 'label' },
													this.props.labels.company.industryTypesSubText
												)
											),
											company.industryTypes && company.industryTypes.includes((industryTypesList.find(function (i) {
												return i.name === 'Other';
											}) || {}).id) && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'industryOther'), {
													floatingLabelText: 'Type of Firm Other' }))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_DropdownChecklist2.default, {
													'data-id': 'company.segmentTypes',
													textLabel: (0, _lodash.get)(this.props.labels, 'company.segmentTypes'),
													menuItems: industrySegmentTypes,
													value: (0, _lodash.get)(company, 'segmentTypes'),
													groupBy: 'parentName',
													onChange: this.onChange.bind(this, 'company', 'segmentTypes'),
													errorText: 'This field is required',
													dirty: !!(0, _lodash.get)(this.state, 'prospectModel.company.industryTypes', false),
													required: true
												}),
												this.props.labels.company.segmentTypesSubText && _react2.default.createElement(
													'div',
													{ className: 'label' },
													this.props.labels.company.segmentTypesSubText
												)
											),
											company.segmentTypes && company.segmentTypes.includes((segmentTypes.find(function (s) {
												return s.name === 'Other';
											}) || {}).id) && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('profile', 'segmentOther'), {
													floatingLabelText: 'Industry Segment Other' }))
											),
											!!(tradeAssociations && tradeAssociations.length) && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_CheckList2.default, _extends({
													floatingLabelStyle: { whiteSpace: 'pre-wrap', transform: 'translateY(-20px)' },
													menuItems: (0, _staticData.convertToMenuItems)(tradeAssociations, 'id', 'crmName')
												}, this.handleUI('company', 'tradeAssociations')))
											),
											!!(company.tradeAssociations && company.tradeAssociations.includes((tradeAssociations.find(function (t) {
												return t.name === 'Other';
											}) || {}).id)) && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'associationOther'), {
													floatingLabelText: 'Trade Associations Other' }))
											),
											!!(company.tradeAssociations && company.tradeAssociations.indexOf(4) != -1) && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_DropDownMenu2.default, _extends({
	
													floatingLabelStyle: { whiteSpace: 'pre-wrap', transform: 'translateY(-40px)' },
													menuItems: iiabaStates
												}, this.handleDropdown('company', 'iiabaState'), {
													floatingLabelText: (0, _lodash.get)(this.props.labels, 'company.iiabaState') }))
											),
											(0, _lodash.get)(this.props.labels, 'company.networkAffiliationsYesNo', false) && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_DropDownMenu2.default, _extends({
													menuItems: yesNoItems
												}, this.handleUI('company', 'networkAffiliationsYesNo')))
											),
											!!(company.networkAffiliationsYesNo && company.networkAffiliationsYesNo == 1) && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_CheckList2.default, _extends({
													menuItems: affiliationTypes
												}, this.handleUI('company', 'affiliationTypes'), {
													floatingLabelText: 'Please select the affiliation or network.' }))
											),
											company.affiliationTypes && company.affiliationTypes.includes((affiliationTypes.find(function (a) {
												return a.name === 'Other';
											}) || {}).id) && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('company', 'affiliationOther'), {
													floatingLabelText: 'Network Affiliations Other' }))
											),
											_react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_SimpleDropDownMenu2.default, _extends({
													menuItems: foundUsVia.sort(_dropdowns.defaultOrdering),
													underlineStyle: { margin: '-1px 0px' },
													iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
													labelStyle: { paddingLeft: '0px' }
												}, this.handleUI('profile', 'foundUsVia')))
											),
											(foundUsViaList.find(function (f) {
												return f.name === 'Other, Please Specify:';
											}) || {}).id === profile.foundUsVia && _react2.default.createElement(
												'div',
												{ className: 'box' },
												_react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('profile', 'foundUsOther'), {
													floatingLabelText: 'Please Specify' }))
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'form-section clearfix' },
									_react2.default.createElement(
										'section',
										{ id: 'Inquiry_Reason' },
										_react2.default.createElement(
											'h1',
											{ className: 'form-section-header' },
											'Inquiry Reason'
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-section-content clearfix' },
											_react2.default.createElement(_c_TextArea2.default, _extends({
												className: 'center-column-1 inquiry',
												description: 'Please tell us what type of help you are looking for.'
											}, this.handleUI('profile', 'initialInquiry')))
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-submit-container' },
							_react2.default.createElement(_c_RaisedButton2.default, {
								label: 'Continue',
								onClick: this.submitForm }),
							this.state.showErrorMessage && _react2.default.createElement(
								'div',
								{ className: 'error-message' },
								'Please fill out the required fields above.'
							)
						)
					),
					_react2.default.createElement(_index2.default, null)
				);
			}
		}]);
	
		return ProspectForm;
	}(_react.Component), _class2.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		children: _react.PropTypes.any,
		currentUser: _react.PropTypes.object.isRequired,
		staticData: _react.PropTypes.object.isRequired,
		scrollBarWidth: _react.PropTypes.number,
		asAdmin: _react.PropTypes.bool,
		contacts: _react.PropTypes.array,
		labels: _react.PropTypes.object
	}, _temp)) || _class) || _class);
	exports.default = ProspectForm;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _C_ProgressComponentList = __webpack_require__(140);
	
	var _C_ProgressComponentList2 = _interopRequireDefault(_C_ProgressComponentList);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _Experience = __webpack_require__(1073);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _AccordionList = __webpack_require__(445);
	
	var _AccordionList2 = _interopRequireDefault(_AccordionList);
	
	var _prettyDate = __webpack_require__(75);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Default Labels
	var formHeading = 'Work Experience';
	var formText = '\n  Please give your full employment record covering the last twenty-five (25) years.\n  We have your permission to contact references unless you indicate "No" for a specific employer.\n  If you have letters of reference, you will have the opportunity to attach them from the File Uploads section towards the end\n  of the application.\n';
	
	var adminScript = 'Great. Let’s review your work experience.';
	var adminInstructions = '\nInstructions: Review your notes about the career summary and work experience with the applicant and the resume that was generated from the information. Review the reason for any \u201CNO\u201D for Permission to Contact Employer.\n';
	var adminInstrutionsItems = ['If the resume needs to be corrected and/or updated, explain:', 'If the applicant did not enter a gap, ask:', 'If the applicant’s end date for the most current job is over four months, ask the applicant the questions below:'];
	// End of Default Labels
	
	// needed to replace '\n' with actual newline
	var newLine = /\\n/g;
	
	var WorkExperience = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Application.experience', {})
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponentLis) {
	  _inherits(WorkExperience, _ProgressComponentLis);
	
	  function WorkExperience(props, context) {
	    _classCallCheck(this, WorkExperience);
	
	    var _this = _possibleConstructorReturn(this, (WorkExperience.__proto__ || Object.getPrototypeOf(WorkExperience)).call(this, props, context));
	
	    _this.adminQuestionProperties = function (model, question, label) {
	      return {
	        defaultValue: (0, _lodash.get)(_this.props.tempState[model], question, (0, _lodash.get)(_this.props[model], question, '')),
	        floatingLabelText: label,
	        capitalizedSentences: true,
	        validation: _this.props.validation[question],
	        onErrorChange: _this.props.errorUpdate,
	        onBlur: function onBlur(event, val) {
	          _this.updateTempState(model, question, event, val);
	        }
	      };
	    };
	
	    _this.handleClickExperience = function (clientId) {
	      _this.setState({ selectedClientId: clientId, showErrors: false });
	      _this.props.dispatch(ui.hideControls());
	    };
	
	    _this.handleCancelExperience = function () {
	      _this.setState({ selectedClientId: null }, function () {
	        return _this.props.updateTempState('' + _this.props.model, '', null, {});
	      });
	      _this.props.dispatch(ui.showControls());
	    };
	
	    _this.handleSave = function (clientId) {
	      if (_this.props.onSave()) {
	        _this.setState({ selectedClientId: null });
	        _this.props.dispatch(ui.showControls());
	      } else {
	        _this.setState({ showErrors: true });
	      }
	    };
	
	    _this.handleSaveExperience = function (clientId) {
	      return function () {
	        (0, _lodash.debounce)(_this.handleSave(clientId), 200);
	      };
	    };
	
	    _this.handleAddExperience = function () {
	      _this.addListItem(_this.handleClickExperience);
	    };
	
	    _this.handleRemoveExperience = function (clientId) {
	      return function () {
	        _this.removeListItem(clientId);
	        _this.props.dispatch(ui.showControls());
	      };
	    };
	
	    _this.state = {
	      has25ExperienceYears: false,
	      selectedClientId: null,
	      showErrors: false
	    };
	    return _this;
	  }
	
	  _createClass(WorkExperience, [{
	    key: 'handleTextAreaUI',
	    value: function handleTextAreaUI(prop) {
	      var _this2 = this;
	
	      return {
	        // need to replace '\n' with actual newline
	        defaultValue: (this.props.profile[prop] || ' ').replace(newLine, '\n'),
	        onBlur: function onBlur(event, val) {
	          return _this2.updateTempState('profile', 'careerSummary', event, val || ' ');
	        }
	      };
	    }
	  }, {
	    key: 'parseDate',
	    value: function parseDate(dateString) {
	      var dateArray = dateString.split('/');
	      var test = new Date(dateArray[1], dateArray[0] - 1);
	      return test;
	    }
	
	    // Override ValidatedForm.validateForm()
	
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var isValid = (0, _lodash.filter)(this.refs, function (ref) {
	        return ref.getWrappedInstance().validateForm;
	      }).reduce(function (valid, section, index) {
	        return section.getWrappedInstance().validateForm() && valid;
	      }, true);
	      return isValid;
	    }
	  }, {
	    key: 'getLabel',
	    value: function getLabel(name) {
	      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      return (0, _lodash.get)(this.props, 'labels.' + name, defaultValue);
	    }
	  }, {
	    key: 'renderAdminAccordion',
	    value: function renderAdminAccordion(workExperiences) {
	      var _this3 = this;
	
	      if (!workExperiences.length) {
	        return;
	      }
	
	      workExperiences = (0, _lodash.orderBy)(workExperiences, ['current', 'employmentEnd', 'employmentStart'], ['desc', 'desc', 'desc']);
	      return _react2.default.createElement(
	        _AccordionList2.default,
	        null,
	        workExperiences.map(function (experience, index, arr) {
	          return _react2.default.createElement(
	            _AccordionList.AccordionListItem,
	            {
	              key: experience.clientId,
	              showCheckMark: false,
	              toggleOpenedText: 'Close',
	              hideAllOnOpen: false,
	              title: _react2.default.createElement(
	                'div',
	                { 'data-id': experience.employerName,
	                  className: 'experience-header' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text' },
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    experience.employerName,
	                    '. '
	                  ),
	                  experience.title,
	                  '. (',
	                  (0, _prettyDate.resumeDate)(experience.employmentStart),
	                  ' - ',
	                  experience.current ? 'Current' : (0, _prettyDate.resumeDate)(experience.employmentEnd),
	                  ')'
	                )
	              )
	            },
	            _react2.default.createElement(_Experience2.default, {
	              ref: experience.clientId,
	              index: index,
	              experience: experience,
	              tempState: _this3.props.tempState,
	              model: _this3.props.model,
	              onChange: _this3.onChange.bind(_this3),
	              removeListItem: _this3.handleRemoveExperience(experience.clientId),
	              showRemove: arr.length > 1,
	              staticData: _this3.props.staticData,
	              updateTempState: _this3.props.updateTempState,
	              validation: _this3.props.validation,
	              validateUpdate: _this3.validateUpdate,
	              adminView: _this3.props.adminView,
	              submitted: _this3.props.submitted
	            })
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderRegularList',
	    value: function renderRegularList(workExperiences) {
	      var _this4 = this;
	
	      workExperiences = (0, _lodash.orderBy)(workExperiences, ['current', 'employmentEnd', 'employmentStart'], ['desc', 'desc', 'desc']);
	      return _react2.default.createElement(
	        'div',
	        { className: 'accordion-container' },
	        workExperiences.map(function (experience, index, arr) {
	          return _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('accordion-panel-container', { 'applicant-view': !_this4.props.adminView }) },
	            _react2.default.createElement(
	              'div',
	              { className: 'accordion-panel-header', onClick: _this4.handleClickExperience.bind(_this4, experience.clientId) },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                _react2.default.createElement(
	                  'div',
	                  { 'data-id': experience.employerName,
	                    className: 'experience-header' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text' },
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      experience.employerName,
	                      '. '
	                    ),
	                    experience.title,
	                    '. (',
	                    (0, _prettyDate.resumeDate)(experience.employmentStart),
	                    ' - ',
	                    experience.current ? 'Current' : (0, _prettyDate.resumeDate)(experience.employmentEnd),
	                    ')'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'accordion-toggle' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'accordion-toggle-text noTextSelect' },
	                    'View'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'accordion-caret-container' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'accordion-toggle-caret chevron toggled' },
	                    _react2.default.createElement(_ChevronIcon2.default, null)
	                  )
	                )
	              )
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var workExperiences = (0, _lodash.filter)((0, _lodash.merge)({}, this.props[this.props.model], this.props.tempState[this.props.model]), function (exp) {
	        return exp !== Symbol.for('__delete');
	      });
	      var selectedExperience = (0, _lodash.find)(workExperiences, function (w) {
	        return w.clientId === _this5.state.selectedClientId;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('application-section-container expanded-accordion-content clearfix') },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          this.formHeading
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-text' },
	          this.props.adminView && this.props.script && _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            adminScript
	          ),
	          !this.props.adminView && !this.props.submitted && this.formInstructions
	        ),
	        this.props.adminView && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', className: 'view-resume-btn', href: '/admin/Qualified/' + this.props.profile.id + '/Profile/resume' },
	            _react2.default.createElement(_c_FlatButton2.default, { className: 'view-resume-btn',
	              label: 'View Resume',
	              style: {
	                display: 'block',
	                width: 'auto',
	                margin: '50px auto'
	              } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'career-summary-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              'Career Summary'
	            ),
	            _react2.default.createElement(_c_TextArea2.default, _extends({
	              className: 'career-summary-text',
	              'data-id': 'Career Summary textarea',
	              maxLength: 800,
	              showCharacterCount: true,
	              capitalizedSentences: true,
	              exampleText: 'Seasoned insurance professional with over twenty-five years of property and casualty ' + 'insurance brokerage experience servicing and managing mid-commercial accounts. Proficient in all ' + 'lines of coverage with a specialty in large real estate accounts. Effectively managed client ' + 'expectations, building and maintaining strong, positive relationships with clients and ' + 'underwriters. Successfully upsold and cross-sold policies to improve clients’ insurance ' + 'programs. Managed multiple priorities, delivering timely and accurate work products with ' + 'a customer service and client retention focus. Developed strong computer skills and the ' + 'ability to navigate through multiple systems. Have focused on professional growth throughout ' + 'my career including obtaining the CIC designation.'
	            }, this.handleTextAreaUI('careerSummary')))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'work-experience-container' },
	          this.props.adminView ? this.renderAdminAccordion(workExperiences) : selectedExperience ? null : this.renderRegularList(workExperiences),
	          selectedExperience && _react2.default.createElement(_Experience2.default, {
	            key: selectedExperience.clientId,
	            ref: selectedExperience.clientId,
	            index: -1,
	            experience: selectedExperience,
	            model: this.props.model,
	            onChange: this.onChange.bind(this),
	            removeListItem: this.handleRemoveExperience(selectedExperience.clientId),
	            saveListItem: this.handleSaveExperience(selectedExperience.clientId),
	            showRemove: false,
	            staticData: this.props.staticData,
	            updateTempState: this.props.updateTempState,
	            handleCancelExperience: this.handleCancelExperience,
	            validation: this.props.validation,
	            validateUpdate: this.validateUpdate,
	            submitted: this.props.submitted,
	            showErrors: this.state.showErrors
	          }),
	          !selectedExperience && _react2.default.createElement(_c_FlatButton2.default, {
	            onClick: this.handleAddExperience,
	            className: 'add-new-experience',
	            label: 'Add Employer',
	            style: {
	              display: 'inline-block',
	              width: '296px',
	              height: '41px',
	              fontSize: '12px',
	              paddingLeft: '30px',
	              paddingRight: '30px',
	              backgroundColor: '#2eb0e3',
	              boxShadow: '0 2px 1px 0 rgba(0,0,0,.41), 0 0 2px 0 rgba(0,0,0,.12)',
	              borderRadius: '2px',
	              border: '0',
	              color: '#ffffff'
	            },
	            hoverStyle: {
	              color: '#ffffff'
	            }
	          })
	        ),
	        this.props.adminView && _react2.default.createElement(
	          'div',
	          { className: 'explanation-of-wahve' },
	          _react2.default.createElement(
	            'div',
	            { className: 'callout above-form-contents' },
	            this.adminInstructions,
	            _react2.default.createElement(
	              'ol',
	              { className: 'instructions-list work-experience-instructions' },
	              this.adminItems.map(function (item, index) {
	                return _react2.default.createElement(
	                  'li',
	                  { className: 'instructions-list-item', key: index },
	                  item,
	                  index === 0 && _this5.props.script && _react2.default.createElement(
	                    'div',
	                    { className: 'speaking-callout' },
	                    'After we complete this interview, you will need to log back into your record and correct your application so that the resume is accurate.'
	                  ),
	                  index === 1 && _react2.default.createElement(
	                    'div',
	                    { className: 'questions' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'title' },
	                      'Please explain the gap as it is helpful to us if client asks us about it?'
	                    ),
	                    _react2.default.createElement(_c_TextArea2.default, _extends({
	                      'data-id': 'Please explain the gap as it is helpful to us if client asks us about it?'
	                    }, _this5.adminQuestionProperties('profile', 'gapExplanation', 'Please explain the gap as it is helpful to us if client asks us about it?')))
	                  ),
	                  index === 2 && _react2.default.createElement(
	                    'div',
	                    { className: 'questions' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'title' },
	                      'What have you been doing to stay current?'
	                    ),
	                    _react2.default.createElement(_c_TextArea2.default, _extends({
	                      'data-id': 'What have you been doing to stay current?'
	                    }, _this5.adminQuestionProperties('profile', 'howStayedCurrentWithWork', 'What have you been doing to stay current?'))),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'title' },
	                      'Have you been doing any type of work?'
	                    ),
	                    _react2.default.createElement(_c_TextArea2.default, _extends({
	                      'data-id': 'Have you been doing any type of work?'
	                    }, _this5.adminQuestionProperties('profile', 'doingAnyTypeOfWork', 'Have you been doing any type of work?')))
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'newExperience',
	    get: function get() {
	      return {
	        isNew: true,
	        clientId: this.newClientId
	      };
	    }
	  }, {
	    key: 'newClientId',
	    get: function get() {
	      return '' + this.getIncrementedChar() + _shortid2.default.generate();
	    }
	  }, {
	    key: 'formHeading',
	    get: function get() {
	      return this.getLabel('formHeading', formHeading);
	    }
	  }, {
	    key: 'formInstructions',
	    get: function get() {
	      return this.getLabel('formInstructions', formText);
	    }
	  }, {
	    key: 'adminScript',
	    get: function get() {
	      return this.getLabel('adminScript', adminScript);
	    }
	  }, {
	    key: 'adminInstructions',
	    get: function get() {
	      return this.getLabel('adminInstructions', adminInstructions);
	    }
	  }, {
	    key: 'adminItems',
	    get: function get() {
	      return this.getLabel('adminItems', adminInstrutionsItems);
	    }
	  }]);
	
	  return WorkExperience;
	}(_C_ProgressComponentList2.default), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  workExperiences: _react.PropTypes.object.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  profileId: _react.PropTypes.number.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired,
	  onSave: _react.PropTypes.func.isRequired,
	  setErrorMessage: _react.PropTypes.func.isRequired,
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = WorkExperience;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// class name
	// import cx from 'classnames';
	
	// import static dropdown data
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _hoursPerWeekList = __webpack_require__(872);
	
	var _hoursPerWeekList2 = _interopRequireDefault(_hoursPerWeekList);
	
	var _hoursPerDayList = __webpack_require__(871);
	
	var _hoursPerDayList2 = _interopRequireDefault(_hoursPerDayList);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var yesNo = [{ value: true, primaryText: 'Yes', subElement: 'localJobDetails' }, { value: false, primaryText: 'No', subElement: null }];
	
	var dropDownCustomization = {
	  labelStyle: {
	    padding: 0,
	    margin: 0,
	    maxWidth: '90%'
	  },
	  underlineStyle: {
	    marginLeft: 0
	  },
	  containerStyle: {
	    margin: '30px 0 10px 45px'
	  },
	  floatingLabelStyle: {
	    left: 0
	  }
	};
	
	var AvailabilityInformation = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.AvailabilityInformation', {})
	  };
	}, undefined, undefined, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(AvailabilityInformation, _ProgressComponent);
	
	  function AvailabilityInformation(props) {
	    _classCallCheck(this, AvailabilityInformation);
	
	    var _this = _possibleConstructorReturn(this, (AvailabilityInformation.__proto__ || Object.getPrototypeOf(AvailabilityInformation)).call(this, props));
	
	    _this.handleDatePickerUI = _this.handleDatePickerUI.bind(_this);
	    _this.handleDropDownMenuUI = _this.handleDropDownMenuUI.bind(_this);
	    _this.handleDropDownMenuStaticUI = _this.handleDropDownMenuStaticUI.bind(_this);
	
	    _this.state = {
	      validation: Object.assign({}, (0, _lodash.pick)(props.validation, ['availabilityHoursPerDay', 'availabilityHoursPerWeek', 'workDays', 'availabilityDate']))
	    };
	    return _this;
	  }
	
	  _createClass(AvailabilityInformation, [{
	    key: 'handleDatePickerUI',
	    value: function handleDatePickerUI(prop, label) {
	      return {
	        'data-id': prop,
	        defaultValue: this.props.profile[prop],
	        separatedFloatingText: label,
	        isDirty: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]') ? true : false,
	        errorText: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]'),
	        onErrorChange: this.props.errorUpdate,
	        onBlur: this.validateUpdate(this.props.model, prop, this.updateTempState)
	      };
	    }
	  }, {
	    key: 'handleDropDownMenuUI',
	    value: function handleDropDownMenuUI(prop, staticDataProp, label) {
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        menuItems: this.props.staticData[staticDataProp],
	        floatingLabelText: label,
	        errorText: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]'),
	        onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
	      };
	    }
	  }, {
	    key: 'handleDropDownMenuStaticUI',
	    value: function handleDropDownMenuStaticUI(prop, staticData, label) {
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        menuItems: staticData,
	        floatingLabelText: label,
	        errorText: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]'),
	        onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
	      };
	    }
	  }, {
	    key: 'toggleButtonProperties',
	    value: function toggleButtonProperties(prop, staticData, label) {
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        menuItems: yesNo,
	        floatingLabelText: label,
	        validation: this.props.validation[prop],
	        onErrorChange: this.props.errorUpdate,
	        onChange: this.updateTempState.bind(this, this.props.model, prop)
	      };
	    }
	  }, {
	    key: 'textFieldProperties',
	    value: function textFieldProperties(prop, label) {
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        value: (0, _lodash.get)(this.props, 'tempState.profile.' + prop + ']', null),
	        floatingLabelText: label,
	        validation: this.props.validation[prop],
	        onBlur: this.updateTempState.bind(this, this.props.model, prop)
	      };
	    }
	  }, {
	    key: 'textAreaProperties',
	    value: function textAreaProperties(prop, label) {
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        validation: this.props.validation[prop],
	        onErrorChange: this.props.errorUpdate,
	        onBlur: this.updateTempState.bind(this, this.props.model, prop)
	      };
	    }
	  }, {
	    key: 'dateDifference',
	    value: function dateDifference(availability) {
	      var startDate = new Date(availability);
	      var now = new Date();
	      return (startDate.getFullYear() - now.getFullYear()) * 12 + (startDate.getMonth() - now.getMonth());
	    }
	  }, {
	    key: 'genFakeDropdown',
	    value: function genFakeDropdown(str) {
	      return {
	        value: str,
	        menuItems: [str],
	        disabled: true
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var localJob = (0, _lodash.get)(this.props.tempState, 'profile.localJob', this.props.profile.localJob);
	      // Employed or Phasing into Retirement.
	      var employed = this.props.profile.employmentStatus.id === 1 || this.props.profile.employmentStatus.id === 4;
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container expanded-accordion-content availability-information clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          'Availability Information'
	        ),
	        this.props.script && this.props.adminView && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            this.props.labels.speakingCallout
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'availability-info-form-contents' },
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_DateInput2.default, _extends({
	              'data-id': 'availability-date-icon',
	              autoOk: true,
	              dataId: 'availability Date',
	              minDate: new Date()
	            }, this.textFieldProperties('availabilityDate', 'Availability Date')))
	          ),
	          this.props.adminView && _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'Employment status',
	              'data-id': 'employement status'
	            }, this.genFakeDropdown(this.props.profile.employmentStatus.name), dropDownCustomization))
	          ),
	          this.props.script && this.props.adminView && (this.dateDifference((0, _lodash.get)(this.props.tempState, 'profile.availabilityDate', 0)) > 4 || this.dateDifference(this.props.profile.availabilityDate) > 4) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'instructions-list' },
	              _react2.default.createElement(
	                'li',
	                null,
	                'It is too soon for the interview.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'When your availability is within 4 month, I will contact you to update your application and will call you to complete the application interview.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'speaking-callout' },
	              'Change the Status to \u201CApplicant in Waiting.\u201D'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropDownMenuStaticUI('availabilityHoursPerWeek', _hoursPerWeekList2.default, 'How many hours per week would you prefer to work?'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropDownMenuStaticUI('availabilityHoursPerDay', _hoursPerDayList2.default, 'How many hours per day?'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_CheckList2.default, _extends({
	              canAutoPosition: 'true'
	            }, this.handleDropDownMenuUI('workDays', 'dayAvailableTypes', 'Days of the week?')))
	          ),
	          this.props.adminView && _react2.default.createElement(
	            _c_ToggleButton2.default,
	            _extends({
	              className: 'local-job'
	            }, this.toggleButtonProperties('localJob', yesNo, 'Are you also looking for a job locally?')),
	            {
	              localJobDetails: _react2.default.createElement(_c_TextArea2.default, _extends({
	                description: 'If yes, explain:'
	              }, this.textAreaProperties('localJobDetails', 'If yes, explain:')))
	            }
	          ),
	          this.props.script && this.props.adminView && !!employed && _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            'Since you are still working, we want you to understand we cannot take responsibility if you leave your current job or guarantee that we can place you quickly with one of our clients. If we do find a placement for you, you must agree to give two weeks\' notice.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AvailabilityInformation;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  adminView: _react.PropTypes.bool.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired,
	  script: _react.PropTypes.bool
	}, _class2.defaultProps = {
	  profile: {}
	}, _temp)) || _class);
	exports.default = AvailabilityInformation;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeOfficeSetup = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.HomeOfficeSetup', {})
	  };
	}, undefined, undefined, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(HomeOfficeSetup, _ProgressComponent);
	
	  function HomeOfficeSetup(props, context) {
	    _classCallCheck(this, HomeOfficeSetup);
	
	    var _this = _possibleConstructorReturn(this, (HomeOfficeSetup.__proto__ || Object.getPrototypeOf(HomeOfficeSetup)).call(this, props, context));
	
	    _this.handleDropDownMenuUI = _this.handleDropDownMenuUI.bind(_this);
	    _this.handleDropDownMenuStaticUI = _this.handleDropDownMenuStaticUI.bind(_this);
	
	    _this.state = {
	      validation: Object.assign(_this.CustomValidation, (0, _lodash.pick)(props.validation, ['hasDedicatedHomeOffice', 'computerTypeId', 'computerOperatingSystemId', 'hasHighSpeedInternet', 'canUpgradeTechnology']))
	    };
	
	    return _this;
	  }
	
	  _createClass(HomeOfficeSetup, [{
	    key: 'handleDropDownMenuUI',
	    value: function handleDropDownMenuUI(prop, staticDataProp, label) {
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        menuItems: this.props.staticData[staticDataProp],
	        floatingLabelText: label,
	        errorText: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]'),
	        onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
	      };
	    }
	  }, {
	    key: 'handleDropDownMenuStaticUI',
	    value: function handleDropDownMenuStaticUI(prop, staticData, label) {
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        menuItems: staticData,
	        floatingLabelText: label,
	        errorText: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]'),
	        onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container expanded-accordion-content clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          'Home Office Setup'
	        ),
	        this.props.adminView && _react2.default.createElement(
	          'div',
	          { className: 'callout' },
	          'Instructions: The questions in this section were asked on the application.'
	        ),
	        this.props.adminView && this.props.script && _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          this.props.labels.speakingCallout,
	          (!(0, _lodash.isNil)((0, _lodash.get)(this.props.tempState, 'profile.computerOperatingSystemId')) ? (0, _lodash.get)(this.props.tempState, 'profile.computerOperatingSystemId') === 2 : this.props.profile.computerOperatingSystemId === 2) && _react2.default.createElement(
	            'p',
	            null,
	            'You may need to purchase a PC, which costs about $350 as most systems do not have remote work capabilities with Apple products.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-contents home-office-form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_ToggleButton2.default, this.handleDropDownMenuStaticUI('hasDedicatedHomeOffice', this.booleanDropDown, 'Do you have an area in your home that can be setup as a dedicated, noise free home office?'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_ToggleButton2.default, this.handleDropDownMenuUI('computerTypeId', 'computerTypes', 'What type of computer do you have?'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_ToggleButton2.default, this.handleDropDownMenuUI('computerOperatingSystemId', 'operatingSystemTypes', 'Is your computer a PC or a Mac?'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_ToggleButton2.default, this.handleDropDownMenuStaticUI('canUpgradeTechnology', this.booleanDropDown, 'If your computer and/or internet connections do not meet the requirements for remote work, would you be willing to upgrade and purchase the necessary technology?'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_ToggleButton2.default, _extends({
	              className: 'high-speed-internet'
	            }, this.handleDropDownMenuStaticUI('hasHighSpeedInternet', this.booleanDropDown, 'Do you have a high-speed internet connection?')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            (!(0, _lodash.isNil)((0, _lodash.get)(this.props.tempState, 'profile.hasHighSpeedInternet')) ? (0, _lodash.get)(this.props.tempState, 'profile.hasHighSpeedInternet') === true : this.props.profile.hasHighSpeedInternet === true) && _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              canAutoPosition: 'true',
	              className: 'internet-type'
	            }, this.handleDropDownMenuUI('internetTypeId', 'internetTypes', 'What is your high-speed internet service type?')))
	          )
	        )
	      );
	    }
	  }, {
	    key: 'CustomValidation',
	    get: function get() {
	      var comp = this;
	      var CustomValidator = function CustomValidator() {
	        var model = function model() {
	          return Object.assign({}, (0, _lodash.get)(comp, 'props.profile'), (0, _lodash.get)(comp, 'props.tempState[' + comp.props.model + ']'));
	        };
	        this.internetTypeId = {
	          custom: {
	            func: function func(val) {
	              return (0, _lodash.isNil)(model().hasHighSpeedInternet) || !model().hasHighSpeedInternet || val;
	            },
	            message: 'This field is required.'
	          }
	        };
	      };
	
	      return new CustomValidator();
	    }
	  }]);
	
	  return HomeOfficeSetup;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  profile: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired
	}, _class2.defaultProps = {
	  profile: {}
	}, _temp)) || _class);
	exports.default = HomeOfficeSetup;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(51);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _index = __webpack_require__(211);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicantTerms = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			user: state.user,
			profile: state.applicantProfile,
			tempState: state.tempState,
			staticData: state.staticData,
			skills: state.skills
		};
	}, {
		push: _reactRouterRedux.push
	}), _dec(_class = (_temp = _class2 = function (_Component) {
		_inherits(ApplicantTerms, _Component);
	
		function ApplicantTerms(props, context) {
			_classCallCheck(this, ApplicantTerms);
	
			var _this = _possibleConstructorReturn(this, (ApplicantTerms.__proto__ || Object.getPrototypeOf(ApplicantTerms)).call(this, props, context));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(ApplicantTerms, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'prelim-application' },
					_react2.default.createElement(
						'div',
						{ className: 'header' },
						_react2.default.createElement(
							'span',
							{ 'data-id': 'Title Text' },
							'Privacy Policy'
						),
						_react2.default.createElement(
							'span',
							{ className: 'login', 'data-id': 'Login Text' },
							'Returning applicant? Please\xA0',
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/login', className: 'link login-link', 'data-id': 'Login Link' },
								'sign in'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'application-section-container applicant-assessment-container applicant-terms clearfix' },
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'Welcome. The information below explains how Work At Home Vintage Experts LLC (the \u201CCompany\u201D) collects, uses, and discloses information collected via our website, located at www.wahve.com (the \u201CWebsite\u201D). By ensuring that you are aware of and understand our Privacy Notice, we can provide you with better service. Please take a moment to read the following notice to learn how we handle your personal information.\n\t\t\t\t\t\t\t'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'The Company ("we" or "us" or \u201Cour\u201D) understands that individuals and companies with whom we conduct business, and who share their information with us, value their privacy. We are committed to taking reasonable steps to protect your privacy online and manage your information responsibly. This Privacy Notice is intended to notify you of our online privacy practices, the type of information that may be collected and stored, how the information is used, with whom the information may be shared, what choices are available to you regarding the collection, use and distribution of the information, what kind of security procedures are in place to protect the loss, misuse or alteration of information under our control, and who to contact with questions or concerns.\n\t\t\t\t\t\t\t\t\t\t\t'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'By using the Website and/or by contacting us and providing any personal information, you consent to the collection, transfer, storage, disclosure and use of information by us in accordance with this Privacy Notice. If we decide to change our Privacy Notice, we will post those changes on this page.\n\t\t\t\t\t\t\t\t\t\t\t\tWhy We Collect Information'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Why We Collect Information.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We collect personal information because it helps us connect with clients and vintage professionals, as well as deliver our services. For example, if you apply to become a wahve, we need to have information such as your contact information, employment status, work experience and other information about your availability in order to determine whether you are a good fit for us. We also may correlate your personal information obtained from you with information from other sources. For example, if you provide us with your personal information as part of an application process, we may cross-check that against information that might be otherwise available through other entities for verification and quality control purposes.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'What Information We Collect.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'The following generally describes the type of information we may collect about you. Those who wish to communicate with us but do not wish to provide personally identifiable information online may contact us through the address or phone numbers provided on our Website. However, you should note that if you contact us by phone or via postal mail, you may still be submitting personally identifiable information to us.\n\t\t\t\t\t\t\tIf you apply to be a wahve, we will request your name, phone number, email address and information about your work experience, educational background, skills, licenses and designations, professional associations, availability and other background information. We will not share this information with any prospective employers without your permission.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'If you are interested in hiring one or more of our wahves, we will collect certain information, such as your name, email address, phone number, tax information and certain technical information pertaining to your company\u2019s computer systems.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'How We Collect Information'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We collect information in three primary ways:'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'p',
								null,
								'1. You Give Us Information: We collect information from you when you submit it to us through our Website or via electronic mail, telephone or facsimile.'
							),
							_react2.default.createElement(
								'p',
								null,
								'2. We Collect Information Automatically: We automatically collect certain types of information when you visit our Website. For example, we automatically collect various types of technical information when you use our Website as otherwise described in this Privacy Notice.'
							),
							_react2.default.createElement(
								'p',
								null,
								'3. We Collect Information from Other Sources: We may obtain information about you from outside sources. For example, we may obtain commercially available information about you from third parties or purchase e-mail lists from third parties for advertising and marketing purposes. We may also receive information from third-parties who provide services for us through web-beacons and other technologies as otherwise discussed in this Privacy Notice. '
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Information You Submit To Us'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We do not automatically collect personally identifiable information unless you voluntarily input this information, such as during a registration or application process, when you submit questions or comments, request information or enter into an agreement with us. Should you voluntarily provide us with personally identifiable information, you consent to our use of it in accordance with this Privacy Notice.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Information Collected During General Browsing'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'Even if you do not submit personal information through the Website, we gather navigational information about where visitors go on the Website and information about the technical efficiencies of our Website and services (i.e., time to connect to the Website, time to download pages, etc.). This information allows us to see which areas of our Website are most visited and helps us better understand the user experience. This information also helps us improve the quality of the Website by recognizing and delivering more of the features, areas, and services our visitors prefer. In this process of gathering information, we may collect personally identifiable and non-personally identifiable information (for example, domain type, browser type and version, service provider and IP address, referring/exit pages, operating system, date/time stamp, and click-stream data). We may also create and use electronic records to compile statistics about how our visitors collectively interact with our Website.',
							_react2.default.createElement(
								'p',
								null,
								'1. Use of Cookies'
							),
							_react2.default.createElement(
								'p',
								null,
								'Cookies are bits of electronic information that a website may transfer to a visitor\u2019s computer to identify specific information about the visitor\u2019s visits to the website. The Website uses a browser feature known as a cookie, which assigns a unique identification to your computer. Cookies are typically stored on your computer\u2019s hard drive and are used to help track clicks as you go through the pages within our Website. We may also use cookies to tell us whether you have previously visited the Website. We also use cookies which may be set by third-parties with whom we have entered into agreements which may enable us to obtain analytics information about the use of our Website. You can set your browser not to accept cookies or to notify you when you are sent a cookie, giving you the opportunity to decide whether or not to accept it. You may also use commonly available tools in your browser to remove cookies which may have been placed onto your computer. Shared local objects (commonly referred to as \u201CFLASH cookies\u201D) are cookies that are placed on your computer that are not removed through normal browser management tools. We will not use FLASH cookies in a manner inconsistent with the purposes for which they were designed unless you are specifically notified that we intend to use them for a specific service. '
							),
							_react2.default.createElement(
								'p',
								null,
								'2. Use of Web Beacons, Clear-GIFs, Pixel Tags and JavaScript'
							),
							_react2.default.createElement(
								'p',
								null,
								'We also may use "pixel tags" (also called \u201Caction pixels,\u201D "web beacons" or "clear gifs") and/or JavaScript plug-ins, placed on our Website and in our emails to you. These web beacons and plug-ins are small graphic images (typically that you cannot see) or code on a website or in an email message which are used for such things as recording webpages and advertisements clicked-on by a user, or for tracking the performance of email marketing campaigns. These devices help us analyze our users\u2019 online behavior and measure the effectiveness of our website and our marketing. We also work with third-party service providers that help us track, collect, and analyze this information. Third-party entities with whom we have agreements may place these devices on the website and/or in emails to use information obtained from them such as pages viewed, items purchased, emails opened and items upon which you may click in emails. These third-party providers may also place cookies onto your computer. Those third-party cookies may enable us to obtain aggregate demographic information and user statistics about you and your preferences from these third-party sources as well as our information we have about you. '
							),
							_react2.default.createElement(
								'p',
								null,
								'3. Server Logs'
							),
							_react2.default.createElement(
								'p',
								null,
								'A web \u201Cserver log\u201D is a record of activity created by a computer that delivers certain webpages to your browser. Certain activities that you perform on our Website may record information in server logs. For example, if you enter a search term into a search box located on the Website, the server log may record the search term, the link you clicked on to bring you to our Website and/or information about your browser, such as your IP address and the cookies set on your browser. '
							),
							_react2.default.createElement(
								'p',
								null,
								'4. Search Queries on Our Website'
							),
							_react2.default.createElement(
								'p',
								null,
								'We may provide you with options to search for information on our Website. If you enter information in a search query box, we may store that information and we may aggregate that information with other information we may have about the browser and/or IP address from which the search query originated. '
							),
							_react2.default.createElement(
								'p',
								null,
								'5. Surveys '
							),
							_react2.default.createElement(
								'p',
								null,
								'From time to time, we may request information from users via surveys. Participation in these surveys or contests is completely voluntary and the user therefore has a choice whether or not to disclose any information to us. Information requested may include contact information, demographic information and other personal information. The aggregate, non-personally identifiable information collected from all survey respondents may be shared with third-parties who sponsor such surveys. If your information gathered via a survey will be used in a manner different from that described in this Privacy Notice, such use will be detailed in the survey instructions. '
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'How We Use the Information We Collect'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We use the information we collect in a variety of ways. Generally, using all of the above mentioned, and similar type tools, we may collect, aggregate, and use information from or about you such as data about the type of browser and operating system used, your geographical location, which webpages you view, the time and duration of your visits to our Website, the search queries you may use on this Website and any other submissions you may make, whether you clicked on any items or links on the Website, whether you have clicked on any links in any emails sent from us, or third-parties on our behalf, whether you have chosen to opt-out of certain services or information sharing, and whether you have viewed or ordered certain products or services. We use the information we collect internally in our business for many business purposes, such as to:  provide the Website; (ii) analyze trends and conduct research about improving our offerings; (iii) provide support and respond to questions from wahves, Website visitors and customers; (iv) improve our Website, products or services; (v) learn about users\u2019 and customers\u2019 needs; (vi) contact users for research, informational, and marketing purposes, including customizing our Website for you based upon your information and browsing habits; (vii) track traffic patterns and Website usage; (viii) enable online job requests and provide customer service and technical support with respect to such requests; (ix) correlate information with other commercially available information to identify demographics and preferences to assist us and our customers in our research and marketing efforts;  provide specific relevant marketing, promotional, or other information to you; (xi) address information security and/or privacy practices, network functioning, engineering, and troubleshooting issues; (xii) investigate claims and/or legal actions, violations of law or agreements, and compliance with relevant applicable laws and legal process; (xiii) comply with law, or based on our good faith belief that it is necessary to conform or comply with the law, or otherwise to disclose information to prevent fraud, to cooperate with police and other governmental authorities, or to protect the rights, property or safety of visitors to the Website, our partners or customers, or the public; and (xiv) process or engage in a sale of all or part of our business, or if we go through a reorganization or merger. We may also share personally identifiable information and non-personally identifiable information externally with our affiliates and business partners, as well as with other third-party service providers who help us provide operational services for the Website and our business, which might include, but is not necessarily limited to: business entities that provide e-mail address management and communication contact services, network equipment and application management providers and hosting entities, credit and debit card payment gateways and processors and the issuing and acquiring banks involved in the funds settlement procedures necessary to charge your cards or financial accounts, entities which obtain information such as demographic information which might be aggregated with information we have about you, judicial, administrative and/or legal or financial accounting providers in the event that information must be reviewed or released in response to civil and/or criminal investigations, claims, lawsuits, or if we are subject to judicial or administrative process (such as a subpoena) to release your information or to prosecute or defend legal actions, and other service providers which may be involved in the other types of services and activities otherwise discussed in this Privacy Notice.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We may also use your personally identifiable information to contact you in ways other than e-mail or regular mail, such as via telephone contact or facsimile. All use of personally identifiable information will be as permitted by applicable law.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Business Transfers'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'If Company or substantially all of its assets were acquired, or in the unlikely event that Company goes out of business or enters bankruptcy, user information would be one of the assets that is transferred or acquired by a third party. You acknowledge that such transfers may occur, and that any acquirer of Company may continue to use your personal information as set forth in this Privacy Notice.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Your Choices about the Information We Collect'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'If you do not consent to the way in which we may use your personal information, please do not submit any personal information to us.  If you do not wish to receive emails about special offers and other promotions from us, click the unsubscribe link located in our emails or opt out in your account profile.  If you do not wish to receive other marketing materials from us and/or if you do not want us to share your personal information with other entities as stated in this Privacy Notice, please provide us with your exact name and address and advise us that you wish to opt-out for information sharing or receiving information from us or both as the case may be.  Please note that de-identified and aggregate data including your personal information may still be shared, but it will not be identified or identifiable to you. Please direct your opt-out request to the following contacts:',
							_react2.default.createElement('br', null),
							' E-mail Address:',
							_react2.default.createElement('br', null),
							'  info@wahve.com',
							_react2.default.createElement('br', null),
							' Postal Address:',
							_react2.default.createElement('br', null),
							'   Work At Home Vintage Experts LLC',
							_react2.default.createElement('br', null),
							' 1180 Town Center Drive #100',
							_react2.default.createElement('br', null),
							'  Las Vegas NV 89144'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Privacy of Children Who Visit the Website'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We recognize the importance of children\'s safety and privacy. The Website is not designed to attract children, and is not intended for use by any children under the age of 18. We do not request, or knowingly collect, any personally identifiable information from children under the age of 18.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Your California Privacy Rights'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We collect various types of personal information about you during the course of your relationship with us. Under California law, if you are a resident of California, you may make a written request to us about how we have shared your information with third parties for their direct marketing purposes. In response to your written request, we are allowed to provide you with a notice describing the cost-free means to opt-out of our sharing your information with third parties with whom we do not share the same brand name, if the third party will use such information for its direct marketing purposes. If you would like to exercise your rights under California law, please send your written request to the e-mail address or postal address below. Please include your postal address in your request. Within thirty (30) days of receiving your written request, we will provide you with a Third Party Direct Marketing Opt-Out Form so you may request that your personal information not be disclosed to third parties for their direct marketing purposes.',
							_react2.default.createElement('br', null),
							' E-mail Address:',
							_react2.default.createElement('br', null),
							' info@wahve.com',
							_react2.default.createElement('br', null),
							'  Postal Address:',
							_react2.default.createElement('br', null),
							'    Work At Home Vintage Experts LLC',
							_react2.default.createElement('br', null),
							'   1180 Town Center Drive #100',
							_react2.default.createElement('br', null),
							'    Las Vegas NV 89144'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Visitors to the Website Outside of the United States'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'If you are visiting the Website from a location outside of the United States, your connection will be through and to servers located in the United States. All information you receive from the Website will be created on servers located in the United States, and all information you provide will be maintained on web servers and systems located within the United States. The data protection laws in the United States and other countries might not be as those in your country.  By using this Website and/or submitting information to us, you specifically consent to the transfer of your information to the United States to the facilities and servers we use, and to those with whom we may share your information.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Updating Personal Information'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We prefer to keep your personal information accurate and up-to-date. If you would like to change your contact information, please send an email to info@wahve.com.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Links'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'For your convenience, the Website may contain links to other websites.  We are not responsible for the privacy practices, advertising, products, or the content of such other websites. None of the links should be deemed to imply that we endorse or have any affiliation with the links.'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							_react2.default.createElement(
								'b',
								null,
								'Security'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'We believe in providing a safe and secure experience for all of our online visitors. To that end, we have implemented security measures to protect the information collected from you. We maintain reasonable physical and electronic safeguards designed to limit unauthorized access to your personally identifiable information, and to protect you against the criminal misuse of that information. We use data encryption technology when transferring and receiving your sensitive personal information, such as during an application process. For example, in your transactions submitted by you through the website, a solid key icon or a locked padlock icon at the lower portion of your web browser window confirms the Website is secured through Secure Sockets Layer (SSL). Pages requesting personal information should always have one of these icons. You can also confirm your data is being encrypted by looking at the URL line of your browser (the place where you type website addresses). When accessing a secure server, the Website address will change from "http" to "https".'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-text example-text' },
							'While we use the foregoing security measures to protect your information, please note that no data transmitted over the Internet or stored and utilized for business purposes can be guaranteed to be completely secure.  No security measures are perfect or impenetrable.  We cannot guarantee that only authorized persons will view your information. We cannot ensure that information you share on the Website will not become publicly available. You can reduce these risks by using common sense security practices such as choosing a strong password, using different passwords for different services, and using up to date antivirus software.'
						)
					),
					_react2.default.createElement(_index2.default, null)
				);
			}
		}]);
	
		return ApplicantTerms;
	}(_react.Component), _class2.propTypes = {
		params: _react.PropTypes.object.isRequired,
		push: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = ApplicantTerms;

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPasswordResetRequests = getPasswordResetRequests;
	exports.getPushQueueItems = getPushQueueItems;
	function getPasswordResetRequests(query, cb) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/admin/passwordresetrequests',
	        query: query
	      }).then(function (_ref) {
	        var passwordresetrequests = _ref.body.data.items;
	        return passwordresetrequests;
	      }).then(function (resp) {
	
	        if (cb) {
	          return cb(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (cb) {
	          return cb(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}
	
	function getPushQueueItems(query, cb) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.get({
	        route: '/api/admin/pushqueueitems',
	        query: query
	      }).then(function (_ref2) {
	        var pushqueueitems = _ref2.body.data.items;
	        return pushqueueitems;
	      }).then(function (resp) {
	
	        if (cb) {
	          return cb(null, resp);
	        }
	        return resp;
	      }).catch(function (err) {
	        if (cb) {
	          return cb(err);
	        }
	        return Promise.reject(err);
	      });
	    };
	  };
	}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.applicantAssessmentUrls = applicantAssessmentUrls;
	exports.updateApplicantAssessments = updateApplicantAssessments;
	function applicantAssessmentUrls(applicantId, done) {
	  return function (simpleIsoFetch) {
	    return function () {
	
	      simpleIsoFetch.get("/api/applicants/" + applicantId + "/assessments/urls").then(function (_ref) {
	        var _ref$body$data$items = _slicedToArray(_ref.body.data.items, 1),
	            assessmentUrls = _ref$body$data$items[0];
	
	        return done ? done(null, assessmentUrls) : assessmentUrls;
	      }).catch(function (err) {
	        return done ? done(err) : Promise.reject(err);
	      });
	    };
	  };
	}
	
	function updateApplicantAssessments(applicantId, assessments, done) {
	  return function (simpleIsoFetch) {
	    return function () {
	
	      simpleIsoFetch.post({
	        route: "/api/applicants/" + applicantId + "/assessments",
	        body: assessments
	      }).then(function () {
	        return done(null);
	      }).catch(done);
	    };
	  };
	}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.done = done;
	exports.error = error;
	function done(callback) {
	  return function (data) {
	    return callback ? callback(null, data) : data;
	  };
	}
	
	function error(callback) {
	  return function (err) {
	    return callback ? callback(err && err.body || err) : Promise.reject(new Error(err && err.body) || err);
	  };
	}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetPasswordRequest = resetPasswordRequest;
	exports.isResetRequestValid = isResetRequestValid;
	exports.updatePassword = updatePassword;
	
	var _superagent = __webpack_require__(440);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = '/api/auth/password/reset';
	
	function resetPasswordRequest(email) {
	  return new Promise(function (resolve, reject) {
	    _superagent2.default.post(url).set('Content-Type', 'application/json').send({ email: email }).end(function (err, res) {
	      if (!err && res.statusCode === 204) {
	        return resolve();
	      }
	
	      return reject(err);
	    });
	  });
	}
	
	function isResetRequestValid(token) {
	  return new Promise(function (resolve, reject) {
	    _superagent2.default.get(url).query({ token: token }).end(function (err, res) {
	      if (!err && res.statusCode === 204) {
	        return resolve();
	      }
	
	      return reject(err);
	    });
	  });
	}
	
	function updatePassword(token, password) {
	  return new Promise(function (resolve, reject) {
	    _superagent2.default.put(url).set('Content-Type', 'application/json').send({ token: token, password: password }).end(function (err, res) {
	      if (!err && res.statusCode === 204) {
	        return resolve();
	      }
	
	      return reject(err);
	    });
	  });
	}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.migrateSkills = migrateSkills;
	
	var _lodash = __webpack_require__(4);
	
	function migrateSkills(profile) {
	  var skills = (0, _lodash.get)(profile, 'viewState.progress.applicant.application.Skills');
	  if (skills) {
	    var newSkills = (0, _lodash.omit)(skills, ['Types of Firms or Organizations worked for', 'Industry Segment', 'Positions or Types of Work', 'Special Areas of Knowledge', 'Management Systems', 'Carriers Worked With']);
	    (0, _lodash.set)(profile, 'viewState.progress.applicant.application.Skills', newSkills);
	  }
	  return profile;
	}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findCompany = findCompany;
	exports.companyInGroups = companyInGroups;
	exports.findGrouping = findGrouping;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function findCompany(criteria, companies) {
	  return _lodash2.default.reduce(companies, function (result, list) {
	    var match = _lodash2.default.find(list, criteria);
	    if (match) {
	      result.push(match);
	    }
	
	    return result;
	  }, [])[0];
	}
	
	function companyInGroups(criteria, companies) {
	  return _lodash2.default.reduce(companies, function (list, group, name) {
	    var index = _lodash2.default.findIndex(group, criteria);
	    if (~index) {
	      list.push({ name: name, index: index });
	    }
	    return list;
	  }, []);
	}
	
	function findGrouping(_ref) {
	  var company = _ref.company,
	      groups = _ref.groups;
	
	  var group = groups.find(function (status) {
	    return status.id === company.companyStatus;
	  }).name;
	  return { company: company, group: group };
	}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = refreshCurrentUser;
	exports.isUserAuthenticated = isUserAuthenticated;
	exports.hasRoles = hasRoles;
	
	var _lodash = __webpack_require__(4);
	
	var _auth = __webpack_require__(213);
	
	var _sync = __webpack_require__(21);
	
	var _contacts = __webpack_require__(84);
	
	var _companies = __webpack_require__(63);
	
	function refreshCurrentUser(store) {
	  return new Promise(function (resolve, reject) {
	    store.dispatch((0, _auth.currentUser)({
	      success: function success(userItems) {
	
	        store.dispatch((0, _sync.updateUser)((0, _lodash.merge)({ loggedIn: true }, userItems[0])));
	
	        if (~userItems[0].roles.indexOf('Client')) {
	          store.dispatch((0, _contacts.updateProfile)(userItems[1].profile));
	          store.dispatch((0, _companies.updateCompany)({ company: userItems[1].company }));
	        } else if (~userItems[0].roles.indexOf('Applicant')) {
	          store.dispatch((0, _contacts.updateProfile)(userItems[1]));
	          store.dispatch((0, _sync.updateApplicant)({ profile: userItems[1] }));
	        } else {
	          store.dispatch((0, _contacts.updateProfile)(userItems[1]));
	        }
	
	        return resolve();
	      },
	      error: function error(err) {
	        reject(err);
	      }
	    }));
	  });
	}
	
	function isUserAuthenticated(store) {
	  return new Promise(function (resolve, reject) {
	    var state = store.getState();
	    if (state.user && state.user.loggedIn) {
	      return resolve();
	    }
	
	    return reject();
	  });
	}
	
	function hasRoles(store, roles) {
	  return new Promise(function (resolve, reject) {
	    var state = store.getState();
	    if (state.user && state.user.roles) {
	      if (state.user.roles.some(function (role) {
	        return roles.includes(role);
	      })) {
	        resolve();
	      }
	    }
	
	    reject();
	  });
	}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1263), __esModule: true };

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1267), __esModule: true };

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1270), __esModule: true };

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1275), __esModule: true };

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(320);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(485);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _threezerotwofour = __webpack_require__(1222);
	
	exports.threezerotwofour = _interopRequire(_threezerotwofour);
	
	var _apathy = __webpack_require__(1189);
	
	exports.apathy = _interopRequire(_apathy);
	
	var _ashes = __webpack_require__(1190);
	
	exports.ashes = _interopRequire(_ashes);
	
	var _atelierDune = __webpack_require__(1191);
	
	exports.atelierDune = _interopRequire(_atelierDune);
	
	var _atelierForest = __webpack_require__(1192);
	
	exports.atelierForest = _interopRequire(_atelierForest);
	
	var _atelierHeath = __webpack_require__(1193);
	
	exports.atelierHeath = _interopRequire(_atelierHeath);
	
	var _atelierLakeside = __webpack_require__(1194);
	
	exports.atelierLakeside = _interopRequire(_atelierLakeside);
	
	var _atelierSeaside = __webpack_require__(1195);
	
	exports.atelierSeaside = _interopRequire(_atelierSeaside);
	
	var _bespin = __webpack_require__(1196);
	
	exports.bespin = _interopRequire(_bespin);
	
	var _brewer = __webpack_require__(1197);
	
	exports.brewer = _interopRequire(_brewer);
	
	var _bright = __webpack_require__(1198);
	
	exports.bright = _interopRequire(_bright);
	
	var _chalk = __webpack_require__(1199);
	
	exports.chalk = _interopRequire(_chalk);
	
	var _codeschool = __webpack_require__(1200);
	
	exports.codeschool = _interopRequire(_codeschool);
	
	var _colors = __webpack_require__(1201);
	
	exports.colors = _interopRequire(_colors);
	
	var _default = __webpack_require__(1202);
	
	exports['default'] = _interopRequire(_default);
	
	var _eighties = __webpack_require__(1203);
	
	exports.eighties = _interopRequire(_eighties);
	
	var _embers = __webpack_require__(1204);
	
	exports.embers = _interopRequire(_embers);
	
	var _flat = __webpack_require__(1205);
	
	exports.flat = _interopRequire(_flat);
	
	var _google = __webpack_require__(1206);
	
	exports.google = _interopRequire(_google);
	
	var _grayscale = __webpack_require__(1207);
	
	exports.grayscale = _interopRequire(_grayscale);
	
	var _greenscreen = __webpack_require__(1208);
	
	exports.greenscreen = _interopRequire(_greenscreen);
	
	var _harmonic = __webpack_require__(1209);
	
	exports.harmonic = _interopRequire(_harmonic);
	
	var _hopscotch = __webpack_require__(1210);
	
	exports.hopscotch = _interopRequire(_hopscotch);
	
	var _isotope = __webpack_require__(1211);
	
	exports.isotope = _interopRequire(_isotope);
	
	var _marrakesh = __webpack_require__(1212);
	
	exports.marrakesh = _interopRequire(_marrakesh);
	
	var _mocha = __webpack_require__(1213);
	
	exports.mocha = _interopRequire(_mocha);
	
	var _monokai = __webpack_require__(1214);
	
	exports.monokai = _interopRequire(_monokai);
	
	var _ocean = __webpack_require__(1215);
	
	exports.ocean = _interopRequire(_ocean);
	
	var _paraiso = __webpack_require__(1216);
	
	exports.paraiso = _interopRequire(_paraiso);
	
	var _pop = __webpack_require__(1217);
	
	exports.pop = _interopRequire(_pop);
	
	var _railscasts = __webpack_require__(1218);
	
	exports.railscasts = _interopRequire(_railscasts);
	
	var _shapeshifter = __webpack_require__(1219);
	
	exports.shapeshifter = _interopRequire(_shapeshifter);
	
	var _solarized = __webpack_require__(1220);
	
	exports.solarized = _interopRequire(_solarized);
	
	var _summerfruit = __webpack_require__(1221);
	
	exports.summerfruit = _interopRequire(_summerfruit);
	
	var _tomorrow = __webpack_require__(1223);
	
	exports.tomorrow = _interopRequire(_tomorrow);
	
	var _tube = __webpack_require__(1224);
	
	exports.tube = _interopRequire(_tube);
	
	var _twilight = __webpack_require__(1225);
	
	exports.twilight = _interopRequire(_twilight);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(40);
	var getKeys = __webpack_require__(172).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(40);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(127);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(172);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(3111)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/chrome.+? edge/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
	      result.android = t
	    } else if (!result.windowsphone && !result.msedge && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	    } else if (mac) {
	      result.mac = t
	    } else if (xbox) {
	      result.xbox = t
	    } else if (windows) {
	      result.windows = t
	    } else if (linux) {
	      result.linux = t
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	    
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  return bowser
	});


/***/ }),
/* 495 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 496 */
[3120, 321, 93],
/* 497 */
[3124, 176, 128],
/* 498 */
[3128, 144, 174, 497],
/* 499 */
[3129, 321],
/* 500 */
[3135, 325, 111, 506, 175, 145, 177, 1286, 329, 504, 93],
/* 501 */
[3143, 242, 215, 146, 333, 145, 498, 144],
/* 502 */
[3144, 146, 503],
/* 503 */
[3145, 505, 324],
/* 504 */
[3146, 145, 216, 330],
/* 505 */
[3147, 145, 146, 1278, 330],
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(175);


/***/ }),
/* 507 */
[3157, 332],
/* 508 */
[3163, 496, 93, 177, 57],
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(94);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(155);
	var toLength = __webpack_require__(46);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(148);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(58);
	var toObject = __webpack_require__(50);
	var IObject = __webpack_require__(218);
	var toLength = __webpack_require__(46);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(58);
	var isObject = __webpack_require__(38);
	var invoke = __webpack_require__(249);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(45).f;
	var create = __webpack_require__(150);
	var redefineAll = __webpack_require__(153);
	var ctx = __webpack_require__(95);
	var anInstance = __webpack_require__(147);
	var forOf = __webpack_require__(148);
	var $iterDefine = __webpack_require__(347);
	var step = __webpack_require__(521);
	var setSpecies = __webpack_require__(154);
	var DESCRIPTORS = __webpack_require__(44);
	var fastKey = __webpack_require__(131).fastKey;
	var validate = __webpack_require__(182);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(217);
	var from = __webpack_require__(511);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(153);
	var getWeak = __webpack_require__(131).getWeak;
	var anObject = __webpack_require__(27);
	var isObject = __webpack_require__(38);
	var anInstance = __webpack_require__(147);
	var forOf = __webpack_require__(148);
	var createArrayMethod = __webpack_require__(99);
	var $has = __webpack_require__(76);
	var validate = __webpack_require__(182);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(250);
	var isObject = __webpack_require__(38);
	var toLength = __webpack_require__(46);
	var ctx = __webpack_require__(95);
	var IS_CONCAT_SPREADABLE = __webpack_require__(41)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 518 */
[3128, 44, 34, 340],
/* 519 */
[3132, 38],
/* 520 */
[3133, 27],
/* 521 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(349);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 523 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 524 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 525 */
[3139, 132, 254, 219, 50, 218, 34],
/* 526 */
[3142, 45, 27, 132, 44],
/* 527 */
[3144, 80, 151],
/* 528 */
[3147, 76, 80, 245, 353],
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(132);
	var toIObject = __webpack_require__(80);
	var isEnum = __webpack_require__(219).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(151);
	var gOPS = __webpack_require__(254);
	var anObject = __webpack_require__(27);
	var Reflect = __webpack_require__(29).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(29).parseFloat;
	var $trim = __webpack_require__(181).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(357) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(29).parseInt;
	var $trim = __webpack_require__(181).trim;
	var ws = __webpack_require__(357);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	var newPromiseCapability = __webpack_require__(351);
	
	module.exports = function (C, x) {
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(46);
	var repeat = __webpack_require__(356);
	var defined = __webpack_require__(101);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(103);
	var toLength = __webpack_require__(46);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 537 */
[3161, 41],
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(514);
	var validate = __webpack_require__(182);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(246)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(44) && /./g.flags != 'g') __webpack_require__(45).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(248)
	});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(514);
	var validate = __webpack_require__(182);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(246)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(99)(0);
	var redefine = __webpack_require__(78);
	var meta = __webpack_require__(131);
	var assign = __webpack_require__(525);
	var weak = __webpack_require__(516);
	var isObject = __webpack_require__(38);
	var fails = __webpack_require__(34);
	var validate = __webpack_require__(182);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(246)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(365);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*!
	 * css-keyframer
	 * Dynamic css animation keyframes Manipulation library.
	 *
	 * @author tsuyoshiwada
	 * @license MIT
	 * @version 1.0.1
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.CSSKeyframer = factory());
	}(this, (function () { 'use strict';
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	function unwrapExports (x) {
		return x && x.__esModule ? x['default'] : x;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var prefixProps = createCommonjsModule(function (module, exports) {
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];
	});
	
	var capitalizeString = createCommonjsModule(function (module, exports) {
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];
	});
	
	var isPrefixedProperty = createCommonjsModule(function (module, exports) {
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];
	});
	
	var sortPrefixedStyle_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = isPrefixedProperty;
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];
	});
	
	var position_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];
	});
	
	var joinPrefixedValue = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];
	});
	
	var isPrefixedValue = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];
	});
	
	var calc_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = joinPrefixedValue;
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = isPrefixedValue;
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];
	});
	
	var cursor_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = joinPrefixedValue;
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];
	});
	
	var flex_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];
	});
	
	var sizing_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = joinPrefixedValue;
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];
	});
	
	var gradient_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = joinPrefixedValue;
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = isPrefixedValue;
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];
	});
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	var index = hyphenateStyleName;
	
	var transition_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = index;
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = capitalizeString;
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = isPrefixedValue;
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = prefixProps;
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index$$1) {
	    multipleValues[index$$1] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];
	});
	
	var flexboxIE_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];
	});
	
	var flexboxOld_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];
	});
	
	var prefixAll_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = prefixProps;
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = capitalizeString;
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = sortPrefixedStyle_1;
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = position_1;
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = calc_1;
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = cursor_1;
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = flex_1;
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = sizing_1;
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = gradient_1;
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = transition_1;
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = flexboxIE_1;
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = flexboxOld_1;
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];
	});
	
	var bowser = createCommonjsModule(function (module) {
	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if ('object' != 'undefined' && module.exports) module.exports = definition();
	  else if (false) undefined(name, definition);
	  else root[name] = definition();
	}(commonjsGlobal, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true;
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result;
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      };
	    } else if (/opr|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      };
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      };
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      };
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      };
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      };
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      };
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , windowsphone: t
	      };
	      if (edgeVersion) {
	        result.msedge = t;
	        result.version = edgeVersion;
	      }
	      else {
	        result.msie = t;
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      };
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      };
	    } else if (/chrome.+? edge/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      };
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      };
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t;
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t);
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      };
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      };
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      };
	      if (versionIdentifier) {
	        result.version = versionIdentifier;
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      };
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier;
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      };
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink";
	        result.blink = t;
	      } else {
	        result.name = result.name || "Webkit";
	        result.webkit = t;
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier;
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko";
	      result.gecko = t;
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
	      result.android = t;
	    } else if (!result.windowsphone && !result.msedge && iosdevice) {
	      result[iosdevice] = t;
	      result.ios = t;
	    } else if (mac) {
	      result.mac = t;
	    } else if (xbox) {
	      result.xbox = t;
	    } else if (windows) {
	      result.windows = t;
	    } else if (linux) {
	      result.linux = t;
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t;
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t;
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t;
	    } else result.x = t;
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  return bowser
	});
	});
	
	var getBrowserInformation = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = bowser;
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie: [['msie']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	var browserByInfo = function browserByInfo(info) {
	  if (info.firefox) {
	    return 'firefox';
	  }
	  var name = '';
	
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  return name;
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  info.browser = browserByInfo(info);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	  info.osversion = parseFloat(info.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (info.browser === 'ios_saf' && info.version > info.osversion) {
	    info.version = info.osversion;
	    info.safari = true;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];
	});
	
	var getPrefixedKeyframes = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];
	});
	
	var prefixProps$2 = createCommonjsModule(function (module, exports) {
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
	module.exports = exports["default"];
	});
	
	var getPrefixedValue = createCommonjsModule(function (module, exports) {
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];
	});
	
	var position_1$1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function position(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];
	});
	
	var calc_1$1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];
	});
	
	var zoomCursor_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];
	});
	
	var grabCursor_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];
	});
	
	var flex_1$1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];
	});
	
	var sizing_1$1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];
	});
	
	var gradient_1$1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];
	});
	
	var unprefixProperty = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];
	});
	
	var transition_1$1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = index;
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _unprefixProperty = unprefixProperty;
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index$$1) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index$$1] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];
	});
	
	var flexboxIE_1$1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];
	});
	
	var flexboxOld_1$1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = getPrefixedValue;
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];
	});
	
	var Prefixer_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = prefixAll_1;
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = getBrowserInformation;
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = getPrefixedKeyframes;
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = capitalizeString;
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = sortPrefixedStyle_1;
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _prefixProps = prefixProps$2;
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _position = position_1$1;
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = calc_1$1;
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = zoomCursor_1;
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = grabCursor_1;
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = flex_1$1;
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = sizing_1$1;
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = gradient_1$1;
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = transition_1$1;
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = flexboxIE_1$1;
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = flexboxOld_1$1;
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return (0, _sortPrefixedStyle2.default)(styles);
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];
	});
	
	var Prefixer = unwrapExports(Prefixer_1);
	
	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	var index$2 = function isObject(val) {
	  return val != null && typeof val === 'object'
	    && !Array.isArray(val);
	};
	
	var isObject = index$2;
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	var index$1 = function isPlainObject(o) {
	  var ctor,prot;
	  
	  if (isObjectObject(o) === false) return false;
	  
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	  
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	  
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	  
	  // Most likely a plain Object
	  return true;
	};
	
	var keys = function keys(obj) {
	  return Object.keys(obj);
	};
	
	var isArray = function isArray(obj) {
	  return obj && Array.isArray(obj);
	};
	
	var isArrayLike = function isArrayLike(obj) {
	  return index$1(obj) || isArray(obj);
	};
	
	// http://hg.mozilla.org/mozilla-central/diff/7c3cb4883157/js/src/builtin/String.js
	var strRepeat = function strRepeat(str, repeatCount) {
	  var s = str;
	  var n = repeatCount;
	  var result = "";
	
	  for (;;) {
	    if (n & 1) result += s;
	    n >>= 1;
	    if (n) s += s;else break;
	  }
	
	  return result;
	};
	
	var indent = function indent(str, size) {
	  var eol = "\n";
	
	  return str.split(eol).map(function (line) {
	    return strRepeat(" ", size) + line;
	  }).join(eol);
	};
	
	var makeStyle = function makeStyle(selector, props) {
	  var pretty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!selector || selector && selector.trim() === "" || !index$1(props)) {
	    return null;
	  }
	
	  var styles = keys(props).map(function (key) {
	    return index(key) + ": " + props[key] + ";";
	  });
	
	  return pretty ? selector + " {\n" + indent(styles.join("\n"), 2) + "\n}" : selector + "{" + styles.join("") + "}";
	};
	
	var makeKeyframes = function makeKeyframes(name, prefixedKeyframes, props) {
	  var pretty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!name || name && name.trim() === "" || !isArrayLike(props)) {
	    return null;
	  }
	
	  var eol = "\n";
	  var styles = keys(props).map(function (selector) {
	    var values = props[selector];
	    var selectorString = selector;
	
	    if (typeof selector === "number" || /^\d+$/.test(selector)) {
	      var maxIndex = props.length - 1;
	
	      if (selector === 0) {
	        selectorString = "0%";
	      } else if (selector === maxIndex) {
	        selectorString = "100%";
	      } else {
	        selectorString = parseInt(selector, 10) / maxIndex * 100 + "%";
	      }
	    }
	
	    return makeStyle(selectorString, values, pretty);
	  });
	
	  return pretty ? ["@" + prefixedKeyframes + " " + name + " {", indent(styles.join(eol + eol), 2), "}"].join(eol) : "@" + prefixedKeyframes + " " + name + "{" + styles.join("") + "}";
	};
	
	var index$4 = createCommonjsModule(function (module) {
	/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (false) {
			undefined(function () {
				return ExecutionEnvironment;
			});
		} else if ('object' !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());
	});
	
	var findStyleElement = function findStyleElement(dataName, name) {
	  return document.querySelector("style[" + dataName + "=\"" + name + "\"]");
	};
	
	var createStyleElement = function createStyleElement(dataName, name) {
	  var el = document.createElement("style");
	  el.type = "text/css";
	  el.setAttribute(dataName, name);
	  document.head.appendChild(el);
	
	  return el;
	};
	
	var getStyleElement = function getStyleElement(dataName, name) {
	  if (!index$4.canUseDOM) return null;
	
	  var el = findStyleElement(dataName, name);
	
	  return el ? el : createStyleElement(dataName, name);
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var CSSKeyframer = function () {
	  function CSSKeyframer() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    classCallCheck(this, CSSKeyframer);
	
	    this.keyframes = {};
	    this.options = _extends({}, CSSKeyframer.defaults, options);
	    this.prefixer = new Prefixer({ userAgent: options.userAgent });
	  }
	
	  createClass(CSSKeyframer, [{
	    key: "getPrefixedName",
	    value: function getPrefixedName(name) {
	      return this.options.namePrefix + name;
	    }
	  }, {
	    key: "getKeyframesString",
	    value: function getKeyframesString(name, keyframes) {
	      var _this = this;
	
	      if (!name || typeof name !== "string" || !isArrayLike(keyframes)) {
	        return "";
	      }
	
	      var prefixedKeyframes = isArray(keyframes) ? [] : {};
	
	      keys(keyframes).forEach(function (selector) {
	        prefixedKeyframes[selector] = _this.prefixer.prefix(keyframes[selector]);
	      });
	
	      return makeKeyframes(this.getPrefixedName(name), this.prefixer.prefixedKeyframes || "keyframes", prefixedKeyframes, this.options.pretty);
	    }
	  }, {
	    key: "getKeyframesStylesheet",
	    value: function getKeyframesStylesheet(name, keyframes) {
	      var styleDataName = this.options.styleDataName;
	
	      var keyframesString = this.getKeyframesString(name, keyframes);
	
	      return !keyframesString ? "" : "<style type=\"text/css\" " + styleDataName + "=\"" + name + "\">" + keyframesString + "</style>";
	    }
	  }, {
	    key: "register",
	    value: function register(name, keyframes) {
	      this.unregister(name);
	
	      var styleDataName = this.options.styleDataName;
	
	      var keyframesString = this.getKeyframesString(name, keyframes);
	      if (keyframesString === "") return;
	
	      var el = getStyleElement(styleDataName, this.getPrefixedName(name));
	      if (el == null) return;
	
	      el.innerHTML = keyframesString;
	
	      this.keyframes[name] = el;
	    }
	  }, {
	    key: "unregister",
	    value: function unregister(name) {
	      if (this.contains(name)) {
	        var el = this.keyframes[name];
	        el.parentNode.removeChild(el);
	        delete this.keyframes[name];
	      }
	    }
	  }, {
	    key: "unregisterAll",
	    value: function unregisterAll() {
	      var _this2 = this;
	
	      keys(this.keyframes).forEach(function (name) {
	        return _this2.unregister(name);
	      });
	    }
	  }, {
	    key: "contains",
	    value: function contains(name) {
	      return this.keyframes.hasOwnProperty(name);
	    }
	  }, {
	    key: "animationProp",
	    get: function get$$1() {
	      var _prefixer = this.prefixer,
	          jsPrefix = _prefixer.jsPrefix,
	          cssPrefix = _prefixer.cssPrefix;
	
	
	      return {
	        js: jsPrefix ? jsPrefix + "Animation" : "animation",
	        css: cssPrefix + "animation"
	      };
	    }
	  }]);
	  return CSSKeyframer;
	}();
	
	CSSKeyframer.defaults = {
	  namePrefix: "",
	  styleDataName: "data-keyframes",
	  pretty: false,
	  userAgent: null
	};
	
	return CSSKeyframer;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(364);
	var XHR = __webpack_require__(1528);
	var JSONP = __webpack_require__(1527);
	var websocket = __webpack_require__(1529);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(363);
	var parseqs = __webpack_require__(397);
	var parser = __webpack_require__(183);
	var inherit = __webpack_require__(241);
	var yeast = __webpack_require__(847);
	var debug = __webpack_require__(260)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(364);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(65);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(1548);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 553 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(1576);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = alphabetical;
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphabetical. */
	function alphabetical(character) {
	  var code = typeof character === 'string' ?
	    character.charCodeAt(0) : character;
	
	  return (code >= 97 && code <= 122) || /* a-z */
	    (code >= 65 && code <= 90); /* A-Z */
	}


/***/ }),
/* 557 */
/***/ (function(module, exports) {

	var moreThanThreePeriods = /\.{3,}/g;
	
	// polyfill Array.isArray if necessary
	if (!Array.isArray) {
	  Array.isArray = function(arg) {
	    return Object.prototype.toString.call(arg) === '[object Array]';
	  };
	}
	
	var errorStr = 'tried to join something other than a string or array, it was ignored in pathJoin\'s result';
	
	// works just like Node.js's native path library's 'join' function with the bonus of handling arrays
	function pathJoin() {
	  return Array.prototype.slice.call(arguments).reduce(function(prev, val) {
	  	if(typeof prev === 'undefined') return;
	
	  	return typeof val === 'string' || typeof val === 'number' ?
	  		joinStringsWithSlash(prev, "" + val) : // if string or number just keep as is
	  		Array.isArray(val) ? joinStringsWithSlash(prev, pathJoin.apply(null, val)) : // handle array with recursion
	  		(console.error ? console.error(errorStr) : console.log(errorStr)) || ''
	  }, '').replace(moreThanThreePeriods, '..'); // join the resulting array together
	}
	
	function joinStringsWithSlash(str1, str2) {
		const str1isEmpty = !str1.length;
		const str1EndsInSlash = str1[str1.length - 1] === '/';
		const str2StartsWithSlash = str2[0] === '/';
		var res = str1EndsInSlash && str2StartsWithSlash && (str1 + str2.slice(1)) || !str1EndsInSlash && !str2StartsWithSlash && !str1isEmpty && (str1 + '/' + str2) || (str1 + str2);
		return res;
	}
	
	module.exports = pathJoin;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(158),
	    root = __webpack_require__(115);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(264),
	    stackClear = __webpack_require__(1671),
	    stackDelete = __webpack_require__(1672),
	    stackGet = __webpack_require__(1673),
	    stackHas = __webpack_require__(1674),
	    stackSet = __webpack_require__(1675);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1612);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(563),
	    isFlattenable = __webpack_require__(1647);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(569),
	    toKey = __webpack_require__(268);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1614),
	    isObjectLike = __webpack_require__(159);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(269),
	    overRest = __webpack_require__(1666),
	    setToString = __webpack_require__(1669);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(116),
	    isKey = __webpack_require__(372),
	    stringToPath = __webpack_require__(1677),
	    toString = __webpack_require__(1688);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(158);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(370),
	    arraySome = __webpack_require__(1604),
	    cacheHas = __webpack_require__(371);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 572 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(376);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 576 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(582),
	    isLength = __webpack_require__(375);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(579),
	    isObjectLike = __webpack_require__(159);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(115),
	    stubFalse = __webpack_require__(1687);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(185),
	    isObject = __webpack_require__(376);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1618),
	    baseUnary = __webpack_require__(568),
	    nodeUtil = __webpack_require__(1664);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(1695);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var selected = props.selected;
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var color = selected ? bottomNavigation.selectedColor : bottomNavigation.unselectedColor;
	
	  var styles = {
	    root: {
	      transition: 'padding-top 0.3s',
	      paddingTop: selected ? 6 : 8,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168
	    },
	    label: {
	      fontSize: selected ? bottomNavigation.selectedFontSize : bottomNavigation.unselectedFontSize,
	      transition: 'color 0.3s, font-size 0.3s',
	      color: color
	    },
	    icon: {
	      display: 'block',
	      /**
	       * Used to ensure SVG icons are centered
	       */
	      width: '100%'
	    },
	    iconColor: color
	  };
	
	  return styles;
	}
	
	var BottomNavigationItem = function BottomNavigationItem(props, context) {
	  var label = props.label,
	      icon = props.icon,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['label', 'icon', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var styledIcon = (0, _react.cloneElement)(icon, {
	    style: (0, _simpleAssign2.default)({}, styles.icon, icon.props.style),
	    color: icon.props.color || styles.iconColor
	  });
	
	  return _react2.default.createElement(
	    _EnhancedButton2.default,
	    (0, _extends3.default)({}, other, { style: (0, _simpleAssign2.default)({}, styles.root, style) }),
	    styledIcon,
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles(styles.label) },
	      label
	    )
	  );
	};
	
	 false ? BottomNavigationItem.propTypes = {
	  /**
	   * Set the icon representing the view for this item.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Set the label describing the view for this item.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	BottomNavigationItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = BottomNavigationItem;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  (0, _inherits3.default)(CardActions, _Component);
	
	  function CardActions() {
	    (0, _classCallCheck3.default)(this, CardActions);
	    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	  return CardActions;
	}(_react.Component);
	
	CardActions.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardActions.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardActions;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keyboardArrowUp = __webpack_require__(621);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(620);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  (0, _inherits3.default)(CardExpandable, _Component);
	
	  function CardExpandable() {
	    (0, _classCallCheck3.default)(this, CardExpandable);
	    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onTouchTap: this.props.onExpanding
	        },
	        this.props.expanded ? this.props.openIcon : this.props.closeIcon
	      );
	    }
	  }]);
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	CardExpandable.defaultProps = {
	  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
	};
	 false ? CardExpandable.propTypes = {
	  closeIcon: _react.PropTypes.node,
	  expanded: _react.PropTypes.bool,
	  onExpanding: _react.PropTypes.func.isRequired,
	  openIcon: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardExpandable;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(584);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  (0, _inherits3.default)(CardHeader, _Component);
	
	  function CardHeader() {
	    (0, _classCallCheck3.default)(this, CardHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          avatarProp = _props.avatar,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          openIcon = _props.openIcon,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          textStyle = _props.textStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardHeader.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _react.PropTypes.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
	   */
	  openIcon: _react.PropTypes.node,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = CardHeader;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  (0, _inherits3.default)(CardMedia, _Component);
	
	  function CardMedia() {
	    (0, _classCallCheck3.default)(this, CardMedia);
	    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          mediaStyle = _props.mediaStyle,
	          overlay = _props.overlay,
	          overlayContainerStyle = _props.overlayContainerStyle,
	          overlayContentStyle = _props.overlayContentStyle,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        if (child.type.muiName === 'CardHeader' || child.type.muiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (child.type.muiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardMedia.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardMedia;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  (0, _inherits3.default)(CardText, _Component);
	
	  function CardText() {
	    (0, _classCallCheck3.default)(this, CardText);
	    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          color = _props.color,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardText.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = CardText;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  (0, _inherits3.default)(CardTitle, _Component);
	
	  function CardTitle() {
	    (0, _classCallCheck3.default)(this, CardTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CardTitle.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _react.PropTypes.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _react.PropTypes.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = CardTitle;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Drawer = __webpack_require__(1720);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FlatButtonLabel.propTypes = {
	  label: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FlatButtonLabel;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(489);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _titleBar;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      gridTile = _context$muiTheme.gridTile;
	
	
	  var actionPos = props.actionIcon && props.actionPosition;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'block',
	      height: '100%',
	      overflow: 'hidden'
	    },
	    titleBar: (_titleBar = {
	      position: 'absolute',
	      left: 0,
	      right: 0
	    }, (0, _defineProperty3.default)(_titleBar, props.titlePosition, 0), (0, _defineProperty3.default)(_titleBar, 'height', props.subtitle ? 68 : 48), (0, _defineProperty3.default)(_titleBar, 'background', props.titleBackground), (0, _defineProperty3.default)(_titleBar, 'display', 'flex'), (0, _defineProperty3.default)(_titleBar, 'alignItems', 'center'), _titleBar),
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      color: gridTile.textColor,
	      overflow: 'hidden'
	    },
	    title: {
	      fontSize: '16px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: '12px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {
	      order: actionPos === 'left' ? -1 : 1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	  return styles;
	}
	
	var GridTile = function (_Component) {
	  (0, _inherits3.default)(GridTile, _Component);
	
	  function GridTile() {
	    (0, _classCallCheck3.default)(this, GridTile);
	    return (0, _possibleConstructorReturn3.default)(this, (GridTile.__proto__ || (0, _getPrototypeOf2.default)(GridTile)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      var _this2 = this;
	
	      var imgEl = this.refs.img;
	
	      if (imgEl) {
	        (function () {
	          var fit = function fit() {
	            if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	              var isRtl = _this2.context.muiTheme.isRtl;
	
	              imgEl.style.height = 'auto';
	              if (isRtl) {
	                imgEl.style.right = '0';
	              } else {
	                imgEl.style.left = '0';
	              }
	              imgEl.style.width = '100%';
	              imgEl.style.top = '50%';
	              imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	            }
	            imgEl.removeEventListener('load', fit);
	            imgEl = null; // prevent closure memory leak
	          };
	          if (imgEl.complete) {
	            fit();
	          } else {
	            imgEl.addEventListener('load', fit);
	          }
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          titlePosition = _props.titlePosition,
	          titleBackground = _props.titleBackground,
	          titleStyle = _props.titleStyle,
	          actionIcon = _props.actionIcon,
	          actionPosition = _props.actionPosition,
	          style = _props.style,
	          children = _props.children,
	          containerElement = _props.containerElement,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'titleStyle', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var titleBar = null;
	
	      if (title) {
	        titleBar = _react2.default.createElement(
	          'div',
	          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.titleWrap) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	              title
	            ),
	            subtitle ? _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.subtitle) },
	              subtitle
	            ) : null
	          ),
	          actionIcon ? _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.actionIcon) },
	            actionIcon
	          ) : null
	        );
	      }
	
	      var newChildren = children;
	
	      // if there is a single image passed as children
	      // clone it and add our styles
	      if (_react2.default.Children.count(children) === 1) {
	        newChildren = _react2.default.Children.map(children, function (child) {
	          if (child.type === 'img') {
	            return _react2.default.cloneElement(child, {
	              key: 'img',
	              ref: 'img',
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
	            });
	          } else {
	            return child;
	          }
	        });
	      }
	
	      var containerProps = (0, _extends3.default)({
	        style: prepareStyles(mergedRootStyles)
	      }, other);
	
	      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
	    }
	  }]);
	  return GridTile;
	}(_react.Component);
	
	GridTile.defaultProps = {
	  titlePosition: 'bottom',
	  titleBackground: 'rgba(0, 0, 0, 0.4)',
	  actionPosition: 'right',
	  cols: 1,
	  rows: 1,
	  containerElement: 'div'
	};
	GridTile.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? GridTile.propTypes = {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _react.PropTypes.element,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in whichcase GridTile takes care of making the image "cover" available space
	   * (similar to background-size: cover or to object-fit:cover).
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _react.PropTypes.number,
	  /**
	   * Either a string used as tag name for the tile root element, or a ReactElement.
	   * This is useful when you have, for example, a custom implementation of
	   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
	   * In case you pass a ReactElement, please ensure that it passes all props,
	   * accepts styles overrides and render it's children.
	   */
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _react.PropTypes.node,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Style used for title bar background.
	   * Useful for setting custom gradients for example
	   */
	  titleBackground: _react.PropTypes.string,
	  /**
	   * Position of the title bar (container of title, subtitle and action icon).
	   */
	  titlePosition: _react.PropTypes.oneOf(['top', 'bottom']),
	  /**
	   * Override the inline-styles of the title element.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = GridTile;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinearProgress = __webpack_require__(1731);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinearProgress2.default;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelectable = undefined;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colorManipulator = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelectable = function makeSelectable(MyComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(_class, _Component);
	
	    function _class() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemTouchTap = function (event, item) {
	        var itemValue = item.props.value;
	
	        if (itemValue !== _this.props.value) {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, itemValue);
	          }
	        }
	      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onTouchTap: function onTouchTap(event) {
	              _this2.handleItemTouchTap(event, child);
	              if (child.props.onTouchTap) {
	                child.props.onTouchTap(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return props.value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            selectedItemStyle = _props.selectedItemStyle,
	            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);
	
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          MyComponent,
	          (0, _extends3.default)({}, other, this.state),
	          _react.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	    return _class;
	  }(_react.Component), _class.propTypes = {
	    children: _react.PropTypes.node,
	    onChange: _react.PropTypes.func,
	    selectedItemStyle: _react.PropTypes.object,
	    value: _react.PropTypes.any
	  }, _class.contextTypes = {
	    muiTheme: _react.PropTypes.object.isRequired
	  }, _temp2;
	};
	
	exports.makeSelectable = makeSelectable;
	exports.default = makeSelectable;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(187);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(385);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedSwitch = __webpack_require__(389);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(632);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(631);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var radioButton = context.muiTheme.radioButton;
	
	
	  return {
	    icon: {
	      height: radioButton.size,
	      width: radioButton.size
	    },
	    target: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(1)',
	      fill: radioButton.borderColor
	    },
	    fill: {
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(0)',
	      transformOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut(),
	      fill: radioButton.checkedColor
	    },
	    targetWhenChecked: {
	      opacity: 0,
	      transform: 'scale(0)'
	    },
	    fillWhenChecked: {
	      opacity: 1,
	      transform: 'scale(1)'
	    },
	    targetWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    fillWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    label: {
	      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
	    },
	    ripple: {
	      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
	    }
	  };
	}
	
	var RadioButton = function (_Component) {
	  (0, _inherits3.default)(RadioButton, _Component);
	
	  function RadioButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, _this.props.value);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Only called when selected, not when unselected.
	
	
	  (0, _createClass3.default)(RadioButton, [{
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	
	    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	    // RadioButton's checked value.
	
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.enhancedSwitch.getValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onCheck = _props.onCheck,
	          uncheckedIcon = _props.uncheckedIcon,
	          disabled = _props.disabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);
	
	      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);
	
	      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });
	
	      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });
	
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
	        ref: 'enhancedSwitch',
	        inputType: 'radio',
	        checked: checked,
	        switched: checked,
	        disabled: disabled,
	        rippleColor: styles.ripple.color,
	        iconStyle: mergedIconStyle,
	        labelStyle: mergedLabelStyle,
	        labelPosition: labelPosition,
	        onSwitch: this.handleSwitch,
	        switchElement: _react2.default.createElement(
	          'div',
	          null,
	          uncheckedElement,
	          checkedElement
	        )
	      }));
	    }
	  }]);
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'right'
	};
	RadioButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RadioButton.propTypes = {
	  /**
	   * @ignore
	   * checked if true
	   * Used internally by `RadioButtonGroup`.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The icon element to show when the radio button is checked.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * If true, the radio button is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	   * Where the label will be placed next to the radio button.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Override the inline-styles of the label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Callback function fired when the radio button is checked. Note that this
	   * function will not be called if the radio button is part of a
	   * radio button group: in this case, use the `onChange` property of
	   * `RadioButtonGroup`.
	   *
	   * @param {object} event `change` event targeting the element.
	   * @param {string} value The element's `value`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The icon element to show when the radio button is unchecked.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * The value of the radio button.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = RadioButton;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RadioButton = __webpack_require__(598);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioButtonGroup = function (_Component) {
	  (0, _inherits3.default)(RadioButtonGroup, _Component);
	
	  function RadioButtonGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      numberCheckedRadioButtons: 0,
	      selected: ''
	    }, _this.handleChange = function (event, newSelection) {
	      _this.updateRadioButtons(newSelection);
	
	      // Successful update
	      if (_this.state.numberCheckedRadioButtons === 0) {
	        if (_this.props.onChange) _this.props.onChange(event, newSelection);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RadioButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var cnt = 0;
	      var selected = '';
	      var _props = this.props,
	          valueSelected = _props.valueSelected,
	          defaultSelected = _props.defaultSelected;
	
	      if (valueSelected !== undefined) {
	        selected = valueSelected;
	      } else if (defaultSelected !== undefined) {
	        selected = defaultSelected;
	      }
	
	      _react2.default.Children.forEach(this.props.children, function (option) {
	        if (_this2.hasCheckAttribute(option)) cnt++;
	      }, this);
	
	      this.setState({
	        numberCheckedRadioButtons: cnt,
	        selected: selected
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('valueSelected')) {
	        this.setState({
	          selected: nextProps.valueSelected
	        });
	      }
	    }
	  }, {
	    key: 'hasCheckAttribute',
	    value: function hasCheckAttribute(radioButton) {
	      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	    }
	  }, {
	    key: 'updateRadioButtons',
	    value: function updateRadioButtons(newSelection) {
	      if (this.state.numberCheckedRadioButtons === 0) {
	        this.setState({ selected: newSelection });
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
	      }
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      return this.state.selected;
	    }
	  }, {
	    key: 'setSelectedValue',
	    value: function setSelectedValue(newSelectionValue) {
	      this.updateRadioButtons(newSelectionValue);
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setSelectedValue('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var options = _react2.default.Children.map(this.props.children, function (option) {
	        var _option$props = option.props,
	            name = _option$props.name,
	            value = _option$props.value,
	            label = _option$props.label,
	            onCheck = _option$props.onCheck,
	            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	
	        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
	          ref: option.props.value,
	          name: _this3.props.name,
	          key: option.props.value,
	          value: option.props.value,
	          label: option.props.label,
	          labelPosition: _this3.props.labelPosition,
	          onCheck: _this3.handleChange,
	          checked: option.props.value === _this3.state.selected
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
	          className: this.props.className
	        },
	        options
	      );
	    }
	  }]);
	  return RadioButtonGroup;
	}(_react.Component);
	
	RadioButtonGroup.defaultProps = {
	  style: {}
	};
	RadioButtonGroup.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RadioButtonGroup.propTypes = {
	  /**
	   * Should be used to pass `RadioButton` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `value` property of the radio button that will be
	   * selected by default. This takes precedence over the `checked` property
	   * of the `RadioButton` elements.
	   */
	  defaultSelected: _react.PropTypes.any,
	  /**
	   * Where the label will be placed for all child radio buttons.
	   * This takes precedence over the `labelPosition` property of the
	   * `RadioButton` elements.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * The name that will be applied to all child radio buttons.
	   */
	  name: _react.PropTypes.string.isRequired,
	  /**
	   * Callback function that is fired when a radio button has
	   * been checked.
	   *
	   * @param {object} event `change` event targeting the selected
	   * radio button.
	   * @param {*} value The `value` of the selected radio button.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The `value` of the currently selected radio button.
	   */
	  valueSelected: _react.PropTypes.any
	} : void 0;
	exports.default = RadioButtonGroup;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(126);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkCircle = __webpack_require__(619);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var baseTheme = muiTheme.baseTheme;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'not-allowed';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	 false ? StepLabel.propTypes = {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * The label text node
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	StepLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	exports.default = StepLabel;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(1754);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(239);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(214);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(126);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(379);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableRowColumn = __webpack_require__(275);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _ClickAwayListener = __webpack_require__(388);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableBody = function (_Component) {
	  (0, _inherits3.default)(TableBody, _Component);
	
	  function TableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedRows: []
	    }, _this.handleClickAway = function () {
	      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length) {
	        _this.setState({
	          selectedRows: []
	        });
	        if (_this.props.onRowSelection) {
	          _this.props.onRowSelection([]);
	        }
	      }
	    }, _this.onRowClick = function (event, rowNumber) {
	      event.stopPropagation();
	
	      if (_this.props.selectable) {
	        // Prevent text selection while selecting rows.
	        window.getSelection().removeAllRanges();
	        _this.processRowSelection(event, rowNumber);
	      }
	    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
	      event.stopPropagation();
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHover) {
	        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHover(event, rowNumber);
	    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHoverExit) {
	        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHoverExit(event, rowNumber);
	    }, _this.onRowHover = function (event, rowNumber) {
	      if (_this.props.onRowHover) {
	        _this.props.onRowHover(rowNumber);
	      }
	    }, _this.onRowHoverExit = function (event, rowNumber) {
	      if (_this.props.onRowHoverExit) {
	        _this.props.onRowHoverExit(rowNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableBody, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ selectedRows: this.calculatePreselectedRows(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        if (!nextProps.allRowsSelected) {
	          this.setState({
	            selectedRows: []
	          });
	        } else {
	          this.setState({
	            selectedRows: this.calculatePreselectedRows(nextProps)
	          });
	        }
	      }
	    }
	  }, {
	    key: 'createRows',
	    value: function createRows() {
	      var _this2 = this;
	
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var rowNumber = 0;
	      var handlers = {
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowClick: this.onRowClick
	      };
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          var _ret2 = function () {
	            var props = {
	              hoverable: _this2.props.showRowHover,
	              selected: _this2.isRowSelected(rowNumber),
	              striped: _this2.props.stripedRows && rowNumber % 2 === 0,
	              rowNumber: rowNumber++
	            };
	
	            if (rowNumber === numChildren) {
	              props.displayBorder = false;
	            }
	
	            var children = [_this2.createRowCheckboxColumn(props)];
	
	            _react2.default.Children.forEach(child.props.children, function (child) {
	              children.push(child);
	            });
	
	            return {
	              v: _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children)
	            };
	          }();
	
	          if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
	        }
	      });
	    }
	  }, {
	    key: 'createRowCheckboxColumn',
	    value: function createRowCheckboxColumn(rowProps) {
	      if (!this.props.displayRowCheckbox) {
	        return null;
	      }
	
	      var key = rowProps.rowNumber + '-cb';
	      var disabled = !this.props.selectable;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        ref: 'rowSelectCB',
	        name: key,
	        value: 'selected',
	        disabled: disabled,
	        checked: rowProps.selected
	      });
	
	      return _react2.default.createElement(
	        _TableRowColumn2.default,
	        {
	          key: key,
	          columnNumber: 0,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'calculatePreselectedRows',
	    value: function calculatePreselectedRows(props) {
	      // Determine what rows are 'pre-selected'.
	      var preSelectedRows = [];
	
	      if (props.selectable && props.preScanRows) {
	        (function () {
	          var index = 0;
	          _react2.default.Children.forEach(props.children, function (child) {
	            if (_react2.default.isValidElement(child)) {
	              if (child.props.selected && (preSelectedRows.length === 0 || props.multiSelectable)) {
	                preSelectedRows.push(index);
	              }
	
	              index++;
	            }
	          });
	        })();
	      }
	
	      return preSelectedRows;
	    }
	  }, {
	    key: 'isRowSelected',
	    value: function isRowSelected(rowNumber) {
	      if (this.props.allRowsSelected) {
	        return true;
	      }
	
	      for (var i = 0; i < this.state.selectedRows.length; i++) {
	        var selection = this.state.selectedRows[i];
	
	        if ((typeof selection === 'undefined' ? 'undefined' : (0, _typeof3.default)(selection)) === 'object') {
	          if (this.isValueInRange(rowNumber, selection)) return true;
	        } else {
	          if (selection === rowNumber) return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isValueInRange',
	    value: function isValueInRange(value, range) {
	      if (!range) return false;
	
	      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'processRowSelection',
	    value: function processRowSelection(event, rowNumber) {
	      var selectedRows = this.state.selectedRows;
	
	      if (event.shiftKey && this.props.multiSelectable && selectedRows.length) {
	        var lastIndex = selectedRows.length - 1;
	        var lastSelection = selectedRows[lastIndex];
	
	        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
	          lastSelection.end = rowNumber;
	        } else {
	          selectedRows.splice(lastIndex, 1, { start: lastSelection, end: rowNumber });
	        }
	      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
	        var idx = selectedRows.indexOf(rowNumber);
	        if (idx < 0) {
	          var foundRange = false;
	          for (var i = 0; i < selectedRows.length; i++) {
	            var range = selectedRows[i];
	            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;
	
	            if (this.isValueInRange(rowNumber, range)) {
	              var _selectedRows;
	
	              foundRange = true;
	              var values = this.splitRange(range, rowNumber);
	              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
	            }
	          }
	
	          if (!foundRange) selectedRows.push(rowNumber);
	        } else {
	          selectedRows.splice(idx, 1);
	        }
	      } else {
	        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	          selectedRows = [];
	        } else {
	          selectedRows = [rowNumber];
	        }
	      }
	
	      this.setState({ selectedRows: selectedRows });
	      if (this.props.onRowSelection) this.props.onRowSelection(this.flattenRanges(selectedRows));
	    }
	  }, {
	    key: 'splitRange',
	    value: function splitRange(range, splitPoint) {
	      var splitValues = [];
	      var startOffset = range.start - splitPoint;
	      var endOffset = range.end - splitPoint;
	
	      // Process start half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));
	
	      // Process end half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));
	
	      return splitValues;
	    }
	  }, {
	    key: 'genRangeOfValues',
	    value: function genRangeOfValues(start, offset) {
	      var values = [];
	      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	      while (offset !== 0) {
	        values.push(start + offset);
	        offset += dir;
	      }
	
	      return values;
	    }
	  }, {
	    key: 'flattenRanges',
	    value: function flattenRanges(selectedRows) {
	      var rows = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(selectedRows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var selection = _step.value;
	
	          if ((typeof selection === 'undefined' ? 'undefined' : (0, _typeof3.default)(selection)) === 'object') {
	            var values = this.genRangeOfValues(selection.end, selection.start - selection.end);
	            rows.push.apply(rows, [selection.end].concat((0, _toConsumableArray3.default)(values)));
	          } else {
	            rows.push(selection);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return rows.sort();
	    }
	  }, {
	    key: 'getColumnId',
	    value: function getColumnId(columnNumber) {
	      var columnId = columnNumber;
	      if (this.props.displayRowCheckbox) {
	        columnId--;
	      }
	
	      return columnId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'tbody',
	          { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	          this.createRows()
	        )
	      );
	    }
	  }]);
	  return TableBody;
	}(_react.Component);
	
	TableBody.muiName = 'TableBody';
	TableBody.defaultProps = {
	  allRowsSelected: false,
	  deselectOnClickaway: true,
	  displayRowCheckbox: true,
	  multiSelectable: false,
	  preScanRows: true,
	  selectable: true,
	  style: {}
	};
	TableBody.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableBody.propTypes = {
	  /**
	   * @ignore
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _react.PropTypes.bool,
	  /**
	   * Children passed to table body.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Controls whether or not to deselect all selected
	   * rows after clicking outside the table.
	   */
	  deselectOnClickaway: _react.PropTypes.bool,
	  /**
	   * Controls the display of the row checkbox. The default value is true.
	   */
	  displayRowCheckbox: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Callback function for when a cell is clicked.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered. rowNumber
	   * is the row number of the hovered row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer
	   * hovered. rowNumber is the row number of the row
	   * that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a row is selected. selectedRows is an
	   * array of all row selections. IF all rows have been selected,
	   * the string "all" will be returned instead to indicate that
	   * all rows have been selected.
	   */
	  onRowSelection: _react.PropTypes.func,
	  /**
	   * Controls whether or not the rows are pre-scanned to determine
	   * initial state. If your table has a large number of rows and
	   * you are experiencing a delay in rendering, turn off this property.
	   */
	  preScanRows: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * If true, table rows can be selected. If multiple
	   * row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * If true, table rows will be highlighted when
	   * the cursor is hovering over the row. The default
	   * value is false.
	   */
	  showRowHover: _react.PropTypes.bool,
	  /**
	   * If true, every other table row starting
	   * with the first row will be striped. The default value is false.
	   */
	  stripedRows: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableBody;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(214);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableRowColumn = __webpack_require__(275);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableFooter = context.muiTheme.tableFooter;
	
	
	  return {
	    cell: {
	      borderTop: '1px solid ' + tableFooter.borderColor,
	      verticalAlign: 'bottom',
	      padding: 20,
	      textAlign: 'left',
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var TableFooter = function (_Component) {
	  (0, _inherits3.default)(TableFooter, _Component);
	
	  function TableFooter() {
	    (0, _classCallCheck3.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          adjustForCheckbox = _props.adjustForCheckbox,
	          children = _props.children,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
	        var newChildProps = {
	          displayBorder: false,
	          key: 'f-' + rowNumber,
	          rowNumber: rowNumber,
	          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	        };
	
	        var newDescendants = void 0;
	
	        if (adjustForCheckbox) {
	          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
	        } else {
	          newDescendants = child.props.children;
	        }
	
	        return _react2.default.cloneElement(child, newChildProps, newDescendants);
	      });
	
	      return _react2.default.createElement(
	        'tfoot',
	        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        footerRows
	      );
	    }
	  }]);
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.muiName = 'TableFooter';
	TableFooter.defaultProps = {
	  adjustForCheckbox: true,
	  style: {}
	};
	TableFooter.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableFooter.propTypes = {
	  /**
	   * @ignore
	   * Controls whether or not header rows should be adjusted
	   * for a checkbox column. If the select all checkbox is true,
	   * this property will not influence the number of columns.
	   * This is mainly useful for "super header" rows so that
	   * the checkbox column does not create an offset that needs
	   * to be accounted for manually.
	   */
	  adjustForCheckbox: _react.PropTypes.bool,
	  /**
	   * Children passed to table footer.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableFooter;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(379);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableHeaderColumn = __webpack_require__(387);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeader = context.muiTheme.tableHeader;
	
	
	  return {
	    root: {
	      borderBottom: '1px solid ' + tableHeader.borderColor
	    }
	  };
	}
	
	var TableHeader = function (_Component) {
	  (0, _inherits3.default)(TableHeader, _Component);
	
	  function TableHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
	      if (_this.props.onSelectAll) {
	        _this.props.onSelectAll(checked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeader, [{
	    key: 'createSuperHeaderRows',
	    value: function createSuperHeaderRows() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      if (numChildren === 1) return undefined;
	
	      var superHeaders = [];
	      for (var index = 0; index < numChildren - 1; index++) {
	        var child = this.props.children[index];
	
	        if (!_react2.default.isValidElement(child)) continue;
	
	        var props = {
	          key: 'sh' + index,
	          rowNumber: index
	        };
	        superHeaders.push(this.createSuperHeaderRow(child, props));
	      }
	
	      if (superHeaders.length) return superHeaders;
	    }
	  }, {
	    key: 'createSuperHeaderRow',
	    value: function createSuperHeaderRow(child, props) {
	      var children = [];
	      if (this.props.adjustForCheckbox) {
	        children.push(this.getCheckboxPlaceholder(props));
	      }
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'createBaseHeaderRow',
	    value: function createBaseHeaderRow() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var child = numChildren === 1 ? this.props.children : this.props.children[numChildren - 1];
	      var props = {
	        key: 'h' + numChildren,
	        rowNumber: numChildren
	      };
	
	      var children = [this.getSelectAllCheckboxColumn(props)];
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'getCheckboxPlaceholder',
	    value: function getCheckboxPlaceholder(props) {
	      if (!this.props.adjustForCheckbox) return null;
	
	      var disabled = !this.props.enableSelectAll;
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(_TableHeaderColumn2.default, {
	        key: key,
	        style: {
	          width: 24,
	          cursor: disabled ? 'not-allowed' : 'inherit'
	        }
	      });
	    }
	  }, {
	    key: 'getSelectAllCheckboxColumn',
	    value: function getSelectAllCheckboxColumn(props) {
	      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);
	
	      var disabled = !this.props.enableSelectAll;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        key: 'selectallcb',
	        name: 'selectallcb',
	        value: 'selected',
	        disabled: disabled,
	        checked: this.props.selectAllSelected,
	        onCheck: this.handleCheckAll
	      });
	
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(
	        _TableHeaderColumn2.default,
	        {
	          key: key,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var superHeaderRows = this.createSuperHeaderRows();
	      var baseHeaderRow = this.createBaseHeaderRow();
	
	      return _react2.default.createElement(
	        'thead',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        superHeaderRows,
	        baseHeaderRow
	      );
	    }
	  }]);
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.muiName = 'TableHeader';
	TableHeader.defaultProps = {
	  adjustForCheckbox: true,
	  displaySelectAll: true,
	  enableSelectAll: true,
	  selectAllSelected: false
	};
	TableHeader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableHeader.propTypes = {
	  /**
	   * Controls whether or not header rows should be
	   * adjusted for a checkbox column. If the select all
	   * checkbox is true, this property will not influence
	   * the number of columns. This is mainly useful for
	   * "super header" rows so that the checkbox column
	   * does not create an offset that needs to be accounted
	   * for manually.
	   */
	  adjustForCheckbox: _react.PropTypes.bool,
	  /**
	   * Children passed to table header.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Controls whether or not the select all checkbox is displayed.
	   */
	  displaySelectAll: _react.PropTypes.bool,
	  /**
	   * If set to true, the select all button will be interactable.
	   * If set to false, the button will not be interactable.
	   * To hide the checkbox, set displaySelectAll to false.
	   */
	  enableSelectAll: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Callback when select all has been checked.
	   */
	  onSelectAll: _react.PropTypes.func,
	  /**
	   * @ignore
	   * True when select all has been checked.
	   */
	  selectAllSelected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableHeader;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var tableRow = context.muiTheme.tableRow;
	
	
	  var cellBgColor = 'inherit';
	  if (props.hovered || state.hovered) {
	    cellBgColor = tableRow.hoverColor;
	  } else if (props.selected) {
	    cellBgColor = tableRow.selectedColor;
	  } else if (props.striped) {
	    cellBgColor = tableRow.stripeColor;
	  }
	
	  return {
	    root: {
	      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
	      color: tableRow.textColor,
	      height: tableRow.height
	    },
	    cell: {
	      backgroundColor: cellBgColor
	    }
	  };
	}
	
	var TableRow = function (_Component) {
	  (0, _inherits3.default)(TableRow, _Component);
	
	  function TableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onCellClick = function (event, columnIndex) {
	      if (_this.props.selectable && _this.props.onCellClick) {
	        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
	      }
	      event.ctrlKey = true;
	      _this.onRowClick(event);
	    }, _this.onCellHover = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHover(event);
	      }
	    }, _this.onCellHoverExit = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHoverExit(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRow, [{
	    key: 'onRowClick',
	    value: function onRowClick(event) {
	      if (this.props.selectable && this.props.onRowClick) this.props.onRowClick(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHover',
	    value: function onRowHover(event) {
	      if (this.props.onRowHover) this.props.onRowHover(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHoverExit',
	    value: function onRowHoverExit(event) {
	      if (this.props.onRowHoverExit) this.props.onRowHoverExit(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          displayBorder = _props.displayBorder,
	          hoverable = _props.hoverable,
	          hovered = _props.hovered,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowClick = _props.onRowClick,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          rowNumber = _props.rowNumber,
	          selectable = _props.selectable,
	          selected = _props.selected,
	          striped = _props.striped,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            columnNumber: columnNumber,
	            hoverable: _this2.props.hoverable,
	            key: _this2.props.rowNumber + '-' + columnNumber,
	            onClick: _this2.onCellClick,
	            onHover: _this2.onCellHover,
	            onHoverExit: _this2.onCellHoverExit,
	            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other),
	        rowColumns
	      );
	    }
	  }]);
	  return TableRow;
	}(_react.Component);
	
	TableRow.defaultProps = {
	  displayBorder: true,
	  hoverable: false,
	  hovered: false,
	  selectable: true,
	  selected: false,
	  striped: false
	};
	TableRow.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TableRow.propTypes = {
	  /**
	   * Children passed to table row.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, row border will be displayed for the row.
	   * If false, no border will be drawn.
	   */
	  displayBorder: _react.PropTypes.bool,
	  /**
	   * Controls whether or not the row reponseds to hover events.
	   */
	  hoverable: _react.PropTypes.bool,
	  /**
	   * Controls whether or not the row should be rendered as being
	   * hovered. This property is evaluated in addition to this.state.hovered
	   * and can be used to synchronize the hovered state with some other
	   * external events.
	   */
	  hovered: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when row is clicked.
	   */
	  onRowClick: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * Number to identify the row. This property is
	   * automatically populated when used with the TableBody component.
	   */
	  rowNumber: _react.PropTypes.number,
	  /**
	   * If true, table rows can be selected. If multiple row
	   * selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * Indicates that a particular row is selected.
	   * This property can be used to programmatically select rows.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Indicates whether or not the row is striped.
	   */
	  striped: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TableRow;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(_this.props.value, event, _this);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          index = _props.index,
	          onActive = _props.onActive,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          label = _props.label,
	          buttonStyle = _props.buttonStyle,
	          style = _props.style,
	          value = _props.value,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onTouchTap', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        var iconProps = {
	          style: {
	            fontSize: 24,
	            color: styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        };
	        // If it's svg icon set color via props
	        if (icon.type.muiName !== 'FontIcon') {
	          iconProps.color = styles.root.color;
	        }
	        iconElement = _react2.default.cloneElement(icon, iconProps);
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onTouchTap: this.handleTouchTap
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tab.propTypes = {
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _react.PropTypes.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  index: _react.PropTypes.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _react.PropTypes.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _react.PropTypes.string
	} : void 0;
	exports.default = Tab;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(240);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timeUtils = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var styles = {
	    root: {
	      directionInvariant: true,
	      display: 'inline-block',
	      position: 'absolute',
	      width: 32,
	      height: 32,
	      borderRadius: '100%',
	      left: 'calc(50% - 16px)',
	      top: 10,
	      textAlign: 'center',
	      paddingTop: 5,
	      userSelect: 'none', /* Chrome all / Safari all */
	      fontSize: '1.1em',
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    }
	  };
	
	  var muiTheme = context.muiTheme;
	
	
	  var pos = props.value;
	
	  if (props.type === 'hour') {
	    pos %= 12;
	  } else {
	    pos = pos / 5;
	  }
	
	  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	  if (props.isSelected) {
	    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
	    styles.root.color = muiTheme.timePicker.selectTextColor;
	  }
	
	  var transformPos = positions[pos];
	
	  if ((0, _timeUtils.isInner)(props)) {
	    styles.root.width = 28;
	    styles.root.height = 28;
	    styles.root.left = 'calc(50% - 14px)';
	    transformPos = innerPositions[pos];
	  }
	
	  var _transformPos = transformPos,
	      _transformPos2 = (0, _slicedToArray3.default)(_transformPos, 2),
	      x = _transformPos2[0],
	      y = _transformPos2[1];
	
	  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	  return styles;
	}
	
	var ClockNumber = function (_Component) {
	  (0, _inherits3.default)(ClockNumber, _Component);
	
	  function ClockNumber() {
	    (0, _classCallCheck3.default)(this, ClockNumber);
	    return (0, _possibleConstructorReturn3.default)(this, (ClockNumber.__proto__ || (0, _getPrototypeOf2.default)(ClockNumber)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ClockNumber, [{
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var clockNumber = this.props.value === 0 ? '00' : this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles(styles.root) },
	        clockNumber
	      );
	    }
	  }]);
	  return ClockNumber;
	}(_react.Component);
	
	ClockNumber.defaultProps = {
	  value: 0,
	  type: 'minute',
	  isSelected: false
	};
	ClockNumber.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ClockNumber.propTypes = {
	  isSelected: _react.PropTypes.bool,
	  onSelected: _react.PropTypes.func,
	  type: _react.PropTypes.oneOf(['hour', 'minute']),
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = ClockNumber;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timeUtils = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcAngle(value, base) {
	  value %= base;
	  var angle = 360 / base * value;
	  return angle;
	}
	
	function getStyles(props, context, state) {
	  var hasSelected = props.hasSelected,
	      type = props.type,
	      value = props.value;
	  var inner = state.inner;
	  var timePicker = context.muiTheme.timePicker;
	
	  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);
	
	  var styles = {
	    root: {
	      height: inner ? '30%' : '40%',
	      background: timePicker.accentColor,
	      width: 2,
	      left: 'calc(50% - 1px)',
	      position: 'absolute',
	      bottom: '50%',
	      transformOrigin: 'bottom',
	      pointerEvents: 'none',
	      transform: 'rotateZ(' + angle + 'deg)'
	    },
	    mark: {
	      boxSizing: 'content-box',
	      background: timePicker.selectTextColor,
	      border: '4px solid ' + timePicker.accentColor,
	      display: hasSelected && 'none',
	      width: 7,
	      height: 7,
	      position: 'absolute',
	      top: -5,
	      left: -6,
	      borderRadius: '100%'
	    }
	  };
	
	  return styles;
	}
	
	var ClockPointer = function (_Component) {
	  (0, _inherits3.default)(ClockPointer, _Component);
	
	  function ClockPointer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockPointer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockPointer.__proto__ || (0, _getPrototypeOf2.default)(ClockPointer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inner: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockPointer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(this.props)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(nextProps)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.value === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
	      );
	    }
	  }]);
	  return ClockPointer;
	}(_react.Component);
	
	ClockPointer.defaultProps = {
	  hasSelected: false,
	  value: null,
	  type: 'minute'
	};
	ClockPointer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ClockPointer.propTypes = {
	  hasSelected: _react.PropTypes.bool,
	  type: _react.PropTypes.oneOf(['hour', 'minute']),
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = ClockPointer;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var firstChild = props.firstChild,
	      lastChild = props.lastChild;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  var marginHorizontal = baseTheme.spacing.desktopGutter;
	  var marginVertical = (toolbar.height - button.height) / 2;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      marginLeft: firstChild ? -marginHorizontal : undefined,
	      marginRight: lastChild ? -marginHorizontal : undefined,
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center'
	    },
	    dropDownMenu: {
	      root: {
	        color: toolbar.color, // removes hover color change, we want to keep it
	        marginRight: baseTheme.spacing.desktopGutter,
	        flex: 1,
	        whiteSpace: 'nowrap'
	      },
	      controlBg: {
	        backgroundColor: toolbar.menuHoverColor,
	        borderRadius: 0
	      },
	      underline: {
	        display: 'none'
	      }
	    },
	    button: {
	      margin: marginVertical + 'px ' + marginHorizontal + 'px',
	      position: 'relative'
	    },
	    icon: {
	      root: {
	        cursor: 'pointer',
	        lineHeight: toolbar.height + 'px',
	        paddingLeft: baseTheme.spacing.desktopGutter
	      }
	    },
	    span: {
	      color: toolbar.iconColor,
	      lineHeight: toolbar.height + 'px'
	    }
	  };
	
	  return styles;
	}
	
	var ToolbarGroup = function (_Component) {
	  (0, _inherits3.default)(ToolbarGroup, _Component);
	
	  function ToolbarGroup() {
	    (0, _classCallCheck3.default)(this, ToolbarGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarGroup, [{
	    key: 'handleMouseLeaveFontIcon',
	    value: function handleMouseLeaveFontIcon(style) {
	      return function (event) {
	        event.target.style.zIndex = 'auto';
	        event.target.style.color = style.root.color;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          firstChild = _props.firstChild,
	          lastChild = _props.lastChild,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (!currentChild) {
	          return null;
	        }
	        if (!currentChild.type) {
	          return currentChild;
	        }
	        switch (currentChild.type.muiName) {
	          case 'DropDownMenu':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
	              underlineStyle: styles.dropDownMenu.underline
	            });
	          case 'RaisedButton':
	          case 'FlatButton':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
	            });
	          case 'FontIcon':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
	              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
	              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
	            });
	          case 'ToolbarSeparator':
	          case 'ToolbarTitle':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
	            });
	          default:
	            return currentChild;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        newChildren
	      );
	    }
	  }]);
	  return ToolbarGroup;
	}(_react.Component);
	
	ToolbarGroup.defaultProps = {
	  firstChild: false,
	  lastChild: false
	};
	ToolbarGroup.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ToolbarGroup.propTypes = {
	  /**
	   * Can be any node or number of nodes.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	   * to prevent setting the left gap.
	   */
	  firstChild: _react.PropTypes.bool,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	   * to prevent setting the right gap.
	   */
	  lastChild: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ToolbarGroup;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      backgroundColor: toolbar.separatorColor,
	      display: 'block',
	      height: baseTheme.spacing.desktopGutterMore,
	      marginLeft: baseTheme.spacing.desktopGutter,
	      width: 1
	    }
	  };
	}
	
	var ToolbarSeparator = function (_Component) {
	  (0, _inherits3.default)(ToolbarSeparator, _Component);
	
	  function ToolbarSeparator() {
	    (0, _classCallCheck3.default)(this, ToolbarSeparator);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	    }
	  }]);
	  return ToolbarSeparator;
	}(_react.Component);
	
	ToolbarSeparator.muiName = 'ToolbarSeparator';
	ToolbarSeparator.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ToolbarSeparator.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ToolbarSeparator;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      lineHeight: toolbar.height + 'px',
	      fontSize: toolbar.titleFontSize,
	      fontFamily: baseTheme.fontFamily,
	      position: 'relative',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    }
	  };
	}
	
	var ToolbarTitle = function (_Component) {
	  (0, _inherits3.default)(ToolbarTitle, _Component);
	
	  function ToolbarTitle() {
	    (0, _classCallCheck3.default)(this, ToolbarTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          text = _props.text,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'text']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style))
	        }, other),
	        text
	      );
	    }
	  }]);
	  return ToolbarTitle;
	}(_react.Component);
	
	ToolbarTitle.muiName = 'ToolbarTitle';
	ToolbarTitle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ToolbarTitle.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to be displayed.
	   */
	  text: _react.PropTypes.node
	} : void 0;
	exports.default = ToolbarTitle;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BeforeAfterWrapper = __webpack_require__(1777);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	 false ? ClearFix.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = ClearFix;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(1776);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoLockScrolling = _props.autoLockScrolling,
	          show = _props.show,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Overlay.propTypes = {
	  autoLockScrolling: _react.PropTypes.bool,
	  show: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  transitionEnabled: _react.PropTypes.bool
	} : void 0;
	exports.default = Overlay;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(35);
	
	var _dom = __webpack_require__(633);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RenderToLayer.propTypes = {
	  componentClickAway: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  render: _react.PropTypes.func.isRequired,
	  useLayerForClickAway: _react.PropTypes.bool
	} : void 0;
	exports.default = RenderToLayer;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: borderRadius,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: 0.9,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tooltip.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  horizontalPosition: _react.PropTypes.oneOf(['left', 'right', 'center']),
	  label: _react.PropTypes.node.isRequired,
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  touch: _react.PropTypes.bool,
	  verticalPosition: _react.PropTypes.oneOf(['top', 'bottom'])
	} : void 0;
	exports.default = Tooltip;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(214);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(490);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsTransitionGroup = __webpack_require__(223);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _dom = __webpack_require__(633);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(1778);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none'
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TouchRipple.propTypes = {
	  abortOnScroll: _react.PropTypes.bool,
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TouchRipple;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (false) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var wrapDisplayName = require('./wrapDisplayName').default;
	      /* eslint-enable global-require */
	
	      if (noArgs) {
	        return {
	          v: function v(BaseComponent) {
	            var Component = func(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          }
	        };
	      }
	
	      return {
	        v: function v() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return function (BaseComponent) {
	            var Component = func.apply(undefined, args)(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          };
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _getMuiTheme = __webpack_require__(393);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? MuiThemeProvider.propTypes = {
	  children: _react.PropTypes.element,
	  muiTheme: _react.PropTypes.object
	} : void 0;
	exports.default = MuiThemeProvider;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCancel = function NavigationCancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
	  );
	};
	NavigationCancel = (0, _pure2.default)(NavigationCancel);
	NavigationCancel.displayName = 'NavigationCancel';
	NavigationCancel.muiName = 'SvgIcon';
	
	exports.default = NavigationCancel;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
	ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
	ToggleRadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonChecked;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
	ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
	ToggleRadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonUnchecked;

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 749 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 752 */
/***/ (function(module, exports) {

	var component = /-?\d+(\.\d+)?%?/g;
	function extractComponents(color) {
	  return color.match(component);
	}
	
	module.exports = extractComponents;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(2895);


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	var invariant = __webpack_require__(22);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return _assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = '$push';
	var COMMAND_UNSHIFT = '$unshift';
	var COMMAND_SPLICE = '$splice';
	var COMMAND_SET = '$set';
	var COMMAND_MERGE = '$merge';
	var COMMAND_APPLY = '$apply';
	
	var ALL_COMMANDS_LIST = [
	  COMMAND_PUSH,
	  COMMAND_UNSHIFT,
	  COMMAND_SPLICE,
	  COMMAND_SET,
	  COMMAND_MERGE,
	  COMMAND_APPLY
	];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function(command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  );
	  var specValue = spec[command];
	  invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	      'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  );
	}
	
	/**
	 * Returns a updated shallow copy of an object without mutating the original.
	 * See https://facebook.github.io/react/docs/update.html for details.
	 */
	function update(value, spec) {
	  invariant(
	    typeof spec === 'object',
	    'update(): You provided a key path to update() that did not contain one ' +
	      'of %s. Did you forget to include {%s: ...}?',
	    ALL_COMMANDS_LIST.join(', '),
	    COMMAND_SET
	  );
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    invariant(
	      Object.keys(spec).length === 1,
	      'Cannot have more than one key in an object with %s',
	      COMMAND_SET
	    );
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    invariant(
	      mergeObj && typeof mergeObj === 'object',
	      "update(): %s expects a spec of type 'object'; got %s",
	      COMMAND_MERGE,
	      mergeObj
	    );
	    invariant(
	      nextValue && typeof nextValue === 'object',
	      "update(): %s expects a target of type 'object'; got %s",
	      COMMAND_MERGE,
	      nextValue
	    );
	    _assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function(item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function(item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    invariant(
	      Array.isArray(value),
	      'Expected %s target to be an array; got %s',
	      COMMAND_SPLICE,
	      value
	    );
	    invariant(
	      Array.isArray(spec[COMMAND_SPLICE]),
	      'update(): expected spec of %s to be an array of arrays; got %s. ' +
	        'Did you forget to wrap your parameters in an array?',
	      COMMAND_SPLICE,
	      spec[COMMAND_SPLICE]
	    );
	    spec[COMMAND_SPLICE].forEach(function(args) {
	      invariant(
	        Array.isArray(args),
	        'update(): expected spec of %s to be an array of arrays; got %s. ' +
	          'Did you forget to wrap your parameters in an array?',
	        COMMAND_SPLICE,
	        spec[COMMAND_SPLICE]
	      );
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    invariant(
	      typeof spec[COMMAND_APPLY] === 'function',
	      'update(): expected spec of %s to be a function; got %s.',
	      COMMAND_APPLY,
	      spec[COMMAND_APPLY]
	    );
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBase16Theme = exports.createStyling = exports.invertTheme = undefined;
	
	var _typeof2 = __webpack_require__(126);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(240);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _keys = __webpack_require__(142);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(1591);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _base = __webpack_require__(491);
	
	var base16 = _interopRequireWildcard(_base);
	
	var _rgb2hex = __webpack_require__(2756);
	
	var _rgb2hex2 = _interopRequireDefault(_rgb2hex);
	
	var _parse = __webpack_require__(2759);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _lodash3 = __webpack_require__(1593);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _colorConverters = __webpack_require__(2766);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_BASE16 = base16.default;
	
	var BASE16_KEYS = (0, _keys2.default)(DEFAULT_BASE16);
	
	// we need a correcting factor, so that a dark, but not black background color
	// converts to bright enough inversed color
	var flip = function flip(x) {
	  return x < 0.25 ? 1 : x < 0.5 ? 0.9 - x : 1.1 - x;
	};
	
	var invertColor = (0, _lodash4.default)(_parse2.default, _colorConverters.rgb2yuv, function (_ref) {
	  var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
	      y = _ref2[0],
	      u = _ref2[1],
	      v = _ref2[2];
	
	  return [flip(y), u, v];
	}, _colorConverters.yuv2rgb, _rgb2hex2.default);
	
	var merger = function merger(styling) {
	  return function (prevStyling) {
	    return {
	      className: [prevStyling.className, styling.className].filter(Boolean).join(' '),
	      style: (0, _extends3.default)({}, prevStyling.style || {}, styling.style || {})
	    };
	  };
	};
	
	var mergeStyling = function mergeStyling(customStyling, defaultStyling) {
	  if (customStyling === undefined) {
	    return defaultStyling;
	  }
	  if (defaultStyling === undefined) {
	    return customStyling;
	  }
	
	  var customType = typeof customStyling === 'undefined' ? 'undefined' : (0, _typeof3.default)(customStyling);
	  var defaultType = typeof defaultStyling === 'undefined' ? 'undefined' : (0, _typeof3.default)(defaultStyling);
	
	  switch (customType) {
	    case 'string':
	      switch (defaultType) {
	        case 'string':
	          return [defaultStyling, customStyling].filter(Boolean).join(' ');
	        case 'object':
	          return merger({ className: customStyling, style: defaultStyling });
	        case 'function':
	          return function (styling) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	              args[_key - 1] = arguments[_key];
	            }
	
	            return merger({
	              className: customStyling
	            })(defaultStyling.apply(undefined, [styling].concat(args)));
	          };
	      }
	    case 'object':
	      switch (defaultType) {
	        case 'string':
	          return merger({ className: defaultStyling, style: customStyling });
	        case 'object':
	          return (0, _extends3.default)({}, defaultStyling, customStyling);
	        case 'function':
	          return function (styling) {
	            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            return merger({
	              style: customStyling
	            })(defaultStyling.apply(undefined, [styling].concat(args)));
	          };
	      }
	    case 'function':
	      switch (defaultType) {
	        case 'string':
	          return function (styling) {
	            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	              args[_key3 - 1] = arguments[_key3];
	            }
	
	            return customStyling.apply(undefined, [merger(styling)({
	              className: defaultStyling
	            })].concat(args));
	          };
	        case 'object':
	          return function (styling) {
	            for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	              args[_key4 - 1] = arguments[_key4];
	            }
	
	            return customStyling.apply(undefined, [merger(styling)({
	              style: defaultStyling
	            })].concat(args));
	          };
	        case 'function':
	          return function (styling) {
	            for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	              args[_key5 - 1] = arguments[_key5];
	            }
	
	            return customStyling.apply(undefined, [defaultStyling.apply(undefined, [styling].concat(args))].concat(args));
	          };
	      }
	  }
	};
	
	var mergeStylings = function mergeStylings(customStylings, defaultStylings) {
	  var keys = (0, _keys2.default)(defaultStylings);
	  for (var key in customStylings) {
	    if (keys.indexOf(key) === -1) keys.push(key);
	  }
	
	  return keys.reduce(function (mergedStyling, key) {
	    return mergedStyling[key] = mergeStyling(customStylings[key], defaultStylings[key]), mergedStyling;
	  }, {});
	};
	
	var getStylingByKeys = function getStylingByKeys(mergedStyling, keys) {
	  for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
	    args[_key6 - 2] = arguments[_key6];
	  }
	
	  if (keys === null) {
	    return mergedStyling;
	  }
	
	  if (!Array.isArray(keys)) {
	    keys = [keys];
	  }
	
	  var styles = keys.map(function (key) {
	    return mergedStyling[key];
	  }).filter(Boolean);
	
	  var props = styles.reduce(function (obj, s) {
	    if (typeof s === 'string') {
	      obj.className = [obj.className, s].filter(Boolean).join(' ');
	    } else if ((typeof s === 'undefined' ? 'undefined' : (0, _typeof3.default)(s)) === 'object') {
	      obj.style = (0, _extends3.default)({}, obj.style, s);
	    } else if (typeof s === 'function') {
	      obj = (0, _extends3.default)({}, obj, s.apply(undefined, [obj].concat(args)));
	    }
	
	    return obj;
	  }, { className: '', style: {} });
	
	  if (!props.className) {
	    delete props.className;
	  }
	
	  if ((0, _keys2.default)(props.style).length === 0) {
	    delete props.style;
	  }
	
	  return props;
	};
	
	var invertTheme = exports.invertTheme = function invertTheme(theme) {
	  return (0, _keys2.default)(theme).reduce(function (t, key) {
	    return t[key] = /^base/.test(key) ? invertColor(theme[key]) : key === 'scheme' ? theme[key] + ':inverted' : theme[key], t;
	  }, {});
	};
	
	var createStyling = exports.createStyling = (0, _lodash2.default)(function (getStylingFromBase16) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
	    args[_key7 - 3] = arguments[_key7];
	  }
	
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var themeOrStyling = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var _options$defaultBase = options.defaultBase16,
	      defaultBase16 = _options$defaultBase === undefined ? DEFAULT_BASE16 : _options$defaultBase,
	      _options$base16Themes = options.base16Themes,
	      base16Themes = _options$base16Themes === undefined ? null : _options$base16Themes;
	
	
	  var base16Theme = getBase16Theme(themeOrStyling, base16Themes);
	  if (base16Theme) {
	    themeOrStyling = (0, _extends3.default)({}, base16Theme, themeOrStyling);
	  }
	
	  var theme = BASE16_KEYS.reduce(function (t, key) {
	    return t[key] = themeOrStyling[key] || defaultBase16[key], t;
	  }, {});
	
	  var customStyling = (0, _keys2.default)(themeOrStyling).reduce(function (s, key) {
	    return BASE16_KEYS.indexOf(key) === -1 ? (s[key] = themeOrStyling[key], s) : s;
	  }, {});
	
	  var defaultStyling = getStylingFromBase16(theme);
	
	  var mergedStyling = mergeStylings(customStyling, defaultStyling);
	
	  return (0, _lodash2.default)(getStylingByKeys, 2).apply(undefined, [mergedStyling].concat(args));
	}, 3);
	
	var getBase16Theme = exports.getBase16Theme = function getBase16Theme(theme, base16Themes) {
	  if (theme && theme.extend) {
	    theme = theme.extend;
	  }
	
	  if (typeof theme === 'string') {
	    var _theme$split = theme.split(':'),
	        _theme$split2 = (0, _slicedToArray3.default)(_theme$split, 2),
	        themeName = _theme$split2[0],
	        modifier = _theme$split2[1];
	
	    theme = (base16Themes || {})[themeName] || base16[themeName];
	    if (modifier === 'inverted') {
	      theme = invertTheme(theme);
	    }
	  }
	
	  return theme && theme.hasOwnProperty('base00') ? theme : undefined;
	};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var JSONArrow = function JSONArrow(_ref) {
	  var styling = _ref.styling,
	      arrowStyle = _ref.arrowStyle,
	      expanded = _ref.expanded,
	      nodeType = _ref.nodeType,
	      onClick = _ref.onClick;
	  return _react2['default'].createElement(
	    'div',
	    (0, _extends3['default'])({}, styling('arrowContainer', arrowStyle), {
	      onClick: onClick
	    }),
	    _react2['default'].createElement(
	      'div',
	      styling(['arrow', 'arrowSign'], nodeType, expanded, arrowStyle),
	      '\u25B6',
	      arrowStyle === 'double' && _react2['default'].createElement(
	        'div',
	        styling(['arrowSign', 'arrowSignInner']),
	        '\u25B6'
	      )
	    )
	  );
	};
	
	JSONArrow.propTypes = {
	  styling: _propTypes2['default'].func.isRequired,
	  arrowStyle: _propTypes2['default'].oneOf(['single', 'double']),
	  expanded: _propTypes2['default'].bool.isRequired,
	  nodeType: _propTypes2['default'].string.isRequired,
	  onClick: _propTypes2['default'].func.isRequired
	};
	
	JSONArrow.defaultProps = {
	  arrowStyle: 'single'
	};
	
	exports['default'] = JSONArrow;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objType = __webpack_require__(2780);
	
	var _objType2 = _interopRequireDefault(_objType);
	
	var _JSONObjectNode = __webpack_require__(2776);
	
	var _JSONObjectNode2 = _interopRequireDefault(_JSONObjectNode);
	
	var _JSONArrayNode = __webpack_require__(2774);
	
	var _JSONArrayNode2 = _interopRequireDefault(_JSONArrayNode);
	
	var _JSONIterableNode = __webpack_require__(2775);
	
	var _JSONIterableNode2 = _interopRequireDefault(_JSONIterableNode);
	
	var _JSONValueNode = __webpack_require__(2777);
	
	var _JSONValueNode2 = _interopRequireDefault(_JSONValueNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var JSONNode = function JSONNode(_ref) {
	  var getItemString = _ref.getItemString,
	      keyPath = _ref.keyPath,
	      labelRenderer = _ref.labelRenderer,
	      styling = _ref.styling,
	      value = _ref.value,
	      valueRenderer = _ref.valueRenderer,
	      isCustomNode = _ref.isCustomNode,
	      rest = (0, _objectWithoutProperties3['default'])(_ref, ['getItemString', 'keyPath', 'labelRenderer', 'styling', 'value', 'valueRenderer', 'isCustomNode']);
	
	  var nodeType = isCustomNode(value) ? 'Custom' : (0, _objType2['default'])(value);
	
	  var simpleNodeProps = {
	    getItemString: getItemString,
	    key: keyPath[0],
	    keyPath: keyPath,
	    labelRenderer: labelRenderer,
	    nodeType: nodeType,
	    styling: styling,
	    value: value,
	    valueRenderer: valueRenderer
	  };
	
	  var nestedNodeProps = (0, _extends3['default'])({}, rest, simpleNodeProps, {
	    data: value,
	    isCustomNode: isCustomNode
	  });
	
	  switch (nodeType) {
	    case 'Object':
	    case 'Error':
	    case 'WeakMap':
	    case 'WeakSet':
	      return _react2['default'].createElement(_JSONObjectNode2['default'], nestedNodeProps);
	    case 'Array':
	      return _react2['default'].createElement(_JSONArrayNode2['default'], nestedNodeProps);
	    case 'Iterable':
	    case 'Map':
	    case 'Set':
	      return _react2['default'].createElement(_JSONIterableNode2['default'], nestedNodeProps);
	    case 'String':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
	          return '"' + raw + '"';
	        } }));
	    case 'Number':
	      return _react2['default'].createElement(_JSONValueNode2['default'], simpleNodeProps);
	    case 'Boolean':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
	          return raw ? 'true' : 'false';
	        } }));
	    case 'Date':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
	          return raw.toISOString();
	        } }));
	    case 'Null':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter() {
	          return 'null';
	        } }));
	    case 'Undefined':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter() {
	          return 'undefined';
	        } }));
	    case 'Function':
	    case 'Symbol':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
	          return raw.toString();
	        } }));
	    case 'Custom':
	      return _react2['default'].createElement(_JSONValueNode2['default'], simpleNodeProps);
	    default:
	      return null;
	  }
	};
	
	JSONNode.propTypes = {
	  getItemString: _propTypes2['default'].func.isRequired,
	  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
	  labelRenderer: _propTypes2['default'].func.isRequired,
	  styling: _propTypes2['default'].func.isRequired,
	  value: _propTypes2['default'].any,
	  valueRenderer: _propTypes2['default'].func.isRequired,
	  isCustomNode: _propTypes2['default'].func.isRequired
	};
	
	exports['default'] = JSONNode;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(142);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _class, _temp; // ES6 + inline style port of JSONViewer https://bitbucket.org/davevedder/react-json-viewer/
	// all credits and original code to the author
	// Dave Vedder <veddermatic@gmail.com> http://www.eskimospy.com/
	// port by Daniele Zannotti http://www.github.com/dzannotti <dzannotti@me.com>
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONNode = __webpack_require__(757);
	
	var _JSONNode2 = _interopRequireDefault(_JSONNode);
	
	var _createStylingFromTheme = __webpack_require__(2778);
	
	var _createStylingFromTheme2 = _interopRequireDefault(_createStylingFromTheme);
	
	var _reactBase16Styling = __webpack_require__(755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var identity = function identity(value) {
	  return value;
	};
	var expandRootNode = function expandRootNode(keyName, data, level) {
	  return level === 0;
	};
	var defaultItemString = function defaultItemString(type, data, itemType, itemString) {
	  return _react2['default'].createElement(
	    'span',
	    null,
	    itemType,
	    ' ',
	    itemString
	  );
	};
	var defaultLabelRenderer = function defaultLabelRenderer(_ref) {
	  var label = _ref[0];
	  return _react2['default'].createElement(
	    'span',
	    null,
	    label,
	    ':'
	  );
	};
	var noCustomNode = function noCustomNode() {
	  return false;
	};
	
	function checkLegacyTheming(theme, props) {
	  var deprecatedStylingMethodsMap = {
	    getArrowStyle: 'arrow',
	    getListStyle: 'nestedNodeChildren',
	    getItemStringStyle: 'nestedNodeItemString',
	    getLabelStyle: 'label',
	    getValueStyle: 'valueText'
	  };
	
	  var deprecatedStylingMethods = (0, _keys2['default'])(deprecatedStylingMethodsMap).filter(function (name) {
	    return props[name];
	  });
	
	  if (deprecatedStylingMethods.length > 0) {
	    if (typeof theme === 'string') {
	      theme = {
	        extend: theme
	      };
	    } else {
	      theme = (0, _extends3['default'])({}, theme);
	    }
	
	    deprecatedStylingMethods.forEach(function (name) {
	      console.error( // eslint-disable-line no-console
	      'Styling method "' + name + '" is deprecated, use "theme" property instead');
	
	      theme[deprecatedStylingMethodsMap[name]] = function (_ref2) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        var style = _ref2.style;
	        return {
	          style: (0, _extends3['default'])({}, style, props[name].apply(props, args))
	        };
	      };
	    });
	  }
	
	  return theme;
	}
	
	function getStateFromProps(props) {
	  var theme = checkLegacyTheming(props.theme, props);
	  if (props.invertTheme) {
	    if (typeof theme === 'string') {
	      theme = theme + ':inverted';
	    } else if (theme && theme.extend) {
	      if (typeof theme === 'string') {
	        theme = (0, _extends3['default'])({}, theme, { extend: theme.extend + ':inverted' });
	      } else {
	        theme = (0, _extends3['default'])({}, theme, { extend: (0, _reactBase16Styling.invertTheme)(theme.extend) });
	      }
	    } else if (theme) {
	      theme = (0, _reactBase16Styling.invertTheme)(theme);
	    }
	  }
	  return {
	    styling: (0, _createStylingFromTheme2['default'])(theme)
	  };
	}
	
	var JSONTree = (_temp = _class = function (_React$Component) {
	  (0, _inherits3['default'])(JSONTree, _React$Component);
	
	  function JSONTree(props) {
	    (0, _classCallCheck3['default'])(this, JSONTree);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.state = getStateFromProps(props);
	    return _this;
	  }
	
	  JSONTree.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (['theme', 'invertTheme'].find(function (k) {
	      return nextProps[k] !== _this2.props[k];
	    })) {
	      this.setState(getStateFromProps(nextProps));
	    }
	  };
	
	  JSONTree.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var _this3 = this;
	
	    return !!(0, _keys2['default'])(nextProps).find(function (k) {
	      return k === 'keyPath' ? nextProps[k].join('/') !== _this3.props[k].join('/') : nextProps[k] !== _this3.props[k];
	    });
	  };
	
	  JSONTree.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.data,
	        keyPath = _props.keyPath,
	        postprocessValue = _props.postprocessValue,
	        hideRoot = _props.hideRoot,
	        theme = _props.theme,
	        _ = _props.invertTheme,
	        rest = (0, _objectWithoutProperties3['default'])(_props, ['data', 'keyPath', 'postprocessValue', 'hideRoot', 'theme', 'invertTheme']);
	    var styling = this.state.styling;
	
	
	    return _react2['default'].createElement(
	      'ul',
	      styling('tree'),
	      _react2['default'].createElement(_JSONNode2['default'], (0, _extends3['default'])({}, (0, _extends3['default'])({ postprocessValue: postprocessValue, hideRoot: hideRoot, styling: styling }, rest), {
	        keyPath: hideRoot ? [] : keyPath,
	        value: postprocessValue(value)
	      }))
	    );
	  };
	
	  return JSONTree;
	}(_react2['default'].Component), _class.propTypes = {
	  data: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]).isRequired,
	  hideRoot: _propTypes2['default'].bool,
	  theme: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
	  invertTheme: _propTypes2['default'].bool,
	  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	  postprocessValue: _propTypes2['default'].func,
	  sortObjectKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].bool])
	}, _class.defaultProps = {
	  shouldExpandNode: expandRootNode,
	  hideRoot: false,
	  keyPath: ['root'],
	  getItemString: defaultItemString,
	  labelRenderer: defaultLabelRenderer,
	  valueRenderer: identity,
	  postprocessValue: identity,
	  isCustomNode: noCustomNode,
	  collectionLimit: 50,
	  invertTheme: true
	}, _temp);
	exports['default'] = JSONTree;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStyles = exports.autoPrefixAndNormalizeStyles = exports.getColors = exports.keyframes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _keyframes;
	
	var _inlineStylePrefixer = __webpack_require__(2800);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	var _exenv = __webpack_require__(547);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var canUseDOM = _exenv2.default.canUseDOM;
	
	var KEYFRAME_PREFIX = "__react-md-spinner-animation__";
	
	var Keyframe = {
	  ROOT_ROTATE: "root-rotate",
	  FILL_UNFILL_ROTATE: "fill-unfill-rotate",
	  LAYER_1_FADE_IN_OUT: "layer-1-fade-in-out",
	  LAYER_2_FADE_IN_OUT: "layer-2-fade-in-out",
	  LAYER_3_FADE_IN_OUT: "layer-3-fade-in-out",
	  LAYER_4_FADE_IN_OUT: "layer-4-fade-in-out",
	  LEFT_SPIN: "left-spin",
	  RIGHT_SPIN: "right-spin"
	};
	
	Object.keys(Keyframe).forEach(function (key) {
	  Keyframe[key] = KEYFRAME_PREFIX + Keyframe[key];
	});
	
	var keyframes = exports.keyframes = (_keyframes = {}, _defineProperty(_keyframes, Keyframe.ROOT_ROTATE, {
	  to: { transform: "rotate(360deg)" }
	}), _defineProperty(_keyframes, Keyframe.FILL_UNFILL_ROTATE, {
	  "12.5%": { transform: "rotate(135deg)" },
	  "25%": { transform: "rotate(270deg)" },
	  "37.5%": { transform: "rotate(405deg)" },
	  "50%": { transform: "rotate(540deg)" },
	  "62.5%": { transform: "rotate(675deg)" },
	  "75%": { transform: "rotate(810deg)" },
	  "87.5%": { transform: "rotate(945deg)" },
	  to: { transform: "rotate(1080deg)" }
	}), _defineProperty(_keyframes, Keyframe.LAYER_1_FADE_IN_OUT, {
	  "0%": { opacity: 1 },
	  "25%": { opacity: 1 },
	  "26%": { opacity: 0 },
	  "89%": { opacity: 0 },
	  "90%": { opacity: 1 },
	  to: { opacity: 1 }
	}), _defineProperty(_keyframes, Keyframe.LAYER_2_FADE_IN_OUT, {
	  "0%": { opacity: 0 },
	  "15%": { opacity: 0 },
	  "25%": { opacity: 1 },
	  "50%": { opacity: 1 },
	  "51%": { opacity: 0 },
	  to: { opacity: 0 }
	}), _defineProperty(_keyframes, Keyframe.LAYER_3_FADE_IN_OUT, {
	  "0%": { opacity: 0 },
	  "40%": { opacity: 0 },
	  "50%": { opacity: 1 },
	  "75%": { opacity: 1 },
	  "76%": { opacity: 0 },
	  to: { opacity: 0 }
	}), _defineProperty(_keyframes, Keyframe.LAYER_4_FADE_IN_OUT, {
	  "0%": { opacity: 0 },
	  "65%": { opacity: 0 },
	  "75%": { opacity: 1 },
	  "90%": { opacity: 1 },
	  to: { opacity: 0 }
	}), _defineProperty(_keyframes, Keyframe.LEFT_SPIN, {
	  from: { transform: "rotate(130deg)" },
	  "50%": { transform: "rotate(-5deg)" },
	  to: { transform: "rotate(130deg)" }
	}), _defineProperty(_keyframes, Keyframe.RIGHT_SPIN, {
	  from: { transform: "rotate(-130deg)" },
	  "50%": { transform: "rotate(5deg)" },
	  to: { transform: "rotate(-130deg)" }
	}), _keyframes);
	
	var getColors = exports.getColors = function getColors(props) {
	  var singleColor = props.singleColor,
	      color1 = props.color1,
	      color2 = props.color2,
	      color3 = props.color3,
	      color4 = props.color4;
	
	
	  return singleColor ? [singleColor, singleColor, singleColor, singleColor] : [color1, color2, color3, color4];
	};
	
	var autoPrefixAndNormalizeStyles = exports.autoPrefixAndNormalizeStyles = function autoPrefixAndNormalizeStyles(prefixer, styles) {
	  var isFlexBox = ["flex", "inline-flex"].indexOf(styles.hasOwnProperty("display") ? styles.display : null) > -1;
	
	  var prefixedStyles = prefixer.prefix(styles);
	
	  if (isFlexBox) {
	    var display = prefixedStyles.display;
	
	    var isArray = Array.isArray(display);
	
	    if (canUseDOM) {
	      prefixedStyles.display = isArray ? display[display.length - 1] : display;
	    } else {
	      prefixedStyles.display = isArray ? display.join("; display: ") : display;
	    }
	  }
	
	  return prefixedStyles;
	};
	
	var getStyles = exports.getStyles = function getStyles(props) {
	  var duration = props.duration,
	      userAgent = props.userAgent;
	
	  var size = parseInt(props.size, 10);
	  var colors = getColors(props);
	  var borderWidth = Math.max(1, Math.round(parseInt(size, 10) * 0.107142));
	  var arcSize = 270;
	  var arcStartRotate = 216;
	  var rootDuration = 360 * duration / (arcStartRotate + (360 - arcSize));
	  var prefixer = new _inlineStylePrefixer2.default({ userAgent: userAgent });
	
	  var rootStyle = autoPrefixAndNormalizeStyles(prefixer, {
	    display: "inline-block",
	    position: "relative",
	    width: size,
	    height: size,
	    verticalAlign: "middle",
	    animation: Keyframe.ROOT_ROTATE + " " + rootDuration + "ms linear infinite"
	  });
	
	  var layerStyle = autoPrefixAndNormalizeStyles(prefixer, {
	    display: "flex",
	    position: "absolute",
	    width: "100%",
	    height: "100%",
	    whiteSpace: "nowrap",
	    animationName: Keyframe.FILL_UNFILL_ROTATE,
	    animationDuration: duration * colors.length + "ms",
	    animationTimingFunction: "cubic-bezier(.4, 0, .2, 1)",
	    animationIterationCount: "infinite",
	    opacity: 1
	  });
	
	  var layerStyles = colors.map(function (color, i) {
	    return _extends({}, layerStyle, {
	      borderColor: color,
	      animationName: Keyframe.FILL_UNFILL_ROTATE + ", " + Keyframe["LAYER_" + (i + 1) + "_FADE_IN_OUT"]
	    });
	  });
	
	  var clipStyle = autoPrefixAndNormalizeStyles(prefixer, {
	    display: "inline-block",
	    position: "relative",
	    flexGrow: 1,
	    height: "100%",
	    overflow: "hidden",
	    borderColor: "inherit"
	  });
	
	  var layerClipAfterStyle = {
	    boxSizing: "border-box",
	    position: "absolute",
	    top: 0,
	    borderRadius: "50%"
	  };
	
	  var layerAfterStyle = autoPrefixAndNormalizeStyles(prefixer, _extends({}, layerClipAfterStyle, {
	    left: "45%",
	    width: "10%",
	    borderWidth: borderWidth,
	    borderColor: "inherit",
	    borderTopStyle: "solid"
	  }));
	
	  var clipAfterStyle = _extends({}, layerClipAfterStyle, {
	    bottom: 0,
	    width: "200%",
	    borderWidth: borderWidth,
	    borderStyle: "solid",
	    animationDuration: duration + "ms",
	    animationTimingFunction: "cubic-bezier(.4, 0, .2, 1)",
	    animationIterationCount: "infinite"
	  });
	
	  var clip1AfterStyle = autoPrefixAndNormalizeStyles(prefixer, _extends({}, clipAfterStyle, {
	    left: 0,
	    transform: "rotate(129deg)",
	    animationName: Keyframe.LEFT_SPIN
	  }));
	
	  var clip1AfterStyles = colors.map(function (color) {
	    return _extends({}, clip1AfterStyle, {
	      borderColor: color + " transparent transparent " + color
	    });
	  });
	
	  var clip2AfterStyle = autoPrefixAndNormalizeStyles(prefixer, _extends({}, clipAfterStyle, {
	    left: "-100%",
	    transform: "rotate(-129deg)",
	    animationName: Keyframe.RIGHT_SPIN
	  }));
	
	  var clip2AfterStyles = colors.map(function (color) {
	    return _extends({}, clip2AfterStyle, {
	      borderColor: color + " " + color + " transparent transparent"
	    });
	  });
	
	  return {
	    rootStyle: rootStyle,
	    layerStyles: layerStyles,
	    layerAfterStyle: layerAfterStyle,
	    clipStyle: clipStyle,
	    clip1AfterStyles: clip1AfterStyles,
	    clip2AfterStyles: clip2AfterStyles
	  };
	};

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    );if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(135);
	
	var _PatternUtils = __webpack_require__(189);
	
	var _InternalPropTypes = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(282);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(284);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(778);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(2858);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(773);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(282);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(284);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(778);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(283);
	
	var _DOMUtils = __webpack_require__(405);
	
	var _createHistory = __webpack_require__(777);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(190);
	
	var _PathUtils = __webpack_require__(164);
	
	var _ExecutionEnvironment = __webpack_require__(283);
	
	var _DOMUtils = __webpack_require__(405);
	
	var _DOMStateStorage = __webpack_require__(774);
	
	var _createDOMHistory = __webpack_require__(775);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(1515);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(164);
	
	var _AsyncUtils = __webpack_require__(2855);
	
	var _Actions = __webpack_require__(190);
	
	var _createLocation2 = __webpack_require__(2857);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(407);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(406);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(283);
	
	var _PathUtils = __webpack_require__(164);
	
	var _runTransitionHook = __webpack_require__(407);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(406);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(285),
	    _assign = __webpack_require__(36);
	
	var ReactNoopUpdateQueue = __webpack_require__(782);
	
	var canDefineProperty = __webpack_require__(783);
	var emptyObject = __webpack_require__(157);
	var invariant = __webpack_require__(22);
	var lowPriorityWarning = __webpack_require__(2870);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(25);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.jQuery = exports.animation = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsUpdate = __webpack_require__(754);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _animationMixin = __webpack_require__(2881);
	
	var _animationMixin2 = _interopRequireDefault(_animationMixin);
	
	var _jQueryMixin = __webpack_require__(2882);
	
	var _jQueryMixin2 = _interopRequireDefault(_jQueryMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function noop() {}
	
	var ToastMessageSpec = {
	  displayName: "ToastMessage",
	
	  getDefaultProps: function getDefaultProps() {
	    var iconClassNames = {
	      error: "toast-error",
	      info: "toast-info",
	      success: "toast-success",
	      warning: "toast-warning"
	    };
	
	    return {
	      className: "toast",
	      iconClassNames: iconClassNames,
	      titleClassName: "toast-title",
	      messageClassName: "toast-message",
	      tapToDismiss: true,
	      closeButton: false
	    };
	  },
	  handleOnClick: function handleOnClick(event) {
	    this.props.handleOnClick(event);
	    if (this.props.tapToDismiss) {
	      this.hideToast(true);
	    }
	  },
	  _handle_close_button_click: function _handle_close_button_click(event) {
	    event.stopPropagation();
	    this.hideToast(true);
	  },
	  _handle_remove: function _handle_remove() {
	    this.props.handleRemove(this.props.toastId);
	  },
	  _render_close_button: function _render_close_button() {
	    return this.props.closeButton ? _react2.default.createElement("button", {
	      className: "toast-close-button", role: "button",
	      onClick: this._handle_close_button_click,
	      dangerouslySetInnerHTML: { __html: "&times;" }
	    }) : false;
	  },
	  _render_title_element: function _render_title_element() {
	    return this.props.title ? _react2.default.createElement(
	      "div",
	      { className: this.props.titleClassName },
	      this.props.title
	    ) : false;
	  },
	  _render_message_element: function _render_message_element() {
	    return this.props.message ? _react2.default.createElement(
	      "div",
	      { className: this.props.messageClassName },
	      this.props.message
	    ) : false;
	  },
	  render: function render() {
	    var iconClassName = this.props.iconClassName || this.props.iconClassNames[this.props.type];
	
	    return _react2.default.createElement(
	      "div",
	      {
	        className: (0, _classnames2.default)(this.props.className, iconClassName),
	        style: this.props.style,
	        onClick: this.handleOnClick,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave
	      },
	      this._render_close_button(),
	      this._render_title_element(),
	      this._render_message_element()
	    );
	  }
	};
	
	var animation = exports.animation = _react2.default.createClass((0, _reactAddonsUpdate2.default)(ToastMessageSpec, {
	  displayName: { $set: "ToastMessage.animation" },
	  mixins: { $set: [_animationMixin2.default] }
	}));
	
	var jQuery = exports.jQuery = _react2.default.createClass((0, _reactAddonsUpdate2.default)(ToastMessageSpec, {
	  displayName: { $set: "ToastMessage.jQuery" },
	  mixins: { $set: [_jQueryMixin2.default] }
	}));
	
	/*
	 * assign default noop functions
	 */
	ToastMessageSpec.handleMouseEnter = noop;
	ToastMessageSpec.handleMouseLeave = noop;
	ToastMessageSpec.hideToast = noop;
	
	var ToastMessage = _react2.default.createClass(ToastMessageSpec);
	
	ToastMessage.animation = animation;
	ToastMessage.jQuery = jQuery;
	
	exports.default = ToastMessage;

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(1260);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(2897);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(2898);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(136);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(193);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactDOMInstrumentation = __webpack_require__(2920);
	var ReactInstrumentation = __webpack_require__(82);
	
	var quoteAttributeValueForBrowser = __webpack_require__(2961);
	var warning = __webpack_require__(25);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onCreateMarkupForProperty(name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onSetValueForProperty(node, name, value);
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(136);
	var ReactElement = __webpack_require__(108);
	
	var emptyFunction = __webpack_require__(65);
	var traverseAllChildren = __webpack_require__(431);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var ReactComponent = __webpack_require__(415);
	var ReactElement = __webpack_require__(108);
	var ReactPropTypeLocations = __webpack_require__(421);
	var ReactPropTypeLocationNames = __webpack_require__(420);
	var ReactNoopUpdateQueue = __webpack_require__(419);
	
	var emptyObject = __webpack_require__(157);
	var invariant = __webpack_require__(22);
	var keyMirror = __webpack_require__(261);
	var keyOf = __webpack_require__(133);
	var warning = __webpack_require__(25);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(410);
	var ReactDOMIDOperations = __webpack_require__(2918);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {}
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var DisabledInputUtils = __webpack_require__(286);
	var LinkedValueUtils = __webpack_require__(414);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(109);
	
	var warning = __webpack_require__(25);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var invariant = __webpack_require__(22);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(2922);
	
	var containsNode = __webpack_require__(1536);
	var focusNode = __webpack_require__(549);
	var getActiveElement = __webpack_require__(550);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var DOMLazyTree = __webpack_require__(192);
	var DOMProperty = __webpack_require__(193);
	var ReactBrowserEventEmitter = __webpack_require__(288);
	var ReactCurrentOwner = __webpack_require__(137);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactDOMContainerInfo = __webpack_require__(2914);
	var ReactDOMFeatureFlags = __webpack_require__(2917);
	var ReactElement = __webpack_require__(108);
	var ReactFeatureFlags = __webpack_require__(797);
	var ReactInstanceMap = __webpack_require__(225);
	var ReactInstrumentation = __webpack_require__(82);
	var ReactMarkupChecksum = __webpack_require__(2931);
	var ReactReconciler = __webpack_require__(196);
	var ReactUpdateQueue = __webpack_require__(423);
	var ReactUpdates = __webpack_require__(109);
	
	var emptyObject = __webpack_require__(157);
	var instantiateReactComponent = __webpack_require__(812);
	var invariant = __webpack_require__(22);
	var setInnerHTML = __webpack_require__(291);
	var shouldUpdateReactComponent = __webpack_require__(430);
	var warning = __webpack_require__(25);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context);
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by devtools!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    if (false) {
	      // The instance here is TopLevelWrapper so we report mount for its child.
	      ReactInstrumentation.debugTool.onMountRootComponent(componentInstance._renderedComponent._debugID);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(261);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactElement = __webpack_require__(108);
	
	var invariant = __webpack_require__(22);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(108);
	var ReactPropTypeLocationNames = __webpack_require__(420);
	var ReactPropTypesSecret = __webpack_require__(422);
	
	var emptyFunction = __webpack_require__(65);
	var getIteratorFn = __webpack_require__(809);
	var warning = __webpack_require__(25);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.0';

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(802);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var ReactCompositeComponent = __webpack_require__(2910);
	var ReactEmptyComponent = __webpack_require__(796);
	var ReactHostComponent = __webpack_require__(798);
	var ReactInstrumentation = __webpack_require__(82);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getDisplayName(instance) {
	  var element = instance._currentElement;
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else if (instance.getName) {
	    return instance.getName() || 'Unknown';
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    if (shouldHaveDebugID) {
	      var debugID = nextDebugID++;
	      instance._debugID = debugID;
	      var displayName = getDisplayName(instance);
	      ReactInstrumentation.debugTool.onSetDisplayName(debugID, displayName);
	      var owner = node && node._owner;
	      if (owner) {
	        ReactInstrumentation.debugTool.onSetOwner(debugID, owner._debugID);
	      }
	    } else {
	      instance._debugID = 0;
	    }
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	var escapeTextContentForBrowser = __webpack_require__(290);
	var setInnerHTML = __webpack_require__(291);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.toggleVisibility = toggleVisibility;
	exports.changePosition = changePosition;
	exports.changeSize = changeSize;
	exports.changeMonitor = changeMonitor;
	var TOGGLE_VISIBILITY = exports.TOGGLE_VISIBILITY = '@@redux-devtools-log-monitor/TOGGLE_VISIBILITY';
	function toggleVisibility() {
	  return { type: TOGGLE_VISIBILITY };
	}
	
	var CHANGE_POSITION = exports.CHANGE_POSITION = '@@redux-devtools-log-monitor/CHANGE_POSITION';
	function changePosition() {
	  return { type: CHANGE_POSITION };
	}
	
	var CHANGE_SIZE = exports.CHANGE_SIZE = '@@redux-devtools-log-monitor/CHANGE_SIZE';
	function changeSize(size) {
	  return { type: CHANGE_SIZE, size: size };
	}
	
	var CHANGE_MONITOR = exports.CHANGE_MONITOR = '@@redux-devtools-log-monitor/CHANGE_MONITOR';
	function changeMonitor() {
	  return { type: CHANGE_MONITOR };
	}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var POSITIONS = exports.POSITIONS = ['left', 'top', 'right', 'bottom'];

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.INIT_ACTION = exports.ActionCreators = exports.ActionTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.liftAction = liftAction;
	exports.liftReducerWith = liftReducerWith;
	exports.unliftState = unliftState;
	exports.unliftStore = unliftStore;
	exports.default = instrument;
	
	var _difference = __webpack_require__(1679);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _union = __webpack_require__(1689);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _isPlainObject = __webpack_require__(270);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(833);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = {
	  PERFORM_ACTION: 'PERFORM_ACTION',
	  RESET: 'RESET',
	  ROLLBACK: 'ROLLBACK',
	  COMMIT: 'COMMIT',
	  SWEEP: 'SWEEP',
	  TOGGLE_ACTION: 'TOGGLE_ACTION',
	  SET_ACTIONS_ACTIVE: 'SET_ACTIONS_ACTIVE',
	  JUMP_TO_STATE: 'JUMP_TO_STATE',
	  JUMP_TO_ACTION: 'JUMP_TO_ACTION',
	  REORDER_ACTION: 'REORDER_ACTION',
	  IMPORT_STATE: 'IMPORT_STATE',
	  LOCK_CHANGES: 'LOCK_CHANGES',
	  PAUSE_RECORDING: 'PAUSE_RECORDING'
	};
	
	/**
	 * Action creators to change the History state.
	 */
	var ActionCreators = exports.ActionCreators = {
	  performAction: function performAction(action) {
	    if (!(0, _isPlainObject2.default)(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    return { type: ActionTypes.PERFORM_ACTION, action: action, timestamp: Date.now() };
	  },
	  reset: function reset() {
	    return { type: ActionTypes.RESET, timestamp: Date.now() };
	  },
	  rollback: function rollback() {
	    return { type: ActionTypes.ROLLBACK, timestamp: Date.now() };
	  },
	  commit: function commit() {
	    return { type: ActionTypes.COMMIT, timestamp: Date.now() };
	  },
	  sweep: function sweep() {
	    return { type: ActionTypes.SWEEP };
	  },
	  toggleAction: function toggleAction(id) {
	    return { type: ActionTypes.TOGGLE_ACTION, id: id };
	  },
	  setActionsActive: function setActionsActive(start, end) {
	    var active = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	    return { type: ActionTypes.SET_ACTIONS_ACTIVE, start: start, end: end, active: active };
	  },
	  reorderAction: function reorderAction(actionId, beforeActionId) {
	    return { type: ActionTypes.REORDER_ACTION, actionId: actionId, beforeActionId: beforeActionId };
	  },
	  jumpToState: function jumpToState(index) {
	    return { type: ActionTypes.JUMP_TO_STATE, index: index };
	  },
	  jumpToAction: function jumpToAction(actionId) {
	    return { type: ActionTypes.JUMP_TO_ACTION, actionId: actionId };
	  },
	  importState: function importState(nextLiftedState, noRecompute) {
	    return { type: ActionTypes.IMPORT_STATE, nextLiftedState: nextLiftedState, noRecompute: noRecompute };
	  },
	  lockChanges: function lockChanges(status) {
	    return { type: ActionTypes.LOCK_CHANGES, status: status };
	  },
	  pauseRecording: function pauseRecording(status) {
	    return { type: ActionTypes.PAUSE_RECORDING, status: status };
	  }
	};
	
	var INIT_ACTION = exports.INIT_ACTION = { type: '@@INIT' };
	
	/**
	 * Computes the next entry with exceptions catching.
	 */
	function computeWithTryCatch(reducer, action, state) {
	  var nextState = state;
	  var nextError = void 0;
	  try {
	    nextState = reducer(state, action);
	  } catch (err) {
	    nextError = err.toString();
	    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof window.chrome !== 'undefined' || typeof window.process !== 'undefined' && window.process.type === 'renderer')) {
	      // In Chrome, rethrowing provides better source map support
	      setTimeout(function () {
	        throw err;
	      });
	    } else {
	      console.error(err);
	    }
	  }
	
	  return {
	    state: nextState,
	    error: nextError
	  };
	}
	
	/**
	 * Computes the next entry in the log by applying an action.
	 */
	function computeNextEntry(reducer, action, state, shouldCatchErrors) {
	  if (!shouldCatchErrors) {
	    return { state: reducer(state, action) };
	  }
	  return computeWithTryCatch(reducer, action, state);
	}
	
	/**
	 * Runs the reducer on invalidated actions to get a fresh computation log.
	 */
	function recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, shouldCatchErrors) {
	  // Optimization: exit early and return the same reference
	  // if we know nothing could have changed.
	  if (!computedStates || minInvalidatedStateIndex === -1 || minInvalidatedStateIndex >= computedStates.length && computedStates.length === stagedActionIds.length) {
	    return computedStates;
	  }
	
	  var nextComputedStates = computedStates.slice(0, minInvalidatedStateIndex);
	  for (var i = minInvalidatedStateIndex; i < stagedActionIds.length; i++) {
	    var actionId = stagedActionIds[i];
	    var action = actionsById[actionId].action;
	
	    var previousEntry = nextComputedStates[i - 1];
	    var previousState = previousEntry ? previousEntry.state : committedState;
	
	    var shouldSkip = skippedActionIds.indexOf(actionId) > -1;
	    var entry = void 0;
	    if (shouldSkip) {
	      entry = previousEntry;
	    } else {
	      if (shouldCatchErrors && previousEntry && previousEntry.error) {
	        entry = {
	          state: previousState,
	          error: 'Interrupted by an error up the chain'
	        };
	      } else {
	        entry = computeNextEntry(reducer, action, previousState, shouldCatchErrors);
	      }
	    }
	    nextComputedStates.push(entry);
	  }
	
	  return nextComputedStates;
	}
	
	/**
	 * Lifts an app's action into an action on the lifted store.
	 */
	function liftAction(action) {
	  return ActionCreators.performAction(action);
	}
	
	/**
	 * Creates a history state reducer from an app's reducer.
	 */
	function liftReducerWith(reducer, initialCommittedState, monitorReducer, options) {
	  var initialLiftedState = {
	    monitorState: monitorReducer(undefined, {}),
	    nextActionId: 1,
	    actionsById: { 0: liftAction(INIT_ACTION) },
	    stagedActionIds: [0],
	    skippedActionIds: [],
	    committedState: initialCommittedState,
	    currentStateIndex: 0,
	    computedStates: [],
	    isLocked: options.shouldStartLocked === true,
	    isPaused: options.shouldRecordChanges === false
	  };
	
	  /**
	   * Manages how the history actions modify the history state.
	   */
	  return function (liftedState, liftedAction) {
	    var _ref = liftedState || initialLiftedState;
	
	    var monitorState = _ref.monitorState;
	    var actionsById = _ref.actionsById;
	    var nextActionId = _ref.nextActionId;
	    var stagedActionIds = _ref.stagedActionIds;
	    var skippedActionIds = _ref.skippedActionIds;
	    var committedState = _ref.committedState;
	    var currentStateIndex = _ref.currentStateIndex;
	    var computedStates = _ref.computedStates;
	    var isLocked = _ref.isLocked;
	    var isPaused = _ref.isPaused;
	
	
	    if (!liftedState) {
	      // Prevent mutating initialLiftedState
	      actionsById = _extends({}, actionsById);
	    }
	
	    function commitExcessActions(n) {
	      // Auto-commits n-number of excess actions.
	      var excess = n;
	      var idsToDelete = stagedActionIds.slice(1, excess + 1);
	
	      for (var i = 0; i < idsToDelete.length; i++) {
	        if (computedStates[i + 1].error) {
	          // Stop if error is found. Commit actions up to error.
	          excess = i;
	          idsToDelete = stagedActionIds.slice(1, excess + 1);
	          break;
	        } else {
	          delete actionsById[idsToDelete[i]];
	        }
	      }
	
	      skippedActionIds = skippedActionIds.filter(function (id) {
	        return idsToDelete.indexOf(id) === -1;
	      });
	      stagedActionIds = [0].concat(stagedActionIds.slice(excess + 1));
	      committedState = computedStates[excess].state;
	      computedStates = computedStates.slice(excess);
	      currentStateIndex = currentStateIndex > excess ? currentStateIndex - excess : 0;
	    }
	
	    function computePausedAction(shouldInit) {
	      var _extends2;
	
	      var computedState = void 0;
	      if (shouldInit) {
	        computedState = computedStates[currentStateIndex];
	        monitorState = monitorReducer(monitorState, liftedAction);
	      } else {
	        computedState = computeNextEntry(reducer, liftedAction.action, computedStates[currentStateIndex].state, false);
	      }
	      if (!options.pauseActionType || nextActionId === 1) {
	        return {
	          monitorState: monitorState,
	          actionsById: { 0: liftAction(INIT_ACTION) },
	          nextActionId: 1,
	          stagedActionIds: [0],
	          skippedActionIds: [],
	          committedState: computedState.state,
	          currentStateIndex: 0,
	          computedStates: [computedState],
	          isLocked: isLocked,
	          isPaused: true
	        };
	      }
	      if (shouldInit) {
	        if (currentStateIndex === stagedActionIds.length - 1) {
	          currentStateIndex++;
	        }
	        stagedActionIds = [].concat(stagedActionIds, [nextActionId]);
	        nextActionId++;
	      }
	      return {
	        monitorState: monitorState,
	        actionsById: _extends({}, actionsById, (_extends2 = {}, _extends2[nextActionId - 1] = liftAction({ type: options.pauseActionType }), _extends2)),
	        nextActionId: nextActionId,
	        stagedActionIds: stagedActionIds,
	        skippedActionIds: skippedActionIds,
	        committedState: committedState,
	        currentStateIndex: currentStateIndex,
	        computedStates: [].concat(computedStates.slice(0, stagedActionIds.length - 1), [computedState]),
	        isLocked: isLocked,
	        isPaused: true
	      };
	    }
	
	    // By default, agressively recompute every state whatever happens.
	    // This has O(n) performance, so we'll override this to a sensible
	    // value whenever we feel like we don't have to recompute the states.
	    var minInvalidatedStateIndex = 0;
	
	    switch (liftedAction.type) {
	      case ActionTypes.PERFORM_ACTION:
	        {
	          if (isLocked) return liftedState || initialLiftedState;
	          if (isPaused) return computePausedAction();
	
	          // Auto-commit as new actions come in.
	          if (options.maxAge && stagedActionIds.length === options.maxAge) {
	            commitExcessActions(1);
	          }
	
	          if (currentStateIndex === stagedActionIds.length - 1) {
	            currentStateIndex++;
	          }
	          var actionId = nextActionId++;
	          // Mutation! This is the hottest path, and we optimize on purpose.
	          // It is safe because we set a new key in a cache dictionary.
	          actionsById[actionId] = liftedAction;
	          stagedActionIds = [].concat(stagedActionIds, [actionId]);
	          // Optimization: we know that only the new action needs computing.
	          minInvalidatedStateIndex = stagedActionIds.length - 1;
	          break;
	        }
	      case ActionTypes.RESET:
	        {
	          // Get back to the state the store was created with.
	          actionsById = { 0: liftAction(INIT_ACTION) };
	          nextActionId = 1;
	          stagedActionIds = [0];
	          skippedActionIds = [];
	          committedState = initialCommittedState;
	          currentStateIndex = 0;
	          computedStates = [];
	          break;
	        }
	      case ActionTypes.COMMIT:
	        {
	          // Consider the last committed state the new starting point.
	          // Squash any staged actions into a single committed state.
	          actionsById = { 0: liftAction(INIT_ACTION) };
	          nextActionId = 1;
	          stagedActionIds = [0];
	          skippedActionIds = [];
	          committedState = computedStates[currentStateIndex].state;
	          currentStateIndex = 0;
	          computedStates = [];
	          break;
	        }
	      case ActionTypes.ROLLBACK:
	        {
	          // Forget about any staged actions.
	          // Start again from the last committed state.
	          actionsById = { 0: liftAction(INIT_ACTION) };
	          nextActionId = 1;
	          stagedActionIds = [0];
	          skippedActionIds = [];
	          currentStateIndex = 0;
	          computedStates = [];
	          break;
	        }
	      case ActionTypes.TOGGLE_ACTION:
	        {
	          var _ret = function () {
	            // Toggle whether an action with given ID is skipped.
	            // Being skipped means it is a no-op during the computation.
	            var actionId = liftedAction.id;
	
	            var index = skippedActionIds.indexOf(actionId);
	            if (index === -1) {
	              skippedActionIds = [actionId].concat(skippedActionIds);
	            } else {
	              skippedActionIds = skippedActionIds.filter(function (id) {
	                return id !== actionId;
	              });
	            }
	            // Optimization: we know history before this action hasn't changed
	            minInvalidatedStateIndex = stagedActionIds.indexOf(actionId);
	            return 'break';
	          }();
	
	          if (_ret === 'break') break;
	        }
	      case ActionTypes.SET_ACTIONS_ACTIVE:
	        {
	          // Toggle whether an action with given ID is skipped.
	          // Being skipped means it is a no-op during the computation.
	          var start = liftedAction.start;
	          var end = liftedAction.end;
	          var active = liftedAction.active;
	
	          var actionIds = [];
	          for (var i = start; i < end; i++) {
	            actionIds.push(i);
	          }if (active) {
	            skippedActionIds = (0, _difference2.default)(skippedActionIds, actionIds);
	          } else {
	            skippedActionIds = (0, _union2.default)(skippedActionIds, actionIds);
	          }
	
	          // Optimization: we know history before this action hasn't changed
	          minInvalidatedStateIndex = stagedActionIds.indexOf(start);
	          break;
	        }
	      case ActionTypes.JUMP_TO_STATE:
	        {
	          // Without recomputing anything, move the pointer that tell us
	          // which state is considered the current one. Useful for sliders.
	          currentStateIndex = liftedAction.index;
	          // Optimization: we know the history has not changed.
	          minInvalidatedStateIndex = Infinity;
	          break;
	        }
	      case ActionTypes.JUMP_TO_ACTION:
	        {
	          // Jumps to a corresponding state to a specific action.
	          // Useful when filtering actions.
	          var _index = stagedActionIds.indexOf(liftedAction.actionId);
	          if (_index !== -1) currentStateIndex = _index;
	          minInvalidatedStateIndex = Infinity;
	          break;
	        }
	      case ActionTypes.SWEEP:
	        {
	          // Forget any actions that are currently being skipped.
	          stagedActionIds = (0, _difference2.default)(stagedActionIds, skippedActionIds);
	          skippedActionIds = [];
	          currentStateIndex = Math.min(currentStateIndex, stagedActionIds.length - 1);
	          break;
	        }
	      case ActionTypes.REORDER_ACTION:
	        {
	          // Recompute actions in a new order.
	          var _actionId = liftedAction.actionId;
	          var idx = stagedActionIds.indexOf(_actionId);
	          // do nothing in case the action is already removed or trying to move the first action
	          if (idx < 1) break;
	          var beforeActionId = liftedAction.beforeActionId;
	          var newIdx = stagedActionIds.indexOf(beforeActionId);
	          if (newIdx < 1) {
	            // move to the beginning or to the end
	            var count = stagedActionIds.length;
	            newIdx = beforeActionId > stagedActionIds[count - 1] ? count : 1;
	          }
	          var diff = idx - newIdx;
	
	          if (diff > 0) {
	            // move left
	            stagedActionIds = [].concat(stagedActionIds.slice(0, newIdx), [_actionId], stagedActionIds.slice(newIdx, idx), stagedActionIds.slice(idx + 1));
	            minInvalidatedStateIndex = newIdx;
	          } else if (diff < 0) {
	            // move right
	            stagedActionIds = [].concat(stagedActionIds.slice(0, idx), stagedActionIds.slice(idx + 1, newIdx), [_actionId], stagedActionIds.slice(newIdx));
	            minInvalidatedStateIndex = idx;
	          }
	          break;
	        }
	      case ActionTypes.IMPORT_STATE:
	        {
	          if (Array.isArray(liftedAction.nextLiftedState)) {
	            // recompute array of actions
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            currentStateIndex = liftedAction.nextLiftedState.length;
	            computedStates = [];
	            committedState = liftedAction.preloadedState;
	            minInvalidatedStateIndex = 0;
	            // iterate through actions
	            liftedAction.nextLiftedState.forEach(function (action) {
	              actionsById[nextActionId] = liftAction(action);
	              stagedActionIds.push(nextActionId);
	              nextActionId++;
	            });
	          } else {
	            var _liftedAction$nextLif = liftedAction.nextLiftedState;
	            // Completely replace everything.
	
	            monitorState = _liftedAction$nextLif.monitorState;
	            actionsById = _liftedAction$nextLif.actionsById;
	            nextActionId = _liftedAction$nextLif.nextActionId;
	            stagedActionIds = _liftedAction$nextLif.stagedActionIds;
	            skippedActionIds = _liftedAction$nextLif.skippedActionIds;
	            committedState = _liftedAction$nextLif.committedState;
	            currentStateIndex = _liftedAction$nextLif.currentStateIndex;
	            computedStates = _liftedAction$nextLif.computedStates;
	
	
	            if (liftedAction.noRecompute) {
	              minInvalidatedStateIndex = Infinity;
	            }
	          }
	
	          break;
	        }
	      case ActionTypes.LOCK_CHANGES:
	        {
	          isLocked = liftedAction.status;
	          minInvalidatedStateIndex = Infinity;
	          break;
	        }
	      case ActionTypes.PAUSE_RECORDING:
	        {
	          isPaused = liftedAction.status;
	          if (isPaused) {
	            return computePausedAction(true);
	          }
	          // Commit when unpausing
	          actionsById = { 0: liftAction(INIT_ACTION) };
	          nextActionId = 1;
	          stagedActionIds = [0];
	          skippedActionIds = [];
	          committedState = computedStates[currentStateIndex].state;
	          currentStateIndex = 0;
	          computedStates = [];
	          break;
	        }
	      case '@@redux/INIT':
	        {
	          if (options.shouldHotReload === false) {
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = computedStates.length === 0 ? initialCommittedState : computedStates[currentStateIndex].state;
	            currentStateIndex = 0;
	            computedStates = [];
	          }
	
	          // Recompute states on hot reload and init.
	          minInvalidatedStateIndex = 0;
	
	          if (options.maxAge && stagedActionIds.length > options.maxAge) {
	            // States must be recomputed before committing excess.
	            computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
	
	            commitExcessActions(stagedActionIds.length - options.maxAge);
	
	            // Avoid double computation.
	            minInvalidatedStateIndex = Infinity;
	          }
	
	          break;
	        }
	      default:
	        {
	          // If the action is not recognized, it's a monitor action.
	          // Optimization: a monitor action can't change history.
	          minInvalidatedStateIndex = Infinity;
	          break;
	        }
	    }
	
	    computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
	    monitorState = monitorReducer(monitorState, liftedAction);
	    return {
	      monitorState: monitorState,
	      actionsById: actionsById,
	      nextActionId: nextActionId,
	      stagedActionIds: stagedActionIds,
	      skippedActionIds: skippedActionIds,
	      committedState: committedState,
	      currentStateIndex: currentStateIndex,
	      computedStates: computedStates,
	      isLocked: isLocked,
	      isPaused: isPaused
	    };
	  };
	}
	
	/**
	 * Provides an app's view into the state of the lifted store.
	 */
	function unliftState(liftedState) {
	  var computedStates = liftedState.computedStates;
	  var currentStateIndex = liftedState.currentStateIndex;
	  var state = computedStates[currentStateIndex].state;
	
	  return state;
	}
	
	/**
	 * Provides an app's view into the lifted store.
	 */
	function unliftStore(liftedStore, liftReducer) {
	  var _extends3;
	
	  var lastDefinedState = void 0;
	
	  function getState() {
	    var state = unliftState(liftedStore.getState());
	    if (state !== undefined) {
	      lastDefinedState = state;
	    }
	    return lastDefinedState;
	  }
	
	  return _extends({}, liftedStore, (_extends3 = {
	
	    liftedStore: liftedStore,
	
	    dispatch: function dispatch(action) {
	      liftedStore.dispatch(liftAction(action));
	      return action;
	    },
	
	
	    getState: getState,
	
	    replaceReducer: function replaceReducer(nextReducer) {
	      liftedStore.replaceReducer(liftReducer(nextReducer));
	    }
	  }, _extends3[_symbolObservable2.default] = function () {
	    return _extends({}, liftedStore[_symbolObservable2.default](), {
	      subscribe: function subscribe(observer) {
	        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = liftedStore.subscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    });
	  }, _extends3));
	}
	
	/**
	 * Redux instrumentation store enhancer.
	 */
	function instrument() {
	  var monitorReducer = arguments.length <= 0 || arguments[0] === undefined ? function () {
	    return null;
	  } : arguments[0];
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  /* eslint-disable no-eq-null */
	  if (options.maxAge != null && options.maxAge < 2) {
	    /* eslint-enable */
	    throw new Error('DevTools.instrument({ maxAge }) option, if specified, ' + 'may not be less than 2.');
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	
	      function liftReducer(r) {
	        if (typeof r !== 'function') {
	          if (r && typeof r.default === 'function') {
	            throw new Error('Expected the reducer to be a function. ' + 'Instead got an object with a "default" field. ' + 'Did you pass a module instead of the default export? ' + 'Try passing require(...).default instead.');
	          }
	          throw new Error('Expected the reducer to be a function.');
	        }
	        return liftReducerWith(r, initialState, monitorReducer, options);
	      }
	
	      var liftedStore = createStore(liftReducer(reducer), enhancer);
	      if (liftedStore.liftedStore) {
	        throw new Error('DevTools instrumentation should not be applied more than once. ' + 'Check your store configuration.');
	      }
	
	      return unliftStore(liftedStore, liftReducer);
	    };
	  };
	}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.updateScrollTop = updateScrollTop;
	exports.startConsecutiveToggle = startConsecutiveToggle;
	var UPDATE_SCROLL_TOP = exports.UPDATE_SCROLL_TOP = '@@redux-devtools-log-monitor/UPDATE_SCROLL_TOP';
	function updateScrollTop(scrollTop) {
	  return { type: UPDATE_SCROLL_TOP, scrollTop: scrollTop };
	}
	
	var START_CONSECUTIVE_TOGGLE = exports.START_CONSECUTIVE_TOGGLE = '@@redux-devtools-log-monitor/START_CONSECUTIVE_TOGGLE';
	function startConsecutiveToggle(id) {
	  return { type: START_CONSECUTIVE_TOGGLE, id: id };
	}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(270);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(833);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  position: true,
	  gfm: true,
	  commonmark: false,
	  footnotes: false,
	  pedantic: false,
	  blocks: __webpack_require__(1588)
	};


/***/ }),
/* 823 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var link = value.indexOf('[', fromIndex);
	  var image = value.indexOf('![', fromIndex);
	
	  if (image === -1) {
	    return link;
	  }
	
	  /* Link can never be `-1` if an image is found, so we don’t need
	   * to check for that :) */
	  return link < image ? link : image;
	}


/***/ }),
/* 824 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('<', fromIndex);
	}


/***/ }),
/* 825 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = indentation;
	
	/* Map of characters, and their column length,
	 * which can be used as indentation. */
	var characters = {' ': 1, '\t': 4};
	
	/* Gets indentation information for a line. */
	function indentation(value) {
	  var index = 0;
	  var indent = 0;
	  var character = value.charAt(index);
	  var stops = {};
	  var size;
	
	  while (character in characters) {
	    size = characters[character];
	
	    indent += size;
	
	    if (size > 1) {
	      indent = Math.floor(indent / size) * size;
	    }
	
	    stops[indent] = index;
	
	    character = value.charAt(++index);
	  }
	
	  return {indent: indent, stops: stops};
	}


/***/ }),
/* 826 */
/***/ (function(module, exports) {

	'use strict';
	
	var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
	var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
	var singleQuoted = '\'[^\']*\'';
	var doubleQuoted = '"[^"]*"';
	var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
	var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
	var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
	var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
	var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
	var processing = '<[?].*?[?]>';
	var declaration = '<![A-Za-z]+\\s+[^>]*>';
	var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
	
	exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');
	
	exports.tag = new RegExp('^(?:' +
	  openTag + '|' +
	  closeTag + '|' +
	  comment + '|' +
	  processing + '|' +
	  declaration + '|' +
	  cdata +
	')');


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomByte = __webpack_require__(3031);
	
	function encode(lookup, number) {
	    var loopCounter = 0;
	    var done;
	
	    var str = '';
	
	    while (!done) {
	        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
	        done = number < (Math.pow(16, loopCounter + 1 ) );
	        loopCounter++;
	    }
	    return str;
	}
	
	module.exports = encode;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(1524);
	var Socket = __webpack_require__(830);
	var Emitter = __webpack_require__(173);
	var parser = __webpack_require__(439);
	var on = __webpack_require__(829);
	var bind = __webpack_require__(495);
	var debug = __webpack_require__(293)('socket.io-client:manager');
	var indexOf = __webpack_require__(553);
	var Backoff = __webpack_require__(1187);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 829 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(439);
	var Emitter = __webpack_require__(173);
	var toArray = __webpack_require__(3050);
	var on = __webpack_require__(829);
	var bind = __webpack_require__(495);
	var debug = __webpack_require__(293)('socket.io-client:socket');
	var hasBin = __webpack_require__(551);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),
/* 831 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3047);


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toDate = __webpack_require__(443);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	var _toFloat = __webpack_require__(846);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	var _toInt = __webpack_require__(3102);
	
	var _toInt2 = _interopRequireDefault(_toInt);
	
	var _toBoolean = __webpack_require__(3101);
	
	var _toBoolean2 = _interopRequireDefault(_toBoolean);
	
	var _equals = __webpack_require__(3061);
	
	var _equals2 = _interopRequireDefault(_equals);
	
	var _contains = __webpack_require__(3060);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _matches = __webpack_require__(3098);
	
	var _matches2 = _interopRequireDefault(_matches);
	
	var _isEmail = __webpack_require__(838);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _isURL = __webpack_require__(3093);
	
	var _isURL2 = _interopRequireDefault(_isURL);
	
	var _isMACAddress = __webpack_require__(3085);
	
	var _isMACAddress2 = _interopRequireDefault(_isMACAddress);
	
	var _isIP = __webpack_require__(842);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _isFQDN = __webpack_require__(442);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isBoolean = __webpack_require__(3069);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isAlpha = __webpack_require__(3064);
	
	var _isAlpha2 = _interopRequireDefault(_isAlpha);
	
	var _isAlphanumeric = __webpack_require__(3065);
	
	var _isAlphanumeric2 = _interopRequireDefault(_isAlphanumeric);
	
	var _isNumeric = __webpack_require__(3091);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isLowercase = __webpack_require__(3084);
	
	var _isLowercase2 = _interopRequireDefault(_isLowercase);
	
	var _isUppercase = __webpack_require__(3095);
	
	var _isUppercase2 = _interopRequireDefault(_isUppercase);
	
	var _isAscii = __webpack_require__(3066);
	
	var _isAscii2 = _interopRequireDefault(_isAscii);
	
	var _isFullWidth = __webpack_require__(839);
	
	var _isFullWidth2 = _interopRequireDefault(_isFullWidth);
	
	var _isHalfWidth = __webpack_require__(840);
	
	var _isHalfWidth2 = _interopRequireDefault(_isHalfWidth);
	
	var _isVariableWidth = __webpack_require__(3096);
	
	var _isVariableWidth2 = _interopRequireDefault(_isVariableWidth);
	
	var _isMultibyte = __webpack_require__(3089);
	
	var _isMultibyte2 = _interopRequireDefault(_isMultibyte);
	
	var _isSurrogatePair = __webpack_require__(3092);
	
	var _isSurrogatePair2 = _interopRequireDefault(_isSurrogatePair);
	
	var _isInt = __webpack_require__(3081);
	
	var _isInt2 = _interopRequireDefault(_isInt);
	
	var _isFloat = __webpack_require__(3076);
	
	var _isFloat2 = _interopRequireDefault(_isFloat);
	
	var _isDecimal = __webpack_require__(3074);
	
	var _isDecimal2 = _interopRequireDefault(_isDecimal);
	
	var _isHexadecimal = __webpack_require__(841);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	var _isDivisibleBy = __webpack_require__(3075);
	
	var _isDivisibleBy2 = _interopRequireDefault(_isDivisibleBy);
	
	var _isHexColor = __webpack_require__(3077);
	
	var _isHexColor2 = _interopRequireDefault(_isHexColor);
	
	var _isMD = __webpack_require__(3086);
	
	var _isMD2 = _interopRequireDefault(_isMD);
	
	var _isJSON = __webpack_require__(3082);
	
	var _isJSON2 = _interopRequireDefault(_isJSON);
	
	var _isNull = __webpack_require__(3090);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _isLength = __webpack_require__(3083);
	
	var _isLength2 = _interopRequireDefault(_isLength);
	
	var _isByteLength = __webpack_require__(837);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isUUID = __webpack_require__(3094);
	
	var _isUUID2 = _interopRequireDefault(_isUUID);
	
	var _isMongoId = __webpack_require__(3088);
	
	var _isMongoId2 = _interopRequireDefault(_isMongoId);
	
	var _isDate = __webpack_require__(3073);
	
	var _isDate2 = _interopRequireDefault(_isDate);
	
	var _isAfter = __webpack_require__(3063);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isBefore = __webpack_require__(3068);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _isIn = __webpack_require__(3080);
	
	var _isIn2 = _interopRequireDefault(_isIn);
	
	var _isCreditCard = __webpack_require__(3070);
	
	var _isCreditCard2 = _interopRequireDefault(_isCreditCard);
	
	var _isISIN = __webpack_require__(3079);
	
	var _isISIN2 = _interopRequireDefault(_isISIN);
	
	var _isISBN = __webpack_require__(3078);
	
	var _isISBN2 = _interopRequireDefault(_isISBN);
	
	var _isMobilePhone = __webpack_require__(3087);
	
	var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);
	
	var _isCurrency = __webpack_require__(3071);
	
	var _isCurrency2 = _interopRequireDefault(_isCurrency);
	
	var _isISO = __webpack_require__(843);
	
	var _isISO2 = _interopRequireDefault(_isISO);
	
	var _isBase = __webpack_require__(3067);
	
	var _isBase2 = _interopRequireDefault(_isBase);
	
	var _isDataURI = __webpack_require__(3072);
	
	var _isDataURI2 = _interopRequireDefault(_isDataURI);
	
	var _ltrim = __webpack_require__(844);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	var _rtrim = __webpack_require__(845);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _trim = __webpack_require__(3103);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _escape = __webpack_require__(3062);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _unescape = __webpack_require__(3104);
	
	var _unescape2 = _interopRequireDefault(_unescape);
	
	var _stripLow = __webpack_require__(3100);
	
	var _stripLow2 = _interopRequireDefault(_stripLow);
	
	var _whitelist = __webpack_require__(3105);
	
	var _whitelist2 = _interopRequireDefault(_whitelist);
	
	var _blacklist = __webpack_require__(836);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	var _isWhitelisted = __webpack_require__(3097);
	
	var _isWhitelisted2 = _interopRequireDefault(_isWhitelisted);
	
	var _normalizeEmail = __webpack_require__(3099);
	
	var _normalizeEmail2 = _interopRequireDefault(_normalizeEmail);
	
	var _toString = __webpack_require__(444);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = '5.7.0';
	
	var validator = {
	  version: version,
	  toDate: _toDate2.default,
	  toFloat: _toFloat2.default, toInt: _toInt2.default,
	  toBoolean: _toBoolean2.default,
	  equals: _equals2.default, contains: _contains2.default, matches: _matches2.default,
	  isEmail: _isEmail2.default, isURL: _isURL2.default, isMACAddress: _isMACAddress2.default, isIP: _isIP2.default, isFQDN: _isFQDN2.default,
	  isBoolean: _isBoolean2.default,
	  isAlpha: _isAlpha2.default, isAlphanumeric: _isAlphanumeric2.default, isNumeric: _isNumeric2.default, isLowercase: _isLowercase2.default, isUppercase: _isUppercase2.default,
	  isAscii: _isAscii2.default, isFullWidth: _isFullWidth2.default, isHalfWidth: _isHalfWidth2.default, isVariableWidth: _isVariableWidth2.default,
	  isMultibyte: _isMultibyte2.default, isSurrogatePair: _isSurrogatePair2.default,
	  isInt: _isInt2.default, isFloat: _isFloat2.default, isDecimal: _isDecimal2.default, isHexadecimal: _isHexadecimal2.default, isDivisibleBy: _isDivisibleBy2.default,
	  isHexColor: _isHexColor2.default,
	  isMD5: _isMD2.default,
	  isJSON: _isJSON2.default,
	  isNull: _isNull2.default,
	  isLength: _isLength2.default, isByteLength: _isByteLength2.default,
	  isUUID: _isUUID2.default, isMongoId: _isMongoId2.default,
	  isDate: _isDate2.default, isAfter: _isAfter2.default, isBefore: _isBefore2.default,
	  isIn: _isIn2.default,
	  isCreditCard: _isCreditCard2.default,
	  isISIN: _isISIN2.default, isISBN: _isISBN2.default,
	  isMobilePhone: _isMobilePhone2.default,
	  isCurrency: _isCurrency2.default,
	  isISO8601: _isISO2.default,
	  isBase64: _isBase2.default, isDataURI: _isDataURI2.default,
	  ltrim: _ltrim2.default, rtrim: _rtrim2.default, trim: _trim2.default,
	  escape: _escape2.default, unescape: _unescape2.default, stripLow: _stripLow2.default,
	  whitelist: _whitelist2.default, blacklist: _blacklist2.default,
	  isWhitelisted: _isWhitelisted2.default,
	  normalizeEmail: _normalizeEmail2.default,
	  toString: _toString2.default
	};
	
	exports.default = validator;
	module.exports = exports['default'];

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var alpha = exports.alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'nl-NL': /^[A-ZÉËÏÓÖÜ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var alphanumeric = exports.alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nl-NL': /^[0-9A-ZÉËÏÓÖÜ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var englishLocales = exports.englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	
	for (var locale, i = 0; i < englishLocales.length; i++) {
	  locale = 'en-' + englishLocales[i];
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	}
	
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	
	// Source: http://www.localeplanet.com/java/
	var arabicLocales = exports.arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	
	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = 'ar-' + arabicLocales[_i];
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blacklist;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function blacklist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isByteLength;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(228);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isByteLength = __webpack_require__(837);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isFQDN = __webpack_require__(442);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	
	/* eslint-disable max-len */
	/* eslint-disable no-control-regex */
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_email_options);
	
	  if (options.allow_display_name) {
	    var display_email = str.match(displayName);
	    if (display_email) {
	      str = display_email[1];
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	
	  var lower_domain = domain.toLowerCase();
	  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
	    user = user.replace(/\./g, '').toLowerCase();
	  }
	
	  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 256 })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
	    return false;
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	
	  var user_parts = user.split('.');
	  for (var i = 0; i < user_parts.length; i++) {
	    if (!pattern.test(user_parts[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fullWidth = undefined;
	exports.default = isFullWidth;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isFullWidth(str) {
	  (0, _assertString2.default)(str);
	  return fullWidth.test(str);
	}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.halfWidth = undefined;
	exports.default = isHalfWidth;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isHalfWidth(str) {
	  (0, _assertString2.default)(str);
	  return halfWidth.test(str);
	}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexadecimal;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexadecimal = /^[0-9A-F]+$/i;
	
	function isHexadecimal(str) {
	  (0, _assertString2.default)(str);
	  return hexadecimal.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    }
	    // initial or final ::
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
	        // it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	    return blocks.length === expectedNumberOfBlocks;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.iso8601 = undefined;
	
	exports.default = function (str) {
	  (0, _assertString2.default)(str);
	  return iso8601.test(str);
	};
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	// from http://goo.gl/0ejHHW
	var iso8601 = exports.iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
	/* eslint-enable max-len */

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ltrim;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ltrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('^[' + chars + ']+', 'g') : /^\s+/g;
	  return str.replace(pattern, '');
	}
	module.exports = exports['default'];

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtrim;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rtrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('[' + chars + ']') : /\s/;
	
	  var idx = str.length - 1;
	  while (idx >= 0 && pattern.test(str[idx])) {
	    idx--;
	  }
	
	  return idx < str.length ? str.substr(0, idx + 1) : str;
	}
	module.exports = exports['default'];

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toFloat;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toFloat(str) {
	  (0, _assertString2.default)(str);
	  return parseFloat(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),
/* 849 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactTapEventPlugin = __webpack_require__(2879);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactRouter = __webpack_require__(51);
	
	var _routes = __webpack_require__(1174);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _configureStore = __webpack_require__(319);
	
	var _simpleIsoFetch = __webpack_require__(227);
	
	var _simpleIsoFetch2 = _interopRequireDefault(_simpleIsoFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// boolean checks
	var isProd = ("production") === 'production';
	var enableDevTools = ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).ENABLE_DEV_TOOLS === 'true';
	
	// grab initial state off window
	var simpleIsoFetch = new _simpleIsoFetch2.default();
	
	var store = (0, _configureStore.configureStore)(_reactRouter.browserHistory, simpleIsoFetch);
	
	// attach bindings to store
	(0, _simpleIsoFetch.syncBindingsWithStore)(simpleIsoFetch, store);
	
	// react's HTML5 history handler
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	// enable tap events throughout app (temporary patch)
	(0, _reactTapEventPlugin2.default)();
	
	// determine where react hooks to actual DOM
	var DomEntryPoint = document.getElementById('root');
	
	// polyfill or augment ES6 native promises with 'bluebird' library throughout app
	window.Promise = window.Promise && _lodash2.default.merge(window.Promise, __webpack_require__(171)) || __webpack_require__(171);
	
	// enable debugger if in dev and client
	if (!isProd) {
	  window.React = _react2.default;
	}
	
	var hashLinkScroll = function hashLinkScroll() {
	  var hash = window.location.hash;
	
	  if (hash !== '') {
	    // Push onto callback queue so it runs after the DOM is updated,
	    // this is required when navigating from a different page so that
	    // the element is rendered on the page before trying to getElementById.
	    setTimeout(function () {
	      var id = hash.replace('#', '');
	      var element = document.getElementById(id);
	      if (element) element.scrollIntoView();
	    }, 0);
	  }
	};
	
	// // inform dev users if isomorphic load failed (checks for 'data-react-checksum' attribute)
	// if (!isProd) {
	//   if (!DomEntryPoint || !DomEntryPoint.firstChild || !DomEntryPoint.firstChild.attributes || !DomEntryPoint.firstChild.attributes['data-react-checksum'] && (!DomEntryPoint.firstChild.firstChild || !DomEntryPoint.firstChild.firstChild.attributes || !DomEntryPoint.firstChild.firstChild.attributes['data-react-checksum'])) { // eslint-disable-line max-len
	//     console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.'); // eslint-disable-line
	//   }
	// }
	
	// hook client-side app to DOM
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_reactRouter.Router, { history: history, routes: (0, _routes2.default)(store), onUpdate: hashLinkScroll })
	), DomEntryPoint);
	
	// enable DevTools if in dev and if user does not have redux Devtools extension installed
	if (!isProd && !window.devToolsExtension && enableDevTools) {
	  var DevTools = __webpack_require__(1119).default; // need to specify "default" when getting require to play with "export default"
	  var devToolsDest = document.createElement('div');
	  DomEntryPoint.parentNode.insertBefore(devToolsDest, DomEntryPoint.nextSibling);
	  (0, _reactDom.render)(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store, key: 'provider' },
	    _react2.default.createElement(DevTools, null)
	  ), devToolsDest);
	}
	
	// @cc_on is conditional compilation that IE Understands
	var isIE = /*@cc_on!@*/false || !!document.documentMode;
	if (isIE) {
	  document.body.setAttribute('spellcheck', 'false');
	}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// toast related
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _Favicon = __webpack_require__(915);
	
	var _Favicon2 = _interopRequireDefault(_Favicon);
	
	var _reactToastr = __webpack_require__(2883);
	
	var _SnackBar = __webpack_require__(861);
	
	var _SnackBar2 = _interopRequireDefault(_SnackBar);
	
	var _Spinner = __webpack_require__(862);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _getMuiTheme = __webpack_require__(393);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _MuiThemeProvider = __webpack_require__(618);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _simpleIsoFetch = __webpack_require__(227);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToastMessageAnim = _reactToastr.ToastMessage.animation;
	
	// UI Components
	
	
	// material UI related
	
	
	// used to bind functions to API call responses
	
	
	// action creators for redux
	// import * as asyncActionCreators from './redux/actionCreators/async';
	
	
	// toast errors
	function errorToastFunc(res) {
	  var _this = this;
	
	  var errorList = (0, _lodash.get)(res, 'body.errors', [{ errorMessage: res.body }]);
	
	  if (res.status >= 500) {
	    return errorList.forEach(function (error) {
	      _this.refs.container.error(res.status + ' : ' + (error.errorMessage || 'Internal Server Error'), res.method + ' ' + res.url, { closeButton: true });
	    });
	  }
	}
	
	var App = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    ui: store.ui,
	    userAgent: store.browserData.userAgent,
	    staticData: store.staticData
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props, context) {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));
	  }
	
	  _createClass(App, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // give the browser's scrollBarWidth to the rest of the app
	      this.props.dispatch(syncActionCreators.getScrollBarWidth());
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // transform response
	      this.props.dispatch((0, _simpleIsoFetch.bindToErrorAction)(errorToastFunc.bind(this)));
	      document.title = (0, _lodash.get)(this.props.staticData, 'account.name', 'WAHVE');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var currentToast = (0, _lodash.get)(this, 'props.ui.toast', {});
	      var nextToast = (0, _lodash.get)(nextProps, 'ui.toast', {});
	
	      if (!(0, _lodash.isEqual)(currentToast, nextToast)) {
	        this.showToastMessages(nextToast);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // this is needed to avoid binding twice on hot reloading (good in principal regardless)
	      this.props.dispatch((0, _simpleIsoFetch.unbindFromErrorAction)(errorToastFunc));
	    }
	  }, {
	    key: 'showToastMessages',
	    value: function showToastMessages(toast) {
	      if ((0, _lodash.isEmpty)(toast)) {
	        return;
	      }
	
	      this.refs.container.warning(toast.message, toast.title, { closeButton: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var muiTheme = (0, _getMuiTheme2.default)({
	        userAgent: this.props.userAgent || window && window.navigator.userAgent,
	        fontFamily: 'Lato, Arial, sans-serif',
	        palette: {
	          primary1Color: '#2eb0e3', // theme color
	          textColor: 'rgb(33, 35, 38)' // main text color
	        },
	        textField: {
	          underlineShow: false,
	          focusColor: 'rgb(0, 188, 212)',
	          textColor: 'rgb(33, 35, 38)',
	          hintColor: 'rgb(33, 35, 38)',
	          errorStyle: {
	            color: 'rgb(33, 35, 38)'
	          },
	          floatingLabelColor: 'rgb(33, 35, 38)',
	          disabledTextColor: 'rgb(33, 35, 38)'
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Favicon2.default, null),
	        _react2.default.createElement(_reactToastr.ToastContainer, {
	          toastMessageFactory: function toastMessageFactory(props) {
	            return _react2.default.createElement(ToastMessageAnim, _extends({}, props, {
	              className: 'slide',
	              transition: 'slide',
	              timeOut: 6000 }));
	          },
	          ref: 'container',
	          className: 'toast-top-right'
	        }),
	        _react2.default.createElement(
	          _MuiThemeProvider2.default,
	          { muiTheme: muiTheme },
	          this.props.children
	        ),
	        _react2.default.createElement(_SnackBar2.default, {
	          show: this.props.ui.showSnackBar || false,
	          snackBarText: this.props.ui.snackBarText || 'Changes are saved',
	          autoHideDuration: 1000,
	          hideAction: this.props.ui.hideSnackBarAction || null
	        }),
	        this.props.ui.showSpinner && _react2.default.createElement(_Spinner2.default, null)
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func,
	  userAgent: _react.PropTypes.string,
	  ui: _react.PropTypes.object,
	  children: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = App;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccordionListItem = (_temp = _class = function (_React$Component) {
	  _inherits(AccordionListItem, _React$Component);
	
	  _createClass(AccordionListItem, [{
	    key: 'getFormattedTitle',
	    value: function getFormattedTitle() {
	      if (this.props.titleLead) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            this.props.titleLead
	          ),
	          ' ',
	          this.props.title
	        );
	      } else {
	        return this.props.title;
	      }
	    }
	  }]);
	
	  function AccordionListItem(props) {
	    _classCallCheck(this, AccordionListItem);
	
	    return _possibleConstructorReturn(this, (AccordionListItem.__proto__ || Object.getPrototypeOf(AccordionListItem)).call(this, props));
	  }
	
	  _createClass(AccordionListItem, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var accordionIsOpen = this.props.openIndex !== null;
	      var handleClose = function handleClose() {
	        return accordionIsOpen && _this2.props.onSave && _this2.props.onSave();
	      };
	      var panelIsOpen = this.props.openIndex === this.props.index;
	      var hide = this.props.hideAllOnOpen && accordionIsOpen && !panelIsOpen;
	
	      return !hide && _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('accordion-panel-container', { open: panelIsOpen }) },
	        _react2.default.createElement(
	          'div',
	          { className: 'accordion-panel-header',
	            onClick: this.props.onToggle },
	          _react2.default.createElement(
	            'div',
	            { className: 'left' },
	            this.props.showCheckMark && _react2.default.createElement('div', { className: (0, _classnames2.default)('checkbox', { checkmark: this.props.done }) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'accordion-text noTextSelect' },
	              this.getFormattedTitle()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right',
	              onClick: function onClick() {
	                handleClose();_this2.props.onToggle();
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('accordion-toggle') },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('accordion-toggle-text', 'noTextSelect') },
	                panelIsOpen ? this.props.toggleOpenedText : 'View'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'accordion-caret-container' },
	              _react2.default.createElement('div', { className: (0, _classnames2.default)('accordion-toggle-caret', 'chevron', 'toggled') })
	            )
	          )
	        ),
	        panelIsOpen && _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('accordion-item', 'expanded-accordion', 'expanded-accordion-content') },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return AccordionListItem;
	}(_react2.default.Component), _class.propTypes = {
	  index: _react.PropTypes.number,
	  onToggle: _react.PropTypes.func,
	  openIndex: _react.PropTypes.number,
	  title: _react2.default.PropTypes.node,
	  titleLead: _react.PropTypes.string,
	  /*title: React.PropTypes.oneOfType([
	    React.PropTypes.string,
	    React.PropTypes.node,
	  ]),*/
	  done: _react.PropTypes.bool,
	  itemKey: _react.PropTypes.string,
	  onSave: _react.PropTypes.func,
	  toggleOpenedText: _react.PropTypes.string,
	  showCheckMark: _react.PropTypes.bool,
	  hideAllOnOpen: _react.PropTypes.bool
	}, _class.defaultProps = {
	  showCheckMark: true,
	  toggleOpenedText: 'Save',
	  hideAllOnOpen: true
	}, _temp);
	exports.default = AccordionListItem;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AddContact;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _SimpleDropDownMenu = __webpack_require__(121);
	
	var _SimpleDropDownMenu2 = _interopRequireDefault(_SimpleDropDownMenu);
	
	var _PhoneNumberField = __webpack_require__(860);
	
	var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function AddContact(props) {
	  var model = props.model,
	      staticData = props.staticData,
	      fields = props.fields,
	      labels = props.labels,
	      disableSave = props.disableSave,
	      onSave = props.onSave,
	      onCancel = props.onCancel,
	      onUpdate = props.onUpdate,
	      columns = props.columns,
	      emailDuplicate = props.emailDuplicate;
	  var contactTypes = staticData.contactTypes,
	      timezoneList = staticData.timezoneList,
	      contactPhoneTypes = staticData.contactPhoneTypes,
	      stateList = staticData.stateList;
	
	
	  var mFields = fields.slice(0),
	      mLabels = labels.slice(0);
	
	  var mainPhone = (0, _lodash.find)(contactPhoneTypes, { name: 'Main' });
	  var mainPhoneId = (0, _lodash.get)(mainPhone, 'id');
	
	  if ((0, _lodash.get)(model, 'user.phoneType1.value') !== mainPhoneId) {
	    mFields = (0, _lodash.without)(fields, 'user.phoneExtension1');
	    mLabels = (0, _lodash.without)(labels, 'Extension');
	  }
	
	  // How many empty columns we need to complete the last row with 3 columns.
	  var generateBlankColumns = function generateBlankColumns(cols) {
	    return (0, _lodash.fill)((0, _lodash.range)(cols), '');
	  };
	  var blankColumnsInLastRow = columns - mFields.length % columns;
	  var emptyColumns = generateBlankColumns(blankColumnsInLastRow);
	
	  var processedFields = [].concat(_toConsumableArray(mFields), _toConsumableArray(emptyColumns));
	
	  var fieldGroups = (0, _lodash.chunk)(processedFields, columns);
	
	  function handleUpdate(prop) {
	    return function (event, value) {
	      if (onUpdate) {
	        onUpdate(event, prop, value);
	      }
	    };
	  }
	
	  var handleSave = function handleSave() {
	    if (onSave) {
	      onSave();
	    }
	  };
	
	  var handleCancel = function handleCancel() {
	    if (onCancel) {
	      onCancel();
	    }
	  };
	
	  function renderPlaceHolder() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      '\xA0'
	    );
	  }
	
	  function renderDropdown(attributes) {
	    var onChange = attributes.onUpdate,
	        attribs = _objectWithoutProperties(attributes, ['onUpdate']);
	
	    return _react2.default.createElement(_SimpleDropDownMenu2.default, _extends({
	      iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	      labelStyle: { paddingLeft: '0px' },
	      underlineStyle: { margin: '0px 0px' },
	      onChange: onChange
	    }, attribs));
	  }
	
	  function renderChecklist(attributes) {
	    var onChange = attributes.onUpdate,
	        attribs = _objectWithoutProperties(attributes, ['onUpdate']);
	
	    return _react2.default.createElement(_c_CheckList2.default, _extends({
	      className: 'dropdown-filter',
	      onChange: onChange
	    }, attribs));
	  }
	
	  function renderTextField(attributes) {
	    var onBlur = attributes.onUpdate,
	        attribs = _objectWithoutProperties(attributes, ['onUpdate']);
	
	    return _react2.default.createElement(_c_TextField2.default, _extends({
	      onBlur: onBlur,
	      onChange: props.onChange
	    }, attribs));
	  }
	
	  function renderPhoneNumberField(attributes) {
	    var onBlur = attributes.onUpdate,
	        attribs = _objectWithoutProperties(attributes, ['onUpdate']);
	
	    return _react2.default.createElement(_PhoneNumberField2.default, _extends({
	      onBlur: onBlur,
	      onChange: props.onChange
	    }, attribs));
	  }
	
	  function getFieldRenderer(type) {
	    switch (type) {
	      case 'TEXTFIELD':
	        return renderTextField;
	      case 'PHONENUMBER':
	        return renderPhoneNumberField;
	      case 'CHECKLIST':
	        return renderChecklist;
	      case 'DROPDOWN':
	        return renderDropdown;
	      default:
	        return renderPlaceHolder;
	    }
	  }
	
	  function getListItems(field) {
	    if (field === 'profile.types') {
	      return contactTypes;
	    } else if (field === 'user.timezone') {
	      return timezoneList;
	    } else if (field === 'user.phoneType1') {
	      return contactPhoneTypes;
	    } else if (field === 'user.state') {
	      return stateList;
	    }
	  }
	
	  function getFieldType(field) {
	    if (['profile.types'].includes(field)) {
	      return 'CHECKLIST';
	    } else if (['user.timezone', 'user.phoneType1', 'user.state'].includes(field)) {
	      return 'DROPDOWN';
	    } else if (['user.phoneNumber1', 'user.phoneNumber2'].includes(field)) {
	      return 'PHONENUMBER';
	    } else if (field.length === 0) {
	      return 'PLACEHOLDER';
	    }
	
	    return 'TEXTFIELD';
	  }
	
	  function renderField(field, label, model) {
	    var fieldType = getFieldType(field);
	    var dirty = !(0, _lodash.isUndefined)((0, _lodash.get)(model, field + '.value'));
	
	    var attributes = {
	      key: field + '_',
	      'data-id': field,
	      defaultValue: (0, _lodash.get)(model, field + '.defaultValue') || (0, _lodash.get)(model, field + '.value'),
	      floatingLabelText: label || field,
	      errorText: props.hasErrors || dirty ? (0, _lodash.get)(model, field + '.errors[0]') : undefined,
	      isDirty: props.hasErrors || dirty,
	      menuItems: getListItems(field),
	      onUpdate: handleUpdate(field)
	    };
	
	    if (field === 'user.zip') {
	      (0, _lodash.merge)(attributes, { type: 'number', maxLength: 5 });
	    }
	
	    if (field === 'user.email') {
	      (0, _lodash.merge)(attributes, { maxLength: 255 });
	      if (emailDuplicate) (0, _lodash.merge)(attributes, { errorText: 'Email is duplicate' });
	    }
	
	    var renderer = getFieldRenderer(fieldType);
	
	    return renderer(attributes);
	  }
	
	  function renderColumn(field) {
	    var currentIndex = mFields.findIndex(function (f) {
	      return f === field;
	    });
	    return _react2.default.createElement(
	      'div',
	      { className: 'col expand' },
	      renderField(field, mLabels[currentIndex], model)
	    );
	  }
	
	  function renderRow() {
	    var rowFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      rowFields.map(function (field) {
	        return renderColumn(field);
	      })
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'add-contact-component' },
	    _react2.default.createElement(
	      'div',
	      { className: 'grid' },
	      fieldGroups.map(function (group) {
	        return renderRow(group);
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'actions' },
	      _react2.default.createElement(_Button2.default, {
	        label: 'Cancel',
	        className: 'button-secondary',
	        onClick: handleCancel
	      }),
	      _react2.default.createElement(_Button2.default, {
	        label: 'Save',
	        disabled: disableSave,
	        onClick: handleSave
	      })
	    )
	  );
	}
	
	AddContact.propTypes = {
	  model: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  fields: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.array.isRequired,
	  disableSave: _react.PropTypes.bool.isRequired,
	  onSave: _react.PropTypes.func.isRequired,
	  onCancel: _react.PropTypes.func.isRequired,
	  onUpdate: _react.PropTypes.func.isRequired,
	  columns: _react.PropTypes.number.isRequired,
	  emailDuplicate: _react.PropTypes.bool
	};
	
	AddContact.defaultProps = {
	  model: {},
	  fields: ['user.firstName', 'user.lastName', 'user.email', 'profile.types'], // Determines order in which they appear
	  labels: ['First Name', 'Last Name', 'Email', 'Type of Contact'], // Must be in the same order as fields
	  staticData: { // Is possible (?)
	    contactTypes: [],
	    timezoneList: [],
	    contactPhoneTypes: []
	  },
	  disableSave: false,
	  columns: 3 // Determines how many inputs per row
	};

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _SearchIcon = __webpack_require__(167);
	
	var _SearchIcon2 = _interopRequireDefault(_SearchIcon);
	
	var _staticData = __webpack_require__(28);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssignmentTable = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var staticData = store.staticData;
	
	  return {
	    staticData: staticData
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AssignmentTable, _Component);
	
	  function AssignmentTable(props, context) {
	    _classCallCheck(this, AssignmentTable);
	
	    var _this = _possibleConstructorReturn(this, (AssignmentTable.__proto__ || Object.getPrototypeOf(AssignmentTable)).call(this, props, context));
	
	    _this.state = {
	      showHeader: (0, _lodash.get)(_this.props, 'showHeader', true),
	      showSearch: (0, _lodash.get)(_this.props, 'showSearch', true),
	      showFilters: (0, _lodash.get)(_this.props, 'showFilters', true),
	      columns: _this.props.columns !== undefined ? _this.props.columns : ['Id', 'Title', 'Date', 'Status'],
	      sortBy: {
	        field: 'id',
	        order: 'asc'
	      }
	    };
	    return _this;
	  }
	
	  _createClass(AssignmentTable, [{
	    key: 'generateMenuItems',
	    value: function generateMenuItems(staticData, type) {
	
	      var object = staticData[type];
	
	      return (0, _lodash.map)(object, function (item) {
	        return {
	          value: item.id,
	          primaryText: item.name || item.primaryText
	        };
	      });
	    }
	  }, {
	    key: 'onChangeFilter',
	    value: function onChangeFilter(filterName) {
	      return function (event, key, payload) {
	        var newFilters = void 0;
	        switch (filterName) {
	
	          default:
	            break;
	        }
	      };
	    }
	  }, {
	    key: 'onChangeSearch',
	    value: function onChangeSearch(event) {
	      var value = event.target.value ? String(event.target.value) : null;
	      this.setState({ filters: (0, _lodash.merge)(this.state.filters, { id: value }) });
	    }
	
	    /*
	     * Render functions for each column
	     */
	
	  }, {
	    key: 'renderId',
	    value: function renderId(header, row, index) {
	      return this.renderIdWithLink(header, row, index, true);
	    }
	  }, {
	    key: 'renderIdNoLink',
	    value: function renderIdNoLink(header, row, index) {
	      return this.renderIdWithLink(header, row, index, false);
	    }
	  }, {
	    key: 'renderIdWithLink',
	    value: function renderIdWithLink(header, row, index, showLink) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { className: 'asmnt-number' },
	          'Asgmt #'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Asmnt Number' + index, className: 'asmnt-number' },
	        showLink && _react2.default.createElement(
	          'div',
	          { className: 'text-link', onClick: function onClick(e) {
	              return console.log(row.id);
	            } },
	          row.id
	        ) || _react2.default.createElement(
	          'div',
	          null,
	          row.id
	        )
	      );
	    }
	  }, {
	    key: 'renderDate',
	    value: function renderDate(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { className: 'asmnt-date' },
	          'Date'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Date ' + index, className: 'asmnt-date' },
	        (0, _moment2.default)(row.dateCreated).format('L')
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(header, row, index) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { className: 'asmnt-title' },
	          'Title'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Asmnt Title' + index, className: 'asmnt-title' },
	        'Title'
	      );
	    }
	  }, {
	    key: 'renderStatus',
	    value: function renderStatus(header, row, index, status) {
	      if (header) {
	        return _react2.default.createElement(
	          _Table.TableHeaderColumn,
	          { className: 'status' },
	          'Status'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Status #' + index, className: 'status' },
	        _react2.default.createElement('div', { className: 'status-circle', 'data-id': 'Status Icon', style: { backgroundColor: status.color, borderColor: status.color } }),
	        status.name
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _ref = this.props || {},
	          assignmentList = _ref.assignmentList,
	          dispatch = _ref.dispatch;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'assignment-table info-table' },
	        this.state.showSearch && _react2.default.createElement(
	          'header',
	          { className: 'assignment-header' },
	          this.state.showHeader && _react2.default.createElement(
	            'div',
	            { className: 'assignment-title-container' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'assignment-title' },
	              'ASSIGNMENTS'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assignment-search-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'assignment-search' },
	              _react2.default.createElement(_SearchIcon2.default, null),
	              _react2.default.createElement('input', { onChange: function onChange(event) {
	                  return _this2.onChangeSearch(event);
	                }, 'data-id': 'Search',
	                ref: 'search',
	                className: 'search-input',
	                type: 'text',
	                placeholder: 'Search by ID...' })
	            )
	          )
	        ),
	        this.state.showFilters && _react2.default.createElement('div', { className: 'assignment-filter' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'assignment-table-section' },
	          _react2.default.createElement(
	            _Table.Table,
	            { selectable: false, multiSelectable: false },
	            _react2.default.createElement(
	              _Table.TableHeader,
	              { displaySelectAll: false, adjustForCheckbox: false },
	              _react2.default.createElement(
	                _Table.TableRow,
	                null,
	                (0, _lodash.map)(this.state.columns, function (column) {
	                  return _this2['render' + column](true);
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _Table.TableBody,
	              { displayRowCheckbox: false },
	              assignmentList.length == 0 && _react2.default.createElement(
	                'div',
	                { className: 'table-no-data' },
	                'No Assignments Available'
	              ),
	              (0, _lodash.map)(assignmentList, function (row, index) {
	                var status = (0, _staticData.getLookupValue)(_this2.props.staticData, 'assignmentStatus', { id: row.assignmentStatus });
	                return _react2.default.createElement(
	                  _Table.TableRow,
	                  { key: '' + row.id, 'data-id': 'Contact ' + row.id },
	                  (0, _lodash.map)(_this2.state.columns, function (column) {
	                    return _this2['render' + column](false, row, index, status);
	                  })
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssignmentTable;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  assignmentList: _react.PropTypes.object,
	  staticData: _react.PropTypes.object,
	  showHeader: _react.PropTypes.bool,
	  showSearch: _react.PropTypes.bool,
	  showFilters: _react.PropTypes.bool,
	  columns: _react.PropTypes.array
	}, _temp)) || _class);
	exports.default = AssignmentTable;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ButtonGroup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddButtonGroupItem(props) {
	
	  var clientId = _shortid2.default.generate();
	
	  var handleAdd = function handleAdd(event) {
	    if (props.onAdd && (0, _lodash.get)(event, 'target.value')) {
	      props.onAdd(event, clientId, (0, _lodash.get)(event, 'target.value'));
	    }
	  };
	
	  var handleEnter = function handleEnter(event) {
	    if (event.key === 'Enter') {
	      handleAdd(event);
	    }
	  };
	
	  return _react2.default.createElement(
	    'li',
	    {
	      className: 'button-group-item add',
	      'data-id': 'ADD' },
	    _react2.default.createElement('input', { className: 'adding-button-group-item',
	      key: clientId,
	      placeholder: 'ADD',
	      type: 'text',
	      name: 'newItem',
	      defaultValue: '',
	      maxLength: '48',
	      onBlur: handleAdd,
	      onKeyUp: handleEnter
	    })
	  );
	}
	
	AddButtonGroupItem.propTypes = {
	  onAdd: _react.PropTypes.func
	};
	
	function ButtonGroupItem(props) {
	  var value = props.value,
	      name = props.name,
	      selected = props.selected,
	      onToggle = props.onToggle;
	
	
	  var handleToggle = function handleToggle(event) {
	    if (onToggle) {
	      onToggle(event, value, !selected);
	    }
	  };
	
	  return _react2.default.createElement(
	    'li',
	    {
	      onClick: handleToggle,
	      className: (0, _classnames2.default)('button-group-item noTextSelect', { active: selected })
	    },
	    name
	  );
	}
	
	ButtonGroupItem.propTypes = {
	  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  name: _react.PropTypes.string,
	  selected: _react.PropTypes.bool,
	  onToggle: _react.PropTypes.func
	};
	
	function ButtonGroup(props) {
	  var value = props.value,
	      items = props.items,
	      _props$allowAdd = props.allowAdd,
	      allowAdd = _props$allowAdd === undefined ? true : _props$allowAdd,
	      onToggle = props.onToggle,
	      onAdd = props.onAdd;
	
	
	  var menuItems = (0, _lodash.union)(value, items).reduce(function (acc, curr) {
	    if (!acc.find(function (i) {
	      return i.value === curr.value;
	    })) {
	      acc.push(curr);
	    }
	    return acc;
	  }, []);
	
	  var handleToggle = function handleToggle(event, val, selected) {
	    if (onToggle) {
	      onToggle(event, val, selected);
	    }
	  };
	
	  var handleAdd = function handleAdd(event, val, name) {
	    if (onAdd) {
	      return onAdd({ value: val, name: name });
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'button-group-container-wrapper' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'button-group-container' },
	      menuItems.map(function (item) {
	        return _react2.default.createElement(ButtonGroupItem, {
	          value: item.value,
	          name: item.name,
	          selected: !!value.find(function (val) {
	            return val.value === item.value;
	          }),
	          onToggle: handleToggle
	        });
	      }),
	      allowAdd && _react2.default.createElement(AddButtonGroupItem, { onAdd: handleAdd })
	    )
	  );
	}
	
	ButtonGroup.propTypes = {
	  value: _react.PropTypes.array,
	  items: _react.PropTypes.array,
	  showNone: _react.PropTypes.bool,
	  allowAdd: _react.PropTypes.bool,
	  onToggle: _react.PropTypes.func,
	  onAdd: _react.PropTypes.func
	};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MaskTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _masks, _class, _temp;
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MaskTypes = exports.MaskTypes = {
	  phone: 'phone',
	  zipCode: 'zipCode',
	  date: 'date',
	  year: 'year',
	  monthYear: 'monthYear'
	};
	
	var masks = (_masks = {}, _defineProperty(_masks, MaskTypes.phone, {
	  pattern: '(999) 999-9999',
	  filter: /[\(\)\-\s]/g
	}), _defineProperty(_masks, MaskTypes.zipCode, {
	  pattern: '99999'
	}), _defineProperty(_masks, MaskTypes.date, {
	  pattern: '99/99/9999',
	  filter: /\//g
	}), _defineProperty(_masks, MaskTypes.year, {
	  pattern: '9999'
	}), _defineProperty(_masks, MaskTypes.monthYear, {
	  pattern: '99/9999',
	  filter: /\//g
	}), _masks);
	
	var MaskedTextField = (_temp = _class = function (_React$Component) {
	  _inherits(MaskedTextField, _React$Component);
	
	  function MaskedTextField(props, context) {
	    _classCallCheck(this, MaskedTextField);
	
	    var _this = _possibleConstructorReturn(this, (MaskedTextField.__proto__ || Object.getPrototypeOf(MaskedTextField)).call(this, props, context));
	
	    _this.id = _shortid2.default.generate();
	
	    _this.handleChange = function (event) {
	      var value = _this.maskValue(event.target.value);
	      if (_this.props.onChange) {
	        _this.props.onChange(Object.assign({}, event, { target: { value: value } }));
	      }
	      _this.setState(Object.assign({}, _this.state, { value: value }));
	    };
	
	    _this.state = {
	      value: _this.maskValue(props.value || props.defaultValue || '')
	    };
	    return _this;
	  }
	
	  _createClass(MaskedTextField, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ value: this.maskValue(nextProps.value || nextProps.defaultValue || '') });
	    }
	  }, {
	    key: 'maskValue',
	    value: function maskValue(value) {
	      var mask = masks[this.props.type];
	      return value;
	    }
	  }, {
	    key: 'unMaskValue',
	    value: function unMaskValue(value) {
	      var filter = masks[this.props.type].filter;
	      return filter ? value.replace(filter, '') : value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          type = _props.type,
	          value = _props.value,
	          onChange = _props.onChange,
	          otherProps = _objectWithoutProperties(_props, ['type', 'value', 'onChange']); // eslint-disable-line no-unused-vars
	
	
	      return _react2.default.createElement(_c_TextField2.default, _extends({
	        name: '' + _shortid2.default.generate(),
	        value: this.state.value,
	        onChange: this.handleChange
	      }, otherProps));
	    }
	  }]);
	
	  return MaskedTextField;
	}(_react2.default.Component), _class.propTypes = {
	  type: _react.PropTypes.string.isRequired,
	  value: _react.PropTypes.string,
	  defaultValue: _react.PropTypes.string,
	  onChange: _react.PropTypes.func
	}, _temp);
	exports.default = MaskedTextField;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // creating separate component as slight hack needed to allow access to animating "closeModal" function in close button
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalClose = (_temp = _class = function (_Component) {
	  _inherits(ModalClose, _Component);
	
	  function ModalClose() {
	    _classCallCheck(this, ModalClose);
	
	    var _this = _possibleConstructorReturn(this, (ModalClose.__proto__ || Object.getPrototypeOf(ModalClose)).call(this));
	
	    _this.respondToKeyPress = _this.respondToKeyPress.bind(_this);
	    return _this;
	  }
	
	  _createClass(ModalClose, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.respondToKeyPress);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.respondToKeyPress);
	    }
	  }, {
	    key: 'respondToKeyPress',
	    value: function respondToKeyPress(event) {
	      // escape key response
	      if (event.keyCode === 27 && this.props.handleClose) {
	        this.props.handleClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'worksheet-toolbar-item right',
	          'data-id': 'Close',
	          onClick: this.props.handleClose },
	        'Close',
	        _react2.default.createElement(_CloseX2.default, { style: { color: '#fff' } })
	      );
	    }
	  }]);
	
	  return ModalClose;
	}(_react.Component), _class.propTypes = {
	  handleClose: _react.PropTypes.func,
	  removeState: _react.PropTypes.any
	}, _temp);
	exports.default = ModalClose;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactScrollspy = __webpack_require__(408);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationSidebar = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    path: store.routing.locationBeforeTransitions.pathname
	  };
	}, {
	  push: _reactRouterRedux.push
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(NavigationSidebar, _Component);
	
	  function NavigationSidebar(props, context) {
	    _classCallCheck(this, NavigationSidebar);
	
	    return _possibleConstructorReturn(this, (NavigationSidebar.__proto__ || Object.getPrototypeOf(NavigationSidebar)).call(this, props, context));
	  }
	
	  _createClass(NavigationSidebar, [{
	    key: 'match',
	    value: function match(path, link) {
	      if (link.exactMatch) {
	        return path === link.href ? 'active' : null;
	      } else {
	        return (0, _lodash.startsWith)(path, link.href) ? 'active' : null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'navigation-sidebar' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement(
	          _reactScrollspy.Scrollspy,
	          { items: this.props.links },
	          this.props.links.map(function (link) {
	            return _react2.default.createElement(
	              'li',
	              { className: _this2.match(_this2.props.path, link) },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.props.push(link.href);
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'label' },
	                  link.title
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return NavigationSidebar;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  links: _react.PropTypes.array.isRequired,
	  title: _react.PropTypes.string,
	  location: _react.PropTypes.object,
	  path: _react.PropTypes.string.isRequired,
	  push: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = NavigationSidebar;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(753);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _InfoIcon = __webpack_require__(204);
	
	var _InfoIcon2 = _interopRequireDefault(_InfoIcon);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notification = (_temp = _class = function (_Component) {
	  _inherits(Notification, _Component);
	
	  function Notification(props) {
	    _classCallCheck(this, Notification);
	
	    var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));
	
	    _this.dismissNotification = _this.dismissNotification.bind(_this);
	    _this.renderUserAlert = _this.renderUserAlert.bind(_this);
	    _this.renderJobRequestAlert = _this.renderJobRequestAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(Notification, [{
	    key: 'dismissNotification',
	    value: function dismissNotification(id) {
	      this.props.dismiss(id);
	    }
	  }, {
	    key: 'renderUserAlert',
	    value: function renderUserAlert(alert) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'notification', key: alert.id },
	        _react2.default.createElement(
	          'div',
	          { className: 'left-side' },
	          _react2.default.createElement(_InfoIcon2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'user-alert-message' },
	            _react2.default.createElement(
	              'span',
	              { className: 'notification-link', onClick: function onClick() {
	                  return _this2.props.navigate(alert, 'user');
	                } },
	              alert.alertData.name
	            ),
	            '\xA0',
	            alert.alertData.actionLong || alert.alertData.action,
	            '\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'notification-link', onClick: function onClick() {
	                  return _this2.props.navigate(alert, 'location');
	                } },
	              alert.alertData.locationName || alert.alertData.location
	            )
	          )
	        ),
	        _react2.default.createElement(_CloseX2.default, { className: 'dismiss-button', onClick: function onClick() {
	            return _this2.dismissNotification(alert.id, true);
	          } })
	      );
	    }
	  }, {
	    key: 'renderJobRequestAlert',
	    value: function renderJobRequestAlert(alert) {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'notification', key: alert.id },
	        _react2.default.createElement(
	          'div',
	          { className: 'left-side' },
	          _react2.default.createElement(_InfoIcon2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'job-request-alert-message' },
	            alert.alertData.prefixMessage,
	            '\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'notification-link', onClick: function onClick() {
	                  return _this3.props.navigate(alert, null, '/admin/contacts/' + alert.alertData.target + '/details');
	                } },
	              alert.alertData.name
	            ),
	            ',\xA0',
	            alert.alertData.title,
	            '\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'notification-link', onClick: function onClick() {
	                  return _this3.props.navigate(alert, null, '/admin/companies/' + alert.alertData.companyId + '/details');
	                } },
	              alert.alertData.companyName
	            ),
	            alert.alertData.companyStatus === 4 && alert.alertData.suffixMessageActiveAccount,
	            (alert.alertData.companyStatus === 1 || alert.alertData.companyStatus === 2) && alert.alertData.suffixMessageProspect
	          )
	        ),
	        _react2.default.createElement(_CloseX2.default, { className: 'dismiss-button', onClick: function onClick() {
	            return _this3.dismissNotification(alert.id, true);
	          } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'notification-container' },
	        _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          {
	            transitionName: 'notify',
	            transitionEnterTimeout: 500,
	            transitionLeaveTimeout: 300,
	            transitionAppearTimeout: 500,
	            transitionAppear: true,
	            key: 'notification' },
	          this.props.alerts.map(function (alert) {
	            switch (alert.alertData.type) {
	              case 'JobRequestAlert':
	                return _this4.renderJobRequestAlert(alert);
	              case 'UserAlert':
	              default:
	                return _this4.renderUserAlert(alert);
	            }
	          }, this)
	        )
	      );
	    }
	  }]);
	
	  return Notification;
	}(_react.Component), _class.propTypes = {
	  alerts: _react.PropTypes.array.isRequired,
	  dismiss: _react.PropTypes.func,
	  navigate: _react.PropTypes.func
	}, _temp);
	exports.default = Notification;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = PhoneNumberField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function PhoneNumberField(props) {
	  var _props$className = props.className,
	      className = _props$className === undefined ? 'phone-number' : _props$className,
	      _props$floatingLabelT = props.floatingLabelText,
	      floatingLabelText = _props$floatingLabelT === undefined ? 'Phone Number' : _props$floatingLabelT,
	      _props$optional = props.optional,
	      optional = _props$optional === undefined ? false : _props$optional,
	      dataId = props['data-id'],
	      attributes = _objectWithoutProperties(props, ['className', 'floatingLabelText', 'optional', 'data-id']);
	
	  var mask = '(999) 999-9999';
	
	  return _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	    hideMaskChar: true,
	    'data-id': dataId,
	    className: className,
	    floatingLabelText: floatingLabelText,
	    mask: mask
	  }, attributes));
	}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SnackBar = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    ui: store.ui
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(SnackBar, _Component);
	
	  function SnackBar(props) {
	    _classCallCheck(this, SnackBar);
	
	    var _this = _possibleConstructorReturn(this, (SnackBar.__proto__ || Object.getPrototypeOf(SnackBar)).call(this, props));
	
	    _this.state = {
	      showSnackBar: false
	    };
	
	    _this.hideSnackbar = _this.hideSnackbar.bind(_this);
	    return _this;
	  }
	
	  _createClass(SnackBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var showSnackBar = this.state.showSnackBar;
	
	      if (showSnackBar !== nextProps.show) {
	        this.setState({
	          showSnackBar: nextProps.show
	        });
	
	        if (nextProps.show) {
	          setTimeout(function () {
	            _this2.hideSnackbar();
	            if (_this2.props.hideAction) {
	              _this2.props.hideAction();
	            }
	          }, 3000);
	        }
	      }
	    }
	  }, {
	    key: 'hideSnackbar',
	    value: function hideSnackbar() {
	      this.props.dispatch(ui.hideSnackBar());
	      this.setState({
	        showSnackBar: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _snackbarStyle;
	
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          actionText = _props.actionText,
	          action = _props.action,
	          show = _props.show,
	          snackBarText = _props.snackBarText;
	      var showSnackBar = this.state.showSnackBar;
	
	
	      var snackbarContainer = {
	        maxWidth: '980px',
	        width: '100%',
	        marginLeft: '265px',
	        position: 'fixed',
	        left: 0,
	        right: 0,
	        bottom: '-50px',
	        zIndex: 2000,
	        WebkitTransition: 'bottom 200ms cubic-bezier(0, 0, 0.30, 1)',
	        transition: 'bottom 200ms cubic-bezier(0, 0, 0.30, 1)',
	        textTransform: 'initial'
	      };
	
	      var snackbarStyle = (_snackbarStyle = {
	        width: '50%',
	        minHeight: '50px',
	        background: '#323232',
	        color: '#fff',
	        margin: 'auto',
	        display: '-webkit-box'
	      }, _defineProperty(_snackbarStyle, 'display', '-ms-flexbox'), _defineProperty(_snackbarStyle, 'display', 'flex'), _defineProperty(_snackbarStyle, 'WebkitBoxAlign', 'center'), _defineProperty(_snackbarStyle, 'msFlexAlign', 'center'), _defineProperty(_snackbarStyle, 'alignItems', 'center'), _defineProperty(_snackbarStyle, 'WebkitBoxPack', 'justify'), _defineProperty(_snackbarStyle, 'msFlexPack', 'justify'), _defineProperty(_snackbarStyle, 'justifyContent', 'space-between'), _defineProperty(_snackbarStyle, 'fontWeight', '500'), _defineProperty(_snackbarStyle, 'fontSize', '14px'), _snackbarStyle);
	
	      var snackbarTextStyle = {
	        marginLeft: '15px',
	        wordBreak: 'break-all',
	        flexGrow: 1
	      };
	
	      var snackbarActionStyle = {
	        textTransform: 'uppercase',
	        color: '#2eb0e3',
	        cursor: 'pointer',
	        marginRight: '15px',
	        border: 0,
	        background: 'transparent',
	        fontSize: '13px',
	        outline: 0
	      };
	
	      if (showSnackBar) {
	        snackbarContainer.bottom = 0;
	      } else {
	        snackbarContainer.bottom = '-50px';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-id': 'snackbar', style: snackbarContainer },
	        _react2.default.createElement(
	          'div',
	          { style: snackbarStyle },
	          _react2.default.createElement(
	            'p',
	            { style: snackbarTextStyle },
	            snackBarText
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: snackbarActionStyle, onClick: this.props.action || this.hideSnackbar },
	            actionText
	          )
	        )
	      );
	    }
	  }]);
	
	  return SnackBar;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func,
	  actionText: _react.PropTypes.string,
	  action: _react.PropTypes.func,
	  hideAction: _react.PropTypes.func,
	  show: _react.PropTypes.bool.isRequired,
	  snackBarText: _react.PropTypes.string.isRequired
	}, _temp)) || _class);
	exports.default = SnackBar;
	
	
	SnackBar.defaultProps = {
	  actionText: 'OK'
	};
	
	SnackBar.propTypes = {
	  actionText: _react.PropTypes.string,
	  action: _react.PropTypes.func,
	  hideAction: _react.PropTypes.func,
	  show: _react.PropTypes.bool.isRequired,
	  snackBarText: _react.PropTypes.string.isRequired
	};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMdSpinner = __webpack_require__(2796);
	
	var _reactMdSpinner2 = _interopRequireDefault(_reactMdSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = (_temp = _class = function (_Component) {
	  _inherits(Spinner, _Component);
	
	  function Spinner() {
	    _classCallCheck(this, Spinner);
	
	    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
	  }
	
	  _createClass(Spinner, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'spinner-fullscreen' },
	        _react2.default.createElement(_reactMdSpinner2.default, { singleColor: '#2eb0e3', size: 100, className: 'spinner' })
	      );
	    }
	  }]);
	
	  return Spinner;
	}(_react.Component), _class.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = Spinner;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// import classnames utility
	
	
	// js utility functions
	
	
	// import modified component from material UI
	
	
	// import material UI element with slightly modified source code
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _c_SourceModMenuItem = __webpack_require__(166);
	
	var _c_SourceModMenuItem2 = _interopRequireDefault(_c_SourceModMenuItem);
	
	var _c_SourceModDropDown = __webpack_require__(202);
	
	var _c_SourceModDropDown2 = _interopRequireDefault(_c_SourceModDropDown);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropdownStyle = {
	  overflow: 'hidden'
	};
	
	var menuCustomization = {
	  autoWidth: false,
	  menuStyle: {
	    overflowX: 'hidden',
	    width: '100%',
	    backgroundColor: '#fafafa'
	  },
	  labelStyle: {
	    color: '#4a4a4a',
	    maxWidth: '100%',
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    fontSize: '16px',
	    height: '48px'
	  },
	  listStyle: {
	    backgroundColor: '#fafafa',
	    fontWeight: 100,
	    width: '100%'
	  },
	  selectedMenuItemStyle: {
	    padding: 0,
	    color: '#4a4a4a',
	    backgroundColor: '#eee'
	  },
	  popoverStyle: {
	    transition: 'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1), width 1000ms cubic-bezier(0.23, 1, 0.32, 1)'
	  }
	};
	
	var menuItemCustomization = {
	  disableTouchRipple: true,
	  disableFocusRipple: true
	};
	
	var StatusFilter = (_temp = _class = function (_Component) {
	  _inherits(StatusFilter, _Component);
	
	  function StatusFilter(props, context) {
	    _classCallCheck(this, StatusFilter);
	
	    var _this = _possibleConstructorReturn(this, (StatusFilter.__proto__ || Object.getPrototypeOf(StatusFilter)).call(this, props, context));
	
	    _this.state = {
	      checked: []
	    };
	    return _this;
	  }
	
	  _createClass(StatusFilter, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // check for initial value
	      var initVal = this.props.defaultValue || [];
	
	      this.setState({ checked: initVal });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event, index, value) {
	      if (!value) {
	        return;
	      }
	
	      var primaryText = this.props.menuItems[index].name;
	
	      var newCheckedArr = ~this.state.checked.indexOf(value) ? this.state.checked.filter(function (val) {
	        return val !== value;
	      }) : this.state.checked.concat(value);
	
	      this.setState((0, _lodash.assign)(this.state, {
	        checked: newCheckedArr
	      }));
	
	      if (this.props.onChange) {
	        this.props.onChange(event, newCheckedArr, primaryText, value);
	      }
	
	      if (this.props.onBlur) {
	        this.props.onBlur(event, newCheckedArr, primaryText, value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // take out properties that will be overwritten from 'this.props'
	      var _props = this.props,
	          className = _props.className,
	          onChange = _props.onChange,
	          onBlur = _props.onBlur,
	          style = _props.style,
	          dataId = _props['data-id'],
	          containerStyle = _props.containerStyle,
	          propsMenuItemCustomization = _props.menuItemCustomization,
	          propsSelectedMenuItemStyle = _props.selectedMenuItemStyle,
	          propsListStyle = _props.listStyle,
	          propsMenuStyle = _props.menuStyle,
	          propsLabelStyle = _props.labelStyle,
	          unmodifiedProps = _objectWithoutProperties(_props, ['className', 'onChange', 'onBlur', 'style', 'data-id', 'containerStyle', 'menuItemCustomization', 'selectedMenuItemStyle', 'listStyle', 'menuStyle', 'labelStyle']);
	
	      var additionalProps = {
	        onChange: this.onChange.bind(this),
	        style: (0, _lodash.merge)({}, style, dropdownStyle)
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('clearfix', 'card-filter-wrapper', className), style: containerStyle },
	        _react2.default.createElement(
	          _c_SourceModDropDown2.default,
	          _extends({ className: 'card-filter-dropdown',
	            'data-id': dataId,
	            isMenu: 'true',
	            checkList: true
	          }, menuCustomization, unmodifiedProps, additionalProps),
	          this.props.menuItems.map(function (val, index) {
	            return _react2.default.createElement(_c_SourceModMenuItem2.default, _extends({ value: val.id,
	              checked: !!~_this2.state.checked.indexOf(val.id) || _this2.props.menuItems.length === 1,
	              checkMark: true,
	              className: 'card-filter-status-item',
	              primaryText: val.name,
	              key: index,
	              'data-id': val.name
	            }, menuItemCustomization, propsMenuItemCustomization));
	          })
	        )
	      );
	    }
	  }]);
	
	  return StatusFilter;
	}(_react.Component), _class.propTypes = {
	  id: _react.PropTypes.any,
	  onErrorChange: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  menuItems: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string,
	  defaultValue: _react.PropTypes.any,
	  style: _react.PropTypes.object,
	  listStyle: _react.PropTypes.object,
	  menuStyle: _react.PropTypes.object,
	  containerStyle: _react.PropTypes.object,
	  labelStyle: _react.PropTypes.object,
	  menuItemCustomization: _react.PropTypes.object,
	  selectedMenuItemStyle: _react.PropTypes.object,
	  'data-id': _react.PropTypes.string,
	  children: _react.PropTypes.object,
	  search: _react.PropTypes.array
	}, _class.defaultProps = {
	  menuItems: []
	}, _temp);
	exports.default = StatusFilter;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubText = (_temp = _class = function (_Component) {
	  _inherits(SubText, _Component);
	
	  function SubText(props, context) {
	    _classCallCheck(this, SubText);
	
	    return _possibleConstructorReturn(this, (SubText.__proto__ || Object.getPrototypeOf(SubText)).call(this, props, context));
	  }
	
	  _createClass(SubText, [{
	    key: 'onClick',
	    value: function onClick() {
	      if (this.props.onClick) {
	        this.props.onClick(this.props.note);
	      }
	    }
	  }, {
	    key: 'renderSubtext',
	    value: function renderSubtext() {
	      var textList = this.props.text.split(/[\[\]]/);
	      var spans = [];
	      if (textList.length === 3) {
	        spans.push(_react2.default.createElement(
	          'span',
	          null,
	          textList[0]
	        ));
	        spans.push(_react2.default.createElement(
	          'span',
	          { className: 'link', onClick: this.onClick.bind(this) },
	          textList[1]
	        ));
	        spans.push(_react2.default.createElement(
	          'span',
	          null,
	          textList[2]
	        ));
	      } else {
	        spans.push(_react2.default.createElement(
	          'span',
	          { className: 'link', onClick: this.onClick.bind(this) },
	          this.props.text
	        ));
	      }
	      return spans;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'subtext-wrapper ' + className },
	        this.props.children,
	        _react2.default.createElement(
	          'div',
	          { className: 'subtext' },
	          this.renderSubtext()
	        )
	      );
	    }
	  }]);
	
	  return SubText;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  text: _react.PropTypes.string,
	  note: _react.PropTypes.string,
	  onClick: _react.PropTypes.func,
	  children: _react.PropTypes.object.isRequired
	}, _temp);
	exports.default = SubText;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonGroupItem = (_temp = _class = function (_Component) {
	  _inherits(ButtonGroupItem, _Component);
	
	  function ButtonGroupItem(props, context) {
	    _classCallCheck(this, ButtonGroupItem);
	
	    return _possibleConstructorReturn(this, (ButtonGroupItem.__proto__ || Object.getPrototypeOf(ButtonGroupItem)).call(this, props, context));
	  }
	
	  _createClass(ButtonGroupItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)('button-group-item noTextSelect', { active: this.props.selected, 'not-visible': !this.props.visible }),
	          onClick: this.props.onClick,
	          'data-id': this.props.value
	        },
	        this.props.value
	      );
	    }
	  }]);
	
	  return ButtonGroupItem;
	}(_react.Component), _class.propTypes = {
	  value: _react.PropTypes.any.isRequired,
	  selected: _react.PropTypes.bool,
	  id: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  visible: _react.PropTypes.bool,
	  onClick: _react.PropTypes.func
	}, _temp);
	exports.default = ButtonGroupItem;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(188);
	
	var _colorManipulator = __webpack_require__(117);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(593);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateLabel(props, propName, componentName) {
	  if (!props.children && !props.label && !props.icon) {
	    return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	  }
	}
	
	var FlatButton = (_temp2 = _class = function (_Component) {
	  _inherits(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FlatButton.__proto__ || Object.getPrototypeOf(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FlatButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          disabled = _props.disabled,
	          disabledStyle = _props.disabledStyle,
	          hoverColor = _props.hoverColor,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          linkButton = _props.linkButton,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          hoverStyle = _props.hoverStyle,
	          other = _objectWithoutProperties(_props, ['children', 'disabled', 'disabledStyle', 'hoverColor', 'backgroundColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'linkButton', 'primary', 'rippleColor', 'secondary', 'style', 'hoverStyle']);
	
	      var _context$muiTheme = this.context.muiTheme,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = Object.assign({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: 2,
	        userSelect: 'none',
	        position: 'relative',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: '0px',
	        margin: 0,
	        textAlign: 'center'
	      }, style, hovered ? hoverStyle : {}, disabled ? disabledStyle : {});
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: {
	            verticalAlign: 'middle',
	            marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	            marginRight: label && labelPosition === 'before' ? 12 : 0
	          }
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = Object.assign({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          linkButton: linkButton,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3 }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	
	  return FlatButton;
	}(_react.Component), _class.muiName = 'FlatButton', _class.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * URL to link to when button clicked if `linkButton` is set to true.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Enables use of `href` property to provide a URL to link to if set to true.
	   */
	  linkButton: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the mouse enters the element.
	   *
	   * @param {object} event `mouseenter` event targeting the element.
	   */
	  onMouseEnter: _react.PropTypes.func,
	  /**
	   * Callback function fired when the mouse leaves the element.
	   *
	   * @param {object} event `mouseleave` event targeting the element.
	   */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Callback function fired when the element is touched.
	   *
	   * @param {object} event `touchstart` event targeting the element.
	   */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _react.PropTypes.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Styles applied when hovered
	   */
	  hoverStyle: _react.PropTypes.object,
	  /**
	   * Styles applied when disabled
	   */
	  disabledStyle: _react.PropTypes.object
	}, _class.defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	}, _class.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	}, _temp2);
	exports.default = FlatButton;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // https://github.com/sanniassin/react-input-mask
	
	
	// utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// declare regexes once for performance
	var windows = new RegExp('windows', 'i');
	var firefox = new RegExp('firefox', 'i');
	var android = new RegExp('android', 'i');
	var phone = new RegExp('phone', 'i');
	
	var InputElement = _react2.default.createClass({
	    displayName: "InputElement",
	
	    defaultCharsRules: {
	        "9": "[0-9]",
	        "a": "[A-Za-z]",
	        "*": "[A-Za-z0-9]"
	    },
	    defaultMaskChar: "_",
	    lastCaretPos: null,
	    isAndroidBrowser: function isAndroidBrowser() {
	        var ua = navigator.userAgent;
	        return !windows.test(ua) && !firefox.test(ua) && android.test(ua);
	    },
	    isWindowsPhoneBrowser: function isWindowsPhoneBrowser() {
	        var ua = navigator.userAgent;
	        return windows.test(ua) && phone.test(ua);
	    },
	    isAndroidFirefox: function isAndroidFirefox() {
	        var ua = navigator.userAgent;
	        return !windows.test(ua) && firefox.test(ua) && android.test(ua);
	    },
	    isDOMElement: function isDOMElement(element) {
	        return (typeof HTMLElement === 'undefined' ? 'undefined' : _typeof(HTMLElement)) === 'object' ? element instanceof HTMLElement : // DOM2
	        element.nodeType === 1 && typeof element.nodeName === 'string';
	    },
	    getInputDOMNode: function getInputDOMNode() {
	        return this.refs.input || null;
	    },
	    enableValueAccessors: function enableValueAccessors() {
	        var _this = this;
	
	        var canUseAccessors = !!(Object.getOwnPropertyDescriptor && Object.getPrototypeOf && Object.defineProperty);
	        if (canUseAccessors) {
	            var input = this.getInputDOMNode();
	            this.valueDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(input), 'value');
	            Object.defineProperty(input, 'value', {
	                configurable: true,
	                enumerable: true,
	                get: function get() {
	                    return _this.value;
	                },
	                set: function set(val) {
	                    _this.value = val;
	                    _this.valueDescriptor.set.call(input, val);
	                }
	            });
	        }
	    },
	    disableValueAccessors: function disableValueAccessors() {
	        var valueDescriptor = this.valueDescriptor;
	
	        if (!valueDescriptor) {
	            return;
	        }
	        this.valueDescriptor = null;
	        var input = this.getInputDOMNode();
	        Object.defineProperty(input, 'value', valueDescriptor);
	    },
	    getInputValue: function getInputValue() {
	        var input = this.getInputDOMNode();
	        var valueDescriptor = this.valueDescriptor;
	
	        var value;
	        if (valueDescriptor) {
	            value = valueDescriptor.get.call(input);
	        } else {
	            value = input.value;
	        }
	
	        return value;
	    },
	    getPrefix: function getPrefix() {
	        var prefix = "";
	        var mask = this.mask;
	
	        for (var i = 0; i < mask.length && this.isPermanentChar(i); ++i) {
	            prefix += mask[i];
	        }
	        return prefix;
	    },
	    getFilledLength: function getFilledLength() {
	        var value = arguments.length <= 0 || arguments[0] === undefined ? this.state.value : arguments[0];
	
	        var i;
	        var maskChar = this.maskChar;
	
	        if (!maskChar) {
	            return value.length;
	        }
	
	        for (i = value.length - 1; i >= 0; --i) {
	            var character = value[i];
	            if (!this.isPermanentChar(i) && this.isAllowedChar(character, i)) {
	                break;
	            }
	        }
	
	        return ++i || this.getPrefix().length;
	    },
	    getLeftEditablePos: function getLeftEditablePos(pos) {
	        for (var i = pos; i >= 0; --i) {
	            if (!this.isPermanentChar(i)) {
	                return i;
	            }
	        }
	        return null;
	    },
	    getRightEditablePos: function getRightEditablePos(pos) {
	        var mask = this.mask;
	
	        for (var i = pos; i < mask.length; ++i) {
	            if (!this.isPermanentChar(i)) {
	                return i;
	            }
	        }
	        return null;
	    },
	    isEmpty: function isEmpty() {
	        var _this2 = this;
	
	        var value = arguments.length <= 0 || arguments[0] === undefined ? this.state.value : arguments[0];
	
	        return !value.split("").some(function (character, i) {
	            return !_this2.isPermanentChar(i) && _this2.isAllowedChar(character, i);
	        });
	    },
	    isFilled: function isFilled() {
	        var value = arguments.length <= 0 || arguments[0] === undefined ? this.state.value : arguments[0];
	
	        return this.getFilledLength(value) === this.mask.length;
	    },
	    createFilledArray: function createFilledArray(length, val) {
	        var array = [];
	        for (var i = 0; i < length; i++) {
	            array[i] = val;
	        }
	        return array;
	    },
	    formatValue: function formatValue(value) {
	        var _this3 = this;
	
	        var maskChar = this.maskChar;
	        var mask = this.mask;
	
	        if (!maskChar) {
	            var prefix = this.getPrefix();
	            var prefixLen = prefix.length;
	            value = this.insertRawSubstr("", value, 0);
	            while (value.length > prefixLen && this.isPermanentChar(value.length - 1)) {
	                value = value.slice(0, value.length - 1);
	            }
	
	            if (value.length < prefixLen) {
	                value = prefix;
	            }
	
	            return value;
	        }
	        if (value) {
	            var emptyValue = this.formatValue("");
	            return this.insertRawSubstr(emptyValue, value, 0);
	        }
	        return value.split("").concat(this.createFilledArray(mask.length - value.length, null)).map(function (character, pos) {
	            if (_this3.isAllowedChar(character, pos)) {
	                return character;
	            } else if (_this3.isPermanentChar(pos)) {
	                return mask[pos];
	            }
	            return maskChar;
	        }).join("");
	    },
	    clearRange: function clearRange(value, start, len) {
	        var _this4 = this;
	
	        var end = start + len;
	        var maskChar = this.maskChar;
	        var mask = this.mask;
	
	        if (!maskChar) {
	            var prefixLen = this.getPrefix().length;
	            value = value.split("").filter(function (character, i) {
	                return i < prefixLen || i < start || i >= end;
	            }).join("");
	            return this.formatValue(value);
	        }
	        return value.split("").map(function (character, i) {
	            if (i < start || i >= end) {
	                return character;
	            }
	            if (_this4.isPermanentChar(i)) {
	                return mask[i];
	            }
	            return maskChar;
	        }).join("");
	    },
	    replaceSubstr: function replaceSubstr(value, newSubstr, pos) {
	        return value.slice(0, pos) + newSubstr + value.slice(pos + newSubstr.length);
	    },
	    insertRawSubstr: function insertRawSubstr(value, substr, pos) {
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	
	        var isFilled = this.isFilled(value);
	        var prefixLen = this.getPrefix().length;
	        substr = substr.split("");
	
	        if (!maskChar && pos > value.length) {
	            value += mask.slice(value.length, pos);
	        }
	
	        for (var i = pos; i < mask.length && substr.length;) {
	            var isPermanent = this.isPermanentChar(i);
	            if (!isPermanent || mask[i] === substr[0]) {
	                var character = substr.shift();
	                if (this.isAllowedChar(character, i, true)) {
	                    if (i < value.length) {
	                        if (maskChar || isFilled || i < prefixLen) {
	                            value = this.replaceSubstr(value, character, i);
	                        } else {
	                            value = this.formatValue(value.substr(0, i) + character + value.substr(i));
	                        }
	                    } else if (!maskChar) {
	                        value += character;
	                    }
	                    ++i;
	                }
	            } else {
	                if (!maskChar && i >= value.length) {
	                    value += mask[i];
	                } else if (maskChar && isPermanent && substr[0] === maskChar) {
	                    substr.shift();
	                }
	                ++i;
	            }
	        }
	        return value;
	    },
	    getRawSubstrLength: function getRawSubstrLength(value, substr, pos) {
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	
	        substr = substr.split("");
	        for (var i = pos; i < mask.length && substr.length;) {
	            if (!this.isPermanentChar(i) || mask[i] === substr[0]) {
	                var character = substr.shift();
	                if (this.isAllowedChar(character, i, true)) {
	                    ++i;
	                }
	            } else {
	                ++i;
	            }
	        }
	        return i - pos;
	    },
	    isAllowedChar: function isAllowedChar(character, pos) {
	        var allowMaskChar = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	
	        if (this.isPermanentChar(pos)) {
	            return mask[pos] === character;
	        }
	        var ruleChar = mask[pos];
	        var charRule = this.charsRules[ruleChar];
	        return new RegExp(charRule).test(character || "") || allowMaskChar && character === maskChar;
	    },
	    isPermanentChar: function isPermanentChar(pos) {
	        return this.permanents.indexOf(pos) !== -1;
	    },
	    setCaretToEnd: function setCaretToEnd() {
	        var filledLen = this.getFilledLength();
	        var pos = this.getRightEditablePos(filledLen);
	        if (pos !== null) {
	            this.setCaretPos(pos);
	        }
	    },
	    setSelection: function setSelection(start) {
	        var len = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	        var input = this.getInputDOMNode();
	        if (!input) {
	            return;
	        }
	
	        var end = start + len;
	        if ("selectionStart" in input && "selectionEnd" in input) {
	            input.selectionStart = start;
	            input.selectionEnd = end;
	        } else {
	            var range = input.createTextRange();
	            range.collapse(true);
	            range.moveStart("character", start);
	            range.moveEnd("character", end - start);
	            range.select();
	        }
	    },
	    getSelection: function getSelection() {
	        var input = this.getInputDOMNode();
	        var start = 0;
	        var end = 0;
	
	        if ("selectionStart" in input && "selectionEnd" in input) {
	            start = input.selectionStart;
	            end = input.selectionEnd;
	        } else {
	            var range = document.selection.createRange();
	            if (range.parentElement() === input) {
	                start = -range.moveStart("character", -input.value.length);
	                end = -range.moveEnd("character", -input.value.length);
	            }
	        }
	
	        return {
	            start: start,
	            end: end,
	            length: end - start
	        };
	    },
	    getCaretPos: function getCaretPos() {
	        return this.getSelection().start;
	    },
	    setCaretPos: function setCaretPos(pos) {
	        var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (fn) {
	            return setTimeout(fn, 0);
	        };
	
	        var setPos = this.setSelection.bind(this, pos, 0);
	
	        setPos();
	        raf(setPos);
	
	        this.lastCaretPos = pos;
	    },
	    isFocused: function isFocused() {
	        return document.activeElement === this.getInputDOMNode();
	    },
	    parseMask: function parseMask(mask) {
	        var _this5 = this;
	
	        if (typeof mask !== "string") {
	            return {
	                mask: null,
	                permanents: []
	            };
	        }
	        var str = "";
	        var permanents = [];
	        var isPermanent = false;
	
	        mask.split("").forEach(function (character) {
	            if (!isPermanent && character === "\\") {
	                isPermanent = true;
	            } else {
	                if (isPermanent || !_this5.charsRules[character]) {
	                    permanents.push(str.length);
	                }
	                str += character;
	                isPermanent = false;
	            }
	        });
	
	        return {
	            mask: str,
	            permanents: permanents
	        };
	    },
	    getStringValue: function getStringValue(value) {
	        return !value && value !== 0 ? "" : value + "";
	    },
	    getInitialState: function getInitialState() {
	        this.hasValue = this.props.value != null;
	        this.charsRules = "formatChars" in this.props ? this.props.formatChars : this.defaultCharsRules;
	
	        var mask = this.parseMask(this.props.mask);
	        var defaultValue = this.props.defaultValue != null ? this.props.defaultValue : '';
	        var value = this.props.value != null ? this.props.value : defaultValue;
	
	        value = this.getStringValue(value);
	
	        this.mask = mask.mask;
	        this.permanents = mask.permanents;
	        this.maskChar = "maskChar" in this.props ? this.props.maskChar : this.defaultMaskChar;
	
	        if (this.mask && (this.props.alwaysShowMask || value)) {
	            value = this.formatValue(value);
	        }
	
	        return { value: value };
	    },
	    componentWillMount: function componentWillMount() {
	        var mask = this.mask;
	        var value = this.state.value;
	
	        if (mask && value) {
	            this.setState({ value: value });
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.hasValue = this.props.value != null;
	        this.charsRules = "formatChars" in nextProps ? nextProps.formatChars : this.defaultCharsRules;
	
	        var mask = this.parseMask(nextProps.mask);
	        var isMaskChanged = mask.mask && mask.mask !== this.mask;
	
	        this.mask = mask.mask;
	        this.permanents = mask.permanents;
	        this.maskChar = "maskChar" in nextProps ? nextProps.maskChar : this.defaultMaskChar;
	
	        if (!this.mask) {
	            return;
	        }
	
	        var newValue = nextProps.value != null ? this.getStringValue(nextProps.value) : this.state.value;
	
	        var showEmpty = nextProps.alwaysShowMask || this.isFocused();
	        if (isMaskChanged || mask.mask && (newValue || showEmpty && !this.hasValue)) {
	            newValue = this.formatValue(newValue);
	
	            if (isMaskChanged) {
	                var pos = this.lastCaretPos;
	                var filledLen = this.getFilledLength(newValue);
	                if (filledLen < pos) {
	                    this.setCaretPos(this.getRightEditablePos(filledLen));
	                }
	            }
	        }
	        if (mask.mask && this.isEmpty(newValue) && !showEmpty && !this.hasValue) {
	            newValue = "";
	        }
	        this.value = newValue;
	        if (this.state.value !== newValue) {
	            this.setState({ value: newValue });
	        }
	    },
	    onKeyDown: function onKeyDown(event) {
	        var hasHandler = typeof this.props.onKeyDown === "function";
	        if (event.ctrlKey || event.metaKey) {
	            if (hasHandler) {
	                this.props.onKeyDown(event);
	            }
	            return;
	        }
	
	        var caretPos = this.getCaretPos();
	        var value = this.state.value;
	        var key = event.key;
	        var preventDefault = false;
	        switch (key) {
	            case "Backspace":
	            case "Delete":
	                var prefixLen = this.getPrefix().length;
	                var deleteFromRight = key === "Delete";
	                var selectionRange = this.getSelection();
	                if (selectionRange.length) {
	                    value = this.clearRange(value, selectionRange.start, selectionRange.length);
	                } else if (caretPos < prefixLen || !deleteFromRight && caretPos === prefixLen) {
	                    caretPos = prefixLen;
	                } else {
	                    var editablePos = deleteFromRight ? this.getRightEditablePos(caretPos) : this.getLeftEditablePos(caretPos - 1);
	                    if (editablePos !== null) {
	                        value = this.clearRange(value, editablePos, 1);
	                        caretPos = editablePos;
	                    }
	                }
	                preventDefault = true;
	                break;
	            default:
	                break;
	        }
	
	        if (hasHandler) {
	            this.props.onKeyDown(event);
	        }
	
	        if (value !== this.state.value) {
	            event.target.value = value;
	            this.setState({
	                value: this.hasValue ? this.state.value : value
	            });
	            preventDefault = true;
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        }
	        if (preventDefault) {
	            event.preventDefault();
	            this.setCaretPos(caretPos);
	        }
	    },
	    onKeyPress: function onKeyPress(event) {
	        var key = event.key;
	        var hasHandler = typeof this.props.onKeyPress === "function";
	        if (key === "Enter" || event.ctrlKey || event.metaKey) {
	            if (hasHandler) {
	                this.props.onKeyPress(event);
	            }
	            return;
	        }
	
	        if (this.isWindowsPhoneBrowser) {
	            return;
	        }
	
	        var caretPos = this.getCaretPos();
	        var selection = this.getSelection();
	        var value = this.state.value;
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	
	        var maskLen = mask.length;
	        var prefixLen = this.getPrefix().length;
	
	        if (this.isPermanentChar(caretPos) && mask[caretPos] === key) {
	            value = this.insertRawSubstr(value, key, caretPos);
	            ++caretPos;
	        } else {
	            var editablePos = this.getRightEditablePos(caretPos);
	            if (editablePos !== null && this.isAllowedChar(key, editablePos)) {
	                value = this.clearRange(value, selection.start, selection.length);
	                value = this.insertRawSubstr(value, key, editablePos);
	                caretPos = editablePos + 1;
	            }
	        }
	
	        if (value !== this.state.value) {
	            event.target.value = value;
	            this.setState({
	                value: this.hasValue ? this.state.value : value
	            });
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        }
	        event.preventDefault();
	        if (caretPos < maskLen && caretPos > prefixLen) {
	            caretPos = this.getRightEditablePos(caretPos);
	        }
	        this.setCaretPos(caretPos);
	    },
	    onChange: function onChange(event) {
	        var _this6 = this;
	
	        var pasteSelection = this.pasteSelection;
	        var mask = this.mask;
	        var maskChar = this.maskChar;
	
	        var target = event.target;
	        var value = this.getInputValue();
	        if (!value && this.preventEmptyChange) {
	            this.disableValueAccessors();
	            this.preventEmptyChange = false;
	            target.value = this.state.value;
	            return;
	        }
	        var oldValue = this.state.value;
	        if (pasteSelection) {
	            this.pasteSelection = null;
	            this.pasteText(oldValue, value, pasteSelection, event);
	            return;
	        }
	        var selection = this.getSelection();
	        var caretPos = selection.end;
	        var maskLen = mask.length;
	        var valueLen = value.length;
	        var oldValueLen = oldValue.length;
	        var prefixLen = this.getPrefix().length;
	        var clearedValue;
	
	        if (valueLen > oldValueLen) {
	            var substrLen = valueLen - oldValueLen;
	            var startPos = selection.end - substrLen;
	            var enteredSubstr = value.substr(startPos, substrLen);
	
	            if (startPos < maskLen && (substrLen !== 1 || enteredSubstr !== mask[startPos])) {
	                caretPos = this.getRightEditablePos(startPos);
	            } else {
	                caretPos = startPos;
	            }
	
	            value = value.substr(0, startPos) + value.substr(startPos + substrLen);
	
	            clearedValue = this.clearRange(value, startPos, maskLen - startPos);
	            clearedValue = this.insertRawSubstr(clearedValue, enteredSubstr, caretPos);
	
	            value = this.insertRawSubstr(oldValue, enteredSubstr, caretPos);
	
	            if (substrLen !== 1 || caretPos >= prefixLen && caretPos < maskLen) {
	                caretPos = this.getFilledLength(clearedValue);
	            } else if (caretPos < maskLen) {
	                caretPos++;
	            }
	        } else if (valueLen < oldValueLen) {
	            var removedLen = maskLen - valueLen;
	            clearedValue = this.clearRange(oldValue, selection.end, removedLen);
	            var substr = value.substr(0, selection.end);
	            var clearOnly = substr === oldValue.substr(0, selection.end);
	
	            if (maskChar) {
	                value = this.insertRawSubstr(clearedValue, substr, 0);
	            }
	
	            clearedValue = this.clearRange(clearedValue, selection.end, maskLen - selection.end);
	            clearedValue = this.insertRawSubstr(clearedValue, substr, 0);
	
	            if (!clearOnly) {
	                caretPos = this.getFilledLength(clearedValue);
	            } else if (caretPos < prefixLen) {
	                caretPos = prefixLen;
	            }
	        }
	        value = this.formatValue(value);
	
	        // prevent android autocomplete insertion on backspace
	        // prevent hanging after first entered character on Windows 10 Mobile
	        if (!this.isAndroidBrowser && !this.isWindowsPhoneBrowser) {
	            target.value = value;
	
	            if (value && !this.getInputValue()) {
	                if (this.isAndroidFirefox) {
	                    this.value = value;
	                    this.enableValueAccessors();
	                }
	                this.preventEmptyChange = true;
	                setTimeout(function () {
	                    _this6.preventEmptyChange = false;
	                    _this6.disableValueAccessors();
	                }, 0);
	            }
	        }
	
	        this.setState({
	            value: this.hasValue ? this.state.value : value
	        });
	
	        if (typeof this.props.onChange === "function") {
	            this.props.onChange(event);
	        }
	        this.setCaretPos(caretPos);
	    },
	    onFocus: function onFocus(event) {
	        if (!this.state.value) {
	            var prefix = this.getPrefix();
	            var value = this.formatValue(prefix);
	            event.target.value = this.formatValue(value);
	
	            this.setState({
	                value: this.hasValue ? this.state.value : value
	            }, this.setCaretToEnd);
	
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        } else if (this.getFilledLength() < this.mask.length) {
	            this.setCaretToEnd();
	        }
	
	        if (typeof this.props.onFocus === "function") {
	            this.props.onFocus(event);
	        }
	    },
	    onBlur: function onBlur(event) {
	        if (!this.props.alwaysShowMask && this.isEmpty(this.state.value)) {
	            event.target.value = "";
	            this.setState({
	                value: this.hasValue ? this.state.value : ""
	            });
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        }
	
	        if (typeof this.props.onBlur === "function") {
	            this.props.onBlur(event);
	        }
	    },
	    onPaste: function onPaste(event) {
	        if (this.isAndroidBrowser) {
	            this.pasteSelection = this.getSelection();
	            event.target.value = "";
	            return;
	        }
	        var text;
	        if (window.clipboardData && window.clipboardData.getData) {
	            // IE
	            text = window.clipboardData.getData("Text");
	        } else if (event.clipboardData && event.clipboardData.getData) {
	            text = event.clipboardData.getData("text/plain");
	        }
	        if (text) {
	            var value = this.state.value;
	            var selection = this.getSelection();
	            this.pasteText(value, text, selection, event);
	        }
	        event.preventDefault();
	    },
	    pasteText: function pasteText(value, text, selection, event) {
	        var caretPos = selection.start;
	        if (selection.length) {
	            value = this.clearRange(value, caretPos, selection.length);
	        }
	        var textLen = this.getRawSubstrLength(value, text, caretPos);
	        value = this.insertRawSubstr(value, text, caretPos);
	        caretPos += textLen;
	        caretPos = this.getRightEditablePos(caretPos) || caretPos;
	        if (value !== this.getInputDOMNode().value) {
	            if (event) {
	                event.target.value = value;
	            }
	            this.setState({
	                value: this.hasValue ? this.state.value : value
	            });
	            if (event && typeof this.props.onChange === "function") {
	                this.props.onChange(event);
	            }
	        }
	        this.setCaretPos(caretPos);
	    },
	    componentDidMount: function componentDidMount() {
	        this.isAndroidBrowser = this.isAndroidBrowser();
	        this.isWindowsPhoneBrowser = this.isWindowsPhoneBrowser();
	        this.isAndroidFirefox = this.isAndroidFirefox();
	    },
	    render: function render() {
	        var _this7 = this;
	
	        var ourProps = {};
	        if (this.mask) {
	            var handlersKeys = ["onFocus", "onBlur", "onChange", "onKeyDown", "onKeyPress", "onPaste"];
	            handlersKeys.forEach(function (key) {
	                ourProps[key] = _this7[key];
	            });
	            ourProps.value = this.state.value;
	        }
	        return _react2.default.createElement("input", Object.assign({ ref: "input" }, _lodash2.default.omit(this.props, 'defaultValue'), ourProps));
	    }
	});
	
	module.exports = InputElement;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utility library
	
	
	// class names utility
	
	
	// import component from material UI
	
	
	// component
	
	
	// validation
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isServer = __webpack_require__(207);
	
	var _isServer2 = _interopRequireDefault(_isServer);
	
	var _Toggle = __webpack_require__(276);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _modelValidator = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addButtonStyle = {
	  display: 'inline-block',
	  width: '165px'
	};
	
	var CustomTextInputList = (_temp = _class = function (_Component) {
	  _inherits(CustomTextInputList, _Component);
	
	  function CustomTextInputList(props, context) {
	    _classCallCheck(this, CustomTextInputList);
	
	    // needed internally by material-ui
	    var _this = _possibleConstructorReturn(this, (CustomTextInputList.__proto__ || Object.getPrototypeOf(CustomTextInputList)).call(this, props, context));
	
	    _this.onChange = function (newVal) {
	      // pass to functions
	      if (_this.props.onChange) _this.props.onChange(null, newVal);
	      if (_this.props.onKeyUp) _this.props.onKeyUp(null, newVal);
	
	      // handle validation here if uncontrolled component
	      if (!_this.props.hasOwnProperty('value')) _this.validate(newVal);
	    };
	
	    _this.onFocus = function (value) {
	      _this.setState(_extends({}, _this.state, {
	        focused: true
	      }));
	      if (_this.props.onFocus) {
	        _this.props.onFocus(null, value);
	      }
	    };
	
	    _this.onBlur = function (newValue) {
	      var updateStateObj = { focused: false };
	      if (!_this.state.dirty) updateStateObj.dirty = true; // set dirty if not already dirty
	      _this.setState(_extends({}, _this.state, updateStateObj));
	      if (_this.props.onBlur) {
	        _this.props.onBlur(null, newValue);
	      }
	    };
	
	    _this.toggleExample = function () {
	      return _this.setState({
	        showExample: !_this.state.showExample
	      });
	    };
	
	    _this.clear = function () {
	      return _this.onKeyUp(null, null);
	    };
	
	    _this.updateValue = function (event, index, array) {
	      var allowToChange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      if (array[index] !== event.target.value) {
	        var newVal = array.slice();
	
	        // Not allow to type more characters if max reached.
	        if (_this.props.maxCharLength) {
	          if (event.target.value.length >= _this.props.maxCharLength) {
	            event.preventDefault();
	            event.target.value = event.target.value.substring(0, _this.props.maxCharLength);
	          }
	        }
	
	        // capitalized sentences.
	        if (_this.props.capitalizedSentences && allowToChange) {
	          var text = event.target.value;
	          text = text.charAt(0).toUpperCase() + text.substr(1);
	          text = text.replace(/[\.\?\!]\s+.+?/g, function (str) {
	            return str.substr(0, str.length - 1) + str.charAt(str.length - 1).toUpperCase();
	          });
	          event.target.value = text;
	        }
	
	        newVal[index] = event.target.value;
	        _this.setState({
	          values: newVal
	        });
	        return newVal;
	      }
	
	      // if nothing has changed just return the old value
	      return array;
	    };
	
	    if (!_isServer2.default) {
	      _this.validate = _lodash2.default.debounce(_this.validate.bind(_this), 16); // debounce to eye frame rate
	    } else {
	      _this.validate = _this.validate.bind(_this);
	    }
	
	    // setting initial state
	    _this.state = {
	      focused: false,
	      dirty: false,
	      passwordShow: false,
	      errors: [],
	      showExample: false,
	      showScript: false,
	      values: []
	    };
	
	    // check for initial value
	    var initVal = props.hasOwnProperty('value') ? props.value : props.hasOwnProperty('defaultValue') ? props.defaultValue : null;
	
	    // run validation
	    var hasValidation = _this.validate(initVal);
	
	    // if no validaton provided, still mark as dirty if intial value provided
	    if (!hasValidation && initVal) {
	      // even without validation, should still set state to dirty if initial value is populated
	      _lodash2.default.assign(_this.state, { dirty: true });
	    }
	    return _this;
	  }
	
	  _createClass(CustomTextInputList, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        this.validate(nextProps.value);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.errors.length && this.props.onErrorChange) {
	        this.props.onErrorChange(-this.state.errors.length);
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(value, additionalStateUpdate) {
	      if (this.props.validation) {
	        // default value to empty array
	        var _value = [].concat(this.props.value || []);
	
	        var updateStateObj = {
	          errors: (0, _modelValidator.validateField)(_value, this.props.validation)
	        };
	
	        // Validation to check mininium items required.
	        if (this.props.requiredLength > 0) {
	          if (_lodash2.default.filter(_value, function (v) {
	            return typeof v === 'string' && v.length > 0;
	          }).length < this.props.requiredLength) {
	            updateStateObj.errors.push('At least ' + this.props.requiredLength + ' are required.');
	          }
	        }
	
	        if (additionalStateUpdate) {
	          updateStateObj = _extends({}, additionalStateUpdate, updateStateObj);
	        }
	
	        // emit error change to parent
	        var errorCountChange = updateStateObj.errors.length === this.state.errors.length ? null : updateStateObj.errors.length - this.state.errors.length;
	
	        if (this.props.onErrorChange && errorCountChange) {
	          this.props.onErrorChange(errorCountChange);
	        }
	
	        // update local error state
	        this.setState(_extends({}, this.state, updateStateObj));
	        return true;
	      }
	    }
	
	    // allows clearing from parent if needed for some hacky reason
	
	  }, {
	    key: 'addValue',
	    value: function addValue(array) {
	      var _this2 = this;
	
	      return function (event) {
	        if (array.length < _this2.props.maxLength) {
	          array.push('');
	          _this2.onChange(array);
	          _this2.onBlur(array);
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // take out properties that will be overwritten from 'this.props'
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          rootStyle = _props.rootStyle,
	          errorStyle = _props.errorStyle,
	          minLength = _props.minLength,
	          maxLength = _props.maxLength,
	          maxCharLength = _props.maxCharLength,
	          errorText = _props.errorText,
	          descriptionBottom = _props.descriptionBottom,
	          onKeyUp = _props.onKeyUp,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          validation = _props.validation,
	          exampleTextArr = _props.exampleTextArr,
	          dataId = _props['data-id'],
	          unmodifiedProps = _objectWithoutProperties(_props, ['className', 'style', 'rootStyle', 'errorStyle', 'minLength', 'maxLength', 'maxCharLength', 'errorText', 'descriptionBottom', 'onKeyUp', 'onFocus', 'onBlur', 'validation', 'exampleTextArr', 'data-id']);
	
	      var additionalProps = {};
	
	      // get booleans
	      var errorStr = void 0;
	      var errorMessage = void 0;
	      var isError = (this.state.dirty || this.props.isDirty) && (typeof this.props.errorText !== 'undefined' || this.state.errors.length); // check passed in error string and local state errors array, only show if value is dirty
	
	      // handle error state visually
	      if (isError) {
	        // set error string
	        errorStr = (errorText && [errorText] || []).concat(this.state.errors).join(', '); // combine passed in error string and local state errors array
	        errorMessage = _react2.default.createElement(
	          'div',
	          { className: 'error-message' },
	          errorStr
	        );
	      }
	
	      // handle optional state visually
	      if (this.props.optional) {
	        if (!isError) {
	          additionalProps.errorText = '(optional)';
	          additionalProps.errorStyle = _lodash2.default.merge({}, errorStyle, {
	            color: '#c9c9c9'
	          });
	        } else {
	          additionalProps.errorText = '(optional) ' + errorStr;
	        }
	      } else if (isError) {
	        additionalProps.errorText = errorStr;
	      }
	
	      // default value to empty array
	      var value = [].concat(this.props.value || []);
	
	      // add an array of empty string to fill to 'minLength'
	      var finalValue = value.concat(new Array(Math.max(minLength - value.length, 0)).fill(''));
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-list ' + className,
	          style: rootStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'description' },
	          this.props.descriptionHead && _react2.default.createElement(
	            'b',
	            null,
	            this.props.descriptionHead,
	            this.props.description && ': '
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.description
	          )
	        ),
	        _lodash2.default.isEmpty(exampleTextArr) ? _react2.default.createElement('div', { className: 'example-toggle-container' }) : _react2.default.createElement(
	          'div',
	          { className: 'example-toggle-container' },
	          'Example',
	          _react2.default.createElement(_Toggle2.default, {
	            'data-id': 'Script',
	            className: 'example-toggle-icon',
	            disableTouchRipple: true,
	            disableFocusRipple: true,
	            labelPosition: 'left',
	            toggled: this.state.showExample,
	            onToggle: this.toggleExample,
	            style: { transition: 'none' },
	            elementStyle: { transition: 'none' },
	            trackStyle: { height: '8px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1)' },
	            thumbStyle: { top: '-2px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1), left .2s cubic-bezier(0.23, 1, 0.32, 1), margin .2s cubic-bezier(0.23, 1, 0.32, 1)' }
	          })
	        ),
	        this.state.showExample && _react2.default.createElement(
	          'ul',
	          { className: 'example-text-container' },
	          exampleTextArr.map(function (exampleVal) {
	            return _react2.default.createElement(
	              'li',
	              { className: 'example-text' },
	              exampleVal
	            );
	          })
	        ),
	        errorMessage,
	        finalValue.map(function (arrVal, index, arr) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'input-list' },
	            _react2.default.createElement('textarea', {
	              'data-id': _this3.props.descriptionHead + ' ' + index,
	              key: index,
	              className: (0, _classnames2.default)('input-list-item', {
	                focused: _this3.state.focused,
	                error: isError,
	                optional: _this3.props.optional && !isError
	              }),
	              style: style,
	              defaultValue: arrVal,
	              onChange: function onChange(event) {
	                return _this3.onChange(_this3.updateValue(event, index, arr));
	              },
	              onBlur: function onBlur(event) {
	                return _this3.onBlur(_this3.updateValue(event, index, arr, true));
	              },
	              onFocus: function onFocus(event) {
	                return _this3.onFocus(_this3.updateValue(event, index, arr));
	              }
	            }),
	            maxCharLength && _react2.default.createElement(
	              'div',
	              {
	                className: 'character-count'
	              },
	              (_this3.state.values[index] || '').length + '/' + maxCharLength
	            )
	          );
	        }),
	        (!maxLength || value.length < maxLength) && _react2.default.createElement(
	          'div',
	          { className: 'add-button-container' },
	          _react2.default.createElement(_c_FlatButton2.default, {
	            style: addButtonStyle,
	            label: 'Add Line',
	            onClick: this.addValue(finalValue)
	          })
	        ),
	        descriptionBottom && _react2.default.createElement(
	          'div',
	          { className: 'bottom-description' },
	          descriptionBottom
	        )
	      );
	    }
	  }]);
	
	  return CustomTextInputList;
	}(_react.Component), _class.propTypes = {
	  // labelling
	  id: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  'data-id': _react.PropTypes.string,
	
	  // options
	  optional: _react.PropTypes.bool,
	  showCharacterCount: _react.PropTypes.bool,
	  minLength: _react.PropTypes.number,
	  maxLength: _react.PropTypes.number,
	  maxCharLength: _react.PropTypes.number,
	  capitalizedSentences: _react.PropTypes.bool,
	  requiredLength: _react.PropTypes.number,
	  exampleTextArr: _react.PropTypes.array,
	  descriptionHead: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  descriptionBottom: _react.PropTypes.string,
	
	  // inline styling if they go that way :(
	  style: _react.PropTypes.object,
	  rootStyle: _react.PropTypes.object,
	  errorStyle: _react.PropTypes.object,
	
	  // determining value
	  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.array]),
	  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.array]),
	
	  // validation
	  validation: _react.PropTypes.object,
	  onErrorChange: _react.PropTypes.func,
	  errorText: _react.PropTypes.string,
	
	  // change handling
	  onChange: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func
	}, _class.defaultProps = {
	  minLength: 3,
	  requiredLength: 0
	}, _temp);
	exports.default = CustomTextInputList;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PasswordValidator;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	function PasswordValidator(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('password-validator', { valid: props.valid }) + ' ' + props.className },
	    props.label
	  );
	}
	
	// class names utility
	
	
	PasswordValidator.propTypes = {
	  className: _react.PropTypes.string,
	  label: _react.PropTypes.string,
	  valid: _react.PropTypes.bool
	};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	var cardModal = function (_Component) {
	  _inherits(cardModal, _Component);
	
	  function cardModal() {
	    _classCallCheck(this, cardModal);
	
	    return _possibleConstructorReturn(this, (cardModal.__proto__ || Object.getPrototypeOf(cardModal)).apply(this, arguments));
	  }
	
	  _createClass(cardModal, [{
	    key: 'onChange',
	    value: function onChange(event, value) {
	      //this.props.statusDropdown.value = value;
	      this.props.onChange(value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var childrenWithProps = _react2.default.Children.map(this.props.children, function (child) {
	        return _react2.default.cloneElement(child, {});
	      });
	      return _react2.default.createElement(
	        _r_Modal2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'card-modal transition-block-form' },
	          childrenWithProps
	        )
	      );
	    }
	  }]);
	
	  return cardModal;
	}(_react.Component);
	
	exports.default = cardModal;

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//TODO: DELETE ME
	exports.default = [4, 5, 6, 7, 8];

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//TODO: DELETE ME
	exports.default = [20, 25, 30, 35, 40];

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['1-9 years', '10-14 years', '15-19 years', '20-24 years', '25+ years'];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ActiveRatingStarIcon(props) {
	    return _react2.default.createElement(
	        'svg',
	        _extends({ width: '17px', height: '16px', viewBox: '0 0 17 16', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' }, props),
	        _react2.default.createElement(
	            'defs',
	            null,
	            _react2.default.createElement('path', { d: 'M12.8599093,15.8942857 L8.36,12.6217143 L3.86009067,15.8948571 C3.66390933,16.0377143 3.399176,16.0348571 3.20633867,15.888 C3.01238667,15.7405714 2.93324533,15.4828571 3.00904267,15.2485714 L4.72061333,9.97485714 L0.234637333,6.712 C0.0373413333,6.568 -0.0473733333,6.30971429 0.0261946667,6.07257143 C0.10032,5.83542857 0.314336,5.67485714 0.557333333,5.67485714 L6.11673333,5.67485714 L7.83109067,0.391428571 C7.90744533,0.157142857 8.11978933,0 8.36,0 C8.60021067,0 8.813112,0.157142857 8.88890933,0.391428571 L10.6032667,5.67485714 L16.1626667,5.67485714 C16.405664,5.67485714 16.61968,5.83542857 16.6938053,6.07257143 C16.7673733,6.30971429 16.6826587,6.568 16.4853627,6.712 C16.4853627,6.712 14.1436356,8.41524601 12.9727721,9.26686902 C12.6483103,9.50286506 11.9993867,9.97485714 11.9993867,9.97485714 L13.7109573,15.2485714 C13.7867547,15.4828571 13.707056,15.7405714 13.5136613,15.888 C13.4155707,15.9628571 13.2985307,16 13.182048,16 C13.0694667,16 12.956328,15.9645714 12.8599093,15.8942857 Z', id: 'path-1' }),
	            _react2.default.createElement(
	                'filter',
	                { x: '-50%', y: '-50%', width: '200%', height: '200%', filterUnits: 'objectBoundingBox', id: 'filter-2' },
	                _react2.default.createElement('feGaussianBlur', { stdDeviation: '0.75', 'in': 'SourceAlpha', result: 'shadowBlurInner1' }),
	                _react2.default.createElement('feOffset', { dx: '0', dy: '0', 'in': 'shadowBlurInner1', result: 'shadowOffsetInner1' }),
	                _react2.default.createElement('feComposite', { 'in': 'shadowOffsetInner1', in2: 'SourceAlpha', operator: 'arithmetic', k2: '-1', k3: '1', result: 'shadowInnerInner1' }),
	                _react2.default.createElement('feColorMatrix', { values: '0 0 0 0 0.961710989   0 0 0 0 0.65036732   0 0 0 0 0.138542295  0 0 0 1 0', type: 'matrix', 'in': 'shadowInnerInner1' })
	            )
	        ),
	        _react2.default.createElement(
	            'g',
	            { id: '97---Applicant-Interview--Ratings-by-QS', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	            _react2.default.createElement(
	                'g',
	                { id: '97---Applicant-Interview--Ratings-by-QS-3', transform: 'translate(-617.000000, -442.000000)' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'icon_song-favorites-copy-4', transform: 'translate(617.000000, 442.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Icons' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Shape' },
	                            _react2.default.createElement('use', { fill: '#FFE40A', fillRule: 'evenodd', xlinkHref: '#path-1' })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = ActiveRatingStarIcon;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function AddContact(props) {
	    var className = props.className,
	        _props$width = props.width,
	        width = _props$width === undefined ? 32 : _props$width,
	        _props$height = props.height,
	        height = _props$height === undefined ? 30 : _props$height,
	        _props$viewBox = props.viewBox,
	        viewBox = _props$viewBox === undefined ? '7 7 23 22' : _props$viewBox,
	        _props$border = props.border,
	        border = _props$border === undefined ? false : _props$border,
	        _props$fillColor = props.fillColor,
	        fillColor = _props$fillColor === undefined ? '#4a4a4a' : _props$fillColor,
	        otherProps = _objectWithoutProperties(props, ['className', 'width', 'height', 'viewBox', 'border', 'fillColor']);
	
	    return _react2.default.createElement(
	        'svg',
	        _extends({ width: width + 'px', height: height + 'px', viewBox: '' + viewBox, version: '1.1', xmlns: 'http://www.w3.org/2000/svg', className: 'add-contact-icon ' + className }, otherProps),
	        _react2.default.createElement(
	            'g',
	            { id: '----3335---Adding-A-Contact-Through-Worksheet', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	            _react2.default.createElement(
	                'g',
	                { id: '3335---SO---Company-Workshet---Add-A-Contact-1', transform: 'translate(-1186.000000, -166.000000)' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Group-9', transform: 'translate(1186.000000, 166.000000)' },
	                    border && _react2.default.createElement(
	                        'g',
	                        { id: 'Group-54-Copy', fill: '' + fillColor },
	                        _react2.default.createElement('path', { d: 'M15.55,30 C6.97573,30 0,23.271 0,15 C0,6.729 6.97573,0 15.55,0 C24.12427,0 31.1,6.729 31.1,15 C31.1,23.271 24.12427,30 15.55,30 L15.55,30 Z M15.55,2 C8.11917333,2 2.07333333,7.832 2.07333333,15 C2.07333333,22.168 8.11917333,28 15.55,28 C22.9808267,28 29.0266667,22.168 29.0266667,15 C29.0266667,7.832 22.9808267,2 15.55,2 L15.55,2 Z', id: 'Shape' })
	                    ),
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Group-22', transform: 'translate(8.000000, 9.000000)' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Group-53' },
	                            _react2.default.createElement('path', { d: 'M14.5,11 L0.5,11 C0.225,11 0,10.7736798 0,10.4970662 L0,2.50293378 C0,2.2263202 0.225,2 0.5,2 L14.5,2 C14.775,2 15,2.2263202 15,2.50293378 L15,10.4970662 C15,10.7736798 14.775,11 14.5,11 Z', id: 'Shape', stroke: '' + fillColor, strokeWidth: '1.5' }),
	                            _react2.default.createElement('path', { d: 'M15,2 C14.3735,3.46137124 12.5835,5 10.887,5 L4.113,5 C2.433,5 0.6365,3.48394649 0,2.0451505', id: 'Shape', stroke: '' + fillColor, strokeWidth: '1.5' }),
	                            _react2.default.createElement('path', { d: 'M5,2 L5,0.25 C5,0.1815 5.035,0.119 5.091875,0.0735 C5.14875,0.028 5.226875,0 5.3125,0 L7.5,0 L9.6875,0 C9.77375,0 9.851875,0.028 9.908125,0.0735 C9.965,0.1185 10,0.181 10,0.25 L10,2', id: 'Shape', stroke: '' + fillColor, strokeWidth: '1.5' }),
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Group-37', transform: 'translate(9.000000, 6.000000)' },
	                                _react2.default.createElement('ellipse', { id: 'Oval-Copy-5', fill: '#FAFAFA', cx: '5', cy: '5', rx: '5', ry: '5' }),
	                                _react2.default.createElement('path', { d: 'M2.14285714,5 L7.85714286,5', id: 'Shape', stroke: '' + fillColor, strokeWidth: '2' }),
	                                _react2.default.createElement('path', { d: 'M5,2.14285714 L5,7.85714286', id: 'Shape', stroke: '' + fillColor, strokeWidth: '2' })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	AddContact.propTypes = {
	    className: _react.PropTypes.string
	};
	
	exports.default = AddContact;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssessmentBank(props) {
	  var _props$style = props.style;
	  _props$style = _props$style === undefined ? {} : _props$style;
	  var color = _props$style.color,
	      backgroundColor = _props$style.backgroundColor;
	
	
	  return _react2.default.createElement(
	    "svg",
	    { width: "67px", height: "67px", viewBox: "0 0 67 67", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "title",
	      null,
	      "30DCED96-9D1E-4C4E-B0D9-F7F13D3A664C"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with sketchtool."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "501---Assesments", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-1041.000000, -453.000000)", id: "Group-7", fill: "#333333" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(971.000000, 405.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "icon_bank", transform: "translate(70.000000, 48.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Icons" },
	              _react2.default.createElement(
	                "g",
	                { id: "Group" },
	                _react2.default.createElement("path", { d: "M63.842625,67 L3.157375,67 C1.41746875,67 0,65.5825313 0,63.842625 L0,57.5969688 C0,55.8549687 1.41746875,54.4375 3.157375,54.4375 L63.8405313,54.4375 C65.5825313,54.4375 67,55.8549687 67,57.594875 L67,63.8405312 C67,65.5825313 65.5825313,67 63.842625,67 L63.842625,67 Z M4.1875,62.8125 L62.8125,62.8125 L62.8125,58.625 L4.1875,58.625 L4.1875,62.8125 L4.1875,62.8125 Z", id: "Shape" }),
	                _react2.default.createElement("path", { d: "M63.859375,20.9375 L3.140625,20.9375 C1.40909375,20.9375 0,19.5660938 0,17.8827188 L0,12.1919063 C0,10.845625 0.88775,9.673125 2.2068125,9.2753125 L33.1712813,0 L34.4338125,0.0879375 L64.7910938,9.21459375 C66.11225,9.61659375 67,10.7890938 67,12.135375 L67,17.8827188 C67,19.5660938 65.5909063,20.9375 63.859375,20.9375 L63.859375,20.9375 Z M4.1875,16.75 L62.8125,16.75 L62.8125,12.9959062 L33.4811563,4.1875 L4.1875,13.0503437 L4.1875,16.75 L4.1875,16.75 Z", id: "Shape" }),
	                _react2.default.createElement("path", { d: "M16.33125,52.34375 L8.79375,52.34375 C7.40978125,52.34375 6.28125,51.2152187 6.28125,49.83125 L6.28125,25.54375 C6.28125,24.1597812 7.40978125,23.03125 8.79375,23.03125 L16.33125,23.03125 C17.7152187,23.03125 18.84375,24.1597812 18.84375,25.54375 L18.84375,49.83125 C18.84375,51.2152187 17.7152187,52.34375 16.33125,52.34375 L16.33125,52.34375 Z M10.46875,48.15625 L14.65625,48.15625 L14.65625,27.21875 L10.46875,27.21875 L10.46875,48.15625 L10.46875,48.15625 Z", id: "Shape" }),
	                _react2.default.createElement("path", { d: "M37.26875,52.34375 L29.73125,52.34375 C28.3451875,52.34375 27.21875,51.2152187 27.21875,49.83125 L27.21875,25.54375 C27.21875,24.1576875 28.3472813,23.03125 29.73125,23.03125 L37.26875,23.03125 C38.6548125,23.03125 39.78125,24.1597812 39.78125,25.54375 L39.78125,49.83125 C39.78125,51.2152187 38.6527188,52.34375 37.26875,52.34375 L37.26875,52.34375 Z M31.40625,48.15625 L35.59375,48.15625 L35.59375,27.21875 L31.40625,27.21875 L31.40625,48.15625 L31.40625,48.15625 Z", id: "Shape" }),
	                _react2.default.createElement("path", { d: "M58.20625,52.34375 L50.66875,52.34375 C49.2826875,52.34375 48.15625,51.2152187 48.15625,49.83125 L48.15625,25.54375 C48.15625,24.1576875 49.2847813,23.03125 50.66875,23.03125 L58.20625,23.03125 C59.5923125,23.03125 60.71875,24.1597812 60.71875,25.54375 L60.71875,49.83125 C60.71875,51.2152187 59.5902187,52.34375 58.20625,52.34375 L58.20625,52.34375 Z M52.34375,48.15625 L56.53125,48.15625 L56.53125,27.21875 L52.34375,27.21875 L52.34375,48.15625 L52.34375,48.15625 Z", id: "Shape" })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	AssessmentBank.propTypes = {
	  style: _react.PropTypes.object
	};
	
	exports.default = AssessmentBank;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssessmentBenefits(props) {
	  var _props$style = props.style;
	  _props$style = _props$style === undefined ? {} : _props$style;
	  var color = _props$style.color,
	      backgroundColor = _props$style.backgroundColor;
	
	
	  return _react2.default.createElement(
	    "svg",
	    { width: "89px", height: "69px", viewBox: "0 0 89 69", version: "1.1" },
	    _react2.default.createElement(
	      "title",
	      null,
	      "9948A670-D278-4B0A-99FA-229BF88B8883"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with sketchtool."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "501---Assesments", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-334.000000, -670.000000)", id: "Group-22", fill: "#333333" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(278.000000, 622.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-4", transform: "translate(56.000000, 48.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "icon_nurse-copy" },
	              _react2.default.createElement(
	                "g",
	                { id: "Icons" },
	                _react2.default.createElement(
	                  "g",
	                  { id: "Group" },
	                  _react2.default.createElement(
	                    "svg",
	                    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512" },
	                    _react2.default.createElement("path", { d: "M275.2 250.5c6.998 7.377 18.5 7.377 25.5 0l108.1-114.2c31.49-33.13 29.72-88.22-5.65-118.7c-35.37-30.63-81.38-16.91-104.9 7.724L287.1 36.91L276.8 25.28C253.9 1.149 207.6-13.45 171.1 17.56C136.7 48.06 134.7 103.1 166.4 136.3L275.2 250.5zM192.3 41.79C213.2 23.79 240.6 33.17 254.2 47.54l33.74 35.26l33.74-35.26c13.5-14.13 40.99-23.76 61.86-5.752c23.74 20.63 20.12 54.51 3.373 72.14L287.9 217.7L188.1 113.9C172.2 96.56 168.7 62.42 192.3 41.79zM558.2 333.6c-9.5-8.619-22-13.37-35.12-13.37c-12.5 0-24.88 4.248-34.62 12.12l-61.45 49.21c-1.928 1.545-4.324 2.385-6.795 2.385h-41.62c4.625-9.619 6.5-20.74 4.75-32.23C379.4 323.7 353.7 304 325.6 304H181.2c-20.75 0-40.1 6.746-57.5 19.24l-38.5 28.73H16c-8.801 0-16 7.195-16 15.99s7.198 16.04 15.1 16.04l80.01 .0091l46.86-35.29c11.12-8.244 24.62-12.74 38.37-12.74h146.7c13.25 0 24 10.74 24 23.99s-10.75 23.98-24 23.98H239.1c-8.75 0-16 7.246-16 15.99c0 8.746 7.25 15.99 16 15.99h180.2c9.625 0 19-3.248 26.62-9.246l61.62-49.22c4.25-3.373 9.5-5.248 14.62-5.248c5 0 9.875 1.75 13.75 5.248c10.12 9.119 9.375 24.48-.875 32.61l-100.7 80.58c-7.584 6.064-17.01 9.369-26.72 9.369H16c-8.801 0-15.1 7.189-15.1 15.98S7.198 512 15.1 512h392.5c17 0 33.38-5.871 46.62-16.37l100.9-80.7c12.25-9.744 19.5-24.36 19.1-39.98C576.5 359.3 569.1 344.2 558.2 333.6z" })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	AssessmentBenefits.propTypes = {
	  style: _react.PropTypes.object
	};
	
	exports.default = AssessmentBenefits;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssessmentComercial(props) {
	  var _props$style = props.style;
	  _props$style = _props$style === undefined ? {} : _props$style;
	  var color = _props$style.color,
	      backgroundColor = _props$style.backgroundColor;
	
	
	  return _react2.default.createElement(
	    "svg",
	    { width: "89px", height: "69px", viewBox: "0 0 89 69", version: "1.1" },
	    _react2.default.createElement(
	      "title",
	      null,
	      "9948A670-D278-4B0A-99FA-229BF88B8883"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with sketchtool."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "501---Assesments", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-334.000000, -670.000000)", id: "Group-22", fill: "#333333" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(278.000000, 622.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-4", transform: "translate(56.000000, 48.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "icon_bank-copy" },
	              _react2.default.createElement(
	                "g",
	                { id: "Icons" },
	                _react2.default.createElement(
	                  "g",
	                  { id: "Group" },
	                  _react2.default.createElement("path", { d: "M48.4605,53.0769231 L2.39664286,53.0769231 C1.07594643,53.0769231 0,51.9540144 0,50.5756731 L0,45.6279087 C0,44.2479087 1.07594643,43.125 2.39664286,43.125 L48.4589107,43.125 C49.7811964,43.125 50.8571429,44.2479087 50.8571429,45.62625 L50.8571429,50.5740144 C50.8571429,51.9540144 49.7811964,53.0769231 48.4605,53.0769231 L48.4605,53.0769231 Z M3.17857143,49.7596154 L47.6785714,49.7596154 L47.6785714,46.4423077 L3.17857143,46.4423077 L3.17857143,49.7596154 L3.17857143,49.7596154 Z", id: "Shape" }),
	                  _react2.default.createElement("path", { d: "M50.4929315,16.5865385 L2.48325893,16.5865385 C1.11415551,16.5865385 0,15.5001202 0,14.1665625 L0,9.65834135 C0,8.59182692 0.701934524,7.66298077 1.74490327,7.34783654 L26.2281808,0 L27.2264509,0.0696634615 L51.2296317,7.29973558 C52.274256,7.61819712 52.9761905,8.54704327 52.9761905,9.61355769 L52.9761905,14.1665625 C52.9761905,15.5001202 51.862035,16.5865385 50.4929315,16.5865385 L50.4929315,16.5865385 Z M3.3110119,13.2692308 L49.6651786,13.2692308 L49.6651786,10.2952644 L26.4731957,3.31730769 L3.3110119,10.3383894 L3.3110119,13.2692308 L3.3110119,13.2692308 Z", id: "Shape" }),
	                  _react2.default.createElement("path", { d: "M12.9129464,41.4663462 L6.953125,41.4663462 C5.85883557,41.4663462 4.96651786,40.5723317 4.96651786,39.4759615 L4.96651786,20.2355769 C4.96651786,19.1392067 5.85883557,18.2451923 6.953125,18.2451923 L12.9129464,18.2451923 C14.0072359,18.2451923 14.8995536,19.1392067 14.8995536,20.2355769 L14.8995536,39.4759615 C14.8995536,40.5723317 14.0072359,41.4663462 12.9129464,41.4663462 L12.9129464,41.4663462 Z M8.27752976,38.1490385 L11.5885417,38.1490385 L11.5885417,21.5625 L8.27752976,21.5625 L8.27752976,38.1490385 L8.27752976,38.1490385 Z", id: "Shape" }),
	                  _react2.default.createElement("path", { d: "M29.468006,41.4663462 L23.5081845,41.4663462 C22.4122396,41.4663462 21.5215774,40.5723317 21.5215774,39.4759615 L21.5215774,20.2355769 C21.5215774,19.1375481 22.4138951,18.2451923 23.5081845,18.2451923 L29.468006,18.2451923 C30.5639509,18.2451923 31.4546131,19.1392067 31.4546131,20.2355769 L31.4546131,39.4759615 C31.4546131,40.5723317 30.5622954,41.4663462 29.468006,41.4663462 L29.468006,41.4663462 Z M24.8325893,38.1490385 L28.1436012,38.1490385 L28.1436012,21.5625 L24.8325893,21.5625 L24.8325893,38.1490385 L24.8325893,38.1490385 Z", id: "Shape" }),
	                  _react2.default.createElement("path", { d: "M46.0230655,41.4663462 L40.063244,41.4663462 C38.9672991,41.4663462 38.0766369,40.5723317 38.0766369,39.4759615 L38.0766369,20.2355769 C38.0766369,19.1375481 38.9689546,18.2451923 40.063244,18.2451923 L46.0230655,18.2451923 C47.1190104,18.2451923 48.0096726,19.1392067 48.0096726,20.2355769 L48.0096726,39.4759615 C48.0096726,40.5723317 47.1173549,41.4663462 46.0230655,41.4663462 L46.0230655,41.4663462 Z M41.3876488,38.1490385 L44.6986607,38.1490385 L44.6986607,21.5625 L41.3876488,21.5625 L41.3876488,38.1490385 L41.3876488,38.1490385 Z", id: "Shape" })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "g",
	              { id: "icon_nurse-copy", transform: "translate(47.678571, 12.738462)" },
	              _react2.default.createElement(
	                "g",
	                { id: "Icons" },
	                _react2.default.createElement(
	                  "g",
	                  { id: "Group" },
	                  _react2.default.createElement("path", { d: "M20.6607143,30.0061538 C16.4027289,30.0061538 12.3231769,28.1776538 9.46824188,24.9913754 C6.99646916,22.2308092 5.63474026,18.6844569 5.63474026,15.0030769 C5.63474026,6.73075538 12.3757679,0 20.6607143,0 C28.9456607,0 35.6866883,6.73075538 35.6866883,15.0030769 C35.6866883,18.6844569 34.3249594,22.2308092 31.8531867,24.9913754 C28.9982516,28.1776538 24.9186997,30.0061538 20.6607143,30.0061538 L20.6607143,30.0061538 Z M20.6607143,3.75076923 C14.4455958,3.75076923 9.39123377,8.79742923 9.39123377,15.0030769 C9.39123377,17.7598923 10.413,20.4191877 12.2687078,22.4914877 C14.4099091,24.8826031 17.4695731,26.2553846 20.6607143,26.2553846 C23.8518555,26.2553846 26.9115195,24.8826031 29.0527208,22.4914877 C30.9084286,20.4191877 31.9301948,17.7598923 31.9301948,15.0030769 C31.9301948,8.79742923 26.8758328,3.75076923 20.6607143,3.75076923 L20.6607143,3.75076923 Z", id: "Shape" }),
	                  _react2.default.createElement("path", { d: "M39.4431818,56.2615385 L1.87824675,56.2615385 C0.841454545,56.2615385 0,55.4213662 0,54.3861538 L0,41.0034092 C0,33.7681754 3.90111851,26.4335462 9.93968182,22.3208277 C10.7961623,21.7375831 11.9644318,21.9570031 12.5504448,22.8140538 C13.1345795,23.6692292 12.9148247,24.8357185 12.0564659,25.4208385 C7.09225974,28.8002815 3.75649351,35.0640662 3.75649351,41.0034092 L3.75649351,52.5107692 L37.5649351,52.5107692 L37.5649351,41.0034092 C37.5649351,35.0640662 34.2291688,28.8021569 29.2668409,25.4189631 C28.4084821,24.8338431 28.1887273,23.6673538 28.772862,22.8121785 C29.358875,21.9570031 30.5252662,21.7357077 31.383625,22.3189523 C37.4203101,26.4335462 41.3214286,33.7681754 41.3214286,41.0034092 L41.3214286,54.3861538 C41.3214286,55.4213662 40.479974,56.2615385 39.4431818,56.2615385 L39.4431818,56.2615385 Z", id: "Shape" }),
	                  _react2.default.createElement(
	                    "g",
	                    { transform: "translate(18.782468, 31.881538)", id: "Shape" },
	                    _react2.default.createElement("path", { d: "M7.51298701,15.0030769 C6.47619481,15.0030769 5.63474026,14.1629046 5.63474026,13.1276923 L5.63474026,1.87538462 C5.63474026,0.840172308 6.47619481,0 7.51298701,0 C8.54977922,0 9.39123377,0.840172308 9.39123377,1.87538462 L9.39123377,13.1276923 C9.39123377,14.1629046 8.54977922,15.0030769 7.51298701,15.0030769 L7.51298701,15.0030769 Z" }),
	                    _react2.default.createElement("path", { d: "M13.1477273,9.37692308 L1.87824675,9.37692308 C0.841454545,9.37692308 0,8.53675077 0,7.50153846 C0,6.46632615 0.841454545,5.62615385 1.87824675,5.62615385 L13.1477273,5.62615385 C14.1845195,5.62615385 15.025974,6.46632615 15.025974,7.50153846 C15.025974,8.53675077 14.1845195,9.37692308 13.1477273,9.37692308 L13.1477273,9.37692308 Z" })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	AssessmentComercial.propTypes = {
	  style: _react.PropTypes.object
	};
	
	exports.default = AssessmentComercial;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssessmentExe(props) {
	  var _props$style = props.style;
	  _props$style = _props$style === undefined ? {} : _props$style;
	  var color = _props$style.color,
	      backgroundColor = _props$style.backgroundColor;
	
	
	  return _react2.default.createElement(
	    "svg",
	    { width: "52px", height: "69px", viewBox: "0 0 52 69", version: "1.1" },
	    _react2.default.createElement(
	      "title",
	      null,
	      "612623A9-8DB7-4268-8D88-96F13E968BFA"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with sketchtool."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "501---Assesments", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-586.000000, -453.000000)", id: "Group-21", fill: "#333333" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(509.000000, 405.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "icon_exe-file-copy", transform: "translate(77.000000, 48.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Icons" },
	              _react2.default.createElement(
	                "g",
	                { id: "Group" },
	                _react2.default.createElement(
	                  "g",
	                  { id: "Shape" },
	                  _react2.default.createElement("path", { d: "M49.4465549,69 L2.14985021,69 C0.960983046,69 0,68.034 0,66.84375 L0,2.15625 C0,0.966 0.960983046,0 2.14985021,0 L31.8005844,0 C32.3853436,0 32.9443047,0.23934375 33.3506264,0.66196875 L50.9965969,19.0806563 C51.3814201,19.4817188 51.5964052,20.018625 51.5964052,20.5749375 L51.5964052,66.84375 C51.5964052,68.034 50.6354221,69 49.4465549,69 L49.4465549,69 Z M4.29970043,64.6875 L47.2967047,64.6875 L47.2967047,21.44175 L30.8847482,4.3125 L4.29970043,4.3125 L4.29970043,64.6875 L4.29970043,64.6875 Z" }),
	                  _react2.default.createElement("path", { d: "M47.2967047,23.71875 L30.097903,23.71875 C28.9090358,23.71875 27.9480528,22.75275 27.9480528,21.5625 L27.9480528,4.3125 C27.9480528,3.12225 28.9090358,2.15625 30.097903,2.15625 C31.2867702,2.15625 32.2477532,3.12225 32.2477532,4.3125 L32.2477532,19.40625 L47.2967047,19.40625 C48.4855719,19.40625 49.4465549,20.37225 49.4465549,21.5625 C49.4465549,22.75275 48.4855719,23.71875 47.2967047,23.71875 L47.2967047,23.71875 Z" })
	                ),
	                _react2.default.createElement(
	                  "g",
	                  { id: "Shape" },
	                  _react2.default.createElement("path", { d: "M49.4465549,69 L2.14985021,69 C0.960983046,69 0,68.034 0,66.84375 L0,2.15625 C0,0.966 0.960983046,0 2.14985021,0 L31.8005844,0 C32.3853436,0 32.9443047,0.23934375 33.3506264,0.66196875 L50.9965969,19.0806563 C51.3814201,19.4817188 51.5964052,20.018625 51.5964052,20.5749375 L51.5964052,66.84375 C51.5964052,68.034 50.6354221,69 49.4465549,69 L49.4465549,69 Z M4.29970043,64.6875 L47.2967047,64.6875 L47.2967047,21.44175 L30.8847482,4.3125 L4.29970043,4.3125 L4.29970043,64.6875 L4.29970043,64.6875 Z" }),
	                  _react2.default.createElement("path", { d: "M47.2967047,23.71875 L30.097903,23.71875 C28.9090358,23.71875 27.9480528,22.75275 27.9480528,21.5625 L27.9480528,4.3125 C27.9480528,3.12225 28.9090358,2.15625 30.097903,2.15625 C31.2867702,2.15625 32.2477532,3.12225 32.2477532,4.3125 L32.2477532,19.40625 L47.2967047,19.40625 C48.4855719,19.40625 49.4465549,20.37225 49.4465549,21.5625 C49.4465549,22.75275 48.4855719,23.71875 47.2967047,23.71875 L47.2967047,23.71875 Z" })
	                ),
	                _react2.default.createElement(
	                  "g",
	                  { transform: "translate(7.599401, 40.968750)", id: "Shape" },
	                  _react2.default.createElement("path", { d: "M9.33281943,15.09375 L9.32851973,15.09375 L6.06719696,15.085125 L2.07707496,15.09375 L2.07492511,15.09375 C1.77609593,15.09375 1.4923157,14.9686875 1.29022978,14.7509062 C1.08599401,14.5309687 0.980651348,14.2377187 1.00214985,13.9401562 C1.12254146,12.238875 1.22573427,10.0438125 1.32247753,7.35065625 C1.41922079,4.6618125 1.4665175,2.5745625 1.4665175,1.08675 C1.4665175,0.79996875 1.58045956,0.52396875 1.78254548,0.3234375 C1.9846314,0.12290625 2.25766238,0.008625 2.5414426,0.008625 L2.5457423,0.008625 L6.41977239,0.01725 L9.81438588,0.008625 L9.81653573,0.008625 C10.1196646,0.008625 10.4077445,0.138 10.6119803,0.36225 C10.8183659,0.5865 10.917259,0.89053125 10.8850113,1.1945625 C10.8635128,1.40803125 10.8527635,1.595625 10.8527635,1.7595 C10.8527635,2.061375 10.7259224,2.34815625 10.5044878,2.553 C10.2852031,2.75784375 9.98422405,2.8678125 9.68754472,2.8333125 L8.94154669,2.77078125 C8.74376047,2.74921875 8.44708114,2.74275 8.0214108,2.7384375 L6.62400816,2.734125 C5.71892122,2.734125 4.94927484,2.734125 4.31291918,2.73628125 L4.19897712,6.0418125 C4.71279132,6.04828125 5.20295717,6.0504375 5.66517497,6.0504375 C6.59176041,6.0504375 7.73548072,6.0418125 9.09418606,6.02240625 C9.35861763,5.97496875 9.70474352,6.15178125 9.91327899,6.38465625 C10.1218145,6.6196875 10.2164079,6.93234375 10.1755607,7.24284375 C10.1540622,7.39809375 10.1411631,7.5684375 10.1368634,7.75603125 C10.1196646,8.340375 9.64454771,8.80396875 9.0619383,8.80396875 L9.0533389,8.80396875 L5.5426335,8.7759375 C5.26530283,8.7759375 4.78158653,8.78025 4.09578431,8.788875 L3.97754255,12.342375 L5.54048365,12.3466875 C6.57026191,12.3466875 7.28831188,12.342375 7.69033387,12.3315937 C8.09450571,12.3229687 8.63411811,12.29925 9.31992033,12.2625937 C9.68754472,12.2518125 9.94767659,12.3704062 10.1669613,12.6054375 C10.3840962,12.8383125 10.4851391,13.1574375 10.4464418,13.4744062 C10.4206436,13.6770937 10.4055947,13.8560625 10.4055947,14.0134687 C10.4055947,14.30025 10.2916526,14.5740937 10.0895667,14.7767812 C9.88963064,14.981625 9.61659966,15.09375 9.33281943,15.09375 L9.33281943,15.09375 Z" }),
	                  _react2.default.createElement("path", { d: "M22.7973313,15.09375 L22.7521845,15.09375 L22.3308138,15.085125 L21.9008438,15.09375 C21.5289197,15.1304063 21.1397968,14.912625 20.9377109,14.5740938 C20.5292393,13.8970313 20.0799207,13.1854688 19.5940545,12.4437188 C19.2199806,11.8744688 18.639521,11.0098125 17.8462263,9.85190625 L14.1871812,14.64525 C13.9764959,14.9406563 13.6497187,15.136875 13.2691952,15.09375 L12.841375,15.085125 L12.4114049,15.09375 C11.9190892,15.1174688 11.5901622,14.878125 11.4009753,14.4964688 C11.2117885,14.1148125 11.2655348,13.6576875 11.5364159,13.3299375 C12.2050193,12.5213438 13.716364,10.5613125 16.1521443,7.34203125 L12.4092551,1.68403125 C12.1856707,1.34765625 12.1706217,0.91209375 12.3684079,0.560625 C12.5661942,0.207 12.9510173,-0.01940625 13.3487396,0.0129375 L13.7873091,0.0215625 L14.2108296,0.0129375 C14.6322002,-0.025875 14.9632771,0.18759375 15.1675129,0.51534375 L16.242438,2.23171875 L18.0397128,4.8946875 L20.9893073,1.0996875 C21.0839007,0.9703125 21.2214911,0.7633125 21.4106779,0.48084375 C21.6213633,0.1681875 21.9954372,-0.01940625 22.3501625,0.00215625 L23.2530996,0.01078125 C23.6615711,0.01078125 24.0377949,0.2458125 24.2183823,0.61453125 C24.3989697,0.98325 24.3538229,1.423125 24.1001406,1.74871875 L19.716596,7.42396875 C20.1100186,8.0341875 20.5571874,8.71125 21.0559527,9.45515625 L23.6895192,13.4161875 C23.9131036,13.7547188 23.9303024,14.188125 23.7325162,14.54175 C23.5433294,14.8845938 23.1843044,15.09375 22.7973313,15.09375 L22.7973313,15.09375 Z" }),
	                  _react2.default.createElement("path", { d: "M33.8368122,15.09375 L33.8325125,15.09375 L30.5711897,15.085125 L26.5810677,15.09375 L26.5789179,15.09375 C26.2800887,15.09375 25.9963084,14.9686875 25.7942225,14.7509063 C25.5899868,14.5309688 25.4846441,14.2377188 25.5061426,13.938 C25.6286841,12.2367188 25.7318769,10.0416563 25.8264703,7.35065625 C25.9232135,4.6618125 25.9705102,2.5745625 25.9705102,1.08675 C25.9705102,0.79996875 26.0844523,0.52396875 26.2865382,0.3234375 C26.4886241,0.12290625 26.7616551,0.008625 27.0454354,0.008625 L27.0497351,0.008625 L30.925915,0.01725 L34.3183786,0.008625 L34.3226783,0.008625 C34.6258072,0.008625 34.9138871,0.138 35.1181229,0.36225 C35.3245085,0.5865 35.4234016,0.89053125 35.3911539,1.1945625 C35.3696554,1.40803125 35.3589061,1.595625 35.3589061,1.7595 C35.3589061,2.061375 35.232065,2.34815625 35.0106304,2.553 C34.7913457,2.75784375 34.4946663,2.8678125 34.1936873,2.8333125 L33.4498391,2.77078125 C33.2520529,2.74921875 32.9553736,2.74275 32.5275534,2.7384375 L31.1301508,2.734125 C30.2250638,2.734125 29.4554174,2.734125 28.8212116,2.73628125 L28.7051197,6.0418125 C29.2210838,6.04828125 29.7090998,6.0504375 30.1713176,6.0504375 C31.097903,6.0504375 32.2416233,6.0418125 33.6003287,6.02240625 C33.9077572,5.97496875 34.213036,6.15178125 34.4194216,6.38465625 C34.6279571,6.6196875 34.7225505,6.93234375 34.6817033,7.24284375 C34.6602048,7.39809375 34.6473057,7.5684375 34.643006,7.75603125 C34.6258072,8.340375 34.1506903,8.80396875 33.5680809,8.80396875 L33.5594815,8.80396875 L30.0487761,8.7759375 C29.7714454,8.7759375 29.2877291,8.78025 28.6019269,8.788875 L28.485835,12.342375 L30.0466262,12.3466875 C31.0785544,12.3466875 31.7944545,12.342375 32.1964765,12.3315938 C32.6006483,12.3229688 33.1402607,12.29925 33.8260629,12.2625938 C34.1872378,12.2518125 34.4538192,12.3704063 34.6731039,12.6054375 C34.8902388,12.8383125 34.9912817,13.1574375 34.9525844,13.4744063 C34.9267862,13.6770938 34.9117373,13.8560625 34.9117373,14.0134688 C34.9117373,14.30025 34.7977952,14.5740938 34.5957093,14.7767813 C34.3936234,14.981625 34.1205924,15.09375 33.8368122,15.09375 L33.8368122,15.09375 Z" })
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	AssessmentExe.propTypes = {
	  style: _react.PropTypes.object
	};
	
	exports.default = AssessmentExe;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssessmentLaptop(props) {
	  var _props$style = props.style;
	  _props$style = _props$style === undefined ? {} : _props$style;
	  var color = _props$style.color,
	      backgroundColor = _props$style.backgroundColor;
	
	
	  return _react2.default.createElement(
	    "svg",
	    { width: "89px", height: "69px", viewBox: "0 0 89 69", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "title",
	      null,
	      "F4226A58-9FCC-4864-AD48-EB2395DBE4F1"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with sketchtool."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "501---Assesments", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-339.000000, -452.000000)", id: "Group-2", fill: "#333333" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(278.000000, 405.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "icon_laptop-copy", transform: "translate(61.000000, 47.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Icons" },
	              _react2.default.createElement(
	                "g",
	                { id: "Group" },
	                _react2.default.createElement(
	                  "g",
	                  { id: "Shape" },
	                  _react2.default.createElement("path", { d: "M75.5871235,43.9009126 L13.1426336,43.9009126 C9.15056022,43.9009126 5.90030364,40.6549889 5.90030364,36.6682373 L5.90030364,7.23267536 C5.90030364,3.24592373 9.15056022,0 13.1426336,0 L75.589871,0 C79.5791969,0 82.8294534,3.24592373 82.8294534,7.23267536 L82.8294534,36.6682373 C82.8294534,40.6549889 79.5791969,43.9009126 75.5871235,43.9009126 L75.5871235,43.9009126 Z M13.1426336,5.48761408 C12.1782718,5.48761408 11.3952429,6.27234289 11.3952429,7.23267536 L11.3952429,36.6682373 C11.3952429,37.6285698 12.1782718,38.4132986 13.1426336,38.4132986 L75.589871,38.4132986 C76.5514853,38.4132986 77.3345142,37.6285698 77.3345142,36.6682373 L77.3345142,7.23267536 C77.3345142,6.27234289 76.5514853,5.48761408 75.5871235,5.48761408 L13.1426336,5.48761408 L13.1426336,5.48761408 Z" }),
	                  _react2.default.createElement("path", { d: "M82.8129686,68.8613253 L5.91678846,68.8613253 C4.08422621,68.8613253 2.37804757,67.9942823 1.35049393,66.5373207 C0.375142206,65.1516982 0.138859818,63.447794 0.707586032,61.8618735 L8.82361134,40.1967731 L13.969622,42.1201819 L6.0129499,63.3572484 L82.7250496,63.3737112 L74.7848623,42.1174381 L79.930873,40.1995169 L88.0084337,61.8289478 C88.5908973,63.4505378 88.3546149,65.154442 87.3792632,66.5400645 C86.3517095,67.9915385 84.6455309,68.8613253 82.8129686,68.8613253 L82.8129686,68.8613253 Z" }),
	                  _react2.default.createElement("path", { d: "M55.3712419,66.2876343 L53.9535476,55.029794 L34.9520476,54.8761408 L33.3585152,66.2876343 L30.6330253,65.9446584 L32.0507196,54.6868181 C32.1825982,53.2490632 33.4326969,52.1323338 34.9520476,52.1323338 L53.7777095,52.1323338 C55.2970602,52.1323338 56.5471589,53.2490632 56.6872799,54.730719 L58.0994793,65.9446584 L55.3712419,66.2876343 L55.3712419,66.2876343 Z" })
	                ),
	                _react2.default.createElement(
	                  "g",
	                  { transform: "translate(13.971660, 8.231421)", id: "Shape" },
	                  _react2.default.createElement("path", { d: "M1.54478745,10.9752282 C1.19311134,10.9752282 0.841435223,10.8407816 0.572183198,10.5746323 C0.0364266194,10.03959 0.0364266194,9.16980313 0.572183198,8.63476076 L8.81459211,0.403339635 C9.35034868,-0.131702738 10.2212966,-0.131702738 10.7570531,0.403339635 C11.2928097,0.938382008 11.2928097,1.80816884 10.7570531,2.34321121 L2.51464423,10.5746323 C2.24813968,10.8407816 1.89646356,10.9752282 1.54478745,10.9752282 L1.54478745,10.9752282 Z" }),
	                  _react2.default.createElement("path", { d: "M1.54478745,21.9504563 C1.19311134,21.9504563 0.841435223,21.8160098 0.572183198,21.5498605 C0.0364266194,21.0148181 0.0364266194,20.1450313 0.572183198,19.6099889 L19.8044706,0.403339635 C20.3402272,-0.131702738 21.2111751,-0.131702738 21.7469317,0.403339635 C22.2826883,0.938382008 22.2826883,1.80816884 21.7469317,2.34321121 L2.51464423,21.5498605 C2.24813968,21.8160098 1.89646356,21.9504563 1.54478745,21.9504563 L1.54478745,21.9504563 Z" })
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	AssessmentLaptop.propTypes = {
	  style: _react.PropTypes.object
	};
	
	exports.default = AssessmentLaptop;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AssessmentPersonal(props) {
	  var _props$style = props.style;
	  _props$style = _props$style === undefined ? {} : _props$style;
	  var color = _props$style.color,
	      backgroundColor = _props$style.backgroundColor;
	
	
	  return _react2.default.createElement(
	    "svg",
	    { width: "54px", height: "73px", viewBox: "0 0 54 73", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "title",
	      null,
	      "822E9C15-09BD-41CF-8542-99987FF1F85B"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with sketchtool."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "501---Assesments", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(-816.000000, -450.000000)", id: "Group-6", fill: "#333333" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(740.000000, 405.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "icon_nurse", transform: "translate(76.000000, 45.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Icons" },
	              _react2.default.createElement(
	                "g",
	                { id: "Group" },
	                _react2.default.createElement("path", { d: "M27,38.9333333 C21.4355455,38.9333333 16.1042727,36.5608333 12.3733636,32.4266 C9.14318182,28.8447333 7.36363636,24.2433 7.36363636,19.4666667 C7.36363636,8.73323333 16.173,0 27,0 C37.827,0 46.6363636,8.73323333 46.6363636,19.4666667 C46.6363636,24.2433 44.8568182,28.8447333 41.6266364,32.4266 C37.8957273,36.5608333 32.5644545,38.9333333 27,38.9333333 L27,38.9333333 Z M27,4.86666667 C18.8779091,4.86666667 12.2727273,11.4147667 12.2727273,19.4666667 C12.2727273,23.0436667 13.608,26.4941333 16.0330909,29.1829667 C18.8312727,32.2854667 22.8297273,34.0666667 27,34.0666667 C31.1702727,34.0666667 35.1687273,32.2854667 37.9669091,29.1829667 C40.392,26.4941333 41.7272727,23.0436667 41.7272727,19.4666667 C41.7272727,11.4147667 35.1220909,4.86666667 27,4.86666667 L27,4.86666667 Z", id: "Shape" }),
	                _react2.default.createElement("path", { d: "M51.5454545,73 L2.45454545,73 C1.09963636,73 0,71.9098667 0,70.5666667 L0,53.2024 C0,43.8146 5.09809091,34.2978333 12.9894545,28.9615333 C14.1087273,28.2047667 15.6354545,28.4894667 16.4012727,29.6015 C17.1646364,30.7111 16.8774545,32.2246333 15.7557273,32.9838333 C9.26836364,37.3687 4.90909091,45.4960333 4.90909091,53.2024 L4.90909091,68.1333333 L49.0909091,68.1333333 L49.0909091,53.2024 C49.0909091,45.4960333 44.7316364,37.3711333 38.2467273,32.9814 C37.125,32.2222 36.8378182,30.7086667 37.6011818,29.5990667 C38.367,28.4894667 39.8912727,28.2023333 41.013,28.9591 C48.9019091,34.2978333 54,43.8146 54,53.2024 L54,70.5666667 C54,71.9098667 52.9003636,73 51.5454545,73 L51.5454545,73 Z", id: "Shape" }),
	                _react2.default.createElement(
	                  "g",
	                  { transform: "translate(24.545455, 41.366667)", id: "Shape" },
	                  _react2.default.createElement("path", { d: "M9.81818182,19.4666667 C8.46327273,19.4666667 7.36363636,18.3765333 7.36363636,17.0333333 L7.36363636,2.43333333 C7.36363636,1.09013333 8.46327273,0 9.81818182,0 C11.1730909,0 12.2727273,1.09013333 12.2727273,2.43333333 L12.2727273,17.0333333 C12.2727273,18.3765333 11.1730909,19.4666667 9.81818182,19.4666667 L9.81818182,19.4666667 Z" }),
	                  _react2.default.createElement("path", { d: "M17.1818182,12.1666667 L2.45454545,12.1666667 C1.09963636,12.1666667 0,11.0765333 0,9.73333333 C0,8.39013333 1.09963636,7.3 2.45454545,7.3 L17.1818182,7.3 C18.5367273,7.3 19.6363636,8.39013333 19.6363636,9.73333333 C19.6363636,11.0765333 18.5367273,12.1666667 17.1818182,12.1666667 L17.1818182,12.1666667 Z" })
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	AssessmentPersonal.propTypes = {
	  style: _react.PropTypes.object
	};
	
	exports.default = AssessmentPersonal;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CalendarIcon(props) {
	    return _react2.default.createElement(
	        'svg',
	        _extends({ width: '13px', height: '15px', viewBox: '0 0 13 15', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' }, props),
	        _react2.default.createElement(
	            'g',
	            { id: '2350---QS---Follow-Up-&-Notes', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	            _react2.default.createElement(
	                'g',
	                { id: '2350---QS---Follow-Up-&-Notes-1', transform: 'translate(-1273.000000, -166.000000)', fill: '#333333' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Group-4', transform: 'translate(1273.000000, 166.000000)' },
	                    _react2.default.createElement('path', { d: 'M12.0786377,15 L0.911639064,15 C0.409193717,15 0,14.5865625 0,14.0789062 L0,2.79609375 C0,2.2884375 0.409193717,1.875 0.911639064,1.875 L12.0781737,1.875 C12.581083,1.875 12.9902767,2.2884375 12.9902767,2.79609375 L12.9902767,14.0784375 C12.9902767,14.5865625 12.581083,15 12.0786377,15 L12.0786377,15 Z M12.0623998,2.79609375 L0.911639064,2.8125 L0.92787691,14.0789063 L12.0623998,14.0625 L12.0623998,2.79609375 L12.0623998,2.79609375 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M2.78363073,3.75 C2.5275367,3.75 2.31969227,3.54 2.31969227,3.28125 L2.31969227,0.46875 C2.31969227,0.21 2.5275367,0 2.78363073,0 C3.03972476,0 3.24756918,0.21 3.24756918,0.46875 L3.24756918,3.28125 C3.24756918,3.54 3.03972476,3.75 2.78363073,3.75 L2.78363073,3.75 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M9.74270755,3.28125 L9.74270755,0.46875 C9.74270755,0.21 9.95055198,0 10.206646,0 C10.46274,0 10.6705845,0.21 10.6705845,0.46875 L10.6705845,3.28125 C10.6705845,3.54 10.46274,3.75 10.206646,3.75 C9.95055198,3.75 9.74270755,3.54 9.74270755,3.28125 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M3.94347687,7.03125 L2.5516615,7.03125 C2.42361449,7.03125 2.31969227,6.92625 2.31969227,6.796875 L2.31969227,5.390625 C2.31969227,5.26125 2.42361449,5.15625 2.5516615,5.15625 L3.94347687,5.15625 C4.07152388,5.15625 4.17544609,5.26125 4.17544609,5.390625 L4.17544609,6.796875 C4.17544609,6.92625 4.07152388,7.03125 3.94347687,7.03125 L3.94347687,7.03125 Z M2.78363073,6.5625 L3.71150764,6.5625 L3.71150764,5.625 L2.78363073,5.625 L2.78363073,6.5625 L2.78363073,6.5625 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M10.4386152,7.03125 L9.04679987,7.03125 C8.91875286,7.03125 8.81483064,6.92625 8.81483064,6.796875 L8.81483064,5.390625 C8.81483064,5.26125 8.91875286,5.15625 9.04679987,5.15625 L10.4386152,5.15625 C10.5666623,5.15625 10.6705845,5.26125 10.6705845,5.390625 L10.6705845,6.796875 C10.6705845,6.92625 10.5666623,7.03125 10.4386152,7.03125 L10.4386152,7.03125 Z M9.2787691,6.5625 L10.206646,6.5625 L10.206646,5.625 L9.2787691,5.625 L9.2787691,6.5625 L9.2787691,6.5625 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M7.19104605,7.03125 L5.79923069,7.03125 C5.67118367,7.03125 5.56726146,6.92625 5.56726146,6.796875 L5.56726146,5.390625 C5.56726146,5.26125 5.67118367,5.15625 5.79923069,5.15625 L7.19104605,5.15625 C7.31909307,5.15625 7.42301528,5.26125 7.42301528,5.390625 L7.42301528,6.796875 C7.42301528,6.92625 7.31909307,7.03125 7.19104605,7.03125 L7.19104605,7.03125 Z M6.03119991,6.5625 L6.95907682,6.5625 L6.95907682,5.625 L6.03119991,5.625 L6.03119991,6.5625 L6.03119991,6.5625 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M3.94347687,9.84375 L2.5516615,9.84375 C2.42361449,9.84375 2.31969227,9.73875 2.31969227,9.609375 L2.31969227,8.203125 C2.31969227,8.07375 2.42361449,7.96875 2.5516615,7.96875 L3.94347687,7.96875 C4.07152388,7.96875 4.17544609,8.07375 4.17544609,8.203125 L4.17544609,9.609375 C4.17544609,9.73875 4.07152388,9.84375 3.94347687,9.84375 L3.94347687,9.84375 Z M2.78363073,9.375 L3.71150764,9.375 L3.71150764,8.4375 L2.78363073,8.4375 L2.78363073,9.375 L2.78363073,9.375 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M10.4386152,9.84375 L9.04679987,9.84375 C8.91875286,9.84375 8.81483064,9.73875 8.81483064,9.609375 L8.81483064,8.203125 C8.81483064,8.07375 8.91875286,7.96875 9.04679987,7.96875 L10.4386152,7.96875 C10.5666623,7.96875 10.6705845,8.07375 10.6705845,8.203125 L10.6705845,9.609375 C10.6705845,9.73875 10.5666623,9.84375 10.4386152,9.84375 L10.4386152,9.84375 Z M9.2787691,9.375 L10.206646,9.375 L10.206646,8.4375 L9.2787691,8.4375 L9.2787691,9.375 L9.2787691,9.375 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M7.19104605,9.84375 L5.79923069,9.84375 C5.67118367,9.84375 5.56726146,9.73875 5.56726146,9.609375 L5.56726146,8.203125 C5.56726146,8.07375 5.67118367,7.96875 5.79923069,7.96875 L7.19104605,7.96875 C7.31909307,7.96875 7.42301528,8.07375 7.42301528,8.203125 L7.42301528,9.609375 C7.42301528,9.73875 7.31909307,9.84375 7.19104605,9.84375 L7.19104605,9.84375 Z M6.03119991,9.375 L6.95907682,9.375 L6.95907682,8.4375 L6.03119991,8.4375 L6.03119991,9.375 L6.03119991,9.375 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M3.94347687,12.65625 L2.5516615,12.65625 C2.42361449,12.65625 2.31969227,12.55125 2.31969227,12.421875 L2.31969227,11.015625 C2.31969227,10.88625 2.42361449,10.78125 2.5516615,10.78125 L3.94347687,10.78125 C4.07152388,10.78125 4.17544609,10.88625 4.17544609,11.015625 L4.17544609,12.421875 C4.17544609,12.55125 4.07152388,12.65625 3.94347687,12.65625 L3.94347687,12.65625 Z M2.78363073,12.1875 L3.71150764,12.1875 L3.71150764,11.25 L2.78363073,11.25 L2.78363073,12.1875 L2.78363073,12.1875 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M10.4386152,12.65625 L9.04679987,12.65625 C8.91875286,12.65625 8.81483064,12.55125 8.81483064,12.421875 L8.81483064,11.015625 C8.81483064,10.88625 8.91875286,10.78125 9.04679987,10.78125 L10.4386152,10.78125 C10.5666623,10.78125 10.6705845,10.88625 10.6705845,11.015625 L10.6705845,12.421875 C10.6705845,12.55125 10.5666623,12.65625 10.4386152,12.65625 L10.4386152,12.65625 Z M9.2787691,12.1875 L10.206646,12.1875 L10.206646,11.25 L9.2787691,11.25 L9.2787691,12.1875 L9.2787691,12.1875 Z', id: 'Shape' }),
	                    _react2.default.createElement('path', { d: 'M7.19104605,12.65625 L5.79923069,12.65625 C5.67118367,12.65625 5.56726146,12.55125 5.56726146,12.421875 L5.56726146,11.015625 C5.56726146,10.88625 5.67118367,10.78125 5.79923069,10.78125 L7.19104605,10.78125 C7.31909307,10.78125 7.42301528,10.88625 7.42301528,11.015625 L7.42301528,12.421875 C7.42301528,12.55125 7.31909307,12.65625 7.19104605,12.65625 L7.19104605,12.65625 Z M6.03119991,12.1875 L6.95907682,12.1875 L6.95907682,11.25 L6.03119991,11.25 L6.03119991,12.1875 L6.03119991,12.1875 Z', id: 'Shape' })
	                )
	            )
	        )
	    );
	}
	
	exports.default = CalendarIcon;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Clip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Clip(props) {
	
		return _react2.default.createElement(
			'svg',
			_extends({}, props, { width: '11px', height: '12px', viewBox: '0 0 11 12', version: '1.1' }),
			_react2.default.createElement(
				'title',
				null,
				'33A4C9F5-2275-4100-8548-773D79B48C53'
			),
			_react2.default.createElement(
				'desc',
				null,
				'Created with sketchtool.'
			),
			_react2.default.createElement('defs', null),
			_react2.default.createElement(
				'g',
				{ id: '2712---Emails', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', 'stroke-linejoin': 'round' },
				_react2.default.createElement(
					'g',
					{ id: '2712---Emails-3', transform: 'translate(-458.000000, -580.000000)', stroke: '#333333' },
					_react2.default.createElement(
						'g',
						{ id: 'Group-9', transform: 'translate(273.000000, 573.000000)' },
						_react2.default.createElement(
							'g',
							{ id: 'Group-6', transform: 'translate(175.000000, 0.000000)' },
							_react2.default.createElement(
								'g',
								{ id: 'Group-4-Copy' },
								_react2.default.createElement(
									'g',
									{ id: 'Mail_attach-mail' },
									_react2.default.createElement(
										'g',
										{ id: 'Icons' },
										_react2.default.createElement(
											'g',
											{ id: 'Group' },
											_react2.default.createElement('path', { d: 'M16.6993922,17.5941112 L17.116806,16.878195 L18.5764687,14.3707961 L20.0361313,11.8633971 C20.2366957,11.5189788 20.3584057,11.1483272 20.4055468,10.7742906 C20.452688,10.4002541 20.4269747,10.0228325 20.3326923,9.663182 C20.2384099,9.30353146 20.0755585,8.96165188 19.850995,8.65954543 C19.6264315,8.35743897 19.3392988,8.09510563 18.9947396,7.89370133 C18.6510375,7.69229703 18.281622,7.5712852 17.908778,7.52304971 C17.535934,7.47566046 17.1588045,7.5018938 16.7996744,7.59667229 C16.4405442,7.69145079 16.0994134,7.85392821 15.7985669,8.07987338 C15.4968633,8.3049723 15.235444,8.59353898 15.0348796,8.93795726 L14.4091875,10.0126777 L13.3652244,11.8024681 L12.3229755,13.5931046 L11.2807267,15.3837412 C11.1375889,15.6299961 11.0510205,15.8940219 11.016736,16.1614326 C10.9824515,16.4288434 11.001308,16.6987929 11.0690199,16.9552025 C11.1367318,17.2124585 11.252442,17.4561746 11.412722,17.6719649 C11.5730021,17.8877552 11.7787091,18.0756198 12.0238433,18.2186337 C12.2698346,18.362494 12.5329681,18.4488101 12.7995301,18.4835058 C13.0660921,18.5173553 13.3352255,18.4987381 13.5915021,18.4310391 C13.8477788,18.3633402 14.0911987,18.2474058 14.3071911,18.0857746 C14.5223263,17.9249897 14.7091769,17.7193542 14.8531718,17.4730993 L15.8954206,15.6824627 L16.9376695,13.8918262 L16.9548117,13.8622079 L16.3119773,14.9665466 L16.9376695,13.8918262 L17.5633616,12.8171057 L18.1890538,11.7423853 C18.2747651,11.5942939 18.3270489,11.4360476 18.3476196,11.2752627 C18.3681903,11.115324 18.3570479,10.9528465 18.3159065,10.7988315 C18.2756222,10.6448164 18.2061961,10.4984175 18.1093423,10.3689433 C18.0133457,10.2394691 17.8899215,10.1269196 17.7424982,10.0406035 C17.5950748,9.95428738 17.436509,9.90266695 17.2770861,9.88151104 C17.116806,9.86120136 16.9556688,9.87220244 16.8022457,9.91282179 C16.6479654,9.95344115 16.5022563,10.0228325 16.3728323,10.1193035 C16.2434083,10.2157745 16.1311266,10.339325 16.0454153,10.4874164 L15.4197232,11.5621369 L14.794031,12.6368573 L13.5426467,14.785452', id: 'Shape-Copy' })
										)
									)
								)
							)
						)
					)
				)
			)
		);
	}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = CloneIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function CloneIcon(props) {
		var className = props.className,
		    otherProps = _objectWithoutProperties(props, ['className']);
	
		return _react2.default.createElement(
			'svg',
			_extends({ width: '18px', height: '22px', viewBox: '0 0 18 22', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', className: 'profile-icon ' + className }, otherProps),
			_react2.default.createElement(
				'g',
				{ id: '2471---HR---Job-Request-Table-Clone', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
				_react2.default.createElement(
					'g',
					{ transform: 'translate(-1245.000000, -222.000000)', id: 'Group-21', strokeWidth: '1.5', stroke: '#333333' },
					_react2.default.createElement(
						'g',
						{ transform: 'translate(80.000000, 161.000000)' },
						_react2.default.createElement(
							'g',
							{ id: 'Group-17', transform: 'translate(990.000000, 0.000000)' },
							_react2.default.createElement(
								'g',
								{ id: 'Files_blank-files', transform: 'translate(176.000000, 62.000000)' },
								_react2.default.createElement(
									'g',
									{ id: 'Group-10' },
									_react2.default.createElement('polygon', { id: 'Shape', points: '0 20 3.2 20 6.4 20 9.6 20 12.8 20 12.8 15.6666667 12.8 11.3333333 12.8 7.602 8.02488889 2.66666667 6.4 2.66666667 3.2 2.66666667 0 2.66666667 0 7 0 11.3333333 0 15.6666667' }),
									_react2.default.createElement('polyline', { id: 'Shape', points: '7.82222222 3.33333333 7.82222222 8 12.0888889 8' }),
									_react2.default.createElement('polyline', { id: 'Shape', points: '12.7111111 17.3333333 15.6444444 17.3333333 15.6444444 13 15.6444444 8.66666667 15.6444444 4.93533333 10.8693333 0 9.24444444 0 6.04444444 0 2.84444444 0 2.84444444 2.62533333' })
								)
							)
						)
					)
				)
			)
		);
	}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EditJobIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function EditJobIcon(props) {
		var className = props.className,
		    color = props.color,
		    otherProps = _objectWithoutProperties(props, ['className', 'color']);
	
		var defaultColor = '#333333';
	
		return _react2.default.createElement(
			'svg',
			_extends({ width: '18px', height: '22px', viewBox: '0 0 18 22', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', className: 'profile-icon ' + className }, otherProps),
			_react2.default.createElement(
				'g',
				{ id: '2471---HR---Job-Request-Table-EditIcon', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
				_react2.default.createElement(
					'g',
					{ transform: 'translate(-1210.000000, -222.000000)', id: 'Group-21', strokeWidth: '1.5', stroke: color || defaultColor },
					_react2.default.createElement(
						'g',
						{ transform: 'translate(80.000000, 161.000000)' },
						_react2.default.createElement(
							'g',
							{ id: 'Group-17', transform: 'translate(990.000000, 0.000000)' },
							_react2.default.createElement(
								'g',
								{ id: 'Group-13', transform: 'translate(141.000000, 62.000000)' },
								_react2.default.createElement('polyline', { id: 'Shape', points: '5.44 19.2 8.96 19.2 12.48 19.2 16 19.2 16 14.4 16 9.6 16 5.46688 10.74688 0 8.96 0 5.44 0 1.92 0 1.92 4.8 1.92 6.4' }),
								_react2.default.createElement('polyline', { id: 'Shape', points: '10.24 0.64 10.24 5.76 15.36 5.76' }),
								_react2.default.createElement('polygon', { id: 'Shape', points: '2.49408 17.42912 0 19.2 0.0992 16.11392 2.69248 11.25696 5.28512 6.4 6.48256 7.05728 7.68 7.71456 5.08672 12.57152' }),
								_react2.default.createElement('path', { d: 'M4.2176,8.62976 L6.36032,9.7472', id: 'Shape' })
							)
						)
					)
				)
			)
		);
	}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function EmailIcon(props) {
	  var className = props.className,
	      otherProps = _objectWithoutProperties(props, ["className"]);
	
	  return _react2.default.createElement(
	    "svg",
	    { width: "32px", height: "30px", viewBox: "0 0 32 30", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "g",
	      { id: "2712---Emails", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "2712---Emails-1", transform: "translate(-744.000000, -181.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-27", transform: "translate(744.000000, 181.000000)" },
	          _react2.default.createElement("path", { d: "M15.55,30 C6.97573,30 0,23.271 0,15 C0,6.729 6.97573,0 15.55,0 C24.12427,0 31.1,6.729 31.1,15 C31.1,23.271 24.12427,30 15.55,30 L15.55,30 Z M15.55,2 C8.11917333,2 2.07333333,7.832 2.07333333,15 C2.07333333,22.168 8.11917333,28 15.55,28 C22.9808267,28 29.0266667,22.168 29.0266667,15 C29.0266667,7.832 22.9808267,2 15.55,2 L15.55,2 Z", id: "Shape-Copy", fill: "#4A4A4A" }),
	          _react2.default.createElement(
	            "g",
	            { id: "Group-18", transform: "translate(8.000000, 10.000000)", stroke: "#4A4A4A", strokeWidth: "1.2", strokeLinejoin: "round" },
	            _react2.default.createElement("path", { d: "M14.5,10 L0.5,10 C0.224,10 0,9.776 0,9.5 L0,0.5 C0,0.224 0.224,0 0.5,0 L14.5,0 C14.776,0 15,0.224 15,0.5 L15,9.5 C15,9.776 14.776,10 14.5,10 Z", id: "Shape" }),
	            _react2.default.createElement("polyline", { id: "Shape", strokeLinecap: "round", points: "0 1 7.5 6 15 1" })
	          )
	        )
	      )
	    )
	  );
	}
	
	EmailIcon.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = EmailIcon;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function GuideIcon(props) {
	    var className = props.className,
	        otherProps = _objectWithoutProperties(props, ['className']);
	
	    return _react2.default.createElement(
	        'svg',
	        _extends({ width: '31px', height: '30px', viewBox: '0 0 31 30', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', className: 'profile-icon ' + className }, otherProps),
	        _react2.default.createElement(
	            'g',
	            { id: '2152---Guide-Icon', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(-127.000000, -113.000000)', id: 'icon_info', stroke: '#4A4A4A' },
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(128.000000, 114.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Icons' },
	                        _react2.default.createElement('ellipse', { id: 'Oval', strokeWidth: '2', cx: '14.5', cy: '14', rx: '14.5', ry: '14' }),
	                        _react2.default.createElement('rect', { id: 'Rectangle-path', x: '12.5666667', y: '12.1047897', width: '3.5', height: '10.2285437' }),
	                        _react2.default.createElement('circle', { id: 'Oval', cx: '14.3166667', cy: '7.8881392', r: '1.75' })
	                    )
	                )
	            )
	        )
	    );
	}
	
	GuideIcon.propTypes = {
	    className: _react.PropTypes.string
	};
	
	exports.default = GuideIcon;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Handset(props) {
	  var _props$style = props.style;
	  _props$style = _props$style === undefined ? {} : _props$style;
	  var color = _props$style.color,
	      backgroundColor = _props$style.backgroundColor;
	
	
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", width: "13", height: "14", viewBox: "0 0 13 14" },
	    _react2.default.createElement("path", { fill: "none", fillRule: "evenodd", stroke: "#212225", d: "M9.432 13.22l-.268-.046A2.613 2.613 0 0 1 8.648 13c-3.538-1.703-6.04-4.512-7.439-8.349C.64 3.087 1.26 1.66 2.751 1.1a1.429 1.429 0 0 1 1.067.008c.758.312 2.119 2.48 2.156 3.248.039.8-.519 1.222-.756 1.403-.14.106-.286.217-.094.7.412 1.034 1.101 1.786 2.109 2.296.101.052.15.054.16.054 0-.002.031-.028.07-.093.453-.767 1.005-.928 1.39-.928.394 0 .79.161 1.21.491l.17.133c.275.215.55.43.811.665l.141.123c.396.339 1.06.905.72 1.976-.311.988-1.38 2.046-2.473 2.046z" })
	  );
	}
	
	Handset.propTypes = {
	  style: _react.PropTypes.object
	};
	
	exports.default = Handset;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function NotificationBellOff(props) {
	    var className = props.className,
	        otherProps = _objectWithoutProperties(props, ["className"]);
	
	    return _react2.default.createElement(
	        "svg",
	        _extends({ width: "18px", height: "21px", viewBox: "0 0 18 21", version: "1.1", xmlns: "http://www.w3.org/2000/svg", className: className }, otherProps),
	        _react2.default.createElement(
	            "g",
	            { id: "2513---CRM---Alerts", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { id: "2513---CRM---Alerts---None", transform: "translate(-1244.000000, -28.000000)", fill: "#151921" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group", transform: "translate(1244.000000, 28.000000)" },
	                    _react2.default.createElement("path", { d: "M9,20.125 C7.55275,20.125 6.375,18.94725 6.375,17.5 L6.375,16.67925 C6.375,16.19625 6.767,15.80425 7.25,15.80425 C7.733,15.80425 8.125,16.19625 8.125,16.67925 L8.125,17.5 C8.125,17.982125 8.517875,18.375 9,18.375 C9.482125,18.375 9.875,17.982125 9.875,17.5 L9.875,16.6845 C9.875,16.2015 10.267,15.8095 10.75,15.8095 C11.233,15.8095 11.625,16.2015 11.625,16.6845 L11.625,17.5 C11.625,18.94725 10.44725,20.125 9,20.125 L9,20.125 Z", id: "Shape" }),
	                    _react2.default.createElement("path", { d: "M9,3.5 C8.517,3.5 8.125,3.108 8.125,2.625 L8.125,0.875 C8.125,0.392 8.517,0 9,0 C9.483,0 9.875,0.392 9.875,0.875 L9.875,2.625 C9.875,3.108 9.483,3.5 9,3.5 L9,3.5 Z", id: "Shape" }),
	                    _react2.default.createElement("path", { d: "M16.7875,18.580625 C16.70175,18.580625 16.615125,18.568375 16.531125,18.542125 C14.322625,17.864 11.718625,17.50525 9,17.50525 C6.281375,17.50525 3.677375,17.864 1.468875,18.542125 C1.0935,18.657625 0.684875,18.507125 0.473125,18.174625 C0.26225,17.842125 0.299,17.409 0.564125,17.117625 C0.8485,16.804375 1.073375,16.484125 1.250125,16.1385 C1.923,14.826 1.902875,13.134625 1.831125,11.652375 L1.811,11.24725 C1.727875,9.625 1.642125,7.947625 2.16275,6.334125 C3.045625,3.591875 5.829875,1.75 9.091,1.75 C10.3615,1.75 11.580375,2.050125 12.61725,2.618 C14.177375,3.472875 15.351625,4.827375 15.83725,6.335 C16.357875,7.9485 16.272125,9.625875 16.188125,11.24725 L16.168,11.652375 C16.09625,13.134625 16.076125,14.826 16.749,16.1385 C16.907375,16.44825 17.105125,16.73875 17.34925,17.021375 C17.5505,17.1815 17.679125,17.429125 17.679125,17.7065 C17.679125,18.1895 17.287125,18.5815 16.804125,18.5815 C16.79975,18.57975 16.793625,18.580625 16.7875,18.580625 L16.7875,18.580625 Z M9.091,3.5 C7.079375,3.5 4.573375,4.55525 3.827,6.871375 C3.40525,8.1795 3.483125,9.69325 3.5575,11.158 L3.5785,11.5675 C3.651125,13.076 3.67125,14.784 3.077125,16.331 C6.767875,15.575 11.230375,15.575 14.921125,16.331 C14.326125,14.784 14.347125,13.076 14.41975,11.5675 L14.44075,11.158 C14.515125,9.69325 14.593,8.1795 14.17125,6.87225 C13.82125,5.786375 12.948875,4.795 11.776375,4.153625 C10.997625,3.72575 10.06925,3.5 9.091,3.5 L9.091,3.5 Z", id: "Shape" })
	                )
	            )
	        )
	    );
	}
	
	exports.default = NotificationBellOff;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function NotificationBellOn(props) {
	    var className = props.className,
	        otherProps = _objectWithoutProperties(props, ["className"]);
	
	    return _react2.default.createElement(
	        "svg",
	        _extends({ width: "24px", height: "25px", viewBox: "0 0 24 25", version: "1.1", xmlns: "http://www.w3.org/2000/svg", className: className }, otherProps),
	        _react2.default.createElement(
	            "g",
	            { id: "2513---CRM---Alerts", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { id: "2513---CRM---Alerts---Pending", transform: "translate(-1241.000000, -26.000000)", fill: "#2EB0E3" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-17", transform: "translate(1235.000000, 21.000000)" },
	                    _react2.default.createElement(
	                        "g",
	                        { id: "Group-13", transform: "translate(18.000000, 17.500000) rotate(45.000000) translate(-18.000000, -17.500000) translate(4.000000, 7.000000)" },
	                        _react2.default.createElement("path", { d: "M21.7875,18.580625 C21.70175,18.580625 21.615125,18.568375 21.531125,18.542125 C19.322625,17.864 16.718625,17.50525 14,17.50525 C11.281375,17.50525 8.677375,17.864 6.468875,18.542125 C6.0935,18.657625 5.684875,18.507125 5.473125,18.174625 C5.26225,17.842125 5.299,17.409 5.564125,17.117625 C5.8485,16.804375 6.073375,16.484125 6.250125,16.1385 C6.923,14.826 6.902875,13.134625 6.831125,11.652375 L6.811,11.24725 C6.727875,9.625 6.642125,7.947625 7.16275,6.334125 C8.045625,3.591875 10.829875,1.75 14.091,1.75 C15.3615,1.75 16.580375,2.050125 17.61725,2.618 C19.177375,3.472875 20.351625,4.827375 20.83725,6.335 C21.357875,7.9485 21.272125,9.625875 21.188125,11.24725 L21.168,11.652375 C21.09625,13.134625 21.076125,14.826 21.749,16.1385 C21.907375,16.44825 22.105125,16.73875 22.34925,17.021375 C22.5505,17.1815 22.679125,17.429125 22.679125,17.7065 C22.679125,18.1895 22.287125,18.5815 21.804125,18.5815 C21.79975,18.57975 21.793625,18.580625 21.7875,18.580625 L21.7875,18.580625 Z M14.091,3.5 C12.079375,3.5 9.573375,4.55525 8.827,6.871375 C8.40525,8.1795 8.483125,9.69325 8.5575,11.158 L8.5785,11.5675 C8.651125,13.076 8.67125,14.784 8.077125,16.331 C11.767875,15.575 16.230375,15.575 19.921125,16.331 C19.326125,14.784 19.347125,13.076 19.41975,11.5675 L19.44075,11.158 C19.515125,9.69325 19.593,8.1795 19.17125,6.87225 C18.82125,5.786375 17.948875,4.795 16.776375,4.153625 C15.997625,3.72575 15.06925,3.5 14.091,3.5 L14.091,3.5 Z", id: "Shape" }),
	                        _react2.default.createElement("path", { d: "M14,20.125 C12.55275,20.125 11.375,18.94725 11.375,17.5 L11.375,16.67925 C11.375,16.19625 11.767,15.80425 12.25,15.80425 C12.733,15.80425 13.125,16.19625 13.125,16.67925 L13.125,17.5 C13.125,17.982125 13.517875,18.375 14,18.375 C14.482125,18.375 14.875,17.982125 14.875,17.5 L14.875,16.6845 C14.875,16.2015 15.267,15.8095 15.75,15.8095 C16.233,15.8095 16.625,16.2015 16.625,16.6845 L16.625,17.5 C16.625,18.94725 15.44725,20.125 14,20.125 L14,20.125 Z", id: "Shape" }),
	                        _react2.default.createElement("path", { d: "M2.4115,15.0885 C2.1875,15.0885 1.9635,15.00275 1.792875,14.832125 C0.637,13.675375 0,12.137125 0,10.5 C0,8.862875 0.637,7.324625 1.792875,6.167875 C2.135,5.82575 2.688,5.82575 3.030125,6.167875 C3.37225,6.51 3.37225,7.063 3.030125,7.405125 C2.205,8.231125 1.75,9.330125 1.75,10.5 C1.75,11.669875 2.205,12.768875 3.030125,13.594875 C3.37225,13.937 3.37225,14.49 3.030125,14.832125 C2.8595,15.00275 2.6355,15.0885 2.4115,15.0885 L2.4115,15.0885 Z", id: "Shape" }),
	                        _react2.default.createElement("path", { d: "M4.524625,13.850375 C4.300625,13.850375 4.076625,13.764625 3.906,13.594 C3.08,12.768 2.625,11.669 2.625,10.5 C2.625,9.331 3.08,8.232 3.906,7.406 C4.248125,7.063875 4.801125,7.063875 5.14325,7.406 C5.485375,7.748125 5.485375,8.301125 5.14325,8.64325 C4.648,9.1385 4.375,9.79825 4.375,10.5 C4.375,11.20175 4.648,11.8615 5.14325,12.35675 C5.485375,12.698875 5.485375,13.251875 5.14325,13.594 C4.972625,13.764625 4.748625,13.850375 4.524625,13.850375 L4.524625,13.850375 Z", id: "Shape" }),
	                        _react2.default.createElement("path", { d: "M25.5885,15.0885 C25.3645,15.0885 25.1405,15.00275 24.969875,14.832125 C24.62775,14.49 24.62775,13.937 24.969875,13.594875 C25.795,12.768875 26.25,11.669875 26.25,10.5 C26.25,9.330125 25.795,8.231125 24.969875,7.405125 C24.62775,7.063 24.62775,6.51 24.969875,6.167875 C25.312,5.82575 25.865,5.82575 26.207125,6.167875 C27.363,7.324625 28,8.862875 28,10.5 C28,12.137125 27.363,13.675375 26.207125,14.832125 C26.035625,15.00275 25.8125,15.0885 25.5885,15.0885 L25.5885,15.0885 Z", id: "Shape" }),
	                        _react2.default.createElement("path", { d: "M23.475375,13.850375 C23.251375,13.850375 23.027375,13.764625 22.85675,13.594 C22.514625,13.251875 22.514625,12.698875 22.85675,12.35675 C23.352,11.8615 23.625,11.20175 23.625,10.5 C23.625,9.79825 23.352,9.1385 22.85675,8.64325 C22.514625,8.301125 22.514625,7.748125 22.85675,7.406 C23.198875,7.063875 23.751875,7.063875 24.094,7.406 C24.92,8.232 25.375,9.331 25.375,10.5 C25.375,11.669 24.92,12.768 24.094,13.594 C23.923375,13.764625 23.699375,13.850375 23.475375,13.850375 L23.475375,13.850375 Z", id: "Shape" }),
	                        _react2.default.createElement("path", { d: "M14,3.5 C13.517,3.5 13.125,3.108 13.125,2.625 L13.125,0.875 C13.125,0.392 13.517,1.13686838e-13 14,1.13686838e-13 C14.483,1.13686838e-13 14.875,0.392 14.875,0.875 L14.875,2.625 C14.875,3.108 14.483,3.5 14,3.5 L14,3.5 Z", id: "Shape" })
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = NotificationBellOn;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RatingStarIcon(props) {
	    return _react2.default.createElement(
	        'svg',
	        _extends({ width: '17px', height: '16px', viewBox: '0 0 17 16', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' }, props),
	        _react2.default.createElement(
	            'g',
	            { id: '97---Applicant-Interview--Ratings-by-QS', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', opacity: '0.4' },
	            _react2.default.createElement(
	                'g',
	                { id: '97---Applicant-Interview--Ratings-by-QS-3', transform: 'translate(-714.000000, -442.000000)', fill: '#333333' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'icon_song-favorites', transform: 'translate(714.280000, 442.000000)' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Icons' },
	                        _react2.default.createElement('path', { d: 'M13.182048,16 C13.0694667,16 12.956328,15.9645714 12.8599093,15.8942857 L8.36,12.6217143 L3.86009067,15.8948571 C3.66390933,16.0377143 3.399176,16.0348571 3.20633867,15.888 C3.01238667,15.7405714 2.93324533,15.4828571 3.00904267,15.2485714 L4.72061333,9.97485714 L0.234637333,6.712 C0.0373413333,6.568 -0.0473733333,6.30971429 0.0261946667,6.07257143 C0.10032,5.83542857 0.314336,5.67485714 0.557333333,5.67485714 L6.11673333,5.67485714 L7.83109067,0.391428571 C7.90744533,0.157142857 8.11978933,0 8.36,0 C8.60021067,0 8.813112,0.157142857 8.88890933,0.391428571 L10.6032667,5.67485714 L16.1626667,5.67485714 C16.405664,5.67485714 16.61968,5.83542857 16.6938053,6.07257143 C16.7673733,6.30971429 16.6826587,6.568 16.4853627,6.712 L11.9993867,9.97485714 L13.7109573,15.2485714 C13.7867547,15.4828571 13.707056,15.7405714 13.5136613,15.888 C13.4155707,15.9628571 13.2985307,16 13.182048,16 L13.182048,16 Z M8.36,11.3497143 C8.47313867,11.3497143 8.58572,11.3851429 8.68213867,11.4554286 L12.115312,13.952 L10.811152,9.93428571 C10.7336827,9.696 10.81784,9.43371429 11.0173653,9.288 L14.4137547,6.81771429 L10.2014293,6.81771429 C9.96121867,6.81771429 9.74831733,6.66057143 9.67252,6.42628571 L8.36,2.38114286 L7.04748,6.42628571 C6.97112533,6.66 6.758224,6.81771429 6.51857067,6.81771429 L2.30624533,6.81771429 L5.70263467,9.288 C5.90216,9.43371429 5.98631733,9.696 5.908848,9.93428571 L4.604688,13.952 L8.03786133,11.4554286 C8.13428,11.3851429 8.24686133,11.3497143 8.36,11.3497143 L8.36,11.3497143 Z', id: 'Shape' })
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = RatingStarIcon;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ResetIcon(props) {
	  var className = props.className,
	      otherProps = _objectWithoutProperties(props, ['className']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({ width: '21', height: '21', viewBox: '0 0 21 21', xmlns: 'http://www.w3.org/2000/svg', className: 'reset-icon ' + className }, otherProps),
	    _react2.default.createElement(
	      'g',
	      { strokeWidth: '.8', stroke: '#4A4A4A', fill: '#4A4A4A', fillRule: 'nonzero' },
	      _react2.default.createElement('path', { d: 'M19.182 7.531h-5.455a.6.6 0 0 1-.606-.593.6.6 0 0 1 .606-.594h5.455a.6.6 0 0 1 .606.593.6.6 0 0 1-.606.594z' }),
	      _react2.default.createElement('path', { d: 'M19.606 7.531A.6.6 0 0 1 19 6.938V1.593A.6.6 0 0 1 19.606 1a.6.6 0 0 1 .606.594v5.343a.6.6 0 0 1-.606.594z' }),
	      _react2.default.createElement('path', { d: 'M10.782 20C5.388 20 1 15.738 1 10.5S5.388 1 10.782 1c3.793 0 7.277 2.16 8.876 5.502a.589.589 0 0 1-.291.79.612.612 0 0 1-.806-.286c-1.401-2.927-4.454-4.819-7.78-4.819-4.725 0-8.569 3.73-8.569 8.313 0 4.584 3.844 8.313 8.57 8.313 4.093 0 7.63-2.824 8.411-6.715a.606.606 0 0 1 .712-.469.595.595 0 0 1 .478.697C19.49 16.773 15.453 20 10.782 20z' })
	    )
	  );
	}
	
	ResetIcon.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = ResetIcon;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var svgImageEmbed = "<image x='40' y='166' width='30' height='30' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAA1teXP8meAAAA1JJREFUWAm1VotR20AUtDMpQCXYHYhxATkqQB0AFQQqsF2BoQKgA1EBSgEM6gCVoBKya+1icZIOhZm8mad93713J1nycvFN2Ww2B7TeqP3u9fX19jtUy7lNWjBXfQssot4SfqZYPXegWQNg8R2ItyLvg3fN04hljyF2cTD2f8aBCf9C8T2Qu+dOKyxQARcYsAYEqHMclj07aFKSJ6CdkygXy1r4G1hAV/IbYAXlgJT3DhYc7Dl1Ej9UOADdc+7Ei1/DDlCSZ9BrEC+ptKEU5gLUPnu34oI5lMkBUOqF97DXaj0Az7AoF68UW9BmjDkoayjsYS/FXJ3Xu6YGcFkr4wF4joVqJ2JU7hxx1lLc23kj19QAbs7Qt4U+phY3t2oe4fM5YS/FXJ3Xu44OoHtWqK4CBugTdK6wlv2VGoqp52B0ADTdqPEWOyLJSqhwGqIevyvM+al5aoBPRf/TmRrgTosecHQBdiOcNUvU41+FOT9xjA6AI+SxlaoMsi/lzwHWsj+ouBSn3BOMDqB0JmyB99Ar7CxXbBJUc4UC9rCXYq7O611TA7jMzdcIvKSGUO4FdayluLfzRq6pAWrV8x3wLpu35g0LPUCDYvwYBcaYg7KGwh72UszVeb3rsmcPTJDuELyA5kquhXzJFNCV/AZYQnnsFA/MhZMfo+QARypcMAh3xiH20BaaQfn+r4DHEwAEqHPcOf+UnAGTMvf/gEl8pPT5lfNxH1zwr/jlCWCRFUh9pBVs7j6HjkmNIE8hKLnGKTSyRyH1ELqhkMHf8jls32cuZLF9r5pSCfe6boBzBvilrj9C+1zMf0g8lHNx7WBhB5ID4PgzFHoX8a7sk8v2oFYcXm+AyQFQbUI+0Q3IcsQyaAu/NpvsljnWsBa284XrxvCrAfgOoDx18DFQKb8PjnlB95ijX/thfzVAUGUlNJnvscJHcMw17gn9otieHABHyZ1k0IZHrHuZi6CMieA7lrNWt6VBnLelGKk/hiYHQNY7MbFJ+Dy0MaFiteKuLeWbK25bpAYwCXd0g06TPA9YTgHnLtSTK2WuU6Ws1Ku4QQ0JghRwlNLGCDK3hXJBqqWxEeMyDvR97CKHH6B8wRD5PJwBJwU9b0iuoBWUDyY/WjVwVP4CJwAS5OambbcAAAAASUVORK5CYII='/>";
	
	function Ribbon(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ width: '22px', height: '30px', viewBox: '0 0 22 30', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' }, props),
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(-375.000000, -441.000000)' },
	      _react2.default.createElement('g', { transform: 'translate(331.000000, 275.000000)', dangerouslySetInnerHTML: { __html: svgImageEmbed } })
	    )
	  );
	}
	
	exports.default = Ribbon;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Menu;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Menu(props) {
	  var _props$style = props.style;
	  _props$style = _props$style === undefined ? {} : _props$style;
	  var color = _props$style.color;
	
	
	  return _react2.default.createElement(
	    'svg',
	    { xmlns: 'http://www.w3.org/2000/svg', width: '22', height: '22', viewBox: '0 0 22 22' },
	    _react2.default.createElement(
	      'g',
	      { fill: '#FFF', fillRule: 'nonzero', stroke: '#FFF', strokeWidth: '.5' },
	      _react2.default.createElement('path', { d: 'M11 13c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z' }),
	      _react2.default.createElement('path', { d: 'M11.903 21h-1.806c-.7 0-1.269-.57-1.269-1.269v-1.457a7.52 7.52 0 0 1-1.435-.595l-1.03 1.03c-.48.48-1.316.48-1.795 0l-1.277-1.277a1.27 1.27 0 0 1 0-1.794l1.03-1.03a7.537 7.537 0 0 1-.595-1.436H2.27c-.7 0-1.269-.57-1.269-1.27v-1.805c0-.7.57-1.269 1.269-1.269h1.457c.149-.498.347-.978.595-1.435l-1.03-1.031a1.27 1.27 0 0 1 0-1.794l1.277-1.277c.48-.48 1.315-.48 1.794 0l1.03 1.03a7.537 7.537 0 0 1 1.436-.595V2.269c0-.7.57-1.269 1.269-1.269h1.806c.7 0 1.269.57 1.269 1.269v1.457a7.52 7.52 0 0 1 1.435.595l1.03-1.03c.48-.48 1.316-.48 1.795 0l1.277 1.277a1.27 1.27 0 0 1 0 1.794l-1.03 1.03c.248.459.446.938.595 1.436h1.457c.7 0 1.269.57 1.269 1.269v1.806c0 .7-.57 1.268-1.269 1.268h-1.457a7.519 7.519 0 0 1-.595 1.436l1.03 1.03a1.27 1.27 0 0 1 0 1.794l-1.277 1.278c-.48.479-1.315.479-1.794 0l-1.03-1.031a7.537 7.537 0 0 1-1.436.595v1.458c0 .7-.569 1.269-1.269 1.269zm-1.741-1.333h1.677v-1.908c0-.313.217-.584.523-.652a6.18 6.18 0 0 0 1.994-.826.668.668 0 0 1 .83.091l1.35 1.35 1.185-1.187-1.35-1.349a.666.666 0 0 1-.09-.83 6.18 6.18 0 0 0 .826-1.994.668.668 0 0 1 .652-.523h1.908v-1.677H17.76a.668.668 0 0 1-.651-.523 6.18 6.18 0 0 0-.827-1.994.666.666 0 0 1 .092-.83l1.349-1.349-1.186-1.186-1.35 1.35a.668.668 0 0 1-.829.09 6.18 6.18 0 0 0-1.995-.826.668.668 0 0 1-.522-.651v-1.91h-1.678v1.908a.668.668 0 0 1-.522.652 6.18 6.18 0 0 0-1.995.826.668.668 0 0 1-.83-.091l-1.35-1.35-1.186 1.187 1.35 1.349c.22.22.258.566.09.83a6.18 6.18 0 0 0-.826 1.994.668.668 0 0 1-.652.523H2.333v1.677h1.908c.313 0 .584.217.652.523a6.18 6.18 0 0 0 .826 1.994.666.666 0 0 1-.09.83l-1.35 1.349 1.186 1.186 1.35-1.35a.668.668 0 0 1 .829-.09 6.18 6.18 0 0 0 1.994.826.668.668 0 0 1 .523.651v1.91z' })
	    )
	  );
	}
	
	Menu.propTypes = {
	  style: _react.PropTypes.object
	};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	// adds "props" to "children"
	exports.default = function (children) {
	  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _react.Children.toArray(children).filter(function (child) {
	    return !!child;
	  }).map(function (child) {
	    return (0, _react.cloneElement)(child, props);
	  });
	};

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = returnLuma;
	function returnLuma(color) {
	  var c = color.substring(1); // strip #
	  var rgb = parseInt(c, 16); // convert rrggbb to decimal
	  var r = rgb >> 16 & 0xff; // extract red
	  var g = rgb >> 8 & 0xff; // extract green
	  var b = rgb >> 0 & 0xff; // extract blue
	
	  var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
	
	  return luma;
	}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPosition;
	function getPosition(el) {
	  var coordinates = {
	    left: 0,
	    top: 0,
	    height: el.scrollHeight,
	    width: el.scrollWidth
	  };
	
	  while (el) {
	    if (el.tagName === 'BODY') {
	      // deal with browser quirks with body/window/document and page scroll
	      var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
	      var yScroll = el.scrollTop || document.documentElement.scrollTop;
	
	      coordinates.left += el.offsetLeft - xScroll + el.clientLeft;
	      coordinates.top += el.offsetTop - yScroll + el.clientTop;
	    } else {
	      // for all other non-BODY elements
	      coordinates.left += el.offsetLeft - el.scrollLeft + el.clientLeft;
	      coordinates.top += el.offsetTop - el.scrollTop + el.clientTop;
	    }
	
	    el = el.offsetParent;
	  }
	
	  return coordinates;
	}
	
	global.getPosition = getPosition;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = getScrollBarWidth;
	function getScrollBarWidth() {
	   // default to 0px server-side
	   //if(!process.env.CLIENT) return 0;
	
	   var inner = document.createElement('p');
	   inner.style.width = '100%';
	   inner.style.height = '200px';
	
	   var outer = document.createElement('div');
	   outer.style.position = 'absolute';
	   outer.style.top = '0px';
	   outer.style.left = '0px';
	   outer.style.visibility = 'hidden';
	   outer.style.width = '200px';
	   outer.style.height = '150px';
	   outer.style.overflow = 'hidden';
	   outer.appendChild(inner);
	
	   document.body.appendChild(outer);
	   var w1 = inner.offsetWidth;
	   outer.style.overflow = 'scroll';
	   var w2 = inner.offsetWidth;
	   if (w1 === w2) w2 = outer.clientWidth;
	
	   document.body.removeChild(outer);
	
	   return w1 - w2;
	}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _isServer = __webpack_require__(207);
	
	var _isServer2 = _interopRequireDefault(_isServer);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// declare elem for sizing in outside scope
	var elem = void 0;
	
	if (!_isServer2.default) {
	  elem = document.createElement('span');
	  document.body.appendChild(elem);
	  elem.style.position = 'fixed';
	  elem.style.top = '-9999px';
	  elem.style.left = '-9999px';
	  elem.style.visibility = 'hidden';
	  global.elem = elem;
	}
	
	var memoize = {};
	
	module.exports = function getTextSize(str, stylesObj, overwriteBool) {
	  if (!overwriteBool && memoize[str]) {
	    return memoize[str];
	  }
	
	  var dimensions = {
	    height: 0,
	    width: 0
	  };
	
	  if (_isServer2.default) return dimensions;
	
	  // adjust text then update dimensions
	  elem.innerText = str;
	
	  if (stylesObj) {
	    _lodash2.default.merge(elem.style, stylesObj); // add stylesObj to element style
	  }
	
	  dimensions.height = elem.offsetHeight;
	  dimensions.width = elem.offsetWidth;
	
	  memoize[str] = dimensions;
	
	  return dimensions;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (queryObj) {
	  return !Object.keys(queryObj).length ? '' : '?' + Object.keys(queryObj).map(function (val) {
	    return val + '=' + (queryObj[val] && _typeof(queryObj[val]) === 'object' ? JSON.stringify(queryObj[val]) : queryObj[val]);
	  }).join('&');
	};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var ApplicantNote = function (_BaseModel) {
	  _inherits(ApplicantNote, _BaseModel);
	
	  function ApplicantNote() {
	    _classCallCheck(this, ApplicantNote);
	
	    return _possibleConstructorReturn(this, (ApplicantNote.__proto__ || Object.getPrototypeOf(ApplicantNote)).call(this, applicantNoteSchema));
	  }
	
	  _createClass(ApplicantNote, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return applicantNoteSchema;
	    }
	  }]);
	
	  return ApplicantNote;
	}(BaseModel);
	
	var applicantNoteSchema = {
	  applicantStatusId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  note: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = ApplicantNote;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var ApplicantTask = function (_BaseModel) {
	  _inherits(ApplicantTask, _BaseModel);
	
	  function ApplicantTask() {
	    _classCallCheck(this, ApplicantTask);
	
	    return _possibleConstructorReturn(this, (ApplicantTask.__proto__ || Object.getPrototypeOf(ApplicantTask)).call(this, applicantTaskSchema));
	  }
	
	  _createClass(ApplicantTask, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return applicantTaskSchema;
	    }
	  }]);
	
	  return ApplicantTask;
	}(BaseModel);
	
	var applicantTaskSchema = {
	  taskTypeId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  message: {
	    isLength: {
	      options: { max: 255 },
	      message: 'Max length is 255 characters.'
	    }
	  }
	};
	
	module.exports = ApplicantTask;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _require = __webpack_require__(311),
	    combine = _require.combine,
	    required = _require.required,
	    isBoolean = _require.isBoolean,
	    isDate = _require.isDate,
	    isNumeric = _require.isNumeric,
	    isString = _require.isString,
	    isLength = _require.isLength,
	    custom = _require.custom,
	    related = _require.related;
	
	var _require2 = __webpack_require__(4),
	    isNil = _require2.isNil,
	    isEmpty = _require2.isEmpty;
	
	var requiredMessage = 'This field is required';
	
	var schema = exports.schema = {
	  computerTypeId: combine(required(), isNumeric()),
	  computerOperatingSystemId: combine(required(), isNumeric()),
	  computerMakeAndModel: combine(required(), isString(), isLength(1, undefined, requiredMessage)),
	  windowsOperatingSystemId: combine(isNumeric()),
	  computerMemorySizeId: combine(required(), isNumeric()),
	  hasSecondMonitor: combine(required(), isBoolean()),
	  hasWebcam: combine(required(), isBoolean()),
	  antiVirusName: combine(required(), isString()),
	  antiVirusExpired: combine(required(), isDate()),
	  internetProviderId: combine(required(), isNumeric()),
	  internetProviderOther: isString(),
	  internetTypeId: combine(required(), isNumeric()),
	  internetDownloadSpeed: combine(required(), isNumeric()),
	  internetUploadSpeed: combine(required(), isNumeric()),
	  internetAgeId: combine(required(), isNumeric()),
	  hasRouter: combine(required(), isBoolean()),
	  isRouterLocatedInSameArea: combine(required(), isBoolean()),
	  supportsVOIP: combine(required(), isBoolean()),
	  smartPhoneMakeAndModel: combine(required(), isString()),
	  hotspot: combine(required(), isBoolean()),
	  hasHeadsetWithMicrophone: combine(required(), isBoolean()),
	  hasSpeakersWithMicrophone: combine(required(), isBoolean())
	};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var ApplicantSubmission = function (_BaseModel) {
	  _inherits(ApplicantSubmission, _BaseModel);
	
	  function ApplicantSubmission() {
	    _classCallCheck(this, ApplicantSubmission);
	
	    return _possibleConstructorReturn(this, (ApplicantSubmission.__proto__ || Object.getPrototypeOf(ApplicantSubmission)).call(this, applicantSubmissionSchema));
	  }
	
	  _createClass(ApplicantSubmission, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return applicantSubmissionSchema;
	    }
	  }]);
	
	  return ApplicantSubmission;
	}(BaseModel);
	
	var applicantSubmissionSchema = {
	  dateAuthorized: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = ApplicantSubmission;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var CompanyModel = function (_BaseModel) {
	  _inherits(CompanyModel, _BaseModel);
	
	  function CompanyModel() {
	    _classCallCheck(this, CompanyModel);
	
	    return _possibleConstructorReturn(this, (CompanyModel.__proto__ || Object.getPrototypeOf(CompanyModel)).call(this, companySchema));
	  }
	
	  _createClass(CompanyModel, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return companySchema;
	    }
	  }]);
	
	  return CompanyModel;
	}(BaseModel);
	
	var companySchema = {
	  name: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 1, max: 255 },
	      message: 'Max length 255 characters and Min 1 characters'
	    }
	  },
	  address: {},
	  city: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  state: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  website: {},
	  zip: {
	    isNumeric: {
	      message: 'Must be numeric'
	    }
	  },
	  numberOfOffices: {
	    isNumeric: {
	      message: 'Must be numeric'
	    }
	  },
	  numberOfEmployees: {
	    required: {
	      message: 'This field is required.'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    }
	  },
	  parentCompany: {},
	  phoneNumber: {
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    },
	    matches: {
	      options: /^[2-9]\d{9}$/,
	      message: 'Must be a valid phone number.'
	    }
	  },
	  parentCompanyId: {},
	  segmentTypes: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  industryTypes: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  segmentOther: {},
	  industryOther: {},
	  tradeAssociations: {},
	  iiabaState: {},
	  salesPartner: {},
	  inquiryHelp: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  affiliationTypes: {},
	  affiliationOther: {},
	  networkAffiliationsYesNo: {},
	  networkAffiliations: {}
	
	};
	
	module.exports = CompanyModel;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var ContactNote = function (_BaseModel) {
	  _inherits(ContactNote, _BaseModel);
	
	  function ContactNote() {
	    _classCallCheck(this, ContactNote);
	
	    return _possibleConstructorReturn(this, (ContactNote.__proto__ || Object.getPrototypeOf(ContactNote)).call(this, contactNoteSchema));
	  }
	
	  _createClass(ContactNote, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return contactNoteSchema;
	    }
	  }]);
	
	  return ContactNote;
	}(BaseModel);
	
	var contactNoteSchema = {
	  note: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = ContactNote;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var ContactProfileModel = function (_BaseModel) {
	  _inherits(ContactProfileModel, _BaseModel);
	
	  function ContactProfileModel() {
	    _classCallCheck(this, ContactProfileModel);
	
	    return _possibleConstructorReturn(this, (ContactProfileModel.__proto__ || Object.getPrototypeOf(ContactProfileModel)).call(this, contactProfileSchema));
	  }
	
	  _createClass(ContactProfileModel, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return contactProfileSchema;
	    }
	  }]);
	
	  return ContactProfileModel;
	}(BaseModel);
	
	var contactProfileSchema = {
	  title: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  phoneNumber: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    },
	    matches: {
	      options: /^[2-9]\d{9}$/,
	      message: 'Must be a valid phone number.'
	    }
	  },
	  foundUsVia: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  initialInquiry: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = ContactProfileModel;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseModel = __webpack_require__(54);
	
	var ContactTask = function (_BaseModel) {
	  _inherits(ContactTask, _BaseModel);
	
	  function ContactTask() {
	    _classCallCheck(this, ContactTask);
	
	    return _possibleConstructorReturn(this, (ContactTask.__proto__ || Object.getPrototypeOf(ContactTask)).call(this, contactTaskSchema));
	  }
	
	  _createClass(ContactTask, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return contactTaskSchema;
	    }
	  }]);
	
	  return ContactTask;
	}(BaseModel);
	
	var contactTaskSchema = {};
	
	module.exports = ContactTask;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.designationsAndAssociationsSchema = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baseModel = __webpack_require__(54);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DesignationsAndAssociations = function (_BaseModel) {
	  _inherits(DesignationsAndAssociations, _BaseModel);
	
	  function DesignationsAndAssociations() {
	    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : designationsAndAssociationsSchema;
	
	    _classCallCheck(this, DesignationsAndAssociations);
	
	    return _possibleConstructorReturn(this, (DesignationsAndAssociations.__proto__ || Object.getPrototypeOf(DesignationsAndAssociations)).call(this, schema));
	  }
	
	  _createClass(DesignationsAndAssociations, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return designationsAndAssociationsSchema;
	    }
	  }]);
	
	  return DesignationsAndAssociations;
	}(_baseModel2.default);
	
	var designationsAndAssociationsSchema = exports.designationsAndAssociationsSchema = {
	  ProfessionalDesignations: {
	    custom: {
	      func: function func(val) {
	        return !_lodash2.default.isEmpty(val);
	      },
	      message: 'Must Select at Least One'
	    }
	  },
	  ProfessionalAssociations: {
	    custom: {
	      func: function func(val) {
	        return !_lodash2.default.isEmpty(val);
	      },
	      message: 'Must Select at Least One'
	    }
	  }
	};
	
	module.exports = DesignationsAndAssociations;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baseModel = __webpack_require__(54);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Documents = function (_BaseModel) {
	  _inherits(Documents, _BaseModel);
	
	  function Documents() {
	    _classCallCheck(this, Documents);
	
	    return _possibleConstructorReturn(this, (Documents.__proto__ || Object.getPrototypeOf(Documents)).call(this, documentsSchema));
	  }
	
	  _createClass(Documents, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return documentsSchema;
	    }
	  }]);
	
	  return Documents;
	}(_baseModel2.default);
	
	var documentsSchema = {
	  fileTypeId: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = Documents;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baseModel = __webpack_require__(54);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Education = function (_BaseModel) {
	  _inherits(Education, _BaseModel);
	
	  function Education() {
	    _classCallCheck(this, Education);
	
	    return _possibleConstructorReturn(this, (Education.__proto__ || Object.getPrototypeOf(Education)).call(this, educationSchema));
	  }
	
	  _createClass(Education, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return educationSchema;
	    }
	  }]);
	
	  return Education;
	}(_baseModel2.default);
	
	var educationSchema = {
	  institutionTypeId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  institutionName: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  degreeTypeId: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  subjectOrMajor: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  dateAttendedStart: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = Education;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.employmentGapSchema = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baseModel = __webpack_require__(54);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmploymentGap = function (_BaseModel) {
	  _inherits(EmploymentGap, _BaseModel);
	
	  function EmploymentGap() {
	    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : employmentGapSchema;
	
	    _classCallCheck(this, EmploymentGap);
	
	    return _possibleConstructorReturn(this, (EmploymentGap.__proto__ || Object.getPrototypeOf(EmploymentGap)).call(this, schema));
	  }
	
	  _createClass(EmploymentGap, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return employmentGapSchema;
	    }
	  }]);
	
	  return EmploymentGap;
	}(_baseModel2.default);
	
	var employmentGapSchema = exports.employmentGapSchema = {
	  gapStart: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  gapEnd: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  explanation: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = EmploymentGap;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baseModel = __webpack_require__(54);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var License = function (_BaseModel) {
	  _inherits(License, _BaseModel);
	
	  function License() {
	    _classCallCheck(this, License);
	
	    return _possibleConstructorReturn(this, (License.__proto__ || Object.getPrototypeOf(License)).call(this, licenseSchema));
	  }
	
	  _createClass(License, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return licenseSchema;
	    }
	  }]);
	
	  return License;
	}(_baseModel2.default);
	
	var licenseSchema = {
	  licenseStatus: {
	    required: {
	      message: 'This field is required'
	    }
	  },
	
	  // if lapsed
	  willingToReinstateLicense: {
	    required: {
	      message: 'This field is required'
	    }
	  },
	
	  // if not lapsed
	  state: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  licenseTypeId: {},
	  renewalDate: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = License;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.skillsSchema = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _baseModel = __webpack_require__(54);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkillsSummary = function (_BaseModel) {
	  _inherits(SkillsSummary, _BaseModel);
	
	  function SkillsSummary() {
	    var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : skillsSchema;
	
	    _classCallCheck(this, SkillsSummary);
	
	    return _possibleConstructorReturn(this, (SkillsSummary.__proto__ || Object.getPrototypeOf(SkillsSummary)).call(this, schema));
	  }
	
	  _createClass(SkillsSummary, null, [{
	    key: 'getSchema',
	    value: function getSchema() {
	      return skillsSchema;
	    }
	  }]);
	
	  return SkillsSummary;
	}(_baseModel2.default);
	
	var skillsSchema = exports.skillsSchema = {
	  lastUsed: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  yearsOfExperience: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  skillLevel: {
	    required: {
	      message: 'This field is required.'
	    }
	  }
	};
	
	module.exports = SkillsSummary;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Favicon = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Common', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Favicon, _Component);
	
	  function Favicon() {
	    _classCallCheck(this, Favicon);
	
	    return _possibleConstructorReturn(this, (Favicon.__proto__ || Object.getPrototypeOf(Favicon)).apply(this, arguments));
	  }
	
	  _createClass(Favicon, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.favicon = document.createElement('link');
	      this.favicon.rel = 'icon';
	      this.favicon.type = 'image/png';
	      this.favicon.href = this.props.labels.favicon;
	      document.head.appendChild(this.favicon);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.favicon.href = this.props.labels.favicon;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Favicon;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = Favicon;

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = combineHooks;
	
	function hooksWrapper(hooks) {
	  var next = hooks.shift();
	  return function (nextState, replace, done) {
	    if (!next) {
	      return done();
	    }
	
	    return next(nextState, replace, function (err) {
	      if (typeof err === 'boolean' && !err) {
	        return done(); // Cancel hook chain if any.
	      } else if (typeof err !== 'boolean' && err) {
	        return done(err); // If hook callsback with error, do not run next
	      }
	
	      return hooksWrapper(hooks)(nextState, replace, done);
	    });
	  };
	}
	
	function combineHooks() {
	  var hooks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (!hooks || !(hooks instanceof Array)) {
	    throw new Error('hooks must be array of functions.');
	  }
	
	  if (hooks.length === 1) {
	    return hooks[0];
	  }
	
	  return hooksWrapper(hooks);
	}

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OnEnterLoadAdminContacts;
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function OnEnterLoadAdminContacts(store) {
	  return function (nextState, replace, done) {
	    var state = store.getState();
	
	    return Promise.resolve(store.dispatch(asyncActionCreator.searchContacts([]))).then(function () {
	      return done();
	    }).catch(function (err) {
	      return done(err || new Error('An error occurred in OnEnterLoadAdminContacts.'));
	    });
	  };
	}

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OnEnterLoadApplicantProfile;
	
	var _lodash = __webpack_require__(4);
	
	var _async = __webpack_require__(37);
	
	function OnEnterLoadApplicantProfile(store) {
	  return function (nextState, replace, done) {
	    var _store$getState = store.getState(),
	        user = _store$getState.user;
	
	    var roles = (0, _lodash.get)(user, 'roles', []);
	    var impersontationId = (0, _lodash.get)(user, 'impersonateUser.profileId');
	    var applicantId = (0, _lodash.get)(user, 'profileId');
	    if (roles.includes('Applicant')) {
	      store.dispatch((0, _async.loadApplicantProfileInfo)(applicantId)).then(function () {
	        return store.dispatch((0, _async.loadRestofApplicantProfileInfo)(applicantId));
	      });
	    } else {
	      store.dispatch((0, _async.loadApplicantProfileInfo)(impersontationId)).then(function () {
	        return store.dispatch((0, _async.loadRestofApplicantProfileInfo)(impersontationId));
	      });
	    }
	
	    done();
	  };
	}

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OnEnterLoadApplicationData;
	
	var _loadStaticData = __webpack_require__(1178);
	
	var _setBrowserData = __webpack_require__(1179);
	
	var _setBrowserData2 = _interopRequireDefault(_setBrowserData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OnEnterLoadApplicationData(store) {
	  return function (nextState, replace, done) {
	    (0, _loadStaticData.loadStaticData)(store).then(function () {
	      return (0, _loadStaticData.loadLabelData)(store);
	    }).then(function () {
	      return (0, _setBrowserData2.default)(store);
	    }).then(function () {
	      done();
	    }).catch(done);
	  };
	}

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OnEnterLoadIdentity;
	
	var _refreshCurrentUser = __webpack_require__(484);
	
	var _refreshCurrentUser2 = _interopRequireDefault(_refreshCurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OnEnterLoadIdentity(store) {
	  return function (nextState, replace, done) {
	    (0, _refreshCurrentUser.isUserAuthenticated)(store).catch(function () {
	      return (0, _refreshCurrentUser2.default)(store);
	    }).catch(function (err) {
	      return console.warn(err.body, ' User not authenticated.');
	    }).then(function () {
	      return done();
	    });
	  };
	};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OnEnterLoadImpersonation;
	
	var _lodash = __webpack_require__(4);
	
	var _impersonation = __webpack_require__(316);
	
	var _impersonation2 = __webpack_require__(1128);
	
	function OnEnterLoadImpersonation(store) {
	  return function (nextState, replace, done) {
	    var state = store.getState();
	    if ((!!~state.user.roles.indexOf('Admin') || !!~state.user.roles.indexOf('Qualifying Specialist') || !!~state.user.roles.indexOf('Support Assistant') || !!~state.user.roles.indexOf('Reference Specialist') || !!~state.user.roles.indexOf('Placement Specialist')) && (0, _lodash.isEmpty)(state.user.impersonateUser)) {
	      store.dispatch((0, _impersonation.getImpersonation)(function (err, impersonateUser) {
	        if (err || !impersonateUser) {
	          return done();
	        }
	        store.dispatch((0, _impersonation2.updateImpersonateUser)({ impersonateUser: impersonateUser }));
	        return done();
	      }));
	    } else {
	      done();
	    }
	  };
	}

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = OnEnterLoadJobRequest;
	
	var _lodash = __webpack_require__(4);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreator = _interopRequireWildcard(_sync);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequestDocuments = __webpack_require__(236);
	
	var jobRequestDocumentsApi = _interopRequireWildcard(_jobrequestDocuments);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _jobrequestDocuments2 = __webpack_require__(318);
	
	var jobRequestDocumentsStore = _interopRequireWildcard(_jobrequestDocuments2);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function OnEnterLoadJobRequest(store, isAdmin) {
	  return function (nextState, replace, done) {
	    var state = store.getState();
	
	    var action = void 0;
	    if (nextState.location.query.hasOwnProperty('clone')) {
	      action = 'clone';
	    } else if (nextState.params.jobId) {
	      action = 'edit';
	    } else {
	      action = 'create';
	    }
	
	    if (action === 'edit') {
	
	      var profileId = (0, _lodash.get)(state, 'user.profileId');
	      var companyId = (0, _lodash.get)(state, 'user.companyId');
	      var jobId = nextState.params.jobId;
	
	      var promises = [];
	
	      if (isAdmin) {
	        promises.push(store.dispatch(jobRequestApi.getJobRequestById(nextState.params.jobId)));
	        promises.push(store.dispatch(jobRequestDocumentsApi.getJobRequestDocuments(profileId, jobId)));
	        promises.push(store.dispatch(asyncActionCreator.searchContacts([])));
	      } else {
	        promises.push(store.dispatch(jobRequestApi.getJobRequest(profileId, nextState.params.jobId)));
	        promises.push(store.dispatch(jobRequestDocumentsApi.getJobRequestDocuments(profileId, jobId)));
	        promises.push(store.dispatch(companyApi.getCompanyContacts(companyId)));
	      }
	
	      return Promise.all(promises).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 3),
	            JobRequests = _ref2[0],
	            documents = _ref2[1],
	            contacts = _ref2[2];
	
	        if (JobRequests[0].id) {
	          store.dispatch(jobRequestStore.createJobRequest(JobRequests[0]));
	        }
	
	        if (documents) {
	          store.dispatch(jobRequestDocumentsStore.createJobRequestDocuments(documents));
	        }
	
	        if (isAdmin) {
	
	          if (contacts) {
	            store.dispatch(syncActionCreator.updateContactsList(contacts));
	          }
	
	          return store.dispatch(companyApi.getCompanyContacts(JobRequests[0].companyId)).then(function (companyContacts) {
	            return store.dispatch(companyStore.updateCompanyContacts((0, _lodash.get)(companyContacts, 'body.data.items', [])));
	          }).then(function () {
	            return done();
	          });
	        } else {
	          if (contacts && !isAdmin) {
	            var companyContacts = (0, _lodash.get)(contacts, 'body.data.items', []);
	            store.dispatch(companyStore.updateCompanyContacts(companyContacts));
	          }
	
	          return done();
	        }
	
	        return done();
	      }).catch(function (err) {
	        return done(err || new Error('An error occurred in OnEnterLoadJobRequestHistory.'));
	      });
	    } else if (action === 'clone') {
	
	      return done();
	    } else if (action === 'create') {
	
	      store.dispatch(jobRequestStore.resetJobRequest());
	      store.dispatch(jobRequestDocumentsStore.resetJobRequestDocuments());
	
	      return done();
	    }
	
	    done();
	  };
	}

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OnEnterLoadPins;
	
	var _lodash = __webpack_require__(4);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreator = _interopRequireWildcard(_sync);
	
	var _employees = __webpack_require__(62);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function OnEnterLoadPins(store) {
	  return function (nextState, replace, done) {
	    var state = store.getState();
	
	    store.dispatch((0, _employees.getPins)(function (err, pins) {
	      if (!err) {
	        store.dispatch(syncActions.loadPins(pins));
	      }
	    }));
	
	    done();
	  };
	}

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = OnEnterLoadPublicJobRequest;
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function OnEnterLoadPublicJobRequest(store) {
	  return function (nextState, replace, done) {
	    var state = store.getState();
	
	    var hash = nextState.params.hash;
	    var jobId = nextState.params.jobId;
	
	    return Promise.resolve(store.dispatch(jobRequestApi.getPublicJobRequest(jobId, hash))).then(function (jobs) {
	      store.dispatch(jobRequestStore.updateJobRequest(_extends({}, jobs[0])));
	      return done();
	    }).catch(function (err) {
	      return done(err || new Error('An error occurred in OnEnterLoadJobRequestHistory.'));
	    });
	
	    return done();
	  };
	}

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OnEnterRedirectUnauthorized;
	exports.OnEnterAllowEmployees = OnEnterAllowEmployees;
	exports.OnEnterAllowClients = OnEnterAllowClients;
	
	var _refreshCurrentUser = __webpack_require__(484);
	
	function OnEnterRedirectUnauthorized(store, allowed) {
	  return function (nextState, replace, done) {
	    (0, _refreshCurrentUser.isUserAuthenticated)(store).then(function () {
	      if (!allowed || allowed.length === 0) {
	        return done();
	      }
	
	      return (0, _refreshCurrentUser.hasRoles)(store, allowed).then(function () {
	        return done();
	      });
	    }).catch(function () {
	      replace('/');
	      done(false); // Cancel subsequent hooks if any.
	    });
	  };
	}
	
	function OnEnterAllowEmployees(store) {
	  return OnEnterRedirectUnauthorized(store, ['Employee']);
	}
	
	function OnEnterAllowClients(store) {
	  return OnEnterRedirectUnauthorized(store, ['Client']);
	}

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _InfoIcon = __webpack_require__(204);
	
	var _InfoIcon2 = _interopRequireDefault(_InfoIcon);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestAlert = (_temp = _class = function (_Component) {
	  _inherits(JobRequestAlert, _Component);
	
	  function JobRequestAlert() {
	    _classCallCheck(this, JobRequestAlert);
	
	    return _possibleConstructorReturn(this, (JobRequestAlert.__proto__ || Object.getPrototypeOf(JobRequestAlert)).apply(this, arguments));
	  }
	
	  _createClass(JobRequestAlert, [{
	    key: 'go',
	    value: function go(path) {
	      var _this2 = this;
	
	      return function (e) {
	        _this2.props.dispatch((0, _reactRouterRedux.push)(path));
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var alert = this.props.alert;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-alert ' + (this.props.selected === alert.id ? '' : 'inactive'), key: alert.id, 'data-id': 'alert-' + alert.id, onClick: function onClick() {
	            return _this3.props.onSelect(alert);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'left-side' },
	          _react2.default.createElement(_InfoIcon2.default, { color: alert.isRead ? '#777777' : '' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'job-request-alert-message' },
	            alert.alertData.prefixMessage,
	            '\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'notification-link', onClick: this.go('/admin/contacts/' + alert.alertData.target + '/details') },
	              alert.alertData.name
	            ),
	            ',\xA0',
	            alert.alertData.title,
	            ', ',
	            _react2.default.createElement(
	              'span',
	              { className: 'notification-link', onClick: this.go('/admin/companies/' + alert.alertData.companyId + '/details') },
	              alert.alertData.companyName
	            ),
	            alert.alertData.companyStatus === 4 && alert.alertData.suffixMessageActiveAccount,
	            (alert.alertData.companyStatus === 1 || alert.alertData.companyStatus === 2) && alert.alertData.suffixMessageProspect
	          )
	        ),
	        _react2.default.createElement(_CloseX2.default, { className: 'dismiss-button', onClick: function onClick(e) {
	            return _this3.props.onClose(e, alert.id);
	          } })
	      );
	    }
	  }]);
	
	  return JobRequestAlert;
	}(_react.Component), _class.propTypes = {
	  onSelect: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  alert: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func.isRequired,
	  selected: _react.PropTypes.bool
	}, _temp);
	exports.default = JobRequestAlert;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _phoneify = __webpack_require__(279);
	
	var _phoneify2 = _interopRequireDefault(_phoneify);
	
	var _staticData = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestAlertDetail = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  return {
	    user: store.user,
	    staticData: store.staticData
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(JobRequestAlertDetail, _Component);
	
	  function JobRequestAlertDetail() {
	    _classCallCheck(this, JobRequestAlertDetail);
	
	    return _possibleConstructorReturn(this, (JobRequestAlertDetail.__proto__ || Object.getPrototypeOf(JobRequestAlertDetail)).apply(this, arguments));
	  }
	
	  _createClass(JobRequestAlertDetail, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          detail = _props.detail,
	          staticData = _props.staticData;
	
	
	      return _react2.default.createElement(
	        'div',
	        { clasName: 'job-request-alert-detail' },
	        _react2.default.createElement(
	          'div',
	          { className: 'alert-contact-info' },
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-action' },
	            'A new Job Request was submitted by:'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'alert-additional-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'notification-link',
	              'data-id': 'selected-name',
	              onClick: function onClick(e) {
	                return _this2.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + detail.profile.id + '/details'));
	              } },
	            detail.user.firstName,
	            ' ',
	            detail.user.lastName
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-title' },
	            detail.profile.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-company-name' },
	            detail.company.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-phone' },
	            detail.user.phoneNumber1 && (0, _phoneify2.default)(detail.user.phoneNumber1).countryCodeRemoved.addTrailingSlashes
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-email' },
	            detail.user.email
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-position-title' },
	            (0, _staticData.lookup)(staticData, 'positionTypes', detail.positionTypeId)
	          )
	        )
	      );
	    }
	  }]);
	
	  return JobRequestAlertDetail;
	}(_react.Component), _class2.propTypes = {
	  user: _react.PropTypes.object.isRequired,
	  detail: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = JobRequestAlertDetail;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _phoneify = __webpack_require__(279);
	
	var _phoneify2 = _interopRequireDefault(_phoneify);
	
	var _InfoIcon = __webpack_require__(204);
	
	var _InfoIcon2 = _interopRequireDefault(_InfoIcon);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserAlert = (_temp = _class = function (_Component) {
	  _inherits(UserAlert, _Component);
	
	  function UserAlert() {
	    _classCallCheck(this, UserAlert);
	
	    return _possibleConstructorReturn(this, (UserAlert.__proto__ || Object.getPrototypeOf(UserAlert)).apply(this, arguments));
	  }
	
	  _createClass(UserAlert, [{
	    key: 'navigateAlert',
	    value: function navigateAlert(alert, target) {
	      var path = '/admin';
	      if (target == 'user') {
	        path = path + ('/' + (alert.alertData.location || alert.alertData.locationName) + '/' + alert.alertData.target + '/details');
	      } else if (target == 'location') {
	        path = path + ('/' + (alert.alertData.location || alert.alertData.locationName));
	      }
	
	      this.props.dispatch((0, _reactRouterRedux.push)(path));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var alert = this.props.alert;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'user-alert ' + (this.props.selected == alert.id ? '' : 'inactive'), key: alert.id, 'data-id': 'alert-' + alert.id, onClick: function onClick() {
	            return _this2.props.onSelect(alert);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'left-side' },
	          _react2.default.createElement(_InfoIcon2.default, { color: alert.isRead ? '#777777' : '' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'user-alert-message' },
	            _react2.default.createElement(
	              'span',
	              { className: 'notification-link', onClick: function onClick(event) {
	                  return _this2.navigateAlert(alert, 'user');
	                } },
	              alert.alertData.name
	            ),
	            '\xA0',
	            alert.alertData.actionLong || alert.alertData.action,
	            '\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'notification-link', onClick: function onClick(event) {
	                  return _this2.navigateAlert(alert, 'location');
	                } },
	              alert.alertData.locationName ? alert.alertData.locationName : alert.alertData.location || ''
	            )
	          )
	        ),
	        _react2.default.createElement(_CloseX2.default, { className: 'dismiss-button', onClick: function onClick(e) {
	            return _this2.props.onClose(e, alert.id);
	          } })
	      );
	    }
	  }]);
	
	  return UserAlert;
	}(_react.Component), _class.propTypes = {
	  onSelect: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  alert: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func.isRequired,
	  selected: _react.PropTypes.number
	}, _temp);
	exports.default = UserAlert;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _phoneify = __webpack_require__(279);
	
	var _phoneify2 = _interopRequireDefault(_phoneify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserAlertDetail = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  return {
	    user: store.user,
	    staticData: store.staticData
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(UserAlertDetail, _Component);
	
	  function UserAlertDetail() {
	    _classCallCheck(this, UserAlertDetail);
	
	    return _possibleConstructorReturn(this, (UserAlertDetail.__proto__ || Object.getPrototypeOf(UserAlertDetail)).apply(this, arguments));
	  }
	
	  _createClass(UserAlertDetail, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var detail = this.props.detail;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'user-alert-detail' },
	        _react2.default.createElement(
	          'div',
	          { className: 'alert-contact-info' },
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-status' },
	            (0, _lodash.find)(this.props.staticData.contactStatus, function (status) {
	              return status.id == detail.profile.contactStatus;
	            }).name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'notification-link',
	              'data-id': 'selected-name',
	              onClick: function onClick(e) {
	                return _this2.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + detail.profile.id + '/details'));
	              } },
	            detail.user.firstName,
	            ' ',
	            detail.user.lastName
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-company-name' },
	            detail.company.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-phone' },
	            detail.user.phoneNumber1 && (0, _phoneify2.default)(detail.user.phoneNumber1).countryCodeRemoved.addTrailingSlashes
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-email' },
	            detail.user.email
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'alert-additional-info' },
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-offices' },
	            detail.company.numberOfOffices,
	            ' Offices'
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-parent' },
	            detail.company.parentCompany
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-types' },
	            detail.company.industryTypes.map(function (v) {
	              return (0, _lodash.find)(_this2.props.staticData.industryTypesList, function (i) {
	                return i.value == v;
	              }).name;
	            }).join(', ')
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'selected-inquiry' },
	            'Inquiry Reason:',
	            _react2.default.createElement('br', null),
	            detail.profile.initialInquiry
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserAlertDetail;
	}(_react.Component), _class2.propTypes = {
	  user: _react.PropTypes.object.isRequired,
	  detail: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = UserAlertDetail;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _UserAlert = __webpack_require__(928);
	
	var _UserAlert2 = _interopRequireDefault(_UserAlert);
	
	var _JobRequestAlert = __webpack_require__(926);
	
	var _JobRequestAlert2 = _interopRequireDefault(_JobRequestAlert);
	
	var _UserAlertDetail = __webpack_require__(929);
	
	var _UserAlertDetail2 = _interopRequireDefault(_UserAlertDetail);
	
	var _JobRequestAlertDetail = __webpack_require__(927);
	
	var _JobRequestAlertDetail2 = _interopRequireDefault(_JobRequestAlertDetail);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlertsDashboard = (_dec = (0, _reactRedux.connect)(function (store) {
	  return { user: store.user, alerts: store.alerts, staticData: store.staticData };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AlertsDashboard, _Component);
	
	  function AlertsDashboard(props, context) {
	    _classCallCheck(this, AlertsDashboard);
	
	    var _this = _possibleConstructorReturn(this, (AlertsDashboard.__proto__ || Object.getPrototypeOf(AlertsDashboard)).call(this, props, context));
	
	    _this.state = {
	      selectedData: false,
	      selectedAlert: null
	    };
	
	    _this.dismissNotification = function (event, alertId) {
	      _this.props.dispatch(asyncActionCreator.deleteAlert(alertId, {
	        success: function success() {
	          return _this.loadAlerts();
	        }
	      }));
	      event.stopPropagation();
	    };
	
	    _this.selectUserAlert = _this.selectUserAlert.bind(_this);
	    _this.selectJobRequestAlert = _this.selectJobRequestAlert.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(AlertsDashboard, [{
	    key: 'loadAlerts',
	    value: function loadAlerts() {
	      var _this2 = this;
	
	      // check current alerts
	      this.props.dispatch(asyncActionCreator.getAlerts({
	        success: function success(data) {
	          _this2.props.dispatch((0, _sync.updateAlerts)(data.items));
	        }
	      }));
	    }
	  }, {
	    key: 'selectUserAlert',
	    value: function selectUserAlert(alert) {
	      var _this3 = this;
	
	      this.props.dispatch(contactApi.getContact(alert.alertData.target, function (err, data) {
	        if (!err && data) {
	          _this3.setState({ selectedAlert: alert, selectedData: data.contact });
	        }
	      }));
	
	      this.markAsRead(alert);
	    }
	  }, {
	    key: 'selectJobRequestAlert',
	    value: function selectJobRequestAlert(alert) {
	      var _this4 = this;
	
	      this.props.dispatch(contactApi.getContact(alert.alertData.target, function (err, data) {
	        if (!err && data) {
	          _this4.setState({ selectedAlert: alert, selectedData: data.contact });
	        }
	      }));
	
	      this.markAsRead(alert);
	    }
	  }, {
	    key: 'markAsRead',
	    value: function markAsRead(alert) {
	      var _this5 = this;
	
	      if (!alert.isRead) {
	        // set alert to read state
	        this.props.dispatch(asyncActionCreator.readAlert(alert.id, {
	          success: function success() {
	            return _this5.loadAlerts();
	          }
	        }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      function displayAlertDetailComponent(state) {
	        switch (state.selectedAlert.alertData.type) {
	
	          case 'JobRequestAlert':
	            return _react2.default.createElement(_JobRequestAlertDetail2.default, { detail: state.selectedData });
	
	          case 'UserAlert':
	          default:
	            return _react2.default.createElement(_UserAlertDetail2.default, { detail: state.selectedData });
	
	        }
	      }
	      var alerts = (0, _lodash.orderBy)(this.props.alerts, ['dateCreated'], ['desc']);
	      return _react2.default.createElement(
	        'div',
	        { className: 'alerts-dashboard content-container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'All Notifications & Alerts History'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'alerts-list-detail-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'alerts-list' },
	            Object.keys(alerts).map(function (alertKey) {
	
	              var alert = _this6.props.alerts[alertKey];
	              switch (alert.alertData.type) {
	
	                case 'JobRequestAlert':
	                  return _react2.default.createElement(_JobRequestAlert2.default, {
	                    selected: (0, _lodash.get)(_this6.state, 'selectedAlert.id', null),
	                    dispatch: _this6.props.dispatch,
	                    alert: alert,
	                    onSelect: _this6.selectJobRequestAlert,
	                    onClose: _this6.dismissNotification });
	
	                case 'UserAlert':
	                default:
	                  return _react2.default.createElement(_UserAlert2.default, {
	                    selected: (0, _lodash.get)(_this6.state, 'selectedAlert.id', null),
	                    dispatch: _this6.props.dispatch,
	                    alert: alert,
	                    onSelect: _this6.selectUserAlert,
	                    onClose: _this6.dismissNotification });
	
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'alert-detail' },
	            this.state.selectedData && displayAlertDetailComponent(this.state)
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlertsDashboard;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  alerts: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = AlertsDashboard;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Assessments;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _DeleteIcon = __webpack_require__(301);
	
	var _DeleteIcon2 = _interopRequireDefault(_DeleteIcon);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _c_SourceSimpleFileInput2 = _interopRequireDefault(_c_SourceSimpleFileInput);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ScoreProficiency(props) {
	  var test = props.test,
	      onChange = props.onChange;
	
	
	  var handleChange = function handleChange(event, value) {
	    if (onChange) {
	      onChange(event, test.id, 'result', value);
	    }
	  };
	
	  return _react2.default.createElement(_c_DropDownMenu2.default, {
	    className: 'result',
	    menuItems: ['Not Proficient', 'Proficient', 'Highly Proficient'],
	    value: test.result,
	    onChange: handleChange
	  });
	}
	
	ScoreProficiency.propTypes = {
	  test: _react.PropTypes.object.isRequired,
	  onChange: _react.PropTypes.func
	};
	
	function Score(props) {
	  var test = props.test,
	      onChange = props.onChange;
	
	
	  var rawScoreClass = test.rawScore ? test.rawScore >= test.passingScore ? 'sufficient' : 'insufficient' : '';
	  var handleChange = function handleChange(prop) {
	    return function (event, value) {
	      if (onChange) {
	        onChange(event, test.id, prop, Number.parseInt(value, 10) || null);
	      }
	    };
	  };
	
	  var rawScore = (0, _lodash.isNull)(test.rawScore) ? '' : test.rawScore;
	  var precentile = (0, _lodash.isNull)(test.percentile) ? '' : test.percentile;
	  var percentage = test.totalQuestions ? (test.rawScore || 0) * 100 / test.totalQuestions + ' %' : 'N/A';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'score-container' },
	    _react2.default.createElement(_c_MaskedTextField2.default, {
	      className: 'value ' + rawScoreClass,
	      mask: '999',
	      hideMaskChar: 'true',
	      value: rawScore,
	      onChange: handleChange('rawScore')
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'percentage-container' },
	      _react2.default.createElement(
	        'span',
	        { className: 'prefix' },
	        '('
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'percentage' },
	        '' + percentage
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'suffix' },
	        ')'
	      )
	    ),
	    _react2.default.createElement(_c_MaskedTextField2.default, {
	      className: 'percentile',
	      mask: '999',
	      hideMaskChar: 'true',
	      value: precentile,
	      onChange: handleChange('percentile')
	    })
	  );
	}
	
	Score.propTypes = {
	  test: _react.PropTypes.object.isRequired,
	  onChange: _react.PropTypes.func
	};
	
	function AssessmentScore(props) {
	  var test = props.test,
	      onChange = props.onChange;
	
	
	  if (test.passingScore) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'score-container' },
	      _react2.default.createElement(Score, { test: test, onChange: onChange })
	    );
	  }
	
	  return _react2.default.createElement(ScoreProficiency, { test: test, onChange: onChange });
	}
	
	AssessmentScore.propTypes = {
	  test: _react.PropTypes.object.isRequired,
	  onChange: _react.PropTypes.func
	};
	
	function AssessmentDocumentViewer(props) {
	  var test = props.test,
	      onRemove = props.onRemove;
	
	
	  var handleRemove = function handleRemove() {
	    if (onRemove) {
	      onRemove(test.id, test.clientId);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'attachment-wrapper' },
	    _react2.default.createElement(
	      _IconButton2.default,
	      { onClick: handleRemove, tooltip: 'Delete', tooltipPosition: 'bottom-left', className: 'remove-section', 'data-id': 'remove-section' },
	      _react2.default.createElement(_DeleteIcon2.default, null)
	    ),
	    _react2.default.createElement(
	      _c_SourceSimpleFileInput.RetrievalButton,
	      {
	        accountId: function accountId() {
	          return test.accountId;
	        },
	        className: 'file-get assessment-file',
	        loadingClass: '',
	        notLoadingClass: '',
	        failureClass: '',
	        autoLoad: true,
	        noMessage: true,
	        path: test.storagePath,
	        signingRoute: '/api/s3/get-sign'
	      },
	      _react2.default.createElement(_c_TextField2.default, {
	        disabled: true,
	        value: test.fileName,
	        inputStyle: {
	          textOverflow: 'ellipsis'
	        }
	      })
	    )
	  );
	}
	
	AssessmentDocumentViewer.propTypes = {
	  test: _react.PropTypes.object.isRequired,
	  onRemove: _react.PropTypes.func
	};
	
	function AssessmentDocumentUploader(props) {
	  var test = props.test,
	      onUpload = props.onUpload;
	
	
	  var clientId = _shortid2.default.generate();
	
	  var handleUpload = function handleUpload(err, fileInfo) {
	    if (onUpload) {
	      onUpload(test.id, clientId, fileInfo);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'attachment-wrapper' },
	    _react2.default.createElement(
	      _c_SourceSimpleFileInput2.default,
	      {
	        className: 'file-uploader',
	        noMessage: true,
	        pristineClass: '',
	        loadingClass: '',
	        successClass: '',
	        failureClass: '',
	        accept: ['.pdf', '.doc', '.docx', '.tiff', '.txt', '.JPG', '.JPEG', '.jpg', '.jpeg', '.png'],
	        remoteFolder: 'applicants',
	        signingRoute: '/api/s3/put-sign',
	        maxSize: ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).AWS_FILE_UPLOAD_SIZE,
	        onLoadStart: handleUpload,
	        onS3Load: function onS3Load(err) {
	          err && console.error(err);
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'upload-file' },
	        'Upload File'
	      )
	    )
	  );
	}
	
	AssessmentDocumentUploader.propTypes = {
	  test: _react.PropTypes.object.isRequired,
	  onUpload: _react.PropTypes.func
	};
	
	function AssessmentDocument(props) {
	  var test = props.test,
	      onUpload = props.onUpload,
	      onRemove = props.onRemove;
	
	
	  if (test.documentId) {
	    return _react2.default.createElement(AssessmentDocumentViewer, { test: test, onRemove: onRemove });
	  }
	
	  return _react2.default.createElement(AssessmentDocumentUploader, { test: test, onUpload: onUpload });
	}
	
	AssessmentDocument.propTypes = {
	  test: _react.PropTypes.object.isRequired,
	  document: _react.PropTypes.object,
	  onUpload: _react.PropTypes.func,
	  onRemove: _react.PropTypes.func
	};
	
	var assessmentItemTextStyle = {
	  borderBottom: '1px solid #333',
	  fontSize: '14px',
	  margin: '7px',
	  padding: '10px 0px 10px 0px',
	  width: '100%'
	};
	
	function AssessmentTest(props) {
	  var test = props.test,
	      onChange = props.onChange,
	      onUpload = props.onUpload,
	      onRemove = props.onRemove;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'assessment-item' },
	    _react2.default.createElement(
	      'div',
	      { style: assessmentItemTextStyle },
	      '' + test.name
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'attachment' },
	      _react2.default.createElement(AssessmentDocument, { test: test, document: test, onUpload: onUpload, onRemove: onRemove })
	    ),
	    _react2.default.createElement(AssessmentScore, { test: test, onChange: onChange })
	  );
	}
	
	AssessmentTest.propTypes = {
	  test: _react.PropTypes.object.isRequired,
	  onChange: _react.PropTypes.func,
	  onUpload: _react.PropTypes.func,
	  onRemove: _react.PropTypes.func
	};
	
	function Assessments(props) {
	  var tests = props.tests;
	
	
	  var testData = (0, _lodash.orderBy)(tests, ['typeId', 'name'], ['asc']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'body-wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'assessments-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'assessment-item columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'test-name' },
	          'Assessment'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'attachment' },
	          'File Name'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'score-container' },
	          'Score'
	        )
	      ),
	      testData.map(function (test) {
	        return _react2.default.createElement(AssessmentTest, {
	          key: test.id,
	          test: test,
	          onChange: props.onChange,
	          onUpload: props.onUpload,
	          onRemove: props.onRemove
	        });
	      })
	    )
	  );
	}
	
	Assessments.propTypes = {
	  tests: _react.PropTypes.array.isRequired,
	  onChange: _react.PropTypes.func,
	  onUpload: _react.PropTypes.func,
	  onRemove: _react.PropTypes.func
	};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _Assessments = __webpack_require__(931);
	
	var _Assessments2 = _interopRequireDefault(_Assessments);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _async = __webpack_require__(37);
	
	var _assessments = __webpack_require__(479);
	
	var _documents = __webpack_require__(1120);
	
	var documentApi = _interopRequireWildcard(_documents);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssessmentsContainer = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    documents: store.documents,
	    applicant: store.applicantProfile,
	    staticData: store.staticData
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AssessmentsContainer, _Component);
	
	  function AssessmentsContainer(props) {
	    _classCallCheck(this, AssessmentsContainer);
	
	    var _this = _possibleConstructorReturn(this, (AssessmentsContainer.__proto__ || Object.getPrototypeOf(AssessmentsContainer)).call(this, props));
	
	    _this.handleUpdateAssessmentScore = function (event, testId, score, value) {
	      var state = _this.newState();
	      var testScore = state.tests[testId];
	      if (testScore) {
	        testScore.dirty = true;
	        testScore[score] = value;
	        state.tests[testId] = testScore;
	        _this.setState(state);
	      }
	    };
	
	    _this.handleUploadDocument = function (testId, clientId, fileInfo) {
	      if (testId && clientId && !(0, _lodash.isEmpty)(fileInfo)) {
	        _this.saveDocument((0, _lodash.get)(_this.props, 'applicant.id'), testId, clientId, fileInfo);
	      }
	    };
	
	    _this.handleDeleteDocument = function (testId, clientId) {
	      if (testId && clientId) {
	        _this.deleteDocument((0, _lodash.get)(_this.props, 'applicant.id'), testId, clientId);
	      }
	    };
	
	    _this.handleSaveScores = function () {
	      var _this$newState = _this.newState(),
	          tests = _this$newState.tests;
	
	      if (tests) {
	
	        var dirtyTests = (0, _lodash.filter)(tests, function (test) {
	          return test.dirty;
	        }).map(function (test) {
	          return {
	            applicantId: (0, _lodash.get)(_this.props, 'applicant.id'),
	            testId: test.id,
	            documentId: test.documentId,
	            rawScore: test.rawScore,
	            percentile: test.percentile,
	            result: test.result
	          };
	        });
	        _this.saveAssessments(_this.props.applicant, dirtyTests);
	      }
	    };
	
	    _this.handleCloseScores = function () {
	      if (_this.props.stateToggle) {
	        _this.props.stateToggle('edit', 0);
	      }
	    };
	
	    _this.isFormDirty = function () {
	      var _this$newState2 = _this.newState(),
	          tests = _this$newState2.tests;
	
	      var dirty = (0, _lodash.filter)(tests, function (test) {
	        return !!test.dirty;
	      });
	      return !!(0, _lodash.isEmpty)(dirty);
	    };
	
	    _this.state = {
	      tests: {}
	    };
	    return _this;
	  }
	
	  _createClass(AssessmentsContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!(0, _lodash.isEmpty)(this.props.applicant)) {
	        this.refreshAssessments(this.props.applicant);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.applicant && !(0, _lodash.isEqual)(nextProps.applicant, this.props.applicant)) {
	        this.refreshAssessments(nextProps.applicant);
	      }
	    }
	  }, {
	    key: 'newState',
	    value: function newState() {
	      return Object.assign({}, this.state);
	    }
	  }, {
	    key: 'deleteDocument',
	    value: function deleteDocument(applicantId, testId, clientId) {
	      var _this2 = this;
	
	      var dispatch = this.props.dispatch;
	
	
	      if (applicantId && testId && clientId) {
	        dispatch(documentApi.deleteApplicantDocument(applicantId, clientId, function (err) {
	          if (err) {
	            return console.error(err);
	          }
	
	          _this2.handleUpdateAssessmentScore(null, testId, 'documentId', null);
	        }));
	      }
	    }
	  }, {
	    key: 'saveDocument',
	    value: function saveDocument(applicantId, testId, clientId, fileInfo) {
	      var _this3 = this;
	
	      var dispatch = this.props.dispatch;
	
	      var assessmentDocumentType = this.props.staticData.applicantDocumentFileTypes.find(function (ft) {
	        return ft.name === "Assessment";
	      }).id;
	      if (applicantId && clientId && fileInfo) {
	        var docInfo = {
	          applicantId: applicantId,
	          clientId: clientId,
	          storagePath: fileInfo.nameWithFolder,
	          fileName: fileInfo.name,
	          fileSize: fileInfo.size,
	          fileTypeId: assessmentDocumentType
	        };
	
	        dispatch(documentApi.createApplicantDocument(applicantId, clientId, docInfo, function (err, id) {
	          _this3.handleUpdateAssessmentScore(null, testId, 'documentId', id);
	          _this3.handleUpdateAssessmentScore(null, testId, 'fileName', fileInfo.name);
	        }));
	      }
	    }
	  }, {
	    key: 'saveAssessments',
	    value: function saveAssessments(applicant, assessments) {
	      var _this4 = this;
	
	      var dispatch = this.props.dispatch;
	
	
	      if (applicant && !(0, _lodash.isEmpty)(assessments)) {
	        dispatch((0, _assessments.updateApplicantAssessments)(applicant.id, assessments, function (err) {
	          if (err) {
	            return console.error(err);
	          }
	
	          _this4.handleCloseScores();
	        }));
	      }
	    }
	  }, {
	    key: 'refreshAssessments',
	    value: function refreshAssessments(applicant) {
	      var _this5 = this;
	
	      var dispatch = this.props.dispatch;
	
	
	      if (applicant) {
	        dispatch((0, _async.getApplicantAssessmentTests)((0, _lodash.get)(applicant, 'id'), function (err, assessmentTests) {
	          if (err) {
	            return console.error(err);
	          }
	
	          var tests = (0, _lodash.keyBy)(assessmentTests, 'id');
	          _this5.setState(Object.assign({}, _this5.state, { tests: tests }));
	        }));
	      }
	    }
	  }, {
	    key: 'renderAssessments',
	    value: function renderAssessments(state, props) {
	
	      var tests = (0, _lodash.map)(state.tests, function (test) {
	        return test;
	      });
	      var documents = (0, _lodash.map)(props.documents, function (doc) {
	        return doc;
	      });
	
	      return _react2.default.createElement(_Assessments2.default, {
	        tests: tests,
	        documents: documents,
	        onChange: this.handleUpdateAssessmentScore,
	        onUpload: this.handleUploadDocument,
	        onRemove: this.handleDeleteDocument
	      });
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm(state, props) {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'score-card',
	          key: 'Assessments Card ' + props.applicant.id,
	          style: props.style },
	        _react2.default.createElement(_ModalX2.default, { onClick: this.handleCloseScores }),
	        _react2.default.createElement(
	          'div',
	          { className: 'top-wrapper clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            'Assessment Scores'
	          )
	        ),
	        this.renderAssessments(state, props),
	        _react2.default.createElement(_Button2.default, {
	          label: 'Save',
	          onClick: this.handleSaveScores,
	          disabled: this.isFormDirty(),
	          style: {
	            display: 'inline-block',
	            width: 'auto',
	            paddingLeft: '50px',
	            paddingRight: '50px',
	            marginTop: '50px',
	            float: 'right'
	          } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if ((0, _lodash.isEmpty)(this.state.tests)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'score-card', style: this.props.style },
	          _react2.default.createElement(_ModalX2.default, { onClick: this.handleCloseScores }),
	          _react2.default.createElement(
	            'div',
	            { className: 'top-wrapper clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              'No Assessments Are Available Yet'
	            )
	          )
	        );
	      }
	
	      return this.renderForm(this.state, this.props);
	    }
	  }]);
	
	  return AssessmentsContainer;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  documents: _react.PropTypes.object.isRequired,
	  applicant: _react.PropTypes.object.isRequired,
	  style: _react.PropTypes.object,
	  stateToggle: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = AssessmentsContainer;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _async = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function AssessmentScore(props) {
	  var test = props.test;
	
	  var rawScore = (0, _lodash.isNil)(test.rawScore) ? '' : test.rawScore;
	  var proficiency = (0, _lodash.isNil)(test.result) ? '( N/A )' : test.result;
	  var percentile = (0, _lodash.isNil)(test.percentile) ? '' : test.percentile;
	  var percentage = test.percentage ? '( ' + (test.rawScore || 0) * 100 / (test.totalQuestions || 1) + '% )' : '( N/A )';
	  var rawScoreClass = test.passingScore ? (0, _lodash.isNil)(test.rawScore) || test.rawScore < test.passingScore ? 'notgood' : '' : test.result === 'Not Proficient' ? 'notgood' : (0, _lodash.isNil)(test.result) ? 'na' : '';
	
	  if ((0, _lodash.isNil)(test.passingScore)) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'data' },
	      _react2.default.createElement(
	        'span',
	        { className: 'user ' + rawScoreClass },
	        proficiency
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'data' },
	    _react2.default.createElement(
	      'span',
	      { className: 'user ' + rawScoreClass },
	      rawScore
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'general' },
	      percentage
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'percentage' },
	      percentile
	    )
	  );
	}
	
	AssessmentScore.propTypes = {
	  test: _react.PropTypes.object.isRequired
	};
	
	function AssessmentRow(props) {
	  var test = props.test;
	
	  var minimumRequirement = test.passingScore ? 'Raw score should be ' + test.passingScore + ' and above.' : 'Proficient (14 and above), but a score of 13 might be acceptable.';
	
	  return _react2.default.createElement(
	    'div',
	    { key: test.id, className: 'assessments-skills-evaluation' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      test.name
	    ),
	    _react2.default.createElement(AssessmentScore, { test: test }),
	    _react2.default.createElement(
	      'div',
	      { className: 'required-score' },
	      minimumRequirement
	    )
	  );
	}
	
	AssessmentRow.propTypes = {
	  test: _react.PropTypes.object.isRequired
	};
	
	var AssessmentsTable = (_temp = _class = function (_Component) {
	  _inherits(AssessmentsTable, _Component);
	
	  function AssessmentsTable(props) {
	    _classCallCheck(this, AssessmentsTable);
	
	    var _this = _possibleConstructorReturn(this, (AssessmentsTable.__proto__ || Object.getPrototypeOf(AssessmentsTable)).call(this, props));
	
	    _this.state = {
	      tests: {}
	    };
	    return _this;
	  }
	
	  _createClass(AssessmentsTable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!(0, _lodash.isEmpty)(this.props.applicant)) {
	        this.refreshAssessments(this.props.applicant);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.applicant && !(0, _lodash.isEqual)(nextProps.applicant, this.props.applicant)) {
	        this.refreshAssessments(nextProps.applicant);
	      }
	    }
	  }, {
	    key: 'refreshAssessments',
	    value: function refreshAssessments(applicant) {
	      var _this2 = this;
	
	      var dispatch = this.props.dispatch;
	
	
	      if (applicant) {
	        dispatch((0, _async.getApplicantAssessmentTests)((0, _lodash.get)(applicant, 'profile.id'), function (err, assessmentTests) {
	          if (err) {
	            return console.error(err);
	          }
	
	          var tests = (0, _lodash.keyBy)(assessmentTests, 'id');
	          _this2.setState(Object.assign({}, _this2.state, { tests: tests }));
	        }));
	      }
	    }
	  }, {
	    key: 'renderScript',
	    value: function renderScript(props) {
	
	      if (props.script) {
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          'Now, I would like to review your assessment scores.?'
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var tests = this.state.tests;
	
	
	      var testData = (0, _lodash.orderBy)(tests, ['typeId', 'name'], ['asc']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve' },
	        this.renderScript(this.props),
	        _react2.default.createElement(
	          'div',
	          { className: 'assessments-skills-list' },
	          testData.map(function (test) {
	            return _react2.default.createElement(AssessmentRow, { test: test });
	          })
	        )
	      );
	    }
	  }]);
	
	  return AssessmentsTable;
	}(_react.Component), _class.propTypes = {
	  tests: _react.PropTypes.array.isRequired,
	  applicant: _react.PropTypes.object.isRequired,
	  dispatch: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = AssessmentsTable;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	var _StatusDropDown = __webpack_require__(199);
	
	var _StatusDropDown2 = _interopRequireDefault(_StatusDropDown);
	
	var _staticData = __webpack_require__(28);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyCard = (_dec = (0, _reactRedux.connect)(function (store) {
		return {
			staticData: store.staticData,
			labels: (0, _lodash.get)(store, 'labels.CompanyCard', {})
		};
	}), _dec(_class = (_temp = _class2 = function (_Component) {
		_inherits(CompanyCard, _Component);
	
		function CompanyCard(props, context) {
			_classCallCheck(this, CompanyCard);
	
			var _this = _possibleConstructorReturn(this, (CompanyCard.__proto__ || Object.getPrototypeOf(CompanyCard)).call(this, props, context));
	
			_this.handleStatusChange = function (companyId) {
				return function (event, value) {
					if (value) {
						_this.props.dispatch(companyApi.updateCompanyStatus(companyId, value, function (err, result) {
							if (err || !result) {
								return console.error(err || 'Update failed.');
							}
	
							result.company = (0, _lodash.merge)(_this.props.company, result.company);
	
							_this.props.dispatch(companyStore.updateCompany(result));
						}));
					}
				};
			};
	
			return _this;
		}
	
		_createClass(CompanyCard, [{
			key: 'goToCompanyWorksheet',
			value: function goToCompanyWorksheet() {
				this.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/' + this.props.company.id + '/details'));
			}
		}, {
			key: 'back',
			value: function back() {
				this.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/'));
				this.props.onClose();
			}
		}, {
			key: 'showSelectedValues',
			value: function showSelectedValues(type, ids) {
				var selectedValues = (0, _lodash.reduce)(this.props.staticData[type], function (values, dataObj) {
					if (!values) {
						values = [];
					}
	
					if ((0, _lodash.find)(ids, function (item) {
						return dataObj.id === item || dataObj.value === item;
					})) {
						values.push(dataObj.name || dataObj.primaryText);
					}
					return values;
				}, []);
	
				return (0, _lodash.join)(selectedValues, ', ');
			}
		}, {
			key: 'render',
			value: function render() {
				function getAddress(user, staticData) {
					var addressArr = [];
					if (user.address) addressArr.push(user.address);
					if (user.city) addressArr.push(user.city);
					if (user.state) addressArr.push((0, _staticData.lookup)(staticData, 'stateList', { id: user.state }));
					if (user.zip) addressArr.push(user.zip);
					return addressArr.join(', ');
				}
	
				var sanitize = function sanitize(val) {
					return val || 'N/A';
				};
				var company = (0, _lodash.get)(this.props, 'company', {});
				var currentStatus = (0, _staticData.getLookupValue)(this.props.staticData, 'companyStatus', { id: (0, _lodash.get)(company, 'companyStatus', 0) });
				var timezone = (0, _staticData.lookup)(this.props.staticData, 'timezoneList', { id: company.timezone });
				var relationshipManager = (0, _staticData.getLookupValue)(this.props.staticData, 'relationshipManagers', { id: company.relationshipManagerId });
	
				return _react2.default.createElement(
					'div',
					{ className: 'company-card-preview' },
					_react2.default.createElement(
						'div',
						{ className: 'close wv-pointer', onClick: this.back.bind(this) },
						'CLOSE ',
						_react2.default.createElement(_CloseX2.default, { style: { color: '#fff' } })
					),
					_react2.default.createElement(
						'div',
						{ className: 'name-container' },
						_react2.default.createElement(
							'div',
							{ className: 'company-card-header' },
							_react2.default.createElement(
								'div',
								{ className: 'full-name', 'data-id': 'Full Name' },
								company.name
							),
							_react2.default.createElement(_StatusDropDown2.default, {
								status: currentStatus,
								smallDisplay: true,
								menuItems: this.props.staticData.companyStatus,
								onChange: this.handleStatusChange(company.id)
							})
						),
						_react2.default.createElement(
							'div',
							{ className: 'company-card-content' },
							_react2.default.createElement(
								'div',
								{ className: 'relatios-block' },
								_react2.default.createElement(
									'div',
									null,
									'Relationship Manager:  ',
									(0, _lodash.get)(relationshipManager, 'firstName'),
									' ',
									(0, _lodash.get)(relationshipManager, 'lastName')
								),
								_react2.default.createElement(
									'div',
									null,
									this.props.labels.industry,
									':  ',
									this.showSelectedValues('industryTypesList', (0, _lodash.get)(company, 'industryTypes'))
								),
								_react2.default.createElement(
									'div',
									null,
									getAddress(company, this.props.staticData),
									' '
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'information-block' },
								_react2.default.createElement(
									'div',
									null,
									'Entered: ',
									company.dateCreated ? (0, _moment2.default)(company.dateCreated).format('L') : sanitize(company.dateCreated)
								),
								_react2.default.createElement(
									'div',
									null,
									'Updated: ',
									company.dateModified ? (0, _moment2.default)(company.dateModified).format('L') : sanitize(company.dateModified)
								),
								_react2.default.createElement(
									'div',
									null,
									'Time Zone: ',
									timezone
								),
								_react2.default.createElement(
									'div',
									null,
									'Main Number: ',
									(0, _prettyPhone2.default)(company.phoneNumber)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'navigate-to wv-pointer', 'data-id': 'View Worksheet' },
						_react2.default.createElement(
							'span',
							{ onClick: this.goToCompanyWorksheet.bind(this) },
							'view Worksheet'
						)
					)
				);
			}
		}]);
	
		return CompanyCard;
	}(_react.Component), _class2.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		staticData: _react.PropTypes.object,
		company: _react.PropTypes.object.isRequired,
		onClose: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = CompanyCard;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utility
	
	
	// lib
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _rcPager = __webpack_require__(280);
	
	var _rcPager2 = _interopRequireDefault(_rcPager);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PreviousIcon = __webpack_require__(233);
	
	var _PreviousIcon2 = _interopRequireDefault(_PreviousIcon);
	
	var _NextIcon = __webpack_require__(232);
	
	var _NextIcon2 = _interopRequireDefault(_NextIcon);
	
	var _SimpleDropDownMenu = __webpack_require__(121);
	
	var _SimpleDropDownMenu2 = _interopRequireDefault(_SimpleDropDownMenu);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompaniesTable = (_temp = _class = function (_Component) {
	  _inherits(CompaniesTable, _Component);
	
	  function CompaniesTable(props, context) {
	    _classCallCheck(this, CompaniesTable);
	
	    var _this = _possibleConstructorReturn(this, (CompaniesTable.__proto__ || Object.getPrototypeOf(CompaniesTable)).call(this, props, context));
	
	    _this.showDashboard = function (event, companyId) {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/' + companyId + '/details'));
	    };
	
	    _this.showCard = function (event, companyId) {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/?card=' + companyId));
	    };
	
	    _this.companyStatusList = _lodash2.default.keyBy(_this.props.staticData.companyStatus, 'id');
	    _this.salesPartners = _lodash2.default.keyBy(_this.props.staticData.salesPartners, 'id');
	
	    var initialState = {
	      relationshipManagers: _this.props.staticData.relationshipManagers,
	      clientAdvisers: _this.props.staticData.clientAdvisers
	    };
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(CompaniesTable, [{
	    key: 'flipColumn',
	    value: function flipColumn(column) {
	      var order = this.props.filters.by === column && this.props.filters.order === 'asc' ? 'desc' : 'asc';
	
	      if (this.props.onSortChange) {
	        this.props.onSortChange({ by: column, order: order });
	      }
	    }
	  }, {
	    key: 'generateMenuItems',
	    value: function generateMenuItems(staticData, type, hideAny) {
	      var object = staticData[type];
	
	      var menuItems = _lodash2.default.map(object, function (item) {
	        return {
	          value: item.id || item.value,
	          primaryText: item.name || item.primaryText
	        };
	      });
	
	      if (hideAny) {
	        return menuItems;
	      } else {
	        return _lodash2.default.concat({ value: -1, primaryText: 'All' }, menuItems);
	      }
	    }
	  }, {
	    key: 'handleSkip',
	    value: function handleSkip(currentPage) {
	      if (this.props.onPageChange) this.props.onPageChange(currentPage);
	    }
	  }, {
	    key: 'handleFilterDefaultValues',
	    value: function handleFilterDefaultValues(filterName) {
	      return _lodash2.default.get(this.props.filters, filterName, -1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          companies = _props.companies,
	          staticData = _props.staticData,
	          labels = _props.labels;
	
	
	      var currentCount = this.props.pageSize * (this.props.currentPage + 1);
	      currentCount = currentCount < this.props.total ? currentCount : this.props.total;
	
	      var companiesComponentArr = (0, _lodash2.default)(companies).map(function (row, index) {
	        var status = _this2.companyStatusList[row.companyStatus];
	        var salesPartner = _lodash2.default.get(_this2.salesPartners, row.salesPartner + '.name');
	        var firmTypes = (0, _lodash2.default)(staticData.industryTypesList).reduce(function (prev, curr) {
	          if (row.industryTypes && !!~row.industryTypes.indexOf(curr.id)) {
	            prev.push(curr.name);
	          }
	          return prev;
	        }, []).join(', ');
	        return _react2.default.createElement(
	          _Table.TableRow,
	          { className: 'company-row', key: row.id + '-' + row.name, 'data-id': row.id + '-' + row.name },
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'table-col name' },
	            _react2.default.createElement('div', { className: 'expand-icon', onClick: function onClick(event) {
	                return _this2.showCard(event, row.id);
	              } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'company-name', onClick: function onClick(event) {
	                  return _this2.showDashboard(event, row.id);
	                } },
	              row.name
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'table-col status', style: { width: '250px' } },
	            _react2.default.createElement('div', { className: 'status-circle', 'data-id': 'Status Icon', style: { backgroundColor: status.color, borderColor: status.color } }),
	            status.name
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'table-col phone', style: { width: '250px' } },
	            !!row.phoneNumber && (0, _prettyPhone2.default)(row.phoneNumber)
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'table-col firm-type' },
	            firmTypes
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'table-col sales-partner' },
	            salesPartner
	          )
	        );
	      }).value();
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'applicants-column company-table company-dashboard-table', 'data-id': 'company-list' },
	        _react2.default.createElement(
	          'header',
	          { className: 'header-container' },
	          _react2.default.createElement(_SimpleDropDownMenu2.default, {
	            onChange: this.props.onFilterChange('statuses'),
	            'data-id': 'status-dropdown',
	            floatingLabelText: 'Status',
	            defaultValue: this.handleFilterDefaultValues('statuses'),
	            className: 'dropdown-filter status-dropdown',
	            menuItems: this.generateMenuItems(this.props.staticData, 'companyStatus')
	          }),
	          _react2.default.createElement(_SimpleDropDownMenu2.default, {
	            className: 'industry-types',
	            'data-id': 'Firm Types Filter',
	            floatingLabelText: labels.filterLabels.firmTypesFilter,
	            defaultValue: this.handleFilterDefaultValues('industryTypes'),
	            onChange: this.props.onFilterChange('industryTypes'),
	            menuItems: _lodash2.default.concat({ primaryText: 'All', value: -1 }, this.props.staticData.industryTypesList)
	          }),
	          _react2.default.createElement(_SimpleDropDownMenu2.default, {
	            className: 'relationship-manager',
	            'data-id': 'Relationship Manager Filter',
	            floatingLabelText: 'Relationship Manager',
	            defaultValue: this.handleFilterDefaultValues('relationshipManagerId'),
	            onChange: this.props.onFilterChange('relationshipManagerId'),
	            menuItems: _lodash2.default.concat([{ primaryText: 'All', value: -1 }, { primaryText: 'Unassigned', value: 0 }], this.state.relationshipManagers.map(function (rm) {
	              return _lodash2.default.assign({ primaryText: rm.firstName + ' ' + rm.lastName, value: rm.employeeId });
	            }))
	          }),
	          labels.filters.showState && _react2.default.createElement(_SimpleDropDownMenu2.default, {
	            className: 'state',
	            'data-id': 'State',
	            floatingLabelText: 'State',
	            defaultValue: this.handleFilterDefaultValues('state'),
	            onChange: this.props.onFilterChange('state'),
	            menuItems: _lodash2.default.concat({ primaryText: 'All', value: -1 }, this.props.staticData.stateList)
	          }),
	          labels.filters.showIiaba && _react2.default.createElement(_SimpleDropDownMenu2.default, {
	            className: 'iiaba-state',
	            'data-id': 'IIABA State',
	            floatingLabelText: 'IIABA State',
	            defaultValue: this.handleFilterDefaultValues('iiabaState'),
	            onChange: this.props.onFilterChange('iiabaState'),
	            menuItems: _lodash2.default.concat({ primaryText: 'All', value: -1 }, this.props.staticData.iiabaStates.map(function (state) {
	              return _lodash2.default.assign({ primaryText: state.name, value: state.id });
	            }))
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pager-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pager-info' },
	            'Showing ',
	            _react2.default.createElement(
	              'span',
	              { className: 'count' },
	              currentCount
	            ),
	            ' of ',
	            _react2.default.createElement(
	              'span',
	              { className: 'count' },
	              this.props.total
	            )
	          ),
	          _react2.default.createElement(_rcPager2.default, {
	            total: Math.ceil(this.props.total / this.props.pageSize),
	            current: this.props.currentPage,
	            onSkipTo: this.handleSkip.bind(this),
	            previousLabel: _react2.default.createElement(
	              'div',
	              { className: 'prev' },
	              _react2.default.createElement(_PreviousIcon2.default, null),
	              ' PREV'
	            ),
	            nextLabel: _react2.default.createElement(
	              'div',
	              { className: 'next' },
	              'NEXT ',
	              _react2.default.createElement(_NextIcon2.default, null)
	            )
	          })
	        ),
	        _react2.default.createElement(
	          _Table.Table,
	          {
	            selectable: false,
	            multiSelectable: false,
	            className: 'table-companies',
	            fixedHeader: true,
	            height: 'calc(100vh - 223px)' // It will not work if moves to CSS.
	          },
	          _react2.default.createElement(
	            _Table.TableHeader,
	            {
	              displaySelectAll: false,
	              adjustForCheckbox: false
	            },
	            _react2.default.createElement(
	              _Table.TableRow,
	              null,
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'table-col name' },
	                'Company Name'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'table-col status', style: { width: '250px' } },
	                'Status'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'table-col phone', style: { width: '250px' } },
	                'Phone #'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'table-col firm-type' },
	                labels.tableRowHeaders.firmType
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'table-col sales-partner' },
	                _react2.default.createElement(
	                  'div',
	                  { onClick: function onClick(e) {
	                      return _this2.flipColumn('salesPartner');
	                    } },
	                  'Sales Partner',
	                  _react2.default.createElement(
	                    'span',
	                    { className: (0, _classnames2.default)('wv-chevron', { active: this.props.filters && this.props.filters.by === 'salesPartner' }, { flipped: this.props.filters && this.props.filters.by === 'salesPartner' && this.props.filters.order !== 'desc' }) },
	                    _react2.default.createElement(_ChevronIcon2.default, null)
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableBody,
	            {
	              displayRowCheckbox: false
	            },
	            companiesComponentArr
	          )
	        )
	      );
	    }
	  }]);
	
	  return CompaniesTable;
	}(_react.Component), _class.propTypes = {
	  companies: _react.PropTypes.object,
	  total: _react.PropTypes.any,
	  staticData: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  onPageChange: _react.PropTypes.func,
	  onFilterChange: _react.PropTypes.func,
	  onSortChange: _react.PropTypes.func,
	  filters: _react.PropTypes.object,
	  currentPage: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number,
	  labels: _react.PropTypes.object
	}, _temp);
	exports.default = CompaniesTable;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// redux interactions
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _index = __webpack_require__(21);
	
	var adminStore = _interopRequireWildcard(_index);
	
	var _Search = __webpack_require__(165);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _CompaniesTable = __webpack_require__(935);
	
	var _CompaniesTable2 = _interopRequireDefault(_CompaniesTable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyManager = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    staticData: state.staticData,
	    companies: state.admin.companies.items,
	    total: state.admin.companies.total,
	    filters: state.admin.companies.filters || {},
	    searchTerms: state.admin.companies.searchTerms || [],
	    labels: _lodash2.default.get(state, 'labels.CompanyDashboard', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CompanyManager, _Component);
	
	  function CompanyManager(props) {
	    _classCallCheck(this, CompanyManager);
	
	    var _this = _possibleConstructorReturn(this, (CompanyManager.__proto__ || Object.getPrototypeOf(CompanyManager)).call(this, props));
	
	    _this.state = {
	      currentPage: 0,
	      pageSize: 25
	    };
	    return _this;
	  }
	
	  _createClass(CompanyManager, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.searchCompanies(this.props.searchTerms, this.props.filters);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!_lodash2.default.isEqual(prevProps.filters, this.props.filters) || !_lodash2.default.isEqual(prevProps.searchTerms, this.props.searchTerms)) {
	        this.onPageChange(this.state.currentPage);
	      }
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(page) {
	      var skip = page * this.state.pageSize;
	      var terms = this.props.searchTerms || [];
	      var filters = this.props.filters || {};
	
	      this.props.dispatch(companyApi.goToPage(skip, this.state.pageSize, terms, filters));
	      this.setState({ currentPage: page });
	    }
	  }, {
	    key: 'onTermChange',
	    value: function onTermChange() {
	      var _this2 = this;
	
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      this.setState({ currentPage: 0 }, function () {
	        return _this2.props.dispatch(adminStore.updateCompaniesTableSearchTerms(terms));
	      });
	    }
	  }, {
	    key: 'onFilterChange',
	    value: function onFilterChange(filterName) {
	      var _this3 = this;
	
	      return function (event, key) {
	
	        // get current filters
	        var newFilters = _lodash2.default.cloneDeep(_this3.props.filters) || {};
	
	        // set new filters
	        if (key < 0) {
	          newFilters = _lodash2.default.omit(newFilters, filterName);
	        } else {
	          _lodash2.default.set(newFilters, filterName, key || _lodash2.default.get(event, 'target.value') || 0);
	        }
	
	        // dispatch action to update filters in companies store
	        _this3.setState({ currentPage: 0 }, function () {
	          return _this3.props.dispatch(adminStore.updateCompaniesTableFilters(newFilters));
	        });
	      };
	    }
	  }, {
	    key: 'onSortChange',
	    value: function onSortChange(newSortFilters) {
	      var newFilters = _lodash2.default.cloneDeep(this.props.filters) || {};
	      var sortFilters = _lodash2.default.merge({}, newFilters, newSortFilters);
	      this.props.dispatch(adminStore.updateCompaniesTableFilters(sortFilters));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'ul',
	        { className: 'applicant-manager columns-container companies-dasboard-manager' },
	        _react2.default.createElement(
	          'div',
	          { className: 'companies-table-header' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'title' },
	            'Companies'
	          ),
	          _react2.default.createElement(_Search2.default, {
	            onTermChange: this.onTermChange.bind(this),
	            baseUrl: '/admin/companies',
	            defaultValues: this.props.searchTerms
	          })
	        ),
	        _react2.default.createElement(_CompaniesTable2.default, {
	          staticData: this.props.staticData,
	          companies: this.props.companies,
	          dispatch: this.props.dispatch,
	          total: this.props.total,
	          currentPage: this.state.currentPage,
	          pageSize: this.state.pageSize,
	          onPageChange: this.onPageChange.bind(this),
	          onFilterChange: this.onFilterChange.bind(this),
	          onSortChange: this.onSortChange.bind(this),
	          filters: this.props.filters,
	          labels: this.props.labels.companyTable
	        })
	      );
	    }
	  }]);
	
	  return CompanyManager;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  companies: _react.PropTypes.any,
	  total: _react.PropTypes.any,
	  staticData: _react.PropTypes.object,
	  searchCompanies: _react.PropTypes.func,
	  filters: _react.PropTypes.object,
	  searchTerms: _react.PropTypes.array,
	  labels: _react.PropTypes.object
	}, _class2.defaultProps = {
	  companies: {}
	}, _temp)) || _class);
	exports.default = CompanyManager;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// redux interactions
	
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _staticData = __webpack_require__(28);
	
	var _CompanyManager = __webpack_require__(936);
	
	var _CompanyManager2 = _interopRequireDefault(_CompanyManager);
	
	var _cardModal = __webpack_require__(870);
	
	var _cardModal2 = _interopRequireDefault(_cardModal);
	
	var _Card = __webpack_require__(934);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompaniesDashboard = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  return {
	    user: store.user,
	    staticData: store.staticData,
	    status: (0, _staticData.statusGroupOrDefault)(props.params.navColumnState, store.user.companyStatusList),
	    companyStatusList: (store.user.companyStatusList || []).slice().sort(function (objA, objB) {
	      return objA - objB;
	    }),
	    companiesLoaded: (0, _lodash.get)(store.admin.companies, 'items', []),
	    contacts: (0, _lodash.get)(store.admin.contacts, 'items', []),
	    companies: store.admin.companies,
	    route: {
	      params: props.params,
	      query: props.location.query // actually being from from react-redux-router to regular props
	    } };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CompaniesDashboard, _Component);
	
	  function CompaniesDashboard(props, context) {
	    _classCallCheck(this, CompaniesDashboard);
	
	    var _this = _possibleConstructorReturn(this, (CompaniesDashboard.__proto__ || Object.getPrototypeOf(CompaniesDashboard)).call(this, props, context));
	
	    _this.state = {
	      selectedCompany: null,
	      statusDropdown: {
	        list: _this.props.staticData.companyStatus,
	        value: 0
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CompaniesDashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.props.dispatch(asyncActionCreator.searchCompanies(this.props.route.query.search || []));
	
	      // load contacts in case they're not in yet
	      if (!this.props.contacts) {
	        this.props.dispatch(asyncActionCreator.searchContacts(this.props.route.query.search || []));
	      }
	
	      //if we have company in url params - need load it for card information
	      if ((0, _lodash.get)(this.props, 'route.query.card', false)) {
	        this.props.dispatch(asyncActionCreator.getCompanyById(this.props.route.query.card, {
	          success: function success(data) {
	            _this2.setState((0, _lodash.merge)({}, _this2.state, {
	              selectedCompany: data.items[0],
	              statusDropdown: { value: data.items[0].companyStatus }
	            }));
	            cb();
	          },
	          error: function error(err) {
	            console.log('error update store', err);
	            return cb(err);
	          }
	        }));
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var _this3 = this;
	
	      if (nextProps.route.query.card && nextProps.route.query.card !== this.props.route.query.card) {
	        this.props.dispatch(asyncActionCreator.getCompanyById(nextProps.route.query.card, {
	          success: function success(data) {
	            _this3.setState((0, _lodash.merge)({}, _this3.state, {
	              selectedCompany: data.items[0],
	              statusDropdown: { value: data.items[0].companyStatus }
	            }));
	            cb();
	          },
	          error: function error(err) {
	            console.log('error update store', err);
	            return cb(err);
	          }
	        }));
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(value) {
	      this.setState((0, _lodash.merge)({}, this.state, {
	        statusDropdown: { value: value }
	      }));
	    }
	  }, {
	    key: 'searchCompanies',
	    value: function searchCompanies() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.props.dispatch(asyncActionCreator.searchCompanies(terms, filters));
	    }
	  }, {
	    key: 'closeCompanyCard',
	    value: function closeCompanyCard() {
	      this.setState((0, _lodash.merge)({}, this.state, {
	        selectedCompany: null
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-content-container companies-dashboard clearfix' },
	        this.state.selectedCompany ? _react2.default.createElement(
	          _cardModal2.default,
	          {
	            statusDropdown: this.state.statusDropdown,
	            onChange: this.onChange.bind(this)
	          },
	          _react2.default.createElement(_Card2.default, {
	            company: this.state.selectedCompany,
	            dispatch: this.props.dispatch,
	            route: this.props.route,
	            onClose: this.closeCompanyCard.bind(this)
	          })
	        ) : null,
	        _react2.default.createElement(_CompanyManager2.default, {
	          navColumnState: this.props.status,
	          searchCompanies: this.searchCompanies.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return CompaniesDashboard;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  route: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  query: _react.PropTypes.object,
	  params: _react.PropTypes.object, // comes from react-redux-router
	  user: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = CompaniesDashboard;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint-disable no-unused-vars,no-console,no-else-return,object-shorthand */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _employees = __webpack_require__(62);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _contacts = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts2);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _lodash = __webpack_require__(4);
	
	var _ui = __webpack_require__(26);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TransferItemOwnershipIcon = __webpack_require__(460);
	
	var _TransferItemOwnershipIcon2 = _interopRequireDefault(_TransferItemOwnershipIcon);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MODES = {
	  loading: 0,
	  ready: 1
	};
	
	var ContactTransferOwnership = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    pinnedContacts: state.pins.contacts
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ContactTransferOwnership, _Component);
	
	  function ContactTransferOwnership(props, context) {
	    _classCallCheck(this, ContactTransferOwnership);
	
	    var _this = _possibleConstructorReturn(this, (ContactTransferOwnership.__proto__ || Object.getPrototypeOf(ContactTransferOwnership)).call(this, props, context));
	
	    _this.handleClose = function (event) {
	
	      // Close Dialog
	      _this.props.onClose && _this.props.onClose(event);
	    };
	
	    _this.handleConfirmTransfer = function (row) {
	      _this.setState({ showTransitionBlocker: true, rowToMove: row });
	    };
	
	    _this.handleTransferContact = function () {
	
	      // update contact with company id (this.props.company.id)
	      var contactToUpdate = _this.state.rowToMove;
	
	      contactToUpdate.company = { id: _this.props.company.id, companyStatus: _this.props.company.companyStatus };
	      contactToUpdate.profile.companyId = _this.props.company.id;
	
	      _this.props.dispatch(contactApi.updateContactOwner(contactToUpdate, function (err, updatedContact) {
	        if (err || !updatedContact) {
	          return console.error(err || 'Update failed.');
	        }
	
	        _this.props.dispatch(contactStore.updateProfile(updatedContact));
	        _this.props.dispatch((0, _ui.showSnackBar)('Transferred ownership of ContactId: ' + contactToUpdate.profile.id + ' to CompanyId: ' + contactToUpdate.profile.companyId));
	
	        _this.setState({
	          viewMode: MODES.loading
	        });
	
	        // update state to remove job from list
	        var eligibleContacts = _this.state.eligibleContacts;
	        var index = eligibleContacts.findIndex(function (contact) {
	          return contact.profile.id === _this.state.rowToMove.profile.id;
	        });
	        if (index !== -1) {
	          eligibleContacts.splice(index, 1);
	        }
	
	        _this.setState({
	          eligibleContacts: eligibleContacts,
	          rowToMove: null,
	          viewMode: MODES.loading,
	          showTransitionBlocker: false
	        });
	
	        // regenerate the list of eligibleContacts in case some have become ineligible to be moved as they
	        // have become the only contact left in a company
	        _this.filterContactCompanies();
	      }));
	
	      // update parent with new contact
	      // not sure this is necessary, doesn't seem to have an effect
	      _this.props.contacts.push(contactToUpdate);
	    };
	
	    _this.state = {
	      showTransitionBlocker: false,
	      selectedContacts: [],
	      eligibleContacts: [],
	      viewMode: MODES.loading,
	      tableColumns: ['Id', 'Company', 'Name', 'Status', 'Actions']
	    };
	    return _this;
	  }
	
	  _createClass(ContactTransferOwnership, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _employees.getPins)(function (err, pins) {
	        if (!err) {
	          dispatch(syncActionCreators.loadPins(pins));
	        }
	      }));
	
	      var eligibleContacts = this.props.pinnedContacts.filter(function (item) {
	        return item.profile.companyId !== _this2.props.company.id;
	      });
	
	      this.setState({ eligibleContacts: eligibleContacts });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.filterContactCompanies();
	    }
	
	    // A company cannot be left without any contacts.
	    // filterContactCompanies removes contacts from eligibleContacts if they are the only contact remaining in a company or, in other
	    // words if removing the contact from the company would leave the company without contacts.
	
	  }, {
	    key: 'filterContactCompanies',
	    value: function filterContactCompanies() {
	      var _this3 = this;
	
	      var eligibleCompanies = this.state.eligibleContacts.map(function (c) {
	        return { id: c.company.id, valid: false };
	      });
	
	      Promise.all(eligibleCompanies.map(function (c) {
	        _this3.props.dispatch(companyApi.getCompanyContacts(c.id, function (err, companyContacts) {
	          if (err || !companyContacts) {
	            return console.error(err || 'Fetch failed.');
	          }
	
	          if (companyContacts.body.data.items.length < 2) {
	            var eligibleContacts = _this3.state.eligibleContacts;
	            var index = eligibleContacts.findIndex(function (contact) {
	              return contact.company.id === c.id;
	            });
	            if (index !== -1) {
	              eligibleContacts.splice(index, 1);
	              _this3.setState({ eligibleContacts: eligibleContacts });
	            }
	          }
	        }));
	      })).then(function () {
	        return _this3.setState({ viewMode: MODES.ready });
	      });
	    }
	  }, {
	    key: 'renderActions',
	
	
	    // table column rendering functions
	    value: function renderActions(header, row, index) {
	      if (header) {
	        return this.renderHeader('Actions', 'actions');
	      }
	
	      // overflow visible hack for tooltips in TableRowColumn
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Actions ' + index, 'data-id': 'Actions ' + index, className: 'actions', style: { overflow: 'visible' } },
	        _react2.default.createElement(
	          _IconButton2.default,
	          { tooltip: 'Transfer Contact', tooltipPosition: 'bottom-center', onClick: this.handleConfirmTransfer.bind(this, row) },
	          _react2.default.createElement(_TransferItemOwnershipIcon2.default, { 'data-id': 'Move' + index, className: 'action-button' })
	        )
	      );
	    }
	  }, {
	    key: 'renderCompany',
	    value: function renderCompany(isHeader, row, index) {
	      if (isHeader) {
	        return this.renderHeader('Company', 'company', 'company', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Company' + index, className: 'company' },
	        row.company.name
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(headerText, className, columnName) {
	      if (!className) {
	        className = (0, _lodash.replace)((0, _lodash.lowerCase)(headerText), ' ', '-');
	      }
	      return _react2.default.createElement(
	        _Table.TableHeaderColumn,
	        { className: (0, _classnames2.default)(className) },
	        _react2.default.createElement(
	          'div',
	          null,
	          headerText
	        )
	      );
	    }
	  }, {
	    key: 'renderId',
	    value: function renderId(isHeader, row, index) {
	      if (isHeader) {
	        return this.renderHeader('Contact #', 'contact-number', 'id', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Contact Number' + index, className: 'contact-number' },
	        _react2.default.createElement(
	          'div',
	          null,
	          row.profile.id
	        )
	      );
	    }
	  }, {
	    key: 'renderName',
	    value: function renderName(isHeader, row, index) {
	      if (isHeader) {
	        return this.renderHeader('Name', 'name', 'name', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Name' + index, className: 'title' },
	        row.user.firstName,
	        ' ',
	        row.user.lastName
	      );
	    }
	  }, {
	    key: 'renderStatus',
	    value: function renderStatus(header, row, index) {
	      if (header) {
	        return this.renderHeader('Status', 'status', 'contactStatus', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Status #' + index, 'data-id': 'Status #' + index, className: 'status' },
	        _react2.default.createElement('div', { className: 'status-circle', 'data-id': 'Status Icon', style: {
	            backgroundColor: this.props.staticData.companyStatus.find(function (s) {
	              return s.id === row.company.companyStatus;
	            }).color,
	            borderColor: this.props.staticData.companyStatus.find(function (s) {
	              return s.id === row.company.companyStatus;
	            }).color
	          } }),
	        this.props.staticData.companyStatus.find(function (s) {
	          return s.id === row.company.companyStatus;
	        }).name
	      );
	    }
	
	    // table rendering function
	
	  }, {
	    key: 'renderContactTable',
	    value: function renderContactTable() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'contact-table' },
	        _react2.default.createElement(
	          _Table.Table,
	          { selectable: false,
	            multiSelectable: false,
	            fixedHeader: true,
	            height: this.props.tableHeight || 'calc(100vh-0px)',
	            onSelectionChange: this.handleTableSelectionChange,
	            onClick: this.handleTableSelectionChange
	          },
	          _react2.default.createElement(
	            _Table.TableHeader,
	            { displaySelectAll: false, adjustForCheckbox: false },
	            _react2.default.createElement(
	              _Table.TableRow,
	              null,
	              (0, _lodash.map)(this.state.tableColumns, function (column) {
	                return _this4['render' + column](true);
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableBody,
	            { displayRowCheckbox: false },
	            this.state.viewMode === MODES.loading && _react2.default.createElement(
	              'div',
	              { className: 'table-no-data' },
	              'Loading Contacts'
	            ),
	            this.state.viewMode === MODES.ready && this.state.eligibleContacts.length === 0 && _react2.default.createElement(
	              'div',
	              { className: 'table-no-data' },
	              'No Eligible Contacts Available'
	            ),
	            this.state.viewMode === MODES.ready && this.state.eligibleContacts.length > 0 && (0, _lodash.map)(this.state.eligibleContacts, function (row, index) {
	              return _react2.default.createElement(
	                _Table.TableRow,
	                { key: '' + row.profile.id, 'data-id': 'Contact ' + row.profile.id },
	                (0, _lodash.map)(_this4.state.tableColumns, function (column) {
	                  return _this4['render' + column](false, row, index);
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	
	    // component render
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClickOut: this.handleClose },
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          secondaryAction: this.handleTransferContact,
	          secondaryButtonLabel: 'Transfer Contact',
	          cancelAction: function cancelAction() {
	            return _this5.setState({ showTransitionBlocker: false, rowToTransfer: null });
	          },
	          primaryAction: function primaryAction() {
	            return _this5.setState({ showTransitionBlocker: false, rowToTransfer: null });
	          },
	          primaryButtonLabel: 'Cancel',
	          transitionText: 'Are you sure you want to move Contact #<b>' + this.state.rowToMove.profile.id + '</b><br>from: <b>' + this.state.rowToMove.company.name + '</b><br>to: <b>' + this.props.company.name + '</b>?'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'transferContactOwnership-dialog' },
	          _react2.default.createElement(_ModalX2.default, { onClick: this.handleClose }),
	          _react2.default.createElement(
	            'h1',
	            { className: 'modal-content-title' },
	            'Transfer Pinned Contacts'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid transferContactOwnership-dialog-fields' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                this.renderContactTable()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'transferContactOwnership-dialog-actions' },
	            _react2.default.createElement(_Button2.default, { 'data-id': 'transfer contacts', label: 'Close', onClick: this.handleClose, disabled: this.state.transferring })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ContactTransferOwnership;
	}(_react.Component), _class2.propTypes = {
	  company: _react.PropTypes.object.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  contacts: _react.PropTypes.array.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  pinnedContacts: _react.PropTypes.array,
	
	  // table
	  staticData: _react.PropTypes.object.isRequired,
	  tableHeight: _react.PropTypes.number
	}, _temp)) || _class);
	exports.default = ContactTransferOwnership;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ContactTable = __webpack_require__(295);
	
	var _ContactTable2 = _interopRequireDefault(_ContactTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPanel = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var companyId = parseInt(props.params.companyId, 10) || 0;
	  var staticData = store.staticData;
	  var contacts = store.companyContacts;
	
	  return {
	    companyId: companyId,
	    staticData: staticData,
	    contacts: contacts
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ContactPanel, _React$Component);
	
	  function ContactPanel(props, context) {
	    _classCallCheck(this, ContactPanel);
	
	    return _possibleConstructorReturn(this, (ContactPanel.__proto__ || Object.getPrototypeOf(ContactPanel)).call(this, props, context));
	  }
	
	  _createClass(ContactPanel, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ContactTable2.default, {
	          useContactTypeDropdown: true,
	          contactLink: true,
	          showFilters: false,
	          columns: ['Name', 'Phone', 'Title', 'Type', 'Email', 'Delete'],
	          contacts: this.props.contacts })
	      );
	    }
	  }]);
	
	  return ContactPanel;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = ContactPanel;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _JobRequestTable = __webpack_require__(230);
	
	var _JobRequestTable2 = _interopRequireDefault(_JobRequestTable);
	
	var _index = __webpack_require__(21);
	
	var adminStore = _interopRequireWildcard(_index);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestPanel = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var companyId = parseInt(props.params.companyId, 10) || 0;
	  var staticData = store.staticData;
	  var contacts = store.companyContacts;
	  var filters = store.admin.jobRequests.filters;
	  var searchTerms = store.admin.jobRequests.searchTerms;
	
	  return {
	    companyId: companyId,
	    staticData: staticData,
	    contacts: contacts,
	    filters: filters,
	    searchTerms: searchTerms,
	    jobRequests: store.companyJobRequests
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(JobRequestPanel, _React$Component);
	
	  function JobRequestPanel(props, context) {
	    _classCallCheck(this, JobRequestPanel);
	
	    var _this = _possibleConstructorReturn(this, (JobRequestPanel.__proto__ || Object.getPrototypeOf(JobRequestPanel)).call(this, props, context));
	
	    _this.onJobRequestFilterChange = function () {
	      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _this.props.dispatch(adminStore.updateJobRequestFilters(filters));
	    };
	
	    _this.onJobRequestTermsChange = function () {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      _this.props.dispatch(adminStore.updateJobRequestTerms(terms));
	    };
	
	    _this.state = {
	      contacts: (0, _lodash.get)(props, 'contacts', [])
	    };
	    return _this;
	  }
	
	  _createClass(JobRequestPanel, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.contacts) {
	        this.setState({ contacts: nextProps.contacts });
	      }
	    }
	  }, {
	    key: 'fetchJobRequests',
	    value: function fetchJobRequests() {
	      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _this2 = this;
	
	      var terms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var skip = arguments[2];
	
	      var callbacks = {
	        success: function success(items) {
	          return _this2.props.dispatch(jobRequestStore.updateCompanyJobRequests(items));
	        },
	        error: function error(err) {
	          return console.error('updateCompanyJobRequests failed', err);
	        }
	      };
	
	      this.props.dispatch(jobRequestApi.getAllJobs(callbacks, skip, terms, filters, this.props.companyId));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_JobRequestTable2.default, {
	        columns: ['Id', 'Date', 'Title', 'Openings', 'Contact', 'Status'],
	        onJobRequestFilterChange: this.onJobRequestFilterChange,
	        onJobRequestTermsChange: this.onJobRequestTermsChange,
	        fetchJobs: this.fetchJobRequests.bind(this),
	        jobRequestsList: (0, _lodash.values)(this.props.jobRequests),
	        filters: this.props.filters,
	        searchTerms: this.props.searchTerms,
	        contacts: this.state.contacts,
	        showHeader: false,
	        JobRequestsTable: false,
	        showLink: false
	      });
	    }
	  }]);
	
	  return JobRequestPanel;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = JobRequestPanel;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _modelValidator = __webpack_require__(33);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _contacts = __webpack_require__(237);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _CheckListTextField = __webpack_require__(447);
	
	var _CheckListTextField2 = _interopRequireDefault(_CheckListTextField);
	
	var _DropdownChecklist = __webpack_require__(296);
	
	var _DropdownChecklist2 = _interopRequireDefault(_DropdownChecklist);
	
	var _parentChildList = __webpack_require__(169);
	
	var _industrySegments = __webpack_require__(307);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var message = 'This field is required.';
	var required = { message: message };
	
	var ProfilePanel = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var contact = null;
	  if (props.params.contactId) {
	    var contactId = parseInt(props.params.contactId, 10);
	    var isContactWorksheet = /\/admin\/contacts\/\d+\/details\/company/g;
	
	    if (isContactWorksheet.test(props.location.pathname)) {
	      contact = (0, _lodash.get)(store.admin, 'contactInContactWorksheet', {});
	    } else {
	      contact = (0, _contacts.findContact)({ profile: { id: contactId } }, (0, _lodash.get)(store.admin.contacts, 'items', []));
	    }
	  }
	
	  return {
	    companyId: contact ? contact.company.id : parseInt(props.params.companyId, 10) || 0,
	    company: contact ? contact.company : store.admin.company,
	    staticData: store.staticData,
	    labels: (0, _lodash.get)(store, 'labels.ProfilePanel', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ProfilePanel, _Component);
	
	  function ProfilePanel(props, context) {
	    _classCallCheck(this, ProfilePanel);
	
	    // TODO: This validation must be kept in sync (for matching values) with shared/models/company.js!
	    var _this = _possibleConstructorReturn(this, (ProfilePanel.__proto__ || Object.getPrototypeOf(ProfilePanel)).call(this, props, context));
	
	    _this.getPlacementFee = function (salesPartner) {
	
	      var cState = (0, _lodash.find)(_this.props.staticData.salesPartners, function (partner) {
	        return partner.id === salesPartner;
	      });
	      return (0, _lodash.get)(cState, 'fee');
	    };
	
	    _this.getCommission = function (salesPartner) {
	
	      var cState = (0, _lodash.find)(_this.props.staticData.salesPartners, function (partner) {
	        return partner.id === salesPartner;
	      });
	      return (0, _lodash.get)(cState, 'commission');
	    };
	
	    _this.iiabaStateMenuItems = function () {
	      return [{ id: null, name: 'None' }].concat(_toConsumableArray((0, _lodash.get)(_this.props, 'staticData.iiabaStates', [])));
	    };
	
	    _this.salesPartnerMenuItems = function () {
	      return [{ id: null, name: 'None' }].concat(_toConsumableArray((0, _lodash.get)(_this.props, 'staticData.salesPartners', [])));
	    };
	
	    _this.handleCheckListTextFieldUI = function (name, title, menuItems) {
	
	      return {
	        dataId: name,
	        defaultValue: (0, _lodash.get)(_this.state, name + '.value'),
	        floatingLabelText: title,
	        onChange: _this.handleChange(name),
	        onBlur: _this.handleSubmitForm(name),
	        className: 'row',
	        checkListContainerClassName: 'col fixed-width-field',
	        textfieldContainerClassName: 'col grow-3',
	        showLabel: true,
	        menuItems: menuItems
	      };
	    };
	
	    _this.handleTextAreaUI = function (name, title) {
	      return {
	        value: (0, _lodash.get)(_this.state, name + '.value'),
	        onChange: _this.handleChange(name),
	        onBlur: _this.handleSubmitForm(name),
	        descriptionHead: title
	      };
	    };
	
	    _this.handleTextFieldUI = function (name, title) {
	      return {
	        value: (0, _lodash.get)(_this.state, name + '.value'),
	        floatingLabelText: title,
	        onChange: _this.handleChange(name),
	        onBlur: _this.handleSubmitForm(name),
	        floatingLabelFixed: true,
	        'data-id': name
	      };
	    };
	
	    _this.handleDropdownUI = function (name, title) {
	      return {
	        'data-id': name,
	        value: (0, _lodash.get)(_this.state, name + '.value'),
	        floatingLabelText: title,
	        onChange: _this.handleChange(name),
	        onBlur: _this.handleSubmitForm(name)
	      };
	    };
	
	    _this.handlePlacementFeeDropdownUI = function () {
	
	      var menuItems = (0, _lodash.map)(_this.props.staticData.setupFees, function (item) {
	        return {
	          primaryText: item.name === '$0' ? 'Waived' : item.name,
	          value: _this.currencyToNumber(item.name)
	        };
	      });
	
	      return {
	        'data-id': 'placementFee',
	        value: (0, _lodash.get)(_this.state, 'placementFee.value'),
	        floatingLabelText: 'One Time Setup Fee',
	        onChange: _this.handleChange('placementFee'),
	        onBlur: _this.handleSubmitForm('placementFee'),
	        menuItems: menuItems
	      };
	    };
	
	    _this.state = {
	      segmentTypes: {
	        value: _this.props.company.segmentTypes || [],
	        required: required
	      },
	      segmentOther: {
	        value: _this.props.company.segmentOther || []
	      },
	      industryTypes: {
	        value: _this.props.company.industryTypes || [],
	        required: required
	      },
	      industryOther: {
	        value: _this.props.company.industryOther || []
	      },
	      description: {
	        value: _this.props.company.description || '',
	        required: required
	      },
	      numberOfOffices: {
	        value: _this.props.company.numberOfOffices || 0,
	        required: required
	      },
	      numberOfEmployees: {
	        value: _this.props.company.numberOfEmployees || 0,
	        required: required
	      },
	      parentCompany: {
	        value: _this.props.company.parentCompany || '',
	        required: required
	      },
	      children: {
	        value: _this.props.company.children || '',
	        required: required
	      },
	      tradeAssociations: {
	        value: _this.props.company.tradeAssociations || []
	      },
	      associationOther: {
	        value: _this.props.company.associationOther || []
	      },
	      affiliationTypes: {
	        value: _this.props.company.affiliationTypes || []
	      },
	      affiliationOther: {
	        value: _this.props.company.affiliationOther || []
	      },
	      iiabaState: {
	        value: _this.props.company.iiabaState || ''
	      },
	      salesPartner: {
	        value: _this.props.company.salesPartner || ''
	      },
	      placementFee: {
	        value: _this.props.company.placementFee,
	        custom: {
	          func: function func(val) {
	            return !_this.props.labels.showPlacementFee || !(0, _lodash.isNil)(val);
	          }, // regular required property doesn't accept 0 as required value.
	          message: 'This field is required.'
	        }
	      },
	      placementFeeOther: {
	        value: _this.props.company.placementFeeOther || '',
	        required: required
	      },
	      commission: {
	        value: _this.props.company.commission
	      },
	      tradeAssociationsOther: {
	        value: _this.props.company.tradeAssociationsOther || '',
	        required: required
	      },
	      showErrorMessage: false
	    };
	
	    _this.parentChildHandlers = (0, _parentChildList.parentChildList)();
	
	    return _this;
	  }
	
	  _createClass(ProfilePanel, [{
	    key: 'handleChange',
	    value: function handleChange(field) {
	      var _this2 = this;
	
	      return function (event, value) {
	        _this2.handleUpdateField && _this2.handleUpdateField(event, field, value);
	
	        if (field === 'salesPartner') {
	          var commission = {
	            value: _this2.getCommission(value)
	          };
	
	          var placementFee = {
	            value: _this2.getPlacementFee(value),
	            custom: _this2.state.placementFee.custom
	          };
	
	          _this2.setState({ placementFee: placementFee, commission: commission });
	        }
	      };
	    }
	  }, {
	    key: 'handleUpdateField',
	    value: function handleUpdateField(event, field, value) {
	      if (field === 'segmentTypes' && (0, _lodash.isNil)(value)) return; // WPS-43 - do not clear segment types when parent changes
	      value = (0, _lodash.isNil)(value) ? (0, _lodash.isNil)(event) ? null : (0, _lodash.get)(event, 'target.value', null) : value;
	      var newState = (0, _lodash.set)((0, _lodash.merge)({}, this.state), field + '.value', value);
	      (0, _lodash.set)(newState, field + '.errors', (0, _modelValidator.validateFormField)(field, newState));
	      var errorText = (0, _lodash.get)(newState, field + '.errors[0]', null);
	      this.setState((0, _lodash.merge)(newState, { showErrorMessage: !!errorText }));
	      if (errorText) {
	        // warn the user, don't just ignore the message
	        this.props.dispatch(ui.warningToast('Error ' + errorText + ' updating field: ' + field));
	      }
	      return !!errorText;
	    }
	  }, {
	    key: 'currencyToNumber',
	    value: function currencyToNumber(currency) {
	      var currencyString = String(currency);
	      return Number(currencyString.replace(/[^0-9\.]+/g, ''));
	    }
	  }, {
	    key: 'handleSubmitForm',
	    value: function handleSubmitForm(field) {
	      var _this3 = this;
	
	      return function (event, value) {
	        var hasError = _this3.handleUpdateField && _this3.handleUpdateField(event, field, value);
	
	        // if there's an error updating the field, don't submit form;
	        if (hasError) return;
	
	        var companyUpdate = {
	          id: _this3.props.companyId
	        };
	
	        // set 'null' value to empty array for trade assoc. and affiliationTypes
	        // update company repo needs an empty array to set fields to none
	        if ((0, _lodash.includes)(['tradeAssociations', 'affiliationTypes'], field) && !value) {
	          value = [];
	        }
	
	        companyUpdate[field] = value;
	
	        if (field === 'salesPartner') {
	          companyUpdate.placementFee = _this3.getPlacementFee(value);
	          companyUpdate.commission = _this3.getCommission(value);
	        }
	
	        if (field === 'placementFee') {
	          companyUpdate.placementFee = value;
	
	          if (companyUpdate.placementFee < _this3.props.company.placementFee) {
	            companyUpdate.reducedFee = true;
	          } else {
	            companyUpdate.reducedFee = false;
	          }
	        }
	
	        if (field === 'iiabaState') {
	          var iiabaState = (0, _lodash.find)(_this3.props.staticData.iiabaStates, { id: value }) || {};
	          var salesPartner = (0, _lodash.find)(_this3.props.staticData.salesPartners, { commissionName: iiabaState.commissionName });
	          if (salesPartner) {
	            companyUpdate.salesPartner = salesPartner.id;
	            var salesPartnerUpdate = { value: companyUpdate.salesPartner };
	            var placementFee = { value: salesPartner.fee, custom: _this3.state.placementFee.custom };
	            var commission = { value: salesPartner.commission };
	            companyUpdate.placementFee = placementFee.value;
	            companyUpdate.commission = commission.value;
	            _this3.setState({ salesPartner: salesPartnerUpdate, placementFee: placementFee, commission: commission });
	          } else {
	            var _iiabaState = (0, _lodash.find)(_this3.props.staticData.iiabaStates, { id: value });
	            if (_iiabaState) {
	              var _placementFee = { value: _iiabaState.fee, custom: _this3.state.placementFee.custom };
	              var _commission = { value: _iiabaState.commission };
	              var _salesPartnerUpdate = { value: null };
	              _this3.setState({ placementFee: _placementFee, commission: _commission, salesPartner: _salesPartnerUpdate });
	              companyUpdate.placementFee = _placementFee.value;
	              companyUpdate.commission = _commission.value;
	              companyUpdate.salesPartner = _salesPartnerUpdate.value;
	            } else {
	              var defaultPlacementFee = _this3.props.staticData.account.defaultSetupFee;
	              var _placementFee2 = { value: defaultPlacementFee };
	              var _commission2 = { value: null };
	              var _salesPartnerUpdate2 = { value: null };
	              _this3.setState({ placementFee: _placementFee2, commission: _commission2, salesPartner: _salesPartnerUpdate2 });
	              companyUpdate.placementFee = defaultPlacementFee;
	              companyUpdate.commission = null;
	              companyUpdate.salesPartner = null;
	            }
	          }
	        }
	
	        _this3.props.dispatch(companyApi.updateCompanyById(companyUpdate, function (err, data) {
	          if (err) {
	            return console.error(err);
	          }
	          var company = (0, _lodash.get)(data, 'body.data.items[0]');
	          var groups = (0, _lodash.get)(_this3.props, 'staticData.companyStatus', []);
	
	          if (field === 'placementFee' || field === 'salesPartner') {
	            var _placementFee3 = {
	              value: companyUpdate.placementFee,
	              custom: _this3.state.placementFee.custom
	            };
	            _this3.setState({ placementFee: _placementFee3 });
	          }
	
	          if (field === 'salesPartner') {
	            var _commission3 = {
	              value: companyUpdate.commission
	            };
	            _this3.setState({ commission: _commission3 });
	          }
	          _this3.props.dispatch(syncActionCreators.getCompanyInfo({ company: company, groups: groups }));
	          _this3.props.dispatch(ui.showSnackBar());
	        }));
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var segmentTypes = (0, _lodash.get)(this.props.staticData, 'segmentTypes');
	      var otherSegmentType = (0, _lodash.get)((0, _lodash.find)(segmentTypes, { name: 'Other' }), 'id');
	      var industryTypes = (0, _lodash.get)(this.props.staticData, 'industryTypesList');
	      var otherIndustryType = (0, _lodash.get)((0, _lodash.find)(industryTypes, { name: 'Other' }), 'id');
	      var allSegments = (0, _industrySegments.activeSegmentTypes)(segmentTypes, industryTypes, (0, _lodash.get)(this.state, 'industryTypes.value'), (0, _lodash.get)(this.state, 'segmentTypes.value'));
	
	      var _parentChildHandlers = this.parentChildHandlers({
	        parentProps: this.handleCheckListTextFieldUI('industryTypes', this.props.labels.industry, industryTypes),
	        childProps: this.handleCheckListTextFieldUI('segmentTypes', 'Industry Segment', segmentTypes)
	      }),
	          industryTypeProps = _parentChildHandlers.parent,
	          segmentTypeProps = _parentChildHandlers.child;
	
	      var tradeAssociations = (0, _lodash.get)(this.props.staticData, 'tradeAssociations');
	      var otherTradeAssociations = (0, _lodash.get)((0, _lodash.find)(tradeAssociations, { name: 'Other' }), 'id');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'company-profile-panel' },
	        _react2.default.createElement(
	          'div',
	          { className: 'grid company-information' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              _react2.default.createElement(_CheckListTextField2.default, _extends({}, industryTypeProps, {
	                errorText: (0, _lodash.get)(this.state, 'industryTypes.errors') && (0, _lodash.get)(this.state, 'industryTypes.errors[0]')
	              }))
	            ),
	            (0, _lodash.includes)(this.state.industryTypes.value, otherIndustryType) && _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, this.handleTextFieldUI('industryOther', 'Other'))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              _react2.default.createElement(_DropdownChecklist2.default, {
	                'data-id': 'segmentTypes',
	                textLabel: (0, _lodash.get)(this.props.labels, 'segmentTypes'),
	                defaultLabel: 'Industry Segment',
	                menuItems: allSegments,
	                value: (0, _lodash.get)(this.state, 'segmentTypes.value'),
	                groupBy: 'parentName',
	                errorText: (0, _lodash.get)(this.state, 'segmentTypes.errors[0]') || 'This field is required',
	                dirty: !!(0, _lodash.get)(this.state, 'industryTypes.value', false),
	                onChange: this.handleSubmitForm('segmentTypes'),
	                required: true
	              })
	            ),
	            (0, _lodash.includes)(this.state.segmentTypes.value, otherSegmentType) && _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, this.handleTextFieldUI('segmentOther', 'Other'))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid company-description' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextArea2.default, _extends({}, this.handleTextAreaUI('description', 'Company Description'), {
	                'data-id': 'company-description'
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col col-offices-employees' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleTextFieldUI('numberOfOffices', '# of Offices'))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleTextFieldUI('numberOfEmployees', '# of Employees'))
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid company-relationships' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col fixed-width-field' },
	              _react2.default.createElement(_c_TextField2.default, this.handleTextFieldUI('parentCompany', 'Parent'))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, this.handleTextFieldUI('children', 'Child'))
	            )
	          ),
	          this.props.labels.showTradeAssociation && _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              _react2.default.createElement(_CheckListTextField2.default, _extends({}, this.handleCheckListTextFieldUI('tradeAssociations', 'National Trade Associations'), {
	                menuItems: (0, _lodash.map)(this.props.staticData.tradeAssociations, function (_ref) {
	                  var id = _ref.id,
	                      crmName = _ref.crmName;
	                  return { id: id, name: crmName };
	                })
	              }))
	            ),
	            (0, _lodash.includes)(this.state.tradeAssociations.value, otherTradeAssociations) && _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, this.handleTextFieldUI('associationOther', 'Other'))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              this.props.labels.showAffiliations && _react2.default.createElement(_CheckListTextField2.default, _extends({}, this.handleCheckListTextFieldUI('affiliationTypes', 'Affiliations'), {
	                menuItems: this.props.staticData.affiliationTypes
	              }))
	            ),
	
	            // Only for wahve
	            (0, _lodash.includes)(this.state.affiliationTypes.value, 5) && _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, this.handleTextFieldUI('affiliationOther', 'Other'))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            this.props.labels.showIiabaState && _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdownUI('iiabaState', 'State Association Memberships to IIABA'), {
	                menuItems: this.iiabaStateMenuItems()
	              }))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid company-billing' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            this.props.labels.showPlacementFee && _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              _react2.default.createElement(_c_DropDownMenu2.default, this.handlePlacementFeeDropdownUI())
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdownUI('referrer', 'Referrer'), {
	                menuItems: []
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdownUI('salesPartner', 'Sales Partner'), {
	                menuItems: this.salesPartnerMenuItems()
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-4' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdownUI('commission', 'Commission'), {
	                menuItems: (0, _lodash.map)(this.props.staticData.commission, function (_ref2) {
	                  var id = _ref2.id,
	                      value = _ref2.value;
	                  return { primaryText: value * 100 + '%', value: value };
	                })
	              }))
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row fixed-width-field' })
	        )
	      );
	    }
	  }]);
	
	  return ProfilePanel;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  company: _react.PropTypes.object.isRequired,
	  params: _react.PropTypes.object.isRequired,
	  contact: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ProfilePanel;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _staticData = __webpack_require__(28);
	
	var _StatusDropDown = __webpack_require__(199);
	
	var _StatusDropDown2 = _interopRequireDefault(_StatusDropDown);
	
	var _EditIcon = __webpack_require__(203);
	
	var _EditIcon2 = _interopRequireDefault(_EditIcon);
	
	var _DocumentIcon = __webpack_require__(302);
	
	var _DocumentIcon2 = _interopRequireDefault(_DocumentIcon);
	
	var _AddContact = __webpack_require__(875);
	
	var _AddContact2 = _interopRequireDefault(_AddContact);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _formatCompanyUrl = __webpack_require__(306);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _EditDetails = __webpack_require__(944);
	
	var _EditDetails2 = _interopRequireDefault(_EditDetails);
	
	var _Documents = __webpack_require__(943);
	
	var _Documents2 = _interopRequireDefault(_Documents);
	
	var _NewContact = __webpack_require__(945);
	
	var _NewContact2 = _interopRequireDefault(_NewContact);
	
	var _TransferItemOwnershipDialogIcon = __webpack_require__(459);
	
	var _TransferItemOwnershipDialogIcon2 = _interopRequireDefault(_TransferItemOwnershipDialogIcon);
	
	var _reactTooltip = __webpack_require__(409);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _ContactTransferOwnership = __webpack_require__(938);
	
	var _ContactTransferOwnership2 = _interopRequireDefault(_ContactTransferOwnership);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MODES = {
	  empty: 0,
	  view: 1,
	  edit: 2,
	  contact: 3
	};
	
	var dropDownCustomization = {
	  labelStyle: {
	    color: '#ffffff',
	    paddingLeft: '10px'
	  }
	};
	
	var CompanyDetails = (_dec = (0, _reactRedux.connect)(function (store) {
	  var company = store.admin.company;
	  var companyStatus = store.staticData.companyStatus;
	  // users "entire" roles, not just names
	  var userRoles = store.staticData.employeeRoles.filter(function (role) {
	    return store.user.roles.includes(role.name);
	  });
	  // roles allowed to transfer
	  var requiredRoles = store.staticData.employeeRoles.filter(function (role) {
	    return role.hardcodelink === 'SYSTEM_ADMINISTRATOR' || role.hardcodelink === 'EMPLOYEE';
	  });
	  // ensure that user has all the required roles to transfer
	  var transferButtonAllowed = requiredRoles.every(function (role) {
	    return userRoles.includes(role);
	  });
	  return {
	    staticData: store.staticData,
	    company: company,
	    companyStatus: companyStatus,
	    contacts: store.companyContacts,
	    currentUser: store.user,
	    showTransferOwnershipButton: transferButtonAllowed
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(CompanyDetails, _React$Component);
	
	  function CompanyDetails(props, context) {
	    _classCallCheck(this, CompanyDetails);
	
	    var _this = _possibleConstructorReturn(this, (CompanyDetails.__proto__ || Object.getPrototypeOf(CompanyDetails)).call(this, props, context));
	
	    _this.handleContactTransferOwnership = function () {
	      return _this.toggleContactTransferOwnershipModal();
	    };
	
	    _this.handleEdit = function () {
	      return _this.setState.apply(_this, _toConsumableArray(_this.state).concat([{ mode: MODES.edit }]));
	    };
	
	    _this.handleNewContact = function () {
	      return _this.setState.apply(_this, _toConsumableArray(_this.state).concat([{ mode: MODES.contact }]));
	    };
	
	    _this.handleClose = function () {
	      return _this.switchModes();
	    };
	
	    _this.showDocuments = function () {
	      _this.setState({ showDocuments: true });
	    };
	
	    _this.closeDocuments = function () {
	      _this.setState({ showDocuments: false });
	    };
	
	    _this.handleChange = function (event, value) {
	
	      var payload = {
	        companyStatus: value,
	        id: _this.props.company.id
	      };
	
	      var updateCompany = function updateCompany(data) {
	        return _this.props.dispatch(companyApi.updateCompanyStatus(data.id, data.companyStatus));
	      };
	      var updateCompanyStore = function updateCompanyStore(data) {
	        return _this.props.dispatch(companyStore.updateCompany(data));
	      };
	
	      updateCompany(payload).then(updateCompanyStore);
	
	      _this.setState({ status: value });
	    };
	
	    _this.toggleContactTransferOwnershipModal = function () {
	      _this.setState(_extends({}, _this.state, { showContactTransferOwnershipModal: !_this.state.showContactTransferOwnershipModal }));
	      _reactTooltip2.default.rebuild();
	    };
	
	    var mode = props.company ? MODES.view : MODES.empty;
	    var initialState = {
	      mode: mode,
	      relationshipManagers: _this.props.staticData.relationshipManagers,
	      showDocuments: false,
	      status: _this.props.company.companyStatus,
	      showContactTransferOwnershipModal: false
	    };
	    _this.getCompanyUrl = _this.getCompanyUrl.bind(_this);
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(CompanyDetails, [{
	    key: 'getCompanyUrl',
	    value: function getCompanyUrl() {
	      if (this.props.company.website) {
	        return (0, _formatCompanyUrl.formatCompanyUrlForHyperlink)(this.props.company.website);
	      } else {
	        if ((0, _lodash.isEmpty)(this.props.contacts)) {
	          return '';
	        } else {
	          var contactEmail = this.props.contacts[0].user.email;
	          return (0, _formatCompanyUrl.extractCompanyUrlFromEmail)(contactEmail);
	        }
	      }
	    }
	  }, {
	    key: 'switchModes',
	    value: function switchModes() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MODES.view;
	
	      this.setState.apply(this, _toConsumableArray(this.state).concat([{ mode: mode }]));
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this2 = this;
	
	      var staticData = this.props.staticData;
	      var relationshipManager = this.state.relationshipManagers.find(function (employee) {
	        return employee.employeeId === _this2.props.company.relationshipManagerId;
	      });
	      var sanitize = function sanitize(val) {
	        return val || '';
	      };
	      var expand = function expand(type, val) {
	        return sanitize((0, _staticData.lookup)(staticData, type, val));
	      };
	      var _props$company = this.props.company,
	          address = _props$company.address,
	          address2 = _props$company.address2,
	          city = _props$company.city,
	          state = _props$company.state,
	          zip = _props$company.zip,
	          website = _props$company.website;
	
	      state = state ? expand('stateList', { id: state }) : null;
	      var currentStatus = (0, _staticData.getLookupValue)(staticData, 'companyStatus', { id: this.state.status });
	
	      var companyHyperlink = this.getCompanyUrl();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'view-contact-card company-card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cols contact-col1' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            '' + this.props.company.name
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Relationship Manager: ',
	            (0, _lodash.get)(relationshipManager, 'firstName'),
	            '  ',
	            (0, _lodash.get)(relationshipManager, 'lastName')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Company Website: ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://' + companyHyperlink },
	              website || companyHyperlink
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cols contact-col2' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Time Zone: ',
	            expand('timezoneList', { id: this.props.company.timezone })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Main: ',
	            (0, _prettyPhone2.default)(this.props.company.phoneNumber)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cols contact-col2' },
	          !!(address || address2) && _react2.default.createElement(
	            'div',
	            null,
	            '' + sanitize(address) + (address2 ? ' ' + address2 : '')
	          ),
	          !!(city || state) && _react2.default.createElement(
	            'div',
	            null,
	            sanitize(city) + ', ' + sanitize(state) + ', ' + sanitize(zip)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cols contact-col2' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Entered: ',
	            this.props.company.dateCreated ? (0, _moment2.default)(this.props.company.dateCreated).format('L') : sanitize(this.props.company.dateCreated)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Updated: ',
	            this.props.company.dateModified ? (0, _moment2.default)(this.props.company.dateModified).format('L') : sanitize(this.props.company.dateModified)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cols contact-col3' },
	          _react2.default.createElement(_StatusDropDown2.default, _extends({
	            'data-id': 'Status Dropdown',
	            className: 'contact-status-dropdown',
	            smallDisplay: true,
	            status: currentStatus,
	            value: this.state.status,
	            menuItems: staticData.companyStatus
	          }, dropDownCustomization, {
	            onChange: this.handleChange
	          })),
	          _react2.default.createElement(
	            'ul',
	            { className: 'buttons' },
	            this.props.showTransferOwnershipButton && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { 'data-id': 'Transfer Icon', tooltip: 'Transfer Contacts', tooltipPosition: 'bottom-center', onClick: this.handleContactTransferOwnership },
	                _react2.default.createElement(_TransferItemOwnershipDialogIcon2.default, { onClick: this.handleContactTransferOwnership })
	              )
	            ),
	            '            ',
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { 'data-id': 'Edit', tooltip: 'Edit', tooltipPosition: 'bottom-center', onClick: this.handleEdit },
	                _react2.default.createElement(_EditIcon2.default, null)
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { 'data-id': 'Documents', tooltip: 'Documents', tooltipPosition: 'bottom-center', onClick: this.showDocuments },
	                _react2.default.createElement(_DocumentIcon2.default, null)
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { 'data-id': 'Contacts', tooltip: 'Add Contact', tooltipPosition: 'bottom-center', onClick: this.handleNewContact },
	                _react2.default.createElement(_AddContact2.default, {
	                  width: 32,
	                  height: 30,
	                  viewBox: '0 0 33 31',
	                  border: true })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEdit',
	    value: function renderEdit() {
	      return _react2.default.createElement(_EditDetails2.default, {
	        company: this.props.company,
	        currentUser: this.props.currentUser,
	        relationshipManagers: this.state.relationshipManagers,
	        website: this.getCompanyUrl(),
	        timezoneList: this.props.staticData.timezoneList,
	        stateList: this.props.staticData.stateList,
	        dispatch: this.props.dispatch,
	        onClose: this.handleClose
	      });
	    }
	  }, {
	    key: 'renderAddContact',
	    value: function renderAddContact() {
	      return _react2.default.createElement(_NewContact2.default, {
	        dispatch: this.props.dispatch,
	        company: this.props.company,
	        contacts: this.props.contacts,
	        staticData: this.props.staticData,
	        onClose: this.handleClose
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'company-worksheeet-details' },
	        this.state.mode === MODES.view && this.renderView(),
	        this.state.mode === MODES.edit && this.renderEdit(),
	        this.state.mode === MODES.contact && this.renderAddContact(),
	        this.state.showDocuments && _react2.default.createElement(_Documents2.default, { closeDocuments: this.closeDocuments }),
	        this.props.showTransferOwnershipButton && this.state.showContactTransferOwnershipModal && _react2.default.createElement(_ContactTransferOwnership2.default, {
	          company: this.props.company,
	          contacts: this.props.contacts,
	          dispatch: this.props.dispatch,
	          onClose: this.toggleContactTransferOwnershipModal,
	          staticData: this.props.staticData
	        })
	      );
	    }
	  }]);
	
	  return CompanyDetails;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  company: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  companyStatus: _react.PropTypes.object.isRequired,
	  contacts: _react.PropTypes.array.isRequired,
	  currentUser: _react.PropTypes.object,
	  showTransferOwnershipButton: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = CompanyDetails;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _lodash = __webpack_require__(4);
	
	var _staticData = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyDocuments = (_dec = (0, _reactRedux.connect)(function (store) {
	  var company = store.admin.company;
	  return {
	    staticData: store.staticData,
	    jobRequests: (0, _lodash.orderBy)((0, _lodash.filter)(store.companyJobRequests, function (job) {
	      return job.jobRequestStatus > 1 && job.companyId == company.id;
	    }), ['dateCreated', 'dateAuthorized'], ['desc', 'desc'])
	  };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(CompanyDocuments, _Component);
	
	  function CompanyDocuments() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CompanyDocuments);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CompanyDocuments.__proto__ || Object.getPrototypeOf(CompanyDocuments)).call.apply(_ref, [this].concat(args))), _this), _this.renderDocument = function (document) {
	
	      return _react2.default.createElement(
	        _c_SourceSimpleFileInput.RetrievalButton,
	        {
	          className: 'file-get',
	          loadingClass: '',
	          notLoadingClass: '',
	          failureClass: '',
	          autoLoad: true,
	          noMessage: true,
	          path: document.storagePath,
	          signingRoute: '/api/s3/get-sign'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'document-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'document-name' },
	            document.fileName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'document-desc-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'document-desc' },
	              document.description
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'document-filesize' },
	              ' ',
	              Math.max(Math.round(document.fileSize / 100000) / 10, 0.1) + ' Mgb'
	            )
	          )
	        )
	      );
	    }, _this.renderJobConfirmation = function (job) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'document-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'document-name' },
	          'ID#:',
	          job.id,
	          ' ',
	          (0, _staticData.lookup)(_this.props.staticData, 'positionTypes', { id: job.positionTypeId })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'document-desc-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'document-desc' },
	            job.primaryContact
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'document-button hover-link', href: '/admin/jobrequests/' + job.id + '/confirmation', target: '_blank' },
	            ' VIEW '
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CompanyDocuments, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'worksheet-documents' },
	        _react2.default.createElement(
	          'div',
	          { className: 'worksheet-documents-container' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'heading' },
	            'Available Documents ',
	            _react2.default.createElement(_ModalX2.default, { onClick: this.props.closeDocuments, style: { color: '#000' }, className: 'close-button' })
	          ),
	          !(0, _lodash.isEmpty)(this.props.documents) ? this.props.documents.map(function (document) {
	            return _this2.renderDocument(document);
	          }) : _react2.default.createElement(
	            'p',
	            null,
	            'No Documents Have Been Uploaded Yet'
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'heading' },
	            'Job Request Documents '
	          ),
	          !(0, _lodash.isEmpty)(this.props.jobRequests) ? (0, _lodash.flatMap)(this.props.jobRequests, function (job) {
	            return _this2.renderJobConfirmation(job);
	          }) : _react2.default.createElement(
	            'p',
	            null,
	            'No Job Requests Have Been Created Yet'
	          )
	        )
	      );
	    }
	  }]);
	
	  return CompanyDocuments;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  closeDocuments: _react.PropTypes.func.isRequired
	}, _temp2)) || _class);
	exports.default = CompanyDocuments;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _lodash = __webpack_require__(4);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modelValidator = __webpack_require__(33);
	
	var _form = __webpack_require__(168);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _staticData = __webpack_require__(28);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formFields = {
	  company: {
	    required: ['name', 'address', 'city', 'state', 'zip'],
	    optional: ['accountTypeId', 'relationshipManagerId', 'phoneNumber', 'timezone', 'website', 'address2', 'dateCreated', 'dateModified']
	  }
	};
	
	function EditCompanyDetailsForm(props) {
	  var _ref = props || {},
	      updateField = _ref.updateField,
	      saveCompany = _ref.saveCompany,
	      onClose = _ref.onClose,
	      onDelete = _ref.onDelete,
	      company = _ref.company,
	      relationshipManagers = _ref.relationshipManagers,
	      timezoneList = _ref.timezoneList,
	      stateList = _ref.stateList,
	      isDirty = _ref.isDirty,
	      hasErrors = _ref.hasErrors,
	      website = _ref.website;
	
	  function handleDelete() {
	    return function (event) {
	      if (onDelete) {
	        return onDelete(event);
	      }
	    };
	  }
	
	  function handleChange(model, prop) {
	    return function (event, value) {
	      return updateField(event, model, prop, value);
	    };
	  }
	
	  function handleSave(event) {
	    saveCompany && saveCompany(event);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'topmodal' },
	    _react2.default.createElement(_ModalX2.default, { onClick: onClose }),
	    _react2.default.createElement(
	      'div',
	      { className: 'topmodal-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'grid grid-topmodal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-2' },
	            _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _lodash.get)(company, 'company.name.defaultValue'),
	              floatingLabelText: "Company Name",
	              errorText: (0, _lodash.get)(company, 'company.name.errors[0]'),
	              onChange: handleChange('company', 'name'),
	              isDirty: isDirty || hasErrors
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  defaultValue: (0, _lodash.get)(company, 'company.address.defaultValue'),
	                  floatingLabelText: "Address Line 1",
	                  errorText: (0, _lodash.get)(company, 'company.address.errors[0]'),
	                  onChange: handleChange('company', 'address'),
	                  isDirty: isDirty || hasErrors
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  defaultValue: (0, _lodash.get)(company, 'company.address2.defaultValue'),
	                  floatingLabelText: "Address Line 2",
	                  errorText: (0, _lodash.get)(company, 'company.address2.errors[0]'),
	                  onChange: handleChange('company', 'address2'),
	                  isDirty: isDirty || hasErrors
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_DateInput2.default, {
	              defaultValue: (0, _moment2.default)((0, _lodash.get)(company, 'company.dateCreated.defaultValue')).format('L'),
	              floatingLabelText: "Entered",
	              disabled: true,
	              isDirty: isDirty || hasErrors
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-2' },
	            _react2.default.createElement(_c_DropDownMenu2.default, {
	              defaultValue: (0, _lodash.get)(company, 'company.relationshipManagerId.defaultValue'),
	              floatingLabelText: "Relationship Manager",
	              errorText: (0, _lodash.get)(company, 'company.relationshipManagerId.errors[0]'),
	              onChange: handleChange('company', 'relationshipManagerId'),
	              menuItems: (0, _staticData.convertEmployeeToMenuItems)(relationshipManagers),
	              isDirty: isDirty || hasErrors
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  'data-id': "City",
	                  defaultValue: (0, _lodash.get)(company, 'company.city.defaultValue'),
	                  floatingLabelText: "City",
	                  errorText: (0, _lodash.get)(company, 'company.city.errors[0]'),
	                  onChange: handleChange('company', 'city'),
	                  isDirty: isDirty || hasErrors
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, {
	                  defaultValue: (0, _lodash.get)(company, 'company.state.defaultValue'),
	                  floatingLabelText: "State",
	                  errorText: (0, _lodash.get)(company, 'company.state.errors[0]'),
	                  onChange: handleChange('company', 'state'),
	                  menuItems: stateList,
	                  isDirty: isDirty || hasErrors
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  defaultValue: (0, _lodash.get)(company, 'company.zip.defaultValue'),
	                  floatingLabelText: "Zip Code",
	                  errorText: (0, _lodash.get)(company, 'company.zip.errors[0]'),
	                  onChange: handleChange('company', 'zip'),
	                  isDirty: isDirty || hasErrors,
	                  maxLength: '5'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_DateInput2.default, {
	              defaultValue: (0, _moment2.default)((0, _lodash.get)(company, 'company.dateModified.defaultValue')).format('L'),
	              floatingLabelText: "Last Updated",
	              disabled: true,
	              isDirty: isDirty || hasErrors
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-2' },
	            _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _lodash.get)(company, 'company.website.defaultValue', '') || website,
	              floatingLabelText: 'Company Website',
	              errorText: (0, _lodash.get)(company, 'company.website.errors[0]'),
	              onChange: handleChange('company', 'website'),
	              isDirty: isDirty || hasErrors
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_MaskedTextField2.default, {
	                  mask: '(999) 999-9999',
	                  hideMaskChar: true,
	                  value: (0, _lodash.get)(company, 'company.phoneNumber.defaultValue'),
	                  floatingLabelText: "Main Number",
	                  errorText: (0, _lodash.get)(company, 'company.phoneNumber.errors[0]'),
	                  onChange: handleChange('company', 'phoneNumber'),
	                  isDirty: isDirty || hasErrors
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, {
	                  defaultValue: (0, _lodash.get)(company, 'company.timezone.defaultValue', ''),
	                  floatingLabelText: "Time Zone",
	                  errorText: (0, _lodash.get)(company, 'company.timezone.errors[0]'),
	                  onChange: handleChange('company', 'timezone'),
	                  menuItems: timezoneList,
	                  isDirty: isDirty || hasErrors
	                })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'col' })
	        )
	      ),
	      hasErrors && _react2.default.createElement(
	        'div',
	        { className: 'error-message' },
	        'Please fill out missing fields.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'actions' },
	        onDelete && _react2.default.createElement(_Button2.default, {
	          className: 'button-delete',
	          'data-id': 'Delete',
	          label: 'DELETE',
	          onClick: handleDelete()
	        }),
	        _react2.default.createElement(_Button2.default, {
	          className: 'button-cancel button-secondary',
	          'data-id': 'Cancel',
	          label: 'CANCEL',
	          onClick: onClose
	        }),
	        _react2.default.createElement(_Button2.default, {
	          className: 'button-save',
	          'data-id': 'Save',
	          label: 'SAVE',
	          disabled: !isDirty,
	          onClick: handleSave
	        })
	      )
	    )
	  );
	}
	
	var EditCompanyDetails = (_temp = _class = function (_React$Component) {
	  _inherits(EditCompanyDetails, _React$Component);
	
	  function EditCompanyDetails(props, context) {
	    _classCallCheck(this, EditCompanyDetails);
	
	    var _this = _possibleConstructorReturn(this, (EditCompanyDetails.__proto__ || Object.getPrototypeOf(EditCompanyDetails)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var company = props.company;
	
	    var form = {
	      company: (0, _form.mapFormFields)(company, formFields.company.required, formFields.company.optional)
	    };
	
	    _this.state = form;
	    return _this;
	  }
	
	  _createClass(EditCompanyDetails, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.company) {
	        var company = nextProps.company.company;
	
	        var form = {
	          company: (0, _form.mapFormFields)(company, formFields.company.required, formFields.company.optional)
	        };
	
	        this.setState(form);
	      }
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm(form, fields) {
	      (0, _lodash.forEach)(form, function (prop, key) {
	        if (fields.required.includes(key)) {
	          (0, _lodash.set)(form, key + '.errors', (0, _modelValidator.validateFormField)(key, form));
	        }
	      });
	    }
	  }, {
	    key: 'renderConfirmDelete',
	    value: function renderConfirmDelete(state) {
	      var showConfirmDelete = state.showConfirmDelete;
	
	
	      if (showConfirmDelete) {
	        return _react2.default.createElement(
	          _r_Modal2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'route-transition-blocker-transition-block-form' },
	            _react2.default.createElement(_ModalX2.default, { onClick: this.cancelDelete }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'prompt-text' },
	                'Are you really sure you want to delete this company? This action cannot be reversed.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actions' },
	                _react2.default.createElement(_Button2.default, {
	                  className: 'button-cancel button-secondary',
	                  label: 'DO NOT DELETE',
	                  onClick: this.cancelDelete
	                }),
	                _react2.default.createElement(_Button2.default, {
	                  className: 'button-delete',
	                  label: 'DELETE',
	                  onClick: this.performDelete
	                })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'rectangle-behind-modal-form absolute-center' })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var saveEnabled = (0, _lodash.reduce)(this.state, function (enabled, model) {
	        return enabled || (0, _lodash.reduce)(model, function (enable, prop) {
	          return enable || !(0, _lodash.isNil)(prop.value) && (!prop.errors || !prop.errors.length);
	        }, false);
	      }, false);
	
	      var allowedDelete = (0, _lodash.get)(this.props, 'currentUser.roles', []).includes('Admin');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'company-card' },
	        this.renderConfirmDelete(this.state, this.props),
	        _react2.default.createElement(EditCompanyDetailsForm, {
	          company: this.state,
	          website: this.props.website,
	          relationshipManagers: this.props.relationshipManagers,
	          timezoneList: this.props.timezoneList,
	          stateList: this.props.stateList,
	          isDirty: saveEnabled,
	          updateField: this.updateField,
	          saveCompany: this.saveCompany,
	          onClose: this.props.onClose,
	          onDelete: allowedDelete && this.onDelete,
	          hasErrors: this.state.hasErrors
	        })
	      );
	    }
	  }]);
	
	  return EditCompanyDetails;
	}(_react2.default.Component), _class.propTypes = {
	  company: _react.PropTypes.object.isRequired,
	  relationshipManagers: _react.PropTypes.array.isRequired,
	  timezoneList: _react.PropTypes.array.isRequired,
	  stateList: _react.PropTypes.array.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  website: _react.PropTypes.string,
	  currentUser: _react.PropTypes.object
	}, _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.saveCompany = function () {
	
	    var company = (0, _lodash.merge)({}, _this2.state.company);
	
	    _this2.validateForm(company, formFields.company);
	
	    var hasErrors = (0, _form.fieldsHasErrors)(company);
	
	    if (hasErrors) {
	      return _this2.setState({ company: company, hasErrors: hasErrors });
	    }
	
	    var newCompany = (0, _lodash.reduce)(_this2.state, function (updateObj, model, key) {
	      return (0, _lodash.set)(updateObj, key, (0, _lodash.reduce)(model, function (obj, prop, name) {
	        return !(0, _lodash.isNil)((0, _lodash.get)(prop, 'value')) ? (0, _lodash.set)(obj, name, (0, _lodash.get)(prop, 'value')) : obj;
	      }, { id: _this2.props.company.id, companyStatus: _this2.props.company.companyStatus }));
	    }, {});
	
	    _this2.props.dispatch(companyApi.updateCompany(newCompany.company, function (err, data) {
	      if (err) {
	        return console.error(err);
	      }
	      data.company.dateModified = new Date();
	      _this2.props.dispatch(companyStore.updateCompany(data));
	      _this2.props.dispatch(ui.showSnackBar());
	      _this2.props.onClose();
	    }));
	  };
	
	  this.onDelete = function () {
	    _this2.setState({ showConfirmDelete: true });
	  };
	
	  this.updateField = function (event, model, prop, value) {
	    var currentState = (0, _lodash.merge)({}, _this2.state);
	    var newValue = value || event.target.value;
	    var reverted = (0, _lodash.get)(currentState, model + '.' + prop + '.defaultValue') === newValue;
	    var newState = (0, _lodash.set)(currentState, model + '.' + prop + '.value', reverted ? undefined : newValue);
	    (0, _lodash.set)(newState, model + '.' + prop + '.errors', reverted ? null : (0, _modelValidator.validateFormField)(prop, newState[model]));
	    _this2.setState(newState);
	  };
	
	  this.performDelete = function () {
	    var _props = _this2.props,
	        dispatch = _props.dispatch,
	        company = _props.company,
	        onClose = _props.onClose;
	
	    if (company && company.id) {
	      dispatch(companyApi.deleteCompany(company.id, function (err) {
	        if (err) {
	          return console.error(err);
	        }
	
	        onClose();
	        dispatch(ui.showSnackBar('Company ' + company.name + ' has been deleted.'));
	        dispatch((0, _reactRouterRedux.push)('/admin/companies/'));
	      }));
	    }
	  };
	
	  this.cancelDelete = function () {
	    _this2.setState({ showConfirmDelete: false });
	  };
	}, _temp);
	exports.default = EditCompanyDetails;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddContact = __webpack_require__(853);
	
	var _AddContact2 = _interopRequireDefault(_AddContact);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _form = __webpack_require__(168);
	
	var _modelValidator = __webpack_require__(33);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fieldList = ['user.firstName', 'user.lastName', 'profile.title', 'user.email', 'user.address', 'user.city', 'user.state', 'user.zip', 'user.phoneNumber1', 'user.phoneType1', 'user.phoneExtension1', 'profile.department', 'user.timezone', 'profile.types'];
	var labels = ['First Name', 'Last Name', 'Contact Title', 'Email Address', 'Address', 'City', 'State', 'Zip', 'Phone Number', 'Phone Type', 'Extension', 'Department', 'Timezone', 'Type of Contact'];
	
	var fields = {
	  user: {
	    required: ['user.firstName', 'user.lastName', 'user.email', 'user.phoneNumber1', 'user.city', 'user.state']
	  },
	  profile: {
	    required: ['profile.title']
	  }
	};
	
	var NewCompanyContact = (_temp = _class = function (_Component) {
	  _inherits(NewCompanyContact, _Component);
	
	  function NewCompanyContact(props) {
	    _classCallCheck(this, NewCompanyContact);
	
	    var _this = _possibleConstructorReturn(this, (NewCompanyContact.__proto__ || Object.getPrototypeOf(NewCompanyContact)).call(this, props));
	
	    _this.handleUpdate = function (event, prop, value) {
	      var state = (0, _lodash.merge)({}, _this.state, { isDirty: true });
	      (0, _form.updateFormFields)(state, prop, value);
	      _this.validateContactForm(state); // state is modified by this function
	      _this.setState(state);
	    };
	
	    _this.handleCancel = function () {
	      if (_this.props.onClose) {
	        _this.props.onClose();
	      }
	    };
	
	    _this.handleSave = function () {
	      var _this$props = _this.props,
	          dispatch = _this$props.dispatch,
	          company = _this$props.company,
	          contacts = _this$props.contacts;
	
	      var newContact = { user: (0, _form.reduceToValues)(_this.state.user), profile: (0, _form.reduceToValues)(_this.state.profile) };
	      (0, _lodash.set)(newContact, 'profile.companyId', company.id);
	      (0, _lodash.set)(newContact, 'profile.foundUsVia', 55); // Other
	
	      dispatch(companyApi.addCompanyContacts(newContact, function (err, data) {
	        if (err) {
	
	          if (err.status === 'fail') {
	            var hasErrors = !!(0, _lodash.reduce)(_this.state, function (errors, obj) {
	              return errors || (0, _form.fieldsHasErrors)(obj);
	            }, false);
	            var newState = (0, _lodash.merge)({}, _this.state, { isDirty: false, hasErrors: hasErrors });
	
	            if ((0, _lodash.get)(err, 'errors[0].errorMessage', '') === 'User with that email already exists.') {
	              (0, _lodash.set)(newState, 'emailDuplicate', true);
	            }
	
	            _this.setState(newState);
	          }
	          return console.error(err);
	        }
	
	        dispatch(companyStore.updateCompanyContacts([].concat(_toConsumableArray(contacts), [data])));
	        dispatch(ui.showSnackBar(newContact.user.firstName + ' ' + newContact.user.lastName + ' has been added'));
	        _this.handleCancel();
	      }));
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    _this.state = (0, _lodash.merge)({}, (0, _form.mapFormFields)({}, fields.user.required), (0, _form.mapFormFields)({}, fields.profile.required), { isDirty: false, emailDuplicate: false });
	
	    // set default values
	    (0, _lodash.set)(_this.state, 'user.address.value', _this.props.company.address);
	    (0, _lodash.set)(_this.state, 'user.city.value', _this.props.company.city);
	    (0, _lodash.set)(_this.state, 'user.state.value', _this.props.company.state);
	    (0, _lodash.set)(_this.state, 'user.zip.value', _this.props.company.zip);
	    return _this;
	  }
	
	  _createClass(NewCompanyContact, [{
	    key: 'validateContactForm',
	    value: function validateContactForm(formState) {
	      (0, _lodash.forEach)(fields, function (model) {
	        return (0, _lodash.forEach)(model.required, function (field) {
	          return (0, _lodash.set)(formState, field + '.errors', (0, _modelValidator.validateFormField)(field, formState));
	        });
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange() {
	      // set state's dirty status to: true;
	      this.setState((0, _lodash.merge)({}, this.state, { isDirty: true }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'company-card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'worksheet-add-contact-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'add-contact-form' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'heading' },
	              'Add Contact ',
	              _react2.default.createElement(_ModalX2.default, { onClick: this.props.onClose, style: { color: '#000' }, className: 'close-button' })
	            ),
	            _react2.default.createElement(_AddContact2.default, {
	              model: this.state,
	              emailDuplicate: this.state.emailDuplicate,
	              fields: fieldList,
	              labels: labels,
	              staticData: this.props.staticData,
	              hasErrors: this.state.hasErrors,
	              onUpdate: this.handleUpdate,
	              onChange: this.handleChange,
	              onCancel: this.handleCancel,
	              onSave: this.handleSave,
	              disableSave: !this.state.isDirty
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewCompanyContact;
	}(_react.Component), _class.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  company: _react.PropTypes.object.isRequired,
	  contacts: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired
	}, _class.defaultProps = {
	  company: {},
	  contacts: []
	}, _temp);
	exports.default = NewCompanyContact;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyDashboardSubNav = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
	  _inherits(CompanyDashboardSubNav, _React$Component);
	
	  function CompanyDashboardSubNav() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CompanyDashboardSubNav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CompanyDashboardSubNav.__proto__ || Object.getPrototypeOf(CompanyDashboardSubNav)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      currentRoute: '',
	      routes: [{
	        name: 'Profile',
	        path: ''
	      }, {
	        name: 'Contacts',
	        path: 'contacts'
	      }, {
	        name: 'Job Requests',
	        path: 'jobs'
	      }, {
	        name: 'Tech Q&A',
	        path: 'tech'
	      }]
	    }, _this.handleClick = function (destination) {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/' + _this.props.companyId + '/details/' + destination));
	      _this.setState({ currentRoute: destination });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CompanyDashboardSubNav, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setCurrentRoute(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setCurrentRoute(nextProps);
	    }
	  }, {
	    key: 'setCurrentRoute',
	    value: function setCurrentRoute(props) {
	      var currentRoute = props.location.substring(props.location.lastIndexOf('/') + 1);
	      this.setState({ currentRoute: currentRoute });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'company-dashboard-subnav' },
	        (0, _lodash.map)(this.state.routes, function (route, index) {
	          return _react2.default.createElement(
	            'li',
	            {
	              key: index,
	              'data-id': 'company-path-' + index,
	              onClick: function onClick(e) {
	                return _this2.handleClick(route.path);
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: route.path == _this2.state.currentRoute ? 'active' : '' },
	              route.name
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return CompanyDashboardSubNav;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  companyId: _react.PropTypes.number,
	  location: _react.PropTypes.string
	}, _temp2)) || _class);
	exports.default = CompanyDashboardSubNav;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.OnEnterRefreshCompany = OnEnterRefreshCompany;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Details = __webpack_require__(942);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _SubNav = __webpack_require__(946);
	
	var _SubNav2 = _interopRequireDefault(_SubNav);
	
	var _async = __webpack_require__(37);
	
	var asyncActions = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _Worksheet = __webpack_require__(298);
	
	var _Worksheet2 = _interopRequireDefault(_Worksheet);
	
	var _TackIcon = __webpack_require__(205);
	
	var _TackIcon2 = _interopRequireDefault(_TackIcon);
	
	var _employees = __webpack_require__(62);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CompanyWorksheet(props) {
	
	  var companyId = parseInt(props.params.companyId, 10) || 0;
	
	  // pin functions
	  var isPinned = function isPinned() {
	    return _lodash2.default.indexOf((0, _lodash.get)(props.pinnedData, 'companies', []), companyId) >= 0;
	  };
	
	  var handleTogglePin = function handleTogglePin() {
	    return function () {
	      var newPinnedData = props.pinnedData;
	      if (isPinned()) {
	        _lodash2.default.pull(newPinnedData.companies, companyId);
	      } else {
	        (0, _lodash.set)(newPinnedData, 'companies', (0, _lodash.union)((0, _lodash.get)(newPinnedData, 'companies', []), [companyId]));
	      }
	
	      props.dispatch((0, _employees.updatePins)(newPinnedData, function (err, pins) {
	        if (!err) {
	          props.dispatch(syncActions.loadPins(pins));
	        }
	      }));
	    };
	  };
	
	  var pin = _react2.default.createElement(
	    'div',
	    { className: 'pin', onClick: handleTogglePin() },
	    ' ',
	    _react2.default.createElement(_TackIcon2.default, null),
	    ' ',
	    _react2.default.createElement(
	      'span',
	      { className: 'pin-text' },
	      isPinned() ? 'unpin' : 'pin'
	    )
	  );
	
	  return _react2.default.createElement(
	    _Worksheet2.default,
	    {
	      baseRoute: '/admin/companies',
	      dispatch: props.dispatch,
	      location: props.location,
	      pin: pin
	    },
	    _react2.default.createElement(
	      'div',
	      { key: 'Card' },
	      _react2.default.createElement(_Details2.default, { companyId: companyId })
	    ),
	    _react2.default.createElement(
	      'div',
	      { key: 'SubNav' },
	      _react2.default.createElement(_SubNav2.default, { location: props.location.pathname, companyId: companyId })
	    ),
	    props.children
	  );
	}
	
	exports.default = (0, _reactRedux.connect)(function (store) {
	  return {
	    staticData: store.staticData,
	    ui: store.ui,
	    pinnedData: (0, _lodash.get)(store, 'pins.pinned', {})
	  };
	})(CompanyWorksheet);
	function OnEnterRefreshCompany(store) {
	  return function (nextState, replace, cb) {
	
	    var id = _lodash2.default.toNumber(nextState.params.companyId);
	    var state = store.getState();
	    var groups = state.staticData.companyStatus;
	    var getCompanyById = function getCompanyById(companyId) {
	      return store.dispatch(asyncActions.getCompanyById(companyId));
	    };
	    var getCompanyJobRequestsList = function getCompanyJobRequestsList(companyId) {
	      return store.dispatch(jobRequestApi.getCompanyJobRequestsList(companyId));
	    };
	    var getCompanyContacts = function getCompanyContacts(companyId) {
	      return store.dispatch(companyApi.getCompanyContacts(companyId));
	    };
	
	    getCompanyById(id).then(function (data) {
	
	      store.dispatch(syncActions.getCompanyInfo({ company: data.items[0], groups: groups }));
	      return Promise.all([getCompanyJobRequestsList(id), getCompanyContacts(id)]);
	    }).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          jobRequests = _ref2[0],
	          contactsData = _ref2[1];
	
	      store.dispatch(jobRequestStore.updateCompanyJobRequests(jobRequests));
	
	      var contacts = (0, _lodash.get)(contactsData, 'body.data.items', []);
	      store.dispatch(companyStore.updateCompanyContacts(contacts));
	
	      if (cb) {
	        return cb();
	      }
	
	      console.error('cb is undefined.');
	    }).catch(function (err) {
	      return console.error('error update store', err);
	    });
	  };
	}

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ProspectForm = __webpack_require__(473);
	
	var _ProspectForm2 = _interopRequireDefault(_ProspectForm);
	
	var _ScrollColumn = __webpack_require__(297);
	
	var _ScrollColumn2 = _interopRequireDefault(_ScrollColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// utilities
	
	// components
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	function AddContact(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'admin-content-container' },
	    _react2.default.createElement(_ScrollColumn2.default, {
	      navGroups: ['Contact_Info', 'Company_Info', 'Preliminary_Info', 'Inquiry_Reason'],
	      title: 'Add New'
	    }),
	    _react2.default.createElement(_ProspectForm2.default, { asAdmin: true })
	  );
	}
	exports.default = (0, _reactRedux.connect)()(AddContact);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp, _class3, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	var _FlagIcon = __webpack_require__(303);
	
	var _FlagIcon2 = _interopRequireDefault(_FlagIcon);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _StatusDropDown = __webpack_require__(199);
	
	var _StatusDropDown2 = _interopRequireDefault(_StatusDropDown);
	
	var _staticData = __webpack_require__(28);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts2);
	
	var _contacts3 = __webpack_require__(237);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandedCard = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var contactId = parseInt(props.params.contactId, 10) || 0;
	  var contact = (0, _contacts3.findContact)({ profile: { id: contactId } }, (0, _lodash.get)(store.admin.contacts, 'items', []));
	
	  return {
	    staticData: store.staticData,
	    contact: contact,
	    route: {
	      params: props.params,
	      query: props.location.query // actually being from from react-redux-router to regular props
	    } };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ExpandedCard, _Component);
	
	  function ExpandedCard(props, context) {
	    _classCallCheck(this, ExpandedCard);
	
	    var _this = _possibleConstructorReturn(this, (ExpandedCard.__proto__ || Object.getPrototypeOf(ExpandedCard)).call(this, props, context));
	
	    _this.onClose = function (event, currentStatusGroup) {
	      _this.props.dispatch((0, _reactRouterRedux.goBack)());
	    };
	
	    _this.handleStatusChange = function (contactId, companyId) {
	      return function (event, value) {
	        if (value) {
	          _this.props.dispatch(companyApi.updateCompanyStatus(companyId, value, function (err, result) {
	            if (err || !result) {
	              return console.error(err || 'Update failed.');
	            }
	
	            // refresh contact
	            _this.props.dispatch(contactApi.getContact(contactId, function (err, data) {
	              if (err || !data) {
	                return console.error(err || 'Fetch failed.');
	              }
	              _this.props.dispatch(contactStore.updateContact(data));
	            }));
	          }));
	        }
	      };
	    };
	
	    _this.handleTagChange = function (contactId) {
	      return function (event, value) {
	        var doAdd = true;
	        var tagId = -1;
	        var currentTags = _this.props.contact.profile.tags || [];
	        var addedTags = _lodash2.default.difference(value, currentTags);
	
	        if (addedTags.length) {
	          tagId = addedTags[0];
	        } else {
	          var removedTags = _lodash2.default.difference(currentTags, value);
	          tagId = removedTags[0];
	          doAdd = false;
	        }
	
	        var tagRequest = { contactId: contactId, tagId: tagId };
	        var tagCallback = function tagCallback(err, result) {
	          if (err) {
	            return console.error(err || 'Update failed.');
	          }
	
	          var updatedContact = _this.props.contact;
	          var updatedTags = updatedContact.profile.tags || [];
	          if (doAdd) {
	            updatedTags.push(tagId);
	          } else {
	            _lodash2.default.pull(updatedTags, tagId);
	          }
	          updatedContact.profile.tags = updatedTags;
	          var contactData = { contact: updatedContact, group: updatedContact.profile.contactStatusGroup };
	          _this.props.dispatch(contactStore.updateContact(contactData));
	          _this.setState({ tags: updatedTags });
	        };
	
	        var tagAction = doAdd ? contactApi.addTag(contactId, tagRequest, tagCallback) : contactApi.deleteTag(contactId, tagRequest, tagCallback);
	        _this.props.dispatch(tagAction);
	      };
	    };
	
	    _this.handleWorksheetClick = function (event, profileId) {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + profileId + '/details'));
	    };
	
	    _this.handleCompanyClick = function (event, companyId) {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/' + companyId + '/details'));
	      event.stopPropagation();
	    };
	
	    var initialState = {
	      clientAdvisors: _this.props.staticData.clientAdvisers,
	      relationshipManagers: _this.props.staticData.relationshipManagers,
	      expandedStyle: {
	        height: 300,
	        'min-width': 720,
	        width: '70%'
	      },
	      tags: _lodash2.default.get(_this.props.contact, 'profile.tags', [])
	    };
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(ExpandedCard, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _ref = this.props.contact || {},
	          user = _ref.user,
	          profile = _ref.profile,
	          company = _ref.company;
	
	      if (!user) return null;
	      var staticData = this.props.staticData;
	
	      var currentStatus = (0, _staticData.getLookupValue)(staticData, 'contactStatus', { id: profile.contactStatus });
	      var currentStatusGroup = (0, _staticData.getLookupValue)(staticData, 'contactStatusGroups', function (s) {
	        return !!~s.statuses.indexOf(profile.contactStatus);
	      });
	
	      var sanitize = function sanitize(val) {
	        return val || '';
	      };
	      var expand = function expand(type, val) {
	        return sanitize((0, _staticData.lookup)(staticData, type, val));
	      };
	      var formattedAddress = function formattedAddress() {
	        return sanitize(user.city) + ', ' + expand('stateList', { id: user.state }) + ', ' + sanitize(user.zip);
	      };
	
	      var lastUpdated = user ? [user.dateModified, profile.dateModified, user.dateCreated, profile.dateCreated].filter(function (d) {
	        return !!d;
	      }).sort(function (d1, d2) {
	        return _moment2.default.utc(d2).diff(_moment2.default.utc(d1));
	      }).shift() : '';
	      var adviser = this.state.clientAdvisors.find(function (item) {
	        return item.employeeId === profile.clientAdvisorId;
	      });
	      var relationshipMgr = this.state.relationshipManagers.find(function (item) {
	        return item.employeeId === company.relationshipManagerId;
	      });
	
	      var followUpTask = (0, _lodash2.default)(this.props.contact.profile.tasks).filter(function (task) {
	        return task.taskFollowUpDate && !task.closed;
	      }).sortBy(function (task) {
	        return new Date(task.taskFollowUpDate);
	      }).head();
	
	      var contactPhoneType = expand('contactPhoneTypes', { id: user.phoneType1 });
	      return this.props.contact && _react2.default.createElement(
	        _r_Modal2.default,
	        {
	          show: true, fadeModal: true, fadeModalChildren: true, noScroll: true, outsideUnclickable: true,
	          onClose: function onClose(event) {
	            return _this2.onClose(event, currentStatusGroup.name);
	          },
	          transitionDuration: 400,
	          opacityTransitionIn: 'cubic-bezier(0,1,.2,.8)',
	          modalContentClass: (0, _classnames2.default)('expanded-card-container'),
	          className: 'contact-dashboard-expanded-card'
	        },
	        _react2.default.createElement(ModalClose, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'front-card', 'data-id': user.email + ' front', style: this.state.expandedStyle },
	          _react2.default.createElement(
	            'div',
	            { className: 'main-card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-sections' },
	              _react2.default.createElement(
	                'div',
	                { className: 'name-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'full-name', 'data-id': 'Full Name' },
	                  _lodash2.default.capitalize(user.firstName) + ' ' + _lodash2.default.capitalize(user.middleName) + ' ' + _lodash2.default.capitalize(user.lastName)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'contact-col' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title', 'data-id': 'Title' },
	                  profile.title
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'department', 'data-id': 'Department' },
	                  'Department: ',
	                  profile.department
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'client-adviser', 'data-id': 'Client Adviser' },
	                  'Client Adviser: ',
	                  adviser ? adviser.firstName + ' ' + adviser.lastName : ''
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'company', 'data-id': 'Company', onClick: function onClick(event) {
	                      return _this2.handleCompanyClick(event, company.id);
	                    } },
	                  'Company: ',
	                  company.name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'address', 'data-id': 'Address' },
	                  formattedAddress()
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'email', 'data-id': 'Email' },
	                  user.email
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-sections' },
	              _react2.default.createElement(
	                'div',
	                { className: 'contact-status-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'contact-status-section' },
	                  _react2.default.createElement(_StatusDropDown2.default, {
	                    status: currentStatus,
	                    smallDisplay: true,
	                    menuItems: this.props.staticData.companyStatus,
	                    onChange: this.handleStatusChange(profile.id, company.id),
	                    'data-id': 'status'
	                  }),
	                  _react2.default.createElement(_c_CheckList2.default, _defineProperty({
	                    className: 'tag-selector',
	                    'data-id': 'Tag',
	                    persistentLabel: 'Tag',
	                    menuItems: this.props.staticData.contactTags,
	                    defaultValue: profile.tags || [],
	                    popoverStyle: { width: '300px' },
	                    popoverClassName: 'tag-selector-checklist-dropdown',
	                    autoWidth: true,
	                    onChange: this.handleTagChange(profile.id)
	                  }, 'data-id', 'tags'))
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'contact-tags' },
	                _lodash2.default.map(this.state.tags, function (tag) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'contact-tag', 'data-id': 'Contact tag ' + tag },
	                    _react2.default.createElement(_FlagIcon2.default, null),
	                    ' ',
	                    (0, _staticData.lookup)(_this2.props.staticData, 'contactTags', { id: tag })
	                  );
	                }).slice(0, 2),
	                (this.state.tags || []).length > 2 && _react2.default.createElement(
	                  'span',
	                  null,
	                  '...'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'contact-col right' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Timezone: ',
	                  expand('timezoneList', { id: user.timezone })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Date Added: ',
	                  profile.dateCreated ? (0, _moment2.default)(profile.dateCreated).format('L') : sanitize(profile.dateCreated)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Follow Up Date: ',
	                  followUpTask ? (0, _moment2.default)(followUpTask.taskFollowUpDate).format('L') : sanitize(followUpTask)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  user.phoneNumber1 && user.phoneType1 && contactPhoneType + ': ',
	                  (0, _prettyPhone2.default)(user.phoneNumber1),
	                  contactPhoneType === 'Main' && _react2.default.createElement(
	                    'span',
	                    null,
	                    ' Ext: ',
	                    user.phoneExtension1
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'detail-toggle outside-card', 'data-id': 'View Worksheet', onClick: function onClick(event) {
	              return _this2.handleWorksheetClick(event, profile.id);
	            } },
	          'View Worksheet'
	        )
	      ) || _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return ExpandedCard;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  route: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  query: _react.PropTypes.object,
	  params: _react.PropTypes.object // comes from react-redux-router
	}, _temp)) || _class);
	
	// creating separate component as slight hack needed to allow access to animating "closeModal" function in close button
	
	exports.default = ExpandedCard;
	var ModalClose = (_temp2 = _class3 = function (_Component2) {
	  _inherits(ModalClose, _Component2);
	
	  function ModalClose() {
	    _classCallCheck(this, ModalClose);
	
	    var _this3 = _possibleConstructorReturn(this, (ModalClose.__proto__ || Object.getPrototypeOf(ModalClose)).call(this));
	
	    _this3.respondToKeyPress = _this3.respondToKeyPress.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(ModalClose, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.respondToKeyPress);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.respondToKeyPress);
	    }
	  }, {
	    key: 'respondToKeyPress',
	    value: function respondToKeyPress(event) {
	      // escape key response
	      if (event.keyCode === 27 && this.props.closeModal) {
	        if (this.props.removeState && !event.shiftKey) {
	          return this.props.removeState();
	        }
	
	        this.props.closeModal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-close outside-card', 'data-id': 'Close', onClick: this.props.closeModal },
	        'dashboard ',
	        _react2.default.createElement(_CloseX2.default, { style: { color: '#fff' } })
	      );
	    }
	  }]);
	
	  return ModalClose;
	}(_react.Component), _class3.propTypes = {
	  closeModal: _react.PropTypes.func,
	  removeState: _react.PropTypes.any
	}, _temp2);

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	// redux interactions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Search = __webpack_require__(165);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _ContactTable = __webpack_require__(295);
	
	var _ContactTable2 = _interopRequireDefault(_ContactTable);
	
	var _contacts = __webpack_require__(83);
	
	var asyncActionCreator = _interopRequireWildcard(_contacts);
	
	var _index = __webpack_require__(21);
	
	var adminStore = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactManager = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var currentPage = state.admin.contacts.page || 0;
	  var pageSize = state.admin.contacts.pageSize || 25;
	  var skip = currentPage * pageSize;
	  var limit = pageSize;
	
	  return {
	    contacts: state.admin.contacts.items,
	    filters: state.admin.contacts.filters || {},
	    searchTerms: state.admin.contacts.searchTerms || [],
	    total: state.admin.contacts.total,
	    pageSize: pageSize,
	    skip: skip,
	    currentPage: currentPage,
	    limit: limit,
	    staticData: state.staticData,
	    route: {
	      params: props.params
	    }
	  };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(ContactManager, _Component);
	
	  function ContactManager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactManager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactManager.__proto__ || Object.getPrototypeOf(ContactManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tableLayout: _lodash2.default.get(_this.props, 'tableLayout', false)
	    }, _this.handleTableToggle = function () {
	      _this.setState({ tableLayout: !_this.state.tableLayout });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ContactManager, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.searchContacts(this.props.searchTerms, this.props.filters, this.props.skip, this.props.limit); // keep current page
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // separate filters from sorting
	      var filters = _lodash2.default.omit(prevProps.filters, ['order']);
	      var newFilters = _lodash2.default.omit(this.props.filters, ['order']);
	
	      var sortBy = _lodash2.default.pick(prevProps.filters, ['order']);
	      var newSortBy = _lodash2.default.pick(this.props.filters, ['order']);
	
	      var skip = this.props.skip || 0;
	      var limit = this.props.limit || 25;
	
	      // check if filters, sorting, or search terms have changed
	      if (!_lodash2.default.isEqual(sortBy, newSortBy)) {
	        this.props.searchContacts(this.props.searchTerms, _extends({}, newFilters, newSortBy, { skip: skip, limit: limit })); // keep current page
	      }
	
	      if (!_lodash2.default.isEqual(filters, newFilters)) {
	        this.props.searchContacts(this.props.searchTerms, _extends({}, newFilters, newSortBy));
	      }
	
	      if (!_lodash2.default.isEqual(prevProps.searchTerms, this.props.searchTerms)) {
	        this.props.searchContacts(this.props.searchTerms, _extends({}, newFilters));
	      }
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange(page) {
	      var _this2 = this;
	
	      var _props = this.props,
	          pageSize = _props.pageSize,
	          _props$searchTerms = _props.searchTerms,
	          searchTerms = _props$searchTerms === undefined ? [] : _props$searchTerms,
	          _props$filters = _props.filters,
	          filters = _props$filters === undefined ? {} : _props$filters;
	
	
	      var skip = page * pageSize;
	
	      this.props.dispatch(asyncActionCreator.goToPage(skip, pageSize, filters, searchTerms)).then(function () {
	        _this2.props.dispatch(adminStore.goToContactsPage(page));
	      });
	    }
	  }, {
	    key: 'onTermChange',
	    value: function onTermChange() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      this.props.dispatch(adminStore.updateContactsTableSearchTerms(terms));
	      this.resetToPageOne();
	    }
	  }, {
	    key: 'onSort',
	    value: function onSort(fields) {
	      this.props.dispatch(adminStore.updateContactsTableFilters(_extends({}, this.props.filters, fields)));
	    }
	  }, {
	    key: 'resetToPageOne',
	    value: function resetToPageOne() {
	      this.props.dispatch(adminStore.goToContactsPage(0));
	    }
	  }, {
	    key: 'updateContactsFilter',
	    value: function updateContactsFilter(event, key, filterName) {
	      // get current filters
	      var newFilters = _lodash2.default.cloneDeep(this.props.filters) || {};
	
	      // set new filter
	      if (key < 0) {
	        newFilters = _lodash2.default.omit(newFilters, filterName);
	      } else {
	        var filterValue = !_lodash2.default.isUndefined(key) ? _lodash2.default.isNull(key) ? filterName === 'clientAdvisorId' ? 'null' : null : key : _lodash2.default.get(event, 'target.value') || 0;
	
	        _lodash2.default.set(newFilters, filterName, filterValue);
	      }
	
	      // dispatch action to update filters in contacts store
	      this.props.dispatch(adminStore.updateContactsTableFilters(_lodash2.default.omitBy(newFilters, _lodash2.default.isNil)));
	      this.resetToPageOne();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'ul',
	        { className: 'contact-dashboard-contact-manager' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-header' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'CONTACTS'
	          ),
	          _react2.default.createElement(_Search2.default, {
	            onTermChange: this.onTermChange.bind(this),
	            defaultValues: this.props.searchTerms,
	            baseUrl: '/admin/contacts'
	          })
	        ),
	        _react2.default.createElement(_ContactTable2.default, {
	          useContactTypeDropdown: true,
	          contactLink: true,
	          companyLink: true,
	          showFilters: true,
	          contacts: this.props.contacts,
	          updateContactsFilter: this.updateContactsFilter.bind(this),
	          onSort: this.onSort.bind(this),
	          className: 'full-width',
	          minWidth: this.props.minWidth,
	          location: this.props.location,
	          filters: this.props.filters,
	          columns: ['CardName', 'Title', 'Company', 'Phone', 'ContactDate', 'Email', 'Status', 'JobCounts', 'Tags'],
	          total: this.props.total,
	          currentPage: this.props.currentPage,
	          pageSize: this.props.pageSize,
	          handlePageSkip: this.onPageChange.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return ContactManager;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  route: _react.PropTypes.object,
	  query: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  // expandCard: PropTypes.func.isRequired,
	  contacts: _react.PropTypes.any,
	  contactGroups: _react.PropTypes.object,
	  staticData: _react.PropTypes.object,
	  selectedContactId: _react.PropTypes.string,
	  tableLayout: _react.PropTypes.bool,
	  minWidth: _react.PropTypes.string,
	  searchContacts: _react.PropTypes.func,
	  filters: _react.PropTypes.object,
	  searchTerms: _react.PropTypes.array,
	  total: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number,
	  currentPage: _react.PropTypes.number
	}, _temp2)) || _class);
	exports.default = ContactManager;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ContactManager = __webpack_require__(950);
	
	var _ContactManager2 = _interopRequireDefault(_ContactManager);
	
	var _lodash = __webpack_require__(4);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactsDashboard = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  return {
	    user: store.user,
	    contacts: (0, _lodash.get)(store.admin, 'contactInContactWorksheet', {}),
	    route: {
	      params: props.params,
	      query: props.location.query // actually being from from react-redux-router to regular props
	    } };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ContactsDashboard, _Component);
	
	  function ContactsDashboard(props, context) {
	    _classCallCheck(this, ContactsDashboard);
	
	    return _possibleConstructorReturn(this, (ContactsDashboard.__proto__ || Object.getPrototypeOf(ContactsDashboard)).call(this, props, context));
	  }
	
	  _createClass(ContactsDashboard, [{
	    key: 'searchContacts',
	    value: function searchContacts() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var skip = arguments[2];
	      var limit = arguments[3];
	
	      this.props.dispatch(asyncActionCreator.searchContacts(terms, filters, skip, limit));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'contact-dashboard' },
	        _react2.default.createElement(_ContactManager2.default, {
	          selectedContactId: this.props.route.params.contactId,
	          minWidth: '1700px',
	          searchContacts: this.searchContacts.bind(this),
	          location: this.props.location.pathname
	        }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ContactsDashboard;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  route: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  query: _react.PropTypes.object,
	  params: _react.PropTypes.object, // comes from react-redux-router
	  user: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ContactsDashboard;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp, _initialiseProps;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _modelValidator = __webpack_require__(33);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts2);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _staticData = __webpack_require__(170);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var message = 'This field is required.';
	var required = { message: message };
	
	function ProfilePanelForm(props) {
	  var profile = props.profile,
	      contactTypes = props.contactTypes,
	      foundUsViaList = props.foundUsViaList,
	      onChange = props.onChange,
	      onSave = props.onSave,
	      saveDisabled = props.saveDisabled,
	      labels = props.labels;
	
	
	  function handleChange(field) {
	    return function (event, value, primaryText) {
	      onChange && onChange(event, field, value);
	      // primaryText && onSave && onSave(event);
	    };
	  }
	
	  function handleSave() {
	    onSave ? onSave(event) : null;
	  }
	
	  var otherfoundUsVia = (0, _lodash.get)((0, _lodash.find)(foundUsViaList, { name: 'Other, Please Specify:' }), 'id');
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'contact-worksheet-profile' },
	    _react2.default.createElement(
	      'div',
	      { className: 'grid grid-worksheet-profile' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col' },
	          _react2.default.createElement(_c_TextField2.default, {
	            value: (0, _lodash.get)(profile, 'title.value'),
	            floatingLabelText: "Contact Title",
	            errorText: (0, _lodash.get)(profile, 'title.errors[0]'),
	            onChange: handleChange('title'),
	            'data-id': 'title'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col' },
	          _react2.default.createElement(_c_TextField2.default, {
	            value: (0, _lodash.get)(profile, 'department.value'),
	            floatingLabelText: "Department",
	            errorText: (0, _lodash.get)(profile, 'department.errors[0]'),
	            onChange: handleChange('department'),
	            'data-id': 'department'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col' },
	          _react2.default.createElement(_c_CheckList2.default, {
	            value: (0, _lodash.get)(profile, 'types.value'),
	            floatingLabelText: "Contact Type",
	            errorText: (0, _lodash.get)(profile, 'types.errors[0]'),
	            onBlur: handleChange('types'),
	            menuItems: contactTypes,
	            'data-id': 'type'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col' },
	          _react2.default.createElement(_c_DropDownMenu2.default, {
	            className: 'profile-foundusvia',
	            value: (0, _lodash.get)(profile, 'foundUsVia.value'),
	            floatingLabelText: labels.foundUsVia,
	            errorText: (0, _lodash.get)(profile, 'foundUsVia.errors[0]'),
	            onChange: handleChange('foundUsVia'),
	            menuItems: foundUsViaList,
	            'data-id': 'foundUsVia'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col' },
	          (0, _lodash.get)(profile, 'foundUsVia.value') === otherfoundUsVia && _react2.default.createElement(_c_TextField2.default, {
	            floatingLabelText: 'Please Specify',
	            value: (0, _lodash.get)(profile, 'foundUsOther.value'),
	            errorText: (0, _lodash.get)(profile, 'foundUsOther.errors[0]'),
	            onChange: handleChange('foundUsOther'),
	            'data-id': 'foundUsOther'
	          })
	        ),
	        _react2.default.createElement('div', { className: 'col' })
	      )
	    ),
	    _react2.default.createElement(
	      'label',
	      { className: 'textarea-label' },
	      'Initial Inquiry Reason'
	    ),
	    _react2.default.createElement(_c_TextArea2.default, {
	      value: (0, _lodash.get)(profile, 'initialInquiry.value'),
	      errorText: (0, _lodash.get)(profile, 'initialInquiry.errors[0]'),
	      onChange: handleChange('initialInquiry'),
	      'data-id': 'initial-inquiry'
	    }),
	    _react2.default.createElement(
	      'label',
	      { className: 'textarea-label' },
	      'Initial Sales Notes'
	    ),
	    _react2.default.createElement(_c_TextArea2.default, {
	      value: (0, _lodash.get)(profile, 'salesNotes.value'),
	      errorText: (0, _lodash.get)(profile, 'salesNotes.errors[0]'),
	      onChange: handleChange('salesNotes'),
	      'data-id': 'initial-sales'
	    }),
	    _react2.default.createElement(
	      'label',
	      { className: 'textarea-label' },
	      'General Comments'
	    ),
	    _react2.default.createElement(_c_TextArea2.default, {
	      value: (0, _lodash.get)(profile, 'generalComments.value'),
	      errorText: (0, _lodash.get)(profile, 'generalComments.errors[0]'),
	      onChange: handleChange('generalComments'),
	      'data-id': 'general-comments'
	    }),
	    _react2.default.createElement(_Button2.default, {
	      disabled: saveDisabled,
	      className: 'button-main-large',
	      'data-id': 'Save',
	      label: 'Save',
	      onClick: handleSave
	    })
	  );
	}
	
	var ProfilePanel = (_dec = (0, _reactRedux.connect)(function (store) {
	  var contact = (0, _lodash.get)(store.admin, 'contactInContactWorksheet', {});
	  var _store$staticData = store.staticData,
	      foundUsViaList = _store$staticData.foundUsViaList,
	      contactTypes = _store$staticData.contactTypes;
	
	
	  return {
	    foundUsViaList: (0, _staticData.referralsByRole)(foundUsViaList, 'C'),
	    contactTypes: contactTypes,
	    contact: contact,
	    labels: (0, _lodash.get)(store, 'labels.WorksheetProfilePanel', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ProfilePanel, _React$Component);
	
	  function ProfilePanel(props, context) {
	    _classCallCheck(this, ProfilePanel);
	
	    var _this = _possibleConstructorReturn(this, (ProfilePanel.__proto__ || Object.getPrototypeOf(ProfilePanel)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var _ref = props.contact || {},
	        _ref$profile = _ref.profile,
	        profile = _ref$profile === undefined ? {} : _ref$profile;
	
	    var currentState = function currentState() {
	      return _this.state;
	    };
	
	    _this.state = {
	      title: {
	        value: profile.title,
	        required: required
	      },
	      department: {
	        value: profile.department,
	        required: required
	      },
	      types: {
	        value: profile.types,
	        required: required
	      },
	      foundUsVia: {
	        value: profile.foundUsVia,
	        required: required
	      },
	      foundUsOther: {
	        value: profile.foundUsOther,
	        custom: {
	          func: function func(val) {
	            return (0, _lodash.get)(currentState(), 'foundUsVia.value', 0) !== 55 || val;
	          },
	          message: message
	        }
	      },
	      initialInquiry: {
	        value: profile.initialInquiry
	      },
	      salesNotes: {
	        value: profile.salesNotes
	      },
	      generalComments: {
	        value: profile.generalComments
	      },
	      saveDisabled: true
	    };
	    return _this;
	  }
	
	  _createClass(ProfilePanel, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(ProfilePanelForm, {
	        saveDisabled: this.state.saveDisabled,
	        profile: this.state,
	        foundUsViaList: this.props.foundUsViaList,
	        contactTypes: this.props.contactTypes,
	        onChange: this.handleUpdateField,
	        onSave: this.handleSubmitForm,
	        labels: this.props.labels
	      });
	    }
	  }]);
	
	  return ProfilePanel;
	}(_react2.default.Component), _class2.propTypes = {
	  foundUsViaList: _react.PropTypes.array.isRequired,
	  contact: _react.PropTypes.shape({
	    profile: _react.PropTypes.object.isRequired,
	    user: _react.PropTypes.object,
	    company: _react.PropTypes.object
	  }).isRequired,
	  labels: _react.PropTypes.object
	}, _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleUpdateField = function (event, field, value) {
	    var newState = (0, _lodash.set)((0, _lodash.merge)({}, _this2.state), field + '.value', value || event.target.value);
	    (0, _lodash.set)(newState, 'saveDisabled', false);
	    (0, _lodash.set)(newState, field + '.errors', (0, _modelValidator.validateFormField)(field, newState));
	    _this2.setState(newState);
	  };
	
	  this.handleSubmitForm = function (event) {
	    var profile = (0, _lodash.reduce)(_this2.state, function (obj, prop, key) {
	      obj[key] = prop ? prop.value : undefined;
	      return obj;
	    }, { id: _this2.props.contact.profile.id });
	    var user = { id: _this2.props.contact.user.id };
	    var company = { id: _this2.props.contact.company.id };
	
	    _this2.props.dispatch(contactApi.updateContact({ profile: profile, user: user, company: company }, function (err, data) {
	      if (err) {
	        return console.error(err);
	      } else {
	        _this2.props.dispatch(ui.showSnackBar('Your work has been saved'));
	      }
	
	      // refresh contact
	      _this2.props.dispatch(contactApi.getContact(profile.id, function (err, data) {
	        if (err || !data) {
	          return console.error(err || 'Fetch failed.');
	        }
	        _this2.props.dispatch(contactStore.updateContactInContactWorksheet(data));
	      }));
	    }));
	    _this2.setState({ saveDisabled: true });
	  };
	}, _temp)) || _class);
	exports.default = ProfilePanel;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	// get validations
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _contactNote = __webpack_require__(906);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validationObj = (0, _contactNote.getSchema)();
	
	var AddNoteForm = (_temp2 = _class = function (_Component) {
	  _inherits(AddNoteForm, _Component);
	
	  function AddNoteForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddNoteForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddNoteForm.__proto__ || Object.getPrototypeOf(AddNoteForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      noteDropDownVal: null, // some statuses will have corresponding dropdowns
	      note: _this.props.value || '',
	      errorCount: 0
	    }, _this.onErrorChange = function (changeInt) {
	      _this.setState(_lodash2.default.merge(_this.state, { errorCount: _this.state.errorCount + changeInt }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddNoteForm, [{
	    key: 'onChange',
	    value: function onChange(prop, event, value) {
	      this.setState(_lodash2.default.merge({}, this.state, _defineProperty({}, prop, value || event.target.value)));
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	      this.props.submitNote({
	        contactId: this.props.contactId,
	        contactStatusId: this.props.contactStatusId,
	        category: this.props.category,
	        note: this.state.note,
	        type: 'note'
	      });
	      this.clear();
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.setState(_lodash2.default.merge({}, {
	        noteDropDownVal: null,
	        note: ''
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var contactStatusKeyById = _lodash2.default.keyBy(this.props.staticData.contactStatus, 'id');
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'event-form notes-form' },
	        _react2.default.createElement(_c_TextArea2.default, {
	          className: 'note-textarea',
	          'data-id': 'Note Text',
	          style: {
	            minHeight: '145px'
	          },
	          description: _lodash2.default.get(contactStatusKeyById, this.props.contactStatusId + '.name') + ' Notes',
	          onChange: this.onChange.bind(this, 'note'),
	          onErrorChange: this.onErrorChange,
	          placeholder: 'Note contents...',
	          value: this.state.note,
	          validation: validationObj.note
	        }),
	        _react2.default.createElement(_c_FlatButton2.default, { disabled: !this.state.note || this.state.errorCount > 0,
	          onClick: this.onSave.bind(this),
	          className: 'save-btn',
	          label: 'Save',
	          disabledStyle: {
	            color: '#979797',
	            backgroundColor: '#fff'
	          },
	          labelStyle: {
	            width: 'auto',
	            padding: 0
	          } })
	      );
	    }
	  }]);
	
	  return AddNoteForm;
	}(_react.Component), _class.propTypes = {
	  contactId: _react.PropTypes.number.isRequired,
	  contactStatusId: _react.PropTypes.number.isRequired,
	  submitNote: _react.PropTypes.func.isRequired,
	  category: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object,
	  value: _react.PropTypes.string.isRequired
	}, _temp2);
	exports.default = AddNoteForm;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	// get validations
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _contactTask = __webpack_require__(908);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validationObj = (0, _contactTask.getSchema)();
	
	var dropDownProps = {
	  style: {
	    height: '45px',
	    width: '100%',
	    fontSize: '14.5px',
	    textTransform: 'none',
	    textAlign: 'left'
	  },
	  labelStyle: {
	    padding: 0
	  },
	  listStyle: {
	    width: '260px'
	  },
	  menuStyle: {
	    width: '260px'
	  },
	  underlineStyle: {
	    margin: 0,
	    borderTopWidth: '1px'
	  },
	  iconStyle: {
	    right: 0
	  }
	};
	
	var AddTaskForm = (_temp2 = _class = function (_Component) {
	  _inherits(AddTaskForm, _Component);
	
	  function AddTaskForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddTaskForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddTaskForm.__proto__ || Object.getPrototypeOf(AddTaskForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      noteType: _lodash2.default.get(_this.props.item, 'noteTypeId'),
	      taskType: _lodash2.default.get(_this.props.item, 'taskTypeId'),
	      taskResultType: _lodash2.default.get(_this.props.item, 'taskResultId'),
	      resultTypeOther: _lodash2.default.get(_this.props.item, 'taskResultOther'),
	      message: _lodash2.default.get(_this.props.item, 'message'),
	      taskFollowUpDate: _lodash2.default.get(_this.props.item, 'taskFollowUpDate'),
	      closed: _lodash2.default.get(_this.props.item, 'closed', false),
	      saveDisabled: true,
	      errorCount: 0
	    }, _this.onErrorChange = function (changeInt) {
	      _this.setState(_lodash2.default.merge(_this.state, { errorCount: _this.state.errorCount + changeInt }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddTaskForm, [{
	    key: 'onChange',
	    value: function onChange(prop, event, value) {
	      var newState = _lodash2.default.merge({}, this.state, _defineProperty({}, prop, value || (event.target || {}).value));
	
	      if (newState.taskResultType !== this.props.taskResultTypes[this.props.taskResultTypes.length - 1].id) {
	        newState.resultTypeOther = '';
	      }
	
	      if (prop === 'taskType' && newState.taskType === 3) {
	        // If followup
	        newState.taskResultType = null;
	        newState.resultTypeOther = null;
	      }
	
	      if (prop === 'closed') {
	        newState.closed = !value;
	      }
	
	      // @TODO update this to match other validation
	      newState.saveDisabled = _lodash2.default.isNil(newState.taskType) || newState.taskType !== 3 && _lodash2.default.isNil(newState.taskResultType) || newState.taskType === 3 && _lodash2.default.isNil(newState.taskFollowUpDate) || newState.taskResultType === this.props.taskResultTypes[this.props.taskResultTypes.length - 1].id && !newState.resultTypeOther;
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	      var _this2 = this;
	
	      var resultText = this.state.taskType === 3 ? 'Follow up on ' + (0, _moment2.default)(this.state.taskFollowUpDate).format('L') : (_lodash2.default.find(this.props.taskResultTypes, { id: this.state.taskResultType }) || {}).name;
	
	      var taskTypeName = _lodash2.default.get(this.props.taskTypes.find(function (type) {
	        return type.id === _this2.state.taskType;
	      }), 'name', null);
	      var taskObj = {
	        contactId: this.props.contactId,
	        contactStatusId: this.props.contactStatusId,
	        isNote: _lodash2.default.get(this.props, 'isNote', false),
	        noteTypeId: this.state.noteType,
	        taskTypeId: this.state.taskType,
	        taskResultId: this.state.taskResultType,
	        taskResultName: resultText,
	        taskFollowUpDate: this.state.taskFollowUpDate,
	        closed: this.state.closed,
	        message: this.state.message,
	        type: 'task',
	        taskTypeName: taskTypeName
	      };
	
	      this.props.submitTask(taskObj);
	      this.clear();
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.setState(_lodash2.default.merge({}, {
	        taskType: null,
	        taskResultType: null,
	        resultTypeOther: null
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'event-form task-form' },
	        !_lodash2.default.get(this.props, 'isNote', false) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'type-dropdown task-dropdown',
	            floatingLabelText: 'Type of Task',
	            floatingLabelStyle: { left: 0 },
	            value: this.state.taskType,
	            onChange: this.onChange.bind(this, 'taskType'),
	            menuItems: this.props.taskTypes,
	            'data-id': 'type of task'
	          }, dropDownProps)),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'type-dropdown task-result',
	            floatingLabelText: 'Result',
	            floatingLabelStyle: { left: 0 },
	            value: this.state.taskResultType,
	            onChange: this.onChange.bind(this, 'taskResultType'),
	            menuItems: this.props.taskResultTypes,
	            'data-id': 'result dropdown'
	          }, dropDownProps)),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('follow-up-form', 'center-column-1') },
	            _react2.default.createElement(
	              'div',
	              { className: 'label' },
	              'Follow Up Date'
	            ),
	            _react2.default.createElement(_DateInput2.default, {
	              autoOk: true,
	              'data-id': 'follow-up-date',
	              defaultValue: this.state.taskFollowUpDate,
	              value: this.state.taskFollowUpDate,
	              onChange: this.onChange.bind(this, 'taskFollowUpDate')
	            })
	          ),
	          _react2.default.createElement(_c_ToggleButton2.default, {
	            'data-id': 'task-open',
	            className: 'center-column-1',
	            menuItems: [{ value: true, primaryText: 'Open' }, { value: false, primaryText: 'Closed' }],
	            value: !this.state.closed,
	            onChange: this.onChange.bind(this, 'closed')
	          })
	        ) || _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'type-dropdown task-dropdown',
	            'data-id': 'note type',
	            floatingLabelText: 'Note Type',
	            floatingLabelStyle: { left: 0 },
	            value: this.state.noteType,
	            onChange: this.onChange.bind(this, 'noteType'),
	            menuItems: this.props.taskTypes
	          }, dropDownProps))
	        ),
	        _react2.default.createElement(_c_TextArea2.default, {
	          className: 'note-textarea',
	          'data-id': 'Note Text',
	          style: {
	            minHeight: '145px'
	          },
	          description: 'Comments',
	          onChange: this.onChange.bind(this, 'message'),
	          onErrorChange: this.onErrorChange,
	          placeholder: 'Note contents...',
	          value: this.state.message,
	          validation: validationObj.message
	        }),
	        _react2.default.createElement(_Button2.default, { disabled: this.state.errorCount > 0,
	          'data-id': 'save button',
	          onClick: this.onSave.bind(this),
	          className: 'button-secondary-full',
	          label: 'Save',
	          disabledStyle: {
	            color: '#979797',
	            backgroundColor: '#fff'
	          },
	          labelStyle: {
	            width: 'auto',
	            padding: 0
	          } })
	      );
	    }
	  }]);
	
	  return AddTaskForm;
	}(_react.Component), _class.propTypes = {
	  submitTask: _react.PropTypes.func,
	  taskTypes: _react.PropTypes.array,
	  taskResultTypes: _react.PropTypes.array,
	  contactId: _react.PropTypes.number,
	  contactStatusId: _react.PropTypes.number.isRequired,
	  item: _react.PropTypes.object
	}, _temp2);
	exports.default = AddTaskForm;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EventsList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _staticData = __webpack_require__(28);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyDate2 = _interopRequireDefault(_prettyDate);
	
	var _prettyTime = __webpack_require__(465);
	
	var _prettyTime2 = _interopRequireDefault(_prettyTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EventsList(props) {
	  var _this = this;
	
	  var contactStatusKeyById = _lodash2.default.keyBy(props.staticData.contactStatus, 'id');
	
	  function click(index, list) {
	    props.handleClick(index, list);
	  }
	
	  function toggle(index) {
	    props.toggleNoteMessage(index);
	  }
	
	  return _react2.default.createElement(
	    'ol',
	    {
	      'data-id': 'Event List',
	      className: 'event-list'
	
	    },
	    props.list.map(function (event, eventIndex) {
	      return _react2.default.createElement(
	        'div',
	        {
	          'data-id': 'Event List Item ' + eventIndex,
	          className: (0, _classnames2.default)('event-list-item', { 'note-item': event.isNote, 'task-item': !event.isNote }),
	          key: eventIndex
	        },
	        _react2.default.createElement('div', {
	          className: 'event-status',
	          style: {
	            backgroundColor: _lodash2.default.get(contactStatusKeyById, event.contactStatusId + '.color') || '#4a4a4a'
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'event-timestamp' },
	          _react2.default.createElement(
	            'div',
	            { className: 'event-header' },
	            _react2.default.createElement(
	              'div',
	              { 'data-id': 'Event Date', className: 'event-date noTextSelect' },
	              (0, _prettyDate2.default)(new Date(event.dateCreated))
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              event.taskTypeName && event.taskTypeName
	            ),
	            !event.isNote && _react2.default.createElement(
	              'div',
	              {
	                'data-id': 'Event Open',
	                className: 'event-open noTextSelect'
	              },
	              event.closed ? 'Closed' : 'Open'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              'data-id': 'Event Time',
	              className: 'event-time noTextSelect hover-link',
	              onClick: click.bind(_this, eventIndex, props.list)
	            },
	            event.isNote ? (0, _staticData.lookup)(props.staticData, 'contactNoteTypes', { id: event.noteTypeId }) : (0, _staticData.lookup)(props.staticData, 'contactTaskResultTypes', { id: event.taskResultId }),
	            ' ',
	            (0, _prettyTime2.default)(new Date(event.dateCreated))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'event-content' },
	          _react2.default.createElement(
	            'div',
	            {
	              'data-id': 'Event Description',
	              className: 'event-description noTextSelect',
	              onClick: toggle.bind(_this, eventIndex)
	            },
	            !event.closed && event.taskTypeId && event.taskTypeId !== 3 && !_lodash2.default.isNil(event.taskFollowUpDate) ? 'Follow up on ' + (0, _moment2.default)(event.taskFollowUpDate).format('L') : '',
	            event.note ? event.dateModified ? 'Note Edited' : 'Note Added' : ''
	          ),
	          event.message && _react2.default.createElement(
	            'div',
	            {
	              'data-id': 'Note Sub-Description',
	              className: 'note-details noTextSelect'
	            },
	            _react2.default.createElement(
	              'pre',
	              null,
	              event.message
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'event-author note-details' },
	            '- ',
	            event.createdBy.name || props.user.firstName + ' ' + props.user.lastName
	          )
	        )
	      );
	    })
	  );
	}
	
	// utilities
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	EventsList.propTypes = {
	  list: _react.PropTypes.array,
	  state: _react.PropTypes.object,
	  category: _react.PropTypes.string,
	  contactStatusId: _react.PropTypes.number,
	  staticData: _react.PropTypes.object
	};
	
	EventsList.defaultProps = {
	  list: [],
	  state: {}
	};

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// Redux stuff
	
	
	// utilities
	
	
	// Async actions
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyDate2 = _interopRequireDefault(_prettyDate);
	
	var _async = __webpack_require__(37);
	
	var _EventsList = __webpack_require__(955);
	
	var _EventsList2 = _interopRequireDefault(_EventsList);
	
	var _AddTaskForm = __webpack_require__(954);
	
	var _AddTaskForm2 = _interopRequireDefault(_AddTaskForm);
	
	var _AddNoteForm = __webpack_require__(953);
	
	var _AddNoteForm2 = _interopRequireDefault(_AddNoteForm);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// gives dispatch function
	var Events = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var contact = (0, _lodash.get)(store.admin, 'contactInContactWorksheet', {});
	  var taskTypes = store.staticData.applicantTaskTypeList;
	  var noteTypes = store.staticData.contactNoteTypes;
	  var taskResultTypes = store.staticData.contactTaskResultTypes;
	
	  return {
	    staticData: store.staticData,
	    user: store.user,
	    contact: contact,
	    taskTypes: taskTypes,
	    noteTypes: noteTypes,
	    taskResultTypes: taskResultTypes,
	    submitContactEvent: _async.submitContactEvent
	  };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Events, _Component);
	
	  function Events() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Events);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Events.__proto__ || Object.getPrototypeOf(Events)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      show: 'tasks',
	      addEventToggled: false,
	      addType: 'task',
	      itemId: '',
	      editMode: false,
	      showNoteDetails: {},
	      sortField: 'dateCreated',
	      sortDescending: true
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Events, [{
	    key: 'toggleShow',
	    value: function toggleShow(show) {
	      this.state.noteText = '';
	      this.state.item = null;
	      this.state.addType = 'task';
	
	      if (show === undefined) {
	        show = 'tasks';
	      }
	
	      this.setState(_lodash2.default.merge({}, this.state, {
	        show: show
	      }));
	    }
	  }, {
	    key: 'toggleSort',
	    value: function toggleSort(sortField) {
	      if (this.state.sortField === sortField) {
	        this.setState(_lodash2.default.merge({}, this.state, {
	          sortDescending: !this.state.sortDescending
	        }));
	      } else {
	        this.setState(_lodash2.default.merge({}, this.state, {
	          sortField: sortField,
	          sortDescending: true
	        }));
	      }
	    }
	  }, {
	    key: 'toggleAdd',
	    value: function toggleAdd() {
	      this.setState(_lodash2.default.merge({}, this.state, {
	        addEventToggled: !this.state.addEventToggled
	      }));
	    }
	  }, {
	    key: 'toggleNoteMessage',
	    value: function toggleNoteMessage(index) {
	      var showNoteDetails = this.state.showNoteDetails;
	      if (_lodash2.default.isNil(showNoteDetails[index])) {
	        showNoteDetails[index] = false;
	      }
	      showNoteDetails[index] = !this.state.showNoteDetails[index];
	
	      this.setState(_lodash2.default.merge({}, this.state, {
	        showNoteDetails: showNoteDetails
	      }));
	    }
	  }, {
	    key: 'selectAddType',
	    value: function selectAddType(val) {
	      this.setState(_lodash2.default.merge({}, this.state, {
	        addType: val
	      }));
	    }
	  }, {
	    key: 'submitTask',
	    value: function submitTask(task) {
	
	      if (this.state.editMode) {
	        task.taskId = this.state.itemId;
	        this.props.dispatch(this.props.submitContactEvent('tasks', task, { type: 'edit', param: this.state.itemId }));
	      } else {
	        this.props.dispatch(this.props.submitContactEvent('tasks', task));
	      }
	
	      this.state.itemId = '';
	      this.state.editMode = false;
	      this.state.noteText = '';
	      this.state.item = null;
	      this.toggleAdd();
	    }
	  }, {
	    key: 'submitNote',
	    value: function submitNote(note) {
	
	      if (this.state.editMode) {
	        note.noteId = this.state.itemId;
	        this.props.dispatch(this.props.submitContactEvent('notes', note, { type: 'edit', param: this.state.itemId }));
	      } else {
	        this.props.dispatch(this.props.submitContactEvent('notes', note));
	      }
	
	      this.state.itemId = '';
	      this.state.editMode = false;
	      this.state.noteText = '';
	      this.state.item = null;
	      this.toggleAdd();
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(index, list) {
	      if (list[index].type === 'note') {
	        this.state.addType = 'note';
	        this.state.item = list[index];
	        this.state.editMode = true;
	        this.toggleAdd();
	      } else {
	        if (list[index].type === 'task') {
	          this.state.addType = 'task';
	          this.state.item = list[index];
	          this.state.itemId = list[index].id;
	          this.state.editMode = true;
	          this.state.show = list[index].isNote ? 'notes' : 'tasks';
	          this.toggleAdd();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // yank vars off state
	      var addEventToggled = this.state.addEventToggled;
	
	      // combine event properties and sort by date
	
	      var eventList = (0, _lodash2.default)([]).concat(_lodash2.default.get(this.props.contact, 'profile.tasks') || []).concat(_lodash2.default.get(this.props.contact, 'profile.notes') || []).concat(_lodash2.default.get(this.props.contact, 'profile.notifications') || []).orderBy(['dateCreated'], ['desc']).orderBy([this.state.sortField], [this.state.sortDescending ? 'desc' : 'asc']).value();
	
	      var alertsStyle = {
	        height: global.innerHeight - 50
	      };
	
	      // TODO: Reserved if client wants to associate notes to sections.
	      var catgoryDescription = 'Profile';
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('contact-worksheet-events', 'clearfix', { 'hide-note': !(this.state.show === 'notes' || this.state.show === 'all'), 'hide-task': !(this.state.show === 'tasks' || this.state.show === 'all') }), style: alertsStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'alerts-nav' },
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'Tasks',
	              className: (0, _classnames2.default)('alerts-nav-item', { 'selected': this.state.show === 'tasks' }),
	              onClick: this.toggleShow.bind(this, 'tasks') },
	            _react2.default.createElement(
	              'div',
	              { className: 'alerts-nav-text' },
	              'Tasks'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'Notes',
	              className: (0, _classnames2.default)('alerts-nav-item', { 'selected': this.state.show === 'notes' }),
	              onClick: this.toggleShow.bind(this, 'notes') },
	            _react2.default.createElement(
	              'div',
	              { className: 'alerts-nav-text' },
	              'Notes'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'All',
	              className: (0, _classnames2.default)('alerts-nav-item', { 'selected': this.state.show === 'all' }),
	              onClick: this.toggleShow.bind(this, 'all') },
	            _react2.default.createElement(
	              'div',
	              { className: 'alerts-nav-text' },
	              'All'
	            )
	          )
	        ),
	        addEventToggled && _react2.default.createElement(
	          'div',
	          { className: 'add-event-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'event-heading-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { 'data-id': 'Add Task', className: (0, _classnames2.default)('add-event-text', 'task', 'noTextSelect', 'active-add') },
	              _react2.default.createElement(_CloseX2.default, { 'data-id': 'Close', className: 'plus noTextSelect add-event-close', onClick: this.toggleAdd.bind(this) })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'add-event-form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'current-date' },
	              (0, _prettyDate2.default)(new Date())
	            ),
	            this.state.show === 'tasks' && _react2.default.createElement(_AddTaskForm2.default, {
	              contactId: this.props.contact.profile.id,
	              contactStatusId: this.props.contact.profile.contactStatus,
	              isNote: false,
	              submitTask: this.submitTask.bind(this),
	              taskTypes: this.props.taskTypes,
	              taskResultTypes: this.props.taskResultTypes,
	              item: this.state.item
	            }),
	            this.state.show === 'notes' && _react2.default.createElement(_AddTaskForm2.default, {
	              contactId: this.props.contact.profile.id,
	              contactStatusId: this.props.contact.profile.contactStatus,
	              isNote: true,
	              submitTask: this.submitTask.bind(this),
	              taskTypes: this.props.noteTypes,
	              taskResultTypes: this.props.taskResultTypes,
	              item: this.state.item
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('event-container', { toggled: addEventToggled }) },
	          this.state.show !== 'all' && _react2.default.createElement(
	            'div',
	            { 'data-id': 'Add Event',
	              className: (0, _classnames2.default)('add-event', { toggled: addEventToggled }),
	              onClick: !addEventToggled && this.toggleAdd.bind(this) },
	            this.state.show === 'tasks' && _react2.default.createElement(_Button2.default, {
	              className: 'button-secondary-full',
	              label: 'Add Task'
	            }),
	            this.state.show === 'notes' && _react2.default.createElement(_Button2.default, {
	              className: 'button-secondary-full',
	              label: 'Add Note'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'notes-filter-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'notes-sort' },
	              (this.state.show === 'tasks' || this.state.show === 'all') && _react2.default.createElement(
	                'div',
	                { 'data-id': 'Follow Up Date', className: 'sort-field follow-up-date', onClick: this.toggleSort.bind(this, 'taskFollowUpDate') },
	                'Follow Up Date',
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('chevron', {
	                      descending: this.state.sortField === 'taskFollowUpDate' && this.state.sortDescending,
	                      ascending: this.state.sortField === 'taskFollowUpDate' && !this.state.sortDescending
	                    })
	                  },
	                  _react2.default.createElement(_ChevronIcon2.default, null)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'data-id': 'Updated Date', className: 'sort-field updated-date', onClick: this.toggleSort.bind(this, 'dateCreated') },
	                'Added Date',
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('chevron', {
	                      descending: this.state.sortField === 'dateCreated' && this.state.sortDescending,
	                      ascending: this.state.sortField === 'dateCreated' && !this.state.sortDescending
	                    })
	                  },
	                  _react2.default.createElement(_ChevronIcon2.default, null)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_EventsList2.default, {
	            list: eventList,
	            state: this.state,
	            user: this.props.user,
	            category: catgoryDescription,
	            contactStatusId: _lodash2.default.get(this.props.contact, 'profile.contactStatus'),
	            staticData: this.props.staticData,
	            handleClick: this.handleClick.bind(this),
	            toggleNoteMessage: this.toggleNoteMessage.bind(this)
	          })
	        )
	      );
	    }
	  }]);
	
	  return Events;
	}(_react.Component), _class2.propTypes = {
	  submitContactEvent: _react.PropTypes.func.isRequired,
	  contactId: _react.PropTypes.number.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  show: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  taskTypes: _react.PropTypes.array,
	  taskResultTypes: _react.PropTypes.array,
	  alertsList: _react.PropTypes.array,
	  route: _react.PropTypes.object.isRequired
	}, _temp2)) || _class);
	exports.default = Events;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable object-shorthand,prefer-const,no-unused-vars,no-console */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactTooltip = __webpack_require__(409);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _staticData = __webpack_require__(28);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts2);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _StatusDropDown = __webpack_require__(199);
	
	var _StatusDropDown2 = _interopRequireDefault(_StatusDropDown);
	
	var _EmailIcon = __webpack_require__(886);
	
	var _EmailIcon2 = _interopRequireDefault(_EmailIcon);
	
	var _EditIcon = __webpack_require__(203);
	
	var _EditIcon2 = _interopRequireDefault(_EditIcon);
	
	var _FlagIcon = __webpack_require__(303);
	
	var _FlagIcon2 = _interopRequireDefault(_FlagIcon);
	
	var _TransferItemOwnershipDialogIcon = __webpack_require__(459);
	
	var _TransferItemOwnershipDialogIcon2 = _interopRequireDefault(_TransferItemOwnershipDialogIcon);
	
	var _EditDetails = __webpack_require__(958);
	
	var _EditDetails2 = _interopRequireDefault(_EditDetails);
	
	var _Emails = __webpack_require__(965);
	
	var _Emails2 = _interopRequireDefault(_Emails);
	
	var _JobRequestTransferOwnership = __webpack_require__(959);
	
	var _JobRequestTransferOwnership2 = _interopRequireDefault(_JobRequestTransferOwnership);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _employees = __webpack_require__(62);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MODES = {
	  empty: 0,
	  view: 1,
	  edit: 2
	};
	
	var ContactDetails = (_dec = (0, _reactRedux.connect)(function (store) {
	  // users "entire" roles, not just names
	  var userRoles = store.staticData.employeeRoles.filter(function (role) {
	    return store.user.roles.includes(role.name);
	  });
	  // roles allowed to transfer
	  var requiredRoles = store.staticData.employeeRoles.filter(function (role) {
	    return role.hardcodelink === 'SYSTEM_ADMINISTRATOR' || role.hardcodelink === 'EMPLOYEE';
	  });
	  // ensure that user has all the required roles to transfer
	  var transferButtonAllowed = requiredRoles.every(function (role) {
	    return userRoles.includes(role);
	  });
	  return {
	    staticData: store.staticData,
	    currentUser: store.user,
	    contact: (0, _lodash.get)(store.admin, 'contactInContactWorksheet', {}),
	    showTransferOwnershipButton: transferButtonAllowed
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ContactDetails, _React$Component);
	
	  function ContactDetails(props, context) {
	    _classCallCheck(this, ContactDetails);
	
	    var _this = _possibleConstructorReturn(this, (ContactDetails.__proto__ || Object.getPrototypeOf(ContactDetails)).call(this, props, context));
	
	    _this.toggleJobRequestTransferOwnershipModal = function () {
	      _this.setState(_extends({}, _this.state, { showJobRequestTransferOwnershipModal: !_this.state.showJobRequestTransferOwnershipModal }));
	      _reactTooltip2.default.rebuild();
	    };
	
	    _this.toggleEmailModal = function () {
	      _this.setState(_extends({}, _this.state, { showEmail: !_this.state.showEmail }));
	      _reactTooltip2.default.rebuild();
	    };
	
	    _this.handleJobRequestTransferOwnership = function () {
	      return _this.toggleJobRequestTransferOwnershipModal();
	    };
	
	    _this.handleEmail = function () {
	      return _this.toggleEmailModal();
	    };
	
	    _this.handleEdit = function () {
	      return _this.switchModes(MODES.edit);
	    };
	
	    _this.handleClose = function () {
	      return _this.switchModes();
	    };
	
	    _this.handleStatusChange = function (contactId, companyId) {
	      return function (event, value) {
	        if (value) {
	          _this.props.dispatch(companyApi.updateCompanyStatus(companyId, value, function (err, result) {
	            if (err || !result) {
	              return console.error(err || 'Update failed.');
	            }
	
	            // refresh contact
	            _this.props.dispatch(contactApi.getContact(contactId, function (err, data) {
	              if (err || !data) {
	                return console.error(err || 'Fetch failed.');
	              }
	              _this.props.dispatch(contactStore.updateContactInContactWorksheet(data));
	            }));
	          }));
	        }
	      };
	    };
	
	    _this.handleTagChange = function (contactId) {
	      return function (event, value) {
	        var doAdd = true;
	        var tagId = -1;
	        var currentTags = _this.props.contact.profile.tags || [];
	        var addedTags = _lodash2.default.difference(value, currentTags);
	
	        if (addedTags.length) {
	          tagId = addedTags[0];
	        } else {
	          var removedTags = _lodash2.default.difference(currentTags, value);
	          tagId = removedTags[0];
	          doAdd = false;
	        }
	
	        var tagRequest = { contactId: contactId, tagId: tagId };
	        var tagCallback = function tagCallback(err, result) {
	          if (err) {
	            return console.error(err || 'Update failed.');
	          }
	
	          var updatedContact = _this.props.contact;
	          var updatedTags = updatedContact.profile.tags || [];
	          if (doAdd) {
	            updatedTags.push(tagId);
	          } else {
	            _lodash2.default.pull(updatedTags, tagId);
	          }
	          updatedContact.profile.tags = updatedTags;
	          var contactData = { contact: updatedContact, group: updatedContact.profile.contactStatusGroup };
	          _this.props.dispatch(contactStore.updateContactInContactWorksheet(contactData));
	          _this.setState({ tags: updatedTags });
	        };
	
	        var tagAction = doAdd ? contactApi.addTag(contactId, tagRequest, tagCallback) : contactApi.deleteTag(contactId, tagRequest, tagCallback);
	        _this.props.dispatch(tagAction);
	      };
	    };
	
	    var mode = props.contact ? MODES.view : MODES.empty;
	    var initialState = {
	      mode: mode,
	      clientAdvisors: _this.props.staticData.clientAdvisers,
	      relationshipManagers: _this.props.staticData.relationshipManagers,
	      showEmail: false,
	      tags: (0, _lodash.get)(_this.props.contact, 'profile.tags', []),
	      showJobRequestTransferOwnershipModal: false
	    };
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(ContactDetails, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'switchModes',
	    value: function switchModes() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MODES.view;
	
	      this.setState(_extends({}, this.state, { mode: mode }));
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView(showEmail, showJobRequestTransferOwnershipModal) {
	      var _this2 = this;
	
	      var _ref = this.props.contact || {},
	          _ref$user = _ref.user,
	          user = _ref$user === undefined ? {} : _ref$user,
	          _ref$profile = _ref.profile,
	          profile = _ref$profile === undefined ? {} : _ref$profile,
	          _ref$company = _ref.company,
	          company = _ref$company === undefined ? {} : _ref$company;
	
	      var staticData = this.props.staticData;
	
	      var currentStatus = (0, _staticData.getLookupValue)(staticData, 'companyStatus', { id: (0, _lodash.get)(company, 'companyStatus') });
	      var sanitize = function sanitize(val) {
	        return val || '';
	      };
	      var expand = function expand(type, val) {
	        return sanitize((0, _staticData.lookup)(staticData, type, val));
	      };
	      var formattedAddress = function formattedAddress() {
	        return '' + sanitize(user.address) + (user.address2 ? ' ' + user.address2 : '') + '\n                                    ' + sanitize(user.city) + ', ' + expand('stateList', { id: user.state }) + ', ' + sanitize(user.zip);
	      };
	      var lastUpdated = [user.dateModified, profile.dateModified, user.dateCreated, profile.dateCreated].filter(function (d) {
	        return !!d;
	      }).sort(function (d1, d2) {
	        return _moment2.default.utc(d2).diff(_moment2.default.utc(d1));
	      }).shift();
	      var adviser = this.state.clientAdvisors.find(function (item) {
	        return item.employeeId === profile.clientAdvisorId;
	      });
	      var relationshipMgr = this.state.relationshipManagers.find(function (item) {
	        return item.employeeId === company.relationshipManagerId;
	      });
	
	      var followUpTask = (0, _lodash2.default)((0, _lodash.get)(profile, 'tasks', [])).filter(function (task) {
	        return task.taskFollowUpDate && !task.closed;
	      }).sortBy(function (task) {
	        return new Date(task.taskFollowUpDate);
	      }).head();
	
	      var mainPhone = (0, _lodash.find)(staticData.contactPhoneTypes, { name: 'Main' });
	      var mainPhoneId = (0, _lodash.get)(mainPhone, 'id');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'view-contact-card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-col1' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            user.firstName + ' ' + user.lastName
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Client Adviser: ',
	            adviser ? adviser.firstName + ' ' + adviser.lastName : ''
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Relationship Manager: ',
	            relationshipMgr ? relationshipMgr.firstName + ' ' + relationshipMgr.lastName : ''
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Company: ',
	            _react2.default.createElement(
	              'span',
	              { className: 'hover-link', onClick: function onClick(e) {
	                  return _this2.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/' + company.id + '/details'));
	                } },
	              sanitize(company.name)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            user.email
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            formattedAddress()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-col2' },
	          _react2.default.createElement(
	            'div',
	            null,
	            expand('timezoneList', { id: user.timezone })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Contact Date: ',
	            profile.dateCreated ? (0, _moment2.default)(profile.dateCreated).format('L') : sanitize(profile.dateCreated)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Last Updated: ',
	            (0, _moment2.default)(lastUpdated).format('L')
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Follow Up: ',
	            followUpTask ? (0, _moment2.default)(followUpTask.taskFollowUpDate).format('L') : sanitize(followUpTask)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            user.phoneNumber1 && user.phoneType1 && expand('contactPhoneTypes', { id: user.phoneType1 }) + ': ',
	            user.phoneNumber1 && (0, _prettyPhone2.default)(user.phoneNumber1),
	            user.phoneType1 === mainPhoneId && user.phoneExtension1 && ' ext ' + user.phoneExtension1
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            user.phoneNumber2 && user.phoneType2 && expand('contactPhoneTypes', { id: user.phoneType2 }) + ': ',
	            user.phoneNumber2 && (0, _prettyPhone2.default)(user.phoneNumber2),
	            user.phoneType2 === mainPhoneId && user.phoneExtension2 && ' ext ' + user.phoneExtension2
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contact-col3' },
	          _react2.default.createElement(
	            'div',
	            { className: 'contact-status-section' },
	            _react2.default.createElement(_StatusDropDown2.default, {
	              status: currentStatus,
	              smallDisplay: true,
	              menuItems: this.props.staticData.companyStatus,
	              onChange: this.handleStatusChange(profile.id, company.id),
	              'data-id': 'status'
	            }),
	            _react2.default.createElement(_c_CheckList2.default, {
	              className: 'tag-selector',
	              'data-id': 'Tag',
	              persistentLabel: 'Tag',
	              menuItems: this.props.staticData.contactTags,
	              defaultValue: profile.tags || [],
	              popoverStyle: { width: '300px' },
	              popoverClassName: 'tag-selector-checklist-dropdown',
	              autoWidth: true,
	              onChange: this.handleTagChange(profile.id)
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'contact-tags' },
	            _lodash2.default.map(this.state.tags, function (tag) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'contact-tag', 'data-id': 'Contact tag ' + tag },
	                _react2.default.createElement(_FlagIcon2.default, null),
	                ' ',
	                (0, _staticData.lookup)(_this2.props.staticData, 'contactTags', { id: tag })
	              );
	            })
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'ul',
	            { className: 'buttons' },
	            this.props.showTransferOwnershipButton && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { 'data-id': 'Transfer Icon', tooltip: 'Transfer Job Requests', tooltipPosition: 'bottom-center', onClick: this.handleJobRequestTransferOwnership },
	                _react2.default.createElement(_TransferItemOwnershipDialogIcon2.default, { onClick: this.handleJobRequestTransferOwnership })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { 'data-id': 'Edit Icon', tooltip: 'Edit', tooltipPosition: 'bottom-center', onClick: this.handleEdit },
	                _react2.default.createElement(_EditIcon2.default, { onClick: this.handleEdit })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { 'data-id': 'Email Icon', tooltip: 'Email', tooltipPosition: 'bottom-center', onClick: this.handleEmail },
	                _react2.default.createElement(_EmailIcon2.default, null)
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'job-counts' },
	              _react2.default.createElement(
	                'div',
	                { 'data-tip': 'Total Job Requests', className: (0, _classnames2.default)('large total-circle', { 'empty-circle': profile.jobs === 0 }) },
	                profile.jobs > 99 ? '99+' : profile.jobs
	              )
	            ),
	            profile.jobsPlaced > 0 && _react2.default.createElement(
	              'li',
	              { className: 'job-counts' },
	              _react2.default.createElement(
	                'div',
	                { 'data-tip': 'Job Requests Placed', className: 'large placed-circle' },
	                profile.jobsPlaced > 99 ? '99+' : profile.jobsPlaced
	              )
	            ),
	            profile.jobsApproved > 0 && _react2.default.createElement(
	              'li',
	              { className: 'job-counts' },
	              _react2.default.createElement(
	                'div',
	                { 'data-tip': 'Job Requests Approved', className: 'large approved-circle' },
	                profile.jobsApproved > 99 ? '99+' : profile.jobsApproved
	              )
	            ),
	            profile.jobsSubmitted > 0 && _react2.default.createElement(
	              'li',
	              { className: 'job-counts' },
	              _react2.default.createElement(
	                'div',
	                { 'data-tip': 'Job Requests Submitted', className: 'large submitted-circle' },
	                profile.jobsSubmitted > 99 ? '99+' : profile.jobsSubmitted
	              )
	            )
	          )
	        ),
	        this.props.showTransferOwnershipButton && showJobRequestTransferOwnershipModal && _react2.default.createElement(_JobRequestTransferOwnership2.default, {
	          contact: this.props.contact,
	          dispatch: this.props.dispatch,
	          onClose: this.toggleJobRequestTransferOwnershipModal,
	          staticData: this.props.staticData
	        }),
	        showEmail && _react2.default.createElement(_Emails2.default, {
	          contact: this.props.contact,
	          dispatch: this.props.dispatch,
	          onClose: this.toggleEmailModal })
	      );
	    }
	  }, {
	    key: 'renderEdit',
	    value: function renderEdit() {
	      return _react2.default.createElement(_EditDetails2.default, {
	        contact: this.props.contact,
	        clientAdvisors: this.state.clientAdvisors,
	        relationshipManagers: this.state.relationshipManagers,
	        timezoneList: this.props.staticData.timezoneList,
	        stateList: this.props.staticData.stateList,
	        contactPhoneTypes: this.props.staticData.contactPhoneTypes,
	        dispatch: this.props.dispatch,
	        onClose: this.handleClose,
	        currentUser: this.props.currentUser
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'contact-worksheeet-details' },
	        this.state.mode === MODES.view && this.renderView(this.state.showEmail, this.state.showJobRequestTransferOwnershipModal) || this.state.mode === MODES.edit && this.renderEdit(),
	        _react2.default.createElement(_reactTooltip2.default, null)
	      );
	    }
	  }]);
	
	  return ContactDetails;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  currentUser: _react.PropTypes.object,
	  showTransferOwnershipButton: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = ContactDetails;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modelValidator = __webpack_require__(33);
	
	var _staticData = __webpack_require__(28);
	
	var _form = __webpack_require__(168);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts2);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formFields = {
	  user: {
	    required: ['firstName', 'lastName', 'email'],
	    optional: ['dateModified', 'phoneNumber1', 'phoneType1', 'phoneNumber2', 'phoneType2', 'address', 'address2', 'city', 'state', 'zip', 'timezone', 'phoneExtension1', 'phoneExtension2']
	  },
	  profile: {
	    required: ['clientAdvisorId'],
	    optional: ['dateModified', 'dateCreated']
	  },
	  company: {
	    required: ['name'],
	    optional: []
	  }
	};
	
	function EditContactDetailsForm(props) {
	  var _ref = props || {},
	      updateField = _ref.updateField,
	      onClose = _ref.onClose,
	      saveContact = _ref.saveContact,
	      contact = _ref.contact,
	      clientAdvisors = _ref.clientAdvisors,
	      timezoneList = _ref.timezoneList,
	      stateList = _ref.stateList,
	      contactPhoneTypes = _ref.contactPhoneTypes,
	      isDirty = _ref.isDirty,
	      tasks = _ref.tasks,
	      hasEditRights = _ref.hasEditRights;
	
	  function handleChange(model, prop) {
	    return function (event, value) {
	      return updateField(event, model, prop, value);
	    };
	  }
	
	  function handleSave(event) {
	    saveContact && saveContact(event);
	  }
	
	  var sanitize = function sanitize(val) {
	    return val || '';
	  };
	  var lastUpdated = [(0, _lodash.get)(contact, 'user.dateModified.defaultValue'), (0, _lodash.get)(contact, 'profile.dateModified.defaultValue'), (0, _lodash.get)(contact, 'user.dateCreated.defaultValue'), (0, _lodash.get)(contact, 'profile.dateCreated.defaultValue')].filter(function (d) {
	    return !!d;
	  }).sort(function (d1, d2) {
	    return _moment2.default.utc(d2).diff(_moment2.default.utc(d1));
	  }).shift();
	
	  var followUpTask = (0, _lodash2.default)(tasks).filter(function (task) {
	    return task.taskFollowUpDate && new Date(task.taskFollowUpDate) - Date.now() > 0;
	  }).sortBy(function (task) {
	    return new Date(task.taskFollowUpDate);
	  }).head();
	
	  var mainPhone = (0, _lodash.find)(contactPhoneTypes, { name: 'Main' });
	  var mainPhoneId = (0, _lodash.get)(mainPhone, 'id');
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'contact-worksheet-edit-details topmodal' },
	    _react2.default.createElement(_ModalX2.default, { onClick: onClose }),
	    _react2.default.createElement(
	      'div',
	      { className: 'topmodal-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'grid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  defaultValue: (0, _lodash.get)(contact, 'user.firstName.defaultValue'),
	                  floatingLabelText: "First Name",
	                  floatingLabelFixed: true,
	                  isDirty: isDirty,
	                  errorText: (0, _lodash.get)(contact, 'user.firstName.errors[0]'),
	                  onBlur: handleChange('user', 'firstName'),
	                  'data-id': 'firstName'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  defaultValue: (0, _lodash.get)(contact, 'user.lastName.defaultValue'),
	                  floatingLabelText: "Last Name",
	                  floatingLabelFixed: true,
	                  errorText: (0, _lodash.get)(contact, 'user.lastName.errors[0]'),
	                  onBlur: handleChange('user', 'lastName'),
	                  'data-id': 'lastName'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'col' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-3' },
	            _react2.default.createElement(_c_DropDownMenu2.default, {
	              defaultValue: (0, _lodash.get)(contact, 'profile.clientAdvisorId.defaultValue'),
	              floatingLabelText: "Client Adviser",
	              errorText: (0, _lodash.get)(contact, 'profile.clientAdvisorId.errors[0]'),
	              onChange: handleChange('profile', 'clientAdvisorId'),
	              menuItems: (0, _staticData.convertEmployeeToMenuItems)(clientAdvisors),
	              'data-id': 'clientAdvisor'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _moment2.default)((0, _lodash.get)(contact, 'profile.dateCreated.defaultValue')).format('L'),
	              floatingLabelFixed: true,
	              floatingLabelText: "Contacted Date",
	              disabled: true,
	              'data-id': 'dateCreated'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-3' },
	            _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _lodash.get)(contact, 'company.name.defaultValue'),
	              floatingLabelText: "Company",
	              floatingLabelFixed: true,
	              isDirty: isDirty,
	              errorText: (0, _lodash.get)(contact, 'company.name.errors[0]'),
	              onBlur: handleChange('company', 'name'),
	              disabled: !hasEditRights,
	              'data-id': 'name'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _moment2.default)(lastUpdated).format('L'),
	              floatingLabelFixed: true,
	              floatingLabelText: "Last Updated",
	              disabled: true,
	              'data-id': 'dateModified'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-3' },
	            _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _lodash.get)(contact, 'user.email.defaultValue'),
	              floatingLabelFixed: true,
	              floatingLabelText: "Email",
	              errorText: (0, _lodash.get)(contact, 'user.email.errors[0]'),
	              onBlur: handleChange('user', 'email'),
	              disabled: !hasEditRights,
	              'data-id': 'email'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: followUpTask ? (0, _moment2.default)(followUpTask.taskFollowUpDate).format('L') : sanitize(followUpTask),
	              floatingLabelFixed: true,
	              floatingLabelText: "Follow Up",
	              disabled: true,
	              'data-id': 'taskFollowUpDate'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  defaultValue: (0, _lodash.get)(contact, 'user.address.defaultValue'),
	                  floatingLabelFixed: true,
	                  isDirty: isDirty,
	                  floatingLabelText: "Address Line 1",
	                  errorText: (0, _lodash.get)(contact, 'user.address.errors[0]'),
	                  onBlur: handleChange('user', 'address'),
	                  'data-id': 'address'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  defaultValue: (0, _lodash.get)(contact, 'user.address2.defaultValue'),
	                  floatingLabelFixed: true,
	                  isDirty: isDirty,
	                  floatingLabelText: "Address Line 2",
	                  errorText: (0, _lodash.get)(contact, 'user.address2.errors[0]'),
	                  onBlur: handleChange('user', 'address2'),
	                  'data-id': 'address2'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_DropDownMenu2.default, {
	              defaultValue: (0, _lodash.get)(contact, 'user.timezone.defaultValue'),
	              floatingLabelText: "Time Zone",
	              errorText: (0, _lodash.get)(contact, 'user.timezone.errors[0]'),
	              onChange: handleChange('user', 'timezone'),
	              menuItems: timezoneList,
	              'data-id': 'timezone'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, {
	                  defaultValue: (0, _lodash.get)(contact, 'user.city.defaultValue'),
	                  floatingLabelText: "City",
	                  floatingLabelFixed: true,
	                  errorText: (0, _lodash.get)(contact, 'user.city.errors[0]'),
	                  onBlur: handleChange('user', 'city'),
	                  'data-id': 'city'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, {
	                  defaultValue: (0, _lodash.get)(contact, 'user.state.defaultValue'),
	                  floatingLabelText: "State",
	                  errorText: (0, _lodash.get)(contact, 'user.state.errors[0]'),
	                  onChange: handleChange('user', 'state'),
	                  menuItems: stateList,
	                  'data-id': 'state'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _lodash.get)(contact, 'user.zip.defaultValue'),
	              floatingLabelText: "Zip Code",
	              floatingLabelFixed: true,
	              errorText: (0, _lodash.get)(contact, 'user.zip.errors[0]'),
	              onBlur: handleChange('user', 'zip'),
	              'data-id': 'zip',
	              maxLength: '5'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_MaskedTextField2.default, {
	                  mask: '(999) 999-9999',
	                  hideMaskChar: true,
	                  defaultValue: (0, _lodash.get)(contact, 'user.phoneNumber1.defaultValue'),
	                  floatingLabelText: "Phone Number",
	                  floatingLabelFixed: true,
	                  isDirty: isDirty,
	                  errorText: (0, _lodash.get)(contact, 'user.phoneNumber1.errors[0]'),
	                  onBlur: handleChange('user', 'phoneNumber1'),
	                  'data-id': 'phoneNumber1'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, {
	                  defaultValue: (0, _lodash.get)(contact, 'user.phoneType1.defaultValue'),
	                  errorText: (0, _lodash.get)(contact, 'user.phoneType1.errors[0]'),
	                  onBlur: handleChange('user', 'phoneType1'),
	                  menuItems: contactPhoneTypes,
	                  'data-id': 'phoneType1'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            (0, _lodash.get)(contact, 'user.phoneType1.value') === mainPhoneId && _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _lodash.get)(contact, 'user.phoneExtension1.defaultValue'),
	              floatingLabelText: "Extension",
	              floatingLabelFixed: true,
	              errorText: (0, _lodash.get)(contact, 'user.phoneExtension1.errors[0]'),
	              onBlur: handleChange('user', 'phoneExtension1'),
	              'data-id': 'phoneExtension1'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_MaskedTextField2.default, {
	                  mask: '(999) 999-9999',
	                  hideMaskChar: true,
	                  defaultValue: (0, _lodash.get)(contact, 'user.phoneNumber2.defaultValue'),
	                  floatingLabelText: "Phone Number",
	                  floatingLabelFixed: true,
	                  isDirty: isDirty,
	                  errorText: (0, _lodash.get)(contact, 'user.phoneNumber2.errors[0]'),
	                  onBlur: handleChange('user', 'phoneNumber2'),
	                  'data-id': 'phoneNumber2'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, {
	                  defaultValue: (0, _lodash.get)(contact, 'user.phoneType2.defaultValue'),
	                  errorText: (0, _lodash.get)(contact, 'user.phoneType2.errors[0]'),
	                  onBlur: handleChange('user', 'phoneType2'),
	                  menuItems: contactPhoneTypes,
	                  'data-id': 'phoneType2'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            (0, _lodash.get)(contact, 'user.phoneType2.value') === mainPhoneId && _react2.default.createElement(_c_TextField2.default, {
	              defaultValue: (0, _lodash.get)(contact, 'user.phoneExtension2.defaultValue'),
	              floatingLabelText: "Extension",
	              floatingLabelFixed: true,
	              errorText: (0, _lodash.get)(contact, 'user.phoneExtension2.errors[0]'),
	              onBlur: handleChange('user', 'phoneExtension2'),
	              'data-id': 'phoneExtension2'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'actions' },
	        _react2.default.createElement(_Button2.default, {
	          className: 'button-save',
	          'data-id': 'Save-Contact',
	          label: 'Save',
	          disabled: !isDirty,
	          onClick: handleSave
	        })
	      )
	    )
	  );
	}
	
	var EditContactDetails = (_temp = _class = function (_React$Component) {
	  _inherits(EditContactDetails, _React$Component);
	
	  function EditContactDetails(props, context) {
	    _classCallCheck(this, EditContactDetails);
	
	    var _this = _possibleConstructorReturn(this, (EditContactDetails.__proto__ || Object.getPrototypeOf(EditContactDetails)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var _props$contact = props.contact,
	        user = _props$contact.user,
	        profile = _props$contact.profile,
	        company = _props$contact.company;
	
	
	    var form = {
	      user: (0, _form.mapFormFields)(user, formFields.user.required, formFields.user.optional),
	      profile: (0, _form.mapFormFields)(profile, formFields.profile.required, formFields.profile.optional),
	      company: (0, _form.mapFormFields)(company, formFields.company.required, formFields.company.optional)
	    };
	
	    // phone number hacks for now since this seems to be an old style form not using the actual schema
	    // TODO: change form to use schema instead of mapFormFields
	    (0, _lodash.set)(form.user.phoneNumber1, 'isLength', { options: { min: 10, max: 10 }, message: 'Must be 10 digits' });
	    (0, _lodash.set)(form.user.phoneNumber2, 'isLength', { options: { min: 10, max: 10 }, message: 'Must be 10 digits' });
	    (0, _lodash.set)(form.user.email, 'isEmail', { message: 'Must be a valid email.' });
	
	    _this.state = form;
	    return _this;
	  }
	
	  _createClass(EditContactDetails, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.contact) {
	        var _nextProps$contact = nextProps.contact,
	            user = _nextProps$contact.user,
	            profile = _nextProps$contact.profile,
	            company = _nextProps$contact.company;
	
	        var form = {
	          user: (0, _form.mapFormFields)(user, formFields.user.required, formFields.user.optional),
	          profile: (0, _form.mapFormFields)(profile, formFields.profile.required, formFields.profile.optional),
	          company: (0, _form.mapFormFields)(company, formFields.company.required, formFields.profile.optional)
	        };
	
	        // phone number hacks for now since this seems to be an old style form not using the actual schema
	        (0, _lodash.set)(form.user.phoneNumber1, 'isLength', { options: { min: 10, max: 10 }, message: 'Must be 10 digits' });
	        (0, _lodash.set)(form.user.phoneNumber2, 'isLength', { options: { min: 10, max: 10 }, message: 'Must be 10 digits' });
	        (0, _lodash.set)(form.user.email, 'isEmail', { message: 'Must be a valid email.' });
	        this.setState(form);
	      }
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm(form, fields) {
	      (0, _lodash.forEach)(form, function (prop, key) {
	        if (fields.required.includes(key)) {
	          (0, _lodash.set)(form, key + '.errors', (0, _modelValidator.validateFormField)(key, form));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var saveEnabled = (0, _lodash.reduce)(this.state, function (enabled, model) {
	        return enabled || (0, _lodash.reduce)(model, function (enable, prop) {
	          return enable || !(0, _lodash.isNil)(prop.value) && (!prop.errors || !prop.errors.length);
	        }, false);
	      }, false);
	
	      var hasEditRights = this.props.currentUser.roles.includes('Admin') || this.props.currentUser.id === (0, _lodash.get)(this.props.contact, 'profile.createdBy', 0);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-contact-container' },
	        _react2.default.createElement(EditContactDetailsForm, {
	          contact: this.state,
	          clientAdvisors: this.props.clientAdvisors,
	          timezoneList: this.props.timezoneList,
	          stateList: this.props.stateList,
	          contactPhoneTypes: this.props.contactPhoneTypes,
	          isDirty: saveEnabled,
	          updateField: this.updateField,
	          saveContact: this.saveContact,
	          onClose: this.props.onClose,
	          tasks: this.props.contact.profile.tasks,
	          hasEditRights: hasEditRights
	        })
	      );
	    }
	  }]);
	
	  return EditContactDetails;
	}(_react2.default.Component), _class.propTypes = {
	  contact: _react.PropTypes.object.isRequired,
	  clientAdvisors: _react.PropTypes.array.isRequired,
	  timezoneList: _react.PropTypes.array.isRequired,
	  stateList: _react.PropTypes.array.isRequired,
	  contactPhoneTypes: _react.PropTypes.array.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  currentUser: _react.PropTypes.object
	}, _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.updateField = function (event, model, prop, value) {
	    var currentState = (0, _lodash.merge)({}, _this2.state);
	    var newValue = value || event.target.value;
	    var isDirty = (0, _lodash.get)(currentState, model + '.' + prop + '.defaultValue') === newValue;
	    var newState = (0, _lodash.set)(currentState, model + '.' + prop + '.value', newValue);
	    if (isDirty) {
	      _this2.setState(newState);
	      return;
	    }
	
	    (0, _lodash.set)(newState, model + '.' + prop + '.errors', (0, _modelValidator.validateFormField)(prop, newState[model]));
	    _this2.setState(newState);
	  };
	
	  this.saveContact = function () {
	    var _merge = (0, _lodash.merge)({}, _this2.state),
	        company = _merge.company,
	        profile = _merge.profile,
	        user = _merge.user;
	
	    _this2.validateForm(company, formFields.company);
	    _this2.validateForm(profile, formFields.profile);
	    _this2.validateForm(user, formFields.user);
	
	    var hasErrors = (0, _form.fieldsHasErrors)(company) || (0, _form.fieldsHasErrors)(profile) || (0, _form.fieldsHasErrors)(user);
	
	    if (hasErrors) {
	      return _this2.setState({ company: company, profile: profile, user: user });
	    }
	
	    var newContact = (0, _lodash.reduce)(_this2.state, function (updateObj, model, key) {
	      return (0, _lodash.set)(updateObj, key, (0, _lodash.reduce)(model, function (obj, prop, name) {
	        return !(0, _lodash.isNil)((0, _lodash.get)(prop, 'value')) ? (0, _lodash.set)(obj, name, (0, _lodash.get)(prop, 'value')) : obj;
	      }, { id: _this2.props.contact[key].id }));
	    }, {});
	
	    _this2.props.dispatch(contactApi.updateContact(newContact, function (err, data) {
	      if (err) {
	        var customError = _lodash2.default.get(err, 'body.data.items[0]');
	        if (_lodash2.default.get(customError, 'errorCode') === 'DUPLICATE_EMAIL') {
	          var currentState = (0, _lodash.merge)({}, _this2.state);
	          var newState = (0, _lodash.set)(currentState, 'user.email.errors[0]', customError.message);
	          _this2.setState(newState);
	        }
	
	        return console.err(err);
	      }
	
	      _this2.props.dispatch(contactStore.updateContactInContactWorksheet(data));
	      if (_this2.props.onClose) {
	        _this2.props.onClose();
	      }
	
	      _this2.props.dispatch(ui.showSnackBar());
	    }));
	  };
	}, _temp);
	exports.default = EditContactDetails;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint-disable no-unused-vars,no-console,no-else-return,object-shorthand */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticData = __webpack_require__(28);
	
	var _employees = __webpack_require__(62);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _jobrequests = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests2);
	
	var _lodash = __webpack_require__(4);
	
	var _ui = __webpack_require__(26);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TransferItemOwnershipIcon = __webpack_require__(460);
	
	var _TransferItemOwnershipIcon2 = _interopRequireDefault(_TransferItemOwnershipIcon);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestTransferOwnership = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    pinnedJobRequests: state.pins.jobRequests
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(JobRequestTransferOwnership, _Component);
	
	  function JobRequestTransferOwnership(props, context) {
	    _classCallCheck(this, JobRequestTransferOwnership);
	
	    var _this = _possibleConstructorReturn(this, (JobRequestTransferOwnership.__proto__ || Object.getPrototypeOf(JobRequestTransferOwnership)).call(this, props, context));
	
	    _this.handleClose = function (event) {
	      // Close Dialog
	      _this.props.onClose && _this.props.onClose(event);
	    };
	
	    _this.handleConfirmTransfer = function (row) {
	      _this.setState({ showTransitionBlocker: true, rowToMove: row });
	    };
	
	    _this.handleTransferJobRequest = function () {
	      // update jr with contact profile id (this.props.contact.profile.id)
	      var jrToUpdate = { id: _this.state.rowToMove.id, primaryContactId: _this.props.contact.profile.id };
	      _this.props.dispatch(jobRequestApi.updateJobRequest(_this.props.contact.profile.id, jrToUpdate, function (err, updatedJR) {
	        if (err || !updatedJR) {
	          return console.error(err || 'Update failed.');
	        }
	
	        _this.props.dispatch(jobRequestStore.updateJobRequest(updatedJR));
	      }));
	
	      // update state to remove job from list
	      var eligibleJobRequests = _this.state.eligibleJobRequests;
	      var index = eligibleJobRequests.findIndex(function (jr) {
	        return jr.id === _this.state.rowToMove.id;
	      });
	      if (index !== -1) {
	        eligibleJobRequests.splice(index, 1);
	      }
	
	      _this.setState({
	        eligibleJobRequests: eligibleJobRequests,
	        rowToMove: null,
	        showTransitionBlocker: false
	      });
	
	      _this.props.dispatch((0, _ui.showSnackBar)('Transferred ownership of JobId: ' + jrToUpdate.id + ' to ContactId: ' + jrToUpdate.primaryContactId));
	    };
	
	    _this.state = {
	      showTransitionBlocker: false,
	      selectedJobRequests: [],
	      eligibleJobRequests: [],
	      transferring: false,
	      tableColumns: ['Id', 'Title', 'Contact', 'Status', 'Actions']
	    };
	    return _this;
	  }
	
	  _createClass(JobRequestTransferOwnership, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _employees.getPins)(function (err, pins) {
	        if (!err) {
	          dispatch(syncActionCreators.loadPins(pins));
	        }
	      }));
	
	      var eligibleJobRequests = this.props.pinnedJobRequests.filter(function (jr) {
	        return jr.primaryContactId !== _this2.props.contact.profile.id;
	      }).map(function (eligibleJR) {
	        return {
	          id: eligibleJR.id,
	          title: '' + (0, _staticData.getLookupValue)(_this2.props.staticData, 'positionTypes', { id: eligibleJR.positionTypeId }).name,
	          primaryContact: eligibleJR.primaryContact,
	          status: (0, _staticData.getLookupValue)(_this2.props.staticData, 'jobRequestStatus', { id: eligibleJR.jobRequestStatus })
	        };
	      });
	      this.setState({ eligibleJobRequests: eligibleJobRequests });
	    }
	  }, {
	    key: 'renderActions',
	
	
	    // table column rendering functions
	    value: function renderActions(header, row, index) {
	      if (header) {
	        return this.renderHeader('Actions', 'actions');
	      }
	
	      // overflow visible hack for tooltips in TableRowColumn
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Actions ' + index, 'data-id': 'Actions ' + index, className: 'actions', style: { overflow: 'visible' } },
	        _react2.default.createElement(
	          _IconButton2.default,
	          { tooltip: 'Transfer Job', tooltipPosition: 'bottom-center', onClick: this.handleConfirmTransfer.bind(this, row) },
	          _react2.default.createElement(_TransferItemOwnershipIcon2.default, { 'data-id': 'Move' + index, className: 'action-button' })
	        )
	      );
	    }
	  }, {
	    key: 'renderContact',
	    value: function renderContact(header, row, index) {
	      if (header) {
	        return this.renderHeader('Contact');
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Contact' + index, 'data-id': 'Contact' + index, className: 'contact' },
	        row.primaryContact && _react2.default.createElement(
	          'span',
	          null,
	          row.primaryContact
	        )
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(headerText, className, columnName) {
	      if (!className) {
	        className = (0, _lodash.replace)((0, _lodash.lowerCase)(headerText), ' ', '-');
	      }
	      return _react2.default.createElement(
	        _Table.TableHeaderColumn,
	        { className: (0, _classnames2.default)(className) },
	        _react2.default.createElement(
	          'div',
	          null,
	          headerText
	        )
	      );
	    }
	  }, {
	    key: 'renderId',
	    value: function renderId(isHeader, row, index) {
	      if (isHeader) {
	        return this.renderHeader('Job #', 'job-number', 'id', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Job Number' + index, className: 'job-number' },
	        _react2.default.createElement(
	          'div',
	          null,
	          row.id
	        )
	      );
	    }
	  }, {
	    key: 'renderStatus',
	    value: function renderStatus(header, row, index) {
	      if (header) {
	        return this.renderHeader('Status', 'status', 'jobRequestStatus', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { key: 'Status #' + index, 'data-id': 'Status #' + index, className: 'status' },
	        _react2.default.createElement('div', { className: 'status-circle', 'data-id': 'Status Icon', style: { backgroundColor: row.status.color, borderColor: row.status.color } }),
	        row.status.name
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(isHeader, row, index) {
	      if (isHeader) {
	        return this.renderHeader('Title', 'title', 'title', true);
	      }
	
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        { 'data-id': 'Title' + index, className: 'title' },
	        row.title
	      );
	    }
	
	    // table rendering function
	
	  }, {
	    key: 'renderJRTable',
	    value: function renderJRTable() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-history-table' },
	        _react2.default.createElement(
	          _Table.Table,
	          { selectable: false,
	            multiSelectable: false,
	            fixedHeader: true,
	            height: this.props.tableHeight || 'calc(100vh - 875px)',
	            onSelectionChange: this.handleTableSelectionChange,
	            onClick: this.handleTableSelectionChange
	          },
	          _react2.default.createElement(
	            _Table.TableHeader,
	            { displaySelectAll: false, adjustForCheckbox: false },
	            _react2.default.createElement(
	              _Table.TableRow,
	              null,
	              (0, _lodash.map)(this.state.tableColumns, function (column) {
	                return _this3['render' + column](true);
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableBody,
	            { displayRowCheckbox: false },
	            this.state.eligibleJobRequests.length === 0 && _react2.default.createElement(
	              'div',
	              { className: 'table-no-data' },
	              'No Eligible Job Requests Available'
	            ),
	            (0, _lodash.map)(this.state.eligibleJobRequests, function (row, index) {
	              return _react2.default.createElement(
	                _Table.TableRow,
	                { key: '' + row.id, 'data-id': 'Contact ' + row.id },
	                (0, _lodash.map)(_this3.state.tableColumns, function (column) {
	                  return _this3['render' + column](false, row, index);
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	
	    // component render
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClickOut: this.handleClose },
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          secondaryAction: this.handleTransferJobRequest,
	          secondaryButtonLabel: 'Transfer Job',
	          cancelAction: function cancelAction() {
	            return _this4.setState({ showTransitionBlocker: false, rowToTransfer: null });
	          },
	          primaryAction: function primaryAction() {
	            return _this4.setState({ showTransitionBlocker: false, rowToTransfer: null });
	          },
	          primaryButtonLabel: 'Cancel',
	          transitionText: 'Are you sure you want to move job request #<b>' + this.state.rowToMove.id + '</b><br>from: <b>' + this.state.rowToMove.primaryContact + '</b><br>to: <b>' + this.props.contact.user.firstName + ' ' + this.props.contact.user.lastName + '</b>?'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'transferJROwnership-dialog' },
	          _react2.default.createElement(_ModalX2.default, { onClick: this.handleClose }),
	          _react2.default.createElement(
	            'h1',
	            { className: 'modal-content-title' },
	            'Transfer Pinned Job Requests'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid transferJROwnership-dialog-fields' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                this.renderJRTable()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'transferJROwnership-dialog-actions' },
	            _react2.default.createElement(_Button2.default, { 'data-id': 'transfer job requests', label: 'Close', onClick: this.handleClose, disabled: this.state.transferring })
	          )
	        )
	      );
	    }
	  }]);
	
	  return JobRequestTransferOwnership;
	}(_react.Component), _class2.propTypes = {
	  contact: _react.PropTypes.object.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  pinnedJobRequests: _react.PropTypes.array,
	
	  // table
	  staticData: _react.PropTypes.object.isRequired,
	  tableHeight: _react.PropTypes.number
	}, _temp)) || _class);
	exports.default = JobRequestTransferOwnership;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactDashboardSubNav = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
	  _inherits(ContactDashboardSubNav, _React$Component);
	
	  function ContactDashboardSubNav() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactDashboardSubNav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactDashboardSubNav.__proto__ || Object.getPrototypeOf(ContactDashboardSubNav)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      currentRoute: '',
	      routes: [{
	        name: 'Profile',
	        path: ''
	      }, {
	        name: 'Company',
	        path: 'company'
	      }]
	    }, _this.handleClick = function (destination) {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + _this.props.contactId + '/details/' + destination));
	      _this.setState({ currentRoute: destination });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ContactDashboardSubNav, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'contact-worksheet-subnav' },
	        (0, _lodash.map)(this.state.routes, function (route, index) {
	          return _react2.default.createElement(
	            'li',
	            {
	              key: index,
	              'data-id': 'contact-path-' + index,
	              onClick: function onClick(e) {
	                return _this2.handleClick(route.path);
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: route.path == _this2.state.currentRoute ? 'active' : '' },
	              route.name
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return ContactDashboardSubNav;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contactId: _react.PropTypes.number
	}, _temp2)) || _class);
	exports.default = ContactDashboardSubNav;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OnEnterRefreshContact = OnEnterRefreshContact;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _Worksheet = __webpack_require__(298);
	
	var _Worksheet2 = _interopRequireDefault(_Worksheet);
	
	var _Details = __webpack_require__(957);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _SubNav = __webpack_require__(960);
	
	var _SubNav2 = _interopRequireDefault(_SubNav);
	
	var _Events = __webpack_require__(956);
	
	var _Events2 = _interopRequireDefault(_Events);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts2);
	
	var _TackIcon = __webpack_require__(205);
	
	var _TackIcon2 = _interopRequireDefault(_TackIcon);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _sync = __webpack_require__(21);
	
	var _employees = __webpack_require__(62);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_DASHBOARD = '/admin/contacts';
	
	function ContactWorksheet(props) {
	
	  var contactId = parseInt(props.params.contactId) || 0;
	  var prevPath = '' + DEFAULT_DASHBOARD;
	  var handleClose = function handleClose(event) {
	    return props.dispatch((0, _reactRouterRedux.push)(prevPath));
	  };
	  var handleHideAction = function handleHideAction() {
	    return props.refreshContact(props, _reactRouterRedux.replace, function () {
	      props.dispatch(ui.hideSnackBar());
	    });
	  };
	
	  // pin functions
	  var isPinned = function isPinned() {
	    return (0, _lodash.indexOf)((0, _lodash.get)(props.pinnedData, 'contacts', []), (0, _lodash.get)(props, 'contact.profile.id')) >= 0;
	  };
	
	  var handleTogglePin = function handleTogglePin() {
	    return function () {
	      var newPinnedData = props.pinnedData;
	      if (isPinned()) {
	        _.pull(newPinnedData.contacts, props.contact.profile.id);
	      } else {
	        (0, _lodash.set)(newPinnedData, 'contacts', (0, _lodash.union)((0, _lodash.get)(newPinnedData, 'contacts', []), [props.contact.profile.id]));
	      }
	
	      props.dispatch((0, _employees.updatePins)(newPinnedData, function (err, pins) {
	        if (!err) {
	          props.dispatch((0, _sync.loadPins)(pins));
	        }
	      }));
	    };
	  };
	
	  var pin = _react2.default.createElement(
	    'div',
	    { className: 'pin', onClick: handleTogglePin() },
	    ' ',
	    _react2.default.createElement(_TackIcon2.default, null),
	    ' ',
	    _react2.default.createElement(
	      'span',
	      { className: 'pin-text' },
	      isPinned() ? 'unpin' : 'pin'
	    )
	  );
	  return _react2.default.createElement(
	    'div',
	    null,
	    !(0, _lodash.isNil)(props.contact) && !(0, _lodash.isNil)(props.contact.user) && !(0, _lodash.isNil)(props.contact.profile) && _react2.default.createElement(
	      _Worksheet2.default,
	      {
	        baseRoute: '/admin/contacts',
	        dispatch: props.dispatch,
	        location: props.location,
	        pin: pin
	      },
	      _react2.default.createElement(
	        'div',
	        { key: 'Card' },
	        _react2.default.createElement(_Details2.default, { contactId: contactId })
	      ),
	      _react2.default.createElement(
	        'div',
	        { key: 'SubNav' },
	        _react2.default.createElement(_SubNav2.default, { contactId: contactId })
	      ),
	      _react2.default.createElement(
	        'ul',
	        { key: 'Side' },
	        _react2.default.createElement(_Events2.default, { contactId: contactId })
	      ),
	      props.children
	    )
	  );
	}
	
	exports.default = (0, _reactRedux.connect)(function (store, props) {
	  var contact = (0, _lodash.get)(store.admin, 'contactInContactWorksheet', {});
	  return {
	    staticData: store.staticData,
	    ui: store.ui,
	    pinnedData: (0, _lodash.get)(store.pins, 'pinned', {}),
	    contact: contact
	  };
	}, function (dispatch) {
	  return {
	    dispatch: dispatch,
	    refreshContact: OnEnterRefreshContact({ dispatch: dispatch })
	  };
	})(ContactWorksheet);
	function OnEnterRefreshContact(store) {
	  return function (nextState, replace, done) {
	
	    var id = (0, _lodash.toNumber)(nextState.params.contactId);
	    store.dispatch(contactStore.clearContactInContactWorksheet());
	    store.dispatch(contactApi.getContact(id, function (err, data) {
	      if (err || !data) {
	        replace(DEFAULT_DASHBOARD);
	        return done(err);
	      }
	
	      // We have to clear the store admin.contactInContactWorksheet before using it. Because the merge..
	      store.dispatch(contactStore.updateContactInContactWorksheet(data));
	
	      done();
	    }));
	  };
	}

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	function GenericCard(props) {
	  var title = props.title,
	      subtitle = props.subtitle,
	      color = props.color,
	      content = props.content,
	      unpin = props.unpin;
	
	
	  var contentRows = [];
	  var currentRow = [];
	  (0, _lodash.forEach)(content, function (section, index) {
	    currentRow.push(section);
	    if (index % 2 == 1 || index == content.length - 1) {
	      if (currentRow.length) contentRows.push(currentRow);
	      currentRow = [];
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    {
	      'data-id': 'Card for ' + title,
	      className: (0, _classnames2.default)('generic-card') },
	    _react2.default.createElement(
	      'div',
	      { className: 'status-container' },
	      _react2.default.createElement('div', { className: 'status-circle', 'data-id': 'Status Icon',
	
	        style: { backgroundColor: color, borderColor: color, color: color } })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'generic-card-info' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card-info-primary' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-title', 'data-id': 'Title' },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-subtitle', 'data-id': 'Subtitle' },
	          subtitle
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid' },
	        (0, _lodash.map)(contentRows, function (row) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            (0, _lodash.map)(row, function (section) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                section
	              );
	            })
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'card-close',
	        'data-id': 'close-icon',
	        onClick: unpin
	      },
	      _react2.default.createElement(_CloseX2.default, null)
	    )
	  );
	}
	
	// utilities
	
	
	GenericCard.propTypes = {
	  title: _react.PropTypes.string.isRequired,
	  subtitle: _react.PropTypes.string,
	  color: _react.PropTypes.string,
	  content: _react.PropTypes.object,
	  unpin: _react.PropTypes.func
	};
	
	exports.default = GenericCard;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Drawer = __webpack_require__(592);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _TackIcon = __webpack_require__(205);
	
	var _TackIcon2 = _interopRequireDefault(_TackIcon);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	var _GenericCard = __webpack_require__(962);
	
	var _GenericCard2 = _interopRequireDefault(_GenericCard);
	
	var _localDate = __webpack_require__(308);
	
	var _localDate2 = _interopRequireDefault(_localDate);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _staticData = __webpack_require__(28);
	
	var _employees = __webpack_require__(62);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CorkBoard = (_dec = (0, _reactRedux.connect)(function (state) {
	  var statuses = state.staticData.applicantStatus;
	  var applicants = (0, _lodash2.default)(state.pins.applicants).map(function (applicant) {
	    return _lodash2.default.chain(statuses).find({ id: applicant.profile.applicantStatus.id }).pick(['color', 'label', 'lifespan']).merge(applicant).value();
	  }).value();
	
	  return {
	    staticData: state.staticData,
	    applicants: applicants,
	    contacts: state.pins.contacts,
	    companies: state.pins.companies,
	    jobRequests: state.pins.jobRequests,
	    pinnedData: state.pins.pinned
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(CorkBoard, _React$Component);
	
	  function CorkBoard(props) {
	    _classCallCheck(this, CorkBoard);
	
	    var _this = _possibleConstructorReturn(this, (CorkBoard.__proto__ || Object.getPrototypeOf(CorkBoard)).call(this, props));
	
	    _this.handleToggle = function () {
	      return _this.setState({ open: !_this.state.open });
	    };
	
	    _this.goToApplicant = function (id) {
	      return function () {
	        _this.props.dispatch(ui.showSpinner());
	        _this.props.dispatch((0, _reactRouterRedux.push)('/admin/In Process/' + id + '/Profile?detail=1'));
	      };
	    };
	
	    _this.goToContact = function (id) {
	      return function () {
	        _this.props.dispatch(ui.showSpinner());
	        _this.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + id + '/details'));
	      };
	    };
	
	    _this.goToCompany = function (id) {
	      return function () {
	        _this.props.dispatch(ui.showSpinner());
	        _this.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/' + id + '/details'));
	      };
	    };
	
	    _this.goToJobRequest = function (id) {
	      return function () {
	        _this.props.dispatch(ui.showSpinner());
	        _this.props.dispatch((0, _reactRouterRedux.push)('/admin/jobrequests/' + id));
	      };
	    };
	
	    _this.unpin = function (type, id) {
	      return function (event) {
	        var newPinnedData = _this.props.pinnedData;
	        _lodash2.default.pull(newPinnedData[type], id);
	        _this.props.dispatch((0, _employees.updatePins)(newPinnedData, function (err, pins) {
	          if (!err) {
	            _this.props.dispatch(syncActionCreators.loadPins(pins));
	          }
	        }));
	        event.stopPropagation();
	      };
	    };
	
	    _this.state = {
	      open: false,
	      showApplicants: true,
	      showContacts: true,
	      showCompanies: true,
	      showJobRequests: true
	    };
	    return _this;
	  }
	
	  _createClass(CorkBoard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _employees.getPins)(function (err, pins) {
	        if (!err) {
	          dispatch(syncActionCreators.loadPins(pins));
	        }
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isEmpty = !this.props.applicants.length;
	      return _react2.default.createElement(
	        'div',
	        { className: 'cork-board' },
	        _react2.default.createElement(
	          _Drawer2.default,
	          {
	            containerClassName: 'pin-drawer',
	            docked: true,
	            width: this.state.open ? 346 : 60,
	            openSecondary: true,
	            open: true,
	            containerStyle: { overflow: 'hidden' }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'pinned-container', onClick: !this.state.open && this.handleToggle },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.state.open && this.handleToggle,
	                className: 'bar' + (this.state.open ? '' : ' closed') },
	              _react2.default.createElement(_TackIcon2.default, null),
	              _react2.default.createElement(
	                'div',
	                { className: 'title' },
	                'Pinned'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'closeIcon' },
	                'Close ',
	                _react2.default.createElement(_CloseX2.default, null)
	              )
	            ),
	            this.state.open && _react2.default.createElement(
	              'div',
	              { className: 'pinned-items', 'data-id': 'pinned-items' },
	              this.props.applicants.length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'title-bar', onClick: function onClick() {
	                    return _this2.setState({ showApplicants: !_this2.state.showApplicants });
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: (0, _classnames2.default)('wv-chevron', { flipped: !this.state.showApplicants }) },
	                  _react2.default.createElement(_ChevronIcon2.default, { color: '#FFF' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title' },
	                  'Candidates'
	                )
	              ),
	              this.state.showApplicants && _lodash2.default.map(this.props.applicants, function (applicant) {
	                return _react2.default.createElement(
	                  'div',
	                  { onClick: _this2.goToApplicant(applicant.profile.id) },
	                  _react2.default.createElement(_GenericCard2.default, {
	                    key: applicant.profile.id,
	                    'data-id': applicant.profile.id,
	                    title: applicant.user.firstName + ' ' + applicant.user.lastName,
	                    color: applicant.color,
	                    unpin: _this2.unpin('applicants', applicant.profile.id),
	                    content: [applicant.user.email, 'Availability: ' + (0, _localDate2.default)(applicant.profile.availabilityDate), (0, _prettyPhone2.default)(applicant.user.phoneNumber1), 'Applied: ' + (0, _localDate2.default)(applicant.profile.dateCreated)]
	                  })
	                );
	              }),
	              this.props.contacts.length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'title-bar', onClick: function onClick() {
	                    return _this2.setState({ showContacts: !_this2.state.showContacts });
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: (0, _classnames2.default)('wv-chevron', { flipped: !this.state.showContacts }) },
	                  _react2.default.createElement(_ChevronIcon2.default, { color: '#FFF' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title' },
	                  'Contacts'
	                )
	              ),
	              this.state.showContacts && _lodash2.default.map(this.props.contacts, function (contact) {
	                var status = (0, _staticData.getLookupValue)(_this2.props.staticData, 'companyStatus', { id: contact.company.companyStatus });
	                var followUpTask = (0, _lodash2.default)(contact.profile.tasks).filter(function (task) {
	                  return task.taskFollowUpDate && new Date(task.taskFollowUpDate) - Date.now() > 0;
	                }).sortBy(function (task) {
	                  return new Date(task.taskFollowUpDate);
	                }).head();
	                return _react2.default.createElement(
	                  'div',
	                  { onClick: _this2.goToContact(contact.profile.id) },
	                  _react2.default.createElement(_GenericCard2.default, {
	                    key: contact.profile.id,
	                    'data-id': contact.profile.id,
	                    title: contact.user.firstName + ' ' + contact.user.lastName,
	                    color: status.color,
	                    unpin: _this2.unpin('contacts', contact.profile.id),
	                    content: [contact.profile.title, contact.company.name, contact.user.email, 'Contacted: ' + (0, _localDate2.default)(contact.profile.dateCreated), (0, _prettyPhone2.default)(contact.user.phoneNumber1), 'Follow Up: ' + (followUpTask ? (0, _moment2.default)(followUpTask.taskFollowUpDate).format('L') : '')]
	                  })
	                );
	              }),
	              this.props.companies.length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'title-bar', onClick: function onClick() {
	                    return _this2.setState({ showCompanies: !_this2.state.showCompanies });
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: (0, _classnames2.default)('wv-chevron', { flipped: !this.state.showCompanies }) },
	                  _react2.default.createElement(_ChevronIcon2.default, { color: '#FFF' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title' },
	                  'Companies'
	                )
	              ),
	              this.state.showCompanies && _lodash2.default.map(this.props.companies, function (company) {
	                var status = (0, _staticData.getLookupValue)(_this2.props.staticData, 'companyStatus', { id: company.companyStatus });
	                return _react2.default.createElement(
	                  'div',
	                  { onClick: _this2.goToCompany(company.id) },
	                  _react2.default.createElement(_GenericCard2.default, {
	                    key: company.id,
	                    'data-id': company.id,
	                    title: company.name,
	                    color: status.color,
	                    unpin: _this2.unpin('companies', company.id),
	                    content: [(0, _staticData.lookup)(_this2.props.staticData, 'industryTypesList', { id: company.industryTypes[0] }), 'Entered: ' + (0, _localDate2.default)(company.dateCreated), (0, _prettyPhone2.default)(company.phoneNumber), 'Updated: ' + (0, _localDate2.default)(company.dateModified)]
	                  })
	                );
	              }),
	              this.props.jobRequests.length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'title-bar', onClick: function onClick() {
	                    return _this2.setState({ showJobRequests: !_this2.state.showJobRequests });
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { className: (0, _classnames2.default)('wv-chevron', { flipped: !this.state.showJobRequests }) },
	                  _react2.default.createElement(_ChevronIcon2.default, { color: '#FFF' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'title' },
	                  'Job Requests'
	                )
	              ),
	              this.state.showJobRequests && _lodash2.default.map(this.props.jobRequests, function (jobRequest) {
	                var status = (0, _staticData.getLookupValue)(_this2.props.staticData, 'jobRequestStatus', { id: jobRequest.jobRequestStatus });
	                var positionTitle = (0, _staticData.lookup)(_this2.props.staticData, 'positionTypes', { id: jobRequest.positionTypeId });
	                return _react2.default.createElement(
	                  'div',
	                  { onClick: _this2.goToJobRequest(jobRequest.id) },
	                  _react2.default.createElement(_GenericCard2.default, {
	                    key: jobRequest.id,
	                    'data-id': jobRequest.id,
	                    title: positionTitle,
	                    color: status.color,
	                    unpin: _this2.unpin('jobRequests', jobRequest.id),
	                    content: ['#' + jobRequest.id, jobRequest.primaryContact, (0, _staticData.lookup)(_this2.props.staticData, 'industryTypesList', { id: jobRequest.industryTypeId }), jobRequest.companyName, '', 'Date Added: ' + (0, _localDate2.default)(jobRequest.dateCreated)]
	                  })
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CorkBoard;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = CorkBoard;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Clip = __webpack_require__(883);
	
	var _Clip2 = _interopRequireDefault(_Clip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemAttachment = (_temp = _class = function (_Component) {
	  _inherits(ItemAttachment, _Component);
	
	  function ItemAttachment(props, context) {
	    _classCallCheck(this, ItemAttachment);
	
	    return _possibleConstructorReturn(this, (ItemAttachment.__proto__ || Object.getPrototypeOf(ItemAttachment)).call(this, props, context));
	  }
	
	  _createClass(ItemAttachment, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item-attachment' },
	        _react2.default.createElement(_Clip2.default, { className: 'clip-icon' }),
	        _react2.default.createElement(
	          'span',
	          { 'data-id': 'filename', className: 'file-name' },
	          this.props.fileName
	        ),
	        _react2.default.createElement('span', { 'data-id': 'close button', className: 'close-button', onClick: this.props.removeAttachment(this.props.fileName) })
	      );
	    }
	  }]);
	
	  return ItemAttachment;
	}(_react.Component), _class.propTypes = {
	  removeAttachment: _react.PropTypes.func.isRequired,
	  fileName: _react.PropTypes.string.isRequired
	}, _temp);
	exports.default = ItemAttachment;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _c_SourceSimpleFileInput2 = _interopRequireDefault(_c_SourceSimpleFileInput);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _companies = __webpack_require__(49);
	
	var _emails = __webpack_require__(235);
	
	var _employees = __webpack_require__(62);
	
	var _staticData = __webpack_require__(28);
	
	var _ItemAttachment = __webpack_require__(964);
	
	var _ItemAttachment2 = _interopRequireDefault(_ItemAttachment);
	
	var _model = __webpack_require__(966);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _modelValidator = __webpack_require__(33);
	
	var _contacts = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailDialog = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    ui: store.ui,
	    user: store.user,
	    profile: store.profile,
	    staticData: store.staticData,
	    account: store.staticData.account,
	    labels: store.labels
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(EmailDialog, _Component);
	
	  function EmailDialog(props, context) {
	    _classCallCheck(this, EmailDialog);
	
	    var _this = _possibleConstructorReturn(this, (EmailDialog.__proto__ || Object.getPrototypeOf(EmailDialog)).call(this, props, context));
	
	    _this.handleClose = function (event) {
	      _this.props.onClose && _this.props.onClose(event);
	    };
	
	    _this.handleSelectTemplate = function (event, id) {
	
	      var newState = (0, _lodash.merge)({}, _this.state);
	      newState.form.EmailTemplates = id;
	      _this.setState(newState);
	    };
	
	    _this.handleSelectContact = function (event, selected, id) {
	      var _merge = (0, _lodash.merge)({}, _this.state),
	          cc = _merge.cc,
	          newState = _objectWithoutProperties(_merge, ['cc']);
	
	      var adding = (selected || []).includes(id);
	      var contact = newState.contacts.find(function (c) {
	        return c.profile.userId === id;
	      });
	      var employee = newState.employees.find(function (e) {
	        return e.id === id;
	      });
	
	      if (employee) {
	        newState.form.CCEmployees = selected;
	      }
	
	      if (contact) {
	        newState.form.CCCompany = selected;
	      }
	
	      var user = employee || (0, _lodash.get)(contact, 'user');
	      var CC = void 0;
	      if (user) {
	        if (adding && !cc.includes(user.email)) {
	          CC = cc;
	          CC.push(user.email);
	        } else if (!adding) {
	          CC = cc;
	          var i = cc.findIndex(function (e) {
	            return e === user.email;
	          });
	          CC.splice(i, 1);
	        }
	      }
	
	      if (CC) {
	        _this.setState(_extends({}, newState, { cc: CC }));
	      }
	    };
	
	    _this.handleSendEmail = function (event) {
	      var _this$state = _this.state,
	          _this$state$cc = _this$state.cc,
	          cc = _this$state$cc === undefined ? [] : _this$state$cc,
	          templates = _this$state.templates,
	          attachments = _this$state.attachments;
	      var _this$props = _this.props,
	          dispatch = _this$props.dispatch,
	          contactId = _this$props.contact.profile.id;
	
	
	      _this.setState({ submitted: true });
	
	      var errors = (0, _modelValidator.validate)(_this.state.form, _model2.default.getModel());
	      if (errors.length) {
	        _this.setState({ errors: errors });
	        return;
	      }
	
	      var _ref = (0, _lodash.find)(templates, { id: _this.state.form.EmailTemplates }) || {},
	          _ref$subject = _ref.subject,
	          subject = _ref$subject === undefined ? '' : _ref$subject;
	
	      var html = document.getElementById('email-dialog-editor').innerHTML;
	
	      _this.setState({ sending: true });
	
	      dispatch((0, _emails.sendContactEmail)(contactId, cc, subject, html, attachments, function (err) {
	        if (err) {
	          return console.error('Ooops, something went wrong');
	        }
	        _this.handleClose(event);
	        _this.props.dispatch(ui.showSnackBar('Email has been sent'));
	
	        // refresh contact
	        dispatch(contactApi.getContact(contactId, function (err, data) {
	          if (err || !data) {
	            return console.error(err || 'Fetch failed.');
	          }
	          dispatch(contactStore.updateContactInContactWorksheet(data));
	        }));
	      }));
	    };
	
	    _this.onUploadStart = function (err, file) {
	
	      var attachments = Object.assign(_this.state.attachments);
	      attachments.push(file);
	      _this.setState({ attachments: attachments });
	    };
	
	    _this.removeAttachment = function (name) {
	
	      return function () {
	
	        var sAttachments = Object.assign(_this.state.attachments);
	        var attachments = (0, _lodash.reject)(sAttachments, { name: name });
	        _this.setState({ attachments: attachments });
	      };
	    };
	
	    _this.onS3Load = function (err) {
	      // updating UI optimistically so we only need to know if there was an error
	      if (err && ("production") !== 'production') {
	        console.error(err);
	      }
	    };
	
	    _this.state = {
	      ITManager: {
	        firstName: '',
	        lastName: ''
	      },
	      placementSpecialist: {
	        firstName: '',
	        lastName: ''
	      },
	      submitted: false,
	      employees: [],
	      contacts: [],
	      templates: [],
	      cc: [],
	      attachments: [],
	      form: {
	        EmailTemplates: null,
	        CCEmployees: [],
	        CCCompany: []
	      }
	    };
	    return _this;
	  }
	
	  _createClass(EmailDialog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          _props$user = _props.user,
	          user = _props$user === undefined ? {} : _props$user;
	
	      var company = (0, _lodash.get)(this.props, 'contact.company', {});
	      var currentContact = (0, _lodash.get)(this.props, 'contact', {});
	
	      if (dispatch && company.id) {
	
	        dispatch((0, _companies.getCompanyJobs)(company.id, function (err, data) {
	
	          var jobs = (0, _lodash.get)(data, 'body.data.items', []);
	
	          // Get first job request approved.
	          var firstJobRequest = (0, _lodash.find)(jobs, { primaryContactId: currentContact.profile.id, jobRequestStatus: 4 });
	
	          if (firstJobRequest === undefined) {
	            return;
	          }
	          var placementSpecialist = (0, _lodash.find)(_this2.props.staticData.placementSpecialists, { employeeId: firstJobRequest.placementSpecialistId });
	
	          if (placementSpecialist) {
	            _this2.setState({ placementSpecialist: placementSpecialist });
	          }
	        }));
	
	        dispatch((0, _companies.getCompanyContacts)(company.id, function (err, res) {
	          if (err) {
	            return console.error('Ooops, something related to getCompanyContacts went wrong');
	          }
	
	          var contacts = (0, _lodash.get)(res, 'body.data.items', []).filter(function (contact) {
	            return contact.user.id !== currentContact.user.id;
	          });
	
	          _this2.setState((0, _lodash.merge)({}, (0, _lodash.omit)(_this2.state, ['contacts']), { contacts: contacts }));
	        }));
	
	        dispatch((0, _emails.getEmailTemplates)()).then(function (templates) {
	          return _this2.setState((0, _lodash.merge)({}, (0, _lodash.omit)(_this2.state, ['templates']), { templates: templates }));
	        });
	
	        dispatch((0, _employees.getUsersByRole)('IT Manager', function (err, employeeList) {
	
	          if (err) {
	            return console.error('Ooops, something related to getUsersByRole went wrong');
	          }
	
	          if (employeeList[0]) {
	            _this2.setState({ ITManager: employeeList[0] });
	          }
	        }));
	
	        dispatch((0, _employees.getUsersByRole)(undefined, function (err, employeeList) {
	          if (err) {
	            return console.error('Ooops, something related to getUsersByRole went wrong');
	          }
	
	          var employees = (employeeList || []).filter(function (employee) {
	            return employee.userId !== user.id;
	          });
	
	          _this2.setState((0, _lodash.merge)({}, (0, _lodash.omit)(_this2.state, ['employees']), { employees: employees }));
	        }));
	      }
	    }
	  }, {
	    key: 'validate',
	    value: function validate(prop) {
	
	      if (!this.state.submitted) {
	        return;
	      }
	
	      var validation = (0, _modelValidator.validateField)(this.state.form[prop], _model2.default.getModel(prop));
	      return validation[0];
	    }
	  }, {
	    key: 'renderEmployeeContacts',
	    value: function renderEmployeeContacts() {
	      var _state$employees = this.state.employees,
	          employees = _state$employees === undefined ? [] : _state$employees;
	
	
	      var menuItems = (0, _lodash.sortBy)(employees.map(function (user) {
	        return { id: user.id, name: (0, _lodash.capitalize)(user.firstName) + ' ' + (0, _lodash.capitalize)(user.lastName) };
	      }), ['name']);
	
	      if (menuItems.length) {
	        return _react2.default.createElement(_c_CheckList2.default, {
	          'data-id': 'employees list',
	          menuItems: menuItems,
	          value: this.state.form.CCEmployees,
	          onChange: this.handleSelectContact,
	          floatingLabelText: 'CC Employees' });
	      }
	    }
	  }, {
	    key: 'renderCompanyContacts',
	    value: function renderCompanyContacts() {
	      var _state$contacts = this.state.contacts,
	          contacts = _state$contacts === undefined ? [] : _state$contacts;
	      var _props$contact = this.props.contact;
	      _props$contact = _props$contact === undefined ? {} : _props$contact;
	      var _props$contact$compan = _props$contact.company,
	          company = _props$contact$compan === undefined ? {} : _props$contact$compan;
	
	
	      var companyName = (0, _lodash.get)(company, 'name', 'Company Contacts');
	      var menuItems = (0, _lodash.sortBy)(contacts.map(function (contact) {
	        return { id: contact.user.id, name: (0, _lodash.capitalize)(contact.user.firstName) + ' ' + (0, _lodash.capitalize)(contact.user.lastName) };
	      }), ['name']);
	      return _react2.default.createElement(_c_CheckList2.default, {
	        'data-id': 'contacts list',
	        menuItems: menuItems,
	        onChange: this.handleSelectContact,
	        floatingLabelText: 'CC ' + companyName,
	        errorText: this.validate('CCCompany') });
	    }
	  }, {
	    key: 'renderEmailTemplates',
	    value: function renderEmailTemplates() {
	      var _state$templates = this.state.templates,
	          templates = _state$templates === undefined ? [] : _state$templates;
	
	
	      return _react2.default.createElement(_c_DropDownMenu2.default, {
	        'data-id': 'templates dropdown',
	        floatingLabelText: 'Email Templates',
	        menuItems: templates,
	        onChange: this.handleSelectTemplate,
	        errorText: this.validate('EmailTemplates')
	      });
	    }
	  }, {
	    key: 'maskCurrency',
	    value: function maskCurrency(currency) {
	      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	
	      var currencyString = String(currency);
	      var currencyNumber = Number(currencyString.replace(/[^0-9\.]+/g, ''));
	
	      return currencyNumber.toLocaleString('en-US', {
	        style: 'currency',
	        currency: 'USD',
	        minimumFractionDigits: 0,
	        maximumFractionDigits: precision
	      });
	    }
	  }, {
	    key: 'renderTemplate',
	    value: function renderTemplate() {
	      var _state = this.state,
	          templates = _state.templates,
	          ITManager = _state.ITManager,
	          placementSpecialist = _state.placementSpecialist;
	      var contact = this.props.contact;
	
	      var profile = JSON.parse(JSON.stringify(this.props.profile)); // Since we have to format the phone numbers we want a clone of the profile.
	
	      var selected = (0, _lodash.find)(templates, { id: this.state.form.EmailTemplates }) || {};
	
	      var feeWaived = contact.company.placementFee === 0;
	      var defaultPlacementFee = this.props.staticData.account.defaultSetupFee;
	      var feeReduced = contact.company.placementFee > 0 && contact.company.placementFee < defaultPlacementFee;
	      var hasSalesPartner = !!contact.company.salesPartner;
	      var salesPartner = (0, _staticData.lookup)(this.props.staticData, 'salesPartners', { id: contact.company.salesPartner }, 'commissionName');
	
	      var jobReqDetails = {
	        salesPartner: salesPartner,
	        feeWaived: feeWaived,
	        feeReduced: feeReduced,
	        hasSalesPartner: hasSalesPartner,
	        waivedByClientAdvisor: false
	      };
	
	      ITManager.phoneNumber = (0, _prettyPhone2.default)(ITManager.phoneNumber);
	      ITManager.cellphoneNumber = (0, _prettyPhone2.default)(ITManager.cellphoneNumber);
	      profile.phoneNumber = (0, _prettyPhone2.default)(profile.phoneNumber);
	      profile.cellphoneNumber = (0, _prettyPhone2.default)(profile.cellphoneNumber);
	
	      var compiled = (0, _lodash.template)(selected.html);
	
	      var account = _extends({}, this.props.account, {
	        logo: '',
	        name: (0, _lodash.get)(this.props.labels, 'Common.fullName', this.props.account.name),
	        website: (0, _lodash.get)(this.props.labels, 'Common.website', ''),
	        mainColor: (0, _lodash.get)(this.props.labels, 'Styles.mainColor'),
	        domain: (0, _lodash.get)(this.props.account, 'domain', '') ? 'http://' + (0, _lodash.get)(this.props.account, 'domain') : '',
	        url: (0, _lodash.get)(this.props.account, 'domain', '') ? 'http://' + (0, _lodash.get)(this.props.account, 'domain') : ''
	      });
	
	      var html = compiled({ user: profile, contact: contact, itm: ITManager, account: account, salesPartner: salesPartner, placementSpecialist: placementSpecialist, jobReqDetails: jobReqDetails });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'email-dialog-editor-container' },
	        _react2.default.createElement('div', {
	          'data-id': 'email editor',
	          id: 'email-dialog-editor',
	          className: 'email-dialog-editor',
	          contentEditable: 'true',
	          dangerouslySetInnerHTML: { __html: html }
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props$contact$compan2 = this.props.contact.company,
	          company = _props$contact$compan2 === undefined ? {} : _props$contact$compan2;
	
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClickOut: this.handleClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'email-dialog' },
	          _react2.default.createElement(_ModalX2.default, { onClick: this.handleClose }),
	          _react2.default.createElement(
	            'h1',
	            { className: 'modal-content-title' },
	            'Email Message'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid email-dialog-fields' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                this.renderEmailTemplates()
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                this.renderEmployeeContacts()
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                this.renderCompanyContacts()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'email-dialog-editor-wrapper' },
	            this.renderTemplate(),
	            _react2.default.createElement(
	              'div',
	              { className: 'attachments-container' },
	              this.state.attachments.map(function (attachment) {
	                return _react2.default.createElement(_ItemAttachment2.default, { removeAttachment: _this3.removeAttachment, fileName: attachment.name });
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'email-dialog-actions' },
	            _react2.default.createElement(_Button2.default, { 'data-id': 'send email', label: 'send email', onClick: this.handleSendEmail, disabled: this.state.sending }),
	            _react2.default.createElement(_Button2.default, { 'data-id': 'cancel', className: 'button-secondary', label: 'cancel', onClick: this.handleClose }),
	            _react2.default.createElement(
	              _c_SourceSimpleFileInput2.default,
	              {
	                'data-id': 'uploader',
	                className: 'file-uploader',
	                noMessage: true,
	                pristineClass: '',
	                loadingClass: '',
	                successClass: '',
	                failureClass: '',
	                accept: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'tiff', 'tig', 'txt', 'JPG', 'JPEG', 'jpg', 'jpeg', 'png'],
	                remoteFolder: 'employees/emails/' + company.id,
	                onLoadStart: this.onUploadStart,
	                onS3Load: this.onS3Load,
	                signingRoute: '/api/s3/put-sign',
	                maxSize: ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).AWS_FILE_UPLOAD_SIZE },
	              _react2.default.createElement(_Button2.default, { 'data-id': 'attach file button', className: 'button-secondary', label: 'attach file' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmailDialog;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  onClose: _react.PropTypes.func,
	  staticData: _react.PropTypes.array.isRequired,
	  account: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = EmailDialog;

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmailDialogModel = function () {
	    function EmailDialogModel() {
	        _classCallCheck(this, EmailDialogModel);
	    }
	
	    _createClass(EmailDialogModel, null, [{
	        key: 'getModel',
	        value: function getModel(prop) {
	            if (prop) {
	                return model[prop];
	            }
	            return model;
	        }
	    }]);
	
	    return EmailDialogModel;
	}();
	
	exports.default = EmailDialogModel;
	
	
	var model = {
	    EmailTemplates: {
	        required: {
	            message: 'This field is required.'
	        }
	    },
	    CCEmployees: {},
	    CCCompany: {}
	};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EditGuide;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EditGuide(props) {
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      onClickOut: props.onClose },
	    _react2.default.createElement(
	      'div',
	      { className: 'guide-modal' },
	      _react2.default.createElement(_c_TextArea2.default, {
	        'data-id': 'edit-textarea',
	        value: props.source,
	        onChange: props.onUpdate
	      }),
	      _react2.default.createElement(_Button2.default, {
	        'data-id': 'save-guide',
	        className: 'button-main',
	        label: 'Save',
	        onClick: props.onSave
	      })
	    )
	  );
	}

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMarkdown = __webpack_require__(2786);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _reactScrollspy = __webpack_require__(408);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _guides = __webpack_require__(1121);
	
	var guideApi = _interopRequireWildcard(_guides);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EditIcon = __webpack_require__(203);
	
	var _EditIcon2 = _interopRequireDefault(_EditIcon);
	
	var _Logo = __webpack_require__(123);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _edit = __webpack_require__(967);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewGuide = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    showSnackBar: ui.showSnackBar,
	    user: store.user
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ViewGuide, _Component);
	
	  function ViewGuide() {
	    _classCallCheck(this, ViewGuide);
	
	    var _this = _possibleConstructorReturn(this, (ViewGuide.__proto__ || Object.getPrototypeOf(ViewGuide)).call(this));
	
	    _this.state = {
	      content: null,
	      navigation: null,
	      edit: null
	    };
	    return _this;
	  }
	
	  _createClass(ViewGuide, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refreshGuide();
	    }
	  }, {
	    key: 'refreshGuide',
	    value: function refreshGuide() {
	      var _this2 = this;
	
	      this.props.dispatch(guideApi.getGuide(function (err, guide) {
	        _this2.setState(_extends({ edit: null }, guide));
	      }));
	    }
	  }, {
	    key: 'saveGuide',
	    value: function saveGuide() {
	      var _this3 = this;
	
	      this.props.dispatch(guideApi.saveGuide(this.state)).then(function (guide) {
	        return _this3.setState(_extends({ edit: null }, guide));
	      });
	    }
	  }, {
	    key: 'newState',
	    value: function newState() {
	      return (0, _lodash.merge)({}, this.state);
	    }
	  }, {
	    key: 'handleEdit',
	    value: function handleEdit(property) {
	      var _this4 = this;
	
	      return function () {
	        var newState = _this4.newState();
	        newState.edit = property;
	        _this4.setState(newState);
	      };
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate(property) {
	      var _this5 = this;
	
	      return function (event, value) {
	        var newState = _this5.newState();
	        (0, _lodash.set)(newState, property, value);
	        _this5.setState(newState);
	      };
	    }
	  }, {
	    key: 'handleCloseModal',
	    value: function handleCloseModal() {
	      var _this6 = this;
	
	      return function () {
	        _this6.refreshGuide();
	      };
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave() {
	      var _this7 = this;
	
	      return function () {
	        _this7.saveGuide();
	      };
	    }
	  }, {
	    key: 'renderEditModal',
	    value: function renderEditModal(state, props) {
	      return !!state.edit && _react2.default.createElement(_edit2.default, {
	        source: (0, _lodash.get)(state, state.edit),
	        onUpdate: this.handleUpdate(state.edit),
	        onClose: this.handleCloseModal(),
	        onSave: this.handleSave()
	      });
	    }
	  }, {
	    key: 'renderEditButton',
	    value: function renderEditButton(state, props, property) {
	      if ((0, _lodash.get)(props, 'user.roles', []).includes('Admin')) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'button-edit ' + property },
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              'data-id': 'edit-' + property,
	              tooltip: 'Edit ' + property,
	              onClick: this.handleEdit(property) },
	            _react2.default.createElement(_EditIcon2.default, null)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderContainer',
	    value: function renderContainer(state, props) {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'guide-page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'guide-navigation' },
	          _react2.default.createElement(
	            'div',
	            { className: 'guide-navigation-container' },
	            _react2.default.createElement(_Logo2.default, { className: 'resume-logo' }),
	            this.renderEditButton(state, props, 'navigation'),
	            _react2.default.createElement(_reactMarkdown2.default, {
	              source: state.navigation,
	              escapeHtml: false
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'guide-container' },
	          this.renderEditButton(state, props, 'content'),
	          _react2.default.createElement(_reactMarkdown2.default, {
	            source: state.content,
	            escapeHtml: false
	          })
	        ),
	        this.renderEditModal(state, props)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var state = this.state,
	          props = this.props;
	
	
	      return this.renderContainer(state, props);
	    }
	  }]);
	
	  return ViewGuide;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  children: _react.PropTypes.any,
	  user: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ViewGuide;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _Logo = __webpack_require__(123);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyDate2 = _interopRequireDefault(_prettyDate);
	
	var _staticData = __webpack_require__(28);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestConfirmation = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    staticData: state.staticData,
	    jobRequest: state.jobRequest,
	    primaryContact: (0, _lodash.flatMap)(state.companyContacts).find(function (contact) {
	      return contact.profile.id === state.jobRequest.primaryContactId;
	    }) || state.jobRequest.contact,
	    labels: (0, _lodash.get)(state, 'labels.JobRequestConfirmation', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(JobRequestConfirmation, _Component);
	
	  function JobRequestConfirmation() {
	    _classCallCheck(this, JobRequestConfirmation);
	
	    return _possibleConstructorReturn(this, (JobRequestConfirmation.__proto__ || Object.getPrototypeOf(JobRequestConfirmation)).call(this));
	  }
	
	  _createClass(JobRequestConfirmation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch(ui.hideSpinner());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {}
	  }, {
	    key: 'getState',
	    value: function getState(value) {
	      var state = _.find(this.props.staticData.stateList, function (s) {
	        return s.id == value;
	      });
	      return _.get(state, 'abbreviation');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var job = this.props.jobRequest;
	      var contact = this.props.primaryContact;
	      var skills = (0, _lodash.flatten)((0, _lodash.valuesIn)(this.props.jobRequest.skills));
	
	      var workdays = [];
	      if (job.workdays) {
	        workdays = (0, _lodash.reduce)(job.workdays, function (days, today) {
	          days.push((0, _staticData.lookup)(_this2.props.staticData, 'dayAvailableTypes', { id: today }));
	          return days;
	        }, []);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-confirmation clearfix' },
	        _react2.default.createElement(_Logo2.default, { className: 'logo' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'center-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'info-container section', 'data-id': 'Header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              _react2.default.createElement(
	                'div',
	                { className: 'header' },
	                this.props.labels.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'job-id sub-header' },
	                'Job Request #',
	                job.id
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                contact.company.name
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                contact.company.address
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                contact.company.city,
	                ', ',
	                this.getState(contact.company.state),
	                ' ',
	                contact.company.zip
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                contact.company.address2
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'disclaimer' },
	                'This Job Request is submitted by Client in accordance with and subject to the Terms & Conditions below.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'phone sub-header' },
	                'Job Request Contact'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                contact.user.firstName,
	                ' ',
	                contact.user.lastName
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                contact.profile.title
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                contact.user.email
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _staticData.lookup)(this.props.staticData, 'contactPhoneTypes', { id: contact.user.phoneType1 }),
	                (0, _prettyPhone2.default)(contact.user.phoneNumber1)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sub-header' },
	              'Position Information'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                this.props.labels.positionTypeId
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                (0, _staticData.lookup)(this.props.staticData, 'positionTypes', { id: job.positionTypeId })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                this.props.labels.industryTypeId
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                (0, _staticData.lookup)(this.props.staticData, 'industryTypesList', { id: job.industryTypeId })
	              )
	            ),
	            job.industryOther && _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                this.props.labels.industryOther
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                job.industryOther
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                this.props.labels.segmentTypeId
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                ' ',
	                (0, _staticData.lookup)(this.props.staticData, 'jobRequestSegmentTypes', { id: job.segmentTypeId })
	              )
	            ),
	            job.segmentOther && _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                this.props.labels.segmentOther
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                job.segmentOther
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                'Does the candidate need to be Licensed?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                job.licenseRequired ? 'Yes' : 'No'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                'Does the job require use of dual monitors?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                job.dualMonitorsRequired ? 'Yes' : 'No'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                'Does the job require client phone contact?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                job.outsideContactRequired ? 'Yes' : 'No'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-field' },
	                'Number of persons required for this type of work'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-data' },
	                job.numberOfPeople
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sub-header' },
	              'Job Description'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'job-description' },
	              job.description
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section skills-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'info-row header-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'sub-header info-field' },
	                'Skills'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'sub-header info-data' },
	                'Importance'
	              )
	            ),
	            skills.map(function (skill, index) {
	              return _react2.default.createElement(
	                'div',
	                null,
	                skill.name !== 'None' && _react2.default.createElement(
	                  'div',
	                  { className: 'info-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info-field' },
	                    skill.name
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info-data' },
	                    (0, _staticData.lookup)(_this2.props.staticData, 'skillOptionTypes', { id: skill.skillOption })
	                  )
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sub-header' },
	              'Schedule'
	            ),
	            job.jobTypeId && _react2.default.createElement(
	              'div',
	              null,
	              'This is a ',
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-data' },
	                'LONG_TERM' === (0, _staticData.getLookupValue)(this.props.staticData, 'jobTypes', { id: job.jobTypeId }).hardcodelink && 'long term',
	                ' project'
	              ),
	              '.'
	            ),
	            job.dateStarted && _react2.default.createElement(
	              'div',
	              null,
	              'The expected start date is ',
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-data' },
	                (0, _prettyDate2.default)(job.dateStarted)
	              ),
	              '.'
	            ),
	            job.dateEnded && _react2.default.createElement(
	              'div',
	              null,
	              'The expected end date is ',
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-data' },
	                (0, _prettyDate2.default)(job.dateEnded)
	              ),
	              '.'
	            ),
	            job.estimatedHoursPerWeek && _react2.default.createElement(
	              'div',
	              null,
	              'The estimated number of hours per week are ',
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-data' },
	                job.estimatedHoursPerWeek
	              ),
	              '.'
	            ),
	            job.timezone && _react2.default.createElement(
	              'div',
	              null,
	              'The time zone is ',
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-data' },
	                (0, _staticData.lookup)(this.props.staticData, 'timezoneList', { id: job.timezone })
	              ),
	              '.'
	            ),
	            job.workdays && _react2.default.createElement(
	              'div',
	              null,
	              'The working days of the week are ',
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-data' },
	                workdays.join(', ')
	              ),
	              '.'
	            ),
	            job.startTime && _react2.default.createElement(
	              'div',
	              null,
	              'The preferred start time is  ',
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-data' },
	                (0, _staticData.lookup)(this.props.staticData, 'workHours', { id: job.startTime })
	              ),
	              '.'
	            ),
	            job.endTime && _react2.default.createElement(
	              'div',
	              null,
	              'The end time is ',
	              _react2.default.createElement(
	                'span',
	                { className: 'schedule-data' },
	                (0, _staticData.lookup)(this.props.staticData, 'workHours', { id: job.endTime })
	              ),
	              '.'
	            )
	          ),
	          _react2.default.createElement('div', { className: 'section terms-section', dangerouslySetInnerHTML: { __html: (0, _lodash.get)(this.props.labels, 'termsAndConditions') } }),
	          job.dateAuthorized && _react2.default.createElement(
	            'div',
	            { className: 'section signature-section' },
	            'Confirmed by (Signature): ',
	            contact.user.firstName,
	            ' ',
	            contact.user.lastName,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Date: ',
	            (0, _prettyDate2.default)(job.dateAuthorized)
	          )
	        )
	      );
	    }
	  }]);
	
	  return JobRequestConfirmation;
	}(_react.Component), _class2.propTypes = {
	  params: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  labels: _react.PropTypes.object,
	  staticData: _react.PropTypes.object,
	  jobRequest: _react.PropTypes.object,
	  primaryContact: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = JobRequestConfirmation;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	var _index = __webpack_require__(21);
	
	var adminStore = _interopRequireWildcard(_index);
	
	var _JobRequestTable = __webpack_require__(230);
	
	var _JobRequestTable2 = _interopRequireDefault(_JobRequestTable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestDashboard = (_dec = (0, _reactRedux.connect)(function (store, props) {
		return {
			user: store.user,
			jobRequests: store.jobRequests,
			filters: store.admin.jobRequests.filters,
			searchTerms: store.admin.jobRequests.searchTerms,
			contacts: store.admin.contacts,
			companies: store.admin.companies,
			staticData: store.staticData,
			labels: store.labels.JobRequestDashboard,
			route: {
				params: props.params,
				query: props.location.query // actually being from from react-redux-router to regular props
			} };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
		_inherits(JobRequestDashboard, _Component);
	
		function JobRequestDashboard(props, context) {
			_classCallCheck(this, JobRequestDashboard);
	
			var _this = _possibleConstructorReturn(this, (JobRequestDashboard.__proto__ || Object.getPrototypeOf(JobRequestDashboard)).call(this, props, context));
	
			_this.state = {
				jobRequests: [],
				filterApplied: false,
				filterRules: {},
				searchQuery: null
			};
	
			return _this;
		}
	
		_createClass(JobRequestDashboard, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				// load contacts in case they're not in yet
				if (!this.props.contacts.items || this.props.contacts.items.length <= 0) {
					this.props.dispatch(asyncActionCreator.searchContacts([]));
				}
	
				if (Object.keys(this.props.companies).length <= 1) {
					this.props.dispatch(asyncActionCreator.searchCompanies([]));
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.jobRequests) {
					if (this.state.filterApplied) {
						this.setState({ jobRequests: (0, _lodash.filter)(nextProps.jobRequests, this.state.filterRules), filterApplied: true });
					} else {
						this.setState((0, _lodash.merge)({}, this.state, { jobRequests: nextProps.jobRequests }));
					}
				}
				if (nextProps.route.query.search !== this.props.route.query.search) {
					this.setState((0, _lodash.merge)({}, this.state, { searchQuery: nextProps.route.query.search }));
				}
			}
		}, {
			key: 'loadAll',
			value: function loadAll(set) {
				var allData = [];
	
				(0, _lodash.forEach)(set, function (section) {
					allData = (0, _lodash.concat)(allData, section);
				});
	
				return allData;
			}
		}, {
			key: 'onJobRequestFilterChange',
			value: function onJobRequestFilterChange() {
				var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				this.props.dispatch(adminStore.updateJobRequestFilters(filters));
			}
		}, {
			key: 'onJobRequestTermsChange',
			value: function onJobRequestTermsChange() {
				var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
				this.props.dispatch(adminStore.updateJobRequestTerms(terms));
			}
		}, {
			key: 'fetchJobRequests',
			value: function fetchJobRequests() {
				var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				var _this2 = this;
	
				var terms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
				var skip = arguments[2];
	
				var callbacks = {
					success: function success(items) {
						return _this2.props.dispatch(jobRequestStore.updateJobRequests(items));
					},
					error: function error(err) {
						return console.error('getAllJobs failed', err);
					}
				};
	
				this.props.dispatch(jobRequestApi.getAllJobs(callbacks, skip, terms, filters));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'job-request-dashboard content-container' },
					_react2.default.createElement(_JobRequestTable2.default, {
						jobRequestsList: (0, _lodash.valuesIn)(this.props.jobRequests),
						onJobRequestFilterChange: this.onJobRequestFilterChange.bind(this),
						onJobRequestTermsChange: this.onJobRequestTermsChange.bind(this),
						fetchJobs: this.fetchJobRequests.bind(this),
						location: this.props.location.pathname,
						companies: this.loadAll(this.props.companies),
						contacts: this.props.contacts.items,
						filters: this.props.filters || {},
						searchTerms: this.props.searchTerms || [],
						columns: ['Id', 'DateCreated', 'DateSubmitted', 'Title', 'Status', 'Contact', 'Company', 'Firm', 'Industry'],
						labels: this.props.labels.jobRequestTable
					})
				);
			}
		}]);
	
		return JobRequestDashboard;
	}(_react.Component), _class2.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		user: _react.PropTypes.object,
		jobRequests: _react.PropTypes.object,
		staticData: _react.PropTypes.object,
		contacts: _react.PropTypes.object,
		filters: _react.PropTypes.object,
		searchTerms: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
		labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = JobRequestDashboard;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// utility function to turn dates to slashes
	
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _staticData = __webpack_require__(28);
	
	var _employees = __webpack_require__(62);
	
	var employeesApi = _interopRequireWildcard(_employees);
	
	var _StatusDropDown = __webpack_require__(199);
	
	var _StatusDropDown2 = _interopRequireDefault(_StatusDropDown);
	
	var _EditIcon = __webpack_require__(203);
	
	var _EditIcon2 = _interopRequireDefault(_EditIcon);
	
	var _DocumentIcon = __webpack_require__(302);
	
	var _DocumentIcon2 = _interopRequireDefault(_DocumentIcon);
	
	var _Documents = __webpack_require__(972);
	
	var _Documents2 = _interopRequireDefault(_Documents);
	
	var _EditJobRequestInformation = __webpack_require__(973);
	
	var _EditJobRequestInformation2 = _interopRequireDefault(_EditJobRequestInformation);
	
	var _socket = __webpack_require__(438);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyDate2 = _interopRequireDefault(_prettyDate);
	
	var _enums = __webpack_require__(92);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var socket = (0, _socket2.default)(({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).BASE_URL);
	
	var MODES = {
	  empty: 0,
	  view: 1,
	  edit: 2
	};
	
	var JobRequestDetails = (_dec = (0, _reactRedux.connect)(function (store) {
	  var contacts = store.companyContacts;
	  var findContact = function findContact(profileId) {
	    return _lodash2.default.find(contacts, function (contact) {
	      return contact.profile.id === profileId;
	    });
	  };
	  var primaryContact = findContact(store.jobRequest.primaryContactId);
	
	  return {
	    staticData: store.staticData,
	    jobRequest: store.jobRequest,
	    contacts: contacts,
	    primaryContact: primaryContact || store.contactProfile
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(JobRequestDetails, _React$Component);
	
	  function JobRequestDetails(props, context) {
	    _classCallCheck(this, JobRequestDetails);
	
	    var _this = _possibleConstructorReturn(this, (JobRequestDetails.__proto__ || Object.getPrototypeOf(JobRequestDetails)).call(this, props, context));
	
	    _this.handleEdit = function () {
	      return _this.switchModes(MODES.edit);
	    };
	
	    _this.handleClose = function () {
	      return _this.switchModes();
	    };
	
	    _this.handleChange = function (event, value) {
	
	      var jobrequest = {
	        id: _this.props.jobRequest.id,
	        primaryContactId: _this.props.jobRequest.primaryContactId,
	        jobRequestStatus: value
	      };
	
	      _this.props.handleUpdateStatus({ jobrequest: jobrequest });
	    };
	
	    _this.showDocuments = function () {
	      _this.setState({ showDocuments: true });
	    };
	
	    _this.closeDocuments = function () {
	      _this.setState({ showDocuments: false });
	    };
	
	    _this.state = {
	      mode: MODES.view,
	      status: null,
	      showDocuments: false
	    };
	    return _this;
	  }
	
	  _createClass(JobRequestDetails, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      socket.on('status updated', function (data) {
	        return console.log('e-mail from status changes:', data);
	      });
	
	      var getUsersById = function getUsersById(id) {
	        return _this2.props.dispatch(employeesApi.getUsersById(id));
	      };
	      var findContact = function findContact(profileId) {
	        return _lodash2.default.find(_this2.props.contacts, function (contact) {
	          return contact.profile.id === profileId;
	        });
	      };
	      var contact = findContact(this.props.jobRequest.primaryContactId) || this.props.contactProfile;
	
	      getUsersById(this.props.primaryContact.profile.clientAdvisorId).then(function (clientAdvisor) {
	
	        if (_this2.props.primaryContact.profile.clientAdvisorId) {
	          _this2.setState({ clientAdvisorName: clientAdvisor.firstName + ' ' + clientAdvisor.lastName });
	        }
	
	        return getUsersById(_this2.props.jobRequest.placementSpecialistId);
	      }).then(function (placementSpecialist) {
	
	        if (_this2.props.jobRequest.placementSpecialistId) {
	          _this2.setState({ placementSpecialistName: placementSpecialist.firstName + ' ' + placementSpecialist.lastName });
	        }
	
	        return getUsersById(_this2.props.primaryContact.company.relationshipManagerId);
	      }).then(function (relationshipManager) {
	
	        if (_this2.props.primaryContact.company.relationshipManagerId) {
	          _this2.setState({ relationshipManagerName: relationshipManager.firstName + ' ' + relationshipManager.lastName });
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var getUsersById = function getUsersById(id) {
	        return _this3.props.dispatch(employeesApi.getUsersById(id));
	      };
	
	      if (this.props.jobRequest.placementSpecialistId !== nextProps.jobRequest.placementSpecialistId) {
	
	        getUsersById(this.props.primaryContact.profile.clientAdvisorId).then(function (clientAdvisor) {
	
	          if (_this3.props.primaryContact.profile.clientAdvisorId) {
	            _this3.setState({ clientAdvisorName: clientAdvisor.firstName + ' ' + clientAdvisor.lastName });
	          }
	
	          return getUsersById(_this3.props.jobRequest.placementSpecialistId);
	        }).then(function (placementSpecialist) {
	
	          if (_this3.props.jobRequest.placementSpecialistId) {
	            _this3.setState({ placementSpecialistName: placementSpecialist.firstName + ' ' + placementSpecialist.lastName });
	          }
	
	          return getUsersById(_this3.props.primaryContact.company.relationshipManagerId);
	        }).then(function (relationshipManager) {
	
	          if (_this3.props.primaryContact.company.relationshipManagerId) {
	            _this3.setState({ relationshipManagerName: relationshipManager.firstName + ' ' + relationshipManager.lastName });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      socket.disconnect();
	    }
	  }, {
	    key: 'switchModes',
	    value: function switchModes() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MODES.view;
	
	      this.setState.apply(this, _toConsumableArray(this.state).concat([{ mode: mode }]));
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView() {
	      var _this4 = this;
	
	      var jobRequest = this.props.jobRequest;
	
	      var contact = this.props.primaryContact;
	      var status = (0, _staticData.getLookupValue)(this.props.staticData, 'jobRequestStatus', { id: jobRequest.jobRequestStatus });
	
	      var priorityReasonId = (0, _lodash.get)(jobRequest, 'priorityReason');
	      var priorityReason = _lodash2.default.find(this.props.staticData.jobRequestPriorityReasonTypes, { id: priorityReasonId });
	
	      var priorityId = (0, _lodash.get)(jobRequest, 'priority');
	      var priority = _lodash2.default.find(this.props.staticData.priorityTypes, { id: priorityId });
	
	      var findContact = function findContact(profileId) {
	        return _lodash2.default.find(_this4.props.contacts, function (contact) {
	          return contact.profile.id === profileId;
	        });
	      };
	      var reportingContact = findContact(jobRequest.reportingContactId);
	      var trainingContact = findContact(jobRequest.trainingContactId);
	      var technologyContact = findContact(jobRequest.technologyContactId) || _lodash2.default.find(this.props.contacts, function (contact) {
	        return _lodash2.default.indexOf(contact.profile.types, _staticData.CONTACT_ROLES.TECHNOLOGY) >= 0;
	      });
	      var billingContact = findContact(jobRequest.billingContactId) || _lodash2.default.find(this.props.contacts, function (contact) {
	        return _lodash2.default.indexOf(contact.profile.types, _staticData.CONTACT_ROLES.BILLING) >= 0;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-worksheet-details' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            (0, _staticData.lookup)(this.props.staticData, 'positionTypes', { id: jobRequest.positionTypeId })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cols' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col1' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'ID# ',
	              jobRequest.id
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Priority: ',
	              (0, _lodash.get)(priority, 'name', 'None')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              (0, _lodash.get)(priorityReason, 'name', 'None')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col2' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Client Advisor: ',
	              (0, _lodash.get)(this.state, 'clientAdvisorName', 'None')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Placement Specialist: ',
	              (0, _lodash.get)(this.state, 'placementSpecialistName', 'None')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Relationship Manager: ',
	              (0, _lodash.get)(this.state, 'relationshipManagerName', 'None')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col2' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Company:  ',
	              _react2.default.createElement(
	                'span',
	                { className: 'hover-link', onClick: function onClick() {
	                    return _this4.props.dispatch((0, _reactRouterRedux.push)('/admin/companies/' + contact.company.id + '/details'));
	                  } },
	                contact.company.name
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Contact: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'hover-link', onClick: function onClick() {
	                    return _this4.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + contact.profile.id + '/details'));
	                  } },
	                contact.user.firstName,
	                ' ',
	                contact.user.lastName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Reporting Contact: ',
	              (0, _lodash.get)(reportingContact, 'user.firstName', 'None') + ' ' + (0, _lodash.get)(reportingContact, 'user.lastName', '')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col2' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Technology Contact: ',
	              technologyContact ? _react2.default.createElement(
	                'span',
	                { className: 'hover-link', onClick: function onClick() {
	                    return _this4.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + technologyContact.profile.id + '/details'));
	                  } },
	                technologyContact.user.firstName + ' ' + technologyContact.user.lastName
	              ) : 'None'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Training Contact: ',
	              (0, _lodash.get)(trainingContact, 'user.firstName', 'None') + ' ' + (0, _lodash.get)(trainingContact, 'user.lastName', '')
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Billing Contact: ',
	              billingContact ? _react2.default.createElement(
	                'span',
	                { className: 'hover-link', onClick: function onClick(e) {
	                    return _this4.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts/' + billingContact.profile.id + '/details'));
	                  } },
	                billingContact.user.firstName + ' ' + billingContact.user.lastName
	              ) : 'None'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col2' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Date Created: ',
	              jobRequest.dateCreated ? (0, _prettyDate2.default)(jobRequest.dateCreated) : 'None'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Date Signed: ',
	              jobRequest.dateAuthorized ? (0, _prettyDate2.default)(jobRequest.dateAuthorized) : 'None'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Date Approved: ',
	              jobRequest.dateApproved ? (0, _prettyDate2.default)(jobRequest.dateApproved) : 'None'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'actions' },
	          _react2.default.createElement(
	            'div',
	            { className: 'job-status' },
	            _react2.default.createElement(_StatusDropDown2.default, {
	              status: status,
	              menuItems: this.props.staticData.jobRequestStatus,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'buttons' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { style: { width: 'auto', padding: '0', border: '0' }, 'data-id': 'document icon', onClick: this.showDocuments, tooltip: 'Documents', tooltipPosition: 'bottom-center' },
	                _react2.default.createElement(_DocumentIcon2.default, null)
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _IconButton2.default,
	                { style: { width: 'auto', padding: '0', border: '0' }, 'data-id': 'edit icon', onClick: this.handleEdit, tooltip: 'Edit', tooltipPosition: 'bottom-center' },
	                _react2.default.createElement(_EditIcon2.default, null)
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEdit',
	    value: function renderEdit() {
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'job-request-worksheeet-details-wrapper' },
	          this.state.mode === MODES.view && this.renderView() || this.state.mode === MODES.edit && this.renderEdit()
	        ),
	        this.state.showDocuments && _react2.default.createElement(_Documents2.default, { closeDocuments: this.closeDocuments }),
	        this.state.mode === MODES.edit && _react2.default.createElement(_EditJobRequestInformation2.default, { handleSave: this.props.handleSave, handleDelete: this.props.handleDelete, close: function close() {
	            return _this5.switchModes();
	          } })
	      );
	    }
	  }]);
	
	  return JobRequestDetails;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  handleSave: _react.PropTypes.func.isRequired,
	  handleDelete: _react.PropTypes.func.isRequired,
	  handleUpdateStatus: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  jobRequest: _react.PropTypes.object.isRequired,
	  contacts: _react.PropTypes.array.isRequired,
	  contactProfile: _react.PropTypes.object
	
	}, _temp)) || _class);
	exports.default = JobRequestDetails;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestDocuments = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    documents: state.jobRequestDocuments.documents,
	    profileId: state.jobRequest.primaryContactId
	  };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(JobRequestDocuments, _Component);
	
	  function JobRequestDocuments() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JobRequestDocuments);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JobRequestDocuments.__proto__ || Object.getPrototypeOf(JobRequestDocuments)).call.apply(_ref, [this].concat(args))), _this), _this.renderDocument = function (document) {
	
	      return _react2.default.createElement(
	        _c_SourceSimpleFileInput.RetrievalButton,
	        {
	          className: 'file-get',
	          loadingClass: '',
	          notLoadingClass: '',
	          failureClass: '',
	          autoLoad: true,
	          noMessage: true,
	          path: document.storagePath,
	          signingRoute: '/api/s3/get-sign'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'document-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'document-name' },
	            document.fileName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'document-desc-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'document-desc' },
	              document.description
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'document-filesize' },
	              ' ',
	              Math.max(Math.round(document.fileSize / 100000) / 10, 0.1) + ' Mgb'
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JobRequestDocuments, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-worksheet-documents' },
	        _react2.default.createElement(
	          'div',
	          { className: 'job-request-worksheet-documents-container' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'heading' },
	            'Available Documents ',
	            _react2.default.createElement(_ModalX2.default, { onClick: this.props.closeDocuments, style: { color: '#000' }, className: 'close-button' })
	          ),
	          !(0, _lodash.isEmpty)(this.props.documents) ? this.props.documents.map(function (document) {
	            return _this2.renderDocument(document);
	          }) : _react2.default.createElement(
	            'p',
	            null,
	            'No Documents Have Been Uploaded Yet'
	          )
	        )
	      );
	    }
	  }]);
	
	  return JobRequestDocuments;
	}(_react.Component), _class2.propTypes = {
	  documents: _react.PropTypes.object.isRequired,
	  closeDocuments: _react.PropTypes.func.isRequired,
	  profileId: _react.PropTypes.number.isRequired
	}, _temp2)) || _class);
	exports.default = JobRequestDocuments;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _lodash = __webpack_require__(4);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _employees = __webpack_require__(62);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _staticData = __webpack_require__(28);
	
	var _enums = __webpack_require__(92);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditJobRequestInformation = (_dec = (0, _reactRedux.connect)(function (state) {
	
	  var allContacts = state.companyContacts;
	  var primaryContact = allContacts.find(function (contact) {
	    return contact.profile.id === (0, _lodash.get)(state.jobRequest, 'primaryContactId', null);
	  });
	
	  return {
	    profileId: state.jobRequest.primaryContactId,
	    staticData: state.staticData,
	    jobRequest: state.jobRequest,
	    contacts: allContacts,
	    primaryContact: primaryContact
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(EditJobRequestInformation, _Component);
	
	  function EditJobRequestInformation(props) {
	    _classCallCheck(this, EditJobRequestInformation);
	
	    var _this = _possibleConstructorReturn(this, (EditJobRequestInformation.__proto__ || Object.getPrototypeOf(EditJobRequestInformation)).call(this, props));
	
	    _this.handleSave = function () {
	
	      _this.props.handleSave((0, _lodash.omit)(_this.state.form, ['contacts']));
	      _this.setState({ submitted: true }, _this.props.close);
	      _this.props.dispatch(ui.showSnackBar('Job request has been updated'));
	    };
	
	    _this.handleTextField = _this.handleTextField.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    _this.state = {
	      dirty: false,
	      form: {
	        jobrequest: (0, _lodash.pick)(_this.props.jobRequest, ['id', 'primaryContactId', 'priority', 'priorityReason', 'placementSpecialistId', 'reportingContactId', 'technologyContactId', 'trainingContactId', 'billingContactId'])
	      },
	      menuItems: {
	        employees: [],
	        contacts: (0, _staticData.convertContactsToMenuItems)(_this.props.contacts),
	        priority: (0, _staticData.convertToMenuItems)((0, _lodash.get)(_this.props, 'staticData.priorityTypes', [])),
	        priorityReason: (0, _staticData.convertToMenuItems)([{ id: null, name: 'None' }].concat(_toConsumableArray((0, _lodash.get)(_this.props, 'staticData.jobRequestPriorityReasonTypes', []))))
	      },
	      submitted: false
	    };
	    return _this;
	  }
	
	  _createClass(EditJobRequestInformation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var getEmployeesByRole = function getEmployeesByRole(role) {
	        return _this2.props.dispatch((0, _employees.getUsersByRole)(role));
	      };
	
	      getEmployeesByRole().then(function (rEmployees) {
	
	        var employees = (0, _staticData.convertEmployeeToMenuItems)(rEmployees);
	        var clonedState = (0, _lodash.merge)({}, _this2.state, { menuItems: { employees: employees } });
	
	        _this2.setState(clonedState);
	      });
	
	      getEmployeesByRole('Placement Specialist').then(function (rEmployees) {
	
	        var placementSpecialists = (0, _staticData.convertEmployeeToMenuItems)(rEmployees);
	        var clonedState = (0, _lodash.merge)({}, _this2.state, { menuItems: { placementSpecialists: placementSpecialists } });
	
	        _this2.setState(clonedState);
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this3 = this;
	
	      return function (event, value) {
	        var clonedState = (0, _lodash.merge)({}, _this3.state, { stateSaved: false, dirty: true });
	        (0, _lodash.set)(clonedState, prop, value);
	        _this3.setState(clonedState);
	      };
	    }
	  }, {
	    key: 'handleTextField',
	    value: function handleTextField(prop, label) {
	      return {
	        'data-id': prop,
	        value: (0, _lodash.get)(this.state, prop),
	        onBlur: this.handleChange(prop),
	        floatingLabelText: label || null,
	        isDirty: this.state.submitted
	      };
	    }
	  }, {
	    key: 'handleDropdown',
	    value: function handleDropdown(prop, label, tempValue) {
	      return {
	        'data-id': prop,
	        value: (0, _lodash.get)(this.state, prop) || tempValue,
	        onBlur: this.handleChange(prop),
	        floatingLabelText: label || null,
	        isDirty: this.state.submitted
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var disableOnApproved = this.props.jobRequest.jobRequestStatus >= _enums.JOB_REQUEST_STATUS.NA;
	
	      // (these fields might come back:)
	      // const techContact = find(this.props.contacts, (contact) => _.indexOf(contact.profile.types, CONTACT_ROLES.TECHNOLOGY) >= 0 );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-worksheet-edit-job-request-information' },
	        _react2.default.createElement(
	          'div',
	          { className: 'job-request-worksheet-edit-job-request-information-container' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'heading' },
	            'Edit Job Request Information ',
	            _react2.default.createElement(_ModalX2.default, { onClick: this.props.close, style: { color: '#000' }, className: 'close-button' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid grid-edit-jr-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleTextField('jobTitle', 'Job Title'), {
	                  value: (0, _staticData.lookup)(this.props.staticData, 'positionTypes', { id: this.props.jobRequest.positionTypeId }),
	                  disabled: true
	                }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleTextField('company', 'Company'), {
	                  disabled: true,
	                  value: this.props.primaryContact.company.name
	                }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleTextField('clientAdvisor', 'Client Advisor'), {
	                  disabled: true,
	                  value: (0, _staticData.lookup)(this.state.menuItems, 'employees', { value: this.props.primaryContact.profile.clientAdvisorId }) || ''
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdown('form.jobrequest.primaryContactId', 'Contact'), {
	                  menuItems: this.state.menuItems.contacts
	                }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdown('form.jobrequest.priority', 'Priority'), {
	                  menuItems: this.state.menuItems.priority,
	                  disabled: disableOnApproved
	                }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdown('form.jobrequest.priorityReason', 'Priority Reason'), {
	                  includeDefault: true,
	                  menuItems: this.state.menuItems.priorityReason,
	                  disabled: disableOnApproved
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdown('form.jobrequest.placementSpecialistId', 'Placement Specialist'), {
	                  menuItems: this.state.menuItems.placementSpecialists,
	                  disabled: disableOnApproved
	                }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleTextField('RelationshipManager', 'Relationship Manager'), {
	                  disabled: true,
	                  value: (0, _staticData.lookup)(this.state.menuItems, 'employees', { value: this.props.primaryContact.company.relationshipManagerId }) || ''
	                }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdown('form.jobrequest.reportingContactId', 'Reporting Contact'), {
	                  menuItems: this.state.menuItems.contacts
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdown('form.jobrequest.trainingContactId', 'Training Contact'), {
	                  menuItems: this.state.menuItems.contacts
	                }))
	              ),
	              _react2.default.createElement('div', { className: 'col' }),
	              _react2.default.createElement('div', { className: 'col' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'edit-jr-actions' },
	            _react2.default.createElement(_Button2.default, { className: 'button-delete',
	              label: 'DELETE',
	              onClick: function onClick(e) {
	                return _this4.setState({ showTransitionBlocker: true });
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'main-actions' },
	              _react2.default.createElement(_Button2.default, {
	                'data-id': 'button-cancel',
	                className: 'button-cancel',
	                label: 'CANCEL',
	                onClick: this.props.close
	              }),
	              _react2.default.createElement(_Button2.default, {
	                'data-id': 'button-save',
	                className: 'button-save',
	                label: 'SAVE',
	                onClick: this.handleSave
	              })
	            )
	          )
	        ),
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          cancelAction: function cancelAction(e) {
	            return _this4.setState({ showTransitionBlocker: false });
	          },
	          primaryAction: function primaryAction(e) {
	            return _this4.setState({ showTransitionBlocker: false });
	          },
	          primaryButtonLabel: 'Cancel',
	          secondaryAction: this.props.handleDelete,
	          secondaryButtonLabel: 'Delete',
	          transitionText: 'Are you sure you want to delete this job request?'
	        })
	      );
	    }
	  }]);
	
	  return EditJobRequestInformation;
	}(_react.Component), _class2.propTypes = {
	  close: _react.PropTypes.func.isRequired,
	  profileId: _react.PropTypes.number.isRequired,
	  jobRequest: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  contacts: _react.PropTypes.array.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  primaryContact: _react.PropTypes.object.isRequired,
	  handleSave: _react.PropTypes.func.isRequired,
	  handleDelete: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = EditJobRequestInformation;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestWorksheetBilling = (_temp = _class = function (_Component) {
	  _inherits(JobRequestWorksheetBilling, _Component);
	
	  function JobRequestWorksheetBilling(props) {
	    _classCallCheck(this, JobRequestWorksheetBilling);
	
	    var _this = _possibleConstructorReturn(this, (JobRequestWorksheetBilling.__proto__ || Object.getPrototypeOf(JobRequestWorksheetBilling)).call(this, props));
	
	    _this.handleSave = function () {
	
	      if (_this.state.dirty === false) {
	        return;
	      }
	
	      _this.props.handleSave({
	        company: {
	          id: _this.props.primaryContact.company.id
	        },
	        jobrequest: {
	          id: _this.props.jobRequest.id,
	          primaryContactId: _this.props.jobRequest.primaryContactId,
	          payRate: _this.currencyToNumber(_this.state.billing.payRate),
	          billRate: _this.currencyToNumber(_this.state.billing.billRate),
	          markUp: _this.state.billing.markUp,
	          commission: _this.state.billing.commission,
	          fee: _this.currencyToNumber(_this.state.billing.fee)
	        }
	      }).then(function () {
	        _this.setState({ dirty: false });
	      });
	    };
	
	    var markUp = _this.props.jobRequest.markUp || _this.props.jobRequest.billRate && _this.props.jobRequest.payRate ? (_this.props.jobRequest.billRate / _this.props.jobRequest.payRate).toFixed(2) : '0';
	
	    _this.state = {
	      dirty: false,
	      billing: {
	        placementFee: _this.props.primaryContact.company.placementFee,
	        salesPartner: _this.props.primaryContact.company.salesPartner,
	        fee: 0,
	        commission: _this.props.jobRequest.commission,
	        payRate: _this.maskCurrency(_this.props.jobRequest.payRate),
	        billRate: _this.maskCurrency(_this.props.jobRequest.billRate),
	        markUp: markUp
	      },
	      menuItems: {
	        placementFee: (0, _lodash.map)(_this.props.staticData.setupFees, function (item) {
	          return {
	            primaryText: item.name === '$0' ? 'Waived' : item.name,
	            value: _this.currencyToNumber(item.name)
	          };
	        }),
	        commission: (0, _lodash.map)(_this.props.staticData.commission, function (_ref) {
	          var value = _ref.value;
	          return { primaryText: value * 100 + '%', value: value };
	        })
	      }
	    };
	
	    _this.handleDropdown = _this.handleDropdown.bind(_this);
	    _this.handleTextField = _this.handleTextField.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(JobRequestWorksheetBilling, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.jobRequests) {
	        this.setState((0, _lodash.merge)({}, this.state, { jobRequest: nextProps.jobRequest }));
	      }
	    }
	  }, {
	    key: 'maskCurrency',
	    value: function maskCurrency(currency) {
	      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	
	      var currencyString = String(currency);
	      var lastDigit = currencyString[currencyString.length - 1];
	      var beforeLastDigit = currencyString[currencyString.length - 2];
	      if (lastDigit === '.') {
	        return currency;
	      }
	
	      if (lastDigit === '0' && beforeLastDigit !== '0') {
	        return currency;
	      }
	
	      var currencyNumber = Number(currencyString.replace(/[^0-9\.]+/g, ''));
	
	      return currencyNumber.toLocaleString('en-US', {
	        style: 'currency',
	        currency: 'USD',
	        minimumFractionDigits: 0,
	        maximumFractionDigits: precision
	      });
	    }
	  }, {
	    key: 'currencyToNumber',
	    value: function currencyToNumber(currency) {
	      var currencyString = String(currency);
	      return Number(currencyString.replace(/[^0-9\.]+/g, ''));
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this2 = this;
	
	      return function (event, value) {
	
	        var billing = (0, _lodash.merge)({}, _this2.state.billing);
	        billing[prop] = value;
	        var markup = _this2.currencyToNumber(billing.billRate) / _this2.currencyToNumber(billing.payRate);
	        billing.markUp = (0, _lodash.isNaN)(markup) ? 0 : markup.toFixed(2);
	        billing.payRate = _this2.maskCurrency(billing.payRate);
	        billing.billRate = _this2.maskCurrency(billing.billRate);
	        billing.fee = _this2.maskCurrency(billing.fee);
	
	        _this2.setState({ billing: billing, dirty: true });
	      };
	    }
	  }, {
	    key: 'handleDropdown',
	    value: function handleDropdown(prop, label, menuItems) {
	
	      return {
	        'data-id': prop,
	        value: this.state.billing[prop],
	        onChange: this.handleChange(prop),
	        floatingLabelText: label,
	        menuItems: menuItems,
	        disabled: this.props.disabled
	      };
	    }
	  }, {
	    key: 'handleTextField',
	    value: function handleTextField(prop, label) {
	
	      return {
	        'data-id': prop,
	        value: this.state.billing[prop],
	        onChange: this.handleChange(prop),
	        floatingLabelText: label,
	        disabled: this.props.disabled
	      };
	    }
	  }, {
	    key: 'handlePercentageChange',
	    value: function handlePercentageChange(prop, min, max) {
	      var handleChange = this.handleChange(prop);
	      return function (event, value) {
	        var number = (0, _lodash.isEmpty)(value) ? 0 : parseInt(value, 10);
	        if ((0, _lodash.isNil)(value) || !(0, _lodash.isNaN)(number) && number >= min && number <= max) {
	          handleChange(event, number);
	        }
	      };
	    }
	  }, {
	    key: 'renderSetupFee',
	    value: function renderSetupFee(state, props) {
	
	      var ACTIVE_ACCOUNT = 4;
	      var status = (0, _lodash.get)(props, 'primaryContact.company.companyStatus');
	      var setupFee = (0, _lodash.get)(props, 'labels.oneTimeSetupFee', true);
	
	      if (setupFee && ![ACTIVE_ACCOUNT].includes(status)) {
	        return _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdown('placementFee', 'One Time Setup Fee', state.menuItems.placementFee), { disabled: true }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var state = this.state;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-worksheet-billing' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'heading' },
	          'Billing'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleTextField('payRate', 'Pay Rate'))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleTextField('billRate', 'Bill Rate'))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleTextField('markUp', 'Mark Up %'), { onChange: this.handlePercentageChange('markUp', 0, 100) }))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  this.renderSetupFee(state, this.props)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col  grow-2' },
	                  _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropdown('salesPartner', 'Sales Partner', this.props.staticData.salesPartners), {
	                    disabled: true
	                  }))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  ' ',
	                  _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'commission-textfield' }, this.handleDropdown('commission', 'Commission', state.menuItems.commission))),
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-2' },
	                  _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'referrer-dropdown' }, this.handleDropdown('referrer', 'Referrer', [])))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({ className: 'fee-textfield' }, this.handleTextField('fee', 'Referrer Fee')))
	                )
	              )
	            )
	          ),
	          this.props.disabled ? null : _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_FlatButton2.default, {
	                className: (0, _classnames2.default)('button-save', { disabled: !this.state.dirty }),
	                onClick: this.handleSave,
	                'data-id': 'save',
	                label: 'save' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return JobRequestWorksheetBilling;
	}(_react.Component), _class.propTypes = {
	  handleSave: _react.PropTypes.func.isRequired,
	  jobRequest: _react.PropTypes.object.isRequired,
	  primaryContact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.object,
	  disabled: _react.PropTypes.bool
	}, _temp);
	exports.default = JobRequestWorksheetBilling;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestDescription = (_temp = _class = function (_Component) {
	  _inherits(JobRequestDescription, _Component);
	
	  function JobRequestDescription(props) {
	    _classCallCheck(this, JobRequestDescription);
	
	    var _this = _possibleConstructorReturn(this, (JobRequestDescription.__proto__ || Object.getPrototypeOf(JobRequestDescription)).call(this, props));
	
	    _this.handleChange = function (event, value) {
	
	      _this.setState({ dirty: true });
	      var jobrequest = {
	        id: _this.props.jobRequest.id,
	        primaryContactId: _this.props.jobRequest.primaryContactId,
	        description: value
	      };
	      _this.setState({ jobrequest: jobrequest });
	    };
	
	    _this.handleSave = function (jobrequest) {
	
	      if (_this.state.dirty === false) {
	        return;
	      }
	
	      _this.props.handleSave(jobrequest).then(function () {
	        _this.setState({ dirty: false });
	      });
	    };
	
	    _this.state = {
	      dirty: false,
	      jobrequest: {
	        description: props.jobRequest.description
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(JobRequestDescription, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-worksheet-description' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'heading' },
	          'Job Description'
	        ),
	        _react2.default.createElement(_c_TextArea2.default, {
	          onChange: this.handleChange,
	          className: 'job-description-textarea',
	          value: this.state.jobrequest.description,
	          disabled: this.props.disabled,
	          'data-id': 'job-description'
	        }),
	        this.props.disabled ? null : _react2.default.createElement(_c_FlatButton2.default, {
	          className: (0, _classnames2.default)('button-save', { disabled: !this.state.dirty }),
	          onClick: function onClick(e) {
	            return _this2.handleSave({ jobrequest: _this2.state.jobrequest });
	          },
	          'data-id': 'save',
	          label: 'save' })
	      );
	    }
	  }]);
	
	  return JobRequestDescription;
	}(_react.Component), _class.propTypes = {
	  jobRequest: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  handleSave: _react.PropTypes.func.isRequired,
	  disabled: _react.PropTypes.bool
	}, _temp);
	exports.default = JobRequestDescription;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _jobRequest = __webpack_require__(208);
	
	var _modelValidator = __webpack_require__(33);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _parentChildList = __webpack_require__(169);
	
	var _enums = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var yesNo = [{ value: true, primaryText: 'Yes', subElement: 'localJobDetails' }, { value: false, primaryText: 'No', subElement: null }];
	
	var PositionSection = (_temp = _class = function (_Component) {
	  _inherits(PositionSection, _Component);
	
	  function PositionSection(props, context) {
	    _classCallCheck(this, PositionSection);
	
	    var _this = _possibleConstructorReturn(this, (PositionSection.__proto__ || Object.getPrototypeOf(PositionSection)).call(this, props, context));
	
	    _this.handleChange = function (prop) {
	      return function (event, value) {
	        var jobRequest = _this.state.jobRequestModel;
	        jobRequest[prop] = value;
	        _this.setState((0, _lodash.merge)({}, _this.state, { jobRequestModel: jobRequest, stateSaved: false, dirty: true }));
	      };
	    };
	
	    _this.handleUI = function (prop, label) {
	      return {
	        'data-id': prop,
	        value: _this.state.jobRequestModel[prop],
	        errorText: _this.state.isDirty && (0, _jobRequest.getSchema)().position[prop] !== undefined ? (0, _modelValidator.validateField)(_this.state.jobRequestModel[prop], (0, _jobRequest.getSchema)().position[prop])[0] : undefined,
	        onChange: _this.handleChange(prop),
	        floatingLabelText: label || null,
	        isDirty: _this.state.isDirty,
	        disabled: _this.props.disabled
	      };
	    };
	
	    _this.handleUIDropdown = function (prop, label, menuItems) {
	      return _extends({
	        menuItems: menuItems
	      }, _this.handleUI(prop, label));
	    };
	
	    _this.state = {
	      dirty: false,
	      jobRequestModel: _this.props.jobRequest
	    };
	
	    _this.parentChildHandlers = (0, _parentChildList.parentChildList)();
	
	    return _this;
	  }
	
	  _createClass(PositionSection, [{
	    key: 'handleSave',
	    value: function handleSave() {
	      var _this2 = this;
	
	      if (this.state.dirty === false) {
	        return;
	      }
	
	      this.props.handleSave({
	        jobrequest: (0, _lodash.omit)(this.state.jobRequestModel, ['primaryContact', 'jobRequestStatus'])
	      }).then(function () {
	        _this2.setState({ dirty: false });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _parentChildHandlers = this.parentChildHandlers({
	        parentProps: this.handleUIDropdown('industryTypeId', this.props.labels.industryTypeId, this.props.staticData.industryTypesList),
	        childProps: this.handleUIDropdown('segmentTypeId', 'Industry Segment', this.props.staticData.jobRequestSegmentTypes)
	      }),
	          industryTypeProps = _parentChildHandlers.parent,
	          segmentTypeProps = _parentChildHandlers.child;
	
	      var isInNewRequestStatus = this.props.jobRequest.jobRequestStatus === _enums.JOB_REQUEST_STATUS.NEW_REQUEST ? true : false;
	      var disabled = isInNewRequestStatus || this.props.disabled;
	
	      var segmentTypes = (0, _lodash.get)(this.props.staticData, 'jobRequestSegmentTypes').filter(function (type) {
	        return !type.hide;
	      });
	      var otherSegmentType = (0, _lodash.get)((0, _lodash.find)(segmentTypes, { name: 'Other' }), 'id');
	
	      var industryTypes = (0, _lodash.get)(this.props.staticData, 'industryTypesList').filter(function (type) {
	        return !type.hide;
	      });
	      var otherIndustryType = (0, _lodash.get)((0, _lodash.find)(industryTypes, { name: 'Other' }), 'id');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-worksheet-position-section' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'heading' },
	          'Position Information'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({ 'data-id': 'question-dropdown-industry-type'
	            }, industryTypeProps, {
	              disabled: disabled
	            }))
	          ),
	          !!(this.state.jobRequestModel.industryTypeId && this.state.jobRequestModel.industryTypeId === otherIndustryType) && _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              floatingLabelFixed: true
	            }, this.handleUI('industryOther', this.props.labels.industryTypeId + ' Other')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({ 'data-id': 'question-dropdown-segment-type'
	            }, segmentTypeProps, {
	              disabled: disabled
	            }))
	          ),
	          !!(this.state.jobRequestModel.segmentTypeId && this.state.jobRequestModel.segmentTypeId === otherSegmentType) && _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1',
	              floatingLabelText: 'Industry Segment Other',
	              floatingLabelFixed: true
	            }, this.handleUI('segmentOther', 'Other, Please Specify')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-inner' },
	              _react2.default.createElement(
	                'div',
	                { className: 'field-inner grow-2' },
	                _react2.default.createElement(_c_DropDownMenu2.default, _extends({ 'data-id': 'question-dropdown-position-type'
	                }, this.handleUI('positionTypeId', 'Position Title'), {
	                  disabled: disabled,
	                  menuItems: this.props.staticData.positionTypes
	                }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'field-inner' },
	                _react2.default.createElement(_c_TextField2.default, _extends({ className: 'number-people'
	                }, this.handleUI('numberOfPeople', '# of Openings')))
	              )
	            )
	          ),
	          (0, _lodash.get)(this.props, 'labels.licenseRequired', true) && _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_ToggleButton2.default, _extends({
	              menuItems: yesNo
	            }, this.handleUI('licenseRequired', 'License Required')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_ToggleButton2.default, _extends({
	              menuItems: yesNo
	            }, this.handleUI('outsideContactRequired', 'Client Phone Contact')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_ToggleButton2.default, _extends({
	              menuItems: yesNo
	            }, this.handleUI('dualMonitorsRequired', 'Dual Monitors')))
	          )
	        ),
	        this.props.disabled ? null : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_c_FlatButton2.default, {
	            className: (0, _classnames2.default)('button-save', { disabled: !this.state.dirty }),
	            onClick: function onClick() {
	              return _this3.handleSave();
	            }, 'data-id': 'save', label: 'save' })
	        )
	      );
	    }
	  }]);
	
	  return PositionSection;
	}(_react.Component), _class.propTypes = {
	  jobRequest: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object,
	  labels: _react.PropTypes.object,
	  handleSave: _react.PropTypes.func,
	  disabled: _react.PropTypes.bool
	}, _temp);
	exports.default = PositionSection;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _strings = __webpack_require__(309);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _staticData = __webpack_require__(28);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var jobRequestWorksheetSchedule = (_temp = _class = function (_Component) {
	  _inherits(jobRequestWorksheetSchedule, _Component);
	
	  function jobRequestWorksheetSchedule(props) {
	    _classCallCheck(this, jobRequestWorksheetSchedule);
	
	    var _this = _possibleConstructorReturn(this, (jobRequestWorksheetSchedule.__proto__ || Object.getPrototypeOf(jobRequestWorksheetSchedule)).call(this, props));
	
	    _this.handleSave = function () {
	
	      if (_this.state.dirty === false) {
	        return;
	      }
	
	      _this.props.handleSave({
	        company: {
	          id: _this.props.primaryContact.company.id
	        },
	        jobrequest: (0, _lodash.omit)(_this.state.jobRequest, ['primaryContact'])
	      }).then(function () {
	        _this.setState({ dirty: false });
	      });
	    };
	
	    _this.jobRequestLocation = function () {
	      var _this$state$jobReques = _this.state.jobRequest,
	          jobRequest = _this$state$jobReques === undefined ? {} : _this$state$jobReques;
	
	      var user = (0, _lodash.get)(_this.props.primaryContact, 'user', {});
	      var contactState = (0, _lodash.get)((0, _lodash.find)(_this.props.staticData.stateList, { id: user.state }), 'primaryText');
	      var jobState = (0, _lodash.get)((0, _lodash.find)(_this.props.staticData.stateList, { id: jobRequest.state }), 'primaryText');
	
	      if (jobRequest.city) {
	        return (0, _strings.concat)([(0, _strings.concat)([jobRequest.address, jobRequest.address2], ' '), jobRequest.city, (0, _strings.concat)([jobState, jobRequest.zip], ' ')], ', ');
	      }
	
	      return (0, _strings.concat)([user.address, user.city, (0, _strings.concat)([contactState, user.zip], ' ')], ', ');
	    };
	
	    _this.state = {
	      jobRequest: props.jobRequest,
	      dirty: false
	    };
	
	    _this.handleDropdown = _this.handleDropdown.bind(_this);
	    _this.handleTextField = _this.handleTextField.bind(_this);
	    _this.handleToggleButton = _this.handleToggleButton.bind(_this);
	    _this.handleDateProperties = _this.handleDateProperties.bind(_this);
	
	    _this.menuItems = {
	      numberOfMonth: [{
	        primaryText: '6',
	        subElement: null,
	        value: 6
	      }, {
	        primaryText: '7',
	        subElement: null,
	        value: 7
	      }, {
	        primaryText: '8',
	        subElement: null,
	        value: 8
	      }, {
	        primaryText: '9',
	        subElement: null,
	        value: 9
	      }, {
	        primaryText: '10',
	        subElement: null,
	        value: 10
	      }, {
	        primaryText: '11',
	        subElement: null,
	        value: 11
	      }, {
	        primaryText: '1 yr',
	        subElement: null,
	        value: 12
	      }, {
	        primaryText: '2 yrs',
	        subElement: null,
	        value: 24
	      }],
	      hoursPerWeek: [{
	        primaryText: 20,
	        subElement: null,
	        value: 20
	      }, {
	        primaryText: 25,
	        subElement: null,
	        value: 25
	      }, {
	        primaryText: 30,
	        subElement: null,
	        value: 30
	      }, {
	        primaryText: 35,
	        subElement: null,
	        value: 35
	      }, {
	        primaryText: 37.5,
	        subElement: null,
	        value: 37.5
	      }, {
	        primaryText: 40,
	        subElement: null,
	        value: 40
	      }],
	      yesNo: [{ value: true, primaryText: 'Yes', subElement: null }, { value: false, primaryText: 'No', subElement: null }],
	      daysPerWeek: _this.props.staticData.dayAvailableTypes,
	      preferredStartTime: (0, _staticData.convertToMenuItems)(_this.props.staticData.workHours.slice(0, 25), 'id', 'name', 'subElement'),
	      preferredEndTime: (0, _staticData.convertToMenuItems)(_this.props.staticData.workHours.slice(6, _this.props.staticData.workHours.length), 'id', 'name', 'subElement'),
	      jobType: (0, _staticData.convertToMenuItems)(_this.props.staticData.jobTypes, 'id', 'name', 'subElement'),
	      timezone: (0, _staticData.convertToMenuItems)(_this.props.staticData.timezoneList, 'id', 'name')
	    };
	
	    return _this;
	  }
	
	  _createClass(jobRequestWorksheetSchedule, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.jobRequest) {
	        this.setState((0, _lodash.merge)({}, this.state, { jobRequest: nextProps.jobRequest }));
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this2 = this;
	
	      return function (event, value) {
	
	        _this2.setState({ dirty: true });
	
	        var jobRequest = (0, _lodash.assign)({}, _this2.state.jobRequest);
	        jobRequest[prop] = value;
	
	        _this2.setState({ jobRequest: jobRequest });
	      };
	    }
	  }, {
	    key: 'handleDateProperties',
	    value: function handleDateProperties(prop, label) {
	      return {
	        'data-id': 'date-' + prop,
	        defaultValue: this.state.jobRequest[prop],
	        floatingLabelText: label,
	        onChange: this.handleChange(prop),
	        floatingLabelFixed: true,
	        disabled: this.props.disabled
	      };
	    }
	  }, {
	    key: 'handleDropdown',
	    value: function handleDropdown(prop, label, menuItems) {
	      return {
	        'data-id': prop,
	        value: this.state.jobRequest[prop],
	        onChange: this.handleChange(prop),
	        floatingLabelText: label,
	        menuItems: menuItems,
	        canAutoPosition: true,
	        disabled: this.props.disabled
	      };
	    }
	  }, {
	    key: 'handleTextField',
	    value: function handleTextField(prop, label) {
	
	      return {
	        'data-id': prop,
	        value: this.state.jobRequest[prop],
	        onChange: this.handleChange(prop),
	        floatingLabelText: label,
	        floatingLabelFixed: true,
	        disabled: this.props.disabled
	      };
	    }
	  }, {
	    key: 'handleToggleButton',
	    value: function handleToggleButton(prop, label) {
	      return {
	        'data-id': 'tooglebutton-' + prop,
	        value: this.state.jobRequest[prop],
	        onChange: this.handleChange(prop),
	        floatingLabelText: label || null,
	        disabled: this.props.disabled
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	
	      var contactUser = props.primaryContact.user;
	      var contactState = (0, _lodash.get)((0, _lodash.find)(props.staticData.stateList, { id: contactUser.state }), 'primaryText');
	
	      var jobType = (0, _staticData.getLookupValue)(props.staticData, 'jobTypes', { id: this.state.jobRequest.jobTypeId });
	      var isProjectType = jobType && jobType.hardcodelink === 'PROJECT';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-worksheet-schedule' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'heading' },
	          'Schedule'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'read-only-field' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'label' },
	                  'Job Office Reporting Location'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'value' },
	                  this.jobRequestLocation()
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropdown('timezone', 'Job Time Zone', this.menuItems.timezone))
	            ),
	            _react2.default.createElement('div', { className: 'col' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropdown('jobTypeId', 'Type of Job', this.menuItems.jobType))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_DateInput2.default, _extends({ className: 'half-width', autoOk: true, minDate: new Date() }, this.handleDateProperties('dateStarted', 'Expected Start Date')))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_CheckList2.default, this.handleDropdown('workdays', 'Days of the Week', this.menuItems.daysPerWeek))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col' },
	                      _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropdown('estimatedHoursPerWeek', 'Hrs. Week', this.menuItems.hoursPerWeek))
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col' },
	                      isProjectType && _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropdown('numberOfMonths', 'Months', this.menuItems.numberOfMonth))
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  isProjectType && _react2.default.createElement(_DateInput2.default, _extends({ className: 'half-width', autoOk: true, minDate: new Date() }, this.handleDateProperties('dateEnded', 'Expected End Date')))
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  ' ',
	                  _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropdown('startTime', 'Pref. Start Time', this.menuItems.preferredStartTime)),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  ' ',
	                  _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropdown('endTime', 'Pref. End Time', this.menuItems.preferredEndTime)),
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({ menuItems: this.menuItems.yesNo }, this.handleToggleButton('offHoursConsidered', 'Work Can Be Performed Outside of Business Hours')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              this.state.jobRequest.estimatedHoursPerWeek >= 40 && _react2.default.createElement(_c_ToggleButton2.default, _extends({ menuItems: this.menuItems.yesNo }, this.handleToggleButton('partTimeWahvesConsidered', 'Consider Two Wahves')))
	            )
	          ),
	          this.props.disabled ? null : _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_FlatButton2.default, {
	                className: (0, _classnames2.default)('button-save', { disabled: !this.state.dirty }),
	                onClick: this.handleSave,
	                'data-id': 'save',
	                label: 'save' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return jobRequestWorksheetSchedule;
	}(_react.Component), _class.propTypes = {
	  jobRequest: _react.PropTypes.object.isRequired,
	  primaryContact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  handleSave: _react.PropTypes.func.isRequired,
	  disabled: _react.PropTypes.bool
	}, _temp);
	exports.default = jobRequestWorksheetSchedule;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _jobRequest = __webpack_require__(208);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _staticData = __webpack_require__(28);
	
	var _Table = __webpack_require__(72);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var jobRequestWorksheetSkills = (_temp = _class = function (_Component) {
	  _inherits(jobRequestWorksheetSkills, _Component);
	
	  _createClass(jobRequestWorksheetSkills, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.jobRequest) {
	        this.setState((0, _lodash.merge)({}, this.state, { jobRequest: nextProps.jobRequest }));
	      }
	    }
	  }]);
	
	  function jobRequestWorksheetSkills(props) {
	    _classCallCheck(this, jobRequestWorksheetSkills);
	
	    var _this = _possibleConstructorReturn(this, (jobRequestWorksheetSkills.__proto__ || Object.getPrototypeOf(jobRequestWorksheetSkills)).call(this, props));
	
	    _this.handleSave = function (evt) {
	
	      if (_this.state.dirty === false) {
	        return;
	      }
	
	      _this.props.handleSave({
	        company: {
	          id: _this.props.primaryContact.company.id
	        },
	        jobrequest: (0, _lodash.omit)(_this.state.jobRequest, ['primaryContact'])
	      }).then(function () {
	        _this.setState({ dirty: false });
	      });
	    };
	
	    _this.state = {
	      jobRequest: props.jobRequest,
	      dirty: false
	    };
	
	    _this.handleSkillDropdown = _this.handleSkillDropdown.bind(_this);
	
	    _this.menuItems = {
	      skills: (0, _staticData.convertToMenuItems)(_this.props.staticData.skillOptionTypes, 'id', 'name')
	    };
	
	    return _this;
	  }
	
	  _createClass(jobRequestWorksheetSkills, [{
	    key: 'handleChange',
	    value: function handleChange(target) {
	      var _this2 = this;
	
	      return function (event, value) {
	        _this2.setState({ dirty: true });
	        var skills = _this2.state.jobRequest.skills;
	
	        (0, _lodash.map)((0, _lodash.get)(skills, '' + target.categoryId), function (skill, index) {
	          if (skill.name === target.name) {
	            (0, _lodash.set)(skills, target.categoryId + '.' + index + '.skillOption', value);
	          }
	        });
	
	        _this2.setState({ jobRequest: _this2.state.jobRequest });
	      };
	    }
	  }, {
	    key: 'handleSkillDropdown',
	    value: function handleSkillDropdown(skill, menuItems, index) {
	
	      return {
	        'data-id': 'skillOption' + index,
	        value: skill.skillOption,
	        onChange: this.handleChange(skill),
	        menuItems: menuItems,
	        canAutoPosition: true,
	        disabled: this.props.disabled
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var props = this.props,
	          state = this.state;
	
	      var skills = (0, _lodash.flatten)((0, _lodash.valuesIn)(this.props.jobRequest.skills));
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-worksheet-skills' },
	        _react2.default.createElement(
	          'div',
	          { className: 'summary-skills-table' },
	          _react2.default.createElement(
	            _Table.Table,
	            { selectable: false, multiSelectable: false },
	            _react2.default.createElement(
	              _Table.TableHeader,
	              { displaySelectAll: false, adjustForCheckbox: false },
	              _react2.default.createElement(
	                _Table.TableRow,
	                null,
	                _react2.default.createElement(
	                  _Table.TableHeaderColumn,
	                  { style: { 'paddingRight': '0', 'paddingLeft': '0' }, className: 'name' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Skills'
	                  )
	                ),
	                _react2.default.createElement(
	                  _Table.TableHeaderColumn,
	                  { style: { width: '120px', 'paddingRight': '0', 'paddingLeft': '0' }, className: 'option' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Importance'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Table.TableBody,
	              { displayRowCheckbox: false },
	              skills.map(function (skill, index) {
	                return skill.name !== 'None' && _react2.default.createElement(
	                  _Table.TableRow,
	                  { key: skill.categoryId + '-' + skill.name },
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { style: { 'paddingRight': '0', 'paddingLeft': '0' }, 'data-id': 'SkillName' + index, className: 'name' },
	                    skill.name
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { style: { width: '143px', 'paddingRight': '0', 'paddingLeft': '0' }, className: 'option' },
	                    _react2.default.createElement(_c_DropDownMenu2.default, _extends({ style: { width: '100%' } }, _this3.handleSkillDropdown(skill, _this3.menuItems.skills, index)))
	                  )
	                );
	              })
	            )
	          )
	        ),
	        this.props.disabled ? null : _react2.default.createElement(
	          'div',
	          { className: 'grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_FlatButton2.default, {
	                className: (0, _classnames2.default)('button-save', { disabled: !this.state.dirty }),
	                onClick: this.handleSave,
	                'data-id': 'save',
	                label: 'save' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return jobRequestWorksheetSkills;
	}(_react.Component), _class.propTypes = {
	  jobRequest: _react.PropTypes.object.isRequired,
	  primaryContact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  handleSave: _react.PropTypes.func.isRequired,
	  disabled: _react.PropTypes.bool
	}, _temp);
	exports.default = jobRequestWorksheetSkills;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _PositionSection = __webpack_require__(976);
	
	var _PositionSection2 = _interopRequireDefault(_PositionSection);
	
	var _Billing = __webpack_require__(974);
	
	var _Billing2 = _interopRequireDefault(_Billing);
	
	var _Schedule = __webpack_require__(977);
	
	var _Schedule2 = _interopRequireDefault(_Schedule);
	
	var _Skills = __webpack_require__(978);
	
	var _Skills2 = _interopRequireDefault(_Skills);
	
	var _Description = __webpack_require__(975);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _enums = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function JobRequestWorksheetProfile(props) {
	  var _props$staticData = props.staticData,
	      staticData = _props$staticData === undefined ? {} : _props$staticData,
	      _props$labels = props.labels,
	      labels = _props$labels === undefined ? {} : _props$labels,
	      _props$jobRequest = props.jobRequest,
	      jobRequest = _props$jobRequest === undefined ? null : _props$jobRequest,
	      _props$primaryContact = props.primaryContact,
	      primaryContact = _props$primaryContact === undefined ? null : _props$primaryContact,
	      handleSave = props.handleSave;
	
	
	  var disabled = jobRequest.jobRequestStatus >= _enums.JOB_REQUEST_STATUS.NA;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'job-request-worksheet-profile' },
	    _react2.default.createElement(_PositionSection2.default, {
	      disabled: disabled,
	      handleSave: handleSave,
	      jobRequest: jobRequest,
	      labels: labels.position,
	      staticData: staticData
	    }),
	    _react2.default.createElement(_Description2.default, {
	      handleSave: handleSave,
	      staticData: staticData,
	      primaryContact: primaryContact,
	      jobRequest: jobRequest,
	      disabled: disabled
	    }),
	    _react2.default.createElement(_Skills2.default, {
	      handleSave: handleSave,
	      staticData: staticData,
	      primaryContact: primaryContact,
	      jobRequest: jobRequest,
	      disabled: disabled
	    }),
	    _react2.default.createElement(_Schedule2.default, {
	      handleSave: handleSave,
	      staticData: staticData,
	      primaryContact: primaryContact,
	      jobRequest: jobRequest,
	      disabled: disabled
	    }),
	    _react2.default.createElement(_Billing2.default, {
	      handleSave: handleSave,
	      staticData: staticData,
	      primaryContact: primaryContact,
	      jobRequest: jobRequest,
	      disabled: disabled,
	      labels: labels.billing
	    })
	  );
	}
	
	JobRequestWorksheetProfile.propTypes = {
	  handleSave: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.object.isRequired,
	  jobRequest: _react.PropTypes.object.isRequired,
	  user: _react.PropTypes.object,
	  primaryContact: _react.PropTypes.object,
	  contacts: _react.PropTypes.array,
	  dispatch: _react.PropTypes.func
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	
	  var allContacts = state.companyContacts;
	  var primaryContact = allContacts.find(function (contact) {
	    return contact.profile.id === (0, _lodash.get)(state.jobRequest, 'primaryContactId', null);
	  });
	
	  return {
	    staticData: state.staticData,
	    jobRequest: state.jobRequest,
	    primaryContact: primaryContact,
	    user: state.user,
	    contacts: allContacts,
	    labels: (0, _lodash.get)(state, 'labels.jobRequest', {})
	  };
	})(JobRequestWorksheetProfile);

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _Worksheet = __webpack_require__(298);
	
	var _Worksheet2 = _interopRequireDefault(_Worksheet);
	
	var _Details = __webpack_require__(971);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _TackIcon = __webpack_require__(205);
	
	var _TackIcon2 = _interopRequireDefault(_TackIcon);
	
	var _staticData = __webpack_require__(28);
	
	var _jobrequestsAdmin = __webpack_require__(1122);
	
	var jobrequestsAdminApi = _interopRequireWildcard(_jobrequestsAdmin);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobrequestsApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequestsAdmin2 = __webpack_require__(1129);
	
	var jobrequestsAdminStore = _interopRequireWildcard(_jobrequestsAdmin2);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _sync = __webpack_require__(21);
	
	var _employees = __webpack_require__(62);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestWorksheet = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    staticData: state.staticData,
	    jobRequest: state.jobRequest,
	    primaryContact: state.companyContacts.find(function (contact) {
	      return contact.profile.id === state.jobRequest.primaryContactId;
	    }),
	    pinnedData: (0, _lodash.get)(state, 'pins.pinned', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(JobRequestWorksheet, _Component);
	
	  function JobRequestWorksheet(props) {
	    _classCallCheck(this, JobRequestWorksheet);
	
	    var _this = _possibleConstructorReturn(this, (JobRequestWorksheet.__proto__ || Object.getPrototypeOf(JobRequestWorksheet)).call(this, props));
	
	    _this.handleSave = function (request) {
	      var updateJobRequest = _this.props.dispatch(jobrequestsAdminApi.updateJobRequest(request.jobrequest.id, request));
	      var updateJobRequestStore = function updateJobRequestStore(data) {
	        return _this.props.dispatch(jobrequestsAdminStore.updateJobRequest(data));
	      };
	
	      var updatedJobRequest = (0, _lodash.merge)({}, _this.props.jobRequest, request.jobrequest);
	
	      return updateJobRequest.then(function () {
	        return updateJobRequestStore(updatedJobRequest);
	      }).then(function () {
	        _this.setState({ showSaved: true });
	        _this.props.dispatch(ui.showSnackBar('Job request has been updated'));
	      });
	    };
	
	    _this.handleDelete = function () {
	      var deleteJobRequest = _this.props.dispatch(jobrequestsApi.deleteJobRequest(_this.props.jobRequest.id));
	
	      return deleteJobRequest.then(function () {
	        _this.props.dispatch(ui.showSnackBar('Job request has been deleted'));
	        _this.props.dispatch((0, _reactRouterRedux.goBack)());
	      });
	    };
	
	    _this.handleUpdateStatus = function (request) {
	
	      if (request.jobrequest.jobRequestStatus && request.jobrequest.jobRequestStatus === _staticData.JOB_REQUEST_STATUS.APPROVED_REQUEST) {
	        // check if there's a placement specialist
	        if (!_this.props.jobRequest.placementSpecialistId) {
	          // show placement specialist modal
	          _this.setState({ showTransitionBlocker: true });
	          return;
	        }
	      }
	
	      var updateJobRequestStore = function updateJobRequestStore(data) {
	        return _this.props.dispatch(jobrequestsAdminStore.updateJobRequest(data));
	      };
	
	      _this.props.dispatch(jobrequestsAdminApi.updateJobRequestStatus(request.jobrequest.id, request.jobrequest.jobRequestStatus)).then(function () {
	        return updateJobRequestStore(request.jobrequest);
	      }).then(function () {
	        _this.setState({ showSaved: true });
	      });
	    };
	
	    _this.handlePlacementChange = function (event, value) {
	      _this.setState({ placementSpecialistId: value });
	    };
	
	    _this.handlePlacementUpdate = function (event) {
	      if (_this.state.placementSpecialistId) {
	        var jobRequest = { id: _this.props.jobRequest.id, jobRequestStatus: _staticData.JOB_REQUEST_STATUS.APPROVED_REQUEST, placementSpecialistId: _this.state.placementSpecialistId };
	        _this.handleSave({ jobrequest: jobRequest }).then(function () {
	          return _this.handleUpdateStatus({ jobrequest: jobRequest });
	        });
	
	        _this.setState({ showTransitionBlocker: false });
	      }
	    };
	
	    _this.isPinned = function () {
	      return (0, _lodash.indexOf)((0, _lodash.get)(_this.props.pinnedData, 'jobRequests', []), _this.props.jobRequest.id) >= 0;
	    };
	
	    _this.handleTogglePin = function () {
	      return function () {
	        var newPinnedData = _this.props.pinnedData;
	        if (_this.isPinned()) {
	          (0, _lodash.pull)(newPinnedData.jobRequests, _this.props.jobRequest.id);
	        } else {
	          (0, _lodash.set)(newPinnedData, 'jobRequests', (0, _lodash.union)((0, _lodash.get)(newPinnedData, 'jobRequests', []), [_this.props.jobRequest.id]));
	        }
	
	        _this.props.dispatch((0, _employees.updatePins)(newPinnedData, function (err, pins) {
	          if (!err) {
	            _this.props.dispatch((0, _sync.loadPins)(pins));
	          }
	        }));
	      };
	    };
	
	    _this.state = {
	      showSaved: false,
	      showTransitionBlocker: false,
	      menuItems: {}
	    };
	
	    return _this;
	  }
	
	  _createClass(JobRequestWorksheet, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var getEmployeesByRole = function getEmployeesByRole(role) {
	        return _this2.props.dispatch((0, _employees.getUsersByRole)(role));
	      };
	
	      getEmployeesByRole('Placement Specialist').then(function (rEmployees) {
	
	        var placementSpecialists = (0, _staticData.convertEmployeeToMenuItems)(rEmployees);
	        var clonedState = (0, _lodash.merge)({}, _this2.state, { menuItems: { placementSpecialists: placementSpecialists } });
	
	        _this2.setState(clonedState);
	      });
	    }
	
	    // pin functions
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props$primaryContact = this.props.primaryContact,
	          primaryContact = _props$primaryContact === undefined ? null : _props$primaryContact;
	
	
	      var placementSpecialistDropdown = _react2.default.createElement(_c_DropDownMenu2.default, {
	        className: 'transition-placement-dropdown',
	        'data-id': 'transition-placement-dropdown',
	        menuItems: (0, _lodash.get)(this.state, 'menuItems.placementSpecialists', []),
	        onChange: this.handlePlacementChange
	      });
	
	      var pin = _react2.default.createElement(
	        'div',
	        { className: 'pin', onClick: this.handleTogglePin() },
	        ' ',
	        _react2.default.createElement(_TackIcon2.default, null),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'pin-text' },
	          this.isPinned() ? 'unpin' : 'pin'
	        )
	      );
	
	      return _react2.default.createElement(
	        _Worksheet2.default,
	        {
	          baseRoute: '/admin/jobrequests',
	          dispatch: this.props.dispatch,
	          location: this.props.location,
	          pin: pin,
	          className: 'job-request-worksheet'
	        },
	        _react2.default.createElement(
	          'div',
	          { key: 'Card' },
	          _react2.default.createElement(_Details2.default, { jobId: this.props.jobId, handleSave: this.handleSave, handleUpdateStatus: this.handleUpdateStatus, handleDelete: this.handleDelete })
	        ),
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          primaryAction: this.handlePlacementUpdate,
	          primaryButtonLabel: 'Save',
	          secondaryAction: function secondaryAction(e) {
	            return _this3.setState({ showTransitionBlocker: false });
	          },
	          secondaryButtonLabel: 'Cancel',
	          cancelAction: function cancelAction(e) {
	            return _this3.setState({ showTransitionBlocker: false });
	          },
	          control: placementSpecialistDropdown,
	          transitionText: 'You have not selected a placement specialist. <br />Please select one before changing the job request status to approved.',
	          className: 'jobrequest-approve'
	        }),
	        _react2.default.cloneElement(this.props.children, { handleSave: this.handleSave, jobRequest: this.props.jobRequest, primaryContact: primaryContact })
	      );
	    }
	  }]);
	
	  return JobRequestWorksheet;
	}(_react.Component), _class2.propTypes = {
	  jobRequest: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  primaryContact: _react.PropTypes.object.isRequired,
	  location: _react.PropTypes.object.isRequired,
	  jobId: _react.PropTypes.number.isRequired,
	  children: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = JobRequestWorksheet;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _querystring = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavColumn = (_dec = (0, _reactRedux.connect)(function (store) {
	  var searchQuery = store.routing.locationBeforeTransitions.query.search;
	  return {
	    search: searchQuery && [].concat(searchQuery) || []
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(NavColumn, _Component);
	
	  function NavColumn(props, context) {
	    _classCallCheck(this, NavColumn);
	
	    return _possibleConstructorReturn(this, (NavColumn.__proto__ || Object.getPrototypeOf(NavColumn)).call(this, props, context));
	  }
	
	  _createClass(NavColumn, [{
	    key: 'changeNavColumnState',
	    value: function changeNavColumnState(newColumnState) {
	      this.props.dispatch((0, _reactRouterRedux.push)(this.props.baseUrl + '/' + newColumnState + (this.props.search.length ? '?' + (0, _querystring.stringify)({ search: this.props.search }) : '')));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'nav-column' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          this.props.navGroups.map(function (statusGroup, index) {
	            return _this2.props.navItems && _react2.default.createElement(
	              'li',
	              { className: (0, _classnames2.default)({ active: !_this2.props.navColumnState && index === 0 || _this2.props.navColumnState === statusGroup }),
	                key: index,
	                'data-id': statusGroup,
	                onClick: _this2.changeNavColumnState.bind(_this2, statusGroup) },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                statusGroup
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'count', 'data-id': statusGroup + ' Count' },
	                _this2.props.navItems[statusGroup] && (_this2.props.navItems[statusGroup].total || _this2.props.navItems[statusGroup].length || 0)
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return NavColumn;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  navGroups: _react.PropTypes.array.isRequired,
	  navItems: _react.PropTypes.object.isRequired,
	  baseUrl: _react.PropTypes.string.isRequired,
	  navColumnState: _react.PropTypes.string,
	  search: _react.PropTypes.array,
	  title: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = NavColumn;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _LogoSmall = __webpack_require__(456);
	
	var _LogoSmall2 = _interopRequireDefault(_LogoSmall);
	
	var _MenuIcon = __webpack_require__(457);
	
	var _MenuIcon2 = _interopRequireDefault(_MenuIcon);
	
	var _ContactIcon = __webpack_require__(454);
	
	var _ContactIcon2 = _interopRequireDefault(_ContactIcon);
	
	var _CandidateIcon = __webpack_require__(452);
	
	var _CandidateIcon2 = _interopRequireDefault(_CandidateIcon);
	
	var _CompanyIcon = __webpack_require__(453);
	
	var _CompanyIcon2 = _interopRequireDefault(_CompanyIcon);
	
	var _JobRequestIcon = __webpack_require__(455);
	
	var _JobRequestIcon2 = _interopRequireDefault(_JobRequestIcon);
	
	var _Settings = __webpack_require__(894);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _lodash = __webpack_require__(4);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationAdmin = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    user: store.user
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(NavigationAdmin, _React$Component);
	
	  function NavigationAdmin(props) {
	    _classCallCheck(this, NavigationAdmin);
	
	    var _this = _possibleConstructorReturn(this, (NavigationAdmin.__proto__ || Object.getPrototypeOf(NavigationAdmin)).call(this, props));
	
	    _this.toggleNavigation = function () {
	      _this.setState({ isOpen: !_this.state.isOpen });
	    };
	
	    _this.handleClick = function (event, url) {
	      _this.props.dispatch(ui.showSpinner());
	      _this.props.dispatch((0, _reactRouterRedux.push)(url));
	    };
	
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(NavigationAdmin, [{
	    key: 'isActiveSection',
	    value: function isActiveSection(path) {
	      return this.props.location.pathname.toLowerCase().startsWith(path.toLowerCase());
	    }
	  }, {
	    key: 'isActiveSections',
	    value: function isActiveSections(paths) {
	      return !!~paths.indexOf(this.props.location.pathname.toLowerCase());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var roles = (0, _lodash.get)(this.props.user, 'roles', []);
	      var isAdmin = roles.includes('Admin');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'navigation-admin ' + (this.state.isOpen ? ' open' : '') },
	        _react2.default.createElement(_LogoSmall2.default, { collapsed: !this.state.isOpen, className: 'navigation-admin-logo', style: { color: '#fefefe', backgroundColor: '#161a21' } }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'navigation-admin-list' },
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'admin-nav-candidate', className: this.isActiveSections(['/admin/in process', '/admin/inactive', '/admin/qualified', '/admin/standby']) ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/admin/In Process');
	              } },
	            _react2.default.createElement(_CandidateIcon2.default, null),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Candidates'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'admin-nav-contact', className: this.isActiveSection('/admin/contacts') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/admin/contacts');
	              } },
	            _react2.default.createElement(_ContactIcon2.default, null),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Contacts'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'admin-nav-company', className: this.isActiveSection('/admin/companies') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/admin/companies/');
	              } },
	            _react2.default.createElement(_CompanyIcon2.default, null),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Companies'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'admin-nav-jobrequest', className: this.isActiveSection('/admin/jobrequests') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/admin/jobrequests');
	              } },
	            _react2.default.createElement(_JobRequestIcon2.default, null),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Job Requests'
	            )
	          ),
	          isAdmin && _react2.default.createElement(
	            'li',
	            { 'data-id': 'admin-nav-settings', className: this.isActiveSection('/admin/settings/') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/admin/settings/users');
	              } },
	            _react2.default.createElement(_Settings2.default, null),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Settings'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'navigation-admin-list menu' },
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'admin-nav-add-contact', className: this.isActiveSection('/admin/Prospect') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/admin/Prospect');
	              } },
	            _react2.default.createElement(_ContactIcon2.default, { showPlus: true }),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Add Contact'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'admin-nav-toggle', onClick: this.toggleNavigation },
	            _react2.default.createElement(_MenuIcon2.default, { isOpen: this.state.isOpen }),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Close'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavigationAdmin;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  location: _react.PropTypes.object.isRequired,
	  user: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = NavigationAdmin;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AccordionList = __webpack_require__(445);
	
	var _AccordionList2 = _interopRequireDefault(_AccordionList);
	
	var _referenceItem = __webpack_require__(985);
	
	var _referenceItem2 = _interopRequireDefault(_referenceItem);
	
	var _placementSpecialists = __webpack_require__(984);
	
	var _placementSpecialists2 = _interopRequireDefault(_placementSpecialists);
	
	var _async = __webpack_require__(37);
	
	var asyncActions = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var References = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var applicantGroupName = void 0;
	  var arrayIndex = void 0;
	
	  var applicant = state.admin.applicant;
	
	  return {
	    dispatch: state.dispatch,
	    applicant: applicant,
	    applicantGroupName: applicantGroupName,
	    arrayIndex: arrayIndex,
	    staticData: state.staticData,
	    references: state.references,
	    workExperiences: state.workExperiences,
	    interviews: state.interviews,
	    placementSpecialists: state.placementSpecialists,
	    route: {
	      params: props.params,
	      query: props.location.query
	    }
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(References, _React$Component);
	
	  function References(props) {
	    _classCallCheck(this, References);
	
	    var _this = _possibleConstructorReturn(this, (References.__proto__ || Object.getPrototypeOf(References)).call(this, props));
	
	    _this.state = {
	      open: false,
	      applicant: _this.initState(props)
	    };
	    return _this;
	  }
	
	  _createClass(References, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState(_lodash2.default.merge({}, this.state, this.initState(nextProps)));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (_lodash2.default.isNil(this.state.placementSpecialists) || _lodash2.default.isEmpty(this.state.placementSpecialists)) {
	        this.props.dispatch(asyncActions.retrievePlacementSpecialists());
	      }
	    }
	  }, {
	    key: 'initState',
	    value: function initState(props) {
	      return {
	        profile: {
	          id: _lodash2.default.get(props, 'applicant.profile.id'),
	          placementSpecialistId: _lodash2.default.get(props, 'applicant.profile.placementSpecialistId')
	        },
	        user: {
	          id: _lodash2.default.get(props, 'applicant.user.id')
	        }
	      };
	    }
	  }, {
	    key: 'professionalReferences',
	    value: function professionalReferences() {
	      var _this2 = this;
	
	      var references = _lodash2.default.filter(this.props.workExperiences, function (job) {
	        return job.contactEmployer;
	      });
	      var pro = references.map(function (item) {
	        var interview = _this2.props.interviews ? _lodash2.default.find(_this2.props.interviews, { workExperienceClientId: item.clientId }) : null;
	        return {
	          name: item.employerName,
	          title: item.title,
	          clientId: item.clientId,
	          type: 'Professional',
	          reference: item,
	          interview: _lodash2.default.merge({}, interview, _this2.state[item.clientId])
	        };
	      });
	      return pro;
	    }
	  }, {
	    key: 'additionalReferences',
	    value: function additionalReferences() {
	      var _this3 = this;
	
	      return _lodash2.default.map(this.props.references, function (item) {
	        var interview = _this3.props.interviews ? _lodash2.default.find(_this3.props.interviews, { referencesClientId: item.clientId }) : null;
	        return {
	          name: item.name,
	          title: item.position,
	          clientId: item.clientId,
	          type: 'Additional',
	          reference: item,
	          interview: _lodash2.default.merge({}, interview, _this3.state[item.clientId])
	        };
	      });
	    }
	  }, {
	    key: 'placementSpecialists',
	    value: function placementSpecialists() {
	      this.props.dispatch(asyncActions.updatePlacementSpecialists());
	    }
	  }, {
	    key: 'updateTempState',
	    value: function updateTempState(prop, newState) {
	      this.setState(_lodash2.default.merge({}, _extends({}, this.state), _defineProperty({}, prop, newState)));
	    }
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle() {
	      var _this4 = this;
	
	      _lodash2.default.debounce(function () {
	        return _this4.updateTempState('open', !_this4.state.open);
	      }, 100); // Prevent state from being updated too frequently
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave(referenceClientId) {
	      var interview = this.state[referenceClientId];
	      if (interview) {
	        var payload = _extends({}, interview, { clientId: interview.isNew ? '' + referenceClientId + _shortid2.default.generate() : interview.clientId });
	        this.props.dispatch(asyncActions.persistReferencesInterviews(this.props.applicant, payload));
	        this.updateTempState(referenceClientId, null);
	      }
	    }
	  }, {
	    key: 'handleUpdateReference',
	    value: function handleUpdateReference(reference, type) {
	      var route = '';
	      var property = '';
	      if (type === 'Professional') {
	        route = 'workexperiences';
	        property = 'workExperiences';
	      } else {
	        route = 'references';
	        property = 'references';
	      }
	      this.props.dispatch(asyncActions.updateApplicantList(route, property, this.state.applicant.profile.id, reference.clientId, _lodash2.default.pick(reference.reference, ['phoneNumber', 'supervisorEmail', 'supervisorPhoneNumber'])));
	    }
	  }, {
	    key: 'handleSavePS',
	    value: function handleSavePS(employeeId) {
	      if (employeeId !== this.props.applicant.profile.placementSpecialistId) {
	        var update = _lodash2.default.merge(this.state.applicant, { profile: { placementSpecialistId: employeeId || null } });
	        this.props.dispatch(asyncActions.persistApplicantUpdate(update));
	        this.props.dispatch(syncActions.updateApplicant(update));
	        this.props.dispatch(syncActions.updateCurrentApplicantAdmin(_lodash2.default.merge(this.props.applicant, update)));
	      }
	    }
	  }, {
	    key: 'getReferenceTitle',
	    value: function getReferenceTitle(item) {
	      if (item.type === 'Professional') {
	        var startDate = (0, _moment2.default)(item.reference.employmentStart).format('MMMM YYYY');
	        var endDate = (0, _moment2.default)(item.reference.employmentEnd).format('MMMM YYYY');
	        return '(' + item.type + ') ' + item.reference.employerName + '. (' + startDate + ' - ' + endDate + ')';
	      }
	      return '(' + item.type + ') ' + item.reference.company + ' ' + item.reference.position + '. (' + item.reference.yearsKnown + ' years)';
	    }
	  }, {
	    key: 'renderEmpty',
	    value: function renderEmpty() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'accordion-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'scroll-hide' },
	          _react2.default.createElement(
	            'div',
	            { className: 'references-empty', style: { height: global.innerHeight - 311 + 'px' } },
	            'There are no references for us to contact.'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderReferences',
	    value: function renderReferences(profile) {
	      var _this5 = this;
	
	      var references = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      return _react2.default.createElement(
	        _AccordionList2.default,
	        {
	          onToggle: this.handleToggle.bind(this) },
	        references.map(function (item, index) {
	          return _react2.default.createElement(
	            _AccordionList.AccordionListItem,
	            {
	              key: index,
	              itemKey: item.clientId,
	              titleLead: item.reference.supervisorName || item.reference.name,
	              title: _this5.getReferenceTitle(item),
	              done: (item.interview || {}).complete,
	              onSave: _this5.handleSave.bind(_this5, item.clientId)
	            },
	            _react2.default.createElement(_referenceItem2.default, {
	              updateTempState: _this5.updateTempState.bind(_this5),
	              applicant: _this5.props.applicant,
	              referenceClientId: item.clientId,
	              reference: item,
	              referenceType: item.type,
	              referenceRelationshipTypes: _this5.props.staticData.referenceRelationshipTypes,
	              questions: _this5.props.staticData.referenceQuestions,
	              onComplete: _this5.handleSave.bind(_this5, item.clientId),
	              updateReference: _this5.handleUpdateReference.bind(_this5) })
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var professional = this.professionalReferences();
	      var additional = this.additionalReferences();
	      var references = [].concat(_toConsumableArray(professional), _toConsumableArray(additional));
	      var profile = _lodash2.default.get(this.props, 'applicant.profile');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'references-container', style: { height: global.innerHeight - 311 + 'px' } },
	        _react2.default.createElement(_placementSpecialists2.default, {
	          profile: profile,
	          specialists: this.props.placementSpecialists,
	          onAssignPS: this.handleSavePS.bind(this)
	        }),
	        profile && references.length ? this.renderReferences(profile, references) : this.renderEmpty()
	      );
	    }
	  }]);
	
	  return References;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  applicant: _react.PropTypes.object.isRequired,
	  workExperiences: _react.PropTypes.object.isRequired,
	  references: _react.PropTypes.array.isRequired,
	  interviews: _react.PropTypes.object.isRequired,
	  route: _react.PropTypes.object.isRequired,
	  placementSpecialists: _react.PropTypes.array
	}, _temp)) || _class);
	exports.default = References;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReferenceListPlacementSpecialists;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function ReferenceListPlacementSpecialists(props) {
	  var profile = props.profile;
	  var handleAssignPS = props.onAssignPS;
	  var defaultOption = { value: 0, primaryText: 'Placement Specialist' };
	  var placementSpecialists = [];
	  if (!_lodash2.default.isEmpty(props.specialists)) {
	    placementSpecialists = props.specialists.map(function (item) {
	      return { value: item.employeeId, primaryText: item.firstName + ' ' + item.lastName };
	    });
	  }
	  var menuItems = [defaultOption].concat(_toConsumableArray(placementSpecialists));
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'references-list-placement-specialists' },
	    _react2.default.createElement(
	      'div',
	      { className: 'label' },
	      'Placement Specialist:'
	    ),
	    _react2.default.createElement(_c_DropDownMenu2.default, {
	      'data-id': 'Placement Specialist',
	      defaultValue: profile.placementSpecialistId || 0,
	      menuItems: menuItems,
	      onChange: function onChange(event, value) {
	        return handleAssignPS(value);
	      } })
	  );
	}
	
	ReferenceListPlacementSpecialists.propTypes = {
	  profile: _react.PropTypes.object.isRequired,
	  onAssignPS: _react.PropTypes.func.isRequired,
	  specialists: _react.PropTypes.array
	};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_RatingStars = __webpack_require__(451);
	
	var _c_RatingStars2 = _interopRequireDefault(_c_RatingStars);
	
	var _MaskedInput = __webpack_require__(856);
	
	var _MaskedInput2 = _interopRequireDefault(_MaskedInput);
	
	var _prettyDate = __webpack_require__(75);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// styling obj
	var completeButtonStyle = {
	  border: 'solid 1px #808080',
	  width: '296px',
	  height: '45px'
	};
	
	var textFieldStyle = {
	  margin: '-8px 0 2px',
	  width: '100%',
	  height: '100px',
	  minHeight: '100px',
	  lineHeight: '1.63'
	};
	
	var ReferenceItem = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    staticData: store.staticData
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ReferenceItem, _React$Component);
	
	  function ReferenceItem(props, context) {
	    _classCallCheck(this, ReferenceItem);
	
	    var _this = _possibleConstructorReturn(this, (ReferenceItem.__proto__ || Object.getPrototypeOf(ReferenceItem)).call(this, props, context));
	
	    _this.handleReferenceUpdate = function () {
	      _this.props.updateReference(_this.state.reference, _this.props.referenceType);
	    };
	
	    return _this;
	  }
	
	  _createClass(ReferenceItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        reference: this.props.reference
	      };
	    }
	  }, {
	    key: 'getReferenceType',
	    value: function getReferenceType() {
	      var _this2 = this;
	
	      var referenceTypes = this.props.staticData.referenceTypes;
	
	      return referenceTypes.find(function (referenceType) {
	        return referenceType.name === _this2.props.referenceType;
	      });
	    }
	  }, {
	    key: 'isProfessional',
	    value: function isProfessional() {
	      var referenceType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getReferenceType();
	
	      return referenceType.name === 'Professional';
	    }
	  }, {
	    key: 'isAdditional',
	    value: function isAdditional() {
	      var referenceType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getReferenceType();
	
	      return referenceType.name === 'Additional';
	    }
	  }, {
	    key: 'newInterview',
	    value: function newInterview() {
	      var referenceType = this.getReferenceType();
	      return {
	        applicantId: this.props.applicant.profile.id,
	        workExperienceClientId: this.isProfessional(referenceType) ? this.props.reference.clientId : null,
	        referencesClientId: this.isAdditional(referenceType) ? this.props.reference.clientId : null,
	        referenceType: referenceType.id,
	        complete: false,
	        isNew: true,
	        answers: []
	      };
	    }
	  }, {
	    key: 'replaceTokens',
	    value: function replaceTokens(label, tokens) {
	      return _lodash2.default.reduce(tokens, function (newLabel, token) {
	        return newLabel.replace(token[0], token[1]);
	      }, label);
	    }
	  }, {
	    key: 'handleAnswerChange',
	    value: function handleAnswerChange(questionId, event, value) {
	      var newVal = _lodash2.default.isBoolean(value) ? value ? 'Yes' : 'No' : value;
	      var interviewState = !_lodash2.default.isEmpty(this.props.reference.interview) ? _extends({}, this.props.reference.interview) : this.newInterview();
	      var index = _lodash2.default.findIndex(interviewState.answers, function (answer) {
	        return answer.questionId === questionId;
	      });
	      if (~index) {
	        interviewState.answers[index].answer = newVal;
	      } else {
	        interviewState.answers.push({ questionId: questionId, answer: newVal });
	      }
	      interviewState.isDirty = true;
	      this.props.updateTempState(this.props.referenceClientId, interviewState);
	    }
	  }, {
	    key: 'handleInterviewChange',
	    value: function handleInterviewChange(prop, event, value) {
	      var _this3 = this;
	
	      var interviewState = this.props.reference.interview ? _extends({}, this.props.reference.interview) : this.newInterview();
	      interviewState[prop] = prop === 'complete' ? true : value;
	      interviewState.isDirty = true;
	      this.props.updateTempState(this.props.referenceClientId, interviewState);
	      if (prop === 'complete') {
	        setTimeout(function () {
	          return _this3.props.onComplete();
	        }, 0);
	      }
	    }
	  }, {
	    key: 'handleReferenceChange',
	    value: function handleReferenceChange(prop) {
	      var _this4 = this;
	
	      return function (event, value) {
	        var newReference = _this4.state.reference;
	        newReference.reference[prop] = value;
	        _this4.setState({ reference: newReference });
	      };
	    }
	  }, {
	    key: 'renderTextArea',
	    value: function renderTextArea(question, answers) {
	      var answer = _lodash2.default.find(answers, { questionId: question.id }) || {};
	      return _react2.default.createElement(_c_TextArea2.default, {
	        style: textFieldStyle,
	        value: (answer || {}).answer,
	        onChange: this.handleAnswerChange.bind(this, question.id) });
	    }
	  }, {
	    key: 'renderYesNo',
	    value: function renderYesNo(question, answers) {
	      var answer = _lodash2.default.find(answers, { questionId: question.id }) || {};
	      var options = [{ value: 'Yes', primaryText: 'Yes' }, { value: 'No', primaryText: 'No' }];
	      return _react2.default.createElement(_c_DropDownMenu2.default, {
	        'data-id': 'question ' + question.id,
	        defaultValue: (answer || {}).answer,
	        menuItems: options,
	        onChange: this.handleAnswerChange.bind(this, question.id) });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var tokens = [['[applicant_name]', this.props.applicant.user.firstName + ' ' + this.props.applicant.user.lastName], ['[job_title]', this.props.reference.title]];
	      var notSpecified = 'Not specified';
	      var referenceType = this.getReferenceType(this.props.referenceType);
	      var answers = this.props.reference.interview && this.props.reference.interview.answers || [];
	      var questions = _lodash2.default.filter(this.props.questions, function (q) {
	        return q.referenceType === referenceType.id || q.referenceType === null;
	      });
	      var valid = _lodash2.default.filter(answers, function (a) {
	        return a.answer.length;
	      }).length === questions.length && this.props.reference.interview.rating && this.props.reference.interview.comments;
	      var isComplete = this.props.reference.interview.complete && !this.props.reference.interview.isDirty;
	      var relationship = _lodash2.default.find(this.props.referenceRelationshipTypes, { id: this.props.reference.reference.relationshipId });
	      if (relationship && relationship.name && ~relationship.name.indexOf('Other')) {
	        relationship.name = this.props.reference.reference.relationshipOther;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'explanation-of-wahve' },
	        _react2.default.createElement(
	          'div',
	          { className: 'reference-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'reference-info-container' },
	            _react2.default.createElement(_c_TextField2.default, {
	              value: this.isProfessional(referenceType) ? this.props.reference.reference.supervisorName : this.props.reference.name,
	              floatingLabelText: this.isProfessional(referenceType) ? "Supervisor's Name" : "Reference's Name",
	              disabled: true
	            }),
	            this.isProfessional(referenceType) && _react2.default.createElement(_c_TextField2.default, {
	              value: this.props.reference.name || notSpecified,
	              floatingLabelText: 'Company Name',
	              disabled: true
	            }),
	            this.isAdditional(referenceType) && _react2.default.createElement(_c_TextField2.default, {
	              value: (relationship || {}).name || notSpecified,
	              floatingLabelText: 'Relationship',
	              disabled: true
	            }),
	            _react2.default.createElement(_c_TextField2.default, {
	              value: this.props.reference.title || notSpecified,
	              floatingLabelText: 'Position/Title',
	              disabled: true
	            }),
	            this.isProfessional(referenceType) && _react2.default.createElement(_c_TextField2.default, {
	              className: 'email',
	              value: this.state.reference.reference.supervisorEmail || notSpecified,
	              floatingLabelText: "Supervisor's Email",
	              onBlur: this.handleReferenceUpdate.bind(this),
	              onChange: this.handleReferenceChange('supervisorEmail')
	            }),
	            _react2.default.createElement(_c_MaskedTextField2.default, {
	              mask: '(999) 999-9999',
	              className: 'phone-number',
	              hideMaskChar: true,
	              defaultValue: this.isProfessional(referenceType) ? this.state.reference.reference.supervisorPhoneNumber : this.state.reference.reference.phoneNumber,
	              floatingLabelText: this.isProfessional(referenceType) ? "Supervisor's Phone Number" : "Reference's Phone Number",
	              onBlur: this.handleReferenceUpdate.bind(this),
	              onChange: this.handleReferenceChange(this.isProfessional(referenceType) ? 'supervisorPhoneNumber' : 'phoneNumber')
	            }),
	            this.isAdditional(referenceType) && _react2.default.createElement(_c_TextField2.default, {
	              value: this.props.reference.reference.yearsKnown || notSpecified,
	              floatingLabelText: 'Years Known',
	              disabled: true
	            }),
	            this.isProfessional(referenceType) && _react2.default.createElement(_MaskedInput2.default, _defineProperty({
	              'data-id': 'Employment Start',
	              className: 'reference-date',
	              disabled: true,
	              type: _MaskedInput.MaskTypes.monthYear,
	              value: (0, _prettyDate.monthYear)(this.props.reference.reference.employmentStart),
	              floatingLabelText: 'Employment Start'
	            }, 'disabled', true)),
	            this.isProfessional(referenceType) && _react2.default.createElement(_MaskedInput2.default, _defineProperty({
	              'data-id': 'Employment End',
	              className: 'reference-date',
	              disabled: true,
	              type: _MaskedInput.MaskTypes.monthYear,
	              value: this.props.reference.reference.current ? 'Current' : (0, _prettyDate.monthYear)(this.props.reference.reference.employmentEnd),
	              floatingLabelText: 'Employment End'
	            }, 'disabled', true))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'reference-questions-container' },
	            _lodash2.default.map(_lodash2.default.sortBy(questions, 'order'), function (item, index) {
	              return _react2.default.createElement(
	                'div',
	                { key: index, className: 'reference-question' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _this5.replaceTokens(item.question, tokens)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  item.questionType === 2 ? _this5.renderYesNo(item, answers) : _this5.renderTextArea(item, answers)
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'reference-questions-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'reference-question' },
	              _react2.default.createElement(_c_RatingStars2.default, {
	                'data-id': 'Rating',
	                floatingLabelText: 'Reference Rating',
	                value: (this.props.reference.interview || {}).rating,
	                onChange: this.handleInterviewChange.bind(this, 'rating')
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'reference-question' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Final Comments'
	              ),
	              _react2.default.createElement(_c_TextArea2.default, {
	                'data-id': 'Comments',
	                style: textFieldStyle,
	                value: (this.props.reference.interview || {}).comments,
	                onChange: this.handleInterviewChange.bind(this, 'comments')
	              })
	            )
	          ),
	          _react2.default.createElement(_c_FlatButton2.default, {
	            className: 'complete-button',
	            disabled: !valid || isComplete,
	            label: 'Complete',
	            'data-id': 'Complete',
	            style: completeButtonStyle,
	            onClick: this.handleInterviewChange.bind(this, 'complete')
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReferenceItem;
	}(_react2.default.Component), _class2.propTypes = {
	  staticData: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  onComplete: _react.PropTypes.func.isRequired,
	  updateReference: _react.PropTypes.func.isRequired,
	  reference: _react.PropTypes.object.isRequired,
	  referenceType: _react.PropTypes.string.isRequired,
	  questions: _react.PropTypes.array.isRequired,
	  applicant: _react.PropTypes.object.isRequired,
	  referenceClientId: _react.PropTypes.string.isRequired,
	  referenceRelationshipTypes: _react.PropTypes.array.isRequired
	}, _temp)) || _class);
	exports.default = ReferenceItem;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _emails = __webpack_require__(235);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var yesNo = [{ value: true, primaryText: 'Yes', subElement: null }, { value: false, primaryText: 'No', subElement: null }];
	var htmlview = [{ value: true, primaryText: 'preview', subElement: null }, { value: false, primaryText: 'plain text', subElement: null }];
	
	var CreateEmailTemplate = (_dec = (0, _reactRedux.connect)(function (store) {
	  return { staticData: store.staticData };
	}, {
	  createTemplate: _emails.createTemplate,
	  showSnackBar: ui.showSnackBar
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CreateEmailTemplate, _Component);
	
	  function CreateEmailTemplate() {
	    _classCallCheck(this, CreateEmailTemplate);
	
	    var _this = _possibleConstructorReturn(this, (CreateEmailTemplate.__proto__ || Object.getPrototypeOf(CreateEmailTemplate)).call(this));
	
	    _this.state = {
	      submitted: false,
	      htmlview: true,
	      enabled: true,
	      html: ''
	    };
	
	    _this.handleClose = function (event) {
	      _this.props.onClose && _this.props.onClose(event);
	    };
	
	    _this.save = _this.save.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(CreateEmailTemplate, [{
	    key: 'handleUI',
	    value: function handleUI(prop, label) {
	
	      return {
	        'data-id': prop,
	        value: this.state[prop],
	        floatingLabelText: label,
	        onBlur: this.handleChange(prop),
	        onChange: this.handleChange(prop),
	        isDirty: this.state.submitted,
	        errorText: this.validate(prop)
	      };
	    }
	  }, {
	    key: 'validate',
	    value: function validate() {
	      return;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this2 = this;
	
	      return function (event, value) {
	
	        if (prop === 'htmlview' && value === false) {
	          var html = document.getElementById('email-dialog-editor').innerHTML;
	          html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
	          _this2.setState({ html: html });
	        }
	
	        _this2.setState(_defineProperty({}, prop, value));
	      };
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;
	
	      var html = document.getElementById('email-dialog-editor').innerHTML;
	
	      var template = {
	        html: html,
	        subject: this.state.subject,
	        name: this.state.name,
	        enabled: this.state.enabled
	      };
	
	      return this.props.createTemplate(template).then(function (templates) {
	        _this3.props.showSnackBar();
	        _this3.props.onUpdate(templates);
	        _this3.handleClose();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClickOut: this.handleClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'create-email-template-modal' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Create Email Template'
	          ),
	          _react2.default.createElement(_c_TextField2.default, _extends({ className: 'control-input-text' }, this.handleUI('name', 'Email Template Name'))),
	          _react2.default.createElement(_c_TextField2.default, _extends({ className: 'control-input-text' }, this.handleUI('subject', 'Subject'))),
	          _react2.default.createElement(_c_ToggleButton2.default, _extends({
	            className: 'toggle-enabled',
	            menuItems: yesNo
	          }, this.handleUI('enabled', 'Enable'))),
	          this.state.htmlview && _react2.default.createElement(
	            'div',
	            { className: 'email-dialog-editor-container' },
	            _react2.default.createElement('div', {
	              id: 'email-dialog-editor',
	              className: 'email-dialog-editor',
	              contentEditable: 'true',
	              dangerouslySetInnerHTML: { __html: this.state.html }
	            })
	          ),
	          !this.state.htmlview && _react2.default.createElement(_c_TextArea2.default, _extends({
	            className: 'email-dialog-editor-plaintext'
	          }, this.handleUI('html'))),
	          _react2.default.createElement(_c_ToggleButton2.default, _extends({
	            className: 'htmlview',
	            menuItems: htmlview
	          }, this.handleUI('htmlview'))),
	          _react2.default.createElement(
	            'div',
	            { className: 'email-dialog-actions' },
	            _react2.default.createElement(_Button2.default, { label: 'save', onClick: this.save }),
	            _react2.default.createElement(_Button2.default, { className: 'button-secondary', label: 'cancel', onClick: this.handleClose })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateEmailTemplate;
	}(_react.Component), _class2.propTypes = {
	  onClose: _react.PropTypes.func.isRequired,
	  showSnackBar: _react.PropTypes.func.isRequired,
	  createTemplate: _react.PropTypes.func.isRequired,
	  onUpdate: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = CreateEmailTemplate;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _emails = __webpack_require__(235);
	
	var _Modal = __webpack_require__(141);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var yesNo = [{ value: true, primaryText: 'Yes', subElement: null }, { value: false, primaryText: 'No', subElement: null }];
	var htmlview = [{ value: true, primaryText: 'preview', subElement: null }, { value: false, primaryText: 'plain text', subElement: null }];
	
	var EditEmailTemplate = (_dec = (0, _reactRedux.connect)(function (store) {
	  return { staticData: store.staticData };
	}, {
	  updateTemplate: _emails.updateTemplate,
	  deleteTemplate: _emails.deleteTemplate,
	  showSnackBar: ui.showSnackBar
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(EditEmailTemplate, _Component);
	
	  function EditEmailTemplate() {
	    _classCallCheck(this, EditEmailTemplate);
	
	    var _this = _possibleConstructorReturn(this, (EditEmailTemplate.__proto__ || Object.getPrototypeOf(EditEmailTemplate)).call(this));
	
	    _this.state = {
	      submitted: false,
	      htmlview: false,
	      enabled: true
	    };
	
	    _this.handleClose = function (event) {
	      _this.props.onClose && _this.props.onClose(event);
	    };
	
	    _this.save = _this.save.bind(_this);
	    _this.remove = _this.remove.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditEmailTemplate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState(_extends({}, this.props.template));
	    }
	  }, {
	    key: 'handleUI',
	    value: function handleUI(prop, label) {
	
	      return {
	        'data-id': prop,
	        value: this.state[prop],
	        floatingLabelText: label,
	        onBlur: this.handleChange(prop),
	        onChange: this.handleChange(prop),
	        isDirty: this.state.submitted,
	        errorText: this.validate(prop)
	      };
	    }
	  }, {
	    key: 'validate',
	    value: function validate() {
	      return;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this2 = this;
	
	      return function (event, value) {
	
	        if (prop === 'htmlview' && value === false) {
	          var html = document.getElementById('email-dialog-editor').innerHTML;
	          html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
	
	          _this2.setState({ html: html });
	        }
	
	        _this2.setState(_defineProperty({}, prop, value));
	      };
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this3 = this;
	
	      var el = document.getElementById('email-dialog-editor');
	      var html = void 0;
	
	      if (el) {
	        html = (0, _lodash.get)(el, 'innerText', '').replace(/\n/g, '<br/>');
	      } else {
	        html = this.state.html;
	      }
	
	      var template = {
	        html: html,
	        subject: this.state.subject,
	        name: this.state.name,
	        enabled: this.state.enabled
	      };
	
	      return this.props.updateTemplate(this.state.id, template).then(function (templates) {
	        _this3.props.showSnackBar();
	        _this3.props.onUpdate(templates);
	        _this3.handleClose();
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var _this4 = this;
	
	      return this.props.deleteTemplate(this.state.id).then(function (templates) {
	        _this4.props.showSnackBar();
	        _this4.props.onUpdate(templates);
	        _this4.handleClose();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { onClickOut: this.handleClose },
	        _react2.default.createElement(
	          'div',
	          { className: 'create-email-template-modal' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Edit Email Template'
	          ),
	          _react2.default.createElement(_c_TextField2.default, _extends({ className: 'control-input-text' }, this.handleUI('name', 'Email Template Name'))),
	          _react2.default.createElement(_c_TextField2.default, _extends({ className: 'control-input-text' }, this.handleUI('subject', 'Subject'))),
	          _react2.default.createElement(_c_ToggleButton2.default, _extends({
	            className: 'toggle-enabled',
	            menuItems: yesNo
	          }, this.handleUI('enabled', 'Enable'))),
	          _react2.default.createElement(_c_TextArea2.default, _extends({
	            className: 'email-dialog-editor-plaintext'
	          }, this.handleUI('html'))),
	          _react2.default.createElement(
	            'div',
	            { className: 'email-dialog-actions' },
	            _react2.default.createElement(_Button2.default, { label: 'save', onClick: this.save }),
	            _react2.default.createElement(_Button2.default, { className: 'button-secondary', label: 'cancel', onClick: this.handleClose }),
	            _react2.default.createElement(_Button2.default, { className: (0, _classnames2.default)('button-delete', { 'button-delete-disabled': this.state.system }), label: 'delete template', onClick: this.remove })
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditEmailTemplate;
	}(_react.Component), _class2.propTypes = {
	  onClose: _react.PropTypes.func.isRequired,
	  showSnackBar: _react.PropTypes.func.isRequired,
	  updateTemplate: _react.PropTypes.func.isRequired,
	  deleteTemplate: _react.PropTypes.func.isRequired,
	  template: _react.PropTypes.object,
	  onUpdate: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = EditEmailTemplate;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailList = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(EmailList, _Component);
	
	    function EmailList() {
	        _classCallCheck(this, EmailList);
	
	        var _this = _possibleConstructorReturn(this, (EmailList.__proto__ || Object.getPrototypeOf(EmailList)).call(this));
	
	        _this.onSelectTemplate = _this.onSelectTemplate.bind(_this);
	        _this.renderItem = _this.renderItem.bind(_this);
	        return _this;
	    }
	
	    _createClass(EmailList, [{
	        key: 'onSelectTemplate',
	        value: function onSelectTemplate(template) {
	
	            this.props.onSelectTemplate && this.props.onSelectTemplate(template);
	        }
	    }, {
	        key: 'renderItem',
	        value: function renderItem(template) {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('email-item', { 'email-item-selected': template.selected, 'email-item-disabled': !template.enabled }), onClick: function onClick() {
	                        return _this2.onSelectTemplate(template);
	                    } },
	                template.name,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-note' },
	                    template.system ? 'System ' : 'User ',
	                    'Template',
	                    template.jid != null ? ': ' + template.jid : ''
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'email-list ' + this.props.className },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    (0, _lodash.map)(this.props.templates, this.renderItem)
	                )
	            );
	        }
	    }]);
	
	    return EmailList;
	}(_react.Component), _class2.propTypes = {
	    dispatch: _react.PropTypes.func.isRequired,
	    templates: _react.PropTypes.array.isRequired,
	    className: _react.PropTypes.string,
	    onSelectTemplate: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = EmailList;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _EmailList = __webpack_require__(988);
	
	var _EmailList2 = _interopRequireDefault(_EmailList);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Search = __webpack_require__(165);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Create = __webpack_require__(986);
	
	var _Create2 = _interopRequireDefault(_Create);
	
	var _Edit = __webpack_require__(987);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _emails = __webpack_require__(235);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsEmailTab = (_dec = (0, _reactRedux.connect)(undefined, {
	  getEmailTemplates: _emails.getEmailTemplates
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(SettingsEmailTab, _Component);
	
	  function SettingsEmailTab() {
	    _classCallCheck(this, SettingsEmailTab);
	
	    var _this = _possibleConstructorReturn(this, (SettingsEmailTab.__proto__ || Object.getPrototypeOf(SettingsEmailTab)).call(this));
	
	    _this.onClose = function () {
	      _this.setState({ createEmail: false, editEmail: false });
	    };
	
	    _this.state = {
	      terms: [],
	      createEmail: false,
	      editEmail: false,
	      templates: [],
	      selectedTemplate: undefined
	    };
	
	    _this.onUpdate = _this.onUpdate.bind(_this);
	    return _this;
	  }
	
	  _createClass(SettingsEmailTab, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getEmailTemplates(true).then(function (templates) {
	        return _this2.setState({ templates: templates });
	      });
	    }
	  }, {
	    key: 'onTermChange',
	    value: function onTermChange() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      this.setState({ terms: terms });
	    }
	  }, {
	    key: 'showCreateEmailModal',
	    value: function showCreateEmailModal() {
	      this.setState({ createEmail: true });
	    }
	  }, {
	    key: 'showEditEmailModal',
	    value: function showEditEmailModal() {
	      this.setState({ editEmail: true });
	    }
	  }, {
	    key: 'onSelectTemplate',
	    value: function onSelectTemplate(selectedTemplate) {
	
	      var templates = (0, _lodash.clone)(this.state.templates);
	
	      templates = (0, _lodash.map)(templates, function (template) {
	        if (template.id === selectedTemplate.id) {
	          selectedTemplate.selected = true;
	          return selectedTemplate;
	        }
	        template.selected = false;
	        return template;
	      });
	
	      this.setState({ templates: templates, selectedTemplate: selectedTemplate });
	    }
	  }, {
	    key: 'onUpdate',
	    value: function onUpdate(templates) {
	
	      if (!this.state.selectedTemplate) {
	        this.setState({ templates: templates });
	        return;
	      }
	
	      var selectedTemplate = (0, _lodash.find)(templates, { id: this.state.selectedTemplate.id });
	
	      if (selectedTemplate) {
	
	        templates = (0, _lodash.map)(templates, function (template) {
	          if (template.id === selectedTemplate.id) {
	            selectedTemplate.selected = true;
	            return selectedTemplate;
	          }
	          template.selected = false;
	          return template;
	        });
	      }
	
	      this.setState({ templates: templates, selectedTemplate: selectedTemplate });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var matchCriteria = function matchCriteria(template) {
	
	        var isLowerCaseOrIgnore = function isLowerCaseOrIgnore(term) {
	          return typeof term === 'string' ? term.toLowerCase() : term;
	        };
	
	        var terms = (0, _lodash.chain)(template).values().map(isLowerCaseOrIgnore).value();
	
	        var searchTerms = _this3.state.terms.map(isLowerCaseOrIgnore);
	
	        var comparator = function comparator(value, otherValue) {
	          return typeof value === 'string' && value.search(otherValue) !== -1;
	        };
	
	        if (_this3.state.terms.length) {
	          return (0, _lodash.intersectionWith)(terms, searchTerms, comparator).length;
	        }
	
	        return true;
	      };
	
	      var matchedTemplates = (0, _lodash.chain)(this.state.templates).filter(matchCriteria).value();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings-emails-tab' },
	        this.state.createEmail && _react2.default.createElement(_Create2.default, { onClose: this.onClose, onUpdate: this.onUpdate }),
	        this.state.editEmail && _react2.default.createElement(_Edit2.default, { onClose: this.onClose, onUpdate: this.onUpdate, template: this.state.selectedTemplate }),
	        _react2.default.createElement(_Search2.default, {
	          onTermChange: this.onTermChange.bind(this),
	          baseUrl: '/admin/settings/emails'
	        }),
	        _react2.default.createElement('h1', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'emails-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'email-list-container' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'title' },
	              'Email Templates'
	            ),
	            _react2.default.createElement(_EmailList2.default, { templates: matchedTemplates, onSelectTemplate: this.onSelectTemplate.bind(this) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'email-preview' },
	            _react2.default.createElement(
	              'div',
	              { className: 'buttons-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'action-button' },
	                _react2.default.createElement(_Button2.default, {
	                  'data-id': 'edit-email-template',
	                  className: 'button-secondary button-secondary-create-edit-template',
	                  label: 'CREATE TEMPLATE',
	                  onClick: this.showCreateEmailModal.bind(this)
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'action-button' },
	                _react2.default.createElement(_Button2.default, {
	                  disabled: !this.state.selectedTemplate,
	                  'data-id': 'create-email-template',
	                  className: 'button-secondary button-secondary-create-edit-template',
	                  label: 'EDIT TEMPLATE',
	                  onClick: this.showEditEmailModal.bind(this)
	                })
	              )
	            ),
	            !this.state.selectedTemplate && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                'No Emails Selected'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Please select an email template from the list to the left to view it.'
	              )
	            ),
	            this.state.selectedTemplate && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                this.state.selectedTemplate.name
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.selectedTemplate.html } })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SettingsEmailTab;
	}(_react.Component), _class2.propTypes = {
	  getEmailTemplates: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = SettingsEmailTab;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stdColStyle = { width: '15%' };
	var linkColStyle = { width: '40%' };
	
	var tableStyle = {
	  borderBottom: '1px solid rgb(224, 224, 224)'
	};
	
	var PasswordResetsTable = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PasswordResetsTable, _Component);
	
	  function PasswordResetsTable() {
	    _classCallCheck(this, PasswordResetsTable);
	
	    return _possibleConstructorReturn(this, (PasswordResetsTable.__proto__ || Object.getPrototypeOf(PasswordResetsTable)).call(this));
	  }
	
	  _createClass(PasswordResetsTable, [{
	    key: 'renderRow',
	    value: function renderRow(row, index) {
	      return _react2.default.createElement(
	        _Table.TableRow,
	        { key: row.link, displayBorder: true, 'data-id': 'Row ' + row.link },
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'Date ' + index },
	          row.dateCreated
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'Account ' + index },
	          row.Account
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'Email ' + index },
	          row.to
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'First Name ' + index },
	          row.firstName
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: linkColStyle, 'data-id': 'Link ' + index },
	          row.link
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var rows = this.props.rows;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-resets-table ' + this.props.className },
	        rows.length > 0 && _react2.default.createElement(
	          _Table.Table,
	          { style: tableStyle, selectable: false, multiSelectable: false },
	          _react2.default.createElement(
	            _Table.TableHeader,
	            { displaySelectAll: false, adjustForCheckbox: false },
	            _react2.default.createElement(
	              _Table.TableRow,
	              null,
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'Date'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'Account'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'Email'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'First Name'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: linkColStyle },
	                'Link'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableBody,
	            { displayRowCheckbox: false },
	            (0, _lodash.map)(rows, this.renderRow.bind(this))
	          )
	        ),
	        !rows.length > 0 && _react2.default.createElement(
	          'div',
	          null,
	          'No items found'
	        )
	      );
	    }
	  }]);
	
	  return PasswordResetsTable;
	}(_react.Component), _class2.propTypes = {
	  rows: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = PasswordResetsTable;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _PasswordResetsTable = __webpack_require__(990);
	
	var _PasswordResetsTable2 = _interopRequireDefault(_PasswordResetsTable);
	
	var _admin = __webpack_require__(478);
	
	var _Search = __webpack_require__(165);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsPasswordResetsTab = (_dec = (0, _reactRedux.connect)(function () {
	  return {};
	}, { getPasswordResetRequests: _admin.getPasswordResetRequests }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(SettingsPasswordResetsTab, _Component);
	
	  function SettingsPasswordResetsTab() {
	    var _this2 = this;
	
	    _classCallCheck(this, SettingsPasswordResetsTab);
	
	    // setting initial state
	    var _this = _possibleConstructorReturn(this, (SettingsPasswordResetsTab.__proto__ || Object.getPrototypeOf(SettingsPasswordResetsTab)).call(this));
	
	    _this.onTermChange = function () {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var rowCount = isNaN(parseInt(terms[0], 10)) ? 25 : parseInt(terms[0], 10);
	      _this.setState({ terms: terms, rowCount: rowCount }, function () {
	        _this.reloadData(rowCount);
	      });
	    };
	
	    _this.onClose = function () {};
	
	    _this.reloadData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.props.getPasswordResetRequests({ rows: _this.state.rowCount }).then(function (passwordResetRequestsList) {
	                return _this.setState({ passwordResetRequests: passwordResetRequestsList[0].rows });
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.state = {
	      terms: [],
	      rowCount: 25,
	      passwordResetRequests: [],
	      stateSaved: true
	    };
	    return _this;
	  }
	
	  _createClass(SettingsPasswordResetsTab, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.reloadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          rowCount = _state.rowCount,
	          passwordResetRequests = _state.passwordResetRequests;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings-password-resets-tab' },
	        _react2.default.createElement(_Search2.default, {
	          onTermChange: this.onTermChange.bind(this),
	          baseUrl: '/admin/settings/passwordresetrequests',
	          placeHolder: '# items...'
	        }),
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          'Password Reset Requests (most recent ',
	          rowCount,
	          ')'
	        ),
	        _react2.default.createElement(_PasswordResetsTable2.default, {
	          className: 'settings-password-resets-table',
	          rows: passwordResetRequests
	        })
	      );
	    }
	  }]);
	
	  return SettingsPasswordResetsTab;
	}(_react.Component), _class2.propTypes = {
	  getPasswordResetRequests: _react.PropTypes.func.isRequired,
	  passwordResetRequests: _react.PropTypes.array.isRequired
	}, _temp)) || _class);
	exports.default = SettingsPasswordResetsTab;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stdColStyle = { width: '13%' };
	var emailColStyle = { width: '22%' };
	
	var tableStyle = {
	  borderBottom: '1px solid rgb(224, 224, 224)'
	};
	
	var PushQueueItemsTable = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PushQueueItemsTable, _Component);
	
	  function PushQueueItemsTable() {
	    _classCallCheck(this, PushQueueItemsTable);
	
	    return _possibleConstructorReturn(this, (PushQueueItemsTable.__proto__ || Object.getPrototypeOf(PushQueueItemsTable)).call(this));
	  }
	
	  _createClass(PushQueueItemsTable, [{
	    key: 'renderRow',
	    value: function renderRow(row, index) {
	      return _react2.default.createElement(
	        _Table.TableRow,
	        { key: row.dateCreated, displayBorder: true, 'data-id': 'Row ' + row.created_at },
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'Account ' + index },
	          row.Account
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'EntityType ' + index },
	          row.EntityType
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'EntityId ' + index },
	          row.EntityId
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'Name ' + index },
	          row.Name
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: emailColStyle, 'data-id': 'Email ' + index },
	          row.Email
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'Attempts ' + index },
	          row.attempts
	        ),
	        _react2.default.createElement(
	          _Table.TableRowColumn,
	          { className: 'column', style: stdColStyle, 'data-id': 'Created ' + index },
	          row.created_at
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var rows = this.props.rows;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-resets-table ' + this.props.className },
	        rows.length > 0 && _react2.default.createElement(
	          _Table.Table,
	          { style: tableStyle, selectable: false, multiSelectable: false },
	          _react2.default.createElement(
	            _Table.TableHeader,
	            { displaySelectAll: false, adjustForCheckbox: false },
	            _react2.default.createElement(
	              _Table.TableRow,
	              null,
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'Account'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'EntityType'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'EntityId'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'Name'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: emailColStyle },
	                'Email'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'Attempts'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'header-column', style: stdColStyle },
	                'Created'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableBody,
	            { displayRowCheckbox: false },
	            (0, _lodash.map)(rows, this.renderRow.bind(this))
	          )
	        ),
	        !rows.length > 0 && _react2.default.createElement(
	          'div',
	          null,
	          'No items found'
	        )
	      );
	    }
	  }]);
	
	  return PushQueueItemsTable;
	}(_react.Component), _class2.propTypes = {
	  rows: _react.PropTypes.array.isRequired,
	  className: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = PushQueueItemsTable;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _PushQueueItemsTable = __webpack_require__(992);
	
	var _PushQueueItemsTable2 = _interopRequireDefault(_PushQueueItemsTable);
	
	var _admin = __webpack_require__(478);
	
	var _Search = __webpack_require__(165);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// eslint-disable-next-line no-unused-vars
	var SettingsPushQueueItemsTab = (_dec = (0, _reactRedux.connect)(function () {
	  return {};
	}, { getPushQueueItems: _admin.getPushQueueItems }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(SettingsPushQueueItemsTab, _Component);
	
	  function SettingsPushQueueItemsTab() {
	    var _this2 = this;
	
	    _classCallCheck(this, SettingsPushQueueItemsTab);
	
	    // setting initial state
	    var _this = _possibleConstructorReturn(this, (SettingsPushQueueItemsTab.__proto__ || Object.getPrototypeOf(SettingsPushQueueItemsTab)).call(this));
	
	    _this.onTermChange = function () {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var days = isNaN(parseInt(terms[0], 10)) ? 60 : parseInt(terms[0], 10);
	      _this.setState({ terms: terms, days: days }, function () {
	        _this.reloadData();
	      });
	    };
	
	    _this.onClose = function () {};
	
	    _this.reloadData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.props.getPushQueueItems({ days: _this.state.days }).then(function (pushQueueItemsList) {
	                return _this.setState({ pushQueueItems: pushQueueItemsList });
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.state = {
	      pushQueueItems: [],
	      terms: [],
	      days: 60,
	      stateSaved: true
	    };
	    return _this;
	  }
	
	  _createClass(SettingsPushQueueItemsTab, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.reloadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          days = _state.days,
	          pushQueueItems = _state.pushQueueItems;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings-push-queue-items-tab' },
	        _react2.default.createElement(_Search2.default, {
	          onTermChange: this.onTermChange.bind(this),
	          baseUrl: '/admin/settings/pushqueueitems',
	          placeHolder: 'Age in days...'
	        }),
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          'Push Queue Items less than ',
	          days,
	          ' days old'
	        ),
	        _react2.default.createElement(_PushQueueItemsTable2.default, {
	          className: 'settings-push-queue-items-table',
	          rows: pushQueueItems
	        })
	      );
	    }
	  }]);
	
	  return SettingsPushQueueItemsTab;
	}(_react.Component), _class2.propTypes = {
	  getPushQueueItems: _react.PropTypes.func.isRequired,
	  pushQueueItems: _react.PropTypes.array.isRequired,
	  dispatch: _react.PropTypes.func.isRequired
	}, _class2.defaultProps = {
	  pushQueueItems: []
	}, _temp)) || _class);
	exports.default = SettingsPushQueueItemsTab;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _UserForm = __webpack_require__(449);
	
	var _UserForm2 = _interopRequireDefault(_UserForm);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _employees = __webpack_require__(62);
	
	var employeesActions = _interopRequireWildcard(_employees);
	
	var _employees2 = __webpack_require__(317);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateUser = (_dec = (0, _reactRedux.connect)(function (store) {
	  return { staticData: store.staticData };
	}, {
	  createUser: employeesActions.createUser,
	  storeEmployees: _employees2.storeEmployees,
	  showSnackBar: ui.showSnackBar
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CreateUser, _Component);
	
	  function CreateUser() {
	    _classCallCheck(this, CreateUser);
	
	    var _this = _possibleConstructorReturn(this, (CreateUser.__proto__ || Object.getPrototypeOf(CreateUser)).call(this));
	
	    _this.handleClose = function (event) {
	      _this.props.onClose && _this.props.onClose(event);
	    };
	
	    return _this;
	  }
	
	  _createClass(CreateUser, [{
	    key: 'save',
	    value: function save(formFields) {
	      var _this2 = this;
	
	      // split up form into 'user' and 'profile' sections
	      var profile = {
	        user: (0, _lodash.pick)(formFields, ['firstName', 'lastName', 'activeState', 'state', 'email', 'roles']),
	        profile: (0, _lodash.pick)(formFields, ['title', 'direct_dial', 'cellphoneNumber', 'defaultRole']),
	        categories: formFields.categories || [],
	        weight: formFields.weight || null
	      };
	
	      if (!profile.user.roles) {
	        profile.user.roles = [2];
	      }
	
	      // make API call, save formFields to database
	      return this.props.createUser(profile).then(function (employees) {
	        _this2.props.storeEmployees(employees);
	        _this2.props.showSnackBar();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(_UserForm2.default, {
	        title: 'Add New User',
	        closeFunc: this.handleClose.bind(this),
	        saveFunc: this.save.bind(this),
	        employees: this.props.employees
	      });
	    }
	  }]);
	
	  return CreateUser;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  showSnackBar: _react.PropTypes.func.isRequired,
	  createUser: _react.PropTypes.func.isRequired,
	  storeEmployees: _react.PropTypes.func.isRequired,
	  employees: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = CreateUser;

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UserModel;
	function UserModel() {
	  return model;
	}
	
	var model = {
	  firstName: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  lastName: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  title: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  direct_dial: {
	    required: {
	      message: 'This field is required.'
	    },
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    }
	  },
	  cellphoneNumber: {
	    isLength: {
	      options: { min: 10, max: 10 },
	      message: 'Must be 10 digits'
	    },
	    isNumeric: {
	      message: 'Must be numeric'
	    }
	  },
	  email: {
	    required: {
	      message: 'This field is required.'
	    },
	    isEmail: {
	      message: 'Must be a valid email.'
	    }
	  },
	  state: {},
	  roles: {},
	  activeState: {
	    required: {
	      message: 'This field is required.'
	    }
	  },
	  categories: {},
	  weight: {},
	  defaultRole: {}
	};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _UserForm = __webpack_require__(449);
	
	var _UserForm2 = _interopRequireDefault(_UserForm);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _employees = __webpack_require__(62);
	
	var employeesActions = _interopRequireWildcard(_employees);
	
	var _employees2 = __webpack_require__(317);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditUser = (_dec = (0, _reactRedux.connect)(function (store) {
	  return { staticData: store.staticData };
	}, {
	  showSnackBar: ui.showSnackBar,
	  updateUser: employeesActions.updateUser,
	  storeEmployees: _employees2.storeEmployees
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(EditUser, _Component);
	
	  function EditUser() {
	    _classCallCheck(this, EditUser);
	
	    var _this = _possibleConstructorReturn(this, (EditUser.__proto__ || Object.getPrototypeOf(EditUser)).call(this));
	
	    _this.handleClose = function (event) {
	      _this.props.onClose && _this.props.onClose(event);
	    };
	
	    return _this;
	  }
	
	  _createClass(EditUser, [{
	    key: 'update',
	    value: function update(formFields) {
	      var _this2 = this;
	
	      // split up form into 'user' and 'profile' sections
	      var profile = {
	        user: (0, _lodash.pick)(formFields, ['id', 'firstName', 'lastName', 'activeState', 'state', 'email', 'roles']),
	        profile: (0, _lodash.pick)(formFields, ['title', 'direct_dial', 'cellphoneNumber', 'defaultRole']),
	        categories: formFields.categories || [],
	        weight: formFields.weight || null
	      };
	
	      if (!profile.user.roles) {
	        profile.user.roles = [2];
	      }
	
	      // make API call, save formFields to database
	      return this.props.updateUser(this.props.employee.employeeId, profile).then(function (employees) {
	        _this2.props.storeEmployees(employees);
	        _this2.props.showSnackBar();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_UserForm2.default, {
	        title: 'Edit Account',
	        closeFunc: this.handleClose.bind(this),
	        saveFunc: this.update.bind(this),
	        employee: this.props.employee,
	        employees: this.props.employees
	      });
	    }
	  }]);
	
	  return EditUser;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  showSnackBar: _react.PropTypes.func.isRequired,
	  employee: _react.PropTypes.object.isRequired,
	  employees: _react.PropTypes.object.isRequired,
	  updateUser: _react.PropTypes.func.isRequired,
	  storeEmployees: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = EditUser;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var columnStyle = {
	    paddingLeft: '0px',
	    paddingRight: '10px'
	};
	
	var LastColumnStyle = {
	    paddingLeft: '0px',
	    paddingRight: '0px',
	    width: '95px'
	};
	
	var tableStyle = {
	    borderBottom: '1px solid rgb(224, 224, 224)'
	};
	
	var UsersTable = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(UsersTable, _Component);
	
	    function UsersTable() {
	        _classCallCheck(this, UsersTable);
	
	        var _this = _possibleConstructorReturn(this, (UsersTable.__proto__ || Object.getPrototypeOf(UsersTable)).call(this));
	
	        _this.openEditUserModal = _this.openEditUserModal.bind(_this);
	
	        _this.state = {
	            isFlipped: false,
	            sortBy: 'name',
	            reserve: false
	        };
	        return _this;
	    }
	
	    _createClass(UsersTable, [{
	        key: 'flipColumn',
	        value: function flipColumn() {
	            this.setState({ isFlipped: !this.state.isFlipped, sortBy: 'activeState', reverse: !this.state.reverse });
	        }
	    }, {
	        key: 'openEditUserModal',
	        value: function openEditUserModal(employee) {
	            this.props.showEditUserModal && this.props.showEditUserModal(employee);
	        }
	    }, {
	        key: 'renderUser',
	        value: function renderUser(user, index) {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _Table.TableRow,
	                { key: user.employeeId, displayBorder: true, 'data-id': 'Employee ' + user.employeeId },
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { className: 'column', style: columnStyle, 'data-id': 'Name ' + index },
	                    user.name
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { className: 'column', style: columnStyle, 'data-id': 'Title ' + index },
	                    user.title
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { className: 'column', style: columnStyle, 'data-id': 'Email ' + index },
	                    user.email
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { className: 'column', style: columnStyle, 'data-id': 'defaultRole ' + index },
	                    user.defaultRoleName
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { className: 'column', style: columnStyle, 'data-id': 'Status ' + index },
	                    user.activeState === 'enabled' && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('span', { className: 'status-circle status-circle-active' }),
	                        ' Activate User'
	                    ),
	                    user.activeState === 'pending' && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('span', { className: 'status-circle status-circle-inactive' }),
	                        ' Inactivate User'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Table.TableRowColumn,
	                    { className: 'column', style: LastColumnStyle, 'data-id': 'Edit ' + index },
	                    _react2.default.createElement(_Button2.default, {
	                        'data-id': 'edit-user',
	                        className: 'button-secondary button-secondary-edit-user',
	                        label: 'EDIT',
	                        onClick: function onClick() {
	                            return _this2.openEditUserModal(user);
	                        }
	
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var sortedUsers = (0, _lodash.sortBy)(this.props.users, this.state.sortBy);
	            var users = this.state.reverse ? (0, _lodash.reverse)(sortedUsers) : sortedUsers;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'users-table ' + this.props.className },
	                _react2.default.createElement(
	                    _Table.Table,
	                    { style: tableStyle, selectable: false, multiSelectable: false },
	                    _react2.default.createElement(
	                        _Table.TableHeader,
	                        { displaySelectAll: false, adjustForCheckbox: false },
	                        _react2.default.createElement(
	                            _Table.TableRow,
	                            null,
	                            _react2.default.createElement(
	                                _Table.TableHeaderColumn,
	                                { className: 'header-column', style: columnStyle },
	                                'Name'
	                            ),
	                            _react2.default.createElement(
	                                _Table.TableHeaderColumn,
	                                { className: 'header-column', style: columnStyle },
	                                'Title'
	                            ),
	                            _react2.default.createElement(
	                                _Table.TableHeaderColumn,
	                                { className: 'header-column', style: columnStyle },
	                                'Email'
	                            ),
	                            _react2.default.createElement(
	                                _Table.TableHeaderColumn,
	                                { className: 'header-column', style: columnStyle },
	                                'Default Role'
	                            ),
	                            _react2.default.createElement(
	                                _Table.TableHeaderColumn,
	                                { className: 'header-column', style: columnStyle },
	                                'Status',
	                                _react2.default.createElement(
	                                    'span',
	                                    {
	                                        className: (0, _classnames2.default)('chevron', { flipped: this.state.isFlipped }),
	                                        onClick: this.flipColumn.bind(this) },
	                                    _react2.default.createElement(_ChevronIcon2.default, null)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _Table.TableHeaderColumn,
	                                { className: 'header-column', style: LastColumnStyle },
	                                'Edit'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _Table.TableBody,
	                        { displayRowCheckbox: false },
	                        (0, _lodash.map)(users, this.renderUser.bind(this))
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UsersTable;
	}(_react.Component), _class2.propTypes = {
	    dispatch: _react.PropTypes.func.isRequired,
	    users: _react.PropTypes.array.isRequired,
	    className: _react.PropTypes.string,
	    showEditUserModal: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = UsersTable;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _UsersTable = __webpack_require__(997);
	
	var _UsersTable2 = _interopRequireDefault(_UsersTable);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Search = __webpack_require__(165);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _employees = __webpack_require__(62);
	
	var _employees2 = __webpack_require__(317);
	
	var _Create = __webpack_require__(994);
	
	var _Create2 = _interopRequireDefault(_Create);
	
	var _index = __webpack_require__(996);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsUserTab = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    employees: store.employees
	  };
	}, {
	  getUsers: _employees.getUsers,
	  storeEmployees: _employees2.storeEmployees
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(SettingsUserTab, _Component);
	
	  function SettingsUserTab() {
	    _classCallCheck(this, SettingsUserTab);
	
	    var _this = _possibleConstructorReturn(this, (SettingsUserTab.__proto__ || Object.getPrototypeOf(SettingsUserTab)).call(this));
	
	    _this.onClose = function () {
	      _this.setState({ createUser: false, editUser: false });
	    };
	
	    _this.state = {
	      terms: [],
	      createUser: false,
	      editUser: false
	    };
	
	    return _this;
	  }
	
	  _createClass(SettingsUserTab, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.getUsers({ everyone: true, roleName: 'all', categoriesName: 'all' }).then(function (employeeList) {
	        return _this2.props.storeEmployees(employeeList);
	      });
	    }
	  }, {
	    key: 'onTermChange',
	    value: function onTermChange() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      this.setState({ terms: terms });
	    }
	  }, {
	    key: 'showCreateUserModal',
	    value: function showCreateUserModal() {
	      this.setState({ createUser: true });
	    }
	  }, {
	    key: 'showEditUserModal',
	    value: function showEditUserModal(employee) {
	      this.setState({ editUser: true, employee: employee });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var transform = function transform(employee) {
	        return _extends({}, employee, {
	          name: employee.firstName + ' ' + employee.lastName
	        });
	      };
	
	      var matchCriteria = function matchCriteria(employee) {
	
	        var isLowerCaseOrIgnore = function isLowerCaseOrIgnore(term) {
	          return typeof term === 'string' ? term.toLowerCase() : term;
	        };
	
	        var terms = (0, _lodash.chain)(employee).values().map(isLowerCaseOrIgnore).value();
	
	        var searchTerms = _this3.state.terms.map(isLowerCaseOrIgnore);
	
	        var comparator = function comparator(value, otherValue) {
	          return typeof value === 'string' && value.search(otherValue) !== -1;
	        };
	
	        if (_this3.state.terms.length) {
	          return (0, _lodash.intersectionWith)(terms, searchTerms, comparator).length;
	        }
	
	        return true;
	      };
	
	      var employees = (0, _lodash.chain)(this.props.employees).map(transform).filter(matchCriteria).value();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings-user-tab' },
	        this.state.createUser && _react2.default.createElement(_Create2.default, { onClose: this.onClose, employees: this.props.employees }),
	        this.state.editUser && _react2.default.createElement(_index2.default, { onClose: this.onClose, employee: this.state.employee, employees: this.props.employees }),
	        _react2.default.createElement(_Search2.default, {
	          onTermChange: this.onTermChange.bind(this),
	          baseUrl: '/admin/settings/users'
	        }),
	        _react2.default.createElement(
	          'h1',
	          { className: 'title' },
	          'User Settings'
	        ),
	        _react2.default.createElement(_UsersTable2.default, {
	          className: 'settings-user-table',
	          users: employees,
	          showEditUserModal: this.showEditUserModal.bind(this)
	        }),
	        _react2.default.createElement(_Button2.default, {
	          onClick: this.showCreateUserModal.bind(this),
	          'data-id': 'add-user',
	          className: 'button-main button-main-add-user',
	          label: 'Add User' })
	      );
	    }
	  }]);
	
	  return SettingsUserTab;
	}(_react.Component), _class2.propTypes = {
	  getUsers: _react.PropTypes.func.isRequired,
	  storeEmployees: _react.PropTypes.func.isRequired,
	  employees: _react.PropTypes.array.isRequired
	}, _class2.defaultProps = {
	  employees: []
	}, _temp)) || _class);
	exports.default = SettingsUserTab;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _NavigationSidebar = __webpack_require__(858);
	
	var _NavigationSidebar2 = _interopRequireDefault(_NavigationSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Settings = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    user: store.user
	  };
	}, {
	  push: _reactRouterRedux.push
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Settings, _Component);
	
	  function Settings() {
	    _classCallCheck(this, Settings);
	
	    return _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).apply(this, arguments));
	  }
	
	  _createClass(Settings, [{
	    key: 'render',
	    value: function render() {
	
	      var roles = (0, _lodash.get)(this.props.user, 'roles', []);
	      var isAdmin = roles.includes('Admin');
	      var isSysAdmin = roles.includes('System Administrator');
	
	      var links = [];
	
	      if (isAdmin) {
	        links.push({
	          title: 'Users',
	          href: '/admin/settings/users'
	        });
	
	        links.push({
	          title: 'Emails',
	          href: '/admin/settings/emails'
	        });
	      }
	
	      if (isSysAdmin) {
	        links.push({
	          title: 'Recent Password Reset Requests',
	          href: '/admin/settings/PasswordResetRequests'
	        });
	
	        links.push({
	          title: 'Push Queue Items',
	          href: '/admin/settings/PushQueueItems'
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'settings' },
	        _react2.default.createElement(_NavigationSidebar2.default, {
	          links: links,
	          title: 'Profile'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'settings-tab-container' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Settings;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  children: _react.PropTypes.any,
	  route: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  user: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = Settings;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(5);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _TechnologySurveyContainer = __webpack_require__(470);
	
	var _TechnologySurveyContainer2 = _interopRequireDefault(_TechnologySurveyContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TechnologySurvey = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    dispatch: state.dispatch,
	    applicant: state.admin.applicant,
	    technologySurvey: state.technologySurvey
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(TechnologySurvey, _React$Component);
	
	  function TechnologySurvey(props) {
	    _classCallCheck(this, TechnologySurvey);
	
	    var _this = _possibleConstructorReturn(this, (TechnologySurvey.__proto__ || Object.getPrototypeOf(TechnologySurvey)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    return _this;
	  }
	
	  _createClass(TechnologySurvey, [{
	    key: 'renderEmpty',
	    value: function renderEmpty() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'accordion-container steps' },
	        _react2.default.createElement(
	          'div',
	          { className: 'scroll-hide' },
	          _react2.default.createElement(
	            'div',
	            { className: 'technology-survey-empty', style: { height: global.innerHeight - 311 + 'px' } },
	            'There is no completed technology survey for the applicant.'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTechnologySurvey',
	    value: function renderTechnologySurvey() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'accordion-container steps' },
	        _react2.default.createElement(
	          'div',
	          { className: 'scroll-hide' },
	          _react2.default.createElement(_TechnologySurveyContainer2.default, {
	            adminView: true
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'technology-survey-container', style: { height: global.innerHeight - 311 + 'px' } },
	        this.renderTechnologySurvey()
	      );
	    }
	  }]);
	
	  return TechnologySurvey;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  applicant: _react.PropTypes.object.isRequired,
	  technologySurvey: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = TechnologySurvey;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _Navigation = __webpack_require__(982);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _UserMenu = __webpack_require__(469);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _CorkBoard = __webpack_require__(963);
	
	var _CorkBoard2 = _interopRequireDefault(_CorkBoard);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminLanding = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AdminLanding, _Component);
	
	  function AdminLanding() {
	    _classCallCheck(this, AdminLanding);
	
	    return _possibleConstructorReturn(this, (AdminLanding.__proto__ || Object.getPrototypeOf(AdminLanding)).apply(this, arguments));
	  }
	
	  _createClass(AdminLanding, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.props.dispatch(ui.hideSpinner());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showMenus = !(this.props.params.jobId || this.props.params.contactId || this.props.params.companyId || this.props.params.profileId);
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-landing' },
	        showMenus && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_UserMenu2.default, { dispatch: this.props.dispatch }),
	          _react2.default.createElement(_Navigation2.default, { location: this.props.location })
	        ),
	        this.props.children,
	        showMenus && _react2.default.createElement(_CorkBoard2.default, null)
	      );
	    }
	  }]);
	
	  return AdminLanding;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  params: _react.PropTypes.object,
	  location: _react.PropTypes.object.isRequired,
	  children: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = AdminLanding;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _prettyDate = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmploymentGapsSummary = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var employmentGaps = state.employmentGaps;
	
	  return {
	    employmentGaps: employmentGaps,
	    updateTempState: props.updateTempState,
	    script: props.script
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(EmploymentGapsSummary, _React$Component);
	
	  function EmploymentGapsSummary(props) {
	    _classCallCheck(this, EmploymentGapsSummary);
	
	    return _possibleConstructorReturn(this, (EmploymentGapsSummary.__proto__ || Object.getPrototypeOf(EmploymentGapsSummary)).call(this, props));
	  }
	
	  _createClass(EmploymentGapsSummary, [{
	    key: 'render',
	    value: function render() {
	      var gaps = (0, _lodash.valuesIn)(this.props.employmentGaps);
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve' },
	        _react2.default.createElement(
	          'div',
	          { className: 'summary-container' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'Start Date'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'End Date'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item explanation' },
	                'Gap Explanation'
	              )
	            ),
	            (0, _lodash.map)(gaps, function (gap) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'summary-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  (0, _prettyDate.monthYear)(gap.gapStart)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  (0, _prettyDate.monthYear)(gap.gapEnd)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item explanation' },
	                  gap.explanation
	                )
	              );
	            }),
	            gaps.length === 0 && _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item-empty' },
	                'No employment gaps have been entered.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmploymentGapsSummary;
	}(_react2.default.Component), _class2.propTypes = {
	  employmentGaps: _react.PropTypes.object,
	  updateTempState: _react.PropTypes.func,
	  script: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = EmploymentGapsSummary;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LicenseLapsed;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var yesNo = [{ value: true, primaryText: 'Yes' }, { value: false, primaryText: 'No' }];
	
	function LicenseLapsed(props) {
	
	  var handleChange = function handleChange(event, value) {
	    if (props.onChange) {
	      return props.onChange(event, value);
	    }
	  };
	
	  return _react2.default.createElement(_c_ToggleButton2.default, {
	    'data-id': 'Willing To Reinstate',
	    floatingLabelText: props.label,
	    menuItems: yesNo,
	    value: props.value,
	    onChange: handleChange
	  });
	}
	
	LicenseLapsed.propTypes = {
	  label: _react.PropTypes.string,
	  value: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func
	};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LicenseStatus;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LicenseStatus(props) {
	
	  var handleChange = function handleChange(event, value) {
	    if (props.onChange) {
	      props.onChange(event, value);
	    }
	  };
	
	  return _react2.default.createElement(_c_ToggleButton2.default, {
	    className: 'main-toggle',
	    'data-id': 'Ever Licensed?',
	    style: {
	      width: '100%'
	    },
	    menuItems: props.statuses,
	    value: props.value,
	    onChange: handleChange
	  });
	}
	
	LicenseStatus.propTypes = {
	  statuses: _react.PropTypes.array.isRequired,
	  value: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	};

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Licenses;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _DateInputDropDown = __webpack_require__(229);
	
	var _DateInputDropDown2 = _interopRequireDefault(_DateInputDropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StateAuthority(props) {
	  var label = props.label,
	      value = props.value,
	      clientId = props.clientId,
	      stateList = props.stateList;
	
	
	  var handleChange = function handleChange(event, val) {
	    if (props.onChange) {
	      props.onChange(event, val);
	    }
	  };
	
	  if (label) {
	    return _react2.default.createElement(_c_DropDownMenu2.default, {
	      style: { display: 'block' },
	      'data-id': 'License Types ' + clientId,
	      canAutoPosition: 'true',
	      floatingLabelText: label,
	      value: value,
	      onChange: handleChange,
	      menuItems: stateList
	    });
	  }
	}
	
	StateAuthority.propTypes = {
	  stateList: _react.PropTypes.array.isRequired,
	  label: _react.PropTypes.string,
	  value: _react.PropTypes.number,
	  clientId: _react.PropTypes.string,
	  onChange: _react.PropTypes.func
	};
	
	function RenewalDate(props) {
	  var label = props.label,
	      value = props.value,
	      clientId = props.clientId;
	
	
	  var handleChange = function handleChange(event) {
	    if (props.onChange && event.target.value) {
	      props.onChange(event, event.target.value);
	    }
	  };
	
	  if (label) {
	    return _react2.default.createElement(_DateInputDropDown2.default, {
	      floatingLabelText: label,
	      'data-id': 'Renewal Anniversary Date ' + clientId,
	      dateFormat: 'MonthYear',
	      hintText: '12/1999',
	      autoOk: true,
	      includeFuture: 'true',
	      value: value,
	      onChange: handleChange
	    });
	  }
	}
	
	RenewalDate.propTypes = {
	  label: _react.PropTypes.string,
	  value: _react.PropTypes.number,
	  clientId: _react.PropTypes.string,
	  onChange: _react.PropTypes.func
	};
	
	function LicenseTypes(props) {
	  var label = props.label,
	      value = props.value,
	      menuItems = props.menuItems;
	
	
	  var onChange = function onChange(event, val) {
	    if (props.onChange) {
	      props.onChange(event, val);
	    }
	  };
	
	  return _react2.default.createElement(_c_DropDownMenu2.default, {
	    'data-id': 'License Types',
	    floatingLabelText: label,
	    menuItems: menuItems,
	    value: value,
	    onChange: onChange,
	    errorText: !!value ? null : 'This field is required'
	  });
	}
	
	LicenseTypes.propTypes = {
	  menuItems: _react.PropTypes.array.isRequired,
	  label: _react.PropTypes.string,
	  value: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	};
	
	function LicenseOther(props) {
	  var label = props.label,
	      value = props.value,
	      licenseStatuses = props.licenseStatuses;
	
	
	  var handleChange = function handleChange(event, val) {
	    if (props.onBlur) {
	      return props.onBlur(event, val);
	    }
	  };
	
	  var other = licenseStatuses.find(function (l) {
	    return l.subElement === 'Other';
	  });
	  if (other && props.licenseTypeId === other.id) {
	    return _react2.default.createElement(_c_TextField2.default, {
	      floatingLabelText: label,
	      defaultValue: value,
	      onBlur: handleChange
	    });
	  }
	
	  return null;
	}
	
	LicenseOther.propTypes = {
	  licenseStatuses: _react.PropTypes.array.isRequired,
	  licenseTypeId: _react.PropTypes.number,
	  label: _react.PropTypes.string,
	  value: _react.PropTypes.string,
	  onBlur: _react.PropTypes.func
	};
	
	function License(props) {
	
	  var handleUpdate = function handleUpdate(property) {
	    return function (event, value) {
	      if (props.onChange) {
	        props.onChange(event, property, value);
	      }
	    };
	  };
	
	  var handleRemove = function handleRemove() {
	    if (props.onRemove) {
	      props.onRemove();
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'license form-contents dropdown-larger-width' },
	    _react2.default.createElement(StateAuthority, {
	      stateList: props.staticData.stateList,
	      label: props.labels.state,
	      value: props.state,
	      clientId: props.clientId,
	      onChange: handleUpdate('state')
	    }),
	    _react2.default.createElement('div', {
	      className: 'force-wrap'
	    }),
	    _react2.default.createElement(RenewalDate, {
	      label: props.labels.renewalDate,
	      value: props.renewalDate,
	      clientId: props.clientId,
	      onChange: handleUpdate('renewalDate')
	    }),
	    _react2.default.createElement(LicenseTypes, {
	      label: 'Please select your licenses from the list below',
	      menuItems: props.staticData.licenseTypes,
	      value: props.licenseTypeId,
	      onChange: handleUpdate('licenseTypeId')
	    }),
	    _react2.default.createElement(LicenseOther, {
	      label: 'Specify License',
	      licenseStatuses: props.staticData.licenseTypes,
	      licenseTypeId: props.licenseTypeId,
	      value: props.licenseName,
	      onBlur: handleUpdate('licenseName')
	    }),
	    _react2.default.createElement(
	      'div',
	      {
	        'data-id': 'remove-section',
	        className: 'remove-section text-btn noTextSelect',
	        onClick: handleRemove },
	      'Remove License'
	    )
	  );
	}
	
	License.propTypes = {
	  staticData: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.object.isRequired,
	  clientId: _react.PropTypes.string.isRequired,
	  state: _react.PropTypes.number,
	  licenseTypeId: _react.PropTypes.number,
	  licenseName: _react.PropTypes.string,
	  renewalDate: _react.PropTypes.object,
	  onChange: _react.PropTypes.func,
	  onRemove: _react.PropTypes.func
	};
	
	function Licenses(props) {
	  var licenses = props.licenses;
	
	
	  var handleChange = function handleChange(clientId) {
	    return function (event, property, value) {
	      if (props.onChange) {
	        props.onChange(event, clientId, property, value);
	      }
	    };
	  };
	
	  var handleRemove = function handleRemove(clientId) {
	    return function () {
	      if (props.onRemove) {
	        props.onRemove(clientId);
	      }
	    };
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    (0, _lodash.map)(licenses, function (license) {
	      return _react2.default.createElement(License, {
	        key: license.clientId,
	        staticData: props.staticData,
	        labels: props.labels,
	        clientId: license.clientId,
	        state: license.state,
	        licenseTypeId: license.licenseTypeId,
	        licenseName: license.licenseName,
	        renewalDate: license.renewalDate,
	        onChange: handleChange(license.clientId),
	        onRemove: handleRemove(license.clientId)
	      });
	    })
	  );
	}
	
	Licenses.propTypes = {
	  licenses: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.object.isRequired,
	  onChange: _react.PropTypes.func,
	  onRemove: _react.PropTypes.func
	};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _lodash = __webpack_require__(4);
	
	var _LicenseStatus = __webpack_require__(1004);
	
	var _LicenseStatus2 = _interopRequireDefault(_LicenseStatus);
	
	var _LicenseLapsed = __webpack_require__(1003);
	
	var _LicenseLapsed2 = _interopRequireDefault(_LicenseLapsed);
	
	var _Licenses = __webpack_require__(1005);
	
	var _Licenses2 = _interopRequireDefault(_Licenses);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _ButtonGroup = __webpack_require__(855);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _licenses = __webpack_require__(1125);
	
	var licenseApi = _interopRequireWildcard(_licenses);
	
	var _ui = __webpack_require__(26);
	
	var uiApi = _interopRequireWildcard(_ui);
	
	var _licenses2 = __webpack_require__(1131);
	
	var licenseStore = _interopRequireWildcard(_licenses2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addButtonStyle = {
	  display: 'inline-block',
	  top: '35px',
	  width: '165px',
	  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
	};
	
	var LicensesContainer = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.Application.background.licenses', {}),
	    licenses: (0, _lodash.get)(store, 'licenses', {}),
	    licenseStatus: (0, _lodash.get)(store, 'staticData.applicantLicenseStatus', []),
	    tempState: (0, _lodash.get)(store, 'tempState')
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(LicensesContainer, _Component);
	
	  function LicensesContainer(props) {
	    _classCallCheck(this, LicensesContainer);
	
	    var _this = _possibleConstructorReturn(this, (LicensesContainer.__proto__ || Object.getPrototypeOf(LicensesContainer)).call(this, props));
	
	    _this.handleStatusChange = function (event, value) {
	      var updateTempState = _this.props.updateTempState;
	
	      updateTempState('profile', 'licenseStatus', event, value);
	    };
	
	    _this.handleProfileChange = function (property) {
	      return function (event, value) {
	        var updateTempState = _this.props.updateTempState;
	
	        updateTempState('profile', property, event, value);
	      };
	    };
	
	    _this.handleChange = function (event, clientId, property, value) {
	      var newState = _this.newState();
	      var license = newState.licenses[clientId] || _this.newLicense(clientId);
	      license[property] = value;
	      _this.saveLicense(license);
	    };
	
	    _this.handleToggle = function (event, clientId, selected) {
	      if (!selected) {
	        _this.deleteLicense(clientId);
	      }
	    };
	
	    _this.handleAddLicense = function () {
	      var newState = _this.newState();
	      var license = _this.newLicense();
	      newState.licenses[license.clientId] = license;
	      _this.setState(newState);
	    };
	
	    _this.handleAddNewLicense = function (item) {
	      var value = item.value,
	          name = item.name;
	
	      var newLicense = _this.newLicense(value);
	      newLicense.licenseName = name;
	      _this.saveLicense(newLicense);
	    };
	
	    _this.handleRemoveLicense = function (clientId) {
	      var newState = _this.newState();
	      var licenses = newState.licenses;
	
	      if (licenses[clientId]) {
	        _this.deleteLicense(clientId);
	      }
	    };
	
	    _this.validateForm = function () {
	      var _this$newState = _this.newState(),
	          licenses = _this$newState.licenses;
	
	      var licenseStatus = _this.props.licenseStatus;
	
	      var currentStatus = _this.licenseStatus();
	      var isLicensed = licenseStatus.find(function (s) {
	        return s.subElement === 'Licensed';
	      });
	      var isLapsed = licenseStatus.find(function (s) {
	        return s.subElement === 'Lapsed';
	      });
	
	      if (isLapsed && currentStatus === isLapsed.id) {
	        return !(0, _lodash.isNil)(_this.willingToReinstate());
	      }
	      if (isLicensed && currentStatus === isLicensed.id) {
	        var isValid = (0, _lodash.reduce)(licenses, function (valid, license) {
	          return valid && (license.licenseName || license.licenseTypeId);
	        }, true);
	        return isValid && !(0, _lodash.isEmpty)(licenses);
	      }
	
	      return true;
	    };
	
	    _this.state = {
	      licenses: {}
	    };
	    return _this;
	  }
	
	  _createClass(LicensesContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!(0, _lodash.isEmpty)(this.props.licenses)) {
	        this.loadLicenses(this.props.licenses);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps) {
	        if (nextProps.licenses && !(0, _lodash.isEqual)(nextProps.licenses, this.props.licenses)) {
	          this.loadLicenses(nextProps.licenses);
	        }
	      }
	    }
	  }, {
	    key: 'loadLicenses',
	    value: function loadLicenses(licenses) {
	      var newState = this.newState();
	      newState.licenses = licenses;
	      this.setState(newState);
	    }
	  }, {
	    key: 'licenseStatus',
	    value: function licenseStatus() {
	      var _props = this.props,
	          tempState = _props.tempState,
	          profile = _props.profile;
	
	      return (0, _lodash.get)(tempState, 'profile.licenseStatus', (0, _lodash.get)(profile, 'licenseStatus'));
	    }
	  }, {
	    key: 'willingToReinstate',
	    value: function willingToReinstate() {
	      var _props2 = this.props,
	          tempState = _props2.tempState,
	          profile = _props2.profile;
	
	      return (0, _lodash.get)(tempState, 'profile.willingToReinstateLicense', (0, _lodash.get)(profile, 'willingToReinstateLicense'));
	    }
	  }, {
	    key: 'newState',
	    value: function newState() {
	      return Object.assign({}, this.state);
	    }
	  }, {
	    key: 'newLicense',
	    value: function newLicense(clientId) {
	      return {
	        clientId: clientId || _shortid2.default.generate(),
	        state: null,
	        licenseTypeId: null,
	        licenseName: null,
	        renewalDate: null
	      };
	    }
	  }, {
	    key: 'saveLicense',
	    value: function saveLicense(license) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          dispatch = _props3.dispatch,
	          profile = _props3.profile;
	
	      if (license && license.licenseTypeId || license.licenseName) {
	        dispatch(licenseApi.saveLicense(profile.id, license, function (err) {
	          if (err) {
	            return uiApi.warningToast(err.message);
	          }
	
	          var newState = _this2.newState();
	          newState.licenses[license.clientId] = license;
	          dispatch(licenseStore.updateApplicantLicenses(profile.id, newState.licenses));
	        }));
	      } else {
	        var newState = this.newState();
	        newState.licenses[license.clientId] = license;
	      }
	    }
	  }, {
	    key: 'deleteLicense',
	    value: function deleteLicense(clientId) {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          dispatch = _props4.dispatch,
	          profile = _props4.profile;
	
	      if (clientId) {
	        dispatch(licenseApi.deleteLicense(profile.id, clientId, function (err) {
	          if (err) {
	            return uiApi.warningToast(err.message);
	          }
	
	          var newState = _this3.newState();
	          var licenses = newState.licenses;
	
	          newState.licenses = (0, _lodash.omit)(licenses, [clientId]);
	          dispatch(licenseStore.updateApplicantLicenses(profile.id, newState.licenses));
	        }));
	      }
	    }
	
	    // This is here for backwards compatibility
	    // Not using standard form validation because Accounting Tenant
	    // Licenses operate differently than Insurance Tenant and this
	    // approach seemed most reasonable at the time. This overrides
	    // the validateForm defined in the Parent Component hierarchy
	
	  }, {
	    key: 'renderLapsed',
	    value: function renderLapsed(state, props) {
	      var statuses = props.licenseStatus;
	      var isLapsed = statuses.filter(function (s) {
	        return s.subElement === 'Lapsed';
	      }).map(function (s) {
	        return s.id;
	      });
	
	      if (isLapsed.includes(this.licenseStatus())) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_LicenseLapsed2.default, {
	            label: (0, _lodash.get)(props.labels, 'willingToReinstateLicense'),
	            value: this.willingToReinstate(),
	            onChange: this.handleProfileChange('willingToReinstateLicense')
	          })
	        );
	      }
	    }
	  }, {
	    key: 'renderLicenses',
	    value: function renderLicenses(state, props) {
	      var licenseTypes = props.staticData.licenseTypes;
	
	      var licenses = (0, _lodash.isEmpty)(state.licenses) ? [this.newLicense()] : state.licenses;
	      var statuses = props.licenseStatus;
	      var isLicensed = statuses.filter(function (s) {
	        return s.subElement === 'Licensed';
	      }).map(function (s) {
	        return s.id;
	      });
	
	      if (!(0, _lodash.isEmpty)(licenseTypes) && isLicensed.includes(this.licenseStatus())) {
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'licenses' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Please select and complete the information below for each ',
	            _react2.default.createElement(
	              'b',
	              null,
	              'resident'
	            ),
	            ' license. If you have non-resident licenses, you can attach a copy in documents but do not include them here.',
	            _react2.default.createElement('br', null),
	            'After you complete entering your licenses please do the following:',
	            _react2.default.createElement(
	              'ol',
	              { className: 'terms-list' },
	              _react2.default.createElement(
	                'li',
	                null,
	                'Click on Save in the bottom right corner of the page'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Click on Documents and attach copies of your licenses'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Return to the license section and click on next to continue with your application'
	              )
	            ),
	            _react2.default.createElement(_Licenses2.default, {
	              licenses: licenses,
	              staticData: props.staticData,
	              labels: props.labels,
	              onChange: this.handleChange,
	              onRemove: this.handleRemoveLicense
	            }),
	            _react2.default.createElement(_c_FlatButton2.default, {
	              style: _extends({}, addButtonStyle),
	              label: 'Add License',
	              onClick: this.handleAddLicense
	            })
	          )
	        );
	      }
	      // if licenses are yes and there are no license types populated... allow them to enter
	      else if ((0, _lodash.isEmpty)(licenseTypes) && isLicensed.includes(this.licenseStatus())) {
	
	          var items = [];
	          var values = (0, _lodash.map)(state.licenses, function (license) {
	            return { value: license.clientId, name: license.licenseName };
	          });
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'licenses' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Please add any licenses you may have.'
	            ),
	            _react2.default.createElement(_ButtonGroup2.default, {
	              items: items,
	              value: values,
	              onToggle: this.handleToggle,
	              onAdd: this.handleAddNewLicense
	            })
	          );
	        }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'licenses-container application-section-container expanded-accordion-content clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          'Licenses'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'formText' },
	          (0, _lodash.get)(this.props, 'labels.formText')
	        ),
	        _react2.default.createElement(_LicenseStatus2.default, {
	          statuses: this.props.licenseStatus,
	          value: this.licenseStatus(),
	          onChange: this.handleStatusChange
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'subElement-container' },
	          this.renderLicenses(this.state, this.props),
	          this.renderLapsed(this.state, this.props)
	        )
	      );
	    }
	  }]);
	
	  return LicensesContainer;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object,
	  licenses: _react.PropTypes.object,
	  licenseStatus: _react.PropTypes.array
	}, _temp)) || _class);
	exports.default = LicensesContainer;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _prettyDate = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LicensesSummary = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var licenses = (0, _lodash2.default)(state.licenses).map(function (license) {
	    return license;
	  }).orderBy(['stateName', 'licenseName']).value();
	  return {
	    licenses: licenses,
	    script: props.script,
	    labels: (0, _lodash.get)(state, 'labels.LicensesSummary', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(LicensesSummary, _React$Component);
	
	  function LicensesSummary(props) {
	    _classCallCheck(this, LicensesSummary);
	
	    return _possibleConstructorReturn(this, (LicensesSummary.__proto__ || Object.getPrototypeOf(LicensesSummary)).call(this, props));
	  }
	
	  _createClass(LicensesSummary, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content licenses-summary' },
	        _react2.default.createElement(
	          'div',
	          { className: 'callout' },
	          this.props.labels.callout
	        ),
	        this.props.script && _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          this.props.labels.speakingCallout
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'summary-container' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'License'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'State'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'Renewal Date'
	              )
	            ),
	            _lodash2.default.map(this.props.licenses, function (item) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'summary-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  item.licenseName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  item.stateName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  _lodash2.default.isNil(item.renewalDate) ? '' : (0, _prettyDate.monthYear)(item.renewalDate)
	                )
	              );
	            }),
	            this.props.licenses.length === 0 && (this.props.profile.licenseStatus == 1 || !this.props.profile.licenseStatus) && _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item-empty' },
	                'No licenses have been selected'
	              )
	            ),
	            this.props.profile.licenseStatus == 2 && _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item-empty' },
	                'License has lapsed',
	                this.props.profile.willingToReinstateLicense ? ' and willing to renew' : ''
	              )
	            ),
	            this.props.profile.licenseStatus == 3 && _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item-empty' },
	                'Never been licensed'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LicensesSummary;
	}(_react2.default.Component), _class2.propTypes = {
	  licenses: _react.PropTypes.array,
	  script: _react.PropTypes.bool,
	  labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = LicensesSummary;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfessionalAssociationsSummary = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var associations = state.associations;
	  var items = (0, _lodash.map)(associations, function (value) {
	    return value;
	  });
	
	  return {
	    items: items,
	    script: props.script
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ProfessionalAssociationsSummary, _React$Component);
	
	  function ProfessionalAssociationsSummary(props) {
	    _classCallCheck(this, ProfessionalAssociationsSummary);
	
	    return _possibleConstructorReturn(this, (ProfessionalAssociationsSummary.__proto__ || Object.getPrototypeOf(ProfessionalAssociationsSummary)).call(this, props));
	  }
	
	  _createClass(ProfessionalAssociationsSummary, [{
	    key: 'getAbbreviation',
	    value: function getAbbreviation(value) {
	      var regExp = /\(([^)]+)\)/;
	      var matches = regExp.exec(value);
	      return matches ? matches[1] : value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve' },
	        _react2.default.createElement(
	          'div',
	          { className: 'summary-container' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              'Category'
	            ),
	            (0, _lodash.map)(this.props.items, function (item) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'summary-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  _this2.getAbbreviation(item.name)
	                )
	              );
	            }),
	            this.props.items.length === 0 && _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item-empty' },
	                'No professional associations have been selected'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfessionalAssociationsSummary;
	}(_react2.default.Component), _class2.propTypes = {
	  items: _react.PropTypes.array,
	  script: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = ProfessionalAssociationsSummary;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfessionalDesignationsSummary = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var designations = state.designations;
	  var items = _lodash2.default.map(designations, function (value) {
	    return value;
	  });
	
	  return {
	    items: items,
	    script: props.script
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ProfessionalDesignationsSummary, _React$Component);
	
	  function ProfessionalDesignationsSummary(props) {
	    _classCallCheck(this, ProfessionalDesignationsSummary);
	
	    return _possibleConstructorReturn(this, (ProfessionalDesignationsSummary.__proto__ || Object.getPrototypeOf(ProfessionalDesignationsSummary)).call(this, props));
	  }
	
	  _createClass(ProfessionalDesignationsSummary, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve' },
	        _react2.default.createElement(
	          'div',
	          { className: 'callout' },
	          'If the applicant has designation, explain:'
	        ),
	        this.props.script && _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          'We recommend you maintain your designations as it indicates your commitment to staying current.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'summary-container' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              'Category'
	            ),
	            _lodash2.default.map(this.props.items, function (item) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'summary-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  item.name
	                )
	              );
	            }),
	            this.props.items.length === 0 && _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item-empty' },
	                'No professional designations have been selected'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfessionalDesignationsSummary;
	}(_react2.default.Component), _class2.propTypes = {
	  items: _react.PropTypes.array,
	  script: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = ProfessionalDesignationsSummary;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkillsSummary = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var skillCategoryTypes = state.staticData.skillCategoryTypes;
	  var skillLevelTypes = state.staticData.skillLevelTypes;
	  var skills = state.skills;
	  var tempState = state.tempState;
	
	  return {
	    skillCategoryTypes: skillCategoryTypes,
	    skillLevelTypes: skillLevelTypes,
	    skills: _lodash2.default.merge({}, skills, tempState.skills || {}),
	    updateTempState: props.updateTempState,
	    script: props.script
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(SkillsSummary, _React$Component);
	
	  function SkillsSummary(props) {
	    _classCallCheck(this, SkillsSummary);
	
	    return _possibleConstructorReturn(this, (SkillsSummary.__proto__ || Object.getPrototypeOf(SkillsSummary)).call(this, props));
	  }
	
	  _createClass(SkillsSummary, [{
	    key: 'handleRemove',
	    value: function handleRemove(skill) {
	      var removedSkill = _lodash2.default.merge({}, this.props.skills[skill.categoryId][skill.name]);
	      removedSkill.deleted = Symbol.for('_deleted_');
	      this.props.updateTempState('skills', removedSkill.categoryId + '.' + removedSkill.name, null, removedSkill);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Flatten map to array of skills
	      var skills = (0, _lodash2.default)(this.props.skills).flatMap(function (category) {
	        return _lodash2.default.reduce(category, function (result, skill) {
	
	          var cat = _lodash2.default.find(_this2.props.skillCategoryTypes, { id: skill.categoryId });
	          var level = _lodash2.default.find(_this2.props.skillLevelTypes, { id: skill.skillLevel });
	          result.push(_extends({}, skill, { categoryName: (cat || {}).name, skillLevelName: (level || {}).name }));
	          return result;
	        }, []);
	      }).filter(function (skill) {
	        return skill.deleted !== Symbol.for('_deleted_') && skill.name !== 'None';
	      }) // Do not include those marked for deletion
	      .value();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve' },
	        this.props.script && _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          'Now, let\u2019s review your skills.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'summary-container' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'Category'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'Skill Name'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'Last Used'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'Yrs of Exp'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item' },
	                'Skill Level'
	              )
	            ),
	            _lodash2.default.map(skills, function (skill) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'summary-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  skill.categoryName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  skill.name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  _lodash2.default.isNil(skill.lastUsed) ? 'N/A' : skill.lastUsed === 100 ? 'Current' : skill.lastUsed === 11 ? '10+ Yr. Ago' : skill.lastUsed + ' Yr. Ago'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  !skill.yearsOfExperience ? 'N/A' : skill.yearsOfExperience
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'summary-row-item' },
	                  !skill.skillLevelName ? 'N/A' : skill.skillLevelName
	                )
	              );
	            }),
	            skills.length === 0 && _react2.default.createElement(
	              'li',
	              { className: 'summary-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'summary-row-item-empty' },
	                'No skills have been selected'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SkillsSummary;
	}(_react2.default.Component), _class2.propTypes = {
	  skills: _react.PropTypes.object,
	  skillCategoryTypes: _react.PropTypes.array,
	  skillLevelTypes: _react.PropTypes.array,
	  updateTempState: _react.PropTypes.func,
	  script: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = SkillsSummary;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = TechnologySurveyForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _dropdowns = __webpack_require__(206);
	
	var _TextField = __webpack_require__(448);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	var _SubText = __webpack_require__(864);
	
	var _SubText2 = _interopRequireDefault(_SubText);
	
	var _f_InfoModal = __webpack_require__(122);
	
	var _f_InfoModal2 = _interopRequireDefault(_f_InfoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YesNo = (0, _dropdowns.YesNoItems)();
	
	function renderAttributes(survey, property, labels) {
	  var errors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  return {
	    key: '' + property,
	    floatingLabelFixed: true,
	    floatingLabelText: labels[property],
	    value: survey[property],
	    errorText: (0, _lodash.get)(errors, property + '[0]')
	  };
	}
	
	function renderTextAttributes(survey, property, labels) {
	  var errors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var onChange = arguments[4];
	
	  var attributes = renderAttributes(survey, property, labels, errors);
	  return _extends({}, attributes, {
	    onChange: onChange(property),
	    onBlur: onChange(property),
	    value: survey[property] || '' // REACT: To prevent controlled components from switching to uncontrolled
	  });
	}
	
	function renderMenuAttributes(survey, property, menuItems, labels, errors) {
	  var attributes = renderAttributes(survey, property, labels, errors);
	  attributes.menuItems = menuItems;
	  return attributes;
	}
	
	function renderModalAttributes(property, labels, onClick) {
	  return {
	    text: labels[property],
	    note: labels[property + 'Message'],
	    onClick: onClick
	  };
	}
	
	function renderModal() {
	  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var onClose = arguments[1];
	
	  var close = function close() {
	    return onClose();
	  };
	
	  if (message) {
	    return _react2.default.createElement(_f_InfoModal2.default, {
	      cancelFunc: close,
	      buttonLabel: 'close',
	      transitionFunc: close,
	      text: message,
	      title: 'Note'
	    });
	  }
	}
	
	function renderTitleText(labels) {
	  var title = (0, _lodash.get)(labels, 'titleText');
	  if (title) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-heading', 'data-id': 'Technology Survey' },
	      title
	    );
	  }
	}
	
	function renderInstructionText() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$fieldLabels = _ref.fieldLabels,
	      fieldLabels = _ref$fieldLabels === undefined ? {} : _ref$fieldLabels,
	      _ref$survey = _ref.survey,
	      survey = _ref$survey === undefined ? {} : _ref$survey;
	
	  var text = (0, _lodash.get)(fieldLabels, 'instructionText');
	  if (text && !survey.dateCompleted) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-text example-text pre' },
	      text
	    );
	  }
	}
	
	function renderErrorText(errors) {
	  if (!(0, _lodash.isEmpty)(errors)) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'left-container error-message' },
	      'Missing or invalid fields.'
	    );
	  }
	}
	
	function renderCompleteButton() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$allowSubmit = _ref2.allowSubmit,
	      allowSubmit = _ref2$allowSubmit === undefined ? false : _ref2$allowSubmit,
	      _ref2$survey = _ref2.survey,
	      survey = _ref2$survey === undefined ? {} : _ref2$survey;
	
	  var onSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return false;
	  };
	
	
	  if (!survey.dateCompleted) {
	    return _react2.default.createElement(_c_RaisedButton2.default, {
	      label: 'Submit',
	      'data-id': 'Complete Button',
	      onClick: onSubmit,
	      disabled: !allowSubmit
	    });
	  }
	}
	
	function ComputerSection(props) {
	  var survey = props.survey,
	      errors = props.errors,
	      onChange = props.onChange,
	      onModal = props.onModal,
	      fieldLabels = props.fieldLabels,
	      _props$staticData = props.staticData,
	      computerTypes = _props$staticData.computerTypes,
	      operatingSystemTypes = _props$staticData.operatingSystemTypes,
	      windowsOperatingSystems = _props$staticData.windowsOperatingSystems,
	      computerMemorySizes = _props$staticData.computerMemorySizes;
	
	
	  var osWindows = (0, _lodash.find)(operatingSystemTypes, { hardcodelink: 'PC' });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'grid form-contents large-floating-text' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	          canAutoPosition: 'true',
	          className: 'internet-type',
	          onChange: onChange('computerTypeId')
	        }, renderMenuAttributes(survey, 'computerTypeId', computerTypes, fieldLabels, errors)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('computerOperatingSystemId')
	        }, renderMenuAttributes(survey, 'computerOperatingSystemId', operatingSystemTypes, fieldLabels, errors)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_TextField2.default, renderTextAttributes(survey, 'computerMakeAndModel', fieldLabels, errors, onChange))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      survey.computerOperatingSystemId === (0, _lodash.get)(osWindows, 'id') && _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          _SubText2.default,
	          renderModalAttributes('windowsOSModal', fieldLabels, onModal),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            onChange: onChange('windowsOperatingSystemId')
	          }, renderMenuAttributes(survey, 'windowsOperatingSystemId', windowsOperatingSystems, fieldLabels, errors)))
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          _SubText2.default,
	          renderModalAttributes('computerMemorySizes', fieldLabels, onModal),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            onChange: onChange('computerMemorySizeId')
	          }, renderMenuAttributes(survey, 'computerMemorySizeId', computerMemorySizes, fieldLabels, errors)))
	        )
	      )
	    )
	  );
	}
	
	ComputerSection.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  onModal: _react.PropTypes.func,
	  survey: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  fieldLabels: _react.PropTypes.object.isRequired,
	  errors: _react.PropTypes.object
	};
	
	function EquipmentSection(props) {
	  var survey = props.survey,
	      errors = props.errors,
	      onChange = props.onChange,
	      fieldLabels = props.fieldLabels,
	      displayConnectionTypes = props.staticData.displayConnectionTypes;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'grid form-contents large-floating-text' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('hasHeadsetWithMicrophone')
	        }, renderMenuAttributes(survey, 'hasHeadsetWithMicrophone', YesNo, fieldLabels, errors)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('hasSpeakersWithMicrophone')
	        }, renderMenuAttributes(survey, 'hasSpeakersWithMicrophone', YesNo, fieldLabels, errors)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('hasWebcam')
	        }, renderMenuAttributes(survey, 'hasWebcam', YesNo, fieldLabels, errors)))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('hasSecondMonitor')
	        }, renderMenuAttributes(survey, 'hasSecondMonitor', YesNo, fieldLabels, errors)))
	      )
	    )
	  );
	}
	
	EquipmentSection.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  survey: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  fieldLabels: _react.PropTypes.object.isRequired,
	  errors: _react.PropTypes.object
	};
	
	function SoftwareSection(props) {
	  var survey = props.survey,
	      errors = props.errors,
	      onChange = props.onChange,
	      onModal = props.onModal,
	      fieldLabels = props.fieldLabels,
	      msOfficeVersions = props.staticData.msOfficeVersions;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'grid form-contents large-floating-text' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_TextField2.default, _extends({
	          disabled: false
	        }, renderTextAttributes(survey, 'antiVirusName', fieldLabels, errors, onChange)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_DateInput2.default, _extends({
	          disabled: false,
	          defaultValue: !survey.hasAntiVirusInstalled ? '' : survey.antiVirusExpired,
	          autoOk: true,
	          dataId: 'antiVirusExpired',
	          minDate: new Date()
	        }, renderTextAttributes(survey, 'antiVirusExpired', fieldLabels, errors, onChange)))
	      ),
	      _react2.default.createElement('div', { className: 'col' })
	    )
	  );
	}
	
	SoftwareSection.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  onModal: _react.PropTypes.func,
	  survey: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  fieldLabels: _react.PropTypes.object.isRequired,
	  errors: _react.PropTypes.object
	};
	
	function InternetSection(props) {
	  var survey = props.survey,
	      errors = props.errors,
	      onChange = props.onChange,
	      onModal = props.onModal,
	      fieldLabels = props.fieldLabels,
	      _props$staticData2 = props.staticData,
	      internetProviders = _props$staticData2.internetProviders,
	      internetTypes = _props$staticData2.internetTypes,
	      internetAges = _props$staticData2.internetAges,
	      routerAges = _props$staticData2.routerAges;
	
	
	  var otherISP = (0, _lodash.get)((0, _lodash.find)(internetProviders, { subElement: 'Other' }), 'id');
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'grid form-contents large-floating-text' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	          onChange: onChange('internetProviderId')
	        }, renderMenuAttributes(survey, 'internetProviderId', internetProviders, fieldLabels, errors)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_TextField2.default, _extends({
	          disabled: !(survey.internetProviderId === otherISP)
	        }, renderTextAttributes(survey, 'internetProviderOther', fieldLabels, errors, onChange)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	          onChange: onChange('internetTypeId')
	        }, renderMenuAttributes(survey, 'internetTypeId', internetTypes, fieldLabels, errors)))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col input-container internet-speeds' },
	        _react2.default.createElement(
	          _SubText2.default,
	          renderModalAttributes('internetSpeeds', fieldLabels, onModal),
	          _react2.default.createElement(_TextField2.default, _extends({
	            min: 0
	          }, renderTextAttributes(survey, 'internetDownloadSpeed', fieldLabels, errors, onChange)))
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col input-container internet-speeds' },
	        _react2.default.createElement(
	          _SubText2.default,
	          renderModalAttributes('internetSpeeds', fieldLabels, onModal),
	          _react2.default.createElement(_TextField2.default, _extends({
	            min: 0
	          }, renderTextAttributes(survey, 'internetUploadSpeed', fieldLabels, errors, onChange)))
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	          onChange: onChange('internetAgeId')
	        }, renderMenuAttributes(survey, 'internetAgeId', internetAges, fieldLabels, errors)))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('hasRouter')
	        }, renderMenuAttributes(survey, 'hasRouter', YesNo, fieldLabels, errors)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col', { 'smaller-label': true }) },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('isRouterLocatedInSameArea')
	        }, renderMenuAttributes(survey, 'isRouterLocatedInSameArea', YesNo, fieldLabels, errors)))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col', { 'smaller-label': true }) },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('supportsVOIP')
	        }, renderMenuAttributes(survey, 'supportsVOIP', YesNo, fieldLabels, errors)))
	      )
	    )
	  );
	}
	
	InternetSection.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  onModal: _react.PropTypes.func,
	  survey: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  fieldLabels: _react.PropTypes.object.isRequired,
	  errors: _react.PropTypes.object
	};
	
	function SmartPhoneSection(props) {
	  var survey = props.survey,
	      errors = props.errors,
	      onChange = props.onChange,
	      fieldLabels = props.fieldLabels;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'grid form-contents large-floating-text' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_TextField2.default, renderTextAttributes(survey, 'smartPhoneMakeAndModel', fieldLabels, errors, onChange))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_ToggleButton2.default, _extends({
	          onChange: onChange('hotspot')
	        }, renderMenuAttributes(survey, 'hotspot', YesNo, fieldLabels, errors)))
	      )
	    )
	  );
	}
	
	SmartPhoneSection.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  onModal: _react.PropTypes.func,
	  survey: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  fieldLabels: _react.PropTypes.object.isRequired,
	  errors: _react.PropTypes.object
	};
	
	function TechnologySurveyForm(props) {
	
	  var onChange = function onChange(field) {
	    return function (event, value) {
	      if (props.onChange) {
	        props.onChange(field, value);
	      }
	    };
	  };
	
	  var onSave = function onSave() {
	    if (props.onSave) {
	      props.onSave();
	    }
	  };
	
	  var onSubmit = function onSubmit() {
	    if (props.onSubmit) {
	      props.onSubmit();
	    }
	  };
	
	  var onModal = function onModal(note) {
	    if (props.onModal) {
	      props.onModal(note);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('application-section-container applicant-technology-survey-container clearfix', { admin: props.adminView }) },
	    renderModal(props.modalMessage, onModal),
	    renderTitleText(props.fieldLabels),
	    renderInstructionText(props),
	    _react2.default.createElement(
	      'div',
	      { className: 'form-subheading', 'data-id': 'Your Computer' },
	      'Your Computer'
	    ),
	    _react2.default.createElement(ComputerSection, {
	      survey: props.survey,
	      staticData: props.staticData,
	      fieldLabels: props.fieldLabels,
	      errors: props.errors,
	      onChange: onChange,
	      onModal: onModal
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'form-subheading', 'data-id': 'Other Equipment' },
	      'Other Equipment'
	    ),
	    _react2.default.createElement(EquipmentSection, {
	      survey: props.survey,
	      staticData: props.staticData,
	      fieldLabels: props.fieldLabels,
	      errors: props.errors,
	      onChange: onChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'form-subheading', 'data-id': 'Your Software' },
	      'Your Software'
	    ),
	    _react2.default.createElement(SoftwareSection, {
	      survey: props.survey,
	      staticData: props.staticData,
	      fieldLabels: props.fieldLabels,
	      errors: props.errors,
	      onChange: onChange,
	      onModal: onModal
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'form-subheading', 'data-id': 'Your Internet Connection' },
	      'Your Internet Connection'
	    ),
	    _react2.default.createElement(InternetSection, {
	      survey: props.survey,
	      staticData: props.staticData,
	      fieldLabels: props.fieldLabels,
	      errors: props.errors,
	      onChange: onChange,
	      onModal: onModal
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'form-subheading', 'data-id': 'Your Internet Connection' },
	      'Your Cell Phone'
	    ),
	    _react2.default.createElement(SmartPhoneSection, {
	      survey: props.survey,
	      staticData: props.staticData,
	      fieldLabels: props.fieldLabels,
	      errors: props.errors,
	      onChange: onChange,
	      onModal: onModal
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'right-container' },
	      renderErrorText(props.errors),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'text-btn back noTextSelect',
	          'data-id': 'Save',
	          onClick: onSave },
	        'Save'
	      ),
	      renderCompleteButton(props, onSubmit)
	    )
	  );
	}
	
	TechnologySurveyForm.propTypes = {
	  survey: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  fieldLabels: _react.PropTypes.object.isRequired,
	  errors: _react.PropTypes.object,
	  modalMessage: _react.PropTypes.string,
	  adminView: _react.PropTypes.bool,
	  allowSubmit: _react.PropTypes.bool,
	  onModal: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  onSave: _react.PropTypes.func,
	  onSubmit: _react.PropTypes.func
	};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.companyFields = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp, _initialiseProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _form = __webpack_require__(168);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _DropdownChecklist = __webpack_require__(296);
	
	var _DropdownChecklist2 = _interopRequireDefault(_DropdownChecklist);
	
	var _CheckListTextField = __webpack_require__(447);
	
	var _CheckListTextField2 = _interopRequireDefault(_CheckListTextField);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _async = __webpack_require__(37);
	
	var _sync = __webpack_require__(21);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _modelValidator = __webpack_require__(33);
	
	var _parentChildList = __webpack_require__(169);
	
	var _industrySegments = __webpack_require__(307);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var companyFields = exports.companyFields = {
	  required: ['name', 'state', 'numberOfEmployees', 'segmentTypes', 'industryTypes', 'phoneNumber'],
	  optional: ['address2', 'parentCompany', 'parentCompanyId', 'address', 'city', 'zip', 'numberOfOffices', 'phoneNumber', 'segmentOther', 'industryOther', 'associationOther', 'isDivisionOrSubsidiary', 'tradeAssociations', 'iiabaState', 'affiliationOther', 'affiliationTypes', 'timezone', 'website']
	};
	
	var parentCompanyFields = {
	  required: ['name'],
	  optional: ['address2', 'address', 'city', 'state', 'zip']
	};
	
	var yesNo = [{ value: true, primaryText: 'Yes' }, { value: false, primaryText: 'No' }];
	
	function initializeCompanyForm(company) {
	  var companyForm = (0, _form.mapFormFields)(company, companyFields.required, companyFields.optional);
	  var parentCompany = companyForm.parentCompany;
	
	  var parentCompanyForm = (0, _form.mapFormFields)({ name: parentCompany }, parentCompanyFields.required, parentCompanyFields.optional);
	  return {
	    companyForm: companyForm,
	    parentCompanyForm: parentCompanyForm
	  };
	}
	
	var ClientCompanyInfo = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    contact: state.contactProfile,
	    company: state.contactProfile.company,
	    staticData: state.staticData,
	    labels: state.labels
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ClientCompanyInfo, _React$Component);
	
	  function ClientCompanyInfo(props, context) {
	    _classCallCheck(this, ClientCompanyInfo);
	
	    var _this = _possibleConstructorReturn(this, (ClientCompanyInfo.__proto__ || Object.getPrototypeOf(ClientCompanyInfo)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var _initializeCompanyFor = initializeCompanyForm(props.company),
	        companyForm = _initializeCompanyFor.companyForm,
	        parentCompanyForm = _initializeCompanyFor.parentCompanyForm;
	
	    _this.state = {
	      companyForm: companyForm,
	      parentCompanyForm: parentCompanyForm,
	      showErrors: false,
	      showForm: !(0, _lodash.isEmpty)(props.company) // use this so we don't load the form with empty contact data on initial load
	    };
	
	    if (_this.state.showForm) {
	      _this.validateCompanyForm(_this.state.companyForm);
	    }
	
	    _this.parentChildHandlers = (0, _parentChildList.parentChildList)();
	
	    return _this;
	  }
	
	  _createClass(ClientCompanyInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _sync.setNavState)({ isOpen: true, hideClose: true }));
	
	      var parentCompanyId = (0, _lodash.get)(this.props, 'company.parentCompanyId');
	      if (this.props.company && parentCompanyId) {
	        this.loadParentCompany(parentCompanyId);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.company) {
	        var _initializeCompanyFor2 = initializeCompanyForm(nextProps.company),
	            companyForm = _initializeCompanyFor2.companyForm,
	            parentCompanyForm = _initializeCompanyFor2.parentCompanyForm;
	
	        this.validateCompanyForm(companyForm);
	
	        this.setState((0, _lodash.merge)(_extends({}, this.state), { companyForm: companyForm, parentCompanyForm: parentCompanyForm, showForm: true }));
	
	        var parentCompanyId = (0, _lodash.get)(this.nextProps, 'company.parentCompanyId');
	        if (!this.state.parentCompanyData && parentCompanyId) {
	          this.loadParentCompany(parentCompanyId);
	        }
	      }
	    }
	  }, {
	    key: 'goToDashboard',
	    value: function goToDashboard() {
	      this.props.dispatch((0, _reactRouterRedux.push)('/client/company'));
	    }
	  }, {
	    key: 'loadParentCompany',
	    value: function loadParentCompany(parentCompanyId) {
	      var _this2 = this;
	
	      if (parentCompanyId) {
	        this.props.dispatch((0, _async.getCompanyById)(this.props.company.parentCompanyId, {
	          success: function success(data) {
	            _this2.setState((0, _lodash.merge)({}, _this2.state, {
	              parentCompanyForm: (0, _form.mapFormFields)(data[0], parentCompanyFields.required, parentCompanyFields.optional)
	            }));
	          }
	        }));
	      }
	    }
	  }, {
	    key: 'hasErrors',
	    value: function hasErrors(companyForm) {
	      return (0, _form.fieldsHasErrors)(companyForm);
	    }
	  }, {
	    key: 'iiabaStatesInternal',
	    value: function iiabaStatesInternal() {
	      return [{ id: null, name: 'Select' }].concat(_toConsumableArray((0, _lodash.get)(this.props, 'staticData.iiabaStates', [])));
	    }
	  }, {
	    key: 'validateCompanyForm',
	    value: function validateCompanyForm(form) {
	      (0, _lodash.forEach)(form, function (prop, key) {
	        if (companyFields.required.includes(key)) {
	          (0, _lodash.set)(form, key + '.errors', (0, _modelValidator.validateFormField)(key, form));
	        }
	      });
	      this.validatePhoneNumber(form);
	    }
	  }, {
	    key: 'validatePhoneNumber',
	    value: function validatePhoneNumber(form) {
	      var pattern = new RegExp(/^[2-9]\d{9}$/);
	      var phoneNumber = (0, _lodash.get)(form, 'phoneNumber.value');
	      if (phoneNumber !== '') {
	        if (pattern.test(phoneNumber) === false) {
	          (0, _lodash.set)(form, 'phoneNumber.errors', ['Must be a valid phone number.']);
	        }
	      }
	    }
	  }, {
	    key: 'handleOtherChange',
	    value: function handleOtherChange(prop, otherProp) {
	      var _this3 = this;
	
	      var menuItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	      var handleUpdate = arguments[3];
	
	      return function (event, value) {
	
	        if (handleUpdate) {
	          handleUpdate(event, value);
	        }
	
	        setTimeout(function () {
	          if (!_this3.renderOtherField(prop, menuItems)) {
	            _this3.handleCompanyUpdate(event, otherProp, null);
	          }
	        });
	      };
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this4 = this;
	
	      return function (event, value) {
	        return _this4.handleCompanyUpdate(event, prop, value);
	      };
	    }
	  }, {
	    key: 'renderFieldProperties',
	    value: function renderFieldProperties(model, prop, label) {
	      var field = (0, _lodash.get)(model, prop, {});
	
	      return {
	        'data-id': prop,
	        defaultValue: field.value,
	        floatingLabelText: label,
	        isDirty: !!(field.required ? (0, _lodash.get)(field, 'errors[0]') : undefined),
	        errorText: field.required ? (0, _lodash.get)(field, 'errors[0]') : undefined,
	        onBlur: this.handleChange(prop)
	      };
	    }
	  }, {
	    key: 'renderCompanyFieldProperties',
	    value: function renderCompanyFieldProperties(prop, label) {
	      var menuItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	      (0, _lodash.sortBy)(menuItems, ['id']);
	      return (0, _lodash.merge)({}, this.renderFieldProperties(this.state.companyForm, prop, label), { menuItems: menuItems });
	    }
	  }, {
	    key: 'renderCompanyFieldWithOtherProperties',
	    value: function renderCompanyFieldWithOtherProperties(prop, otherProp, label) {
	      var menuItems = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	      var fieldProps = this.renderCompanyFieldProperties(prop, label, menuItems);
	      var onChange = fieldProps.onChange;
	
	      fieldProps.dataId = prop;
	      fieldProps.onChange = this.handleOtherChange(prop, otherProp, menuItems, onChange);
	      return fieldProps;
	    }
	  }, {
	    key: 'renderParentCompanyFieldProperties',
	    value: function renderParentCompanyFieldProperties(prop, label) {
	      var menuItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	      (0, _lodash.sortBy)(menuItems, ['id']);
	      return (0, _lodash.merge)(this.renderFieldProperties(this.state.parentCompanyForm, prop, label), { menuItems: menuItems }, { disabled: true });
	    }
	  }, {
	    key: 'renderOtherField',
	    value: function renderOtherField(prop) {
	      var menuItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      var otherItem = menuItems.find(function (i) {
	        return i.name === 'Other' || i.primaryText === 'Other';
	      });
	      var fieldValue = (0, _lodash.get)(this.state.companyForm, prop + '.value', (0, _lodash.get)(this.state.companyForm, prop + '.defaultValue', []));
	      return otherItem && fieldValue && fieldValue.length && fieldValue.includes(otherItem.id || otherItem.value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$labels = this.props.labels,
	          editCompany = _props$labels.Client.Company.editCompany,
	          CompanyCard = _props$labels.CompanyCard;
	      var _props$staticData = this.props.staticData,
	          industryTypesList = _props$staticData.industryTypesList,
	          segmentTypes = _props$staticData.segmentTypes;
	
	      var _parentChildHandlers = this.parentChildHandlers({
	        parentProps: this.renderCompanyFieldWithOtherProperties('industryTypes', 'industryOther', CompanyCard.industry, this.props.staticData.industryTypesList),
	        childProps: this.renderCompanyFieldWithOtherProperties('segmentTypes', 'segmentOther', 'Industry Segment', this.props.staticData.segmentTypes)
	      }),
	          industryTypeProps = _parentChildHandlers.parent,
	          segmentTypeProps = _parentChildHandlers.child;
	
	      var selectedIndustries = (0, _lodash.get)(this.state, 'companyForm.industryTypes.value', (0, _lodash.get)(this.state, 'companyForm.industryTypes.defaultValue'));
	      var activeSegments = (0, _industrySegments.activeSegmentTypes)(segmentTypes, industryTypesList, selectedIndustries, (0, _lodash.get)(this.state, 'companyForm.segmentTypes.defaultValue'));
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'client-company-info' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Company Information'
	        ),
	        this.state.showForm && _react2.default.createElement(
	          'div',
	          { className: 'form-fields' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section' },
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderCompanyFieldProperties('name', 'Company Name'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderCompanyFieldProperties('address', 'Address Line 1'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderCompanyFieldProperties('address2', 'Address Line 2'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderCompanyFieldProperties('city', 'City'))),
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              className: 'inline-dropdown-container center-column-1'
	            }, this.renderCompanyFieldProperties('state', 'State', this.props.staticData.stateList))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1', type: 'number', maxLength: '5'
	            }, this.renderCompanyFieldProperties('zip', 'Zip'))),
	            _react2.default.createElement(_c_MaskedTextField2.default, _extends({ className: 'center-column-1',
	              hideMaskChar: true
	            }, this.renderCompanyFieldProperties('phoneNumber', 'Phone Number'), {
	              mask: '(999) 999-9999' })),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1',
	              type: 'number',
	              min: 0
	            }, this.renderCompanyFieldProperties('numberOfOffices', 'Number of Offices'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1',
	              type: 'number',
	              min: 0
	            }, this.renderCompanyFieldProperties('numberOfEmployees', 'Number of Employees'))),
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              className: 'inline-dropdown-container center-column-1'
	            }, this.renderCompanyFieldProperties('timezone', 'Timezone', this.props.staticData.timezoneList))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderCompanyFieldProperties('website', 'Company Website')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'center-column-3 text-only-section' },
	              'Are you a division or subsidiary of another company?'
	            ),
	            _react2.default.createElement(_c_ToggleButton2.default, _extends({
	              className: 'center-column-1 division-toggle'
	            }, this.renderCompanyFieldProperties('isDivisionOrSubsidiary', undefined, yesNo)))
	          ),
	          !!(0, _lodash.get)(this.state, 'companyForm.isDivisionOrSubsidiary.value', false) && _react2.default.createElement(
	            'div',
	            { className: 'form-section company-parent-info' },
	            !!(0, _lodash.get)(this.state, 'companyForm.parentCompanyId.value', false) && _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderParentCompanyFieldProperties('name', 'Parent Company Name'))) || _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderCompanyFieldProperties('parentCompany', 'Parent Company Name'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderParentCompanyFieldProperties('address', 'Address Line 1'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderParentCompanyFieldProperties('address2', 'Address Line 2'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderParentCompanyFieldProperties('city', 'City'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderParentCompanyFieldProperties('state', 'State'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'center-column-1'
	            }, this.renderParentCompanyFieldProperties('zip', 'Zip')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid form-section industry-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'industry' },
	              _react2.default.createElement(_CheckListTextField2.default, _extends({
	                className: 'row',
	                checkListContainerClassName: 'col',
	                textfieldContainerClassName: 'col grow-3',
	                showLabel: true
	              }, industryTypeProps)),
	              _.get(this.props.labels, 'Client.Company.editCompany.industryTypesSubText') && _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                _.get(this.props.labels, 'Client.Company.editCompany.industryTypesSubText')
	              ),
	              this.renderOtherField('industryTypes', this.props.staticData.industryTypesList) && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-3' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({
	                    className: 'center-column-1'
	                  }, this.renderCompanyFieldProperties('industryOther', 'Please specify')))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'industry' },
	              _react2.default.createElement(_DropdownChecklist2.default, {
	                'data-id': 'segmentTypes',
	                textLabel: 'Industry Segment',
	                menuItems: activeSegments,
	                value: (0, _lodash.get)(this.state, 'companyForm.segmentTypes.value'),
	                groupBy: 'parentName',
	                errorText: (0, _lodash.get)(this.state, 'companyForm.segmentTypes.errors[0]') || 'This field is required',
	                dirty: !!(0, _lodash.get)(this.state, 'companyForm.industryTypes.value', false),
	                onChange: this.handleChange('segmentTypes'),
	                required: true
	              }),
	              _.get(this.props.labels, 'Client.Company.editCompany.segmentTypesSubText') && _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                _.get(this.props.labels, 'Client.Company.editCompany.segmentTypesSubText')
	              ),
	              !!this.renderOtherField('segmentTypes', this.props.staticData.segmentTypes) && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-3' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({
	                    className: 'center-column-1'
	                  }, this.renderCompanyFieldProperties('segmentOther', 'Please specify')))
	                )
	              )
	            ),
	            (0, _lodash.get)(this.props.labels, 'tradeAssociations') && _react2.default.createElement(
	              'div',
	              { className: 'industry' },
	              _react2.default.createElement(_CheckListTextField2.default, _extends({
	                className: 'row',
	                checkListContainerClassName: 'col',
	                textfieldContainerClassName: 'col grow-3',
	                dataId: 'tradeAssociationsDisplay',
	                showLabel: true
	              }, this.renderCompanyFieldWithOtherProperties('tradeAssociations', 'associationOther', (0, _lodash.get)(this.props.labels, 'tradeAssociations'), (0, _lodash.map)(this.props.staticData.tradeAssociations, function (_ref) {
	                var id = _ref.id,
	                    crmName = _ref.crmName;
	                return { id: id, name: crmName };
	              })))),
	              this.renderOtherField('tradeAssociations', this.props.staticData.tradeAssociations) && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-3' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({
	                    className: 'center-column-1'
	                  }, this.renderCompanyFieldProperties('associationOther', 'Please specify')))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'industry' },
	              (0, _lodash.get)(editCompany, 'affiliationTypes') && _react2.default.createElement(_CheckListTextField2.default, _extends({
	                className: 'row',
	                checkListContainerClassName: 'col',
	                textfieldContainerClassName: 'col grow-3',
	                showLabel: true
	              }, this.renderCompanyFieldWithOtherProperties('affiliationTypes', 'affiliationOther', 'Network Affiliations', this.props.staticData.affiliationTypes))),
	              this.renderOtherField('affiliationTypes', this.props.staticData.affiliationTypes) && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-3' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({
	                    className: 'center-column-1'
	                  }, this.renderCompanyFieldProperties('affiliationOther', 'Please specify')))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'industry' },
	              (0, _lodash.get)(editCompany, 'iiabaStates') && _react2.default.createElement(_c_DropDownMenu2.default, this.renderCompanyFieldProperties('iiabaState', 'State Association Memberships to IIABA', this.iiabaStatesInternal()))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'form-submission-container' },
	          _react2.default.createElement(
	            'li',
	            { className: 'submission-button' },
	            this.state.showErrors && _react2.default.createElement(
	              'div',
	              { className: 'error-message' },
	              'Please fill out missing fields.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'submission-button' },
	            _react2.default.createElement(_Button2.default, {
	              className: 'button-secondary-large',
	              label: 'Cancel',
	              onClick: this.handleCancel
	            })
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'submission-button' },
	            _react2.default.createElement(_Button2.default, {
	              className: 'button-main-large',
	              label: 'Save',
	              onClick: this.handleSubmitCompanyForm
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClientCompanyInfo;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  company: _react.PropTypes.object,
	  staticData: _react.PropTypes.object,
	  labels: _react.PropTypes.object
	}, _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleCompanyUpdate = function (event, prop, value) {
	
	    if (prop === 'segmentTypes' && (0, _lodash.isNil)(value)) return; // WPS-43 - do not clear segment types when parent changes
	
	    var companyForm = (0, _lodash.get)((0, _lodash.merge)({}, _this5.state), 'companyForm', {});
	    var newValue = !(0, _lodash.isUndefined)(value) ? value : (0, _lodash.get)(event, 'target.value');
	
	    if (prop === 'isDivisionOrSubsidiary') {
	      (0, _lodash.set)(companyForm, 'isDivisionOrSubsidiary.value', newValue);
	    } else if (['numberOfOffices', 'numberOfEmployees'].includes(prop)) {
	      (0, _form.updateFormFields)(companyForm, prop, Math.abs(newValue));
	    } else {
	      (0, _form.updateFormFields)(companyForm, prop, newValue);
	    }
	
	    var showErrors = !!_this5.hasErrors(companyForm);
	    _this5.setState((0, _lodash.merge)({}, (0, _lodash.omit)(_this5.state, ['companyForm']), { companyForm: companyForm, showErrors: showErrors }));
	  };
	
	  this.handleSubmitCompanyForm = function () {
	    var _props = _this5.props,
	        dispatch = _props.dispatch,
	        contact = _props.contact,
	        company = _props.company;
	
	    var companyForm = (0, _lodash.merge)({}, _this5.state.companyForm);
	    _this5.validateCompanyForm(companyForm);
	    var showErrors = _this5.hasErrors(companyForm);
	    var newCompany = (0, _form.reduceToValues)(companyForm);
	
	    if (showErrors) {
	      return _this5.setState((0, _lodash.merge)({}, _extends({}, _this5.state), { companyForm: companyForm, showErrors: showErrors }));
	    }
	    if (!(0, _lodash.isEmpty)(newCompany)) {
	      newCompany.id = (0, _lodash.get)(company, 'id');
	      newCompany.putByClient = true;
	      dispatch(companyApi.updateCompanyById(newCompany, function (err, _ref2) {
	        var _ref2$body$data$items = _slicedToArray(_ref2.body.data.items, 1),
	            companyData = _ref2$body$data$items[0];
	
	        if (err) {
	          return console.error(err);
	        }
	
	        // remove the putByClient because it was only needed for the update, do not reflect it in the store.
	        delete newCompany.putByClient;
	
	        dispatch(companyStore.updateCompany((0, _lodash.merge)({}, { company: newCompany })));
	        dispatch(ui.showSnackBar());
	        _this5.goToDashboard();
	      }));
	    } else {
	      _this5.goToDashboard();
	    }
	  };
	
	  this.handleCancel = function () {
	    _this5.goToDashboard();
	  };
	
	  this.handleHideSnackBar = function () {
	    if (!_this5.state.showErrors) {
	      _this5.goToDashboard();
	    }
	  };
	}, _temp)) || _class);
	exports.default = ClientCompanyInfo;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.contactFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp, _initialiseProps;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _form = __webpack_require__(168);
	
	var _modelValidator = __webpack_require__(33);
	
	var _user = __webpack_require__(124);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _contacts2 = __webpack_require__(84);
	
	var contactStore = _interopRequireWildcard(_contacts2);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var contactFields = exports.contactFields = {
	  user: {
	    required: ['firstName', 'lastName', 'email', 'phoneNumber1', 'phoneType1', 'address', 'city', 'state', 'zip'],
	    optional: ['phoneExtension1', 'phoneExtension2', 'phoneNumber2', 'phoneType2', 'address2', 'timezone']
	  },
	  profile: {
	    required: ['title', 'initialInquiry'],
	    optional: ['department']
	  }
	};
	
	function initializeContactForm() {
	  var contact = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _contact$profile = contact.profile,
	      profile = _contact$profile === undefined ? {} : _contact$profile,
	      _contact$user = contact.user,
	      user = _contact$user === undefined ? {} : _contact$user;
	
	
	  return {
	    user: (0, _lodash.merge)((0, _form.mapFormFields)(user, contactFields.user.required, contactFields.user.optional), (0, _lodash.pick)((0, _user.getSchema)(), ['phoneNumber1', 'phoneNumber2'])),
	    profile: (0, _form.mapFormFields)(profile, contactFields.profile.required, contactFields.profile.optional),
	    company: {}
	  };
	}
	
	function ContactInfoForm(props) {
	  var _extends2;
	
	  var _props$contact = props.contact,
	      contact = _props$contact === undefined ? {} : _props$contact,
	      _props$stateList = props.stateList,
	      stateList = _props$stateList === undefined ? [] : _props$stateList,
	      _props$timezoneList = props.timezoneList,
	      timezoneList = _props$timezoneList === undefined ? [] : _props$timezoneList,
	      _props$phoneTypeList = props.phoneTypeList,
	      phoneTypeList = _props$phoneTypeList === undefined ? [] : _props$phoneTypeList,
	      _props$contactTypes = props.contactTypes,
	      contactTypes = _props$contactTypes === undefined ? [] : _props$contactTypes,
	      updateContact = props.updateContact;
	
	
	  function handleChange(model, prop) {
	    return function (event, value) {
	      return updateContact(event, model, prop, value);
	    };
	  }
	
	  function renderFieldProperties(model, prop, label) {
	    var field = (0, _lodash.get)(contact, model + '.' + prop, {});
	
	    return {
	      'data-id': '' + model + prop,
	      defaultValue: field.defaultValue,
	      floatingLabelText: label,
	      isDirty: !!(field.required ? (0, _lodash.get)(field, 'errors[0]') : undefined),
	      errorText: field.required ? (0, _lodash.get)(field, 'errors[0]') : undefined,
	      onBlur: handleChange(model, prop)
	    };
	  }
	
	  function renderCheckListFieldProperties(model, prop, label, menuItems) {
	    var field = (0, _lodash.get)(contact, model + '.' + prop, {});
	
	    return {
	      'data-id': '' + model + prop,
	      defaultValue: field.defaultValue,
	      floatingLabelText: label,
	      isDirty: !!(field.required ? (0, _lodash.get)(field, 'errors[0]') : undefined),
	      errorText: field.required ? (0, _lodash.get)(field, 'errors[0]') : undefined,
	      onBlur: handleChange(model, prop),
	      menuItems: menuItems
	    };
	  }
	
	  function renderDropDownFieldProperties(model, prop, label, menuItems) {
	    return (0, _lodash.merge)(renderFieldProperties(model, prop, label), { menuItems: menuItems });
	  }
	
	  var mainPhone = (0, _lodash.find)(phoneTypeList, { name: 'Main' });
	  var mainPhoneId = (0, _lodash.get)(mainPhone, 'id');
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'contact-info-form grid' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, renderFieldProperties('user', 'firstName', 'First Name'))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, renderFieldProperties('user', 'lastName', 'Last Name'))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, renderFieldProperties('profile', 'title', 'Title'))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, _extends({ disabled: true }, renderFieldProperties('user', 'email', 'Email')))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row  phone-number-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-2' },
	            _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	              className: 'phone-number center-column-2',
	              hideMaskChar: true
	            }, renderDropDownFieldProperties('user', 'phoneNumber1', 'Phone Number'), {
	              mask: '(999) 999-9999' }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'phone-type-dropdown'
	            }, renderDropDownFieldProperties('user', 'phoneType1', null, phoneTypeList)))
	          ),
	          (props.contact.user.phoneType1.value || props.contact.user.phoneType1.defaultValue) === mainPhoneId && _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_TextField2.default, _extends((_extends2 = { type: 'number'
	            }, _defineProperty(_extends2, 'type', 'number'), _defineProperty(_extends2, 'min', '0'), _defineProperty(_extends2, 'step', '1'), _defineProperty(_extends2, 'floatingLabelFixed', true), _extends2), renderFieldProperties('user', 'phoneExtension1', 'Extension')))
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row phone-number-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col grow-2' },
	            _react2.default.createElement(_c_MaskedTextField2.default, _extends({ className: 'phone-number center-column-2',
	              hideMaskChar: true,
	              validation: (0, _user.getSchema)().phoneNumber2
	            }, renderDropDownFieldProperties('user', 'phoneNumber2', 'Phone Number'), {
	              mask: '(999) 999-9999' }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'phone-type-dropdown'
	            }, renderDropDownFieldProperties('user', 'phoneType2', null, phoneTypeList)))
	          ),
	          (props.contact.user.phoneType2.value || props.contact.user.phoneType2.defaultValue) === mainPhoneId && _react2.default.createElement(
	            'div',
	            { className: 'col' },
	            _react2.default.createElement(_c_TextField2.default, _extends({ type: 'number', step: '1', min: '0', floatingLabelFixed: true }, renderFieldProperties('user', 'phoneExtension2', 'Extension')))
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, renderFieldProperties('user', 'address', 'Address Line 1'))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, renderFieldProperties('user', 'address2', 'Address Line 2'))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_DropDownMenu2.default, renderDropDownFieldProperties('user', 'timezone', 'Timezone', timezoneList))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, renderFieldProperties('user', 'city', 'City'))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_DropDownMenu2.default, renderDropDownFieldProperties('user', 'state', 'State', stateList))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, _extends({ type: 'number', maxLength: '5' }, renderFieldProperties('user', 'zip', 'Zip')))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextField2.default, renderFieldProperties('profile', 'department', 'Department'))
	      ),
	      _react2.default.createElement('div', { className: 'col' }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row', style: { marginTop: '20px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(_c_TextArea2.default, _extends({ description: 'Inquiry Reason' }, renderFieldProperties('profile', 'initialInquiry', 'Inquiry Reason')))
	      )
	    )
	  );
	}
	
	ContactInfoForm.propTypes = {
	  contact: _react.PropTypes.object.isRequired,
	  stateList: _react.PropTypes.array.isRequired,
	  timezoneList: _react.PropTypes.array.isRequired,
	  phoneTypeList: _react.PropTypes.array.isRequired,
	  contactTypes: _react.PropTypes.array.isRequired,
	  updateContact: _react.PropTypes.func.isRequired
	};
	
	var ClientContactInfo = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    contact: state.contactProfile,
	    staticData: state.staticData
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ClientContactInfo, _React$Component);
	
	  function ClientContactInfo(props, context) {
	    _classCallCheck(this, ClientContactInfo);
	
	    var _this = _possibleConstructorReturn(this, (ClientContactInfo.__proto__ || Object.getPrototypeOf(ClientContactInfo)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var contactForm = initializeContactForm(props.contact);
	
	    _this.state = {
	      contactForm: contactForm,
	      showErrors: false,
	      showForm: !(0, _lodash.isEmpty)(props.contact) // use this so we don't load the form with empty contact data on initial load
	    };
	
	    if (_this.state.showForm) {
	      _this.validateContactForm(_this.state.contactForm);
	    }
	
	    return _this;
	  }
	
	  _createClass(ClientContactInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.handleKeyPress);
	      this.props.dispatch(syncActions.setNavState({ isOpen: true, hideClose: true }));
	      var contact = this.props.contact;
	      if (!(0, _lodash.get)(contact, 'profile.verified', true)) {
	        this.setVerified(contact);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.contact) {
	        var contactForm = initializeContactForm(nextProps.contact);
	        var contact = nextProps.contact;
	
	        if (!(0, _lodash.get)(contact, 'profile.verified', true)) {
	          this.setVerified(contact);
	        }
	
	        this.validateContactForm(contactForm);
	
	        this.setState((0, _lodash.merge)(_extends({}, this.state), { contactForm: contactForm, showErrors: false, showForm: true }));
	      }
	    }
	  }, {
	    key: 'setVerified',
	    value: function setVerified(contact) {
	      var _this2 = this;
	
	      var updatedContact = {
	        user: {
	          id: contact.user.id
	        },
	        profile: {
	          id: contact.profile.id,
	          verified: true
	        },
	        company: {
	          id: contact.company.id
	        }
	      };
	
	      this.props.dispatch(contactApi.updateContact(updatedContact, function (err, result) {
	        if (err || !result) {
	          return console.error(err || 'Update failed.');
	        }
	
	        _this2.props.dispatch(contactStore.updateProfile(result.contact.profile));
	      }));
	    }
	  }, {
	    key: 'goToDashboard',
	    value: function goToDashboard() {
	      this.props.dispatch((0, _reactRouterRedux.push)('/client'));
	    }
	  }, {
	    key: 'hasErrors',
	    value: function hasErrors(contactForm) {
	      return (0, _lodash.reduce)(contactForm, function (errors, model) {
	        return (0, _form.fieldsHasErrors)(model) || errors;
	      }, false);
	    }
	  }, {
	    key: 'validateContactForm',
	    value: function validateContactForm(form) {
	      var _this3 = this;
	
	      (0, _lodash.forEach)(form, function (model, key) {
	        return _this3.validateForm(model, contactFields[key]);
	      });
	      this.validatePhoneNumber(form);
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm(form, fields) {
	      if (fields !== undefined) {
	        (0, _lodash.forEach)(form, function (prop, key) {
	          if (fields.required.includes(key)) {
	            (0, _lodash.set)(form, key + '.errors', (0, _modelValidator.validateFormField)(key, form));
	          }
	        });
	      }
	    }
	  }, {
	    key: 'validatePhoneNumber',
	    value: function validatePhoneNumber(form) {
	      var pattern = new RegExp(/^[2-9]\d{9}$/);
	      var phoneNumber = (0, _lodash.get)(form, 'phoneNumber1.value');
	      if (phoneNumber !== '') {
	        if (pattern.test(phoneNumber) === false) {
	          (0, _lodash.set)(form, 'phoneNumber1.errors', ['Must be a valid phone number.']);
	        }
	      }
	    }
	  }, {
	    key: 'updateFormFields',
	    value: function updateFormFields(model, prop, newValue) {
	      (0, _lodash.set)(model, prop + '.value', newValue);
	      (0, _lodash.set)(model, prop + '.errors', (0, _modelValidator.validateFormField)(prop, model));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'client-contact-info' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Contact Information'
	        ),
	        this.state.showForm && _react2.default.createElement(ContactInfoForm, {
	          contact: this.state.contactForm,
	          stateList: this.props.staticData.stateList,
	          phoneTypeList: this.props.staticData.contactPhoneTypes,
	          timezoneList: this.props.staticData.timezoneList,
	          contactTypes: this.props.staticData.contactTypes,
	          updateContact: this.handleContactUpdate
	        }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'form-submission-container' },
	          _react2.default.createElement(
	            'li',
	            { className: 'submission-button' },
	            this.state.showErrors && _react2.default.createElement(
	              'div',
	              { className: 'error-message' },
	              'Please fill out missing fields.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'submission-button' },
	            _react2.default.createElement(_Button2.default, {
	              className: 'button-secondary-large',
	              label: 'Cancel',
	              onClick: this.handleCancel
	            })
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'submission-button' },
	            _react2.default.createElement(_Button2.default, {
	              className: 'button-main-large',
	              label: 'Save',
	              onClick: this.handleSave
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClientContactInfo;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object
	}, _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.handleKeyPress = function (event) {
	    // escape key response
	    if (event.keyCode === 27) {
	      _this4.goToDashboard();
	    }
	  };
	
	  this.handleContactUpdate = function (event, model, prop, value) {
	
	    var contactForm = (0, _lodash.get)((0, _lodash.merge)({}, _extends({}, _this4.state)), 'contactForm');
	
	    _this4.updateFormFields(contactForm[model], prop, value || event.target.value);
	
	    var showErrors = _this4.hasErrors(contactForm);
	    _this4.setState((0, _lodash.merge)({}, (0, _lodash.omit)(_this4.state, ['contactForm']), { contactForm: contactForm, showErrors: showErrors }));
	  };
	
	  this.handleSubmitContactForm = function () {
	    var dispatch = _this4.props.dispatch;
	
	    var contactForm = (0, _lodash.merge)({}, _this4.state.contactForm);
	    _this4.validateContactForm(contactForm);
	    var showErrors = _this4.hasErrors(contactForm);
	    var newContact = (0, _lodash.reduce)(contactForm, function (form, model, prop) {
	      return (0, _lodash.set)(form, prop, (0, _form.reduceToValues)(model));
	    }, {});
	
	    if (showErrors) {
	      return _this4.setState((0, _lodash.merge)({}, _extends({}, _this4.state), { contactForm: contactForm, showErrors: showErrors }));
	    }
	    if (!(0, _lodash.isEmpty)(newContact.user) || !(0, _lodash.isEmpty)(newContact.profile)) {
	      newContact.user.id = (0, _lodash.get)(_this4.props.contact, 'user.id');
	      newContact.company.id = (0, _lodash.get)(_this4.props.contact, 'company.id');
	      newContact.profile.id = (0, _lodash.get)(_this4.props.contact, 'profile.id');
	      dispatch(contactApi.updateContact(newContact, function (err, data) {
	        if (err) {
	          return console.error(err);
	        }
	
	        dispatch((0, _sync.updateUser)((0, _lodash.merge)({}, _this4.props.contact.user, data.contact.user)));
	        dispatch(contactStore.updateProfile((0, _lodash.merge)({}, _this4.props.contact.profile, data.contact.profile)));
	
	        _this4.props.dispatch(ui.showSnackBar());
	        _this4.goToDashboard();
	      }));
	    } else {
	      _this4.goToDashboard();
	    }
	  };
	
	  this.handleSave = function (event) {
	    _this4.handleSubmitContactForm(event);
	  };
	
	  this.handleCancel = function () {
	    _this4.goToDashboard();
	  };
	}, _temp)) || _class);
	exports.default = ClientContactInfo;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _staticData = __webpack_require__(28);
	
	var _enums = __webpack_require__(92);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _JobRequestTable = __webpack_require__(230);
	
	var _JobRequestTable2 = _interopRequireDefault(_JobRequestTable);
	
	var _AssignmentTable = __webpack_require__(854);
	
	var _AssignmentTable2 = _interopRequireDefault(_AssignmentTable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientDashboard = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    allowAddJobRequest: state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.QUALIFIED_PROSPECT || state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.ACTIVE_ACCOUNT || state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.INACTIVE_ACCOUNT,
	    company: state.company,
	    contact: state.contactProfile,
	    contacts: (0, _lodash.valuesIn)(state.companyContacts),
	    jobs: (0, _lodash.valuesIn)(state.jobRequests),
	    staticData: state.staticData,
	    bqpMigrationFeature: state.staticData.featureToggles.find(function (feature) {
	      return feature.hardcodelink === 'BQP_MIGRATION_FEATURE';
	    }).value === true
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ClientDashboard, _React$Component);
	
	  function ClientDashboard(props, context) {
	    _classCallCheck(this, ClientDashboard);
	
	    var _this = _possibleConstructorReturn(this, (ClientDashboard.__proto__ || Object.getPrototypeOf(ClientDashboard)).call(this, props, context));
	
	    var initialState = {};
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(ClientDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch(syncActions.setNavState({ isOpen: true, hideClose: true }));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.contact && nextProps.contact.profile) {
	        if (this.firstTimeUser(nextProps)) {
	          this.props.dispatch((0, _reactRouterRedux.push)('/client/welcome'));
	        }
	      }
	    }
	  }, {
	    key: 'firstTimeUser',
	    value: function firstTimeUser(nextProps) {
	      return nextProps.contact.profile && !nextProps.contact.profile.verified && nextProps.contact.profile.createdBy;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var user = this.props.contact.user;
	      var profile = this.props.contact.profile;
	      var company = this.props.contact.company;
	
	      var clientAdviser = this.props.staticData.clientAdvisers && this.props.staticData.clientAdvisers.find(function (ca) {
	        return company.clientAdvisorId === ca.employeeId;
	      });
	
	      var contactPhoneTypes = (0, _lodash.get)(this.props.staticData, 'contactPhoneTypes');
	      var mainPhone = (0, _lodash.find)(contactPhoneTypes, { name: 'Main' });
	      var mainPhoneId = (0, _lodash.get)(mainPhone, 'id');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'client-dashboard' },
	        _react2.default.createElement(
	          'div',
	          { className: 'top-info-section' },
	          (0, _lodash.get)(company, 'clientAdvisorId', null) && clientAdviser && _react2.default.createElement(
	            'div',
	            { 'data-id': 'Client Advisor' },
	            clientAdviser && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                clientAdviser.firstName + ' ' + clientAdviser.lastName,
	                ', Client Advisor \u2022 '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                clientAdviser.phoneNumber && (0, _prettyPhone2.default)(clientAdviser.phoneNumber) + ' \u2022 '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                clientAdviser.email
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid client-dashboard-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'h1',
	                { 'data-id': 'Client Name' },
	                (0, _lodash.get)(user, 'firstName'),
	                ' ',
	                (0, _lodash.get)(user, 'lastName')
	              )
	            ),
	            !this.props.bqpMigrationFeature && _react2.default.createElement(
	              'div',
	              { className: 'col buttons-container' },
	              _react2.default.createElement(_Button2.default, {
	                'data-id': 'edit-button',
	                className: 'button-secondary',
	                onClick: function onClick() {
	                  return _this2.props.dispatch((0, _reactRouterRedux.push)('/client/edit'));
	                },
	                label: 'Edit Info'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-column-1' },
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Title' },
	              'Title: ',
	              (0, _lodash.get)(profile, 'title'),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Phone1' },
	              (0, _staticData.lookup)(this.props.staticData, 'contactPhoneTypes', { id: (0, _lodash.get)(user, 'phoneType1') }),
	              ' #: ',
	              user.phoneNumber1 && (0, _prettyPhone2.default)((0, _lodash.get)(user, 'phoneNumber1')),
	              (0, _lodash.get)(user, 'phoneType1') === mainPhoneId && ' Ext:  ' + (0, _lodash.get)(user, 'phoneExtension1'),
	              ' ',
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Phone2' },
	              (0, _lodash.get)(user, 'phoneType2') ? (0, _staticData.lookup)(this.props.staticData, 'contactPhoneTypes', { id: (0, _lodash.get)(user, 'phoneType2') }) + ' #: ' + (0, _prettyPhone2.default)((0, _lodash.get)(user, 'phoneNumber2')) : '',
	              (0, _lodash.get)(user, 'phoneType2') === mainPhoneId && ' Ext:  ' + (0, _lodash.get)(user, 'phoneExtension2'),
	              ' ',
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Email' },
	              'Email: ',
	              (0, _lodash.get)(user, 'email'),
	              _react2.default.createElement('br', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'center-column-1' },
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Department' },
	              'Department: ',
	              (0, _lodash.get)(profile, 'department'),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Address' },
	              (0, _lodash.get)(user, 'address'),
	              ' ',
	              (0, _lodash.get)(user, 'address2'),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'City State Zip' },
	              (0, _lodash.get)(user, 'city'),
	              ', ',
	              (0, _staticData.lookup)(this.props.staticData, 'stateList', { id: (0, _lodash.get)(user, 'state') }, 'abbreviation'),
	              ' ',
	              (0, _lodash.get)(user, 'zip'),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Time Zone' },
	              'Time Zone: ',
	              (0, _staticData.lookup)(this.props.staticData, 'timezoneList', { id: (0, _lodash.get)(user, 'timezone') }),
	              _react2.default.createElement('br', null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'summary-view' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Summary View'
	          ),
	          _react2.default.createElement(_JobRequestTable2.default, {
	            columns: ['IdNoLink', 'Title', 'Date', 'Status'],
	            jobRequestsList: this.props.jobs,
	            showFilters: false,
	            showSearch: false,
	            showHeader: false,
	            contacts: this.props.contacts,
	            linksInNewTab: true,
	            tableHeight: '400px',
	            companyId: this.props.company.id
	          }),
	          _react2.default.createElement(_AssignmentTable2.default, {
	            columns: ['IdNoLink', 'Title', 'Date', 'Status'],
	            assignmentList: [],
	            showFilters: false,
	            showSearch: false,
	            showHeader: false
	          })
	        ),
	        this.props.allowAddJobRequest && !this.props.bqpMigrationFeature && _react2.default.createElement(
	          'div',
	          { className: 'add-job-button', 'data-id': 'Add Job Request' },
	          _react2.default.createElement(_Button2.default, {
	            'data-id': 'add-button',
	            className: 'button-main-large',
	            onClick: function onClick() {
	              return _this2.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest'));
	            },
	            label: 'Add Job Request' })
	        )
	      );
	    }
	  }]);
	
	  return ClientDashboard;
	}(_react2.default.Component), _class2.propTypes = {
	  allowAddJobRequest: _react.PropTypes.object,
	  company: _react.PropTypes.object,
	  contact: _react.PropTypes.object.isRequired,
	  contacts: _react.PropTypes.array.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  jobs: _react.PropTypes.array.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  bqpMigrationFeature: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = ClientDashboard;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _lodash = __webpack_require__(4);
	
	var _enums = __webpack_require__(92);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientWelcome = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    contact: state.contactProfile,
	    staticData: state.staticData
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ClientWelcome, _React$Component);
	
	  function ClientWelcome(props, context) {
	    _classCallCheck(this, ClientWelcome);
	
	    return _possibleConstructorReturn(this, (ClientWelcome.__proto__ || Object.getPrototypeOf(ClientWelcome)).call(this, props, context));
	  }
	
	  _createClass(ClientWelcome, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch(syncActions.setNavState({ isOpen: true, hideClose: true }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var companyName = (0, _lodash.get)(this.props.contact, 'company.name');
	
	      var clientAdviserId = (0, _lodash.get)(this.props.contact, 'profile.clientAdvisorId');
	      var clientAdviser = this.props.staticData.clientAdvisers.find(function (adviser) {
	        return adviser.employeeId === clientAdviserId;
	      }) || this.props.staticData.clientAdvisers.find(function (adviser) {
	        return adviser.defaultRole === _enums.EMPLOYEE_ROLES.CLIENT_ADVISER;
	      });
	
	      var relationshipManagerId = (0, _lodash.get)(this.props.contact, 'company.relationshipManagerId');
	      var relationshipManager = this.props.staticData.relationshipManagers.find(function (manager) {
	        return manager.employeeId === relationshipManagerId;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'client-welcome' },
	        _react2.default.createElement(
	          'div',
	          { className: 'top-info-section' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'top-info-section-company' },
	              'Company: ',
	              companyName,
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'top-info-section-seperator' },
	              '\u2022'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'top-info-section-manager' },
	              'Client Adviser: ',
	              clientAdviser.firstName,
	              ' ',
	              clientAdviser.lastName
	            ),
	            clientAdviser.phoneNumber && _react2.default.createElement(
	              'span',
	              { className: 'top-info-section-number' },
	              ', ',
	              (0, _prettyPhone2.default)(clientAdviser.phoneNumber)
	            ),
	            relationshipManager && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'top-info-section-seperator' },
	                '\u2022'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'top-info-section-manager' },
	                'Relationship Manager: ',
	                relationshipManager.firstName,
	                ' ',
	                relationshipManager.lastName
	              ),
	              relationshipManager.phoneNumber && _react2.default.createElement(
	                'span',
	                { className: 'top-info-section-number' },
	                ', ',
	                (0, _prettyPhone2.default)(relationshipManager.phoneNumber)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'client-welcome-container' },
	          function (user) {
	            if (user) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'client-welcome-content' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'header' },
	                  'Welcome, ',
	                  _this2.props.contact.user.firstName,
	                  '!'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'You have been added to the system but are still missing some information. please click on the button below to add or edit your infomation'
	                ),
	                _react2.default.createElement(_Button2.default, {
	                  'data-id': 'add-button',
	                  className: 'button-main-large',
	                  onClick: function onClick() {
	                    return _this2.props.dispatch((0, _reactRouterRedux.push)('/client/edit'));
	                  },
	                  label: 'Add Information' })
	              );
	            }
	          }(this.props.contact.user)
	        )
	      );
	    }
	  }]);
	
	  return ClientWelcome;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ClientWelcome;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _formatCompanyUrl = __webpack_require__(306);
	
	var _staticData = __webpack_require__(28);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ContactTable = __webpack_require__(295);
	
	var _ContactTable2 = _interopRequireDefault(_ContactTable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyDashboard = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    contact: state.contactProfile,
	    company: state.company,
	    staticData: state.staticData,
	    labels: state.labels,
	    jobs: (0, _lodash.valuesIn)(state.jobRequests),
	    contacts: (0, _lodash.valuesIn)(state.companyContacts),
	    bqpMigrationFeature: state.staticData.featureToggles.find(function (feature) {
	      return feature.hardcodelink === 'BQP_MIGRATION_FEATURE';
	    }).value === true
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(CompanyDashboard, _React$Component);
	
	  function CompanyDashboard(props, context) {
	    _classCallCheck(this, CompanyDashboard);
	
	    var _this = _possibleConstructorReturn(this, (CompanyDashboard.__proto__ || Object.getPrototypeOf(CompanyDashboard)).call(this, props, context));
	
	    _this.getCompanyUrl = _this.getCompanyUrl.bind(_this);
	    var initialState = {};
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(CompanyDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch(syncActions.setNavState({ isOpen: true, hideClose: true }));
	    }
	  }, {
	    key: 'showSelectedValues',
	    value: function showSelectedValues(type, ids) {
	      var values = (0, _lodash.reduce)(this.props.staticData[type], function (values, dataObj) {
	        if (!values) {
	          values = [];
	        }
	
	        if ((0, _lodash.find)(ids, function (item) {
	          return dataObj.id === item || dataObj.value === item;
	        })) {
	          values.push(dataObj.name || dataObj.primaryText);
	        }
	        return values;
	      }, []);
	
	      return (0, _lodash.join)(values, ', ');
	    }
	  }, {
	    key: 'getCompanyUrl',
	    value: function getCompanyUrl() {
	      if (this.props.company.website) {
	        return (0, _formatCompanyUrl.formatCompanyUrlForHyperlink)(this.props.company.website);
	
	        // eslint-disable-next-line no-else-return
	      } else {
	        if ((0, _lodash.isEmpty)(this.props.contact)) {
	          return '';
	
	          // eslint-disable-next-line no-else-return
	        } else {
	          var contactEmail = this.props.contact.user.email;
	          return (0, _formatCompanyUrl.extractCompanyUrlFromEmail)(contactEmail);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var CompanyCard = this.props.labels.CompanyCard;
	
	      var company = this.props.company;
	      var companyHyperlink = this.getCompanyUrl();
	      return _react2.default.createElement(
	        'div',
	        { className: 'company-dashboard' },
	        _react2.default.createElement(
	          'div',
	          { className: 'top-info-section' },
	          (0, _lodash.get)(company, 'relationshipManagerId', null) && _react2.default.createElement(
	            'div',
	            { 'data-id': 'Relationship Manager' },
	            _react2.default.createElement(
	              'span',
	              { className: 'heavy-text' },
	              (0, _lodash.get)(this.props.staticData, 'account.name')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              company.relationshipManager.name,
	              ', Relationship Manager \u2022 '
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              company.relationshipManager.phone && (0, _prettyPhone2.default)(company.relationshipManager.phone) + ' \u2022 '
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              company.relationshipManager.email
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid company-dashboard-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'h1',
	                { 'data-id': 'Company Name' },
	                (0, _lodash.get)(company, 'name')
	              )
	            ),
	            !this.props.bqpMigrationFeature && _react2.default.createElement(
	              'div',
	              { className: 'col buttons-container' },
	              _react2.default.createElement(_Button2.default, {
	                'data-id': 'tech-button',
	                className: 'button-secondary',
	                onClick: function onClick() {
	                  return _this2.props.dispatch((0, _reactRouterRedux.push)('/client/company/tech'));
	                },
	                label: 'Tech Q&A' }),
	              _react2.default.createElement(_Button2.default, {
	                'data-id': 'edit-button',
	                className: 'button-secondary',
	                onClick: function onClick() {
	                  return _this2.props.dispatch((0, _reactRouterRedux.push)('/client/company/edit'));
	                },
	                label: 'Edit Info'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-column-1' },
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Address' },
	              (0, _lodash.get)(company, 'address'),
	              ' ',
	              (0, _lodash.get)(company, 'address2'),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'City State Zip' },
	              (0, _lodash.get)(company, 'city'),
	              ', ',
	              (0, _staticData.lookup)(this.props.staticData, 'stateList', { id: (0, _lodash.get)(company, 'state') }, 'abbreviation'),
	              ' ',
	              (0, _lodash.get)(company, 'zip'),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Phone' },
	              company.phoneNumber && (0, _prettyPhone2.default)((0, _lodash.get)(company, 'phoneNumber')),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Number Employees' },
	              '# of Employees: ',
	              (0, _lodash.get)(company, 'numberOfEmployees'),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Number Offices' },
	              '# of Offices: ',
	              (0, _lodash.get)(company, 'numberOfOffices'),
	              _react2.default.createElement('br', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'center-column-1' },
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Firm Type' },
	              _react2.default.createElement(
	                'span',
	                { className: 'heavy-text' },
	                CompanyCard.industry
	              ),
	              ' ',
	              this.showSelectedValues('industryTypesList', (0, _lodash.get)(company, 'industryTypes')),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Industry Segment' },
	              _react2.default.createElement(
	                'span',
	                { className: 'heavy-text' },
	                'Industry Segment:'
	              ),
	              ' ',
	              this.showSelectedValues('segmentTypes', (0, _lodash.get)(company, 'segmentTypes')),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'data-id': 'Company Website' },
	              _react2.default.createElement(
	                'span',
	                { className: 'heavy-text' },
	                'Company Website:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://' + companyHyperlink },
	                company.website || companyHyperlink
	              ),
	              _react2.default.createElement('br', null)
	            ),
	            (0, _lodash.get)(this.props.labels, 'tradeAssociations', '') && _react2.default.createElement(
	              'span',
	              { 'data-id': 'Trade Associations' },
	              _react2.default.createElement(
	                'span',
	                { className: 'heavy-text' },
	                (0, _lodash.get)(this.props.labels, 'tradeAssociations', ''),
	                ':'
	              ),
	              ' ',
	              this.showSelectedValues('tradeAssociations', (0, _lodash.get)(company, 'tradeAssociations')),
	              _react2.default.createElement('br', null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'summary-view contacts-section' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Contact Information'
	          ),
	          _react2.default.createElement(_ContactTable2.default, {
	            contactLink: false,
	            useContactTypeDropdown: true,
	            contacts: this.props.contacts,
	            showFilters: false,
	            columns: ['Name', 'Title', 'Email', 'Phone'],
	            location: this.props.location.pathname })
	        )
	      );
	    }
	  }]);
	
	  return CompanyDashboard;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  company: _react.PropTypes.object.isRequired,
	  contacts: _react.PropTypes.array.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.object.isRequired,
	  bqpMigrationFeature: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = CompanyDashboard;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _modelValidator = __webpack_require__(33);
	
	var _ScrollColumn = __webpack_require__(297);
	
	var _ScrollColumn2 = _interopRequireDefault(_ScrollColumn);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _f_InfoModal = __webpack_require__(122);
	
	var _f_InfoModal2 = _interopRequireDefault(_f_InfoModal);
	
	var _SimpleDropDownMenu = __webpack_require__(121);
	
	var _SimpleDropDownMenu2 = _interopRequireDefault(_SimpleDropDownMenu);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateCompanyContact = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    user: store.user,
	    company: store.contactProfile.company,
	    staticData: store.staticData,
	    companyContacts: store.companyContacts
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CreateCompanyContact, _Component);
	
	  function CreateCompanyContact(props, context) {
	    _classCallCheck(this, CreateCompanyContact);
	
	    var _this = _possibleConstructorReturn(this, (CreateCompanyContact.__proto__ || Object.getPrototypeOf(CreateCompanyContact)).call(this, props, context));
	
	    _this.handleSubmit = function () {
	
	      var errors = (0, _modelValidator.validate)(_this.state.newContactModel, _this.addNewContactModel);
	      if (errors.length > 0) {
	        _this.setState({ isDirty: true });
	      } else {
	        var newContact = {
	          user: (0, _lodash.pick)(_this.state.newContactModel, ['firstName', 'lastName', 'email', 'phoneNumber1', 'address', 'city', 'state', 'zip']),
	          profile: (0, _lodash.pick)(_this.state.newContactModel, ['companyId', 'title', 'types'])
	        };
	        _this.props.dispatch(companyApi.addCompanyContacts(newContact, function (err, contact) {
	          if (err) {
	            console.log('error', err);
	            if (err.errors[0].errorMessage === 'User with that email already exists.') {
	              _this.setState((0, _lodash.merge)({}, _this.state, { modalMessage: 'The contact you are trying to add already exists in your company\'s contacts list. Click on your Company name to access your company\'s record.', showModal: true }));
	            } else {
	              _this.setState((0, _lodash.merge)({}, _this.state, { modalMessage: err.errors[0].message, showModal: true }));
	            }
	          } else {
	            _this.setState((0, _lodash.merge)({}, _this.state, { modalMessage: 'Contact has been successfully created.', showModal: true }));
	            _this.props.dispatch((0, _companies2.updateCompanyContacts)([].concat(_toConsumableArray(_this.props.companyContacts), [contact])));
	          }
	        }));
	      }
	    };
	
	    _this.state = {
	      company: {},
	      isDirty: false,
	      newContactModel: {
	        companyId: _this.props.user.companyId, // adding required fields for user model
	        department: _this.props.user.department,
	        cellPhone: _this.props.user.cellPhone,
	        workTypeDescription: _this.props.user.workTypeDescription,
	        address: _this.props.company.address,
	        city: _this.props.company.city,
	        state: _this.props.company.state,
	        zip: _this.props.company.zip
	      },
	      showModal: false,
	      modalMessage: ''
	    };
	    _this.addNewContactModel = {
	      firstName: {
	        required: {
	          message: 'This field is required.'
	        }
	      },
	      lastName: {
	        required: {
	          message: 'This field is required.'
	        }
	      },
	      title: {
	        required: {
	          message: 'This field is required.'
	        }
	      },
	      phoneNumber1: {
	        required: {
	          message: 'This field is required.'
	        },
	        isLength: {
	          options: { min: 10, max: 10 },
	          message: 'Must be 10 digits'
	        },
	        isNumeric: {
	          message: 'Must be numeric'
	        },
	        matches: {
	          options: /^[2-9]\d{9}$/,
	          message: 'Must be a valid phone number.'
	        }
	      },
	      email: {
	        required: {
	          message: 'This field is required.'
	        },
	        isEmail: {
	          message: 'Must be a valid email.'
	        }
	      },
	      address: {},
	      city: {
	        required: {
	          message: 'This field is required.'
	        }
	      },
	      state: {
	        required: {
	          message: 'This field is required.'
	        }
	      },
	      zip: {},
	      types: {}
	    };
	
	    _this.handleUI = _this.handleUI.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(CreateCompanyContact, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch(syncActions.setNavState({ isOpen: false, hideClose: false }));
	
	      if ((0, _lodash.isEmpty)(this.state.company) && !(0, _lodash.isEmpty)(this.props.company)) {
	        this.setState((0, _lodash.merge)({}, this.state, { company: this.props.company }));
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.company) {
	        this.setState((0, _lodash.merge)({}, this.state, { company: nextProps.company }));
	      }
	    }
	  }, {
	    key: 'handleUI',
	    value: function handleUI(prop, label) {
	
	      var result = {
	        'data-id': prop,
	        defaultValue: this.state.newContactModel[prop],
	        floatingLabelText: label,
	        isDirty: this.state.isDirty,
	        errorText: this.state.isDirty ? (0, _modelValidator.validateField)(this.state.newContactModel[prop], this.addNewContactModel[prop])[0] : undefined,
	        onErrorChange: this.state.isDirty ? (0, _modelValidator.validateField)(this.state.newContactModel[prop], this.addNewContactModel[prop])[0] : undefined,
	        onBlur: this.handleChange(prop)
	      };
	
	      var extraFields = {};
	      if (prop === 'state') {
	        extraFields.validation = this.addNewContactModel[prop];
	        result = (0, _lodash.omit)(result, ['onErrorChange']);
	      }
	
	      return _extends({}, result, extraFields);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this2 = this;
	
	      return function (event, value) {
	        var newContact = _this2.state.newContactModel;
	        newContact[prop] = value;
	        _this2.setState((0, _lodash.merge)({}, _this2.state, { newContactModel: newContact }));
	      };
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var _this3 = this;
	
	      this.setState((0, _lodash.merge)(this.state, { showModal: false }), function () {
	        if (_this3.state.modalMessage === 'Contact has been successfully created.') {
	          _this3.props.dispatch((0, _reactRouterRedux.push)('/client/company'));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var yesNoItems = [{
	        primaryText: 'Yes',
	        subElement: null,
	        value: true
	      }, {
	        primaryText: 'No',
	        subElement: null,
	        value: false
	      }];
	      var stateList = this.props.staticData.stateList;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'create-company-contact application-form' },
	        _react2.default.createElement(_ScrollColumn2.default, {
	          navGroups: ['Contact_Info'],
	          title: 'Add New'
	        }),
	        !!this.state.showModal && _react2.default.createElement(_f_InfoModal2.default, {
	          cancelFunc: this.closeModal.bind(this),
	          buttonLabel: 'close',
	          transitionFunc: this.closeModal.bind(this),
	          text: this.state.modalMessage
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'section',
	            { id: 'Contact_Info' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Contact Information'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-section-content clearfix' },
	              _react2.default.createElement(
	                'div',
	                { className: 'box-container-fixed clearfix' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleUI('firstName', 'First Name'))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleUI('lastName', 'Last Name'))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleUI('title', "Contact's Title"))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleUI('email', 'Email Address'))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	                    hideMaskChar: true,
	                    mask: '(999) 999-9999'
	                  }, this.handleUI('phoneNumber1', 'Phone Number')))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleUI('address', 'Street Address'))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_c_TextField2.default, this.handleUI('city', 'City'))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_SimpleDropDownMenu2.default, _extends({
	                    menuItems: stateList,
	                    underlineStyle: { margin: '-1px 0px' },
	                    iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                    labelStyle: { paddingLeft: '0px' }
	                  }, this.handleUI('state', 'State')))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({
	                    type: 'number',
	                    maxLength: 5
	                  }, this.handleUI('zip', 'Zip')))
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'bottom-bar' },
	          _react2.default.createElement(
	            'li',
	            { className: 'continue-button' },
	            _react2.default.createElement(_c_RaisedButton2.default, { label: 'Create',
	              onClick: this.handleSubmit
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateCompanyContact;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object,
	  staticData: _react.PropTypes.object.isRequired,
	  companyContacts: _react.PropTypes.object.isRequired,
	  company: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = CreateCompanyContact;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(51);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _c_SourceSimpleFileInput2 = _interopRequireDefault(_c_SourceSimpleFileInput);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _C_ProgressComponentList = __webpack_require__(140);
	
	var _C_ProgressComponentList2 = _interopRequireDefault(_C_ProgressComponentList);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _jobrequestDocuments = __webpack_require__(236);
	
	var jobRequestDocumentsApi = _interopRequireWildcard(_jobrequestDocuments);
	
	var _jobrequestDocuments2 = __webpack_require__(318);
	
	var jobRequestDocumentsStore = _interopRequireWildcard(_jobrequestDocuments2);
	
	var _SubmissionBar = __webpack_require__(125);
	
	var _SubmissionBar2 = _interopRequireDefault(_SubmissionBar);
	
	var _DocumentItemView = __webpack_require__(1021);
	
	var _DocumentItemView2 = _interopRequireDefault(_DocumentItemView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addButtonStyle = {
		width: '165px',
		transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
	};
	
	var AddDocuments = (_dec = (0, _reactRedux.connect)(function (store, props) {
		return {
			user: store.user,
			documents: store.jobRequestDocuments.documents,
			jobId: parseInt(props.params.jobId || 0, 10)
		};
	}), _dec(_class = (_temp = _class2 = function (_ProgressComponentLis) {
		_inherits(AddDocuments, _ProgressComponentLis);
	
		function AddDocuments(props, context) {
			_classCallCheck(this, AddDocuments);
	
			var _this = _possibleConstructorReturn(this, (AddDocuments.__proto__ || Object.getPrototypeOf(AddDocuments)).call(this, props, context));
	
			_this.handleSave = function (event, cb) {
	
				var documents = _.chain(_this.state.documentsModel).map(function (newDocument) {
					return _this.saveNewDocument(newDocument);
				}) // Save new documents.
				.map(function (document) {
					return _this.updateDocument(document);
				}) // Update created documents.
				.filter(function (document) {
					return _this.removeDocument(document);
				}); // Delete  created documents.
	
				_this.setState({ isDirty: true, stateSaved: true }, function () {
					_this.props.dispatch(jobRequestDocumentsStore.updateJobRequestDocuments(documents.value()));
					cb();
				});
			};
	
			_this.saveNewDocument = function (document) {
	
				if (document.isNew === true && document.softDelete !== true) {
					var processedDoc = _.omit(document, ['isNew', 'isModified', 'softDelete']);
					_this.props.dispatch(jobRequestDocumentsApi.createJobRequestDocuments(_this.props.user.profileId, processedDoc));
					return processedDoc;
				} else {
					return document;
				}
			};
	
			_this.updateDocument = function (document) {
	
				if (document.isModified === true && document.softDelete !== true) {
					var processedDoc = _.omit(document, ['isNew', 'isModified', 'softDelete', 'fileTypeId']);
					_this.props.dispatch(jobRequestDocumentsApi.updateJobRequestDocuments(_this.props.user.profileId, processedDoc));
					return processedDoc;
				} else {
					return document;
				}
			};
	
			_this.removeDocument = function (document) {
	
				// We filter out this document. check handleSave function.
	
				if (document.softDelete === true && document.isNew !== true) {
					var processedDoc = _.omit(document, ['isNew', 'isModified', 'softDelete', 'fileTypeId']);
					_this.props.dispatch(jobRequestDocumentsApi.deleteJobRequestDocuments(_this.props.user.profileId, processedDoc));
					return false;
				} else {
					return true;
				}
			};
	
			_this.handleSaveAndNext = function (event) {
	
				_this.handleSave(event, function () {
					_this.props.checkComplete();
					_this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/skills'));
				});
			};
	
			_this.handleBack = function (event) {
				_this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/description'));
			};
	
			_this.onUploadStart = function (err, infoObj) {
				var clientId = '' + _this.getIncrementedChar() + _shortid2.default.generate();
	
				_this.state.documentsModel.push({
					jobId: _this.props.params.jobId,
					clientId: clientId,
					fileName: infoObj.name,
					fileSize: infoObj.size,
					storagePath: infoObj.nameWithFolder,
					fileTypeId: infoObj.type,
					isNew: true,
					isModified: false
				});
	
				_this.state.stateSaved = false;
	
				_this.setState((0, _lodash.merge)({}, _this.state));
			};
	
			_this.onS3Load = function (err) {
				// updating UI optimistically so we only need to know if there was an error
				if (err && ("production") !== 'production') {
					console.error(err);
				}
			};
	
			_this.closeTransitionBlocker = function () {
				_this.setState((0, _lodash.merge)({}, _this.state, { showTransitionBlocker: false }));
			};
	
			_this.transitionFunction = function () {
				_this.setState({ stateSaved: true }, function () {
					return _this.props.dispatch((0, _reactRouterRedux.push)(_this.state.transitionRoute));
				});
			};
	
			_this.state = {
				profileId: _this.props.user.profileId,
				isDirty: false,
				documents: null,
				documentsModel: _this.cloneCollection(props.documents),
				showTransitionBlocker: false,
				transitionRoute: '',
				stateSaved: true
			};
	
			_this.onRemoveDocument = _this.onRemoveDocument.bind(_this);
			_this.onChangeDocument = _this.onChangeDocument.bind(_this);
			_this.onUploadStart = _this.onUploadStart.bind(_this);
	
			return _this;
		}
	
		_createClass(AddDocuments, [{
			key: 'cloneCollection',
			value: function cloneCollection(collection) {
				return _.chain(collection).map(function (item) {
					return (0, _lodash.merge)({}, item);
				}).value();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.documents) {
					var documentsModel = (0, _lodash.get)(nextProps, 'documents', []);
					this.setState((0, _lodash.merge)({}, { documentsModel: documentsModel }));
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				this.props.router.setRouteLeaveHook(this.props.route, function (location) {
	
					var jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;
	
					if (jobRequestSteps.test(location.pathname)) {
						_this2.state.primaryButtonLabel = 'Stay';
						_this2.state.secondaryButtonLabel = 'Leave';
					} else {
						_this2.state.primaryButtonLabel = undefined;
						_this2.state.secondaryButtonLabel = undefined;
					}
	
					if (!_this2.state.stateSaved) {
						_this2.setState((0, _lodash.merge)({}, _this2.state, { showTransitionBlocker: true, transitionRoute: location.pathname }));
						return _this2.state.stateSaved;
					} else {
						return true;
					}
				});
			}
		}, {
			key: 'onRemoveDocument',
			value: function onRemoveDocument(document) {
	
				var index = (0, _lodash.findIndex)(this.state.documentsModel, document);
	
				if (index === -1) return;
	
				this.state.documentsModel[index].softDelete = true;
				this.state.stateSaved = false;
				this.setState((0, _lodash.merge)({}, this.state));
			}
		}, {
			key: 'onChangeDocument',
			value: function onChangeDocument(description, document) {
	
				var index = (0, _lodash.findIndex)(this.state.documentsModel, { clientId: document.clientId });
	
				if (index === -1) return;
	
				this.state.documentsModel[index].description = description;
	
				// We only mark as modified if the document is stored in DB.
				if (this.state.documentsModel[index].isNew !== true) {
					this.state.documentsModel[index].isModified = true;
				}
	
				this.state.stateSaved = false;
	
				this.setState((0, _lodash.merge)({}, this.state));
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _ref = this.state || [],
				    documentsModel = _ref.documentsModel;
	
				return _react2.default.createElement(
					'div',
					{ className: 'add-documents' },
					this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
						cancelAction: this.closeTransitionBlocker.bind(this),
						primaryAction: this.closeTransitionBlocker.bind(this),
						primaryButtonLabel: this.state.primaryButtonLabel,
						secondaryButtonLabel: this.state.secondaryButtonLabel,
						secondaryAction: this.transitionFunction.bind(this),
						transitionText: 'You are leaving the Job Request record. Please click on Save first before you exit.'
					}),
					_react2.default.createElement(
						'h1',
						null,
						'Add Documents '
					),
					_react2.default.createElement(
						'h2',
						null,
						'Please provide us with any documents needed. '
					),
					_react2.default.createElement(
						'div',
						{ className: 'documents-container' },
						_react2.default.createElement(
							_c_SourceSimpleFileInput2.default,
							{
								className: 'file-uploader',
								noMessage: true,
								pristineClass: '',
								loadingClass: '',
								successClass: '',
								failureClass: '',
								accept: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'tiff', 'tig', 'txt', 'JPG', 'JPEG', 'jpg', 'jpeg', 'png'],
								remoteFolder: 'contacts/' + this.state.profileId,
								onLoadStart: this.onUploadStart,
								onS3Load: this.onS3Load,
								signingRoute: '/api/s3/put-sign',
								maxSize: ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).AWS_FILE_UPLOAD_SIZE
							},
							_react2.default.createElement(_c_FlatButton2.default, {
								style: addButtonStyle,
								label: 'Attach File'
							})
						)
					),
					(0, _lodash.map)(documentsModel, function (document) {
						return document.softDelete === true ? null : _react2.default.createElement(_DocumentItemView2.default, { 'data-id': 'document-item=-' + document.id, key: document.id, data: document, onChange: _this3.onChangeDocument, onRemove: _this3.onRemoveDocument });
					}),
					_react2.default.createElement(_SubmissionBar2.default, {
						onBack: this.handleBack,
						onNext: this.handleSaveAndNext,
						onSave: this.handleSave
					})
				);
			}
		}]);
	
		return AddDocuments;
	}(_C_ProgressComponentList2.default), _class2.propTypes = {
		user: _react.PropTypes.object,
		checkComplete: _react.PropTypes.func,
		tempState: _react.PropTypes.object,
		documents: _react.PropTypes.array.isRequired,
		dispatch: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(AddDocuments);

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	// import * as companyApi from '../../../../../redux/actionCreators/async/companies';
	// import * as companyStore from '../../../../../redux/actionCreators/sync/companies';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _modelValidator = __webpack_require__(33);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SimpleDropDownMenu = __webpack_require__(121);
	
	var _SimpleDropDownMenu2 = _interopRequireDefault(_SimpleDropDownMenu);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _AdditionalContactModel = __webpack_require__(471);
	
	var _AdditionalContactModel2 = _interopRequireDefault(_AdditionalContactModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addButtonStyle = {
	  width: '165px',
	  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
	};
	
	var AddAdditionalContacts = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    staticData: store.staticData,
	    user: store.user,
	    companyContacts: store.companyContacts
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AddAdditionalContacts, _Component);
	
	  function AddAdditionalContacts(props, context) {
	    _classCallCheck(this, AddAdditionalContacts);
	
	    var _this = _possibleConstructorReturn(this, (AddAdditionalContacts.__proto__ || Object.getPrototypeOf(AddAdditionalContacts)).call(this, props, context));
	
	    _this.state = {
	      dirty: false,
	      submitted: false,
	      errors: [],
	      jobRequest: null
	    };
	
	    _this.AdditionalContactModel = _AdditionalContactModel2.default.getModel();
	    _this.handleDropDownMenuUI = _this.handleDropDownMenuUI.bind(_this);
	    _this.handleUI = _this.handleUI.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.validate = _this.validate.bind(_this);
	    return _this;
	  }
	
	  _createClass(AddAdditionalContacts, [{
	    key: 'handleDropDownMenuUI',
	    value: function handleDropDownMenuUI(prop, menuItems, label) {
	      return {
	        'data-id': prop,
	        value: this.props.contact[prop],
	        menuItems: menuItems,
	        floatingLabelText: label,
	        errorText: this.validate(prop),
	        onChange: this.handleChange(prop),
	        isDirty: this.state.dirty,
	        validation: this.AdditionalContactModel[prop]
	      };
	    }
	  }, {
	    key: 'validate',
	    value: function validate(prop) {
	
	      // if (!this.state.submitted) {
	      //   return;
	      // }
	
	      var message = this.state.errors[0];
	      var validation = (0, _modelValidator.validateField)(this.props.contact[prop], this.AdditionalContactModel[prop]);
	
	      if (prop === 'email' && message && message.search('email') !== -1) {
	        return message;
	      } else {
	        return validation[0];
	      }
	    }
	  }, {
	    key: 'handleUI',
	    value: function handleUI(prop, label) {
	
	      return {
	        'data-id': prop,
	        key: prop + '-' + this.props.contact[prop],
	        defaultValue: this.props.contact[prop],
	        floatingLabelText: label,
	        onBlur: this.handleChange(prop),
	        isDirty: this.state.dirty,
	        errorText: this.validate(prop)
	      };
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this2 = this;
	
	      return function (event, value) {
	        // update contact in parent state
	        _this2.props.handleChange(prop, value);
	
	        // update dirty in local state
	        _this2.setState({ dirty: true });
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'add-additional-contacts' },
	        _react2.default.createElement(
	          'div',
	          { className: 'add-additional-contacts-header' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Add New Reporting Contact'
	          ),
	          _react2.default.createElement(_ModalX2.default, {
	            className: 'close-add-additional-contacts',
	            onClick: this.props.cancel,
	            fill: '#000000'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box-container-fixed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_TextField2.default, this.handleUI('firstName', 'First Name'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_TextField2.default, this.handleUI('lastName', 'Last Name'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_TextField2.default, this.handleUI('title', 'Title'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box-c' },
	              _react2.default.createElement(
	                'div',
	                { className: 'box-i' },
	                _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	                  hideMaskChar: true,
	                  mask: '(999) 999-9999'
	                }, this.handleUI('phoneNumber1', 'Phone Number')))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'box-i' },
	                _react2.default.createElement(_c_TextField2.default, this.handleUI('phoneExtension1', 'Extension'))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_TextField2.default, this.handleUI('email', 'Email Address'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_TextField2.default, this.handleUI('address', 'Address'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_TextField2.default, this.handleUI('city', 'City'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box-c' },
	              _react2.default.createElement(
	                'div',
	                { className: 'box-i' },
	                _react2.default.createElement(_SimpleDropDownMenu2.default, _extends({}, this.handleDropDownMenuUI('state', this.props.staticData.stateList, 'State'), {
	                  underlineStyle: { margin: '-1px 0px' },
	                  iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                  labelStyle: { paddingLeft: '0px' }
	                }))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'box-i' },
	                _react2.default.createElement(_c_TextField2.default, _extends({
	                  type: 'number',
	                  maxLength: '5'
	                }, this.handleUI('zip', 'Zip')))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddAdditionalContacts;
	}(_react.Component), _class2.propTypes = {
	  staticData: _react.PropTypes.object.isRequired,
	  user: _react.PropTypes.object,
	  cancel: _react.PropTypes.func,
	  selectContact: _react.PropTypes.func,
	  companyContacts: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  handleChange: _react.PropTypes.func,
	  contact: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = AddAdditionalContacts;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactRouter = __webpack_require__(51);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _staticData = __webpack_require__(28);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _modelValidator = __webpack_require__(33);
	
	var _SubmissionBar = __webpack_require__(125);
	
	var _SubmissionBar2 = _interopRequireDefault(_SubmissionBar);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _AddAdditionalContacts = __webpack_require__(1019);
	
	var _AddAdditionalContacts2 = _interopRequireDefault(_AddAdditionalContacts);
	
	var _AdditionalContactModel = __webpack_require__(471);
	
	var _AdditionalContactModel2 = _interopRequireDefault(_AdditionalContactModel);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdditionalContacts = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  return {
	    user: store.user,
	    jobId: parseInt(props.params.jobId || 0, 10),
	    jobRequest: store.jobRequest,
	    contacts: store.companyContacts
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AdditionalContacts, _Component);
	
	  function AdditionalContacts(props, context) {
	    _classCallCheck(this, AdditionalContacts);
	
	    var _this = _possibleConstructorReturn(this, (AdditionalContacts.__proto__ || Object.getPrototypeOf(AdditionalContacts)).call(this, props, context));
	
	    _this.add = function (contact) {
	      var companyContacts = _this.props.contacts;
	      var newContact = {
	        user: (0, _lodash.pick)(contact, ['firstName', 'lastName', 'email', 'phoneNumber1', 'phoneExtension1', 'address', 'city', 'state', 'zip']),
	        profile: (0, _lodash.pick)(contact, ['companyId', 'title', 'foundUsVia'])
	      };
	
	      var addContact = function addContact(contactInfo) {
	        return _this.props.dispatch(companyApi.addCompanyContacts(contactInfo));
	      };
	
	      var updateContactsStore = function updateContactsStore(contactInfo) {
	        _this.props.dispatch(companyStore.updateCompanyContacts([].concat(_toConsumableArray(companyContacts), [contactInfo])));
	        return contactInfo;
	      };
	
	      return addContact(newContact).then(updateContactsStore).then(function (newContactInfo) {
	        // instead of select Contact, manually set ID in state in handleSave();
	        // this.selectContact(contactInfo.profile.id);
	        _this.handleSave(newContactInfo);
	      }).catch(function (err) {
	        if (err.errors) {
	          console.log(err, 'Error adding Reporting Contact');
	          _this.setState({ errors: [err.errors[0].errorMessage] });
	        }
	      });
	    };
	
	    _this.handleSave = function (newContactInfo) {
	
	      var newState = (0, _lodash.merge)({}, _this.state);
	      if (newContactInfo) {
	        newState.showAddContact = false;
	        var contactId = newContactInfo.profile.id;
	        newState.jobRequestModel.reportingContactId = contactId;
	      }
	
	      var updateJobRequest = function updateJobRequest(profileId, jobRequest) {
	        return _this.props.dispatch(jobRequestApi.updateJobRequest(profileId, jobRequest));
	      };
	      var updateJobRequestStore = function updateJobRequestStore(jobRequest) {
	        return _this.props.dispatch(jobRequestStore.updateJobRequest(jobRequest));
	      };
	
	      return updateJobRequest(_this.props.user.profileId, (0, _lodash.omit)(newState.jobRequestModel, ['primaryContact'])).then(function () {
	        return updateJobRequestStore(newState.jobRequestModel);
	      }).then(function () {
	        _this.setState({ submitted: true }, function () {
	          _this.props.checkComplete();
	          _this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/authorize'));
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    _this.handleSaveAndNext = function () {
	      if (_this.state.showAddContact) {
	        if (_this.validateForm()) {
	          return;
	        }
	        _this.handleAdd();
	      } else {
	        return _this.handleSave(null);
	      }
	    };
	
	    _this.handleBack = function () {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/workschedule'));
	    };
	
	    _this.handleNew = function () {
	      _this.setState({ showAddContact: true, dirty: true });
	    };
	
	    _this.handleChange = function (event, value) {
	      _this.selectContact(value);
	    };
	
	    _this.closeTransitionBlocker = function () {
	      _this.setState({ showTransitionBlocker: false });
	    };
	
	    _this.transitionFunction = function () {
	      _this.setState({ exitWithoutSubmit: true }, function () {
	        return _this.props.dispatch((0, _reactRouterRedux.push)(_this.state.transitionRoute));
	      });
	    };
	
	    _this.selectContact = function (contactId) {
	      var newState = (0, _lodash.merge)({}, _this.state);
	      newState.showAddContact = false;
	      newState.jobRequestModel.reportingContactId = contactId;
	      _this.setState(_extends({}, newState, { errors: [] }));
	    };
	
	    _this.state = {
	      dirty: false,
	      submitted: false,
	      valid: true,
	      exitWithoutSubmit: false,
	      errors: [],
	      showAddContact: false,
	      showTransitionBlocker: false,
	      jobRequestModel: props.jobRequest,
	      transitionRoute: '',
	      contact: {
	        companyId: props.user.companyId,
	        email: undefined,
	        phoneNumber1: undefined,
	        title: undefined,
	        lastName: undefined,
	        firstName: undefined,
	        workTypeDescription: props.user.workypeDescription,
	        foundUsVia: null,
	        address: undefined,
	        city: undefined,
	        state: undefined,
	        zip: undefined
	      }
	    };
	
	    _this.AdditionalContactModel = _AdditionalContactModel2.default.getModel();
	
	    _this.routeLeaveHook = _this.routeLeaveHook.bind(_this);
	    _this.handleAdd = _this.handleAdd.bind(_this);
	    _this.add = _this.add.bind(_this);
	    _this.handleNewContactChange = _this.handleNewContactChange.bind(_this);
	    _this.validateForm = _this.validateForm.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(AdditionalContacts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.jobRequest) {
	        this.setState({
	          jobRequestModel: nextProps.jobRequest,
	          contacts: nextProps.contacts
	        });
	      }
	    }
	  }, {
	    key: 'routeLeaveHook',
	    value: function routeLeaveHook(location) {
	
	      if (!this.state.dirty || this.state.submitted || this.state.exitWithoutSubmit) {
	        return true;
	      }
	
	      var CreateJobRequestRoute = /\/client\/jobrequest\/(.*)\/?(.*)/;
	      var isLocationInsideCreateJobRequest = CreateJobRequestRoute.test(location.pathname);
	
	      this.setState({
	        primaryButtonLabel: isLocationInsideCreateJobRequest ? 'Stay' : undefined,
	        secondaryButtonLabel: isLocationInsideCreateJobRequest ? 'Leave' : undefined
	      });
	
	      this.setState({
	        showTransitionBlocker: true,
	        transitionRoute: location.pathname
	      });
	
	      return false;
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var validationErrors = (0, _modelValidator.validate)(this.state.contact, this.AdditionalContactModel);
	      var errors = validationErrors.length > 0 ? ['Please fill in all required fields.'] : [];
	      this.setState({ errors: errors });
	      return errors.length > 0;
	    }
	  }, {
	    key: 'handleNewContactChange',
	    value: function handleNewContactChange(prop, value) {
	      var contact = (0, _lodash.merge)({}, this.state.contact);
	      contact[prop] = value;
	      this.setState({ contact: contact, dirty: true });
	    }
	  }, {
	    key: 'handleAdd',
	    value: function handleAdd() {
	      var _this2 = this;
	
	      if (this.state.errors.length > 0) {
	        return false;
	      }
	
	      this.add(this.state.contact).then(function () {
	        return Promise.resolve(true);
	      }).catch(function (err) {
	        var message = (0, _lodash.get)(err, '[0].errorMessage');
	        _this2.setState({ errors: message ? [message] : [] });
	        return Promise.reject(err);
	      });
	    }
	  }, {
	    key: 'contactsToMenuItems',
	    value: function contactsToMenuItems(contacts) {
	      return (0, _lodash.map)(contacts, function (contact) {
	        return {
	          value: contact.profile.id,
	          primaryText: contact.user.firstName + ' ' + contact.user.lastName
	        };
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	
	      var contact = {
	        companyId: this.props.user.companyId,
	        email: undefined,
	        phoneNumber1: undefined,
	        title: undefined,
	        lastName: undefined,
	        firstName: undefined,
	        workTypeDescription: this.props.user.workypeDescription,
	        foundUsVia: null,
	        address: undefined,
	        city: undefined,
	        state: undefined,
	        zip: undefined
	      };
	
	      this.setState({ contact: contact, dirty: false, submitted: false, showAddContact: false, errors: [] });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'additional-contacts' },
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          cancelAction: this.closeTransitionBlocker.bind(this),
	          primaryAction: this.closeTransitionBlocker.bind(this),
	          primaryButtonLabel: this.state.primaryButtonLabel,
	          secondaryAction: this.transitionFunction.bind(this),
	          secondaryButtonLabel: this.state.secondaryButtonLabel,
	          transitionText: 'You are leaving the Job Request record. Please click on Save first before you exit.'
	        }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Reporting Contact '
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Please select your reporting contact for this position or create a new one.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reporting-contact-select-button' },
	          _react2.default.createElement(_c_DropDownMenu2.default, {
	            'data-id': 'Reporting Contact',
	            disabled: this.state.showAddContact,
	            value: this.state.jobRequestModel.reportingContactId,
	            onChange: this.handleChange,
	            className: 'reporting-contact-select',
	            floatingLabelText: 'Reporting Contact',
	            menuItems: (0, _staticData.convertContactsToMenuItems)(this.props.contacts),
	            includeDefault: true
	          }),
	          _react2.default.createElement(_Button2.default, {
	            onClick: this.handleNew,
	            className: 'button-secondary',
	            disabled: !!this.state.showAddContact,
	            label: 'NEW' })
	        ),
	        this.state.showAddContact && _react2.default.createElement(_AddAdditionalContacts2.default, {
	          handleChange: this.handleNewContactChange,
	          selectContact: this.selectContact,
	          contact: this.state.contact,
	          cancel: this.cancel.bind(this),
	          jobId: this.props.jobId
	        }),
	        _react2.default.createElement(_SubmissionBar2.default, {
	          hideBack: true,
	          onBack: this.handleBack,
	          onNext: this.handleSaveAndNext,
	          onSave: this.handleSave,
	          errors: this.state.errors,
	          showError: this.state.dirty
	        })
	      );
	    }
	  }]);
	
	  return AdditionalContacts;
	}(_react.Component), _class2.propTypes = {
	  user: _react.PropTypes.object,
	  checkComplete: _react.PropTypes.func,
	  jobRequest: _react.PropTypes.object,
	  params: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(AdditionalContacts);

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addButtonStyle = {
		style: {
			width: '70px',
			display: 'inline-block',
			transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1)',
			border: '0px '
		},
		hoverStyle: {
			border: '0px'
		}
	};
	
	var DocumentItemView = (_temp = _class = function (_Component) {
		_inherits(DocumentItemView, _Component);
	
		function DocumentItemView(props, context) {
			_classCallCheck(this, DocumentItemView);
	
			return _possibleConstructorReturn(this, (DocumentItemView.__proto__ || Object.getPrototypeOf(DocumentItemView)).call(this, props, context));
		}
	
		_createClass(DocumentItemView, [{
			key: 'render',
			value: function render() {
				var _ref = this.props || [],
				    data = _ref.data,
				    onRemove = _ref.onRemove,
				    _onChange = _ref.onChange;
	
				return _react2.default.createElement(
					'div',
					{ className: 'document-item-view' },
					_react2.default.createElement(
						'div',
						{ className: 'document-item-view-filename' },
						_react2.default.createElement(_c_TextField2.default, {
							'data-id': 'document filename',
							disabled: true,
							style: { width: 'calc(100% - 14px)' },
							floatingLabelText: 'File Name',
							value: data.fileName,
							inputStyle: {
								textOverflow: 'ellipsis',
								maxWidth: '76%',
								color: '#777'
							}
						}),
						_react2.default.createElement(
							'span',
							{ className: 'megabyte-count' },
							Math.max(Math.round(data.fileSize / 100000) / 10, 0.1) + ' Mgb'
						)
					),
					_react2.default.createElement(_c_TextField2.default, {
						'data-id': 'document description',
						floatingLabelText: 'Description',
						value: data.description,
						inputStyle: { fontSize: '14px' },
						style: { width: 'calc(59% - 40px)' },
						onChange: function onChange(e, value) {
							return _onChange(value, data);
						}
					}),
					_react2.default.createElement(
						'div',
						{ className: 'remove-button-container' },
						_react2.default.createElement(_c_FlatButton2.default, _extends({}, addButtonStyle, { onClick: function onClick(e) {
								return onRemove(data);
							}, label: 'Remove' }))
					)
				);
			}
		}]);
	
		return DocumentItemView;
	}(_react.Component), _class.propTypes = {
		data: _react.PropTypes.object,
		onChange: _react.PropTypes.func.isRequired,
		onRemove: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = DocumentItemView;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _f_InfoModal = __webpack_require__(122);
	
	var _f_InfoModal2 = _interopRequireDefault(_f_InfoModal);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _SubmissionBar = __webpack_require__(125);
	
	var _SubmissionBar2 = _interopRequireDefault(_SubmissionBar);
	
	var _companies = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ACTIVE_ACCOUNT = 4;
	
	var JobRequestAuthorize = (_dec = (0, _reactRedux.connect)(function (store) {
		return {
			staticData: store.staticData,
			user: store.user,
			jobRequest: store.jobRequest,
			company: store.company,
			labels: store.labels.jobRequest.authorize || {}
		};
	}), _dec(_class = (_temp = _class2 = function (_Component) {
		_inherits(JobRequestAuthorize, _Component);
	
		function JobRequestAuthorize(props, context) {
			_classCallCheck(this, JobRequestAuthorize);
	
			var _this = _possibleConstructorReturn(this, (JobRequestAuthorize.__proto__ || Object.getPrototypeOf(JobRequestAuthorize)).call(this, props, context));
	
			_this.handleBack = function () {
				_this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobRequest.id || 0) + '/addcontact'));
			};
	
			_this.handleSubmit = function () {
	
				var company = _this.props.company;
				var updateCompanyStatus = function updateCompanyStatus() {
					return _this.props.dispatch(companyStore.updateCompany(_extends({}, company, { companyStatus: ACTIVE_ACCOUNT })));
				};
				var authorizeJR = function authorizeJR(userId, jobId, success) {
					return _this.props.dispatch(jobRequestApi.authorizeJobRequest(userId, jobId, { success: success }));
				};
	
				authorizeJR(_this.props.user.id, _this.props.jobRequest.id, function () {
					_this.setState({ showSuccess: true, submitted: true });
					updateCompanyStatus();
				});
			};
	
			_this.signature = function () {
				return [(0, _lodash.get)(_this.props, 'user.firstName'), (0, _lodash.get)(_this.props, 'user.middleName'), (0, _lodash.get)(_this.props, 'user.lastName')].map(_lodash.trim).filter(function (part) {
					return !(0, _lodash.isNil)(part) && !(0, _lodash.isEmpty)(part);
				}).join(' ');
			};
	
			_this.state = {
				isDirty: false,
				showSuccess: false,
				submitted: false
			};
	
			return _this;
		}
	
		_createClass(JobRequestAuthorize, [{
			key: 'closeModal',
			value: function closeModal() {
				this.setState((0, _lodash.merge)(this.state, { showSuccess: false }));
			}
		}, {
			key: 'handleChange',
			value: function handleChange(event) {
				var regexp = new RegExp(this.signature(), 'gi');
				var errorText = !regexp.test(event.target.value) ? 'Please sign with the name provided.' : undefined;
	
				this.setState({ errorText: errorText, isDirty: true });
			}
		}, {
			key: 'handleUI',
			value: function handleUI(prop, label) {
	
				if (this.props.jobRequest.dateAuthorized && prop === 'signature') {
					return {
						value: this.signature(),
						ref: prop,
						'data-id': prop,
						errorText: this.state.errorText,
						floatingLabelText: label || null
					};
				}
	
				return {
					ref: prop,
					'data-id': prop,
					errorText: this.state.errorText,
					floatingLabelText: label || null
				};
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var sectionNames = {
					description: 'Job Description',
					adddocuments: 'Add Documents',
					skills: 'Skills',
					summary: 'Summary Of Skills',
					workschedule: 'Work Schedule'
	
				};
	
				var sections = (0, _lodash.omit)(this.props.completed, ['addcontact', 'adddocuments']);
				var completed = (0, _lodash.map)(sections, function (value, key) {
					return { name: sectionNames[key], valid: value };
				});
				var isCompleted = (0, _lodash.reduce)(completed, function (acc, section) {
					return acc && section.valid;
				}, true);
				var companyStatus = (0, _lodash.get)(this.props.company, 'companyStatus');
				var isActiveAccount = companyStatus === ACTIVE_ACCOUNT;
				var canSubmit = isCompleted && this.state.isDirty && !this.state.submitted && !this.state.errorText;
	
				var _get = (0, _lodash.get)(this.props, 'labels', {}),
				    _get$successfulInitia = _get.successfulInitial,
				    successfulInitial = _get$successfulInitia === undefined ? '' : _get$successfulInitia,
				    _get$successfulAdditi = _get.successfulAdditional,
				    successfulAdditional = _get$successfulAdditi === undefined ? '' : _get$successfulAdditi;
	
				var successText = isActiveAccount ? successfulAdditional : successfulInitial;
	
				return _react2.default.createElement(
					'div',
					{ className: 'job-request-authorize' },
					this.state.showSuccess && _react2.default.createElement(_f_InfoModal2.default, {
						cancelFunc: this.closeModal.bind(this),
						buttonLabel: 'close',
						transitionFunc: function transitionFunc() {
							return _this2.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequesthistory'));
						},
						text: successText
					}),
					_react2.default.createElement(
						'h1',
						null,
						' Terms and Conditions, Authorize & Submit'
					),
					_react2.default.createElement('div', { className: 'terms-section', dangerouslySetInnerHTML: { __html: this.props.labels.authorizeText } }),
					!isCompleted && !this.state.submitted && _react2.default.createElement(
						'div',
						{ className: 'invalid-sections' },
						'The following section(s) have not been completed. Please complete in order to authorize and submit.',
						_react2.default.createElement(
							'ul',
							{ className: 'sections' },
							completed.filter(function (section) {
								return section.valid === false;
							}).map(function (section) {
								return _react2.default.createElement(
									'li',
									null,
									section.name
								);
							})
						)
					),
					_react2.default.createElement(
						'p',
						{ className: 'signature-label' },
						'By typing your name in the Signature, you are agreeing to the Terms and Conditions and authorizing this Job Request.'
					),
					_react2.default.createElement(_c_TextField2.default, _extends({ className: 'center-column-1 terms-signature'
					}, this.handleUI('signature', 'Signature'), {
						onChange: this.handleChange.bind(this),
						disabled: this.props.jobRequest.dateAuthorized,
						subText: this.signature()
					})),
					_react2.default.createElement(_c_TextField2.default, {
						className: 'center-column-1',
						disabled: true,
						defaultValue: this.props.jobRequest.dateAuthorized ? new Date(this.props.jobRequest.dateAuthorized).toDateString() : new Date().toDateString(),
						floatingLabelText: 'Date Signed',
						'data-id': 'Date Signed'
					}),
					!this.props.jobRequest.dateAuthorized && _react2.default.createElement(_SubmissionBar2.default, {
						onBack: this.handleBack,
						onNext: this.handleSubmit,
						onSave: null,
						submitDisabled: !canSubmit,
						hideBack: true,
						finalStep: true
					})
				);
			}
		}]);
	
		return JobRequestAuthorize;
	}(_react.Component), _class2.propTypes = {
		staticData: _react.PropTypes.object.isRequired,
		user: _react.PropTypes.object,
		jobRequest: _react.PropTypes.object,
		completed: _react.PropTypes.object,
		params: _react.PropTypes.object,
		dispatch: _react.PropTypes.func.isRequired,
		company: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = JobRequestAuthorize;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(51);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _jobRequest = __webpack_require__(208);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _SubmissionBar = __webpack_require__(125);
	
	var _SubmissionBar2 = _interopRequireDefault(_SubmissionBar);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestDescription = (_dec = (0, _reactRedux.connect)(function (store, props) {
		return {
			staticData: store.staticData,
			user: store.user,
			jobRequest: store.jobRequest,
			jobId: parseInt(props.params.jobId || 0, 10)
		};
	}), _dec(_class = (_temp = _class2 = function (_Component) {
		_inherits(JobRequestDescription, _Component);
	
		function JobRequestDescription(props, context) {
			_classCallCheck(this, JobRequestDescription);
	
			var _this = _possibleConstructorReturn(this, (JobRequestDescription.__proto__ || Object.getPrototypeOf(JobRequestDescription)).call(this, props, context));
	
			_this.save = function (clientId, jobRequestModel) {
	
				var updateJobRequest = _this.props.dispatch(jobRequestApi.updateJobRequest(clientId, jobRequestModel));
				return updateJobRequest.then(function () {
	
					// update store.
	
					var updatedJobRequestStore = (0, _lodash.cloneDeep)(_this.props.jobRequest);
					updatedJobRequestStore.description = _this.getJobDescriptionValue();
					_this.props.dispatch(jobRequestStore.updateJobRequest(_extends({}, _this.state.jobRequestModel)));
				});
			};
	
			_this.handleSave = function (event, cb) {
	
				_this.setState({ submitted: true }, function () {
					if (!_this.isJobDescriptionFilled()) return;
	
					_this.save(_this.state.clientId, _this.state.jobRequestModel).then(function () {
						return _this.setState({ stateSaved: true }, cb);
					});
				});
			};
	
			_this.handleSaveAndNext = function (event) {
	
				_this.setState({ submitted: true }, function () {
					_this.handleSave(event, function () {
						_this.props.checkComplete();
						_this.gotoNextScreen();
					});
				});
			};
	
			_this.gotoNextScreen = function () {
				_this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/adddocuments'));
			};
	
			_this.handleBack = function (event) {
				_this.setState({ submitted: true }, function () {
					if (!_this.isJobDescriptionFilled()) return;
					_this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0)));
				});
			};
	
			_this.closeTransitionBlocker = function () {
				_this.setState((0, _lodash.merge)({}, _this.state, { showTransitionBlocker: false }));
			};
	
			_this.transitionFunction = function () {
				_this.setState({ stateSaved: true }, function () {
					return _this.props.dispatch((0, _reactRouterRedux.push)(_this.state.transitionRoute));
				});
			};
	
			_this.state = {
				clientId: _this.props.user.profileId,
				submitted: false, // save and next.
				jobRequest: null,
				jobRequestModel: {
					id: _this.props.jobId,
					primaryContactId: _this.props.user.profileId,
					description: (0, _lodash.get)(props.jobRequest, 'description') || ''
				},
				showTransitionBlocker: false,
				transitionRoute: '',
				stateSaved: true
			};
	
			_this.isJobDescriptionFilled = _this.isJobDescriptionFilled.bind(_this);
			_this.getJobDescriptionValue = _this.getJobDescriptionValue.bind(_this);
	
			return _this;
		}
	
		_createClass(JobRequestDescription, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				this.props.router.setRouteLeaveHook(this.props.route, function (location) {
	
					var jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;
	
					if (jobRequestSteps.test(location.pathname)) {
						_this2.state.primaryButtonLabel = 'Stay';
						_this2.state.secondaryButtonLabel = 'Leave';
					} else {
						_this2.state.primaryButtonLabel = undefined;
						_this2.state.secondaryButtonLabel = undefined;
					}
	
					if (!_this2.state.stateSaved) {
						_this2.setState((0, _lodash.merge)({}, _this2.state, { showTransitionBlocker: true, transitionRoute: location.pathname }));
						return _this2.state.stateSaved;
					} else {
						return true;
					}
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.jobRequest) {
					this.state.jobRequestModel.description = (0, _lodash.get)(nextProps.jobRequest, 'description');
					this.setState((0, _lodash.merge)({}, this.state));
				}
			}
		}, {
			key: 'getJobDescriptionValue',
			value: function getJobDescriptionValue() {
				return (0, _lodash.get)(this.state.jobRequestModel, 'description') || '';
			}
		}, {
			key: 'getCount',
			value: function getCount(str) {
				return str.split(' ').filter(function (num) {
					return num !== '';
				}).length;
			}
		}, {
			key: 'isJobDescriptionFilled',
			value: function isJobDescriptionFilled() {
				return this.getCount(this.getJobDescriptionValue()) >= 100;
			}
		}, {
			key: 'handleChange',
			value: function handleChange(prop) {
				var _this3 = this;
	
				return function (event, value, primaryText) {
					var jobRequest = _this3.state.jobRequestModel;
					jobRequest[prop] = value;
					_this3.setState({ stateSaved: false });
				};
			}
		}, {
			key: 'render',
			value: function render() {
				var jobSummaryDescription = 'Description';
				var errorText = this.state.submitted && !this.isJobDescriptionFilled() && 'This field is required and must be 100 words minimum.';
	
				return _react2.default.createElement(
					'div',
					{ className: 'job-request-description' },
					this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
						cancelAction: this.closeTransitionBlocker.bind(this),
						primaryAction: this.closeTransitionBlocker.bind(this),
						primaryButtonLabel: this.state.primaryButtonLabel,
						secondaryAction: this.transitionFunction.bind(this),
						secondaryButtonLabel: this.state.secondaryButtonLabel,
						transitionText: 'You are leaving the Job Request record. Please click on Save first before you exit.'
					}),
					_react2.default.createElement(
						'h1',
						null,
						' Job Description '
					),
					_react2.default.createElement(
						'h2',
						null,
						'Please provide us with a job description for the position. You can copy and paste an existing Job Description into this field. You can also add additional supporting documents. '
					),
					_react2.default.createElement(
						'div',
						null,
						'Please include at a minimum, one paragraph position description, and five (5) daily job functions.  There is a minimum 100 word count requirement.'
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement('br', null),
					_react2.default.createElement(_c_TextArea2.default, {
						style: { minHeight: '295px' },
						description: jobSummaryDescription,
						value: (0, _lodash.get)(this.state.jobRequestModel, 'description'),
						onChange: this.handleChange('description'),
						isDirty: true,
						errorText: errorText
					}),
					_react2.default.createElement(
						'span',
						null,
						'(100 words minimum, current word count is ',
						this.getCount((0, _lodash.get)(this.state.jobRequestModel, 'description')),
						')'
					),
					_react2.default.createElement(_SubmissionBar2.default, {
						onBack: this.handleBack,
						onNext: this.handleSaveAndNext,
						onSave: this.handleSave
					})
				);
			}
		}]);
	
		return JobRequestDescription;
	}(_react.Component), _class2.propTypes = {
		staticData: _react.PropTypes.object.isRequired,
		user: _react.PropTypes.object,
		checkComplete: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(JobRequestDescription);

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = NextStepBlocker;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// utilities
	var flatButtonStyle = {
	  width: '296px',
	  height: '41px',
	  marginRight: '25px'
	};
	
	// material
	
	
	// components
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var flatButtonLabelStyle = {
	  fontSize: '12px',
	  transform: 'translateY(-.5px)',
	  top: 0
	};
	
	function NextStepBlocker(props) {
	  var text = props.transitionText ? props.transitionText : ['You have not completed the required fields needed to save. <br/>  If you exit the page now you will lose the information that hasn\u2019t been saved.'];
	  return _react2.default.createElement(
	    _r_Modal2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'next-step-blocker' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { className: 'prompt-text',
	          dangerouslySetInnerHTML: { __html: text } }),
	        _react2.default.createElement(_c_RaisedButton2.default, {
	          label: 'Close',
	          onClick: props.cancelFunc
	        })
	      ),
	      _react2.default.createElement(_ModalX2.default, { onClick: props.cancelFunc })
	    ),
	    _react2.default.createElement('div', { className: 'rectangle-behind-modal-form absolute-center' })
	  );
	}
	
	NextStepBlocker.propTypes = {
	  transitionFunc: _react.PropTypes.func,
	  cancelFunc: _react.PropTypes.func,
	  transitionText: _react.PropTypes.text
	};

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(51);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _jobrequestDocuments = __webpack_require__(236);
	
	var jobRequestDocumentsApi = _interopRequireWildcard(_jobrequestDocuments);
	
	var _jobRequest = __webpack_require__(208);
	
	var _modelValidator = __webpack_require__(33);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _SubmissionBar = __webpack_require__(125);
	
	var _SubmissionBar2 = _interopRequireDefault(_SubmissionBar);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _NextStepBlocker = __webpack_require__(1024);
	
	var _NextStepBlocker2 = _interopRequireDefault(_NextStepBlocker);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _parentChildList = __webpack_require__(169);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var yesNo = [{ value: true, primaryText: 'Yes', subElement: 'localJobDetails' }, { value: false, primaryText: 'No', subElement: null }];
	
	var addressSchema = {
	  position: {
	    city: {
	      required: {
	        message: 'This field is required.'
	      }
	    },
	    state: {
	      required: {
	        message: 'This field is required.'
	      }
	    }
	  }
	};
	
	var PositionInfo = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    staticData: state.staticData,
	    user: state.user,
	    contactProfile: state.contactProfile,
	    jobRequest: state.jobRequest,
	    documents: state.jobRequestDocuments.documents,
	    labels: (0, _lodash.get)(state, 'labels.jobRequest.position', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PositionInfo, _Component);
	
	  function PositionInfo(props, context) {
	    _classCallCheck(this, PositionInfo);
	
	    var _this = _possibleConstructorReturn(this, (PositionInfo.__proto__ || Object.getPrototypeOf(PositionInfo)).call(this, props, context));
	
	    _this.isFromDifferentOffice = function () {
	      return (0, _lodash.get)(_this.state, 'jobRequestModel.fromDifferentOffice', false);
	    };
	
	    _this.handleSubmit = function (doNext) {
	
	      var schema = _this.jobRequestSchema()['position'];
	      var errors = doNext ? (0, _modelValidator.validate)(_this.state.jobRequestModel, schema) : [];
	
	      if (errors.length > 0) {
	        _this.setState({ isDirty: true });
	      } else {
	
	        _this.setState({ canSubmit: false });
	        var positionInfo = (0, _lodash.pick)(_this.state.jobRequestModel, _this.positionInfoFields);
	
	        if (_this.props.location.query.hasOwnProperty('clone')) {
	          _this.clone(_this.state.clientId, positionInfo, _this.state.jobRequestModel, doNext);
	          return;
	        }
	
	        if (_this.props.params.jobId === 0 || _this.props.params.jobId === undefined) {
	          _this.props.dispatch(jobRequestApi.createJobRequest(_this.state.clientId, positionInfo, _this.submitCallback(doNext)));
	        } else {
	          _this.props.dispatch(jobRequestApi.updateJobRequest(_this.state.clientId, positionInfo, _this.submitCallback(doNext)));
	        }
	        _this.setState({ stateSaved: true, canSubmit: true });
	      }
	    };
	
	    _this.closeTransitionBlocker = function () {
	      _this.setState((0, _lodash.merge)({}, _this.state, { showTransitionBlocker: false, showNextStepBlocker: false }));
	    };
	
	    _this.transitionFunction = function () {
	      _this.setState({ stateSaved: true }, function () {
	        return _this.props.dispatch((0, _reactRouterRedux.push)(_this.state.transitionRoute));
	      });
	    };
	
	    _this.handleUI = _this.handleUI.bind(_this);
	    _this.handleUIDropdown = _this.handleUIDropdown.bind(_this);
	
	    _this.handleChange = _this.handleChange.bind(_this);
	
	    _this.state = {
	      clientId: _this.props.user.profileId,
	      jobRequestModel: {},
	      isDirty: false,
	      showTransitionBlocker: false,
	      showNextStepBlocker: false,
	      transitionRoute: '',
	      stateSaved: true,
	      primaryButtonLabel: undefined,
	      secondaryButtonLabel: undefined,
	      canSubmit: true
	    };
	
	    _this.positionInfoFields = ['id', 'primaryContactId', 'industryTypeId', 'segmentTypeId', 'positionTypeId', 'licenseRequired', 'dualMonitorsRequired', 'outsideContactRequired', 'numberOfPeople', 'fromDifferentOffice', 'companyName', 'address', 'address2', 'city', 'state', 'zip', 'segmentOther', 'industryOther'];
	
	    _this.parentChildHandlers = (0, _parentChildList.parentChildList)();
	
	    return _this;
	  }
	
	  _createClass(PositionInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if ((0, _lodash.isEmpty)(this.state.jobRequestModel) && !(0, _lodash.isEmpty)(this.props.jobRequest)) {
	        this.setState((0, _lodash.assign)({}, this.state, { jobRequestModel: this.props.jobRequest }));
	      }
	
	      this.props.router.setRouteLeaveHook(this.props.route, function (location) {
	
	        var newJobRequestSteps = /\/client\/jobrequest\/0\/(.*)/;
	        var savedJobRequestSteps = /\/client\/jobrequest\/(.*)\/(.*)/;
	        var errors = (0, _modelValidator.validate)(_this2.state.jobRequestModel, (0, _jobRequest.getSchema)()['position']);
	
	        if (savedJobRequestSteps.test(location.pathname)) {
	          _this2.state.primaryButtonLabel = 'Stay';
	          _this2.state.secondaryButtonLabel = 'Leave';
	        } else {
	          _this2.state.primaryButtonLabel = undefined;
	          _this2.state.secondaryButtonLabel = undefined;
	        }
	
	        if (newJobRequestSteps.test(location.pathname)) {
	          _this2.setState((0, _lodash.merge)({}, _this2.state, { showTransitionBlocker: false, showNextStepBlocker: true, transitionRoute: location.pathname }));
	          return false;
	        } else if (!_this2.state.stateSaved) {
	          _this2.setState((0, _lodash.merge)({}, _this2.state, { showTransitionBlocker: true, showNextStepBlocker: false, transitionRoute: location.pathname }));
	          return _this2.state.stateSaved;
	        }
	
	        if (savedJobRequestSteps.test(location.pathname) && errors.length > 0) {
	          _this2.setState({ isDirty: true });
	          return false;
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.jobRequest) {
	        this.setState((0, _lodash.assign)({}, this.state, { jobRequestModel: nextProps.jobRequest }));
	      }
	    }
	  }, {
	    key: 'jobRequestSchema',
	    value: function jobRequestSchema() {
	      var _this3 = this;
	
	      var schema = (0, _lodash.cloneDeep)((0, _jobRequest.getSchema)());
	      if (this.isFromDifferentOffice()) {
	        schema = (0, _lodash.merge)({}, schema, (0, _lodash.cloneDeep)(addressSchema));
	      }
	      if (this.props.labels) {
	        (0, _lodash.forEach)(this.props.labels, function (val, key) {
	          if (!_this3.props.labels[key]) delete schema.position[key];
	        });
	      }
	
	      schema = this.industryOtherSchema(schema);
	      schema = this.segmentOtherSchema(schema);
	      return schema;
	    }
	  }, {
	    key: 'segmentOtherSchema',
	    value: function segmentOtherSchema(schema) {
	      var segmentTypes = (0, _lodash.get)(this.props.staticData, 'jobRequestSegmentTypes');
	      var otherSegmentType = (0, _lodash.get)((0, _lodash.find)(segmentTypes, { name: 'Other' }), 'id');
	      if (!!(this.state.jobRequestModel.segmentTypeId && this.state.jobRequestModel.segmentTypeId === otherSegmentType)) {
	        schema = (0, _lodash.merge)({}, schema, {
	          position: {
	            segmentOther: {
	              required: {
	                message: 'This field is required'
	              }
	            }
	          }
	        });
	      }
	      return schema;
	    }
	  }, {
	    key: 'industryOtherSchema',
	    value: function industryOtherSchema(schema) {
	      var industryTypes = (0, _lodash.get)(this.props.staticData, 'industryTypesList');
	      var otherIndustryType = (0, _lodash.get)((0, _lodash.find)(industryTypes, { name: 'Other' }), 'id');
	      if (!!(this.state.jobRequestModel.industryTypeId && this.state.jobRequestModel.industryTypeId === otherIndustryType)) {
	        schema = (0, _lodash.merge)({}, schema, {
	          position: {
	            industryOther: {
	              required: {
	                message: 'This field is required'
	              }
	            }
	          }
	        });
	      }
	      return schema;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(prop) {
	      var _this4 = this;
	
	      return function (event, value) {
	        var jobRequest = _this4.state.jobRequestModel;
	        jobRequest[prop] = value;
	        _this4.setState((0, _lodash.merge)({}, _this4.state, { jobRequestModel: jobRequest, stateSaved: false, isDirty: true }));
	      };
	    }
	  }, {
	    key: 'handleOfficeChange',
	    value: function handleOfficeChange() {
	      var _this5 = this;
	
	      return function (event, value) {
	        var _merge = (0, _lodash.merge)({}, _this5.state),
	            _merge$jobRequestMode = _merge.jobRequestModel,
	            jobRequestModel = _merge$jobRequestMode === undefined ? {} : _merge$jobRequestMode;
	
	        jobRequestModel['fromDifferentOffice'] = value;
	        if (!value) {
	          ['city', 'state', 'address', 'address2', 'zip'].forEach(function (prop) {
	            return jobRequestModel[prop] = null;
	          });
	        }
	        _this5.setState((0, _lodash.merge)({}, _this5.state, { jobRequestModel: jobRequestModel, stateSaved: false, isDirty: true }));
	      };
	    }
	  }, {
	    key: 'handleUI',
	    value: function handleUI(prop, label) {
	
	      var errorText = this.state.isDirty && this.jobRequestSchema().position[prop] !== undefined ? (0, _modelValidator.validateField)(this.state.jobRequestModel[prop], this.jobRequestSchema().position[prop])[0] : undefined;
	
	      return {
	        'data-id': prop,
	        value: this.state.jobRequestModel[prop],
	        errorText: errorText,
	        onChange: this.handleChange(prop),
	        floatingLabelText: label || null,
	        isDirty: this.state.isDirty
	      };
	    }
	  }, {
	    key: 'handleUIDropdown',
	    value: function handleUIDropdown(prop, label, menuItems) {
	      var byName = function byName(item1, item2) {
	        return item1.name.localeCompare(item2.name);
	      };
	
	      return _extends({
	        menuItems: menuItems.sort(byName)
	      }, this.handleUI(prop, label));
	    }
	  }, {
	    key: 'handleOfficeUI',
	    value: function handleOfficeUI(prop, label) {
	      return (0, _lodash.merge)({}, this.handleUI(prop, label), { onChange: this.handleOfficeChange() });
	    }
	  }, {
	    key: 'submitCallback',
	    value: function submitCallback(doNext) {
	      var _this6 = this;
	
	      return {
	        success: function success(data) {
	          var jobId = _this6.state.jobRequestModel.id || data[0].id;
	
	          // update store
	          if (data[0]) {
	
	            var positionInfo = (0, _lodash.pick)(_extends({}, data[0]), _this6.positionInfoFields);
	            var jobRequest = (0, _lodash.merge)(positionInfo, _extends({}, _this6.state.jobRequestModel));
	
	            _this6.props.dispatch(jobRequestStore.updateJobRequest(jobRequest));
	          } else {
	            _this6.props.dispatch(jobRequestStore.updateJobRequest(_extends({}, _this6.state.jobRequestModel)));
	          }
	          _this6.props.checkComplete();
	          _this6.props.dispatch((0, _reactRouterRedux.push)(doNext ? '/client/jobRequest/' + jobId + '/description' : '/client/jobRequest/' + jobId));
	        }
	      };
	    }
	  }, {
	    key: 'clone',
	    value: function clone(primaryContactId, positionInfo, jobrequest, doNext) {
	      var _this7 = this;
	
	      // Create.
	      var createJobRequest = function createJobRequest() {
	        return _this7.props.dispatch(jobRequestApi.createJobRequest(primaryContactId, positionInfo));
	      };
	
	      // Save.
	      var updateJobRequest = function updateJobRequest(jobId) {
	        var jobrequestFiltered = (0, _lodash.omit)(jobrequest, ['id', 'primaryContact', 'clone', 'jobRequestStatus', 'contact', 'dateCreated', 'dateModified', 'dateAuthorized', 'dateLastExported', 'crmEntityId', 'payRate', 'billRate', 'placementSpecialistId']);
	        return _this7.props.dispatch(jobRequestApi.updateJobRequest(primaryContactId, _extends({ id: jobId }, jobrequestFiltered)));
	      };
	
	      // Save Documents.
	      var saveNewDocument = function saveNewDocument(jobId, document) {
	
	        var clientId = '' + jobrequest.id + _shortid2.default.generate();
	        _this7.props.dispatch(jobRequestDocumentsApi.createJobRequestDocuments(_this7.props.user.profileId, _extends({}, document, { jobId: jobId, clientId: clientId })));
	      };
	
	      createJobRequest().then(function (resp) {
	        jobrequest.id = resp[0].id;
	        _this7.props.documents.map(function (document) {
	          return saveNewDocument(jobrequest.id, document);
	        });
	        return updateJobRequest(resp[0].id);
	      }).then(function () {
	        _this7.setState({ stateSaved: true }, function () {
	          _this7.props.dispatch(jobRequestStore.updateJobRequest(jobrequest));
	          _this7.props.checkComplete();
	          _this7.props.dispatch((0, _reactRouterRedux.push)(doNext ? '/client/jobRequest/' + jobrequest.id + '/description' : '/client/jobRequest/' + jobrequest.id));
	        });
	      }).catch(function (err) {
	        _this7.setState({ canSubmit: true });
	        return console.error('Unable to clone', err);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var isInNewRequestStatus = this.props.jobRequest.jobRequestStatus === 2 && !this.props.location.query.hasOwnProperty('clone') ? true : false;
	
	      var _parentChildHandlers = this.parentChildHandlers({
	        parentProps: this.handleUIDropdown('industryTypeId', undefined, this.props.staticData.industryTypesList),
	        childProps: this.handleUIDropdown('segmentTypeId', undefined, this.props.staticData.jobRequestSegmentTypes)
	      }),
	          industryTypeProps = _parentChildHandlers.parent,
	          segmentTypeProps = _parentChildHandlers.child;
	
	      var segmentTypes = (0, _lodash.get)(this.props.staticData, 'jobRequestSegmentTypes');
	      var otherSegmentType = (0, _lodash.get)((0, _lodash.find)(segmentTypes, { name: 'Other' }), 'id');
	      var industryTypes = (0, _lodash.get)(this.props.staticData, 'industryTypesList');
	      var otherIndustryType = (0, _lodash.get)((0, _lodash.find)(industryTypes, { name: 'Other' }), 'id');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'position-info' },
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          cancelAction: this.closeTransitionBlocker.bind(this),
	          primaryAction: this.closeTransitionBlocker.bind(this),
	          primaryButtonLabel: this.state.primaryButtonLabel,
	          secondaryAction: this.transitionFunction.bind(this),
	          secondaryButtonLabel: this.state.secondaryButtonLabel,
	          transitionText: 'You are leaving the Job Request record. Please click on Save first before you exit.'
	        }),
	        this.state.showNextStepBlocker && _react2.default.createElement(_NextStepBlocker2.default, {
	          cancelFunc: this.closeTransitionBlocker.bind(this),
	          transitionText: 'You are leaving the Job Request record. Please click on Save first before you exit.'
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Position Information'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                this.props.labels.industryTypeId
	              ),
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                'data-id': 'question-dropdown-industry-type'
	              }, industryTypeProps, {
	                disabled: isInNewRequestStatus
	              })),
	              this.props.labels.industryTypeIdSubText && _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                this.props.labels.industryTypeIdSubText
	              )
	            ),
	            !!(this.state.jobRequestModel.industryTypeId && this.state.jobRequestModel.industryTypeId === otherIndustryType) && _react2.default.createElement(
	              'div',
	              { className: 'field other' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                'If other, please specify'
	              ),
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                floatingLabelText: 'Firm type Other'
	              }, { required: { message: 'This field is required' } }, this.handleUI('industryOther')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                this.props.labels.segmentTypeId
	              ),
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                'data-id': 'question-dropdown-segment-type',
	                disabled: isInNewRequestStatus
	              }, segmentTypeProps)),
	              this.props.labels.segmentTypeIdSubText && _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                this.props.labels.segmentTypeIdSubText
	              )
	            ),
	            !!(this.state.jobRequestModel.segmentTypeId && this.state.jobRequestModel.segmentTypeId === otherSegmentType) && _react2.default.createElement(
	              'div',
	              { className: 'field other' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                'If other, please specify'
	              ),
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                floatingLabelText: 'Industry Segment Other'
	              }, this.handleUI('segmentOther')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                this.props.labels.positionTypeId
	              ),
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                'data-id': 'question-dropdown-position-type',
	                disabled: isInNewRequestStatus
	              }, this.handleUI('positionTypeId'), {
	                menuItems: this.props.staticData.positionTypes,
	                underlineStyle: { margin: '-1px 0px' },
	                iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                labelStyle: { paddingLeft: '0px' }
	              }))
	            ),
	            this.props.labels.licenseRequired && _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                this.props.labels.licenseRequired
	              ),
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.handleUI('licenseRequired')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                'Does the job require use of dual monitors?'
	              ),
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.handleUI('dualMonitorsRequired')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                'Does the job require phone contact with people outside the company?'
	              ),
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.handleUI('outsideContactRequired')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                'Number of people for this type of work'
	              ),
	              _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('numberOfPeople'), {
	                type: 'number',
	                min: '1'
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'div',
	                { className: 'label' },
	                'Is this job opening for a different office from your office?'
	              ),
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.handleOfficeUI('fromDifferentOffice')))
	            )
	          )
	        ),
	        this.isFromDifferentOffice() && _react2.default.createElement(
	          'div',
	          { className: 'form-extra-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('companyName', 'Company Name'), {
	              disabled: true,
	              floatingLabelFixed: true,
	              defaultValue: this.props.contactProfile.company.name
	            }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelFixed: true }, this.handleUI('address', 'Address')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelFixed: true }, this.handleUI('address2', 'Address Line 2')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelFixed: true }, this.handleUI('city', 'City')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              canAutoPosition: true
	            }, this.handleUI('state', 'State'), {
	              floatingLabelFixed: true,
	              menuItems: this.props.staticData.stateList,
	              underlineStyle: { margin: '-1px 0px' },
	              iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	              labelStyle: { paddingLeft: '0px' }
	            }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelFixed: true }, this.handleUI('zip', 'Zip')))
	          )
	        ),
	        _react2.default.createElement(_SubmissionBar2.default, {
	          onNext: function onNext() {
	            return _this8.handleSubmit(true);
	          },
	          onSave: function onSave() {
	            return _this8.handleSubmit(false);
	          },
	          submitDisabled: !this.state.canSubmit
	        })
	      );
	    }
	  }]);
	
	  return PositionInfo;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  user: _react.PropTypes.object,
	  jobRequest: _react.PropTypes.object,
	  contactProfile: _react.PropTypes.object,
	  checkComplete: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  route: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  documents: _react.PropTypes.array,
	  labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(PositionInfo);

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* global Symbol */
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactRouter = __webpack_require__(51);
	
	var _staticData = __webpack_require__(28);
	
	var _c_ButtonGroup = __webpack_require__(231);
	
	var _c_ButtonGroup2 = _interopRequireDefault(_c_ButtonGroup);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _TopNavigation = __webpack_require__(1028);
	
	var _TopNavigation2 = _interopRequireDefault(_TopNavigation);
	
	var _SubmissionBar = __webpack_require__(125);
	
	var _SubmissionBar2 = _interopRequireDefault(_SubmissionBar);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _lodash = __webpack_require__(4);
	
	var _SearchIcon = __webpack_require__(167);
	
	var _SearchIcon2 = _interopRequireDefault(_SearchIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const links = [
	//   {
	//     name: 'Special Areas of Knowledge',
	//     categoryId: 4,
	//     next: 'skills/5',
	//     previous: 'adddocuments',
	//     max: 3,
	//     categoryDescription: 'Please select a maximum of three special areas of knowledge for this position.'
	//   },
	//   {
	//     name: 'Management Systems',
	//      categoryId: 5,
	//      next: 'skills/8',
	//      previous: 'skills/4',
	//      categoryDescription: 'Please select management system(s) for this position.'
	//   },
	//   {
	//     name: 'Carrier Knowledge',
	//     categoryId: 8,
	//     next: 'skills/7',
	//     previous: 'skills/5',
	//     categoryDescription: 'Please select a maximum of three carriers with which you would like your wahve to have experience.'
	//   },
	//   {
	//     name: 'Rating Systems',
	//     categoryId: 7, next:
	//     'skills/6',
	//     previous: 'skills/8',
	//     categoryDescription: 'Please select the rating system(s) for this position.'
	//   },
	//   {
	//     name: 'Computer Skills',
	//     categoryId: 6,
	//     next: 'skills/9',
	//     previous: 'skills/7',
	//     categoryDescription: 'Please select the computer skills for this position.'
	//   },
	//   {
	//     name: 'Foreign Language',
	//     categoryId: 9,
	//     next: 'skills/summary',
	//     previous: 'skills/6',
	//     categoryDescription: 'Please select the foreign language that is important for this position.'
	//   }
	// ];
	
	var JobRequestSkills = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var _store$staticData = store.staticData,
	      _store$staticData$ski = _store$staticData.skillCategoryTypes,
	      skillCategoryTypes = _store$staticData$ski === undefined ? [] : _store$staticData$ski,
	      _store$staticData$acc = _store$staticData.account,
	      account = _store$staticData$acc === undefined ? {} : _store$staticData$acc;
	
	  var categoryTypes = (0, _staticData.skillCategoryTypesByTenant)(account.id, skillCategoryTypes, 'showInJobRequest');
	
	  var links = categoryTypes.map(function (skillType, index, arr) {
	    var isFirst = index === 0;
	    var isLast = index === arr.length - 1;
	    var prevSkillCategoryId = isFirst ? null : arr[index - 1].id;
	    var nextSkillCategoryId = isLast ? null : arr[index + 1].id;
	
	    var link = {
	      name: skillType.name,
	      categoryId: skillType.id,
	      description: skillType.jobRequestDescription
	    };
	
	    if (isFirst) {
	      (0, _lodash.set)(link, 'previous', 'adddocuments');
	      (0, _lodash.set)(link, 'next', 'skills/' + nextSkillCategoryId);
	    } else if (isLast) {
	      (0, _lodash.set)(link, 'previous', 'skills/' + prevSkillCategoryId);
	      (0, _lodash.set)(link, 'next', 'skills/summary');
	    } else {
	      (0, _lodash.set)(link, 'previous', 'skills/' + prevSkillCategoryId);
	      (0, _lodash.set)(link, 'next', 'skills/' + nextSkillCategoryId);
	      (0, _lodash.set)(link, 'description', skillType.jobRequestDescription);
	    }
	
	    return link;
	  });
	
	  var skills = (0, _lodash.keyBy)((0, _lodash.get)(store.jobRequest, 'skills.' + (props.params.categoryId || links[0].categoryId), {}), 'name');
	  var currentCategory = (0, _lodash.get)((0, _lodash.keyBy)(links, 'categoryId'), props.params.categoryId || links[0].categoryId);
	
	  return {
	    staticData: store.staticData,
	    user: store.user,
	    contact: store.contactProfile,
	    jobRequest: store.jobRequest,
	    categoryId: parseInt(props.params.categoryId || links[0].categoryId, 10),
	    currentCategory: currentCategory,
	    jobId: parseInt(props.params.jobId || 0, 10),
	    skills: skills,
	    links: links,
	    labels: (0, _lodash.get)(store, 'labels.jobRequest.skills', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(JobRequestSkills, _Component);
	
	  function JobRequestSkills(props, context) {
	    _classCallCheck(this, JobRequestSkills);
	
	    // setting initial state
	    var _this = _possibleConstructorReturn(this, (JobRequestSkills.__proto__ || Object.getPrototypeOf(JobRequestSkills)).call(this, props, context));
	
	    _this.updateStoreAfterSaved = function (skills) {
	      var updatedSkills = (0, _lodash.valuesIn)(skills);
	      var updatedJobRequestStore = (0, _lodash.cloneDeep)(_this.props.jobRequest);
	      (0, _lodash.set)(updatedJobRequestStore, 'skills[' + _this.props.categoryId + ']', updatedSkills);
	      _this.props.dispatch(jobRequestStore.updateJobRequest(_extends({}, updatedJobRequestStore)));
	    };
	
	    _this.save = function (skills) {
	
	      var updatedSkills = (0, _lodash.valuesIn)(skills);
	
	      var updatedJobRequest = {
	        id: _this.props.jobId,
	        primaryContactId: _this.props.contact.profile.id,
	        skills: {}
	      };
	
	      updatedJobRequest.skills['' + _this.props.categoryId] = updatedSkills;
	
	      var updateJobRequest = function updateJobRequest(jobId, jobRequest) {
	        return _this.props.dispatch(jobRequestApi.updateJobRequest(jobId, jobRequest));
	      };
	
	      return updateJobRequest(_this.props.jobId, updatedJobRequest).then(function () {
	        _this.updateStoreAfterSaved(_this.state.skills);
	        _this.props.checkComplete();
	      });
	    };
	
	    _this.gotoNextScreen = function () {
	
	      var skillsInCategory = (0, _lodash.filter)(_this.props.skills, { categoryId: _this.props.currentCategory.categoryId });
	      var hasErrors = _this.validation(skillsInCategory);
	
	      if (hasErrors) {
	        _this.setState({ showError: true });
	        return;
	      }
	
	      _this.props.checkComplete();
	      _this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/' + _this.props.currentCategory.next));
	    };
	
	    _this.handleSave = function (event, cb) {
	
	      // We should not save if there not jobId.
	
	      if (!_this.props.jobId) {
	        return false;
	      }
	
	      _this.save(_this.state.skills).then(function () {
	        return _this.setState({ stateSaved: true }, cb);
	      });
	    };
	
	    _this.handleSaveAndNext = function (event) {
	
	      var hasErrors = !(0, _lodash.isEmpty)(_this.state.errors);
	
	      _this.handleSave(event, function () {
	        if (hasErrors) {
	          _this.setState({ showError: true });
	        } else {
	          _this.gotoNextScreen();
	        }
	      });
	    };
	
	    _this.handleBack = function () {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/' + _this.props.currentCategory.previous));
	    };
	
	    _this.searchOnChange = function (event) {
	      (0, _lodash.debounce)(_this.setState({
	        searchTags: event.target.value.toLowerCase().trim()
	      }), 200);
	    };
	
	    _this.closeTransitionBlocker = function () {
	      _this.setState((0, _lodash.merge)({}, _this.state, { showTransitionBlocker: false }));
	    };
	
	    _this.transitionFunction = function () {
	      _this.setState({ stateSaved: true, showTransitionBlocker: false }, function () {
	        return _this.props.dispatch((0, _reactRouterRedux.push)(_this.state.transitionRoute));
	      });
	    };
	
	    _this.state = {
	      skills: _this.props.skills,
	      searchTags: [],
	      errors: [],
	      showError: false,
	      showTransitionBlocker: false,
	      transitionRoute: '',
	      stateSaved: true
	    };
	    return _this;
	  }
	
	  _createClass(JobRequestSkills, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.router.setRouteLeaveHook(this.props.route, function (location) {
	
	        var jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;
	
	        if (jobRequestSteps.test(location.pathname)) {
	
	          _this2.state.primaryButtonLabel = 'Stay';
	          _this2.state.secondaryButtonLabel = 'Leave';
	        } else {
	          _this2.state.primaryButtonLabel = undefined;
	          _this2.state.secondaryButtonLabel = undefined;
	        }
	
	        if (!_this2.state.stateSaved) {
	          _this2.setState((0, _lodash.merge)({}, _this2.state, { showTransitionBlocker: true, transitionRoute: location.pathname }));
	        }
	        return _this2.state.stateSaved;
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.skills) {
	        this.setState({ showError: false, searchTags: [] });
	        this.validation(nextProps.skills);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event, value) {
	      var _this3 = this;
	
	      var skills = (0, _lodash.reduce)(value, function (category, skill) {
	        category[skill] = (0, _lodash.get)(_this3.state.skills, skill) ? _this3.state.skills[skill] : { categoryId: _this3.props.categoryId, name: skill };
	        return category;
	      }, {});
	      this.validation(skills);
	      this.setState({ stateSaved: false });
	    }
	  }, {
	    key: 'validation',
	    value: function validation(skills) {
	      var errors = [];
	      if ((0, _lodash.isEmpty)(skills)) {
	        errors.push('Please Select at Least One Item.');
	      } else if (this.props.currentCategory.max && (0, _lodash.keysIn)(skills).length > this.props.currentCategory.max) {
	        errors.push('Please Select maximum of ' + this.props.currentCategory.max + ' Items.');
	      }
	      this.setState({ skills: skills, errors: errors });
	
	      return errors.length ? true : false;
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete(event, value) {
	      var values = (0, _lodash.remove)((0, _lodash.keysIn)(this.state.skills), function (s) {
	        return s !== value;
	      });
	      this.onChange(event, values);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var values = (0, _lodash.keysIn)(this.state.skills);
	      var list = (0, _lodash.reduce)((0, _lodash.orderBy)(this.props.staticData.skillTypes, ['name'], ['asc']), function (skillsList, skill) {
	        if (skill.skillCategoryTypeId === _this4.props.categoryId) {
	          skillsList.push({ primaryText: skill.name });
	        }
	        return skillsList;
	      }, []);
	
	      list.unshift({ primaryText: 'None' });
	
	      var visibleList = (0, _lodash.reduce)(list, function (skillsList, skill) {
	        if (_this4.state.searchTags === '' || skill.primaryText.toLowerCase().indexOf(_this4.state.searchTags) > -1) {
	          skillsList.push(skill.primaryText);
	        }
	        return skillsList;
	      }, []);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-skills' },
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          cancelAction: this.closeTransitionBlocker.bind(this),
	          primaryAction: this.closeTransitionBlocker.bind(this),
	          primaryButtonLabel: this.state.primaryButtonLabel,
	          secondaryAction: this.transitionFunction.bind(this),
	          secondaryButtonLabel: this.state.secondaryButtonLabel,
	          transitionText: 'You are leaving the Job Request record. Please click on Save first before you exit.'
	        }),
	        _react2.default.createElement(_TopNavigation2.default, {
	          activeCategoryId: this.props.categoryId,
	          links: this.props.links,
	          jobId: this.props.jobId,
	          dispatch: this.props.dispatch,
	          jobRequest: this.props.jobRequest
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'job-request-skills-body' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Skills'
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              this.props.labels.instructions
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'skills-container' },
	              _react2.default.createElement(
	                'div',
	                { className: 'category' },
	                this.props.currentCategory.title
	              ),
	              this.props.currentCategory.description && _react2.default.createElement(
	                'div',
	                { className: 'category-description' },
	                this.props.currentCategory.description
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'div',
	                { className: 'search center-column-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'search-input-container' },
	                  _react2.default.createElement(_SearchIcon2.default, null),
	                  _react2.default.createElement('input', { 'data-id': 'Search',
	                    ref: 'search',
	                    className: 'search-input',
	                    value: this.state.searchTags,
	                    type: 'text',
	                    placeholder: 'Search...',
	                    onChange: this.searchOnChange.bind(this) })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'skills-list-container' },
	                _react2.default.createElement(_c_ButtonGroup2.default, {
	                  menuItems: list,
	                  visibleItems: visibleList,
	                  value: values,
	                  onChange: this.onChange.bind(this)
	                }),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'skill-list-client ' + (values.length ? '' : 'empty') },
	                  (0, _lodash.map)(values, function (value, index) {
	                    var _React$createElement;
	
	                    return _react2.default.createElement(
	                      'li',
	                      { key: index, className: 'skill-item' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'data-id': 'SkillName' + index, className: 'name' },
	                        value
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'actions' },
	                        _react2.default.createElement(_c_FlatButton2.default, (_React$createElement = {
	                          'data-id': 'Remove' + index,
	                          label: 'Remove'
	                        }, _defineProperty(_React$createElement, 'data-id', 'Remove' + index), _defineProperty(_React$createElement, 'onClick', function onClick(event) {
	                          _this4.handleDelete(event, value);
	                        }), _React$createElement))
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_SubmissionBar2.default, {
	            onBack: this.handleBack,
	            onNext: this.handleSaveAndNext,
	            onSave: this.handleSave,
	            errors: this.state.errors,
	            showError: this.state.showError
	          })
	        )
	      );
	    }
	  }]);
	
	  return JobRequestSkills;
	}(_react.Component), _class2.propTypes = {
	  params: _react.PropTypes.object,
	  staticData: _react.PropTypes.object,
	  links: _react.PropTypes.array
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(JobRequestSkills);

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* global Symbol */
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// lib
	
	
	// js utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactRouter = __webpack_require__(51);
	
	var _Table = __webpack_require__(72);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _SubmissionBar = __webpack_require__(125);
	
	var _SubmissionBar2 = _interopRequireDefault(_SubmissionBar);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _staticData = __webpack_require__(28);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropdownStyling = {
	  containerStyle: {
	    width: '95%',
	    transform: 'translateY(-2px)'
	  },
	  labelStyle: {
	    padding: 0
	  },
	  listStyle: {
	    width: '100px'
	  },
	  menuStyle: {
	    width: '100px'
	  },
	  iconStyle: {
	    right: 0
	  },
	  underlineStyle: {
	    display: 'none'
	  }
	};
	
	// class name
	// import cx from 'classnames';
	
	var SkillsSumary = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  var skills = (0, _lodash.get)(store.jobRequest, 'skills');
	  return {
	    staticData: store.staticData,
	    user: store.user,
	    contact: store.contactProfile,
	    jobRequest: store.jobRequest,
	    jobId: parseInt(props.params.jobId || 0, 10),
	    skills: skills
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(SkillsSumary, _Component);
	
	  function SkillsSumary(props, context) {
	    _classCallCheck(this, SkillsSumary);
	
	    // setting initial state
	    var _this = _possibleConstructorReturn(this, (SkillsSumary.__proto__ || Object.getPrototypeOf(SkillsSumary)).call(this, props, context));
	
	    _this.save = function (jobId, primaryContactId, skills) {
	
	      var updatedJobRequest = {
	        id: jobId,
	        primaryContactId: primaryContactId,
	        skills: skills
	      };
	
	      var updateJobRequest = _this.props.dispatch(jobRequestApi.updateJobRequest(_this.props.jobId, updatedJobRequest));
	
	      return updateJobRequest.then(function () {
	
	        var updatedJobRequestStore = (0, _lodash.cloneDeep)(_this.props.jobRequest);
	        updatedJobRequestStore.skills = _this.state.skills;
	        return _this.props.dispatch(jobRequestStore.updateJobRequest(_extends({}, updatedJobRequestStore)));
	      });
	    };
	
	    _this.handleSave = function (event, cb) {
	
	      if (!_this.props.jobId) return false;
	
	      _this.save(_this.props.jobId, _this.props.contact.profile.id, _this.state.skills).then(function () {
	        _this.setState({ stateSaved: true }, cb);
	      });
	    };
	
	    _this.handleSaveAndNext = function (event) {
	
	      var hasErrors = !_this.validation(_this.state.skills);
	
	      _this.handleSave(event, function () {
	        if (hasErrors) {
	          _this.setState({ showError: true });
	        } else {
	          _this.gotoNextScreen();
	        }
	      });
	    };
	
	    _this.gotoNextScreen = function () {
	      _this.props.checkComplete();
	      _this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/workschedule'));
	    };
	
	    _this.handleBack = function (event) {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/skills/9'));
	    };
	
	    _this.closeTransitionBlocker = function () {
	      _this.setState((0, _lodash.merge)({}, _this.state, { showTransitionBlocker: false }));
	    };
	
	    _this.transitionFunction = function () {
	      _this.setState({ stateSaved: true }, function () {
	        return _this.props.dispatch((0, _reactRouterRedux.push)(_this.state.transitionRoute));
	      });
	    };
	
	    _this.state = {
	      skills: _this.props.skills,
	      validation: {},
	      errors: [],
	      showError: false,
	      showTransitionBlocker: false,
	      transitionRoute: '',
	      stateSaved: true
	    };
	    return _this;
	  }
	
	  _createClass(SkillsSumary, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.skills) {
	        this.validation(nextProps.skills);
	        this.setState({ skills: nextProps.skills });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.router.setRouteLeaveHook(this.props.route, function (location) {
	
	        var jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;
	
	        if (jobRequestSteps.test(location.pathname)) {
	          _this2.state.primaryButtonLabel = 'Stay';
	          _this2.state.secondaryButtonLabel = 'Leave';
	        } else {
	          _this2.state.primaryButtonLabel = undefined;
	          _this2.state.secondaryButtonLabel = undefined;
	        }
	
	        if (!_this2.state.stateSaved) {
	          _this2.setState((0, _lodash.merge)({}, _this2.state, { showTransitionBlocker: true, transitionRoute: location.pathname }));
	          return _this2.state.stateSaved;
	        } else {
	          return true;
	        }
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(target, prop, event, value) {
	      var skills = this.state.skills;
	      (0, _lodash.map)((0, _lodash.get)(skills, '' + target.categoryId), function (skill, index) {
	        if (skill.name === target.name) {
	          (0, _lodash.set)(skills, target.categoryId + '.' + index + '.' + prop, value);
	        }
	      });
	
	      this.setState({ stateSaved: false });
	      this.validation(skills);
	    }
	  }, {
	    key: 'validation',
	    value: function validation(skills) {
	      var validation = {};
	      var errors = [];
	      var formValid = (0, _lodash.reduce)(skills, function (catValid, cat) {
	        return (0, _lodash.reduce)(cat, function (skillValid, skill, index) {
	          var isValid = (0, _lodash.isNil)(skill) || skill.name === 'None' || !(0, _lodash.isNil)(skill.skillOption);
	          validation[skill.name] = !isValid || null;
	          return isValid && skillValid;
	        }, true) && catValid;
	      }, true);
	
	      if (!formValid) {
	        errors.push('Please fill out the required fields above.');
	      }
	      this.setState({ errors: errors, validation: validation });
	      return formValid;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var errorMessage = 'Please fill out all fields.';
	      var errorLabel = _react2.default.createElement(
	        'div',
	        { className: 'error-message' },
	        errorMessage
	      );
	
	      var skills = (0, _lodash.flatten)((0, _lodash.valuesIn)(this.props.skills));
	
	      // Filtering out skills with none  selection.
	      for (var i = skills.length - 1; i >= 0; i--) {
	        if (skills[i].name === 'None') {
	          skills.splice(i, 1);
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'skills-sumary' },
	        this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          cancelAction: this.closeTransitionBlocker.bind(this),
	          primaryAction: this.closeTransitionBlocker.bind(this),
	          primaryButtonLabel: this.state.primaryButtonLabel,
	          secondaryAction: this.transitionFunction.bind(this),
	          secondaryButtonLabel: this.state.secondaryButtonLabel,
	          transitionText: 'You are leaving the Job Request record. Please click on Save first before you exit.'
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'application-section-container clearfix' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Summary Skills'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'summary-skills-table' },
	              _react2.default.createElement(
	                _Table.Table,
	                {
	                  selectable: false,
	                  multiSelectable: false
	                },
	                _react2.default.createElement(
	                  _Table.TableHeader,
	                  {
	                    displaySelectAll: false,
	                    adjustForCheckbox: false
	                  },
	                  _react2.default.createElement(
	                    _Table.TableRow,
	                    null,
	                    _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      { className: 'name' },
	                      'Skill Name'
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableHeaderColumn,
	                      { style: { width: '100px', paddingLeft: '2px', paddingRight: '0px' }, className: 'option' },
	                      'Importance'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _Table.TableBody,
	                  {
	                    displayRowCheckbox: false
	                  },
	                  skills.map(function (row, index) {
	                    return _react2.default.createElement(
	                      _Table.TableRow,
	                      { key: row.categoryId + '-' + row.name },
	                      _react2.default.createElement(
	                        _Table.TableRowColumn,
	                        { 'data-id': 'SkillName' + index, className: 'name' },
	                        row.name,
	                        !(0, _lodash.isNil)(_this3.state.validation[row.name]) && _this3.state.showError && errorLabel
	                      ),
	                      _react2.default.createElement(
	                        _Table.TableRowColumn,
	                        { style: { width: '100px', paddingLeft: '2px', paddingRight: '0px' }, className: 'option' },
	                        _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                          'data-id': 'skillOption' + index,
	                          canAutoPosition: 'true',
	                          defaultValue: row.skillOption,
	                          menuItems: (0, _staticData.convertToMenuItems)(_this3.props.staticData.skillOptionTypes, 'id', 'name'),
	                          onChange: _this3.onChange.bind(_this3, row, 'skillOption')
	                        }, dropdownStyling))
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_SubmissionBar2.default, {
	            onBack: this.handleBack,
	            onNext: this.handleSaveAndNext,
	            onSave: this.handleSave,
	            errors: this.state.errors,
	            showError: this.state.showError
	          })
	        )
	      );
	    }
	  }]);
	
	  return SkillsSumary;
	}(_react.Component), _class2.propTypes = {
	  params: _react.PropTypes.object,
	  staticData: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(SkillsSumary);

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TopNavigation;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TopNavigation(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'top-navigation' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'application-progress ' + props.className },
	      props.links.map(function (link, index) {
	
	        return _react2.default.createElement(
	          'li',
	          {
	            key: index,
	            'data-id': link.name,
	            className: (0, _classnames2.default)('subnav-button', { active: link.categoryId === props.activeCategoryId }, { bottomBorder: true }, { highlightedCircleEdge: true }, { checked: !(0, _lodash.isEmpty)((0, _lodash.get)(props.jobRequest, 'skills.' + link.categoryId)) }) },
	          _react2.default.createElement(
	            'div',
	            { className: 'subnav-text-container' },
	            _react2.default.createElement(
	              'span',
	              { className: 'subnav-text' },
	              link.name
	            )
	          )
	        );
	      })
	    )
	  );
	}
	
	TopNavigation.propTypes = {
	  links: _react.PropTypes.array,
	  activeCategoryId: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  jobId: _react.PropTypes.integer,
	  jobRequest: _react.PropTypes.Object
	};

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactRouter = __webpack_require__(51);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _modelValidator = __webpack_require__(33);
	
	var _staticData = __webpack_require__(28);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _SubmissionBar = __webpack_require__(125);
	
	var _SubmissionBar2 = _interopRequireDefault(_SubmissionBar);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkSchedule = (_dec = (0, _reactRedux.connect)(function (store, props) {
		return {
			staticData: store.staticData,
			user: store.user,
			jobRequest: store.jobRequest,
			jobId: parseInt(props.params.jobId || 0, 10),
			labels: store.labels.jobRequest.workschedule || {}
		};
	}), _dec(_class = (_temp = _class2 = function (_Component) {
		_inherits(WorkSchedule, _Component);
	
		function WorkSchedule(props, context) {
			_classCallCheck(this, WorkSchedule);
	
			var _this = _possibleConstructorReturn(this, (WorkSchedule.__proto__ || Object.getPrototypeOf(WorkSchedule)).call(this, props, context));
	
			_this.save = function (clientId, jobRequestModel, jobWorkScheduleModel) {
	
				// Pick only the neccesary fields for the request.
	
				var jobWorkScheduleFields = ['id', 'primaryContactId'].concat(_toConsumableArray(Object.keys(jobWorkScheduleModel)));
				var jobWorkSchedule = (0, _lodash.pick)(jobRequestModel, jobWorkScheduleFields);
	
				return _this.props.dispatch(jobRequestApi.updateJobRequest(clientId, jobWorkSchedule)).then(function () {
					_this.props.dispatch(jobRequestStore.updateJobRequest(_extends({}, _this.state.jobRequestModel)));
				});
			};
	
			_this.handleSave = function (event, cb) {
	
				_this.save(_this.state.clientId, _this.state.jobRequestModel, _this.jobWorkScheduleModel).then(function () {
					return _this.setState({ stateSaved: true }, cb);
				});
			};
	
			_this.handleSaveAndNext = function (event) {
	
				var errors = (0, _modelValidator.validate)(_this.state.jobRequestModel, _this.jobWorkScheduleModel);
				_this.state.errors = [];
	
				if (_this.state.jobRequestModel.startTime > _this.state.jobRequestModel.endTime) {
					_this.state.errors.push('Preferred Start Time can not be after than Preferred End Time.');
				}
	
				if (_this.state.jobRequestModel.hardcodelink === 'PROJECT' && new Date(_this.state.jobRequestModel.dateStarted) > new Date(_this.state.jobRequestModel.dateEnded)) {
					_this.state.errors.push('Desired Start Date can not be after than Projected End.');
				}
	
				_this.handleSave(event, function () {
	
					if (errors.length > 0 || _this.state.errors.length > 0) {
						_this.setState({ isDirty: true });
					} else {
						_this.props.checkComplete();
						_this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/addcontact'));
					}
				});
			};
	
			_this.handleBack = function () {
				_this.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest/' + (_this.props.jobId || 0) + '/skills/summary'));
			};
	
			_this.closeTransitionBlocker = function () {
				_this.setState((0, _lodash.merge)({}, _this.state, { showTransitionBlocker: false }));
			};
	
			_this.transitionFunction = function () {
				_this.setState({ stateSaved: true }, function () {
					return _this.props.dispatch((0, _reactRouterRedux.push)(_this.state.transitionRoute));
				});
			};
	
			_this.state = {
				clientId: _this.props.user.id,
				isDirty: false,
				errors: [],
				jobRequest: null,
				jobRequestModel: _extends({}, _this.props.jobRequest, {
					id: _this.props.jobId,
					primaryContactId: _this.props.user.profileId
				}),
				showTransitionBlocker: false,
				transitionRoute: '',
				stateSaved: true
			};
			_this.jobWorkScheduleModel = {
				jobTypeId: {
					required: {
						message: 'This field is required.'
					}
				},
				numberOfMonths: {},
				dateEnded: {},
				dateStarted: {
					required: {
						message: 'This field is required.'
					}
				},
				estimatedHoursPerWeek: {
					required: {
						message: 'This field is required.'
					}
				},
				partTimeWahvesConsidered: {},
				workdays: {
					required: {
						message: 'This field is required.'
					}
				},
				offHoursConsidered: {
					required: {
						message: 'This field is required.'
					}
				},
				timezone: {
					required: {
						message: 'This field is required.'
					}
				},
				startTime: {
					required: {
						message: 'This field is required.'
					}
				},
				endTime: {
					required: {
						message: 'This field is required.'
					}
				}
			};
	
			_this.handleDropDownMenuUI = _this.handleDropDownMenuUI.bind(_this);
			_this.handleDateProperties = _this.handleDateProperties.bind(_this);
			_this.handleToggleButtonUI = _this.handleToggleButtonUI.bind(_this);
			_this.handleChange = _this.handleChange.bind(_this);
			return _this;
		}
	
		_createClass(WorkSchedule, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				this.props.router.setRouteLeaveHook(this.props.route, function (location) {
	
					var jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;
	
					if (jobRequestSteps.test(location.pathname)) {
						_this2.state.primaryButtonLabel = 'Stay';
						_this2.state.secondaryButtonLabel = 'Leave';
					} else {
						_this2.state.primaryButtonLabel = undefined;
						_this2.state.secondaryButtonLabel = undefined;
					}
	
					if (!_this2.state.stateSaved) {
						_this2.setState((0, _lodash.merge)({}, _this2.state, { showTransitionBlocker: true, transitionRoute: location.pathname }));
						return _this2.state.stateSaved;
					}
	
					return true;
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.jobRequest) {
					this.setState((0, _lodash.merge)({}, this.state, { jobRequestModel: nextProps.jobRequest }));
				}
			}
		}, {
			key: 'handleDropDownMenuUI',
			value: function handleDropDownMenuUI(prop, menuItems, label) {
				return {
					'data-id': 'dropdown-' + prop,
					menuItems: menuItems,
					value: this.state.jobRequestModel[prop],
					floatingLabelText: label,
					errorText: this.state.isDirty ? (0, _modelValidator.validateField)(this.state.jobRequestModel[prop], this.jobWorkScheduleModel[prop])[0] : undefined,
					onChange: this.handleChange(prop)
				};
			}
		}, {
			key: 'handleDateProperties',
			value: function handleDateProperties(prop, label) {
				return {
					'data-id': 'date-' + prop,
					defaultValue: this.state.jobRequestModel[prop],
					floatingLabelText: label,
					errorText: (0, _modelValidator.validateField)(this.state.jobRequestModel[prop], this.jobWorkScheduleModel[prop])[0],
					isDirty: this.state.isDirty,
					onBlur: this.handleChange(prop)
				};
			}
		}, {
			key: 'handleToggleButtonUI',
			value: function handleToggleButtonUI(prop, label) {
				return {
					'data-id': 'tooglebutton-' + prop,
					value: this.state.jobRequestModel[prop],
					errorText: this.state.isDirty ? (0, _modelValidator.validateField)(this.state.jobRequestModel[prop], this.jobWorkScheduleModel[prop])[0] : undefined,
					onChange: this.handleChange(prop),
					floatingLabelText: label || null
				};
			}
		}, {
			key: 'handleChange',
			value: function handleChange(prop) {
				var _this3 = this;
	
				return function (event, value) {
					var jobRequest = _this3.state.jobRequestModel;
					jobRequest[prop] = value;
					if ((prop === 'numberOfMonths' || prop === 'dateStarted') && !(0, _lodash.isNil)(jobRequest.dateStarted) && !(0, _lodash.isNil)(jobRequest.numberOfMonths)) {
						jobRequest.dateEnded = (0, _moment2.default)(jobRequest.dateStarted).add(jobRequest.numberOfMonths, 'months').format();
					}
					_this3.setState((0, _lodash.merge)({}, _this3.state, { jobRequestModel: jobRequest, stateSaved: false }));
				};
			}
		}, {
			key: 'render',
			value: function render() {
	
				var jobIs = (0, _staticData.convertToMenuItems)(this.props.staticData.jobTypes, 'id', 'name', 'subElement');
	
				var numberOfMonth = [{
					primaryText: '6',
					subElement: null,
					value: 6
				}, {
					primaryText: '7',
					subElement: null,
					value: 7
				}, {
					primaryText: '8',
					subElement: null,
					value: 8
				}, {
					primaryText: '9',
					subElement: null,
					value: 9
				}, {
					primaryText: '10',
					subElement: null,
					value: 10
				}, {
					primaryText: '11',
					subElement: null,
					value: 11
				}, {
					primaryText: '1 yr',
					subElement: null,
					value: 12
				}, {
					primaryText: '2 yrs',
					subElement: null,
					value: 24
				}];
	
				var yesNo = [{ value: true, primaryText: 'Yes', subElement: null }, { value: false, primaryText: 'No', subElement: null }];
	
				var hoursPerWeek = [{
					primaryText: 20,
					subElement: null,
					value: 20
				}, {
					primaryText: 25,
					subElement: null,
					value: 25
				}, {
					primaryText: 30,
					subElement: null,
					value: 30
				}, {
					primaryText: 35,
					subElement: null,
					value: 35
				}, {
					primaryText: 37.5,
					subElement: null,
					value: 37.5
				}, {
					primaryText: 40,
					subElement: null,
					value: 40
				}];
	
				var daysPerWeek = this.props.staticData.dayAvailableTypes;
				var preferredStartTime = (0, _staticData.convertToMenuItems)(this.props.staticData.workHours.slice(0, 25), 'id', 'name', 'subElement');
				var preferredEndTime = (0, _staticData.convertToMenuItems)(this.props.staticData.workHours.slice(6, this.props.staticData.workHours.length), 'id', 'name', 'subElement');
	
				var jobType = (0, _staticData.getLookupValue)(this.props.staticData, 'jobTypes', { id: this.state.jobRequestModel.jobTypeId });
				var isProjectType = jobType && jobType.hardcodelink === 'PROJECT';
	
				return _react2.default.createElement(
					'div',
					{ className: 'work-schedule' },
					this.state.showTransitionBlocker && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
						cancelAction: this.closeTransitionBlocker.bind(this),
						primaryAction: this.closeTransitionBlocker.bind(this),
						primaryButtonLabel: this.state.primaryButtonLabel,
						secondaryAction: this.transitionFunction.bind(this),
						secondaryButtonLabel: this.state.secondaryButtonLabel,
						transitionText: 'You are leaving the Job Request record. Please click on Save first before you exit.'
					}),
					_react2.default.createElement(
						'h1',
						null,
						'Work Schedule'
					),
					_react2.default.createElement(
						'div',
						{ className: 'form-section-content clearfix' },
						_react2.default.createElement(
							'div',
							{ className: 'headings-row clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								'This job is:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								'Desired Start Date:'
							),
							isProjectType ? _react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								_react2.default.createElement(
									'div',
									{ className: 'half-width' },
									'Number of months:'
								),
								_react2.default.createElement(
									'div',
									{ className: 'half-width' },
									'Projected End Date:'
								)
							) : null
						),
						_react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'question-dropdown center-column-1 drop-plain',
							includeDefault: true,
							floatingLabelStyle: { top: '-13px' }
						}, this.handleDropDownMenuUI('jobTypeId', jobIs, ''))),
						_react2.default.createElement(_DateInput2.default, _extends({
							autoOk: true,
							minDate: new Date(),
							className: 'center-column-1 date-input',
							textStyle: { margin: '0px' }
						}, this.handleDateProperties('dateStarted', ''))),
						isProjectType && _react2.default.createElement(
							'div',
							{ className: 'center-column-1' },
							_react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'half-width',
								floatingLabelStyle: { overflow: 'visible', top: '-13px' }
							}, this.handleDropDownMenuUI('numberOfMonths', numberOfMonth, ''))),
							_react2.default.createElement(_DateInput2.default, _extends({
								autoOk: true,
								minDate: new Date(),
								className: 'half-width date-input',
								textStyle: { margin: '0px' }
							}, this.handleDateProperties('dateEnded', '')))
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form-section-content clearfix' },
						_react2.default.createElement(
							'div',
							{ className: 'headings-row clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								'Estimated Number of Hours per Week:'
							),
							this.state.jobRequestModel.estimatedHoursPerWeek === 40 ? _react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								this.props.labels.partTime
							) : null
						),
						_react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'question-dropdown center-column-1 drop-plain'
						}, this.handleDropDownMenuUI('estimatedHoursPerWeek', hoursPerWeek, ''))),
						this.state.jobRequestModel.estimatedHoursPerWeek === 40 ? //
						_react2.default.createElement(_c_ToggleButton2.default, _extends({ className: 'center-column-1',
							menuItems: yesNo
						}, this.handleToggleButtonUI('partTimeWahvesConsidered', ''))) : null
					),
					_react2.default.createElement(
						'div',
						{ className: 'form-section-content clearfix' },
						_react2.default.createElement(
							'div',
							{ className: 'headings-row clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								'Days of the week:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								'Can work be performed outside business hours?'
							),
							_react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								'Job Time Zone:'
							)
						),
						_react2.default.createElement(_c_CheckList2.default, _extends({ className: 'question-dropdown center-column-1 drop-plain',
							defaultValue: this.state.jobRequestModel.workdays
						}, this.handleDropDownMenuUI('workdays', daysPerWeek, ''))),
						_react2.default.createElement(_c_ToggleButton2.default, _extends({ className: 'center-column-1',
							menuItems: yesNo
						}, this.handleToggleButtonUI('offHoursConsidered', ''))),
						_react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'question-dropdown center-column-1 drop-plain'
						}, this.handleDropDownMenuUI('timezone', this.props.staticData.timezoneList, '')))
					),
					_react2.default.createElement(
						'div',
						{ className: 'form-section-content clearfix' },
						_react2.default.createElement(
							'div',
							{ className: 'headings-row clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								'Preferred Start Time:'
							),
							_react2.default.createElement(
								'div',
								{ className: 'center-column-1' },
								'Preferred End Time:'
							)
						),
						_react2.default.createElement(_c_DropDownMenu2.default, _extends({ canAutoPosition: true, className: 'question-dropdown center-column-1 drop-plain'
						}, this.handleDropDownMenuUI('startTime', preferredStartTime, ''))),
						_react2.default.createElement(_c_DropDownMenu2.default, _extends({ canAutoPosition: true, className: 'question-dropdown center-column-1 drop-plain'
						}, this.handleDropDownMenuUI('endTime', preferredEndTime, '')))
					),
					_react2.default.createElement(_SubmissionBar2.default, {
						onBack: this.handleBack,
						onNext: this.handleSaveAndNext,
						onSave: this.handleSave,
						showError: this.state.isDirty,
						errors: this.state.errors
					})
				);
			}
		}]);
	
		return WorkSchedule;
	}(_react.Component), _class2.propTypes = {
		staticData: _react.PropTypes.object.isRequired,
		user: _react.PropTypes.object,
		checkComplete: _react.PropTypes.func,
		params: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(WorkSchedule);

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _jobRequest = __webpack_require__(208);
	
	var _modelValidator = __webpack_require__(33);
	
	var _SubNavigation = __webpack_require__(1034);
	
	var _SubNavigation2 = _interopRequireDefault(_SubNavigation);
	
	var _JobRequestLinks = __webpack_require__(1033);
	
	var _JobRequestLinks2 = _interopRequireDefault(_JobRequestLinks);
	
	var _staticData = __webpack_require__(28);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequest = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    user: store.user,
	    jobRequest: store.jobRequest,
	    documents: store.jobRequestDocuments.documents,
	    contactProfile: store.contactProfile,
	    staticData: store.staticData,
	    labels: store.labels.jobRequest,
	    bqpMigrationFeature: store.staticData.featureToggles.find(function (feature) {
	      return feature.hardcodelink === 'BQP_MIGRATION_FEATURE';
	    }).value === true
	
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(JobRequest, _Component);
	
	  function JobRequest(props, context) {
	    _classCallCheck(this, JobRequest);
	
	    var _this = _possibleConstructorReturn(this, (JobRequest.__proto__ || Object.getPrototypeOf(JobRequest)).call(this, props, context));
	
	    _this.checkJobRequestSectionCompletion = _this.checkJobRequestSectionCompletion.bind(_this);
	    _this.jobRequestSchema = _this.jobRequestSchema.bind(_this);
	
	    _this.state = {
	      activeLink: 'Position Info',
	      jobRequestCompletion: {
	        position: false,
	        description: false,
	        adddocuments: false,
	        skills: false,
	        summary: false,
	        workschedule: false,
	        addcontact: false
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(JobRequest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      if (!(0, _lodash.isNil)(this.props.params.jobId)) {
	        this.checkJobRequest();
	      }
	
	      this.props.dispatch(syncActions.setNavState({ isOpen: false, hideClose: false }));
	    }
	  }, {
	    key: 'getActiveLink',
	    value: function getActiveLink() {
	      var routeArray = this.props.location.pathname.split('/');
	      var routeTail = routeArray[routeArray.length - 1];
	      var activeLinkText = 'Position Info';
	
	      switch (routeTail) {
	        case 'description':
	          activeLinkText = 'Job Description';
	          break;
	        case 'adddocuments':
	          activeLinkText = 'Add Documents';
	          break;
	        case 'skills':
	          activeLinkText = 'Skills';
	          break;
	        case 'summary':
	          activeLinkText = 'Summary of Skills';
	          break;
	        case 'workschedule':
	          activeLinkText = 'Work Schedule';
	          break;
	        case 'addcontact':
	          activeLinkText = 'Reporting';
	          break;
	        case 'authorize':
	          activeLinkText = 'Authorize';
	          break;
	
	        default:
	          if (routeArray[routeArray.length - 2] == 'skills') {
	            activeLinkText = 'Skills';
	          }
	          break;
	      }
	
	      return activeLinkText;
	    }
	  }, {
	    key: 'jobRequestSchema',
	    value: function jobRequestSchema(section) {
	      var _this2 = this;
	
	      var schema = (0, _lodash.cloneDeep)((0, _jobRequest.getSchema)()[section]);
	
	      if (this.props.labels) {
	        (0, _lodash.forEach)(this.props.labels[section], function (val, key) {
	          if (!_this2.props.labels[key]) delete schema[key];
	        });
	      }
	
	      return schema;
	    }
	  }, {
	    key: 'checkJobRequest',
	    value: function checkJobRequest() {
	      var skills = (0, _lodash.pickBy)(this.props.jobRequest.skills, function (skill) {
	        return skill.length > 0;
	      });
	      var isSkillValid = function isSkillValid(skill) {
	        return (0, _lodash.isNil)(skill) || skill.name === 'None' || !(0, _lodash.isNil)(skill.skillOption);
	      };
	      var isSkillCategoryValid = function isSkillCategoryValid(cat) {
	        return (0, _lodash.reduce)(cat, function (acc, skill) {
	          return isSkillValid(skill) && acc;
	        }, true);
	      };
	      var areAllSkillCategoriesValid = function areAllSkillCategoriesValid(skills) {
	        return (0, _lodash.reduce)(skills, function (acc, category) {
	          return isSkillCategoryValid(category) && acc;
	        }, true);
	      };
	      var validSummary = areAllSkillCategoriesValid(skills);
	      var _props$staticData = this.props.staticData,
	          _props$staticData$ski = _props$staticData.skillCategoryTypes,
	          skillCategoryTypes = _props$staticData$ski === undefined ? [] : _props$staticData$ski,
	          _props$staticData$acc = _props$staticData.account,
	          account = _props$staticData$acc === undefined ? {} : _props$staticData$acc;
	
	
	      var requiredCategoryTypes = (0, _staticData.skillCategoryTypesByTenant)(account.id, skillCategoryTypes);
	      var filledCategoryTypes = Object.keys(skills || {});
	      var areAllSkillCategoriesFilled = true;
	      requiredCategoryTypes.forEach(function (x) {
	        if (filledCategoryTypes.find(function (g) {
	          return g === x.id.toString();
	        }) === undefined) {
	          areAllSkillCategoriesFilled = false;
	        } else {
	          if (skills.hasOwnProperty(x.id.toString())) {
	            if (skills[x.id.toString()].length === 0) {
	              areAllSkillCategoriesFilled = false;
	            }
	          }
	        }
	      });
	
	      // Menu item should have item name and status of passed validation
	
	      var jobRequestCompletion = {
	        position: (0, _modelValidator.validate)(this.props.jobRequest, this.jobRequestSchema('position')).length === 0,
	        adddocuments: !(0, _lodash.isEmpty)(this.props.documents),
	        description: !(0, _lodash.isNil)(this.props.jobRequest.description),
	        workschedule: (0, _modelValidator.validate)(this.props.jobRequest, this.jobRequestSchema('workschedule')).length === 0,
	        addcontact: false,
	        skills: areAllSkillCategoriesFilled,
	        summary: areAllSkillCategoriesFilled && validSummary
	      };
	
	      this.setState({ jobRequestCompletion: jobRequestCompletion });
	    }
	
	    // eslint-disable-next-line no-unused-vars
	
	  }, {
	    key: 'checkJobRequestSectionCompletion',
	    value: function checkJobRequestSectionCompletion(menuItem) {
	      // revalidate every time user click next.
	      this.checkJobRequest();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.state.activeLink = this.getActiveLink();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request' },
	        // omit if BQP_MIGRATION_FEATURE on
	        !this.props.bqpMigrationFeature && _react2.default.createElement(
	          _SubNavigation2.default,
	          { title: 'Job Request' },
	          _react2.default.createElement(_JobRequestLinks2.default, {
	            jobId: this.props.params.jobId,
	            route: this.props.route,
	            params: this.props.params,
	            activeLink: this.state.activeLink,
	            completed: this.state.jobRequestCompletion,
	            dispatch: this.props.dispatch })
	        ),
	        _react2.default.cloneElement(this.props.children, { checkComplete: this.checkJobRequestSectionCompletion, completed: this.state.jobRequestCompletion })
	      );
	    }
	  }]);
	
	  return JobRequest;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  params: _react.PropTypes.object,
	  user: _react.PropTypes.object,
	  children: _react.PropTypes.any,
	  location: _react.PropTypes.object,
	  jobRequest: _react.PropTypes.object,
	  route: _react.PropTypes.object,
	  documents: _react.PropTypes.any,
	  contactProfile: _react.PropTypes.object,
	  staticData: _react.PropTypes.object,
	  labels: _react.PropTypes.object,
	  bqpMigrationFeature: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = JobRequest;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	exports.OnEnterLoadJobRequestHistory = OnEnterLoadJobRequestHistory;
	exports.loadJobRequestHistory = loadJobRequestHistory;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _jobrequests = __webpack_require__(55);
	
	var jobRequestApi = _interopRequireWildcard(_jobrequests);
	
	var _jobrequests2 = __webpack_require__(71);
	
	var jobRequestStore = _interopRequireWildcard(_jobrequests2);
	
	var _index = __webpack_require__(21);
	
	var adminStore = _interopRequireWildcard(_index);
	
	var _JobRequestTable = __webpack_require__(230);
	
	var _JobRequestTable2 = _interopRequireDefault(_JobRequestTable);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enums = __webpack_require__(92);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobRequestHistory = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    allowAddJobRequest: state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.QUALIFIED_PROSPECT || state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.ACTIVE_ACCOUNT || state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.INACTIVE_ACCOUNT,
	    jobs: (0, _lodash.valuesIn)(state.jobRequests),
	    contactProfile: state.contactProfile,
	    contacts: (0, _lodash.valuesIn)(state.companyContacts),
	    staticData: state.staticData,
	    filters: state.admin.jobRequests.filters,
	    searchTerms: state.admin.jobRequests.searchTerms,
	    bqpMigrationFeature: state.staticData.featureToggles.find(function (feature) {
	      return feature.hardcodelink === 'BQP_MIGRATION_FEATURE';
	    }).value === true
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(JobRequestHistory, _Component);
	
	  function JobRequestHistory(props, context) {
	    _classCallCheck(this, JobRequestHistory);
	
	    var _this = _possibleConstructorReturn(this, (JobRequestHistory.__proto__ || Object.getPrototypeOf(JobRequestHistory)).call(this, props, context));
	
	    _this.disableEditButton = function (jobRequest) {
	      return jobRequest.primaryContactId !== _this.props.contactProfile.profile.id;
	    };
	
	    var roles = (0, _lodash.intersectionWith)(_this.props.staticData.contactTypes, (0, _lodash.get)(_this.props.contactProfile, 'profile.types', []), function (type, id) {
	      return type.id == id;
	    });
	    var isAdmin = (0, _lodash.intersectionWith)(['HR', 'Owner', 'Billing', 'Executive', 'Main', 'Technology'], roles, function (name, type) {
	      return type.name == name;
	    });
	    _this.state = {
	      roles: roles,
	      contactAdmin: isAdmin.length
	    };
	    return _this;
	  }
	
	  _createClass(JobRequestHistory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch(syncActions.setNavState({ isOpen: false, hideClose: false }));
	    }
	  }, {
	    key: 'onJobRequestTermsChange',
	    value: function onJobRequestTermsChange() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      this.props.dispatch(adminStore.updateJobRequestTerms(terms));
	    }
	  }, {
	    key: 'onJobRequestFilterChange',
	    value: function onJobRequestFilterChange() {
	      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this.props.dispatch(adminStore.updateJobRequestFilters(filters));
	    }
	  }, {
	    key: 'fetchJobRequests',
	    value: function fetchJobRequests() {
	      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _this2 = this;
	
	      var terms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var skip = arguments[2];
	
	      var callbacks = {
	        success: function success(items) {
	          return _this2.props.dispatch(jobRequestStore.updateJobRequests(items));
	        },
	        error: function error(err) {
	          return console.error('getAllJobs failed', err);
	        }
	      };
	
	      this.props.dispatch(jobRequestApi.getAllJobs(callbacks, skip, terms, filters, this.props.contactProfile.company.id));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _ref = this.props || {},
	          jobs = _ref.jobs;
	
	      var columns = ['IdNoLink', 'Date', 'Title', 'Openings', 'Status', 'Actions'];
	      var isHR = Boolean(this.state.contactAdmin); // check if contact's type is one of the admin roles
	
	      if (isHR) {
	        columns.splice(4, 0, 'Contact');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'job-request-history' },
	        _react2.default.createElement(_JobRequestTable2.default, {
	          jobRequestsList: jobs,
	          contacts: this.props.contacts,
	          disableEditButton: this.disableEditButton,
	          columns: columns,
	          companyId: this.props.contactProfile.company.id,
	          showContactFilter: this.state.contactAdmin ? true : false,
	          linksInNewTab: true,
	          onJobRequestTermsChange: this.onJobRequestTermsChange.bind(this),
	          onJobRequestFilterChange: this.onJobRequestFilterChange.bind(this),
	          fetchJobs: this.fetchJobRequests.bind(this),
	          searchTerms: this.props.searchTerms || [],
	          filters: this.props.filters,
	          showFilters: false
	        }),
	        this.props.allowAddJobRequest && !this.props.bqpMigrationFeature && _react2.default.createElement(
	          'div',
	          { className: 'add-job-button', 'data-id': 'Add Job Request' },
	          _react2.default.createElement(_Button2.default, {
	            'data-id': 'add-button',
	            className: 'button-main-large',
	            onClick: function onClick() {
	              return _this3.props.dispatch((0, _reactRouterRedux.push)('/client/jobrequest'));
	            },
	            label: 'Add Job Request' })
	        )
	      );
	    }
	  }]);
	
	  return JobRequestHistory;
	}(_react.Component), _class2.propTypes = {
	  contactProfile: _react.PropTypes.object,
	  jobs: _react.PropTypes.array,
	  contacts: _react.PropTypes.array,
	  dispatch: _react.PropTypes.func.isRequired,
	  searchTerms: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
	  filters: _react.PropTypes.object,
	  staticData: _react.PropTypes.object,
	  allowAddJobRequest: _react.PropTypes.object,
	  bqpMigrationFeature: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = JobRequestHistory;
	function OnEnterLoadJobRequestHistory(store) {
	
	  return function (nextState, replace, done) {
	    var state = store.getState();
	    var companyId = (0, _lodash.get)(state, 'user.companyId');
	
	    loadJobRequestHistory(companyId, store.dispatch).then(function () {
	      done();
	    }).catch(function (err) {
	      return done(err || new Error('An error occurred in OnEnterLoadJobRequestHistory.'));
	    });
	
	    done();
	  };
	}
	
	function loadJobRequestHistory(companyId, dispatch) {
	
	  var callbacks = {
	    success: function success(items) {
	      return dispatch(jobRequestStore.updateJobRequests(items));
	    },
	    error: function error(err) {
	      return console.error('getAllJobs failed', err);
	    }
	  };
	
	  var companyJobsPromise = dispatch(jobRequestApi.getAllJobs(callbacks, 0, [], {}, companyId));
	
	  var companyContactsPromise = dispatch(companyApi.getCompanyContacts(companyId, function (err, data) {
	    var companyContacts = (0, _lodash.get)(data, 'body.data.items', []);
	    dispatch(companyStore.updateCompanyContacts(companyContacts));
	    return companyContacts;
	  }));
	
	  return Promise.all([companyJobsPromise, companyContactsPromise]);
	}

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _enums = __webpack_require__(92);
	
	var _CandidateIcon = __webpack_require__(452);
	
	var _CandidateIcon2 = _interopRequireDefault(_CandidateIcon);
	
	var _ContactIcon = __webpack_require__(454);
	
	var _ContactIcon2 = _interopRequireDefault(_ContactIcon);
	
	var _CompanyIcon = __webpack_require__(453);
	
	var _CompanyIcon2 = _interopRequireDefault(_CompanyIcon);
	
	var _JobRequestIcon = __webpack_require__(455);
	
	var _JobRequestIcon2 = _interopRequireDefault(_JobRequestIcon);
	
	var _LogoSmall = __webpack_require__(456);
	
	var _LogoSmall2 = _interopRequireDefault(_LogoSmall);
	
	var _MenuIcon = __webpack_require__(457);
	
	var _MenuIcon2 = _interopRequireDefault(_MenuIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationContact = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    contact: state.contactProfile,
	    navState: state.ui.navState,
	    allowAddJobRequest: state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.QUALIFIED_PROSPECT || state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.ACTIVE_ACCOUNT || state.contactProfile.company.companyStatus === _enums.COMPANY_STATUS.INACTIVE_ACCOUNT,
	    bqpMigrationFeature: state.staticData.featureToggles.find(function (feature) {
	      return feature.hardcodelink === 'BQP_MIGRATION_FEATURE';
	    }).value === true
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(NavigationContact, _React$Component);
	
	  function NavigationContact(props) {
	    _classCallCheck(this, NavigationContact);
	
	    var _this = _possibleConstructorReturn(this, (NavigationContact.__proto__ || Object.getPrototypeOf(NavigationContact)).call(this, props));
	
	    _this.toggleNavigation = function (event) {
	      _this.setState({ isOpen: !_this.state.isOpen });
	    };
	
	    _this.handleClick = function (event, url) {
	      _this.props.dispatch((0, _reactRouterRedux.push)(url));
	    };
	
	    _this.checkContactStatus = function (event) {
	
	      _this.handleClick(event, '/client/jobrequest');
	    };
	
	    _this.state = {
	      isOpen: false,
	      hideClose: false
	    };
	    return _this;
	  }
	
	  _createClass(NavigationContact, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps && nextProps.navState && nextProps.navState.isOpen !== undefined) {
	
	        this.setState(nextProps.navState);
	      }
	    }
	
	    // eslint-disable-next-line no-unused-vars
	
	  }, {
	    key: 'isActiveSection',
	    value: function isActiveSection(path) {
	      return this.props.location.pathname === path;
	    }
	  }, {
	    key: 'isActiveSections',
	    value: function isActiveSections(paths) {
	      return !!~paths.indexOf(this.props.location.pathname.toLowerCase());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var allowAddJobRequest = this.props.allowAddJobRequest && !this.props.bqpMigrationFeature;
	      return _react2.default.createElement(
	        'div',
	        { className: 'navigation-contact ' + (this.state.isOpen ? ' open' : '') + '  ' + (this.state.isDisabled ? ' disabled' : '') },
	        _react2.default.createElement(_LogoSmall2.default, { collapsed: !this.state.isOpen, className: 'navigation-contact-logo', style: { color: '#fefefe', backgroundColor: '#161a21' } }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'navigation-contact-list' },
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'contact-dashboard', className: this.isActiveSection('/client') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/client');
	              } },
	            _react2.default.createElement(_CandidateIcon2.default, null),
	            _react2.default.createElement(
	              'label',
	              null,
	              'My Account'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'company-dashboard', className: this.isActiveSection('/client/company') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/client/company');
	              } },
	            _react2.default.createElement(_CompanyIcon2.default, null),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Company'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'jobrequesthistory-link', className: this.isActiveSection('/client/jobrequesthistory') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/client/jobrequesthistory');
	              } },
	            _react2.default.createElement(_JobRequestIcon2.default, null),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Job Requests'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'navigation-contact-list menu' },
	          !this.props.bqpMigrationFeature && _react2.default.createElement(
	            'li',
	            { 'data-id': 'add-contact-link', className: this.isActiveSection('/client/newcontact') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.handleClick(event, '/client/newcontact');
	              } },
	            _react2.default.createElement(_ContactIcon2.default, { showPlus: true }),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Add Contact'
	            )
	          ),
	          allowAddJobRequest && _react2.default.createElement(
	            'li',
	            { 'data-id': 'add-job-req-link', className: this.isActiveSection('/client/jobrequest') ? 'active' : '',
	              onClick: function onClick(event) {
	                return _this2.checkContactStatus(event);
	              } },
	            _react2.default.createElement(_JobRequestIcon2.default, { showPlus: true }),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Add Job Req.'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { 'data-id': 'close-btn', onClick: this.toggleNavigation },
	            _react2.default.createElement(_MenuIcon2.default, { isOpen: this.state.isOpen }),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Close'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavigationContact;
	}(_react2.default.Component), _class2.propTypes = {
	  location: _react.PropTypes.object.isRequired,
	  allowAddJobRequest: _react.PropTypes.bool,
	  bqpMigrationFeature: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = NavigationContact;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = JobRequestLinks;
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function JobRequestLinks(props) {
	
	  var links = [{ key: 'position', name: 'Position Info', route: props.jobId ? '/client/jobrequest/' + props.jobId : '/client/jobrequest' }, { key: 'description', name: 'Job Description', route: '/client/jobrequest/' + (props.jobId || 0) + '/description' }, { key: 'adddocuments', name: 'Add Documents', route: '/client/jobrequest/' + (props.jobId || 0) + '/adddocuments' }, { key: 'skills', name: 'Skills', route: '/client/jobrequest/' + (props.jobId || 0) + '/skills' }, { key: 'summary', name: 'Summary of Skills', route: '/client/jobrequest/' + (props.jobId || 0) + '/skills/summary' }, { key: 'workschedule', name: 'Work Schedule', route: '/client/jobrequest/' + (props.jobId || 0) + '/workschedule' }, { key: 'addcontact', name: 'Reporting', route: '/client/jobrequest/' + (props.jobId || 0) + '/addcontact' }, { key: 'authorize', name: 'Authorize', route: '/client/jobrequest/' + (props.jobId || 0) + '/authorize' }];
	
	  var navigateTo = function navigateTo(link) {
	    return function (event) {
	      props.dispatch((0, _reactRouterRedux.push)(link.route));
	    };
	  };
	
	  return _react2.default.createElement(
	    'ul',
	    { className: 'job-request-links' },
	    links.map(function (link, index) {
	      return _react2.default.createElement(
	        'li',
	        {
	          key: link.name,
	          'data-id': link.name,
	          className: (0, _classnames2.default)({ active: link.name === props.activeLink }),
	          onClick: navigateTo(link)
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'job-request-checkmark' },
	          (props.completed || {})[link.key] ? '✔ ' : ''
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          link.name
	        )
	      );
	    })
	  );
	}
	
	JobRequestLinks.propTypes = {
	  activeLink: _react.PropTypes.string,
	  jobId: _react.PropTypes.integer,
	  completed: _react.PropTypes.object
	};

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ContactSubNavigation;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContactSubNavigation(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'contact-sub-navigation' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      props.title
	    ),
	    props.children
	  );
	}

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _form = __webpack_require__(168);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	var _staticData = __webpack_require__(28);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _sync = __webpack_require__(21);
	
	var syncActions = _interopRequireWildcard(_sync);
	
	var _reactRouter = __webpack_require__(51);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var yesNo = [{ value: true, primaryText: 'Yes' }, { value: false, primaryText: 'No' }];
	var vendorProprietary = [{ value: true, primaryText: 'Vendor' }, { value: false, primaryText: 'Proprietary' }];
	
	var techFields = {
	  required: [],
	  optional: ['additionalInfo', 'internalUseOnly', 'vendorName', 'vendorVersion', 'vendorLocation', 'vendorAgencyCode', 'phoneProvider', 'remoteConnectivityOther', 'hasVolumeLicensing', 'hasRemoteExtensions', 'remoteExtensionType', 'remoteExtensionTypeOther', 'needAssistance', 'remoteConnectivity', 'remoteVendor', 'ipOrHostname', 'isVendorSystem', 'hasWahveExtension', 'requiresMSOffice', 'webConfSoftwareId', 'webConfSoftwareOther', 'mfaLogin']
	};
	
	var TechQA = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    contact: state.contactProfile,
	    staticData: state.staticData,
	    companyId: parseInt(props.params.companyId, 10) || 0,
	    isAdmin: (0, _lodash.intersection)(['Admin', 'Employee'], state.user.roles).length ? true : false,
	    isInternalUseEnabled: state.user.privs.includes('ENABLE_INTERNAL_IT_NOTES'),
	    labels: (0, _lodash.get)(state, 'labels.Client.Company.ClientTechQA', {}),
	    webConfSoftwareOther: (0, _lodash.get)(state, 'staticData.webConfSoftware', []).find(function (software) {
	      return software.hardcodelink === 'OTHER';
	    })
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(TechQA, _React$Component);
	
	  function TechQA(props, context) {
	    _classCallCheck(this, TechQA);
	
	    var _this = _possibleConstructorReturn(this, (TechQA.__proto__ || Object.getPrototypeOf(TechQA)).call(this, props, context));
	
	    _this.state = {
	      showErrors: false,
	      tech: null,
	      saveDisabled: true
	    };
	    return _this;
	  }
	
	  _createClass(TechQA, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.loadTech(this.props);
	      this.props.dispatch(syncActions.setNavState({ isOpen: true, hideClose: true, isDisabled: true }));
	
	      this.props.router.setRouteLeaveHook(this.props.route, function () {
	        _this2.props.dispatch(syncActions.setNavState({ isOpen: true, hideClose: false, isDisabled: false }));
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.loadTech(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dispatch(syncActions.setNavState({ isOpen: true, hideClose: false, isDisabled: false }));
	    }
	  }, {
	    key: 'loadTech',
	    value: function loadTech(props) {
	      var _this3 = this;
	
	      var companyId = this.props.companyId || (0, _lodash.get)(props.contact, 'company.id', null);
	      if (companyId && !this.state.tech) {
	        props.dispatch(companyApi.getCompanyTech(companyId, function (err, data) {
	          if (err === null && data !== null) {
	            // load tech and load form data once that's loaded
	            _this3.setState({ tech: data.items[0] || {} }, function () {
	              return _this3.setState({ techForm: (0, _form.mapFormFields)(_this3.state.tech, techFields.required, techFields.optional) });
	            });
	          }
	        }));
	      }
	    }
	  }, {
	    key: 'handleCancel',
	    value: function handleCancel() {
	      this.props.dispatch(syncActions.setNavState({ isOpen: true, hideClose: false, isDisabled: false }));
	      var path = this.props.isAdmin ? '/admin/companies/' + this.props.companyId + '/details/' : '/client/company';
	      this.props.dispatch((0, _reactRouterRedux.push)(path));
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave() {
	      var _this4 = this;
	
	      (0, _form.validateForm)(this.state.techForm, techFields);
	      var showErrors = this.hasErrors(this.state.techForm);
	      if (showErrors) {
	        return this.setState((0, _lodash.merge)({}, _extends({}, this.state), { showErrors: showErrors }));
	      }
	
	      var updatedTech = (0, _lodash.reduce)(this.state.techForm, function (form, model, prop) {
	        var newModel = {};
	        newModel[prop] = model;
	        form = (0, _lodash.merge)(form, (0, _form.reduceToValues)(newModel));
	        return form;
	      }, {});
	
	      updatedTech.companyId = this.props.companyId || (0, _lodash.get)(this.props.contact, 'company.id', null);
	
	      var techFunc = 'createCompanyTech';
	      if ((0, _lodash.get)(this.state.tech, 'id', null)) {
	        techFunc = 'updateCompanyTech';
	      }
	
	      this.props.dispatch(companyApi[techFunc](updatedTech, function (err) {
	
	        if (err) {
	          console.error(techFunc + ' failed.');
	          return;
	        }
	
	        _this4.props.dispatch(ui.showSnackBar());
	
	        if (_this4.props.companyId === 0) {
	          _this4.props.dispatch((0, _reactRouterRedux.push)('/client/company'));
	        }
	      }));
	      this.setState((0, _lodash.merge)({}, _extends({}, this.state), { saveDisabled: true }));
	    }
	  }, {
	    key: 'hasErrors',
	    value: function hasErrors(form) {
	      return (0, _lodash.reduce)(form, function (errors, model, prop) {
	        var newModel = {};
	        newModel[prop] = model;
	        return (0, _form.fieldsHasErrors)(newModel) || errors;
	      }, false);
	    }
	  }, {
	    key: 'checkValue',
	    value: function checkValue(field, value) {
	      return (0, _lodash.get)(this.state.techForm, field + '.value', null) === value || (0, _lodash.get)(this.state.techForm, field + '.defaultValue', null) === value && this.state.techForm[field].value === undefined;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, prop, value) {
	      var techForm = (0, _lodash.get)((0, _lodash.merge)({}, _extends({}, this.state)), 'techForm');
	      (0, _form.updateFormFields)(techForm, prop, value === undefined || value === null ? event.target.value : value);
	      var showErrors = this.hasErrors(techForm);
	      this.setState((0, _lodash.merge)({}, (0, _lodash.omit)(this.state, ['techForm']), { techForm: techForm, showErrors: showErrors, saveDisabled: false }));
	    }
	  }, {
	    key: 'renderFieldProperties',
	    value: function renderFieldProperties(prop, label) {
	      var _this5 = this;
	
	      var field = (0, _lodash.get)(this.state.techForm, '' + prop, {});
	
	      return {
	        'data-id': '' + prop,
	        defaultValue: field.defaultValue,
	        value: field.value === undefined ? field.defaultValue : field.value,
	        floatingLabelText: label,
	        floatingLabelFixed: true,
	        errorText: field.required ? (0, _lodash.get)(field, 'errors[0]') : undefined,
	        onChange: function onChange(event, value) {
	          return _this5.handleChange(event, prop, value);
	        }
	      };
	    }
	  }, {
	    key: 'renderDropDownFieldProperties',
	    value: function renderDropDownFieldProperties(prop, label, menuItems) {
	      return (0, _lodash.merge)(this.renderFieldProperties(prop, label), { menuItems: menuItems });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('tech-qa', { admin: this.props.isAdmin }) },
	        _react2.default.createElement(
	          'h3',
	          { className: 'close-button hover-link', 'data-id': 'close', onClick: function onClick() {
	              return _this6.handleCancel();
	            } },
	          'CLOSE ',
	          _react2.default.createElement(_CloseX2.default, { style: { color: '#000' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid tech-qa-inner-container' },
	          this.props.companyId === 0 && _react2.default.createElement(
	            'h1',
	            null,
	            'Technology Questions'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Remote Workstations Specifications'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box-container-fixed' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.renderFieldProperties('needAssistance', '' + (this.props.labels.needAssistance || ''))))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, this.renderDropDownFieldProperties('remoteConnectivity', 'Please select the methodology you use for remote connectivity', this.props.staticData.remoteConnectivityTypes))
	            ),
	            this.checkValue('remoteConnectivity', 4) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('remoteConnectivityOther', 'Other'))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('remoteVendor', ((0, _staticData.lookup)(this.props.staticData, 'remoteConnectivityTypes', { id: (0, _lodash.get)(this.state.techForm, 'remoteConnectivity.value', 0) }) || '') + ' Vendor: (e.g. Cisco, Microsoft)'))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('ipOrHostname', 'Host Name / IP'))
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Management System'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box-container-fixed' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: vendorProprietary
	              }, this.renderFieldProperties('isVendorSystem', 'Do you use a vendor or proprietary management system?')))
	            ),
	            this.checkValue('isVendorSystem', true) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('vendorName', 'Software Vendor Name'))
	            ),
	            this.checkValue('isVendorSystem', true) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('vendorVersion', 'Software Version'))
	            ),
	            this.checkValue('isVendorSystem', true) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('vendorLocation', 'Online Web Server Location'))
	            ),
	            this.checkValue('isVendorSystem', true) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('vendorAgencyCode', 'Agency Code (If Applicable)'))
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Phone System'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box-container-fixed' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.renderFieldProperties('hasWahveExtension', this.props.labels.hasWahveExtension)))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              this.props.labels.note
	            ),
	            this.checkValue('hasWahveExtension', true) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.renderFieldProperties('hasRemoteExtensions', 'Can your system support remote extensions?')))
	            ),
	            this.checkValue('hasWahveExtension', true) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, this.renderDropDownFieldProperties('remoteExtensionType', 'What method will you use for the remote extension?', this.props.staticData.remoteExtensionTypes))
	            ),
	            this.checkValue('hasWahveExtension', true) && this.checkValue('remoteExtensionType', 5) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('remoteExtensionTypeOther', 'Other'))
	            ),
	            this.checkValue('hasWahveExtension', true) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('phoneProvider', 'Who is your phone system provider?'))
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Software and Additional Information'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box-container-fixed' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, this.renderDropDownFieldProperties('webConfSoftwareId', this.props.labels.webConfSoftware, this.props.staticData.webConfSoftware))
	            ),
	            this.checkValue('webConfSoftwareId', this.props.webConfSoftwareOther.id) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, this.renderFieldProperties('webConfSoftwareOther', this.props.labels.webConfSoftwareOther))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.renderFieldProperties('requiresMSOffice', 'Does your setup require Microsoft Office?')))
	            ),
	            this.checkValue('requiresMSOffice', true) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.renderFieldProperties('hasVolumeLicensing', this.props.labels.hasVolumeLicensing)))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_ToggleButton2.default, _extends({
	                menuItems: yesNo
	              }, this.renderFieldProperties('mfaLogin', this.props.labels.mfaLogin)))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextArea2.default, _extends({
	                description: this.props.labels.additionalInfo
	              }, this.renderFieldProperties('additionalInfo', this.props.labels.additionalInfo)))
	            )
	          ),
	          this.props.isInternalUseEnabled && _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextArea2.default, _extends({
	                description: this.props.labels.internalUseOnly
	              }, this.renderFieldProperties('internalUseOnly', this.props.labels.internalUseOnly)))
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'row' },
	            _react2.default.createElement(
	              'li',
	              { className: 'col' },
	              this.state.showErrors && _react2.default.createElement(
	                'div',
	                { className: 'error-message' },
	                'Please fill out missing fields.'
	              )
	            ),
	            this.props.companyId === 0 && _react2.default.createElement(
	              'li',
	              { className: 'col' },
	              _react2.default.createElement(_Button2.default, {
	                className: 'button-secondary-large',
	                style: { width: '100%' },
	                label: 'Cancel',
	                onClick: function onClick(e) {
	                  return _this6.handleCancel(e);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'col' },
	              _react2.default.createElement(_Button2.default, {
	                disabled: this.state.saveDisabled,
	                className: 'button-main-large',
	                style: { width: '100%' },
	                label: 'Save',
	                onClick: function onClick(e) {
	                  return _this6.handleSave(e);
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TechQA;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  isAdmin: _react.PropTypes.bool,
	  isInternalUseEnabled: _react.PropTypes.bool,
	  labels: _react.PropTypes.object,
	  webConfSoftwareOther: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(TechQA);

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	exports.OnEnterLoadCompanyContacts = OnEnterLoadCompanyContacts;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _Navigation = __webpack_require__(1032);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _companies = __webpack_require__(49);
	
	var companyApi = _interopRequireWildcard(_companies);
	
	var _companies2 = __webpack_require__(63);
	
	var companyStore = _interopRequireWildcard(_companies2);
	
	var _UserMenu = __webpack_require__(469);
	
	var _UserMenu2 = _interopRequireDefault(_UserMenu);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _contacts = __webpack_require__(83);
	
	var contactApi = _interopRequireWildcard(_contacts);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _f_InfoModal = __webpack_require__(122);
	
	var _f_InfoModal2 = _interopRequireDefault(_f_InfoModal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientLanding = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    contact: state.contactProfile,
	    staticData: state.staticData,
	    ui: state.ui,
	    bqpMigrationFeature: state.staticData.featureToggles.find(function (feature) {
	      return feature.hardcodelink === 'BQP_MIGRATION_FEATURE';
	    }).value === true,
	    showBqpMigrationModal: true,
	    bqpClientMigrationLabels: state.labels.Client.BqpClientMigration
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ClientLanding, _Component);
	
	  function ClientLanding(props, context) {
	    _classCallCheck(this, ClientLanding);
	
	    var _this = _possibleConstructorReturn(this, (ClientLanding.__proto__ || Object.getPrototypeOf(ClientLanding)).call(this, props, context));
	
	    _this.state = {
	      showBqpMigrationModal: _this.props.bqpMigrationFeature
	    };
	    return _this;
	  }
	
	  _createClass(ClientLanding, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.sendBQPClientMigrationEmail();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.sendBQPClientMigrationEmail();
	    }
	
	    // determine if the onboarding email has ever been sent, or it has been at least 2 days since the onboarding email has been sent
	
	  }, {
	    key: 'checkSendBQPClientMigrationEmail',
	    value: function checkSendBQPClientMigrationEmail() {
	      if (this.props.contact.profile.lastBQPOnboardingEmailSentDate === null) {
	        return true;
	      }
	      var dateSent = (0, _moment2.default)(this.props.contact.profile.lastBQPOnboardingEmailSentDate);
	      var thresholdDays = 2; // send if we haven't sent for 2 days
	      var threshold = (0, _moment2.default)(new Date()).subtract(thresholdDays, 'days');
	
	      return threshold > dateSent;
	    }
	
	    // Send migration email if we haven't sent it in 2 days
	
	  }, {
	    key: 'sendBQPClientMigrationEmail',
	    value: function sendBQPClientMigrationEmail() {
	      var _this2 = this;
	
	      if (this.props.bqpMigrationFeature) {
	        if (this.props.contact.profile) {
	          if (this.checkSendBQPClientMigrationEmail()) {
	
	            // update redux store with lastBQPOnboardingEmailSentDate
	            var updatedContact = this.props.contact;
	            updatedContact.profile.lastBQPOnboardingEmailSentDate = new Date();
	            this.setState({ contact: updatedContact });
	
	            // update db with lastBQPOnboardingEmailSentDate
	            this.props.dispatch(contactApi.updateContactOnboardingEmailDate(updatedContact, function (err, data) {
	              if (err) {
	
	                // eslint-disable-next-line no-console
	                console.error(data);
	
	                // eslint-disable-next-line no-console
	                return console.error(err);
	
	                // eslint-disable-next-line no-else-return
	              } else {
	                _this2.props.dispatch(ui.showSnackBar('Updated Contact:lastBQPOnboardingEmailSent'));
	              }
	            }));
	          }
	        }
	      }
	    }
	
	    // save the fact that we've shown the migration modal in this session
	
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState((0, _lodash.merge)(this.state, { showBqpMigrationModal: false }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var migrationText = this.props.bqpClientMigrationLabels.message;
	      var migrationEmailLink = _react2.default.createElement(
	        'span',
	        { className: 'migration-modal-font-color' },
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:sales@wahve.com' },
	          this.props.bqpClientMigrationLabels.emailLinkText
	        )
	      );
	      var migrationModalEmailLink = _react2.default.createElement(
	        'div',
	        { className: 'migration-modal-font-color' },
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:sales@wahve.com' },
	          this.props.bqpClientMigrationLabels.emailLinkText
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'client-landing content-container' },
	        _react2.default.createElement(_UserMenu2.default, { dispatch: this.props.dispatch }),
	        _react2.default.createElement(_Navigation2.default, { location: this.props.location }),
	        // send migration email?
	        this.props.bqpMigrationFeature && _react2.default.createElement(
	          'div',
	          { className: 'migration-info-section' },
	          migrationText,
	          migrationEmailLink
	        ),
	        // show migration modal?
	        this.props.bqpMigrationFeature && this.state.showBqpMigrationModal && _react2.default.createElement(
	          'div',
	          { className: 'migration-modal-font-color' },
	          _react2.default.createElement(_f_InfoModal2.default, {
	            buttonLabel: 'close',
	            text: migrationText,
	            children: migrationModalEmailLink,
	            cancelFunc: this.closeModal.bind(this),
	            transitionFunc: this.closeModal.bind(this)
	          })
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ClientLanding;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  contact: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object,
	  bqpMigrationFeature: _react.PropTypes.bool,
	  bqpClientMigrationLabels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = ClientLanding;
	function OnEnterLoadCompanyContacts(store) {
	  return function (nextState, replace, done) {
	    var state = store.getState();
	    if ((0, _lodash.isEmpty)(state.companyContacts)) {
	      var companyId = (0, _lodash.get)(state, 'user.companyId');
	
	      store.dispatch(companyApi.getCompanyContacts(companyId, function (err, data) {
	        if (err || !data) {
	          return done(err || new Error('No contact profile found.'));
	        }
	        var companyContacts = (0, _lodash.get)(data, 'body.data.items', []);
	        store.dispatch(companyStore.updateCompanyContacts(companyContacts));
	        return done();
	      }));
	    }
	    done();
	  };
	}

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _Logo = __webpack_require__(123);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavColumn = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Common', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(NavColumn, _Component);
	
	  function NavColumn() {
	    _classCallCheck(this, NavColumn);
	
	    return _possibleConstructorReturn(this, (NavColumn.__proto__ || Object.getPrototypeOf(NavColumn)).apply(this, arguments));
	  }
	
	  _createClass(NavColumn, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'applicant-nav-column' },
	        _react2.default.createElement(
	          'a',
	          { href: this.props.labels.website },
	          _react2.default.createElement(_Logo2.default, { className: 'logo' })
	        )
	      );
	    }
	  }]);
	
	  return NavColumn;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = NavColumn;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _r_ApplicationForm = __webpack_require__(1039);
	
	var _r_ApplicationForm2 = _interopRequireDefault(_r_ApplicationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Application = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Common', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Application, _Component);
	
	  function Application() {
	    _classCallCheck(this, Application);
	
	    return _possibleConstructorReturn(this, (Application.__proto__ || Object.getPrototypeOf(Application)).apply(this, arguments));
	  }
	
	  _createClass(Application, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { className: 'instructions mobile-hide',
	          'data-id': 'Display Text', dangerouslySetInnerHTML: { __html: (0, _lodash.get)(this.props.labels, 'applyInstructions') } }),
	        _react2.default.createElement('div', { className: 'instructions mobile-only',
	          'data-id': 'Display Text', dangerouslySetInnerHTML: { __html: (0, _lodash.get)(this.props.labels, 'applyInstructionsMb') } }),
	        _react2.default.createElement(_r_ApplicationForm2.default, null)
	      );
	    }
	  }]);
	
	  return Application;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = Application;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	// import text question response lists
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _user = __webpack_require__(124);
	
	var _applicantProfile = __webpack_require__(313);
	
	var _dropdowns = __webpack_require__(206);
	
	var _materialUi = __webpack_require__(277);
	
	var _r_CreateUserModal = __webpack_require__(1047);
	
	var _r_CreateUserModal2 = _interopRequireDefault(_r_CreateUserModal);
	
	var _muiThemeable = __webpack_require__(394);
	
	var _muiThemeable2 = _interopRequireDefault(_muiThemeable);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _SimpleDropDownMenu = __webpack_require__(121);
	
	var _SimpleDropDownMenu2 = _interopRequireDefault(_SimpleDropDownMenu);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _index = __webpack_require__(211);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _updates = __webpack_require__(310);
	
	var _staticData = __webpack_require__(170);
	
	var _industryYearsExperienceList = __webpack_require__(873);
	
	var _industryYearsExperienceList2 = _interopRequireDefault(_industryYearsExperienceList);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _c_SourceSimpleFileInput2 = _interopRequireDefault(_c_SourceSimpleFileInput);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _querystring = __webpack_require__(105);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _SegmentsPositionsDepartments = __webpack_require__(300);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validationObj = {
	  user: _lodash2.default.omit((0, _user.getSchema)(), 'password'), // password gets validated in the next step
	  profile: (0, _applicantProfile.getSchema)()
	};
	
	var otherCountryValidation = {
	  user: {
	    countryOther: {
	      required: {
	        message: 'This field is required'
	      }
	    }
	  }
	};
	
	// this validation is designed to always fail, because when Canada is selected
	// as a country, this validation is decorated into the validation stack,
	// and it will not equal 12345 -- in other words it will always fail if used
	// as a validation -- this is by design.
	var canadaCountryValidation = {
	  user: {
	    country: {
	      matches: {
	        options: /^12345$/,
	        message: 'Please use the link above for Canadian applicants.'
	      }
	    }
	  }
	};
	
	var industryTypeOtherValidation = {
	  profile: {
	    insuranceTypeOther: {
	      required: {
	        message: 'This field is required'
	      }
	    }
	  }
	};
	
	var workedLastInIndustryYesNoValidation = {
	  profile: {
	    workedLastInIndustryYesNo: {
	      required: {
	        message: 'This field is required'
	      }
	    }
	  }
	};
	
	var ApplicationForm = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    user: store.prelimApplication.user,
	    profile: store.prelimApplication.profile,
	    staticData: store.staticData,
	    scrollBarWidth: store.browserData.scrollBarWidth,
	    labels: store.labels.PrelimForm
	  };
	}), _dec2 = (0, _muiThemeable2.default)(), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ApplicationForm, _Component);
	
	  function ApplicationForm(props, context) {
	    _classCallCheck(this, ApplicationForm);
	
	    // need to bind functions to self either here or in render
	    var _this = _possibleConstructorReturn(this, (ApplicationForm.__proto__ || Object.getPrototypeOf(ApplicationForm)).call(this, props, context));
	
	    _this.state = {
	      showCreateUserModal: false,
	      availabilityDateText: '',
	      availabilityDate: null,
	      showErrorMessage: false,
	      lastWorkedInIndustryItems: []
	    };
	
	    _this.componentDidMount = function () {
	      // Set Initial list of items (this is so that for non-insurance tenants, we have the whole list)
	      _this.setState({
	        lastWorkedInIndustryItems: _this.props.staticData.applicantYearsWorkedLastIndustry.filter(function (item) {
	          return !item.hide;
	        }).map(function (item) {
	          return item.text;
	        })
	      });
	      var firstTimeQueryString = _querystring2.default.parse(window.location.search.substring(1));
	      var countryList = _this.props.staticData.countryList;
	
	      var defaultCountry = countryList.find(function (c) {
	        return c.name === 'United States';
	      }).id || 0;
	      _this.setState({
	        prelimApplication: {
	          profile: {
	            firstTimeQueryString: firstTimeQueryString
	          },
	          user: {
	            country: defaultCountry
	          }
	        }
	      });
	      _this.props.profile.firstTimeQueryString = firstTimeQueryString;
	      _this.props.user.country = defaultCountry;
	    };
	
	    _this.onChange = function (propParent, prop, event, newVal) {
	      // update field
	      if (prop === 'optIntoNewsletter') {
	        _this.props.dispatch(syncActionCreators.updatePrelimForm(_defineProperty({}, propParent, _defineProperty({}, prop, !_this.refs.optIntoNewsletter.state.switched))));
	      } else {
	        _this.props.dispatch(syncActionCreators.updatePrelimForm(_defineProperty({}, propParent, _defineProperty({}, prop, newVal || event.target.value))));
	      }
	    };
	
	    _this.onCountryChange = function (event, value) {
	      var countryList = _this.props.staticData.countryList;
	
	      var updateUserCountry = (0, _updates.updateCountry)(countryList);
	      var user = updateUserCountry(value || event.target.value);
	
	      _this.props.dispatch(syncActionCreators.updatePrelimForm({ user: user }));
	    };
	
	    _this.onErrorChange = function (changeInt) {
	      _this.errorCount = _this.errorCount + changeInt;
	    };
	
	    _this.onLastWorkedChange = function (event, value) {
	      _this.setState({
	        prelimApplication: {
	          profile: {
	            workedLastInIndustry: null
	          }
	        },
	        lastWorkedInIndustryItems: value === true ? _this.props.staticData.applicantYearsWorkedLastIndustry.filter(function (item) {
	          return !item.hide && (item.text === 'Less than 1 year ago' || item.text === '1-5 years ago');
	        }).map(function (item) {
	          return item.text;
	        }) : _this.props.staticData.applicantYearsWorkedLastIndustry.filter(function (item) {
	          return !item.hide && item.text !== 'Less than 1 year ago' && item.text !== '1-5 years ago';
	        }).map(function (item) {
	          return item.text;
	        })
	      }, function () {
	        _this.props.profile.workedLastInIndustry = null;
	        _this.refs.workedLastInIndustry.validate();
	      });
	    };
	
	    _this.today = new Date();
	    _this.errorCount = 0;
	
	    _this.onUploadStart = function (err, infoObj) {
	      var inc = 65;
	      var getIncrementedChar = function getIncrementedChar() {
	        return String.fromCharCode(inc++);
	      };
	      var clientId = '' + getIncrementedChar() + _shortid2.default.generate();
	      _this.props.dispatch(syncActionCreators.updatePrelimForm({
	        profile: {
	          resumeClientId: clientId,
	          resumeFileName: infoObj.name,
	          resumeFileSize: infoObj.size,
	          resumeStoragePath: infoObj.nameWithFolder
	        }
	      }));
	    };
	
	    _this.onS3Load = function (err) {
	      // updating UI optimistically so we only need to know if there was an error
	      if (err && ("production") !== 'production') {
	        console.error(err);
	      }
	    };
	
	    _this.handleUI = _this.handleUI.bind(_this);
	    _this.toggleShowCreateUserModal = _this.toggleShowCreateUserModal.bind(_this);
	    _this.yearsExperienceList = _lodash2.default.times(35, function (i) {
	      return i + 1;
	    });
	    return _this;
	  }
	
	  // refilter the list of items based on if the insurance applicant has worked in the industry in the last 5 years or not
	
	
	  _createClass(ApplicationForm, [{
	    key: 'handleLastWorkedDropDown',
	    value: function handleLastWorkedDropDown() {
	      var attributes = this.handleUI('workedLastInIndustryYesNo');
	      attributes.onChange = this.onLastWorkedChange;
	      return attributes;
	
	      // return {onChange: this.onLastWorkedChange};
	    }
	
	    // decorate static validation with dynamic validation
	
	  }, {
	    key: 'validationSchema',
	    value: function validationSchema() {
	
	      var dynamicValidation = _lodash2.default.merge({}, validationObj); // do *not* merge into validationObj
	
	      var _props$staticData = this.props.staticData,
	          countryList = _props$staticData.countryList,
	          industryTypesList = _props$staticData.industryTypesList,
	          account = _props$staticData.account;
	      var _props = this.props,
	          user = _props.user,
	          profile = _props.profile;
	
	      var canadaCountry = countryList.find(function (c) {
	        return c.name === 'Canada';
	      });
	      var otherCountry = countryList.find(function (c) {
	        return c.subElement === 'Other';
	      });
	      var otherIndustryType = (0, _lodash.get)((0, _lodash.find)(industryTypesList, { subElement: 'Other' }), 'id');
	
	      if (user.country === canadaCountry.id) {
	        _lodash2.default.merge(dynamicValidation, canadaCountryValidation);
	      }
	
	      if (otherCountry && user.country === otherCountry.id) {
	        _lodash2.default.merge(dynamicValidation, otherCountryValidation);
	      }
	      if (!!(0, _lodash.get)(profile, 'industryTypes', []).includes(otherIndustryType)) {
	        _lodash2.default.merge(dynamicValidation, industryTypeOtherValidation);
	      }
	      if (account.hardcodelink === 'WAHVE') {
	        _lodash2.default.merge(dynamicValidation, workedLastInIndustryYesNoValidation);
	      }
	
	      return dynamicValidation;
	    }
	  }, {
	    key: 'handleUI',
	    value: function handleUI(prop, bindOnChange) {
	      var _ref;
	
	      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var bindOnClick = arguments[3];
	
	      var propParent = this.props.user.hasOwnProperty(prop) ? 'user' : 'profile';
	      var propValidationObj = this.validationSchema()[propParent][prop];
	      var changeAction = bindOnChange ? 'onChange' : 'onBlur';
	      if (bindOnClick) {
	        changeAction = 'onClick';
	      }
	      return _ref = {
	        'data-id': prop,
	        floatingLabelText: _lodash2.default.get(this.props.labels, prop)
	      }, _defineProperty(_ref, changeAction, this.onChange.bind(this, propParent, prop)), _defineProperty(_ref, 'onErrorChange', this.onErrorChange), _defineProperty(_ref, 'validation', propValidationObj), _defineProperty(_ref, 'ref', prop), _defineProperty(_ref, 'defaultValue', defaultValue === null ? this.props[propParent][prop] : defaultValue), _ref;
	    }
	  }, {
	    key: 'handleCountryDropDown',
	    value: function handleCountryDropDown(prop, bindOnChange) {
	      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var attributes = this.handleUI(prop, true, defaultValue);
	      attributes.onChange = this.onCountryChange;
	      return attributes;
	    }
	  }, {
	    key: 'toggleShowCreateUserModal',
	    value: function toggleShowCreateUserModal() {
	      var _this2 = this;
	
	      if (!!this.errorCount) {
	        // trigger blur event to force validation errors
	        for (var refKey in this.refs) {
	          if (this.refs[refKey].checkErrors) {
	            this.refs[refKey].checkErrors();
	          }
	        }
	        this.setState(function (state) {
	          return _lodash2.default.merge({}, state, {
	            showErrorMessage: true
	          });
	        });
	      } else {
	        this.setState(function (state) {
	          return _lodash2.default.merge({}, state, {
	            showCreateUserModal: !_this2.state.showCreateUserModal,
	            showErrorMessage: false
	          });
	        });
	      }
	    }
	
	    // styling obj
	
	  }, {
	    key: 'renderStateZip',
	    value: function renderStateZip(state, props) {
	      var _props$staticData2 = props.staticData,
	          _props$staticData2$st = _props$staticData2.stateList,
	          stateList = _props$staticData2$st === undefined ? [] : _props$staticData2$st,
	          _props$staticData2$co = _props$staticData2.countryList,
	          countryList = _props$staticData2$co === undefined ? [] : _props$staticData2$co;
	
	      var selectedCountry = (0, _lodash.get)(props, 'user.country');
	      var otherCountry = countryList.find(function (c) {
	        return c.subElement === 'Other';
	      });
	      var us = countryList.find(function (c) {
	        return c.name === 'United States';
	      });
	
	      if (!_lodash2.default.isNil(selectedCountry) && otherCountry && selectedCountry === otherCountry.id) {
	
	        return _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('countryOther'), {
	          floatingLabelText: 'Please specify country' }));
	      } else if (!selectedCountry || us && selectedCountry === us.id) {
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'box-c' },
	          _react2.default.createElement(
	            'div',
	            { className: 'box-i' },
	            _react2.default.createElement(_SimpleDropDownMenu2.default, _extends({
	              menuItems: _lodash2.default.concat({ primaryText: 'Select', value: 0 }, stateList),
	              underlineStyle: { margin: '-1px 0px' },
	              iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	              labelStyle: { paddingLeft: '0px' }
	            }, this.handleUI('state', true, 0), {
	              floatingLabelText: 'State' }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box-i' },
	            _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	              hideMaskChar: true,
	              mask: '99999'
	            }, this.handleUI('zip'), {
	              floatingLabelText: 'Zip' }))
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          user = _props2.user,
	          profile = _props2.profile,
	          scrollBarWidth = _props2.scrollBarWidth;
	      var _props$staticData3 = this.props.staticData,
	          foundUsViaList = _props$staticData3.foundUsViaList,
	          employmentStatusList = _props$staticData3.employmentStatusList,
	          bestContactTimeList = _props$staticData3.bestContactTimeList,
	          timezoneList = _props$staticData3.timezoneList,
	          industryTypesList = _props$staticData3.industryTypesList,
	          countryList = _props$staticData3.countryList,
	          phoneTypeList = _props$staticData3.phoneTypeList,
	          applicantWorkFromHomeReasonsList = _props$staticData3.applicantWorkFromHomeReasonsList,
	          applicantTotalYearsExperience = _props$staticData3.applicantTotalYearsExperience;
	
	
	      var addButtonStyle = {
	        display: 'inline-block',
	        top: '11px',
	        width: '165px',
	        transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
	      };
	
	      var foundUsVia = (0, _staticData.referralsByRole)(foundUsViaList);
	      var otherIndustryType = (0, _lodash.get)((0, _lodash.find)(industryTypesList, { subElement: 'Other' }), 'id');
	      var otherfoundUsVia = (0, _lodash.get)((0, _lodash.find)(foundUsViaList, { name: 'Other, Please Specify:' }), 'id');
	      var menuItems = _lodash2.default.concat({ primaryText: 'Select', value: 0 }, foundUsVia.sort(_dropdowns.defaultOrdering));
	
	      var _getSegmentsPositions = (0, _SegmentsPositionsDepartments.getSegmentsPositionsDepartments)(this.props),
	          segments = _getSegmentsPositions.segments,
	          positions = _getSegmentsPositions.positions,
	          departments = _getSegmentsPositions.departments;
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'application-form clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-section clearfix application-section-container contact-information' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'form-section-header' },
	            'Contact Information'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'box-container-fixed clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('firstName'), {
	                floatingLabelText: 'First Name' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                optional: true
	              }, this.handleUI('middleName'), {
	                floatingLabelText: 'Middle Name or Initial' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('lastName'), {
	                floatingLabelText: 'Last Name' }))
	            ),
	            [null].map(function (val, index) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'box ' + (index > 0 ? 'mobile-hide' : '') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-c', key: index },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-i' },
	                    _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	                      hideMaskChar: true
	
	                      // floatingLabelFixed
	                      , optional: index > 0,
	                      value: user['phoneNumber' + (index + 1)],
	                      mask: '(999) 999-9999'
	                    }, _this3.handleUI('phoneNumber' + (index + 1)), {
	                      floatingLabelText: 'Phone Number' }))
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-i' },
	                    _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                      menuItems: phoneTypeList
	                    }, _this3.handleUI('phoneType' + (index + 1), true, 0)))
	                  )
	                )
	              );
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('email'), {
	                floatingLabelText: 'Email' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: countryList,
	                value: user.country | countryList.find(function (c) {
	                  return c.name === 'United States';
	                }).id
	              }, this.handleCountryDropDown('country', true), {
	                floatingLabelText: 'Country of Residence',
	                disabled: true
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: bestContactTimeList
	              }, this.handleUI('bestContactTime', true), {
	                floatingLabelText: 'What is the best time to call you?' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              this.renderStateZip(this.state, this.props)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: timezoneList
	              }, this.handleUI('timezone', true), {
	                floatingLabelText: 'Time Zone' }))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'preliminary-info form-section clearfix' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'form-section-header' },
	            'Preliminary Information'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box-container-fixed clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: employmentStatusList
	              }, this.handleUI('employmentStatus', true), {
	                floatingLabelText: 'Employment status' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_DateInput2.default, _extends({
	                autoOk: true,
	                dateFormat: 'Full',
	                floatingLabelFocusStyle: { whiteSpace: 'normal' },
	                floatingLabelFixed: true,
	                minDate: this.today,
	                textStyle: { margin: '' },
	                isDirty: this.state.showErrorMessage
	              }, this.handleUI('availabilityDate', false), {
	                floatingLabelText: 'When are you available to start?' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: this.yearsExperienceList
	              }, this.handleUI('totalYearsExperienceNumeric'), {
	                floatingLabelText: 'Total Years Experience' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: this.yearsExperienceList
	              }, this.handleUI('industryYearsExperienceNumeric'), {
	                floatingLabelText: 'Industry Years Experience' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: ['Yes', 'No'],
	                floatingLabelText: (0, _lodash.get)(this.props.labels, 'workedLastInIndustryYesNo')
	              }, this.handleLastWorkedDropDown('workedLastInIndustryYesNo', true)))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_CheckList2.default, _extends({
	                menuItems: industryTypesList,
	                scrollBarWidth: scrollBarWidth
	              }, this.handleUI('industryTypes', true)))
	            ),
	            !!(0, _lodash.get)(profile, 'industryTypes', []).includes(otherIndustryType) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('insuranceTypeOther'), {
	                floatingLabelText: 'Please specify' }))
	            ),
	            this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: segments
	              }, this.handleUI('mostRecentSegment', true)))
	            ),
	            this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: departments,
	                floatingLabelText: 'department'
	              }, this.handleUI('mostRecentDepartment', true)))
	            ),
	            this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                menuItems: positions,
	                floatingLabelText: 'position'
	              }, this.handleUI('mostRecentPosition', true)))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_CheckList2.default, _extends({
	                menuItems: applicantWorkFromHomeReasonsList,
	                scrollBarWidth: scrollBarWidth
	              }, this.handleUI('workFromHomeReasons', true), {
	                floatingLabelText: 'Please let us know why you want to work from home. Select as many that apply.' }))
	            ),
	            !!(profile.workFromHomeReasons && profile.workFromHomeReasons.includes((applicantWorkFromHomeReasonsList.find(function (t) {
	              return t.name === 'Other, Please Specify';
	            }) || {}).id)) && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('workFromHomeReasonOther'), {
	                floatingLabelText: 'Please Specify' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_SimpleDropDownMenu2.default, _extends({
	                canAutoPosition: 'true',
	                menuItems: menuItems,
	                pickedSub: Math.random() > 0.5 ? 'Other' : '',
	                underlineStyle: { margin: '-1px 0px' },
	                iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                labelStyle: { paddingLeft: '0px' }
	              }, this.handleUI('foundUsVia', true, 0)))
	            ),
	            profile.foundUsVia === otherfoundUsVia && _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_c_TextField2.default, _extends({}, this.handleUI('foundUsOther'), {
	                floatingLabelText: 'Please Specify' }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'box' },
	              _react2.default.createElement(_materialUi.Checkbox, _extends({
	                label: (0, _lodash.get)(this.props.labels, 'optIntoNewsletter'),
	                labelStyle: { fontSize: 14 }
	              }, this.handleUI('optIntoNewsletter', null, null, true)))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'form-section-header' },
	          'Please Attach Your Resume'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'documents-container application-section-container clearfix' },
	          profile.resumeFileName !== undefined && _react2.default.createElement(
	            'div',
	            { style: { color: 'red' } },
	            'Your Resume is Attached'
	          ),
	          _react2.default.createElement(
	            _c_SourceSimpleFileInput2.default,
	            {
	              className: 'file-uploader',
	              noMessage: true,
	              pristineClass: '',
	              loadingClass: '',
	              successClass: '',
	              failureClass: '',
	              accept: ['pdf', 'doc', 'docx', 'tiff', 'txt', 'JPG', 'JPEG', 'jpg', 'jpeg', 'png'],
	              remoteFolder: 'applicants',
	              onLoadStart: this.onUploadStart,
	              onS3Load: this.onS3Load,
	              signingRoute: '/api/s3/put-sign',
	              maxSize: ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).AWS_FILE_UPLOAD_SIZE,
	              accountId: this.props.staticData.account.id
	            },
	            _react2.default.createElement(_c_FlatButton2.default, {
	              style: _extends({}, addButtonStyle),
	              label: 'Attach File'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-submit-container' },
	          _react2.default.createElement(_c_RaisedButton2.default, { label: 'Continue',
	            onClick: this.toggleShowCreateUserModal }),
	          this.state.showErrorMessage && _react2.default.createElement(
	            'div',
	            { className: 'error-message' },
	            'Please fill out the required fields above.'
	          )
	        ),
	        this.state.showCreateUserModal && _react2.default.createElement(_r_CreateUserModal2.default, { closeFunction: this.toggleShowCreateUserModal }),
	        _react2.default.createElement(_index2.default, null)
	      );
	    }
	  }]);
	
	  return ApplicationForm;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  scrollBarWidth: _react.PropTypes.number,
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class) || _class);
	exports.default = ApplicationForm;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	// import customized material UI element
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _f_PasswordWithValidators = __webpack_require__(299);
	
	var _f_PasswordWithValidators2 = _interopRequireDefault(_f_PasswordWithValidators);
	
	var _JoveoTrackingPixel = __webpack_require__(210);
	
	var _JoveoTrackingPixel2 = _interopRequireDefault(_JoveoTrackingPixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordEntry = (_temp = _class = function (_Component) {
	  _inherits(PasswordEntry, _Component);
	
	  function PasswordEntry(props, context) {
	    _classCallCheck(this, PasswordEntry);
	
	    var _this = _possibleConstructorReturn(this, (PasswordEntry.__proto__ || Object.getPrototypeOf(PasswordEntry)).call(this, props, context));
	
	    _this.initState = { /* eslint react/sort-comp:0 */
	      confirmPassword: '',
	      confirmPasswordDirty: false,
	      passwordIsValid: false,
	      disableUserClosing: true
	    };
	    _this.state = Object.assign({}, _this.initState);
	
	
	    _this.resetPasswordState = _this.resetPasswordState.bind(_this);
	    return _this;
	  }
	
	  _createClass(PasswordEntry, [{
	    key: 'resetPasswordState',
	    value: function resetPasswordState() {
	      this.setState(Object.assign({}, this.initState));
	    }
	  }, {
	    key: 'passwordChange',
	    value: function passwordChange(event, password, passwordIsValid) {
	      if (!this.state.passwordIsValid && passwordIsValid) {
	        this.setState(_lodash2.default.merge(this.state, { passwordIsValid: passwordIsValid }));
	      } else if (this.state.passwordIsValid && !passwordIsValid) {
	        this.setState(_lodash2.default.merge(this.state, { passwordIsValid: passwordIsValid }));
	      }
	
	      this.props.updatePassword(password, passwordIsValid && password === this.state.confirmPassword);
	    }
	  }, {
	    key: 'confirmPasswordChange',
	    value: function confirmPasswordChange(event, confirmPassword) {
	      this.setState(_lodash2.default.merge(this.state, {
	        confirmPassword: confirmPassword
	      }));
	
	      if (this.state.passwordIsValid && this.props.password === this.state.confirmPassword) {
	        this.props.updatePassword(this.props.password, true);
	      } else if (this.props.passwordIsReady) {
	        this.props.updatePassword(this.props.password, false);
	      }
	    }
	  }, {
	    key: 'confirmPasswordBlur',
	    value: function confirmPasswordBlur() {
	      // make confirm password dirty on first blur
	      if (!this.state.confirmPasswordDirty) {
	        this.setState(_lodash2.default.merge(this.state, {
	          confirmPasswordDirty: true
	        }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-entry' },
	        _react2.default.createElement(_JoveoTrackingPixel2.default, { conversionType: 'preliminary-dropoff' }),
	        _react2.default.createElement(_c_TextField2.default, { className: 'full-width',
	          floatingLabelText: 'Email',
	          'data-id': 'Email',
	          value: this.props.email,
	          disabled: true }),
	        _react2.default.createElement(_f_PasswordWithValidators2.default, { value: this.props.password,
	          onChange: this.passwordChange.bind(this) }),
	        _react2.default.createElement(_c_TextField2.default, { className: 'full-width',
	          floatingLabelText: 'Confirm Password',
	          'data-id': 'Confirm Password',
	          password: true,
	          onChange: this.confirmPasswordChange.bind(this),
	          onBlur: this.confirmPasswordBlur.bind(this),
	          errorText: this.state.confirmPasswordDirty && this.state.confirmPassword !== this.props.password && 'Please make sure both password entries are the same' || undefined })
	      );
	    }
	  }]);
	
	  return PasswordEntry;
	}(_react.Component), _class.propTypes = {
	  updatePassword: _react.PropTypes.func,
	  password: _react.PropTypes.string,
	  passwordIsReady: _react.PropTypes.bool,
	  email: _react.PropTypes.string
	}, _temp);
	exports.default = PasswordEntry;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	// material-ui component
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LinearProgress = __webpack_require__(595);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WaitingSequence = (_temp = _class = function (_Component) {
	  _inherits(WaitingSequence, _Component);
	
	  function WaitingSequence(props, context) {
	    _classCallCheck(this, WaitingSequence);
	
	    var _this = _possibleConstructorReturn(this, (WaitingSequence.__proto__ || Object.getPrototypeOf(WaitingSequence)).call(this, props, context));
	
	    _this.state = {
	      currentSlide: 0,
	      progress: 0
	    };
	    return _this;
	  }
	
	  _createClass(WaitingSequence, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'waiting-sequence' },
	        _react2.default.createElement(_LinearProgress2.default, { mode: 'indeterminate', color: '#2eb0e3' })
	      );
	    }
	  }]);
	
	  return WaitingSequence;
	}(_react.Component), _class.propTypes = {
	  endFunc: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = WaitingSequence;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlreadyExists = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'AlreadyExists', {})
	  };
	}), _dec(_class = function (_Component) {
	  _inherits(AlreadyExists, _Component);
	
	  function AlreadyExists() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlreadyExists);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlreadyExists.__proto__ || Object.getPrototypeOf(AlreadyExists)).call.apply(_ref, [this].concat(args))), _this), _this.propTypes = {
	      firstName: _react.PropTypes.string,
	      assignedSpecialist: _react.PropTypes.object,
	      labels: _react.PropTypes.object.isRequired
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlreadyExists, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _lodash.clone)(this.props);
	      props.assignedSpecialist = props.assignedSpecialist || {};
	      props.assignedSpecialist.phoneNumber = (0, _prettyPhone2.default)((0, _lodash.get)(props.assignedSpecialist, 'phoneNumber')) || 'N/A';
	      var html = (0, _lodash.template)(this.props.labels.message)(props);
	      return _react2.default.createElement('div', { className: 'already-exists-message', dangerouslySetInnerHTML: { __html: html } });
	    }
	  }]);
	
	  return AlreadyExists;
	}(_react.Component)) || _class);
	exports.default = AlreadyExists;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IndeedConversionCode = __webpack_require__(314);
	
	var _IndeedConversionCode2 = _interopRequireDefault(_IndeedConversionCode);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isDupAndUnqualified = (_temp = _class = function (_Component) {
	  _inherits(isDupAndUnqualified, _Component);
	
	  function isDupAndUnqualified(props) {
	    _classCallCheck(this, isDupAndUnqualified);
	
	    return _possibleConstructorReturn(this, (isDupAndUnqualified.__proto__ || Object.getPrototypeOf(isDupAndUnqualified)).call(this, props));
	  }
	
	  _createClass(isDupAndUnqualified, [{
	    key: 'render',
	    value: function render() {
	      var message = this.props.message;
	
	      var html = (0, _lodash.template)(message)(this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'rejection-body message-body' },
	        _react2.default.createElement(_IndeedConversionCode2.default, { conversionLabel: 'duplicate and unquailified' }),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: html } })
	      );
	    }
	  }]);
	
	  return isDupAndUnqualified;
	}(_react.Component), _class.propTypes = {
	  message: _react.PropTypes.string
	}, _temp);
	exports.default = isDupAndUnqualified;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PrelimMessage(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'welcome-message' },
	    _react2.default.createElement(
	      'div',
	      { className: 'prelim-message-body message-body' },
	      'You will receive an email from the Qualifying Specialist ',
	      props.profile.qualifyingspecialist.firstName,
	      ' ',
	      props.profile.qualifyingspecialist.lastName,
	      ' you have been assigned to who will also contact you shortly to discuss the WAHVE opportunity. We look forward to working with you.'
	    )
	  );
	}
	
	exports.default = PrelimMessage;
	
	
	PrelimMessage.propTypes = {
	  profile: _react.PropTypes.object
	};

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _IndeedConversionCode = __webpack_require__(314);
	
	var _IndeedConversionCode2 = _interopRequireDefault(_IndeedConversionCode);
	
	var _PandoLogicTrackingPixel = __webpack_require__(315);
	
	var _PandoLogicTrackingPixel2 = _interopRequireDefault(_PandoLogicTrackingPixel);
	
	var _JoveoTrackingPixel = __webpack_require__(210);
	
	var _JoveoTrackingPixel2 = _interopRequireDefault(_JoveoTrackingPixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnqualifiedMessage = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'UnqualifiedMessage', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(UnqualifiedMessage, _Component);
	
	  function UnqualifiedMessage() {
	    _classCallCheck(this, UnqualifiedMessage);
	
	    return _possibleConstructorReturn(this, (UnqualifiedMessage.__proto__ || Object.getPrototypeOf(UnqualifiedMessage)).apply(this, arguments));
	  }
	
	  _createClass(UnqualifiedMessage, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'rejection-body message-body' },
	        _react2.default.createElement(_IndeedConversionCode2.default, { conversionLabel: 'unquailified' }),
	        _react2.default.createElement(_PandoLogicTrackingPixel2.default, { conversionType: 'preliminary-unqualified' }),
	        _react2.default.createElement(_JoveoTrackingPixel2.default, { conversionType: 'preliminary-unqualified' }),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.labels.message } })
	      );
	    }
	  }]);
	
	  return UnqualifiedMessage;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = UnqualifiedMessage;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _IndeedConversionCode = __webpack_require__(314);
	
	var _IndeedConversionCode2 = _interopRequireDefault(_IndeedConversionCode);
	
	var _PandoLogicTrackingPixel = __webpack_require__(315);
	
	var _PandoLogicTrackingPixel2 = _interopRequireDefault(_PandoLogicTrackingPixel);
	
	var _JoveoTrackingPixel = __webpack_require__(210);
	
	var _JoveoTrackingPixel2 = _interopRequireDefault(_JoveoTrackingPixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var gaEvent = __webpack_require__(461).gaEvent();
	
	var WelcomeMessage = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'WelcomeMessage', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(WelcomeMessage, _Component);
	
	  function WelcomeMessage() {
	    _classCallCheck(this, WelcomeMessage);
	
	    return _possibleConstructorReturn(this, (WelcomeMessage.__proto__ || Object.getPrototypeOf(WelcomeMessage)).apply(this, arguments));
	  }
	
	  _createClass(WelcomeMessage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      gaEvent('Applicant', 'Application Success', 'WAHVE Applicant');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'welcome-message' },
	        _react2.default.createElement(_IndeedConversionCode2.default, { conversionLabel: 'qualified' }),
	        _react2.default.createElement(_PandoLogicTrackingPixel2.default, { conversionType: 'preliminary-qualified' }),
	        _react2.default.createElement(_JoveoTrackingPixel2.default, { conversionType: 'preliminary-qualified' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'welcome-header' },
	          this.props.labels.title
	        ),
	        _react2.default.createElement('hr', { className: 'message-divider' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'welcome-body message-body' },
	          this.props.labels.content
	        )
	      );
	    }
	  }]);
	
	  return WelcomeMessage;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = WelcomeMessage;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
	
	// action creators for redux
	
	
	// js utilities
	
	
	// classname utilities
	// import cx from 'classnames';
	
	// app components
	
	
	// different modals
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_ModalForm = __webpack_require__(201);
	
	var _c_ModalForm2 = _interopRequireDefault(_c_ModalForm);
	
	var _f_InfoModal = __webpack_require__(122);
	
	var _f_InfoModal2 = _interopRequireDefault(_f_InfoModal);
	
	var _c_PasswordEntry = __webpack_require__(1040);
	
	var _c_PasswordEntry2 = _interopRequireDefault(_c_PasswordEntry);
	
	var _c_WaitingSequence = __webpack_require__(1041);
	
	var _c_WaitingSequence2 = _interopRequireDefault(_c_WaitingSequence);
	
	var _f_AlreadyExists = __webpack_require__(1042);
	
	var _f_AlreadyExists2 = _interopRequireDefault(_f_AlreadyExists);
	
	var _f_WelcomeMessage = __webpack_require__(1046);
	
	var _f_WelcomeMessage2 = _interopRequireDefault(_f_WelcomeMessage);
	
	var _f_UnqualifiedMessage = __webpack_require__(1045);
	
	var _f_UnqualifiedMessage2 = _interopRequireDefault(_f_UnqualifiedMessage);
	
	var _f_DuplicateAndUnqualified = __webpack_require__(1043);
	
	var _f_DuplicateAndUnqualified2 = _interopRequireDefault(_f_DuplicateAndUnqualified);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateUserModal = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    isQualified: store.prelimApplication.isQualified,
	    alreadyExists: store.prelimApplication.alreadyExists,
	    isDupAndInWaiting: store.prelimApplication.isDupAndInWaiting,
	    isDupQualifiedAndUnresponsive: store.prelimApplication.isDupQualifiedAndUnresponsive,
	    isDupAndUnqualified: store.prelimApplication.isDupAndUnqualified,
	    passwordIsReady: store.prelimApplication.passwordIsReady,
	    userSection: store.prelimApplication.user,
	    profileSection: store.prelimApplication.profile,
	    assignedSpecialist: store.prelimApplication.assignedSpecialist,
	    qualifyingSpecialists: (0, _lodash.get)(store, 'staticData.qualifyingSpecialists', []),
	    roles: (0, _lodash.get)(store, 'staticData.employeeRoles', []),
	    labels: (0, _lodash.get)(store.labels, 'Common', {}),
	    messageLabels: (0, _lodash.get)(store.labels, 'PrelimForm.createUserMessages', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CreateUserModal, _Component);
	
	  function CreateUserModal(props, context) {
	    _classCallCheck(this, CreateUserModal);
	
	    var _this = _possibleConstructorReturn(this, (CreateUserModal.__proto__ || Object.getPrototypeOf(CreateUserModal)).call(this, props, context));
	
	    _this.state = {
	      disableUserClosing: false,
	      isWaiting: false,
	      transparentMessage: false
	    };
	    _this.debouncedSubmitApplicant = (0, _lodash.debounce)(function () {
	      _this.submitApplicant();
	    }, 5000, { leading: true, trailing: false });
	    _this.modalFormData = {
	      passwordEntry: {
	        prompt: 'Create a signin to complete the Preliminary Profile process',
	        style: {
	          'min-height': '596px'
	        },
	        button: {
	          label: 'Continue',
	          onClick: _this.debouncedSubmitApplicant.bind(_this)
	        }
	      },
	      waiting: {
	        button: {
	          hide: true
	        }
	      },
	      qualified: {
	        style: {
	          height: '534.5px'
	        },
	        button: {
	          className: 'mobile-hide',
	          label: 'View Profile',
	          onClick: _this.goToLogin.bind(_this)
	        },
	        afterButtonText: {
	          className: 'mobile-only',
	          content: 'Return to wahve.com',
	          onClick: _this.directToHomePage.bind(_this)
	        },
	        onClose: _this.directToHomePage.bind(_this)
	      },
	      isDupAndUnqualified: {
	        button: {
	          label: 'Close',
	          onClick: _this.directToHomePage.bind(_this)
	        },
	        onClose: _this.directToHomePage.bind(_this)
	      },
	      unqualified: {
	        button: {
	          label: 'Close',
	          onClick: _this.directToHomePage.bind(_this)
	        },
	        onClose: _this.directToHomePage.bind(_this)
	      },
	      alreadyExists: {
	        button: {
	          hide: true
	        },
	        afterButtonText: {
	          className: 'mobile-only',
	          content: 'Return to wahve.com',
	          onClick: _this.directToHomePage.bind(_this)
	        },
	        onClose: _this.directToHomePage.bind(_this)
	      }
	    };
	
	
	    _this.updatePassword = _this.updatePassword.bind(_this);
	    _this.submitApplicant = _this.submitApplicant.bind(_this);
	    _this.debouncedSubmitApplicant = _this.debouncedSubmitApplicant.bind(_this);
	    _this.goToLogin = _this.goToLogin.bind(_this);
	    _this.endWaitingSequence = _this.endWaitingSequence.bind(_this);
	    _this.getCurrentModal = _this.getCurrentModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(CreateUserModal, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(newProps, newState) {
	      var _this2 = this;
	
	      if (this.getCurrentModal(newProps, newState) !== this.getCurrentModal()) {
	        this.setState(_lodash2.default.assign(this.state, {
	          transparentMessage: true
	        }));
	        setTimeout(function () {
	          return _this2.setState(_lodash2.default.assign(_this2.state, {
	            transparentMessage: false
	          }));
	        }, 450);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // reset state after close
	      this.props.dispatch(syncActionCreators.updatePrelimForm({
	        isQualified: 'unsubmitted'
	      }));
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      if (!this.state.userCantClose) {
	        // redirect them to homepage if they try to exit the modal and they already exist or are unqualified
	        if ((!this.props.isQualified || this.props.alreadyExists) && (true)) {
	          return this.directToHomePage();
	        }
	
	        // need to reset password's state if closed without submitting password
	        if (this.props.isQualified === 'unsubmitted') {
	          this.refs.passwordEntry.resetPasswordState();
	          this.updatePassword('');
	        }
	
	        // closes modal with function passed in from parent
	        this.props.closeFunction();
	      }
	    }
	  }, {
	    key: 'getCurrentModal',
	    value: function getCurrentModal(newProps, newState) {
	      var props = newProps || this.props;
	      var state = newState || this.state;
	
	      return state.isWaiting === true ? 'waiting' : props.isDupAndInWaiting === true ? 'isDupAndInWaiting' : props.isDupQualifiedAndUnresponsive === true ? 'isDupQualifiedAndUnresponsive' : props.isDupAndUnqualified === true ? 'isDupAndUnqualified' : props.alreadyExists === true ? 'alreadyExists' : props.isQualified === 'unsubmitted' ? 'passwordEntry' : props.isQualified ? 'qualified' : 'unqualified';
	    }
	  }, {
	    key: 'getQualifyingSpecialist',
	    value: function getQualifyingSpecialist() {
	      var assignedSpecialist = (0, _lodash.get)(this.props, 'assignedSpecialist');
	      if (assignedSpecialist) {
	        return assignedSpecialist;
	      }
	
	      var qsRole = (0, _lodash.get)(this.props, 'roles', []).find(function (r) {
	        return r.name === 'Qualifying Specialist';
	      }) || {};
	      var defaultQS = (0, _lodash.get)(this.props, 'qualifyingSpecialists', []).find(function (qs) {
	        return qs.defaultRole === qsRole.id;
	      });
	
	      if (defaultQS) {
	        return defaultQS;
	      }
	
	      return (0, _lodash.get)(this.props, 'qualifyingSpecialists', [])[0]; // Default to the first QS in the list.
	    }
	  }, {
	    key: 'updatePassword',
	    value: function updatePassword(password, passwordIsReady) {
	      this.props.dispatch(syncActionCreators.updatePrelimForm({
	        user: { password: password },
	        passwordIsReady: passwordIsReady
	      }));
	    }
	
	    // fire submitApplicant immediately and not again for 5000ms
	    // leading calls fn immediately
	    // trailing calls fn at end of wait if multiple invokations were requested during wait
	    // we want only 1 call so leading=true and trailing=false
	
	  }, {
	    key: 'submitApplicant',
	    value: function submitApplicant() {
	      this.setState({
	        disableUserClosing: true // ,
	        // isWaiting: true
	      });
	      this.props.dispatch(asyncActionCreators.submitApplicant({
	        user: this.props.userSection,
	        profile: this.props.profileSection
	      }));
	    }
	  }, {
	    key: 'goToLogin',
	    value: function goToLogin() {
	      this.props.closeFunction();
	      this.props.dispatch((0, _reactRouterRedux.push)('/login'));
	    }
	  }, {
	    key: 'endWaitingSequence',
	    value: function endWaitingSequence() {
	      this.setState({
	        disableUserClosing: false,
	        isWaiting: false
	      });
	    }
	  }, {
	    key: 'directToHomePage',
	    value: function directToHomePage() {
	      window.location = this.props.labels.website; // direct user to WAHVE homepage
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // determine current modal state
	      var currentModal = this.getCurrentModal();
	
	      // for determining whether password submit button is disabled, need to add this here, tried doing getter, doesn't work
	      this.modalFormData.passwordEntry.button.disabled = !this.props.passwordIsReady;
	
	      var qualifyingSpecialist = this.getQualifyingSpecialist();
	      var qsNumber = qualifyingSpecialist.direct_dial ? qualifyingSpecialist.direct_dial : qualifyingSpecialist.phoneNumber;
	      qualifyingSpecialist.direct_dial = (0, _prettyPhone2.default)(qsNumber);
	
	      return _react2.default.createElement(
	        _c_ModalForm2.default,
	        _extends({ key: 'blahblah',
	          message: currentModal !== 'passwordEntry'
	        }, this.modalFormData[currentModal], {
	          transparent: this.state.transparentMessage }),
	        currentModal === 'waiting' && _react2.default.createElement(_c_WaitingSequence2.default, { endFunc: this.endWaitingSequence }) || currentModal === 'isDupQualifiedAndUnresponsive' && _react2.default.createElement(_f_InfoModal2.default, {
	          text: _lodash2.default.template(this.props.messageLabels.isDupQualifiedAndUnresponsive)({ assignedSpecialist: qualifyingSpecialist }),
	          transitionFunc: this.directToHomePage.bind(this),
	          cancelFunc: this.directToHomePage.bind(this)
	        }) || currentModal === 'isDupAndInWaiting' && _react2.default.createElement(_f_InfoModal2.default, {
	          text: _lodash2.default.template(this.props.messageLabels.isDupAndInWaiting)({ assignedSpecialist: qualifyingSpecialist }),
	          transitionFunc: this.directToHomePage.bind(this) // reroute to tenant homepage
	          , cancelFunc: this.directToHomePage.bind(this) // reroute to tenant homepage
	          , buttonLabel: 'Close'
	        }) || currentModal === 'isDupAndUnqualified' && _react2.default.createElement(_f_DuplicateAndUnqualified2.default, {
	          message: this.props.messageLabels.isDupAndUnqualified
	        }) || currentModal === 'alreadyExists' && _react2.default.createElement(_f_AlreadyExists2.default, { firstName: this.props.userSection.firstName, assignedSpecialist: qualifyingSpecialist }) || currentModal === 'passwordEntry' && _react2.default.createElement(_c_PasswordEntry2.default, { ref: 'passwordEntry',
	          email: this.props.userSection.email,
	          password: this.props.userSection.password,
	          passwordIsReady: this.props.passwordIsReady,
	          updatePassword: this.updatePassword }) || currentModal === 'qualified' && _react2.default.createElement(_f_WelcomeMessage2.default, null) || currentModal === 'unqualified' && _react2.default.createElement(_f_UnqualifiedMessage2.default, null)
	      );
	    }
	  }]);
	
	  return CreateUserModal;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  closeFunction: _react.PropTypes.func.isRequired,
	  userSection: _react.PropTypes.object,
	  profileSection: _react.PropTypes.object,
	  assignedSpecialist: _react.PropTypes.object,
	  isQualified: _react.PropTypes.any,
	  alreadyExists: _react.PropTypes.bool,
	  isDupAndInWaiting: _react.PropTypes.bool,
	  isDupQualifiedAndUnresponsive: _react.PropTypes.bool,
	  isDupAndUnqualified: _react.PropTypes.bool,
	  passwordIsReady: _react.PropTypes.bool,
	  closeModal: _react.PropTypes.func,
	  labels: _react.PropTypes.object.isRequired,
	  messageLabels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = CreateUserModal;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(51);
	
	var _PandoLogicTrackingPixel = __webpack_require__(315);
	
	var _PandoLogicTrackingPixel2 = _interopRequireDefault(_PandoLogicTrackingPixel);
	
	var _JoveoTrackingPixel = __webpack_require__(210);
	
	var _JoveoTrackingPixel2 = _interopRequireDefault(_JoveoTrackingPixel);
	
	var _f_Application = __webpack_require__(1038);
	
	var _f_Application2 = _interopRequireDefault(_f_Application);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicantDashboard = (_temp = _class = function (_Component) {
	  _inherits(ApplicantDashboard, _Component);
	
	  function ApplicantDashboard() {
	    _classCallCheck(this, ApplicantDashboard);
	
	    return _possibleConstructorReturn(this, (ApplicantDashboard.__proto__ || Object.getPrototypeOf(ApplicantDashboard)).apply(this, arguments));
	  }
	
	  _createClass(ApplicantDashboard, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'prelim-application' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement(
	            'span',
	            { 'data-id': 'Title Text' },
	            'Preliminary Profile'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'login', 'data-id': 'Login Text' },
	            'Returning applicant? Please\xA0',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/login', className: 'link login-link', 'data-id': 'Login Link' },
	              'sign in'
	            )
	          )
	        ),
	        _react2.default.createElement(_PandoLogicTrackingPixel2.default, { conversionType: 'preliminary-application' }),
	        _react2.default.createElement(_JoveoTrackingPixel2.default, { conversionType: 'preliminary-application' }),
	        _react2.default.createElement(_f_Application2.default, null),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ApplicantDashboard;
	}(_react.Component), _class.propTypes = {
	  children: _react.PropTypes.any
	}, _temp);
	exports.default = ApplicantDashboard;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(5);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(51);
	
	var _c_ModalForm = __webpack_require__(201);
	
	var _c_ModalForm2 = _interopRequireDefault(_c_ModalForm);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _f_PasswordWithValidators = __webpack_require__(299);
	
	var _f_PasswordWithValidators2 = _interopRequireDefault(_f_PasswordWithValidators);
	
	var _auth = __webpack_require__(481);
	
	var _modelValidator = __webpack_require__(33);
	
	var _user = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loginSchema = _lodash2.default.pick((0, _user.getSchema)(), 'password');
	
	var ChangePassword = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    token: props.location.query.token
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ChangePassword, _React$Component);
	
	  function ChangePassword(props) {
	    _classCallCheck(this, ChangePassword);
	
	    var _this = _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call(this, props));
	
	    _this.resetUrl = '/forgotpassword';
	    _this.loginUrl = '/login';
	    _this.FORM = 0;
	    _this.SUBMIT = 1;
	    _this.COMPLETE = 2;
	
	    _this.handleSubmit = function () {
	      _this.setState(_extends({}, _this.setState, { step: _this.SUBMIT }));
	      (0, _auth.updatePassword)(_this.props.token, _this.state.password.value).then(function () {
	        return _this.setState(_extends({}, _this.state, { step: _this.COMPLETE }));
	      }).catch(function () {
	        return _this.setState(_extends({}, _this.state, { error: true, step: _this.FORM }));
	      });
	    };
	
	    _this.handleClose = function () {
	      _this.props.dispatch((0, _reactRouterRedux.push)('/'));
	    };
	
	    _this.handlePasswordChange = function (event) {
	      var newState = _this.cloneState();
	      newState.password.value = event.target.value;
	      newState.password.dirty = true;
	      newState.error = false;
	      _this.setState(newState);
	    };
	
	    _this.handleConfirmChange = function (event) {
	      var newState = _this.cloneState();
	      newState.confirm.value = event.target.value;
	      newState.confirm.dirty = true;
	      newState.error = false;
	      _this.setState(newState);
	    };
	
	    _this.handleConfirmBlur = function () {
	      var newState = _this.cloneState();
	      newState.confirm.dirty = true;
	      _this.setState(newState);
	    };
	
	    _this.state = {
	      disabled: false,
	      password: {
	        value: '',
	        dirty: false
	      },
	      confirm: {
	        value: '',
	        dirty: false
	      },
	      step: _this.FORM,
	      error: false
	    };
	    return _this;
	  }
	
	  _createClass(ChangePassword, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      if (!this.props.token) {
	        return this.props.dispatch((0, _reactRouterRedux.push)(this.resetUrl));
	      }
	
	      (0, _auth.isResetRequestValid)(this.props.token).catch(function () {
	        return _this2.props.dispatch((0, _reactRouterRedux.push)(_this2.resetUrl));
	      });
	    }
	  }, {
	    key: 'cloneState',
	    value: function cloneState() {
	      return _lodash2.default.merge({}, this.state);
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-entry' },
	        _react2.default.createElement(_f_PasswordWithValidators2.default, { value: this.state.password.value,
	          onChange: this.handlePasswordChange }),
	        _react2.default.createElement(_c_TextField2.default, { className: 'full-width',
	          floatingLabelText: 'Confirm Password',
	          'data-id': 'Confirm Password',
	          password: true,
	          onChange: this.handleConfirmChange,
	          onBlur: this.handleConfirmBlur,
	          errorText: this.state.confirm.dirty && this.state.confirm.value !== this.state.password.value && 'Please make sure both password entries are the same' || undefined }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('error-message', { opaque: this.state.error }) },
	          'Ooops, something went wrong.'
	        )
	      );
	    }
	  }, {
	    key: 'renderSent',
	    value: function renderSent() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-message' },
	        _react2.default.createElement('hr', { className: 'message-divider' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'already-exists-section' },
	          'While we update your password.'
	        )
	      );
	    }
	  }, {
	    key: 'renderComplete',
	    value: function renderComplete() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-message' },
	        _react2.default.createElement('hr', { className: 'message-divider' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'welcome-body message-body' },
	          'Your password was successfully reset. Please ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'link', to: '/login' },
	            'sign in'
	          ),
	          ' using your new password.'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var isNotForm = this.state.step !== this.FORM;
	      var isNotValid = (0, _modelValidator.validate)({ password: this.state.password.value }, loginSchema).length;
	      var isNotMatch = !(this.state.password.value && this.state.confirm.value === this.state.password.value);
	      var prompt = '';
	      var promptStyle = 'reset-form';
	
	      switch (this.state.step) {
	        case this.SUBMIT:
	          prompt = 'Please wait';
	          break;
	        case this.COMPLETE:
	          prompt = 'Success!';
	          promptStyle = 'reset-form-success';
	          break;
	        default:
	          prompt = 'Change Password';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _c_ModalForm2.default,
	          { className: promptStyle,
	            prompt: prompt,
	            onClose: this.handleClose,
	            button: {
	              label: 'Submit',
	              onClick: this.handleSubmit,
	              disabled: isNotForm || isNotValid || isNotMatch
	            } },
	          this.state.step === this.FORM && this.renderForm() || this.state.step === this.SUBMIT && this.renderSent() || this.state.step === this.COMPLETE && this.renderComplete(),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ChangePassword;
	}(_react2.default.Component), _class2.propTypes = {
	  token: _react.PropTypes.string,
	  dispatch: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = ChangePassword;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// classnames utility
	
	
	// js utilities
	
	
	// action creators for redux
	
	
	// validation
	// returns an array of validation errors (empty array if none)
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _auth = __webpack_require__(213);
	
	var _modelValidator = __webpack_require__(33);
	
	var _user = __webpack_require__(124);
	
	var _c_ModalForm = __webpack_require__(201);
	
	var _c_ModalForm2 = _interopRequireDefault(_c_ModalForm);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _f_PasswordWithValidators = __webpack_require__(299);
	
	var _f_PasswordWithValidators2 = _interopRequireDefault(_f_PasswordWithValidators);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loginSchema = _lodash2.default.pick((0, _user.getSchema)(), 'email', 'password'); // this page only uses email and password
	
	// Modal form component
	
	// storing outside since it's fixed
	var initState = {
	  email: '',
	  password: '',
	  dirty: false
	};
	
	var Login = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    loginFormType: state.routing.locationBeforeTransitions.query.type || 'default',
	    user: state.user,
	    firstStatusGroup: (state.user.statusGroups || [])[0],
	    labels: (0, _lodash.get)(state.labels, 'Common', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props, context) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props, context));
	
	    _this.state = _lodash2.default.merge({}, initState);
	
	    _this.onClose = function () {
	      window.location = _this.props.labels.website; // TODO: whitelabel url
	    };
	
	    _this.promptText = {
	      default: (0, _lodash.get)(_this.props, 'labels.loginText', 'Log into Account')
	    };
	
	
	    _this.redirectLoggedInUser = _this.redirectLoggedInUser.bind(_this);
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.redirectLoggedInUser();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      if (this.props.user !== nextProps.user) {
	        this.redirectLoggedInUser();
	      }
	    }
	  }, {
	    key: 'setDirty',
	    value: function setDirty() {
	      if (!this.state.dirty) {
	        this.setState(_lodash2.default.merge({}, this.state, {
	          dirty: true
	        }));
	      }
	    }
	  }, {
	    key: 'componentWillUnMount',
	    value: function componentWillUnMount() {
	      this.setState(_lodash2.default.merge({}, this.initState));
	    }
	  }, {
	    key: 'redirectLoggedInUser',
	    value: function redirectLoggedInUser() {
	      var roles = this.props.user.roles;
	
	      if (this.props.user.loggedIn) {
	        if (roles.includes('Applicant')) {
	          this.props.dispatch((0, _reactRouterRedux.push)('/applicant'));
	        } else if (roles.includes('Client')) {
	          this.props.dispatch((0, _reactRouterRedux.push)('/client'));
	        } else if (roles.includes('Admin') || roles.includes('Employee')) {
	
	          if (roles.includes('Qualifying Specialist')) {
	            this.props.dispatch((0, _reactRouterRedux.push)('/admin/In Process'));
	          } else if (roles.includes('Placement Specialist')) {
	            this.props.dispatch((0, _reactRouterRedux.push)('/admin/In Process'));
	          } else if (roles.includes('Relationship Manager')) {
	            this.props.dispatch((0, _reactRouterRedux.push)('/admin/In Process'));
	          } else if (roles.includes('Client Adviser')) {
	            this.props.dispatch((0, _reactRouterRedux.push)('/admin/contacts'));
	          } else {
	            this.props.dispatch((0, _reactRouterRedux.push)('/admin/In Process'));
	          }
	        }
	      }
	    }
	  }, {
	    key: 'gotoContactUs',
	    value: function gotoContactUs() {
	      this.props.dispatch((0, _reactRouterRedux.push)('/contactus'));
	    }
	  }, {
	    key: 'logIn',
	    value: function logIn() {
	      this.setState(_lodash2.default.merge({}, this.state, {
	        dirty: false
	      }));
	      this.props.dispatch((0, _auth.logIn)({
	        email: this.state.email,
	        password: this.state.password
	      }));
	    }
	  }, {
	    key: 'forgotPassword',
	    value: function forgotPassword() {
	      this.props.dispatch((0, _reactRouterRedux.push)('/forgotPassword'));
	    }
	  }, {
	    key: 'updateVal',
	    value: function updateVal(name, event, value) {
	      this.setState(_lodash2.default.merge(this.state, _defineProperty({}, name, value)));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _c_ModalForm2.default,
	        { className: 'login-form',
	          prompt: this.promptText[this.props.loginFormType],
	          onClose: this.onClose,
	          dataId: 'Login',
	          button: {
	            label: 'Sign In',
	            onClick: this.logIn.bind(this),
	            disabled: !!(0, _modelValidator.validate)(this.state, loginSchema).length
	          },
	          afterButtonText: {
	            content: 'Create/reset your password',
	            onClick: this.forgotPassword.bind(this)
	          } },
	        _react2.default.createElement(_c_TextField2.default, { className: 'full-width',
	          floatingLabelText: 'Email',
	          floatingLabelFixed: true,
	          'data-id': 'Email',
	          onChange: this.updateVal.bind(this, 'email'),
	          onFocus: this.setDirty.bind(this) }),
	        _react2.default.createElement(_f_PasswordWithValidators2.default, { value: this.state.password,
	          onChange: this.updateVal.bind(this, 'password'),
	          onFocus: this.setDirty.bind(this),
	          hideWhenEmpty: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('error-message', { opaque: this.props.user.authFailed && !this.state.dirty }) },
	          'Your email and/or password are incorrect'
	        ),
	        this.props.location.query.hasOwnProperty('create-account') && _react2.default.createElement(
	          'div',
	          { className: 'button-create-account-container' },
	          _react2.default.createElement(_Button2.default, {
	            onClick: this.gotoContactUs.bind(this),
	            label: 'CREATE ACCOUNT',
	            className: 'button-main button-create-account'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  loginFormType: _react.PropTypes.any,
	  user: _react.PropTypes.object,
	  firstStatusGroup: _react.PropTypes.string.isRequired,
	  location: _react.PropTypes.object,
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = Login;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(51);
	
	var _f_NavColumn = __webpack_require__(1037);
	
	var _f_NavColumn2 = _interopRequireDefault(_f_NavColumn);
	
	var _f_copyright = __webpack_require__(211);
	
	var _f_copyright2 = _interopRequireDefault(_f_copyright);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublicLanding = (_temp = _class = function (_Component) {
		_inherits(PublicLanding, _Component);
	
		function PublicLanding() {
			_classCallCheck(this, PublicLanding);
	
			return _possibleConstructorReturn(this, (PublicLanding.__proto__ || Object.getPrototypeOf(PublicLanding)).apply(this, arguments));
		}
	
		_createClass(PublicLanding, [{
			key: 'render',
			value: function render() {
				// const path = this.props.location.pathname.split('/');
				// const className = path.filter(p => !!p.length).length ? '' : 'bottom';
	
				return _react2.default.createElement(
					'div',
					{ className: 'applicant-content-container prelim-form public clearfix' },
					_react2.default.createElement(
						'div',
						{ className: 'prelim-application-container' },
						_react2.default.createElement(_f_NavColumn2.default, null),
						this.props.children
					)
				);
			}
		}]);
	
		return PublicLanding;
	}(_react.Component), _class.propTypes = {
		children: _react.PropTypes.any
	}, _temp);
	exports.default = PublicLanding;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(51);
	
	var _ProspectForm = __webpack_require__(473);
	
	var _ProspectForm2 = _interopRequireDefault(_ProspectForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublicProspect = (_temp = _class = function (_Component) {
	  _inherits(PublicProspect, _Component);
	
	  function PublicProspect() {
	    _classCallCheck(this, PublicProspect);
	
	    return _possibleConstructorReturn(this, (PublicProspect.__proto__ || Object.getPrototypeOf(PublicProspect)).apply(this, arguments));
	  }
	
	  _createClass(PublicProspect, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'prospect-application' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement(
	            'span',
	            { 'data-id': 'Title Text' },
	            'Contact Us'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'login', 'data-id': 'Login Text' },
	            'Returning client? Please\xA0',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/login', className: 'link login-link', 'data-id': 'Login Link' },
	              'sign in'
	            )
	          )
	        ),
	        _react2.default.createElement(_ProspectForm2.default, null),
	        this.props.children
	      );
	    }
	  }]);
	
	  return PublicProspect;
	}(_react.Component), _class.propTypes = {
	  children: _react.PropTypes.any
	}, _temp);
	exports.default = PublicProspect;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // returns an array of validation errors (empty array if none)
	
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_ModalForm = __webpack_require__(201);
	
	var _c_ModalForm2 = _interopRequireDefault(_c_ModalForm);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _modelValidator = __webpack_require__(33);
	
	var _user = __webpack_require__(124);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _auth = __webpack_require__(481);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loginSchema = _lodash2.default.pick((0, _user.getSchema)(), 'email'); // this page only uses email and password
	
	var ResetPassword = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    labels: (0, _lodash.get)(state.labels, 'Common', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ResetPassword, _React$Component);
	
	  function ResetPassword(props) {
	    _classCallCheck(this, ResetPassword);
	
	    var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this, props));
	
	    _this.setDirty = function () {
	      _this.setState(_extends({}, _this.state, { dirty: true }));
	    };
	
	    _this.FORM = 0;
	    _this.SUBMIT = 1;
	    _this.COMPLETE = 2;
	
	    _this.handleChange = function (event) {
	      var newState = _lodash2.default.merge({}, _this.state);
	      newState.error = false;
	      newState.email = event.target.value;
	      newState.disabled = !!(0, _modelValidator.validate)({ email: newState.email }, loginSchema).length;
	      _this.setState(newState);
	    };
	
	    _this.handleClose = function () {
	      window.location = _this.props.labels.website;
	    };
	
	    _this.handleSubmit = function () {
	      var newState = _lodash2.default.merge({}, _this.state);
	      newState.step = _this.SUBMIT;
	      newState.disabled = true;
	      _this.setState(newState);
	      (0, _auth.resetPasswordRequest)(_this.state.email).then(function () {
	        return _this.setState(_extends({}, newState, { step: _this.COMPLETE }));
	      }).catch(function () {
	        newState.disabled = false;
	        newState.error = true;
	        newState.step = _this.FORM;
	        _this.setState(newState);
	      });
	    };
	
	    _this.state = {
	      dirty: false,
	      opaque: false,
	      disabled: true,
	      error: false,
	      step: _this.FORM
	    };
	    return _this;
	  }
	
	  _createClass(ResetPassword, [{
	    key: 'renderForm',
	    value: function renderForm() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-entry' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'We\u2019ll send you an email with a reset link.'
	        ),
	        _react2.default.createElement(_c_TextField2.default, { className: 'full-width',
	          floatingLabelText: 'Email',
	          'data-id': 'Email',
	          onChange: this.handleChange,
	          onFocus: this.setDirty }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('error-message', { opaque: this.state.opaque }) },
	          'Your email is incorrect'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('error-message', { opaque: this.state.error }) },
	          'Ooops, something went wrong.'
	        )
	      );
	    }
	  }, {
	    key: 'renderSubmit',
	    value: function renderSubmit() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-message' },
	        _react2.default.createElement('hr', { className: 'message-divider' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'message-body' },
	          'Please wait'
	        )
	      );
	    }
	  }, {
	    key: 'renderComplete',
	    value: function renderComplete() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-message' },
	        _react2.default.createElement('hr', { className: 'message-divider' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'welcome-body message-body' },
	          'Please follow the link in the email to reset your password.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'welcome-body message-body' },
	          'Please remember to check your Spam and/or Junk Mail folders in case you don\'t see the message in your Inbox.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'welcome-body message-body' },
	          'Should you need assistance with resetting your password or logging in, please contact our',
	          _react2.default.createElement('br', null),
	          'IT Team by calling 646-807-4372 and press #2.',
	          _react2.default.createElement('br', null),
	          'Our IT Team will be happy to assist you.'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prompt = '';
	      var promptStyle = 'reset-form';
	
	      switch (this.state.step) {
	        case this.SUBMIT:
	          prompt = 'Sending Email';
	          break;
	        case this.COMPLETE:
	          prompt = 'Email Sent';
	          promptStyle = 'reset-form-success';
	          break;
	        default:
	          prompt = 'Change Password';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _c_ModalForm2.default,
	          { className: promptStyle,
	            prompt: prompt,
	            onClose: this.handleClose,
	            button: {
	              label: 'Reset',
	              onClick: this.handleSubmit,
	              disabled: this.state.disabled
	            } },
	          this.state.step === this.FORM && this.renderForm() || this.state.step === this.SUBMIT && this.renderSubmit() || this.state.step === this.COMPLETE && this.renderComplete(),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react2.default.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  labels: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = ResetPassword;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// components
	
	
	// utility
	
	
	// redux interactions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _socket = __webpack_require__(438);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _NavColumn = __webpack_require__(981);
	
	var _NavColumn2 = _interopRequireDefault(_NavColumn);
	
	var _ScrollColumn = __webpack_require__(297);
	
	var _ScrollColumn2 = _interopRequireDefault(_ScrollColumn);
	
	var _r_ApplicantManager = __webpack_require__(1059);
	
	var _r_ApplicantManager2 = _interopRequireDefault(_r_ApplicantManager);
	
	var _queryify = __webpack_require__(900);
	
	var _queryify2 = _interopRequireDefault(_queryify);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreator = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreator = _interopRequireWildcard(_sync);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var socket = (0, _socket2.default)(({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).BASE_URL);
	
	var AdminDashboard = (_dec = (0, _reactRedux.connect)(function (store, props) {
	  return {
	    user: store.user,
	    staticData: store.staticData,
	    applicantsLoaded: !!Object.keys(store.admin.applicants).reduce(function (prev, current) {
	      return prev + current.length;
	    }, 0),
	    applicantStatusGroups: store.user.statusGroups,
	    applicants: store.admin.applicants,
	    route: {
	      params: props.params,
	      query: props.location.query // actually being from from react-redux-router to regular props
	    } };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AdminDashboard, _Component);
	
	  function AdminDashboard(props, context) {
	    _classCallCheck(this, AdminDashboard);
	
	    return _possibleConstructorReturn(this, (AdminDashboard.__proto__ || Object.getPrototypeOf(AdminDashboard)).call(this, props, context));
	  }
	
	  _createClass(AdminDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // register sockets
	      this.onSearch();
	      socket.on('new applicant', function (data) {
	        return _this2.incomingApplicant(data);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'onSearch',
	    value: function onSearch() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.props.dispatch(asyncActionCreator.search(terms, filters));
	    }
	  }, {
	    key: 'onPageChange',
	    value: function onPageChange() {
	      var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var group = arguments[2];
	      var skip = arguments[3];
	      var sortBy = arguments[4];
	
	      this.props.dispatch(asyncActionCreator.goToPage(terms, filters, group, skip, sortBy));
	    }
	  }, {
	    key: 'incomingApplicant',
	    value: function incomingApplicant(applicant) {
	      var qsUID = (0, _lodash.get)((0, _lodash.find)(this.props.staticData.qualifyingSpecialists, function (q) {
	        return q.employeeId === applicant.profile.qualifyingSpecialistId;
	      }), 'id');
	
	      // For QS we only add the new applicant with QS matched.
	      if (!!~this.props.user.roles.indexOf('Qualifying Specialist') && this.props.user.id !== qsUID) {
	        return;
	      }
	      this.props.dispatch(syncActionCreator.addApplicantAdmin(applicant));
	    }
	  }, {
	    key: 'expandCard',
	    value: function expandCard(applicantEmail) {
	      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (detail === true) {
	        this.props.dispatch((0, _reactRouterRedux.push)('/admin/' + this.props.route.params.navColumnState + '/' + applicantEmail + '/Profile/?detail=1'));
	      } else {
	        this.props.dispatch((0, _reactRouterRedux.push)('/admin/' + this.props.route.params.navColumnState + '/' + applicantEmail + (0, _queryify2.default)(this.props.route.query)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-content-container clearfix' },
	        this.props.route.params.navColumnState === 'Prospect' && _react2.default.createElement(_ScrollColumn2.default, {
	          navGroups: ['Company_Info', 'Contact_Info', 'Preliminary_Info', 'Inquiry_Reason'],
	          title: 'Add New'
	        }) || _react2.default.createElement(_NavColumn2.default, {
	          navColumnState: this.props.route.params.navColumnState,
	          navGroups: this.props.applicantStatusGroups,
	          navItems: this.props.applicants.search,
	          baseUrl: '/admin',
	          title: 'Candidates'
	        }),
	        _react2.default.createElement(_r_ApplicantManager2.default, {
	          expandCard: this.expandCard.bind(this),
	          selectedEmail: this.props.route.params.email,
	          navColumnState: this.props.route.params.navColumnState,
	          onSearch: this.onSearch.bind(this),
	          onPageChange: this.onPageChange.bind(this)
	        }),
	        // allow for expanded card
	        this.props.children
	      );
	    }
	  }]);
	
	  return AdminDashboard;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  route: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  query: _react.PropTypes.object,
	  params: _react.PropTypes.object, // comes from react-redux-router
	  user: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = AdminDashboard;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _ResetIcon = __webpack_require__(892);
	
	var _ResetIcon2 = _interopRequireDefault(_ResetIcon);
	
	var _lodash = __webpack_require__(4);
	
	var _enums = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dateOptions = [{ id: 'past due', name: 'Past Due' }, { id: 'today', name: 'Today' }, { id: 'tomorrow', name: 'Tomorrow' }, { id: 'this week', name: 'This Week' }, { id: 'next week', name: 'Next Week' }, { id: 'this month', name: 'This Month' }, { id: 'future', name: 'Future' }];
	
	var appliedDateOptions = [{ id: 'today', name: 'Today' }, { id: 'yesterday', name: 'Yesterday' }, { id: 'past week', name: 'Past Week' }, { id: 'past month', name: 'Past Month' }, { id: 'past year', name: 'Past Year' }];
	
	var availabilityDateOptions = [{ id: 'past', name: 'Past' }, { id: 'next 30 days', name: 'Next 30 Days' }, { id: 'next 60 days', name: 'Next 60 Days' }, { id: 'next 90 days', name: 'Next 90 Days' }, { id: 'next 120 days', name: 'Next 120 Days' }, { id: 'next 180 days', name: 'Next 180 Days' }];
	
	var initState = {
	  statuses: null,
	  followUpDate: null,
	  appliedDate: null,
	  timezone: null,
	  bestContactTime: null,
	  qs: null
	};
	
	var Filters = (_temp = _class = function (_Component) {
	  _inherits(Filters, _Component);
	
	  function Filters(props, context) {
	    _classCallCheck(this, Filters);
	
	    var _this = _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this, props, context));
	
	    _this.state = (0, _lodash.assign)({}, initState);
	
	
	    var qualifyingSpecialists = [];
	    if (!(0, _lodash.isEmpty)(props.specialists)) {
	      qualifyingSpecialists = props.specialists.map(function (item) {
	        return { value: item.employeeId, primaryText: item.firstName + ' ' + item.lastName };
	      });
	    }
	    _this.qsList = [].concat(_toConsumableArray(qualifyingSpecialists));
	
	    return _this;
	  }
	
	  _createClass(Filters, [{
	    key: 'onChange',
	    value: function onChange(prop, event, value) {
	      value = (0, _lodash.get)(event, 'target.value', value);
	      if (this.state[prop] !== value) {
	        this.setState((0, _lodash.assign)(this.state, _defineProperty({}, prop, value)));
	        (0, _lodash.debounce)(this.props.onFilterChange, 200)(this.state);
	      }
	    }
	  }, {
	    key: 'onDateChange',
	    value: function onDateChange(prop, event) {
	      var value = event.target.value ? event.target.value.toString() : null;
	      if (this.state[prop] !== value) {
	        this.setState((0, _lodash.assign)(this.state, _defineProperty({}, prop, value)));
	        (0, _lodash.debounce)(this.props.onFilterChange, 200)(this.state);
	      }
	    }
	  }, {
	    key: 'handleDropDownMenuUI',
	    value: function handleDropDownMenuUI(prop, items, label) {
	      return {
	        'data-id': prop,
	        value: this.state[prop],
	        menuItems: items,
	        floatingLabelText: label,
	        onChange: this.onChange.bind(this, prop),
	        primaryText: 'All',
	        includeDefault: true
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.setState(initState);
	      (0, _lodash.debounce)(this.props.onFilterChange, 200)(initState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var disabledStatusDropdown = this.props.navColumnState === 'Standby';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-filters-container' },
	        this.props.admin && _react2.default.createElement(
	          'div',
	          { className: 'qs-filter-wapper' },
	          _react2.default.createElement(_c_DropDownMenu2.default, {
	            className: 'qs-filter',
	            'data-id': 'Qualifying Specialist',
	            primaryText: 'All QS',
	            includeDefault: true,
	            value: this.state.qs,
	            menuItems: this.qsList,
	            onChange: this.onChange.bind(this, 'qs')
	          }),
	          _react2.default.createElement(_ResetIcon2.default, { onClick: function onClick() {
	              return _this2.reset();
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'center-column-1' },
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            disabled: disabledStatusDropdown,
	            className: 'status-dropdown'
	          }, this.handleDropDownMenuUI('statuses', this.props.staticData.applicantStatus, 'Status'))),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            className: 'date-dropdown follow-up'
	          }, this.handleDropDownMenuUI('followUpDate', dateOptions, 'Follow Up Date')))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'center-column-1' },
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            className: 'date-dropdown applied'
	          }, this.handleDropDownMenuUI('appliedDate', appliedDateOptions, 'Applied Date'))),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            className: 'date-dropdown availability'
	          }, this.handleDropDownMenuUI('availabilityDate', availabilityDateOptions, 'Availability Date')))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'center-column-1' },
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            className: 'timezone-dropdown'
	          }, this.handleDropDownMenuUI('timezone', this.props.staticData.timezoneList, 'Time Zone'))),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            className: 'best-contact-time'
	          }, this.handleDropDownMenuUI('bestContactTime', this.props.staticData.bestContactTimeList, 'Best Contact Time')))
	        )
	      );
	    }
	  }]);
	
	  return Filters;
	}(_react.Component), _class.propTypes = {
	  onFilterChange: _react.PropTypes.func,
	  staticData: _react.PropTypes.object,
	  specialists: _react.PropTypes.array,
	  terms: _react.PropTypes.array,
	  admin: _react.PropTypes.bool,
	  navColumnState: _react.PropTypes.string.isRequired
	}, _temp);
	exports.default = Filters;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _localDate = __webpack_require__(308);
	
	var _localDate2 = _interopRequireDefault(_localDate);
	
	var _emailLink = __webpack_require__(305);
	
	var _emailLink2 = _interopRequireDefault(_emailLink);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _prettyTimezone = __webpack_require__(466);
	
	var _prettyTimezone2 = _interopRequireDefault(_prettyTimezone);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	function ApplicantCard(props) {
	  var applicant = props.applicant,
	      selectedEmail = props.selectedEmail,
	      corkBoard = props.corkBoard,
	      togglePin = props.togglePin;
	
	  // this will be a prop
	
	  var transparentPct = (0, _lodash.isNil)(applicant.lifespan) ? 1 : applicant.lifespan > 0 ? 1 - (+new Date() - +new Date(applicant.profile.dateModifiedByApplicant || applicant.profile.dateCreated)) / (applicant.lifespan * 60 * 60 * 1000) : 0;
	  var rgbaColor = 'rgba(' + (0, _lodash.chunk)(applicant.color.slice(1), 2).map(function (stringArr) {
	    return Number.parseInt(stringArr.join(''), 16);
	  }).join() // conversion from base 16
	  + ',' + transparentPct + ')'; // calculating opacity
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: applicant.user.email,
	      'data-id': applicant.user.email,
	      className: (0, _classnames2.default)('applicant-card', { transparent: selectedEmail === applicant.user.email }) },
	    _react2.default.createElement(
	      'div',
	      { className: 'status-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'status-circle', 'data-id': 'Status Icon',
	          onClick: props.expandCard.bind(this, applicant.profile.id, true),
	          style: { backgroundColor: rgbaColor, borderColor: applicant.color, color: transparentPct < 0.25 ? applicant.color : '#fff' } },
	        applicant.label || ''
	      ),
	      _react2.default.createElement('div', { className: 'expand-icon', onClick: props.expandCard.bind(this, applicant.profile.id) })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'applicant-info', onClick: props.expandCard.bind(this, applicant.profile.id, true) },
	      _react2.default.createElement(
	        'div',
	        { className: 'applicant-info-primary' },
	        _react2.default.createElement(
	          'div',
	          { className: 'applicant-name', 'data-id': 'Name' },
	          applicant.user.firstName + ' ' + applicant.user.lastName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'applicant-email', 'data-id': 'Email' },
	          (0, _emailLink2.default)(applicant.user.email)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'applicant-phone', 'data-id': 'Phone Number' },
	          (0, _prettyPhone2.default)(applicant.user.phoneNumber1)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'applicant-best-contact-time', 'data-id': 'best contact time' },
	          applicant.bestContactTime
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'applicant-info', onClick: props.expandCard.bind(this, applicant.profile.id, true) },
	      _react2.default.createElement(
	        'div',
	        { className: 'applicant-info-secondary' },
	        _react2.default.createElement(
	          'div',
	          { className: 'applicant-timezone', 'data-id': 'timezone' },
	          (0, _prettyTimezone2.default)(applicant.timezone),
	          '\xA0'
	        ),
	        applicant.profile.followUpDate && _react2.default.createElement(
	          'div',
	          { className: 'applicant-followup', 'data-id': 'followup' },
	          'Follow Up: ',
	          (0, _localDate2.default)(applicant.profile.followUpDate)
	        ),
	        applicant.profile.availabilityDate && _react2.default.createElement(
	          'div',
	          { className: 'applicant-updated', 'data-id': 'updated' },
	          'Availability: ',
	          (0, _localDate2.default)(applicant.profile.availabilityDate)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'applicant-applied', 'data-id': 'applied' },
	          'Applied: ',
	          (0, _localDate2.default)(applicant.profile.dateCreated)
	        )
	      )
	    ),
	    corkBoard && _react2.default.createElement(
	      'div',
	      { className: 'applicant-close',
	        'data-id': 'close-icon',
	        onClick: togglePin.bind(this, applicant)
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'closeIcon' },
	        _react2.default.createElement(_CloseX2.default, null)
	      )
	    )
	  );
	}
	
	// utilities
	
	
	ApplicantCard.propTypes = {
	  expandCard: _react.PropTypes.func,
	  applicant: _react.PropTypes.object.isRequired,
	  selectedEmail: _react.PropTypes.string
	};
	
	exports.default = ApplicantCard;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactProps = __webpack_require__(238);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _f_ApplicantCard = __webpack_require__(1056);
	
	var _f_ApplicantCard2 = _interopRequireDefault(_f_ApplicantCard);
	
	var _CardFilter = __webpack_require__(446);
	
	var _CardFilter2 = _interopRequireDefault(_CardFilter);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// hold style object out here for performance
	var verticalScrollbarStyle = { borderRadius: '4px' };
	
	// utility
	
	
	// components
	
	
	var initState = {
	  isFlipped: false,
	  checkList: []
	};
	
	var ApplicantsColumn = (_temp = _class = function (_Component) {
	  _inherits(ApplicantsColumn, _Component);
	
	  function ApplicantsColumn(props, context) {
	    _classCallCheck(this, ApplicantsColumn);
	
	    var _this = _possibleConstructorReturn(this, (ApplicantsColumn.__proto__ || Object.getPrototypeOf(ApplicantsColumn)).call(this, props, context));
	
	    _this.state = _lodash2.default.assign({}, initState);
	
	
	    _this.state.statusList = _lodash2.default.reduce(_lodash2.default.keysIn(props.applicantsColumn), function (result, status) {
	      result.push({ id: _lodash2.default.get(props.applicantStatusKeyedByName, status + '.id'), name: status });
	      return result;
	    }, []);
	    return _this;
	  }
	
	  _createClass(ApplicantsColumn, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Reset filters when resultes changed.
	      if (!_lodash2.default.isEqual(nextProps.terms, this.props.terms)) {
	        this.setState(_lodash2.default.assign({}, initState));
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event, newStatusArr) {
	      this.setState({
	        checkList: newStatusArr
	      });
	    }
	  }, {
	    key: 'flipColumn',
	    value: function flipColumn() {
	      this.setState({
	        isFlipped: !this.state.isFlipped
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          header = _props.header,
	          applicantsColumn = _props.applicantsColumn,
	          expandCard = _props.expandCard,
	          selectedEmail = _props.selectedEmail;
	
	
	      var applicantsComponentArr = (0, _lodash2.default)(applicantsColumn).map(function (status) {
	        return _lodash2.default.filter(status, function (applicant) {
	          // Filter by statuses.
	          if (!_lodash2.default.isEmpty(_this2.state.checkList) && !~_this2.state.checkList.indexOf(applicant.profile.applicantStatus.id)) {
	            return false;
	          }
	
	          return true;
	        }).map(function (applicant) {
	          return _react2.default.createElement(_f_ApplicantCard2.default, { key: applicant.user.email,
	            expandCard: expandCard,
	            selectedEmail: selectedEmail,
	            applicant: applicant });
	        });
	      }).flatten().value();
	
	      // flip if state says so
	      if (this.state.isFlipped) {
	        applicantsComponentArr.reverse();
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'applicants-column center-column-1', 'data-id': header },
	        _react2.default.createElement(
	          'header',
	          { className: 'header-container', onClick: this.flipColumn.bind(this) },
	          _react2.default.createElement(
	            'h3',
	            { className: 'count', 'data-id': header + ' Count' },
	            applicantsComponentArr.length
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'header' },
	            header
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('chevron', { flipped: this.state.isFlipped }), onClick: this.flipColumn.bind(this) },
	            _react2.default.createElement(_ChevronIcon2.default, null)
	          ),
	          _react2.default.createElement(_CardFilter2.default, {
	            search: this.props.terms,
	            menuItems: this.state.statusList,
	            onChange: this.onChange.bind(this)
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'applicants-list',
	            speed: 1 },
	          applicantsComponentArr
	        )
	      );
	    }
	  }]);
	
	  return ApplicantsColumn;
	}(_react.Component), _class.propTypes = {
	  expandCard: _react.PropTypes.func.isRequired,
	  header: _react.PropTypes.string.isRequired,
	  applicantsColumn: _react.PropTypes.object,
	  applicantStatusKeyedByName: _react.PropTypes.object,
	  selectedEmail: _react.PropTypes.string,
	  terms: _react.PropTypes.array
	}, _temp);
	exports.default = ApplicantsColumn;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utility
	
	
	// lib
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _localDate = __webpack_require__(308);
	
	var _localDate2 = _interopRequireDefault(_localDate);
	
	var _emailLink = __webpack_require__(305);
	
	var _emailLink2 = _interopRequireDefault(_emailLink);
	
	var _rcPager = __webpack_require__(280);
	
	var _rcPager2 = _interopRequireDefault(_rcPager);
	
	var _PreviousIcon = __webpack_require__(233);
	
	var _PreviousIcon2 = _interopRequireDefault(_PreviousIcon);
	
	var _NextIcon = __webpack_require__(232);
	
	var _NextIcon2 = _interopRequireDefault(_NextIcon);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _Table = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicantsTable = (_temp = _class = function (_Component) {
	  _inherits(ApplicantsTable, _Component);
	
	  function ApplicantsTable(props, context) {
	    _classCallCheck(this, ApplicantsTable);
	
	    var _this = _possibleConstructorReturn(this, (ApplicantsTable.__proto__ || Object.getPrototypeOf(ApplicantsTable)).call(this, props, context));
	
	    _this.sortColumn = _this.sortColumn.bind(_this);
	    var initialState = {
	      isFlipped: false,
	      qualifyingSpecialists: _lodash2.default.keyBy(_this.props.qualifyingSpecialists, 'employeeId'),
	      sortBy: {
	        by: 'id',
	        order: 'desc'
	      }
	    };
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(ApplicantsTable, [{
	    key: 'flipColumn',
	    value: function flipColumn() {
	      this.setState({
	        isFlipped: !this.state.isFlipped
	      });
	    }
	  }, {
	    key: 'handleSkip',
	    value: function handleSkip(currentPage) {
	      if (this.props.OnPageChange) {
	        this.props.OnPageChange(this.props.navColumnState, currentPage, this.props.pageSize, this.state.sortBy);
	      }
	    }
	  }, {
	    key: 'sortColumn',
	    value: function sortColumn(columnName) {
	      var newState = _lodash2.default.merge(this.state, {
	        sortBy: {
	          by: columnName,
	          order: this.state.sortBy.by === columnName && this.state.sortBy.order === 'desc' ? 'asc' : 'desc' }
	      });
	
	      this.setState(newState);
	
	      if (this.props.OnPageChange) {
	        this.props.OnPageChange(this.props.navColumnState, this.props.currentPage, this.props.pageSize, newState.sortBy);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          applicantGroup = _props.applicantGroup,
	          expandCard = _props.expandCard,
	          total = _props.total;
	
	
	      var currentCount = this.props.pageSize * (this.props.currentPage + 1);
	      currentCount = currentCount < total ? currentCount : total;
	
	      var applicants = _lodash2.default.get(applicantGroup, 'data.items', []);
	
	      var applicantsComponentArr = (0, _lodash2.default)(applicants).map(function (applicant) {
	        // const qualifyingSpecialist = _.get(this.state.qualifyingSpecialists, applicant.profile.qualifyingSpecialistId, {});
	        var _$get = _lodash2.default.get(_this2.props.applicantStatusKeyedByName, applicant.profile.applicantStatus.name, {}),
	            color = _$get.color,
	            label = _$get.label,
	            lifespan = _$get.lifespan;
	
	        // this will be a prop
	
	
	        var transparentPct = _lodash2.default.isNil(lifespan) ? 1 : lifespan > 0 ? 1 - (+new Date() - +new Date(applicant.profile.dateModified)) / (lifespan * 60 * 60 * 1000) : 0;
	        var rgbaColor = 'rgba(' + _lodash2.default.chunk(color.slice(1), 2).map(function (stringArr) {
	          return Number.parseInt(stringArr.join(''), 16);
	        }).join() // conversion from base 16
	        + ',' + transparentPct + ')'; // calculating opacity
	
	        return _react2.default.createElement(
	          _Table.TableRow,
	          { className: 'applicant-row', key: '' + applicant.user.email, 'data-id': '' + applicant.user.email },
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'name', style: { paddingLeft: '7px' } },
	            _react2.default.createElement('div', { className: 'expand-icon', onClick: expandCard.bind(_this2, applicant.profile.id) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'applicant-name', 'data-id': 'Name', onClick: expandCard.bind(_this2, applicant.profile.id, true) },
	              applicant.user.firstName + ' ' + applicant.user.lastName
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'status', style: { paddingLeft: '12px' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'status-circle', 'data-id': 'Status Icon', style: { backgroundColor: rgbaColor, borderColor: color, color: transparentPct < 0.25 ? color : '#fff' } },
	              label || ''
	            ),
	            applicant.profile.applicantStatus.name
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'phone', style: { paddingLeft: '12px', width: '148px' } },
	            (0, _prettyPhone2.default)(applicant.user.phoneNumber1)
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'email', style: { paddingLeft: '12px', width: '200px' } },
	            (0, _emailLink2.default)(applicant.user.email)
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'availability', style: { paddingLeft: '12px', width: '140px' } },
	            (0, _localDate2.default)(applicant.profile.availabilityDate)
	          ),
	          _react2.default.createElement(
	            _Table.TableRowColumn,
	            { className: 'applied-date', style: { paddingLeft: '12px', width: '107px' } },
	            (0, _localDate2.default)(applicant.profile.dateCreated)
	          )
	        );
	      }).value();
	
	      // flip if state says so
	      if (this.state.isFlipped) {
	        applicantsComponentArr.reverse();
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'applicants-column applicant-table', 'data-id': 'applicant-list' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pager-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pager-info' },
	            'Showing ',
	            _react2.default.createElement(
	              'span',
	              { className: 'count' },
	              currentCount
	            ),
	            ' of ',
	            _react2.default.createElement(
	              'span',
	              { className: 'count' },
	              total
	            )
	          ),
	          _react2.default.createElement(_rcPager2.default, {
	            total: Math.ceil(total / this.props.pageSize),
	            current: this.props.currentPage,
	            onSkipTo: this.handleSkip.bind(this),
	            previousLabel: _react2.default.createElement(
	              'div',
	              { className: 'prev' },
	              _react2.default.createElement(_PreviousIcon2.default, null),
	              ' PREV'
	            ),
	            nextLabel: _react2.default.createElement(
	              'div',
	              { className: 'next' },
	              'NEXT ',
	              _react2.default.createElement(_NextIcon2.default, null)
	            )
	          })
	        ),
	        _react2.default.createElement(
	          _Table.Table,
	          {
	            selectable: false,
	            multiSelectable: false,
	            fixedHeader: true,
	            height: 'calc(100vh - 286.5px)'
	          },
	          _react2.default.createElement(
	            _Table.TableHeader,
	            {
	              displaySelectAll: false,
	              adjustForCheckbox: false
	            },
	            _react2.default.createElement(
	              _Table.TableRow,
	              null,
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'name', style: { paddingLeft: '7px' } },
	                'Name'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'status', style: { paddingLeft: '12px' } },
	                'Status'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'phone', style: { paddingLeft: '12px', width: '148px' } },
	                'Phone #'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'email', style: { paddingLeft: '12px', width: '200px' } },
	                'Email'
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                {
	                  className: (0, _classnames2.default)('availabilityDate', { 'wv-pointer': true }),
	                  style: { padding: '0px', width: '140px' }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { onClick: function onClick() {
	                      return _this2.sortColumn('availabilityDate');
	                    } },
	                  'Availability',
	                  _react2.default.createElement(
	                    'span',
	                    { className: (0, _classnames2.default)('wv-chevron', { active: this.state.sortBy.by === 'availabilityDate' }, { flipped: this.state.sortBy.by === 'availabilityDate' && this.state.sortBy.order === 'desc' }) },
	                    _react2.default.createElement(_ChevronIcon2.default, null)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { className: 'applied-date', style: { paddingLeft: '12px', width: '107px' } },
	                'Applied'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Table.TableBody,
	            {
	              displayRowCheckbox: false
	            },
	            applicantsComponentArr
	          )
	        )
	      );
	    }
	  }]);
	
	  return ApplicantsTable;
	}(_react.Component), _class.propTypes = {
	  applicantGroup: _react.PropTypes.object.isRequired,
	  expandCard: _react.PropTypes.func,
	  qualifyingSpecialists: _react.PropTypes.object,
	  applicantStatusKeyedByName: _react.PropTypes.object,
	  OnPageChange: _react.PropTypes.func,
	  total: _react.PropTypes.any,
	  navColumnState: _react.PropTypes.any,
	  currentPage: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number
	}, _temp);
	exports.default = ApplicantsTable;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _r_Search = __webpack_require__(1060);
	
	var _r_Search2 = _interopRequireDefault(_r_Search);
	
	var _Filters = __webpack_require__(1055);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _c_ApplicantsColumn = __webpack_require__(1057);
	
	var _c_ApplicantsColumn2 = _interopRequireDefault(_c_ApplicantsColumn);
	
	var _c_ApplicantsTable = __webpack_require__(1058);
	
	var _c_ApplicantsTable2 = _interopRequireDefault(_c_ApplicantsTable);
	
	var _staticData = __webpack_require__(28);
	
	var _prettyTimezone = __webpack_require__(466);
	
	var _prettyTimezone2 = _interopRequireDefault(_prettyTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tableGroups = ['Qualified', 'Inactive', 'No Longer Placeable'];
	
	var ApplicantManager = (_dec = (0, _reactRedux.connect)(function (state) {
	  // storing final object
	  var applicantGroups = {};
	
	  var qualifyingSpecialists = state.staticData.qualifyingSpecialists;
	
	  // groups with keys as group names
	  var statusGroups = _lodash2.default.keyBy(state.staticData.statusGroups, 'name');
	
	  // statuses with keys as status names
	  var applicantStatusKeyedByName = _lodash2.default.keyBy(state.staticData.applicantStatus, 'name');
	
	  // add empty 'applicants' array to statuses
	  _lodash2.default.forEach(applicantStatusKeyedByName, function (applicantStatus) {
	    return applicantStatus.applicants = [];
	  }); // eslint-disable-line no-return-assign
	
	  // push corresponding applicants into the 'applicants' arrays
	  _lodash2.default.forEach(_lodash2.default.omit(state.admin.applicants.search, ['pinned']), function (group, groupName) {
	    if (!~tableGroups.indexOf(groupName) && !_lodash2.default.isEmpty(group.items)) {
	      group.items.forEach(function (applicant) {
	        var statusName = applicant.profile.applicantStatus.name;
	        applicantStatusKeyedByName[statusName].applicants.push(_lodash2.default.merge(_lodash2.default.pick(applicantStatusKeyedByName[statusName], ['color', 'label', 'lifespan']), applicant, {
	          timezone: (0, _prettyTimezone2.default)((0, _staticData.lookup)(state.staticData, 'timezoneList', { id: applicant.user.timezone })),
	          bestContactTime: (0, _staticData.lookup)(state.staticData, 'bestContactTimeList', { id: applicant.user.bestContactTime })
	        }));
	      });
	    } else {
	      _lodash2.default.set(applicantGroups, groupName + '.data', _lodash2.default.get(state.admin.applicants.search, groupName));
	    }
	  });
	  // organizing into nested object
	  (0, _lodash2.default)(applicantStatusKeyedByName).groupBy('subGroup').forEach(function (subGroup, subGroupName) {
	    _lodash2.default.forEach(statusGroups, function (group, groupName) {
	      // check if subGroup status is contained in group
	      if (~group.statuses.indexOf(subGroup[0].id)) {
	        // if so, use lodash's deep property set method to place this object on 'applicantGroups'
	        _lodash2.default.set(applicantGroups, groupName + '.' + subGroupName, (0, _lodash2.default)(subGroup).keyBy('name').mapValues(function (val) {
	          return val.applicants;
	        }).value());
	      }
	    });
	  });
	
	  var searchQuery = state.routing.locationBeforeTransitions.query.search;
	
	  return {
	    user: state.user,
	    qualifyingSpecialists: qualifyingSpecialists,
	    applicants: state.admin.applicants.search,
	    applicantGroups: applicantGroups,
	    applicantStatusKeyedByName: applicantStatusKeyedByName,
	    search: searchQuery && [].concat(searchQuery) || [],
	    staticData: state.staticData
	  };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(ApplicantManager, _Component);
	
	  function ApplicantManager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ApplicantManager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ApplicantManager.__proto__ || Object.getPrototypeOf(ApplicantManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      filters: {},
	      terms: [],
	      currentPage: 0,
	      pageSize: 25
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ApplicantManager, [{
	    key: 'onTermChange',
	    value: function onTermChange(terms) {
	      var _this2 = this;
	
	      this.setState({ terms: terms, currentPage: 0 }, function () {
	        return _this2.props.onSearch(_this2.state.terms, _this2.state.filters);
	      });
	    }
	  }, {
	    key: 'onFilterChange',
	    value: function onFilterChange(filters) {
	      var _this3 = this;
	
	      this.setState({ filters: filters, currentPage: 0 }, function () {
	        return _this3.props.onSearch(_this3.state.terms, _this3.state.filters);
	      });
	    }
	  }, {
	    key: 'OnPageChange',
	    value: function OnPageChange(group, currentPage, pageSize, sortBy) {
	      this.setState({
	        currentPage: currentPage
	      });
	      this.props.onPageChange(this.state.terms, this.state.filters, group, pageSize * currentPage, sortBy);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'applicant-manager columns-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'admin-top-bar' },
	          _react2.default.createElement(_r_Search2.default, { navColumnState: this.props.navColumnState, onTermChange: this.onTermChange.bind(this) }),
	          _react2.default.createElement(_Filters2.default, {
	            terms: this.state.terms,
	            onFilterChange: this.onFilterChange.bind(this),
	            staticData: this.props.staticData,
	            specialists: this.props.qualifyingSpecialists,
	            admin: !!~this.props.user.roles.indexOf('Admin'),
	            navColumnState: this.props.navColumnState
	          })
	        ),
	        !~tableGroups.indexOf(this.props.navColumnState) && this.props.applicantGroups[this.props.navColumnState] && _lodash2.default.map(_lodash2.default.omit(this.props.applicantGroups[this.props.navColumnState], ['data']), function (column, header) {
	          var _React$createElement;
	
	          return _react2.default.createElement(_c_ApplicantsColumn2.default, (_React$createElement = {
	            key: _this4.props.navColumnState,
	            terms: _this4.state.terms
	          }, _defineProperty(_React$createElement, 'key', header), _defineProperty(_React$createElement, 'expandCard', _this4.props.expandCard), _defineProperty(_React$createElement, 'selectedEmail', _this4.props.selectedEmail), _defineProperty(_React$createElement, 'header', header), _defineProperty(_React$createElement, 'applicantsColumn', column), _defineProperty(_React$createElement, 'applicantStatusKeyedByName', _this4.props.applicantStatusKeyedByName), _React$createElement));
	        }),
	        !!~tableGroups.indexOf(this.props.navColumnState) && this.props.applicantGroups[this.props.navColumnState] && _react2.default.createElement(_c_ApplicantsTable2.default, {
	          key: this.props.navColumnState,
	          terms: this.state.terms,
	          expandCard: this.props.expandCard,
	          selectedEmail: this.props.selectedEmail,
	          applicantGroup: this.props.applicantGroups[this.props.navColumnState],
	          navColumnState: this.props.navColumnState,
	          total: _lodash2.default.get(this.props.applicants, this.props.navColumnState + '.total', 0),
	          qualifyingSpecialists: this.props.qualifyingSpecialists,
	          applicantStatusKeyedByName: this.props.applicantStatusKeyedByName,
	          currentPage: this.state.currentPage,
	          pageSize: this.state.pageSize,
	          OnPageChange: this.OnPageChange.bind(this)
	        })
	      );
	    }
	  }]);
	
	  return ApplicantManager;
	}(_react.Component), _class2.propTypes = {
	  user: _react.PropTypes.object,
	  qualifyingSpecialists: _react.PropTypes.any,
	  dispatch: _react.PropTypes.func.isRequired,
	  expandCard: _react.PropTypes.func.isRequired,
	  navColumnState: _react.PropTypes.string.isRequired,
	  applicants: _react.PropTypes.any,
	  applicantGroups: _react.PropTypes.object,
	  applicantStatusKeyedByName: _react.PropTypes.object,
	  selectedEmail: _react.PropTypes.string,
	  search: _react.PropTypes.array,
	  onSearch: _react.PropTypes.func,
	  onPageChange: _react.PropTypes.func,
	  staticData: _react.PropTypes.object
	}, _temp2)) || _class);
	exports.default = ApplicantManager;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is 'retrieve the property 'Component' off of the object exported from the 'react'
	
	
	// helper functions
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _querystring = __webpack_require__(105);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SearchIcon = __webpack_require__(167);
	
	var _SearchIcon2 = _interopRequireDefault(_SearchIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = (_dec = (0, _reactRedux.connect)(function (store) {
	  var searchQuery = store.routing.locationBeforeTransitions.query.search;
	  return {
	    search: searchQuery && [].concat(searchQuery) || []
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props, context) {
	    _classCallCheck(this, Search);
	
	    // asyncActionCreator.search(this.state.searchTags.concat(str))
	    // only run search when there's 50 ms of no other running's of search
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));
	
	    _this.state = {
	      searchTags: []
	    };
	    _this.search = function () {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      // default to empty array
	      _this.props.dispatch((0, _reactRouterRedux.push)('/admin/' + _this.props.navColumnState + (arr.length ? '?' + (0, _querystring.stringify)({ search: arr.map(function (q) {
	          return _this.strip(q);
	        }) }) : '')));
	      _this.props.onTermChange(arr);
	    };
	    _this.debouncedSearch = _lodash2.default.debounce(_this.search, 200);
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.search) {
	        this.setState({
	          searchTags: this.props.search // need to make string JSON parse-able
	        });
	      }
	    }
	  }, {
	    key: 'inputKeyEvents',
	    value: function inputKeyEvents(e) {
	      if (e.key === 'Enter' || e.key === ' ') {
	        // Enter pressed
	        if (e.target.value.trim()) {
	          // test if input is empty
	          e.preventDefault();
	          e.stopPropagation();
	          var updatedSearch = this.state.searchTags.concat(e.target.value.trim());
	          this.search(updatedSearch);
	          this.setState({ // add tag
	            searchTags: updatedSearch // remove whitespace at the beginning and end of string
	          });
	          this.refs.search.value = '';
	        }
	      }
	      if (!e.target.value && this.state.searchTags.length && e.key === 'Backspace') {
	        // Backspace pressed
	        this.removeTag(this.state.searchTags.length - 1);
	      }
	    }
	  }, {
	    key: 'removeTag',
	    value: function removeTag(removalIndex) {
	      var updatedSearch = this.state.searchTags.filter(function (val, index) {
	        return index !== removalIndex;
	      });
	      this.debouncedSearch(updatedSearch);
	      this.setState({
	        searchTags: updatedSearch
	      });
	    }
	  }, {
	    key: 'searchOnChange',
	    value: function searchOnChange(e) {
	      if (e.target.value.trim().length > 2 || e.key === 'Backspace') {
	        this.debouncedSearch(this.state.searchTags.concat(e.target.value.trim()));
	      }
	    }
	  }, {
	    key: 'strip',
	    value: function strip(query) {
	      var phoneRegex = /(-|\(|\))/g;
	      query = query.replace(phoneRegex, '');
	      return query;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search' },
	        _react2.default.createElement(
	          'div',
	          { className: 'search-input-container' },
	          _react2.default.createElement(_SearchIcon2.default, null),
	          this.state.searchTags.map(function (val, index) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'search-tag', key: index },
	              val,
	              _react2.default.createElement('span', { className: 'close-icon', onClick: _this2.removeTag.bind(_this2, index) })
	            );
	          }),
	          _react2.default.createElement('input', { 'data-id': 'Search',
	            ref: 'search',
	            className: 'search-input',
	            type: 'text',
	            placeholder: 'Search...',
	            onKeyDown: this.inputKeyEvents.bind(this) })
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  navColumnState: _react.PropTypes.string.isRequired,
	  location: _react.PropTypes.object,
	  search: _react.PropTypes.array,
	  onTermChange: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = Search;

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var appViewState = exports.appViewState = {
	  firstTime: true,
	  Profile: {
	    'Contact Information': {
	      done: false
	    },
	    'Preliminary Information': {
	      done: false
	    }
	  },
	  Instructions: {
	    Instructions: {
	      done: false
	    }
	  },
	  Preferences: {
	    'Availability Information': {
	      done: false
	    },
	    'Home Office Setup': {
	      done: false
	    }
	  },
	  Experience: {
	    'Career Summary': {
	      done: false
	    },
	    'Work Experience': {
	      done: false
	    },
	    'Employment Gaps': {
	      done: false
	    }
	  },
	  Skills: {
	    Instructions: {
	      done: false
	    },
	    'Industry Segments': {
	      done: false
	    },
	    'Firm Types': {
	      done: false
	    },
	    Positions: {
	      done: false
	    },
	    Departments: {
	      done: false
	    },
	    'Areas of Expertise': {
	      done: false
	    },
	    'Mgmt Systems': {
	      done: false
	    },
	    'Computer Skills': {
	      done: false
	    },
	    'Rating Systems': {
	      done: false
	    },
	    Languages: {
	      done: false
	    }
	  },
	  'Summary of Skills': {
	    'Summary of Skills': {
	      done: false
	    }
	  },
	  Background: {
	    Licenses: {
	      done: false
	    },
	    Education: {
	      done: false
	    },
	    'Professional Associations': {
	      done: false
	    },
	    'Professional Designations': {
	      done: false
	    },
	    'Additional Professional References': {
	      done: false
	    }
	  },
	  Documents: {
	    done: false
	  },
	  Submit: {
	    done: false
	  },
	  Assessments: {
	    done: false
	  }
	};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ApplicationProgress;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	function ApplicationProgress(props) {
	  var _this = this;
	
	  var activeHit = false;
	  var checkedIndex = 0;
	  props.rowSubNav.forEach(function (subNav, index) {
	    return (props.viewData[props.rowSubNav[index].key] || {}).done ? checkedIndex = index : null;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'application-progress-wrapper' },
	    _react2.default.createElement(
	      'ul',
	      {
	        className: 'application-progress ' + props.className
	      },
	      props.rowSubNav.map(function (subNav, index) {
	        // at present show checked until selected point (not holding "complete" state)
	        var isActive = props.rowSubNav[index].key === props.activeRowSubNav;
	        if (isActive) activeHit = true;
	
	        // will change checked to be conditional on accordionData!!!
	        return _react2.default.createElement(
	          'li',
	          {
	            key: index,
	            'data-id': subNav.display,
	            className: (0, _classnames2.default)('subnav-button', { hide: subNav.display === 'Introduction' }, { active: isActive }, { bottomBorder: !activeHit || index < checkedIndex }, { highlightedCircleEdge: !activeHit || isActive || index <= checkedIndex }, { checked: (props.viewData[props.rowSubNav[index].key] || {}).done }),
	            onClick: props.updateRowSubNav.bind(_this, subNav.key)
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'subnav-text-container' },
	            _react2.default.createElement(
	              'span',
	              { className: 'subnav-text' },
	              subNav.display
	            )
	          )
	        );
	      })
	    )
	  );
	}
	
	// class name
	
	
	ApplicationProgress.propTypes = {
	  updateRowSubNav: _react.PropTypes.func,
	  activeRowSubNav: _react.PropTypes.string,
	  adjustProgressView: _react.PropTypes.number,
	  rowSubNav: _react.PropTypes.array,
	  viewData: _react.PropTypes.object,
	  className: _react.PropTypes.string
	};

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	// view ordering array of arrays
	
	
	exports.default = Application;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _f_ApplicationProgress = __webpack_require__(1062);
	
	var _f_ApplicationProgress2 = _interopRequireDefault(_f_ApplicationProgress);
	
	var _r_ApplicationForm = __webpack_require__(1086);
	
	var _r_ApplicationForm2 = _interopRequireDefault(_r_ApplicationForm);
	
	var _viewOrderArr = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Application(props) {
	  var currentNav = (0, _lodash.find)(_viewOrderArr.viewOrderArr, function (v) {
	    return v.key === props.activeColumnNav;
	  });
	  var hideSubNavSubmitted = (0, _lodash.get)(currentNav, 'hideSubNavSubmitted', false) && props.submitted;
	  var showProgress = !!props.rowSubNav.length && !hideSubNavSubmitted;
	  var activeColumnNav = (props.activeColumnNav || '').toLowerCase();
	  return _react2.default.createElement(
	    'div',
	    { className: 'application-container clearfix' },
	    showProgress && _react2.default.createElement(_f_ApplicationProgress2.default, _extends({
	      className: activeColumnNav,
	      updateRowSubNav: props.navStateChange.bind(this, props.activeColumnNav)
	    }, props)),
	    !props.assessment ? _react2.default.createElement(_r_ApplicationForm2.default, _extends({
	      className: (0, _classnames2.default)({ 'progress-is-showing': showProgress })
	    }, props)) : null
	  );
	}
	
	Application.propTypes = {
	  navStateChange: _react.PropTypes.func,
	  activeColumnNav: _react.PropTypes.string,
	  rowSubNav: _react.PropTypes.array
	};
	
	Application.defaultProps = {
	  rowSubNav: []
	};

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _staticData = __webpack_require__(170);
	
	var _reference = __webpack_require__(468);
	
	var _ValidatedForm2 = __webpack_require__(200);
	
	var _ValidatedForm3 = _interopRequireDefault(_ValidatedForm2);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _validator = __webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Reference = (_temp = _class = function (_ValidatedForm) {
	  _inherits(Reference, _ValidatedForm);
	
	  function Reference(props, context) {
	    _classCallCheck(this, Reference);
	
	    var _this = _possibleConstructorReturn(this, (Reference.__proto__ || Object.getPrototypeOf(Reference)).call(this, props, context));
	
	    _this.handleUpdate = function (clientId, prop) {
	      return function (model, field, event, value) {
	        return _this.props.onChange(clientId, prop, event, value);
	      };
	    };
	
	    _this.state = {
	      validation: Object.assign({}, props.validation)
	    };
	    return _this;
	  }
	
	  _createClass(Reference, [{
	    key: 'validateForm',
	
	
	    // Override: ValidatedForm.validateForm
	    value: function validateForm() {
	      var state = (0, _lodash.merge)({}, (0, _lodash.get)(this, 'state'));
	      var reference = this.formModel;
	
	      var _validate = this.validate(reference),
	          _validate2 = _slicedToArray(_validate, 2),
	          valid = _validate2[0],
	          validation = _validate2[1];
	
	      this.setState(_extends({}, state, { validation: validation }));
	      return valid;
	    }
	
	    // Override: ValidatedForm.validateUpdate
	
	  }, {
	    key: 'validateUpdate',
	    value: function validateUpdate(model, field, callback) {
	      var _this2 = this;
	
	      return function (event, value) {
	        var reference = _this2.formModel;
	        reference[field] = value;
	
	        var _validate3 = _this2.validate(reference),
	            _validate4 = _slicedToArray(_validate3, 2),
	            valid = _validate4[0],
	            validation = _validate4[1];
	
	        var newState = (0, _lodash.merge)({}, (0, _lodash.omit)(_this2.state, ['validation.' + field]), {
	          validation: _extends({}, (0, _lodash.pick)(validation, [field]))
	        });
	
	        _this2.setState(newState);
	        if (callback) {
	          callback(model, field, event, value);
	        }
	      };
	    }
	  }, {
	    key: 'validate',
	    value: function validate(reference) {
	
	      var form = (0, _validator.validateObject)(reference, this.validationSchema);
	      var errors = typeof form.errors === 'string' ? {} : form.errors;
	
	      return [form.valid, errors];
	    }
	  }, {
	    key: 'handleRemove',
	    value: function handleRemove(clientId) {
	      var _this3 = this;
	
	      return function () {
	        return _this3.props.onRemove(clientId);
	      };
	    }
	  }, {
	    key: 'renderAttributes',
	    value: function renderAttributes(prop, label) {
	      var _ref;
	
	      var updateOn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onBlur';
	      var valueOn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'defaultValue';
	
	      return _ref = {
	        floatingLabelText: label,
	        'data-id': prop + ' ' + this.props.index
	      }, _defineProperty(_ref, valueOn, this.props.reference[prop]), _defineProperty(_ref, 'isDirty', !!(0, _lodash.get)(this.state, 'validation.' + prop + '[0]', false)), _defineProperty(_ref, 'errorText', (0, _lodash.get)(this.state, 'validation.' + prop + '[0]')), _defineProperty(_ref, updateOn, this.validateUpdate(this.props.model, prop, this.handleUpdate(this.formModel.clientId, prop))), _ref;
	    }
	  }, {
	    key: 'renderMenuItems',
	    value: function renderMenuItems(items) {
	      return {
	        menuItems: typeof items === 'string' ? this.props.staticData[items] : items
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var reference = this.props.reference;
	      var index = this.props.index;
	      var showRemove = this.props.showRemove;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: index,
	          className: 'reference form-contents'
	        },
	        _react2.default.createElement(_c_TextField2.default, this.renderAttributes('name', 'Reference Name')),
	        _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	          mask: '(999) 999-9999',
	          hideMaskChar: true
	        }, this.renderAttributes('phoneNumber', 'Phone Number'))),
	        _react2.default.createElement(_c_TextField2.default, this.renderAttributes('position', 'Position')),
	        _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	          mask: '999',
	          hideMaskChar: true
	        }, this.renderAttributes('yearsKnown', 'Years Known'))),
	        _react2.default.createElement(_c_TextField2.default, this.renderAttributes('company', 'Company')),
	        _react2.default.createElement(
	          _c_DropDownMenu2.default,
	          _extends({
	            className: 'relationship-container',
	            canAutoPosition: 'true'
	          }, this.renderAttributes('relationshipId', 'Relationship', 'onChange', 'value'), this.renderMenuItems('referenceRelationshipTypes')),
	          {
	            Other: _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'other-relationship'
	            }, this.renderAttributes('relationshipOther', 'Other Relationship')))
	          }
	        ),
	        showRemove && _react2.default.createElement(
	          'div',
	          {
	            'data-id': 'remove-section',
	            className: 'remove-section text-btn noTextSelect',
	            onClick: this.handleRemove(reference.clientId)
	          },
	          'Remove Reference'
	        )
	      );
	    }
	  }, {
	    key: 'validationSchema',
	    get: function get() {
	      var referenceRelationshipTypes = (0, _staticData.getDataType)('referenceRelationshipTypes');
	      return (0, _reference.getSchema)({ referenceRelationshipTypes: referenceRelationshipTypes });
	    }
	
	    // Override: ValidatedForm.formModel
	
	  }, {
	    key: 'formModel',
	    get: function get() {
	      return (0, _lodash.merge)({}, (0, _lodash.get)(this, 'props.reference'), (0, _lodash.get)(this, 'props.tempState.references[' + this.props.reference.clientId + ']'));
	    }
	  }]);
	
	  return Reference;
	}(_ValidatedForm3.default), _class.propTypes = {
	  reference: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  onChange: _react.PropTypes.func.isRequired,
	  onRemove: _react.PropTypes.func.isRequired,
	  index: _react.PropTypes.number,
	  showRemove: _react.PropTypes.bool
	}, _temp);
	exports.default = Reference;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// class name
	// import cx from 'classnames';
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _C_ProgressComponentList = __webpack_require__(140);
	
	var _C_ProgressComponentList2 = _interopRequireDefault(_C_ProgressComponentList);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _Reference = __webpack_require__(1064);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// static constants
	var formHeading = 'Additional Professional References';
	var formText = '\n  Please provide two additional work related references. We have your permission to contact these references. If you have letters of reference, you will be able to attach them in the Documents section.\n';
	
	// styling obj
	var addButtonStyle = {
	  display: 'inline-block',
	  top: '35px',
	  width: '165px',
	  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
	};
	
	var AdditionalReferences = (_temp = _class = function (_ProgressComponentLis) {
	  _inherits(AdditionalReferences, _ProgressComponentLis);
	
	  function AdditionalReferences(props, context) {
	    _classCallCheck(this, AdditionalReferences);
	
	    return _possibleConstructorReturn(this, (AdditionalReferences.__proto__ || Object.getPrototypeOf(AdditionalReferences)).call(this, props, context));
	  }
	
	  // Override ValidatedForm.validateForm()
	
	
	  _createClass(AdditionalReferences, [{
	    key: 'validateForm',
	    value: function validateForm() {
	      var referenceComponents = (0, _lodash.filter)(this.refs, function (ref) {
	        return ref.validateForm;
	      });
	
	      var hasTwoReferences = referenceComponents.length >= 2;
	      var sectionValidation = referenceComponents.reduce(function (valid, section) {
	        return section.validateForm() && valid;
	      }, true);
	
	      return sectionValidation && hasTwoReferences;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var referenceArr = this.getList(false);
	      var emptyReference = this.newReference;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'references-container application-section-container clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          formHeading
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-text' },
	          formText
	        ),
	        referenceArr.length && referenceArr.map(function (reference, index, arr) {
	          return _react2.default.createElement(_Reference2.default, {
	            key: reference.clientId,
	            ref: reference.clientId,
	            index: index,
	            reference: reference,
	            tempState: _this2.props.tempState,
	            staticData: _this2.props.staticData,
	            validation: _this2.props.validation,
	            onChange: _this2.onChange.bind(_this2),
	            onRemove: _this2.removeListItem.bind(_this2),
	            showRemove: arr.length > 1
	          });
	        }) || _react2.default.createElement(_Reference2.default, {
	          key: emptyReference.clientId,
	          ref: emptyReference.clientId,
	          index: 0,
	          reference: emptyReference,
	          tempState: this.props.tempState,
	          staticData: this.props.staticData,
	          validation: this.props.validation,
	          onChange: this.onChange.bind(this),
	          onRemove: this.removeListItem.bind(this),
	          showRemove: false
	        }),
	        _react2.default.createElement(_c_FlatButton2.default, {
	          onClick: this.addListItem.bind(this),
	          style: _extends({}, addButtonStyle, !referenceArr.length && { top: '10.5px' } || {}),
	          label: 'Add Reference'
	        })
	      );
	    }
	  }, {
	    key: 'newReference',
	    get: function get() {
	      return {
	        isNew: true,
	        clientId: this.newClientId
	      };
	    }
	  }, {
	    key: 'newClientId',
	    get: function get() {
	      return '' + this.getIncrementedChar() + _shortid2.default.generate();
	    }
	  }]);
	
	  return AdditionalReferences;
	}(_C_ProgressComponentList2.default), _class.propTypes = {
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired
	}, _temp);
	exports.default = AdditionalReferences;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ValidatedForm2 = __webpack_require__(200);
	
	var _ValidatedForm3 = _interopRequireDefault(_ValidatedForm2);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _DateInputDropDown = __webpack_require__(229);
	
	var _DateInputDropDown2 = _interopRequireDefault(_DateInputDropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EducationRecord = (_temp = _class = function (_ValidatedForm) {
	  _inherits(EducationRecord, _ValidatedForm);
	
	  function EducationRecord(props, context) {
	    _classCallCheck(this, EducationRecord);
	
	    var _this = _possibleConstructorReturn(this, (EducationRecord.__proto__ || Object.getPrototypeOf(EducationRecord)).call(this, props, context));
	
	    _this.handleUpdate = function (clientId, prop) {
	      return function (model, field, event, value) {
	        return _this.props.onChange(clientId, prop, event, value);
	      };
	    };
	
	    _this.handleRemove = function (clientId) {
	      return function () {
	        return _this.props.onRemove(clientId);
	      };
	    };
	
	    _this.state = {
	      validation: Object.assign({}, props.validation)
	    };
	    return _this;
	  }
	
	  // Override ValidatedForm.formModel method
	
	
	  _createClass(EducationRecord, [{
	    key: 'renderAttributes',
	    value: function renderAttributes(prop, label) {
	      var _ref;
	
	      var updateOn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onBlur';
	      var valueOn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'defaultValue';
	
	      return _ref = {
	        // need to replace '\n' with actual newline
	        'data-id': prop,
	        style: { margin: '0 7px 7px 7px;' },
	        floatingLabelText: label
	      }, _defineProperty(_ref, valueOn, this.props.education[prop]), _defineProperty(_ref, 'isDirty', !!(0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]', false)), _defineProperty(_ref, 'errorText', (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]')), _defineProperty(_ref, updateOn, this.validateUpdate(this.props.model, prop, this.handleUpdate(this.formModel.clientId, prop))), _ref;
	    }
	  }, {
	    key: 'renderMenuItems',
	    value: function renderMenuItems(items) {
	      return {
	        menuItems: typeof items === 'string' ? this.props.staticData[items] : items
	      };
	    }
	  }, {
	    key: 'renderDegreeOther',
	    value: function renderDegreeOther(props) {
	      var clientId = (0, _lodash.get)(props, 'education.clientId');
	      var type = (0, _lodash.get)(props, 'tempState.education.' + clientId + '.degreeTypeId', (0, _lodash.get)(props, 'education.degreeTypeId'));
	      var degrees = (0, _lodash.get)(this.props, 'staticData.educationDegrees') || [];
	      var other = degrees.find(function (d) {
	        return d.subElement === 'Other';
	      });
	      var none = degrees.find(function (d) {
	        return d.name === 'None';
	      });
	
	      if (other && type === other.id) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(_c_TextField2.default, this.renderAttributes('degreeTypeOther', 'Other Degree, Please specify'))
	        );
	      } else if (none && type === none.id) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	            mask: '999',
	            hideMaskChar: 'true'
	          }, this.renderAttributes('creditsEarned', 'Credits Earned')))
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var education = this.props.education;
	      var index = this.props.index;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: index,
	          'data-id': 'Container ' + index,
	          className: 'box-container-fixed'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.renderAttributes('institutionTypeId', 'Institution Type', 'onChange', 'value'), this.renderMenuItems('educationInstitutionTypes')))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(_c_TextField2.default, this.renderAttributes('institutionName', 'Institution Name'))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.renderAttributes('degreeTypeId', 'Degree Earned'), this.renderMenuItems('educationDegrees')))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(_c_TextField2.default, this.renderAttributes('subjectOrMajor', 'Subjects or Major'))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(_DateInputDropDown2.default, _extends({
	            className: 'education-date-input',
	            dateFormat: 'MonthYear',
	            autoOk: true
	          }, this.renderAttributes('dateAttendedStart', 'Attended From', 'onChange')))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(_DateInputDropDown2.default, _extends({
	            className: 'education-date-input',
	            dateFormat: 'MonthYear',
	            autoOk: true,
	            minDate: education.dateAttendedStart
	          }, this.renderAttributes('dateAttendedEnd', ' Attended To', 'onChange')))
	        ),
	        this.renderDegreeOther(this.props),
	        _react2.default.createElement(
	          'div',
	          {
	            'data-id': 'remove-section',
	            className: 'remove-section text-btn noTextSelect',
	            onClick: this.handleRemove(education.clientId)
	          },
	          'Remove Section'
	        )
	      );
	    }
	  }, {
	    key: 'formModel',
	    get: function get() {
	      return (0, _lodash.merge)({}, (0, _lodash.get)(this, 'props.education'), (0, _lodash.get)(this, 'props.tempState.education[' + this.props.education.clientId + ']'));
	    }
	  }]);
	
	  return EducationRecord;
	}(_ValidatedForm3.default), _class.propTypes = {
	  education: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  onChange: _react.PropTypes.func.isRequired,
	  onRemove: _react.PropTypes.func.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  index: _react.PropTypes.number
	}, _temp);
	exports.default = EducationRecord;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	// import cx from 'classnames';
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _C_ProgressComponentList = __webpack_require__(140);
	
	var _C_ProgressComponentList2 = _interopRequireDefault(_C_ProgressComponentList);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _EducationRecord = __webpack_require__(1066);
	
	var _EducationRecord2 = _interopRequireDefault(_EducationRecord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// static constants
	var formHeading = 'Education';
	var formText = '\n  Please provide your educational information above high school.\n';
	
	// styling obj
	var addButtonStyle = {
	  display: 'inline-block',
	  top: '35px',
	  width: '165px',
	  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
	};
	
	var Education = (_temp2 = _class = function (_ProgressComponentLis) {
	  _inherits(Education, _ProgressComponentLis);
	
	  function Education() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Education);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Education.__proto__ || Object.getPrototypeOf(Education)).call.apply(_ref, [this].concat(args))), _this), _this.today = new Date(), _this.handleRemove = function (clientId) {
	      return function () {
	        return _this.removeListItem(clientId);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Education, [{
	    key: 'validateForm',
	
	
	    // Override ValidatedForm.validateForm()
	    value: function validateForm() {
	      return (0, _lodash.filter)(this.refs, function (ref) {
	        return ref.validateForm;
	      }).reduce(function (valid, section, index) {
	        return section.validateForm() && valid;
	      }, true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var educationArr = this.getList(false, ['employmentEnd', 'employmentStart'], ['desc', 'desc']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'education-container application-section-container clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          formHeading
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-text' },
	          this.props.submitted ? '' : formText
	        ),
	        educationArr.map(function (education, index, arr) {
	          return _react2.default.createElement(_EducationRecord2.default, {
	            index: index,
	            ref: education.clientId,
	            key: education.clientId,
	            staticData: _this2.props.staticData,
	            education: education,
	            tempState: _this2.props.tempState,
	            validation: _this2.props.validation,
	            onChange: _this2.onChange.bind(_this2),
	            onRemove: _this2.handleRemove(education.clientId)
	          });
	        }),
	        _react2.default.createElement(_c_FlatButton2.default, {
	          onClick: this.addListItem,
	          style: _extends({}, addButtonStyle, !educationArr.length && { top: '10.5px' } || {}),
	          label: 'Add Education'
	        })
	      );
	    }
	  }]);
	
	  return Education;
	}(_C_ProgressComponentList2.default), _class.propTypes = {
	  education: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired
	}, _temp2);
	exports.default = Education;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* global Symbol */
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_ButtonGroup = __webpack_require__(231);
	
	var _c_ButtonGroup2 = _interopRequireDefault(_c_ButtonGroup);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// class name
	// import cx from 'classnames';
	
	var ProfessionalAssociations = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: _lodash2.default.get(store.labels, 'Application.background.professionalAssociations', {})
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(ProfessionalAssociations, _ProgressComponent);
	
	  function ProfessionalAssociations(props, context) {
	    _classCallCheck(this, ProfessionalAssociations);
	
	    var _this = _possibleConstructorReturn(this, (ProfessionalAssociations.__proto__ || Object.getPrototypeOf(ProfessionalAssociations)).call(this, props, context));
	
	    _this.state = {
	      validation: Object.assign(_this.CustomValidation, _lodash2.default.pick(props.validation, []))
	    };
	    return _this;
	  }
	
	  _createClass(ProfessionalAssociations, [{
	    key: 'onChange',
	    value: function onChange(event, value) {
	      value = _lodash2.default.map(value, function (str) {
	        return _lodash2.default.replace(str, /\[/g, '(').replace(/\]/g, ')');
	      });
	      var diff = _lodash2.default.difference(_lodash2.default.keysIn(this.props.associations), value);
	      var newAssociations = _lodash2.default.reduce(value.concat(diff), function (associations, assoc) {
	        associations[assoc] = { name: assoc, deleted: diff.includes(assoc) ? Symbol.for('_deleted_') : null };
	        return associations;
	      }, {});
	
	      this.props.updateTempState('' + this.props.model, null, null, newAssociations);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var values = _lodash2.default.keysIn(_lodash2.default.pickBy(_lodash2.default.get(this.props.tempState, [this.props.model], this.props.associations || {}), function (s) {
	        return !s.deleted;
	      }));
	      var list = _lodash2.default.map(_lodash2.default.orderBy(this.props.staticData.professionalAssociationTypes, ['name'], ['asc']), function (a) {
	        return { primaryText: a.name };
	      });
	      list.unshift({ primaryText: 'None' });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container clearfix' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'form-heading',
	            'data-id': 'Professional Associations title' },
	          _lodash2.default.get(this.props.labels, 'Professional Associations title', 'Professional Associations')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'associations-instructions' },
	          _lodash2.default.get(this.props.labels, 'associations-instructions', 'Please select the Professional Associations of which you are a member.')
	        ),
	        _react2.default.createElement(_c_ButtonGroup2.default, {
	          menuItems: list,
	          value: values,
	          validation: this.props.validation[this.props.validationKey],
	          onErrorChange: this.props.errorUpdate,
	          onChange: this.onChange.bind(this)
	        })
	      );
	    }
	  }, {
	    key: 'CustomValidation',
	    get: function get() {
	      var comp = this;
	      var CustomValidator = function CustomValidator() {
	        var model = function model() {
	          return Object.assign({}, _lodash2.default.get(comp, 'props.associations'), _lodash2.default.get(comp, 'props.tempState[' + comp.props.model + ']'));
	        };
	        this.associations = {
	          custom: {
	            func: function func(val) {
	              return !_lodash2.default.isEmpty(_lodash2.default.filter(model(), function (s) {
	                return s.deleted !== Symbol.for('_deleted_');
	              })) || !_lodash2.default.isEmpty(val);
	            },
	            message: 'Must Select at Least One'
	          }
	        };
	      };
	
	      return new CustomValidator();
	    }
	  }]);
	
	  return ProfessionalAssociations;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  user: _react.PropTypes.object,
	  profileId: _react.PropTypes.number.isRequired,
	  associations: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  viewState: _react.PropTypes.object,
	  tempState: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired
	}, _class2.defaultProps = {
	  user: {}
	}, _temp)) || _class);
	exports.default = ProfessionalAssociations;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* global Symbol */
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_ButtonGroup = __webpack_require__(231);
	
	var _c_ButtonGroup2 = _interopRequireDefault(_c_ButtonGroup);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// class name
	// import cx from 'classnames';
	
	// constants
	var adminInstructions = 'If the applicant has designation, explain:';
	var adminScript = 'We recommend you maintain your designations as it indicates your commitment to staying current.';
	
	var ProfessionalDesignations = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: _lodash2.default.get(store.labels, 'Application.background.professionalDesignations', {})
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(ProfessionalDesignations, _ProgressComponent);
	
	  function ProfessionalDesignations(props, context) {
	    _classCallCheck(this, ProfessionalDesignations);
	
	    var _this = _possibleConstructorReturn(this, (ProfessionalDesignations.__proto__ || Object.getPrototypeOf(ProfessionalDesignations)).call(this, props, context));
	
	    _this.state = {
	      validation: Object.assign(_this.CustomValidation, _lodash2.default.pick(props.validation, []))
	    };
	    return _this;
	  }
	
	  _createClass(ProfessionalDesignations, [{
	    key: 'onChange',
	    value: function onChange(event, value) {
	      value = _lodash2.default.map(value, function (str) {
	        return _lodash2.default.replace(str, /\[/g, '(').replace(/\]/g, ')');
	      });
	      var diff = _lodash2.default.difference(_lodash2.default.keysIn(this.props.designations), value);
	      var newDesignations = _lodash2.default.reduce(value.concat(diff), function (designations, des) {
	        designations[des] = { name: des, deleted: diff.includes(des) ? Symbol.for('_deleted_') : null };
	        return designations;
	      }, {});
	
	      this.props.updateTempState('' + this.props.model, null, null, newDesignations);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var values = _lodash2.default.keysIn(_lodash2.default.pickBy(_lodash2.default.get(this.props.tempState, [this.props.model], this.props.designations || {}), function (s) {
	        return !s.deleted;
	      }));
	      var list = _lodash2.default.map(_lodash2.default.orderBy(this.props.staticData.professionalDesignationTypes, ['name'], ['asc']), function (a) {
	        return { primaryText: a.name };
	      });
	      list.unshift({ primaryText: 'None' });
	      return _react2.default.createElement(
	        'div',
	        { className: 'designations-container application-section-container expanded-accordion-content clearfix' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'form-heading',
	            'data-id': 'Professional Designations title' },
	          _lodash2.default.get(this.props.labels, 'Professional Designations title', '')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'designations-instructions' },
	          _lodash2.default.get(this.props.labels, 'designations-instructions', '')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-text' },
	          this.props.adminView && _react2.default.createElement(
	            'div',
	            { className: 'callout' },
	            adminInstructions
	          ),
	          this.props.adminView && this.props.script && _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            adminScript
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-contents' },
	          _react2.default.createElement(_c_ButtonGroup2.default, {
	            menuItems: list,
	            value: values,
	            validation: this.props.validation[this.props.validationKey],
	            onErrorChange: this.props.errorUpdate,
	            onChange: this.onChange.bind(this)
	          })
	        )
	      );
	    }
	  }, {
	    key: 'CustomValidation',
	    get: function get() {
	      var comp = this;
	      var CustomValidator = function CustomValidator() {
	        var model = function model() {
	          return Object.assign({}, _lodash2.default.get(comp, 'props.designations'), _lodash2.default.get(comp, 'props.tempState[' + comp.props.model + ']'));
	        };
	        this.designations = {
	          custom: {
	            func: function func(val) {
	              return !_lodash2.default.isEmpty(_lodash2.default.filter(model(), function (s) {
	                return s.deleted !== Symbol.for('_deleted_');
	              })) || !_lodash2.default.isEmpty(val);
	            },
	            message: 'Must Select at Least One'
	          }
	        };
	      };
	
	      return new CustomValidator();
	    }
	  }]);
	
	  return ProfessionalDesignations;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  user: _react.PropTypes.object,
	  profile: _react.PropTypes.object.isRequired,
	  profileId: _react.PropTypes.number.isRequired,
	  designations: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  viewState: _react.PropTypes.object,
	  tempState: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired
	}, _class2.defaultProps = {
	  user: {}
	}, _temp)) || _class);
	exports.default = ProfessionalDesignations;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	// import cx from 'classnames';
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// needed to replace '\n' with actual newline
	var newLine = /\\n/g;
	
	var jobDescritionBottom = 'Please remember to proofread before you submit.';
	
	var CareerSummary = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Application', {})
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(CareerSummary, _ProgressComponent);
	
	  function CareerSummary(props, context) {
	    _classCallCheck(this, CareerSummary);
	
	    var _this = _possibleConstructorReturn(this, (CareerSummary.__proto__ || Object.getPrototypeOf(CareerSummary)).call(this, props, context));
	
	    _this.state = {
	      validation: Object.assign({}, (0, _lodash.pick)(props.validation, ['careerSummary']))
	    };
	    return _this;
	  }
	
	  _createClass(CareerSummary, [{
	    key: 'handleTextAreaUI',
	    value: function handleTextAreaUI(prop) {
	      return {
	        // need to replace '\n' with actual newline
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: (this.props.profile[prop] || '').replace(newLine, '\n'),
	        isDirty: !!(0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]', false),
	        errorText: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]'),
	        onBlur: this.validateUpdate(this.props.model, prop, this.updateTempState)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container career-summary clearfix' },
	        _react2.default.createElement(
	          'div',
	          {
	            'data-id': 'Heading',
	            className: 'form-heading'
	          },
	          'Career Summary'
	        ),
	        !this.props.submitted && _react2.default.createElement(
	          'div',
	          {
	            'data-id': 'Prompt',
	            className: 'form-text'
	          },
	          'Please write a paragraph (up to 800 characters) summarizing your career experience. Your career summary should be a concise overview of your entire career highlighting years of experience, type of work roles and responsibilities, and if you had management duties. If you would like an example of what a career summary might look like, click on Example.'
	        ),
	        _react2.default.createElement(_c_TextArea2.default, _extends({
	          className: 'career-summary-text',
	          'data-id': 'Career Summary textarea',
	          descriptionBottom: jobDescritionBottom,
	          maxLength: 800,
	          capitalizedSentences: true,
	          showCharacterCount: true,
	          exampleText: this.props.submitted ? '' : (0, _lodash.get)(this.props.labels, 'careerSummaryExample')
	        }, this.handleTextAreaUI('careerSummary')))
	      );
	    }
	  }]);
	
	  return CareerSummary;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  profile: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = CareerSummary;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ValidatedForm2 = __webpack_require__(200);
	
	var _ValidatedForm3 = _interopRequireDefault(_ValidatedForm2);
	
	var _DateInputDropDown = __webpack_require__(229);
	
	var _DateInputDropDown2 = _interopRequireDefault(_DateInputDropDown);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gap = (_temp = _class = function (_ValidatedForm) {
	  _inherits(Gap, _ValidatedForm);
	
	  function Gap(props, context) {
	    _classCallCheck(this, Gap);
	
	    var _this = _possibleConstructorReturn(this, (Gap.__proto__ || Object.getPrototypeOf(Gap)).call(this, props, context));
	
	    _this.handleUpdate = function (clientId, prop) {
	      return function (model, field, event, value) {
	        return _this.props.onChange(clientId, prop, event, value);
	      };
	    };
	
	    _this.state = {
	      validation: (0, _lodash.merge)({}, (0, _lodash.cloneDeep)(props.validation), _this.CustomValidation)
	    };
	    return _this;
	  }
	
	  _createClass(Gap, [{
	    key: 'handleRemove',
	    value: function handleRemove(clientId) {
	      var _this2 = this;
	
	      return function (event) {
	        return _this2.props.removeListItem(clientId);
	      };
	    }
	  }, {
	    key: 'renderAttributes',
	    value: function renderAttributes(prop, label) {
	      var _ref;
	
	      var updateOn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onBlur';
	      var valueOn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'defaultValue';
	
	      return _ref = {
	        floatingLabelText: label
	      }, _defineProperty(_ref, valueOn, this.props.gap[prop]), _defineProperty(_ref, 'isDirty', !!(0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]', false)), _defineProperty(_ref, 'errorText', (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]')), _defineProperty(_ref, updateOn, this.validateUpdate(this.props.model, prop, this.handleUpdate(this.formModel.clientId, prop))), _ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var gap = this.props.gap;
	      var index = this.props.index || gap.clientId;
	      var yearsDiff = (0, _moment2.default)(gap.gapEnd).diff((0, _moment2.default)(gap.gapStart), 'years');
	      var monthsDiff = (0, _moment2.default)(gap.gapEnd).diff((0, _moment2.default)(gap.gapStart), 'months');
	      var totalGapDiff = yearsDiff ? 'Total: ' + yearsDiff + ' years' : 'Total ' + monthsDiff + ' months';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: gap.clientId,
	          className: 'employment-gap'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'date-input-menus' },
	          _react2.default.createElement(_DateInputDropDown2.default, _extends({
	            autoOk: true,
	            ref: 'gapStart',
	            'data-id': 'Employed From ' + index,
	            dateFormat: 'MonthYear',
	            hintText: '12/1999'
	          }, this.renderAttributes('gapStart', 'Period of Gap From', 'onChange'), {
	            underlineStyle: { margin: '-1px 10px 0 0' },
	            iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	            labelStyle: { paddingLeft: '0px' }
	          })),
	          _react2.default.createElement(_DateInputDropDown2.default, _extends({
	            autoOk: true,
	            ref: 'gapEnd',
	            'data-id': 'Employed To ' + index,
	            dateFormat: 'MonthYear',
	            hintText: '01/2001',
	            minDate: gap.gapStart
	          }, this.renderAttributes('gapEnd', 'Period of Gap To', 'onChange'), {
	            underlineStyle: { margin: '-1px 10px 0 0' },
	            iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	            labelStyle: { paddingLeft: '0px' }
	          })),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'total-container',
	              style: { opacity: gap.gapStart && gap.gapEnd ? 1 : 0 } },
	            _react2.default.createElement(
	              'div',
	              { className: 'total-heading' },
	              totalGapDiff
	            )
	          )
	        ),
	        _react2.default.createElement(_c_TextArea2.default, _extends({
	          style: { minHeight: '95px' },
	          showCharacterCount: true,
	          capitalizedSentences: true,
	          maxLength: 400,
	          description: 'Please Explain:',
	          'data-id': 'employment-gap-explain'
	        }, this.renderAttributes('explanation'))),
	        _react2.default.createElement(
	          'div',
	          {
	            'data-id': 'remove-section',
	            className: 'remove-section text-btn noTextSelect',
	            onClick: this.handleRemove(gap.clientId)
	          },
	          'Remove Employment Gap'
	        )
	      );
	    }
	  }, {
	    key: 'CustomValidation',
	    get: function get() {
	      var component = this;
	
	      var CustomValidator = function CustomValidator() {
	        this.gapEnd = {
	          custom: {
	            func: function func(val) {
	              var gapStart = (0, _lodash.get)(component.formModel, 'gapStart');
	              var gapEnd = (0, _lodash.isNil)((0, _lodash.get)(component.formModel, 'gapEnd')) || !(0, _lodash.get)(component.formModel, 'gapEnd') || val;
	              var yearsDiff = (0, _moment2.default)(gapEnd).diff((0, _moment2.default)(gapStart), 'years');
	              var monthsDiff = (0, _moment2.default)(gapEnd).diff((0, _moment2.default)(gapStart), 'months');
	              return yearsDiff !== 0 || monthsDiff !== 0;
	            },
	            message: 'Please select a different end date.'
	          }
	        };
	      };
	
	      return new CustomValidator();
	    }
	
	    // Override ValidatedForm.formModel method
	
	  }, {
	    key: 'formModel',
	    get: function get() {
	      return (0, _lodash.merge)({}, (0, _lodash.get)(this, 'props.gap'), (0, _lodash.get)(this, 'props.tempState.employmentGaps[' + this.props.gap.clientId + ']'));
	    }
	  }]);
	
	  return Gap;
	}(_ValidatedForm3.default), _class.propTypes = {
	  gap: _react.PropTypes.object.isRequired,
	  onChange: _react.PropTypes.func.isRequired,
	  removeListItem: _react.PropTypes.func.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  index: _react.PropTypes.number
	}, _temp);
	exports.default = Gap;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	// import cx from 'classnames';
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _C_ProgressComponentList = __webpack_require__(140);
	
	var _C_ProgressComponentList2 = _interopRequireDefault(_C_ProgressComponentList);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _Gap = __webpack_require__(1071);
	
	var _Gap2 = _interopRequireDefault(_Gap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// static constants
	var formHeading = 'Employment Gap';
	var formText = '\n  If you had a gap in your work experience, please enter the information. If you have not been employed for a year or more prior to the date of this application, it is considered a gap.\n  In addition to explaining the reason for the gap, you should include what you were doing to stay engaged, such as\n  taking CE classes or other types of coursework, doing volunteer work, etc.\n';
	
	// styling obj
	var addButtonStyle = {
	  display: 'inline-block',
	  top: '35px',
	  width: '165px',
	  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
	};
	
	var EmploymentGap = (_temp = _class = function (_ProgressComponentLis) {
	  _inherits(EmploymentGap, _ProgressComponentLis);
	
	  function EmploymentGap(props, context) {
	    _classCallCheck(this, EmploymentGap);
	
	    var _this = _possibleConstructorReturn(this, (EmploymentGap.__proto__ || Object.getPrototypeOf(EmploymentGap)).call(this, props, context));
	
	    _this.handleRemoveGap = function (clientId) {
	      return function () {
	        return _this.removeListItem(clientId);
	      };
	    };
	
	    return _this;
	  }
	
	  // Override ValidatedForm.validateForm()
	
	
	  _createClass(EmploymentGap, [{
	    key: 'validateForm',
	    value: function validateForm() {
	      return (0, _lodash.filter)(this.refs, function (ref) {
	        return ref.validateForm;
	      }).reduce(function (valid, section, index) {
	        return section.validateForm() && valid;
	      }, true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var employmentGapArr = this.getList(false, ['gapStart', 'gapEnd'], ['desc', 'desc']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('employment-gaps application-section-container clearfix') },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          formHeading
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-text' },
	          this.props.submitted ? '' : formText
	        ),
	        employmentGapArr.length > 0 && employmentGapArr.map(function (employmentGap, index, arr) {
	          var gap = (0, _lodash.merge)({}, employmentGap, (0, _lodash.get)(_this2.props.tempState, 'employmentGaps.' + employmentGap.clientId, {}));
	          return _react2.default.createElement(_Gap2.default, {
	            key: employmentGap.clientId,
	            ref: employmentGap.clientId,
	            gap: gap,
	            tempState: _this2.props.tempState,
	            onChange: _this2.onChange.bind(_this2),
	            removeListItem: _this2.handleRemoveGap(employmentGap.clientId),
	            validation: _this2.props.validation
	          });
	        }),
	        _react2.default.createElement(_c_FlatButton2.default, {
	          onClick: this.addListItem,
	          style: _extends({}, addButtonStyle, !employmentGapArr.length && { top: '10.5px' } || {}),
	          label: 'Add Gap'
	        })
	      );
	    }
	  }]);
	
	  return EmploymentGap;
	}(_C_ProgressComponentList2.default), _class.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  employmentGaps: _react.PropTypes.object.isRequired,
	  workExperiences: _react.PropTypes.object.isRequired,
	  profileId: _react.PropTypes.number.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = EmploymentGap;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ValidatedForm2 = __webpack_require__(200);
	
	var _ValidatedForm3 = _interopRequireDefault(_ValidatedForm2);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_TextInputList = __webpack_require__(868);
	
	var _c_TextInputList2 = _interopRequireDefault(_c_TextInputList);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _DateInputDropDown = __webpack_require__(229);
	
	var _DateInputDropDown2 = _interopRequireDefault(_DateInputDropDown);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _validator = __webpack_require__(312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Experience = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Application', {})
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ValidatedForm) {
	  _inherits(Experience, _ValidatedForm);
	
	  function Experience(props, context) {
	    _classCallCheck(this, Experience);
	
	    var _this = _possibleConstructorReturn(this, (Experience.__proto__ || Object.getPrototypeOf(Experience)).call(this, props, context));
	
	    _this.handleUpdate = function (clientId, prop) {
	      return function (model, field, event, value) {
	        return _this.props.onChange(clientId, prop, event, value);
	      };
	    };
	
	    _this.handleRemove = function (clientId) {
	      return function () {
	        return _this.props.removeListItem(clientId);
	      };
	    };
	
	    _this.handleCancel = function (clientId) {
	      return function () {
	        return _this.props.handleCancelExperience(clientId);
	      };
	    };
	
	    _this.handleSave = function (clientId) {
	      return function () {
	        // trigger blur event to force validation errors
	        for (var refKey in _this.refs) {
	          if (_this.refs[refKey].checkErrors) {
	            _this.refs[refKey].checkErrors();
	          }
	        }
	        return _this.props.saveListItem(clientId);
	      };
	    };
	
	    _this.state = {
	      clientId: props.experience.clientId,
	      validation: Object.assign(_this.CustomValidator, (0, _lodash.omit)((0, _lodash.cloneDeep)(props.validation), ['contactEmployerReason', 'current', 'jobSpecifics', 'supervisorName', 'supervisorEmail', 'supervisorPhoneNumber', 'reasonForLeaving']))
	    };
	    return _this;
	  }
	
	  // Override ValidatedForm.formModel method
	
	
	  _createClass(Experience, [{
	    key: 'handleIsCurrentJob',
	    value: function handleIsCurrentJob(clientId, val, event) {
	      var _this2 = this;
	
	      var resetEnd = function resetEnd() {
	        return _this2.props.onChange(clientId, 'employmentEnd', event, null);
	      };
	
	      this.props.onChange(clientId, 'current', event, val);
	      if (val) {
	        setTimeout(resetEnd);
	      }
	    }
	
	    // clear supervisor info when contact employer permission is revoked and reason when permission is granted
	
	  }, {
	    key: 'handleContactEmployer',
	    value: function handleContactEmployer(clientId, newValue, event) {
	      var _this3 = this;
	
	      this.props.onChange(clientId, 'contactEmployer', event, newValue);
	
	      if (newValue === false) {
	        // clear supervisor info when contact employer permission is revoked and
	        setTimeout(function () {
	          _this3.props.onChange(clientId, 'supervisorPhoneNumber', event, null);
	          _this3.props.onChange(clientId, 'supervisorName', event, null);
	          _this3.props.onChange(clientId, 'supervisorEmail', event, null);
	        });
	      } else {
	        // clear reason when permission is granted
	        setTimeout(function () {
	          _this3.props.onChange(clientId, 'contactEmployerReason', event, null);
	        });
	      }
	    }
	  }, {
	    key: 'renderAttributes',
	    value: function renderAttributes(prop, label) {
	      var _ref;
	
	      var updateOn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onBlur';
	      var valueOn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'defaultValue';
	
	      return _ref = {
	        // need to replace '\n' with actual newline
	        floatingLabelText: label,
	        ref: label
	      }, _defineProperty(_ref, valueOn, this.props.experience[prop]), _defineProperty(_ref, 'isDirty', !!(0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]', false)), _defineProperty(_ref, 'errorText', (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]')), _defineProperty(_ref, updateOn, this.validateUpdate(this.props.model, prop, this.handleUpdate(this.formModel.clientId, prop))), _ref;
	    }
	  }, {
	    key: 'renderMenuItems',
	    value: function renderMenuItems(items) {
	      return {
	        menuItems: typeof items === 'string' ? this.props.staticData[items] : items
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // held here to avoid making a bunch of constants with the same text
	      var exampleJobSummaryText = this.props.submitted ? '' : (0, _lodash.get)(this.props.labels, 'jobSummaryExample');
	      var jobSummaryDescriptionHead = 'Job Summary';
	      var jobSummaryDescription = this.props.submitted ? '' : 'Please provide an overview (up to 400 characters) of the position you held and any special areas of focus.';
	
	      // job responsibilities example text
	      var jobResponsibilitiesDescriptionHead = 'Job Specifics';
	      var jobResponsibilitiesDescription = this.props.submitted ? '' : 'Please list the specific day to day job responsibilities and/or job functions. At least three are required with a maximum of eight.';
	      var exampleJobResponsibilities = this.props.submitted ? [] : (0, _lodash.get)(this.props.labels, 'jobSpecificsExamples');
	
	      var jobDescritionBottom = 'Please remember to proofread before you submit.';
	
	      var contactSupervisor = [{ value: true, primaryText: 'Yes', subElement: 'supervisorContact' }, { value: false, primaryText: 'No', subElement: 'contactEmployerReason' }];
	
	      var index = this.props.index;
	      var experience = this.props.experience;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('work-experience-wrapper', { 'applicant-view': !this.props.adminView }) },
	        !this.props.adminView && _react2.default.createElement(_ModalX2.default, {
	          onClick: this.handleCancel(this.props.experience.clientId),
	          style: { fill: '#000000' }
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'work-experience form-contents grid',
	            key: index
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                'data-id': 'Employer Name',
	                floatingLabelFixed: true
	              }, this.renderAttributes('employerName', 'Employer Name')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                'data-id': 'City',
	                floatingLabelFixed: true
	              }, this.renderAttributes('city', 'City')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                canAutoPosition: 'true',
	                'data-id': 'State'
	              }, this.renderAttributes('state', 'State', 'onChange', 'value'), this.renderMenuItems('stateList')))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                className: 'typeofbusiness',
	                canAutoPosition: 'true',
	                'data-id': 'Type of Business'
	              }, this.renderAttributes('typeOfBusiness', (0, _lodash.get)(this.props.labels, 'typeOfBusiness', ''), 'onChange'), this.renderMenuItems('industryTypesList')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                'data-id': 'Position/Title',
	                floatingLabelFixed: true,
	                maxLength: 60
	              }, this.renderAttributes('title', 'Position/Title')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                floatingLabelFixed: true,
	                maxLength: 25,
	                'data-id': 'Department'
	              }, this.renderAttributes('department', 'Department')))
	            )
	          ),
	          experience.typeOfBusiness === 12 && // Other
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                floatingLabelFixed: true,
	                'data-id': 'Type of Business Other'
	              }, { validation: { required: { message: 'This field is required' } } }, this.renderAttributes('typeOfBusinessOther', 'If other, please specify')))
	            ),
	            _react2.default.createElement('div', { className: 'col' }),
	            _react2.default.createElement('div', { className: 'col' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_DateInputDropDown2.default, _extends({
	                'data-id': 'Employed From',
	                dateFormat: 'MonthYear',
	                hintText: '12/1999',
	                autoOk: true
	              }, this.renderAttributes('employmentStart', 'Employed From', 'onChange'), {
	                underlineStyle: { margin: '-1px 0px' },
	                iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                labelStyle: { paddingLeft: '0px' }
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_DateInputDropDown2.default, _extends({
	                'data-id': 'Employed To',
	                dateFormat: 'MonthYear',
	                hintText: '01/2001',
	                disabled: experience.current,
	                autoOk: true,
	                minDate: experience.employmentStart
	              }, this.renderAttributes('employmentEnd', 'Employed To', 'onChange'), {
	                underlineStyle: { margin: '-1px 0px' },
	                iconStyle: { right: '0px', fill: 'rgb(33, 35, 38)' },
	                labelStyle: { paddingLeft: '0px' },
	                value: experience.current ? null : experience.employmentEnd || null
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_FlatButton2.default, {
	                'data-id': 'Current Job',
	                className: (0, _classnames2.default)('current-job', { active: experience.current }),
	                label: 'Current Job',
	                onClick: this.handleIsCurrentJob.bind(this, experience.clientId, !experience.current)
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextArea2.default, _extends({
	                key: 'Reason for Leaving ' + experience.current,
	                'data-id': 'Reason for Leaving',
	                className: 'reason-for-leaving',
	                description: 'Reason for Leaving',
	                showCharacterCount: true,
	                capitalizedSentences: true,
	                maxLength: 255,
	                style: { minHeight: '95px' },
	                disabled: experience.current
	              }, this.renderAttributes('reasonForLeaving', 'Reason for Leaving'), {
	                defaultValue: experience.current ? '' : this.props.experience.reasonForLeaving
	              }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_ToggleButton2.default, {
	                'data-id': 'Permission to Contact Employer',
	                menuItems: contactSupervisor,
	                floatingLabelText: 'Permission to Contact Employer',
	                ref: 'Permission to Contact Employer',
	                value: this.props.experience.contactEmployer,
	                isDirty: !!(0, _lodash.get)(this.state, 'validation.contactEmployer.errors[0]', false),
	                errorText: (0, _lodash.get)(this.state, 'validation.contactEmployer.errors[0]'),
	                onChange: this.handleContactEmployer.bind(this, experience.clientId, !experience.contactEmployer)
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              !experience.contactEmployer && _react2.default.createElement(_c_TextArea2.default, _extends({
	                className: 'no-contact-reason',
	                description: 'If no, please explain',
	                'data-id': 'If no, please explain',
	                showCharacterCount: true,
	                capitalizedSentences: true,
	                maxLength: 255,
	                style: { minHeight: '95px' }
	              }, this.renderAttributes('contactEmployerReason', 'If no, please explain')))
	            )
	          ),
	          experience.contactEmployer && _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                'data-id': 'Supervisor\'s Name',
	                floatingLabelFixed: true,
	                disabled: this.props.adminView
	              }, this.renderAttributes('supervisorName', "Supervisor's Name")))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	                'data-id': 'Supervisor\'s Phone Number',
	                floatingLabelFixed: true,
	                mask: '(999) 999-9999',
	                hideMaskChar: true,
	                disabled: this.props.adminView
	              }, this.renderAttributes('supervisorPhoneNumber', "Supervisor's Phone Number")))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({
	                'data-id': 'Supervisor\'s Email Address',
	                floatingLabelFixed: true,
	                disabled: this.props.adminView
	              }, this.renderAttributes('supervisorEmail', "Supervisor's Email")))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-3' },
	              _react2.default.createElement(_c_TextArea2.default, _extends({
	                style: { minHeight: '95px' },
	                'data-id': jobSummaryDescriptionHead,
	                showCharacterCount: true,
	                maxLength: 500,
	                capitalizedSentences: true,
	                descriptionHead: jobSummaryDescriptionHead,
	                description: jobSummaryDescription,
	                descriptionBottom: jobDescritionBottom,
	                exampleText: exampleJobSummaryText
	              }, this.renderAttributes('jobSummary')))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-3' },
	              _react2.default.createElement(_c_TextInputList2.default, _extends({
	                minLength: 3,
	                maxLength: 8,
	                requiredLength: 3,
	                maxCharLength: 250,
	                capitalizedSentences: true,
	                descriptionHead: jobResponsibilitiesDescriptionHead,
	                description: jobResponsibilitiesDescription,
	                descriptionBottom: jobDescritionBottom,
	                exampleTextArr: exampleJobResponsibilities
	              }, this.renderAttributes('jobSpecifics', 'Job Specifics', 'onBlur', 'value')))
	            )
	          ),
	          !this.props.adminView && _react2.default.createElement(
	            'div',
	            { className: 'row actions' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              !this.props.experience.isNew && _react2.default.createElement(_c_FlatButton2.default, { className: 'delete-btn',
	                label: 'Delete',
	                onClick: this.handleRemove(this.props.experience.clientId),
	                style: {
	                  position: 'absolute',
	                  display: 'inline-block',
	                  width: '268px',
	                  paddingLeft: '30px',
	                  paddingRight: '30px',
	                  backgroundColor: '#d0011b',
	                  border: '1px solid #d0011b',
	                  color: '#ffffff',
	                  marginTop: '20px'
	                },
	                hoverStyle: {
	                  border: '1px solid #d0011b',
	                  color: '#ffffff'
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  this.props.showErrors && _react2.default.createElement(
	                    'div',
	                    { className: 'error-message' },
	                    'Please fill out the required fields above.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-2 right-bottons' },
	                  _react2.default.createElement(_c_FlatButton2.default, { className: 'cancel-btn',
	                    label: 'Cancel',
	                    onClick: this.handleCancel(this.props.experience.clientId),
	                    style: {
	                      display: 'inline-block',
	                      width: '165px',
	                      paddingLeft: '30px',
	                      paddingRight: '30px',
	                      marginRight: '25px'
	                    } }),
	                  _react2.default.createElement(_c_FlatButton2.default, { className: 'save-btn',
	                    label: 'Save',
	                    onClick: this.handleSave(this.props.experience.clientId),
	                    style: {
	                      display: 'inline-block',
	                      width: '165px',
	                      paddingLeft: '30px',
	                      paddingRight: '30px',
	                      backgroundColor: '#2eb0e3',
	                      boxShadow: '0 2px 1px 0 rgba(0,0,0,.41), 0 0 2px 0 rgba(0,0,0,.12)',
	                      borderRadius: '2px',
	                      border: '0',
	                      color: '#ffffff'
	                    },
	                    hoverStyle: {
	                      color: '#ffffff'
	                    }
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'formModel',
	    get: function get() {
	      return (0, _lodash.merge)({}, (0, _lodash.get)(this, 'props.experience'), (0, _lodash.get)(this, 'props.tempState.workExperiences[' + this.props.experience.clientId + ']'));
	    }
	  }, {
	    key: 'CustomValidator',
	    get: function get() {
	      var fieldIsRequired = 'This field is required.';
	      var invalidFormat = 'This value is invalid.';
	      var component = this;
	      var mayContactSupervisor = function mayContactSupervisor(val) {
	        return (0, _lodash.isNil)((0, _lodash.get)(component.formModel, 'contactEmployer')) || !(0, _lodash.get)(component.formModel, 'contactEmployer') || val;
	      };
	      var mayNotContactSupervisor = function mayNotContactSupervisor(val) {
	        return (0, _lodash.isNil)((0, _lodash.get)(component.formModel, 'contactEmployer')) || (0, _lodash.get)(component.formModel, 'contactEmployer') || val;
	      };
	      var isNotCurrentJob = function isNotCurrentJob(val) {
	        return !(0, _lodash.isNil)((0, _lodash.get)(component.formModel, 'current')) && (0, _lodash.get)(component.formModel, 'current') || val;
	      };
	      var isValidPhone = function isValidPhone(val) {
	        return !(0, _lodash.get)(component.formModel, 'contactEmployer') || val.match(/^[2-9]\d{9}$/);
	      };
	      var isValidEmail = function isValidEmail(val) {
	        return !(0, _lodash.get)(component.formModel, 'contactEmployer') || !val || (0, _validator.validate)(val, 'isEmail');
	      };
	      var CustomValidator = function CustomValidator() {
	        this.contactEmployerReason = {
	          custom: {
	            func: mayNotContactSupervisor,
	            message: fieldIsRequired
	          }
	        }, this.employmentEnd = {
	          custom: {
	            func: function func(val) {
	              return !(0, _lodash.isNil)((0, _lodash.get)(component.formModel, 'current')) && (0, _lodash.get)(component.formModel, 'current') || val;
	            },
	            message: fieldIsRequired
	          }
	        };
	        this.supervisorName = {
	          custom: {
	            func: mayContactSupervisor,
	            message: fieldIsRequired
	          }
	        }, this.supervisorEmail = {
	          custom: {
	            func: isValidEmail,
	            message: invalidFormat
	          }
	        }, this.supervisorPhoneNumber = {
	          custom: {
	            func: isValidPhone,
	            message: 'Must be valid, 10 digits.'
	          }
	        }, this.reasonForLeaving = {
	          custom: {
	            func: isNotCurrentJob,
	            message: fieldIsRequired
	          }
	        }, this.jobSpecifics = {
	          custom: {
	            func: function func(val) {
	              return !(0, _lodash.isEmpty)(val) && (0, _lodash.inRange)(val.filter(function (text) {
	                return !(0, _lodash.isEmpty)(text);
	              }).length, 3, 9);
	            },
	            message: 'Please provide between 3 and 8 job specifics.'
	          }
	        };
	      };
	
	      return new CustomValidator();
	    }
	  }]);
	
	  return Experience;
	}(_ValidatedForm3.default), _class2.propTypes = {
	  experience: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  index: _react.PropTypes.number.isRequired,
	  onChange: _react.PropTypes.func.isRequired,
	  removeListItem: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  validateUpdate: _react.PropTypes.func.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  showRemove: _react.PropTypes.bool
	}, _temp)) || _class);
	exports.default = Experience;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warningExperienceYears = undefined;
	
	exports.default = function (experiences) {
	  if ((0, _lodash.isEmpty)(experiences)) return false;
	  var twentyFiveYears = (0, _moment2.default)().diff((0, _moment2.default)().subtract(25, 'years'));
	  var datesList = (0, _lodash.reduce)(experiences, function (dates, currentExperience) {
	    dates.startDates.push((0, _moment2.default)(currentExperience.employmentStart));
	    dates.endDates.push(currentExperience.current ? (0, _moment2.default)() : (0, _moment2.default)(currentExperience.employmentEnd));
	    return dates;
	  }, { startDates: [], endDates: [] });
	
	  // WAHV-2285: Count total years of experience from the applicant starts working.
	  // It will include the gaps.
	  var totalDuration = (0, _lodash.max)(datesList.endDates).diff((0, _lodash.min)(datesList.startDates));
	
	  return totalDuration >= twentyFiveYears;
	};
	
	var _lodash = __webpack_require__(4);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warningExperienceYears = exports.warningExperienceYears = 'You cannot move to the next section until you have completed at least 25 years of work experience';

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _updates = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactInformation = (_temp = _class = function (_ProgressComponent) {
	  _inherits(ContactInformation, _ProgressComponent);
	
	  function ContactInformation(props, context) {
	    _classCallCheck(this, ContactInformation);
	
	    var _this = _possibleConstructorReturn(this, (ContactInformation.__proto__ || Object.getPrototypeOf(ContactInformation)).call(this, props, context));
	
	    _this.state = {
	      validation: Object.assign({}, (0, _lodash.omit)(props.validation, ['password', 'phoneNumber', 'title', 'foundUsVia', 'foundUsOther']))
	    };
	    return _this;
	  }
	
	  _createClass(ContactInformation, [{
	    key: 'handleTextFieldAttributes',
	    value: function handleTextFieldAttributes(prop, label) {
	      return {
	        key: prop + '_' + (this.props.user[prop] || label),
	        defaultValue: (0, _lodash.get)(this.props, 'tempState.user.' + prop, (0, _lodash.get)(this.props, 'user.' + prop)),
	        floatingLabelText: label,
	        isDirty: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]') ? true : false,
	        errorText: (0, _lodash.get)(this.state, 'validation.' + prop + '.errors[0]'),
	        onBlur: this.validateUpdate(this.props.model, prop, this.updateTempState)
	      };
	    }
	  }, {
	    key: 'handleDropDownMenuUI',
	    value: function handleDropDownMenuUI(prop, staticDataProp, label) {
	      return {
	        value: (0, _lodash.get)(this.props, 'tempState.user.' + prop, (0, _lodash.get)(this.props, 'user.' + prop)),
	        menuItems: this.props.staticData[staticDataProp],
	        floatingLabelText: label,
	        validation: this.props.validation[prop],
	        onErrorChange: this.props.errorUpdate,
	        onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
	      };
	    }
	  }, {
	    key: 'handleCountryDropDown',
	    value: function handleCountryDropDown(prop, staticDataProp, label) {
	      var attributes = this.handleDropDownMenuUI(prop, staticDataProp, label);
	      attributes.onChange = this.validateUpdate(this.props.model, prop, this.handleCountryChange(attributes.menuItems));
	      return attributes;
	    }
	  }, {
	    key: 'handleCountryChange',
	    value: function handleCountryChange(countryList) {
	      var _this2 = this;
	
	      return function (model, field, event, value) {
	        var updateUserCountry = (0, _updates.updateCountry)(countryList);
	        var user = updateUserCountry(value || event.target.value);
	        _this2.updateTempState('user', null, {}, user);
	      };
	    }
	  }, {
	    key: 'renderStateOrOtherCountry',
	    value: function renderStateOrOtherCountry(state, props) {
	
	      var country = (0, _lodash.get)(props, 'tempState.user.country', (0, _lodash.get)(props, 'user.country'));
	
	      var _get = (0, _lodash.get)(props, 'staticData', {}),
	          countryList = _get.countryList;
	
	      var otherCountry = countryList.find(function (c) {
	        return c.subElement === 'Other';
	      });
	
	      if (otherCountry && country === otherCountry.id) {
	        return _react2.default.createElement(_c_TextField2.default, _extends({
	          className: 'dropdown-wrapper countryOther'
	        }, this.handleTextFieldAttributes('countryOther', 'Specify Country')));
	      }
	
	      return _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	        className: 'state-dropdown',
	        canAutoPosition: 'true'
	      }, this.handleDropDownMenuUI('state', 'stateList', 'State')));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container contact-information' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          'Contact Information'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-contents' },
	          _react2.default.createElement(_c_TextField2.default, this.handleTextFieldAttributes('firstName', 'First Name')),
	          _react2.default.createElement(_c_TextField2.default, _extends({
	            optional: true
	          }, this.handleTextFieldAttributes('middleName', 'Middle Name or Initial'))),
	          _react2.default.createElement(_c_TextField2.default, this.handleTextFieldAttributes('lastName', 'Last Name')),
	          _react2.default.createElement(_c_TextField2.default, _extends({
	            optional: true
	          }, this.handleTextFieldAttributes('nickName', 'Nickname'))),
	          _react2.default.createElement(_c_TextField2.default, _extends({
	            disabled: true
	          }, this.handleTextFieldAttributes('email', 'Email'))),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	            style: {}
	          }, this.handleDropDownMenuUI('bestContactTime', 'bestContactTimeList', 'What is the best time to call you?'))),
	          _react2.default.createElement(
	            'div',
	            { className: 'phone-number-container' },
	            _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	              'data-id': 'Phone Number 1',
	              mask: '(999) 999-9999',
	              hideMaskChar: true,
	              className: 'phone-number'
	            }, this.handleTextFieldAttributes('phoneNumber1', 'Preferred Phone Number'))),
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              className: 'phone-number-type'
	            }, this.handleDropDownMenuUI('phoneType1', 'phoneTypeList')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'phone-number-container' },
	            _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	              'data-id': 'Phone Number 2',
	              mask: '(999) 999-9999',
	              hideMaskChar: true,
	              optional: true,
	              className: 'phone-number'
	            }, this.handleTextFieldAttributes('phoneNumber2', 'Phone Number'))),
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              className: 'phone-number-type'
	            }, this.handleDropDownMenuUI('phoneType2', 'phoneTypeList')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'phone-number-container' },
	            _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	              'data-id': 'Phone Number 3',
	              mask: '(999) 999-9999',
	              hideMaskChar: true,
	              optional: true,
	              className: 'phone-number'
	            }, this.handleTextFieldAttributes('phoneNumber3', 'Phone Number'))),
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              className: 'phone-number-type'
	            }, this.handleDropDownMenuUI('phoneType3', 'phoneTypeList')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'location-container' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              className: 'country-dropdown'
	            }, this.handleCountryDropDown('country', 'countryList', 'Country of Residence'))),
	            this.renderStateOrOtherCountry(this.state, this.props),
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              className: 'timezone-dropdown',
	              canAutoPosition: 'true'
	            }, this.handleDropDownMenuUI('timezone', 'timezoneList', 'Time Zone')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fields-container' },
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'address'
	            }, this.handleTextFieldAttributes('address', 'Address Line 1'))),
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'city',
	              maxLength: '60'
	            }, this.handleTextFieldAttributes('city', 'City')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'fields-container' },
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'address'
	            }, this.handleTextFieldAttributes('address2', 'Address Line 2'))),
	            _react2.default.createElement(_c_MaskedTextField2.default, _extends({
	              'data-id': 'Zip',
	              hideMaskChar: true,
	              mask: '99999',
	              className: 'zip'
	            }, this.handleTextFieldAttributes('zip', 'Zip')))
	          )
	        )
	      );
	    }
	  }]);
	
	  return ContactInformation;
	}(_C_ProgressComponent2.default), _class.propTypes = {
	  user: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired,
	  validation: _react.PropTypes.object.isRequired
	}, _class.defaultProps = {
	  user: {}
	}, _temp);
	exports.default = ContactInformation;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// class name
	// import cx from 'classnames';
	// import _ from 'lodash';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// must pass {withRef: true} as 4th argument to connect() to allow parent component to access
	// child component's validateForm method if it is wrapped in a HOC
	var ProfileInstructions = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Application', {})
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(ProfileInstructions, _ProgressComponent);
	
	  function ProfileInstructions(props, context) {
	    _classCallCheck(this, ProfileInstructions);
	
	    return _possibleConstructorReturn(this, (ProfileInstructions.__proto__ || Object.getPrototypeOf(ProfileInstructions)).call(this, props, context));
	  }
	
	  _createClass(ProfileInstructions, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          'Application Instructions'
	        ),
	        _react2.default.createElement('div', { className: 'form-text', dangerouslySetInnerHTML: { __html: (0, _lodash.get)(this.props.labels, 'instructions') } })
	      );
	    }
	  }]);
	
	  return ProfileInstructions;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  user: _react.PropTypes.object,
	  viewState: _react.PropTypes.object,
	  tempState: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired
	}, _class2.defaultProps = {
	  user: {}
	}, _temp)) || _class);
	exports.default = ProfileInstructions;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// class name
	// import cx from 'classnames';
	// import _ from 'lodash';
	
	// import static dropdown data
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _staticData = __webpack_require__(170);
	
	var _materialUi = __webpack_require__(277);
	
	var _SegmentsPositionsDepartments = __webpack_require__(300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PreliminaryInformation = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.PreliminaryInformation', {}),
	    staticData: store.staticData
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(PreliminaryInformation, _ProgressComponent);
	
	  function PreliminaryInformation() {
	    _classCallCheck(this, PreliminaryInformation);
	
	    var _this = _possibleConstructorReturn(this, (PreliminaryInformation.__proto__ || Object.getPrototypeOf(PreliminaryInformation)).call(this));
	
	    _this.handleTextFieldUI = _this.handleTextFieldUI.bind(_this);
	    _this.handleDropDownMenuUI = _this.handleDropDownMenuUI.bind(_this);
	    _this.handleDropDownMenuStaticUI = _this.handleDropDownMenuStaticUI.bind(_this);
	    _this.yearsExperienceList = _lodash2.default.times(35, function (i) {
	      return i + 1;
	    });
	    return _this;
	  }
	
	  _createClass(PreliminaryInformation, [{
	    key: 'handleIndustryUI',
	    value: function handleIndustryUI(prop, staticDataProp, label) {
	      var _this2 = this;
	
	      var value = '';
	      if (this.props.profile.industries) {
	        value = this.props.profile.industries.map(function (v) {
	          return (0, _lodash.find)(_this2.props.staticData.industryTypesList, function (i) {
	            return i.id === v;
	          }).name;
	        }).join(', ');
	      } else {
	        value = this.props.profile[prop];
	      }
	      return {
	        'data-id': prop,
	        key: value,
	        defaultValue: value,
	        menuItems: this.props.staticData[staticDataProp],
	        floatingLabelText: label,
	        validation: this.props.validation[prop],
	        onErrorChange: this.props.errorUpdate,
	        onChange: this.updateTempState.bind(this, this.props.model, prop)
	      };
	    }
	  }, {
	    key: 'handleTextFieldUI',
	    value: function handleTextFieldUI(prop, label) {
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        floatingLabelText: label,
	        validation: this.props.validation[prop],
	        onErrorChange: this.props.errorUpdate,
	        onChange: this.updateTempState.bind(this, this.props.model, prop)
	      };
	    }
	  }, {
	    key: 'handleDropDownMenuStaticUI',
	    value: function handleDropDownMenuStaticUI(prop, staticData, label) {
	      var defaultVal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      // WPS-73: added defaultVal so that caller can specify literal default if needed
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: defaultVal !== null ? defaultVal : this.props.profile[prop],
	        menuItems: staticData,
	        floatingLabelText: label,
	        validation: this.props.validation[prop],
	        onErrorChange: this.props.errorUpdate,
	        onChange: this.updateTempState.bind(this, this.props.model, prop)
	      };
	    }
	  }, {
	    key: 'handleDropDownMenuUI',
	    value: function handleDropDownMenuUI(prop, staticDataProp, label) {
	      var filter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (list) {
	        return list;
	      };
	
	      return {
	        'data-id': prop,
	        key: prop + '_' + this.props.profile[prop],
	        defaultValue: this.props.profile[prop],
	        menuItems: filter(this.props.staticData[staticDataProp]),
	        floatingLabelText: label,
	        validation: this.props.validation[prop],
	        onErrorChange: this.props.errorUpdate,
	        onChange: this.updateTempState.bind(this, this.props.model, prop)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$staticData = this.props.staticData,
	          applicantYearsWorkedLastIndustry = _props$staticData.applicantYearsWorkedLastIndustry,
	          applicantTotalYearsExperience = _props$staticData.applicantTotalYearsExperience;
	
	      var _getSegmentsPositions = (0, _SegmentsPositionsDepartments.getSegmentsPositionsDepartments)(this.props),
	          segments = _getSegmentsPositions.segments,
	          positions = _getSegmentsPositions.positions,
	          departments = _getSegmentsPositions.departments;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container preliminary-information clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          'Preliminary Information'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'box-container-fixed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, this.handleDropDownMenuUI('employmentStatus', 'employmentStatusList', 'Employment status'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              disabled: true
	            }, this.handleDropDownMenuStaticUI('totalYearsExperienceNumeric', this.yearsExperienceList, this.props.labels.totalYearsExperience)))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              disabled: true
	            }, this.handleDropDownMenuStaticUI('industryYearsExperienceNumeric', this.yearsExperienceList, this.props.labels.industryYearsExperience)))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	              disabled: true
	            }, this.handleDropDownMenuStaticUI('workedLastInIndustry', ['No', 'Yes'], this.props.labels.workedLastInIndustryYesNo, this.props.profile.workedLastInIndustry === 'More than 5 years ago' ? 'No' : 'Yes')))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_TextField2.default, _extends({
	              className: 'industry-types',
	              disabled: true
	            }, this.handleIndustryUI('industries', 'industryTypesList', this.props.labels.industries), {
	              floatingLabelStyle: { whiteSpace: 'normal' }
	            }))
	          ),
	          this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropDownMenuUI('mostRecentSegment', null, this.props.labels.mostRecentSegment), {
	              menuItems: segments
	            }))
	          ),
	          this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropDownMenuUI('mostRecentDepartment', null, this.props.labels.mostRecentDepartment), {
	              menuItems: departments
	            }))
	          ),
	          this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_c_DropDownMenu2.default, _extends({}, this.handleDropDownMenuUI('mostRecentPosition', null, this.props.labels.mostRecentPosition), {
	              menuItems: positions
	            }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(
	              _c_DropDownMenu2.default,
	              _extends({
	                disabled: true,
	                className: 'found-us-via'
	              }, this.handleDropDownMenuUI('foundUsVia', 'foundUsViaList', this.props.labels.foundUsVia, _staticData.referralsByRole)),
	              {
	                Other: _react2.default.createElement(_c_TextField2.default, _extends({
	                  disabled: true
	                }, this.handleTextFieldUI('foundUsOther')))
	              }
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'box' },
	            _react2.default.createElement(_materialUi.Checkbox, _extends({
	              label: (0, _lodash.get)(this.props.labels, 'optIntoNewsletter'),
	              labelStyle: { fontSize: 14 },
	              disabled: true,
	              checked: (0, _lodash.get)(this.props.profile, 'optIntoNewsletter')
	            }, this.handleTextFieldUI('optIntoNewsletter', true)))
	          )
	        )
	      );
	    }
	  }]);
	
	  return PreliminaryInformation;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  profile: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  viewModel: _react.PropTypes.string.isRequired,
	  viewState: _react.PropTypes.object,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired,
	  validation: _react.PropTypes.object.isRequired
	}, _class2.defaultProps = {
	  profile: {}
	}, _temp)) || _class);
	exports.default = PreliminaryInformation;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkillsIntroduction = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Application', {})
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(SkillsIntroduction, _ProgressComponent);
	
	  function SkillsIntroduction(props, context) {
	    _classCallCheck(this, SkillsIntroduction);
	
	    return _possibleConstructorReturn(this, (SkillsIntroduction.__proto__ || Object.getPrototypeOf(SkillsIntroduction)).call(this, props, context));
	  }
	
	  _createClass(SkillsIntroduction, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateProgress();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          this.props.title
	        ),
	        _react2.default.createElement('div', { className: 'form-text', dangerouslySetInnerHTML: { __html: (0, _lodash.get)(this.props.labels, 'skillsInstructions') } })
	      );
	    }
	  }]);
	
	  return SkillsIntroduction;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  user: _react.PropTypes.object,
	  viewState: _react.PropTypes.object,
	  tempState: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  title: _react.PropTypes.string
	}, _class2.defaultProps = {
	  user: {}
	}, _temp)) || _class);
	exports.default = SkillsIntroduction;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _c_Skills = __webpack_require__(1080);
	
	var _c_Skills2 = _interopRequireDefault(_c_Skills);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// class name
	// import cx from 'classnames';
	
	var SkillSection = function (_Skills) {
	  _inherits(SkillSection, _Skills);
	
	  function SkillSection(props, context) {
	    _classCallCheck(this, SkillSection);
	
	    return _possibleConstructorReturn(this, (SkillSection.__proto__ || Object.getPrototypeOf(SkillSection)).call(this, props, context));
	  }
	
	  return SkillSection;
	}(_c_Skills2.default);
	
	exports.default = SkillSection;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* global Symbol */
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// js utilities
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_ButtonGroup = __webpack_require__(231);
	
	var _c_ButtonGroup2 = _interopRequireDefault(_c_ButtonGroup);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SearchIcon = __webpack_require__(167);
	
	var _SearchIcon2 = _interopRequireDefault(_SearchIcon);
	
	var _dropdowns = __webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// class name
	// import cx from 'classnames';
	
	var Skills = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: store.labels
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(Skills, _ProgressComponent);
	
	  function Skills(props, context) {
	    _classCallCheck(this, Skills);
	
	    var _this = _possibleConstructorReturn(this, (Skills.__proto__ || Object.getPrototypeOf(Skills)).call(this, props, context));
	
	    _this.state = {
	      searchTags: [],
	      validation: Object.assign(_this.CustomValidation, _lodash2.default.pick(_this.props.validation, []))
	    };
	
	    _this.getSkillList = _this.getSkillList.bind(_this);
	    _this.getParentSkillHeaders = _this.getParentSkillHeaders.bind(_this);
	    return _this;
	  }
	
	  _createClass(Skills, [{
	    key: 'onChange',
	    value: function onChange(event, value, parentId) {
	      var _this2 = this;
	
	      value = _lodash2.default.map(value, function (str) {
	        return _lodash2.default.replace(str, /\[/g, '(').replace(/\]/g, ')');
	      });
	      if (parentId) {
	        // get all selected skills from tempstate that are 1) not deleted 2) not of the current Parent
	        // append it to value
	        var existingSkills = _lodash2.default.keysIn(_lodash2.default.pickBy(_lodash2.default.get(this.props.tempState, [this.props.model, this.props.categoryId], _lodash2.default.get(this.props.skills, [this.props.categoryId], {})), function (s) {
	          return !s.deleted && s.parentSkillId !== parentId;
	        }));
	        value = value.concat(existingSkills);
	      }
	
	      var diff = _lodash2.default.difference(_lodash2.default.keysIn(this.props.skills[this.props.categoryId]), value);
	      var skills = _lodash2.default.reduce(value.concat(diff), function (category, skill) {
	        var selectedSkill = _this2.props.staticData.skillTypes.find(function (skillType) {
	          return skillType.name === skill;
	        }) || {};
	        category[skill] = { id: selectedSkill.id || null, categoryId: _this2.props.categoryId, name: skill, parentSkillId: selectedSkill.parentSkillId || null, deleted: diff.includes(skill) ? Symbol.for('_deleted_') : null };
	        return category;
	      }, {});
	      if (_lodash2.default.get(this.props.tempState, this.props.model)) {
	        this.props.updateTempState('' + this.props.model, '' + this.props.categoryId, null, skills);
	      } else {
	        this.props.updateTempState('' + this.props.model, '', null, {});
	        setTimeout(function () {
	          _this2.props.updateTempState('' + _this2.props.model, '' + _this2.props.categoryId, null, skills);
	        });
	      }
	    }
	  }, {
	    key: 'onItemChange',
	    value: function onItemChange(target, prop, event, value) {
	      var _this3 = this;
	
	      var skills = _lodash2.default.merge({}, _lodash2.default.get(this.props.skills, [this.props.categoryId], {}), _lodash2.default.get(this.props.tempState, [this.props.model, this.props.categoryId], {}));
	      skills[target.name][prop] = value;
	      if (_lodash2.default.get(this.props.tempState, this.props.model)) {
	        this.props.updateTempState('' + this.props.model, '' + target.categoryId, null, skills);
	      } else {
	        this.props.updateTempState('' + this.props.model, '', null, {});
	        setTimeout(function () {
	          _this3.props.updateTempState('' + _this3.props.model, '' + target.categoryId, null, skills);
	        });
	      }
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(target, event) {
	      this.onItemChange(target, 'deleted', event, Symbol.for('_deleted_'));
	    }
	  }, {
	    key: 'searchOnChange',
	    value: function searchOnChange(e) {
	      _lodash2.default.debounce(this.setState({
	        searchTags: e.target.value.toLowerCase().trim()
	      }), 200);
	    }
	  }, {
	    key: 'mapObject',
	    value: function mapObject(object, callback) {
	      return Object.keys(object).map(function (key) {
	        return callback(object[key], key);
	      });
	    }
	  }, {
	    key: 'getSkillList',
	    value: function getSkillList() {
	      var _this4 = this;
	
	      /**
	        selectedSkillIds is a lookup dictionary of ids of selected skills:
	        selectedSkillIds = {
	          870: true,
	          871: true,
	          872: true,
	        }
	       **/
	      var selectedSkillIds = _lodash2.default.reduce(this.props.skills, function (ids, categories) {
	        if (!_lodash2.default.isEmpty(categories)) {
	          _lodash2.default.forEach(categories, function (category) {
	            ids[category.id] = true;
	          });
	        }
	        return ids;
	      }, {});
	
	      return this.props.staticData.skillTypes.filter(function (skill) {
	        var belongsToCategory = skill.skillCategoryTypeId === _this4.props.categoryId;
	        var isParentNull = skill.parentSkillId === null;
	        var belongsToParent = !isParentNull && selectedSkillIds[skill.parentSkillId];
	        return belongsToCategory && (isParentNull || belongsToParent);
	      }).map(function (skill) {
	        return { primaryText: skill.name, parentSkillId: _lodash2.default.get(skill, 'parentSkillId', null) };
	      });
	    }
	  }, {
	    key: 'getParentSkillHeaders',
	    value: function getParentSkillHeaders(skillList) {
	      var _this5 = this;
	
	      return _lodash2.default.uniqBy(skillList, 'parentSkillId').map(function (skill) {
	        return {
	          name: _lodash2.default.get(_this5.props.staticData.skillTypes.find(function (skillType) {
	            return skillType.id === skill.parentSkillId;
	          }), 'name', ''),
	          id: skill.parentSkillId || null
	        };
	      }).filter(function (header) {
	        return header.id !== null;
	      }).sort(function (skillA, skillB) {
	        return skillA.name.localeCompare(skillB.name);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var items = _lodash2.default.pickBy(_lodash2.default.get(this.props.tempState, [this.props.model, this.props.categoryId], _lodash2.default.get(this.props.skills, [this.props.categoryId], {})), function (s) {
	        return !s.deleted;
	      });
	      var values = _lodash2.default.keysIn(items);
	
	      var skillList = this.getSkillList();
	
	      // Hide the add button when the skill category is INDUSTRIES (leave for FIRM_TYPES)
	      var skillCategory = this.props.staticData.skillCategoryTypes.find(function (skillCategoryType) {
	        return skillCategoryType.id === _this6.props.categoryId;
	      });
	      var showAdd = !(skillCategory && skillCategory.hardcodelink === 'INDUSTRIES');
	
	      var parentSkillHeaders = this.getParentSkillHeaders(skillList);
	
	      // adding option none for Special Areas of Knowledge, Management Systems, Rating Systems by WAHV-905;
	      if (this.props.hasNone) {
	        skillList.unshift({ primaryText: 'None' });
	      }
	
	      var visibleList = _lodash2.default.reduce(skillList, function (skillsList, skill) {
	        if (_this6.state.searchTags === '' || skill.primaryText.toLowerCase().indexOf(_this6.state.searchTags) > -1) {
	          skillsList.push(skill.primaryText);
	        }
	        return skillsList;
	      }, []);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container clearfix skills' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'form-heading',
	            'data-id': this.props.title + ' title' },
	          this.props.title
	        ),
	        this.props.description && _react2.default.createElement(
	          'div',
	          { className: 'form-description' },
	          this.props.description
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'search center-column-3' },
	          _react2.default.createElement(
	            'div',
	            { className: 'search-input-container' },
	            _react2.default.createElement(_SearchIcon2.default, null),
	            _react2.default.createElement('input', { 'data-id': 'Search',
	              ref: 'search',
	              className: 'search-input',
	              type: 'text',
	              placeholder: 'Search...',
	              onKeyUp: this.searchOnChange.bind(this) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.labels.Application.skillsSubheading
	        ),
	        parentSkillHeaders.length ? _react2.default.createElement(
	          'div',
	          null,
	          parentSkillHeaders.map(function (parent) {
	            var selectedSkills = _lodash2.default.filter(items, function (item) {
	              return item.parentSkillId === parent.id;
	            }).map(function (skill) {
	              return skill.name;
	            });
	            var menuItems = skillList.filter(function (s) {
	              return s.parentSkillId === parent.id;
	            });
	            return _react2.default.createElement(
	              'div',
	              { className: 'skill-section' },
	              _react2.default.createElement(
	                'span',
	                { className: 'skill-section-parent' },
	                parent.name
	              ),
	              _react2.default.createElement(_c_ButtonGroup2.default, {
	                menuItems: menuItems.sort(_dropdowns.defaultOrdering),
	                visibleItems: visibleList.sort(_dropdowns.defaultOrdering),
	                value: selectedSkills,
	                validation: _this6.props.validation[_this6.props.validationKey],
	                onErrorChange: _this6.props.errorUpdate,
	                onChange: function onChange(event, value) {
	                  return _this6.onChange(event, value, parent.id);
	                }
	              })
	            );
	          })
	        ) : _react2.default.createElement(_c_ButtonGroup2.default, {
	          menuItems: skillList.sort(_dropdowns.defaultOrdering),
	          visibleItems: visibleList.sort(_dropdowns.defaultOrdering),
	          value: values,
	          showAdd: showAdd,
	          validation: this.props.validation[this.props.validationKey],
	          onErrorChange: this.props.errorUpdate,
	          onChange: this.onChange.bind(this)
	        }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'skill-list ' + (values.length ? '' : 'empty') },
	          this.mapObject(items, function (row, index) {
	            var _React$createElement;
	
	            return _react2.default.createElement(
	              'li',
	              { key: index, className: 'skill-item' },
	              _react2.default.createElement(
	                'div',
	                { 'data-id': 'SkillName' + index, className: 'name' },
	                row.name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actions' },
	                _react2.default.createElement(_c_FlatButton2.default, (_React$createElement = {
	                  'data-id': 'Remove' + index,
	                  label: 'Remove'
	                }, _defineProperty(_React$createElement, 'data-id', 'Remove' + index), _defineProperty(_React$createElement, 'onClick', _this6.onDelete.bind(_this6, row)), _React$createElement))
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'CustomValidation',
	    get: function get() {
	      var comp = this;
	      var key = _lodash2.default.get(comp, 'props.categoryId');
	      var CustomValidator = function CustomValidator() {
	        var model = function model() {
	          key = _lodash2.default.get(comp, 'props.categoryId');
	          return Object.assign({}, _lodash2.default.get(comp, 'props.skills[' + key + ']'), _lodash2.default.get(comp, 'props.tempState[' + comp.props.model + '][' + key + ']'));
	        };
	        this.skills = {
	          custom: {
	            func: function func(val) {
	              return !_lodash2.default.isEmpty(_lodash2.default.filter(model(), function (s) {
	                return s.deleted !== Symbol.for('_deleted_');
	              })) || !_lodash2.default.isEmpty(val);
	            },
	            message: 'Must Select at Least One'
	          }
	        };
	      };
	
	      return new CustomValidator();
	    }
	  }]);
	
	  return Skills;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  user: _react.PropTypes.object,
	  profileId: _react.PropTypes.number.isRequired,
	  skills: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  viewState: _react.PropTypes.object,
	  tempState: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  categoryId: _react.PropTypes.number,
	  title: _react.PropTypes.string,
	  validation: _react.PropTypes.object,
	  validationKey: _react.PropTypes.string,
	  labels: _react.PropTypes.object.isRequired
	}, _class2.defaultProps = {
	  user: {}
	}, _temp)) || _class);
	exports.default = Skills;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* global Symbol */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Table = __webpack_require__(72);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _status = __webpack_require__(209);
	
	var applicationStatus = _interopRequireWildcard(_status);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropdownStyling = {
	  containerStyle: {
	    width: '95%',
	    transform: 'translateY(-2px)'
	  },
	  labelStyle: {
	    padding: 0
	  },
	  listStyle: {
	    width: '100px'
	  },
	  menuStyle: {
	    width: '100px'
	  },
	  iconStyle: {
	    right: 0
	  },
	  underlineStyle: {
	    display: 'none'
	  }
	};
	
	var SummaryOfSkills = (_temp = _class = function (_ProgressComponent) {
	  _inherits(SummaryOfSkills, _ProgressComponent);
	
	  function SummaryOfSkills(props, context) {
	    _classCallCheck(this, SummaryOfSkills);
	
	    var _this = _possibleConstructorReturn(this, (SummaryOfSkills.__proto__ || Object.getPrototypeOf(SummaryOfSkills)).call(this, props, context));
	
	    _this.state = {};
	    _this.state.skills = _lodash2.default.merge({}, props.skills, props.tempState.skills || {});
	    _this.state.validation = {};
	    return _this;
	  }
	
	  _createClass(SummaryOfSkills, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newSkills = _lodash2.default.merge({}, this.state.skills, nextProps.skills, nextProps.tempState.skills);
	      this.setState({
	        skills: newSkills
	      });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var validation = _lodash2.default.merge({}, this.state.validation);
	      var skills = _lodash2.default.get(this.state, 'skills', {});
	
	      var formValid = _lodash2.default.reduce(skills, function (catValid, cat) {
	        return _lodash2.default.reduce(cat, function (skillValid, skill, name) {
	
	          var isValid = _lodash2.default.isNil(skill) || skill.deleted || name === 'None' || !_lodash2.default.isNil(skill.lastUsed) && !_lodash2.default.isNil(skill.yearsOfExperience) && !_lodash2.default.isNil(skill.skillLevel);
	          validation[name] = !isValid || null;
	          return isValid && skillValid;
	        }, true) && catValid;
	      }, true);
	
	      this.setState(_lodash2.default.merge({}, this.state, { validation: validation }));
	      return formValid;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(target, prop, event, value) {
	      var _this2 = this;
	
	      var updatedSkill = _lodash2.default.merge({}, this.state.skills[target.categoryId][target.name]);
	      updatedSkill[prop] = value;
	      if (_lodash2.default.get(this.props.tempState, this.props.model)) {
	        this.props.updateTempState('' + this.props.model, target.categoryId + '.' + target.name, null, updatedSkill);
	      } else {
	        this.props.updateTempState('' + this.props.model, '', null, {});
	        setTimeout(function () {
	          _this2.props.updateTempState('' + _this2.props.model, target.categoryId + '.' + target.name, null, updatedSkill);
	        });
	      }
	    }
	  }, {
	    key: 'onDelete',
	    value: function onDelete(target, event) {
	      this.onChange(target, 'deleted', event, Symbol.for('_deleted_'));
	    }
	  }, {
	    key: 'mapSummary',
	    value: function mapSummary(skills) {
	      return _lodash2.default.reduce(skills, function (accumulator, category) {
	        return accumulator.concat(_lodash2.default.map(category, function (val) {
	          return val;
	        }));
	      }, []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var errorMessage = 'Please fill out all fields.';
	      var state = _lodash2.default.merge({}, this.state.skills, this.props.tempState.skills);
	      var skills = _lodash2.default.sortBy(_lodash2.default.filter(_lodash2.default.reduce(state, function (accumulator, category) {
	        return accumulator.concat(_lodash2.default.map(category, function (val) {
	          return val;
	        }));
	      }, []), function (s) {
	        return !s.deleted;
	      }), ['categoryId', 'name']);
	      var lastUsedOpts = _lodash2.default.map(_lodash2.default.times(11), function (val) {
	        return { value: val ? val : 100, primaryText: val ? val > 1 ? val + ' Years Ago' : val + ' Year Ago' : 'Current' };
	      });
	      lastUsedOpts.push({ primaryText: '10+ Years Ago', value: 11 });
	      var yearsOfExpOpts = _lodash2.default.map(_lodash2.default.times(10).concat(_lodash2.default.range(10, 60, 10)), function (val) {
	        return { value: val, primaryText: val };
	      });
	      var expertiesOpts = _lodash2.default.map(this.props.staticData.skillLevelTypes, function (item) {
	        return { value: item.id, primaryText: item.name };
	      });
	      var requiredSkillCategories = this.props.staticData.skillCategoryTypes.filter(function (cat) {
	        return !cat.hasNone;
	      }).map(function (cat) {
	        return cat.id;
	      });
	
	      // required categories that should be removable
	      var filteredRequiredSkillCategories = [];
	
	      // collect the required categories that have only one skill selected
	      // this ensures that you can't remove the last skill in a required category on this screen
	      requiredSkillCategories.forEach(function (cat) {
	        if (skills.filter(function (skill) {
	          return skill.categoryId === cat;
	        }).length === 1) {
	          filteredRequiredSkillCategories.push(cat);
	        }
	      });
	
	      // Filtering out skills with none selection
	      for (var i = skills.length - 1; i >= 0; i--) {
	        if (skills[i].name === 'None') {
	          skills.splice(i, 1);
	        }
	      }
	
	      var errorLabel = _react2.default.createElement(
	        'div',
	        { className: 'error-message' },
	        errorMessage
	      );
	      var isQualified = applicationStatus.isQualified(_lodash2.default.get(this.props.profile, 'applicantStatus'));
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container clearfix skills' },
	        this.props.adminView && _react2.default.createElement(
	          'div',
	          { className: 'expanded-accordion-content explanation-of-wahve' },
	          this.props.script && _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            'Script: Let\u2019s now review your skills.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'callout' },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Instructions:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'callout' },
	            'Review the Summary of Skills table with the applicant. Confirm the skills selected, skills levels, and last used. This is important as some applicants are not familiar with the labels we give to some skills. If any are incorrect, update the skill and the table. It is essential that the Skills Table is accurate as it is the basis of successfully matching applicants to Job Requests.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'callout' },
	            'In notes, provide a commentary about the applicant\u2019s skills and types of positions applicant may be qualified for.'
	          )
	        ),
	        !(this.props.adminView || this.props.submitted) && _react2.default.createElement(
	          'div',
	          { className: 'applicant-instructions' },
	          _react2.default.createElement(
	            'div',
	            { className: 'callout' },
	            'Please complete the following table for the professional skills you selected. For each skill, select the skill level, years of experience, and when you last used the skill. Please note, all fields are required for each skill selected. To add a skill to the Table, you must go back to the skill Category and select the skill you wish to add.'
	          )
	        ),
	        isQualified && _react2.default.createElement(
	          'div',
	          { className: 'application-section-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-heading' },
	            'Summary of Skills'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-text' },
	            'If you added skills to your profile, for each skill added, you must select the skill level, years of experience, and when you last used the skill. Make sure you click on SAVE before you sign out.'
	          )
	        ),
	        skills.length === 0 ? _react2.default.createElement(
	          'span',
	          { className: 'no-skills' },
	          'No Skills have been selected'
	        ) : null,
	        !(skills.length === 0) ? _react2.default.createElement(
	          'div',
	          { className: 'application-section-table-container clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'summary-skills-table' },
	            _react2.default.createElement(
	              _Table.Table,
	              {
	                selectable: false,
	                multiSelectable: false,
	                fixedHeader: true,
	                wrapperStyle: { overflow: 'visible' },
	                headerStyle: { position: 'sticky', top: '-30px', zIndex: '1' },
	                className: 'mui-table-summary'
	              },
	              _react2.default.createElement(
	                _Table.TableHeader,
	                {
	                  displaySelectAll: false,
	                  adjustForCheckbox: false
	                },
	                _react2.default.createElement(
	                  _Table.TableRow,
	                  null,
	                  _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { className: 'category', style: { color: '#4a4a4a', fontSize: '14px' } },
	                    'Category'
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { className: 'name', style: { color: '#4a4a4a', fontSize: '14px' } },
	                    'Skill Name'
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { className: 'last-used', style: { width: '160px', color: '#4a4a4a', fontSize: '14px' } },
	                    'Skill Last Used'
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { className: 'yrs', style: { width: '60px', color: '#4a4a4a', fontSize: '14px' } },
	                    'Yrs. of Exp.'
	                  ),
	                  _react2.default.createElement(
	                    _Table.TableHeaderColumn,
	                    { className: 'level', style: { width: '130px', color: '#4a4a4a', fontSize: '14px' } },
	                    'Skill Level'
	                  ),
	                  _react2.default.createElement(_Table.TableHeaderColumn, { className: 'actions' })
	                )
	              ),
	              _react2.default.createElement(
	                _Table.TableBody,
	                {
	                  displayRowCheckbox: false
	                },
	                skills.map(function (row, index) {
	                  var _React$createElement;
	
	                  return _react2.default.createElement(
	                    _Table.TableRow,
	                    { key: row.categoryId + '-' + row.name },
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { 'data-id': 'Category' + index, className: 'category' },
	                      _this3.props.staticData.skillCategoryTypes.find(function (elem) {
	                        return elem.id === row.categoryId;
	                      }).name || ''
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: { width: '280px' }, 'data-id': 'SkillName' + index, className: 'name' },
	                      row.name,
	                      !_lodash2.default.isNil(_this3.state.validation[row.name]) && errorLabel
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: { paddingLeft: '2px', paddingRight: '0px', width: '160px' }, className: 'last-used' },
	                      _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                        'data-id': 'LastUsed' + index,
	                        canAutoPosition: 'true',
	                        defaultValue: row.lastUsed,
	                        menuItems: lastUsedOpts,
	                        onChange: _this3.onChange.bind(_this3, row, 'lastUsed'),
	                        validation: _this3.props.validation.lastUsed,
	                        onErrorChange: _this3.props.errorUpdate,
	                        errorText: _lodash2.default.get(_this3.state.validation, row.categoryId + '.' + row.name)
	                      }, dropdownStyling))
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: { paddingLeft: '2px', paddingRight: '0px', width: '60px' }, className: 'yrs' },
	                      _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                        'data-id': 'YearsOfExperience' + index,
	                        canAutoPosition: 'true',
	                        defaultValue: row.yearsOfExperience,
	                        menuItems: yearsOfExpOpts,
	                        onChange: _this3.onChange.bind(_this3, row, 'yearsOfExperience'),
	                        validation: _this3.props.validation.yearsOfExperience,
	                        onErrorChange: _this3.props.errorUpdate
	                      }, dropdownStyling))
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { style: { paddingLeft: '2px', paddingRight: '0px', width: '130px' }, className: 'level' },
	                      _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                        'data-id': 'SkillLevel' + index,
	                        canAutoPosition: 'true',
	                        defaultValue: row.skillLevel,
	                        menuItems: expertiesOpts,
	                        onChange: _this3.onChange.bind(_this3, row, 'skillLevel'),
	                        validation: _this3.props.validation.skillLevel,
	                        onErrorChange: _this3.props.errorUpdate
	                      }, dropdownStyling))
	                    ),
	                    _react2.default.createElement(
	                      _Table.TableRowColumn,
	                      { className: 'actions' },
	                      !filteredRequiredSkillCategories.includes(row.categoryId) && _react2.default.createElement(_c_FlatButton2.default, (_React$createElement = {
	                        'data-id': 'Remove' + index,
	                        label: 'Remove'
	                      }, _defineProperty(_React$createElement, 'data-id', 'Remove' + index), _defineProperty(_React$createElement, 'onClick', _this3.onDelete.bind(_this3, row)), _React$createElement))
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return SummaryOfSkills;
	}(_C_ProgressComponent2.default), _class.propTypes = {
	  user: _react.PropTypes.object,
	  profile: _react.PropTypes.object,
	  profileId: _react.PropTypes.number.isRequired,
	  skills: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  title: _react.PropTypes.string
	}, _temp);
	exports.default = SummaryOfSkills;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _C_ProgressComponentList = __webpack_require__(140);
	
	var _C_ProgressComponentList2 = _interopRequireDefault(_C_ProgressComponentList);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocumentItem = (_temp = _class = function (_ProgressComponentLis) {
	  _inherits(DocumentItem, _ProgressComponentLis);
	
	  function DocumentItem(props, context) {
	    _classCallCheck(this, DocumentItem);
	
	    var _this = _possibleConstructorReturn(this, (DocumentItem.__proto__ || Object.getPrototypeOf(DocumentItem)).call(this, props, context));
	
	    _this.handleUpdate = function (clientId, prop) {
	      return function (model, field, event, value) {
	        return _this.props.onChange(clientId, prop, event, value);
	      };
	    };
	
	    _this.handleTextFieldUI = function (clientId, prop, label) {
	
	      return {
	        'data-id': prop,
	        defaultValue: _lodash2.default.get(_this.props.document, prop),
	        floatingLabelText: label,
	        validation: _this.props.validation[prop],
	        onBlur: _this.validateUpdate(_this.props.model, prop, _this.handleUpdate(clientId, prop))
	      };
	    };
	
	    _this.handleDropDownMenuUI = function (clientId, prop, staticData, label) {
	
	      return {
	        'data-id': prop,
	        value: _lodash2.default.get(_this.props.document, prop),
	        menuItems: typeof staticData === 'string' ? _this.props.staticData[staticData] : staticData,
	        floatingLabelText: label,
	        validation: _this.props.validation[prop],
	        errorText: _lodash2.default.get(_this.state, 'validation.' + prop + '.errors[0]'),
	        onBlur: _this.validateUpdate(_this.props.model, prop, _this.handleUpdate(clientId, prop))
	
	      };
	    };
	
	    _this.handleRemove = function (clientId) {
	      return function (event) {
	        return _this.props.onRemove(clientId);
	      };
	    };
	
	    _this.state = {
	      validation: props.validation
	    };
	
	    _this.handleTextFieldUI = _this.handleTextFieldUI.bind(_this);
	    _this.handleDropDownMenuUI = _this.handleDropDownMenuUI.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(DocumentItem, [{
	    key: 'render',
	    value: function render() {
	      var document = this.props.document;
	      var fileName = document.fileName,
	          storagePath = document.storagePath,
	          fileSize = document.fileSize;
	
	      var docTypes = this.props.staticData.applicantDocumentFileTypes.filter(function (ft) {
	        return ft.name !== "Assessment";
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'documents form-contents' },
	        _react2.default.createElement(
	          _c_SourceSimpleFileInput.RetrievalButton,
	          {
	            className: 'file-get',
	            loadingClass: '',
	            notLoadingClass: '',
	            failureClass: '',
	            autoLoad: true,
	            noMessage: true,
	            path: storagePath,
	            signingRoute: '/api/s3/get-sign'
	          },
	          _react2.default.createElement(_c_TextField2.default, {
	            disabled: true,
	            floatingLabelText: 'File Name',
	            value: fileName,
	            inputStyle: {
	              textOverflow: 'ellipsis',
	              maxWidth: '76%'
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'megabyte-count' },
	            Math.max(Math.round(fileSize / 100000) / 10, 0.1) + ' Mgb'
	          )
	        ),
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	          containerStyle: {
	            width: 'calc(33.3% - 40px)'
	          }
	        }, this.handleDropDownMenuUI(document.clientId, 'fileTypeId', docTypes, 'File Type'))),
	        _react2.default.createElement(_c_TextField2.default, _extends({
	          optional: true,
	          style: {
	            width: 'calc(33.3% - 40px)'
	          }
	        }, this.handleTextFieldUI(document.clientId, 'description', 'File Description'))),
	        _react2.default.createElement(
	          'div',
	          {
	            'data-id': 'remove-section',
	            className: 'remove-section text-btn noTextSelect',
	            onClick: this.handleRemove(document.clientId)
	          },
	          'Remove'
	        )
	      );
	    }
	  }, {
	    key: 'formModel',
	
	
	    // Override ValidatedForm.formModel method
	    get: function get() {
	      var document = _lodash2.default.get(this.props, 'document');
	      var tempStateDocument = _lodash2.default.get(this.props, 'tempState.documents[' + document.clientId + ']');
	      return _lodash2.default.merge({}, document, tempStateDocument);
	    }
	  }]);
	
	  return DocumentItem;
	}(_C_ProgressComponentList2.default), _class.propTypes = {
	  document: _react.PropTypes.object,
	  staticData: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  onChange: _react.PropTypes.func.isRequired,
	  onRemove: _react.PropTypes.func.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = DocumentItem;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shortid = __webpack_require__(67);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _c_SourceSimpleFileInput2 = _interopRequireDefault(_c_SourceSimpleFileInput);
	
	var _C_ProgressComponentList = __webpack_require__(140);
	
	var _C_ProgressComponentList2 = _interopRequireDefault(_C_ProgressComponentList);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _DocumentItem = __webpack_require__(1082);
	
	var _DocumentItem2 = _interopRequireDefault(_DocumentItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// styling obj
	var addButtonStyle = {
	  display: 'inline-block',
	  top: '11px',
	  width: '165px',
	  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
	};
	
	// text constants
	var formHeading = 'Documents';
	
	var formText = 'Please attach your resume, if you have one, any licenses, designations and reference letters.';
	
	var Documents = (_temp2 = _class = function (_ProgressComponentLis) {
	  _inherits(Documents, _ProgressComponentLis);
	
	  function Documents() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Documents);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Documents.__proto__ || Object.getPrototypeOf(Documents)).call.apply(_ref, [this].concat(args))), _this), _this.onUploadStart = function (err, infoObj) {
	      var clientId = '' + _this.getIncrementedChar() + _shortid2.default.generate();
	      _this.updateTempState(_this.props.model, clientId, null, {
	        clientId: clientId,
	        isNew: true,
	        fileName: infoObj.name,
	        fileSize: infoObj.size,
	        storagePath: infoObj.nameWithFolder
	      });
	    }, _this.onS3Load = function (err) {
	      // updating UI optimistically so we only need to know if there was an error
	      if (err && ("production") !== 'production') {
	        console.error(err);
	      }
	    }, _this.handleRemove = function (clientId) {
	      return function () {
	        return _this.removeListItem(clientId);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Documents, [{
	    key: 'validateForm',
	
	
	    // Override ValidatedForm.validateForm()
	    value: function validateForm() {
	      return _lodash2.default.filter(this.refs, function (ref) {
	        return ref.validateForm;
	      }).reduce(function (valid, section) {
	        return section.validateForm() && valid;
	      }, true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var documentsArr = this.getList(false, ['employmentEnd', 'employmentStart'], ['desc', 'desc']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'documents-container application-section-container clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading' },
	          formHeading
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-text' },
	          this.props.submitted ? '' : formText
	        ),
	        _react2.default.createElement(
	          _c_SourceSimpleFileInput2.default,
	          {
	            className: 'file-uploader',
	            noMessage: true,
	            pristineClass: '',
	            loadingClass: '',
	            successClass: '',
	            failureClass: '',
	            accept: ['pdf', 'doc', 'docx', 'tiff', 'txt', 'JPG', 'JPEG', 'jpg', 'jpeg', 'png'],
	            remoteFolder: 'applicants',
	            onLoadStart: this.onUploadStart,
	            onS3Load: this.onS3Load,
	            signingRoute: '/api/s3/put-sign',
	            maxSize: ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).AWS_FILE_UPLOAD_SIZE
	          },
	          _react2.default.createElement(_c_FlatButton2.default, {
	            style: _extends({}, addButtonStyle, !documentsArr.length && { top: '10.5px' } || {}),
	            label: 'Attach File'
	          })
	        ),
	        documentsArr.map(function (document, index) {
	          return _react2.default.createElement(_DocumentItem2.default, {
	            key: index,
	            ref: document.clientId,
	            document: document,
	            validation: _this2.props.validation,
	            staticData: _this2.props.staticData,
	            updateTempState: _this2.updateTempState,
	            tempState: _this2.props.tempState,
	            onChange: _this2.onChange.bind(_this2),
	            onRemove: _this2.handleRemove(document.clientId)
	          });
	        })
	      );
	    }
	  }]);
	
	  return Documents;
	}(_C_ProgressComponentList2.default), _class.propTypes = {
	  documents: _react.PropTypes.object,
	  profileId: _react.PropTypes.number.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  validation: _react.PropTypes.object.isRequired,
	  errorUpdate: _react.PropTypes.func.isRequired
	}, _temp2);
	exports.default = Documents;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _C_ProgressComponent = __webpack_require__(73);
	
	var _C_ProgressComponent2 = _interopRequireDefault(_C_ProgressComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// class name
	// import cx from 'classnames';
	
	var Submit = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: _lodash2.default.get(store.labels, 'Application', {})
	  };
	}, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_ProgressComponent) {
	  _inherits(Submit, _ProgressComponent);
	
	  function Submit(props, context) {
	    _classCallCheck(this, Submit);
	
	    var _this = _possibleConstructorReturn(this, (Submit.__proto__ || Object.getPrototypeOf(Submit)).call(this, props, context));
	
	    _this.state = {
	      showSubscribeError: false
	    };
	
	    _this.closeModal = function () {
	      _this.setState({ showSubscribeError: false });
	    };
	
	    return _this;
	  }
	
	  _createClass(Submit, [{
	    key: 'expectedSignature',
	    value: function expectedSignature() {
	      var signature = this.props.user.firstName + ' ' + this.props.user.middleName + ' ' + this.props.user.lastName;
	
	      // remove multiple consecutive spaces in case middleName is null/blank
	      return signature.replace(/\s+/g, ' ');
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      if (this.expectedSignature() === String(event.target.value)) {
	        this.setState({ showSubscribeError: false });
	        this.props.updateTempState(this.props.model, 'dateAuthorized', event, new Date().toDateString());
	      } else {
	        this.setState({ showSubscribeError: true });
	        this.props.updateTempState(this.props.model, 'dateAuthorized', event, '');
	      }
	    }
	  }, {
	    key: 'validateForm',
	
	
	    // Override ValidatedForm.validateForm()
	    value: function validateForm() {
	      return !_lodash2.default.isNil(_lodash2.default.get(this.props.tempState, 'profile', {}).dateAuthorized);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var requiredSections = {
	        Profile: false,
	        Preferences: false,
	        Experience: false,
	        Skills: false,
	        'Summary of Skills': false,
	        Background: false
	      };
	      var incompleteSections = _lodash2.default.merge({}, requiredSections, _lodash2.default.omit(this.props.formSections, ['Welcome', 'Documents', 'Instructions', 'Submit', 'Assessments']));
	
	      var incompleteErrorArray = _lodash2.default.map(_lodash2.default.pickBy(incompleteSections, function (value) {
	        return !value;
	      }), function (value, sectionName) {
	        return sectionName;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('application-section-container clearfix authorize-and-submit') },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'form-heading',
	            'data-id': 'Authorize & Submit title' },
	          'Authorize & Submit'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'callout' },
	          _lodash2.default.get(this.props.labels, 'authorizationIntro')
	        ),
	        _react2.default.createElement('div', { className: 'form-text claim-text', dangerouslySetInnerHTML: { __html: _lodash2.default.get(this.props.labels, 'authorizationTerms') } }),
	        _react2.default.createElement(
	          'div',
	          null,
	          incompleteErrorArray.length ? _react2.default.createElement(
	            'div',
	            { className: 'incomplete-sections' },
	            'The following section(s) have not been completed. Please complete in order to submit.',
	            _react2.default.createElement(
	              'ul',
	              { className: 'sections-list' },
	              incompleteErrorArray.map(function (sectionName, idx) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: idx },
	                  sectionName
	                );
	              })
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_c_TextField2.default, {
	              'data-id': 'signature',
	              disabled: !_lodash2.default.isNil(this.props.profile.dateAuthorized),
	              defaultValue: _lodash2.default.isNil(this.props.profile.dateAuthorized) ? '' : this.expectedSignature(),
	              onBlur: this.handleChange.bind(this),
	              floatingLabelText: 'First Name Middle Name and Last Name'
	            }),
	            !this.state.showSubscribeError ? _react2.default.createElement(
	              'span',
	              { className: 'user-name' },
	              '(',
	              this.expectedSignature(),
	              ')'
	            ) : null,
	            this.state.showSubscribeError ? _react2.default.createElement(
	              'span',
	              { className: 'user-name error' },
	              '(',
	              this.expectedSignature(),
	              ') Please sign with the name provided.'
	            ) : null
	          ),
	          _react2.default.createElement(_c_TextField2.default, {
	            'data-id': 'date signed',
	            disabled: !_lodash2.default.isNil(this.props.profile.dateAuthorized),
	            defaultValue: _lodash2.default.isNil(this.props.profile.dateAuthorized) ? new Date().toDateString() : new Date(this.props.profile.dateAuthorized).toDateString(),
	            floatingLabelText: 'Date Signed'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Submit;
	}(_C_ProgressComponent2.default), _class2.propTypes = {
	  user: _react.PropTypes.object.isRequired,
	  workExperiences: _react.PropTypes.object.isRequired,
	  profileId: _react.PropTypes.number.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  model: _react.PropTypes.string.isRequired,
	  formSections: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = Submit;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lookup = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// redux action creators for persistence
	
	
	// utilities
	// import _ from 'lodash';
	
	// validation object
	
	
	exports.getCurrent = getCurrent;
	
	var _react = __webpack_require__(1);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _user = __webpack_require__(124);
	
	var _applicantProfile = __webpack_require__(313);
	
	var _applicantWorkExperience = __webpack_require__(467);
	
	var _employmentGap = __webpack_require__(912);
	
	var _skillsSummary = __webpack_require__(914);
	
	var _education = __webpack_require__(911);
	
	var _license = __webpack_require__(913);
	
	var _documents = __webpack_require__(910);
	
	var _designationsAndAssociations = __webpack_require__(909);
	
	var _applicationSubmission = __webpack_require__(904);
	
	var _reference = __webpack_require__(468);
	
	var _c_Instructions = __webpack_require__(1076);
	
	var _c_Instructions2 = _interopRequireDefault(_c_Instructions);
	
	var _c_ContactInformation = __webpack_require__(1075);
	
	var _c_ContactInformation2 = _interopRequireDefault(_c_ContactInformation);
	
	var _c_PreliminaryInformation = __webpack_require__(1077);
	
	var _c_PreliminaryInformation2 = _interopRequireDefault(_c_PreliminaryInformation);
	
	var _c_AvailabilityInformation = __webpack_require__(475);
	
	var _c_AvailabilityInformation2 = _interopRequireDefault(_c_AvailabilityInformation);
	
	var _c_HomeOfficeSetup = __webpack_require__(476);
	
	var _c_HomeOfficeSetup2 = _interopRequireDefault(_c_HomeOfficeSetup);
	
	var _c_CareerSummary = __webpack_require__(1070);
	
	var _c_CareerSummary2 = _interopRequireDefault(_c_CareerSummary);
	
	var _c_WorkExperience = __webpack_require__(474);
	
	var _c_WorkExperience2 = _interopRequireDefault(_c_WorkExperience);
	
	var _c_EmploymentGaps = __webpack_require__(1072);
	
	var _c_EmploymentGaps2 = _interopRequireDefault(_c_EmploymentGaps);
	
	var _LicensesContainer = __webpack_require__(1006);
	
	var _LicensesContainer2 = _interopRequireDefault(_LicensesContainer);
	
	var _c_Education = __webpack_require__(1067);
	
	var _c_Education2 = _interopRequireDefault(_c_Education);
	
	var _c_ProfessionalAssociations = __webpack_require__(1068);
	
	var _c_ProfessionalAssociations2 = _interopRequireDefault(_c_ProfessionalAssociations);
	
	var _c_ProfessionalDesignations = __webpack_require__(1069);
	
	var _c_ProfessionalDesignations2 = _interopRequireDefault(_c_ProfessionalDesignations);
	
	var _c_AdditionalReferences = __webpack_require__(1065);
	
	var _c_AdditionalReferences2 = _interopRequireDefault(_c_AdditionalReferences);
	
	var _c_Introduction = __webpack_require__(1078);
	
	var _c_Introduction2 = _interopRequireDefault(_c_Introduction);
	
	var _c_SummaryOfSkills = __webpack_require__(1081);
	
	var _c_SummaryOfSkills2 = _interopRequireDefault(_c_SummaryOfSkills);
	
	var _validateExperienceYears = __webpack_require__(1074);
	
	var _validateExperienceYears2 = _interopRequireDefault(_validateExperienceYears);
	
	var _c_Documents = __webpack_require__(1083);
	
	var _c_Documents2 = _interopRequireDefault(_c_Documents);
	
	var _c_Submit = __webpack_require__(1084);
	
	var _c_Submit2 = _interopRequireDefault(_c_Submit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// get validation objects
	var userSchema = (0, _user.getSchema)(),
	    profileSchema = (0, _applicantProfile.getSchema)(),
	    workExperienceSchema = (0, _applicantWorkExperience.getSchema)(),
	    employmentGapsSchema = (0, _employmentGap.getSchema)(),
	    skillsSummarySchema = (0, _skillsSummary.getSchema)(),
	    educationSchema = (0, _education.getSchema)(),
	    licensesSchema = (0, _license.getSchema)(),
	    documentsSchema = (0, _documents.getSchema)(),
	    designationsAndAssociationsSchema = (0, _designationsAndAssociations.getSchema)(),
	    applicationSubmissionSchema = (0, _applicationSubmission.getSchema)(),
	    referenceSchema = (0, _reference.getSchema)();
	
	// application page components
	// // Profile
	
	
	// // Preferences
	
	
	// // Experience
	
	
	// // Background
	
	
	// // Skill
	
	
	// Documents
	
	
	// Submit
	
	
	// retrieves current component
	function getCurrent(activeColumnNav, activeRowSubNav) {
	  // look up column on 'lookup' object
	  var lookupVal = lookup[activeColumnNav];
	
	  // corresponding string
	  var viewModel = activeColumnNav;
	
	  // some components are nested, others are not, this handles that
	  if (lookupVal && activeRowSubNav) {
	    lookupVal = lookupVal[activeRowSubNav];
	    viewModel += '.' + activeRowSubNav;
	  }
	  return _extends({}, lookupVal, { viewModel: viewModel });
	}
	
	// object based on view nav keys used to look up components
	var lookup = exports.lookup = {
	  Profile: {
	    'Contact Information': {
	      component: (0, _react.createFactory)(_c_ContactInformation2.default),
	      model: 'user',
	      validation: userSchema
	    },
	    'Preliminary Information': {
	      component: (0, _react.createFactory)(_c_PreliminaryInformation2.default),
	      model: 'profile',
	      validation: profileSchema
	    }
	  },
	  Instructions: {
	    component: (0, _react.createFactory)(_c_Instructions2.default)
	  },
	  Preferences: {
	    'Availability Information': {
	      component: (0, _react.createFactory)(_c_AvailabilityInformation2.default),
	      model: 'profile',
	      validation: profileSchema
	    },
	    'Home Office Setup': {
	      component: (0, _react.createFactory)(_c_HomeOfficeSetup2.default),
	      model: 'profile',
	      validation: profileSchema
	    }
	  },
	  Experience: {
	    'Career Summary': {
	      component: (0, _react.createFactory)(_c_CareerSummary2.default),
	      model: 'profile',
	      validation: profileSchema
	    },
	    'Work Experience': {
	      component: (0, _react.createFactory)(_c_WorkExperience2.default),
	      model: 'workExperiences',
	      validation: workExperienceSchema,
	      submitValidator: _validateExperienceYears2.default,
	      submitErrorMessage: _validateExperienceYears.warningExperienceYears,
	      saveFunc: function saveFunc(tempState) {
	        return asyncActionCreators.persistListUpdate('workexperiences', 'workExperiences', tempState);
	      }
	    },
	    'Employment Gaps': {
	      component: (0, _react.createFactory)(_c_EmploymentGaps2.default),
	      model: 'employmentGaps',
	      validation: employmentGapsSchema,
	      saveFunc: function saveFunc(tempState) {
	        return asyncActionCreators.persistListUpdate('employmentgaps', 'employmentGaps', tempState);
	      }
	    }
	  },
	  Skills: {
	    Instructions: {
	      component: (0, _react.createFactory)(_c_Introduction2.default),
	      title: 'Instructions'
	    }
	  },
	  'Summary of Skills': {
	    'Summary of Skills': {
	      component: (0, _react.createFactory)(_c_SummaryOfSkills2.default),
	      model: 'skills',
	      title: 'Summary of Skills',
	      validation: skillsSummarySchema,
	      saveFunc: function saveFunc(tempState) {
	        return asyncActionCreators.persistSkills(tempState);
	      }
	    }
	  },
	  Background: {
	    Licenses: {
	      component: (0, _react.createFactory)(_LicensesContainer2.default),
	      model: ['licenses', 'profile'],
	      validation: licensesSchema,
	      saveFunc: function saveFunc(tempState) {
	        return asyncActionCreators.persistListUpdate('licenses', 'licenses', tempState);
	      }
	    },
	    Education: {
	      component: (0, _react.createFactory)(_c_Education2.default),
	      model: 'education',
	      validation: educationSchema,
	      saveFunc: function saveFunc(tempState) {
	        return asyncActionCreators.persistListUpdate('education', 'education', tempState);
	      }
	    },
	    'Professional Associations': {
	      component: (0, _react.createFactory)(_c_ProfessionalAssociations2.default),
	      model: 'associations',
	      validation: designationsAndAssociationsSchema,
	      validationKey: 'ProfessionalAssociations',
	      customErrorMessage: 'Please Select at Least One Item.',
	      saveFunc: function saveFunc(tempState) {
	        return asyncActionCreators.persistBackground(tempState, 'associations');
	      }
	    },
	    'Professional Designations': {
	      component: (0, _react.createFactory)(_c_ProfessionalDesignations2.default),
	      model: 'designations',
	      validation: designationsAndAssociationsSchema,
	      validationKey: 'ProfessionalDesignations',
	      customErrorMessage: 'Please Select at Least One Item.',
	      saveFunc: function saveFunc(tempState) {
	        return asyncActionCreators.persistBackground(tempState, 'designations');
	      }
	    },
	    'Additional Professional References': {
	      component: (0, _react.createFactory)(_c_AdditionalReferences2.default),
	      model: 'references',
	      customErrorMessage: 'Please fill out the required fields above and include at least two references.',
	      saveFunc: function saveFunc(tempState) {
	        return asyncActionCreators.persistListUpdate('references', 'references', tempState);
	      }
	    }
	  },
	  Documents: {
	    component: (0, _react.createFactory)(_c_Documents2.default),
	    model: 'documents',
	    validation: documentsSchema,
	    saveFunc: function saveFunc(tempState) {
	      return asyncActionCreators.persistListUpdate('documents', 'documents', tempState);
	    }
	  },
	  Submit: {
	    component: (0, _react.createFactory)(_c_Submit2.default),
	    model: 'profile',
	    validation: applicationSubmissionSchema,
	    saveFunc: function saveFunc(tempState) {
	      return [asyncActionCreators.persistApplicantUpdate(tempState), asyncActionCreators.authorizeApplication(tempState)];
	    }
	  }
	};

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// action creators for redux
	
	
	// form components
	
	
	// components lookup
	
	
	// Skill components
	
	
	// ui components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _deepUnset = __webpack_require__(304);
	
	var _deepUnset2 = _interopRequireDefault(_deepUnset);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_ModalForm = __webpack_require__(201);
	
	var _c_ModalForm2 = _interopRequireDefault(_c_ModalForm);
	
	var _f_PrelimMessage = __webpack_require__(1044);
	
	var _f_PrelimMessage2 = _interopRequireDefault(_f_PrelimMessage);
	
	var _componentLookup = __webpack_require__(1085);
	
	var _c_SkillSection = __webpack_require__(1079);
	
	var _c_SkillSection2 = _interopRequireDefault(_c_SkillSection);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _status = __webpack_require__(209);
	
	var applicationStatus = _interopRequireWildcard(_status);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// styling obj
	var nextButtonStyle = {
	  width: '296px',
	  height: '45px'
	};
	
	var formModes = {
	  DEFAULT: 1,
	  NOTREADY: 2
	};
	
	var ApplicationForm = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.user,
	    profile: state.applicantProfile,
	    workExperiences: state.workExperiences,
	    employmentGaps: state.employmentGaps,
	    education: state.education,
	    licenses: state.licenses,
	    skills: state.skills,
	    documents: state.documents,
	    references: state.references,
	    staticData: state.staticData,
	    tempState: state.tempState,
	    associations: state.associations,
	    designations: state.designations,
	    hideControls: state.ui.hideControls
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ApplicationForm, _Component);
	
	  function ApplicationForm() {
	    _classCallCheck(this, ApplicationForm);
	
	    // error count tracker
	    // Is on the instance to avoid it being overwritten
	    // by multiple setStates firing.
	    var _this = _possibleConstructorReturn(this, (ApplicationForm.__proto__ || Object.getPrototypeOf(ApplicationForm)).call(this));
	
	    _this.state = {
	      errorCount: 0,
	      mode: formModes.DEFAULT,
	      valid: true,
	      customError: null,
	      submitError: null
	    };
	
	    _this.onSubmitValidate = function () {
	      var currentComponent = _this.getCurrentComponent(_this.props.activeColumnNav, _this.props.activeRowSubNav);
	      // If submitValidator defined in component, we also need to validate it before "continue".
	      // This validation only for continue button, not used in "save".
	
	      if (currentComponent.submitValidator) {
	        var items = _lodash2.default.filter(_lodash2.default.merge({}, _this.props[currentComponent.model], _this.props.tempState[currentComponent.model]), function (item) {
	          return item !== Symbol.for('__delete');
	        });
	        if (!currentComponent.submitValidator(items)) {
	          _this.setSubmitError(currentComponent.submitErrorMessage);
	          return false;
	        }
	      }
	      return true;
	    };
	
	    _this.onSave = function () {
	      // reset errors.
	      _this.setSubmitError(null);
	      var formState = _lodash2.default.merge({}, _this.state);
	
	      // currentForm is either standalone React component or a React component wrapped in a HOC
	      // in case of currentForm being wrapped in a HOC, we need to getWrappedInstance to access the inner wrapped component's refs
	      var validateFunc = _this.refs.currentForm.validateForm ? _this.refs.currentForm.validateForm : _this.refs.currentForm.getWrappedInstance().validateForm;
	      formState.valid = validateFunc();
	
	      if (_this.refs.currentForm && formState.valid) {
	        // if (!_.isEmpty(this.props.tempState)) {
	        // retrieve gurrent component from static data
	        var currentComponent = _this.getCurrentComponent(_this.props.activeColumnNav, _this.props.activeRowSubNav);
	        // if component.saveFunc is provided then use that, otherwise use default route hitting actionCreator
	        var newState = _lodash2.default.cloneDeep(_this.props.tempState);
	        _lodash2.default.set(newState, 'user.id', _lodash2.default.get(_this.props.user, 'impersonateUser.id', _this.props.user.id));
	        _lodash2.default.set(newState, 'profile.id', _this.props.profile.id);
	
	        var objPath = 'profile.viewState.progress.applicant.application.' + currentComponent.viewModel + '.done';
	        _lodash2.default.set(newState, objPath, true);
	
	        newState.profile.viewState = _lodash2.default.merge({}, { progress: { applicant: { application: _this.props.appViewState || {} } } }, _this.props.profile.viewState, newState.profile.viewState);
	
	        // update front end
	        _this.props.dispatch(syncActionCreators.updateApplicant(newState));
	
	        var actions = (currentComponent.saveFunc || asyncActionCreators.persistApplicantUpdate)(newState);
	        actions = _lodash2.default.isArray(actions) ? actions : [actions];
	
	        if (!_lodash2.default.isNil(_this.props.profile.dateAuthorized) && _this.props.activeColumnNav === 'Skills') {
	          actions.push((0, _reactRouterRedux.push)('/applicant/Summary of Skills/Summary of Skills'));
	        }
	
	        // update back end
	        actions = actions.map(function (action) {
	          return _this.props.dispatch(action);
	        });
	
	        if (!_lodash2.default.isNil(_this.props.profile.dateAuthorized)) {
	          Promise.all(actions).then(function () {
	            return _this.props.dispatch(ui.showSnackBar('Your information has been saved.'));
	          }).catch(function () {
	            return console.warn('Error updating application');
	          });
	        }
	      }
	
	      _this.setState(formState);
	      return formState.valid;
	    };
	
	    _this.onBack = function () {
	      _this.setCustomError(null);
	      _this.props.stepBackward();
	    };
	
	    _this.onNext = function () {
	      if (_this.onSubmitValidate() && _this.onSave()) {
	        if (!_this.props.stepForward()) {
	          _this.setState(_extends({}, _this.state, { mode: formModes.NOTREADY }));
	        } else {
	          _this.setCustomError(null);
	        }
	      }
	    };
	
	    _this.onSubmit = function () {
	      if (_this.onSave()) {
	        _this.props.submitApplication();
	      }
	    };
	
	    _this.handleCloseModal = function () {
	      _this.setState(_extends({}, _this.state, { mode: formModes.DEFAULT }));
	    };
	
	    _this.updateTempState = function (parent, prop, event, val, cb) {
	      // reset errors.
	      _this.setSubmitError(null);
	      _this.setState({ valid: true });
	      var newTempState = _lodash2.default.cloneDeep(_this.props.tempState);
	      var propPath = parent && !prop ? parent : !parent && prop ? prop : '' + parent + (prop[0] === '[' ? '' : '.') + prop;
	
	      if (val === undefined) {
	        // unsets parent objects if they are empty
	        (0, _deepUnset2.default)(newTempState, propPath);
	      } else {
	        _lodash2.default.setWith(newTempState, propPath, val, Object);
	      }
	
	      _this.props.dispatch(syncActionCreators.updateTempState(newTempState));
	
	      if (typeof cb === 'function') {
	        cb();
	      }
	    };
	
	    _this.errorCount = 0;
	
	    _this.updateErrorState = function (newCount) {
	      return _this.setState(_extends({}, _this.state, {
	        errorCount: newCount
	      }));
	    };
	
	    _this.errorUpdate = function (countChange) {
	      _this.errorCount += countChange;
	      _this.updateErrorState(_this.errorCount);
	    };
	
	    _this.getCurrentComponent = _this.getCurrentComponent.bind(_this);
	    return _this;
	  }
	
	  _createClass(ApplicationForm, [{
	    key: 'setCustomError',
	    value: function setCustomError(message) {
	      var _this2 = this;
	
	      // hack so state actually gets state
	      setTimeout(function () {
	        return _this2.setState({ customError: message });
	      });
	    }
	  }, {
	    key: 'setSubmitError',
	    value: function setSubmitError(message) {
	      var _this3 = this;
	
	      // hack so state actually gets state
	      setTimeout(function () {
	        return _this3.setState({ submitError: message });
	      });
	    }
	
	    // only debouncing on front end
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // delaying actual state update to avoid collisions
	      this.updateErrorState = _lodash2.default.debounce(this.updateErrorState, 100);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // clear tempState when we switch pages
	      if (this.props.activeColumnNav !== nextProps.activeColumnNav || this.props.activeRowSubNav !== nextProps.activeRowSubNav) {
	        this.setCustomError(null);
	        if (!_lodash2.default.isEmpty(this.props.tempState)) {
	          this.props.dispatch(syncActionCreators.updateTempState({}));
	        }
	
	        if (!this.state.valid) {
	          this.setState({
	            valid: true
	          });
	        }
	      }
	    }
	
	    // modify tempState properties
	
	  }, {
	    key: 'renderNotReady',
	    value: function renderNotReady() {
	      return _react2.default.createElement(
	        _c_ModalForm2.default,
	        { onClose: this.handleCloseModal,
	          className: 'application-welcome-message prelim-message',
	          button: {
	            label: 'Close',
	            onClick: this.handleCloseModal
	          } },
	        _react2.default.createElement(_f_PrelimMessage2.default, {
	          profile: this.props.profile
	        })
	      );
	    }
	  }, {
	    key: 'getCurrentComponent',
	    value: function getCurrentComponent(activeColumnNav, activeRowSubNav) {
	      if (activeColumnNav === 'Skills' && activeRowSubNav !== 'Instructions') {
	        // return a obj of props including a component prop
	
	        var skillType = this.props.staticData.skillCategoryTypes.find(function (skill) {
	          return skill.url_query_string === activeRowSubNav;
	        });
	
	        var viewModel = activeRowSubNav ? activeColumnNav + '.' + activeRowSubNav : activeColumnNav;
	
	        var skillObj = {
	          component: (0, _react.createFactory)(_c_SkillSection2.default),
	          model: 'skills',
	          categoryId: skillType.id,
	          title: skillType.title,
	          description: skillType.applicantDescription,
	          viewModel: viewModel,
	          validation: _defineProperty({}, skillType.url_query_string, {
	            custom: {
	              func: function func(val) {
	                return !_lodash2.default.isEmpty(val);
	              },
	              message: 'Must Select at Least One'
	            }
	          }),
	          validationKey: skillType.url_query_string,
	          customErrorMessage: 'Please Select at Least One Item.',
	          hasNone: skillType.hasNone,
	          saveFunc: function saveFunc(tempState) {
	            return asyncActionCreators.persistSkills(tempState);
	          }
	        };
	        return skillObj;
	      } else {
	        return (0, _componentLookup.getCurrent)(activeColumnNav, activeRowSubNav);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _getCurrentComponent = this.getCurrentComponent(this.props.activeColumnNav, this.props.activeRowSubNav),
	          component = _getCurrentComponent.component,
	          staticProps = _objectWithoutProperties(_getCurrentComponent, ['component']);
	
	      var applicantStatus = _lodash2.default.get(this.props, 'profile.applicantStatus', 0);
	      var submitted = !!_lodash2.default.get(this.props, 'profile.dateAuthorized', false);
	      var interviewed = applicationStatus.hasInterviewed(applicantStatus);
	      var isInactivePipeline = applicationStatus.isInactivePipeline(applicantStatus);
	      var isImpersonatedUser = !_lodash2.default.isEmpty(this.props.user.impersonateUser);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-form ' + this.props.className },
	        component ? //simple validation for defined component. if it's not present or undefined - will not be rendered and no error occure;
	        component(_extends({}, typeof staticProps.model === 'string' ? _defineProperty({}, staticProps.model, this.props[staticProps.model]) : Array.isArray(staticProps.model) ? _lodash2.default.fromPairs(staticProps.model.map(function (model) {
	          return [model, _this4.props[model]];
	        })) : {}, staticProps, {
	          user: !_lodash2.default.isEmpty(this.props.user.impersonateUser) ? this.props.user.impersonateUser : this.props.user,
	          profile: this.props.profile,
	          ref: 'currentForm',
	          adminView: false,
	          submitted: submitted,
	          workExperiences: this.props.workExperiences,
	          dispatch: this.props.dispatch,
	          viewState: _lodash2.default.get(this.props.profile.viewState, 'progress.applicant.application.' + staticProps.viewModel),
	          profileId: this.props.profile.id,
	          staticData: this.props.staticData,
	          errorCount: this.state.errorCount,
	          errorUpdate: this.errorUpdate,
	          tempState: this.props.tempState,
	          updateTempState: this.updateTempState,
	          onSave: this.onSave,
	          setErrorMessage: this.setCustomError.bind(this),
	          formSections: this.props.formSections
	        })) : null,
	        component && !this.props.hideControls ? _react2.default.createElement(
	          'div',
	          { className: 'application-form-controls' },
	          _react2.default.createElement(
	            'div',
	            { className: 'left-container' },
	            !this.props.isLast && !submitted && _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)('text-btn save noTextSelect'),
	                'data-id': 'Save',
	                onClick: this.props.isLast ? this.onSubmit : this.onSave
	              },
	              'Save'
	            ),
	            interviewed && !submitted && (!isInactivePipeline || isImpersonatedUser) // only show resume button in inactive pipeline if non-applicant view
	            && _react2.default.createElement(
	              'a',
	              { target: '_blank', className: 'view-resume-btn', href: '/applicant/resume' },
	              _react2.default.createElement(_c_FlatButton2.default, { className: 'view-resume-btn',
	                label: 'View Resume',
	                style: {
	                  display: 'inline-block',
	                  width: 'auto',
	                  paddingLeft: '50px',
	                  paddingRight: '50px',
	                  marginTop: '50px',
	                  float: 'right'
	                } })
	            ),
	            this.state.submitError && _react2.default.createElement(
	              'div',
	              { className: 'error-message' },
	              this.state.submitError
	            ),
	            !this.state.valid && _react2.default.createElement(
	              'div',
	              { className: 'error-message' },
	              this.state.customError || staticProps.customErrorMessage || 'Please fill out the required fields above.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right-container' },
	            !submitted && _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)('text-btn back noTextSelect', { disabled: this.props.isFirst }),
	                'data-id': 'Back',
	                onClick: !this.props.isFirst && this.onBack || null
	              },
	              'Back'
	            ),
	
	            // Submit Button if not yet submitted
	            !submitted && (!isInactivePipeline || isImpersonatedUser) // Show if Active or (Inactive and Admin)
	            && _react2.default.createElement(_c_RaisedButton2.default, {
	              disabled: this.props.isLast && (!this.props.submitReady || _lodash2.default.get(this.props.tempState, 'profile.dateAuthorized', '').length === 0),
	              label: this.props.isLast ? 'Submit' : 'Next',
	              'data-id': this.props.isLast ? 'Submit Button' : 'Next Button',
	              style: nextButtonStyle,
	              onClick: this.props.isLast ? this.onSubmit : this.onNext
	            }),
	
	            // Save Button if already submitted
	            submitted && (!isInactivePipeline || isImpersonatedUser) // Show if Active or (Inactive and Admin)
	            && _react2.default.createElement(_c_RaisedButton2.default, {
	              disabled: this.props.activeColumnNav === 'Submit' && submitted,
	              label: 'Save',
	              'data-id': 'Save',
	              style: nextButtonStyle,
	              onClick: this.onSave
	            })
	          )
	        ) : null,
	        this.state.mode === formModes.NOTREADY && this.renderNotReady()
	      );
	    }
	  }]);
	
	  return ApplicationForm;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  workExperiences: _react.PropTypes.object.isRequired,
	  employmentGaps: _react.PropTypes.object.isRequired,
	  education: _react.PropTypes.object.isRequired,
	  references: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  className: _react.PropTypes.string,
	  navStateChange: _react.PropTypes.func,
	  isFirst: _react.PropTypes.bool,
	  isLast: _react.PropTypes.bool,
	  stepBackward: _react.PropTypes.func,
	  stepForward: _react.PropTypes.func,
	  submitApplication: _react.PropTypes.func,
	  activeColumnNav: _react.PropTypes.string,
	  activeRowSubNav: _react.PropTypes.string,
	  tempState: _react.PropTypes.object.isRequired,
	  skills: _react.PropTypes.object,
	  associations: _react.PropTypes.object,
	  designations: _react.PropTypes.object,
	  submitReady: _react.PropTypes.bool,
	  hideControls: _react.PropTypes.bool,
	  formSections: _react.PropTypes.object,
	  appViewState: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ApplicationForm;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _viewOrderArr = __webpack_require__(212);
	
	var _Logo = __webpack_require__(123);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var logoStyle = { backgroundColor: '#fafafa' };
	var NavColumn = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store.labels, 'Common', {}),
	    account: (0, _lodash.get)(store.staticData, 'account', {}),
	    impersonatedUser: (0, _lodash.get)(store.user, 'impersonateUser', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(NavColumn, _Component);
	
	  function NavColumn() {
	    _classCallCheck(this, NavColumn);
	
	    return _possibleConstructorReturn(this, (NavColumn.__proto__ || Object.getPrototypeOf(NavColumn)).apply(this, arguments));
	  }
	
	  _createClass(NavColumn, [{
	    key: 'includeSection',
	
	
	    // Should section be displayed?
	    value: function includeSection(heading) {
	      if (heading.key === 'Instructions') {
	        // show instructions if requested
	        return this.props.showInstructions;
	      } else if ((0, _lodash.isEmpty)(this.props.impersonatedUser)) {
	        // Applicant View
	        if (this.props.isInactivePipeline) {
	          // Applicant in Inactive Pipeline
	          return heading.showInactivePipeline;
	
	          // eslint-disable-next-line no-else-return
	        } else {
	          return (this.props.hasInterviewed || heading.showUnqualified) && (!this.props.submitted || !heading.hideSubmitted);
	        }
	      }
	
	      // eslint-disable-next-line no-else-return
	      else {
	          // QS View
	          return (this.props.hasInterviewed || heading.showUnqualified) && (!this.props.submitted || !heading.hideSubmitted);
	        }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'applicant-profile-nav' },
	        _react2.default.createElement(
	          'a',
	          { className: 'reset-href', href: this.props.labels.website },
	          _react2.default.createElement(_Logo2.default, { className: 'logo', style: logoStyle, account: this.props.account })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'applicant-nav-container noTextSelect' },
	          _viewOrderArr.viewOrderArr.filter(this.includeSection.bind(this)).map(function (heading, index) {
	            var subNavIndex = heading.key === 'Skills' && _this2.props.isQualified && _this2.props.submitted ? 1 : 0;
	            return _react2.default.createElement(
	              'div',
	              {
	                'data-id': heading.display,
	                key: index,
	                className: (0, _classnames2.default)('applicant-nav-heading noTextSelect', { active: _this2.props.activeColumnNav === heading.key }, { checkmark: !_this2.props.submitted && _this2.props.navViewState[heading.key] }),
	                onClick: _this2.props.activeColumnNav !== heading && _this2.props.navStateChange.bind(_this2, heading.key, heading.subNav && heading.subNav[subNavIndex].key || null)
	              },
	              _this2.props.submitted ? heading.displaySubmitted || heading.display : heading.display
	            );
	          }),
	          this.props.submitted && _react2.default.createElement(
	            'div',
	            {
	              'data-id': 'view resume',
	              className: 'applicant-nav-heading noTextSelect'
	            },
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', className: 'view-resume-btn', href: '/applicant/resume' },
	              'resume'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'applicant-nav-heading noTextSelect separator'
	            },
	            ' \xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)('applicant-nav-heading noTextSelect', { active: this.props.assessment }, { checkmark: !this.props.submitted && this.props.navViewState.Assessments }),
	              style: { display: this.props.canShowAssessment ? 'inline-block' : 'none' },
	              onClick: this.props.showAssessment,
	              'data-id': 'Assessments'
	            },
	            ' Assessments'
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)('applicant-nav-heading noTextSelect', { active: this.props.technologySurvey }),
	              style: { display: this.props.canShowTechnologySurvey ? 'inline-block' : 'none' },
	              onClick: this.props.showTechnologySurvey,
	              'data-id': 'Technology'
	            },
	            ' Technology'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'terms-section noTextSelect' },
	          _react2.default.createElement(
	            'span',
	            null,
	            ' \xA9 Work At Home Vintage Experts LLC.'
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'terms-link', href: 'https://wahve.com/privacy-policy/', target: '_blank', title: 'Privacy Policy opens in a new browser tab' },
	            'Terms & Privacy'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavColumn;
	}(_react.Component), _class2.propTypes = {
	  navStateChange: _react.PropTypes.func,
	  logoutFunc: _react.PropTypes.func,
	  activeColumnNav: _react.PropTypes.string,
	  navViewState: _react.PropTypes.object,
	  assessment: _react.PropTypes.bool,
	  canShowAssessment: _react.PropTypes.bool,
	  submitted: _react.PropTypes.bool,
	  isQualified: _react.PropTypes.bool,
	  hasInterviewed: _react.PropTypes.bool,
	  showInstructions: _react.PropTypes.bool,
	  labels: _react.PropTypes.object.isRequired,
	  account: _react.PropTypes.object.isRequired,
	  impersonatedUser: _react.PropTypes.object.isRequired,
	  isInactivePipeline: _react.PropTypes.object.isRequired }, _temp)) || _class);
	exports.default = NavColumn;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint-disable lines-around-comment */
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// action creators for redux
	
	
	// components
	
	
	// view ordering array of arrays
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _reactRouter = __webpack_require__(51);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _auth = __webpack_require__(213);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _ui = __webpack_require__(26);
	
	var ui = _interopRequireWildcard(_ui);
	
	var _impersonation = __webpack_require__(316);
	
	var impersonationApi = _interopRequireWildcard(_impersonation);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _f_NavColumn = __webpack_require__(1087);
	
	var _f_NavColumn2 = _interopRequireDefault(_f_NavColumn);
	
	var _f_Application = __webpack_require__(1063);
	
	var _f_Application2 = _interopRequireDefault(_f_Application);
	
	var _r_ApplicantAssessment = __webpack_require__(1089);
	
	var _r_ApplicantAssessment2 = _interopRequireDefault(_r_ApplicantAssessment);
	
	var _r_ApplicantTermsAndConditions = __webpack_require__(477);
	
	var _r_ApplicantTermsAndConditions2 = _interopRequireDefault(_r_ApplicantTermsAndConditions);
	
	var _TechnologySurveyContainer = __webpack_require__(470);
	
	var _TechnologySurveyContainer2 = _interopRequireDefault(_TechnologySurveyContainer);
	
	var _f_RouteTransitionBlocker = __webpack_require__(70);
	
	var _f_RouteTransitionBlocker2 = _interopRequireDefault(_f_RouteTransitionBlocker);
	
	var _f_InfoModal = __webpack_require__(122);
	
	var _f_InfoModal2 = _interopRequireDefault(_f_InfoModal);
	
	var _f_applicantMenu = __webpack_require__(472);
	
	var _f_applicantMenu2 = _interopRequireDefault(_f_applicantMenu);
	
	var _JoveoTrackingPixel = __webpack_require__(210);
	
	var _JoveoTrackingPixel2 = _interopRequireDefault(_JoveoTrackingPixel);
	
	var _viewOrderArr = __webpack_require__(212);
	
	var _appViewState = __webpack_require__(1061);
	
	var _status = __webpack_require__(209);
	
	var applicantHelpers = _interopRequireWildcard(_status);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicantDashboard = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    user: state.user,
	    profile: state.applicantProfile,
	    workExperience: state.workExperience,
	    licenses: state.licenses,
	    scrollBarWidth: state.browserData.scrollBarWidth,
	    activeColumnNav: props.params.activeColumnNav,
	    activeRowSubNav: props.params.activeRowSubNav || null,
	    tempState: state.tempState,
	    staticData: state.staticData,
	    skills: state.skills,
	    labels: (0, _lodash.get)(state.labels, 'Common', {}),
	    viewOrderArrLabels: (0, _lodash.get)(state.labels, 'Application.viewOrderArr.nav', {})
	  };
	}, {
	  showControls: ui.showControls,
	  push: _reactRouterRedux.push,
	  updateTempState: syncActionCreators.updateTempState,
	  getProfileById: asyncActionCreators.getProfileById,
	  logOut: _auth.logOut
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ApplicantDashboard, _Component);
	
	  function ApplicantDashboard(props, context) {
	    _classCallCheck(this, ApplicantDashboard);
	
	    var _this2 = _possibleConstructorReturn(this, (ApplicantDashboard.__proto__ || Object.getPrototypeOf(ApplicantDashboard)).call(this, props, context));
	
	    _this2.navSkillsChange = function (activeColumnNav, activeRowSubNav, adjustProgressView) {
	      var newLocation = '/applicant/' + activeColumnNav + (activeRowSubNav ? '/' + activeRowSubNav : '');
	      var summaryOFSkills = encodeURI('/applicant/Summary of Skills/Summary of Skills');
	
	      var incompletedSkills = _lodash2.default.chain(_this2.props.skills).values().map(function (i) {
	        return _lodash2.default.values(i);
	      }).flatten() // Convert the multilevel object in flatten array.
	      .filter(function (skill) {
	        return skill.name !== 'None';
	      }) // Filter out everything set to none.
	      .filter(function (skill) {
	        return !skill.lastUsed || !skill.yearsOfExperience || !skill.skillLevel;
	      }) // If something is missing keep it.
	      .value();
	
	      if (_lodash2.default.startsWith(location.pathname, '/applicant/Skills/')) {
	        if (_lodash2.default.startsWith(newLocation, '/applicant/Skills/') || encodeURI(newLocation) === summaryOFSkills) {
	          return true;
	        }
	
	        return !incompletedSkills.length;
	      }
	
	      return true;
	    };
	
	    _this2.navStateChange = function (activeColumnNav, activeRowSubNav, adjustProgressView) {
	      if (!_this2.navSkillsChange(activeColumnNav, activeRowSubNav, adjustProgressView)) {
	        return _this2.setState({ blockRoutes: true });
	      }
	
	      var filledFlag = void 0;
	      var orSkills = _this2.props.skills;
	
	      filledFlag = false;
	      // eslint-disable-next-line no-unused-vars
	      var _this = _this2;
	
	      // add check for skills last page only. Checking if all skills are fullfilled
	      if (_lodash2.default.isEmpty(_this2.props.tempState) && _this2.props.params.activeColumnNav === 'Summary of Skills' && _this2.props.params.activeRowSubNav === 'Summary of Skills') {
	        // eslint-disable-next-line no-unused-vars
	        var skillsAreFilled = (0, _lodash2.default)(orSkills).forEach(function (value, key) {
	          if (!orSkills[key].hasOwnProperty('None')) {
	            // eslint-disable-next-line no-unused-vars
	            (0, _lodash2.default)(value).forEach(function (skill, name) {
	              if (!skill.lastUsed && !skill.skillLevel && !skill.yearsOfExperience) filledFlag = true;
	            });
	          }
	        });
	      }
	
	      var finalAdjustProgressView = typeof adjustProgressView === 'number' ? Math.max(adjustProgressView, 0) : // if clicking next or back then scooch row nav
	      activeColumnNav !== _this2.props.activeColumnNav ? 0 : // if column nav changes, move back to zero adjustment
	      _this2.state.adjustProgressView; // if navigation happens via row nav then don't change adjustment to row nav
	
	      // for some reason dispatch on save has not taken place when you get here, forcing to the bottom of the call stack with setTimeout :(
	      _this2.setState({
	        showAssessmentFlag: false,
	        showTermsFlag: false,
	        showTechnologySurveyFlag: false
	      });
	
	      setTimeout(function () {
	        if (!_lodash2.default.isEmpty(_this2.props.tempState) && !(_this2.props.activeColumnNav === 'Skills' && _this2.props.activeRowSubNav === 'Instructions') || filledFlag) {
	          _this2.setState(_extends({}, _this2.state, {
	            transitionBlockingRoute: '/applicant/' + activeColumnNav + (activeRowSubNav ? '/' + activeRowSubNav : ''),
	            transitionAdjustProgressView: finalAdjustProgressView
	          }));
	        } else {
	          _this2.setState(_extends({}, _this2.state, {
	            adjustProgressView: finalAdjustProgressView
	          }), function () {
	            return _this2.props.push('/applicant/' + activeColumnNav + (activeRowSubNav ? '/' + activeRowSubNav : ''));
	          });
	        }
	        _this2.props.showControls();
	      });
	    };
	
	    _this2.closeTransitionBlocker = function (cb, adjustProgressView) {
	      // store transition route here temporarily as it will get wiped off of local state
	      var transitionRoute = _this2.state.transitionBlockingRoute;
	
	      var newState = {
	        transitionBlockingRoute: '',
	        transitionAdjustProgressView: null,
	        showResults: false
	      };
	
	      if (!_lodash2.default.isNil(adjustProgressView)) {
	        _lodash2.default.set(newState, 'adjustProgressView', adjustProgressView);
	      }
	
	      // get rid of transition blocker pop-up + route
	      _this2.setState(newState, typeof cb === 'function' && cb(transitionRoute) || null);
	    };
	
	    _this2.stepBackward = function () {
	      var nextColKey = void 0; // default to current colNav (only move forward if row navs are used up)
	      var nextRowKey = void 0;
	      var nextRowIndex = void 0;
	
	      var currentColumnIndex = _this2.viewOrderArr.findIndex(function (col) {
	        return col.key === _this2.props.activeColumnNav;
	      });
	      var currentColumn = _this2.viewOrderArr[currentColumnIndex];
	      var currentRowIndex = currentColumn.subNav ? currentColumn.subNav.findIndex(function (val) {
	        return val.key === _this2.props.activeRowSubNav;
	      }) : -1; // using binary flip '~' so -1 will flip to falsey
	
	      if (~currentRowIndex && currentRowIndex > 0) {
	        // if index is found and index is less than rowSubNav length
	        nextColKey = _this2.props.activeColumnNav;
	        nextRowIndex = currentRowIndex - 1;
	        nextRowKey = currentColumn.subNav[nextRowIndex].key;
	      } else {
	        var incrementedColumn = _this2.viewOrderArr[currentColumnIndex - 1];
	        nextColKey = incrementedColumn.key;
	        nextRowIndex = _lodash2.default.get(incrementedColumn, ['subNav', 'length'], 1) - 1;
	        nextRowKey = _lodash2.default.get(incrementedColumn, ['subNav', nextRowIndex, 'key'], null);
	      }
	
	      // for scooching progress bar
	      var adjustProgressView = nextRowIndex - _this2.state.adjustProgressView < 1 ? Math.max(nextRowIndex - 1, 0) : // move one ahead of the beginning
	      nextRowIndex - _this2.state.adjustProgressView > 3 ? nextRowIndex - 3 : // handle if you've moved to the previous 'column'
	      null; // if in the middle of view don't move at all
	
	      _this2.navStateChange(nextColKey, nextRowKey, adjustProgressView);
	    };
	
	    _this2.stepForward = function () {
	      var nextColKey = void 0; // default to current colNav (only move forward if row navs are used up)
	      var nextRowKey = void 0;
	      var nextRowIndex = void 0;
	      var showUnqualified = void 0;
	
	      var currentColumnIndex = _this2.viewOrderArr.findIndex(function (col) {
	        return col.key === _this2.props.activeColumnNav;
	      });
	      var currentColumn = _this2.viewOrderArr[currentColumnIndex];
	      var currentRowIndex = currentColumn.subNav ? currentColumn.subNav.findIndex(function (val) {
	        return val.key === _this2.props.activeRowSubNav;
	      }) : -1; // using binary flip '~' so -1 will flip to falsey
	
	      if (~currentRowIndex && currentRowIndex < currentColumn.subNav.length - 1) {
	        // if index is found and index is less than rowSubNav length
	        showUnqualified = currentColumn.showUnqualified;
	        nextColKey = _this2.props.activeColumnNav;
	        nextRowIndex = currentRowIndex + 1;
	        nextRowKey = currentColumn.subNav[nextRowIndex].key;
	      } else {
	        var incrementedColumn = _this2.viewOrderArr[currentColumnIndex + 1];
	        showUnqualified = incrementedColumn.showUnqualified;
	        nextColKey = incrementedColumn.key;
	        nextRowIndex = 0;
	        nextRowKey = _lodash2.default.get(incrementedColumn, ['subNav', nextRowIndex, 'key'], null);
	      }
	
	      if (showUnqualified || _this2.state.hasInterviewed) {
	        // for scooching progress bar
	        var adjustProgressView = nextRowIndex - _this2.state.adjustProgressView > 3 ? Math.max(nextRowIndex - 3, 0) : // move one behind the end
	        nextRowIndex === 0 ? 0 : // handle if you've moved to a next 'column'
	        null; // if in the middle of view don't move at all
	
	        _this2.navStateChange(nextColKey, nextRowKey, adjustProgressView);
	        return true;
	      }
	      // eslint-disable-next-line no-else-return
	      else {
	          return false;
	        }
	    };
	
	    _this2.submitApplication = function () {
	      _this2.setState({ showResults: true, transitionBlockingRoute: '/applicant/Profile/Contact Information' });
	    };
	
	    _this2.closeModal = function () {
	      _this2.setState({ showResults: false });
	    };
	
	    _this2.showAssessment = function () {
	      _this2.navStateChange('Assesments', 0, 0);
	      _this2.setState({ showAssessmentFlag: true });
	    };
	
	    _this2.showTechnologySurvey = function () {
	      _this2.navStateChange('TechnologySurvey', 0, 0);
	      _this2.setState({ showTechnologySurveyFlag: true });
	    };
	
	    _this2.showTerms = function () {
	      _this2.navStateChange('TermsAndPrivacy', 0, 0);
	      _this2.setState({ showAssessmentFlag: true, showTermsFlag: true });
	    };
	
	    _this2.moveToSumarySkills = function () {
	      _this2.setState({ blockRoutes: false }, function () {
	        _this2.props.push('/applicant/Summary of Skills/Summary of Skills');
	      });
	    };
	
	    _this2.handleLogOut = function () {
	      var warn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var website = _this2.props.labels.website;
	      var _this2$props = _this2.props,
	          tempState = _this2$props.tempState,
	          user = _this2$props.user;
	
	
	      if (user.impersonateUser) {
	        impersonationApi.deleteImpersonation().then(function () {
	          if (window) {
	            if (window) window.close();
	          }
	        });
	
	        return;
	      } else if (!(0, _lodash.isEmpty)(tempState) && warn) {
	
	        _this2.setState({ showLogoutModal: warn });
	        return;
	      }
	
	      _this2.props.logOut().then(function () {
	        window.location = website;
	      });
	    };
	
	    _this2.hideLogoutWarning = function () {
	      _this2.setState({ showLogoutModal: false });
	    };
	
	    _this2.viewOrderArr = _this2.mapSkillsViewOrderArr();
	    _this2.appViewState = _this2.mapSkillsAppViewState();
	
	    _this2.state = _this2.initializeState(props);
	    return _this2;
	  }
	
	  _createClass(ApplicantDashboard, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.transitionBlockingRoute.length === 0) {
	        this.setState(_lodash2.default.merge({}, this.state, this.initializeState(nextProps)));
	      }
	    }
	  }, {
	    key: 'mapSkillsViewOrderArr',
	    value: function mapSkillsViewOrderArr() {
	      // construct new skills subnav array using staticData skillCategoryTypes
	      var _props = this.props,
	          staticData = _props.staticData,
	          viewOrderArrLabels = _props.viewOrderArrLabels;
	
	
	      return _viewOrderArr.viewOrderArr.map(function (col) {
	        if (col.display === 'Skills') {
	
	          // concat instructions page to beginning
	          col.subNav = [{ display: 'Introduction', key: 'Instructions' }].concat(_lodash2.default.orderBy(staticData.skillCategoryTypes, ['order'], ['asc']).map(function (cat) {
	            return { display: cat.name, key: cat.url_query_string };
	          }));
	        }
	
	        if (col.display === 'Background') {
	          col.subNav = col.subNav.map(function (sub) {
	            if (sub.display === 'Professional Designations') {
	              sub.display = (0, _lodash.get)(viewOrderArrLabels, 'background.professionalDesignations');
	            }
	            return sub;
	          });
	        }
	
	        return col;
	      });
	    }
	  }, {
	    key: 'mapSkillsAppViewState',
	    value: function mapSkillsAppViewState() {
	      var newAppViewState = _lodash2.default.merge({}, _appViewState.appViewState);
	
	      newAppViewState.Skills = this.props.staticData.skillCategoryTypes.reduce(function (obj, skillType) {
	        obj[skillType.url_query_string] = { done: false };
	        return obj;
	      }, { Instructions: { done: false } });
	
	      return newAppViewState;
	    }
	  }, {
	    key: 'initializeState',
	    value: function initializeState(props) {
	      var _this3 = this;
	
	      var currentColumnIndex = this.viewOrderArr.findIndex(function (col) {
	        return col.key === _this3.props.activeColumnNav;
	      });
	      var currentColumn = this.viewOrderArr[currentColumnIndex] ? this.viewOrderArr[currentColumnIndex] : this.viewOrderArr[0];
	      var currentRowIndex = currentColumn.subNav ? currentColumn.subNav.findIndex(function (val) {
	        return val.key === _this3.props.activeRowSubNav;
	      }) : -1; // using binary flip '~' so -1 will flip to falsey
	      var applicantStatus = _lodash2.default.get(props.profile, 'applicantStatus', 0);
	
	      return {
	        adjustProgressView: Math.max(currentRowIndex - 2, 0), // for scooching progress bar, if more than 5 items, move current one to the middle
	        transitionBlockingRoute: '',
	        transitionAdjustProgressView: null,
	        showLogoutModal: false,
	        canShowAssessment: applicantHelpers.enableAssessments(applicantStatus), // Pending Assessments.
	        isQualified: applicantHelpers.isQualified(applicantStatus),
	        hasInterviewed: applicantHelpers.hasInterviewed(applicantStatus),
	        submitted: applicantHelpers.hasSubmitted(props.profile),
	        showAssessmentFlag: props.location.pathname === '/applicant/Assesments',
	        showTermsFlag: props.location.pathname === '/applicant/TermsAndPrivacy',
	        showTechnologySurveyFlag: props.location.pathname === '/applicant/TechnologySurvey',
	        canShowTechnologySurvey: applicantHelpers.enableTechnologySurvey(applicantStatus), // Show technology for "Pending Reference Checks" or "Ready to Place".
	        showInstructions: applicantHelpers.enableInstructions(applicantStatus),
	        isInactivePipeline: applicantHelpers.isInactivePipeline(applicantStatus)
	      };
	    }
	
	    // eslint-disable-next-line no-unused-vars
	
	  }, {
	    key: 'renderLogoutModal',
	
	
	    // eslint-disable-next-line no-unused-vars
	    value: function renderLogoutModal(state, props) {
	      var _this4 = this;
	
	      var showLogoutModal = this.state.showLogoutModal;
	
	
	      if (showLogoutModal) {
	
	        return _react2.default.createElement(
	          _r_Modal2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'route-transition-blocker-transition-block-form' },
	            _react2.default.createElement(_ModalX2.default, { onClick: this.hideLogoutWarning }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'prompt-text' },
	                'You have not saved all your changes. If you exit the application now you will lose the information that hasn\u2019t been saved.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'logout-buttons' },
	                _react2.default.createElement(_Button2.default, {
	                  className: 'button-main-large',
	                  label: 'Stay',
	                  onClick: this.hideLogoutWarning
	                }),
	                _react2.default.createElement(_Button2.default, {
	                  className: 'button-secondary-large',
	                  label: 'Leave',
	                  onClick: function onClick() {
	                    return _this4.handleLogOut(false);
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'rectangle-behind-modal-form absolute-center' })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var isFirst = // boolean to check if first form (first row val of first column)
	      this.props.activeColumnNav === this.viewOrderArr[0].key && (!this.viewOrderArr[0].subNav || this.viewOrderArr[0].subNav[0].key === this.props.activeRowSubNav);
	      var isLast = // boolean to check if last form (last row val of last column)
	      this.props.activeColumnNav === this.viewOrderArr[this.viewOrderArr.length - 1].key && (!this.viewOrderArr[this.viewOrderArr.length - 1].subNav || this.viewOrderArr[this.viewOrderArr.length - 1].subNav[this.viewOrderArr[this.viewOrderArr.length - 1].subNav.length - 1].key === this.props.activeRowSubNav);
	
	      var navViewState = _lodash2.default.chain(_lodash2.default.get(this.props.profile, 'viewState.progress.applicant.application', this.appViewState)).omit(['firstTime']).clone().mapValues(function (prop) {
	        return prop.done || _lodash2.default.every(prop, function (subProp) {
	          return subProp.done;
	        });
	      }).value();
	
	      var submitDone = navViewState.Submit,
	          nonSubmitViewState = _objectWithoutProperties(navViewState, ['Submit']);
	
	      var requiredSections = {
	        Profile: false,
	        Preferences: false,
	        Experience: false,
	        Skills: false,
	        'Summary of Skills': false,
	        Background: false
	      };
	
	      var completedSections = _lodash2.default.merge({}, requiredSections, _lodash2.default.omit(nonSubmitViewState, ['Welcome', 'Documents', 'Instructions', 'Submit', 'Assessments']));
	
	      var submitReady = _lodash2.default.every(completedSections, function (val) {
	        return val;
	      });
	
	      var applicantName = '';
	
	      if (this.props.user.impersonateUser) {
	        applicantName = _lodash2.default.get(this.props.user, 'impersonateUser.firstName', '') + ' ' + _lodash2.default.get(this.props.user, 'impersonateUser.lastName', '');
	      } else {
	        applicantName = _lodash2.default.get(this.props.user, 'firstName', '') + ' ' + _lodash2.default.get(this.props.user, 'lastName', '');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'applicant-profile-container clearfix' },
	        this.state.transitionBlockingRoute && _react2.default.createElement(_f_RouteTransitionBlocker2.default, {
	          cancelAction: this.closeTransitionBlocker,
	          primaryAction: this.closeTransitionBlocker,
	          secondaryAction: this.closeTransitionBlocker.bind(this, this.props.push, this.state.transitionAdjustProgressView)
	        }),
	        this.renderLogoutModal(this.state, this.props),
	        this.state.showResults ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_f_InfoModal2.default, {
	            cancelFunc: this.closeModal,
	            transitionFunc: this.closeTransitionBlocker.bind(this, this.props.push),
	            buttonLabel: 'Close'
	            // text={' <br /> We look forward to working with you.'}
	            , text: ['Thank you for completing the WAHVE application. We appreciate the time you have spent to provide us with all your professional information. You will receive an email from ' + this.props.profile.qualifyingspecialist.firstName + ' ' + this.props.profile.qualifyingspecialist.lastName + ' with the next steps. ', _react2.default.createElement('br', null), _react2.default.createElement('br', null), ' We look forward to working with you.']
	          }),
	          _react2.default.createElement(_JoveoTrackingPixel2.default, { conversionType: 'full-apply' })
	        ) : null,
	        this.state.blockRoutes && _react2.default.createElement(_f_InfoModal2.default, {
	          transitionFunc: this.moveToSumarySkills,
	          buttonLabel: 'COMPLETE INFO',
	          text: ['You must complete the required additional information on the', _react2.default.createElement('br', null), 'Summary of Skills table for the new skill(s) you added and save', _react2.default.createElement('br', null), 'your changes before continuing or logging out.']
	        }),
	        _react2.default.createElement(_f_NavColumn2.default, { activeColumnNav: this.props.activeColumnNav,
	          navStateChange: this.navStateChange,
	          navViewState: navViewState,
	          logoutFunc: this.logOut,
	          showAssessment: this.showAssessment,
	          showTerms: this.showTerms,
	          showTechnologySurvey: this.showTechnologySurvey,
	          assessment: this.state.showAssessmentFlag,
	          canShowAssessment: this.state.canShowAssessment,
	          canShowTechnologySurvey: this.state.canShowTechnologySurvey,
	          technologySurvey: this.state.showTechnologySurveyFlag,
	          isQualified: this.state.isQualified,
	          submitted: this.state.submitted,
	          hasInterviewed: this.state.hasInterviewed,
	          showInstructions: this.state.showInstructions,
	          isInactivePipeline: this.state.isInactivePipeline
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'applicant-application-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'applicant-profile-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'applicant-welcome' },
	              this.state.showTermsFlag ? 'PRIVACY NOTICE' : _react2.default.createElement(
	                'h1',
	                null,
	                applicantName
	              )
	            ),
	            _react2.default.createElement(_f_applicantMenu2.default, {
	              logOut: this.handleLogOut
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'applicant-profile-form' },
	            this.state.showAssessmentFlag && this.state.canShowAssessment && !this.state.showTermsFlag ? _react2.default.createElement(_r_ApplicantAssessment2.default, null) : null,
	            this.state.showTechnologySurveyFlag ? _react2.default.createElement(_TechnologySurveyContainer2.default, null) : null,
	            this.state.showTermsFlag ? _react2.default.createElement(_r_ApplicantTermsAndConditions2.default, null) : null,
	            _react2.default.createElement(_f_Application2.default, {
	              activeColumnNav: this.props.activeColumnNav,
	              activeRowSubNav: this.props.activeRowSubNav,
	              navStateChange: this.navStateChange,
	              adjustProgressView: this.state.adjustProgressView,
	              isFirst: isFirst,
	              isLast: isLast,
	              stepBackward: this.stepBackward,
	              stepForward: this.stepForward,
	              submitApplication: this.submitApplication,
	              viewData: _lodash2.default.get(this.props.profile, 'viewState.progress.applicant.application.' + this.props.activeColumnNav, this.appViewState[this.props.activeColumnNav]),
	              rowSubNav: this.viewOrderArr.find(function (nav) {
	                return nav.key === _this5.props.activeColumnNav;
	              }) ? this.viewOrderArr.find(function (nav) {
	                return nav.key === _this5.props.activeColumnNav;
	              }).subNav : [],
	              submitReady: !submitDone && submitReady,
	              assessment: this.state.showAssessmentFlag,
	              submitted: this.state.submitted,
	              formSections: nonSubmitViewState,
	              appViewState: this.appViewState
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'style',
	          null,
	          '\n            .application-section-container {\n              width: calc(100%); //+ ' + (this.props.scrollBarWidth || '15') + 'px\n              padding-right: ' + (this.props.scrollBarWidth || '15') + 'px;\n            }\n          '
	        )
	      );
	    }
	  }]);
	
	  return ApplicantDashboard;
	}(_react.Component), _class2.propTypes = {
	  params: _react.PropTypes.object.isRequired,
	  push: _react.PropTypes.func.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  getProfileById: _react.PropTypes.func.isRequired,
	  logOut: _react.PropTypes.func.isRequired,
	  scrollBarWidth: _react.PropTypes.number.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  profile: _react.PropTypes.object,
	  workExperience: _react.PropTypes.object,
	  licenses: _react.PropTypes.object,
	  tempState: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  columnState: _react.PropTypes.string,
	  rowState: _react.PropTypes.string,
	  skills: _react.PropTypes.object.isRequired,
	  route: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.object.isRequired,
	  viewOrderArrLabels: _react.PropTypes.object.isRequired,
	  isInactivePipeline: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = (0, _reactRouter.withRouter)(ApplicantDashboard);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// bring in SVG
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _assessments = __webpack_require__(479);
	
	var _assessmentRules = __webpack_require__(1175);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _AssessmentBank = __webpack_require__(876);
	
	var _AssessmentBank2 = _interopRequireDefault(_AssessmentBank);
	
	var _AssessmentBenefits = __webpack_require__(877);
	
	var _AssessmentBenefits2 = _interopRequireDefault(_AssessmentBenefits);
	
	var _AssessmentLaptop = __webpack_require__(880);
	
	var _AssessmentLaptop2 = _interopRequireDefault(_AssessmentLaptop);
	
	var _AssessmentComercial = __webpack_require__(878);
	
	var _AssessmentComercial2 = _interopRequireDefault(_AssessmentComercial);
	
	var _AssessmentPersonal = __webpack_require__(881);
	
	var _AssessmentPersonal2 = _interopRequireDefault(_AssessmentPersonal);
	
	var _AssessmentExe = __webpack_require__(879);
	
	var _AssessmentExe2 = _interopRequireDefault(_AssessmentExe);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicantAssessment = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.user,
	    profile: state.applicantProfile,
	    assessmentUrls: state.assessmentUrls,
	    tempState: state.tempState,
	    staticData: state.staticData,
	    skills: state.skills,
	    labels: _lodash2.default.get(state.labels, 'Application', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ApplicantAssessment, _Component);
	
	  function ApplicantAssessment(props, context) {
	    _classCallCheck(this, ApplicantAssessment);
	
	    var _this = _possibleConstructorReturn(this, (ApplicantAssessment.__proto__ || Object.getPrototypeOf(ApplicantAssessment)).call(this, props, context));
	
	    _this.updateAssessmentViewState = function () {
	      // if component.saveFunc is provided then use that, otherwise use default route hitting actionCreator
	      var newState = _lodash2.default.cloneDeep(_this.props.tempState);
	      _lodash2.default.set(newState, 'user.id', _this.props.user.id);
	      _lodash2.default.set(newState, 'profile.id', _this.props.profile.id);
	
	      newState.profile.viewState = _lodash2.default.merge({}, _this.props.profile.viewState, newState.profile.viewState, {
	        progress: { applicant: { application: { Assessments: { done: true } } } }
	      });
	
	      // update front end
	      _this.props.dispatch(syncActionCreators.updateApplicant(newState));
	
	      // update back end
	      _this.props.dispatch(asyncActionCreators.persistApplicantUpdate(newState));
	    };
	
	    _this.showAssessment = function (assessmentItem) {
	      return _lodash2.default.get(_this.state, 'assessments.' + assessmentItem.name + '.display', false);
	    };
	
	    _this.state = _this.refreshState();
	    return _this;
	  }
	
	  _createClass(ApplicantAssessment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          profile = _props.profile,
	          dispatch = _props.dispatch;
	
	
	      dispatch((0, _assessments.applicantAssessmentUrls)(profile.id, function (err, assessmentUrls) {
	        if (err) {
	          return console.error(err);
	        }
	
	        if (assessmentUrls && !_lodash2.default.isEmpty(assessmentUrls)) {
	          dispatch(syncActionCreators.updateApplicant({ assessmentUrls: assessmentUrls }));
	        }
	      }));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.skills !== this.props.skills) {
	        this.setState(this.refreshState({ props: nextProps }));
	      }
	    }
	  }, {
	    key: 'refreshState',
	    value: function refreshState() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this,
	          props = _ref.props;
	
	      var clonedAssessmentTypes = _lodash2.default.cloneDeep(props.staticData.assessmentTypes);
	
	      // props.skills is a collection of collections of skills grouped by skillcategory and needs to be flattened
	      var flatSkills = _lodash2.default.flatMapDeep(props.skills, function (skill) {
	        return _lodash2.default.valuesIn(skill);
	      });
	      var assessments = (0, _assessmentRules.getAssessments)(flatSkills, clonedAssessmentTypes, true);
	      var objPath = 'viewState.progress.applicant.application.Assessments.done';
	      var viewStateDone = _lodash2.default.get(props.profile, objPath, false);
	      if (!viewStateDone) {
	        this.updateAssessmentViewState();
	      }
	
	      return {
	        assessments: _lodash2.default.keyBy(assessments, 'name')
	      };
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(icon) {
	      switch (icon) {
	        case 'computer-skills':
	          return _react2.default.createElement(_AssessmentLaptop2.default, null);
	        case 'excel':
	          return _react2.default.createElement(_AssessmentExe2.default, null);
	        case 'personal-lines':
	          return _react2.default.createElement(_AssessmentPersonal2.default, null);
	        case 'commercial-lines':
	          return _react2.default.createElement(_AssessmentBank2.default, null);
	        case 'commercial-personal-lines':
	          return _react2.default.createElement(_AssessmentComercial2.default, null);
	        case 'benefits':
	          return _react2.default.createElement(_AssessmentBenefits2.default, null);
	        default:
	          return _react2.default.createElement('img', { src: icon });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-section-container applicant-assessment-container clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-heading', 'data-id': 'Assessments Title' },
	          _lodash2.default.get(this.props.labels, 'ApplicantAssessment.Title')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-subheading', 'data-id': 'Assessments SubTitle' },
	          _lodash2.default.get(this.props.labels, 'ApplicantAssessment.SubTitle')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-text example-text' },
	          _lodash2.default.get(this.props.labels, 'ApplicantAssessment.Intro')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'assesment-sections' },
	          this.props.staticData.assessmentTypes.map(function (assessmentItem) {
	            return _react2.default.createElement(
	              'a',
	              { className: 'reset-href',
	                target: '_blank',
	                style: { display: _this2.showAssessment(assessmentItem) ? 'inline-block' : 'none' },
	                href: _lodash2.default.get(_this2.props.assessmentUrls, assessmentItem.id),
	                'data-id': 'Assessments link ' + assessmentItem.icon },
	              _this2.renderIcon(assessmentItem.icon),
	              _react2.default.createElement(
	                'span',
	                null,
	                assessmentItem.name
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ApplicantAssessment;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  skills: _react.PropTypes.object.isRequired,
	  assessmentUrls: _react.PropTypes.object,
	  labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ApplicantAssessment;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _status = __webpack_require__(209);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	var _Logo = __webpack_require__(123);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _f_applicantMenu = __webpack_require__(472);
	
	var _f_applicantMenu2 = _interopRequireDefault(_f_applicantMenu);
	
	var _f_copyright = __webpack_require__(211);
	
	var _f_copyright2 = _interopRequireDefault(_f_copyright);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _auth = __webpack_require__(213);
	
	var _viewOrderArr = __webpack_require__(212);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// styling objects
	var welcomeButtonStyle = { width: '296px', height: '45px' };
	
	// redux action creators
	
	
	// view ordering array
	var ApplicantLanding = (_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    firstName: state.user.firstName,
	    nickName: state.user.nickName,
	    profileId: state.user.profileId,
	    userId: state.user.id,
	    profile: state.profile,
	    applicantProfile: state.applicantProfile,
	    workExperience: state.workExperience,
	    tempState: state.tempState,
	    labels: (0, _lodash.get)(state.labels, 'ApplicantLanding', {}),
	    commonLabels: (0, _lodash.get)(state.labels, 'Common', {}),
	    qs: state.applicantProfile.qualifyingspecialist
	  };
	}, {
	  push: _reactRouterRedux.push,
	  logOut: _auth.logOut,
	  getProfileById: asyncActionCreators.getProfileById,
	  updateApplicant: syncActionCreators.updateApplicant,
	  persistApplicantUpdate: asyncActionCreators.persistApplicantUpdate
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ApplicantLanding, _Component);
	
	  function ApplicantLanding() {
	    _classCallCheck(this, ApplicantLanding);
	
	    var _this = _possibleConstructorReturn(this, (ApplicantLanding.__proto__ || Object.getPrototypeOf(ApplicantLanding)).call(this));
	
	    _this.handleLogOut = function () {
	      var website = _this.props.commonLabels.website;
	
	
	      _this.props.logOut().then(function () {
	        window.location = website;
	      });
	    };
	
	    _this.closeWelcome = _this.closeWelcome.bind(_this);
	    _this.isInactive = _this.isInactive.bind(_this);
	    _this.hasProgressedPassedPending = _this.hasProgressedPassedPending.bind(_this);
	    _this.isPendingApplication = _this.isPendingApplication.bind(_this);
	    _this.state = {
	      welcomePage: {}
	    };
	    return _this;
	  }
	
	  _createClass(ApplicantLanding, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      try {
	
	        /**
	          * Check for an inactive status and direct to inactive route...
	          */
	        if (this.isInactive() && !this.props.location.pathname.includes('inactive')) {
	          this.props.push('/applicant/inactive');
	        }
	
	        var welcomePage = this.refreshWelcome();
	
	        this.setState({ welcomePage: welcomePage }, function () {
	
	          if (_lodash2.default.isEmpty(welcomePage)) {
	            _this2.closeWelcome();
	            return null;
	          }
	        });
	      } catch (err) {
	        console.log(err);
	      }
	    }
	  }, {
	    key: 'isInactive',
	    value: function isInactive() {
	      return (0, _status.isInactivePipeline)(this.props.profile.applicantStatus);
	    }
	  }, {
	    key: 'isQSAssigned',
	    value: function isQSAssigned() {
	      return !_lodash2.default.isEmpty(this.props.qs);
	    }
	  }, {
	    key: 'isPendingApplication',
	    value: function isPendingApplication() {
	      return this.props.profile.applicantStatus === 3;
	    }
	  }, {
	    key: 'hasProgressedPassedPending',
	    value: function hasProgressedPassedPending() {
	      return this.props.profile.applicantStatus >= 3;
	    }
	  }, {
	    key: 'hasValidViewStateToSet',
	    value: function hasValidViewStateToSet() {
	      var r = false;
	      if (this.props.hasOwnProperty('applicantProfile')) {
	        if (this.props.applicantProfile.hasOwnProperty('viewState')) {
	          r = true;
	        }
	      }
	      return r;
	    }
	  }, {
	    key: 'updateWelcomeViewState',
	    value: function updateWelcomeViewState() {
	
	      if (this.hasProgressedPassedPending()) {
	        if (this.hasValidViewStateToSet()) {
	          // if component.saveFunc is provided then use that, otherwise use default route hitting actionCreator
	          var newState = _lodash2.default.cloneDeep(this.props.tempState);
	          _lodash2.default.set(newState, 'user.id', this.props.userId);
	          _lodash2.default.set(newState, 'profile.id', this.props.profileId);
	
	          var objPath = 'profile.viewState.progress.applicant.application.Welcome.done';
	          _lodash2.default.set(newState, objPath, true);
	
	          newState.profile.viewState = _lodash2.default.merge({}, this.props.applicantProfile.viewState, newState.profile.viewState);
	
	          // update front end
	          this.props.updateApplicant(newState);
	
	          // update back end
	          this.props.persistApplicantUpdate(newState);
	        }
	      }
	    }
	  }, {
	    key: 'refreshWelcome',
	    value: function refreshWelcome() {
	      var messagesObj = this.props.labels.welcomeMessages.welcome;
	
	      if (this.isInactive()) {
	        // message depends on the qualifying specialist
	        messagesObj = this.props.labels.welcomeMessages.welcomeInactive;
	        if (this.isQSAssigned()) {
	          messagesObj.message = this.props.labels.welcomeMessages.welcomeInactive.qsAssigned;
	        } else {
	          messagesObj.message = this.props.labels.welcomeMessages.welcomeInactive.noQsAssigned;
	        }
	        return messagesObj;
	      } else if (this.isPendingApplication()) {
	        // Only firstTime for "Pending Application" Status
	
	        var profile = _lodash2.default.isEmpty(this.props.applicantProfile) ? this.props.profile : this.props.applicantProfile;
	        var welcomePath = 'viewState.progress.applicant.application.Welcome.done';
	        var submitPath = 'viewState.progress.applicant.application.Submit.done';
	
	        var isWelcomeBack = _lodash2.default.get(profile, welcomePath, false) && !_lodash2.default.get(profile, submitPath, false);
	        var isWelcome = !_lodash2.default.get(profile, welcomePath, false);
	
	        if (isWelcomeBack) messagesObj = this.props.labels.welcomeMessages.welcomeBack;
	        if (!isWelcome && !isWelcomeBack) messagesObj = {};
	
	        return messagesObj;
	      }
	
	      return {};
	    }
	  }, {
	    key: 'closeWelcome',
	    value: function closeWelcome() {
	      // set progress
	      if (!this.props.viewState) {
	        this.updateWelcomeViewState();
	      }
	      this.props.push('/applicant/' + _viewOrderArr.viewOrderArr[0].key + (_viewOrderArr.viewOrderArr[0].subNav ? '/' + _viewOrderArr.viewOrderArr[0].subNav[0].key : ''));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var viewName = this.props.nickName || this.props.firstName;
	      this.refreshWelcome();
	      var welcomePage = this.state.welcomePage;
	
	      // bomb out until status can be determined
	      if (!this.props.profile.applicantStatus) {
	        return _react2.default.createElement('div', { className: 'application-landing clearfix' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'application-landing clearfix' },
	        _react2.default.createElement(_f_applicantMenu2.default, { logOut: this.handleLogOut }),
	        _lodash2.default.isEmpty(this.state.welcomePage) ? null : _react2.default.createElement(
	          'div',
	          { className: 'center-container' },
	          _react2.default.createElement(_Logo2.default, { className: 'logo' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'landing-welcome' },
	            welcomePage.title && welcomePage.title + ', ' + viewName
	          ),
	          _react2.default.createElement('div', { className: 'landing-message', dangerouslySetInnerHTML: { __html: welcomePage.message } }),
	          this.isInactive() && this.isQSAssigned() && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'qs-content' },
	              _react2.default.createElement(
	                'span',
	                { className: 'qs-name' },
	                this.props.qs.firstName,
	                ' ',
	                this.props.qs.lastName
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'qs-type' },
	                'Qualifying Specialist'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'qs-info' },
	              _react2.default.createElement(
	                'span',
	                { style: { whiteSpace: 'nowrap' } },
	                this.props.qs.email
	              )
	            )
	          ),
	          !this.isInactive() && _react2.default.createElement(_c_RaisedButton2.default, {
	            label: 'Start Now',
	            'data-id': 'Start Now',
	            style: welcomeButtonStyle,
	            onClick: this.closeWelcome
	          })
	        ),
	        _react2.default.createElement(_f_copyright2.default, null)
	      );
	    }
	  }]);
	
	  return ApplicantLanding;
	}(_react.Component), _class2.propTypes = {
	  push: _react.PropTypes.func.isRequired,
	  getProfileById: _react.PropTypes.func.isRequired,
	  updateApplicant: _react.PropTypes.func.isRequired,
	  persistApplicantUpdate: _react.PropTypes.func.isRequired,
	  firstName: _react.PropTypes.string.isRequired,
	  profileId: _react.PropTypes.number.isRequired,
	  userId: _react.PropTypes.number.isRequired,
	  nickName: _react.PropTypes.string,
	  profile: _react.PropTypes.object,
	  applicantProfile: _react.PropTypes.object.isRequired,
	  workExperience: _react.PropTypes.object,
	  tempState: _react.PropTypes.object.isRequired,
	  labels: _react.PropTypes.object.isRequired,
	  logOut: _react.PropTypes.func.isRequired,
	  location: _react.PropTypes.object.isRequired,
	  commonLabels: _react.PropTypes.object,
	  qs: _react.PropTypes.object
	}, _class2.need = [function (route, user) {
	  return asyncActionCreators.getProfileById(user.profileId);
	}], _temp)) || _class);
	exports.default = ApplicantLanding;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	// styling objects
	
	// redux action creators
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Logo = __webpack_require__(123);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _fixLines = __webpack_require__(234);
	
	var _fixLines2 = _interopRequireDefault(_fixLines);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyAddress = __webpack_require__(463);
	
	var _prettyAddress2 = _interopRequireDefault(_prettyAddress);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WAHVE_ACCOUNT_HARDCODELINK = 'WAHVE';
	
	var ApplicantResume = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var root = props.location.pathname.split('/')[1];
	  return {
	    profile: state.applicantProfile,
	    user: root === 'admin' ? state.applicantUser : state.user.impersonateUser || state.user,
	    workExperiences: state.workExperiences,
	    skills: state.skills,
	    education: state.education,
	    licenses: state.licenses,
	    designations: state.designations,
	    associations: state.associations,
	    staticData: state.staticData
	  };
	}, {
	  getProfileById: asyncActionCreators.getProfileById
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ApplicantResume, _Component);
	
	  function ApplicantResume() {
	    _classCallCheck(this, ApplicantResume);
	
	    return _possibleConstructorReturn(this, (ApplicantResume.__proto__ || Object.getPrototypeOf(ApplicantResume)).call(this));
	  }
	
	  _createClass(ApplicantResume, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var profileId = this.props.params.profileId || this.props.user.profileId;
	      if (profileId && (_lodash2.default.isEmpty(this.props.profile) || _lodash2.default.isEmpty(this.props.workExperiences))) {
	        this.props.getProfileById(profileId);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var profileId = nextProps.params.profileId || nextProps.user.profileId;
	      if (profileId && _lodash2.default.isEmpty(this.props.profile)) {
	        this.props.getProfileById(profileId);
	      }
	    }
	  }, {
	    key: 'getState',
	    value: function getState(value) {
	      var state = _lodash2.default.find(this.props.staticData.stateList, function (s) {
	        return s.id === value;
	      });
	      return _lodash2.default.get(state, 'name', '');
	    }
	  }, {
	    key: 'getLicenseType',
	    value: function getLicenseType(license) {
	      var _props$staticData$lic = this.props.staticData.licenseTypes,
	          licenseTypes = _props$staticData$lic === undefined ? {} : _props$staticData$lic;
	
	      var type = _lodash2.default.find(licenseTypes, function (s) {
	        return s.id === license.licenseTypeId;
	      });
	      return [_lodash2.default.get(type, 'name'), license.licenseName].filter(function (s) {
	        return !!s;
	      }).reduce(function (name, curr) {
	        return name !== 'Other' ? name : curr;
	      });
	    }
	  }, {
	    key: 'getDates',
	    value: function getDates(value, value2, isCurrent) {
	      var dates = [];
	      if (value) {
	        dates.push((0, _prettyDate.resumeDate)(value));
	      }
	
	      if (isCurrent) {
	        dates.push('Current');
	      } else if (value2) {
	        dates.push((0, _prettyDate.resumeDate)(value2));
	      }
	      return dates.join(' - ');
	    }
	  }, {
	    key: 'getPhoneNumber',
	    value: function getPhoneNumber(value, value2, value3) {
	      if (!_lodash2.default.isEmpty(value)) {
	        return (0, _prettyPhone2.default)(value);
	      }
	      if (!_lodash2.default.isEmpty(value2)) {
	        return (0, _prettyPhone2.default)(value2);
	      }
	      if (!_lodash2.default.isEmpty(value3)) {
	        return (0, _prettyPhone2.default)(value3);
	      }
	    }
	  }, {
	    key: 'getComputerSkills',
	    value: function getComputerSkills() {
	      var skillCategoryTypes = this.props.staticData.skillCategoryTypes;
	      var skills = this.props.skills;
	
	      var computerSkills = skillCategoryTypes.filter(function (type) {
	        return type && type.sub_category === 'Computer';
	      }).map(function (type) {
	        return type.id;
	      }).reduce(function (compSkills, categoryId) {
	        if (skills[categoryId]) {
	          return _lodash2.default.merge(compSkills, skills[categoryId]);
	        }
	        return compSkills;
	      }, {});
	
	      return _lodash2.default.filter(computerSkills, function (skill) {
	        return skill.name !== 'None' && skill.skillLevelName !== 'Beginner';
	      });
	    }
	  }, {
	    key: 'getDegreeName',
	    value: function getDegreeName(item) {
	
	      if (item.degreeName === 'Other') {
	        return item.degreeTypeOther;
	      } else if (item.degreeName === 'None') {
	        return 'No degree';
	      }
	
	      return item.degreeName;
	    }
	  }, {
	    key: 'getAttendedDates',
	    value: function getAttendedDates(item) {
	      var dates = [];
	      if (item.dateAttendedStart) {
	        dates.push((0, _prettyDate.toYear)(item.dateAttendedStart));
	      }
	      if (item.dateAttendedEnd) {
	        dates.push((0, _prettyDate.toYear)(item.dateAttendedEnd));
	      }
	      return dates.join(' - ');
	    }
	  }, {
	    key: 'getEducation',
	    value: function getEducation(item) {
	      var education = [];
	      var degree = this.getDegreeName(item);
	      if (!_lodash2.default.isEmpty(degree)) {
	        education.push(degree);
	      }
	      education.push(item.subjectOrMajor);
	
	      if (!_lodash2.default.isEmpty(item.creditsEarned)) {
	        education.push(item.creditsEarned + ' Credits');
	      }
	      education.push(item.institutionName);
	      education.push(this.getAttendedDates(item));
	      return education.join(', ');
	    }
	  }, {
	    key: 'getAbbreviation',
	    value: function getAbbreviation(value) {
	      var regExp = /\(([^)]+)\)/;
	      var matches = regExp.exec(value);
	      return matches ? matches[1] : value;
	    }
	  }, {
	    key: 'mapObject',
	    value: function mapObject(object, callback) {
	      return Object.keys(object).map(function (key) {
	        return callback(object[key], key);
	      });
	    }
	  }, {
	    key: 'renderComputerSkills',
	    value: function renderComputerSkills() {
	
	      var computerSkills = this.getComputerSkills();
	      if (!_lodash2.default.isEmpty(computerSkills)) {
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'section', 'data-id': 'Computer Skills' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            'Computer Skills'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'computer-skill' },
	            _lodash2.default.map(computerSkills, function (skill) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'item' },
	                skill.name
	              );
	            })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderLicenses',
	    value: function renderLicenses(props) {
	      var _this2 = this;
	
	      var licenses = props.licenses,
	          _props$profile = props.profile,
	          profile = _props$profile === undefined ? {} : _props$profile,
	          _props$staticData = props.staticData,
	          staticData = _props$staticData === undefined ? {} : _props$staticData;
	      var _staticData$applicant = staticData.applicantLicenseStatus,
	          applicantLicenseStatus = _staticData$applicant === undefined ? [] : _staticData$applicant;
	
	      var isLicensed = !!applicantLicenseStatus.filter(function (s) {
	        return s.subElement === 'Licensed';
	      }).find(function (s) {
	        return s.id === profile.licenseStatus;
	      });
	
	      if (_lodash2.default.isEmpty(props.licenses) || !isLicensed) {
	        return;
	      }
	
	      var renderLicenseName = function renderLicenseName(state, type) {
	        return [state, type].filter(function (l) {
	          return !!l;
	        }).join(' - ');
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section', 'data-id': 'Licenses' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          'Licenses'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'licenses' },
	          this.mapObject(licenses, function (license) {
	            return _react2.default.createElement(
	              'li',
	              { className: 'license-item' },
	              renderLicenseName(_this2.getState(license.state), _this2.getLicenseType(license)),
	              ' '
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (_lodash2.default.isEmpty(this.props.profile)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'applicant-resume clearfix' },
	        _react2.default.createElement(_Logo2.default, { className: 'resume-logo' }),
	        !_lodash2.default.isEmpty(this.props.user) && !_lodash2.default.isEmpty(this.props.profile) && _react2.default.createElement(
	          'div',
	          { className: 'center-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'info-container section', 'data-id': 'Contact Info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              _react2.default.createElement(
	                'div',
	                { className: 'name' },
	                this.props.user.firstName,
	                ' ',
	                this.props.user.lastName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'address' },
	                (0, _prettyAddress2.default)(_extends({}, this.props.user, { stateName: this.getState(this.props.user.state) }))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'email' },
	                this.props.user.email
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'phone' },
	                this.getPhoneNumber(this.props.user.phoneNumber1, this.props.user.phoneNumber2, this.props.user.phoneNumber3)
	              )
	            )
	          ),
	          !_lodash2.default.isEmpty(this.props.profile.careerSummary) && _react2.default.createElement(
	            'div',
	            { className: 'career-summary section', 'data-id': 'Career Summary' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              'Career Summary'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              (0, _fixLines2.default)(this.props.profile.careerSummary)
	            )
	          ),
	          !_lodash2.default.isEmpty(this.props.workExperiences) && _react2.default.createElement(
	            'div',
	            { className: 'work-experiences section', 'data-id': 'Work Experiences' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              'Work Experience'
	            ),
	            this.mapObject((0, _lodash2.default)({}).merge(this.props.workExperiences).orderBy(['current', 'employmentEnd', 'employmentStart'], ['desc', 'desc', 'desc']).value(), function (experience) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'sub-section' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'left' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'company' },
	                    experience.employerName
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'job-title' },
	                    experience.title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'right' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'location' },
	                    experience.city,
	                    ', ',
	                    _this3.getState(experience.state)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'date' },
	                    _this3.getDates(experience.employmentStart, experience.employmentEnd, experience.current)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'job-summary' },
	                  (0, _fixLines2.default)(experience.jobSummary)
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'job-responsibilities' },
	                  experience.jobSpecifics.map(function (responsibility) {
	                    return _react2.default.createElement(
	                      'li',
	                      { className: 'responsibility-item' },
	                      responsibility
	                    );
	                  })
	                )
	              );
	            })
	          ),
	          this.renderComputerSkills(),
	          !_lodash2.default.isEmpty(this.props.education) && _react2.default.createElement(
	            'div',
	            { className: 'section', 'data-id': 'Education' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              'Education'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'education' },
	              this.mapObject(this.props.education, function (item) {
	                return _react2.default.createElement(
	                  'li',
	                  { className: 'education-item' },
	                  _this3.getEducation(item)
	                );
	              })
	            )
	          ),
	          this.props.staticData.account.hardcodelink === WAHVE_ACCOUNT_HARDCODELINK && this.renderLicenses(this.props),
	          !_lodash2.default.isEmpty(_lodash2.default.filter(this.props.designations, function (s) {
	            return s.name !== 'None';
	          })) && _react2.default.createElement(
	            'div',
	            { className: 'section', 'data-id': 'Professional Designations' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              'Professional Designations & Certifications'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'designations' },
	              this.mapObject(this.props.designations, function (designation, key) {
	                return _react2.default.createElement(
	                  'li',
	                  { className: 'item' },
	                  key
	                );
	              })
	            )
	          ),
	          !_lodash2.default.isEmpty(_lodash2.default.filter(this.props.associations, function (s) {
	            return s.name !== 'None';
	          })) && _react2.default.createElement(
	            'div',
	            { className: 'section', 'data-id': 'Professional Designations' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              'Professional Associations'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'associations' },
	              this.mapObject(this.props.associations, function (designation, key) {
	                return _react2.default.createElement(
	                  'li',
	                  { className: 'item' },
	                  _this3.getAbbreviation(key)
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ApplicantResume;
	}(_react.Component), _class2.propTypes = {
	  params: _react.PropTypes.func.isRequired,
	  getProfileById: _react.PropTypes.func.isRequired,
	  profile: _react.PropTypes.object,
	  user: _react.PropTypes.object,
	  workExperiences: _react.PropTypes.object,
	  skills: _react.PropTypes.object,
	  education: _react.PropTypes.object,
	  licenses: _react.PropTypes.object,
	  designations: _react.PropTypes.object,
	  staticData: _react.PropTypes.object,
	  location: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ApplicantResume;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ApplicationAssessmentsInstructions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ApplicationAssessmentsInstructions() {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'expanded-accordion-content explanation-of-wahve' },
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'b',
	        null,
	        'Instructions:'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'There are a number of parts to the interview. Each section has a script to guide you through the interview.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'b',
	        null,
	        'Overview:'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'ol',
	        { className: 'instructions-list' },
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Preferences (Availability, Work Objectives, Home Office Setup)'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Assessments'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Work Experience'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Skills'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Background (Licenses, Designations, Medicare & Social Security)'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Behavioral Questions'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Completion of Interview (Status Determination and Interview Conclusion)'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Rating of Applicant'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'Make sure to view your application review notes in each section throughout the interview and add any additional notes. Please be as detailed as possible in your interview notes as they are very important in determining the best match for the applicant.'
	    )
	  );
	}

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BehavioralInterview = (_temp = _class = function (_React$Component) {
	  _inherits(BehavioralInterview, _React$Component);
	
	  function BehavioralInterview() {
	    _classCallCheck(this, BehavioralInterview);
	
	    var _this = _possibleConstructorReturn(this, (BehavioralInterview.__proto__ || Object.getPrototypeOf(BehavioralInterview)).call(this));
	
	    _this.state = { values: {} };
	    return _this;
	  }
	
	  _createClass(BehavioralInterview, [{
	    key: 'onChange',
	    value: function onChange(questionId, event) {
	      var values = _lodash2.default.assign({}, this.state.values, _defineProperty({}, questionId, event.target.value));
	      this.setState({ values: values });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(questionId, event) {
	      if (event.target.value !== _lodash2.default.get(this.props.behavioralAnswers[questionId], 'answer')) {
	        this.props.saveData({ behavioralAnswers: _lodash2.default.set({}, questionId + '.answer', event.target.value) });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue(questionId) {
	      var newLine = /\\n/g;
	      var value = '';
	      if (this.state.values.hasOwnProperty(questionId)) {
	        value = this.state.values[questionId];
	      } else if (this.props.behavioralAnswers[questionId]) {
	        value = _lodash2.default.get(this.props.behavioralAnswers[questionId], 'answer');
	      }
	      return value.replace(newLine, '\n');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // booleans
	      var script = this.props.script;
	      var behavioralQuestions = this.props.staticData.behavioralQuestions;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve',
	          key: 'behavioral-interview ' + this.props.applicant.profile.id },
	        script && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            'I would now like to ask you some questions that will help us get to know you better. The questions only relate to your work experience and not personal.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'data-id': 'Questions', className: 'behavioral-questions' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Questions:'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'instructions-list', style: { paddingBottom: !this.props.script ? '15px' : null } },
	            behavioralQuestions.map(function (listItem, questionKey) {
	              return _react2.default.createElement(
	                'li',
	                {
	                  className: 'instructions-list-item',
	                  key: questionKey
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'instructions-list-text' },
	                  listItem.question
	                ),
	                _react2.default.createElement(_c_TextArea2.default, { 'data-id': listItem.id,
	                  maxLength: 4000,
	                  className: 'instructions-text-field',
	                  value: _this2.getValue(listItem.id),
	                  onBlur: _this2.onBlur.bind(_this2, listItem.id),
	                  onChange: _this2.onChange.bind(_this2, listItem.id),
	                  validator: _this2.props.validator.bind(_this2, listItem),
	                  onErrorChange: _this2.props.errorUpdate,
	                  showCharacterCount: true
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return BehavioralInterview;
	}(_react2.default.Component), _class.propTypes = {
	  staticData: _react.PropTypes.object,
	  applicant: _react.PropTypes.object,
	  behavioralAnswers: _react.PropTypes.object,
	  script: _react.PropTypes.bool,
	  tempState: _react.PropTypes.object,
	  model: _react.PropTypes.string.isRequired,
	  dispatch: _react.PropTypes.func,
	  saveData: _react.PropTypes.func
	}, _temp);
	exports.default = BehavioralInterview;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeterminationOfStatus = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.DeterminationOfStatus', {})
	  };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(DeterminationOfStatus, _Component);
	
	  function DeterminationOfStatus() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeterminationOfStatus);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeterminationOfStatus.__proto__ || Object.getPrototypeOf(DeterminationOfStatus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      openAccordion: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeterminationOfStatus, [{
	    key: 'toggleExpanded',
	    value: function toggleExpanded(newVal) {
	      this.setState({
	        openAccordion: newVal
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var startDate = new Date(this.props.profile.availabilityDate);
	      var now = new Date();
	      var diff = Math.round((startDate - now) / (1000 * 60 * 60 * 24));
	      var tooSoon = diff > 45 && diff < 120;
	      var openAccordion = this.state.openAccordion;
	
	
	      this.state.openAccordion = this.props.labels.subAccordionData[0].header;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'expanded-accordion-content sub-accordion' },
	        this.props.labels.subAccordionData.map(function (datum, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i, className: (0, _classnames2.default)('callout', { 'sub-accordion-item': datum.content.length > 0 }, { expanded: openAccordion === datum.header }) },
	            _react2.default.createElement('div', { 'data-id': datum.header,
	              className: 'sub-accordion-header noTextSelect',
	              onClick: _this2.toggleExpanded.bind(_this2, openAccordion === datum.header ? null : datum.header),
	              dangerouslySetInnerHTML: { __html: datum.header } }),
	            _react2.default.createElement(
	              'ul',
	              { className: (0, _classnames2.default)('text-list', { bullet: datum.content.length > 1 }) },
	              datum.content.map(function (textRow, j) {
	                if (j !== datum.content.length - 1 || !datum.tooSoonItem || tooSoon) {
	                  return _react2.default.createElement(
	                    'li',
	                    { 'data-id': 'Instructions List Item ' + j,
	                      key: j, className: 'accordion-text' },
	                    textRow
	                  );
	                }
	              })
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return DeterminationOfStatus;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object
	}, _temp2)) || _class);
	exports.default = DeterminationOfStatus;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Introduction;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Introduction(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'expanded-accordion-content explanation-of-wahve' },
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'The conversation should begin per below.'
	    ),
	    props.script && _react2.default.createElement(
	      'div',
	      { className: 'speaking-callout' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'instructions-list' },
	        _react2.default.createElement(
	          'li',
	          null,
	          'Thank you for taking the time to complete your application and for taking our assessments.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'I would like to review the application with you as well as spend some time interviewing you.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'This may take a half hour or so. Do you have the time now?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'We will discuss your availability, work objectives and home office setup.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'We will review your work history and professional skills.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'I will then ask you some questions that will help us get to know you.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Please feel free to ask questions at any time.'
	        )
	      )
	    )
	  );
	}
	
	Introduction.propTypes = {
	  script: _react.PropTypes.bool.isRequired
	};

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// components
	
	
	exports.default = MedicareSocialSecurity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _prettyMoney = __webpack_require__(464);
	
	var _prettyMoney2 = _interopRequireDefault(_prettyMoney);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// menuItems for boolean toggle
	var booleanDropDown = [{ value: true, primaryText: 'Yes' }, { value: false, primaryText: 'No' }];
	
	var medicareBoolean = [{
	  value: true,
	  primaryText: 'Yes',
	  subElement: 'onMedicare'
	}, {
	  value: false,
	  primaryText: 'No',
	  subElement: 'notOnMedicare'
	}];
	
	var healthCareBoolean = [{
	  value: true,
	  primaryText: 'Yes',
	  subElement: 'hasHealthCarePlan'
	}, {
	  value: false,
	  primaryText: 'No',
	  subElement: 'doesNotHaveHealthCarePlan'
	}];
	
	var socialSecurityBoolean = [{
	  value: true,
	  primaryText: 'Yes',
	  subElement: 'onSocialSecurity'
	}, {
	  value: false,
	  primaryText: 'No',
	  subElement: null
	}];
	
	function MedicareSocialSecurity(props) {
	  // booleans
	  var script = props.script;
	
	  function handleDropDownMenuUI(prop, staticDataProp, label) {
	    return {
	      defaultValue: props.applicant.profile[prop] || false,
	      menuItems: props.staticData[staticDataProp],
	      floatingLabelText: label,
	      onChange: props.updateTempState.bind(this, props.model, prop)
	    };
	  }
	
	  function formatMoney(event) {
	    event.target.value = (0, _prettyMoney2.default)(event.target.value).substring(0, 10);
	  }
	
	  function saveMoney(parent, prop, event, val) {
	    // Remove non-numeric chars.
	    val = val.replace(/[^0-9\.]/g, '') || 0;
	    props.updateTempState(parent, prop, event, val);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'expanded-accordion-content explanation-of-wahve',
	      key: 'medicare-social-security ' + props.applicant.profile.id },
	    script && _react2.default.createElement(
	      'div',
	      { className: 'script speaking-callout' },
	      'I have just a few more questions. We ask these questions because some are concerned about the earning limitation if they are on social security and we are concerned about health care.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'on-medicare' },
	      _react2.default.createElement(
	        _c_ToggleButton2.default,
	        {
	          defaultValue: props.applicant.profile.onMedicare,
	          menuItems: medicareBoolean,
	          onChange: props.updateTempState.bind(this, props.model, 'onMedicare'),
	          floatingLabelText: 'Are you on Medicare?'
	        },
	        {
	          notOnMedicare: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _c_ToggleButton2.default,
	              {
	                className: 'health-care-plan',
	                defaultValue: props.applicant.profile.hasHealthCarePlan,
	                menuItems: healthCareBoolean,
	                onChange: props.updateTempState.bind(this, props.model, 'hasHealthCarePlan'),
	                floatingLabelText: 'Do you have a health care plan?'
	              },
	              {
	                hasHealthCarePlan: _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _c_DropDownMenu2.default,
	                    _extends({
	                      className: 'health-care-plan-type'
	                    }, handleDropDownMenuUI('healthCarePlanType', 'healthCarePlanTypes', 'What type of health care plan do you have?')),
	                    {
	                      Other: _react2.default.createElement(_c_TextField2.default, {
	                        className: 'health-plan-other',
	                        defaultValue: props.applicant.profile.healthCarePlanOther,
	                        floatingLabelText: 'If other, name the health plan:',
	                        onBlur: props.updateTempState.bind(this, props.model, 'healthCarePlanOther')
	                      })
	                    }
	                  )
	                )
	              }
	            )
	          )
	        }
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'on-early-social-security' },
	      _react2.default.createElement(
	        _c_ToggleButton2.default,
	        {
	          defaultValue: props.applicant.profile.onEarlySocialSecurity,
	          menuItems: socialSecurityBoolean,
	          onChange: props.updateTempState.bind(this, props.model, 'onEarlySocialSecurity'),
	          floatingLabelText: 'Are you on early Social Security?'
	        },
	        {
	          onSocialSecurity: _react2.default.createElement(_c_TextField2.default, {
	            className: 'social-security-earning-limit',
	            defaultValue: (0, _prettyMoney2.default)(props.applicant.profile.socialSecurityEarningLimit),
	            floatingLabelText: 'What is your Social Security earnings limit?',
	            onChange: formatMoney.bind(this),
	            onBlur: saveMoney.bind(this, props.model, 'socialSecurityEarningLimit')
	          })
	        }
	      )
	    )
	  );
	}
	
	MedicareSocialSecurity.propTypes = {
	  staticData: _react.PropTypes.object,
	  applicant: _react.PropTypes.object,
	  script: _react.PropTypes.bool,
	  tempState: _react.PropTypes.object,
	  model: _react.PropTypes.string.isRequired,
	  updateTempState: _react.PropTypes.func
	};

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_RatingStars = __webpack_require__(451);
	
	var _c_RatingStars2 = _interopRequireDefault(_c_RatingStars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ratings = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.Ratings', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Ratings, _Component);
	
	  function Ratings() {
	    _classCallCheck(this, Ratings);
	
	    var _this = _possibleConstructorReturn(this, (Ratings.__proto__ || Object.getPrototypeOf(Ratings)).call(this));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.handleDropDownMenuUI = _this.handleDropDownMenuUI.bind(_this);
	    _this.averageRating = _this.averageRating.bind(_this);
	    return _this;
	  }
	
	  _createClass(Ratings, [{
	    key: 'onChange',
	    value: function onChange(prop, rid) {
	      var _this2 = this;
	
	      return function (event, value) {
	        _this2.props.saveData({ ratings: _lodash2.default.set({}, rid + '.' + prop, value) });
	      };
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(model, prop) {
	      var _this3 = this;
	
	      return function (event, value) {
	        _this3.props.saveData(_lodash2.default.set({}, model + '.' + prop, value));
	      };
	    }
	  }, {
	    key: 'handleDropDownMenuUI',
	    value: function handleDropDownMenuUI(ratingItem, prop, label) {
	      return {
	        defaultValue: _lodash2.default.get(this.props.ratings[ratingItem.id], prop),
	        value: _lodash2.default.get(this.props.ratings[ratingItem.id], prop),
	        floatingLabelText: label,
	        onChange: this.onChange(prop, ratingItem.id),
	        id: 'interview-rating-' + ratingItem.id,
	        disabled: false // Client wants rating regardless status.
	      };
	    }
	  }, {
	    key: 'isInterviewGroup',
	    value: function isInterviewGroup(groupId) {
	      return !_lodash2.default.isNil(this.props.staticData.ratingGroups.find(function (ratingGroup) {
	        return ratingGroup.id === groupId && ['Group One', 'Group Two'].includes(ratingGroup.name);
	      }));
	    }
	  }, {
	    key: 'averageRating',
	    value: function averageRating() {
	      var _this4 = this;
	
	      var overalRatings = _lodash2.default.filter(_lodash2.default.merge({}, this.props.ratings, _lodash2.default.get(this.props.tempState, this.props.model) || {}), function (rating) {
	        return _this4.isInterviewGroup(rating.groupId) || _lodash2.default.isNil(rating.groupId);
	      });
	      var total = _lodash2.default.reduce(overalRatings, function (sum, n) {
	        return sum + parseInt(n.rating, 10);
	      }, 0);
	      var average = total / Object.keys(overalRatings).length;
	      return Math.round(average) || 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var script = this.props.script;
	      var interviewRatingGroups = _lodash2.default.keyBy(this.props.staticData.ratingGroups, 'id');
	      var interviewRatings = this.props.staticData.ratingTypes;
	      var groupedRatings = _lodash2.default.reduce(interviewRatings, function (result, rating) {
	        if (_this5.isInterviewGroup(rating.groupId)) {
	          (result[rating.groupId] || (result[rating.groupId] = [])).push(rating);
	        }
	        return result;
	      }, {});
	
	      // Only enable rating for "Active" and "Not Qualified" applicants.
	      // const ratingDisabled = ([8, 11].indexOf(this.props.applicant.profile.applicantStatus.id) < 0);
	
	      function mapObject(object, callback) {
	        return Object.keys(object).map(function (key) {
	          return callback(object[key], key);
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve',
	          key: 'ratings ' + this.props.applicant.profile.id },
	        _react2.default.createElement(
	          'div',
	          { 'data-id': 'Instructions 1',
	            className: 'callout ratings-instruction',
	            style: { paddingBottom: !script ? 0 : null } },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Instructions:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            this.props.labels.intro
	          )
	        ),
	        mapObject(groupedRatings, function (groupedRating, groupId) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'callout rating-group', 'data-id': _lodash2.default.get(interviewRatingGroups[groupId], 'name') || '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'group-name' },
	              _lodash2.default.get(interviewRatingGroups[groupId], 'name') || ''
	            ),
	            groupedRating.map(function (ratingItem, ratingKey) {
	              return _react2.default.createElement(_c_RatingStars2.default, _extends({
	                className: 'rating-item'
	              }, _this5.handleDropDownMenuUI(ratingItem, 'rating', ratingItem.name)));
	            })
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'final-rating callout', 'data-id': 'Final Rating' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            'Final Rating'
	          ),
	          _react2.default.createElement(_c_RatingStars2.default, {
	            className: 'rating-item',
	            value: this.averageRating(),
	            floatingLabelText: 'Overall Rating',
	            id: 'overal-interview-rating',
	            readOnly: 'true'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'rating-comments callout' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            'Rating Comments'
	          ),
	          _react2.default.createElement(_c_TextArea2.default, {
	            defaultValue: typeof _lodash2.default.get(this.props.tempState, 'profile.ratingComments') === 'string' ? this.props.tempState.profile.ratingComments : this.props.applicant.profile.ratingComments,
	            onBlur: this.onBlur('profile', 'ratingComments'),
	            'data-id': 'rating-comments'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Ratings;
	}(_react.Component), _class2.propTypes = {
	  staticData: _react.PropTypes.object,
	  script: _react.PropTypes.bool,
	  applicant: _react.PropTypes.object,
	  ratings: _react.PropTypes.object,
	  updateTempState: _react.PropTypes.func,
	  model: _react.PropTypes.string.isRequired,
	  tempState: _react.PropTypes.object,
	  labels: _react.PropTypes.object,
	  saveData: _react.PropTypes.func
	}, _temp)) || _class);
	exports.default = Ratings;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StatusDetermination;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dropDownCustomization = {
	  labelStyle: {
	    padding: 0,
	    margin: 0
	  },
	  underlineStyle: {
	    marginLeft: 0
	  },
	  floatingLabelStyle: {
	    left: 0,
	    top: '-3px'
	  },
	  containerStyle: {
	    width: '40%',
	    margin: '30px 0 10px 45px'
	  }
	};
	
	function StatusDetermination() {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'expanded-accordion-content explanation-of-wahve' },
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'During or at the end of the interview, you will need to decide the status of the applicant. Based on that determination, when you click on the appropriate status, a closing script will appear for you to conclude the interview.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'b',
	        null,
	        'Active'
	      ),
	      ' - Applicant Qualified'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'If the applicant scored acceptable or better on assessments, application is complete, and interview was satisfactory, and the applicant is determined to be qualified (an overall rating of 3 or better), select the \u201CActive\u201D status.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'The applicant will receive an email which you can edit and the applicant\u2019s records will be exported to Bullhorn. The applicant\u2019s record is moved to the Standby Applicants pipeline.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'If the applicant\u2019s availability date is between 45 days and 4 months, the record will not export to Bullhorn. Forty-four days prior to the availability date, the record will automatically export.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'Active applicants are placed in the Standby pipeline waiting to be matched to an assignment in Bullhorn.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'b',
	        null,
	        'Not Qualified'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'If the applicant is technically qualified but of low caliber or not qualified at all, do not approve (overall rating 2 or below). If you feel the applicant may have a potential character issue, do not approve. Explain in the notes the reason for your decision. In both instances, change the status to Not Qualified.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'The applicant is not sent an email. The applicant\u2019s record is moved to the Not Qualified Applicants pipeline. Not Qualified applicants are moved to the Inactive pipeline.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'b',
	        null,
	        'Pending information Update'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'If the applicant needs to correct her/his application:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'instructions-list' },
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Change the applicant\u2019s status to Pending Information Update.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'When the applicant updates her/his information, you will receive a notification.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Call the applicant and complete the application review and interview.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'If update acceptable, change the Status to Active.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'b',
	        null,
	        'Applicant in Waiting'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'If the Applicant is Qualified but when reviewing the availability date, the applicant changes it to greater than four months, immediately conclude the interview and:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'instructions-list' },
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Change her/his availability date to the new date.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'Change the applicant status to \u201CApplicant in Waiting.\u201D'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'A script will guide you through the conclusion.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'At the four month mark, the applicant will be invited back to update the application.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'The applicant will be moved to the Standby pipeline. At the four month mark, the applicant will be moved back to the In Progress Pipeline, Pending Application.'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'The applicant will receive an email inviting her/him to update the application and that you will call to discuss the next steps'
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'instructions-list-item' },
	          'You will also receive a notification that the applicant is now available for you to complete the interview process.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'callout' },
	      'It is essential that throughout the interview, you summarize the conversation and add any comments that will give the placement specialist a better understanding of the applicant.'
	    )
	  );
	}
	
	StatusDetermination.propTypes = {
	  staticData: _react.PropTypes.object,
	  script: _react.PropTypes.bool,
	  applicant: _react.PropTypes.object,
	  updateTempState: _react.PropTypes.func,
	  model: _react.PropTypes.string.isRequired,
	  tempState: _react.PropTypes.object
	};

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkObjectives = (_temp = _class = function (_React$Component) {
	  _inherits(WorkObjectives, _React$Component);
	
	  function WorkObjectives(props) {
	    _classCallCheck(this, WorkObjectives);
	
	    var _this = _possibleConstructorReturn(this, (WorkObjectives.__proto__ || Object.getPrototypeOf(WorkObjectives)).call(this, props));
	
	    _this.onBlur = function (prop, qid, event) {
	      _this.props.saveData(_defineProperty({}, _this.props.model, _lodash2.default.set({}, qid + '.' + prop, event.target.value)));
	    };
	
	    _this.handleChange = function (questionId, e) {
	      var values = _lodash2.default.assign({}, _this.state.values);
	      values[questionId] = e.target.value;
	      _this.setState({ values: values });
	    };
	
	    _this.handleTextAreaUI = function (listItem, prop) {
	      var newLine = /\\n/g;
	      var workObjectives = _this.props.workObjectives;
	      var value = _lodash2.default.get(_this.state, 'values[' + listItem.id + ']');
	
	      if (_lodash2.default.isUndefined(value)) {
	        value = _lodash2.default.get(workObjectives[listItem.id], prop, '');
	      }
	
	      return {
	        // needed to replace '\n' with actual newline
	        value: value.replace(newLine, '\n'),
	        onChange: _this.handleChange.bind(_this, listItem.id),
	        onBlur: _this.onBlur.bind(_this, prop, listItem.id),
	        validator: _this.props.validator.bind(_this, listItem),
	        onErrorChange: _this.props.errorUpdate,
	        showCharacterCount: true,
	        maxLength: 4000
	      };
	    };
	
	    _this.state = { values: {} };
	    return _this;
	  }
	
	  _createClass(WorkObjectives, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // booleans
	      var script = this.props.script;
	      var workObjectiveQuestions = this.props.staticData.workObjectiveQuestions;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve',
	          key: 'work-objectives ' + this.props.applicant.profile.id },
	        script && _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          'Now I would like to ask you a few questions about your work objectives.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'data-id': 'Questions', className: 'work-objective-questions' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Questions:'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'instructions-list', style: { paddingBottom: !script ? '15px' : null } },
	            workObjectiveQuestions.map(function (listItem, questionKey) {
	              return _react2.default.createElement(
	                'li',
	                {
	                  className: 'instructions-list-item',
	                  key: questionKey
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'instructions-list-text' },
	                  listItem.question
	                ),
	                _react2.default.createElement(_c_TextArea2.default, _extends({ 'data-id': listItem.id,
	                  className: 'instructions-text-field'
	                }, _this2.handleTextAreaUI(listItem, 'answer')))
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'thanks' },
	          'Great, Thanks. Let\'s move on to your home office setup.'
	        )
	      );
	    }
	  }]);
	
	  return WorkObjectives;
	}(_react2.default.Component), _class.propTypes = {
	  staticData: _react.PropTypes.object,
	  applicant: _react.PropTypes.object,
	  defaultValue: _react.PropTypes.object,
	  workObjectives: _react.PropTypes.object,
	  script: _react.PropTypes.bool,
	  tempState: _react.PropTypes.object,
	  model: _react.PropTypes.string.isRequired,
	  saveData: _react.PropTypes.func,
	  errorUpdate: _react.PropTypes.func,
	  validator: _react.PropTypes.func
	}, _temp);
	exports.default = WorkObjectives;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConclusionOfInterview = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.ConclusionOfInterview', {})
	  };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(ConclusionOfInterview, _Component);
	
	  function ConclusionOfInterview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConclusionOfInterview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConclusionOfInterview.__proto__ || Object.getPrototypeOf(ConclusionOfInterview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      openAccordion: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConclusionOfInterview, [{
	    key: 'toggleExpanded',
	    value: function toggleExpanded(newVal) {
	      this.setState({
	        openAccordion: newVal
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var openAccordion = this.state.openAccordion;
	
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'expanded-accordion-content sub-accordion' },
	        this.props.labels.subAccordionData && this.props.labels.subAccordionData.map(function (datum, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i, className: (0, _classnames2.default)('sub-accordion-item', { expanded: openAccordion === datum.header }) },
	            _react2.default.createElement(
	              'div',
	              { 'data-id': datum.header,
	                className: 'sub-accordion-header noTextSelect',
	                onClick: _this2.toggleExpanded.bind(_this2, openAccordion === datum.header ? null : datum.header) },
	              datum.header
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: (0, _classnames2.default)('text-list', { bullet: datum.content.length > 1 }) },
	              datum.content.map(function (textRow, j) {
	                return _react2.default.createElement(
	                  'li',
	                  { 'data-id': 'Instructions List Item ' + j,
	                    key: j, className: 'accordion-text' },
	                  textRow
	                );
	              })
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return ConclusionOfInterview;
	}(_react.Component), _class2.propTypes = {
	  labels: _react.PropTypes.object
	}, _temp2)) || _class);
	exports.default = ConclusionOfInterview;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _prettyMoney = __webpack_require__(464);
	
	var _prettyMoney2 = _interopRequireDefault(_prettyMoney);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hourlyRateAcceptableMenuItems = [{
	  value: 'true',
	  primaryText: 'Yes',
	  subElement: 'hourlyRateAcceptable'
	}, {
	  value: 'false',
	  primaryText: 'No',
	  subElement: 'hourlyRateAcceptable'
	}];
	
	var hasWorkedRemotelyMenuItems = [{ value: true, primaryText: 'Yes' }, { value: false, primaryText: 'No' }];
	
	var textFieldStyle = {
	  margin: '-8px 0 2px',
	  width: '100%',
	  height: '100px',
	  minHeight: '100px',
	  lineHeight: '1.63'
	};
	
	var dropDownCustomization = {
	  labelStyle: {
	    padding: 0,
	    margin: 0
	  },
	  underlineStyle: {
	    marginLeft: 0
	  },
	  containerStyle: {
	    width: '25%'
	  }
	};
	
	var ExplanationOfWahve = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.ExplanationOfWahve', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ExplanationOfWahve, _Component);
	
	  function ExplanationOfWahve() {
	    _classCallCheck(this, ExplanationOfWahve);
	
	    var _this = _possibleConstructorReturn(this, (ExplanationOfWahve.__proto__ || Object.getPrototypeOf(ExplanationOfWahve)).call(this));
	
	    _this.getValue = function (propertyName) {
	
	      var profile = _lodash2.default.get(_this.props.applicant, 'profile');
	      var value = _lodash2.default.get(_this.state.values, propertyName, profile[propertyName]);
	
	      return value;
	    };
	
	    _this.handleTextArea = function (propertyName, text) {
	
	      var value = _this.getValue(propertyName);
	
	      return {
	        'data-id': propertyName,
	        text: text,
	        value: value,
	        onChange: _this.onChange.bind(_this, propertyName),
	        onBlur: _this.onBlur.bind(_this, propertyName)
	      };
	    };
	
	    _this.handleTextField = function (propertyName, text) {
	
	      var value = _this.getValue(propertyName);
	
	      return {
	        dataId: propertyName,
	        text: text,
	        value: value,
	        onChange: _this.onChange.bind(_this, propertyName),
	        onBlur: _this.onBlur.bind(_this, propertyName)
	      };
	    };
	
	    _this.handleDropdown = function (propertyName, text, menuItems) {
	
	      var value = _this.getValue(propertyName);
	
	      return {
	        'data-id': propertyName,
	        value: value,
	        text: text,
	        menuItems: menuItems,
	        onChange: _this.onBlur.bind(_this, propertyName)
	      };
	    };
	
	    _this.state = { values: {} };
	    return _this;
	  }
	
	  _createClass(ExplanationOfWahve, [{
	    key: 'onChange',
	    value: function onChange(property, event, value, name) {
	
	      if (property === 'hourlyRateAcceptable') {
	        event.target.value = (0, _prettyMoney2.default)(event.target.value).substring(0, 3);
	      }
	
	      value = name ? { id: value, name: name } : value;
	      var values = _lodash2.default.assign({}, this.state.values, _defineProperty({}, property, value));
	      this.setState({ values: values });
	    }
	
	    // handles tempState updates
	
	  }, {
	    key: 'onBlur',
	    value: function onBlur(property, event, value, name) {
	      var _this2 = this;
	
	      // handle dropdown
	
	      if (property === 'desiredHourlyRate') {
	        value = value.replace(/[^0-9\.]/g, '') || 0;
	      } else {
	        value = !_lodash2.default.isBoolean(value) && _lodash2.default.isEmpty(value) ? ' ' : value;
	      }
	
	      value = name ? { id: value, name: name } : value;
	      var values = _lodash2.default.assign({}, this.state.values, _defineProperty({}, property, value));
	      this.setState({ values: values }, function () {
	        _this2.props.saveData(_lodash2.default.set({}, _this2.props.model + '.' + property, value));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          script = _props.script,
	          applicant = _props.applicant;
	      var values = this.state.values;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content explanation-of-wahve',
	          key: 'explanation-of-wahve ' + applicant.profile.id },
	
	        // hide text when script disabled
	        script && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            'Now I\'d like to tell you about WAHVE'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'instructions-list' },
	            this.props.labels.explanationSection.map(function (listItemText, headerKey) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'instructions-list-item', key: headerKey },
	                listItemText
	              );
	            }),
	            _react2.default.createElement(
	              'li',
	              { className: 'instructions-list-item' },
	              'Please refer to the ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://wahve-my.sharepoint.com/personal/chrissy_tadlock_wahve_com/_layouts/OneNote.aspx?id=%2fpersonal%2fchrissy_tadlock_wahve_com%2fDocuments%2fNotebooks%2fWAHVE+Procedures&wd=target(Placement.one%7c328AEB29-9DF9-4884-B5BB-ABE8E73F1FB8%2fPay%5c%2fBill+Rates%7c1C47DFAF-88A1-4E9A-8FA1-395A45066239%2f)&xsdata=MDV8MDJ8YWRhbS5zdGllcmxlQHdhaHZlLmNvbXwwODkyOTU1YzgxODI0Y2I2OTRlZTA4ZGNhMmIwMTA5Znw1YTUyNDlhY2MzN2U0NTZjOTAzNjQ4NDc0Y2YxNzZjOHwwfDB8NjM4NTY0MTI0Mjc5MzYwNTAwfFVua25vd258VFdGcGJHWnNiM2Q4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazFoYVd3aUxDSlhWQ0k2TW4wPXwwfHx8&sdata=MlFDYVlSNVNReTFncFVkWWN6Q3AvMzl5WFEwdkJyUms0NjJaME15K0tkOD0%3d' },
	                'pay rates'
	              ),
	              ' for more information.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'instructions-list', style: { paddingBottom: !script ? '15px' : null } },
	          _react2.default.createElement(DropdownItem, this.handleDropdown('hourlyRateAcceptable', 'Is the hourly rate range acceptable?', hourlyRateAcceptableMenuItems)),
	          _react2.default.createElement(TextFieldItem, _extends({
	            defaultValue: (0, _prettyMoney2.default)(applicant.profile.desiredHourlyRate),
	            className: 'desired-hourly-rate'
	          }, this.handleTextField('desiredHourlyRate', 'What would be your minimum desired hourly pay rate?'))),
	          script && _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            this.props.labels.speakingCallout
	          ),
	          _react2.default.createElement(TextAreaItem, this.handleTextArea('mostRecentWork', 'Tell me about your work at you most recent/current job.')),
	          _react2.default.createElement(TextAreaItem, this.handleTextArea('mostRecentWorkFirmType', 'Briefly describe for me the firm/company you are/were working for, for example, the size of the company, # of employees, # of offices, your department, the culture, etc.')),
	          _react2.default.createElement(TextAreaItem, this.handleTextArea('mostRecentWorkDuration', 'How long have you been doing this type of work?')),
	          _react2.default.createElement(TextAreaItem, this.handleTextArea('previousTypeOfWork', 'Okay, that\'s great. What type of work did you do before that?')),
	          _react2.default.createElement(DropdownItem, this.handleDropdown('hasWorkedRemotely', 'Have you ever had the opportunity to work remotely?', hasWorkedRemotelyMenuItems)),
	          (this.getValue('hasWorkedRemotely') === true || this.getValue('hasWorkedRemotely') && this.getValue('hasWorkedRemotely').id === true) && _react2.default.createElement(TextAreaItem, this.handleTextArea('hasWorkedRemotelyComment', 'Please tell me about it.')),
	          (this.getValue('hasWorkedRemotely') === false || this.getValue('hasWorkedRemotely') && this.getValue('hasWorkedRemotely').id === false) && _react2.default.createElement(TextAreaItem, this.handleTextArea('hasWorkedRemotelyComment', 'How do you feel about working from home?'))
	        ),
	        script && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            'Do you have any questions that I might not have addressed?'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExplanationOfWahve;
	}(_react.Component), _class2.propTypes = {
	  applicant: _react.PropTypes.object,
	  saveData: _react.PropTypes.func,
	  model: _react.PropTypes.string.isRequired,
	  script: _react.PropTypes.bool,
	  labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ExplanationOfWahve;
	
	
	function TextAreaItem(props) {
	  var text = props.text,
	      otherProps = _objectWithoutProperties(props, ['text']);
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'instructions-list-item' },
	    _react2.default.createElement(
	      'div',
	      { className: 'instructions-list-text' },
	      text
	    ),
	    _react2.default.createElement(_c_TextArea2.default, _extends({ className: 'instructions-text-field', style: textFieldStyle }, otherProps))
	  );
	}
	
	function TextFieldItem(props) {
	  var text = props.text,
	      otherProps = _objectWithoutProperties(props, ['text']);
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'instructions-list-item' },
	    _react2.default.createElement(
	      'div',
	      { className: 'instructions-list-text' },
	      text
	    ),
	    _react2.default.createElement(_c_TextField2.default, _extends({ className: 'instructions-text-field', style: textFieldStyle }, otherProps))
	  );
	}
	
	function DropdownItem(props) {
	  var text = props.text,
	      otherProps = _objectWithoutProperties(props, ['text']);
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'instructions-list-item' },
	    _react2.default.createElement(
	      'div',
	      { className: 'instructions-list-text' },
	      text
	    ),
	    _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'instructions-dropdown' }, dropDownCustomization, otherProps))
	  );
	}

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _c_CheckList = __webpack_require__(68);
	
	var _c_CheckList2 = _interopRequireDefault(_c_CheckList);
	
	var _staticData = __webpack_require__(170);
	
	var _SegmentsPositionsDepartments = __webpack_require__(300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropDownCustomization = {
	  labelStyle: {
	    padding: 0,
	    margin: 0,
	    maxWidth: '90%'
	  },
	  underlineStyle: {
	    marginLeft: 0
	  },
	  containerStyle: {
	    width: 'calc(50% - 35px)',
	    margin: '30px 0 10px 45px'
	  },
	  floatingLabelStyle: {
	    left: 0,
	    top: '-10px'
	  }
	};
	
	var secondDropDown = _lodash2.default.merge({}, dropDownCustomization, {
	  containerStyle: {
	    margin: '30px 0 10px 10px'
	  }
	});
	
	// eslint-disable-next-line no-unused-vars
	var textFieldStyle = {
	  margin: '-8px 0 2px',
	  width: '100%'
	};
	
	var PrelimInterview = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.PrelimInterview', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PrelimInterview, _Component);
	
	  function PrelimInterview(props) {
	    _classCallCheck(this, PrelimInterview);
	
	    var _this = _possibleConstructorReturn(this, (PrelimInterview.__proto__ || Object.getPrototypeOf(PrelimInterview)).call(this, props));
	
	    _this.state = {
	      currentJobTitle: ''
	    };
	    _this.yearsExperienceList = _lodash2.default.times(35, function (i) {
	      return i + 1;
	    });
	    return _this;
	  }
	
	  _createClass(PrelimInterview, [{
	    key: 'handleChangeIndustry',
	    value: function handleChangeIndustry() {
	      var _this2 = this;
	
	      return function (event, value) {
	        return _this2.props.updateTempState(_this2.props.model, 'industryTypes', event, value);
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var currentWorkFromHomeReasons = _lodash2.default.get(this.props.tempState, 'profile.workFromHomeReasons') || this.props.applicant.profile.workFromHomeReasons;
	      var otherId = (this.props.staticData.applicantWorkFromHomeReasonsList.find(function (t) {
	        return t.name === 'Other, Please Specify';
	      }) || {}).id;
	      var showOther = (currentWorkFromHomeReasons || []).includes(otherId);
	      var script = this.props.script;
	      var isEmployed = this.props.applicant.profile.employmentStatus.name === 'Phasing into Retirement' || this.props.applicant.profile.employmentStatus.name === 'Employed';
	      var isFullTime = (_lodash2.default.get(this.props.tempState, 'profile.currentWorkStatus.id') || this.props.applicant.profile.currentWorkStatus) === 1;
	      var foundUsVia = (0, _staticData.referralsByRole)(this.props.staticData.foundUsViaList);
	
	      var workedLastIndustryList = [{ value: '5 or less years ago', primaryText: 'Yes' }, { value: 'More than 5 years ago', primaryText: 'No' }];
	
	      var totalYearsExperienceList = this.props.staticData.applicantTotalYearsExperience.map(function (i) {
	        return i.text;
	      });
	      var selectedIndustries = _lodash2.default.get(this.props.tempState, 'profile.industryTypes') || _lodash2.default.get(this.props, 'applicant.profile.industries').map(function (x) {
	        return x.id;
	      }) || [];
	      var otherIndustryTypeId = (0, _lodash.get)((0, _lodash.find)(this.props.staticData.industryTypesList, { subElement: 'Other' }), 'id');
	      var showOtherIndustry = selectedIndustries.includes(otherIndustryTypeId);
	
	      // handles tempState updates
	      function onChange(property, event, value, name) {
	        if (property === 'totalYearsExperienceNumeric' || property === 'industryYearsExperienceNumeric') {
	          if (!value) {
	            if (event.target.value !== value) {
	              value = event.target.value;
	            }
	          }
	        }
	
	        if (showOther && property === 'workFromHomeReason' && value !== otherId) {
	          this.props.updateTempState(this.props.model, 'workFromHomeReasonOther', event, '');
	        }
	
	        if (showOtherIndustry && property === 'insuranceTypeOther' && value !== otherIndustryTypeId) {
	          this.props.updateTempState(this.props.model, 'insuranceTypeOther', event, '');
	        }
	
	        // handle dropdown not check list
	        if (!_lodash2.default.isArray(value) && name) {
	          value = {
	            id: value,
	            name: name
	          };
	        }
	
	        if (this.props.applicant.profile[property] !== value) {
	          // add to tempstate
	          this.props.updateTempState(this.props.model, property, event, value);
	        } else if ((0, _lodash2.default)(this.props.tempState).omit(property).size()) {
	          // remove from tempState if there remains properties on tempState without it
	          this.props.updateTempState(this.props.model, property, event, value);
	        } else {
	          // wipe tempstate if this was only property
	          this.props.updateTempState(null, null, null, null);
	        }
	      }
	
	      var _getSegmentsPositions = (0, _SegmentsPositionsDepartments.getSegmentsPositionsDepartments)(this.props),
	          segments = _getSegmentsPositions.segments,
	          positions = _getSegmentsPositions.positions,
	          departments = _getSegmentsPositions.departments;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content prelim-interview',
	          key: 'prelim-interview ' + this.props.applicant.profile.id },
	        script && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            this.props.labels.speakingCallout
	          )
	        ),
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'Employment status',
	          'data-id': 'employmentStatus',
	          className: 'employment-status-dropdown',
	          value: this.props.applicant.profile.employmentStatus.id,
	          menuItems: this.props.staticData.employmentStatusList,
	          onChange: onChange.bind(this, 'employmentStatus')
	        }, dropDownCustomization)),
	        isEmployed && _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'Are you working full-time or part time now?',
	          'data-id': 'currentWorkStatus',
	          className: 'work-status-dropdown',
	          value: this.props.applicant.profile.currentWorkStatus,
	          menuItems: this.props.staticData.currentEmploymentStatusList,
	          onChange: onChange.bind(this, 'currentWorkStatus')
	        }, secondDropDown)),
	        isFullTime && script && _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          'If working full-time, explain: All our jobs require that you are available during regular working hours for at least part of the time. You cannot work full-time and also work for WAHVE.'
	        ),
	        _react2.default.createElement(_DateInput2.default, { 'data-id': 'availabilityDate',
	          className: 'availability-date dropdown-wrapper',
	          floatingLabelText: 'Date available to start work',
	          container: 'block',
	          autoOk: true,
	          minDate: new Date(),
	          defaultValue: _lodash2.default.get(this.props.tempState, 'profile.availabilityDate', null) ? this.props.tempState.profile.availabilityDate : this.props.applicant.profile.availabilityDate,
	          value: _lodash2.default.get(this.props.tempState, 'profile.availabilityDate', null) ? this.props.tempState.profile.availabilityDate : this.props.applicant.profile.availabilityDate,
	          onChange: onChange.bind(this, 'availabilityDate')
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: this.props.labels.totalYearsExperience,
	            'data-id': 'totalYearsExperience',
	            className: 'industry-drop-down',
	            value: _lodash2.default.get(this.props.tempState, 'profile.totalYearsExperienceNumeric', null) ? this.props.tempState.profile.totalYearsExperienceNumeric : this.props.applicant.profile.totalYearsExperienceNumeric,
	            menuItems: this.yearsExperienceList,
	            onChange: onChange.bind(this, 'totalYearsExperienceNumeric')
	          }, dropDownCustomization)),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: this.props.labels.industryYearsExperience,
	            'data-id': 'industryYearsExperience',
	            className: 'industry-drop-down',
	            value: _lodash2.default.get(this.props.tempState, 'profile.industryYearsExperienceNumeric', null) ? this.props.tempState.profile.industryYearsExperienceNumeric : this.props.applicant.profile.industryYearsExperienceNumeric,
	            menuItems: this.yearsExperienceList,
	            onChange: onChange.bind(this, 'industryYearsExperienceNumeric')
	          }, secondDropDown)),
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: this.props.labels.workedLastInIndustryYesNo,
	            'data-id': 'workedLastInIndustry',
	            className: 'industry-drop-down',
	            value: this.props.applicant.profile.workedLastInIndustry,
	            menuItems: workedLastIndustryList,
	            onChange: onChange.bind(this, 'workedLastInIndustry')
	          }, dropDownCustomization)),
	          _react2.default.createElement(_c_CheckList2.default, {
	            className: 'industry-drop-down',
	            floatingLabelText: this.props.labels.industries,
	            menuItems: this.props.staticData.industryTypesList,
	            defaultValue: selectedIndustries,
	            onBlur: this.handleChangeIndustry()
	          }),
	          showOtherIndustry && _react2.default.createElement(_c_TextField2.default, {
	            'data-id': 'insuranceTypeOther',
	            className: 'work-from-home-reasons',
	            style: { marginLeft: '100px' },
	            defaultValue: this.state.insuranceTypeOther || this.props.applicant.profile.insuranceTypeOther,
	            onChange: function onChange(event, val) {
	              _this3.setState({ insuranceTypeOther: val });
	            },
	            onBlur: onChange.bind(this, 'insuranceTypeOther'),
	            floatingLabelText: 'Please Specify Other Firm Type' })
	        ),
	        this.props.staticData.account.hardcodelink !== 'WAHVE' && _react2.default.createElement(_c_TextField2.default, {
	          defaultValue: _lodash2.default.get(this.state, 'currentJobTitle') || this.props.applicant.profile.currentJobTitle,
	          floatingLabelText: this.props.labels.currentJobTitle,
	          className: 'current-job-title',
	          'data-id': this.props.labels.currentJobTitle,
	          style: _lodash2.default.merge({}, textFieldStyle, { padding: '20px 28px 20px 45px' }),
	          onChange: function onChange(event, val) {
	            _this3.setState({ currentJobTitle: val });
	          },
	          onBlur: onChange.bind(this, 'currentJobTitle', event, this.state.currentJobTitle, null)
	        }),
	        this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	          floatingLabelText: this.props.labels.mostRecentSegment,
	          style: { width: 350 },
	          'data-id': 'mostRecentSegment',
	          value: this.props.applicant.profile.mostRecentSegment,
	          menuItems: segments,
	          onChange: onChange.bind(this, 'mostRecentSegment')
	        }, dropDownCustomization)),
	        this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	          floatingLabelText: this.props.labels.mostRecentDepartment,
	          style: { width: 350 },
	          'data-id': 'mostRecentDepartment',
	          value: this.props.applicant.profile.mostRecentDepartment,
	          menuItems: departments,
	          onChange: onChange.bind(this, 'mostRecentDepartment')
	        }, secondDropDown)),
	        this.props.staticData.account.hardcodelink === 'WAHVE' && _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	          floatingLabelText: this.props.labels.mostRecentPosition,
	          style: { width: 350 },
	          'data-id': 'mostRecentPosition',
	          value: this.props.applicant.profile.mostRecentPosition,
	          menuItems: positions,
	          onChange: onChange.bind(this, 'mostRecentPosition')
	        }, dropDownCustomization)),
	        _react2.default.createElement(
	          _c_DropDownMenu2.default,
	          _extends({ floatingLabelText: this.props.labels.foundUsVia,
	            'data-id': 'foundUsVia',
	            value: this.props.applicant.profile.foundUsVia.id,
	            menuItems: foundUsVia,
	            onChange: onChange.bind(this, 'foundUsVia')
	          }, dropDownCustomization),
	          {
	            Other: _react2.default.createElement(_c_TextField2.default, { floatingLabelText: 'Please Specify',
	              'data-id': 'foundUsOther',
	              defaultValue: typeof this.props.tempState.foundUsOther === 'string' ? this.props.tempState.foundUsOther : this.props.applicant.profile.foundUsOther,
	              onBlur: onChange.bind(this, 'foundUsOther')
	            })
	          }
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'callout' },
	          _react2.default.createElement(
	            'b',
	            null,
	            'Instructions:'
	          ),
	          '  If the applicant did not enter accurate information and does not meet the requirements, you may need to disqualify the applicant at this point.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          'Reasons would like to work from home.'
	        ),
	        _react2.default.createElement(_c_CheckList2.default, { className: 'work-from-home-reasons',
	          key: this.props.applicant.profile.id + ' workFromHomeReasons',
	          'data-id': 'workFromHomeReasons',
	          defaultValue: currentWorkFromHomeReasons,
	          onBlur: onChange.bind(this, 'workFromHomeReasons'),
	          menuItems: this.props.staticData.applicantWorkFromHomeReasonsList }),
	        showOther && _react2.default.createElement(_c_TextArea2.default, { floatingLabelText: 'Please Specify',
	          key: this.props.applicant.profile.id + ' Work From Home Reason Other',
	          'data-id': 'workFromHomeReasonOther',
	          defaultValue: typeof this.props.tempState.workFromHomeReasonOther === 'string' ? this.props.tempState.workFromHomeReasonOther : this.props.applicant.profile.workFromHomeReasonOther,
	          onBlur: onChange.bind(this, 'workFromHomeReasonOther'),
	          rootStyle: {
	            margin: '-9px 42px 9.5px',
	            width: 'calc(50% - 35px)'
	          } })
	      );
	    }
	  }]);
	
	  return PrelimInterview;
	}(_react.Component), _class2.propTypes = {
	  staticData: _react.PropTypes.object,
	  applicant: _react.PropTypes.object,
	  script: _react.PropTypes.bool,
	  tempState: _react.PropTypes.object,
	  model: _react.PropTypes.string.isRequired,
	  updateTempState: _react.PropTypes.func,
	  labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = PrelimInterview;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint-disable no-unused-vars */
	
	
	// utilities
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyDate2 = _interopRequireDefault(_prettyDate);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _materialUi = __webpack_require__(277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dropDownCustomization = {
	  labelStyle: {
	    padding: 0,
	    margin: 0,
	    maxWidth: '90%'
	  },
	  underlineStyle: {
	    marginLeft: 0
	  },
	  containerStyle: {
	    width: 'calc(50% - 35px)',
	    margin: '30px 0 10px 45px'
	  },
	  floatingLabelStyle: {
	    left: 0,
	    top: '-10px'
	  }
	};
	
	var secondDropDown = _lodash2.default.merge({}, dropDownCustomization, {
	  containerStyle: {
	    margin: '30px 0 10px 10px'
	  }
	});
	var noMargin = {
	  containerStyle: {
	    margin: '30px 0 10px 0px'
	  }
	};
	
	var textFieldStyle = {
	  margin: '-8px 0 2px',
	  width: '100%',
	  minHeight: '100px',
	  lineHeight: '1.63'
	};
	
	var secondTextField = {
	  width: 'calc(50% - 35px)',
	  margin: '-8px 0 8.5px',
	  display: 'inline-block',
	  verticalAlign: 'text-bottom'
	};
	var questionSection = [{
	  type: 'DropDown',
	  text: 'Hourly rate range acceptable',
	  options: [{ value: 'true', primaryText: 'Yes' }, { value: 'false', primaryText: 'No' }],
	  propertyName: 'hourlyRateAcceptable'
	}, {
	  type: 'TextField',
	  text: 'What would be your minimum desired hourly pay rate?',
	  propertyName: 'desiredHourlyRate'
	}, {
	  type: 'TextArea',
	  text: 'Tell me about your work at you most recent/current job.',
	  propertyName: 'mostRecentWork'
	}, {
	  type: 'TextArea',
	  text: 'Briefly describe for me the firm/company you are/were working for, for example, the size of the company, # of employees, # of offices, your department, the culture, etc.',
	  propertyName: 'mostRecentWorkFirmType'
	}, {
	  type: 'TextArea',
	  text: 'How long have you been doing this type of work?',
	  propertyName: 'mostRecentWorkDuration'
	}, {
	  type: 'TextArea',
	  text: "Okay, that's great. What type of work did you do before that?",
	  propertyName: 'previousTypeOfWork'
	}, {
	  type: 'DropDown',
	  text: 'Have you ever had the opportunity to work remotely?',
	  options: [{ value: true, primaryText: 'Yes' }, { value: false, primaryText: 'No' }],
	  propertyName: 'hasWorkedRemotely'
	}, {
	  type: 'TextArea',
	  text: 'Please tell me about it.',
	  text1: 'How do you feel about working from home?',
	  propertyName: 'hasWorkedRemotelyComment'
	}];
	
	function genFakeDropdown(str) {
	  return {
	    value: str,
	    menuItems: [str],
	    disabled: true
	  };
	}
	
	var PreliminaryProfile = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    labels: (0, _lodash.get)(store, 'labels.PreliminaryProfile', {})
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PreliminaryProfile, _Component);
	
	  function PreliminaryProfile() {
	    _classCallCheck(this, PreliminaryProfile);
	
	    return _possibleConstructorReturn(this, (PreliminaryProfile.__proto__ || Object.getPrototypeOf(PreliminaryProfile)).apply(this, arguments));
	  }
	
	  _createClass(PreliminaryProfile, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var currentWorkFromHomeReason = this.props.tempState.workFromHomeReason || this.props.applicant.profile.workFromHomeReason;
	      var otherId = this.props.staticData.applicantWorkFromHomeReasonsList[this.props.staticData.applicantWorkFromHomeReasonsList.length - 1].id;
	      var showOther = currentWorkFromHomeReason && currentWorkFromHomeReason === otherId;
	
	      // booleans
	      var script = this.props.script;
	      var isEmployed = this.props.applicant.profile.employmentStatus.name === 'Phasing into Retirement' || this.props.applicant.profile.employmentStatus.name === 'Employed';
	      var isFullTime = (_lodash2.default.get(this.props.tempState, 'profile.currentWorkStatus.id') || this.props.applicant.profile.currentWorkStatus) === 1;
	
	      // handles tempState updates
	      function onChange(property, event, value, name) {
	
	        value = !_lodash2.default.isBoolean(value) && !_lodash2.default.isNumber(value) && _lodash2.default.isEmpty(value) ? ' ' : value;
	
	        if (showOther && property === 'workFromHomeReason' && value !== otherId) {
	          this.props.updateTempState(this.props.model, 'workFromHomeReasonOther', event, ' ');
	        }
	
	        // handle dropdown
	        if (name) {
	          value = {
	            id: value,
	            name: name
	          };
	        }
	
	        if (this.props.applicant.profile[property] !== value) {
	          // add to tempstate
	          this.props.updateTempState(this.props.model, property, event, value);
	        } else if ((0, _lodash2.default)(this.props.tempState).omit(property).size()) {
	          // remove from tempState if there remains properties on tempState without it
	          this.props.updateTempState(this.props.model, property, event, value);
	        } else {
	          // wipe tempstate if this was only property
	          this.props.updateTempState(null, null, null, null);
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-accordion-content prelim-interview',
	          key: 'prelim-profile ' + this.props.applicant.profile.id },
	        script && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'speaking-callout' },
	            this.props.labels.speakingCallout
	          )
	        ),
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'Employment status',
	          className: 'employment-status-dropdown',
	          value: this.props.applicant.profile.employmentStatus.id,
	          menuItems: this.props.staticData.employmentStatusList,
	          onChange: onChange.bind(this, 'employmentStatus')
	        }, dropDownCustomization)),
	        isEmployed && _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'Are you working full-time or part time now?',
	          className: 'work-status-dropdown',
	          value: this.props.applicant.profile.currentWorkStatus,
	          menuItems: this.props.staticData.currentEmploymentStatusList,
	          onChange: onChange.bind(this, 'currentWorkStatus')
	        }, secondDropDown)),
	        isFullTime && script && _react2.default.createElement(
	          'div',
	          { className: 'speaking-callout' },
	          'If working full-time, explain: All our jobs require that you are available during regular working hours for at least part of the time. You cannot work full-time and also work for WAHVE.'
	        ),
	        _react2.default.createElement(_DateInput2.default, { 'data-id': 'date available to begin',
	          className: 'availability-date dropdown-wrapper',
	          floatingLabelText: 'Date available to start work',
	          container: 'block',
	          minDate: new Date(),
	          autoOk: true,
	          defaultValue: _lodash2.default.get(this.props.tempState, 'profile.availabilityDate', null) ? this.props.tempState.profile.availabilityDate : this.props.applicant.profile.availabilityDate,
	          value: _lodash2.default.get(this.props.tempState, 'profile.availabilityDate', null) ? this.props.tempState.profile.availabilityDate : this.props.applicant.profile.availabilityDate,
	          onChange: onChange.bind(this, 'availabilityDate')
	        }),
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: this.props.labels.totalYearsExperience,
	          className: 'total-years-dropdown'
	        }, genFakeDropdown(this.props.applicant.profile.totalYearsExperienceNumeric || this.props.applicant.profile.totalYearsExperience), dropDownCustomization)),
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: this.props.labels.industryYearsExperience,
	          className: 'total-years-insurance-dropdown'
	        }, genFakeDropdown(this.props.applicant.profile.industryYearsExperienceNumeric || this.props.applicant.profile.industryYearsExperience), secondDropDown)),
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: this.props.labels.workedLastInIndustryYesNo,
	          className: 'last-in-insurance-dropdown'
	        }, genFakeDropdown(this.props.applicant.profile.workedLastInIndustry === 'More than 5 years ago' ? 'No' : 'Yes'), dropDownCustomization)),
	        _react2.default.createElement(
	          _c_DropDownMenu2.default,
	          _extends({ floatingLabelText: this.props.labels.foundUsVia,
	            canAutoPosition: 'true',
	            className: 'found-us-via admin',
	            value: this.props.applicant.profile.foundUsVia.id,
	            menuItems: this.props.staticData.foundUsViaList,
	            onChange: onChange.bind(this, 'foundUsVia')
	          }, secondDropDown),
	          {
	            Other: _react2.default.createElement(_c_TextField2.default, { floatingLabelText: 'Please Specify',
	              defaultValue: typeof this.props.tempState.foundUsOther === 'string' ? this.props.tempState.foundUsOther : this.props.applicant.profile.foundUsOther,
	              onBlur: onChange.bind(this, 'foundUsOther'),
	              style: secondTextField })
	          }
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'data-id': 'Instructions 2',
	            className: 'callout' },
	          _react2.default.createElement(_c_TextField2.default, { value: this.props.applicant.profile.industries.map(function (obj) {
	              return obj.name;
	            }).join(', '),
	            disabled: true,
	            multiLine: true,
	            floatingLabelText: this.props.labels.industries,
	            style: textFieldStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'expanded-accordion-content explanation-of-wahve review-explanations' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'instructions-list', style: { paddingBottom: !this.props.script ? '15px' : null } },
	            questionSection.map(function (listItem, questionKey) {
	              return _react2.default.createElement(
	                'li',
	                {
	                  className: 'instructions-list-item',
	                  key: questionKey
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'instructions-list-text' },
	                  /* should refactor this to remove the hard-coding aspect and choose listItem.text or listItem.text1 based on a property in the questionSection[] */
	                  listItem.propertyName === 'hasWorkedRemotelyComment' && !((_this2.props.tempState.profile || {}).hasOwnProperty('hasWorkedRemotely') ? _this2.props.tempState.profile.hasWorkedRemotely.id : _this2.props.applicant.profile.hasWorkedRemotely) ? listItem.text1 : listItem.text
	                ),
	                listItem.type === 'TextField' && _react2.default.createElement(_c_TextField2.default, {
	                  'data-id': listItem.propertyName,
	                  className: 'instructions-text-field',
	                  style: secondTextField,
	                  defaultValue: _this2.props.applicant.profile[listItem.propertyName],
	                  onBlur: onChange.bind(_this2, listItem.propertyName)
	                }) || listItem.type === 'TextArea' && _react2.default.createElement(_c_TextArea2.default, { 'data-id': listItem.propertyName,
	                  className: 'instructions-text-field',
	                  style: textFieldStyle,
	                  defaultValue: _this2.props.applicant.profile[listItem.propertyName] || '',
	                  onBlur: onChange.bind(_this2, listItem.propertyName)
	                }) || listItem.type === 'DropDown' && _react2.default.createElement(_c_DropDownMenu2.default, _extends({ 'data-id': listItem.propertyName,
	                  className: 'instructions-dropdown',
	                  value: _this2.props.applicant.hasOwnProperty(listItem.propertyName) ? _this2.props.applicant.profile[listItem.propertyName].id : // #theWorst
	                  _this2.props.applicant.profile.hasOwnProperty(listItem.propertyName) && _this2.props.applicant.profile[listItem.propertyName] && _this2.props.applicant.profile[listItem.propertyName].hasOwnProperty('id') ? _this2.props.applicant.profile[listItem.propertyName].id : _this2.props.applicant.profile.hasOwnProperty(listItem.propertyName) ? _this2.props.applicant.profile[listItem.propertyName] : null,
	                  onChange: onChange.bind(_this2, listItem.propertyName),
	                  menuItems: listItem.options
	                }, secondDropDown))
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PreliminaryProfile;
	}(_react.Component), _class2.propTypes = {
	  staticData: _react.PropTypes.object,
	  applicant: _react.PropTypes.object,
	  script: _react.PropTypes.bool,
	  tempState: _react.PropTypes.object,
	  model: _react.PropTypes.string.isRequired,
	  updateTempState: _react.PropTypes.func,
	  labels: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = PreliminaryProfile;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// redux action creators for persistence
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _componentLookup = __webpack_require__(1112);
	
	var _querystring = __webpack_require__(105);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var _Toggle = __webpack_require__(276);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _c_FadeOnChange = __webpack_require__(450);
	
	var _c_FadeOnChange2 = _interopRequireDefault(_c_FadeOnChange);
	
	var _reactRedux = __webpack_require__(5);
	
	var _svgIcons = __webpack_require__(2545);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Step = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    viewOrder: (0, _lodash.get)(store, 'labels.viewOrder', [])
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Step, _Component);
	
	  function Step(props, context) {
	    _classCallCheck(this, Step);
	
	    var _this2 = _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).call(this, props, context));
	
	    _this2.state = {};
	    _this2.state.openAccordion = null;
	
	    _this2.updateTimeOut = false;
	
	    // error count tracker
	    // Is on the instance to avoid it being overwritten
	    // by multiple setStates firing.
	    _this2.errorCount = 0;
	
	    _this2.updateErrorState = function (newCount) {
	      return _this2.setState(_extends({}, _this2.state, {
	        errorCount: newCount
	      }));
	    };
	
	    _this2.errorUpdate = function (countChange) {
	      _this2.errorCount += countChange;
	      _this2.updateErrorState(_this2.errorCount);
	    };
	    return _this2;
	  }
	
	  _createClass(Step, [{
	    key: 'saveData',
	    value: function saveData() {
	      var _this3 = this;
	
	      var currentComponent = (0, _componentLookup.getCurrent)(this.props.activeStep.key, this.props.activeSubStep.key);
	      var newState = _lodash2.default.cloneDeep(this.props.tempState);
	      _lodash2.default.set(newState, 'user.id', this.props.applicant.user.id);
	      _lodash2.default.set(newState, 'profile.id', this.props.applicant.profile.id);
	      _lodash2.default.set(newState, 'profile.viewState.progress.admin.application.' + this.props.activeStep.key + '.' + this.props.activeSubStep.key + '.done', currentComponent.validator());
	      if (newState.profile.viewState) {
	        newState.profile.viewState = _lodash2.default.merge({}, {
	          progress: { admin: { application: this.props.viewState } }
	        }, this.props.applicant.profile.viewState, newState.profile.viewState);
	      }
	
	      // update back end
	      var actions = (currentComponent.saveFunc || asyncActionCreators.updateApplicantAdmin)(newState, this.props.applicantGroupName, this.props.arrayIndex);
	      actions = _lodash2.default.isArray(actions) ? actions : [actions];
	      actions.map(function (action) {
	        return _this3.props.dispatch(action);
	      });
	    }
	
	    // Directly saved from local state.
	
	  }, {
	    key: 'saveStateData',
	    value: function saveStateData(newState) {
	      var _this4 = this;
	
	      var currentComponent = (0, _componentLookup.getCurrent)(this.props.activeStep.key, this.props.activeSubStep.key);
	      _lodash2.default.set(newState, 'user.id', this.props.applicant.user.id);
	      _lodash2.default.set(newState, 'profile.id', this.props.applicant.profile.id);
	      _lodash2.default.set(newState, 'profile.viewState.progress.admin.application.' + this.props.activeStep.key + '.' + this.props.activeSubStep.key + '.done', currentComponent.validator());
	      if (newState.profile.viewState) {
	        newState.profile.viewState = _lodash2.default.merge({}, {
	          progress: { admin: { application: this.props.viewState } }
	        }, this.props.applicant.profile.viewState, newState.profile.viewState);
	      }
	
	      // update back end
	      var actions = (currentComponent.saveFunc || asyncActionCreators.updateApplicantAdmin)(newState, this.props.applicantGroupName, this.props.arrayIndex);
	      actions = _lodash2.default.isArray(actions) ? actions : [actions];
	      actions.map(function (action) {
	        return _this4.props.dispatch(action);
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	
	      this.saveData();
	
	      // clearing temp state after save
	      this.props.dispatch((0, _sync.updateTempState)({}));
	
	      this.toggleOpenAccordion('save');
	    }
	  }, {
	    key: 'openInWindow',
	    value: function openInWindow(step, substep) {
	      var basePath = '/admin/' + this.props.route.params.navColumnState + '/' + this.props.route.params.email;
	      var queryString = '?' + (0, _querystring.stringify)({ detail: 1, openInWindow: 1 });
	      if (window) {
	        var win = window.open(basePath + '/' + step + '/' + substep + queryString, 'openInWindow', 'width=900,height=450,location=no,menubar=no');
	        win.focus();
	      }
	    }
	  }, {
	    key: 'toggleScripts',
	    value: function toggleScripts(step, substep, toggled) {
	      this.props.updateTempState('profile', 'viewState.progress.admin.application.' + step + '.' + substep + '.scriptVisible', null, toggled);
	    }
	  }, {
	    key: 'toggleOpenAccordion',
	    value: function toggleOpenAccordion(substep) {
	
	      this.setState({
	        openAccordion: substep
	      });
	
	      var routeCategory = this.props.route.params.category;
	      var routeSubCategory = this.props.route.params.subcategory;
	      var activeStepIndex = _lodash2.default.findIndex(this.props.viewOrder, function (o) {
	        return o.key === routeCategory;
	      });
	      var basePath = '/admin/' + this.props.route.params.navColumnState + '/' + this.props.route.params.email;
	      var queryString = '?' + (0, _querystring.stringify)(this.props.route.query);
	
	      var categoryLength = this.props.viewOrder[_lodash2.default.findIndex(this.props.viewOrder, ['key', routeCategory])].subNav.length;
	      var currentStepIndex = _lodash2.default.findIndex(this.props.viewOrder[_lodash2.default.findIndex(this.props.viewOrder, ['key', routeCategory])].subNav, ['key', routeSubCategory]);
	
	      if (substep !== 'save') {
	        this.props.onChangeStep(activeStepIndex, basePath + '/' + routeCategory + '/' + substep + queryString);
	      } else {
	        if (currentStepIndex + 1 < categoryLength) {
	          this.props.onChangeStep(activeStepIndex, basePath + '/' + routeCategory + '/' + this.props.viewOrder[activeStepIndex].subNav[currentStepIndex + 1].key + queryString);
	        } else {
	          this.props.onChangeStep(activeStepIndex, basePath + '/' + routeCategory + '/' + queryString);
	
	          /* if(!this.props.viewOrder[_.findIndex(this.props.viewOrder, ['display', routeCategory] )+1]){
	             this.props.onChangeStep(3, `${basePath}/references${queryString}`)
	           }else{
	             this.props.onChangeStep(activeStepIndex, `${basePath}/${this.props.viewOrder[activeStepIndex+1].display}/${this.props.viewOrder[activeStepIndex+1].subNav[0].key}${queryString}`)
	           }*/
	        }
	      }
	    }
	
	    // wrapper for update temp state method call
	
	  }, {
	    key: 'localUpdateTempState',
	    value: function localUpdateTempState() {
	      var _props;
	
	      var _this = this;
	      // depounce a bit save request
	      if (!this.updateTimeOut) {
	        this.updateTimeOut = true;
	        setTimeout(function () {
	          _this.saveData();
	          _this.updateTimeOut = false;
	        }, 1);
	      }
	
	      // update tempstate object, based on what will be sent update data
	      (_props = this.props).updateTempState.apply(_props, arguments);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _getCurrent = (0, _componentLookup.getCurrent)(this.props.activeStep.key, this.props.activeSubStep.key),
	          component = _getCurrent.component,
	          saveFunc = _getCurrent.saveFunc,
	          stepProps = _objectWithoutProperties(_getCurrent, ['component', 'saveFunc']);
	
	      var localViewState = (this.props.viewState[this.props.activeStep.key] || {})[this.props.activeSubStep.key] || {};
	      var expanded = this.props.route.params.subcategory === this.props.activeSubStep.key;
	      var done = localViewState.done;
	      var script = this.props.activeSubStep.script;
	      var scriptVisible = _lodash2.default.get(this.props.tempState, 'profile.viewState.progress.admin.application.' + this.props.activeStep.key + '.' + this.props.activeSubStep.key + '.scriptVisible', true);
	      var showSaveOrNext = expanded && (this.props.activeSubStep.showNext || this.props.tempState[stepProps.model]);
	
	      var actionText = !showSaveOrNext ? 'View' : this.props.activeSubStep.showNext && !this.props.isLast ? 'Next' : 'Save';
	      var openInWindow = this.props.route.query.openInWindow === '1';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('accordion-item', { expanded: expanded }),
	          key: this.props.activeSubStepIndex,
	          id: 'step' + this.props.activeSubStepIndex
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('accordion-heading', { clickable: !expanded }),
	            'data-id': this.props.activeSubStep.display,
	            onClick: !expanded && this.toggleOpenAccordion.bind(this, this.props.activeSubStep.key)
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'left',
	              onClick: !openInWindow && expanded && this.toggleOpenAccordion.bind(this, 'test2')
	            },
	            _react2.default.createElement('div', { className: (0, _classnames2.default)('checkbox', { checkmark: done }) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'accordion-text noTextSelect' },
	              this.props.activeSubStep.display
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('script-toggle', 'noTextSelect', { showScriptToggle: expanded && script }) },
	              'Script',
	              _react2.default.createElement(_Toggle2.default, {
	                className: 'script-toggle-icon',
	                'data-id': 'Script',
	                disabled: this.props.activeSubStep.display === 'Conclusion to the Interview',
	                disableTouchRipple: true,
	                disableFocusRipple: true,
	                labelPosition: 'right',
	                toggled: script && scriptVisible,
	                onToggle: this.toggleScripts.bind(this, this.props.activeStep.key, this.props.activeSubStep.key, !scriptVisible),
	                style: { transition: 'none' },
	                elementStyle: { transition: 'none' },
	                trackStyle: { height: '8px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1)' },
	                thumbStyle: { top: '-2px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1), left .2s cubic-bezier(0.23, 1, 0.32, 1), margin .2s cubic-bezier(0.23, 1, 0.32, 1)' }
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'script-state-text' },
	                _react2.default.createElement(
	                  _c_FadeOnChange2.default,
	                  {
	                    duration: 195,
	                    className: 'noTextSelect'
	                  },
	                  script && scriptVisible ? 'On' : 'Off'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('script-toggle', 'noTextSelect', 'open-window', { showScriptToggle: expanded && this.props.activeSubStep.openInWindow }),
	                onClick: this.openInWindow.bind(this, this.props.activeStep.key, this.props.activeSubStep.key)
	              },
	              'Open In Window'
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'accordion-toggle',
	                'data-id': actionText
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: (0, _classnames2.default)('accordion-toggle-text', 'noTextSelect', { clickable: showSaveOrNext }),
	                  onClick: showSaveOrNext && !this.errorCount ? this.onSave.bind(this) : this.toggleOpenAccordion.bind(this, 'save')
	                },
	                actionText
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'accordion-caret-container',
	                  onClick: expanded && this.toggleOpenAccordion.bind(this, 'test')
	                },
	                _react2.default.createElement('div', {
	                  className: (0, _classnames2.default)('accordion-toggle-caret', 'chevron', { toggled: expanded })
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'expanded-accordion admin-view',
	            style: {
	              maxHeight: expanded ? 'none' : 0,
	              display: expanded ? '' : 'none'
	            }
	          },
	          component(_extends({
	            adminView: true,
	            staticData: this.props.staticData,
	            applicant: this.props.applicant,
	            behavioralAnswers: this.props.behavioralAnswers,
	            workObjectives: this.props.workObjectives,
	            workExperiences: this.props.workExperiences,
	            ratings: this.props.ratings,
	            skills: this.props.skills,
	            licenses: this.props.licenses,
	            designations: this.props.designations,
	            profile: this.props.applicant.profile,
	            tempState: this.props.tempState,
	            updateTempState: this.localUpdateTempState.bind(this),
	            errorUpdate: this.errorUpdate,
	            script: script && scriptVisible,
	            assessments: this.props.assessments,
	            dispatch: this.props.dispatch,
	            saveData: this.saveStateData.bind(this)
	          }, stepProps))
	        )
	      );
	    }
	  }]);
	
	  return Step;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  activeStep: _react.PropTypes.object.isRequired,
	  activeSubStep: _react.PropTypes.object.isRequired,
	  activeSubStepIndex: _react.PropTypes.number.isRequired,
	  isLast: _react.PropTypes.bool.isRequired,
	  applicant: _react.PropTypes.object.isRequired,
	  assessments: _react.PropTypes.object.isRequired,
	  behavioralAnswers: _react.PropTypes.object.isRequired,
	  workObjectives: _react.PropTypes.object.isRequired,
	  workExperiences: _react.PropTypes.object.isRequired,
	  ratings: _react.PropTypes.object.isRequired,
	  skills: _react.PropTypes.object.isRequired,
	  licenses: _react.PropTypes.object.isRequired,
	  designations: _react.PropTypes.object.isRequired,
	  updateProgress: _react.PropTypes.func.isRequired,
	  updateTempState: _react.PropTypes.func.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  viewState: _react.PropTypes.object,
	  applicantGroupName: _react.PropTypes.string,
	  arrayIndex: _react.PropTypes.number,
	  toggleGuide: _react.PropTypes.func,
	  guideOpen: _react.PropTypes.bool,
	  onChangeStep: _react.PropTypes.func.isRequired,
	  route: _react.PropTypes.object.isRequired,
	  viewOrder: _react.PropTypes.array.isRequired
	}, _temp)) || _class);
	exports.default = Step;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _adminViewState = __webpack_require__(1107);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _deepUnset = __webpack_require__(304);
	
	var _deepUnset2 = _interopRequireDefault(_deepUnset);
	
	var _reactRedux = __webpack_require__(5);
	
	var _c_Step = __webpack_require__(1104);
	
	var _c_Step2 = _interopRequireDefault(_c_Step);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Steps = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    viewOrder: (0, _lodash.get)(store, 'labels.viewOrder', [])
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Steps, _Component);
	
	  function Steps(props, context) {
	    _classCallCheck(this, Steps);
	
	    var _this = _possibleConstructorReturn(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).call(this, props, context));
	
	    _this.updateTempState = function (parent, prop, event, val, cb) {
	      // getting params as array [parent, prop, event, val, cb]
	
	      var newTempState = _lodash2.default.cloneDeep(_this.props.tempState);
	      var propPath = parent && !prop ? parent : !parent && prop ? prop : '' + parent + (prop[0] === '[' ? '' : '.') + prop;
	
	      if (val === undefined) {
	        // unsets parent objects if they are empty
	        (0, _deepUnset2.default)(newTempState, propPath);
	      } else {
	        _lodash2.default.setWith(newTempState, propPath, val, Object);
	      }
	      _this.props.dispatch(syncActionCreators.updateTempState(newTempState));
	
	      if (typeof cb === 'function') {
	        cb();
	      }
	    };
	
	    _this.accordionDidMount = function (container) {
	      _this.frozenStep = false;
	      if (container) {
	        var that = _this;
	        container.addEventListener('scroll', function () {
	          var containerRect = (0, _reactDom.findDOMNode)(container).getBoundingClientRect();
	          var routeCategory = _this.props.route.params.category;
	          var activeStepIndex = _lodash2.default.findIndex(_this.props.viewOrder, function (o) {
	            return o.key == routeCategory;
	          });
	          var activeSubStepIndex = _lodash2.default.findIndex((_this.props.viewOrder[activeStepIndex] || {}).subNav || [], function (x) {
	            return x.key == _this.props.route.params.subcategory;
	          });
	          var stepRect = (0, _reactDom.findDOMNode)(_this.refs['step' + activeSubStepIndex]).getBoundingClientRect();
	          if (!that.frozenStep && stepRect.top - containerRect.top < 0) {
	            (0, _reactDom.findDOMNode)(that.refs['step' + activeSubStepIndex]).className += ' frozen';
	            that.frozenStep = true;
	          }
	          if (that.frozenStep && stepRect.top - containerRect.top >= 0) {
	            var el = (0, _reactDom.findDOMNode)(that.refs['step' + activeSubStepIndex]);
	            el.className = el.className.replace(' frozen', '');
	            that.frozenStep = false;
	          }
	        });
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Steps, [{
	    key: 'updateProgress',
	    value: function updateProgress(step, substep, doneValue) {
	      this.updateTempState('profile', 'viewState.progress.admin.application.' + step + '.' + substep + '.done', null, doneValue);
	    }
	
	    // modify tempState properties
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.route.params.subcategory !== this.props.route.params.subcategory) {
	        var currentStepName = _lodash2.default.get(this.props, 'route.params.subcategory', '');
	        var expandedStep = _lodash2.default.find(this.refs, function (step) {
	          return _lodash2.default.get(step, 'props.activeSubStep.key', '') === currentStepName;
	        });
	        var stepId = _lodash2.default.get(expandedStep, 'props.activeSubStepIndex', '');
	
	        if (stepId) {
	          document.getElementById('step' + stepId).scrollIntoView();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$style = this.props.style,
	          steps = _props$style.steps,
	          otherStyles = _objectWithoutProperties(_props$style, ['steps']);
	
	      var routeCategory = this.props.route.params.category;
	      var activeStepIndex = _lodash2.default.findIndex(this.props.viewOrder, function (o) {
	        return o.key == routeCategory;
	      });
	
	      var activeStep = this.props.viewOrder[activeStepIndex] || {};
	      var subSteps = (this.props.viewOrder[activeStepIndex] || {}).subNav || [];
	      var viewState = _lodash2.default.get(_lodash2.default.merge({}, this.props.applicant.profile.viewState || {}, this.props.tempState && this.props.tempState.profile ? this.props.tempState.profile.viewState : {}), 'progress.admin.application', _adminViewState.adminViewState);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'steps-container clearfix', style: otherStyles },
	        _react2.default.createElement(
	          'div',
	          { className: 'steps', style: steps },
	          _react2.default.createElement(
	            'div',
	            { className: 'scroll-hide', ref: this.accordionDidMount },
	            _react2.default.createElement(
	              'ol',
	              { className: 'profile-steps' },
	              _react2.default.createElement(
	                'div',
	                { className: 'profile-accordion' },
	                subSteps.map(function (item, index) {
	                  return _react2.default.createElement(_c_Step2.default, {
	                    key: index,
	                    applicantGroupName: _this2.props.applicantGroupName,
	                    arrayIndex: _this2.props.arrayIndex,
	                    dispatch: _this2.props.dispatch,
	                    staticData: _this2.props.staticData,
	                    activeStep: activeStep,
	                    activeSubStep: item,
	                    activeSubStepIndex: index,
	                    isLast: index === subSteps.length - 1,
	                    applicant: _this2.props.applicant,
	                    behavioralAnswers: _this2.props.behavioralAnswers,
	                    workObjectives: _this2.props.workObjectives,
	                    workExperiences: _this2.props.workExperiences,
	                    ratings: _this2.props.ratings,
	                    skills: _this2.props.skills,
	                    licenses: _this2.props.licenses,
	                    designations: _this2.props.designations,
	                    tempState: _this2.props.tempState,
	                    viewState: viewState,
	                    updateProgress: _this2.updateProgress.bind(_this2, activeStep.key, item.key),
	                    updateTempState: _this2.updateTempState.bind(_this2),
	                    assessments: _this2.props.assessments,
	                    toggleGuide: _this2.props.toggleGuide,
	                    guideOpen: _this2.props.guideOpen,
	                    style: _extends({}, steps),
	                    onChangeStep: _this2.props.onChangeStep,
	                    route: _this2.props.route,
	                    ref: 'step' + index
	                  });
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Steps;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  staticData: _react.PropTypes.object.isRequired,
	  applicant: _react.PropTypes.object.isRequired,
	  assessments: _react.PropTypes.object.isRequired,
	  behavioralAnswers: _react.PropTypes.object.isRequired,
	  workObjectives: _react.PropTypes.object.isRequired,
	  workExperiences: _react.PropTypes.object.isRequired,
	  ratings: _react.PropTypes.object.isRequired,
	  skills: _react.PropTypes.object.isRequired,
	  licenses: _react.PropTypes.object.isRequired,
	  designations: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  updateApplicantStatus: _react.PropTypes.func.isRequired,
	  profileId: _react.PropTypes.number,
	  applicantGroupName: _react.PropTypes.string,
	  arrayIndex: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  onChangeStep: _react.PropTypes.func.isRequired,
	  toggleGuide: _react.PropTypes.func,
	  guideOpen: _react.PropTypes.bool,
	  route: _react.PropTypes.object.isRequired,
	  viewOrder: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = Steps;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(51);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _querystring = __webpack_require__(105);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubNav = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    viewOrder: (0, _lodash.get)(store, 'labels.viewOrder', [])
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(SubNav, _Component);
	
	  function SubNav(props, context) {
	    _classCallCheck(this, SubNav);
	
	    return _possibleConstructorReturn(this, (SubNav.__proto__ || Object.getPrototypeOf(SubNav)).call(this, props, context));
	  }
	
	  _createClass(SubNav, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var activeStepKey = (this.props.viewOrder[this.props.activeStepIndex] || {}).key;
	      var basePath = '/admin/' + this.props.route.params.navColumnState + '/' + this.props.route.params.email;
	      var queryString = '?' + (0, _querystring.stringify)(this.props.route.query);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'subnav', style: this.props.style },
	        _react2.default.createElement(
	          'ul',
	          { className: 'subnav-link-container' },
	          this.props.viewOrder.map(function (navItem, index) {
	            return _react2.default.createElement(
	              'li',
	              {
	                key: index,
	                'data-id': navItem.key,
	                className: (0, _classnames2.default)('subnav-link', 'link', { active: navItem.key === _this2.props.route.params.category }),
	                onClick: _this2.props.onChangeStep.bind(_this2, index, basePath + '/' + navItem.key + queryString)
	              },
	              navItem.display
	            );
	          }),
	          _react2.default.createElement(
	            'li',
	            {
	              'data-id': 'References',
	              className: (0, _classnames2.default)('subnav-link', 'link', { active: this.props.activeStepIndex === 3 }),
	              onClick: this.props.onChangeStep.bind(this, 3, basePath + '/References' + queryString)
	            },
	            'References'
	          ),
	          _react2.default.createElement(
	            'li',
	            {
	              'data-id': 'Technology Survey',
	              className: (0, _classnames2.default)('subnav-link', 'link', { active: this.props.activeStepIndex === 4 }),
	              onClick: this.props.onChangeStep.bind(this, 4, basePath + '/TechnologySurvey' + queryString)
	            },
	            'Tech Survey'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SubNav;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  onChangeStep: _react.PropTypes.func.isRequired,
	  activeStepIndex: _react.PropTypes.number.isRequired,
	  route: _react.PropTypes.object.isRequired,
	  style: _react.PropTypes.object,
	  viewOrder: _react.PropTypes.object.isRequired
	}, _temp)) || _class);
	exports.default = SubNav;

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var adminViewState = exports.adminViewState = {
	  Profile: {
	    'Preliminary Information': {
	      scriptVisible: true,
	      done: false
	    },
	    'Explanation of Wahve': {
	      scriptVisible: true,
	      done: false
	    },
	    'Conclusion to the Interview': {
	      scriptVisible: true,
	      done: false
	    }
	  },
	  Review: {
	    'Preliminary Profile': {
	      scriptVisible: true,
	      done: false
	    },
	    Application: {
	      scriptVisible: true,
	      done: false
	    },
	    Assessments: {
	      scriptVisible: true,
	      done: false
	    }
	  },
	  Interview: {
	    Introduction: {
	      scriptVisible: true,
	      done: false
	    },
	    'Preferences Availability': {
	      scriptVisible: true,
	      done: false
	    },
	    'Work Objectives': {
	      scriptVisible: true,
	      done: false
	    },
	    'Home Office Setup': {
	      scriptVisible: true,
	      done: false
	    },
	    'Work Experience': {
	      scriptVisible: true,
	      done: false
	    },
	    'Employment Gaps': {
	      scriptVisible: false,
	      done: false
	    },
	    Skills: {
	      scriptVisible: true,
	      done: false
	    },
	    Assessments: {
	      scriptVisible: true,
	      done: false
	    },
	    Licenses: {
	      scriptVisible: true,
	      done: false
	    },
	    'Professional Designations': {
	      scriptVisible: true,
	      done: false
	    },
	    'Professional Associations': {
	      scriptVisible: false,
	      done: false
	    },
	    'Behavioral Interview': {
	      scriptVisible: true,
	      done: false
	    },
	    'Medicare and Social Security': {
	      scriptVisible: true,
	      done: false
	    },
	    'Determination of Status': {
	      scriptVisible: true,
	      done: false
	    },
	    Ratings: {
	      scriptVisible: true,
	      done: false
	    }
	  }
	};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _c_SourceSimpleFileInput = __webpack_require__(110);
	
	var _c_SourceSimpleFileInput2 = _interopRequireDefault(_c_SourceSimpleFileInput);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssessmentsView = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    documents: state.documents,
	    pathname: state.routing.locationBeforeTransitions.pathname
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AssessmentsView, _Component);
	
	  function AssessmentsView(props) {
	    _classCallCheck(this, AssessmentsView);
	
	    var _this = _possibleConstructorReturn(this, (AssessmentsView.__proto__ || Object.getPrototypeOf(AssessmentsView)).call(this));
	
	    _this.flipBack = props.stateToggle.bind(_this, 'edit', 0);
	
	    // increment through alphabet
	    var inc = 65; // charcode for 'A'
	    _this.getIncrementedChar = function () {
	      return String.fromCharCode(inc++);
	    };
	    return _this;
	  }
	
	  _createClass(AssessmentsView, [{
	    key: 'mapObject',
	    value: function mapObject(object, callback) {
	      return Object.keys(object).map(function (key) {
	        return callback(object[key], key);
	      });
	    }
	  }, {
	    key: 'downladAll',
	    value: function downladAll() {
	      var links = document.getElementsByClassName('retrieval-button file-get document-file');
	      for (var i = 0; i < links.length; i++) {
	        links[i].click();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'document-card',
	          'data-id': this.props.applicant.user.email + ' document',
	          key: 'Documents Card ' + this.props.applicant.profile.id,
	          style: this.props.style },
	        _react2.default.createElement(_ModalX2.default, { onClick: this.flipBack }),
	        _react2.default.createElement(
	          'div',
	          { className: 'top-wrapper clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            'Available Documents'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'body-wrapper' },
	          !_lodash2.default.isEmpty(this.props.documents) && _react2.default.createElement(
	            'div',
	            { className: 'documents-container' },
	            this.mapObject(this.props.documents, function (document, key) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'document-item', 'data-id': document.fileTypeName + '-' + key },
	                _react2.default.createElement(_c_TextField2.default, { className: 'type-name',
	                  defaultValue: document.fileTypeName,
	                  disabled: true,
	                  inputStyle: {
	                    textOverflow: 'ellipsis'
	                  }
	                }),
	                _react2.default.createElement(
	                  _c_SourceSimpleFileInput.RetrievalButton,
	                  {
	                    className: 'file-get document-file',
	                    loadingClass: '',
	                    notLoadingClass: '',
	                    failureClass: '',
	                    autoLoad: true,
	                    noMessage: true,
	                    path: document.storagePath,
	                    signingRoute: '/api/s3/get-sign'
	                  },
	                  _react2.default.createElement(_c_TextField2.default, {
	                    disabled: true,
	                    value: document.fileName,
	                    inputStyle: {
	                      textOverflow: 'ellipsis'
	                    }
	                  }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'megabyte-count' },
	                    Math.max(Math.round(document.fileSize / 100000) / 10, 0.1) + ' Mgb'
	                  )
	                )
	              );
	            })
	          ),
	          _lodash2.default.isEmpty(this.props.documents) && _react2.default.createElement(
	            'div',
	            { className: 'no-documents' },
	            'No Documents Have Been Uploaded Yet'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssessmentsView;
	}(_react.Component), _class2.propTypes = {
	  applicant: _react.PropTypes.object,
	  documents: _react.PropTypes.object,
	  stateToggle: _react.PropTypes.func,
	  staticData: _react.PropTypes.object,
	  open: _react.PropTypes.bool,
	  pathname: _react.PropTypes.string
	}, _temp)) || _class);
	exports.default = AssessmentsView;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_TextField = __webpack_require__(23);
	
	var _c_TextField2 = _interopRequireDefault(_c_TextField);
	
	var _c_MaskedTextField = __webpack_require__(52);
	
	var _c_MaskedTextField2 = _interopRequireDefault(_c_MaskedTextField);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _user = __webpack_require__(124);
	
	var _qualifyingSpecialists = __webpack_require__(1110);
	
	var _qualifyingSpecialists2 = _interopRequireDefault(_qualifyingSpecialists);
	
	var _updates = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validationObj = _lodash2.default.omit((0, _user.getSchema)(), 'password'); // password gets validated in the next step;
	
	// getting required fields
	var getRequiredFieldsArray = function getRequiredFieldsArray(schemaObj) {
	  return Object.keys(_lodash2.default.pickBy(schemaObj, function (val) {
	    return val && val.hasOwnProperty('required');
	  }));
	};
	
	// gets array of required fields
	var requiredFieldsArr = getRequiredFieldsArray(validationObj);
	
	var textFieldHeightAdj = 3;
	var textFieldProps = {
	  className: 'adminTextField',
	  focusColor: '#dbdbdb',
	  style: {
	    margin: 0,
	    width: '100%',
	    height: 72 - textFieldHeightAdj
	  },
	  fieldStyle: {
	    fontSize: '14.5px',
	    height: 72 - textFieldHeightAdj
	  },
	  floatingLabelStyle: {
	    color: 'rgba(0, 0, 0, 0.498039)'
	  },
	  errorStyle: {
	    display: 'none'
	  }
	};
	var inlineTextField = _lodash2.default.merge({}, textFieldProps, {
	  style: {
	    display: 'inline-block',
	    width: '32.7%'
	  },
	  fieldStyle: {
	    width: '100%'
	  }
	});
	var addressTextField = _lodash2.default.merge({}, textFieldProps, {
	  style: {
	    display: 'inline-block',
	    width: '49%'
	  },
	  fieldStyle: {
	    width: '100%'
	  }
	});
	var dropDownProps = {
	  containerStyle: {
	    height: '45px',
	    width: '100%',
	    fontSize: '14.5px'
	  },
	  labelStyle: {
	    padding: '0 15px 0 0'
	  },
	  underlineStyle: {
	    margin: 0,
	    borderTopWidth: '1px'
	  },
	  iconStyle: {
	    right: 0
	  },
	  floatingLabelStyle: {
	    left: 0
	  }
	};
	var inlineDropDown = _lodash2.default.merge({}, dropDownProps, {
	  containerStyle: {
	    display: 'inline-block',
	    transform: 'translateY(-5px)'
	  }
	});
	
	var textFieldLeft = _lodash2.default.merge({}, inlineTextField, {
	  style: {
	    width: 'calc(60% - 11px)',
	    marginRight: '11px',
	    height: '63px'
	  },
	  fieldStyle: {
	    height: '66.4px'
	  }
	});
	var dropDownRight = _lodash2.default.merge({}, inlineDropDown, {
	  containerStyle: {
	    width: '100%'
	  }
	});
	
	// specific elements
	var nickNameProps = _lodash2.default.merge({}, inlineTextField, {
	  style: {
	    transform: 'translateY(-2px)'
	  }
	});
	
	var middleNameProps = _lodash2.default.merge({}, inlineTextField, {
	  style: {
	    margin: '0 10px',
	    width: 'calc(34.6% - 20px)'
	  },
	  fieldStyle: {
	    width: '100%'
	  }
	});
	var emailProps = _lodash2.default.merge({}, inlineTextField, {
	  style: {
	    width: '100%'
	  },
	  fieldStyle: {
	    width: '100%'
	  }
	});
	var adjustedDropdownProps = _lodash2.default.merge({}, dropDownProps, {
	  containerStyle: {
	    transform: 'translateY(-2.5px)'
	  }
	});
	
	var bestTimeDropdownProps = _lodash2.default.merge({}, dropDownProps, {
	  containerStyle: {
	    transform: 'translateY(-3px)'
	  }
	});
	
	// setting default state out here as constant for clearing
	var defaultState = {
	  tempApplicant: {
	    user: {}
	  },
	  requiredMissing: [], // for validation
	  saveDisabled: true,
	  customError: null
	};
	
	var EditView = (_temp = _class = function (_Component) {
	  _inherits(EditView, _Component);
	
	  function EditView(props) {
	    _classCallCheck(this, EditView);
	
	    var _this = _possibleConstructorReturn(this, (EditView.__proto__ || Object.getPrototypeOf(EditView)).call(this));
	
	    _this.state = _lodash2.default.cloneDeep(defaultState);
	
	    _this.onCountryChange = function (event, value) {
	      var countryList = _this.props.staticData.countryList;
	
	      var updateUserCountry = (0, _updates.updateCountry)(countryList);
	      var user = updateUserCountry(value || event.target.value);
	      _lodash2.default.forEach(user, function (val, key) {
	        _this.onChange(key, {}, val);
	      });
	    };
	
	    _this.onSave = function () {
	      _this.props.updateApplicant(_this.state.tempApplicant, function (err, data) {
	        if (err) {
	          var customError = _lodash2.default.get(err, 'body.data.items[0]');
	          if (_lodash2.default.get(customError, 'errorCode') === 'DUPLICATE_EMAIL') {
	            _this.setState({ customError: customError.message });
	          }
	
	          return console.error(err);
	        }
	        _this.disableSave();
	        _this.flipBack();
	      });
	    };
	
	    _this.handleUI = _this.handleUI.bind(_this);
	    _this.wipeLocalState = _this.wipeLocalState.bind(_this);
	    _this.flipBack = props.stateToggle.bind(_this, 'edit', 0);
	    _this.currentUser = props.user;
	
	    _this.defaultApplicantState = _lodash2.default.merge(_lodash2.default.cloneDeep(defaultState), {
	      tempApplicant: {
	        user: {
	          id: props.applicant.user.id
	        },
	        profile: {
	          id: props.applicant.profile.id
	        }
	      }
	    });
	    return _this;
	  }
	
	  _createClass(EditView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.wipeLocalState();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(newProps) {
	      // reset state on close
	      if (this.props.open && !newProps.open) {
	        setTimeout(this.wipeLocalState, 137.5); // clear state mid-flip animation
	      }
	    }
	  }, {
	    key: 'propValue',
	    value: function propValue(fieldName) {
	      return this.state.tempApplicant.user.hasOwnProperty(fieldName) ? this.state.tempApplicant.user[fieldName] : _lodash2.default.isObject(this.props.applicant.user[fieldName]) ? this.props.applicant.user[fieldName].id : this.props.applicant.user[fieldName];
	    }
	  }, {
	    key: 'propValueProfile',
	    value: function propValueProfile(fieldName) {
	      return this.state.tempApplicant.profile.hasOwnProperty(fieldName) ? this.state.tempApplicant.profile[fieldName] : _lodash2.default.isObject(this.props.applicant.profile[fieldName]) ? this.props.applicant.profile[fieldName].id : this.props.applicant.profile[fieldName];
	    }
	  }, {
	    key: 'onQSChange',
	    value: function onQSChange(newValue) {
	      var profile = _lodash2.default.merge(this.state.tempApplicant.profile, {
	        qualifyingSpecialistId: newValue
	      });
	      this.setState({
	        tempApplicant: _lodash2.default.merge(this.state.tempApplicant, { profile: profile }),
	        saveDisabled: false
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(fieldName, event, newValue) {
	      var user = !_lodash2.default.isNil(this.props.applicant.user) && _lodash2.default.merge(this.state.tempApplicant.user, _defineProperty({}, fieldName, newValue));
	
	      // remove from errors array if now valid
	      var newRequiredMissing = newValue && ~this.state.requiredMissing.indexOf(fieldName) && this.state.requiredMissing.filter(function (field) {
	        return field !== fieldName;
	      }) || this.state.requiredMissing;
	
	      this.setState({
	        tempApplicant: _lodash2.default.merge(this.state.tempApplicant, { user: user }),
	        saveDisabled: !Object.keys(user).length || !!newRequiredMissing.length,
	        requiredMissing: newRequiredMissing,
	        customError: null
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(fieldName, event, newValue) {
	      // errors for emptying required fields
	      if (!newValue && ~requiredFieldsArr.indexOf(fieldName)) {
	        this.setState(_lodash2.default.assign(this.state, {
	          requiredMissing: this.state.requiredMissing.concat(fieldName),
	          saveDisabled: true
	        }));
	      }
	    }
	  }, {
	    key: 'handleUI',
	    value: function handleUI(fieldName) {
	      return {
	        'data-id': fieldName,
	        onChange: this.onChange.bind(this, fieldName),
	        onBlur: this.onBlur.bind(this, fieldName),
	        value: this.propValue(fieldName),
	        errorText: !!~this.state.requiredMissing.indexOf(fieldName) && ' ' || undefined // shows or hides error (sticks with text proptype, usually there's an error message actually in the thing)
	      };
	    }
	  }, {
	    key: 'handleCountryDropDown',
	    value: function handleCountryDropDown() {
	      var attributes = this.handleUI('country');
	      attributes.onChange = this.onCountryChange;
	      attributes.onBlur = this.onCountryChange;
	      return attributes;
	    }
	  }, {
	    key: 'disableSave',
	    value: function disableSave() {
	      this.setState(_lodash2.default.merge({}, { saveDisabled: true }));
	    }
	  }, {
	    key: 'wipeLocalState',
	    value: function wipeLocalState() {
	      this.setState(_lodash2.default.cloneDeep(this.defaultApplicantState));
	    }
	  }, {
	    key: 'renderStateOrCountry',
	    value: function renderStateOrCountry(state, props) {
	      var _props$staticData = props.staticData,
	          _props$staticData$sta = _props$staticData.stateList,
	          stateList = _props$staticData$sta === undefined ? [] : _props$staticData$sta,
	          _props$staticData$cou = _props$staticData.countryList,
	          countryList = _props$staticData$cou === undefined ? [] : _props$staticData$cou;
	
	      var selectedCountry = this.propValue('country');
	      var otherCountry = countryList.find(function (c) {
	        return c.subElement === 'Other';
	      });
	
	      if (!_lodash2.default.isNil(selectedCountry) && otherCountry && selectedCountry === otherCountry.id) {
	        return _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'Specify Country',
	          floatingLabelFixed: true
	        }, inlineTextField, this.handleUI('countryOther')));
	      }
	
	      return _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'State',
	        className: 'state-dropdown',
	        menuItems: stateList
	      }, adjustedDropdownProps, this.handleUI('state')));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-card form-container applicant-information-form',
	          'data-id': this.props.applicant.user.email + ' edit',
	          key: 'Edit Card ' + this.props.applicant.profile.id,
	          style: this.props.style },
	        _react2.default.createElement(_ModalX2.default, { onClick: this.flipBack }),
	        _react2.default.createElement(
	          'div',
	          { className: 'main-column grid' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Edit Profile Information'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'First Name',
	                floatingLabelFixed: true
	              }, inlineTextField, this.handleUI('firstName')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'Middle/Initial',
	                floatingLabelFixed: true
	              }, middleNameProps, this.handleUI('middleName')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'Last Name',
	                floatingLabelFixed: true
	              }, inlineTextField, this.handleUI('lastName')))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'Nickname',
	                floatingLabelFixed: true
	              }, nickNameProps, this.handleUI('nickName')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              (!!~this.currentUser.roles.indexOf('Admin') || !!~this.currentUser.roles.indexOf('Qualifying Specialist')) && _react2.default.createElement(_qualifyingSpecialists2.default, {
	                profile: this.props.applicant.profile,
	                specialists: this.props.staticData.qualifyingSpecialists,
	                onAssignQS: this.onQSChange.bind(this)
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'Email',
	                floatingLabelFixed: true,
	                className: 'email-text',
	                disabled: !~this.currentUser.roles.indexOf('Admin')
	              }, this.handleUI('email'), emailProps))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'Country of Residence',
	                className: 'country-dropdown',
	                menuItems: this.props.staticData.countryList
	              }, adjustedDropdownProps, this.handleCountryDropDown()))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'Address 1',
	                floatingLabelFixed: true
	              }, addressTextField, this.handleUI('address')))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'Address 2',
	                floatingLabelFixed: true
	              }, addressTextField, this.handleUI('address2')))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              this.renderStateOrCountry(this.state, this.props)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-2' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'City',
	                    floatingLabelFixed: true
	                  }, addressTextField, this.handleUI('city')))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_TextField2.default, _extends({ floatingLabelText: 'Zip Code',
	                    floatingLabelFixed: true,
	                    maxLength: '5'
	                  }, addressTextField, this.handleUI('zip')))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'Time Zone',
	                    className: 'timezone-dropdown',
	                    menuItems: this.props.staticData.timezoneList,
	                    menuStyle: {
	                      overflowX: 'visible',
	                      overflowY: 'visible'
	                    }
	                  }, adjustedDropdownProps, this.handleUI('timezone')))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_DropDownMenu2.default, _extends({ floatingLabelText: 'Best Time to Call',
	                    className: 'best-time-dropdown',
	                    style: { width: '100%' },
	                    menuItems: this.props.staticData.bestContactTimeList
	                  }, bestTimeDropdownProps, this.handleUI('bestContactTime')))
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-2' },
	                  _react2.default.createElement(_c_MaskedTextField2.default, _extends({ className: 'phone-number center-column-1',
	                    floatingLabelText: 'Phone Number',
	                    floatingLabelFixed: true,
	                    hideMaskChar: true,
	                    mask: '(999) 999-9999'
	                  }, textFieldLeft, this.handleUI('phoneNumber1')))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                    floatingLabelText: 'Type',
	                    menuItems: this.props.staticData.phoneTypeList
	                  }, dropDownRight, this.handleUI('phoneType1')))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-2' },
	                  _react2.default.createElement(_c_MaskedTextField2.default, _extends({ className: 'phone-number center-column-1',
	                    floatingLabelText: 'Phone Number',
	                    floatingLabelFixed: true,
	                    hideMaskChar: true,
	                    mask: '(999) 999-9999'
	                  }, textFieldLeft, this.handleUI('phoneNumber2')))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                    floatingLabelText: 'Type',
	                    menuItems: this.props.staticData.phoneTypeList
	                  }, dropDownRight, this.handleUI('phoneType2')))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-2' },
	                  _react2.default.createElement(_c_MaskedTextField2.default, _extends({ className: 'phone-number center-column-1',
	                    floatingLabelText: 'Phone Number',
	                    floatingLabelFixed: true,
	                    hideMaskChar: true,
	                    mask: '(999) 999-9999'
	                  }, textFieldLeft, this.handleUI('phoneNumber3')))
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(_c_DropDownMenu2.default, _extends({
	                    floatingLabelText: 'Type',
	                    menuItems: this.props.staticData.phoneTypeList
	                  }, dropDownRight, this.handleUI('phoneType3')))
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row actions' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              !!~this.currentUser.roles.indexOf('Admin') && _react2.default.createElement(_c_FlatButton2.default, { 'data-id': 'delete account button', className: 'delete-btn',
	                label: 'Delete Account',
	                onClick: function onClick() {
	                  return _this2.props.onDeletion();
	                },
	                style: {
	                  position: 'absolute',
	                  display: 'inline-block',
	                  width: '268px',
	                  paddingLeft: '30px',
	                  paddingRight: '30px',
	                  backgroundColor: '#d0011b',
	                  border: '1px solid #d0011b',
	                  color: '#ffffff'
	                },
	                hoverStyle: {
	                  border: '1px solid #d0011b',
	                  color: '#ffffff'
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col grow-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('shared-error', { 'show-error': this.state.customError || this.state.requiredMissing.length }) },
	                    this.state.customError || 'Must keep required fields populated'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col grow-2' },
	                  _react2.default.createElement(_c_FlatButton2.default, { 'data-id': 'cancel button', className: 'cancel-btn',
	                    label: 'Cancel',
	                    onClick: this.flipBack,
	                    style: {
	                      display: 'inline-block',
	                      width: '165px',
	                      paddingLeft: '30px',
	                      paddingRight: '30px',
	                      marginRight: '25px'
	                    } }),
	                  _react2.default.createElement(_c_FlatButton2.default, { 'data-id': 'save button', disabled: this.state.saveDisabled,
	                    className: 'save-btn',
	                    label: 'Save',
	                    onClick: this.onSave,
	                    style: {
	                      display: 'inline-block',
	                      width: '165px',
	                      paddingLeft: '30px',
	                      paddingRight: '30px',
	                      backgroundColor: '#2eb0e3',
	                      boxShadow: '0 2px 1px 0 rgba(0,0,0,.41), 0 0 2px 0 rgba(0,0,0,.12)',
	                      borderRadius: '2px',
	                      border: '0',
	                      color: '#ffffff'
	                    },
	                    hoverStyle: {
	                      color: '#ffffff'
	                    }
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditView;
	}(_react.Component), _class.propTypes = {
	  user: _react.PropTypes.object,
	  applicant: _react.PropTypes.object,
	  stateToggle: _react.PropTypes.func,
	  updateApplicant: _react.PropTypes.func,
	  updateApplicantQS: _react.PropTypes.func,
	  onDeletion: _react.PropTypes.func,
	  staticData: _react.PropTypes.object,
	  style: _react.PropTypes.object,
	  open: _react.PropTypes.bool
	}, _temp);
	exports.default = EditView;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = QualifyingSpecialists;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function QualifyingSpecialists(props) {
	  var profile = props.profile;
	  var handleAssignQS = props.onAssignQS;
	  var qualifyingSpecialists = [];
	  if (!_lodash2.default.isEmpty(props.specialists)) {
	    qualifyingSpecialists = props.specialists.map(function (item) {
	      return { value: item.employeeId, primaryText: item.firstName + ' ' + item.lastName };
	    });
	  }
	  var menuItems = [].concat(_toConsumableArray(qualifyingSpecialists));
	
	  return _react2.default.createElement(_c_DropDownMenu2.default, {
	    className: 'qs-container',
	    'data-id': 'Qualifying Specialist',
	    floatingLabelText: 'Qualifying Specialist',
	    defaultValue: profile.qualifyingSpecialistId,
	    menuItems: menuItems,
	    onChange: function onChange(event, value) {
	      return handleAssignQS(value);
	    } });
	}
	
	QualifyingSpecialists.propTypes = {
	  profile: _react.PropTypes.object.isRequired,
	  onAssignQS: _react.PropTypes.func.isRequired,
	  specialists: _react.PropTypes.array
	};

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StatusConfirmation;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _ModalX = __webpack_require__(43);
	
	var _ModalX2 = _interopRequireDefault(_ModalX);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_RaisedButton = __webpack_require__(91);
	
	var _c_RaisedButton2 = _interopRequireDefault(_c_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// material
	
	
	// components
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	var flatButtonStyle = {
	  width: '296px',
	  height: '41px',
	  marginRight: '25px'
	};
	
	// utilities
	
	
	var flatButtonLabelStyle = {
	  fontSize: '12px',
	  transform: 'translateY(-.5px)',
	  top: 0
	};
	
	function StatusConfirmation(props) {
	  return _react2.default.createElement(
	    _r_Modal2.default,
	    { className: 'status-confirmation' },
	    _react2.default.createElement(
	      'div',
	      { className: 'transition-block-form' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'prompt-text' },
	          props.message
	        ),
	        _react2.default.createElement(_c_FlatButton2.default, {
	          style: flatButtonStyle,
	          labelStyle: flatButtonLabelStyle,
	          label: 'Cancel',
	          onClick: props.cancelFunc
	        }),
	        _react2.default.createElement(_c_RaisedButton2.default, {
	          label: 'Continue',
	          onClick: props.continueFunc
	        })
	      ),
	      _react2.default.createElement(_ModalX2.default, { onClick: props.cancelFunc })
	    ),
	    _react2.default.createElement('div', { className: 'rectangle-behind-modal-form absolute-center' })
	  );
	}
	
	StatusConfirmation.propTypes = {
	  message: _react.PropTypes.string,
	  continueFunc: _react.PropTypes.func,
	  cancelFunc: _react.PropTypes.func
	};

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lookup = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// redux action creators for persistence
	
	
	// Profile components
	
	
	// Review components
	
	
	// Interview components
	
	
	// from applicant side
	
	
	// Model schemas
	
	
	exports.getCurrent = getCurrent;
	
	var _react = __webpack_require__(1);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _f_PrelimInterview = __webpack_require__(1102);
	
	var _f_PrelimInterview2 = _interopRequireDefault(_f_PrelimInterview);
	
	var _f_ExplanationOfWahve = __webpack_require__(1101);
	
	var _f_ExplanationOfWahve2 = _interopRequireDefault(_f_ExplanationOfWahve);
	
	var _c_ConclusionToTheInterview = __webpack_require__(1100);
	
	var _c_ConclusionToTheInterview2 = _interopRequireDefault(_c_ConclusionToTheInterview);
	
	var _f_PreliminaryProfile = __webpack_require__(1103);
	
	var _f_PreliminaryProfile2 = _interopRequireDefault(_f_PreliminaryProfile);
	
	var _AssessmentsTable = __webpack_require__(933);
	
	var _AssessmentsTable2 = _interopRequireDefault(_AssessmentsTable);
	
	var _f_Introduction = __webpack_require__(1095);
	
	var _f_Introduction2 = _interopRequireDefault(_f_Introduction);
	
	var _f_ApplicationAssessmentsInstructions = __webpack_require__(1092);
	
	var _f_ApplicationAssessmentsInstructions2 = _interopRequireDefault(_f_ApplicationAssessmentsInstructions);
	
	var _f_StatusDetermination = __webpack_require__(1098);
	
	var _f_StatusDetermination2 = _interopRequireDefault(_f_StatusDetermination);
	
	var _f_MedicareSocialSecurity = __webpack_require__(1096);
	
	var _f_MedicareSocialSecurity2 = _interopRequireDefault(_f_MedicareSocialSecurity);
	
	var _f_BehavioralInterview = __webpack_require__(1093);
	
	var _f_BehavioralInterview2 = _interopRequireDefault(_f_BehavioralInterview);
	
	var _f_DeterminationOfStatus = __webpack_require__(1094);
	
	var _f_DeterminationOfStatus2 = _interopRequireDefault(_f_DeterminationOfStatus);
	
	var _f_WorkObjectives = __webpack_require__(1099);
	
	var _f_WorkObjectives2 = _interopRequireDefault(_f_WorkObjectives);
	
	var _f_Ratings = __webpack_require__(1097);
	
	var _f_Ratings2 = _interopRequireDefault(_f_Ratings);
	
	var _c_AvailabilityInformation = __webpack_require__(475);
	
	var _c_AvailabilityInformation2 = _interopRequireDefault(_c_AvailabilityInformation);
	
	var _c_HomeOfficeSetup = __webpack_require__(476);
	
	var _c_HomeOfficeSetup2 = _interopRequireDefault(_c_HomeOfficeSetup);
	
	var _c_WorkExperience = __webpack_require__(474);
	
	var _c_WorkExperience2 = _interopRequireDefault(_c_WorkExperience);
	
	var _ProfessionalDesignationsSummary = __webpack_require__(1009);
	
	var _ProfessionalDesignationsSummary2 = _interopRequireDefault(_ProfessionalDesignationsSummary);
	
	var _ProfessionalAssociationsSummary = __webpack_require__(1008);
	
	var _ProfessionalAssociationsSummary2 = _interopRequireDefault(_ProfessionalAssociationsSummary);
	
	var _LicensesSummary = __webpack_require__(1007);
	
	var _LicensesSummary2 = _interopRequireDefault(_LicensesSummary);
	
	var _SkillsSummary = __webpack_require__(1010);
	
	var _SkillsSummary2 = _interopRequireDefault(_SkillsSummary);
	
	var _EmploymentGapsSummary = __webpack_require__(1002);
	
	var _EmploymentGapsSummary2 = _interopRequireDefault(_EmploymentGapsSummary);
	
	var _applicantProfile = __webpack_require__(313);
	
	var _applicantWorkExperience = __webpack_require__(467);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profileSchema = (0, _applicantProfile.getSchema)();
	var workExperienceSchema = (0, _applicantWorkExperience.getSchema)();
	
	// retrieves current component
	function getCurrent(activeColumnNav, activeRowSubNav) {
	  // look up column on 'lookup' object
	  var lookupVal = lookup[activeColumnNav];
	
	  // corresponding string
	  var viewModel = activeColumnNav;
	
	  // some components are nested, others are not, this handles that
	  if (lookupVal && activeRowSubNav) {
	    lookupVal = lookupVal[activeRowSubNav];
	    viewModel += '.' + activeRowSubNav;
	  }
	  return _extends({}, lookupVal, { viewModel: viewModel });
	}
	
	var lookup = exports.lookup = {
	  Profile: {
	    'Preliminary Information': {
	      component: (0, _react.createFactory)(_f_PrelimInterview2.default),
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Explanation of Wahve': {
	      component: (0, _react.createFactory)(_f_ExplanationOfWahve2.default),
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Conclusion to the Interview': {
	      component: (0, _react.createFactory)(_c_ConclusionToTheInterview2.default),
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    }
	  },
	  Review: {
	    'Preliminary Profile': {
	      component: (0, _react.createFactory)(_f_PreliminaryProfile2.default),
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    },
	    Application: {
	      component: (0, _react.createFactory)(_SkillsSummary2.default),
	      model: 'skills',
	      validation: {},
	      validator: function validator() {
	        return true;
	      }
	    },
	    Assessments: {
	      component: (0, _react.createFactory)(_AssessmentsTable2.default),
	      model: 'assessments',
	      validator: function validator() {
	        return true;
	      }
	    }
	  },
	  Interview: {
	    'Application Assessments Instructions': {
	      component: _f_ApplicationAssessmentsInstructions2.default,
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    },
	    Assessments: {
	      component: (0, _react.createFactory)(_AssessmentsTable2.default),
	      model: 'assessments',
	      validator: function validator() {
	        return true;
	      },
	      saveFunc: function saveFunc(applicant, group, arrayIndex) {
	        var actions = [];
	        applicant.assessments && actions.push(asyncActionCreators.updateApplicantAssessments(applicant, applicant.assessments, group, arrayIndex));
	        applicant.ratings && actions.push(asyncActionCreators.updateApplicantInterviewRatings(applicant, applicant.ratings, group, arrayIndex));
	        applicant.profile.viewState && actions.push(asyncActionCreators.updateApplicantAdmin(applicant, group, arrayIndex));
	        return actions;
	      }
	    },
	    'Preferences Availability': {
	      component: (0, _react.createFactory)(_c_AvailabilityInformation2.default),
	      model: 'profile',
	      validation: profileSchema,
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Home Office Setup': {
	      component: (0, _react.createFactory)(_c_HomeOfficeSetup2.default),
	      model: 'profile',
	      validation: {},
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Work Experience': {
	      component: (0, _react.createFactory)(_c_WorkExperience2.default),
	      model: 'workExperiences',
	      validation: workExperienceSchema,
	      validator: function validator() {
	        return true;
	      },
	      saveFunc: function saveFunc(newstate, group, arrayIndex) {
	        var actions = [];
	        var updateViewState = _lodash2.default.get(newstate, 'profile.viewState', null) ? true : false;
	        var updateProfile = !_lodash2.default.isEmpty(_lodash2.default.omit(newstate.profile, ['viewState']));
	        var updateWorkExperience = !_lodash2.default.isNil(newstate.workExperiences);
	        updateWorkExperience && actions.push(asyncActionCreators.persistListUpdate('workExperiences', 'workExperiences', newstate));
	        (updateViewState || updateProfile) && actions.push(asyncActionCreators.updateApplicantAdmin(newstate, group, arrayIndex));
	        (updateWorkExperience || updateViewState || updateProfile) && actions.push(syncActionCreators.updateApplicant(newstate));
	        return actions;
	      }
	    },
	    'Employment Gaps': {
	      component: (0, _react.createFactory)(_EmploymentGapsSummary2.default),
	      model: 'employmentGaps',
	      validation: {},
	      validator: function validator() {
	        return true;
	      }
	    },
	    Skills: {
	      component: (0, _react.createFactory)(_SkillsSummary2.default),
	      model: 'skills',
	      validation: {},
	      validator: function validator() {
	        return true;
	      }
	    },
	    Licenses: {
	      component: (0, _react.createFactory)(_LicensesSummary2.default),
	      model: 'licenses',
	      validation: {},
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Professional Designations': {
	      component: (0, _react.createFactory)(_ProfessionalDesignationsSummary2.default),
	      model: 'designations',
	      validation: {},
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Professional Associations': {
	      component: (0, _react.createFactory)(_ProfessionalAssociationsSummary2.default),
	      model: 'associations',
	      validation: {},
	      validator: function validator() {
	        return true;
	      }
	    },
	    Introduction: {
	      component: _f_Introduction2.default,
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Status Determination': {
	      component: _f_StatusDetermination2.default,
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Medicare and Social Security': {
	      component: _f_MedicareSocialSecurity2.default,
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    },
	    'Behavioral Interview': {
	      component: (0, _react.createFactory)(_f_BehavioralInterview2.default),
	      model: 'behavioralAnswers',
	      validator: function validator(question, value) {
	        var errors = [];
	        if (question && question.required && _lodash2.default.isEmpty(value)) {
	          errors.push('This field is requried.');
	        }
	        return errors;
	      },
	      saveFunc: function saveFunc(applicant, group, arrayIndex) {
	        var actions = [];
	        applicant.behavioralAnswers && actions.push(asyncActionCreators.updateApplicantBehavioralAnswers(applicant, applicant.behavioralAnswers, group, arrayIndex));
	        applicant.profile.viewState && actions.push(asyncActionCreators.updateApplicantAdmin(applicant, group, arrayIndex));
	        return actions;
	      }
	    },
	    'Work Objectives': {
	      component: (0, _react.createFactory)(_f_WorkObjectives2.default),
	      model: 'workObjectives',
	      validator: function validator(question, value) {
	        var errors = [];
	        if (question && question.required && _lodash2.default.isEmpty(value)) {
	          errors.push('This field is requried.');
	        } else if (question && value.length > 4000) {
	          errors.push('Max length is 4000 characters.');
	        }
	
	        return errors;
	      },
	      saveFunc: function saveFunc(applicant, group, arrayIndex) {
	        var actions = [];
	        applicant.workObjectives && actions.push(asyncActionCreators.updateApplicantWorkObjectives(applicant, applicant.workObjectives, group, arrayIndex));
	        applicant.profile.viewState && actions.push(asyncActionCreators.updateApplicantAdmin(applicant, group, arrayIndex));
	        return actions;
	      }
	    },
	    Ratings: {
	      component: (0, _react.createFactory)(_f_Ratings2.default),
	      model: 'ratings',
	      validator: function validator() {
	        return true;
	      },
	      saveFunc: function saveFunc(applicant, group, arrayIndex) {
	        var actions = [];
	        applicant.ratings && actions.push(asyncActionCreators.updateApplicantInterviewRatings(applicant, applicant.ratings, group, arrayIndex));
	        applicant.profile.viewState && actions.push(asyncActionCreators.updateApplicantAdmin(applicant, group, arrayIndex));
	        return actions;
	      }
	    },
	    'Determination of Status': {
	      component: (0, _react.createFactory)(_f_DeterminationOfStatus2.default),
	      model: 'profile',
	      validator: function validator() {
	        return true;
	      }
	    }
	  }
	};

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	exports.default = FrontView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyDate2 = _interopRequireDefault(_prettyDate);
	
	var _emailLink = __webpack_require__(305);
	
	var _emailLink2 = _interopRequireDefault(_emailLink);
	
	var _Ribbon = __webpack_require__(893);
	
	var _Ribbon2 = _interopRequireDefault(_Ribbon);
	
	var _EditIcon = __webpack_require__(203);
	
	var _EditIcon2 = _interopRequireDefault(_EditIcon);
	
	var _GuideIcon = __webpack_require__(887);
	
	var _GuideIcon2 = _interopRequireDefault(_GuideIcon);
	
	var _DocumentIcon = __webpack_require__(302);
	
	var _DocumentIcon2 = _interopRequireDefault(_DocumentIcon);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _prettyPhone = __webpack_require__(47);
	
	var _prettyPhone2 = _interopRequireDefault(_prettyPhone);
	
	var _prettyAddress = __webpack_require__(463);
	
	var _prettyAddress2 = _interopRequireDefault(_prettyAddress);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _impersonation = __webpack_require__(316);
	
	var impersonationApi = _interopRequireWildcard(_impersonation);
	
	var _staticData = __webpack_require__(28);
	
	var _status = __webpack_require__(209);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dropDownCustomization = {
	  labelStyle: {
	    color: '#ffffff',
	    paddingLeft: '10px'
	  }
	};
	
	FrontView.propTypes = {
	  statusColor: _react.PropTypes.string,
	  staticData: _react.PropTypes.object,
	  applicant: _react.PropTypes.object,
	  profile: _react.PropTypes.object,
	  user: _react.PropTypes.object,
	  followUpTask: _react.PropTypes.object,
	  stateToggle: _react.PropTypes.func,
	  toggleGuide: _react.PropTypes.func,
	  onStatusChange: _react.PropTypes.func,
	  style: _react.PropTypes.object,
	  route: _react.PropTypes.object
	};
	
	function FrontView(props) {
	  var _props$applicant = props.applicant,
	      user = _props$applicant.user,
	      profile = _props$applicant.profile;
	
	
	  var currentUser = props.user;
	
	  var qualifyingSpecialistsKeyById = _lodash2.default.keyBy(props.staticData.qualifyingSpecialists, 'employeeId');
	
	  var selectedStatus = _lodash2.default.get(props.tempState, 'applicantStatus.id', null) || _lodash2.default.get(props.applicant.profile, 'applicantStatus.id', null);
	  var stateName = _lodash2.default.isNumber(user.state) ? _lodash2.default.find(props.staticData.stateList, { id: user.state }) ? _lodash2.default.find(props.staticData.stateList, { id: user.state }).name : 'N/A' : (user.state || {}).name;
	
	  // Get hash query for guide.
	  var hash = '';
	  var currentCategory = props.route.params.category;
	  var currentSubCategory = props.route.params.subcategory;
	
	  switch (currentCategory) {
	    case 'Profile':
	      hash = 'Preliminary-Interview-0';
	      if (currentSubCategory === 'Preliminary Profile') {
	        hash = 'General-Instructions-1';
	      } else if (currentSubCategory === 'Conclusion to the Interview') {
	        hash = 'Status-Determination-2';
	      }
	      break;
	    case 'Review':
	      hash = 'Application-Assessments-Review-4';
	      if (currentSubCategory === 'Preliminary Profile') {
	        hash = 'General-Instructions-5';
	      } else if (currentSubCategory === 'Application') {
	        hash = 'Application-Resume-7';
	      } else if (currentSubCategory === 'Assessments') {
	        hash = 'Assessments-8';
	      }
	      break;
	    case 'Interview':
	      hash = 'Application-Interview-12';
	      if (currentSubCategory === 'Introduction') {
	        hash = 'General-Instructions-13';
	      } else if (currentSubCategory === 'Preferences Availability') {
	        hash = 'Availability-Date-14';
	      } else if (currentSubCategory === 'Work Objectives') {
	        hash = 'Work-Objectives-15';
	      } else if (!!~['Work Experience', 'Skills'].indexOf(currentSubCategory)) {
	        hash = 'Work-Experience-Skills-16';
	      } else if (currentSubCategory === 'Assessments') {
	        hash = 'Assessments-17';
	      } else if (currentSubCategory === 'Behavioral Interview') {
	        hash = 'Behavioral-Questions-18';
	      } else if (currentSubCategory === 'Determination of Status') {
	        hash = 'Status-Determination-Conclusion-19';
	      }
	      break;
	    default:
	  }
	
	  function phoneType(id) {
	    if (id) {
	      var phonType = _lodash2.default.find(props.staticData.phoneTypeList, { id: id });
	      if (phonType && phoneType.name) {
	        return phonType.name.replace('Mobile', 'Cell');
	      }
	    }
	    return '';
	  }
	
	  function handleImpersonation() {
	    impersonationApi.resetImpersonation(user.id).then(function () {
	      if (window) {
	        var win = window.open('/applicant', 'applicant');
	        win.focus();
	      }
	    });
	  }
	
	  function handleGuide() {
	    if (window) {
	      var win = window.open('/admin/guide#' + hash, 'guide');
	      win.focus();
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'front-card',
	      'data-id': user.email + ' front',
	      key: 'Front Card ' + props.applicant.profile.id,
	      style: props.style },
	    _react2.default.createElement(
	      'div',
	      { className: 'status-flag-container clearfix' },
	      _react2.default.createElement(_c_DropDownMenu2.default, _extends({ style: { backgroundColor: props.statusColor },
	        'data-id': 'Status Dropdown',
	        className: 'applicant-status-dropdown',
	        value: selectedStatus,
	        menuItems: props.staticData.applicantStatus,
	        onChange: props.onStatusChange.bind(this, 'applicantStatus')
	      }, dropDownCustomization))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'main-card' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card-sections col-1' },
	        _react2.default.createElement(
	          'div',
	          { className: 'name-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'full-name', 'data-id': 'Full Name' },
	            user.firstName + ' ' + user.middleName + ' ' + user.lastName
	          ),
	          user.nickName && _lodash2.default.trim(user.nickName) !== '' && _react2.default.createElement(
	            'div',
	            { className: 'nickname', 'data-id': 'Nickname' },
	            '( ',
	            user.nickName,
	            ' )'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'qs-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'full-name', 'data-id': 'Full Name' },
	            'QS: ',
	            (qualifyingSpecialistsKeyById[profile.qualifyingSpecialistId] || {}).firstName,
	            ' ',
	            (qualifyingSpecialistsKeyById[profile.qualifyingSpecialistId] || {}).lastName
	          )
	        ),
	        profile.availabilityDate && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'date-heading' },
	            'Availability Date:'
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'date' },
	            (0, _prettyDate2.default)(profile.availabilityDate)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'updatedDate-email-address-contactTime-badges-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'email', 'data-id': 'Email' },
	            (0, _emailLink2.default)(user.email)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'address' },
	            (0, _prettyAddress2.default)(_extends({}, user, { stateName: stateName }))
	          ),
	          false // this is going to be included in the future
	          && _react2.default.createElement(
	            'div',
	            { className: 'badge-container' },
	            _react2.default.createElement(_Ribbon2.default, null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'card-sections col-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'state-timezone-container' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'date-heading' },
	              'Applied:'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'date' },
	              (0, _prettyDate2.default)(profile.dateCreated)
	            )
	          ),
	          profile.qualifiedDate && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'date-heading' },
	              'Qualified:'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'date' },
	              (0, _prettyDate2.default)(profile.qualifiedDate)
	            )
	          ),
	          profile.dateModifiedByApplicant && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'date-heading' },
	              'Updated:'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'date' },
	              (0, _prettyDate2.default)(profile.dateModifiedByApplicant)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'timezone', 'data-id': 'Timezone' },
	            user.timezone.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'contactTime' },
	            'Time to Contact: ',
	            user.bestContactTime.name || props.staticData.bestContactTimeList.find(function (time) {
	              return time.id === user.bestContactTime;
	            }).name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'phoneNumbers-edit-container' },
	            new Array(3).fill(null).map(function (__, index) {
	              return user['phoneNumber' + (index + 1)] && _react2.default.createElement(
	                'div',
	                { className: 'phoneNumber-container', key: index },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'phoneType', 'data-id': 'phoneType' + (index + 1) },
	                  index === 0 ? 'Main (' + phoneType(_lodash2.default.get(user, 'phoneType' + (index + 1))) + '):' : phoneType(_lodash2.default.get(user, 'phoneType' + (index + 1))) + ':'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'phoneNumber', 'data-id': 'phoneNumber' + (index + 1) },
	                  (0, _prettyPhone2.default)(_lodash2.default.get(user, 'phoneNumber' + (index + 1), ''))
	                )
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'card-sections col-3' },
	        _react2.default.createElement(
	          'div',
	          { className: 'status-dropdown' },
	          _react2.default.createElement(_c_DropDownMenu2.default, _extends({ style: { backgroundColor: props.statusColor },
	            'data-id': 'Status Dropdown',
	            className: 'applicant-status-dropdown',
	            value: selectedStatus,
	            menuItems: props.staticData.applicantStatus,
	            onChange: props.onStatusChange.bind(this, 'applicantStatus')
	          }, dropDownCustomization))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'application-container' },
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', className: 'view-resume-btn', href: '/admin/Qualified/' + profile.id + '/Profile/resume' },
	            _react2.default.createElement(_c_FlatButton2.default, { className: 'view-resume-btn',
	              label: 'Resume'
	            })
	          ),
	          selectedStatus !== _staticData.APPLICANT_STATUS.NOT_QUALIFIED && _lodash2.default.intersection(currentUser.roles, ['Admin', 'Qualifying Specialist', 'Placement Specialist', 'Reference Specialist', 'Support Assistant']).length > 0 && _react2.default.createElement(_c_FlatButton2.default, { className: 'view-resume-btn',
	            label: (0, _status.isQualified)(parseInt(selectedStatus)) ? 'Record' : 'Application',
	            onClick: handleImpersonation
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-container' },
	          _react2.default.createElement(
	            _IconButton2.default,
	            { tooltip: 'Edit', tooltipPosition: 'bottom-center', className: 'icon-btn', 'data-id': 'edit', onClick: props.stateToggle.bind(this, 'edit', 1) },
	            _react2.default.createElement(_EditIcon2.default, null)
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            { tooltip: 'Guide', tooltipPosition: 'bottom-center', className: 'icon-btn', 'data-id': 'guide', onClick: handleGuide },
	            _react2.default.createElement(_GuideIcon2.default, null)
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            { tooltip: 'Assessments', tooltipPosition: 'bottom-center', onClick: props.stateToggle.bind(this, 'edit', 2) },
	            _react2.default.createElement(
	              'div',
	              { className: 'scores-icon-wrapper' },
	              _react2.default.createElement('a', { className: 'scores-icon', 'data-id': 'star' })
	            )
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            { tooltip: 'Document', tooltipPosition: 'bottom-center', className: 'icon-btn', 'data-id': 'document', onClick: props.stateToggle.bind(this, 'edit', 3) },
	            _react2.default.createElement(_DocumentIcon2.default, null)
	          )
	        )
	      )
	    )
	  );
	}

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp, _class3, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	// helper function to get top + left pixels
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(399);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _querystring = __webpack_require__(105);
	
	var _isServer = __webpack_require__(207);
	
	var _isServer2 = _interopRequireDefault(_isServer);
	
	var _getPosition = __webpack_require__(897);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTextSize2 = __webpack_require__(899);
	
	var _getTextSize3 = _interopRequireDefault(_getTextSize2);
	
	var _deepUnset = __webpack_require__(304);
	
	var _deepUnset2 = _interopRequireDefault(_deepUnset);
	
	var _r_Modal = __webpack_require__(97);
	
	var _r_Modal2 = _interopRequireDefault(_r_Modal);
	
	var _CloseX = __webpack_require__(69);
	
	var _CloseX2 = _interopRequireDefault(_CloseX);
	
	var _TackIcon = __webpack_require__(205);
	
	var _TackIcon2 = _interopRequireDefault(_TackIcon);
	
	var _c_FadeOnChange = __webpack_require__(450);
	
	var _c_FadeOnChange2 = _interopRequireDefault(_c_FadeOnChange);
	
	var _f_FrontCard = __webpack_require__(1113);
	
	var _f_FrontCard2 = _interopRequireDefault(_f_FrontCard);
	
	var _c_EditCard = __webpack_require__(1109);
	
	var _c_EditCard2 = _interopRequireDefault(_c_EditCard);
	
	var _AssessmentsContainer = __webpack_require__(932);
	
	var _AssessmentsContainer2 = _interopRequireDefault(_AssessmentsContainer);
	
	var _c_DocumentsCard = __webpack_require__(1108);
	
	var _c_DocumentsCard2 = _interopRequireDefault(_c_DocumentsCard);
	
	var _c_Steps = __webpack_require__(1105);
	
	var _c_Steps2 = _interopRequireDefault(_c_Steps);
	
	var _r_Events = __webpack_require__(1118);
	
	var _r_Events2 = _interopRequireDefault(_r_Events);
	
	var _f_SubNav = __webpack_require__(1106);
	
	var _f_SubNav2 = _interopRequireDefault(_f_SubNav);
	
	var _c_StatusConfirmation = __webpack_require__(1111);
	
	var _c_StatusConfirmation2 = _interopRequireDefault(_c_StatusConfirmation);
	
	var _async = __webpack_require__(37);
	
	var asyncActionCreators = _interopRequireWildcard(_async);
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _employees = __webpack_require__(62);
	
	var _enums = __webpack_require__(92);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var statusFlagStyles = {
	  padding: '6px 12px',
	  letterSpacing: '.5px',
	  fontSize: '15px'
	};
	
	var memoizeColor = {};
	
	var ExpandedCard = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var arrayIndex = void 0;
	  var searchQuery = state.routing.locationBeforeTransitions.query.search;
	  var currentRoute = _lodash2.default.get(state.routing, 'locationBeforeTransitions.pathname', '');
	  var applicant = state.admin.applicant;
	  var applicantGroupName = _lodash2.default.get(state.admin.applicant, 'profile.statusGroup');
	
	  if (applicant && !memoizeColor[applicant.profile.applicantStatus.name]) {
	    memoizeColor[applicant.profile.applicantStatus.name] = (0, _lodash2.default)(state.staticData.applicantStatus).filter(function (status) {
	      return status.name === applicant.profile.applicantStatus.name;
	    }).head().color;
	  }
	
	  var availabilityDateMoreThan4Months = false;
	  var availabilityDate45DaysOrLess = false;
	  var availabilityDateBetween45DaysAnd4Months = false;
	
	  if (applicant && applicant.profile.availabilityDate) {
	    var timeDiff = new Date(applicant.profile.availabilityDate).getTime() - new Date().getTime();
	    availabilityDateMoreThan4Months = Math.ceil(timeDiff / (1000 * 3600 * 24)) > 120; // 4 Months.
	    availabilityDate45DaysOrLess = Math.ceil(timeDiff / (1000 * 3600 * 24)) <= 45; // 45 Days.
	    availabilityDateBetween45DaysAnd4Months = !(availabilityDateMoreThan4Months || availabilityDate45DaysOrLess);
	  }
	
	  return {
	    // grab applicant corresponding to route email
	    viewOrder: (0, _lodash.get)(state, 'labels.viewOrder', []),
	    applicant: applicant,
	    availabilityDateMoreThan4Months: availabilityDateMoreThan4Months,
	    availabilityDate45DaysOrLess: availabilityDate45DaysOrLess,
	    availabilityDateBetween45DaysAnd4Months: availabilityDateBetween45DaysAnd4Months,
	    profile: state.applicantProfile,
	    admin: state.admin,
	    user: state.user,
	    behavioralAnswers: state.behavioralAnswers,
	    workObjectives: state.workObjectives,
	    workExperiences: state.workExperiences,
	    ratings: state.ratings,
	    assessments: state.assessments,
	    licenses: state.licenses,
	    designations: state.designations,
	    skills: state.skills,
	    applicantGroupName: applicantGroupName,
	    applicantStatus: _lodash2.default.get(applicant, 'profile.applicantStatus.name'),
	    navColumnState: props.params.navColumnState,
	    arrayIndex: arrayIndex,
	    statusColor: memoizeColor[_lodash2.default.get(applicant, 'profile.applicantStatus.name')],
	    staticData: state.staticData,
	    tempState: state.tempState,
	    search: searchQuery,
	    pins: state.pins,
	    route: {
	      current: currentRoute,
	      params: props.params,
	      query: props.location.query // actually being from from react-redux-router to regular props
	    } };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ExpandedCard, _Component);
	
	  function ExpandedCard(props, context) {
	    _classCallCheck(this, ExpandedCard);
	
	    // performance optimization
	    var _this = _possibleConstructorReturn(this, (ExpandedCard.__proto__ || Object.getPrototypeOf(ExpandedCard)).call(this, props, context));
	
	    _this.state = {
	      confirmationOpen: false,
	      deleteConfirmationOpen: false,
	      newStatus: {},
	      oldStatus: {},
	      guideOpen: false,
	      activeStepIndex: 0,
	      activeSubStepIndex: 0,
	      offScreen: false, // flag for if current card is on screen
	      collapsedStyle: {}, // collapsing anim styling
	      expandedStyle: {
	        'min-height': 218,
	        'min-width': 672,
	        width: '70%'
	      },
	      worksheetStyle: {
	        stepsContainer: {
	          subnav: {
	            marginTop: 10,
	            marginBottom: 10,
	            height: 55
	          },
	          steps: {
	            height: 294
	          }
	        },
	        alertsContainer: {
	          height: 700,
	          width: '100%',
	          marginLeft: 0
	        },
	        cardTranslateX: 0,
	        cardTranslateY: 0,
	        worksheetTranslateY: 0,
	        worksheetScaleX: 0,
	        worksheetScaleY: 0,
	        closeTranslateX: 0,
	        detailToggleTranslateY: 0 // expanded worksheet style
	      } };
	
	    _this.toggleGuide = function () {
	      _this.setState(_lodash2.default.merge({}, _this.state, { guideOpen: !_this.state.guideOpen }));
	    };
	
	    _this.cancelConfirmation = function () {
	      var updatedApplicant = _this.props.applicant;
	      updatedApplicant.profile.applicantStatus = _this.state.oldStatus;
	      _this.props.dispatch(syncActionCreators.updateApplicant(updatedApplicant));
	
	      _this.setState({
	        confirmationOpen: false,
	        newStatus: {},
	        oldStatus: {}
	      });
	    };
	
	    _this.cancelDeleteConfirmation = function () {
	      _this.setState({
	        deleteConfirmationOpen: false
	      });
	    };
	
	    _this.continueConfirmation = function () {
	      var updatedStatus = _this.state.newStatus;
	      // Move Qualified  applicant to Qualified in queue if availabilityDate > 45.
	      if (updatedStatus.id === _enums.APPLICANT_STATUS.QUALIFIED_CANDIDATE && _this.props.availabilityDateBetween45DaysAnd4Months) {
	        updatedStatus = {
	          id: _enums.APPLICANT_STATUS.QUALIFIED_CANDIDATE_IN_QUEUE,
	          name: 'Qualified Candidate in Queue'
	        };
	      }
	
	      // Move Qualified applicant to Qualified in waiting if availabilityDate > 4 months.
	      else if (updatedStatus.id === _enums.APPLICANT_STATUS.QUALIFIED_CANDIDATE && _this.props.availabilityDateMoreThan4Months) {
	          updatedStatus = {
	            id: _enums.APPLICANT_STATUS.QUALIFIED_IN_WAITING,
	            name: 'Qualified in Waiting'
	          };
	        }
	
	      _this.updateApplicantStatus(updatedStatus);
	      _this.setState({
	        confirmationOpen: false,
	        newStatus: {},
	        oldStatus: {}
	      });
	    };
	
	    _this.continueDeleteConfirmation = function () {
	      _this.props.dispatch(asyncActionCreators.deleteApplicant(_this.props.applicant.profile.id, _this.props.applicantGroupName));
	      _this.setState({
	        deleteConfirmationOpen: false
	      });
	      _this.onClose();
	    };
	
	    _this.updateTempState = function (parent, prop, event, val, cb) {
	      var newTempState = _lodash2.default.cloneDeep(_this.props.tempState);
	      var propPath = parent && !prop ? parent : !parent && prop ? prop : '' + parent + (prop[0] === '[' ? '' : '.') + prop;
	
	      if (val === undefined) {
	        // unsets parent objects if they are empty
	        (0, _deepUnset2.default)(newTempState, propPath);
	      } else {
	        _lodash2.default.setWith(newTempState, propPath, val, Object);
	      }
	
	      _this.props.dispatch(syncActionCreators.updateTempState(newTempState));
	
	      if (typeof cb === 'function') {
	        cb();
	      }
	    };
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_reactAddonsPureRenderMixin2.default);
	    _this.setDimensions = _this.setDimensions.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpandedCard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.params.email) {
	        this.setDimensions();
	        this.props.dispatch(asyncActionCreators.retrieve(this.props.params.email));
	        this.props.dispatch(asyncActionCreators.getProfileById(this.props.params.email));
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.setDimensions);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.applicant && nextProps.applicant) {
	        this.props.dispatch(asyncActionCreators.getProfileById(nextProps.applicant.profile.id));
	        this.setDimensions();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.applicantStatus) {
	        return;
	      }
	      if (this.props.applicantStatus !== prevProps.applicantStatus) {
	        // if status changes, update dimensions
	        this.setDimensions();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dispatch(syncActionCreators.clearApplicant());
	      window.removeEventListener('resize', this.setDimensions);
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.props.dispatch((0, _reactRouterRedux.push)('/admin/' + this.props.route.params.navColumnState + '/' + (0, _querystring.stringify)(_lodash2.default.omit(this.props.route.query, ['edit', 'detail']))));
	    }
	  }, {
	    key: 'onChangeStep',
	    value: function onChangeStep(index, url) {
	      var _this2 = this;
	
	      this.setState(function (prevState) {
	        var newState = _lodash2.default.cloneDeep(prevState);
	        newState.activeStepIndex = index;
	        return _lodash2.default.merge({}, _this2.state, newState);
	      }, function () {
	        if (url) {
	          _this2.props.dispatch((0, _reactRouterRedux.push)(url));
	        }
	      });
	    }
	
	    // handles tempState updates
	
	  }, {
	    key: 'onStatusChange',
	    value: function onStatusChange(property, event, value, name) {
	      if (value === _lodash2.default.get(this.props.applicant.profile, 'applicantStatus.id', null)) {
	        return;
	      }
	      // handle dropdown
	      if (name) {
	        value = {
	          id: value,
	          name: name
	        };
	      }
	
	      // Confirm popup for qualifed.
	      if (!!~[_enums.APPLICANT_STATUS.QUALIFIED_CANDIDATE, _enums.APPLICANT_STATUS.QUALIFIED_IN_WAITING, _enums.APPLICANT_STATUS.QUALIFIED_CANDIDATE_IN_QUEUE].indexOf(value.id)) {
	        this.setState({
	          confirmationOpen: true,
	          newStatus: value,
	          oldStatus: _lodash2.default.get(this.props.applicant.profile, 'applicantStatus', null)
	        });
	
	        var updatedApplicant = this.props.applicant;
	        updatedApplicant.profile.applicantStatus = value;
	        this.props.dispatch(syncActionCreators.updateApplicant(updatedApplicant));
	      } else {
	        this.updateApplicantStatus(value);
	      }
	    }
	  }, {
	    key: 'onDeletion',
	    value: function onDeletion() {
	      this.setState({
	        deleteConfirmationOpen: true
	      });
	    }
	  }, {
	    key: 'setDimensions',
	    value: function setDimensions() {
	      var collapsedStyle = {};
	      var statusTagTransform = '';
	      var offScreen = false;
	      if (!_isServer2.default) {
	        var element = document.getElementById(this.props.params.id);
	
	        if (!element) {
	          // handle element off screen case
	          offScreen = true;
	          statusTagTransform = 'translate3d(calc(-100% - 21px),0,0)'; // initial style
	        } else {
	          // collapsed card calculations
	          var dimCollapsed = (0, _getPosition2.default)(element);
	          var scaleY = dimCollapsed.height / this.state.expandedStyle.height;
	          var scaleX = dimCollapsed.width / this.state.expandedStyle.width;
	          var translateX = window.innerWidth / 2 - dimCollapsed.left + this.state.expandedStyle.width * (1 - scaleX) / 2;
	          var translateY = window.innerHeight / 2 - dimCollapsed.top + this.state.expandedStyle.height * (1 - scaleY) / 2;
	          collapsedStyle.transform = 'translate3d(' + -translateX + 'px, ' + -translateY + 'px,0) scale(' + scaleX + ',' + scaleY + ')';
	
	          // status flag calculations
	
	          var _getTextSize = (0, _getTextSize3.default)(this.props.applicant.profile.applicantStatus.name, statusFlagStyles),
	              $textWidth = _getTextSize.width; // textwidth is used to standardize accross different text lengths
	
	
	          var widthConstant = 260;
	          var $scaleDown = 10;
	          var $scaleUp = 1.8;
	          var $scaleX = 1 / $scaleDown * $scaleUp * widthConstant / $textWidth;
	          var $scaleY = 1 * $scaleUp * 76 / dimCollapsed.height; // 'dimCollapsed.height' used to adjust based on height of card
	          var $endTranslateX = -100;
	          var $translateX = $endTranslateX - 100 * $scaleDown / $scaleUp / 2 - 100 * (1.135 - $scaleUp) * widthConstant * 2 / $textWidth;
	          var $endTranslateY = 0;
	          var $translateY = $endTranslateY + $scaleDown * 1.5 * 76 / dimCollapsed.height; // 'dimCollapsed.height' used to adjust based on height of card
	          var $leftPadding = 42;
	          statusTagTransform = 'scale(' + $scaleX + ', ' + $scaleY + ') translate3d(calc(' + $translateX + '% - ' + $leftPadding / 2 + 'px), ' + $translateY + '%, 0)';
	        }
	      }
	
	      var openInWindow = this.props.route.query.openInWindow === '1';
	
	      // worksheet calculations
	      var worksheetStyle = this.state.worksheetStyle;
	
	      // step calculations
	      var stepsContainerHeight = openInWindow ? global.innerHeight : global.innerHeight - 211 - 35; //card height + subnav height
	
	      // notes calculations
	      var notesFullWidth = worksheetStyle.alertsContainer.width + worksheetStyle.alertsContainer.marginLeft; // width + margin
	
	      this.setState(_lodash2.default.merge({}, this.state, {
	        offScreen: offScreen,
	        collapsedStyle: _lodash2.default.merge(this.state.collapsedStyle, collapsedStyle),
	        worksheetStyle: {
	          stepsContainer: {
	            steps: {
	              height: stepsContainerHeight - worksheetStyle.stepsContainer.subnav.height - worksheetStyle.stepsContainer.subnav.marginTop - worksheetStyle.stepsContainer.subnav.marginBottom
	            }
	          },
	          alertsContainer: {
	            top: -this.state.expandedStyle.height,
	            right: -notesFullWidth
	          },
	          alertsContainerScaleY: this.state.expandedStyle.height / worksheetStyle.alertsContainer.height,
	          stepsContainerScaleY: this.state.expandedStyle.height / stepsContainerHeight,
	          cardTranslateX: notesFullWidth / 2,
	          cardTranslateY: stepsContainerHeight / 2,
	          closeTranslateX: notesFullWidth,
	          detailToggleTranslateY: stepsContainerHeight
	        },
	        statusTagTransform: statusTagTransform
	      }));
	    }
	  }, {
	    key: 'stateToggle',
	    value: function stateToggle(prop, state) {
	
	      var updatedQueryString = (0, _querystring.stringify)(_lodash2.default.merge({}, this.props.route.query, _defineProperty({}, prop, state)));
	
	      var route = this.props.route.current;
	
	      // Add the default cateogry and subcategory terms to route.
	      if (route.split('/').length === 4) {
	        this.props.dispatch((0, _reactRouterRedux.push)(route + '/' + this.props.viewOrder[0].key + '/' + (updatedQueryString ? '?' + updatedQueryString : '')));
	      } else {
	        this.props.dispatch((0, _reactRouterRedux.push)('' + route + (updatedQueryString ? '?' + updatedQueryString : '')));
	      }
	    }
	  }, {
	    key: 'isPinned',
	    value: function isPinned(pinnedApplicant) {
	      return _lodash2.default.get(this.props.pins, 'pinned.applicants', []).indexOf(pinnedApplicant.profile.id) >= 0;
	    }
	  }, {
	    key: 'togglePin',
	    value: function togglePin(applicant) {
	      var _this3 = this;
	
	      var newPinnedData = this.props.pins.pinned;
	      if (this.isPinned(applicant)) {
	        _lodash2.default.pull(newPinnedData.applicants, applicant.profile.id);
	      } else {
	        _lodash2.default.set(newPinnedData, 'applicants', _lodash2.default.union(_lodash2.default.get(newPinnedData, 'applicants', []), [applicant.profile.id]));
	      }
	
	      this.props.dispatch((0, _employees.updatePins)(newPinnedData, function (err, pins) {
	        if (!err) {
	          _this3.props.dispatch(syncActionCreators.loadPins(pins));
	        }
	      }));
	    }
	  }, {
	    key: 'updateApplicantStatus',
	    value: function updateApplicantStatus(status) {
	      this.props.dispatch(asyncActionCreators.updateApplicantStatus(this.props.applicant, status, this.props.applicantGroupName, this.props.arrayIndex));
	    }
	  }, {
	    key: 'updateApplicant',
	    value: function updateApplicant(updatedApplicant, callback) {
	      var _this4 = this;
	
	      var update = _lodash2.default.merge({}, updatedApplicant, {
	        profile: {
	          id: this.props.applicant.profile.id
	        },
	        user: {
	          id: this.props.applicant.user.id
	        }
	      });
	      this.props.dispatch(asyncActionCreators.updateApplicantAdmin(update, this.props.applicantGroupName, this.props.arrayIndex, function (err) {
	        if (err) {
	          if (callback) return callback(err);
	        }
	        _this4.props.dispatch(syncActionCreators.updateApplicant(update));
	        if (callback) return callback(null, update);
	      }));
	    }
	  }, {
	    key: 'updateApplicantAssessments',
	    value: function updateApplicantAssessments(tempState) {
	      if (tempState.assessments) {
	        this.props.dispatch(asyncActionCreators.updateApplicantAssessments(this.props.applicant, tempState.assessments), this.updateTempState('assessments', '', null, {}));
	      }
	    }
	  }, {
	    key: 'renderCard',
	    value: function renderCard(editIsOpen, detailIsOpen, scoreIsOpen, documentIsOpen) {
	      var followUpTask = (0, _lodash2.default)(this.props.applicant.profile.tasks).filter(function (task) {
	        return task.taskFollowUpDate && new Date(task.taskFollowUpDate) - Date.now() > 0;
	      }).sortBy(function (task) {
	        return new Date(task.taskFollowUpDate);
	      }).head();
	      if (editIsOpen) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'expanded-card' },
	          _react2.default.createElement(_c_EditCard2.default, { user: this.props.user,
	            applicant: this.props.applicant,
	            staticData: this.props.staticData,
	            stateToggle: this.stateToggle.bind(this),
	            updateApplicant: this.updateApplicant.bind(this),
	            dispatch: this.props.dispatch,
	            onDeletion: this.onDeletion.bind(this),
	            open: editIsOpen })
	        );
	      } else if (scoreIsOpen) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'expanded-card' },
	          _react2.default.createElement(_AssessmentsContainer2.default, { open: scoreIsOpen, stateToggle: this.stateToggle.bind(this) })
	        );
	      } else if (documentIsOpen) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'expanded-card' },
	          _react2.default.createElement(_c_DocumentsCard2.default, { applicant: this.props.applicant, staticData: this.props.staticData, stateToggle: this.stateToggle.bind(this), open: documentIsOpen })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expanded-card' },
	        _react2.default.createElement(_f_FrontCard2.default, {
	          applicant: this.props.applicant,
	          user: this.props.user,
	          profile: this.props.profile,
	          staticData: this.props.staticData,
	          statusColor: this.props.statusColor,
	          followUpTask: followUpTask,
	          stateToggle: this.stateToggle.bind(this),
	          onStatusChange: this.onStatusChange.bind(this),
	          style: this.state.expandedStyle,
	          toggleGuide: this.toggleGuide.bind(this),
	          route: this.props.route })
	      );
	    }
	  }, {
	    key: 'renderEvents',
	    value: function renderEvents() {
	      var alertsContainer = this.state.worksheetStyle.alertsContainer;
	
	
	      return _react2.default.createElement(_r_Events2.default, {
	        style: alertsContainer,
	        applicant: this.props.applicant,
	        applicantStatusColor: this.props.statusColor,
	        taskTypes: this.props.staticData.applicantTaskTypeList,
	        taskResultTypes: this.props.staticData.applicantTaskResultList,
	        taskList: this.props.applicant.alertsList,
	        route: this.props.route
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      // convert string #s to boolean
	      var editIsOpen = this.props.route.query.edit === '1';
	      var scoreIsOpen = this.props.route.query.edit === '2';
	      var documentIsOpen = this.props.route.query.edit === '3';
	      var detailIsOpen = !!+this.props.route.query.detail;
	      var openInWindow = this.props.route.query.openInWindow === '1';
	
	      var _state$worksheetStyle = this.state.worksheetStyle,
	          closeTranslateX = _state$worksheetStyle.closeTranslateX,
	          detailToggleTranslateY = _state$worksheetStyle.detailToggleTranslateY,
	          stepsContainer = _state$worksheetStyle.stepsContainer,
	          alertsContainer = _state$worksheetStyle.alertsContainer,
	          cardTranslateX = _state$worksheetStyle.cardTranslateX,
	          cardTranslateY = _state$worksheetStyle.cardTranslateY,
	          alertsContainerScaleY = _state$worksheetStyle.alertsContainerScaleY,
	          stepsContainerScaleY = _state$worksheetStyle.stepsContainerScaleY;
	
	      // conditional upon whether or not current card is on screen
	
	      var currentModalProps = this.state.offScreen ? {
	        floatDownModalChildren: true,
	        transformTransitionOut: 'ease-in-out'
	      } : {
	        childAnimInit: this.state.collapsedStyle
	      };
	
	      return this.props.applicant && _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('applicant-card-container', { openInWindow: openInWindow }) },
	        this.state.confirmationOpen && _react2.default.createElement(_c_StatusConfirmation2.default, {
	          message: this.state.newStatus.id == 11 && 'Are you sure this applicant is a Qualified Candidate and should be exported to Bullhorn?',
	          cancelFunc: this.cancelConfirmation,
	          continueFunc: this.continueConfirmation
	        }),
	        this.state.deleteConfirmationOpen && _react2.default.createElement(_c_StatusConfirmation2.default, {
	          message: 'Are you sure want to delete the account?',
	          cancelFunc: this.cancelDeleteConfirmation,
	          continueFunc: this.continueDeleteConfirmation
	        }),
	        _react2.default.createElement(
	          _r_Modal2.default,
	          _extends({
	            show: true, fadeModal: true, fadeModalChildren: true, noScroll: true, outsideUnclickable: true,
	            onClose: this.onClose.bind(this),
	            transitionDuration: 400,
	            opacityTransitionIn: 'cubic-bezier(0,1,.2,.8)',
	            childStyle: detailIsOpen && { transform: 'translate3d(calc(-50% - ' + cardTranslateX + 'px), calc(-50% - ' + cardTranslateY + 'px), 0)' } || {},
	            modalContentClass: (0, _classnames2.default)('expanded-card-container', { 'edit-view': editIsOpen, 'score-view': scoreIsOpen, 'document-view': documentIsOpen, 'detail-view': detailIsOpen })
	          }, currentModalProps),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-actions' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pin', onClick: this.togglePin.bind(this, this.props.applicant) },
	              ' ',
	              _react2.default.createElement(_TackIcon2.default, null),
	              ' ',
	              this.isPinned(this.props.applicant) ? 'unpin' : 'pin'
	            )
	          ),
	
	          // Disable close for window popup.
	          !openInWindow && _react2.default.createElement(ModalClose, { removeState: (editIsOpen || detailIsOpen || scoreIsOpen || documentIsOpen) && this.stateToggle.bind(this, editIsOpen || scoreIsOpen || documentIsOpen ? 'edit' : 'detail', 0) }),
	          this.renderCard(editIsOpen, detailIsOpen, scoreIsOpen, documentIsOpen),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('worksheet') },
	            _react2.default.createElement(_f_SubNav2.default, {
	              dispatch: this.props.dispatch,
	              route: this.props.route,
	              style: stepsContainer.subnav,
	              activeStepIndex: this.state.activeStepIndex,
	              onChangeStep: this.onChangeStep.bind(this)
	            }),
	            this.props.children || _react2.default.createElement(_c_Steps2.default, { style: stepsContainer,
	              applicantGroupName: this.props.applicantGroupName,
	              arrayIndex: this.props.arrayIndex,
	              dispatch: this.props.dispatch,
	              staticData: this.props.staticData,
	              tempState: this.props.tempState,
	              updateApplicant: this.updateApplicant.bind(this),
	              updateApplicantStatus: this.updateApplicantStatus.bind(this),
	              behavioralAnswers: this.props.behavioralAnswers,
	              workObjectives: this.props.workObjectives,
	              workExperiences: this.props.workExperiences,
	              ratings: this.props.ratings,
	              skills: this.props.skills,
	              licenses: this.props.licenses,
	              designations: this.props.designations,
	              applicant: this.props.applicant,
	              activeStepIndex: this.state.activeStepIndex,
	              assessments: this.props.assessments,
	              toggleGuide: this.toggleGuide,
	              guideOpen: this.state.guideOpen,
	              onChangeStep: this.onChangeStep.bind(this),
	              route: this.props.route
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-events' },
	            this.renderEvents()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'detail-toggle outside-card', 'data-id': 'View ' + (detailIsOpen ? 'Card' : 'Worksheet'), onClick: this.stateToggle.bind(this, 'detail', 1) },
	            'View ',
	            _react2.default.createElement(
	              _c_FadeOnChange2.default,
	              null,
	              detailIsOpen ? 'Card' : 'Worksheet'
	            )
	          ),
	          _react2.default.createElement(
	            'style',
	            null,
	            '\n              .modal-show.detail-view .modal-close {\n                //transform: translate3d(' + closeTranslateX + 'px, -100%, 0);\n              }\n              .modal-show.detail-view .detail-toggle {\n                //transform: translate3d(0, ' + detailToggleTranslateY + 'px, 0);\n              }\n\n              .modal-fade .alerts-container {\n                //transform: translate3d(calc(-100% - ' + alertsContainer.marginLeft + 'px), calc(-50% + ' + this.state.expandedStyle.height / 2 + 'px), 0) scale3d(1,' + alertsContainerScaleY + ',1);\n              }\n              .modal-fade .steps-container {\n                //transform: translate3d(0, calc(-100% + ' + (this.state.expandedStyle.height / 2 + stepsContainer.subnav.marginTop) + 'px), 0) scale3d(1,' + stepsContainerScaleY + ',1);\n              }\n              .modal-fade .status-flag-container {\n                //transform: ' + this.state.statusTagTransform + '\n              }\n\n              ' + (this.state.offScreen ? '\n                .status-flag-container {\n                  color: hsla(0,0%,100%,.9) !important;\n                }\n\n                .status-flag {\n                  border-radius: 0 !important;\n                  opacity:\n                }\n              ' : '') + '\n            '
	          )
	        )
	      ) || _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return ExpandedCard;
	}(_react.Component), _class2.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  applicant: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  behavioralAnswers: _react.PropTypes.object,
	  workObjectives: _react.PropTypes.object,
	  ratings: _react.PropTypes.object,
	  assessments: _react.PropTypes.object,
	  applicantGroupName: _react.PropTypes.string,
	  applicantStatus: _react.PropTypes.string,
	  skills: _react.PropTypes.object.isRequired,
	  tempState: _react.PropTypes.object.isRequired,
	  arrayIndex: _react.PropTypes.number,
	  navColumnState: _react.PropTypes.string,
	  statusColor: _react.PropTypes.string,
	  staticData: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  closeModal: _react.PropTypes.func, // comes from modal, includes modal animation,
	  viewOrder: _react.PropTypes.array.isRequired
	}, _temp)) || _class);
	
	// creating separate component as slight hack needed to allow access to animating "closeModal" function in close button
	
	exports.default = ExpandedCard;
	var ModalClose = (_temp2 = _class3 = function (_Component2) {
	  _inherits(ModalClose, _Component2);
	
	  function ModalClose() {
	    _classCallCheck(this, ModalClose);
	
	    var _this5 = _possibleConstructorReturn(this, (ModalClose.__proto__ || Object.getPrototypeOf(ModalClose)).call(this));
	
	    _this5.respondToKeyPress = _this5.respondToKeyPress.bind(_this5);
	    return _this5;
	  }
	
	  _createClass(ModalClose, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.respondToKeyPress);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.respondToKeyPress);
	    }
	  }, {
	    key: 'respondToKeyPress',
	    value: function respondToKeyPress(event) {
	      // escape key response
	      if (event.keyCode === 27 && this.props.closeModal) {
	        // if(this.props.removeState && !event.shiftKey) {
	        //   return this.props.removeState();
	        // }
	
	        this.props.closeModal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-close outside-card', 'data-id': 'Close', onClick: this.props.closeModal },
	        'Close ',
	        _react2.default.createElement(_CloseX2.default, { style: { color: '#fff' } })
	      );
	    }
	  }]);
	
	  return ModalClose;
	}(_react.Component), _class3.propTypes = {
	  closeModal: _react.PropTypes.func,
	  removeState: _react.PropTypes.any
	}, _temp2);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	// get validations
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _fixLines = __webpack_require__(234);
	
	var _fixLines2 = _interopRequireDefault(_fixLines);
	
	var _applicantNote = __webpack_require__(901);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validationObj = (0, _applicantNote.getSchema)();
	
	var dropDownProps = {
	  style: {
	    height: '45px',
	    width: '100%',
	    fontSize: '14.5px',
	    textTransform: 'none',
	    textAlign: 'left'
	  },
	  labelStyle: {
	    padding: 0
	  },
	  listStyle: {
	    width: '260px'
	  },
	  menuStyle: {
	    width: '260px'
	  },
	  underlineStyle: {
	    margin: 0,
	    borderTopWidth: '1px'
	  },
	  iconStyle: {
	    right: 0
	  }
	};
	
	var AddNoteForm = (_temp2 = _class = function (_Component) {
	  _inherits(AddNoteForm, _Component);
	
	  function AddNoteForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddNoteForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddNoteForm.__proto__ || Object.getPrototypeOf(AddNoteForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      noteDropDownVal: null, // some statuses will have corresponding dropdowns
	      note: (0, _lodash.get)(_this.props.selectedItem, 'note'),
	      category: (0, _lodash.get)(_this.props.selectedItem, 'category', _this.props.category),
	      errorCount: 0
	    }, _this.onErrorChange = function (changeInt) {
	      _this.setState((0, _lodash.merge)(_this.state, { errorCount: _this.state.errorCount + changeInt }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddNoteForm, [{
	    key: 'onChange',
	    value: function onChange(prop, event, value) {
	      this.setState((0, _lodash.merge)({}, this.state, _defineProperty({}, prop, value || event.target.value)));
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	      this.props.submitNote({
	        applicantId: this.props.applicantId,
	        applicantStatusId: this.props.applicantStatusId,
	        category: this.state.category,
	        color: this.props.color,
	        note: (0, _fixLines2.default)(this.state.note)
	      });
	      this.clear();
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.setState((0, _lodash.merge)({}, {
	        noteDropDownVal: null,
	        note: ''
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'form',
	        { className: 'event-form notes-form' },
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'type-dropdown note-dropdown',
	          floatingLabelText: 'Type of Note',
	          floatingLabelStyle: { left: 0, top: '-10px' },
	          defaultValue: this.state.category,
	          menuItems: this.props.categories,
	          onChange: this.onChange.bind(this, 'category'),
	          'data-id': 'type of note'
	        }, dropDownProps)),
	        _react2.default.createElement(_c_TextArea2.default, {
	          className: 'note-textarea',
	          'data-id': 'Note Text',
	          style: {
	            minHeight: '160px'
	          },
	          onChange: this.onChange.bind(this, 'note'),
	          onErrorChange: this.onErrorChange,
	          value: this.state.note,
	          validation: validationObj.note
	        }),
	        _react2.default.createElement(_c_FlatButton2.default, { disabled: !this.state.note || this.state.errorCount > 0,
	          onClick: this.onSave.bind(this),
	          className: 'save-btn',
	          label: 'Save',
	          'data-id': 'save button',
	          disabledStyle: {
	            color: '#979797',
	            backgroundColor: '#fff'
	          },
	          labelStyle: {
	            width: 'auto',
	            padding: 0
	          } })
	      );
	    }
	  }]);
	
	  return AddNoteForm;
	}(_react.Component), _class.propTypes = {
	  applicantId: _react.PropTypes.number.isRequired,
	  applicantStatusId: _react.PropTypes.number.isRequired,
	  submitNote: _react.PropTypes.func.isRequired,
	  category: _react.PropTypes.string.isRequired,
	  categories: _react.PropTypes.array,
	  color: _react.PropTypes.string.isRequired,
	  selectedItem: _react.PropTypes.object
	}, _temp2);
	exports.default = AddNoteForm;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// utilities
	
	
	// components
	
	
	// get validations
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _c_DropDownMenu = __webpack_require__(19);
	
	var _c_DropDownMenu2 = _interopRequireDefault(_c_DropDownMenu);
	
	var _c_TextArea = __webpack_require__(39);
	
	var _c_TextArea2 = _interopRequireDefault(_c_TextArea);
	
	var _c_FlatButton = __webpack_require__(32);
	
	var _c_FlatButton2 = _interopRequireDefault(_c_FlatButton);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _c_ToggleButton = __webpack_require__(53);
	
	var _c_ToggleButton2 = _interopRequireDefault(_c_ToggleButton);
	
	var _applicantTask = __webpack_require__(902);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validationObj = (0, _applicantTask.getSchema)();
	
	var dropDownProps = {
	  style: {
	    height: '45px',
	    width: '100%',
	    fontSize: '14.5px',
	    textTransform: 'none',
	    textAlign: 'left'
	  },
	  labelStyle: {
	    padding: 0
	  },
	  listStyle: {
	    width: '260px'
	  },
	  menuStyle: {
	    width: '260px'
	  },
	  underlineStyle: {
	    margin: 0,
	    borderTopWidth: '1px'
	  },
	  iconStyle: {
	    right: 0
	  }
	};
	
	var taskStatusBoolean = [{
	  value: false,
	  primaryText: 'Open'
	}, {
	  value: true,
	  primaryText: 'Closed'
	}];
	
	var AddTaskForm = (_temp2 = _class = function (_Component) {
	  _inherits(AddTaskForm, _Component);
	
	  function AddTaskForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddTaskForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddTaskForm.__proto__ || Object.getPrototypeOf(AddTaskForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      taskType: (0, _lodash.get)(_this.props.selectedItem, 'taskTypeId'),
	      taskResultType: (0, _lodash.get)(_this.props.selectedItem, 'taskResultId'),
	      taskFollowUpDate: (0, _lodash.get)(_this.props.selectedItem, 'taskFollowUpDate'),
	      closed: (0, _lodash.get)(_this.props.selectedItem, 'closed', false),
	      taskNote: (0, _lodash.get)(_this.props.selectedItem, 'message'),
	      saveDisabled: true,
	      errorCount: 0
	    }, _this.onErrorChange = function (changeInt) {
	      _this.setState((0, _lodash.merge)(_this.state, { errorCount: _this.state.errorCount + changeInt }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddTaskForm, [{
	    key: 'onChange',
	    value: function onChange(prop, event, value) {
	      var newState = (0, _lodash.merge)({}, this.state, _defineProperty({}, prop, !(0, _lodash.isNil)(value) ? value : (event.target || {}).value));
	
	      // @TODO update this to match other validation
	      newState.saveDisabled = (0, _lodash.isNil)(newState.taskType);
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave() {
	      var _this2 = this;
	
	      var resultText = (0, _lodash.get)((0, _lodash.find)(this.props.taskResultTypes, { id: this.state.taskResultType }) || {}, 'name', null);
	      var taskTypeName = (0, _lodash.get)(this.props.taskTypes.find(function (type) {
	        return type.id === _this2.state.taskType;
	      }), 'name', null);
	
	      this.props.submitTask({
	        applicantId: this.props.applicantId,
	        taskTypeId: this.state.taskType,
	        taskResultId: this.state.taskResultType,
	        taskResultName: resultText,
	        taskFollowUpDate: this.state.taskFollowUpDate,
	        closed: this.state.closed,
	        category: this.props.category,
	        message: this.state.taskNote,
	        taskTypeName: taskTypeName
	      });
	      this.clear();
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.setState((0, _lodash.merge)({}, {
	        taskType: null,
	        taskResultType: null,
	        taskNote: null
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'form',
	        { className: 'event-form task-form' },
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'type-dropdown task-dropdown',
	          floatingLabelText: 'Type of Task',
	          floatingLabelStyle: { left: 0, top: '-10px' },
	          value: this.state.taskType,
	          onChange: this.onChange.bind(this, 'taskType'),
	          menuItems: this.props.taskTypes,
	          'data-id': 'type of task'
	        }, dropDownProps)),
	        _react2.default.createElement(_c_DropDownMenu2.default, _extends({ className: 'type-dropdown task-result',
	          floatingLabelText: 'Result',
	          floatingLabelStyle: { left: 0, top: '-10px' },
	          value: this.state.taskResultType,
	          onChange: this.onChange.bind(this, 'taskResultType'),
	          menuItems: this.props.taskResultTypes,
	          'data-id': 'task result'
	        }, dropDownProps)),
	        _react2.default.createElement(
	          'div',
	          { className: 'follow-up-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('follow-up-form') },
	            _react2.default.createElement(
	              'div',
	              { className: 'label' },
	              'Follow Up Date'
	            ),
	            _react2.default.createElement(_DateInput2.default, {
	              autoOk: true,
	              'data-id': 'follow-up-date',
	              defaultValue: this.state.taskFollowUpDate,
	              value: this.state.taskFollowUpDate,
	              onChange: this.onChange.bind(this, 'taskFollowUpDate') })
	          ),
	          _react2.default.createElement(_c_ToggleButton2.default, {
	            className: 'task-status',
	            'data-id': 'Task Status',
	            style: {
	              width: '100%'
	            },
	            defaultValue: this.state.closed,
	            menuItems: taskStatusBoolean,
	            onChange: this.onChange.bind(this, 'closed')
	          })
	        ),
	        _react2.default.createElement(_c_TextArea2.default, {
	          className: 'other-text',
	          'data-id': 'Task Comment',
	          description: 'Task Comment',
	          style: {
	            minHeight: '100px'
	          },
	          defaultValue: this.state.taskNote,
	          onChange: this.onChange.bind(this, 'taskNote'),
	          onErrorChange: this.onErrorChange,
	          maxLength: 255,
	          validation: validationObj.message
	        }),
	        _react2.default.createElement(_c_FlatButton2.default, { disabled: this.state.saveDisabled || this.state.errorCount > 0,
	          onClick: this.onSave.bind(this),
	          className: 'save-btn',
	          'data-id': 'save button',
	          label: 'Save',
	          disabledStyle: {
	            color: '#979797',
	            backgroundColor: '#fff'
	          },
	          labelStyle: {
	            width: 'auto',
	            padding: 0
	          } })
	      );
	    }
	  }]);
	
	  return AddTaskForm;
	}(_react.Component), _class.propTypes = {
	  submitTask: _react.PropTypes.func,
	  taskTypes: _react.PropTypes.array,
	  taskResultTypes: _react.PropTypes.array,
	  applicantId: _react.PropTypes.number,
	  selectedItem: _react.PropTypes.object,
	  category: _react.PropTypes.string
	}, _temp2);
	exports.default = AddTaskForm;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EventsList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyTime = __webpack_require__(465);
	
	var _prettyTime2 = _interopRequireDefault(_prettyTime);
	
	var _fixLines = __webpack_require__(234);
	
	var _fixLines2 = _interopRequireDefault(_fixLines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EventsList(props) {
	  var _this = this;
	
	  function click(selectedItem) {
	    props.handleClick(selectedItem);
	  }
	
	  return _react2.default.createElement(
	    'ol',
	    {
	      'data-id': 'Event List',
	      className: 'event-list'
	    },
	    props.list.map(function (event, eventIndex) {
	      return _react2.default.createElement(
	        'div',
	        {
	          'data-id': 'Event List Item ' + eventIndex,
	          className: (0, _classnames2.default)('event-list-item', { 'note-item': _lodash2.default.isNil(event.taskTypeId) === 'note', 'task-item': !_lodash2.default.isNil(event.taskTypeId) }),
	          key: eventIndex
	        },
	        _react2.default.createElement('div', {
	          className: 'event-status',
	          style: {
	            backgroundColor: event.color || '#4a4a4a'
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'event-timestamp' },
	          _react2.default.createElement('div', { 'data-id': 'Event Date',
	            className: 'event-date noTextSelect',
	            dangerouslySetInnerHTML: { __html: (0, _prettyDate.fullDate)(new Date(event.dateCreated)) }
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            event.taskTypeName && event.taskTypeName
	          ),
	          !_lodash2.default.isNil(event.taskTypeId) && _react2.default.createElement(
	            'div',
	            { 'data-id': 'Task Status',
	              className: 'task-status noTextSelect'
	            },
	            event.closed ? 'Closed' : 'Open'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'event-content' },
	          _react2.default.createElement(
	            'div',
	            {
	              'data-id': 'Event Title',
	              className: 'event-title noTextSelect',
	              onClick: click.bind(_this, event)
	            },
	            !_lodash2.default.isNil(event.taskTypeId) ? (event.taskResultName ? event.taskResultName : '') + ' (' + (0, _prettyTime2.default)(new Date(event.dateCreated)) + ')' : (event.category || '') + ' Notes'
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              'data-id': 'Event Description',
	              className: 'event-description noTextSelect'
	            },
	            !_lodash2.default.isNil(event.taskFollowUpDate) ? 'Follow up on ' + (0, _moment2.default)(event.taskFollowUpDate).format('L') : ''
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              'data-id': 'Note Sub-Description',
	              className: 'note-details noTextSelect'
	            },
	            !_lodash2.default.isNil(event.taskTypeId) ? (0, _fixLines2.default)(event.message) : (0, _fixLines2.default)(event.note)
	          )
	        )
	      );
	    })
	  );
	}
	
	// utilities
	// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	EventsList.propTypes = {
	  list: _react.PropTypes.array,
	  state: _react.PropTypes.object,
	  category: _react.PropTypes.string
	};
	
	EventsList.defaultProps = {
	  list: [],
	  state: {}
	};

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2; // Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
	
	
	// Redux stuff
	
	
	// utilities
	
	
	// Async actions
	
	
	// components
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _prettyDate = __webpack_require__(75);
	
	var _prettyDate2 = _interopRequireDefault(_prettyDate);
	
	var _async = __webpack_require__(37);
	
	var _f_EventsList = __webpack_require__(1117);
	
	var _f_EventsList2 = _interopRequireDefault(_f_EventsList);
	
	var _c_AddTaskForm = __webpack_require__(1116);
	
	var _c_AddTaskForm2 = _interopRequireDefault(_c_AddTaskForm);
	
	var _c_AddNoteForm = __webpack_require__(1115);
	
	var _c_AddNoteForm2 = _interopRequireDefault(_c_AddNoteForm);
	
	var _DateInput = __webpack_require__(74);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _ChevronIcon = __webpack_require__(98);
	
	var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);
	
	var _StatusFilter = __webpack_require__(863);
	
	var _StatusFilter2 = _interopRequireDefault(_StatusFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// HJP 2018-04-19: The following table should be in the DB, NOT hard-coded
	// Added TechnologySurvey
	var categories = [{ id: 'Preliminary', name: 'Preliminary Profile Interview' }, { id: 'Review', name: 'Review' }, { id: 'Interview', name: 'Interview' }, { id: 'References', name: 'References' }, { id: 'TechnologySurvey', name: 'Technology Survey' }];
	
	// gives dispatch function
	var Events = (_dec = (0, _reactRedux.connect)(function (store) {
	  return {
	    viewOrder: (0, _lodash.get)(store, 'labels.viewOrder', [])
	  };
	}, {
	  submitEvent: _async.submitEvent
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Events, _Component);
	
	  function Events() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Events);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Events.__proto__ || Object.getPrototypeOf(Events)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      activeSection: 'task',
	      addEventToggled: false,
	      selectedItem: null,
	      editMode: false,
	      selectedCategories: [],
	      filterDate: null,
	      sortField: 'dateCreated',
	      sortDescending: true
	    }, _this.handleCategoryFilter = function (e, values) {
	      _this.setState({ selectedCategories: values });
	    }, _this.handleDate = function (e, value) {
	      _this.setState({ filterDate: value });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Events, [{
	    key: 'toggleShow',
	    value: function toggleShow(section) {
	      this.setState(_lodash2.default.merge({}, this.state, {
	        activeSection: section,
	        selectedCategories: [],
	        filterDate: null,
	        sortField: 'dateCreated',
	        sortDescending: true,
	        addEventToggled: false
	      }));
	    }
	  }, {
	    key: 'toggleSort',
	    value: function toggleSort(sortField) {
	      if (this.state.sortField === sortField) {
	        this.setState(_lodash2.default.merge({}, this.state, {
	          sortDescending: !this.state.sortDescending
	        }));
	      } else {
	        this.setState(_lodash2.default.merge({}, this.state, {
	          sortField: sortField,
	          sortDescending: true
	        }));
	      }
	    }
	  }, {
	    key: 'toggleAdd',
	    value: function toggleAdd() {
	      this.setState(_lodash2.default.merge({}, this.state, {
	        addEventToggled: !this.state.addEventToggled,
	        selectedItem: null,
	        editMode: false
	      }));
	    }
	  }, {
	    key: 'submitTask',
	    value: function submitTask(task) {
	      if (this.state.editMode) {
	        task.taskId = this.state.selectedItem.id;
	        this.props.submitEvent('tasks', task, { type: 'edit', param: this.state.selectedItem.id });
	      } else {
	        this.props.submitEvent('tasks', task);
	      }
	
	      this.setState({ selectedItem: null, editMode: false, addEventToggled: false });
	    }
	  }, {
	    key: 'submitNote',
	    value: function submitNote(note) {
	
	      if (this.state.editMode) {
	        note.noteId = this.state.selectedItem.id;
	        this.props.submitEvent('notes', note, { type: 'edit', param: this.state.selectedItem.id });
	      } else {
	        this.props.submitEvent('notes', note);
	      }
	
	      this.setState({ selectedItem: null, editMode: false, addEventToggled: false });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(item) {
	      if (item) {
	        this.setState({ selectedItem: item, editMode: true, addEventToggled: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // yank vars off state
	      var _state = this.state,
	          activeSection = _state.activeSection,
	          addEventToggled = _state.addEventToggled,
	          selectedCategories = _state.selectedCategories,
	          filterDate = _state.filterDate,
	          sortField = _state.sortField,
	          sortDescending = _state.sortDescending;
	
	      // combine event properties and sort by date
	
	      var eventArray = (0, _lodash2.default)([]).concat(activeSection !== 'note' ? this.props.applicant.profile.tasks || [] : []).concat(activeSection !== 'task' ? this.props.applicant.profile.notes || [] : []).filter(function (e) {
	        return filterDate ? (0, _moment2.default)(e.dateCreated).format('YYYY-MM-DD') === (0, _moment2.default)(filterDate).format('YYYY-MM-DD') : e;
	      }).filter(function (e) {
	        return selectedCategories ? _lodash2.default.isEmpty(selectedCategories) || !!~selectedCategories.indexOf(e.category) : e;
	      });
	
	      var eventList = activeSection === 'task' ? eventArray.orderBy(['closed', sortField], ['asc', sortDescending ? 'desc' : 'asc']).value() : eventArray.orderBy([sortField], [sortDescending ? 'desc' : 'asc']).value();
	
	      var alertsStyle = {
	        height: global.innerHeight - 50
	      };
	
	      var catgoryDescription = '';
	      if (this.props.route.params.category) {
	        catgoryDescription = (this.props.viewOrder[this.props.viewOrder.findIndex(function (category) {
	          return category.key === _this2.props.route.params.category;
	        })] || {}).display;
	      } else {
	        // Specially references section.
	        catgoryDescription = _lodash2.default.last(this.props.route.current.split('/'));
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('alerts-container', 'clearfix', activeSection),
	          key: 'Events ' + this.props.applicant.profile.id,
	          style: alertsStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'alerts-nav' },
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'Tasks',
	              className: (0, _classnames2.default)('alerts-nav-item', 'noTextSelect', { active: activeSection === 'task' }),
	              onClick: this.toggleShow.bind(this, 'task') },
	            _react2.default.createElement(
	              'div',
	              { className: 'alerts-nav-text noTextSelect' },
	              'Tasks'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'Notes',
	              className: (0, _classnames2.default)('alerts-nav-item', { active: activeSection === 'note' }),
	              onClick: this.toggleShow.bind(this, 'note') },
	            _react2.default.createElement(
	              'div',
	              { className: 'alerts-nav-text noTextSelect' },
	              'Notes'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'data-id': 'All',
	              className: (0, _classnames2.default)('alerts-nav-item', { active: activeSection === 'all' }),
	              onClick: this.toggleShow.bind(this, 'all') },
	            _react2.default.createElement(
	              'div',
	              { className: 'alerts-nav-text noTextSelect' },
	              'All'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('event-container', { toggled: addEventToggled }) },
	          activeSection !== 'all' && _react2.default.createElement(
	            'div',
	            { 'data-id': 'Add Event',
	              className: (0, _classnames2.default)('add-event', { toggled: addEventToggled }),
	              onClick: !addEventToggled && this.toggleAdd.bind(this) },
	            !addEventToggled && _react2.default.createElement(
	              'div',
	              { className: 'event-heading-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'add-event-text noTextSelect' },
	                'Add ',
	                activeSection === 'task' ? 'Task' : 'Note'
	              )
	            ),
	            addEventToggled && _react2.default.createElement(
	              'div',
	              { className: 'event-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'event-heading-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { 'data-id': 'Add Task', className: (0, _classnames2.default)('add-event-text', 'task', 'noTextSelect', 'active-add') },
	                  'Add ',
	                  activeSection === 'task' ? 'Task' : 'Note'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'data-id': 'Close', className: 'plus noTextSelect', onClick: this.toggleAdd.bind(this) },
	                  '+'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('add-event-form', activeSection) },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'current-date' },
	                  (0, _prettyDate2.default)(_lodash2.default.get(this.state.selectedItem, 'dateCreated', new Date()))
	                ),
	                activeSection === 'task' && _react2.default.createElement(_c_AddTaskForm2.default, {
	                  applicantId: this.props.applicant.profile.id,
	                  submitTask: this.submitTask.bind(this),
	                  taskTypes: this.props.taskTypes,
	                  taskResultTypes: this.props.taskResultTypes,
	                  category: catgoryDescription,
	                  selectedItem: this.state.selectedItem
	                }) || _react2.default.createElement(_c_AddNoteForm2.default, {
	                  applicantId: this.props.applicant.profile.id,
	                  applicantStatusId: this.props.applicant.profile.applicantStatus.id,
	                  submitNote: this.submitNote.bind(this),
	                  category: catgoryDescription,
	                  categories: categories,
	                  color: this.props.applicantStatusColor,
	                  selectedItem: this.state.selectedItem
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'notes-filter-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'notes-sort' },
	              activeSection !== 'note' && _react2.default.createElement(
	                'div',
	                { 'data-id': 'Follow Up Date', className: 'sort-field follow-up-date', onClick: this.toggleSort.bind(this, 'taskFollowUpDate') },
	                'Follow Up Date',
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('chevron', {
	                      descending: this.state.sortField === 'taskFollowUpDate' && this.state.sortDescending,
	                      ascending: this.state.sortField === 'taskFollowUpDate' && !this.state.sortDescending
	                    })
	                  },
	                  _react2.default.createElement(_ChevronIcon2.default, null)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'data-id': 'Date Added', className: 'sort-field updated-date', onClick: this.toggleSort.bind(this, 'dateCreated') },
	                'Date Added',
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('chevron', {
	                      descending: this.state.sortField === 'dateCreated' && this.state.sortDescending,
	                      ascending: this.state.sortField === 'dateCreated' && !this.state.sortDescending
	                    })
	                  },
	                  _react2.default.createElement(_ChevronIcon2.default, null)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'notes-filter' },
	              _react2.default.createElement(_DateInput2.default, {
	                'data-id': 'Filter Notes By Date',
	                autoOk: true,
	                onChange: this.handleDate
	              }),
	              _react2.default.createElement(_StatusFilter2.default, {
	                menuItems: categories,
	                onChange: this.handleCategoryFilter.bind(this)
	              })
	            )
	          ),
	          _react2.default.createElement(_f_EventsList2.default, {
	            list: eventList,
	            activeSection: this.state.activeSection,
	            category: catgoryDescription,
	            handleClick: this.handleClick.bind(this)
	          })
	        )
	      );
	    }
	  }]);
	
	  return Events;
	}(_react.Component), _class2.propTypes = {
	  submitEvent: _react.PropTypes.func.isRequired,
	  applicant: _react.PropTypes.object.isRequired,
	  applicantStatusColor: _react.PropTypes.string.isRequired,
	  show: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  taskTypes: _react.PropTypes.array,
	  taskResultTypes: _react.PropTypes.array,
	  alertsList: _react.PropTypes.array,
	  route: _react.PropTypes.object.isRequired,
	  viewOrder: _react.PropTypes.object.isRequired
	}, _temp2)) || _class);
	exports.default = Events;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxDevtools = __webpack_require__(433);
	
	var _reduxDevtoolsLogMonitor = __webpack_require__(2974);
	
	var _reduxDevtoolsLogMonitor2 = _interopRequireDefault(_reduxDevtoolsLogMonitor);
	
	var _reduxDevtoolsDockMonitor = __webpack_require__(2965);
	
	var _reduxDevtoolsDockMonitor2 = _interopRequireDefault(_reduxDevtoolsDockMonitor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Configure redux devtools
	var DevTools = (0, _reduxDevtools.createDevTools)(_react2.default.createElement(
	  _reduxDevtoolsDockMonitor2.default,
	  {
	    defaultSize: 0.15,
	    toggleVisibilityKey: 'ctrl-h',
	    changePositionKey: 'ctrl-m' },
	  _react2.default.createElement(_reduxDevtoolsLogMonitor2.default, null)
	));
	
	exports.default = DevTools;

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.createApplicantDocument = createApplicantDocument;
	exports.deleteApplicantDocument = deleteApplicantDocument;
	function createApplicantDocument(applicantId, clientId, docInfo, done) {
	  return function (simpleIsoFetch) {
	    return function () {
	
	      simpleIsoFetch.post({
	        route: "/api/applicants/" + applicantId + "/documents/" + clientId,
	        body: docInfo
	      }).then(function (_ref) {
	        var _ref$body$data$items = _slicedToArray(_ref.body.data.items, 1),
	            id = _ref$body$data$items[0];
	
	        return id;
	      }).then(function (id) {
	        return done(null, id);
	      }).catch(done);
	    };
	  };
	}
	
	function deleteApplicantDocument(applicantId, clientId, done) {
	  return function (simpleIsoFetch) {
	    return function () {
	
	      simpleIsoFetch.del("/api/applicants/" + applicantId + "/documents/" + clientId).then(function () {
	        return done(null);
	      }).catch(done);
	    };
	  };
	}

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getGuide = getGuide;
	exports.saveGuide = saveGuide;
	function getGuide(cb) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.get('/api/admin/guides').then(function (_ref) {
	        var _ref$body$data$items = _slicedToArray(_ref.body.data.items, 1),
	            guide = _ref$body$data$items[0];
	
	        return cb ? cb(null, guide) : guide;
	      }).catch(function (error) {
	        return cb ? cb(error) : Promise.reject(error);
	      });
	    };
	  };
	}
	
	function saveGuide() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      content = _ref2.content,
	      navigation = _ref2.navigation;
	
	  var cb = arguments[1];
	
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.post({
	        route: '/api/admin/guides',
	        body: {
	          content: content,
	          navigation: navigation
	        }
	      }).then(function (_ref3) {
	        var _ref3$body$data$items = _slicedToArray(_ref3.body.data.items, 1),
	            guide = _ref3$body$data$items[0];
	
	        return cb ? cb(null, guide) : guide;
	      }).catch(function (error) {
	        return cb ? cb(error) : Promise.reject(error);
	      });
	    };
	  };
	}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateJobRequest = updateJobRequest;
	exports.updateJobRequestStatus = updateJobRequestStatus;
	
	var _sync = __webpack_require__(21);
	
	var syncActionCreators = _interopRequireWildcard(_sync);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _bluebird = __webpack_require__(171);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/* global Symbol */
	function updateJobRequest(id, body, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({
	        route: '/api/jobs/' + id,
	        body: body
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	          return err;
	        }
	      });
	    };
	  };
	}
	
	function updateJobRequestStatus(id, statusId, callback) {
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      return simpleIsoFetch.put({
	        route: '/api/jobs/' + id + '/status/' + statusId
	      }).then(function (resp) {
	        if (callback && callback.success) return callback.success(resp.body.data.items);
	
	        return resp.body.data.items;
	      }, function (err) {
	        if (callback && callback.error) return callback.error(err);
	
	        return err;
	      }).catch(function (err) {
	        if (!err || !~[400].indexOf(err.status)) {
	          console.log(err);
	          return err;
	        }
	      });
	    };
	  };
	}

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.loadData = loadData;
	
	var _lodash = __webpack_require__(4);
	
	function loadData(_ref) {
	  var success = _ref.success,
	      error = _ref.error;
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.get('/api/labels').then(function (_ref2) {
	        var _ref2$body$data$items = _slicedToArray(_ref2.body.data.items, 1),
	            labels = _ref2$body$data$items[0];
	
	        return labels ? labels.labelData : {};
	      }).then(success).catch(error);
	    };
	  };
	}

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.loadData = loadData;
	function loadData(_ref) {
	  var success = _ref.success,
	      error = _ref.error;
	
	  return function (simpleIsoFetch) {
	    return function (dispatch) {
	      simpleIsoFetch.get('/api/types').then(function (_ref2) {
	        var _ref2$body$data$items = _slicedToArray(_ref2.body.data.items, 1),
	            staticData = _ref2$body$data$items[0];
	
	        return staticData;
	      }).then(success).catch(error);
	    };
	  };
	}

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveLicense = saveLicense;
	exports.deleteLicense = deleteLicense;
	
	var _common = __webpack_require__(480);
	
	function saveLicense(applicantId, license, callback) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.post('/api/v2/applicants/' + applicantId + '/licenses', {
	        body: license
	      }).then(function (resp) {
	        return resp.data;
	      }).then((0, _common.done)(callback)).catch((0, _common.error)(callback));
	    };
	  };
	}
	
	function deleteLicense(applicantId, clientId, callback) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.del('/api/v2/applicants/' + applicantId + '/licenses/' + clientId).then(function (resp) {
	        return resp.data;
	      }).then((0, _common.done)(callback)).catch((0, _common.error)(callback));
	    };
	  };
	}

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTechnologySurvey = getTechnologySurvey;
	exports.saveTechnologySurvey = saveTechnologySurvey;
	exports.submitTechnologySurvey = submitTechnologySurvey;
	
	var _common = __webpack_require__(480);
	
	function getTechnologySurvey(applicantId, callback) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.get('/api/v2/applicants/' + applicantId + '/technology').then(function (resp) {
	        return resp.data;
	      }).then((0, _common.done)(callback)).catch((0, _common.error)(callback));
	    };
	  };
	}
	
	function saveTechnologySurvey(applicantId, survey, callback) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.post('/api/v2/applicants/' + applicantId + '/technology', {
	        body: survey
	      }).then(function (resp) {
	        return resp && resp.body && resp.body.data;
	      }).then((0, _common.done)(callback)).catch((0, _common.error)(callback));
	    };
	  };
	}
	
	function submitTechnologySurvey(applicantId, survey, callback) {
	  return function (simpleIsoFetch) {
	    return function () {
	      return simpleIsoFetch.post('/api/v2/applicants/' + applicantId + '/technology/submit', {
	        body: survey
	      }).then(function (resp) {
	        return resp && resp.body && resp.body.data;
	      }).then((0, _common.done)(callback)).catch((0, _common.error)(callback));
	    };
	  };
	}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logout = logout;
	
	var _actionTypes = __webpack_require__(20);
	
	function logout() {
	  return {
	    type: _actionTypes.LOG_OUT
	  };
	}

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateImpersonateUser = updateImpersonateUser;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function updateImpersonateUser(_ref) {
	  var impersonateUser = _ref.impersonateUser;
	
	  return {
	    type: actionTypes.UPDATE_IMPERSONATE_USER,
	    impersonateUser: impersonateUser
	  };
	} // action type strings

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateJobRequest = updateJobRequest;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function updateJobRequest(jobRequest) {
	  return {
	    type: actionTypes.UPDATE_JOB_REQUEST,
	    jobRequest: jobRequest
	  };
	} // action type strings

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateLabels = updateLabels;
	
	var _actionTypes = __webpack_require__(20);
	
	function updateLabels(labels) {
	  return {
	    type: _actionTypes.UPDATE_LABELS,
	    labels: labels
	  };
	}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateApplicantLicenses = updateApplicantLicenses;
	
	var _actionTypes = __webpack_require__(20);
	
	function updateApplicantLicenses(applicantId, licenses) {
	  return {
	    type: _actionTypes.UPDATE_APPLICANT_LICENSES,
	    applicantId: applicantId,
	    licenses: licenses
	  };
	}

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateStaticData = updateStaticData;
	
	var _actionTypes = __webpack_require__(20);
	
	function updateStaticData(staticData) {
	  return {
	    type: _actionTypes.UPDATE_STATIC_DATA,
	    staticData: staticData
	  };
	}

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateTechnologySurvey = updateTechnologySurvey;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function updateTechnologySurvey(technologySurvey) {
	  return {
	    type: actionTypes.UPDATE_TECHNOLOGY_SURVEY,
	    technologySurvey: technologySurvey
	  };
	} // action type strings

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = adminReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _contacts = __webpack_require__(237);
	
	var _companies = __webpack_require__(483);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var initialState = exports.initialState = {
	  applicants: {
	    list: {},
	    search: {},
	    pinned: []
	  },
	  contacts: {
	    searchTerms: [],
	    filters: {},
	    pinned: [],
	    page: 0,
	    pageSize: 25
	  },
	  companies: {
	    searchTerms: [],
	    filters: {},
	    pinned: []
	  },
	  jobRequests: {
	    searchTerms: [],
	    filters: {},
	    pinned: []
	  },
	  applicant: null,
	  navColumnState: null
	};
	
	function adminReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var clonedState = void 0;
	  var contactInContactWorksheet = void 0;
	  var index = void 0;
	  switch (action.type) {
	    case actionTypes.UPDATE_APPLICANTS_LIST:
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'applicants.search', action.applicants);
	      return clonedState;
	
	    case actionTypes.UPDATE_CONTACTS_LIST:
	      clonedState = Object.assign({}, state, {
	        contacts: action.contacts
	      });
	      clonedState.contacts.pinned = state.contacts.pinned;
	      clonedState.contacts.filters = state.contacts.filters || {};
	      clonedState.contacts.searchTerms = state.contacts.searchTerms || [];
	      return clonedState;
	
	    case actionTypes.UPDATE_CONTACTS_PAGE:
	      clonedState = Object.assign({}, state, {
	        contacts: action.data
	      });
	      clonedState.contacts.pinned = state.contacts.pinned;
	      clonedState.contacts.filters = state.contacts.filters || {};
	      clonedState.contacts.searchTerms = state.contacts.searchTerms || [];
	      clonedState.contacts.page = state.contacts.page || 0;
	      clonedState.contacts.pageSize = state.contacts.pageSize || 25;
	      return clonedState;
	
	    case actionTypes.UPDATE_COMPANIES_LIST:
	      clonedState = Object.assign({}, state, {
	        companies: action.companies
	      });
	      clonedState.companies.pinned = state.companies.pinned;
	      clonedState.companies.filters = state.companies.filters || {};
	      clonedState.companies.searchTerms = state.companies.searchTerms || [];
	      return clonedState;
	
	    case actionTypes.UPDATE_COMPANIES_PAGE:
	      clonedState = Object.assign({}, state, {
	        companies: action.data
	      });
	      clonedState.companies.pinned = state.companies.pinned;
	      clonedState.companies.filters = state.companies.filters || {};
	      clonedState.companies.searchTerms = state.companies.searchTerms || [];
	      return clonedState;
	
	    case actionTypes.UPDATE_COMPANY:
	      clonedState = Object.assign({}, state);
	      var criteriaCompany = { id: action.company.id };
	      var existsInCompany = (0, _companies.companyInGroups)(criteriaCompany, clonedState.companies) || [];
	      existsInCompany.map(function (group) {
	        if (group.name !== "items") {
	          if (group === action.newGroup || group === 'pinned') {
	            clonedState.companies[group.name][group.index] = action.company;
	          } else {
	            clonedState.companies[group.name].splice(group.index, 1);
	          }
	        } else {
	          clonedState.companies[group.name][group.index] = action.company;
	        }
	      });
	
	      if (action.newGroup && !clonedState.companies[action.newGroup]) {
	        clonedState.companies[action.newGroup] = [];
	      }
	
	      if (action.newGroup && action.newGroup !== 'pinned') {
	        clonedState.companies[action.newGroup].push(action.company);
	      }
	
	      // TODO: Not sure we can just use the one from status list.
	      clonedState.company = _lodash2.default.merge({}, clonedState.company, action.company);
	
	      return clonedState;
	
	    case actionTypes.CLEAR_CONTACT_IN_CONTACT_WORKSHEET:
	      return _extends({}, state, { contactInContactWorksheet: {} });
	
	    case actionTypes.UPDATE_CONTACT_IN_CONTACT_WORKSHEET:
	      return _extends({}, state, { contactInContactWorksheet: _lodash2.default.merge({}, state.contactInContactWorksheet, action.contact) });
	
	    case actionTypes.UPDATE_CONTACT:
	      clonedState = Object.assign({}, state);
	      var criteria = { profile: { id: action.contact.profile.id } };
	
	      var contactIndex = _lodash2.default.findIndex(_lodash2.default.get(clonedState, 'contacts.items'), criteria);
	
	      if (contactIndex === -1) {
	
	        console.warn('This contact cannot be found in \'admin.contacts\' store. This could be because a misuse of this UPDATE_CONTACT action type (in certain cases).\n          \'admin.contacts\' has all contacts of the current page of Contact Dashboard. The contact You\'re trying to update is not in this page.\n          ');
	
	        return clonedState;
	      }
	
	      _lodash2.default.set(clonedState, 'contacts.items[' + contactIndex + ']', action.contact);
	
	      return clonedState;
	    case actionTypes.UPDATE_APPLICANTS_PAGE:
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'applicants.search.' + action.group, action.data);
	      return clonedState;
	
	    case actionTypes.ADD_APPLICANT_ADMIN:
	      clonedState = _lodash2.default.cloneDeep(state);
	
	      var Group = _lodash2.default.get(action, 'applicant.profile.statusGroup');
	
	      // Add new applicant to the top of group.
	      if (Group && clonedState.applicants.search[Group]) {
	        clonedState.applicants.search[Group].items.unshift(action.applicant);
	        clonedState.applicants.search[Group].total++;
	      }
	
	      return clonedState;
	
	    case actionTypes.DELETE_APPLICANT_ADMIN:
	      clonedState = _lodash2.default.cloneDeep(state);
	
	      index = clonedState.applicants.search[action.group].items.findIndex(function (applicant) {
	        return applicant.profile.id === action.applicantId;
	      });
	      // updating specific applicant
	      if (~index) {
	        clonedState.applicants.search[action.group].items.splice(index, 1);
	        clonedState.applicants.search[action.group].total--;
	      }
	
	      // if applicant is pinned, update pinned copy
	      index = clonedState.applicants.pinned.findIndex(function (applicant) {
	        return applicant.profile.id === action.applicantId;
	      });
	      if (~index) {
	        clonedState.applicants.pinned.splice(index, 1);
	      }
	
	      return clonedState;
	
	    case actionTypes.UPDATE_APPLICANT_ADMIN:
	      clonedState = _lodash2.default.cloneDeep(state);
	      var newGroup = action.newGroup;
	      var id = action.updatedApplicant.profile.id;
	
	      index = clonedState.applicants.search[action.group].items.findIndex(function (applicant) {
	        return applicant.profile.id === id;
	      });
	      var original = [];
	
	      // updating specific applicant
	      if (newGroup && newGroup !== action.group) {
	        if (~index) {
	          original = clonedState.applicants.search[action.group].items.splice(index, 1);
	          clonedState.applicants.search[action.group].total--;
	        }
	        if (clonedState.applicants.search[newGroup] && clonedState.applicants.search[newGroup].items) {
	          clonedState.applicants.search[newGroup].items.unshift(_lodash2.default.merge(!_lodash2.default.isEmpty(original) && original[0], action.updatedApplicant));
	          clonedState.applicants.search[newGroup].total++;
	        }
	      } else {
	        _lodash2.default.mergeWith(clonedState.applicants.search[action.group].items[index], action.updatedApplicant, function (dest, src) {
	          // CAN'T CHANGE STUFF TO NULL, WILL FIX LATER
	          return _lodash2.default.merge(dest, src);
	        });
	      }
	
	      // if applicant is pinned, update pinned copy
	      index = clonedState.applicants.pinned.findIndex(function (applicant) {
	        return applicant.profile.id === action.updatedApplicant.profile.id;
	      });
	      if (~index) {
	        _lodash2.default.mergeWith(clonedState.applicants.pinned[index], action.updatedApplicant, function (dest, src) {
	          // CAN'T CHANGE STUFF TO NULL, WILL FIX LATER
	          return _lodash2.default.merge(dest, src);
	        });
	      }
	
	      // update current applicant
	      _lodash2.default.mergeWith(clonedState.applicant, action.updatedApplicant, function (dest, src) {
	        // CAN'T CHANGE STUFF TO NULL, WILL FIX LATER
	        return _lodash2.default.merge(dest, src);
	      });
	
	      return clonedState;
	
	    case actionTypes.UPDATE_CURRENT_APPLICANT_ADMIN:
	      clonedState = _lodash2.default.cloneDeep(state);
	      clonedState.applicant = action.applicant;
	
	      return clonedState;
	
	    case actionTypes.UPDATE_EVENT_LIST:
	      clonedState = _lodash2.default.cloneDeep(state);
	
	      // updating applicant events (tasks, notes, notifications)
	
	      var _action$event = action.event,
	          eventRoute = _action$event.eventRoute,
	          event = _objectWithoutProperties(_action$event, ['eventRoute']);
	
	      var applicantObj = clonedState.applicant;
	      if (applicantObj.profile.id === event.applicantId && event.noteId) {
	        if (!applicantObj.profile[eventRoute]) {
	          applicantObj.profile[eventRoute] = []; // account for if value is null
	        }
	
	        applicantObj.profile[eventRoute].map(function (targetEvent) {
	          if (targetEvent.id === event.noteId) {
	            targetEvent.note = event.note;
	            targetEvent.category = event.category;
	            targetEvent.dateModified = Date();
	          }
	        });
	      } else if (applicantObj.profile.id === event.applicantId && event.taskId) {
	        if (!applicantObj.profile[eventRoute]) {
	          applicantObj.profile[eventRoute] = []; // account for if value is null
	        }
	
	        applicantObj.profile[eventRoute].map(function (targetEvent) {
	          if (targetEvent.id === event.taskId) {
	            targetEvent.taskTypeId = event.taskTypeId;
	            targetEvent.taskResultId = event.taskResultId;
	            targetEvent.taskFollowUpDate = event.taskFollowUpDate;
	            targetEvent.closed = event.closed;
	            targetEvent.message = event.message;
	          }
	        });
	      } else if (applicantObj.profile.id === event.applicantId) {
	        if (!applicantObj.profile[eventRoute]) {
	          applicantObj.profile[eventRoute] = []; // account for if value is null
	        }
	
	        applicantObj.profile[eventRoute].push(event);
	      }
	
	      return clonedState;
	
	    case actionTypes.UPDATE_CONTACT_EVENT_LIST:
	
	      // updating contact events (tasks, notes, notifications)
	
	      clonedState = _lodash2.default.cloneDeep(state);
	      contactInContactWorksheet = _lodash2.default.get(clonedState, 'contactInContactWorksheet', {});
	
	      // For contactInContactWorksheet
	      clonedState.contactInContactWorksheet = processEventList(contactInContactWorksheet, action);
	
	      // For contacts.items
	      clonedState.contacts.items = (0, _lodash2.default)(clonedState.contacts.items).map(function (contactObj) {
	        return processEventList(contactObj, action);
	      }).value();
	
	      return clonedState;
	
	    case actionTypes.CHANGE_NAV_COLUMN_STATE:
	      return Object.assign({}, state, {
	        navColumnState: action.navColumnState
	      });
	
	    case actionTypes.UPDATE_PINNED_APPLICANTS:
	      var newState = _lodash2.default.merge({}, state);
	      var pinnedApplicant = action.applicant;
	      index = newState.applicants.pinned.findIndex(function (applicant) {
	        return applicant.profile.id === pinnedApplicant.profile.id;
	      });
	      if (~index) {
	        newState.applicants.pinned.splice(index, 1);
	      } else {
	        newState.applicants.pinned.push(pinnedApplicant);
	      }
	
	      return newState;
	
	    case actionTypes.FETCH_PINNED_APPLICANTS:
	      var admin = _lodash2.default.merge({}, state);
	      var applicants = action.applicants;
	      admin.applicants.pinned = applicants;
	
	      return admin;
	
	    case actionTypes.GET_COMPANY_INFO:
	      var newCompany = action.company;
	      var oldCompany = _extends({}, state.company);
	      var companies = _extends({}, state.companies);
	      var existsIn = (0, _companies.companyInGroups)({ id: newCompany.id }, companies);
	      var belongsIn = (0, _companies.findGrouping)({ company: newCompany, groups: action.groups });
	      var move = true;
	      contactInContactWorksheet = _lodash2.default.get(state, 'contactInContactWorksheet', {});
	      var contacts = _lodash2.default.get(state, 'contacts.items', []);
	
	      existsIn.forEach(function (_ref) {
	        var name = _ref.name,
	            index = _ref.index;
	        return belongsIn.group !== name ? companies[name].splice(index, 1) : move = false;
	      });
	      if (move) {
	        if (!companies[belongsIn.group]) {
	          companies[belongsIn.group] = [];
	        }
	        companies[belongsIn.group].push(newCompany);
	      }
	
	      var newContacts = _lodash2.default.map(contacts, function (contact) {
	
	        if (contact.company.id === newCompany.id) {
	          return _extends({}, contact, { company: newCompany });
	        }
	
	        return contact;
	      });
	
	      return Object.assign({}, state, {
	        companies: companies,
	        company: newCompany,
	        contacts: _extends({}, state.contacts, { items: newContacts }),
	        contactInContactWorksheet: _extends({}, contactInContactWorksheet, { company: newCompany })
	      });
	
	    case actionTypes.UPDATE_CONTACTS_TABLE_SEARCH_TERMS:
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'contacts.searchTerms', action.searchTerms);
	      return clonedState;
	
	    case actionTypes.UPDATE_CONTACTS_TABLE_FILTERS:
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'contacts.filters', {});
	      _lodash2.default.forEach(action.filters, function (val, key) {
	        clonedState.contacts.filters[key] = val;
	      });
	      return clonedState;
	    case actionTypes.UPDATE_COMPANIES_TABLE_FILTERS:
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'companies.filters', {});
	      _lodash2.default.forEach(action.filters, function (val, key) {
	        clonedState.companies.filters[key] = val;
	      });
	      return clonedState;
	    case actionTypes.UPDATE_COMPANIES_TABLE_SEARCH_TERMS:
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'companies.searchTerms', action.searchTerms);
	      return clonedState;
	    case actionTypes.LOG_OUT:
	      return initialState;
	
	    case actionTypes.UPDATE_JOB_REQUESTS_FILTERS:
	
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'jobRequests.filters', {});
	      _lodash2.default.forEach(action.filters, function (val, key) {
	        clonedState.jobRequests.filters[key] = val;
	      });
	
	      return clonedState;
	
	    case actionTypes.UPDATE_JOB_REQUESTS_TERMS:
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'jobRequests.searchTerms', action.searchTerms, []);
	      return clonedState;
	
	    case actionTypes.GO_TO_CONTACTS_PAGE:
	      clonedState = _lodash2.default.cloneDeep(state);
	      _lodash2.default.set(clonedState, 'contacts.page', action.page);
	      return clonedState;
	    default:
	      return state;
	  }
	}
	
	function processEventList(contactObj, action) {
	  var _action$contactEvent = action.contactEvent,
	      contactEventRoute = _action$contactEvent.contactEventRoute,
	      contactEvent = _objectWithoutProperties(_action$contactEvent, ['contactEventRoute']);
	
	  if (contactObj.profile.id === contactEvent.contactId && contactEvent.noteId) {
	    if (!contactObj.profile[contactEventRoute]) {
	      contactObj.profile[contactEventRoute] = []; // account for if value is null
	    }
	
	    contactObj.profile[contactEventRoute].map(function (targetEvent) {
	      if (targetEvent.id === contactEvent.noteId) {
	        targetEvent.note = contactEvent.note;
	        targetEvent.dateModified = Date();
	      }
	    });
	  } else if (contactObj.profile.id === contactEvent.contactId && contactEvent.taskId) {
	    if (!contactObj.profile[contactEventRoute]) {
	      contactObj.profile[contactEventRoute] = []; // account for if value is null
	    }
	
	    contactObj.profile[contactEventRoute].map(function (targetEvent) {
	      if (targetEvent.id === contactEvent.taskId) {
	        targetEvent.closed = contactEvent.closed;
	        targetEvent.noteTypeId = contactEvent.noteTypeId;
	        targetEvent.taskTypeId = contactEvent.taskTypeId;
	        targetEvent.taskResultId = contactEvent.taskResultId;
	        targetEvent.taskResultOther = contactEvent.taskResultOther;
	        targetEvent.taskFollowUpDate = contactEvent.taskFollowUpDate;
	        targetEvent.message = contactEvent.message;
	      }
	    });
	  } else if (contactObj.profile.id === contactEvent.contactId) {
	    if (!contactObj.profile[contactEventRoute]) {
	      contactObj.profile[contactEventRoute] = []; // account for if value is null
	    }
	
	    contactObj.profile[contactEventRoute].push(contactEvent);
	  }
	
	  return contactObj;
	}

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = alertReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function alertReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_ALERTS:
	      return action.alerts;
	
	    case actionTypes.LOG_OUT:
	      return (0, _lodash.clone)(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = applicantProfileReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _applicants = __webpack_require__(482);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function applicantProfileReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	
	    case actionTypes.UPDATE_APPLICANT:
	      var profile = (0, _applicants.migrateSkills)(action.profile);
	      return _extends({}, state, profile);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = applicantUserReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function applicantUserReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      applicantUser = _ref.applicantUser;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      return _lodash2.default.merge({}, state, applicantUser);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = assessmentUrlReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function assessmentUrlReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      assessmentUrls = _ref.assessmentUrls;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      if (assessmentUrls && assessmentUrls !== state) {
	        return Object.assign({}, state, assessmentUrls);
	      }
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = assessmentsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function assessmentsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      assessments = _ref.assessments;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT_ASSESSMENTS:
	      // need to use assign to handle logout
	      return _lodash2.default.merge({}, state, assessments);
	    case actionTypes.UPDATE_APPLICANT:
	      return _lodash2.default.merge({}, state, assessments);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = behavioralAnswersReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function behavioralAnswersReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      behavioralAnswers = _ref.behavioralAnswers;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT_BEHAVIORAL_ANS:
	      // need to use assign to handle logout
	      return _lodash2.default.merge({}, state, behavioralAnswers);
	    case actionTypes.UPDATE_APPLICANT:
	      return _lodash2.default.merge({}, state, behavioralAnswers);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = browserDataReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _getScrollBarWidth = __webpack_require__(898);
	
	var _getScrollBarWidth2 = _interopRequireDefault(_getScrollBarWidth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {
	  // default to Chrome user agent
	  userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_4) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/49.0.2623.112 Safari/537.36',
	
	  // browser's scrollBarWidth stored on state
	  scrollBarWidth: 15, // default to 15 as this is common
	
	  pathHistory: []
	};
	
	function browserDataReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.GET_SCROLLBAR_WIDTH:
	      return _extends({}, state, { scrollBarWidth: (0, _getScrollBarWidth2.default)() });
	
	    case actionTypes.SET_USERAGENT:
	      return _extends({}, state, { userAgent: action.userAgent });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = companyReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function companyReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_CONTACT_PROFILE:
	      // If UPDATE_CONTACT_PROFILE is dispatch we need to update the company store.
	      return (0, _lodash.merge)({}, state, action.contact.company);
	
	    case actionTypes.UPDATE_COMPANY:
	      var newState = (0, _lodash.merge)({}, (0, _lodash.omit)(state, ['segmentTypes', 'industryTypes', 'tradeAssociations']), action.company);
	      return newState;
	
	    case actionTypes.LOG_OUT:
	      return (0, _lodash.clone)(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = companyContactsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = [];
	
	function companyContactsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_COMPANY_CONTACTS:
	      return action.companyContacts;
	
	    case actionTypes.LOG_OUT:
	      return (0, _lodash.clone)(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = jobRequestsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function jobRequestsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_COMPANY_JOB_REQUESTS:
	      return action.companyJobRequests;
	
	    case actionTypes.LOG_OUT:
	      return _.clone(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = employmentGapsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// utilities
	
	
	// initial state
	var initialState = exports.initialState = {};
	
	function employmentGapsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      if (action.documents && action.documents !== state) {
	        // don't allow 'isNew' to enter store, get rid of properties with value of Symbol.for('__delete')
	        return (0, _lodash2.default)(_extends({}, state)).merge(_lodash2.default.omit(action.documents, 'isNew')).omitBy(function (val) {
	          return val === Symbol.for('__delete');
	        }).value();
	      }
	
	    case actionTypes.DELETE_FROM_APPLICANT_LIST:
	      // remove clientId property from state
	      return _lodash2.default.omit(state, action.clientId);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = employmentGapsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// utilities
	
	
	// initial state
	var initialState = exports.initialState = {};
	
	function employmentGapsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      if (action.education && action.education !== state) {
	        // don't allow 'isNew' to enter store, get rid of properties with value of Symbol.for('__delete')
	        return (0, _lodash2.default)(_extends({}, state)).merge(_lodash2.default.omit(action.education, 'isNew')).omitBy(function (val) {
	          return val === Symbol.for('__delete');
	        }).value();
	      }
	
	    case actionTypes.DELETE_FROM_APPLICANT_LIST:
	      // remove clientId property from state
	      return _lodash2.default.omit(state, action.clientId);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = employeesReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var initialState = exports.initialState = [];
	
	function updateEmployee(currentEmployee, updatedEmployee) {
	  if (currentEmployee.employeeId === updatedEmployee.employeeId) {
	    return _extends({}, currentEmployee, updatedEmployee);
	  }
	  return currentEmployee;
	}
	
	function employeesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	
	    case actionTypes.CREATE_EMPLOYEE:
	      return (0, _lodash.join)(state, (0, _lodash.cloneDeep)(action.employee));
	
	    case actionTypes.REMOVE_EMPLOYEE:
	      return (0, _lodash.remove)(state, { employeeId: action.employeeId });
	
	    case actionTypes.UPDATE_EMPLOYEE:
	      return (0, _lodash.map)(state, function (employee) {
	        return updateEmployee(employee, action.employee);
	      });
	
	    case actionTypes.STORE_EMPLOYEES:
	      return (0, _lodash.cloneDeep)(action.employees);
	
	    case actionTypes.LOG_OUT:
	      return (0, _lodash.clone)(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = employmentGapsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// utilities
	
	
	// initial state
	var initialState = exports.initialState = {};
	
	function employmentGapsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      if (action.employmentGaps && action.employmentGaps !== state) {
	        // don't allow 'isNew' to enter store, get rid of properties with value of Symbol.for('__delete')
	        return (0, _lodash2.default)(_extends({}, state)).merge(_lodash2.default.omit(action.employmentGaps, 'isNew')).omitBy(function (val) {
	          return val === Symbol.for('__delete');
	        }).value();
	      }
	
	    case actionTypes.DELETE_FROM_APPLICANT_LIST:
	      // remove clientId property from state
	      return _lodash2.default.omit(state, action.clientId);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(434);
	
	var _reduxIgnore = __webpack_require__(2981);
	
	var _reactRouterRedux = __webpack_require__(17);
	
	var _simpleIsoFetch = __webpack_require__(227);
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _labels = __webpack_require__(1155);
	
	var _labels2 = _interopRequireDefault(_labels);
	
	var _staticData = __webpack_require__(1166);
	
	var _staticData2 = _interopRequireDefault(_staticData);
	
	var _prelimApplication = __webpack_require__(1159);
	
	var _prelimApplication2 = _interopRequireDefault(_prelimApplication);
	
	var _admin = __webpack_require__(1134);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _tempState = __webpack_require__(1168);
	
	var _tempState2 = _interopRequireDefault(_tempState);
	
	var _user = __webpack_require__(1170);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _profile = __webpack_require__(1162);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _applicantProfile = __webpack_require__(1136);
	
	var _applicantProfile2 = _interopRequireDefault(_applicantProfile);
	
	var _company = __webpack_require__(1142);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _jobRequest = __webpack_require__(1151);
	
	var _jobRequest2 = _interopRequireDefault(_jobRequest);
	
	var _jobRequests = __webpack_require__(1154);
	
	var _jobRequests2 = _interopRequireDefault(_jobRequests);
	
	var _companyJobRequests = __webpack_require__(1144);
	
	var _companyJobRequests2 = _interopRequireDefault(_companyJobRequests);
	
	var _jobRequestDocuments = __webpack_require__(1152);
	
	var _jobRequestDocuments2 = _interopRequireDefault(_jobRequestDocuments);
	
	var _companyContacts = __webpack_require__(1143);
	
	var _companyContacts2 = _interopRequireDefault(_companyContacts);
	
	var _jobRequestHistory = __webpack_require__(1153);
	
	var _jobRequestHistory2 = _interopRequireDefault(_jobRequestHistory);
	
	var _browserData = __webpack_require__(1141);
	
	var _browserData2 = _interopRequireDefault(_browserData);
	
	var _workExperience = __webpack_require__(1171);
	
	var _workExperience2 = _interopRequireDefault(_workExperience);
	
	var _employmentGaps = __webpack_require__(1148);
	
	var _employmentGaps2 = _interopRequireDefault(_employmentGaps);
	
	var _education = __webpack_require__(1146);
	
	var _education2 = _interopRequireDefault(_education);
	
	var _skills = __webpack_require__(1165);
	
	var _skills2 = _interopRequireDefault(_skills);
	
	var _licenses = __webpack_require__(1156);
	
	var _licenses2 = _interopRequireDefault(_licenses);
	
	var _documents = __webpack_require__(1145);
	
	var _documents2 = _interopRequireDefault(_documents);
	
	var _professionalAssociations = __webpack_require__(1160);
	
	var _professionalAssociations2 = _interopRequireDefault(_professionalAssociations);
	
	var _professionalDesignations = __webpack_require__(1161);
	
	var _professionalDesignations2 = _interopRequireDefault(_professionalDesignations);
	
	var _behavioralAnswers = __webpack_require__(1140);
	
	var _behavioralAnswers2 = _interopRequireDefault(_behavioralAnswers);
	
	var _workObjectives = __webpack_require__(1172);
	
	var _workObjectives2 = _interopRequireDefault(_workObjectives);
	
	var _references = __webpack_require__(1164);
	
	var _references2 = _interopRequireDefault(_references);
	
	var _interviews = __webpack_require__(1150);
	
	var _interviews2 = _interopRequireDefault(_interviews);
	
	var _ratings = __webpack_require__(1163);
	
	var _ratings2 = _interopRequireDefault(_ratings);
	
	var _assessments = __webpack_require__(1139);
	
	var _assessments2 = _interopRequireDefault(_assessments);
	
	var _applicantUser = __webpack_require__(1137);
	
	var _applicantUser2 = _interopRequireDefault(_applicantUser);
	
	var _placementSpecialists = __webpack_require__(1158);
	
	var _placementSpecialists2 = _interopRequireDefault(_placementSpecialists);
	
	var _alerts = __webpack_require__(1135);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _worksheets = __webpack_require__(1173);
	
	var _worksheets2 = _interopRequireDefault(_worksheets);
	
	var _ui = __webpack_require__(1169);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	var _technologySurvey = __webpack_require__(1167);
	
	var _technologySurvey2 = _interopRequireDefault(_technologySurvey);
	
	var _assessmentUrls = __webpack_require__(1138);
	
	var _assessmentUrls2 = _interopRequireDefault(_assessmentUrls);
	
	var _pins = __webpack_require__(1157);
	
	var _pins2 = _interopRequireDefault(_pins);
	
	var _employees = __webpack_require__(1147);
	
	var _employees2 = _interopRequireDefault(_employees);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var contactProfile = (0, _redux.combineReducers)({
	  user: (0, _reduxIgnore.filterActions)(_user2.default, [actionTypes.UPDATE_USER, actionTypes.UPDATE_IMPERSONATE_USER, actionTypes.UPDATE_APPLICANT, actionTypes.LOG_OUT]),
	  profile: (0, _reduxIgnore.filterActions)(_profile2.default, [actionTypes.UPDATE_APPLICANT, actionTypes.CLEAR_APPLICANT, actionTypes.LOG_OUT, actionTypes.UPDATE_PROFILE]),
	  company: (0, _reduxIgnore.filterActions)(_company2.default, [actionTypes.UPDATE_COMPANY, actionTypes.LOG_OUT])
	});
	
	exports.default = (0, _redux.combineReducers)({
	  user: (0, _reduxIgnore.filterActions)(_user2.default, [actionTypes.UPDATE_USER, actionTypes.UPDATE_IMPERSONATE_USER, actionTypes.UPDATE_APPLICANT, actionTypes.LOG_OUT]),
	  profile: (0, _reduxIgnore.filterActions)(_profile2.default, [actionTypes.UPDATE_APPLICANT, actionTypes.UPDATE_PROFILE, actionTypes.CLEAR_APPLICANT, actionTypes.LOG_OUT]),
	  company: (0, _reduxIgnore.filterActions)(_company2.default, [actionTypes.UPDATE_COMPANY, actionTypes.LOG_OUT]),
	  contactProfile: contactProfile,
	  applicantProfile: (0, _reduxIgnore.filterActions)(_applicantProfile2.default, [actionTypes.UPDATE_APPLICANT, actionTypes.CLEAR_APPLICANT, actionTypes.LOG_OUT]),
	  jobRequest: (0, _reduxIgnore.filterActions)(_jobRequest2.default, [actionTypes.CREATE_JOB_REQUEST, actionTypes.UPDATE_JOB_REQUEST, actionTypes.RESET_JOB_REQUEST, actionTypes.LOG_OUT]),
	  jobRequests: (0, _reduxIgnore.filterActions)(_jobRequests2.default, [actionTypes.UPDATE_JOB_REQUESTS, actionTypes.LOG_OUT]),
	  companyJobRequests: (0, _reduxIgnore.filterActions)(_companyJobRequests2.default, [actionTypes.UPDATE_COMPANY_JOB_REQUESTS, actionTypes.LOG_OUT]),
	  jobRequestDocuments: (0, _reduxIgnore.filterActions)(_jobRequestDocuments2.default, [actionTypes.CREATE_JOB_REQUEST_DOCUMENTS, actionTypes.UPDATE_JOB_REQUEST_DOCUMENTS, actionTypes.RESET_JOB_REQUEST_DOCUMENTS, actionTypes.LOG_OUT]),
	  companyContacts: (0, _reduxIgnore.filterActions)(_companyContacts2.default, [actionTypes.UPDATE_COMPANY_CONTACTS, actionTypes.LOG_OUT]),
	  jobRequestHistory: (0, _reduxIgnore.filterActions)(_jobRequestHistory2.default, [actionTypes.UPDATE_COMPANY_JOBS, actionTypes.FILTER_COMPANY_JOBS, actionTypes.LOG_OUT]),
	  prelimApplication: (0, _reduxIgnore.filterActions)(_prelimApplication2.default, [actionTypes.UPDATE_PRELIM_FORM]),
	  admin: (0, _reduxIgnore.filterActions)(_admin2.default, [actionTypes.UPDATE_APPLICANTS_PAGE, actionTypes.ADD_APPLICANT_ADMIN, actionTypes.DELETE_APPLICANT_ADMIN, actionTypes.UPDATE_APPLICANTS_LIST, actionTypes.UPDATE_CONTACTS_LIST, actionTypes.UPDATE_COMPANIES_LIST, actionTypes.UPDATE_CONTACTS_PAGE, actionTypes.UPDATE_COMPANIES_PAGE, actionTypes.UPDATE_CONTACT_IN_CONTACT_WORKSHEET, actionTypes.CLEAR_CONTACT_IN_CONTACT_WORKSHEET, actionTypes.UPDATE_COMPANY, actionTypes.UPDATE_CONTACT, actionTypes.UPDATE_APPLICANT_ADMIN, actionTypes.UPDATE_CURRENT_APPLICANT_ADMIN, actionTypes.UPDATE_EVENT_LIST, actionTypes.UPDATE_CONTACT_EVENT_LIST, actionTypes.CHANGE_NAV_COLUMN_STATE, actionTypes.UPDATE_PINNED_APPLICANTS, actionTypes.FETCH_PINNED_APPLICANTS, actionTypes.GET_COMPANY_INFO, actionTypes.LOG_OUT, actionTypes.UPDATE_CONTACTS_TABLE_SEARCH_TERMS, actionTypes.UPDATE_CONTACTS_TABLE_FILTERS, actionTypes.UPDATE_COMPANIES_TABLE_SEARCH_TERMS, actionTypes.UPDATE_COMPANIES_TABLE_FILTERS, actionTypes.UPDATE_JOB_REQUESTS_FILTERS, actionTypes.UPDATE_JOB_REQUESTS_TERMS, actionTypes.GO_TO_CONTACTS_PAGE]),
	  pins: (0, _reduxIgnore.filterActions)(_pins2.default, [actionTypes.LOAD_PINS, actionTypes.UPDATE_PINS]),
	  tempState: (0, _reduxIgnore.filterActions)(_tempState2.default, [actionTypes.UPDATE_TEMP_STATE, actionTypes.UPDATE_APPLICANT]),
	  applicantUser: (0, _reduxIgnore.filterActions)(_applicantUser2.default, [actionTypes.UPDATE_APPLICANT, actionTypes.CLEAR_APPLICANT, actionTypes.LOG_OUT]),
	  employmentGaps: _employmentGaps2.default,
	  workExperiences: _workExperience2.default,
	  education: _education2.default,
	  skills: _skills2.default,
	  licenses: _licenses2.default,
	  documents: _documents2.default,
	  associations: _professionalAssociations2.default,
	  designations: _professionalDesignations2.default,
	  behavioralAnswers: _behavioralAnswers2.default,
	  workObjectives: _workObjectives2.default,
	  references: _references2.default,
	  interviews: _interviews2.default,
	  ratings: _ratings2.default,
	  assessments: _assessments2.default,
	  placementSpecialists: _placementSpecialists2.default,
	  alerts: (0, _reduxIgnore.filterActions)(_alerts2.default, [actionTypes.UPDATE_ALERTS, actionTypes.LOG_OUT]),
	  staticData: (0, _reduxIgnore.filterActions)(_staticData2.default, [actionTypes.UPDATE_STATIC_DATA]),
	  labels: (0, _reduxIgnore.filterActions)(_labels2.default, [actionTypes.UPDATE_LABELS]),
	  browserData: (0, _reduxIgnore.filterActions)(_browserData2.default, [actionTypes.GET_SCROLLBAR_WIDTH, actionTypes.SET_USERAGENT]),
	  worksheets: (0, _reduxIgnore.filterActions)(_worksheets2.default, [actionTypes.UPDATE_WORKSHEET, actionTypes.REMOVE_WORKSHEET, actionTypes.LOG_OUT]),
	  ui: _ui2.default,
	  employees: _employees2.default,
	  technologySurvey: _technologySurvey2.default,
	  assessmentUrls: _assessmentUrls2.default,
	  routing: _reactRouterRedux.routerReducer,
	  simpleIsoFetch: _simpleIsoFetch.bindingsReducer
	});

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// utilities
	
	
	exports.default = interviewsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function interviewsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      interviews = _ref.interviews;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      return _lodash2.default.merge({}, state, interviews);
	
	    case actionTypes.UPDATE_APPLICANT_REFERENCES_INTERVIEWS:
	      var interview = _extends({}, interviews);
	      return _lodash2.default.merge({}, state, _defineProperty({}, interview.clientId, interview));
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = jobRequestReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function jobRequestReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	
	    case actionTypes.CREATE_JOB_REQUEST:
	      return Object.assign({}, action.jobRequest);
	
	    case actionTypes.UPDATE_JOB_REQUEST:
	      return _extends({}, state, action.jobRequest);
	
	    case actionTypes.RESET_JOB_REQUEST:
	      return {};
	
	    case actionTypes.LOG_OUT:
	      return Object.assign(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = jobRequestDocumentsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function jobRequestDocumentsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	
	    case actionTypes.CREATE_JOB_REQUEST_DOCUMENTS:
	      return Object.assign({}, action);
	
	    case actionTypes.UPDATE_JOB_REQUEST_DOCUMENTS:
	      return _extends({}, state, { documents: action.documents });
	
	    case actionTypes.RESET_JOB_REQUEST_DOCUMENTS:
	      return {};
	
	    case actionTypes.LOG_OUT:
	      return Object.assign(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = jobRequestHistoryReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function jobRequestHistoryReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_COMPANY_JOBS:
	      return _extends({}, state, { companyJobs: action.companyJobs });
	
	    case actionTypes.FILTER_COMPANY_JOBS:
	      var filters = (0, _lodash.assign)({}, state.filters, action.filters);
	      return _extends({}, state, { filters: filters });
	
	    case actionTypes.LOG_OUT:
	      return (0, _lodash.clone)(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = jobRequestsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function jobRequestsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_JOB_REQUESTS:
	      return _extends({}, action.jobRequests);
	
	    case actionTypes.LOG_OUT:
	      return _.clone(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = labelReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function labelReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_LABELS:
	      return (0, _lodash.clone)(action.labels);
	
	    case actionTypes.LOG_OUT:
	      return (0, _lodash.clone)(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = licensesReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// utilities
	
	
	// initial state
	var initialState = exports.initialState = {};
	
	function licensesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      if (action.licenses && action.licenses !== state) {
	        // don't allow 'isNew' to enter store, get rid of properties with value of Symbol.for('__delete')
	        return (0, _lodash2.default)(_extends({}, state)).merge(_lodash2.default.omit(action.licenses, 'isNew')).omitBy(function (val) {
	          return val === Symbol.for('__delete');
	        }).value();
	      }
	
	    case actionTypes.DELETE_FROM_APPLICANT_LIST:
	      // remove clientId property from state
	      return _lodash2.default.omit(state, action.clientId);
	
	    case actionTypes.UPDATE_APPLICANT_LICENSES:
	
	      return _lodash2.default.merge({}, action.licenses);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = pinReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function pinReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.LOAD_PINS:
	      return Object.assign({}, action.pins);
	
	    case actionTypes.LOG_OUT:
	      return (0, _lodash.clone)(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = placementSpecialists;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function placementSpecialists() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      placementSpecialists = _ref.placementSpecialists;
	
	  switch (type) {
	    case actionTypes.UPDATE_PLACEMENT_SPECIALISTS:
	      return placementSpecialists;
	
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// js utility library
	
	
	var initialState = exports.initialState = {
	  isQualified: 'unsubmitted',
	  passwordIsReady: false,
	  alreadyExists: false,
	  user: {
	    email: '',
	    password: '',
	    firstName: '',
	    lastName: '',
	    middleName: '',
	    nickName: '',
	    phoneNumber1: '',
	    phoneType1: null,
	    phoneNumber2: '',
	    phoneType2: null,
	    phoneNumber3: '',
	    phoneType3: null,
	    address: '',
	    city: '',
	    zip: '',
	    country: '',
	    countryOther: null,
	    state: null,
	    timezone: null,
	    bestContactTime: null
	  },
	  profile: {
	    employmentStatus: null,
	    availabilityDate: '',
	    totalYearsExperience: null,
	    industryYearsExperience: null,
	    workedLastInIndustry: null,
	    industryTypes: [],
	    foundUsVia: null,
	    foundUsOther: '',
	    optIntoNewsletter: false,
	    mostRecentSegment: null,
	    mostRecentPosition: null,
	    mostRecentDepartment: null
	  }
	};
	
	function overwriteDeep(object, overwriteObject) {
	  Object.keys(overwriteObject).forEach(function (val) {
	    return Object.assign(object, _defineProperty({}, val, overwriteObject[val]));
	  });
	}
	
	function prelimApplicationReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actionTypes.UPDATE_PRELIM_FORM:
	      var clonedState = _lodash2.default.cloneDeep(state);
	
	      // overwrite shallow properties
	      Object.assign(clonedState, _lodash2.default.omit(action, 'user', 'profile', 'type'));
	
	      // overwrite deep properties (if provided)
	      if (action.user) {
	        overwriteDeep(clonedState.user, action.user);
	      }
	      if (action.profile) {
	        overwriteDeep(clonedState.profile, action.profile);
	      }
	
	      // return result
	      return clonedState;
	
	    default:
	      return state;
	  }
	}
	
	exports.default = prelimApplicationReducer;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = associationsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function associationsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      associations = _ref.associations;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      // need to use assign to handle logout
	      return _lodash2.default.merge({}, state, associations);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = designationsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function designationsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      designations = _ref.designations;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      // need to use assign to handle logout
	      return _lodash2.default.merge({}, state, designations);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = profileReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _applicants = __webpack_require__(482);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function profileReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	
	    case actionTypes.UPDATE_CONTACT_PROFILE:
	      return _extends({}, state, action.contact.profile);
	
	    case actionTypes.UPDATE_PROFILE:
	      var profile = (0, _applicants.migrateSkills)(action.profile);
	      return _extends({}, state, profile);
	
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = ratingsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function ratingsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      ratings = _ref.ratings;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT_INTERVIEW_RATINGS:
	      // need to use assign to handle logout
	      return _lodash2.default.merge({}, state, ratings);
	    case actionTypes.UPDATE_APPLICANT:
	      return _lodash2.default.merge({}, state, ratings);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = referenceReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// utilities
	
	
	// initial state
	var initialState = exports.initialState = {};
	
	function referenceReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      if (action.references && action.references !== state) {
	        // don't allow 'isNew' to enter store, get rid of properties with value of Symbol.for('__delete')
	        return (0, _lodash2.default)(_extends({}, state)).merge(_lodash2.default.omit(action.references, 'isNew')).omitBy(function (val) {
	          return val === Symbol.for('__delete');
	        }).value();
	      }
	
	    case actionTypes.DELETE_FROM_APPLICANT_LIST:
	      // remove clientId property from state
	      return _lodash2.default.omit(state, action.clientId);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = skillsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function skillsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      skills = _ref.skills;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      // need to use assign to handle logout
	      var mergedSkills = _lodash2.default.merge({}, state, skills);
	      var newSkills = _lodash2.default.reduce(mergedSkills, function (result, category, key) {
	        var skillList = _lodash2.default.filter(category, function (s) {
	          return s.deleted !== Symbol.for('_deleted_');
	        });
	        _lodash2.default.forEach(skillList, function (s) {
	          return _lodash2.default.setWith(result, key + '.' + String(s.name), s, Object);
	        }, {});
	        return result;
	      }, {});
	
	      return newSkills;
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = staticDataReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = exports.initialState = {};
	
	// js utility library
	function staticDataReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actionTypes.UPDATE_STATIC_DATA:
	      return action.staticData;
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = technologySurveyReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function technologySurveyReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      technologySurvey = _ref.technologySurvey;
	
	  switch (type) {
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	    case actionTypes.UPDATE_APPLICANT:
	    case actionTypes.UPDATE_TECHNOLOGY_SURVEY:
	      if (technologySurvey && technologySurvey !== state) {
	        return (0, _lodash.merge)({}, state, technologySurvey);
	      }
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _actionTypes = __webpack_require__(20);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  tempState: {}
	};
	
	// js utility library
	
	
	function applicantApplicationReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      newTempState = _ref.newTempState;
	
	  switch (type) {
	    case _actionTypes.UPDATE_TEMP_STATE:
	      return _lodash2.default.merge({}, newTempState);
	
	    case _actionTypes.UPDATE_APPLICANT:
	      return {};
	
	    default:
	      return state;
	  }
	}
	
	exports.default = applicantApplicationReducer;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = uiReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {};
	
	function uiReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case _actionTypes.SET_NAV_STATE:
	      return _extends({}, state, { navState: action.navState });
	
	    case _actionTypes.SHOW_SNACKBAR:
	    case _actionTypes.HIDE_SNACKBAR:
	      return _extends({}, state, { showSnackBar: action.showSnackBar, snackBarText: action.snackBarText, hideSnackBarAction: action.hideSnackBarAction });
	
	    case _actionTypes.SHOW_SPINNER:
	    case _actionTypes.HIDE_SPINNER:
	      return _extends({}, state, { showSpinner: action.showSpinner });
	
	    case _actionTypes.SHOW_CONTROLS:
	    case _actionTypes.HIDE_CONTROLS:
	      return _extends({}, state, { hideControls: action.hideControls });
	
	    case _actionTypes.WARNING_TOAST:
	      return _extends({}, state, { toast: action });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = userReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// utilities
	
	
	// initial state
	var initialState = exports.initialState = {
	  // auth failed
	  authFailed: false,
	
	  // not loggedIn by default
	  loggedIn: false
	};
	
	function userReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_USER:
	      // need to use assign to handle logout
	      return _extends({}, state, action);
	
	    case actionTypes.UPDATE_IMPERSONATE_USER:
	      // need to use assign to handle logout
	      var impersonateUser = action.impersonateUser;
	      return _lodash2.default.merge({}, state, { impersonateUser: impersonateUser });
	
	    case actionTypes.UPDATE_APPLICANT:
	      // need to use assign to handle logout
	      return _extends({}, state, action.user);
	
	    case actionTypes.LOG_OUT:
	      return _lodash2.default.clone(initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = workExperienceReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// utilities
	
	
	// initial state
	var initialState = exports.initialState = {};
	
	function workExperienceReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT:
	      if (action.workExperiences && action.workExperiences !== state) {
	        // don't allow 'isNew' to enter store, get rid of properties with value of Symbol.for('__delete')
	        return (0, _lodash2.default)(_extends({}, state)).merge(_lodash2.default.omit(action.workExperiences, 'isNew')).omitBy(function (val) {
	          return val === Symbol.for('__delete');
	        }).value();
	      }
	
	    case actionTypes.DELETE_FROM_APPLICANT_LIST:
	      // remove clientId property from state
	      return _lodash2.default.omit(state, action.clientId);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = workObjectivesReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// initial state
	var initialState = exports.initialState = {};
	
	// utilities
	function workObjectivesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      workObjectives = _ref.workObjectives;
	
	  switch (type) {
	    case actionTypes.UPDATE_APPLICANT_WORK_OBJECTIVES:
	      // need to use assign to handle logout
	      return _lodash2.default.merge({}, state, workObjectives);
	    case actionTypes.UPDATE_APPLICANT:
	      return _lodash2.default.merge({}, state, workObjectives);
	
	    case actionTypes.CLEAR_APPLICANT:
	    case actionTypes.LOG_OUT:
	      return {};
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = worksheetsReducer;
	
	var _actionTypes = __webpack_require__(20);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// initial state
	var initialState = exports.initialState = {
	  trail: []
	};
	
	function worksheetsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	
	  var type = _ref.type,
	      action = _objectWithoutProperties(_ref, ['type']);
	
	  var worksheet = action.worksheet,
	      path = action.path;
	
	
	  var trail = state.trail.slice(0);
	  var index = void 0;
	
	  switch (type) {
	    case actionTypes.UPDATE_WORKSHEET:
	
	      var placeholder = null;
	      index = trail.findIndex(function (w) {
	        return w.worksheet === worksheet;
	      });
	      if (~index) {
	        placeholder = trail[index];
	        trail.splice(index, 1);
	      }
	
	      placeholder = placeholder || { worksheet: worksheet };
	      placeholder.path = path;
	      trail.unshift(placeholder);
	
	      return _extends({}, state, { trail: trail });
	
	    case actionTypes.REMOVE_WORKSHEET:
	
	      index = trail.findIndex(function (w) {
	        return w.worksheet === worksheet;
	      });
	      if (~index) {
	        trail.splice(index, 1);
	      }
	
	      return _extends({}, state, { trail: trail });
	
	    case actionTypes.LOG_OUT:
	      return _extends({}, initialState);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRouter = __webpack_require__(51);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(851);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _f_PreliminaryApplication = __webpack_require__(1048);
	
	var _f_PreliminaryApplication2 = _interopRequireDefault(_f_PreliminaryApplication);
	
	var _r_ApplicantLanding = __webpack_require__(1090);
	
	var _r_ApplicantLanding2 = _interopRequireDefault(_r_ApplicantLanding);
	
	var _r_ApplicantDashboard = __webpack_require__(1088);
	
	var _r_ApplicantDashboard2 = _interopRequireDefault(_r_ApplicantDashboard);
	
	var _r_ApplicantTermsAndConditions = __webpack_require__(477);
	
	var _r_ApplicantTermsAndConditions2 = _interopRequireDefault(_r_ApplicantTermsAndConditions);
	
	var _r_ApplicantResume = __webpack_require__(1091);
	
	var _r_ApplicantResume2 = _interopRequireDefault(_r_ApplicantResume);
	
	var _view = __webpack_require__(968);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _admin = __webpack_require__(1001);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _r_AdminDashboard = __webpack_require__(1054);
	
	var _r_AdminDashboard2 = _interopRequireDefault(_r_AdminDashboard);
	
	var _Worksheet = __webpack_require__(961);
	
	var _Worksheet2 = _interopRequireDefault(_Worksheet);
	
	var _Worksheet3 = __webpack_require__(947);
	
	var _Worksheet4 = _interopRequireDefault(_Worksheet3);
	
	var _Worksheet5 = __webpack_require__(980);
	
	var _Worksheet6 = _interopRequireDefault(_Worksheet5);
	
	var _Profile = __webpack_require__(979);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Confirmation = __webpack_require__(969);
	
	var _Confirmation2 = _interopRequireDefault(_Confirmation);
	
	var _Alerts = __webpack_require__(930);
	
	var _Alerts2 = _interopRequireDefault(_Alerts);
	
	var _loadApplicantProfile = __webpack_require__(918);
	
	var _loadApplicantProfile2 = _interopRequireDefault(_loadApplicantProfile);
	
	var _loadAdminContacts = __webpack_require__(917);
	
	var _loadAdminContacts2 = _interopRequireDefault(_loadAdminContacts);
	
	var _loadJobRequest = __webpack_require__(922);
	
	var _loadJobRequest2 = _interopRequireDefault(_loadJobRequest);
	
	var _loadPins = __webpack_require__(923);
	
	var _loadPins2 = _interopRequireDefault(_loadPins);
	
	var _loadPublicJobRequest = __webpack_require__(924);
	
	var _loadPublicJobRequest2 = _interopRequireDefault(_loadPublicJobRequest);
	
	var _loadIdentity = __webpack_require__(920);
	
	var _loadIdentity2 = _interopRequireDefault(_loadIdentity);
	
	var _loadImpersonation = __webpack_require__(921);
	
	var _loadImpersonation2 = _interopRequireDefault(_loadImpersonation);
	
	var _loadApplicationData = __webpack_require__(919);
	
	var _loadApplicationData2 = _interopRequireDefault(_loadApplicationData);
	
	var _redirectUnauthorized = __webpack_require__(925);
	
	var _redirectUnauthorized2 = _interopRequireDefault(_redirectUnauthorized);
	
	var _combineHooks = __webpack_require__(916);
	
	var _combineHooks2 = _interopRequireDefault(_combineHooks);
	
	var _r_ExpandedCard = __webpack_require__(1114);
	
	var _r_ExpandedCard2 = _interopRequireDefault(_r_ExpandedCard);
	
	var _ReferencesList = __webpack_require__(983);
	
	var _ReferencesList2 = _interopRequireDefault(_ReferencesList);
	
	var _TechnologySurvey = __webpack_require__(1000);
	
	var _TechnologySurvey2 = _interopRequireDefault(_TechnologySurvey);
	
	var _Dashboard = __webpack_require__(951);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Profile3 = __webpack_require__(952);
	
	var _Profile4 = _interopRequireDefault(_Profile3);
	
	var _Card = __webpack_require__(949);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Add = __webpack_require__(948);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _Dashboard3 = __webpack_require__(937);
	
	var _Dashboard4 = _interopRequireDefault(_Dashboard3);
	
	var _Profile5 = __webpack_require__(941);
	
	var _Profile6 = _interopRequireDefault(_Profile5);
	
	var _JobRequests = __webpack_require__(940);
	
	var _JobRequests2 = _interopRequireDefault(_JobRequests);
	
	var _Contacts = __webpack_require__(939);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _Settings = __webpack_require__(999);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _Landing = __webpack_require__(998);
	
	var _Landing2 = _interopRequireDefault(_Landing);
	
	var _Landing3 = __webpack_require__(989);
	
	var _Landing4 = _interopRequireDefault(_Landing3);
	
	var _Landing5 = __webpack_require__(991);
	
	var _Landing6 = _interopRequireDefault(_Landing5);
	
	var _Landing7 = __webpack_require__(993);
	
	var _Landing8 = _interopRequireDefault(_Landing7);
	
	var _client = __webpack_require__(1036);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _ClientDashboard = __webpack_require__(1014);
	
	var _ClientDashboard2 = _interopRequireDefault(_ClientDashboard);
	
	var _CompanyDashboard = __webpack_require__(1016);
	
	var _CompanyDashboard2 = _interopRequireDefault(_CompanyDashboard);
	
	var _ClientContactInfo = __webpack_require__(1013);
	
	var _ClientContactInfo2 = _interopRequireDefault(_ClientContactInfo);
	
	var _ClientCompanyInfo = __webpack_require__(1012);
	
	var _ClientCompanyInfo2 = _interopRequireDefault(_ClientCompanyInfo);
	
	var _ClientWelcome = __webpack_require__(1015);
	
	var _ClientWelcome2 = _interopRequireDefault(_ClientWelcome);
	
	var _TechQA = __webpack_require__(1035);
	
	var _TechQA2 = _interopRequireDefault(_TechQA);
	
	var _JobRequest = __webpack_require__(1030);
	
	var _JobRequest2 = _interopRequireDefault(_JobRequest);
	
	var _PositionInfo = __webpack_require__(1025);
	
	var _PositionInfo2 = _interopRequireDefault(_PositionInfo);
	
	var _JobRequestDescription = __webpack_require__(1023);
	
	var _JobRequestDescription2 = _interopRequireDefault(_JobRequestDescription);
	
	var _AddDocuments = __webpack_require__(1018);
	
	var _AddDocuments2 = _interopRequireDefault(_AddDocuments);
	
	var _JobRequestSkills = __webpack_require__(1026);
	
	var _JobRequestSkills2 = _interopRequireDefault(_JobRequestSkills);
	
	var _SkillSummary = __webpack_require__(1027);
	
	var _SkillSummary2 = _interopRequireDefault(_SkillSummary);
	
	var _JobRequestAuthorize = __webpack_require__(1022);
	
	var _JobRequestAuthorize2 = _interopRequireDefault(_JobRequestAuthorize);
	
	var _WorkSchedule = __webpack_require__(1029);
	
	var _WorkSchedule2 = _interopRequireDefault(_WorkSchedule);
	
	var _AdditionalContacts = __webpack_require__(1020);
	
	var _AdditionalContacts2 = _interopRequireDefault(_AdditionalContacts);
	
	var _JobRequestHistory = __webpack_require__(1031);
	
	var _JobRequestHistory2 = _interopRequireDefault(_JobRequestHistory);
	
	var _CreateCompanyContact = __webpack_require__(1017);
	
	var _CreateCompanyContact2 = _interopRequireDefault(_CreateCompanyContact);
	
	var _Dashboard5 = __webpack_require__(970);
	
	var _Dashboard6 = _interopRequireDefault(_Dashboard5);
	
	var _PublicLanding = __webpack_require__(1051);
	
	var _PublicLanding2 = _interopRequireDefault(_PublicLanding);
	
	var _PublicProspect = __webpack_require__(1052);
	
	var _PublicProspect2 = _interopRequireDefault(_PublicProspect);
	
	var _Login = __webpack_require__(1050);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _ResetPassword = __webpack_require__(1053);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _ChangePassword = __webpack_require__(1049);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _authRedirectGen = __webpack_require__(1176);
	
	var _authRedirectGen2 = _interopRequireDefault(_authRedirectGen);
	
	var _bullhornRedirect = __webpack_require__(1177);
	
	var _bullhornRedirect2 = _interopRequireDefault(_bullhornRedirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// route strings
	
	
	// function to generate authedRoute handler for 'onEnter'
	
	
	// Client components
	
	
	// expanded card view
	
	
	// insurance company's Admin page
	
	
	// applicant's resume page
	
	
	// applicant's dashboard after prelim app status
	
	
	// public applicant's page
	var loginRoute = 'login';
	
	// Public components
	
	
	// public components
	
	
	// Settings
	
	// Company Dashboard page
	
	
	// Contact Dashboard page
	
	
	// guide
	
	
	// applicant's dashboard after prelim app status
	
	
	// applicant's dashboard after prelim app status
	
	var adminRoute = 'admin';
	var applicantRoute = 'applicant';
	var clientRoute = 'client';
	var termsRoute = 'terms';
	var forgotPasswordRoute = 'forgotpassword';
	var publicRoute = 'public';
	
	var unauthedRoutes = ['', 'apply', 'contactus', 'job', loginRoute, termsRoute, forgotPasswordRoute, publicRoute];
	
	var authRedirect = (0, _authRedirectGen2.default)(unauthedRoutes, applicantRoute, adminRoute, clientRoute);
	
	exports.default = function (store) {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _App2.default, onEnter: (0, _loadApplicationData2.default)(store) },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _PublicLanding2.default },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Login2.default, onEnter: (0, _combineHooks2.default)([(0, _loadIdentity2.default)(store), authRedirect(store)]) }),
	      _react2.default.createElement(_reactRouter.Redirect, { from: loginRoute, to: '/' }),
	      _react2.default.createElement(_reactRouter.Route, { path: termsRoute, component: _r_ApplicantTermsAndConditions2.default }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: forgotPasswordRoute, component: _ResetPassword2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'change', component: _ChangePassword2.default })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: 'apply', component: _f_PreliminaryApplication2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'contactus', component: _PublicProspect2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'bh/:profileId/:page', onEnter: _bullhornRedirect2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'job/:hash/:jobId', component: _Confirmation2.default, onEnter: (0, _loadPublicJobRequest2.default)(store) })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: applicantRoute, onEnter: (0, _combineHooks2.default)([(0, _loadIdentity2.default)(store), (0, _redirectUnauthorized2.default)(store, ['Applicant', 'Employee']), (0, _loadImpersonation2.default)(store), (0, _loadApplicantProfile2.default)(store)]) },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _r_ApplicantLanding2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'inactive', component: _r_ApplicantLanding2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'resume', component: _r_ApplicantResume2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':activeColumnNav', component: _r_ApplicantDashboard2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':activeColumnNav/:activeRowSubNav', component: _r_ApplicantDashboard2.default })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: clientRoute, component: _client2.default, onEnter: (0, _combineHooks2.default)([(0, _loadIdentity2.default)(store), (0, _redirectUnauthorized.OnEnterAllowClients)(store)]) },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _ClientDashboard2.default, onEnter: (0, _JobRequestHistory.OnEnterLoadJobRequestHistory)(store) }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'welcome', component: _ClientWelcome2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'edit', component: _ClientContactInfo2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'company', component: _CompanyDashboard2.default, onEnter: (0, _client.OnEnterLoadCompanyContacts)(store) }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'company/edit', component: _ClientCompanyInfo2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'company/tech', component: _TechQA2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'jobrequesthistory', component: _JobRequestHistory2.default, onEnter: (0, _JobRequestHistory.OnEnterLoadJobRequestHistory)(store) }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'jobrequest/:jobId/confirmation', component: _Confirmation2.default, onEnter: (0, _loadJobRequest2.default)(store, true) }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'jobrequest(/:jobId)', component: _JobRequest2.default, onEnter: (0, _loadJobRequest2.default)(store) },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _PositionInfo2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'description', component: _JobRequestDescription2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'adddocuments', component: _AddDocuments2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'authorize', component: _JobRequestAuthorize2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'skills/summary', component: _SkillSummary2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'skills(/:categoryId)', component: _JobRequestSkills2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'workschedule', component: _WorkSchedule2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'addcontact', component: _AdditionalContacts2.default })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: 'newcontact', component: _CreateCompanyContact2.default })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: adminRoute, component: _admin2.default, onEnter: (0, _combineHooks2.default)([(0, _loadIdentity2.default)(store), (0, _redirectUnauthorized.OnEnterAllowEmployees)(store), (0, _loadPins2.default)(store)]) },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'settings', component: _Settings2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'users', component: _Landing2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'emails', component: _Landing4.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'passwordResetRequests', component: _Landing6.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'pushQueueItems', component: _Landing8.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'contacts', onEnter: (0, _loadAdminContacts2.default)(store) },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _Dashboard2.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':contactId', component: _Dashboard2.default },
	          _react2.default.createElement(_reactRouter.IndexRoute, { component: _Card2.default })
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':contactId(\\\\d+)/details', component: _Worksheet2.default, onEnter: (0, _Worksheet.OnEnterRefreshContact)(store) },
	          _react2.default.createElement(_reactRouter.IndexRoute, { component: _Profile4.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'company', component: _Profile6.default })
	        )
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'companies' },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _Dashboard4.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':companyId/details', onEnter: (0, _Worksheet3.OnEnterRefreshCompany)(store), component: _Worksheet4.default },
	          _react2.default.createElement(_reactRouter.IndexRoute, { component: _Profile6.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'jobs', component: _JobRequests2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'contacts', component: _Contacts2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'tech', component: _TechQA2.default })
	        )
	      ),
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _r_AdminDashboard2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'prospect', component: _Add2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'alerts', component: _Alerts2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'jobrequests', component: _Dashboard6.default }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'jobrequests/:jobId', component: _Worksheet6.default, onEnter: (0, _loadJobRequest2.default)(store, true) },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _Profile2.default })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: 'jobrequests/:jobId/confirmation', component: _Confirmation2.default, onEnter: (0, _loadJobRequest2.default)(store, true) }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'guide', component: _view2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':navColumnState([a-ZA-Z\\s]+)/:profileId(\\d+)/:category/resume', component: _r_ApplicantResume2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':navColumnState([a-ZA-Z\\s]+)/:profileId(\\d+)/:category/:subcategory/resume', component: _r_ApplicantResume2.default }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: ':navColumnState([a-ZA-Z\\\\s]+)', component: _r_AdminDashboard2.default },
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: ':email(\\\\d+)', component: _r_ExpandedCard2.default },
	          _react2.default.createElement(_reactRouter.Route, { path: 'references', component: _ReferencesList2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'technologysurvey', component: _TechnologySurvey2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: ':email(\\\\d+)/:category', component: _r_ExpandedCard2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: ':email(\\\\d+)/:category/:subcategory', component: _r_ExpandedCard2.default })
	      )
	    ),
	    _react2.default.createElement(_reactRouter.Redirect, { from: '*', to: '/' }),
	    ' '
	  );
	};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAssessments = getAssessments;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 Function: getAssessments
	
	 Parameters:
	  skills - flat array of skills
	  clonedAssessmentTypes - set of assessments to evaluate
	  filterBySkillCategory - bool indicating if the skillCategory is taken into account or not
	
	*/
	function getAssessments(skills, clonedAssessmentTypes, filterBySkillCategory) {
	  var filterSkills = function filterSkills(categoryId) {
	    var maxLastUsed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
	
	    var skillsWithValues = _lodash2.default.filter(skills, function (skill) {
	      return skill.name !== 'None';
	    });
	    var validSkills = _lodash2.default.filter(skillsWithValues, function (skill) {
	      return _lodash2.default.get(skill, 'lastUsed', 999) <= maxLastUsed || _lodash2.default.get(skill, 'lastUsed') === 100;
	    });
	    var skillsInCategory = filterBySkillCategory === true ? _lodash2.default.filter(validSkills, function (skill) {
	      return skill.categoryId === categoryId;
	    }) : validSkills;
	    return skillsInCategory.map(function (skill) {
	      return skill.name;
	    });
	  };
	
	  // filtering functions
	  var fns = {
	    has: function has(skillCategory, reqSkills, assessment) {
	      var filteredSkills = filterSkills(skillCategory, assessment.maxLastUsed);
	      return _lodash2.default.intersection(filteredSkills, reqSkills).length === reqSkills.length;
	    },
	    hasNot: function hasNot(skillCategory, reqSkills, assessment) {
	      var filteredSkills = filterSkills(skillCategory, assessment.maxLastUsed);
	      return _lodash2.default.intersection(filteredSkills, reqSkills).length === 0;
	    },
	    any: function any() {
	      return true;
	    },
	    atLeastOne: function atLeastOne(skillCategory, requiredSkills, assessment) {
	      var filteredSkills = filterSkills(skillCategory, assessment.maxLastUsed);
	      return _lodash2.default.intersection(filteredSkills, requiredSkills).length > 0;
	    }
	  };
	
	  // evaluates filtering functions to determine if the assessment is required for the applicant
	  // returns true if all assessment display criteria are met
	  var showDisplay = function showDisplay(assessment) {
	    return assessment.display.every(function (param) {
	      // ensure that all filters evaluate to true
	      var reqSkills = param.parameters; // skills
	      var skillCategory = Number.parseInt(param.skillCategoryId, 10); // category
	      var action = param.action; // name of filter function
	      var skill = fns[action](skillCategory, reqSkills, assessment); // evaluate filter
	      return skill;
	    });
	  };
	
	  var assessments = clonedAssessmentTypes.map(function (assessment) {
	    assessment.display = showDisplay(assessment);
	    return assessment;
	  });
	
	  return assessments;
	}

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = function (unauthedRoutes, applicantRoute, adminRoute, clientRoute) {
	  return function (store) {
	    return function (nextRouterState, replace, cb) {
	      var _store$getState = store.getState(),
	          _store$getState$user = _store$getState.user,
	          loggedIn = _store$getState$user.loggedIn,
	          roles = _store$getState$user.roles,
	          statusGroups = _store$getState$user.statusGroups;
	
	      var _nextRouterState$loca = nextRouterState.location.pathname.split('/'),
	          _nextRouterState$loca2 = _slicedToArray(_nextRouterState$loca, 3),
	          rootParam = _nextRouterState$loca2[0],
	          firstParam = _nextRouterState$loca2[1],
	          secondParam = _nextRouterState$loca2[2];
	
	      var adminPages = ['guide'];
	
	      var publicRoutes = ~unauthedRoutes.indexOf((firstParam || rootParam).toLowerCase());
	
	      // Redirect user to root if they're not authed and go to authed route
	      if (!loggedIn && !publicRoutes) {
	        replace('/login');
	        return cb();
	      }
	
	      // Catch a unsual error.
	      if (loggedIn && !roles) return console.error('somehow roles array was not returned from back end');
	
	      // redirect to respective workspace.
	      if (loggedIn && (firstParam === 'login' || firstParam === '')) {
	
	        if (roles.includes('Admin') || roles.includes('Employee')) {
	
	          if (roles.includes('Qualifying Specialist')) {
	            replace('/' + adminRoute + '/' + statusGroups[0]);
	          } else if (roles.includes('Placement Specialist')) {
	            replace('/' + adminRoute + '/' + statusGroups[0]);
	          } else if (roles.includes('Relationship Manager')) {
	            replace('/' + adminRoute + '/' + statusGroups[0]);
	          } else if (roles.includes('Client Adviser')) {
	            replace('/' + adminRoute + '/contacts');
	          } else {
	            replace('/' + adminRoute + '/' + statusGroups[0]);
	          }
	        }
	
	        if (roles.includes('Client')) {
	          replace(clientRoute);
	        }
	
	        if (roles.includes('Applicant')) {
	          replace(applicantRoute);
	        }
	        return cb();
	      }
	
	      // Something related to guide(?) ...
	
	      if (firstParam === 'admin' && !~adminPages.indexOf[secondParam] && statusGroups && !~statusGroups.indexOf(nextRouterState.params.navColumnState)) {
	        replace('/' + adminRoute + '/' + statusGroups[0]);
	      }
	
	      return cb();
	    };
	  };
	};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nextState, replaceState) {
	  var profileId = nextState.params.profileId;
	  var page = nextState.params.page;
	
	  switch (page) {
	    case 'assessments':
	      replaceState({}, '/admin/Qualified/' + profileId + '/Profile/Preliminary%20Information?detail=1&edit=2');
	      break;
	    case 'resume':
	      replaceState({}, '/admin/Qualified/' + profileId + '/Profile/Preliminary%20Information/resume');
	      break;
	    case 'resume-pdf':
	      replaceState({}, '/api/applicants/' + profileId + '/pdf/' + ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).CRON_SECRET);
	      break;
	    default:
	      replaceState({}, '/');
	      break;
	  }
	};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadStaticData = loadStaticData;
	exports.loadLabelData = loadLabelData;
	
	var _staticData = __webpack_require__(1124);
	
	var staticDataApi = _interopRequireWildcard(_staticData);
	
	var _staticData2 = __webpack_require__(1132);
	
	var staticDataStore = _interopRequireWildcard(_staticData2);
	
	var _labels = __webpack_require__(1123);
	
	var labelDataApi = _interopRequireWildcard(_labels);
	
	var _labels2 = __webpack_require__(1130);
	
	var labelDataStore = _interopRequireWildcard(_labels2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function loadStaticData(store) {
	  return new Promise(function (resolve, reject) {
	    return store.dispatch(staticDataApi.loadData({
	      success: function success(data) {
	        store.dispatch(staticDataStore.updateStaticData(data));
	        resolve();
	      },
	      error: function error(err) {
	        console.log(err);
	        reject(err);
	      }
	    }));
	  });
	}
	
	function loadLabelData(store, accountId) {
	  return new Promise(function (resolve, reject) {
	    return store.dispatch(labelDataApi.loadData({
	      success: function success(data) {
	        store.dispatch(labelDataStore.updateLabels(data));
	        resolve();
	      },
	      error: function error(err) {
	        console.log(err);
	        reject(err);
	      }
	    }));
	  });
	}

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setBrowserData;
	
	var _sync = __webpack_require__(21);
	
	function setBrowserData(store) {
	  return Promise.resolve(store.dispatch((0, _sync.getScrollBarWidth)()));
	}

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1513);
	
	__webpack_require__(1181);
	
	__webpack_require__(1262);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1265), __esModule: true };

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1266), __esModule: true };

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1268), __esModule: true };

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1273), __esModule: true };

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1274), __esModule: true };

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),
/* 1188 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = bail;
	
	function bail(err) {
	  if (err) {
	    throw err;
	  }
	}


/***/ }),
/* 1189 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'apathy',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#031A16',
	  base01: '#0B342D',
	  base02: '#184E45',
	  base03: '#2B685E',
	  base04: '#5F9C92',
	  base05: '#81B5AC',
	  base06: '#A7CEC8',
	  base07: '#D2E7E4',
	  base08: '#3E9688',
	  base09: '#3E7996',
	  base0A: '#3E4C96',
	  base0B: '#883E96',
	  base0C: '#963E4C',
	  base0D: '#96883E',
	  base0E: '#4C963E',
	  base0F: '#3E965B'
	};
	module.exports = exports['default'];

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'ashes',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#1C2023',
	  base01: '#393F45',
	  base02: '#565E65',
	  base03: '#747C84',
	  base04: '#ADB3BA',
	  base05: '#C7CCD1',
	  base06: '#DFE2E5',
	  base07: '#F3F4F5',
	  base08: '#C7AE95',
	  base09: '#C7C795',
	  base0A: '#AEC795',
	  base0B: '#95C7AE',
	  base0C: '#95AEC7',
	  base0D: '#AE95C7',
	  base0E: '#C795AE',
	  base0F: '#C79595'
	};
	module.exports = exports['default'];

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier dune',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)',
	  base00: '#20201d',
	  base01: '#292824',
	  base02: '#6e6b5e',
	  base03: '#7d7a68',
	  base04: '#999580',
	  base05: '#a6a28c',
	  base06: '#e8e4cf',
	  base07: '#fefbec',
	  base08: '#d73737',
	  base09: '#b65611',
	  base0A: '#cfb017',
	  base0B: '#60ac39',
	  base0C: '#1fad83',
	  base0D: '#6684e1',
	  base0E: '#b854d4',
	  base0F: '#d43552'
	};
	module.exports = exports['default'];

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier forest',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)',
	  base00: '#1b1918',
	  base01: '#2c2421',
	  base02: '#68615e',
	  base03: '#766e6b',
	  base04: '#9c9491',
	  base05: '#a8a19f',
	  base06: '#e6e2e0',
	  base07: '#f1efee',
	  base08: '#f22c40',
	  base09: '#df5320',
	  base0A: '#d5911a',
	  base0B: '#5ab738',
	  base0C: '#00ad9c',
	  base0D: '#407ee7',
	  base0E: '#6666ea',
	  base0F: '#c33ff3'
	};
	module.exports = exports['default'];

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier heath',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)',
	  base00: '#1b181b',
	  base01: '#292329',
	  base02: '#695d69',
	  base03: '#776977',
	  base04: '#9e8f9e',
	  base05: '#ab9bab',
	  base06: '#d8cad8',
	  base07: '#f7f3f7',
	  base08: '#ca402b',
	  base09: '#a65926',
	  base0A: '#bb8a35',
	  base0B: '#379a37',
	  base0C: '#159393',
	  base0D: '#516aec',
	  base0E: '#7b59c0',
	  base0F: '#cc33cc'
	};
	module.exports = exports['default'];

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier lakeside',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)',
	  base00: '#161b1d',
	  base01: '#1f292e',
	  base02: '#516d7b',
	  base03: '#5a7b8c',
	  base04: '#7195a8',
	  base05: '#7ea2b4',
	  base06: '#c1e4f6',
	  base07: '#ebf8ff',
	  base08: '#d22d72',
	  base09: '#935c25',
	  base0A: '#8a8a0f',
	  base0B: '#568c3b',
	  base0C: '#2d8f6f',
	  base0D: '#257fad',
	  base0E: '#5d5db1',
	  base0F: '#b72dd2'
	};
	module.exports = exports['default'];

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier seaside',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)',
	  base00: '#131513',
	  base01: '#242924',
	  base02: '#5e6e5e',
	  base03: '#687d68',
	  base04: '#809980',
	  base05: '#8ca68c',
	  base06: '#cfe8cf',
	  base07: '#f0fff0',
	  base08: '#e6193c',
	  base09: '#87711d',
	  base0A: '#c3c322',
	  base0B: '#29a329',
	  base0C: '#1999b3',
	  base0D: '#3d62f5',
	  base0E: '#ad2bee',
	  base0F: '#e619c3'
	};
	module.exports = exports['default'];

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'bespin',
	  author: 'jan t. sott',
	  base00: '#28211c',
	  base01: '#36312e',
	  base02: '#5e5d5c',
	  base03: '#666666',
	  base04: '#797977',
	  base05: '#8a8986',
	  base06: '#9d9b97',
	  base07: '#baae9e',
	  base08: '#cf6a4c',
	  base09: '#cf7d34',
	  base0A: '#f9ee98',
	  base0B: '#54be0d',
	  base0C: '#afc4db',
	  base0D: '#5ea6ea',
	  base0E: '#9b859d',
	  base0F: '#937121'
	};
	module.exports = exports['default'];

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'brewer',
	  author: 'timothée poisot (http://github.com/tpoisot)',
	  base00: '#0c0d0e',
	  base01: '#2e2f30',
	  base02: '#515253',
	  base03: '#737475',
	  base04: '#959697',
	  base05: '#b7b8b9',
	  base06: '#dadbdc',
	  base07: '#fcfdfe',
	  base08: '#e31a1c',
	  base09: '#e6550d',
	  base0A: '#dca060',
	  base0B: '#31a354',
	  base0C: '#80b1d3',
	  base0D: '#3182bd',
	  base0E: '#756bb1',
	  base0F: '#b15928'
	};
	module.exports = exports['default'];

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'bright',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#000000',
	  base01: '#303030',
	  base02: '#505050',
	  base03: '#b0b0b0',
	  base04: '#d0d0d0',
	  base05: '#e0e0e0',
	  base06: '#f5f5f5',
	  base07: '#ffffff',
	  base08: '#fb0120',
	  base09: '#fc6d24',
	  base0A: '#fda331',
	  base0B: '#a1c659',
	  base0C: '#76c7b7',
	  base0D: '#6fb3d2',
	  base0E: '#d381c3',
	  base0F: '#be643c'
	};
	module.exports = exports['default'];

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'chalk',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#151515',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#b0b0b0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#f5f5f5',
	  base08: '#fb9fb1',
	  base09: '#eda987',
	  base0A: '#ddb26f',
	  base0B: '#acc267',
	  base0C: '#12cfc0',
	  base0D: '#6fc2ef',
	  base0E: '#e1a3ee',
	  base0F: '#deaf8f'
	};
	module.exports = exports['default'];

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'codeschool',
	  author: 'brettof86',
	  base00: '#232c31',
	  base01: '#1c3657',
	  base02: '#2a343a',
	  base03: '#3f4944',
	  base04: '#84898c',
	  base05: '#9ea7a6',
	  base06: '#a7cfa3',
	  base07: '#b5d8f6',
	  base08: '#2a5491',
	  base09: '#43820d',
	  base0A: '#a03b1e',
	  base0B: '#237986',
	  base0C: '#b02f30',
	  base0D: '#484d79',
	  base0E: '#c59820',
	  base0F: '#c98344'
	};
	module.exports = exports['default'];

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'colors',
	  author: 'mrmrs (http://clrs.cc)',
	  base00: '#111111',
	  base01: '#333333',
	  base02: '#555555',
	  base03: '#777777',
	  base04: '#999999',
	  base05: '#bbbbbb',
	  base06: '#dddddd',
	  base07: '#ffffff',
	  base08: '#ff4136',
	  base09: '#ff851b',
	  base0A: '#ffdc00',
	  base0B: '#2ecc40',
	  base0C: '#7fdbff',
	  base0D: '#0074d9',
	  base0E: '#b10dc9',
	  base0F: '#85144b'
	};
	module.exports = exports['default'];

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'default',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#181818',
	  base01: '#282828',
	  base02: '#383838',
	  base03: '#585858',
	  base04: '#b8b8b8',
	  base05: '#d8d8d8',
	  base06: '#e8e8e8',
	  base07: '#f8f8f8',
	  base08: '#ab4642',
	  base09: '#dc9656',
	  base0A: '#f7ca88',
	  base0B: '#a1b56c',
	  base0C: '#86c1b9',
	  base0D: '#7cafc2',
	  base0E: '#ba8baf',
	  base0F: '#a16946'
	};
	module.exports = exports['default'];

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'eighties',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2d2d2d',
	  base01: '#393939',
	  base02: '#515151',
	  base03: '#747369',
	  base04: '#a09f93',
	  base05: '#d3d0c8',
	  base06: '#e8e6df',
	  base07: '#f2f0ec',
	  base08: '#f2777a',
	  base09: '#f99157',
	  base0A: '#ffcc66',
	  base0B: '#99cc99',
	  base0C: '#66cccc',
	  base0D: '#6699cc',
	  base0E: '#cc99cc',
	  base0F: '#d27b53'
	};
	module.exports = exports['default'];

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'embers',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#16130F',
	  base01: '#2C2620',
	  base02: '#433B32',
	  base03: '#5A5047',
	  base04: '#8A8075',
	  base05: '#A39A90',
	  base06: '#BEB6AE',
	  base07: '#DBD6D1',
	  base08: '#826D57',
	  base09: '#828257',
	  base0A: '#6D8257',
	  base0B: '#57826D',
	  base0C: '#576D82',
	  base0D: '#6D5782',
	  base0E: '#82576D',
	  base0F: '#825757'
	};
	module.exports = exports['default'];

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'flat',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2C3E50',
	  base01: '#34495E',
	  base02: '#7F8C8D',
	  base03: '#95A5A6',
	  base04: '#BDC3C7',
	  base05: '#e0e0e0',
	  base06: '#f5f5f5',
	  base07: '#ECF0F1',
	  base08: '#E74C3C',
	  base09: '#E67E22',
	  base0A: '#F1C40F',
	  base0B: '#2ECC71',
	  base0C: '#1ABC9C',
	  base0D: '#3498DB',
	  base0E: '#9B59B6',
	  base0F: '#be643c'
	};
	module.exports = exports['default'];

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'google',
	  author: 'seth wright (http://sethawright.com)',
	  base00: '#1d1f21',
	  base01: '#282a2e',
	  base02: '#373b41',
	  base03: '#969896',
	  base04: '#b4b7b4',
	  base05: '#c5c8c6',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#CC342B',
	  base09: '#F96A38',
	  base0A: '#FBA922',
	  base0B: '#198844',
	  base0C: '#3971ED',
	  base0D: '#3971ED',
	  base0E: '#A36AC7',
	  base0F: '#3971ED'
	};
	module.exports = exports['default'];

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'grayscale',
	  author: 'alexandre gavioli (https://github.com/alexx2/)',
	  base00: '#101010',
	  base01: '#252525',
	  base02: '#464646',
	  base03: '#525252',
	  base04: '#ababab',
	  base05: '#b9b9b9',
	  base06: '#e3e3e3',
	  base07: '#f7f7f7',
	  base08: '#7c7c7c',
	  base09: '#999999',
	  base0A: '#a0a0a0',
	  base0B: '#8e8e8e',
	  base0C: '#868686',
	  base0D: '#686868',
	  base0E: '#747474',
	  base0F: '#5e5e5e'
	};
	module.exports = exports['default'];

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'green screen',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#001100',
	  base01: '#003300',
	  base02: '#005500',
	  base03: '#007700',
	  base04: '#009900',
	  base05: '#00bb00',
	  base06: '#00dd00',
	  base07: '#00ff00',
	  base08: '#007700',
	  base09: '#009900',
	  base0A: '#007700',
	  base0B: '#00bb00',
	  base0C: '#005500',
	  base0D: '#009900',
	  base0E: '#00bb00',
	  base0F: '#005500'
	};
	module.exports = exports['default'];

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'harmonic16',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#0b1c2c',
	  base01: '#223b54',
	  base02: '#405c79',
	  base03: '#627e99',
	  base04: '#aabcce',
	  base05: '#cbd6e2',
	  base06: '#e5ebf1',
	  base07: '#f7f9fb',
	  base08: '#bf8b56',
	  base09: '#bfbf56',
	  base0A: '#8bbf56',
	  base0B: '#56bf8b',
	  base0C: '#568bbf',
	  base0D: '#8b56bf',
	  base0E: '#bf568b',
	  base0F: '#bf5656'
	};
	module.exports = exports['default'];

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'hopscotch',
	  author: 'jan t. sott',
	  base00: '#322931',
	  base01: '#433b42',
	  base02: '#5c545b',
	  base03: '#797379',
	  base04: '#989498',
	  base05: '#b9b5b8',
	  base06: '#d5d3d5',
	  base07: '#ffffff',
	  base08: '#dd464c',
	  base09: '#fd8b19',
	  base0A: '#fdcc59',
	  base0B: '#8fc13e',
	  base0C: '#149b93',
	  base0D: '#1290bf',
	  base0E: '#c85e7c',
	  base0F: '#b33508'
	};
	module.exports = exports['default'];

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'isotope',
	  author: 'jan t. sott',
	  base00: '#000000',
	  base01: '#404040',
	  base02: '#606060',
	  base03: '#808080',
	  base04: '#c0c0c0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#ff0000',
	  base09: '#ff9900',
	  base0A: '#ff0099',
	  base0B: '#33ff00',
	  base0C: '#00ffff',
	  base0D: '#0066ff',
	  base0E: '#cc00ff',
	  base0F: '#3300ff'
	};
	module.exports = exports['default'];

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'marrakesh',
	  author: 'alexandre gavioli (http://github.com/alexx2/)',
	  base00: '#201602',
	  base01: '#302e00',
	  base02: '#5f5b17',
	  base03: '#6c6823',
	  base04: '#86813b',
	  base05: '#948e48',
	  base06: '#ccc37a',
	  base07: '#faf0a5',
	  base08: '#c35359',
	  base09: '#b36144',
	  base0A: '#a88339',
	  base0B: '#18974e',
	  base0C: '#75a738',
	  base0D: '#477ca1',
	  base0E: '#8868b3',
	  base0F: '#b3588e'
	};
	module.exports = exports['default'];

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'mocha',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#3B3228',
	  base01: '#534636',
	  base02: '#645240',
	  base03: '#7e705a',
	  base04: '#b8afad',
	  base05: '#d0c8c6',
	  base06: '#e9e1dd',
	  base07: '#f5eeeb',
	  base08: '#cb6077',
	  base09: '#d28b71',
	  base0A: '#f4bc87',
	  base0B: '#beb55b',
	  base0C: '#7bbda4',
	  base0D: '#8ab3b5',
	  base0E: '#a89bb9',
	  base0F: '#bb9584'
	};
	module.exports = exports['default'];

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'monokai',
	  author: 'wimer hazenberg (http://www.monokai.nl)',
	  base00: '#272822',
	  base01: '#383830',
	  base02: '#49483e',
	  base03: '#75715e',
	  base04: '#a59f85',
	  base05: '#f8f8f2',
	  base06: '#f5f4f1',
	  base07: '#f9f8f5',
	  base08: '#f92672',
	  base09: '#fd971f',
	  base0A: '#f4bf75',
	  base0B: '#a6e22e',
	  base0C: '#a1efe4',
	  base0D: '#66d9ef',
	  base0E: '#ae81ff',
	  base0F: '#cc6633'
	};
	module.exports = exports['default'];

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'ocean',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2b303b',
	  base01: '#343d46',
	  base02: '#4f5b66',
	  base03: '#65737e',
	  base04: '#a7adba',
	  base05: '#c0c5ce',
	  base06: '#dfe1e8',
	  base07: '#eff1f5',
	  base08: '#bf616a',
	  base09: '#d08770',
	  base0A: '#ebcb8b',
	  base0B: '#a3be8c',
	  base0C: '#96b5b4',
	  base0D: '#8fa1b3',
	  base0E: '#b48ead',
	  base0F: '#ab7967'
	};
	module.exports = exports['default'];

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'paraiso',
	  author: 'jan t. sott',
	  base00: '#2f1e2e',
	  base01: '#41323f',
	  base02: '#4f424c',
	  base03: '#776e71',
	  base04: '#8d8687',
	  base05: '#a39e9b',
	  base06: '#b9b6b0',
	  base07: '#e7e9db',
	  base08: '#ef6155',
	  base09: '#f99b15',
	  base0A: '#fec418',
	  base0B: '#48b685',
	  base0C: '#5bc4bf',
	  base0D: '#06b6ef',
	  base0E: '#815ba4',
	  base0F: '#e96ba8'
	};
	module.exports = exports['default'];

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'pop',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#000000',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#b0b0b0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#eb008a',
	  base09: '#f29333',
	  base0A: '#f8ca12',
	  base0B: '#37b349',
	  base0C: '#00aabb',
	  base0D: '#0e5a94',
	  base0E: '#b31e8d',
	  base0F: '#7a2d00'
	};
	module.exports = exports['default'];

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'railscasts',
	  author: 'ryan bates (http://railscasts.com)',
	  base00: '#2b2b2b',
	  base01: '#272935',
	  base02: '#3a4055',
	  base03: '#5a647e',
	  base04: '#d4cfc9',
	  base05: '#e6e1dc',
	  base06: '#f4f1ed',
	  base07: '#f9f7f3',
	  base08: '#da4939',
	  base09: '#cc7833',
	  base0A: '#ffc66d',
	  base0B: '#a5c261',
	  base0C: '#519f50',
	  base0D: '#6d9cbe',
	  base0E: '#b6b3eb',
	  base0F: '#bc9458'
	};
	module.exports = exports['default'];

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'shapeshifter',
	  author: 'tyler benziger (http://tybenz.com)',
	  base00: '#000000',
	  base01: '#040404',
	  base02: '#102015',
	  base03: '#343434',
	  base04: '#555555',
	  base05: '#ababab',
	  base06: '#e0e0e0',
	  base07: '#f9f9f9',
	  base08: '#e92f2f',
	  base09: '#e09448',
	  base0A: '#dddd13',
	  base0B: '#0ed839',
	  base0C: '#23edda',
	  base0D: '#3b48e3',
	  base0E: '#f996e2',
	  base0F: '#69542d'
	};
	module.exports = exports['default'];

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'solarized',
	  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
	  base00: '#002b36',
	  base01: '#073642',
	  base02: '#586e75',
	  base03: '#657b83',
	  base04: '#839496',
	  base05: '#93a1a1',
	  base06: '#eee8d5',
	  base07: '#fdf6e3',
	  base08: '#dc322f',
	  base09: '#cb4b16',
	  base0A: '#b58900',
	  base0B: '#859900',
	  base0C: '#2aa198',
	  base0D: '#268bd2',
	  base0E: '#6c71c4',
	  base0F: '#d33682'
	};
	module.exports = exports['default'];

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'summerfruit',
	  author: 'christopher corley (http://cscorley.github.io/)',
	  base00: '#151515',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#B0B0B0',
	  base05: '#D0D0D0',
	  base06: '#E0E0E0',
	  base07: '#FFFFFF',
	  base08: '#FF0086',
	  base09: '#FD8900',
	  base0A: '#ABA800',
	  base0B: '#00C918',
	  base0C: '#1faaaa',
	  base0D: '#3777E6',
	  base0E: '#AD00A1',
	  base0F: '#cc6633'
	};
	module.exports = exports['default'];

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'threezerotwofour',
	  author: 'jan t. sott (http://github.com/idleberg)',
	  base00: '#090300',
	  base01: '#3a3432',
	  base02: '#4a4543',
	  base03: '#5c5855',
	  base04: '#807d7c',
	  base05: '#a5a2a2',
	  base06: '#d6d5d4',
	  base07: '#f7f7f7',
	  base08: '#db2d20',
	  base09: '#e8bbd0',
	  base0A: '#fded02',
	  base0B: '#01a252',
	  base0C: '#b5e4f4',
	  base0D: '#01a0e4',
	  base0E: '#a16a94',
	  base0F: '#cdab53'
	};
	module.exports = exports['default'];

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'tomorrow',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#1d1f21',
	  base01: '#282a2e',
	  base02: '#373b41',
	  base03: '#969896',
	  base04: '#b4b7b4',
	  base05: '#c5c8c6',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#cc6666',
	  base09: '#de935f',
	  base0A: '#f0c674',
	  base0B: '#b5bd68',
	  base0C: '#8abeb7',
	  base0D: '#81a2be',
	  base0E: '#b294bb',
	  base0F: '#a3685a'
	};
	module.exports = exports['default'];

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'london tube',
	  author: 'jan t. sott',
	  base00: '#231f20',
	  base01: '#1c3f95',
	  base02: '#5a5758',
	  base03: '#737171',
	  base04: '#959ca1',
	  base05: '#d9d8d8',
	  base06: '#e7e7e8',
	  base07: '#ffffff',
	  base08: '#ee2e24',
	  base09: '#f386a1',
	  base0A: '#ffd204',
	  base0B: '#00853e',
	  base0C: '#85cebc',
	  base0D: '#009ddc',
	  base0E: '#98005d',
	  base0F: '#b06110'
	};
	module.exports = exports['default'];

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'twilight',
	  author: 'david hart (http://hart-dev.com)',
	  base00: '#1e1e1e',
	  base01: '#323537',
	  base02: '#464b50',
	  base03: '#5f5a60',
	  base04: '#838184',
	  base05: '#a7a7a7',
	  base06: '#c3c3c3',
	  base07: '#ffffff',
	  base08: '#cf6a4c',
	  base09: '#cda869',
	  base0A: '#f9ee98',
	  base0B: '#8f9d6a',
	  base0C: '#afc4db',
	  base0D: '#7587a6',
	  base0E: '#9b859d',
	  base0F: '#9b703f'
	};
	module.exports = exports['default'];

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(1252);
	var Queue = __webpack_require__(1249);
	var util = __webpack_require__(40);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(40);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(40);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(127).Warning;
	var util = __webpack_require__(40);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new CustomEvent(name.toLowerCase(), {
	                    detail: event,
	                    cancelable: true
	                });
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(40);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(492)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(127);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(40);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(40);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(40);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(40);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(40);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(40);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(172);
	var Async = __webpack_require__(1230);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(127);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(1256)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(1246)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(1234)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(1235)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(1239)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(492)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(493);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(1243)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(1231)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(1233)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(1236)(Promise);
	__webpack_require__(1255)(Promise);
	__webpack_require__(1241)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.0";
	__webpack_require__(1242)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(1232)(Promise);
	__webpack_require__(1258)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(1257)(Promise, INTERNAL, debug);
	__webpack_require__(1240)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(1244)(Promise);
	__webpack_require__(1247)(Promise, INTERNAL);
	__webpack_require__(1248)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(1250)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(1251)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(1253)(Promise, PromiseArray, debug);
	__webpack_require__(1254)(Promise, PromiseArray, apiRejection);
	__webpack_require__(1238)(Promise, INTERNAL);
	__webpack_require__(1237)(Promise, INTERNAL);
	__webpack_require__(1229)(Promise);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(40);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(40);
	var nodebackForPromise = __webpack_require__(493);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(127).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(40);
	var isObject = util.isObject;
	var es5 = __webpack_require__(172);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(40);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(40);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(40);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova))) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(61), __webpack_require__(3049).setImmediate))

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(40);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(40);
	var RangeError = __webpack_require__(127).RangeError;
	var AggregateError = __webpack_require__(127).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(40);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(40);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(40);
	    var TypeError = __webpack_require__(127).TypeError;
	    var inherits = __webpack_require__(40).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1227)
	var ieee754 = __webpack_require__(1550)
	var isArray = __webpack_require__(1583)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 1261 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = collapse;
	
	/* collapse(' \t\nbar \nbaz\t'); // ' bar baz ' */
	function collapse(value) {
	  return String(value).replace(/\s+/g, ' ');
	}


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1321);
	module.exports = __webpack_require__(100).RegExp.escape;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(244);
	__webpack_require__(1298);
	module.exports = __webpack_require__(57).Array.from;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(336);
	__webpack_require__(244);
	module.exports = __webpack_require__(1296);


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(336);
	__webpack_require__(244);
	module.exports = __webpack_require__(1297);


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1300);
	module.exports = __webpack_require__(57).Number.isSafeInteger;


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1301);
	module.exports = __webpack_require__(57).Object.assign;


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1302);
	var $Object = __webpack_require__(57).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1303);
	var $Object = __webpack_require__(57).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1304);
	var $Object = __webpack_require__(57).Object;
	module.exports = function getOwnPropertyNames(it) {
	  return $Object.getOwnPropertyNames(it);
	};


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1305);
	module.exports = __webpack_require__(57).Object.getPrototypeOf;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1306);
	module.exports = __webpack_require__(57).Object.keys;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1307);
	module.exports = __webpack_require__(57).Object.setPrototypeOf;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1309);
	__webpack_require__(1308);
	__webpack_require__(1310);
	__webpack_require__(1311);
	module.exports = __webpack_require__(57).Symbol;


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(244);
	__webpack_require__(336);
	module.exports = __webpack_require__(335).f('iterator');


/***/ }),
/* 1276 */
58,
/* 1277 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 1278 */
[3119, 146, 507, 1295],
/* 1279 */
[3121, 129, 215],
/* 1280 */
[3125, 178, 327, 242],
/* 1281 */
[3127, 128],
/* 1282 */
[3130, 177, 93],
/* 1283 */
[3131, 321],
/* 1284 */
[3132, 176],
/* 1285 */
[3133, 143],
/* 1286 */
[3134, 326, 215, 329, 175, 93],
/* 1287 */
[3136, 93],
/* 1288 */
521,
/* 1289 */
[3137, 178, 146],
/* 1290 */
[3138, 243, 176, 145, 129, 174],
/* 1291 */
[3139, 178, 327, 242, 216, 499, 174],
/* 1292 */
[3142, 129, 143, 178, 144],
/* 1293 */
[3150, 176, 143, 322, 501],
/* 1294 */
[3154, 332, 323],
/* 1295 */
[3155, 332],
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(143);
	var get = __webpack_require__(508);
	module.exports = __webpack_require__(57).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(496);
	var ITERATOR = __webpack_require__(93)('iterator');
	var Iterators = __webpack_require__(177);
	module.exports = __webpack_require__(57).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 1298 */
[3164, 322, 111, 216, 1285, 1282, 507, 1279, 508, 1287],
/* 1299 */
[3165, 1277, 1288, 177, 146, 500],
/* 1300 */
[3166, 111, 1284],
/* 1301 */
[3167, 111, 1291],
/* 1302 */
[3168, 111, 326],
/* 1303 */
[3169, 111, 144, 129],
/* 1304 */
[3170, 328, 502],
/* 1305 */
[3171, 216, 504, 328],
/* 1306 */
[3172, 216, 178, 328],
/* 1307 */
[3173, 111, 1293],
/* 1308 */
/***/ (function(module, exports) {



/***/ }),
/* 1309 */
[3175, 128, 145, 144, 111, 506, 1290, 174, 331, 329, 243, 93, 335, 334, 1289, 1280, 1283, 143, 146, 333, 215, 326, 502, 501, 129, 178, 503, 242, 327, 325, 175],
/* 1310 */
[3176, 334],
/* 1311 */
[3177, 334],
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(38);
	var isArray = __webpack_require__(250);
	var SPECIES = __webpack_require__(41)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(34);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(27);
	var toPrimitive = __webpack_require__(104);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 1315 */
[3125, 132, 254, 219],
/* 1316 */
[3137, 132, 80],
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path = __webpack_require__(1318);
	var invoke = __webpack_require__(249);
	var aFunction = __webpack_require__(58);
	module.exports = function (/* ...pargs */) {
	  var fn = aFunction(this);
	  var length = arguments.length;
	  var pargs = Array(length);
	  var i = 0;
	  var _ = path._;
	  var holder = false;
	  while (length > i) if ((pargs[i] = arguments[i++]) === _) holder = true;
	  return function (/* ...args */) {
	    var that = this;
	    var aLen = arguments.length;
	    var j = 0;
	    var k = 0;
	    var args;
	    if (!holder && !aLen) return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if (holder) for (;length > j; j++) if (args[j] === _) args[j] = arguments[k++];
	    while (aLen > k) args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(29);


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(7);
	var $re = __webpack_require__(1319)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(7);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(510) });
	
	__webpack_require__(130)('copyWithin');


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $every = __webpack_require__(99)(4);
	
	$export($export.P + $export.F * !__webpack_require__(96)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(7);
	
	$export($export.P, 'Array', { fill: __webpack_require__(337) });
	
	__webpack_require__(130)('fill');


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $filter = __webpack_require__(99)(2);
	
	$export($export.P + $export.F * !__webpack_require__(96)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(7);
	var $find = __webpack_require__(99)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(130)(KEY);


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(7);
	var $find = __webpack_require__(99)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(130)(KEY);


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $forEach = __webpack_require__(99)(0);
	var STRICT = __webpack_require__(96)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1329 */
[3164, 95, 7, 50, 520, 345, 46, 339, 361, 252],
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $indexOf = __webpack_require__(245)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(96)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(250) });


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(7);
	var toIObject = __webpack_require__(80);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(218) != Object || !__webpack_require__(96)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toIObject = __webpack_require__(80);
	var toInteger = __webpack_require__(103);
	var toLength = __webpack_require__(46);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(96)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $map = __webpack_require__(99)(1);
	
	$export($export.P + $export.F * !__webpack_require__(96)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var createProperty = __webpack_require__(339);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(34)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $reduce = __webpack_require__(512);
	
	$export($export.P + $export.F * !__webpack_require__(96)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $reduce = __webpack_require__(512);
	
	$export($export.P + $export.F * !__webpack_require__(96)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var html = __webpack_require__(343);
	var cof = __webpack_require__(94);
	var toAbsoluteIndex = __webpack_require__(155);
	var toLength = __webpack_require__(46);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(34)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $some = __webpack_require__(99)(3);
	
	$export($export.P + $export.F * !__webpack_require__(96)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var aFunction = __webpack_require__(58);
	var toObject = __webpack_require__(50);
	var fails = __webpack_require__(34);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(96)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(154)('Array');


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(7);
	var toISOString = __webpack_require__(1313);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(50);
	var toPrimitive = __webpack_require__(104);
	
	$export($export.P + $export.F * __webpack_require__(34)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(41)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(77)(proto, TO_PRIMITIVE, __webpack_require__(1314));


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(78)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(7);
	
	$export($export.P, 'Function', { bind: __webpack_require__(513) });


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(38);
	var getPrototypeOf = __webpack_require__(86);
	var HAS_INSTANCE = __webpack_require__(41)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(45).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(45).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(44) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(7);
	var log1p = __webpack_require__(523);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(7);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(7);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(7);
	var sign = __webpack_require__(349);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(7);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(7);
	var $expm1 = __webpack_require__(348);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { fround: __webpack_require__(522) });


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(7);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(7);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(34)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(523) });


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { sign: __webpack_require__(349) });


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(7);
	var expm1 = __webpack_require__(348);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(34)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(7);
	var expm1 = __webpack_require__(348);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(29);
	var has = __webpack_require__(76);
	var cof = __webpack_require__(94);
	var inheritIfRequired = __webpack_require__(344);
	var toPrimitive = __webpack_require__(104);
	var fails = __webpack_require__(34);
	var gOPN = __webpack_require__(151).f;
	var gOPD = __webpack_require__(85).f;
	var dP = __webpack_require__(45).f;
	var $trim = __webpack_require__(181).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(150)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(44) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(78)(global, NUMBER, $Number);
	}


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(7);
	var _isFinite = __webpack_require__(29).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(519) });


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 1372 */
[3166, 7, 519],
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $parseFloat = __webpack_require__(531);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $parseInt = __webpack_require__(532);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toInteger = __webpack_require__(103);
	var aNumberValue = __webpack_require__(509);
	var repeat = __webpack_require__(356);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(34)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $fails = __webpack_require__(34);
	var aNumberValue = __webpack_require__(509);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 1379 */
[3167, 7, 525],
/* 1380 */
[3168, 7, 150],
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(44), 'Object', { defineProperties: __webpack_require__(526) });


/***/ }),
/* 1382 */
[3169, 7, 44, 45],
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(38);
	var meta = __webpack_require__(131).onFreeze;
	
	__webpack_require__(102)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(80);
	var $getOwnPropertyDescriptor = __webpack_require__(85).f;
	
	__webpack_require__(102)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 1385 */
[3170, 102, 527],
/* 1386 */
[3171, 50, 86, 102],
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(38);
	
	__webpack_require__(102)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(38);
	
	__webpack_require__(102)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(38);
	
	__webpack_require__(102)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(7);
	$export($export.S, 'Object', { is: __webpack_require__(1320) });


/***/ }),
/* 1391 */
[3172, 50, 132, 102],
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(38);
	var meta = __webpack_require__(131).onFreeze;
	
	__webpack_require__(102)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(38);
	var meta = __webpack_require__(131).onFreeze;
	
	__webpack_require__(102)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 1394 */
[3173, 7, 352],
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(217);
	var test = {};
	test[__webpack_require__(41)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(78)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $parseFloat = __webpack_require__(531);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $parseInt = __webpack_require__(532);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(149);
	var global = __webpack_require__(29);
	var ctx = __webpack_require__(95);
	var classof = __webpack_require__(217);
	var $export = __webpack_require__(7);
	var isObject = __webpack_require__(38);
	var aFunction = __webpack_require__(58);
	var anInstance = __webpack_require__(147);
	var forOf = __webpack_require__(148);
	var speciesConstructor = __webpack_require__(258);
	var task = __webpack_require__(358).set;
	var microtask = __webpack_require__(350)();
	var newPromiseCapabilityModule = __webpack_require__(351);
	var perform = __webpack_require__(533);
	var promiseResolve = __webpack_require__(534);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(41)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var sameConstructor = LIBRARY ? function (a, b) {
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	} : function (a, b) {
	  return a === b;
	};
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  } return true;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(153)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return sameConstructor($Promise, C)
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(180)($Promise, PROMISE);
	__webpack_require__(154)(PROMISE);
	Wrapper = __webpack_require__(100)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
	    return promiseResolve(this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(252)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(7);
	var aFunction = __webpack_require__(58);
	var anObject = __webpack_require__(27);
	var rApply = (__webpack_require__(29).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(34)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(7);
	var create = __webpack_require__(150);
	var aFunction = __webpack_require__(58);
	var anObject = __webpack_require__(27);
	var isObject = __webpack_require__(38);
	var fails = __webpack_require__(34);
	var bind = __webpack_require__(513);
	var rConstruct = (__webpack_require__(29).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(45);
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(27);
	var toPrimitive = __webpack_require__(104);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(34)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(7);
	var gOPD = __webpack_require__(85).f;
	var anObject = __webpack_require__(27);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(27);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(346)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(85);
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(27);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(7);
	var getProto = __webpack_require__(86);
	var anObject = __webpack_require__(27);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(85);
	var getPrototypeOf = __webpack_require__(86);
	var has = __webpack_require__(76);
	var $export = __webpack_require__(7);
	var isObject = __webpack_require__(38);
	var anObject = __webpack_require__(27);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(27);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(530) });


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(27);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(7);
	var setProto = __webpack_require__(352);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(45);
	var gOPD = __webpack_require__(85);
	var getPrototypeOf = __webpack_require__(86);
	var has = __webpack_require__(76);
	var $export = __webpack_require__(7);
	var createDesc = __webpack_require__(152);
	var anObject = __webpack_require__(27);
	var isObject = __webpack_require__(38);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29);
	var inheritIfRequired = __webpack_require__(344);
	var dP = __webpack_require__(45).f;
	var gOPN = __webpack_require__(151).f;
	var isRegExp = __webpack_require__(251);
	var $flags = __webpack_require__(248);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(44) && (!CORRECT_NEW || __webpack_require__(34)(function () {
	  re2[__webpack_require__(41)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(78)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(154)('RegExp');


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(247)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(247)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(247)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(247)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(251);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(539);
	var anObject = __webpack_require__(27);
	var $flags = __webpack_require__(248);
	var DESCRIPTORS = __webpack_require__(44);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(78)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(34)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(79)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(79)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(79)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(79)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $at = __webpack_require__(354)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(7);
	var toLength = __webpack_require__(46);
	var context = __webpack_require__(355);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(342)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(79)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(79)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(79)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var toAbsoluteIndex = __webpack_require__(155);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(7);
	var context = __webpack_require__(355);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(342)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(79)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 1431 */
[3174, 354, 347],
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(79)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var toIObject = __webpack_require__(80);
	var toLength = __webpack_require__(46);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(356)
	});


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(79)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(7);
	var toLength = __webpack_require__(46);
	var context = __webpack_require__(355);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(342)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(79)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(79)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(79)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(181)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 1441 */
[3175, 29, 76, 44, 7, 78, 131, 34, 257, 180, 156, 41, 537, 360, 1316, 1315, 250, 27, 80, 104, 152, 150, 527, 85, 45, 132, 151, 219, 254, 149, 77],
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $typed = __webpack_require__(259);
	var buffer = __webpack_require__(359);
	var anObject = __webpack_require__(27);
	var toAbsoluteIndex = __webpack_require__(155);
	var toLength = __webpack_require__(46);
	var isObject = __webpack_require__(38);
	var ArrayBuffer = __webpack_require__(29).ArrayBuffer;
	var speciesConstructor = __webpack_require__(258);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(34)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(154)(ARRAY_BUFFER);


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	$export($export.G + $export.W + $export.F * !__webpack_require__(259).ABV, {
	  DataView: __webpack_require__(359).DataView
	});


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(516);
	var validate = __webpack_require__(182);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(246)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(7);
	var flattenIntoArray = __webpack_require__(517);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(46);
	var aFunction = __webpack_require__(58);
	var arraySpeciesCreate = __webpack_require__(338);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(130)('flatMap');


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(7);
	var flattenIntoArray = __webpack_require__(517);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(46);
	var toInteger = __webpack_require__(103);
	var arraySpeciesCreate = __webpack_require__(338);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(130)('flatten');


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(7);
	var $includes = __webpack_require__(245)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(130)('includes');


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(7);
	var microtask = __webpack_require__(350)();
	var process = __webpack_require__(29).process;
	var isNode = __webpack_require__(94)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(7);
	var cof = __webpack_require__(94);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(7);
	
	$export($export.G, { global: __webpack_require__(29) });


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(255)('Map');


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(256)('Map');


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(7);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(515)('Map') });


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	var scale = __webpack_require__(524);
	var fround = __webpack_require__(522);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { scale: __webpack_require__(524) });


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(50);
	var aFunction = __webpack_require__(58);
	var $defineProperty = __webpack_require__(45);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(44) && $export($export.P + __webpack_require__(253), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(50);
	var aFunction = __webpack_require__(58);
	var $defineProperty = __webpack_require__(45);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(44) && $export($export.P + __webpack_require__(253), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(7);
	var $entries = __webpack_require__(529)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(7);
	var ownKeys = __webpack_require__(530);
	var toIObject = __webpack_require__(80);
	var gOPD = __webpack_require__(85);
	var createProperty = __webpack_require__(339);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(50);
	var toPrimitive = __webpack_require__(104);
	var getPrototypeOf = __webpack_require__(86);
	var getOwnPropertyDescriptor = __webpack_require__(85).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(44) && $export($export.P + __webpack_require__(253), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(50);
	var toPrimitive = __webpack_require__(104);
	var getPrototypeOf = __webpack_require__(86);
	var getOwnPropertyDescriptor = __webpack_require__(85).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(44) && $export($export.P + __webpack_require__(253), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(7);
	var $values = __webpack_require__(529)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(7);
	var global = __webpack_require__(29);
	var core = __webpack_require__(100);
	var microtask = __webpack_require__(350)();
	var OBSERVABLE = __webpack_require__(41)('observable');
	var aFunction = __webpack_require__(58);
	var anObject = __webpack_require__(27);
	var anInstance = __webpack_require__(147);
	var redefineAll = __webpack_require__(153);
	var hide = __webpack_require__(77);
	var forOf = __webpack_require__(148);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(154)('Observable');


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(7);
	var core = __webpack_require__(100);
	var global = __webpack_require__(29);
	var speciesConstructor = __webpack_require__(258);
	var promiseResolve = __webpack_require__(534);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(7);
	var newPromiseCapability = __webpack_require__(351);
	var perform = __webpack_require__(533);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(540);
	var from = __webpack_require__(511);
	var metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(86);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(86);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(86);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(112);
	var anObject = __webpack_require__(27);
	var aFunction = __webpack_require__(58);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(255)('Set');


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(256)('Set');


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(7);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(515)('Set') });


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(7);
	var $at = __webpack_require__(354)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(7);
	var defined = __webpack_require__(101);
	var toLength = __webpack_require__(46);
	var isRegExp = __webpack_require__(251);
	var getFlags = __webpack_require__(248);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(346)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(7);
	var $pad = __webpack_require__(535);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(7);
	var $pad = __webpack_require__(535);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(181)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(181)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 1503 */
[3176, 360],
/* 1504 */
[3177, 360],
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(7);
	
	$export($export.S, 'System', { global: __webpack_require__(29) });


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(255)('WeakMap');


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(256)('WeakMap');


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(255)('WeakSet');


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(256)('WeakSet');


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(362);
	var getKeys = __webpack_require__(132);
	var redefine = __webpack_require__(78);
	var global = __webpack_require__(29);
	var hide = __webpack_require__(77);
	var Iterators = __webpack_require__(179);
	var wks = __webpack_require__(41);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $task = __webpack_require__(358);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(29);
	var $export = __webpack_require__(7);
	var invoke = __webpack_require__(249);
	var partial = __webpack_require__(1317);
	var navigator = global.navigator;
	var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return MSIE ? function (fn, time /* , ...args */) {
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      // eslint-disable-next-line no-new-func
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1441);
	__webpack_require__(1380);
	__webpack_require__(1382);
	__webpack_require__(1381);
	__webpack_require__(1384);
	__webpack_require__(1386);
	__webpack_require__(1391);
	__webpack_require__(1385);
	__webpack_require__(1383);
	__webpack_require__(1393);
	__webpack_require__(1392);
	__webpack_require__(1388);
	__webpack_require__(1389);
	__webpack_require__(1387);
	__webpack_require__(1379);
	__webpack_require__(1390);
	__webpack_require__(1394);
	__webpack_require__(1395);
	__webpack_require__(1347);
	__webpack_require__(1349);
	__webpack_require__(1348);
	__webpack_require__(1397);
	__webpack_require__(1396);
	__webpack_require__(1367);
	__webpack_require__(1377);
	__webpack_require__(1378);
	__webpack_require__(1368);
	__webpack_require__(1369);
	__webpack_require__(1370);
	__webpack_require__(1371);
	__webpack_require__(1372);
	__webpack_require__(1373);
	__webpack_require__(1374);
	__webpack_require__(1375);
	__webpack_require__(1376);
	__webpack_require__(1350);
	__webpack_require__(1351);
	__webpack_require__(1352);
	__webpack_require__(1353);
	__webpack_require__(1354);
	__webpack_require__(1355);
	__webpack_require__(1356);
	__webpack_require__(1357);
	__webpack_require__(1358);
	__webpack_require__(1359);
	__webpack_require__(1360);
	__webpack_require__(1361);
	__webpack_require__(1362);
	__webpack_require__(1363);
	__webpack_require__(1364);
	__webpack_require__(1365);
	__webpack_require__(1366);
	__webpack_require__(1428);
	__webpack_require__(1433);
	__webpack_require__(1440);
	__webpack_require__(1431);
	__webpack_require__(1423);
	__webpack_require__(1424);
	__webpack_require__(1429);
	__webpack_require__(1434);
	__webpack_require__(1436);
	__webpack_require__(1419);
	__webpack_require__(1420);
	__webpack_require__(1421);
	__webpack_require__(1422);
	__webpack_require__(1425);
	__webpack_require__(1426);
	__webpack_require__(1427);
	__webpack_require__(1430);
	__webpack_require__(1432);
	__webpack_require__(1435);
	__webpack_require__(1437);
	__webpack_require__(1438);
	__webpack_require__(1439);
	__webpack_require__(1342);
	__webpack_require__(1344);
	__webpack_require__(1343);
	__webpack_require__(1346);
	__webpack_require__(1345);
	__webpack_require__(1331);
	__webpack_require__(1329);
	__webpack_require__(1335);
	__webpack_require__(1332);
	__webpack_require__(1338);
	__webpack_require__(1340);
	__webpack_require__(1328);
	__webpack_require__(1334);
	__webpack_require__(1325);
	__webpack_require__(1339);
	__webpack_require__(1323);
	__webpack_require__(1337);
	__webpack_require__(1336);
	__webpack_require__(1330);
	__webpack_require__(1333);
	__webpack_require__(1322);
	__webpack_require__(1324);
	__webpack_require__(1327);
	__webpack_require__(1326);
	__webpack_require__(1341);
	__webpack_require__(362);
	__webpack_require__(1413);
	__webpack_require__(1418);
	__webpack_require__(539);
	__webpack_require__(1414);
	__webpack_require__(1415);
	__webpack_require__(1416);
	__webpack_require__(1417);
	__webpack_require__(1398);
	__webpack_require__(538);
	__webpack_require__(540);
	__webpack_require__(541);
	__webpack_require__(1453);
	__webpack_require__(1442);
	__webpack_require__(1443);
	__webpack_require__(1448);
	__webpack_require__(1451);
	__webpack_require__(1452);
	__webpack_require__(1446);
	__webpack_require__(1449);
	__webpack_require__(1447);
	__webpack_require__(1450);
	__webpack_require__(1444);
	__webpack_require__(1445);
	__webpack_require__(1399);
	__webpack_require__(1400);
	__webpack_require__(1401);
	__webpack_require__(1402);
	__webpack_require__(1403);
	__webpack_require__(1406);
	__webpack_require__(1404);
	__webpack_require__(1405);
	__webpack_require__(1407);
	__webpack_require__(1408);
	__webpack_require__(1409);
	__webpack_require__(1410);
	__webpack_require__(1412);
	__webpack_require__(1411);
	__webpack_require__(1456);
	__webpack_require__(1454);
	__webpack_require__(1455);
	__webpack_require__(1497);
	__webpack_require__(1500);
	__webpack_require__(1499);
	__webpack_require__(1501);
	__webpack_require__(1502);
	__webpack_require__(1498);
	__webpack_require__(1503);
	__webpack_require__(1504);
	__webpack_require__(1478);
	__webpack_require__(1481);
	__webpack_require__(1477);
	__webpack_require__(1475);
	__webpack_require__(1476);
	__webpack_require__(1479);
	__webpack_require__(1480);
	__webpack_require__(1462);
	__webpack_require__(1496);
	__webpack_require__(1461);
	__webpack_require__(1495);
	__webpack_require__(1507);
	__webpack_require__(1509);
	__webpack_require__(1460);
	__webpack_require__(1494);
	__webpack_require__(1506);
	__webpack_require__(1508);
	__webpack_require__(1459);
	__webpack_require__(1505);
	__webpack_require__(1458);
	__webpack_require__(1463);
	__webpack_require__(1464);
	__webpack_require__(1465);
	__webpack_require__(1466);
	__webpack_require__(1467);
	__webpack_require__(1469);
	__webpack_require__(1468);
	__webpack_require__(1470);
	__webpack_require__(1471);
	__webpack_require__(1472);
	__webpack_require__(1474);
	__webpack_require__(1473);
	__webpack_require__(1483);
	__webpack_require__(1484);
	__webpack_require__(1485);
	__webpack_require__(1486);
	__webpack_require__(1488);
	__webpack_require__(1487);
	__webpack_require__(1490);
	__webpack_require__(1489);
	__webpack_require__(1491);
	__webpack_require__(1492);
	__webpack_require__(1493);
	__webpack_require__(1457);
	__webpack_require__(1482);
	__webpack_require__(1512);
	__webpack_require__(1511);
	__webpack_require__(1510);
	module.exports = __webpack_require__(100);


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var emptyObject = __webpack_require__(157);
	var _invariant = __webpack_require__(22);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1517);
	var isArguments = __webpack_require__(1516);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(1519);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(544);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(544);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(1525);


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(1526);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(183);


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(545);
	var Emitter = __webpack_require__(173);
	var debug = __webpack_require__(260)('engine.io-client:socket');
	var index = __webpack_require__(553);
	var parser = __webpack_require__(183);
	var parseuri = __webpack_require__(749);
	var parsejson = __webpack_require__(2750);
	var parseqs = __webpack_require__(397);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(363);
	Socket.transports = __webpack_require__(545);
	Socket.parser = __webpack_require__(183);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(546);
	var inherit = __webpack_require__(241);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(364);
	var Polling = __webpack_require__(546);
	var Emitter = __webpack_require__(173);
	var inherit = __webpack_require__(241);
	var debug = __webpack_require__(260)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(363);
	var parser = __webpack_require__(183);
	var parseqs = __webpack_require__(397);
	var inherit = __webpack_require__(241);
	var yeast = __webpack_require__(847);
	var debug = __webpack_require__(260)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(3117);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1530 */
[3179, 1531],
/* 1531 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1534);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1544);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var createArrayFromMixed = __webpack_require__(1537);
	var getMarkupWrap = __webpack_require__(1539);
	var invariant = __webpack_require__(22);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1541);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1543);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	/* eslint-env browser */
	module.exports = window.FormData;


/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(1573);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(1574);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(1575);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(366);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(555);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _prefixProps = __webpack_require__(1563);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _position = __webpack_require__(1559);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(1553);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(1562);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(1557);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(1554);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(1560);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(1558);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(1561);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(1555);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1556);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return (0, _sortPrefixedStyle2.default)(styles);
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function position(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(365);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _unprefixProperty = __webpack_require__(1577);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(114);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
	module.exports = exports["default"];

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(262);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(367);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(262);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(262);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(367);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(262);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(365);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(366);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(367);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(554);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(554);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(366);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(555);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(1570);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(1564);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(1565);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(1566);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(1571);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(1569);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(1572);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(1567);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1568);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(494);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie: [['msie']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	var browserByInfo = function browserByInfo(info) {
	  if (info.firefox) {
	    return 'firefox';
	  }
	  var name = '';
	
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  return name;
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  info.browser = browserByInfo(info);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	  info.osversion = parseFloat(info.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (info.browser === 'ios_saf' && info.version > info.osversion) {
	    info.version = info.osversion;
	    info.safari = true;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabetical = __webpack_require__(556);
	var decimal = __webpack_require__(263);
	
	module.exports = alphanumerical;
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphanumerical. */
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character);
	}


/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = hexadecimal;
	
	/* Check if the given character code, or the character
	 * code at the first character, is hexadecimal. */
	function hexadecimal(character) {
	  var code = typeof character === 'string' ?
	    character.charCodeAt(0) : character;
	
	  return (code >= 97 /* a */ && code <= 102 /* z */) ||
	    (code >= 65 /* A */ && code <= 70 /* Z */) ||
	    (code >= 48 /* A */ && code <= 57 /* Z */);
	}


/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = wordCharacter;
	
	var fromCode = String.fromCharCode;
	var re = /\w/;
	
	/* Check if the given character code, or the character
	 * code at the first character, is a word character. */
	function wordCharacter(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  );
	}


/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(3113);
	module.exports = self.fetch.bind(self);


/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	module.exports = {"AEli":"Æ","AElig":"Æ","AM":"&","AMP":"&","Aacut":"Á","Aacute":"Á","Abreve":"Ă","Acir":"Â","Acirc":"Â","Acy":"А","Afr":"𝔄","Agrav":"À","Agrave":"À","Alpha":"Α","Amacr":"Ā","And":"⩓","Aogon":"Ą","Aopf":"𝔸","ApplyFunction":"⁡","Arin":"Å","Aring":"Å","Ascr":"𝒜","Assign":"≔","Atild":"Ã","Atilde":"Ã","Aum":"Ä","Auml":"Ä","Backslash":"∖","Barv":"⫧","Barwed":"⌆","Bcy":"Б","Because":"∵","Bernoullis":"ℬ","Beta":"Β","Bfr":"𝔅","Bopf":"𝔹","Breve":"˘","Bscr":"ℬ","Bumpeq":"≎","CHcy":"Ч","COP":"©","COPY":"©","Cacute":"Ć","Cap":"⋒","CapitalDifferentialD":"ⅅ","Cayleys":"ℭ","Ccaron":"Č","Ccedi":"Ç","Ccedil":"Ç","Ccirc":"Ĉ","Cconint":"∰","Cdot":"Ċ","Cedilla":"¸","CenterDot":"·","Cfr":"ℭ","Chi":"Χ","CircleDot":"⊙","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","Colon":"∷","Colone":"⩴","Congruent":"≡","Conint":"∯","ContourIntegral":"∮","Copf":"ℂ","Coproduct":"∐","CounterClockwiseContourIntegral":"∳","Cross":"⨯","Cscr":"𝒞","Cup":"⋓","CupCap":"≍","DD":"ⅅ","DDotrahd":"⤑","DJcy":"Ђ","DScy":"Ѕ","DZcy":"Џ","Dagger":"‡","Darr":"↡","Dashv":"⫤","Dcaron":"Ď","Dcy":"Д","Del":"∇","Delta":"Δ","Dfr":"𝔇","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","Diamond":"⋄","DifferentialD":"ⅆ","Dopf":"𝔻","Dot":"¨","DotDot":"⃜","DotEqual":"≐","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrow":"↓","DownArrowBar":"⤓","DownArrowUpArrow":"⇵","DownBreve":"̑","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVector":"↽","DownLeftVectorBar":"⥖","DownRightTeeVector":"⥟","DownRightVector":"⇁","DownRightVectorBar":"⥗","DownTee":"⊤","DownTeeArrow":"↧","Downarrow":"⇓","Dscr":"𝒟","Dstrok":"Đ","ENG":"Ŋ","ET":"Ð","ETH":"Ð","Eacut":"É","Eacute":"É","Ecaron":"Ě","Ecir":"Ê","Ecirc":"Ê","Ecy":"Э","Edot":"Ė","Efr":"𝔈","Egrav":"È","Egrave":"È","Element":"∈","Emacr":"Ē","EmptySmallSquare":"◻","EmptyVerySmallSquare":"▫","Eogon":"Ę","Eopf":"𝔼","Epsilon":"Ε","Equal":"⩵","EqualTilde":"≂","Equilibrium":"⇌","Escr":"ℰ","Esim":"⩳","Eta":"Η","Eum":"Ë","Euml":"Ë","Exists":"∃","ExponentialE":"ⅇ","Fcy":"Ф","Ffr":"𝔉","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","Fopf":"𝔽","ForAll":"∀","Fouriertrf":"ℱ","Fscr":"ℱ","GJcy":"Ѓ","G":">","GT":">","Gamma":"Γ","Gammad":"Ϝ","Gbreve":"Ğ","Gcedil":"Ģ","Gcirc":"Ĝ","Gcy":"Г","Gdot":"Ġ","Gfr":"𝔊","Gg":"⋙","Gopf":"𝔾","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","Gt":"≫","HARDcy":"Ъ","Hacek":"ˇ","Hat":"^","Hcirc":"Ĥ","Hfr":"ℌ","HilbertSpace":"ℋ","Hopf":"ℍ","HorizontalLine":"─","Hscr":"ℋ","Hstrok":"Ħ","HumpDownHump":"≎","HumpEqual":"≏","IEcy":"Е","IJlig":"Ĳ","IOcy":"Ё","Iacut":"Í","Iacute":"Í","Icir":"Î","Icirc":"Î","Icy":"И","Idot":"İ","Ifr":"ℑ","Igrav":"Ì","Igrave":"Ì","Im":"ℑ","Imacr":"Ī","ImaginaryI":"ⅈ","Implies":"⇒","Int":"∬","Integral":"∫","Intersection":"⋂","InvisibleComma":"⁣","InvisibleTimes":"⁢","Iogon":"Į","Iopf":"𝕀","Iota":"Ι","Iscr":"ℐ","Itilde":"Ĩ","Iukcy":"І","Ium":"Ï","Iuml":"Ï","Jcirc":"Ĵ","Jcy":"Й","Jfr":"𝔍","Jopf":"𝕁","Jscr":"𝒥","Jsercy":"Ј","Jukcy":"Є","KHcy":"Х","KJcy":"Ќ","Kappa":"Κ","Kcedil":"Ķ","Kcy":"К","Kfr":"𝔎","Kopf":"𝕂","Kscr":"𝒦","LJcy":"Љ","L":"<","LT":"<","Lacute":"Ĺ","Lambda":"Λ","Lang":"⟪","Laplacetrf":"ℒ","Larr":"↞","Lcaron":"Ľ","Lcedil":"Ļ","Lcy":"Л","LeftAngleBracket":"⟨","LeftArrow":"←","LeftArrowBar":"⇤","LeftArrowRightArrow":"⇆","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVector":"⇃","LeftDownVectorBar":"⥙","LeftFloor":"⌊","LeftRightArrow":"↔","LeftRightVector":"⥎","LeftTee":"⊣","LeftTeeArrow":"↤","LeftTeeVector":"⥚","LeftTriangle":"⊲","LeftTriangleBar":"⧏","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVector":"↿","LeftUpVectorBar":"⥘","LeftVector":"↼","LeftVectorBar":"⥒","Leftarrow":"⇐","Leftrightarrow":"⇔","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","LessLess":"⪡","LessSlantEqual":"⩽","LessTilde":"≲","Lfr":"𝔏","Ll":"⋘","Lleftarrow":"⇚","Lmidot":"Ŀ","LongLeftArrow":"⟵","LongLeftRightArrow":"⟷","LongRightArrow":"⟶","Longleftarrow":"⟸","Longleftrightarrow":"⟺","Longrightarrow":"⟹","Lopf":"𝕃","LowerLeftArrow":"↙","LowerRightArrow":"↘","Lscr":"ℒ","Lsh":"↰","Lstrok":"Ł","Lt":"≪","Map":"⤅","Mcy":"М","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","MinusPlus":"∓","Mopf":"𝕄","Mscr":"ℳ","Mu":"Μ","NJcy":"Њ","Nacute":"Ń","Ncaron":"Ň","Ncedil":"Ņ","Ncy":"Н","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","Nfr":"𝔑","NoBreak":"⁠","NonBreakingSpace":" ","Nopf":"ℕ","Not":"⫬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","NotLeftTriangle":"⋪","NotLeftTriangleBar":"⧏̸","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangle":"⋫","NotRightTriangleBar":"⧐̸","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","Nscr":"𝒩","Ntild":"Ñ","Ntilde":"Ñ","Nu":"Ν","OElig":"Œ","Oacut":"Ó","Oacute":"Ó","Ocir":"Ô","Ocirc":"Ô","Ocy":"О","Odblac":"Ő","Ofr":"𝔒","Ograv":"Ò","Ograve":"Ò","Omacr":"Ō","Omega":"Ω","Omicron":"Ο","Oopf":"𝕆","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","Or":"⩔","Oscr":"𝒪","Oslas":"Ø","Oslash":"Ø","Otild":"Õ","Otilde":"Õ","Otimes":"⨷","Oum":"Ö","Ouml":"Ö","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","PartialD":"∂","Pcy":"П","Pfr":"𝔓","Phi":"Φ","Pi":"Π","PlusMinus":"±","Poincareplane":"ℌ","Popf":"ℙ","Pr":"⪻","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","Prime":"″","Product":"∏","Proportion":"∷","Proportional":"∝","Pscr":"𝒫","Psi":"Ψ","QUO":"\"","QUOT":"\"","Qfr":"𝔔","Qopf":"ℚ","Qscr":"𝒬","RBarr":"⤐","RE":"®","REG":"®","Racute":"Ŕ","Rang":"⟫","Rarr":"↠","Rarrtl":"⤖","Rcaron":"Ř","Rcedil":"Ŗ","Rcy":"Р","Re":"ℜ","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","Rfr":"ℜ","Rho":"Ρ","RightAngleBracket":"⟩","RightArrow":"→","RightArrowBar":"⇥","RightArrowLeftArrow":"⇄","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVector":"⇂","RightDownVectorBar":"⥕","RightFloor":"⌋","RightTee":"⊢","RightTeeArrow":"↦","RightTeeVector":"⥛","RightTriangle":"⊳","RightTriangleBar":"⧐","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVector":"↾","RightUpVectorBar":"⥔","RightVector":"⇀","RightVectorBar":"⥓","Rightarrow":"⇒","Ropf":"ℝ","RoundImplies":"⥰","Rrightarrow":"⇛","Rscr":"ℛ","Rsh":"↱","RuleDelayed":"⧴","SHCHcy":"Щ","SHcy":"Ш","SOFTcy":"Ь","Sacute":"Ś","Sc":"⪼","Scaron":"Š","Scedil":"Ş","Scirc":"Ŝ","Scy":"С","Sfr":"𝔖","ShortDownArrow":"↓","ShortLeftArrow":"←","ShortRightArrow":"→","ShortUpArrow":"↑","Sigma":"Σ","SmallCircle":"∘","Sopf":"𝕊","Sqrt":"√","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","Sscr":"𝒮","Star":"⋆","Sub":"⋐","Subset":"⋐","SubsetEqual":"⊆","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","SuchThat":"∋","Sum":"∑","Sup":"⋑","Superset":"⊃","SupersetEqual":"⊇","Supset":"⋑","THOR":"Þ","THORN":"Þ","TRADE":"™","TSHcy":"Ћ","TScy":"Ц","Tab":"\t","Tau":"Τ","Tcaron":"Ť","Tcedil":"Ţ","Tcy":"Т","Tfr":"𝔗","Therefore":"∴","Theta":"Θ","ThickSpace":"  ","ThinSpace":" ","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","Topf":"𝕋","TripleDot":"⃛","Tscr":"𝒯","Tstrok":"Ŧ","Uacut":"Ú","Uacute":"Ú","Uarr":"↟","Uarrocir":"⥉","Ubrcy":"Ў","Ubreve":"Ŭ","Ucir":"Û","Ucirc":"Û","Ucy":"У","Udblac":"Ű","Ufr":"𝔘","Ugrav":"Ù","Ugrave":"Ù","Umacr":"Ū","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","Uopf":"𝕌","UpArrow":"↑","UpArrowBar":"⤒","UpArrowDownArrow":"⇅","UpDownArrow":"↕","UpEquilibrium":"⥮","UpTee":"⊥","UpTeeArrow":"↥","Uparrow":"⇑","Updownarrow":"⇕","UpperLeftArrow":"↖","UpperRightArrow":"↗","Upsi":"ϒ","Upsilon":"Υ","Uring":"Ů","Uscr":"𝒰","Utilde":"Ũ","Uum":"Ü","Uuml":"Ü","VDash":"⊫","Vbar":"⫫","Vcy":"В","Vdash":"⊩","Vdashl":"⫦","Vee":"⋁","Verbar":"‖","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","Vopf":"𝕍","Vscr":"𝒱","Vvdash":"⊪","Wcirc":"Ŵ","Wedge":"⋀","Wfr":"𝔚","Wopf":"𝕎","Wscr":"𝒲","Xfr":"𝔛","Xi":"Ξ","Xopf":"𝕏","Xscr":"𝒳","YAcy":"Я","YIcy":"Ї","YUcy":"Ю","Yacut":"Ý","Yacute":"Ý","Ycirc":"Ŷ","Ycy":"Ы","Yfr":"𝔜","Yopf":"𝕐","Yscr":"𝒴","Yuml":"Ÿ","ZHcy":"Ж","Zacute":"Ź","Zcaron":"Ž","Zcy":"З","Zdot":"Ż","ZeroWidthSpace":"​","Zeta":"Ζ","Zfr":"ℨ","Zopf":"ℤ","Zscr":"𝒵","aacut":"á","aacute":"á","abreve":"ă","ac":"∾","acE":"∾̳","acd":"∿","acir":"â","acirc":"â","acut":"´","acute":"´","acy":"а","aeli":"æ","aelig":"æ","af":"⁡","afr":"𝔞","agrav":"à","agrave":"à","alefsym":"ℵ","aleph":"ℵ","alpha":"α","amacr":"ā","amalg":"⨿","am":"&","amp":"&","and":"∧","andand":"⩕","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsd":"∡","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","aogon":"ą","aopf":"𝕒","ap":"≈","apE":"⩰","apacir":"⩯","ape":"≊","apid":"≋","apos":"'","approx":"≈","approxeq":"≊","arin":"å","aring":"å","ascr":"𝒶","ast":"*","asymp":"≈","asympeq":"≍","atild":"ã","atilde":"ã","aum":"ä","auml":"ä","awconint":"∳","awint":"⨑","bNot":"⫭","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","barvee":"⊽","barwed":"⌅","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","beta":"β","beth":"ℶ","between":"≬","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bnot":"⌐","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxDL":"╗","boxDR":"╔","boxDl":"╖","boxDr":"╓","boxH":"═","boxHD":"╦","boxHU":"╩","boxHd":"╤","boxHu":"╧","boxUL":"╝","boxUR":"╚","boxUl":"╜","boxUr":"╙","boxV":"║","boxVH":"╬","boxVL":"╣","boxVR":"╠","boxVh":"╫","boxVl":"╢","boxVr":"╟","boxbox":"⧉","boxdL":"╕","boxdR":"╒","boxdl":"┐","boxdr":"┌","boxh":"─","boxhD":"╥","boxhU":"╨","boxhd":"┬","boxhu":"┴","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxuL":"╛","boxuR":"╘","boxul":"┘","boxur":"└","boxv":"│","boxvH":"╪","boxvL":"╡","boxvR":"╞","boxvh":"┼","boxvl":"┤","boxvr":"├","bprime":"‵","breve":"˘","brvba":"¦","brvbar":"¦","bscr":"𝒷","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsol":"\\","bsolb":"⧅","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","bumpeq":"≏","cacute":"ć","cap":"∩","capand":"⩄","capbrcup":"⩉","capcap":"⩋","capcup":"⩇","capdot":"⩀","caps":"∩︀","caret":"⁁","caron":"ˇ","ccaps":"⩍","ccaron":"č","ccedi":"ç","ccedil":"ç","ccirc":"ĉ","ccups":"⩌","ccupssm":"⩐","cdot":"ċ","cedi":"¸","cedil":"¸","cemptyv":"⦲","cen":"¢","cent":"¢","centerdot":"·","cfr":"𝔠","chcy":"ч","check":"✓","checkmark":"✓","chi":"χ","cir":"○","cirE":"⧃","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledR":"®","circledS":"Ⓢ","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","clubs":"♣","clubsuit":"♣","colon":":","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","conint":"∮","copf":"𝕔","coprod":"∐","cop":"©","copy":"©","copysr":"℗","crarr":"↵","cross":"✗","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cup":"∪","cupbrcap":"⩈","cupcap":"⩆","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curre":"¤","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dArr":"⇓","dHar":"⥥","dagger":"†","daleth":"ℸ","darr":"↓","dash":"‐","dashv":"⊣","dbkarow":"⤏","dblac":"˝","dcaron":"ď","dcy":"д","dd":"ⅆ","ddagger":"‡","ddarr":"⇊","ddotseq":"⩷","de":"°","deg":"°","delta":"δ","demptyv":"⦱","dfisht":"⥿","dfr":"𝔡","dharl":"⇃","dharr":"⇂","diam":"⋄","diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","digamma":"ϝ","disin":"⋲","div":"÷","divid":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","dopf":"𝕕","dot":"˙","doteq":"≐","doteqdot":"≑","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","downarrow":"↓","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","dscr":"𝒹","dscy":"ѕ","dsol":"⧶","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","dzcy":"џ","dzigrarr":"⟿","eDDot":"⩷","eDot":"≑","eacut":"é","eacute":"é","easter":"⩮","ecaron":"ě","ecir":"ê","ecirc":"ê","ecolon":"≕","ecy":"э","edot":"ė","ee":"ⅇ","efDot":"≒","efr":"𝔢","eg":"⪚","egrav":"è","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","emacr":"ē","empty":"∅","emptyset":"∅","emptyv":"∅","emsp13":" ","emsp14":" ","emsp":" ","eng":"ŋ","ensp":" ","eogon":"ę","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","equals":"=","equest":"≟","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erDot":"≓","erarr":"⥱","escr":"ℯ","esdot":"≐","esim":"≂","eta":"η","et":"ð","eth":"ð","eum":"ë","euml":"ë","euro":"€","excl":"!","exist":"∃","expectation":"ℰ","exponentiale":"ⅇ","fallingdotseq":"≒","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","ffr":"𝔣","filig":"ﬁ","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","fopf":"𝕗","forall":"∀","fork":"⋔","forkv":"⫙","fpartint":"⨍","frac1":"¼","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac3":"¾","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","gE":"≧","gEl":"⪌","gacute":"ǵ","gamma":"γ","gammad":"ϝ","gap":"⪆","gbreve":"ğ","gcirc":"ĝ","gcy":"г","gdot":"ġ","ge":"≥","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","ges":"⩾","gescc":"⪩","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","gfr":"𝔤","gg":"≫","ggg":"⋙","gimel":"ℷ","gjcy":"ѓ","gl":"≷","glE":"⪒","gla":"⪥","glj":"⪤","gnE":"≩","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gneq":"⪈","gneqq":"≩","gnsim":"⋧","gopf":"𝕘","grave":"`","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","g":">","gt":">","gtcc":"⪧","gtcir":"⩺","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","hArr":"⇔","hairsp":" ","half":"½","hamilt":"ℋ","hardcy":"ъ","harr":"↔","harrcir":"⥈","harrw":"↭","hbar":"ℏ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","horbar":"―","hscr":"𝒽","hslash":"ℏ","hstrok":"ħ","hybull":"⁃","hyphen":"‐","iacut":"í","iacute":"í","ic":"⁣","icir":"î","icirc":"î","icy":"и","iecy":"е","iexc":"¡","iexcl":"¡","iff":"⇔","ifr":"𝔦","igrav":"ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","ijlig":"ĳ","imacr":"ī","image":"ℑ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","imof":"⊷","imped":"Ƶ","in":"∈","incare":"℅","infin":"∞","infintie":"⧝","inodot":"ı","int":"∫","intcal":"⊺","integers":"ℤ","intercal":"⊺","intlarhk":"⨗","intprod":"⨼","iocy":"ё","iogon":"į","iopf":"𝕚","iota":"ι","iprod":"⨼","iques":"¿","iquest":"¿","iscr":"𝒾","isin":"∈","isinE":"⋹","isindot":"⋵","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","itilde":"ĩ","iukcy":"і","ium":"ï","iuml":"ï","jcirc":"ĵ","jcy":"й","jfr":"𝔧","jmath":"ȷ","jopf":"𝕛","jscr":"𝒿","jsercy":"ј","jukcy":"є","kappa":"κ","kappav":"ϰ","kcedil":"ķ","kcy":"к","kfr":"𝔨","kgreen":"ĸ","khcy":"х","kjcy":"ќ","kopf":"𝕜","kscr":"𝓀","lAarr":"⇚","lArr":"⇐","lAtail":"⤛","lBarr":"⤎","lE":"≦","lEg":"⪋","lHar":"⥢","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","lambda":"λ","lang":"⟨","langd":"⦑","langle":"⟨","lap":"⪅","laqu":"«","laquo":"«","larr":"←","larrb":"⇤","larrbfs":"⤟","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","lat":"⪫","latail":"⤙","late":"⪭","lates":"⪭︀","lbarr":"⤌","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","lcaron":"ľ","lcedil":"ļ","lceil":"⌈","lcub":"{","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","leftarrow":"←","leftarrowtail":"↢","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","leftthreetimes":"⋋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","les":"⩽","lescc":"⪨","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","lessgtr":"≶","lesssim":"≲","lfisht":"⥼","lfloor":"⌊","lfr":"𝔩","lg":"≶","lgE":"⪑","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","ljcy":"љ","ll":"≪","llarr":"⇇","llcorner":"⌞","llhard":"⥫","lltri":"◺","lmidot":"ŀ","lmoust":"⎰","lmoustache":"⎰","lnE":"≨","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","longleftrightarrow":"⟷","longmapsto":"⟼","longrightarrow":"⟶","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","lstrok":"ł","l":"<","lt":"<","ltcc":"⪦","ltcir":"⩹","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltrPar":"⦖","ltri":"◃","ltrie":"⊴","ltrif":"◂","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","mDDot":"∺","mac":"¯","macr":"¯","male":"♂","malt":"✠","maltese":"✠","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","mcy":"м","mdash":"—","measuredangle":"∡","mfr":"𝔪","mho":"℧","micr":"µ","micro":"µ","mid":"∣","midast":"*","midcir":"⫰","middo":"·","middot":"·","minus":"−","minusb":"⊟","minusd":"∸","minusdu":"⨪","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","mopf":"𝕞","mp":"∓","mscr":"𝓂","mstpos":"∾","mu":"μ","multimap":"⊸","mumap":"⊸","nGg":"⋙̸","nGt":"≫⃒","nGtv":"≫̸","nLeftarrow":"⇍","nLeftrightarrow":"⇎","nLl":"⋘̸","nLt":"≪⃒","nLtv":"≪̸","nRightarrow":"⇏","nVDash":"⊯","nVdash":"⊮","nabla":"∇","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natur":"♮","natural":"♮","naturals":"ℕ","nbs":" ","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","ncaron":"ň","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","ncy":"н","ndash":"–","ne":"≠","neArr":"⇗","nearhk":"⤤","nearr":"↗","nearrow":"↗","nedot":"≐̸","nequiv":"≢","nesear":"⤨","nesim":"≂̸","nexist":"∄","nexists":"∄","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","ngsim":"≵","ngt":"≯","ngtr":"≯","nhArr":"⇎","nharr":"↮","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","njcy":"њ","nlArr":"⇍","nlE":"≦̸","nlarr":"↚","nldr":"‥","nle":"≰","nleftarrow":"↚","nleftrightarrow":"↮","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nlsim":"≴","nlt":"≮","nltri":"⋪","nltrie":"⋬","nmid":"∤","nopf":"𝕟","no":"¬","not":"¬","notin":"∉","notinE":"⋹̸","notindot":"⋵̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","npar":"∦","nparallel":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","npre":"⪯̸","nprec":"⊀","npreceq":"⪯̸","nrArr":"⇏","nrarr":"↛","nrarrc":"⤳̸","nrarrw":"↝̸","nrightarrow":"↛","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","ntild":"ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","nu":"ν","num":"#","numero":"№","numsp":" ","nvDash":"⊭","nvHarr":"⤄","nvap":"≍⃒","nvdash":"⊬","nvge":"≥⃒","nvgt":">⃒","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwArr":"⇖","nwarhk":"⤣","nwarr":"↖","nwarrow":"↖","nwnear":"⤧","oS":"Ⓢ","oacut":"ó","oacute":"ó","oast":"⊛","ocir":"ô","ocirc":"ô","ocy":"о","odash":"⊝","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","oelig":"œ","ofcir":"⦿","ofr":"𝔬","ogon":"˛","ograv":"ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","omacr":"ō","omega":"ω","omicron":"ο","omid":"⦶","ominus":"⊖","oopf":"𝕠","opar":"⦷","operp":"⦹","oplus":"⊕","or":"∨","orarr":"↻","ord":"º","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oscr":"ℴ","oslas":"ø","oslash":"ø","osol":"⊘","otild":"õ","otilde":"õ","otimes":"⊗","otimesas":"⨶","oum":"ö","ouml":"ö","ovbar":"⌽","par":"¶","para":"¶","parallel":"∥","parsim":"⫳","parsl":"⫽","part":"∂","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","pfr":"𝔭","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plus":"+","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plusdo":"∔","plusdu":"⨥","pluse":"⩲","plusm":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","pointint":"⨕","popf":"𝕡","poun":"£","pound":"£","pr":"≺","prE":"⪳","prap":"⪷","prcue":"≼","pre":"⪯","prec":"≺","precapprox":"⪷","preccurlyeq":"≼","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","precsim":"≾","prime":"′","primes":"ℙ","prnE":"⪵","prnap":"⪹","prnsim":"⋨","prod":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","propto":"∝","prsim":"≾","prurel":"⊰","pscr":"𝓅","psi":"ψ","puncsp":" ","qfr":"𝔮","qint":"⨌","qopf":"𝕢","qprime":"⁗","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quo":"\"","quot":"\"","rAarr":"⇛","rArr":"⇒","rAtail":"⤜","rBarr":"⤏","rHar":"⥤","race":"∽̱","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","rangd":"⦒","range":"⦥","rangle":"⟩","raqu":"»","raquo":"»","rarr":"→","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","rarrtl":"↣","rarrw":"↝","ratail":"⤚","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","rcaron":"ř","rcedil":"ŗ","rceil":"⌉","rcub":"}","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","rect":"▭","re":"®","reg":"®","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","rhard":"⇁","rharu":"⇀","rharul":"⥬","rho":"ρ","rhov":"ϱ","rightarrow":"→","rightarrowtail":"↣","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","rightthreetimes":"⋌","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoust":"⎱","rmoustache":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","roplus":"⨮","rotimes":"⨵","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","rsaquo":"›","rscr":"𝓇","rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","ruluhar":"⥨","rx":"℞","sacute":"ś","sbquo":"‚","sc":"≻","scE":"⪴","scap":"⪸","scaron":"š","sccue":"≽","sce":"⪰","scedil":"ş","scirc":"ŝ","scnE":"⪶","scnap":"⪺","scnsim":"⋩","scpolint":"⨓","scsim":"≿","scy":"с","sdot":"⋅","sdotb":"⊡","sdote":"⩦","seArr":"⇘","searhk":"⤥","searr":"↘","searrow":"↘","sec":"§","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","sfr":"𝔰","sfrown":"⌢","sharp":"♯","shchcy":"щ","shcy":"ш","shortmid":"∣","shortparallel":"∥","sh":"­","shy":"­","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","softcy":"ь","sol":"/","solb":"⧄","solbar":"⌿","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","squ":"□","square":"□","squarf":"▪","squf":"▪","srarr":"→","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","subE":"⫅","subdot":"⪽","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","subseteq":"⊆","subseteqq":"⫅","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succ":"≻","succapprox":"⪸","succcurlyeq":"≽","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","sum":"∑","sung":"♪","sup":"⊃","sup1":"¹","sup2":"²","sup3":"³","supE":"⫆","supdot":"⪾","supdsub":"⫘","supe":"⊇","supedot":"⫄","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swArr":"⇙","swarhk":"⤦","swarr":"↙","swarrow":"↙","swnwar":"⤪","szli":"ß","szlig":"ß","target":"⌖","tau":"τ","tbrk":"⎴","tcaron":"ť","tcedil":"ţ","tcy":"т","tdot":"⃛","telrec":"⌕","tfr":"𝔱","there4":"∴","therefore":"∴","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","thinsp":" ","thkap":"≈","thksim":"∼","thor":"þ","thorn":"þ","tilde":"˜","time":"×","times":"×","timesb":"⊠","timesbar":"⨱","timesd":"⨰","tint":"∭","toea":"⤨","top":"⊤","topbot":"⌶","topcir":"⫱","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","tscr":"𝓉","tscy":"ц","tshcy":"ћ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","uArr":"⇑","uHar":"⥣","uacut":"ú","uacute":"ú","uarr":"↑","ubrcy":"ў","ubreve":"ŭ","ucir":"û","ucirc":"û","ucy":"у","udarr":"⇅","udblac":"ű","udhar":"⥮","ufisht":"⥾","ufr":"𝔲","ugrav":"ù","ugrave":"ù","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","umacr":"ū","um":"¨","uml":"¨","uogon":"ų","uopf":"𝕦","uparrow":"↑","updownarrow":"↕","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","upsi":"υ","upsih":"ϒ","upsilon":"υ","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","uring":"ů","urtri":"◹","uscr":"𝓊","utdot":"⋰","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","uum":"ü","uuml":"ü","uwangle":"⦧","vArr":"⇕","vBar":"⫨","vBarv":"⫩","vDash":"⊨","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vcy":"в","vdash":"⊢","vee":"∨","veebar":"⊻","veeeq":"≚","vellip":"⋮","verbar":"|","vert":"|","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","vopf":"𝕧","vprop":"∝","vrtri":"⊳","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","vzigzag":"⦚","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","wedgeq":"≙","weierp":"℘","wfr":"𝔴","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","xfr":"𝔵","xhArr":"⟺","xharr":"⟷","xi":"ξ","xlArr":"⟸","xlarr":"⟵","xmap":"⟼","xnis":"⋻","xodot":"⨀","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrArr":"⟹","xrarr":"⟶","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","yacut":"ý","yacute":"ý","yacy":"я","ycirc":"ŷ","ycy":"ы","ye":"¥","yen":"¥","yfr":"𝔶","yicy":"ї","yopf":"𝕪","yscr":"𝓎","yucy":"ю","yum":"ÿ","yuml":"ÿ","zacute":"ź","zcaron":"ž","zcy":"з","zdot":"ż","zeetrf":"ℨ","zeta":"ζ","zfr":"𝔷","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	module.exports = ["address","article","aside","base","basefont","blockquote","body","caption","center","col","colgroup","dd","details","dialog","dir","div","dl","dt","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","legend","li","link","main","menu","menuitem","meta","nav","noframes","ol","optgroup","option","p","param","pre","section","source","title","summary","table","tbody","td","tfoot","th","thead","title","tr","track","ul"]

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(3112);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module), (function() { return this; }())))

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256,
	    FLIP_FLAG = 512;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', ARY_FLAG],
	  ['bind', BIND_FLAG],
	  ['bindKey', BIND_KEY_FLAG],
	  ['curry', CURRY_FLAG],
	  ['curryRight', CURRY_RIGHT_FLAG],
	  ['flip', FLIP_FLAG],
	  ['partial', PARTIAL_FLAG],
	  ['partialRight', PARTIAL_RIGHT_FLAG],
	  ['rearg', REARG_FLAG]
	];
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/* Used to set `toString` methods. */
	var defineProperty = (function() {
	  var func = getNative(Object, 'defineProperty'),
	      name = getNative.name;
	
	  return (name && name.length > 2) ? func : undefined;
	}());
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	
	  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  return setWrapToString(result, func, bitmask);
	}
	
	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length,
	      lastIndex = length - 1;
	
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return defineProperty(wrapper, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
	  });
	};
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(1590);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeNow = getNative(Date, 'now');
	
	/**
	 * Gets the number of milliseconds that have elapsed since the Unix epoch
	 * (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @category Date
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = nativeNow || function() {
	  return new Date().getTime();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed invocations. Provide an options object to indicate that `func`
	 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	 * Subsequent calls to the debounced function return the result of the last
	 * `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=false] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	 *  delayed before it is invoked.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // avoid costly calculations while the window size is in flux
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // ensure `batchLog` is invoked once after 1 second of debounced calls
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', _.debounce(batchLog, 250, {
	 *   'maxWait': 1000
	 * }));
	 *
	 * // cancel a debounced call
	 * var todoChanges = _.debounce(batchLog, 1000);
	 * Object.observe(models.todo, todoChanges);
	 *
	 * Object.observe(models, function(changes) {
	 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	 *     todoChanges.cancel();
	 *   }
	 * }, ['delete']);
	 *
	 * // ...at some point `models.todo` is changed
	 * models.todo.completed = true;
	 *
	 * // ...before 1 second has passed `models.todo` is deleted
	 * // which cancels the debounced `todoChanges` call
	 * delete models.todo;
	 */
	function debounce(func, wait, options) {
	  var args,
	      maxTimeoutId,
	      result,
	      stamp,
	      thisArg,
	      timeoutId,
	      trailingCall,
	      lastCalled = 0,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = wait < 0 ? 0 : (+wait || 0);
	  if (options === true) {
	    var leading = true;
	    trailing = false;
	  } else if (isObject(options)) {
	    leading = !!options.leading;
	    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    if (maxTimeoutId) {
	      clearTimeout(maxTimeoutId);
	    }
	    lastCalled = 0;
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	  }
	
	  function complete(isCalled, id) {
	    if (id) {
	      clearTimeout(id);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	    if (isCalled) {
	      lastCalled = now();
	      result = func.apply(thisArg, args);
	      if (!timeoutId && !maxTimeoutId) {
	        args = thisArg = undefined;
	      }
	    }
	  }
	
	  function delayed() {
	    var remaining = wait - (now() - stamp);
	    if (remaining <= 0 || remaining > wait) {
	      complete(trailingCall, maxTimeoutId);
	    } else {
	      timeoutId = setTimeout(delayed, remaining);
	    }
	  }
	
	  function maxDelayed() {
	    complete(trailing, timeoutId);
	  }
	
	  function debounced() {
	    args = arguments;
	    stamp = now();
	    thisArg = this;
	    trailingCall = trailing && (timeoutId || !leading);
	
	    if (maxWait === false) {
	      var leadingCall = leading && !timeoutId;
	    } else {
	      if (!maxTimeoutId && !leading) {
	        lastCalled = stamp;
	      }
	      var remaining = maxWait - (stamp - lastCalled),
	          isCalled = remaining <= 0 || remaining > maxWait;
	
	      if (isCalled) {
	        if (maxTimeoutId) {
	          maxTimeoutId = clearTimeout(maxTimeoutId);
	        }
	        lastCalled = stamp;
	        result = func.apply(thisArg, args);
	      }
	      else if (!maxTimeoutId) {
	        maxTimeoutId = setTimeout(maxDelayed, remaining);
	      }
	    }
	    if (isCalled && timeoutId) {
	      timeoutId = clearTimeout(timeoutId);
	    }
	    else if (!timeoutId && wait !== maxWait) {
	      timeoutId = setTimeout(delayed, wait);
	    }
	    if (leadingCall) {
	      isCalled = true;
	      result = func.apply(thisArg, args);
	    }
	    if (isCalled && !timeoutId && !maxTimeoutId) {
	      args = thisArg = undefined;
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = debounce;


/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return baseRest(function(funcs) {
	    funcs = baseFlatten(funcs, 1);
	
	    var length = funcs.length,
	        index = length;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      if (typeof funcs[index] != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	    }
	    return function() {
	      var index = 0,
	          result = length ? funcs[index].apply(this, arguments) : arguments[0];
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = baseKeysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(138)(module)))

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(158),
	    root = __webpack_require__(115);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1642),
	    hashDelete = __webpack_require__(1643),
	    hashGet = __webpack_require__(1644),
	    hashHas = __webpack_require__(1645),
	    hashSet = __webpack_require__(1646);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(158),
	    root = __webpack_require__(115);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(115);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(158),
	    root = __webpack_require__(115);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1626),
	    isArguments = __webpack_require__(374),
	    isArray = __webpack_require__(116),
	    isBuffer = __webpack_require__(581),
	    isIndex = __webpack_require__(573),
	    isTypedArray = __webpack_require__(583);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(570);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(370),
	    arrayIncludes = __webpack_require__(560),
	    arrayIncludesWith = __webpack_require__(561),
	    arrayMap = __webpack_require__(562),
	    baseUnary = __webpack_require__(568),
	    cacheHas = __webpack_require__(371);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1630);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1608),
	    keys = __webpack_require__(378);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(563),
	    isArray = __webpack_require__(116);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1607),
	    baseIsNaN = __webpack_require__(1616),
	    strictIndexOf = __webpack_require__(1676);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(185),
	    isObjectLike = __webpack_require__(159);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(559),
	    equalArrays = __webpack_require__(571),
	    equalByTag = __webpack_require__(1632),
	    equalObjects = __webpack_require__(1633),
	    getTag = __webpack_require__(1639),
	    isArray = __webpack_require__(116),
	    isBuffer = __webpack_require__(581),
	    isTypedArray = __webpack_require__(583);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(559),
	    baseIsEqual = __webpack_require__(566);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(582),
	    isMasked = __webpack_require__(1649),
	    isObject = __webpack_require__(376),
	    toSource = __webpack_require__(577);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(185),
	    isLength = __webpack_require__(375),
	    isObjectLike = __webpack_require__(159);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1621),
	    baseMatchesProperty = __webpack_require__(1622),
	    identity = __webpack_require__(269),
	    isArray = __webpack_require__(116),
	    property = __webpack_require__(1685);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1650),
	    nativeKeys = __webpack_require__(1663);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1615),
	    getMatchData = __webpack_require__(1635),
	    matchesStrictComparable = __webpack_require__(575);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(566),
	    get = __webpack_require__(1680),
	    hasIn = __webpack_require__(1681),
	    isKey = __webpack_require__(372),
	    isStrictComparable = __webpack_require__(574),
	    matchesStrictComparable = __webpack_require__(575),
	    toKey = __webpack_require__(268);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(565);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1678),
	    defineProperty = __webpack_require__(570),
	    identity = __webpack_require__(269);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221),
	    arrayMap = __webpack_require__(562),
	    isArray = __webpack_require__(116),
	    isSymbol = __webpack_require__(377);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(370),
	    arrayIncludes = __webpack_require__(560),
	    arrayIncludesWith = __webpack_require__(561),
	    cacheHas = __webpack_require__(371),
	    createSet = __webpack_require__(1631),
	    setToArray = __webpack_require__(373);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(115);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(558),
	    noop = __webpack_require__(1684),
	    setToArray = __webpack_require__(373);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221),
	    Uint8Array = __webpack_require__(1599),
	    eq = __webpack_require__(578),
	    equalArrays = __webpack_require__(571),
	    mapToArray = __webpack_require__(1661),
	    setToArray = __webpack_require__(373);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1634);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1610),
	    getSymbols = __webpack_require__(1638),
	    keys = __webpack_require__(378);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(574),
	    keys = __webpack_require__(378);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(576);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1602),
	    stubArray = __webpack_require__(1686);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1596),
	    Map = __webpack_require__(368),
	    Promise = __webpack_require__(1598),
	    Set = __webpack_require__(558),
	    WeakMap = __webpack_require__(1600),
	    baseGetTag = __webpack_require__(185),
	    toSource = __webpack_require__(577);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(569),
	    isArguments = __webpack_require__(374),
	    isArray = __webpack_require__(116),
	    isIndex = __webpack_require__(573),
	    isLength = __webpack_require__(375),
	    toKey = __webpack_require__(268);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(267);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(267);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(267);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(267);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221),
	    isArguments = __webpack_require__(374),
	    isArray = __webpack_require__(116);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1629);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(265);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(265);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(265);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(265);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1597),
	    ListCache = __webpack_require__(264),
	    Map = __webpack_require__(368);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(266);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(266);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(266);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(266);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1683);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(576);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(572);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1601);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1668 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1625),
	    shortOut = __webpack_require__(1670);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(264);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1672 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1673 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1674 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(264),
	    Map = __webpack_require__(368),
	    MapCache = __webpack_require__(369);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1676 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1662);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(1606),
	    baseFlatten = __webpack_require__(564),
	    baseRest = __webpack_require__(567),
	    isArrayLikeObject = __webpack_require__(580);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(565);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1611),
	    hasPath = __webpack_require__(1641);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(1605),
	    baseForOwn = __webpack_require__(1609),
	    baseIteratee = __webpack_require__(1619);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(369);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1623),
	    basePropertyDeep = __webpack_require__(1624),
	    isKey = __webpack_require__(372),
	    toKey = __webpack_require__(268);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1686 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 1687 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1627);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(564),
	    baseRest = __webpack_require__(567),
	    baseUniq = __webpack_require__(1628),
	    isArrayLikeObject = __webpack_require__(580);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = escapes;
	
	var defaults = [
	  '\\',
	  '`',
	  '*',
	  '{',
	  '}',
	  '[',
	  ']',
	  '(',
	  ')',
	  '#',
	  '+',
	  '-',
	  '.',
	  '!',
	  '_',
	  '>'
	];
	
	var gfm = defaults.concat(['~', '|']);
	
	var commonmark = gfm.concat([
	  '\n',
	  '"',
	  '$',
	  '%',
	  '&',
	  '\'',
	  ',',
	  '/',
	  ':',
	  ';',
	  '<',
	  '=',
	  '?',
	  '@',
	  '^'
	]);
	
	escapes.default = defaults;
	escapes.gfm = gfm;
	escapes.commonmark = commonmark;
	
	/* Get markdown escapes. */
	function escapes(options) {
	  var settings = options || {};
	
	  if (settings.commonmark) {
	    return commonmark;
	  }
	
	  return settings.gfm ? gfm : defaults;
	}


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(142);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(628);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      appBar = _context$muiTheme.appBar,
	      iconButtonSize = _context$muiTheme.button.iconButtonSize,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  (0, _inherits3.default)(AppBar, _Component);
	
	  function AppBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonTouchTap) {
	        _this.props.onLeftIconButtonTouchTap(event);
	      }
	    }, _this.handleTouchTapRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonTouchTap) {
	        _this.props.onRightIconButtonTouchTap(event);
	      }
	    }, _this.handleTitleTouchTap = function (event) {
	      if (_this.props.onTitleTouchTap) {
	        _this.props.onTitleTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          titleStyle = _props.titleStyle,
	          iconStyleLeft = _props.iconStyleLeft,
	          iconStyleRight = _props.iconStyleRight,
	          onTitleTouchTap = _props.onTitleTouchTap,
	          showMenuIconButton = _props.showMenuIconButton,
	          iconElementLeft = _props.iconElementLeft,
	          iconElementRight = _props.iconElementRight,
	          iconClassNameLeft = _props.iconClassNameLeft,
	          iconClassNameRight = _props.iconClassNameRight,
	          onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap,
	          onRightIconButtonTouchTap = _props.onRightIconButtonTouchTap,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'onRightIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onTouchTap: this.handleTitleTouchTap,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        if (iconElementLeft) {
	          var iconElementLeftProps = {};
	
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
	          }
	
	          if (!iconElementLeft.props.onTouchTap && this.props.onLeftIconButtonTouchTap) {
	            iconElementLeftProps.onTouchTap = this.handleTouchTapLeftIconButton;
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
	          );
	        } else {
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onTouchTap: this.handleTouchTapLeftIconButton
	            },
	            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightProps = {};
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
	            break;
	
	          case 'FlatButton':
	            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
	            break;
	
	          default:
	        }
	
	        if (!iconElementRight.props.onTouchTap && this.props.onRightIconButtonTouchTap) {
	          iconElementRightProps.onTouchTap = this.handleTouchTapRightIconButton;
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onTouchTap: this.handleTouchTapRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? AppBar.propTypes = {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _react.PropTypes.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _react.PropTypes.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _react.PropTypes.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _react.PropTypes.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _react.PropTypes.object,
	  /**
	   * Callback function for when the left icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the left `IconButton`.
	   */
	  onLeftIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the right icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the right `IconButton`.
	   */
	  onRightIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the title text is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the `title` node.
	   */
	  onTitleTouchTap: _react.PropTypes.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _react.PropTypes.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = AppBar;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(1691);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(126);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Menu = __webpack_require__(597);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(385);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(271);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var anchorEl = state.anchorEl;
	  var fullWidth = props.fullWidth;
	
	
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'relative',
	      width: fullWidth ? '100%' : 256
	    },
	    menu: {
	      width: '100%'
	    },
	    list: {
	      display: 'block',
	      width: fullWidth ? '100%' : 256
	    },
	    innerDiv: {
	      overflow: 'hidden'
	    }
	  };
	
	  if (anchorEl && fullWidth) {
	    styles.popover = {
	      width: anchorEl.clientWidth
	    };
	  }
	
	  return styles;
	}
	
	var AutoComplete = function (_Component) {
	  (0, _inherits3.default)(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      focusTextField: true,
	      open: false,
	      searchText: undefined
	    }, _this.handleRequestClose = function () {
	      // Only take into account the Popover clickAway when we are
	      // not focusing the TextField.
	      if (!_this.state.focusTextField) {
	        _this.close();
	      }
	    }, _this.handleMouseDown = function (event) {
	      // Keep the TextField focused
	      event.preventDefault();
	    }, _this.handleItemTouchTap = function (event, child) {
	      var dataSource = _this.props.dataSource;
	
	      var index = parseInt(child.key, 10);
	      var chosenRequest = dataSource[index];
	      var searchText = _this.chosenRequestText(chosenRequest);
	
	      _this.setState({
	        searchText: searchText
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'touchTap'
	        });
	
	        _this.timerTouchTapCloseId = setTimeout(function () {
	          _this.timerTouchTapCloseId = null;
	          _this.close();
	          _this.props.onNewRequest(chosenRequest, index);
	        }, _this.props.menuCloseDelay);
	      });
	    }, _this.chosenRequestText = function (chosenRequest) {
	      if (typeof chosenRequest === 'string') {
	        return chosenRequest;
	      } else {
	        return chosenRequest[_this.props.dataSourceConfig.text];
	      }
	    }, _this.handleEscKeyDown = function () {
	      _this.close();
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.close();
	          var searchText = _this.state.searchText;
	          if (searchText !== '') {
	            _this.props.onNewRequest(searchText, -1);
	          }
	          break;
	
	        case 'esc':
	          _this.close();
	          break;
	
	        case 'down':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            focusTextField: false,
	            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	          });
	          break;
	
	        default:
	          break;
	      }
	    }, _this.handleChange = function (event) {
	      var searchText = event.target.value;
	
	      // Make sure that we have a new searchText.
	      // Fix an issue with a Cordova Webview
	      if (searchText === _this.state.searchText) {
	        return;
	      }
	
	      _this.setState({
	        searchText: searchText,
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'change'
	        });
	      });
	    }, _this.handleBlur = function (event) {
	      if (_this.state.focusTextField && _this.timerTouchTapCloseId === null) {
	        _this.timerBlurClose = setTimeout(function () {
	          _this.close();
	        }, 0);
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      if (!_this.state.open && _this.props.openOnFocus) {
	        _this.setState({
	          open: true,
	          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	        });
	      }
	
	      _this.setState({
	        focusTextField: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoComplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.requestsList = [];
	      this.setState({
	        open: this.props.open,
	        searchText: this.props.searchText
	      });
	      this.timerTouchTapCloseId = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.searchText !== nextProps.searchText) {
	        this.setState({
	          searchText: nextProps.searchText
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerTouchTapCloseId);
	      clearTimeout(this.timerBlurClose);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        open: false,
	        anchorEl: null
	      });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.searchTextField.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.searchTextField.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          animated = _props.animated,
	          animation = _props.animation,
	          dataSource = _props.dataSource,
	          dataSourceConfig = _props.dataSourceConfig,
	          disableFocusRipple = _props.disableFocusRipple,
	          errorStyle = _props.errorStyle,
	          floatingLabelText = _props.floatingLabelText,
	          filter = _props.filter,
	          fullWidth = _props.fullWidth,
	          style = _props.style,
	          hintText = _props.hintText,
	          maxSearchResults = _props.maxSearchResults,
	          menuCloseDelay = _props.menuCloseDelay,
	          textFieldStyle = _props.textFieldStyle,
	          menuStyle = _props.menuStyle,
	          menuProps = _props.menuProps,
	          listStyle = _props.listStyle,
	          targetOrigin = _props.targetOrigin,
	          onClose = _props.onClose,
	          onNewRequest = _props.onNewRequest,
	          onUpdateInput = _props.onUpdateInput,
	          openOnFocus = _props.openOnFocus,
	          popoverProps = _props.popoverProps,
	          searchTextProp = _props.searchText,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'onClose', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'popoverProps', 'searchText']);
	
	      var _ref2 = popoverProps || {},
	          popoverStyle = _ref2.style,
	          popoverOther = (0, _objectWithoutProperties3.default)(_ref2, ['style']);
	
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl,
	          searchText = _state.searchText,
	          focusTextField = _state.focusTextField;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var requestsList = [];
	
	      dataSource.every(function (item, index) {
	        switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) {
	          case 'string':
	            if (filter(searchText, item, item)) {
	              requestsList.push({
	                text: item,
	                value: _react2.default.createElement(_MenuItem2.default, {
	                  innerDivStyle: styles.innerDiv,
	                  value: item,
	                  primaryText: item,
	                  disableFocusRipple: disableFocusRipple,
	                  key: index
	                })
	              });
	            }
	            break;
	
	          case 'object':
	            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
	              var itemText = item[_this2.props.dataSourceConfig.text];
	              if (!_this2.props.filter(searchText, itemText, item)) break;
	
	              var itemValue = item[_this2.props.dataSourceConfig.value];
	              if (itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.cloneElement(itemValue, {
	                    key: index,
	                    disableFocusRipple: disableFocusRipple
	                  })
	                });
	              } else {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.createElement(_MenuItem2.default, {
	                    innerDivStyle: styles.innerDiv,
	                    primaryText: itemText,
	                    disableFocusRipple: disableFocusRipple,
	                    key: index
	                  })
	                });
	              }
	            }
	            break;
	
	          default:
	          // Do nothing
	        }
	
	        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
	      });
	
	      this.requestsList = requestsList;
	
	      var menu = open && requestsList.length > 0 && _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, menuProps, {
	          ref: 'menu',
	          autoWidth: false,
	          disableAutoFocus: focusTextField,
	          onEscKeyDown: this.handleEscKeyDown,
	          initiallyKeyboardFocused: true,
	          onItemTouchTap: this.handleItemTouchTap,
	          onMouseDown: this.handleMouseDown,
	          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
	          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
	        }),
	        requestsList.map(function (i) {
	          return i.value;
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          ref: 'searchTextField',
	          autoComplete: 'off',
	          value: searchText,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          fullWidth: fullWidth,
	          multiLine: false,
	          errorStyle: errorStyle,
	          style: textFieldStyle
	        })),
	        _react2.default.createElement(
	          _Popover2.default,
	          (0, _extends3.default)({
	            style: (0, _simpleAssign2.default)({}, styles.popover, popoverStyle),
	            canAutoPosition: false,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation
	          }, popoverOther),
	          menu
	        )
	      );
	    }
	  }]);
	  return AutoComplete;
	}(_react.Component);
	
	AutoComplete.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  dataSourceConfig: {
	    text: 'text',
	    value: 'value'
	  },
	  disableFocusRipple: true,
	  filter: function filter(searchText, key) {
	    return searchText !== '' && key.indexOf(searchText) !== -1;
	  },
	  fullWidth: false,
	  open: false,
	  openOnFocus: false,
	  onUpdateInput: function onUpdateInput() {},
	  onNewRequest: function onNewRequest() {},
	  searchText: '',
	  menuCloseDelay: 300,
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	AutoComplete.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? AutoComplete.propTypes = {
	  /**
	   * Location of the anchor for the auto complete.
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the auto complete is animated as it is toggled.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Array of strings or nodes used to populate the list.
	   */
	  dataSource: _react.PropTypes.array.isRequired,
	  /**
	   * Config for objects list dataSource.
	   *
	   * @typedef {Object} dataSourceConfig
	   *
	   * @property {string} text `dataSource` element key used to find a string to be matched for search
	   * and shown as a `TextField` input value after choosing the result.
	   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
	   */
	  dataSourceConfig: _react.PropTypes.object,
	  /**
	   * Disables focus ripple when true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * Override style prop for error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * Callback function used to filter the auto complete.
	   *
	   * @param {string} searchText The text to search for within `dataSource`.
	   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
	   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
	   */
	  filter: _react.PropTypes.func,
	  /**
	   * The content to use for adding floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property `width: 100%`.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override style for list.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The max number of search results to be shown.
	   * By default it shows all the items which matches filter.
	   */
	  maxSearchResults: _react.PropTypes.number,
	  /**
	   * Delay for closing time of the menu.
	   */
	  menuCloseDelay: _react.PropTypes.number,
	  /**
	   * Props to be passed to menu.
	   */
	  menuProps: _react.PropTypes.object,
	  /**
	   * Override style for menu.
	   */
	  menuStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
	   *
	   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
	   * or the text value of the corresponding list item that was selected.
	   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
	   * `TextField`.
	   */
	  onNewRequest: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the user updates the `TextField`.
	   *
	   * @param {string} searchText The auto-complete's `searchText` value.
	   * @param {array} dataSource The auto-complete's `dataSource` array.
	   * @param {object} params Additional information linked the update.
	   */
	  onUpdateInput: _react.PropTypes.func,
	  /**
	   * Auto complete menu is open if true.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * If true, the list item is showed when a focus event triggers.
	   */
	  openOnFocus: _react.PropTypes.bool,
	  /**
	   * Props to be passed to popover.
	   */
	  popoverProps: _react.PropTypes.object,
	  /**
	   * Text being input to auto complete.
	   */
	  searchText: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Origin for location of target.
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Override the inline-styles of AutoComplete's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object
	} : void 0;
	
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = void 0;
	  var value = void 0;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.indexOf(searchText) !== -1;
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) {
	    return AutoComplete.levenshteinDistance;
	  } else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  var compareString = key.toLowerCase();
	  searchText = searchText.toLowerCase();
	
	  var searchTextIndex = 0;
	  for (var index = 0; index < key.length; index++) {
	    if (compareString[index] === searchText[searchTextIndex]) {
	      searchTextIndex += 1;
	    }
	  }
	
	  return searchTextIndex === searchText.length;
	};
	
	AutoComplete.Item = _MenuItem2.default;
	AutoComplete.Divider = _Divider2.default;
	
	exports.default = AutoComplete;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AutoComplete = __webpack_require__(1693);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoComplete2.default;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor,
	      color = props.color,
	      size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  (0, _inherits3.default)(Avatar, _Component);
	
	  function Avatar() {
	    (0, _classCallCheck3.default)(this, Avatar);
	    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          src = _props.src,
	          style = _props.style,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Avatar.propTypes = {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _react.PropTypes.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Avatar;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var primary = props.primary,
	      secondary = props.secondary;
	  var badge = context.muiTheme.badge;
	
	
	  var badgeBackgroundColor = void 0;
	  var badgeTextColor = void 0;
	
	  if (primary) {
	    badgeBackgroundColor = badge.primaryColor;
	    badgeTextColor = badge.primaryTextColor;
	  } else if (secondary) {
	    badgeBackgroundColor = badge.secondaryColor;
	    badgeTextColor = badge.secondaryTextColor;
	  } else {
	    badgeBackgroundColor = badge.color;
	    badgeTextColor = badge.textColor;
	  }
	
	  var radius = 12;
	  var radius2x = Math.floor(2 * radius);
	
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontWeight: badge.fontWeight,
	      fontSize: radius,
	      width: radius2x,
	      height: radius2x,
	      borderRadius: '50%',
	      backgroundColor: badgeBackgroundColor,
	      color: badgeTextColor
	    }
	  };
	}
	
	var Badge = function (_Component) {
	  (0, _inherits3.default)(Badge, _Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, (Badge.__proto__ || (0, _getPrototypeOf2.default)(Badge)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          badgeStyle = _props.badgeStyle,
	          children = _props.children,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
	          badgeContent
	        )
	      );
	    }
	  }]);
	  return Badge;
	}(_react.Component);
	
	Badge.defaultProps = {
	  primary: false,
	  secondary: false
	};
	Badge.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Badge.propTypes = {
	  /**
	   * This is the content rendered within the badge.
	   */
	  badgeContent: _react.PropTypes.node.isRequired,
	  /**
	   * Override the inline-styles of the badge element.
	   */
	  badgeStyle: _react.PropTypes.object,
	  /**
	   * The badge will be added relativelty to this node.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the badge will use the primary badge colors.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * If true, the badge will use the secondary badge colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Badge;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Badge = __webpack_require__(1696);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      width: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      backgroundColor: bottomNavigation.backgroundColor,
	      height: bottomNavigation.height
	    },
	    item: {
	      flex: '1'
	    }
	  };
	
	  return styles;
	}
	
	var BottomNavigation = function BottomNavigation(props, context) {
	  var children = props.children,
	      style = props.style,
	      selectedIndex = props.selectedIndex,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'style', 'selectedIndex']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var preparedChildren = _react.Children.map(children, function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      style: (0, _simpleAssign2.default)({}, styles.item, child.props.style),
	      selected: index === selectedIndex
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    preparedChildren
	  );
	};
	
	 false ? BottomNavigation.propTypes = {
	  /**
	   * The `BottomNavigationItem`s to populate the element with.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The index of the currently selected navigation item.
	   */
	  selectedIndex: _react.PropTypes.number,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	BottomNavigation.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = BottomNavigation;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BottomNavigationItem = exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(1698);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(585);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.default = _BottomNavigation3.default;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(587);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          containerStyle = _props.containerStyle,
	          children = _props.children,
	          expandable = _props.expandable,
	          expandedProp = _props.expanded,
	          initiallyExpanded = _props.initiallyExpanded,
	          onExpandChange = _props.onExpandChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onTouchTap = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, {
	            closeIcon: currentChild.props.closeIcon,
	            expanded: expanded,
	            onExpanding: _this2.handleExpanding,
	            openIcon: currentChild.props.openIcon
	          });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	 false ? Card.propTypes = {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _react.PropTypes.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _react.PropTypes.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _react.PropTypes.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Card;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(1700);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(588);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(591);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(589);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(590);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(586);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(587);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedSwitch = __webpack_require__(389);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(629);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(630);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Checkbox.propTypes = {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _react.PropTypes.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _react.PropTypes.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _react.PropTypes.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = Checkbox;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _colorManipulator = __webpack_require__(117);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _cancel = __webpack_require__(622);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var chip = context.muiTheme.chip;
	
	
	  var backgroundColor = props.backgroundColor || chip.backgroundColor;
	  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
	  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);
	
	  return {
	    avatar: {
	      marginRight: -4
	    },
	    deleteIcon: {
	      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
	      cursor: 'pointer',
	      margin: '4px 4px 0px -8px'
	    },
	    label: {
	      color: props.labelColor || chip.textColor,
	      fontSize: chip.fontSize,
	      fontWeight: chip.fontWeight,
	      lineHeight: '32px',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap'
	    },
	    root: {
	      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
	      borderRadius: 16,
	      boxShadow: state.clicked ? chip.shadow : null,
	      cursor: props.onTouchTap ? 'pointer' : 'default',
	      display: 'flex',
	      whiteSpace: 'nowrap',
	      width: 'fit-content'
	    }
	  };
	}
	
	var Chip = function (_Component) {
	  (0, _inherits3.default)(Chip, _Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clicked: false,
	      deleteHovered: false,
	      focused: false,
	      hovered: false
	    }, _this.handleBlur = function (event) {
	      _this.setState({ clicked: false, focused: false });
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (_this.props.onTouchTap || _this.props.onRequestDelete) {
	        _this.setState({ focused: true });
	      }
	      _this.props.onFocus(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused) {
	        _this.handleFocus();
	        _this.props.onFocus(event);
	      } else {
	        _this.handleBlur();
	      }
	
	      _this.props.onKeyboardFocus(event, keyboardFocused);
	    }, _this.handleKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'backspace') {
	        event.preventDefault();
	        if (_this.props.onRequestDelete) {
	          _this.props.onRequestDelete(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleMouseDown = function (event) {
	      // Only listen to left clicks
	      if (event.button === 0) {
	        event.stopPropagation();
	        if (_this.props.onTouchTap) {
	          _this.setState({ clicked: true });
	        }
	      }
	      _this.props.onMouseDown(event);
	    }, _this.handleMouseEnter = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.setState({ hovered: true });
	      }
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseEnterDeleteIcon = function () {
	      _this.setState({ deleteHovered: true });
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({
	        clicked: false,
	        hovered: false
	      });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseLeaveDeleteIcon = function () {
	      _this.setState({ deleteHovered: false });
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onMouseUp(event);
	    }, _this.handleTouchTapDeleteIcon = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      _this.props.onRequestDelete(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onTouchEnd(event);
	    }, _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      if (_this.props.onTouchTap) {
	        _this.setState({ clicked: true });
	      }
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chip, [{
	    key: 'render',
	    value: function render() {
	      var buttonEventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchStart: this.handleTouchStart,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          containerElement = _props.containerElement,
	          style = _props.style,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelColor = _props.labelColor,
	          backgroundColor = _props.backgroundColor,
	          onRequestDelete = _props.onRequestDelete,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'containerElement', 'style', 'className', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);
	
	
	      var deletable = this.props.onRequestDelete;
	      var avatar = null;
	
	      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
	        color: styles.deleteIcon.color,
	        style: styles.deleteIcon,
	        onTouchTap: this.handleTouchTapDeleteIcon,
	        onMouseEnter: this.handleMouseEnterDeleteIcon,
	        onMouseLeave: this.handleMouseLeaveDeleteIcon
	      }) : null;
	
	      var children = childrenProp;
	      var childCount = _react2.default.Children.count(children);
	
	      // If the first child is an avatar, extract it and style it
	      if (childCount > 1) {
	        children = _react2.default.Children.toArray(children);
	
	        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
	          avatar = children.shift();
	
	          avatar = _react2.default.cloneElement(avatar, {
	            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
	            size: 32
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, buttonEventHandlers, {
	          className: className,
	          containerElement: containerElement,
	          disableTouchRipple: true,
	          disableFocusRipple: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	          children
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	  return Chip;
	}(_react.Component);
	
	Chip.defaultProps = {
	  containerElement: 'div', // Firefox doesn't support nested buttons
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {}
	};
	Chip.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	 false ? Chip.propTypes = {
	  /**
	   * Override the background color of the chip.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Used to render elements inside the Chip.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * CSS `className` of the root element.
	   */
	  className: _react.PropTypes.node,
	  /**
	   * The element to use as the container for the Chip. Either a string to
	   * use a DOM element or a ReactElement.
	   */
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  /**
	   * Override the label color.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /** @ignore */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
	   * @param {object} event `touchTap` event targeting the element.
	   */
	  onRequestDelete: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `Chip` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Chip;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Chip = __webpack_require__(1703);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip2.default;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(162);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return clampedValue / (max - min);
	}
	
	function getArcLength(fraction, props) {
	  return fraction * Math.PI * (props.size - props.thickness);
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      size = props.size,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      width: size,
	      height: size
	    },
	    wrapper: {
	      width: size,
	      height: size,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      width: size,
	      height: size,
	      position: 'relative'
	    },
	    path: {
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  (0, _inherits3.default)(CircularProgress, _Component);
	
	  function CircularProgress() {
	    (0, _classCallCheck3.default)(this, CircularProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path) {
	      var _this2 = this;
	
	      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-1, this.props);
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          innerStyle = _props.innerStyle,
	          size = _props.size,
	          thickness = _props.thickness,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 ' + size + ' ' + size,
	              style: prepareStyles(styles.svg)
	            },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: size / 2,
	              cy: size / 2,
	              r: (size - thickness) / 2,
	              fill: 'none',
	              strokeWidth: thickness,
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 40,
	  thickness: 3.5
	};
	CircularProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CircularProgress.propTypes = {
	  /**
	   * Override the progress's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _react.PropTypes.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The diameter of the progress in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Stroke width in pixels.
	   */
	  thickness: _react.PropTypes.number,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = CircularProgress;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(1705);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(214);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _CalendarActionButtons = __webpack_require__(1708);
	
	var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);
	
	var _CalendarMonth = __webpack_require__(1709);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarYear = __webpack_require__(1711);
	
	var _CalendarYear2 = _interopRequireDefault(_CalendarYear);
	
	var _CalendarToolbar = __webpack_require__(1710);
	
	var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);
	
	var _DateDisplay = __webpack_require__(1712);
	
	var _DateDisplay2 = _interopRequireDefault(_DateDisplay);
	
	var _SlideIn = __webpack_require__(391);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	var _dateUtils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));
	
	var Calendar = function (_Component) {
	  (0, _inherits3.default)(Calendar, _Component);
	
	  function Calendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      displayDate: undefined,
	      displayMonthDay: true,
	      selectedDate: undefined,
	      transitionDirection: 'left',
	      transitionEnter: true
	    }, _this.handleTouchTapDay = function (event, date) {
	      _this.setSelectedDate(date);
	      if (_this.props.onTouchTapDay) _this.props.onTouchTapDay(event, date);
	    }, _this.handleMonthChange = function (months) {
	      _this.setState({
	        transitionDirection: months >= 0 ? 'left' : 'right',
	        displayDate: (0, _dateUtils.addMonths)(_this.state.displayDate, months)
	      });
	    }, _this.handleTouchTapYear = function (event, year) {
	      var date = (0, _dateUtils.cloneDate)(_this.state.selectedDate);
	      date.setFullYear(year);
	      _this.setSelectedDate(date, event);
	      _this.handleTouchTapDateDisplayMonthDay();
	    }, _this.handleTouchTapDateDisplayMonthDay = function () {
	      _this.setState({
	        displayMonthDay: true
	      });
	    }, _this.handleTouchTapDateDisplayYear = function () {
	      _this.setState({
	        displayMonthDay: false
	      });
	    }, _this.handleWindowKeyDown = function (event) {
	      if (_this.props.open) {
	        switch ((0, _keycode2.default)(event)) {
	          case 'up':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-7);
	            }
	            break;
	
	          case 'down':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(7);
	            }
	            break;
	
	          case 'right':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(1);
	            }
	            break;
	
	          case 'left':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-1);
	            }
	            break;
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Calendar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        displayDate: (0, _dateUtils.getFirstDayOfMonth)(this.props.initialDate),
	        selectedDate: this.props.initialDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialDate !== this.props.initialDate) {
	        var date = nextProps.initialDate || new Date();
	        this.setState({
	          displayDate: (0, _dateUtils.getFirstDayOfMonth)(date),
	          selectedDate: date
	        });
	      }
	    }
	  }, {
	    key: 'getSelectedDate',
	    value: function getSelectedDate() {
	      return this.state.selectedDate;
	    }
	  }, {
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      if (!this.state.displayMonthDay) {
	        return false;
	      }
	
	      return this.refs.calendar.isSelectedDateDisabled();
	    }
	  }, {
	    key: 'addSelectedDays',
	    value: function addSelectedDays(days) {
	      this.setSelectedDate((0, _dateUtils.addDays)(this.state.selectedDate, days));
	    }
	  }, {
	    key: 'addSelectedMonths',
	    value: function addSelectedMonths(months) {
	      this.setSelectedDate((0, _dateUtils.addMonths)(this.state.selectedDate, months));
	    }
	  }, {
	    key: 'addSelectedYears',
	    value: function addSelectedYears(years) {
	      this.setSelectedDate((0, _dateUtils.addYears)(this.state.selectedDate, years));
	    }
	  }, {
	    key: 'setDisplayDate',
	    value: function setDisplayDate(date, newSelectedDate) {
	      var newDisplayDate = (0, _dateUtils.getFirstDayOfMonth)(date);
	      var direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';
	
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setState({
	          displayDate: newDisplayDate,
	          transitionDirection: direction,
	          selectedDate: newSelectedDate || this.state.selectedDate
	        });
	      }
	    }
	  }, {
	    key: 'setSelectedDate',
	    value: function setSelectedDate(date) {
	      var adjustedDate = date;
	      if ((0, _dateUtils.isBeforeDate)(date, this.props.minDate)) {
	        adjustedDate = this.props.minDate;
	      } else if ((0, _dateUtils.isAfterDate)(date, this.props.maxDate)) {
	        adjustedDate = this.props.maxDate;
	      }
	
	      var newDisplayDate = (0, _dateUtils.getFirstDayOfMonth)(adjustedDate);
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setDisplayDate(newDisplayDate, adjustedDate);
	      } else {
	        this.setState({
	          selectedDate: adjustedDate
	        });
	      }
	    }
	  }, {
	    key: 'getToolbarInteractions',
	    value: function getToolbarInteractions() {
	      return {
	        prevMonth: (0, _dateUtils.monthDiff)(this.state.displayDate, this.props.minDate) > 0,
	        nextMonth: (0, _dateUtils.monthDiff)(this.state.displayDate, this.props.maxDate) < 0
	      };
	    }
	  }, {
	    key: 'yearSelector',
	    value: function yearSelector() {
	      if (!this.props.disableYearSelection) {
	        return _react2.default.createElement(_CalendarYear2.default, {
	          key: 'years',
	          DateTimeFormat: this.props.DateTimeFormat,
	          locale: this.props.locale,
	          onTouchTapYear: this.handleTouchTapYear,
	          selectedDate: this.state.selectedDate,
	          minDate: this.props.minDate,
	          maxDate: this.props.maxDate
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var hideCalendarDate = this.props.hideCalendarDate;
	
	      var toolbarInteractions = this.getToolbarInteractions();
	      var isLandscape = this.props.mode === 'landscape';
	      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;
	
	
	      var styles = {
	        root: {
	          color: calendarTextColor,
	          userSelect: 'none',
	          width: !hideCalendarDate && isLandscape ? 479 : 310
	        },
	        calendar: {
	          display: 'flex',
	          flexDirection: 'column'
	        },
	        calendarContainer: {
	          display: 'flex',
	          alignContent: 'space-between',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          fontSize: 12,
	          fontWeight: 400,
	          padding: '0px 8px',
	          transition: _transitions2.default.easeOut()
	        },
	        yearContainer: {
	          display: 'flex',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          height: 272,
	          marginTop: 10,
	          overflow: 'hidden',
	          width: 310
	        },
	        weekTitle: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          fontWeight: '500',
	          height: 20,
	          lineHeight: '15px',
	          opacity: '0.5',
	          textAlign: 'center'
	        },
	        weekTitleDay: {
	          width: 42
	        },
	        transitionSlide: {
	          height: 214
	        }
	      };
	
	      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);
	
	      var _props = this.props,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          cancelLabel = _props.cancelLabel,
	          DateTimeFormat = _props.DateTimeFormat,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          okLabel = _props.okLabel,
	          onTouchTapCancel = _props.onTouchTapCancel,
	          onTouchTapOk = _props.onTouchTapOk;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleWindowKeyDown
	        }),
	        !hideCalendarDate && _react2.default.createElement(_DateDisplay2.default, {
	          DateTimeFormat: DateTimeFormat,
	          disableYearSelection: this.props.disableYearSelection,
	          onTouchTapMonthDay: this.handleTouchTapDateDisplayMonthDay,
	          onTouchTapYear: this.handleTouchTapDateDisplayYear,
	          locale: locale,
	          monthDaySelected: this.state.displayMonthDay,
	          mode: this.props.mode,
	          selectedDate: this.state.selectedDate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.calendar) },
	          this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.calendarContainer) },
	            _react2.default.createElement(_CalendarToolbar2.default, {
	              DateTimeFormat: DateTimeFormat,
	              locale: locale,
	              displayDate: this.state.displayDate,
	              onMonthChange: this.handleMonthChange,
	              prevMonth: toolbarInteractions.prevMonth,
	              nextMonth: toolbarInteractions.nextMonth
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.weekTitle) },
	              daysArray.map(function (event, i) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: i, style: weekTitleDayStyle },
	                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SlideIn2.default,
	              { direction: this.state.transitionDirection, style: styles.transitionSlide },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                DateTimeFormat: DateTimeFormat,
	                locale: locale,
	                displayDate: this.state.displayDate,
	                firstDayOfWeek: this.props.firstDayOfWeek,
	                key: this.state.displayDate.toDateString(),
	                minDate: minDate,
	                maxDate: maxDate,
	                onTouchTapDay: this.handleTouchTapDay,
	                ref: 'calendar',
	                selectedDate: this.state.selectedDate,
	                shouldDisableDate: this.props.shouldDisableDate
	              })
	            )
	          ),
	          !this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.yearContainer) },
	            this.yearSelector()
	          ),
	          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
	            autoOk: this.props.autoOk,
	            cancelLabel: cancelLabel,
	            okLabel: okLabel,
	            onTouchTapCancel: onTouchTapCancel,
	            onTouchTapOk: onTouchTapOk
	          })
	        )
	      );
	    }
	  }]);
	  return Calendar;
	}(_react.Component);
	
	Calendar.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  disableYearSelection: false,
	  initialDate: new Date(),
	  locale: 'en-US',
	  minDate: (0, _dateUtils.addYears)(new Date(), -100),
	  maxDate: (0, _dateUtils.addYears)(new Date(), 100)
	};
	Calendar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Calendar.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  disableYearSelection: _react.PropTypes.bool,
	  firstDayOfWeek: _react.PropTypes.number,
	  hideCalendarDate: _react.PropTypes.bool,
	  initialDate: _react.PropTypes.object,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  okLabel: _react.PropTypes.node,
	  onTouchTapCancel: _react.PropTypes.func,
	  onTouchTapDay: _react.PropTypes.func,
	  onTouchTapOk: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  shouldDisableDate: _react.PropTypes.func
	} : void 0;
	exports.default = Calendar;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FlatButton = __webpack_require__(272);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarActionButton = function (_Component) {
	  (0, _inherits3.default)(CalendarActionButton, _Component);
	
	  function CalendarActionButton() {
	    (0, _classCallCheck3.default)(this, CalendarActionButton);
	    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CalendarActionButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          okLabel = _props.okLabel;
	
	
	      var styles = {
	        root: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'flex-end',
	          margin: 0,
	          maxHeight: 48,
	          padding: 0
	        },
	        flatButtons: {
	          fontsize: 14,
	          margin: '4px 8px 8px 0px',
	          maxHeight: 36,
	          minWidth: 64,
	          padding: 0
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_FlatButton2.default, {
	          label: cancelLabel,
	          onTouchTap: this.props.onTouchTapCancel,
	          primary: true,
	          style: styles.flatButtons
	        }),
	        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
	          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	          label: okLabel,
	          onTouchTap: this.props.onTouchTapOk,
	          primary: true,
	          style: styles.flatButtons
	        })
	      );
	    }
	  }]);
	  return CalendarActionButton;
	}(_react.Component);
	
	 false ? CalendarActionButton.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  okLabel: _react.PropTypes.node,
	  onTouchTapCancel: _react.PropTypes.func,
	  onTouchTapOk: _react.PropTypes.func
	} : void 0;
	exports.default = CalendarActionButton;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateUtils = __webpack_require__(186);
	
	var _DayButton = __webpack_require__(1715);
	
	var _DayButton2 = _interopRequireDefault(_DayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'flex-start',
	    fontWeight: 400,
	    height: 228,
	    lineHeight: 2,
	    position: 'relative',
	    textAlign: 'center',
	    MozPaddingStart: 0
	  },
	  week: {
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-around',
	    height: 34,
	    marginBottom: 2
	  }
	};
	
	var CalendarMonth = function (_Component) {
	  (0, _inherits3.default)(CalendarMonth, _Component);
	
	  function CalendarMonth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarMonth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapDay = function (event, date) {
	      if (_this.props.onTouchTapDay) {
	        _this.props.onTouchTapDay(event, date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarMonth, [{
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      return this.selectedDateDisabled;
	    }
	  }, {
	    key: 'shouldDisableDate',
	    value: function shouldDisableDate(day) {
	      if (day === null) return false;
	      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
	      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	      return disabled;
	    }
	  }, {
	    key: 'getWeekElements',
	    value: function getWeekElements() {
	      var _this2 = this;
	
	      var weekArray = (0, _dateUtils.getWeekArray)(this.props.displayDate, this.props.firstDayOfWeek);
	
	      return weekArray.map(function (week, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: styles.week },
	          _this2.getDayElements(week, i)
	        );
	      }, this);
	    }
	  }, {
	    key: 'getDayElements',
	    value: function getDayElements(week, i) {
	      var _this3 = this;
	
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          selectedDate = _props.selectedDate;
	
	
	      return week.map(function (day, j) {
	        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
	        var disabled = _this3.shouldDisableDate(day);
	        var selected = !disabled && isSameDate;
	
	        if (isSameDate) {
	          _this3.selectedDateDisabled = disabled;
	        }
	
	        return _react2.default.createElement(_DayButton2.default, {
	          DateTimeFormat: DateTimeFormat,
	          locale: locale,
	          date: day,
	          disabled: disabled,
	          key: 'db' + (i + j),
	          onTouchTap: _this3.handleTouchTapDay,
	          selected: selected
	        });
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        this.getWeekElements()
	      );
	    }
	  }]);
	  return CalendarMonth;
	}(_react.Component);
	
	 false ? CalendarMonth.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  autoOk: _react.PropTypes.bool,
	  displayDate: _react.PropTypes.object.isRequired,
	  firstDayOfWeek: _react.PropTypes.number,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  onTouchTapDay: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  shouldDisableDate: _react.PropTypes.func
	} : void 0;
	exports.default = CalendarMonth;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(624);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(625);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _SlideIn = __webpack_require__(391);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    backgroundColor: 'inherit',
	    height: 48
	  },
	  titleDiv: {
	    fontSize: 14,
	    fontWeight: '500',
	    textAlign: 'center',
	    width: '100%'
	  },
	  titleText: {
	    height: 'inherit',
	    paddingTop: 12
	  }
	};
	
	var CalendarToolbar = function (_Component) {
	  (0, _inherits3.default)(CalendarToolbar, _Component);
	
	  function CalendarToolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _this.handleTouchTapPrevMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(-1);
	      }
	    }, _this.handleTouchTapNextMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(1);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarToolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.displayDate !== this.props.displayDate) {
	        var direction = nextProps.displayDate > this.props.displayDate ? 'left' : 'right';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          displayDate = _props.displayDate;
	
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'long',
	        year: 'numeric'
	      }).format(displayDate);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.prevMonth,
	            onTouchTap: this.handleTouchTapPrevMonth
	          },
	          _react2.default.createElement(_chevronLeft2.default, null)
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            direction: this.state.transitionDirection,
	            style: styles.titleDiv
	          },
	          _react2.default.createElement(
	            'div',
	            { key: dateTimeFormatted, style: styles.titleText },
	            dateTimeFormatted
	          )
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.nextMonth,
	            onTouchTap: this.handleTouchTapNextMonth
	          },
	          _react2.default.createElement(_chevronRight2.default, null)
	        )
	      );
	    }
	  }]);
	  return CalendarToolbar;
	}(_react.Component);
	
	CalendarToolbar.defaultProps = {
	  nextMonth: true,
	  prevMonth: true
	};
	 false ? CalendarToolbar.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  displayDate: _react.PropTypes.object.isRequired,
	  locale: _react.PropTypes.string.isRequired,
	  nextMonth: _react.PropTypes.bool,
	  onMonthChange: _react.PropTypes.func,
	  prevMonth: _react.PropTypes.bool
	} : void 0;
	exports.default = CalendarToolbar;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _YearButton = __webpack_require__(1716);
	
	var _YearButton2 = _interopRequireDefault(_YearButton);
	
	var _dateUtils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarYear = function (_Component) {
	  (0, _inherits3.default)(CalendarYear, _Component);
	
	  function CalendarYear() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarYear);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapYear = function (event, year) {
	      if (_this.props.onTouchTapYear) {
	        _this.props.onTouchTapYear(event, year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarYear, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          selectedDate = _props.selectedDate;
	
	
	      var minYear = minDate.getFullYear();
	      var maxYear = maxDate.getFullYear();
	      var years = [];
	      var dateCheck = (0, _dateUtils.cloneDate)(selectedDate);
	
	      for (var year = minYear; year <= maxYear; year++) {
	        dateCheck.setFullYear(year);
	        var selected = selectedDate.getFullYear() === year;
	        var selectedProps = {};
	        if (selected) {
	          selectedProps.ref = 'selectedYearButton';
	        }
	
	        var yearFormated = new DateTimeFormat(locale, {
	          year: 'numeric'
	        }).format(dateCheck);
	
	        var yearButton = _react2.default.createElement(
	          _YearButton2.default,
	          (0, _extends3.default)({
	            key: 'yb' + year,
	            onTouchTap: this.handleTouchTapYear,
	            selected: selected,
	            year: year
	          }, selectedProps),
	          yearFormated
	        );
	
	        years.push(yearButton);
	      }
	
	      return years;
	    }
	  }, {
	    key: 'scrollToSelectedYear',
	    value: function scrollToSelectedYear() {
	      if (this.refs.selectedYearButton === undefined) {
	        return;
	      }
	
	      var container = _reactDom2.default.findDOMNode(this);
	      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	      var containerHeight = container.clientHeight;
	      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	      container.scrollTop = scrollYOffset;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;
	
	
	      var styles = {
	        root: {
	          backgroundColor: calendarYearBackgroundColor,
	          height: 'inherit',
	          lineHeight: '35px',
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          position: 'relative'
	        },
	        child: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'center',
	          minHeight: '100%'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.child) },
	          this.getYears()
	        )
	      );
	    }
	  }]);
	  return CalendarYear;
	}(_react.Component);
	
	CalendarYear.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CalendarYear.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  locale: _react.PropTypes.string.isRequired,
	  maxDate: _react.PropTypes.object.isRequired,
	  minDate: _react.PropTypes.object.isRequired,
	  onTouchTapYear: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  wordings: _react.PropTypes.object
	} : void 0;
	exports.default = CalendarYear;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _SlideIn = __webpack_require__(391);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var datePicker = context.muiTheme.datePicker;
	  var selectedYear = state.selectedYear;
	
	  var isLandscape = props.mode === 'landscape';
	
	  var styles = {
	    root: {
	      width: isLandscape ? 165 : '100%',
	      height: isLandscape ? 330 : 'auto',
	      float: isLandscape ? 'left' : 'none',
	      fontWeight: 700,
	      display: 'inline-block',
	      backgroundColor: datePicker.selectColor,
	      borderTopLeftRadius: 2,
	      borderTopRightRadius: isLandscape ? 0 : 2,
	      borderBottomLeftRadius: isLandscape ? 2 : 0,
	      color: datePicker.textColor,
	      padding: 20,
	      boxSizing: 'border-box'
	    },
	    monthDay: {
	      display: 'block',
	      fontSize: 36,
	      lineHeight: '36px',
	      height: props.mode === 'landscape' ? '100%' : 38,
	      opacity: selectedYear ? 0.7 : 1,
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      fontWeight: '500'
	    },
	    monthDayTitle: {
	      cursor: !selectedYear ? 'default' : 'pointer',
	      width: '100%',
	      display: 'block'
	    },
	    year: {
	      margin: 0,
	      fontSize: 16,
	      fontWeight: '500',
	      lineHeight: '16px',
	      height: 16,
	      opacity: selectedYear ? 1 : 0.7,
	      transition: _transitions2.default.easeOut(),
	      marginBottom: 10
	    },
	    yearTitle: {
	      cursor: props.disableYearSelection ? 'not-allowed' : !selectedYear ? 'pointer' : 'default'
	    }
	  };
	
	  return styles;
	}
	
	var DateDisplay = function (_Component) {
	  (0, _inherits3.default)(DateDisplay, _Component);
	
	  function DateDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DateDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedYear: false,
	      transitionDirection: 'up'
	    }, _this.handleTouchTapMonthDay = function () {
	      if (_this.props.onTouchTapMonthDay && _this.state.selectedYear) {
	        _this.props.onTouchTapMonthDay();
	      }
	
	      _this.setState({ selectedYear: false });
	    }, _this.handleTouchTapYear = function () {
	      if (_this.props.onTouchTapYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
	        _this.props.onTouchTapYear();
	      }
	
	      if (!_this.props.disableYearSelection) {
	        _this.setState({ selectedYear: true });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DateDisplay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.monthDaySelected) {
	        this.setState({ selectedYear: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedDate !== this.props.selectedDate) {
	        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	
	      if (nextProps.monthDaySelected !== undefined) {
	        this.setState({
	          selectedYear: !nextProps.monthDaySelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          disableYearSelection = _props.disableYearSelection,
	          locale = _props.locale,
	          mode = _props.mode,
	          monthDaySelected = _props.monthDaySelected,
	          onTouchTapMonthDay = _props.onTouchTapMonthDay,
	          onTouchTapYear = _props.onTouchTapYear,
	          selectedDate = _props.selectedDate,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onTouchTapMonthDay', 'onTouchTapYear', 'selectedDate', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var year = new DateTimeFormat(locale, {
	        year: 'numeric'
	      }).format(selectedDate);
	
	      var dateTime = new DateTimeFormat(locale, {
	        month: 'short',
	        weekday: 'short',
	        day: '2-digit'
	      }).format(selectedDate);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.year, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            { key: year, style: styles.yearTitle, onTouchTap: this.handleTouchTapYear },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.monthDay, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            {
	              key: dateTime,
	              onTouchTap: this.handleTouchTapMonthDay,
	              style: styles.monthDayTitle
	            },
	            dateTime
	          )
	        )
	      );
	    }
	  }]);
	  return DateDisplay;
	}(_react.Component);
	
	DateDisplay.defaultProps = {
	  disableYearSelection: false,
	  monthDaySelected: true
	};
	DateDisplay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DateDisplay.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  disableYearSelection: _react.PropTypes.bool,
	  locale: _react.PropTypes.string.isRequired,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  monthDaySelected: _react.PropTypes.bool,
	  onTouchTapMonthDay: _react.PropTypes.func,
	  onTouchTapYear: _react.PropTypes.func,
	  selectedDate: _react.PropTypes.object.isRequired,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = DateDisplay;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateUtils = __webpack_require__(186);
	
	var _DatePickerDialog = __webpack_require__(1714);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePicker = function (_Component) {
	  (0, _inherits3.default)(DatePicker, _Component);
	
	  function DatePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      date: undefined
	    }, _this.handleAccept = function (date) {
	      if (!_this.isControlled()) {
	        _this.setState({
	          date: date
	        });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(null, date);
	      }
	    }, _this.handleFocus = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	
	      if (!_this.props.disabled) {
	        setTimeout(function () {
	          _this.openDialog();
	        }, 0);
	      }
	    }, _this.formatDate = function (date) {
	      if (_this.props.locale) {
	        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
	        return new DateTimeFormat(_this.props.locale, {
	          day: 'numeric',
	          month: 'numeric',
	          year: 'numeric'
	        }).format(date);
	      } else {
	        return (0, _dateUtils.formatIso)(date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled()) {
	        var newDate = this.getControlledDate(nextProps);
	        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
	          this.setState({
	            date: newDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate() {
	      return this.state.date;
	    }
	
	    /**
	     * Open the date-picker dialog programmatically from a parent.
	     */
	
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      /**
	       * if the date is not selected then set it to new date
	       * (get the current system date while doing so)
	       * else set it to the currently selected date
	       */
	      if (this.state.date !== undefined) {
	        this.setState({
	          dialogDate: this.getDate()
	        }, this.refs.dialogWindow.show);
	      } else {
	        this.setState({
	          dialogDate: new Date()
	        }, this.refs.dialogWindow.show);
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'getControlledDate',
	    value: function getControlledDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if (props.value instanceof Date) {
	        return props.value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          className = _props.className,
	          container = _props.container,
	          defaultDate = _props.defaultDate,
	          dialogContainerStyle = _props.dialogContainerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          formatDateProp = _props.formatDate,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onDismiss = _props.onDismiss,
	          onFocus = _props.onFocus,
	          onShow = _props.onShow,
	          onTouchTap = _props.onTouchTap,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onTouchTap', 'shouldDisableDate', 'hideCalendarDate', 'style', 'textFieldStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var formatDate = formatDateProp || this.formatDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          onFocus: this.handleFocus,
	          onTouchTap: this.handleTouchTap,
	          ref: 'input',
	          style: textFieldStyle,
	          value: this.state.date ? formatDate(this.state.date) : ''
	        })),
	        _react2.default.createElement(_DatePickerDialog2.default, {
	          DateTimeFormat: DateTimeFormat,
	          autoOk: autoOk,
	          cancelLabel: cancelLabel,
	          container: container,
	          containerStyle: dialogContainerStyle,
	          disableYearSelection: disableYearSelection,
	          firstDayOfWeek: firstDayOfWeek,
	          initialDate: this.state.dialogDate,
	          locale: locale,
	          maxDate: maxDate,
	          minDate: minDate,
	          mode: mode,
	          okLabel: okLabel,
	          onAccept: this.handleAccept,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          ref: 'dialogWindow',
	          shouldDisableDate: shouldDisableDate,
	          hideCalendarDate: hideCalendarDate
	        })
	      );
	    }
	  }]);
	  return DatePicker;
	}(_react.Component);
	
	DatePicker.defaultProps = {
	  autoOk: false,
	  container: 'dialog',
	  disabled: false,
	  disableYearSelection: false,
	  firstDayOfWeek: 1,
	  hideCalendarDate: false,
	  style: {}
	};
	DatePicker.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DatePicker.propTypes = {
	  /**
	   * Constructor for date formatting for the specified `locale`.
	   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
	   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
	   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
	   *
	   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
	   */
	  DateTimeFormat: _react.PropTypes.func,
	  /**
	   * If true, automatically accept and close the picker on select a date.
	   */
	  autoOk: _react.PropTypes.bool,
	  /**
	   * Override the default text of the 'Cancel' button.
	   */
	  cancelLabel: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Used to control how the Date Picker will be displayed when the input field is focused.
	   * `dialog` (default) displays the DatePicker as a dialog with a modal.
	   * `inline` displays the DatePicker below the input field (similar to auto complete).
	   */
	  container: _react.PropTypes.oneOf(['dialog', 'inline']),
	  /**
	   * This is the initial date value of the component.
	   * If either `value` or `valueLink` is provided they will override this
	   * prop with `value` taking precedence.
	   */
	  defaultDate: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of DatePickerDialog's Container element.
	   */
	  dialogContainerStyle: _react.PropTypes.object,
	  /**
	   * Disables the year selection in the date picker.
	   */
	  disableYearSelection: _react.PropTypes.bool,
	  /**
	   * Disables the DatePicker.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Used to change the first day of week. It varies from
	   * Saturday to Monday between different locales.
	   * The allowed range is 0 (Sunday) to 6 (Saturday).
	   * The default is `1`, Monday, as per ISO 8601.
	   */
	  firstDayOfWeek: _react.PropTypes.number,
	  /**
	   * This function is called to format the date displayed in the input field, and should return a string.
	   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
	   *
	   * @param {object} date Date object to be formatted.
	   * @returns {any} The formatted date.
	   */
	  formatDate: _react.PropTypes.func,
	  /**
	   * Hide date display
	   */
	  hideCalendarDate: _react.PropTypes.bool,
	  /**
	   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
	   * must provide a `DateTimeFormat` that supports the chosen `locale`.
	   */
	  locale: _react.PropTypes.string,
	  /**
	   * The ending of a range of valid dates. The range includes the endDate.
	   * The default value is current date + 100 years.
	   */
	  maxDate: _react.PropTypes.object,
	  /**
	   * The beginning of a range of valid dates. The range includes the startDate.
	   * The default value is current date - 100 years.
	   */
	  minDate: _react.PropTypes.object,
	  /**
	   * Tells the component to display the picker in portrait or landscape mode.
	   */
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  /**
	   * Override the default text of the 'OK' button.
	   */
	  okLabel: _react.PropTypes.node,
	  /**
	   * Callback function that is fired when the date value changes.
	   *
	   * @param {null} null Since there is no particular event associated with the change,
	   * the first argument will always be null.
	   * @param {object} date The new date.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is dismissed.
	   */
	  onDismiss: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's `TextField` gains focus.
	   */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is shown.
	   */
	  onShow: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when a touch tap event occurs on the Date Picker's `TextField`.
	   *
	   * @param {object} event TouchTap event targeting the `TextField`.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function used to determine if a day's entry should be disabled on the calendar.
	   *
	   * @param {object} day Date object of a day.
	   * @returns {boolean} Indicates whether the day should be disabled.
	   */
	  shouldDisableDate: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of DatePicker's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * Sets the date for the Date Picker programmatically.
	   */
	  value: _react.PropTypes.object
	} : void 0;
	exports.default = DatePicker;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Calendar = __webpack_require__(1707);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Dialog = __webpack_require__(380);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(274);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _dateUtils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerDialog = function (_Component) {
	  (0, _inherits3.default)(DatePickerDialog, _Component);
	
	  function DatePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.show = function () {
	      if (_this.props.onShow && !_this.state.open) {
	        _this.props.onShow();
	      }
	
	      _this.setState({
	        open: true
	      });
	    }, _this.dismiss = function () {
	      if (_this.props.onDismiss && _this.state.open) {
	        _this.props.onDismiss();
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleTouchTapDay = function () {
	      if (_this.props.autoOk) {
	        setTimeout(_this.handleTouchTapOk, 300);
	      }
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOk = function () {
	      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
	        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleWindowKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOk();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePickerDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          container = _props.container,
	          containerStyle = _props.containerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          initialDate = _props.initialDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onAccept = _props.onAccept,
	          onDismiss = _props.onDismiss,
	          onShow = _props.onShow,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          animation = _props.animation,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'shouldDisableDate', 'hideCalendarDate', 'style', 'animation']);
	      var open = this.state.open;
	
	
	      var styles = {
	        dialogContent: {
	          width: !hideCalendarDate && mode === 'landscape' ? 479 : 310
	        },
	        dialogBodyContent: {
	          padding: 0,
	          minHeight: hideCalendarDate || mode === 'landscape' ? 330 : 434,
	          minWidth: hideCalendarDate || mode !== 'landscape' ? 310 : 479
	        }
	      };
	
	      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'root' }),
	        _react2.default.createElement(
	          Container,
	          {
	            anchorEl: this.refs.root // For Popover
	            , animation: animation || _PopoverAnimationVertical2.default // For Popover
	            , bodyStyle: styles.dialogBodyContent,
	            contentStyle: styles.dialogContent,
	            ref: 'dialog',
	            repositionOnUpdate: true,
	            open: open,
	            onRequestClose: this.handleRequestClose,
	            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
	          },
	          _react2.default.createElement(_reactEventListener2.default, {
	            target: 'window',
	            onKeyUp: this.handleWindowKeyUp
	          }),
	          _react2.default.createElement(_Calendar2.default, {
	            autoOk: autoOk,
	            DateTimeFormat: DateTimeFormat,
	            cancelLabel: cancelLabel,
	            disableYearSelection: disableYearSelection,
	            firstDayOfWeek: firstDayOfWeek,
	            initialDate: initialDate,
	            locale: locale,
	            onTouchTapDay: this.handleTouchTapDay,
	            maxDate: maxDate,
	            minDate: minDate,
	            mode: mode,
	            open: open,
	            ref: 'calendar',
	            onTouchTapCancel: this.handleTouchTapCancel,
	            onTouchTapOk: this.handleTouchTapOk,
	            okLabel: okLabel,
	            shouldDisableDate: shouldDisableDate,
	            hideCalendarDate: hideCalendarDate
	          })
	        )
	      );
	    }
	  }]);
	  return DatePickerDialog;
	}(_react.Component);
	
	DatePickerDialog.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  cancelLabel: 'Cancel',
	  container: 'dialog',
	  locale: 'en-US',
	  okLabel: 'OK'
	};
	DatePickerDialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DatePickerDialog.propTypes = {
	  DateTimeFormat: _react.PropTypes.func,
	  animation: _react.PropTypes.func,
	  autoOk: _react.PropTypes.bool,
	  cancelLabel: _react.PropTypes.node,
	  container: _react.PropTypes.oneOf(['dialog', 'inline']),
	  containerStyle: _react.PropTypes.object,
	  disableYearSelection: _react.PropTypes.bool,
	  firstDayOfWeek: _react.PropTypes.number,
	  hideCalendarDate: _react.PropTypes.bool,
	  initialDate: _react.PropTypes.object,
	  locale: _react.PropTypes.string,
	  maxDate: _react.PropTypes.object,
	  minDate: _react.PropTypes.object,
	  mode: _react.PropTypes.oneOf(['portrait', 'landscape']),
	  okLabel: _react.PropTypes.node,
	  onAccept: _react.PropTypes.func,
	  onDismiss: _react.PropTypes.func,
	  onShow: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  shouldDisableDate: _react.PropTypes.func,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = DatePickerDialog;

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateUtils = __webpack_require__(186);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var date = props.date,
	      disabled = props.disabled,
	      selected = props.selected;
	  var hover = state.hover;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	
	
	  var labelColor = baseTheme.palette.textColor;
	  var buttonStateOpacity = 0;
	  var buttonStateTransform = 'scale(0)';
	
	  if (hover || selected) {
	    labelColor = datePicker.selectTextColor;
	    buttonStateOpacity = selected ? 1 : 0.6;
	    buttonStateTransform = 'scale(1)';
	  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
	    labelColor = datePicker.color;
	  }
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      fontWeight: '400',
	      opacity: disabled && '0.4',
	      padding: '4px 0px',
	      position: 'relative',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      width: 42
	    },
	    label: {
	      color: labelColor,
	      fontWeight: '400',
	      position: 'relative'
	    },
	    buttonState: {
	      backgroundColor: datePicker.selectColor,
	      borderRadius: '50%',
	      height: 34,
	      left: 4,
	      opacity: buttonStateOpacity,
	      position: 'absolute',
	      top: 0,
	      transform: buttonStateTransform,
	      transition: _transitions2.default.easeOut(),
	      width: 34
	    }
	  };
	}
	
	var DayButton = function (_Component) {
	  (0, _inherits3.default)(DayButton, _Component);
	
	  function DayButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DayButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this.handleMouseLeave = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (!_this.props.disabled && _this.props.onTouchTap) {
	        _this.props.onTouchTap(event, _this.props.date);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          date = _props.date,
	          disabled = _props.disabled,
	          locale = _props.locale,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onTouchTap', 'selected']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return date ? _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          new DateTimeFormat(locale, {
	            day: 'numeric'
	          }).format(date)
	        )
	      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
	    }
	  }]);
	  return DayButton;
	}(_react.Component);
	
	DayButton.defaultProps = {
	  selected: false,
	  disabled: false
	};
	DayButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DayButton.propTypes = {
	  DateTimeFormat: _react.PropTypes.func.isRequired,
	  date: _react.PropTypes.object,
	  disabled: _react.PropTypes.bool,
	  locale: _react.PropTypes.string.isRequired,
	  onKeyboardFocus: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  selected: _react.PropTypes.bool
	} : void 0;
	exports.default = DayButton;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var selected = props.selected,
	      year = props.year;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	  var hover = state.hover;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      color: year === new Date().getFullYear() && datePicker.color,
	      display: 'block',
	      fontSize: 14,
	      margin: '0 auto',
	      position: 'relative',
	      textAlign: 'center',
	      lineHeight: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    label: {
	      alignSelf: 'center',
	      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
	      fontSize: selected ? 26 : 17,
	      fontWeight: hover ? 450 : selected ? 500 : 400,
	      position: 'relative',
	      top: -1
	    }
	  };
	}
	
	var YearButton = function (_Component) {
	  (0, _inherits3.default)(YearButton, _Component);
	
	  function YearButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, YearButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event, _this.props.year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(YearButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          year = _props.year,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onTouchTap', 'selected', 'year']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          children
	        )
	      );
	    }
	  }]);
	  return YearButton;
	}(_react.Component);
	
	YearButton.defaultProps = {
	  selected: false
	};
	YearButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? YearButton.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  onTouchTap: _react.PropTypes.func,
	  selected: _react.PropTypes.bool,
	  year: _react.PropTypes.number.isRequired
	} : void 0;
	exports.default = YearButton;

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DatePicker = __webpack_require__(1713);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DatePicker2.default;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(613);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(614);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactAddonsTransitionGroup = __webpack_require__(223);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransitionItem = function (_Component) {
	  (0, _inherits3.default)(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TransitionItem.propTypes = {
	  children: _react.PropTypes.node,
	  style: _react.PropTypes.object
	} : void 0;
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent,
	      open = props.open;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      spacing = _context$muiTheme$bas.spacing,
	      palette = _context$muiTheme$bas.palette,
	      dialog = _context$muiTheme.dialog,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0,
	      borderTop: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0,
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  (0, _inherits3.default)(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
	          autoScrollBodyContent = _props2.autoScrollBodyContent,
	          bodyStyle = _props2.bodyStyle,
	          open = _props2.open,
	          repositionOnUpdate = _props2.repositionOnUpdate,
	          title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionsContainerClassName = _props3.actionsContainerClassName,
	          actionsContainerStyle = _props3.actionsContainerStyle,
	          bodyClassName = _props3.bodyClassName,
	          bodyStyle = _props3.bodyStyle,
	          children = _props3.children,
	          className = _props3.className,
	          contentClassName = _props3.contentClassName,
	          contentStyle = _props3.contentStyle,
	          overlayClassName = _props3.overlayClassName,
	          overlayStyle = _props3.overlayStyle,
	          open = _props3.open,
	          titleClassName = _props3.titleClassName,
	          titleStyle = _props3.titleStyle,
	          title = _props3.title,
	          style = _props3.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { zDepth: 4 },
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onTouchTap: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DialogInline.propTypes = {
	  actions: _react.PropTypes.node,
	  actionsContainerClassName: _react.PropTypes.string,
	  actionsContainerStyle: _react.PropTypes.object,
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  autoScrollBodyContent: _react.PropTypes.bool,
	  bodyClassName: _react.PropTypes.string,
	  bodyStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  contentClassName: _react.PropTypes.string,
	  contentStyle: _react.PropTypes.object,
	  modal: _react.PropTypes.bool,
	  onRequestClose: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  overlayClassName: _react.PropTypes.string,
	  overlayStyle: _react.PropTypes.object,
	  repositionOnUpdate: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  title: _react.PropTypes.node,
	  titleClassName: _react.PropTypes.string,
	  titleStyle: _react.PropTypes.object
	} : void 0;
	
	var Dialog = function (_Component3) {
	  (0, _inherits3.default)(Dialog, _Component3);
	
	  function Dialog() {
	    var _ref3;
	
	    var _temp3, _this3, _ret3;
	
	    (0, _classCallCheck3.default)(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	  return Dialog;
	}(_react.Component);
	
	Dialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	 false ? Dialog.propTypes = {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _react.PropTypes.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _react.PropTypes.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _react.PropTypes.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _react.PropTypes.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _react.PropTypes.object
	} : void 0;
	exports.default = Dialog;

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	
	 false ? Divider.propTypes = {
	  /**
	   * If true, the `Divider` will be indented.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	Divider.defaultProps = {
	  inset: false
	};
	
	Divider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = Divider;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _autoPrefix = __webpack_require__(162);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(613);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openNavEventHandler = null;
	
	var Drawer = function (_Component) {
	  (0, _inherits3.default)(Drawer, _Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapOverlay = function (event) {
	      event.preventDefault();
	      _this.close('clickaway');
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
	        _this.close('escape');
	      }
	    }, _this.onBodyTouchStart = function (event) {
	      var swipeAreaWidth = _this.props.swipeAreaWidth;
	
	      var touchStartX = event.touches[0].pageX;
	      var touchStartY = event.touches[0].pageY;
	
	      // Open only if swiping from far left (or right) while closed
	      if (swipeAreaWidth !== null && !_this.state.open) {
	        if (_this.props.openSecondary) {
	          // If openSecondary is true calculate from the far right
	          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	        } else {
	          // If openSecondary is false calculate from the far left
	          if (touchStartX > swipeAreaWidth) return;
	        }
	      }
	
	      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
	        return;
	      }
	
	      _this.maybeSwiping = true;
	      _this.touchStartX = touchStartX;
	      _this.touchStartY = touchStartY;
	
	      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _this.onBodyTouchMove = function (event) {
	      var currentX = event.touches[0].pageX;
	      var currentY = event.touches[0].pageY;
	
	      if (_this.state.swiping) {
	        event.preventDefault();
	        _this.setPosition(_this.getTranslateX(currentX));
	      } else if (_this.maybeSwiping) {
	        var dXAbs = Math.abs(currentX - _this.touchStartX);
	        var dYAbs = Math.abs(currentY - _this.touchStartY);
	        // If the user has moved his thumb ten pixels in either direction,
	        // we can safely make an assumption about whether he was intending
	        // to swipe or scroll.
	        var threshold = 10;
	
	        if (dXAbs > threshold && dYAbs <= threshold) {
	          _this.swipeStartX = currentX;
	          _this.setState({
	            swiping: _this.state.open ? 'closing' : 'opening'
	          });
	          _this.setPosition(_this.getTranslateX(currentX));
	        } else if (dXAbs <= threshold && dYAbs > threshold) {
	          _this.onBodyTouchEnd();
	        }
	      }
	    }, _this.onBodyTouchEnd = function (event) {
	      if (_this.state.swiping) {
	        var currentX = event.changedTouches[0].pageX;
	        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();
	
	        _this.maybeSwiping = false;
	        var swiping = _this.state.swiping;
	        _this.setState({
	          swiping: null
	        });
	
	        // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	        if (translateRatio > 0.5) {
	          if (swiping === 'opening') {
	            _this.setPosition(_this.getMaxTranslateX());
	          } else {
	            _this.close('swipe');
	          }
	        } else {
	          if (swiping === 'opening') {
	            _this.open('swipe');
	          } else {
	            _this.setPosition(0);
	          }
	        }
	      } else {
	        _this.maybeSwiping = false;
	      }
	
	      document.body.removeEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.removeEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maybeSwiping = false;
	      this.touchStartX = null;
	      this.touchStartY = null;
	      this.swipeStartX = null;
	
	      this.setState({
	        open: this.props.open !== null ? this.props.open : this.props.docked,
	        swiping: null
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If controlled then the open prop takes precedence.
	      if (nextProps.open !== null) {
	        this.setState({
	          open: nextProps.open
	        });
	        // Otherwise, if docked is changed, change the open state for when uncontrolled.
	      } else if (this.props.docked !== nextProps.docked) {
	        this.setState({
	          open: nextProps.docked
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disableSwipeHandling();
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var muiTheme = this.context.muiTheme;
	      var theme = muiTheme.drawer;
	
	      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());
	
	      var styles = {
	        root: {
	          height: '100%',
	          width: this.props.width || theme.width,
	          position: 'fixed',
	          zIndex: muiTheme.zIndex.drawer,
	          left: 0,
	          top: 0,
	          transform: 'translate(' + x + 'px, 0)',
	          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	          backgroundColor: theme.color,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch' },
	        overlay: {
	          zIndex: muiTheme.zIndex.drawerOverlay,
	          pointerEvents: this.state.open ? 'auto' : 'none' },
	        rootWhenOpenRight: {
	          left: 'auto',
	          right: 0
	        }
	      };
	
	      return styles;
	    }
	  }, {
	    key: 'shouldShow',
	    value: function shouldShow() {
	      return this.state.open || !!this.state.swiping; // component is swiping
	    }
	  }, {
	    key: 'close',
	    value: function close(reason) {
	      if (this.props.open === null) this.setState({ open: false });
	      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	      return this;
	    }
	  }, {
	    key: 'open',
	    value: function open(reason) {
	      if (this.props.open === null) this.setState({ open: true });
	      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	      return this;
	    }
	  }, {
	    key: 'getMaxTranslateX',
	    value: function getMaxTranslateX() {
	      var width = this.props.width || this.context.muiTheme.drawer.width;
	      return width + 10;
	    }
	  }, {
	    key: 'getTranslateMultiplier',
	    value: function getTranslateMultiplier() {
	      return this.props.openSecondary ? 1 : -1;
	    }
	  }, {
	    key: 'enableSwipeHandling',
	    value: function enableSwipeHandling() {
	      if (!this.props.docked) {
	        document.body.addEventListener('touchstart', this.onBodyTouchStart);
	        if (!openNavEventHandler) {
	          openNavEventHandler = this.onBodyTouchStart;
	        }
	      } else {
	        this.disableSwipeHandling();
	      }
	    }
	  }, {
	    key: 'disableSwipeHandling',
	    value: function disableSwipeHandling() {
	      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
	      if (openNavEventHandler === this.onBodyTouchStart) {
	        openNavEventHandler = null;
	      }
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(translateX) {
	      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	      var transformCSS = 'translate(' + this.getTranslateMultiplier() * translateX + 'px, 0)';
	      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
	      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
	    }
	  }, {
	    key: 'getTranslateX',
	    value: function getTranslateX(currentX) {
	      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          containerClassName = _props.containerClassName,
	          containerStyle = _props.containerStyle,
	          docked = _props.docked,
	          openSecondary = _props.openSecondary,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = this.getStyles();
	
	      var overlay = void 0;
	      if (!docked) {
	        overlay = _react2.default.createElement(_Overlay2.default, {
	          ref: 'overlay',
	          show: this.shouldShow(),
	          className: overlayClassName,
	          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
	          transitionEnabled: !this.state.swiping,
	          onTouchTap: this.handleTouchTapOverlay
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: style
	        },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        overlay,
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            ref: 'clickAwayableElement',
	            zDepth: zDepth,
	            rounded: false,
	            transitionEnabled: !this.state.swiping,
	            className: containerClassName,
	            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return Drawer;
	}(_react.Component);
	
	Drawer.defaultProps = {
	  disableSwipeToOpen: false,
	  docked: true,
	  open: null,
	  openSecondary: false,
	  swipeAreaWidth: 30,
	  width: null,
	  zDepth: 2
	};
	Drawer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Drawer.propTypes = {
	  /**
	   * The contents of the `Drawer`
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The CSS class name of the container element.
	   */
	  containerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If true, swiping sideways when the `Drawer` is closed will not open it.
	   */
	  disableSwipeToOpen: _react.PropTypes.bool,
	  /**
	   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
	   * clicking on a menu item will not close the `Drawer`.
	   */
	  docked: _react.PropTypes.bool,
	  /**
	   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
	   *
	   * @param {boolean} open If true, the `Drawer` was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
	   * 'escape' (on escape key press), and 'swipe' for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
	   * into a controlled component.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * If true, the `Drawer` is positioned to open from the opposite side.
	   */
	  openSecondary: _react.PropTypes.bool,
	  /**
	   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The width of the left most (or right most) area in pixels where the `Drawer` can be
	   * swiped open from. Setting this to `null` spans that area to the entire page
	   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	   * swipeable `Tabs`: use at your own risk).
	   */
	  swipeAreaWidth: _react.PropTypes.number,
	  /**
	   * The width of the `Drawer` in pixels. Defaults to using the values from theme.
	   */
	  width: _react.PropTypes.number,
	  /**
	   * The zDepth of the `Drawer`.
	   */
	  zDepth: _propTypes2.default.zDepth
	
	} : void 0;
	exports.default = Drawer;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(395);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(187);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(612);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(274);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(278);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(60);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var anchorOrigin = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      height: spacing.desktopToolbarHeight + 'px',
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      if (_this.props.multiple) {
	        if (!_this.state.open) {
	          _this.setState({ open: true });
	        }
	      } else {
	        event.persist();
	        _this.setState({
	          open: false
	        }, function () {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, index, child.props.value);
	          }
	
	          _this.close(_events2.default.isKeyboard(event));
	        });
	      }
	    }, _this.handleChange = function (event, value) {
	      if (_this.props.multiple && _this.props.onChange) {
	        _this.props.onChange(event, undefined, value);
	      }
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          selectionRenderer = _props.selectionRenderer,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          iconButton = _props.iconButton,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      if (!multiple) {
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value === child.props.value) {
	            if (selectionRenderer) {
	              displayValue = selectionRenderer(value);
	            } else {
	              // This will need to be improved (in case primaryText is a node)
	              displayValue = child.props.label || child.props.primaryText;
	            }
	          }
	        });
	      } else {
	        (function () {
	          var values = [];
	          _react2.default.Children.forEach(children, function (child) {
	            if (child && value && value.includes(child.props.value)) {
	              if (selectionRenderer) {
	                values.push(child.props.value);
	              } else {
	                values.push(child.props.label || child.props.primaryText);
	              }
	            }
	          });
	
	          displayValue = [];
	          if (selectionRenderer) {
	            displayValue = selectionRenderer(values);
	          } else {
	            displayValue = values.join(', ');
	          }
	        })();
	      }
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onTouchTap: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              disabled: disabled,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            iconButton
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              multiple: multiple,
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              onChange: this.handleChange,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
	  openImmediately: false,
	  maxHeight: 500,
	  multiple: false
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? DropDownMenu.propTypes = {
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides default `SvgIcon` dropdown arrow component.
	   */
	  iconButton: _react.PropTypes.node,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _react.PropTypes.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  selectionRenderer: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = DropDownMenu;

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(188);
	
	var _colorManipulator = __webpack_require__(117);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(593);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          children = _props.children,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          hoverColor = _props.hoverColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          borderRadius = _context$muiTheme.borderRadius,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: fullWidth ? '100%' : buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: borderRadius,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FlatButton.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The element to use as the container for the FlatButton. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * FlatButton in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _react2.default.PropTypes.bool,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _react.PropTypes.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FlatButton;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(117);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(382);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(188);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block',
	      backgroundColor: 'transparent'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  (0, _inherits3.default)(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth
	      });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextState = {};
	
	      if (nextProps.disabled !== this.props.disabled) {
	        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
	      }
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          className = _props.className,
	          childrenProp = _props.children,
	          disabled = _props.disabled,
	          disabledColor = _props.disabledColor,
	          mini = _props.mini,
	          secondary = _props.secondary,
	          iconStyle = _props.iconStyle,
	          iconClassName = _props.iconClassName,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'disabledColor', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = void 0;
	
	      if (childrenProp) {
	        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
	          return {
	            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
	          };
	        });
	      }
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FloatingActionButton.propTypes = {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = FloatingActionButton;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(1723);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? FontIcon.propTypes = {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = FontIcon;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    root: {
	      display: 'flex',
	      flexWrap: 'wrap',
	      margin: -props.padding / 2
	    },
	    item: {
	      boxSizing: 'border-box',
	      padding: props.padding / 2
	    }
	  };
	}
	
	var GridList = function (_Component) {
	  (0, _inherits3.default)(GridList, _Component);
	
	  function GridList() {
	    (0, _classCallCheck3.default)(this, GridList);
	    return (0, _possibleConstructorReturn3.default)(this, (GridList.__proto__ || (0, _getPrototypeOf2.default)(GridList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          padding = _props.padding,
	          cellHeight = _props.cellHeight,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
	          return currentChild;
	        }
	        var childCols = currentChild.props.cols || 1;
	        var childRows = currentChild.props.rows || 1;
	        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
	          width: 100 / cols * childCols + '%',
	          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + padding
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { style: prepareStyles(itemStyle) },
	          currentChild
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles(mergedRootStyles) }, other),
	        wrappedChildren
	      );
	    }
	  }]);
	  return GridList;
	}(_react.Component);
	
	GridList.defaultProps = {
	  cols: 2,
	  padding: 4,
	  cellHeight: 180
	};
	GridList.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Number of columns.
	   */
	  cols: _react.PropTypes.number,
	  /**
	   * Number of px for the padding/spacing between items.
	   */
	  padding: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = GridList;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridTile = exports.GridList = undefined;
	
	var _GridList2 = __webpack_require__(1726);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(594);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.default = _GridList3.default;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(382);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(615);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'not-allowed'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? IconButton.propTypes = {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _react.PropTypes.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _react.PropTypes.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseOut: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _react.PropTypes.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes2.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _react.PropTypes.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _react.PropTypes.bool
	} : void 0;
	exports.default = IconButton;

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(278);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Menu = __webpack_require__(187);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(134);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function (_Component) {
	  (0, _inherits3.default)(IconMenu, _Component);
	
	  function IconMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemTouchTap = function (event, child) {
	      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        (function () {
	          var isKeyboard = _events2.default.isKeyboard(event);
	          _this.timerCloseId = setTimeout(function () {
	            _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	          }, _this.props.touchTapCloseDelay);
	        })();
	      }
	
	      _this.props.onItemTouchTap(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      } else {
	        this.setState({ open: false }, function () {
	          // Set focus on the icon button when the menu close
	          if (isKeyboard) {
	            var iconButton = _this2.refs.iconButton;
	            _reactDom2.default.findDOMNode(iconButton).focus();
	            iconButton.setKeyboardFocus();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	
	      event.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          className = _props.className,
	          animated = _props.animated,
	          animation = _props.animation,
	          iconButtonElement = _props.iconButtonElement,
	          iconStyle = _props.iconStyle,
	          onItemTouchTap = _props.onItemTouchTap,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseUp = _props.onMouseUp,
	          onRequestChange = _props.onRequestChange,
	          onTouchTap = _props.onTouchTap,
	          listStyle = _props.listStyle,
	          menuStyle = _props.menuStyle,
	          style = _props.style,
	          targetOrigin = _props.targetOrigin,
	          touchTapCloseDelay = _props.touchTapCloseDelay,
	          useLayerForClickAway = _props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onTouchTap', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;
	
	      var iconButtonProps = {
	        onKeyboardFocus: onKeyboardFocus,
	        onTouchTap: function onTouchTap(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onTouchTap) {
	            iconButtonElement.props.onTouchTap(event);
	          }
	        },
	        ref: 'iconButton'
	      };
	      if (iconStyle || iconButtonElement.props.iconStyle) {
	        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
	      }
	      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemTouchTap: this.handleItemTouchTap,
	          style: mergedMenuStyles,
	          listStyle: listStyle
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onTouchTap: onTouchTap,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onTouchTap: function onTouchTap() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  touchTapCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? IconMenu.propTypes = {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _react.PropTypes.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item is selected with a touch-tap.
	   *
	   * @param {object} event TouchTap event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the `IconButton` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the `IconButton` element.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  touchTapCloseDelay: _react.PropTypes.number,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _react.PropTypes.bool
	} : void 0;
	exports.default = IconMenu;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(1729);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(384);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      value = props.value;
	  var _context$muiTheme = context.muiTheme,
	      palette = _context$muiTheme.baseTheme.palette,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      height: 4,
	      display: 'block',
	      width: '100%',
	      backgroundColor: palette.primary3Color,
	      borderRadius: borderRadius,
	      margin: 0,
	      overflow: 'hidden'
	    },
	    bar: {
	      height: '100%'
	    },
	    barFragment1: {},
	    barFragment2: {}
	  };
	
	  if (props.mode === 'indeterminate') {
	    styles.barFragment1 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	    };
	
	    styles.barFragment2 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	    };
	  } else {
	    styles.bar.backgroundColor = props.color || palette.primary1Color;
	    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	    styles.bar.width = getRelativeValue(value, min, max) + '%';
	  }
	
	  return styles;
	}
	
	var LinearProgress = function (_Component) {
	  (0, _inherits3.default)(LinearProgress, _Component);
	
	  function LinearProgress() {
	    (0, _classCallCheck3.default)(this, LinearProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LinearProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timers = {};
	
	      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);
	
	      this.timers.bar2 = setTimeout(function () {
	        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]], 0);
	      }, 850);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timers.bar1);
	      clearTimeout(this.timers.bar2);
	    }
	  }, {
	    key: 'barUpdate',
	    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      timeToNextStep = timeToNextStep || 420;
	      step = step || 0;
	      step %= 4;
	
	      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
	      var left = this.context.muiTheme.isRtl ? 'right' : 'left';
	
	      if (step === 0) {
	        barElement.style[left] = stepValues[0][0] + '%';
	        barElement.style[right] = stepValues[0][1] + '%';
	      } else if (step === 1) {
	        barElement.style.transitionDuration = '840ms';
	      } else if (step === 2) {
	        barElement.style[left] = stepValues[1][0] + '%';
	        barElement.style[right] = stepValues[1][1] + '%';
	      } else if (step === 3) {
	        barElement.style.transitionDuration = '0ms';
	      }
	      this.timers[id] = setTimeout(function () {
	        return _this3.barUpdate(id, step + 1, barElement, stepValues);
	      }, timeToNextStep);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.bar) },
	          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
	          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
	        )
	      );
	    }
	  }]);
	  return LinearProgress;
	}(_react.Component);
	
	LinearProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100
	};
	LinearProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? LinearProgress.propTypes = {
	  /**
	   * The color of the progress bar, defaults to
	   * primary color of theme.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate for when
	   * there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	} : void 0;
	exports.default = LinearProgress;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(383);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	 false ? NestedList.propTypes = {
	  children: _react.PropTypes.node,
	  nestedLevel: _react.PropTypes.number.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = NestedList;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(383);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(273);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(596);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.default = _List3.default;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Paper.propTypes = {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Set to true to generate a circlular paper container.
	   */
	  circle: _react.PropTypes.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _react.PropTypes.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = Paper;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(90);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? PopoverAnimationDefault.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin.isRequired,
	  zDepth: _propTypes2.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationDefault;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(134);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(274);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;
	
	var _RadioButton2 = __webpack_require__(598);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(599);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.default = _RadioButton3.default;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(117);
	
	var _childUtils = __webpack_require__(188);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton,
	      borderRadius = _context$muiTheme.borderRadius;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	      });
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RaisedButton.propTypes = {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _react.PropTypes.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	    * The element to use as the container for the RaisedButton. Either a string to
	    * use a DOM element or a ReactElement. This is useful for wrapping the
	    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
	    * that it passes all of its given props through to the underlying DOM
	    * element and renders its children prop for proper integration.
	    */
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _react2.default.PropTypes.bool,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _react.PropTypes.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _react.PropTypes.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = RaisedButton;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _slicedToArray2 = __webpack_require__(240);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(162);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWBOX_SIZE = 32;
	
	function getStyles(props) {
	  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
	  return {
	    root: {
	      position: 'absolute',
	      zIndex: 2,
	      width: props.size,
	      height: props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
	      opacity: props.status === 'hide' ? 0 : 1,
	      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    }
	  };
	}
	
	var RefreshIndicator = function (_Component) {
	  (0, _inherits3.default)(RefreshIndicator, _Component);
	
	  function RefreshIndicator() {
	    (0, _classCallCheck3.default)(this, RefreshIndicator);
	    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RefreshIndicator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var paperSize = this.getPaperSize();
	
	      var childrenCmp = null;
	      if (this.props.status !== 'ready') {
	        var circleStyle = this.getCircleStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'div',
	          {
	            ref: 'wrapper',
	            style: prepareStyles({
	              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	              width: '100%',
	              height: '100%'
	            })
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              style: {
	                width: paperSize,
	                height: paperSize
	              },
	              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	            },
	            _react2.default.createElement('circle', (0, _extends3.default)({
	              ref: 'path',
	              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
	                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	              }))
	            }, circleStyle.attr))
	          )
	        );
	      } else {
	        var _circleStyle = this.getCircleStyle(paperSize);
	        var polygonStyle = this.getPolygonStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'svg',
	          {
	            style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', (0, _extends3.default)({
	            style: prepareStyles(_circleStyle.style)
	          }, _circleStyle.attr)),
	          _react2.default.createElement('polygon', (0, _extends3.default)({
	            style: prepareStyles(polygonStyle.style)
	          }, polygonStyle.attr))
	        );
	      }
	
	      return childrenCmp;
	    }
	  }, {
	    key: 'getTheme',
	    value: function getTheme() {
	      return this.context.muiTheme.refreshIndicator;
	    }
	  }, {
	    key: 'getPaddingSize',
	    value: function getPaddingSize() {
	      var padding = this.props.size * 0.1;
	      return padding;
	    }
	  }, {
	    key: 'getPaperSize',
	    value: function getPaperSize() {
	      return this.props.size - this.getPaddingSize() * 2;
	    }
	  }, {
	    key: 'getCircleAttr',
	    value: function getCircleAttr() {
	      return {
	        radiu: VIEWBOX_SIZE / 2 - 5,
	        originX: VIEWBOX_SIZE / 2,
	        originY: VIEWBOX_SIZE / 2,
	        strokeWidth: 3
	      };
	    }
	  }, {
	    key: 'getArcDeg',
	    value: function getArcDeg() {
	      var p = this.props.percentage / 100;
	
	      var beginDeg = p * 120;
	      var endDeg = p * 410;
	      return [beginDeg, endDeg];
	    }
	  }, {
	    key: 'getFactor',
	    value: function getFactor() {
	      var p = this.props.percentage / 100;
	      var p1 = Math.min(1, p / 0.4);
	
	      return p1;
	    }
	  }, {
	    key: 'getCircleStyle',
	    value: function getCircleStyle() {
	      var isLoading = this.props.status === 'loading';
	      var p1 = isLoading ? 1 : this.getFactor();
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	
	      var _getArcDeg = this.getArcDeg(),
	          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
	          beginDeg = _getArcDeg2[0],
	          endDeg = _getArcDeg2[1];
	
	      var arcLen = (endDeg - beginDeg) * perimeter / 360;
	      var dashOffset = -beginDeg * perimeter / 360;
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	          strokeDashoffset: dashOffset,
	          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          strokeLinecap: 'round',
	          opacity: p1,
	          strokeWidth: circle.strokeWidth * p1,
	          fill: 'none'
	        },
	        attr: {
	          cx: circle.originX,
	          cy: circle.originY,
	          r: circle.radiu
	        }
	      };
	    }
	  }, {
	    key: 'getPolygonStyle',
	    value: function getPolygonStyle() {
	      var p1 = this.getFactor();
	      var circle = this.getCircleAttr();
	
	      var triangleCx = circle.originX + circle.radiu;
	      var triangleCy = circle.originY;
	      var dx = circle.strokeWidth * 7 / 4 * p1;
	      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	      var _getArcDeg3 = this.getArcDeg(),
	          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
	          endDeg = _getArcDeg4[1];
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          transform: 'rotate(' + endDeg + 'deg)',
	          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	          opacity: p1
	        },
	        attr: {
	          points: trianglePath
	        }
	      };
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      var currStep = (step || 0) % 3;
	
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	      var arcLen = perimeter * 0.64;
	
	      var strokeDasharray = void 0;
	      var strokeDashoffset = void 0;
	      var transitionDuration = void 0;
	
	      if (currStep === 0) {
	        strokeDasharray = '1, 200';
	        strokeDashoffset = 0;
	        transitionDuration = '0ms';
	      } else if (currStep === 1) {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -15;
	        transitionDuration = '750ms';
	      } else {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -(perimeter - 1);
	        transitionDuration = '850ms';
	      }
	
	      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
	      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
	      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, currStep + 1);
	      }, currStep ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', null);
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      this.rotateWrapperSecondTimer = setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          top = _props.top,
	          left = _props.left,
	          percentage = _props.percentage,
	          status = _props.status,
	          loadingColor = _props.loadingColor,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          circle: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }, other),
	        this.renderChildren()
	      );
	    }
	  }]);
	  return RefreshIndicator;
	}(_react.Component);
	
	RefreshIndicator.defaultProps = {
	  percentage: 0,
	  size: 40,
	  status: 'hide'
	};
	RefreshIndicator.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? RefreshIndicator.propTypes = {
	  /**
	   * Override the theme's color of the indicator while it's status is
	   * "ready" and it's percentage is less than 100.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * The absolute left position of the indicator in pixels.
	   */
	  left: _react.PropTypes.number.isRequired,
	  /**
	   * Override the theme's color of the indicator while
	   * it's status is "loading" or when it's percentage is 100.
	   */
	  loadingColor: _react.PropTypes.string,
	  /**
	   * The confirmation progress to fetch data. Max value is 100.
	   */
	  percentage: _react.PropTypes.number,
	  /**
	   * Size in pixels.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * The display status of the indicator. If the status is
	   * "ready", the indicator will display the ready state
	   * arrow. If the status is "loading", it will display
	   * the loading progress indicator. If the status is "hide",
	   * the indicator will be hidden.
	   */
	  status: _react.PropTypes.oneOf(['ready', 'loading', 'hide']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The absolute top position of the indicator in pixels.
	   */
	  top: _react.PropTypes.number.isRequired
	} : void 0;
	exports.default = RefreshIndicator;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RefreshIndicator = __webpack_require__(1740);
	
	var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RefreshIndicator2.default;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(381);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          selectionRenderer = _props.selectionRenderer,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          {
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight,
	            multiple: multiple,
	            selectionRenderer: selectionRenderer
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false,
	  multiple: false
	};
	SelectField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SelectField.propTypes = {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _react.PropTypes.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _react.PropTypes.bool,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item, or undefined
	   * if `multiple` is true.
	   * @param {any} payload If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Customize the rendering of the selected item.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  selectionRenderer: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = SelectField;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(1742);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(489);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(390);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _deprecatedPropType = __webpack_require__(2743);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	function getPercent(value, min, max) {
	  var percent = (value - min) / (max - min);
	  if (isNaN(percent)) {
	    percent = 0;
	  }
	
	  return percent;
	}
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var axis = props.axis,
	      disabled = props.disabled,
	      max = props.max,
	      min = props.min;
	  var _context$muiTheme$sli = context.muiTheme.slider,
	      handleColorZero = _context$muiTheme$sli.handleColorZero,
	      handleFillColor = _context$muiTheme$sli.handleFillColor,
	      handleSize = _context$muiTheme$sli.handleSize,
	      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
	      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
	      trackSize = _context$muiTheme$sli.trackSize,
	      trackColor = _context$muiTheme$sli.trackColor,
	      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
	      rippleColor = _context$muiTheme$sli.rippleColor,
	      selectionColor = _context$muiTheme$sli.selectionColor;
	
	
	  var fillGutter = handleSize / 2;
	  var disabledGutter = trackSize + handleSizeDisabled / 2;
	  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
	  var percent = getPercent(state.value, min, max);
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[axis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[axis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[axis], trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[axis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
	      x: trackSize / 2 + 'px 0 0 0',
	      'x-reverse': trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: trackColor,
	      width: handleSizeDisabled,
	      height: handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: trackSize + 'px solid ' + handleColorZero,
	      backgroundColor: handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: handleSizeDisabled,
	      height: handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: trackSize + 'px solid ' + trackColorSelected
	    },
	    handleWhenActive: {
	      width: handleSizeActive,
	      height: handleSizeActive
	    },
	    ripple: {
	      height: handleSize,
	      width: handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -trackSize,
	      left: -trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -handleSize,
	      left: -handleSize
	    },
	    rippleColor: {
	      fill: percent === 0 ? handleColorZero : rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[axis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[axis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  (0, _inherits3.default)(Slider, _Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      value: 0
	    }, _this.track = null, _this.handle = null, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step;
	
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (axis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (axis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (axis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (axis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'min';
	          break;
	        case 'end':
	          action = 'max';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        switch (action) {
	          case 'decrease':
	            newValue = _this.state.value - step;
	            break;
	          case 'increase':
	            newValue = _this.state.value + step;
	            break;
	          case 'min':
	            newValue = min;
	            break;
	          case 'max':
	            newValue = max;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        newValue = parseFloat(newValue.toFixed(5));
	
	        if (newValue > max) {
	          newValue = max;
	        } else if (newValue < min) {
	          newValue = min;
	        }
	
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            value: newValue
	          });
	
	          if (_this.props.onChange) {
	            _this.props.onChange(event, newValue);
	          }
	        }
	      }
	    }, _this.handleDragMouseMove = function (event) {
	      _this.onDragUpdate(event, 'mouse');
	    }, _this.handleTouchMove = function (event) {
	      _this.onDragUpdate(event, 'touch');
	    }, _this.handleMouseEnd = function (event) {
	      document.removeEventListener('mousemove', _this.handleDragMouseMove);
	      document.removeEventListener('mouseup', _this.handleMouseEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchEnd = function (event) {
	      document.removeEventListener('touchmove', _this.handleTouchMove);
	      document.removeEventListener('touchup', _this.handleTouchEnd);
	      document.removeEventListener('touchend', _this.handleTouchEnd);
	      document.removeEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('touchmove', _this.handleTouchMove);
	      document.addEventListener('touchup', _this.handleTouchEnd);
	      document.addEventListener('touchend', _this.handleTouchEnd);
	      document.addEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.handleFocus = function (event) {
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('mousemove', _this.handleDragMouseMove);
	      document.addEventListener('mouseup', _this.handleMouseEnd);
	
	      // Cancel text selection
	      event.preventDefault();
	
	      // Set focus manually since we called preventDefault()
	      _this.handle.focus();
	
	      _this.onDragStart(event);
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          active: false
	        });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({
	        hovered: true
	      });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({
	        hovered: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          valueProp = _props.value,
	          defaultValue = _props.defaultValue,
	          min = _props.min,
	          max = _props.max;
	
	
	      var value = valueProp;
	      if (value === undefined) {
	        value = defaultValue !== undefined ? defaultValue : min;
	      }
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      this.setState({
	        value: value
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setState({
	          value: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      return this.state.value;
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      this.setState({
	        value: this.props.min
	      });
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[this.props.axis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, type) {
	      var _this2 = this;
	
	      if (this.dragRunning) {
	        return;
	      }
	      this.dragRunning = true;
	
	      requestAnimationFrame(function () {
	        _this2.dragRunning = false;
	
	        var source = type === 'touch' ? event.touches[0] : event;
	
	        var position = void 0;
	        if (isMouseControlInverted(_this2.props.axis)) {
	          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[_this2.props.axis]];
	        } else {
	          position = source[mainAxisClientOffsetProperty[_this2.props.axis]] - _this2.getTrackOffset();
	        }
	
	        if (!_this2.props.disabled) {
	          _this2.setValueFromPosition(event, position);
	        }
	      });
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'setValueFromPosition',
	    value: function setValueFromPosition(event, position) {
	      var positionMax = this.track[mainAxisClientProperty[this.props.axis]];
	      if (position < 0) {
	        position = 0;
	      } else if (position > positionMax) {
	        position = positionMax;
	      }
	
	      var _props2 = this.props,
	          step = _props2.step,
	          min = _props2.min,
	          max = _props2.max;
	
	
	      var value = void 0;
	      value = position / positionMax * (max - min);
	      value = Math.round(value / step) * step + min;
	      value = parseFloat(value.toFixed(5));
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      if (this.state.value !== value) {
	        this.setState({
	          value: value
	        });
	
	        if (this.props.onChange) {
	          this.props.onChange(event, value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          axis = _props3.axis,
	          description = _props3.description,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          error = _props3.error,
	          max = _props3.max,
	          min = _props3.min,
	          name = _props3.name,
	          onBlur = _props3.onBlur,
	          onChange = _props3.onChange,
	          onDragStart = _props3.onDragStart,
	          onDragStop = _props3.onDragStop,
	          onFocus = _props3.onFocus,
	          required = _props3.required,
	          sliderStyle = _props3.sliderStyle,
	          step = _props3.step,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['axis', 'description', 'disabled', 'disableFocusRipple', 'error', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style']);
	      var _state = this.state,
	          active = _state.active,
	          focused = _state.focused,
	          hovered = _state.hovered,
	          value = _state.value;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var percent = getPercent(value, min, max);
	
	      var handleStyles = {};
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'span',
	          null,
	          description
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart,
	            onKeyDown: !disabled && this.handleKeyDown
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(node) {
	                return _this3.track = node;
	              }, style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  return _this3.handle = node;
	                },
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              },
	              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
	                style: rippleStyle,
	                innerStyle: styles.rippleInner,
	                show: (hovered || focused) && !active,
	                color: styles.rippleColor.fill
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: name,
	          value: value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Slider.propTypes = {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _react.PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Describe the slider.
	   */
	  description: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * An error message for the slider.
	   */
	  error: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event KeyDown event targeting the slider.
	   * @param {number} newValue The new value of the slider.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   *
	   * @param {object} event MouseDown or TouchStart event targeting the slider.
	   */
	  onDragStart: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   *
	   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
	   */
	  onDragStop: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _react.PropTypes.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	} : void 0;
	exports.default = Slider;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(1744);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ClickAwayListener = __webpack_require__(388);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _SnackbarBody = __webpack_require__(1747);
	
	var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
	      zIndex = _context$muiTheme.zIndex;
	  var open = state.open;
	
	
	  var styles = {
	    root: {
	      position: 'fixed',
	      left: '50%',
	      display: 'flex',
	      bottom: 0,
	      zIndex: zIndex.snackbar,
	      visibility: open ? 'visible' : 'hidden',
	      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
	      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
	    }
	  };
	
	  return styles;
	}
	
	var Snackbar = function (_Component) {
	  (0, _inherits3.default)(Snackbar, _Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
	      if (_this.timerTransitionId) {
	        // If transitioning, don't close the snackbar.
	        return;
	      }
	
	      if (_this.props.open !== null && _this.props.onRequestClose) {
	        _this.props.onRequestClose('clickaway');
	      } else {
	        _this.setState({ open: false });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open,
	        message: this.props.message,
	        action: this.props.action
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open) {
	        this.setAutoHideTimer();
	        this.setTransitionTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	        this.setState({
	          open: false
	        });
	
	        clearTimeout(this.timerOneAtTheTimeId);
	        this.timerOneAtTheTimeId = setTimeout(function () {
	          _this2.setState({
	            message: nextProps.message,
	            action: nextProps.action,
	            open: true
	          });
	        }, 400);
	      } else {
	        var open = nextProps.open;
	
	        this.setState({
	          open: open !== null ? open : this.state.open,
	          message: nextProps.message,
	          action: nextProps.action
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.open !== this.state.open) {
	        if (this.state.open) {
	          this.setAutoHideTimer();
	          this.setTransitionTimer();
	        } else {
	          clearTimeout(this.timerAutoHideId);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHideId);
	      clearTimeout(this.timerTransitionId);
	      clearTimeout(this.timerOneAtTheTimeId);
	    }
	  }, {
	    key: 'setAutoHideTimer',
	
	
	    // Timer that controls delay before snackbar auto hides
	    value: function setAutoHideTimer() {
	      var _this3 = this;
	
	      var autoHideDuration = this.props.autoHideDuration;
	
	      if (autoHideDuration > 0) {
	        clearTimeout(this.timerAutoHideId);
	        this.timerAutoHideId = setTimeout(function () {
	          if (_this3.props.open !== null && _this3.props.onRequestClose) {
	            _this3.props.onRequestClose('timeout');
	          } else {
	            _this3.setState({ open: false });
	          }
	        }, autoHideDuration);
	      }
	    }
	
	    // Timer that controls delay before click-away events are captured (based on when animation completes)
	
	  }, {
	    key: 'setTransitionTimer',
	    value: function setTransitionTimer() {
	      var _this4 = this;
	
	      this.timerTransitionId = setTimeout(function () {
	        _this4.timerTransitionId = undefined;
	      }, 400);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHideDuration = _props.autoHideDuration,
	          contentStyle = _props.contentStyle,
	          bodyStyle = _props.bodyStyle,
	          messageProp = _props.message,
	          onRequestClose = _props.onRequestClose,
	          onActionTouchTap = _props.onActionTouchTap,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionTouchTap', 'style']);
	      var _state = this.state,
	          action = _state.action,
	          message = _state.message,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: open ? this.componentClickAway : null },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	          _react2.default.createElement(_SnackbarBody2.default, {
	            action: action,
	            contentStyle: contentStyle,
	            message: message,
	            open: open,
	            onActionTouchTap: onActionTouchTap,
	            style: bodyStyle
	          })
	        )
	      );
	    }
	  }]);
	  return Snackbar;
	}(_react.Component);
	
	Snackbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Snackbar.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _react.PropTypes.node,
	  /**
	   * The number of milliseconds to wait before automatically dismissing.
	   * If no value is specified the snackbar will dismiss normally.
	   * If a value is provided the snackbar can still be dismissed normally.
	   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	   */
	  autoHideDuration: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the body element.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _react.PropTypes.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _react.PropTypes.func,
	  /**
	   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	   * `autoHideDuration` timer expires.
	   *
	   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	   * `open` prop.
	   *
	   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Snackbar;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SnackbarBody = undefined;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _withWidth = __webpack_require__(2746);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _FlatButton = __webpack_require__(272);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var open = props.open,
	      width = props.width;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
	      desktopGutter = _context$muiTheme$bas2.desktopGutter,
	      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
	      fontFamily = _context$muiTheme$bas.fontFamily,
	      _context$muiTheme$sna = _context$muiTheme.snackbar,
	      backgroundColor = _context$muiTheme$sna.backgroundColor,
	      textColor = _context$muiTheme$sna.textColor,
	      actionColor = _context$muiTheme$sna.actionColor,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var isSmall = width === _withWidth.SMALL;
	
	  var styles = {
	    root: {
	      fontFamily: fontFamily,
	      backgroundColor: backgroundColor,
	      padding: '0 ' + desktopGutter + 'px',
	      height: desktopSubheaderHeight,
	      lineHeight: desktopSubheaderHeight + 'px',
	      borderRadius: isSmall ? 0 : borderRadius,
	      maxWidth: isSmall ? 'inherit' : 568,
	      minWidth: isSmall ? 'inherit' : 288,
	      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
	      flexGrow: isSmall ? 1 : 0
	    },
	    content: {
	      fontSize: 14,
	      color: textColor,
	      opacity: open ? 1 : 0,
	      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
	    },
	    action: {
	      color: actionColor,
	      float: 'right',
	      marginTop: 6,
	      marginRight: -16,
	      marginLeft: desktopGutter,
	      backgroundColor: 'transparent'
	    }
	  };
	
	  return styles;
	}
	
	var SnackbarBody = function SnackbarBody(props, context) {
	  var action = props.action,
	      contentStyle = props.contentStyle,
	      message = props.message,
	      open = props.open,
	      onActionTouchTap = props.onActionTouchTap,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionTouchTap', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
	    style: styles.action,
	    label: action,
	    onTouchTap: onActionTouchTap
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    )
	  );
	};
	
	exports.SnackbarBody = SnackbarBody;
	 false ? SnackbarBody.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _react.PropTypes.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _react.PropTypes.func,
	  /**
	   * @ignore
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * @ignore
	   * Width of the screen.
	   */
	  width: _react.PropTypes.number.isRequired
	} : void 0;
	
	SnackbarBody.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Snackbar = __webpack_require__(1746);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Snackbar2.default;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _react.PropTypes.number,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Step;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(89);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(600);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? StepButton.propTypes = {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _react.PropTypes.object,
	  /** @ignore */
	  last: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = StepButton;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	 false ? StepConnector.propTypes = propTypes : void 0;
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExpandTransition = __webpack_require__(1779);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	 false ? StepContent.propTypes = {
	  /**
	   * Expands the content
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Step content
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _react.PropTypes.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = StepContent;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StepConnector = __webpack_require__(1751);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	Stepper.childContextTypes = { stepper: _react.PropTypes.object };
	 false ? Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _react.PropTypes.number,
	  /**
	   * Should be two or more `<Step />` components
	   */
	  children: _react.PropTypes.arrayOf(_react.PropTypes.node),
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _react.PropTypes.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _react.PropTypes.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Stepper;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	 false ? Subheader.propTypes = {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	exports.default = Subheader;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SvgIcon.propTypes = {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _react.PropTypes.string
	} : void 0;
	exports.default = SvgIcon;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      table = _context$muiTheme.table;
	
	
	  return {
	    root: {
	      backgroundColor: table.backgroundColor,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      tableLayout: 'fixed',
	      fontFamily: baseTheme.fontFamily
	    },
	    bodyTable: {
	      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
	      overflowX: 'hidden',
	      overflowY: 'auto'
	    },
	    tableWrapper: {
	      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
	      overflow: 'auto'
	    }
	  };
	}
	
	var Table = function (_Component) {
	  (0, _inherits3.default)(Table, _Component);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      allRowsSelected: false
	    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
	    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
	    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
	    }, _this.onRowHover = function (rowNumber) {
	      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
	    }, _this.onRowHoverExit = function (rowNumber) {
	      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
	    }, _this.onRowSelection = function (selectedRows) {
	      if (_this.state.allRowsSelected) _this.setState({ allRowsSelected: false });
	      if (_this.props.onRowSelection) _this.props.onRowSelection(selectedRows);
	    }, _this.onSelectAll = function () {
	      if (_this.props.onRowSelection) {
	        if (!_this.state.allRowsSelected) {
	          _this.props.onRowSelection('all');
	        } else {
	          _this.props.onRowSelection('none');
	        }
	      }
	
	      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.allRowsSelected) {
	        this.setState({ allRowsSelected: true });
	      }
	    }
	  }, {
	    key: 'isScrollbarVisible',
	    value: function isScrollbarVisible() {
	      var tableDivHeight = this.refs.tableDiv.clientHeight;
	      var tableBodyHeight = this.refs.tableBody.clientHeight;
	
	      return tableBodyHeight > tableDivHeight;
	    }
	  }, {
	    key: 'createTableHeader',
	    value: function createTableHeader(base) {
	      return _react2.default.cloneElement(base, {
	        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	        onSelectAll: this.onSelectAll,
	        selectAllSelected: this.state.allRowsSelected
	      });
	    }
	  }, {
	    key: 'createTableBody',
	    value: function createTableBody(base) {
	      return _react2.default.cloneElement(base, {
	        allRowsSelected: this.state.allRowsSelected,
	        multiSelectable: this.props.multiSelectable,
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowSelection: this.onRowSelection,
	        selectable: this.props.selectable,
	        style: (0, _simpleAssign2.default)({ height: this.props.height }, base.props.style)
	      });
	    }
	  }, {
	    key: 'createTableFooter',
	    value: function createTableFooter(base) {
	      return base;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixedFooter = _props.fixedFooter,
	          fixedHeader = _props.fixedHeader,
	          style = _props.style,
	          wrapperStyle = _props.wrapperStyle,
	          headerStyle = _props.headerStyle,
	          bodyStyle = _props.bodyStyle,
	          footerStyle = _props.footerStyle;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var tHead = void 0;
	      var tFoot = void 0;
	      var tBody = void 0;
	
	      _react2.default.Children.forEach(children, function (child) {
	        if (!_react2.default.isValidElement(child)) return;
	
	        var muiName = child.type.muiName;
	
	        if (muiName === 'TableBody') {
	          tBody = _this2.createTableBody(child);
	        } else if (muiName === 'TableHeader') {
	          tHead = _this2.createTableHeader(child);
	        } else if (muiName === 'TableFooter') {
	          tFoot = _this2.createTableFooter(child);
	        } else {
	           false ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
	        }
	      });
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	      if (!tBody && !tHead) return null;
	
	      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var headerTable = void 0;
	      var footerTable = void 0;
	      var inlineHeader = void 0;
	      var inlineFooter = void 0;
	
	      if (fixedHeader) {
	        headerTable = _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tHead
	          )
	        );
	      } else {
	        inlineHeader = tHead;
	      }
	
	      if (tFoot !== undefined) {
	        if (fixedFooter) {
	          footerTable = _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
	            _react2.default.createElement(
	              'table',
	              { className: className, style: prepareStyles(mergedTableStyle) },
	              tFoot
	            )
	          );
	        } else {
	          inlineFooter = tFoot;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
	        headerTable,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle, ref: 'tableBody' },
	            inlineHeader,
	            inlineFooter,
	            tBody
	          )
	        ),
	        footerTable
	      );
	    }
	  }]);
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  allRowsSelected: false,
	  fixedFooter: true,
	  fixedHeader: true,
	  height: 'inherit',
	  multiSelectable: false,
	  selectable: true
	};
	Table.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Table.propTypes = {
	  /**
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the body's table element.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * Children passed to table.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the footer will appear fixed below the table.
	   * The default value is true.
	   */
	  fixedFooter: _react.PropTypes.bool,
	  /**
	   * If true, the header will appear fixed above the table.
	   * The default value is true.
	   */
	  fixedHeader: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the footer's table element.
	   */
	  footerStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the header's table element.
	   */
	  headerStyle: _react.PropTypes.object,
	  /**
	   * The height of the table.
	   */
	  height: _react.PropTypes.string,
	  /**
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _react.PropTypes.bool,
	  /**
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _react.PropTypes.func,
	  /**
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _react.PropTypes.func,
	  /**
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _react.PropTypes.func,
	  /**
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _react.PropTypes.func,
	  /**
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _react.PropTypes.func,
	  /**
	   * Called when a row is selected.
	   * selectedRows is an array of all row selections.
	   * IF all rows have been selected, the string "all"
	   * will be returned instead to indicate that all rows have been selected.
	   */
	  onRowSelection: _react.PropTypes.func,
	  /**
	   * If true, table rows can be selected.
	   * If multiple row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the table's wrapper element.
	   */
	  wrapperStyle: _react.PropTypes.object
	} : void 0;
	exports.default = Table;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var inkBar = context.muiTheme.inkBar;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  (0, _inherits3.default)(InkBar, _Component);
	
	  function InkBar() {
	    (0, _classCallCheck3.default)(this, InkBar);
	    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	  return InkBar;
	}(_react.Component);
	
	InkBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? InkBar.propTypes = {
	  color: _react.PropTypes.string,
	  left: _react.PropTypes.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  width: _react.PropTypes.string.isRequired
	} : void 0;
	exports.default = InkBar;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  width: '100%',
	  position: 'relative',
	  textAlign: 'initial'
	};
	
	var TabTemplate = function TabTemplate(_ref) {
	  var children = _ref.children,
	      selected = _ref.selected,
	      style = _ref.style;
	
	  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
	  if (!selected) {
	    templateStyle.height = 0;
	    templateStyle.overflow = 'hidden';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: templateStyle },
	    children
	  );
	};
	
	 false ? TabTemplate.propTypes = {
	  children: _react.PropTypes.node,
	  selected: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	} : void 0;
	
	exports.default = TabTemplate;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TabTemplate = __webpack_require__(1758);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(1757);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap',
	      display: 'flex'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  (0, _inherits3.default)(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var tabs = [];
	
	      _react.Children.forEach(props.children, function (tab) {
	        if ((0, _react.isValidElement)(tab)) {
	          tabs.push(tab);
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs(props).forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentContainerClassName = _props.contentContainerClassName,
	          contentContainerStyle = _props.contentContainerStyle,
	          initialSelectedIndex = _props.initialSelectedIndex,
	          inkBarStyle = _props.inkBarStyle,
	          onChange = _props.onChange,
	          style = _props.style,
	          tabItemContainerStyle = _props.tabItemContainerStyle,
	          tabTemplate = _props.tabTemplate,
	          tabTemplateStyle = _props.tabTemplateStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index),
	          style: tabTemplateStyle
	        }, tab.props.children) : undefined);
	
	        return (0, _react.cloneElement)(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onTouchTap: _this2.handleTabTouchTap
	        });
	      });
	
	      var inkBar = this.state.selectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * this.state.selectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: inkBarContainerWidth } },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Tabs.propTypes = {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _react.PropTypes.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _react.PropTypes.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _react.PropTypes.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the tab template.
	   */
	  tabTemplateStyle: _react.PropTypes.object,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = Tabs;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(606);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(1759);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'initial'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(undefined, event);
	    }, _this.handleChange = function (event) {
	      _this.syncHeightWithShadow(event.target.value);
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
	        this.syncHeightWithShadow(nextProps.value, null, nextProps);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event, props) {
	      var shadow = this.refs.shadow;
	
	      if (newValue !== undefined) {
	        shadow.value = newValue;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      props = props || this.props;
	
	      if (props.rowsMax >= props.rows) {
	        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	
	        if (props.onHeightChange) {
	          props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = this.props.valueLink.value;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value,
	          valueLink: this.props.valueLink
	        }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? EnhancedTextarea.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onHeightChange: _react.PropTypes.func,
	  rows: _react.PropTypes.number,
	  rowsMax: _react.PropTypes.number,
	  shadowStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  textareaStyle: _react.PropTypes.object,
	  value: _react.PropTypes.string,
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = EnhancedTextarea;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(161);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(1761);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(1763);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(1764);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(1765);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    inputNative: {
	      appearance: 'textfield' }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      _this.setState({ hasValue: isValid(event.target.value) });
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TextField.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _react.PropTypes.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _react.PropTypes.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _react.PropTypes.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value of the text field.
	   */
	  value: _react.PropTypes.any
	} : void 0;
	exports.default = TextField;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	 false ? TextFieldHint.propTypes = {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _react.PropTypes.node
	} : void 0;
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onTouchTap = props.onTouchTap;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	 false ? TextFieldLabel.propTypes = {
	  /**
	   * The label contents.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _react.PropTypes.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
	  );
	};
	
	 false ? TextFieldUnderline.propTypes = propTypes : void 0;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeDisplay = __webpack_require__(1769);
	
	var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);
	
	var _ClockHours = __webpack_require__(1767);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(1768);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = function (_Component) {
	  (0, _inherits3.default)(Clock, _Component);
	
	  function Clock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Clock.__proto__ || (0, _getPrototypeOf2.default)(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedTime: null,
	      mode: 'hour'
	    }, _this.setMode = function (mode) {
	      setTimeout(function () {
	        _this.setState({
	          mode: mode
	        });
	      }, 100);
	    }, _this.handleSelectAffix = function (affix) {
	      if (affix === _this.getAffix()) return;
	
	      var hours = _this.state.selectedTime.getHours();
	
	      if (affix === 'am') {
	        _this.handleChangeHours(hours - 12, affix);
	        return;
	      }
	
	      _this.handleChangeHours(hours + 12, affix);
	    }, _this.handleChangeHours = function (hours, finished) {
	      var time = new Date(_this.state.selectedTime);
	      var affix = void 0;
	
	      if (typeof finished === 'string') {
	        affix = finished;
	        finished = undefined;
	      }
	      if (!affix) {
	        affix = _this.getAffix();
	      }
	      if (affix === 'pm' && hours < 12) {
	        hours += 12;
	      }
	
	      time.setHours(hours);
	      _this.setState({
	        selectedTime: time
	      });
	
	      if (finished) {
	        setTimeout(function () {
	          _this.setState({
	            mode: 'minute'
	          });
	
	          var onChangeHours = _this.props.onChangeHours;
	
	          if (onChangeHours) {
	            onChangeHours(time);
	          }
	        }, 100);
	      }
	    }, _this.handleChangeMinutes = function (minutes, finished) {
	      var time = new Date(_this.state.selectedTime);
	      time.setMinutes(minutes);
	      _this.setState({
	        selectedTime: time
	      });
	
	      var onChangeMinutes = _this.props.onChangeMinutes;
	
	      if (onChangeMinutes && finished) {
	        setTimeout(function () {
	          onChangeMinutes(time);
	        }, 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Clock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        selectedTime: this.props.initialTime || new Date()
	      });
	    }
	  }, {
	    key: 'getAffix',
	    value: function getAffix() {
	      if (this.props.format !== 'ampm') return '';
	
	      var hours = this.state.selectedTime.getHours();
	      if (hours < 12) {
	        return 'am';
	      }
	
	      return 'pm';
	    }
	  }, {
	    key: 'getSelectedTime',
	    value: function getSelectedTime() {
	      return this.state.selectedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clock = null;
	
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          userSelect: 'none'
	        },
	        container: {
	          height: 280,
	          padding: 10,
	          position: 'relative',
	          boxSizing: 'content-box'
	        },
	        circle: {
	          position: 'absolute',
	          top: 20,
	          width: 260,
	          height: 260,
	          borderRadius: '100%',
	          backgroundColor: timePicker.clockCircleColor
	        }
	      };
	
	      if (this.state.mode === 'hour') {
	        clock = _react2.default.createElement(_ClockHours2.default, {
	          key: 'hours',
	          format: this.props.format,
	          onChange: this.handleChangeHours,
	          initialHours: this.state.selectedTime.getHours()
	        });
	      } else {
	        clock = _react2.default.createElement(_ClockMinutes2.default, {
	          key: 'minutes',
	          onChange: this.handleChangeMinutes,
	          initialMinutes: this.state.selectedTime.getMinutes()
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_TimeDisplay2.default, {
	          selectedTime: this.state.selectedTime,
	          mode: this.state.mode,
	          format: this.props.format,
	          affix: this.getAffix(),
	          onSelectAffix: this.handleSelectAffix,
	          onSelectHour: this.setMode.bind(this, 'hour'),
	          onSelectMin: this.setMode.bind(this, 'minute')
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.container) },
	          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
	          clock
	        )
	      );
	    }
	  }]);
	  return Clock;
	}(_react.Component);
	
	Clock.defaultProps = {
	  initialTime: new Date()
	};
	Clock.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Clock.propTypes = {
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialTime: _react.PropTypes.object,
	  onChangeHours: _react.PropTypes.func,
	  onChangeMinutes: _react.PropTypes.func
	} : void 0;
	exports.default = Clock;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ClockNumber = __webpack_require__(607);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(608);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockHours = function (_Component) {
	  (0, _inherits3.default)(ClockHours, _Component);
	
	  function ClockHours() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockHours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockHours.__proto__ || (0, _getPrototypeOf2.default)(ClockHours)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) return;
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouchMove = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _this.handleTouchEnd = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], true);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var hours = this.getHours(event.offsetX, event.offsetY);
	
	      this.props.onChange(hours, finish);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours(offsetX, offsetY) {
	      var step = 30;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      var delta = Math.pow(x, 2) + Math.pow(y, 2);
	      var distance = Math.sqrt(delta);
	
	      value = value || 12;
	      if (this.props.format === '24hr') {
	        if (distance < 90) {
	          value += 12;
	          value %= 24;
	        }
	      } else {
	        value %= 12;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var hour = this.props.initialHours;
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      return hour;
	    }
	  }, {
	    key: 'getHourNumbers',
	    value: function getHourNumbers() {
	      var _this2 = this;
	
	      var style = {
	        pointerEvents: 'none'
	      };
	      var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	      var hours = [];
	      for (var i = 1; i <= hourSize; i++) {
	        hours.push(i % 24);
	      }
	
	      return hours.map(function (hour) {
	        var isSelected = _this2.getSelected() === hour;
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: hour,
	          style: style,
	          isSelected: isSelected,
	          type: 'hour',
	          value: hour
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var hours = this.getSelected();
	      var numbers = this.getHourNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	        numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockHours;
	}(_react.Component);
	
	ClockHours.defaultProps = {
	  initialHours: new Date().getHours(),
	  onChange: function onChange() {},
	  format: 'ampm'
	};
	ClockHours.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ClockHours.propTypes = {
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialHours: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	} : void 0;
	exports.default = ClockHours;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClockNumber = __webpack_require__(607);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(608);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockMinutes = function (_Component) {
	  (0, _inherits3.default)(ClockMinutes, _Component);
	
	  function ClockMinutes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockMinutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockMinutes.__proto__ || (0, _getPrototypeOf2.default)(ClockMinutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) {
	        return;
	      }
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouch = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], event.type === 'touchend');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockMinutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = this.refs.mask;
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var minutes = this.getMinutes(event.offsetX, event.offsetY);
	
	      this.props.onChange(minutes, finish);
	    }
	  }, {
	    key: 'getMinutes',
	    value: function getMinutes(offsetX, offsetY) {
	      var step = 6;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      return value;
	    }
	  }, {
	    key: 'getMinuteNumbers',
	    value: function getMinuteNumbers() {
	      var minutes = [];
	      for (var i = 0; i < 12; i++) {
	        minutes.push(i * 5);
	      }
	      var selectedMinutes = this.props.initialMinutes;
	      var hasSelected = false;
	
	      var numbers = minutes.map(function (minute) {
	        var isSelected = selectedMinutes === minute;
	        if (isSelected) {
	          hasSelected = true;
	        }
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: minute,
	          isSelected: isSelected,
	          type: 'minute',
	          value: minute
	        });
	      });
	
	      return {
	        numbers: numbers,
	        hasSelected: hasSelected,
	        selected: selectedMinutes
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var minutes = this.getMinuteNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
	        minutes.numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask',
	          style: prepareStyles(styles.hitMask),
	          onTouchMove: this.handleTouch,
	          onTouchEnd: this.handleTouch,
	          onMouseUp: this.handleUp,
	          onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockMinutes;
	}(_react.Component);
	
	ClockMinutes.defaultProps = {
	  initialMinutes: new Date().getMinutes(),
	  onChange: function onChange() {}
	};
	ClockMinutes.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ClockMinutes.propTypes = {
	  initialMinutes: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	} : void 0;
	exports.default = ClockMinutes;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(240);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeDisplay = function (_Component) {
	  (0, _inherits3.default)(TimeDisplay, _Component);
	
	  function TimeDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimeDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimeDisplay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTime !== this.props.selectedTime) {
	        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'sanitizeTime',
	    value: function sanitizeTime() {
	      var hour = this.props.selectedTime.getHours();
	      var min = this.props.selectedTime.getMinutes().toString();
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      hour = hour.toString();
	      if (hour.length < 2) hour = '0' + hour;
	      if (min.length < 2) min = '0' + min;
	
	      return [hour, min];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          affix = _props.affix,
	          format = _props.format,
	          mode = _props.mode,
	          onSelectAffix = _props.onSelectAffix,
	          onSelectHour = _props.onSelectHour,
	          onSelectMin = _props.onSelectMin,
	          selectedTime = _props.selectedTime,
	          other = (0, _objectWithoutProperties3.default)(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          padding: '14px 0',
	          borderTopLeftRadius: 2,
	          borderTopRightRadius: 2,
	          backgroundColor: timePicker.headerColor,
	          color: timePicker.textColor
	        },
	        text: {
	          margin: '6px 0',
	          lineHeight: '58px',
	          height: 58,
	          fontSize: 58,
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'baseline'
	        },
	        time: {
	          margin: '0 10px'
	        },
	        affix: {
	          flex: 1,
	          position: 'relative',
	          lineHeight: '17px',
	          height: 17,
	          fontSize: 17
	        },
	        affixTop: {
	          position: 'absolute',
	          top: -20,
	          left: 0
	        },
	        clickable: {
	          cursor: 'pointer'
	        },
	        inactive: {
	          opacity: 0.7
	        }
	      };
	
	      var _sanitizeTime = this.sanitizeTime(),
	          _sanitizeTime2 = (0, _slicedToArray3.default)(_sanitizeTime, 2),
	          hour = _sanitizeTime2[0],
	          min = _sanitizeTime2[1];
	
	      var buttons = [];
	      if (format === 'ampm') {
	        buttons = [_react2.default.createElement(
	          'div',
	          {
	            key: 'pm',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('pm');
	            }
	          },
	          'PM'
	        ), _react2.default.createElement(
	          'div',
	          {
	            key: 'am',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('am');
	            }
	          },
	          'AM'
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
	                onTouchTap: onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
	                onTouchTap: onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
	            buttons
	          )
	        )
	      );
	    }
	  }]);
	  return TimeDisplay;
	}(_react.Component);
	
	TimeDisplay.defaultProps = {
	  affix: '',
	  mode: 'hour'
	};
	TimeDisplay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TimeDisplay.propTypes = {
	  affix: _react.PropTypes.oneOf(['', 'pm', 'am']),
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  mode: _react.PropTypes.oneOf(['hour', 'minute']),
	  onSelectAffix: _react.PropTypes.func,
	  onSelectHour: _react.PropTypes.func,
	  onSelectMin: _react.PropTypes.func,
	  selectedTime: _react.PropTypes.object.isRequired
	} : void 0;
	exports.default = TimeDisplay;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimePickerDialog = __webpack_require__(1771);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _timeUtils = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = function (_Component) {
	  (0, _inherits3.default)(TimePicker, _Component);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePicker.__proto__ || (0, _getPrototypeOf2.default)(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      time: null,
	      dialogTime: new Date()
	    }, _this.handleAcceptDialog = function (time) {
	      _this.setState({
	        time: time
	      });
	      if (_this.props.onChange) _this.props.onChange(null, time);
	    }, _this.handleFocusInput = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTapInput = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.openDialog();
	      }
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          time: this.getControlledTime(nextProps)
	        });
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      this.setState({
	        dialogTime: this.state.time
	      });
	      this.refs.dialogWindow.show();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.value !== null;
	    }
	  }, {
	    key: 'getControlledTime',
	    value: function getControlledTime() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var result = null;
	      if (props.value instanceof Date) {
	        result = props.value;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          defaultTime = _props.defaultTime,
	          dialogBodyStyle = _props.dialogBodyStyle,
	          dialogStyle = _props.dialogStyle,
	          format = _props.format,
	          okLabel = _props.okLabel,
	          onFocus = _props.onFocus,
	          onTouchTap = _props.onTouchTap,
	          onShow = _props.onShow,
	          onDismiss = _props.onDismiss,
	          pedantic = _props.pedantic,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onTouchTap', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var time = this.state.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          style: textFieldStyle,
	          ref: 'input',
	          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
	          onFocus: this.handleFocusInput,
	          onTouchTap: this.handleTouchTapInput
	        })),
	        _react2.default.createElement(_TimePickerDialog2.default, {
	          ref: 'dialogWindow',
	          bodyStyle: dialogBodyStyle,
	          initialTime: this.state.dialogTime,
	          onAccept: this.handleAcceptDialog,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          format: format,
	          okLabel: okLabel,
	          cancelLabel: cancelLabel,
	          autoOk: autoOk,
	          style: dialogStyle
	        })
	      );
	    }
	  }]);
	  return TimePicker;
	}(_react.Component);
	
	TimePicker.defaultProps = {
	  autoOk: false,
	  cancelLabel: 'Cancel',
	  defaultTime: null,
	  disabled: false,
	  format: 'ampm',
	  okLabel: 'OK',
	  pedantic: false,
	  style: {},
	  value: null
	};
	TimePicker.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TimePicker.propTypes = {
	  /**
	   * If true, automatically accept and close the picker on set minutes.
	   */
	  autoOk: _react.PropTypes.bool,
	  /**
	   * Override the label of the 'Cancel' button.
	   */
	  cancelLabel: _react.PropTypes.node,
	  /**
	   * The initial time value of the TimePicker.
	   */
	  defaultTime: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's body element.
	   */
	  dialogBodyStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's root element.
	   */
	  dialogStyle: _react.PropTypes.object,
	  /**
	   * If true, the TimePicker is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
	   */
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  /**
	   * Override the label of the 'OK' button.
	   */
	  okLabel: _react.PropTypes.node,
	  /**
	   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	   * Since there is no particular event associated with the change the first argument will always be null
	   * and the second argument will be the new Date instance.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker dialog is dismissed.
	   */
	  onDismiss: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker `TextField` gains focus.
	   */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker dialog is shown.
	   */
	  onShow: _react.PropTypes.func,
	  /**
	   * Callback function fired when the TimePicker is tapped or clicked.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
	   *
	   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
	   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
	   * ("12 a.m." / "12 p.m.").
	   */
	  pedantic: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of TimePicker's TextField element.
	   */
	  textFieldStyle: _react.PropTypes.object,
	  /**
	   * Sets the time for the Time Picker programmatically.
	   */
	  value: _react.PropTypes.object
	} : void 0;
	exports.default = TimePicker;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(88);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Clock = __webpack_require__(1766);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Dialog = __webpack_require__(380);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(272);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerDialog = function (_Component) {
	  (0, _inherits3.default)(TimePickerDialog, _Component);
	
	  function TimePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOK = function () {
	      if (_this.props.onAccept) {
	        _this.props.onAccept(_this.refs.clock.getSelectedTime());
	      }
	      _this.setState({
	        open: false
	      });
	    }, _this.handleKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOK();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePickerDialog, [{
	    key: 'show',
	    value: function show() {
	      if (this.props.onShow && !this.state.open) this.props.onShow();
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bodyStyle = _props.bodyStyle,
	          initialTime = _props.initialTime,
	          onAccept = _props.onAccept,
	          format = _props.format,
	          autoOk = _props.autoOk,
	          okLabel = _props.okLabel,
	          cancelLabel = _props.cancelLabel,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style']);
	
	
	      var styles = {
	        root: {
	          fontSize: 14,
	          color: this.context.muiTheme.timePicker.clockColor
	        },
	        dialogContent: {
	          width: 280
	        },
	        body: {
	          padding: 0
	        }
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        key: 0,
	        label: cancelLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        key: 1,
	        label: okLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapOK
	      })];
	
	      var onClockChangeMinutes = autoOk === true ? this.handleTouchTapOK : undefined;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
	          actions: actions,
	          contentStyle: styles.dialogContent,
	          repositionOnUpdate: false,
	          open: open,
	          onRequestClose: this.handleRequestClose
	        }),
	        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        open && _react2.default.createElement(_Clock2.default, {
	          ref: 'clock',
	          format: format,
	          initialTime: initialTime,
	          onChangeMinutes: onClockChangeMinutes
	        })
	      );
	    }
	  }]);
	  return TimePickerDialog;
	}(_react.Component);
	
	TimePickerDialog.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel'
	};
	TimePickerDialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? TimePickerDialog.propTypes = {
	  autoOk: _react.PropTypes.bool,
	  bodyStyle: _react.PropTypes.object,
	  cancelLabel: _react.PropTypes.node,
	  format: _react.PropTypes.oneOf(['ampm', '24hr']),
	  initialTime: _react.PropTypes.object,
	  okLabel: _react.PropTypes.node,
	  onAccept: _react.PropTypes.func,
	  onDismiss: _react.PropTypes.func,
	  onShow: _react.PropTypes.func,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = TimePickerDialog;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimePicker = __webpack_require__(1770);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimePicker2.default;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(81);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _EnhancedSwitch = __webpack_require__(389);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var disabled = props.disabled,
	      elementStyle = props.elementStyle,
	      trackSwitchedStyle = props.trackSwitchedStyle,
	      thumbSwitchedStyle = props.thumbSwitchedStyle,
	      trackStyle = props.trackStyle,
	      thumbStyle = props.thumbStyle,
	      iconStyle = props.iconStyle,
	      rippleStyle = props.rippleStyle,
	      labelStyle = props.labelStyle;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toggle = _context$muiTheme.toggle;
	
	
	  var toggleSize = 20;
	  var toggleTrackWidth = 36;
	  var styles = {
	    icon: {
	      width: 36,
	      padding: '4px 0px 6px 2px'
	    },
	    ripple: {
	      top: -10,
	      left: -10,
	      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
	    },
	    toggleElement: {
	      width: toggleTrackWidth
	    },
	    track: {
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      height: 14,
	      borderRadius: 30,
	      backgroundColor: toggle.trackOffColor
	    },
	    thumb: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      top: 1,
	      left: 0,
	      width: toggleSize,
	      height: toggleSize,
	      lineHeight: '24px',
	      borderRadius: '50%',
	      backgroundColor: toggle.thumbOffColor
	    },
	    trackWhenSwitched: {
	      backgroundColor: toggle.trackOnColor
	    },
	    thumbWhenSwitched: {
	      backgroundColor: toggle.thumbOnColor,
	      left: '100%'
	    },
	    trackWhenDisabled: {
	      backgroundColor: toggle.trackDisabledColor
	    },
	    thumbWhenDisabled: {
	      backgroundColor: toggle.thumbDisabledColor
	    },
	    label: {
	      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
	      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
	    }
	  };
	
	  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);
	
	  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);
	
	  if (state.switched) {
	    styles.thumb.marginLeft = 0 - styles.thumb.width;
	  }
	
	  (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	  (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);
	
	  return styles;
	}
	
	var Toggle = function (_Component) {
	  (0, _inherits3.default)(Toggle, _Component);
	
	  function Toggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleToggle = function (event, isInputChecked) {
	      if (_this.props.onToggle) {
	        _this.props.onToggle(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          valueLink = _props.valueLink;
	
	
	      if (toggled || defaultToggled || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'isToggled',
	    value: function isToggled() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setToggled',
	    value: function setToggled(newToggledValue) {
	      this.refs.enhancedSwitch.setSwitched(newToggledValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          defaultToggled = _props2.defaultToggled,
	          elementStyle = _props2.elementStyle,
	          onToggle = _props2.onToggle,
	          trackSwitchedStyle = _props2.trackSwitchedStyle,
	          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
	          toggled = _props2.toggled,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var toggleElement = _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
	        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
	      );
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switchElement: toggleElement,
	        rippleStyle: styles.ripple,
	        rippleColor: styles.ripple.color,
	        iconStyle: styles.icon,
	        trackStyle: styles.track,
	        thumbStyle: styles.thumb,
	        labelStyle: styles.label,
	        switched: this.state.switched,
	        onSwitch: this.handleToggle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      if (this.props.hasOwnProperty('toggled')) {
	        enhancedSwitchProps.checked = toggled;
	      } else if (this.props.hasOwnProperty('defaultToggled')) {
	        enhancedSwitchProps.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Toggle;
	}(_react.Component);
	
	Toggle.defaultProps = {
	  defaultToggled: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	Toggle.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Toggle.propTypes = {
	  /**
	   * Determines whether the Toggle is initially turned on.
	   * **Warning:** This cannot be used in conjunction with `toggled`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultToggled: _react.PropTypes.bool,
	  /**
	   * Will disable the toggle if true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Overrides the inline-styles of the Toggle element.
	   */
	  elementStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the Icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * Label for toggle.
	   */
	  label: _react.PropTypes.node,
	  /**
	   * Where the label will be placed next to the toggle.
	   */
	  labelPosition: _react.PropTypes.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Toggle element label.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function that is fired when the toggle switch is toggled.
	   *
	   * @param {object} event Change event targeting the toggle.
	   * @param {bool} isInputChecked The new value of the toggle.
	   */
	  onToggle: _react.PropTypes.func,
	  /**
	   * Override style of ripple.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override style for thumb.
	   */
	  thumbStyle: _react.PropTypes.object,
	  /**
	  * Override the inline styles for thumb when the toggle switch is toggled on.
	  */
	  thumbSwitchedStyle: _react.PropTypes.object,
	  /**
	   * Toggled if set to true.
	   */
	  toggled: _react.PropTypes.bool,
	  /**
	   * Override style for track.
	   */
	  trackStyle: _react.PropTypes.object,
	  /**
	  * Override the inline styles for track when the toggle switch is toggled on.
	  */
	  trackSwitchedStyle: _react.PropTypes.object,
	  /**
	   * ValueLink prop for when using controlled toggle.
	   */
	  valueLink: _react.PropTypes.object
	} : void 0;
	exports.default = Toggle;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var noGutter = props.noGutter;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      backgroundColor: toolbar.backgroundColor,
	      height: toolbar.height,
	      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
	      display: 'flex',
	      justifyContent: 'space-between'
	    }
	  };
	}
	
	var Toolbar = function (_Component) {
	  (0, _inherits3.default)(Toolbar, _Component);
	
	  function Toolbar() {
	    (0, _classCallCheck3.default)(this, Toolbar);
	    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          noGutter = _props.noGutter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.defaultProps = {
	  noGutter: false
	};
	Toolbar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? Toolbar.propTypes = {
	  /**
	   * Can be a `ToolbarGroup` to render a group of related items.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Do not apply `desktopGutter` to the `Toolbar`.
	   */
	  noGutter: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = Toolbar;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(1774);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(609);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(610);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(611);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;
	exports.default = _Toolbar3.default;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  (0, _inherits3.default)(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) {
	        this.preventScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) {
	        return;
	      }
	
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return AutoLockScrolling;
	}(_react.Component);
	
	 false ? AutoLockScrolling.propTypes = {
	  lock: _react.PropTypes.bool.isRequired
	} : void 0;
	exports.default = AutoLockScrolling;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? BeforeAfterWrapper.propTypes = {
	  afterElementType: _react.PropTypes.string,
	  afterStyle: _react.PropTypes.object,
	  beforeElementType: _react.PropTypes.string,
	  beforeStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  elementType: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = BeforeAfterWrapper;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(161);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(162);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? CircleRipple.propTypes = {
	  aborted: _react.PropTypes.bool,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  touchGenerated: _react.PropTypes.bool
	} : void 0;
	exports.default = CircleRipple;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(223);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(1780);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ExpandTransition.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  loading: _react.PropTypes.bool,
	  open: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = ExpandTransition;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ExpandTransitionChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	} : void 0;
	exports.default = ExpandTransitionChild;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(223);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ScaleInChild = __webpack_require__(1782);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ScaleIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ScaleIn;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(162);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? ScaleInChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = ScaleInChild;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(14);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(162);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(24);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideInChild = function (_Component) {
	  (0, _inherits3.default)(SlideInChild, _Component);
	
	  function SlideInChild() {
	    (0, _classCallCheck3.default)(this, SlideInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SlideInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var direction = this.props.getLeaveDirection();
	      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          getLeaveDirection = _props.getLeaveDirection,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return SlideInChild;
	}(_react.Component);
	
	SlideInChild.defaultProps = {
	  enterDelay: 0
	};
	SlideInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	 false ? SlideInChild.propTypes = {
	  children: _react.PropTypes.node,
	  direction: _react.PropTypes.string,
	  enterDelay: _react.PropTypes.number,
	  // This callback is needed bacause the direction could change when leaving the DOM
	  getLeaveDirection: _react.PropTypes.func.isRequired,
	  style: _react.PropTypes.object
	} : void 0;
	exports.default = SlideInChild;

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(1789);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(1787);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(1786);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (("production") === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(617);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(1785);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(392);
	
	var _colorManipulator = __webpack_require__(117);
	
	var _spacing = __webpack_require__(1791);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  borderRadius: 2,
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccessibility = function ActionAccessibility(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z' })
	  );
	};
	ActionAccessibility = (0, _pure2.default)(ActionAccessibility);
	ActionAccessibility.displayName = 'ActionAccessibility';
	ActionAccessibility.muiName = 'SvgIcon';
	
	exports.default = ActionAccessibility;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccessible = function ActionAccessible(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '4', r: '2' }),
	    _react2.default.createElement('path', { d: 'M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z' })
	  );
	};
	ActionAccessible = (0, _pure2.default)(ActionAccessible);
	ActionAccessible.displayName = 'ActionAccessible';
	ActionAccessible.muiName = 'SvgIcon';
	
	exports.default = ActionAccessible;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBalanceWallet = function ActionAccountBalanceWallet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ActionAccountBalanceWallet = (0, _pure2.default)(ActionAccountBalanceWallet);
	ActionAccountBalanceWallet.displayName = 'ActionAccountBalanceWallet';
	ActionAccountBalanceWallet.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBalanceWallet;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBalance = function ActionAccountBalance(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z' })
	  );
	};
	ActionAccountBalance = (0, _pure2.default)(ActionAccountBalance);
	ActionAccountBalance.displayName = 'ActionAccountBalance';
	ActionAccountBalance.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBalance;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBox = function ActionAccountBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z' })
	  );
	};
	ActionAccountBox = (0, _pure2.default)(ActionAccountBox);
	ActionAccountBox.displayName = 'ActionAccountBox';
	ActionAccountBox.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBox;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountCircle = function ActionAccountCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' })
	  );
	};
	ActionAccountCircle = (0, _pure2.default)(ActionAccountCircle);
	ActionAccountCircle.displayName = 'ActionAccountCircle';
	ActionAccountCircle.muiName = 'SvgIcon';
	
	exports.default = ActionAccountCircle;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAddShoppingCart = function ActionAddShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z' })
	  );
	};
	ActionAddShoppingCart = (0, _pure2.default)(ActionAddShoppingCart);
	ActionAddShoppingCart.displayName = 'ActionAddShoppingCart';
	ActionAddShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionAddShoppingCart;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmAdd = function ActionAlarmAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
	  );
	};
	ActionAlarmAdd = (0, _pure2.default)(ActionAlarmAdd);
	ActionAlarmAdd.displayName = 'ActionAlarmAdd';
	ActionAlarmAdd.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmAdd;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmOff = function ActionAlarmOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z' })
	  );
	};
	ActionAlarmOff = (0, _pure2.default)(ActionAlarmOff);
	ActionAlarmOff.displayName = 'ActionAlarmOff';
	ActionAlarmOff.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmOff;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmOn = function ActionAlarmOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z' })
	  );
	};
	ActionAlarmOn = (0, _pure2.default)(ActionAlarmOn);
	ActionAlarmOn.displayName = 'ActionAlarmOn';
	ActionAlarmOn.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmOn;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarm = function ActionAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	ActionAlarm = (0, _pure2.default)(ActionAlarm);
	ActionAlarm.displayName = 'ActionAlarm';
	ActionAlarm.muiName = 'SvgIcon';
	
	exports.default = ActionAlarm;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAllOut = function ActionAllOut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z' })
	  );
	};
	ActionAllOut = (0, _pure2.default)(ActionAllOut);
	ActionAllOut.displayName = 'ActionAllOut';
	ActionAllOut.muiName = 'SvgIcon';
	
	exports.default = ActionAllOut;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAndroid = function ActionAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z' })
	  );
	};
	ActionAndroid = (0, _pure2.default)(ActionAndroid);
	ActionAndroid.displayName = 'ActionAndroid';
	ActionAndroid.muiName = 'SvgIcon';
	
	exports.default = ActionAndroid;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAnnouncement = function ActionAnnouncement(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z' })
	  );
	};
	ActionAnnouncement = (0, _pure2.default)(ActionAnnouncement);
	ActionAnnouncement.displayName = 'ActionAnnouncement';
	ActionAnnouncement.muiName = 'SvgIcon';
	
	exports.default = ActionAnnouncement;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAspectRatio = function ActionAspectRatio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	ActionAspectRatio = (0, _pure2.default)(ActionAspectRatio);
	ActionAspectRatio.displayName = 'ActionAspectRatio';
	ActionAspectRatio.muiName = 'SvgIcon';
	
	exports.default = ActionAspectRatio;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssessment = function ActionAssessment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	ActionAssessment = (0, _pure2.default)(ActionAssessment);
	ActionAssessment.displayName = 'ActionAssessment';
	ActionAssessment.muiName = 'SvgIcon';
	
	exports.default = ActionAssessment;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentInd = function ActionAssignmentInd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z' })
	  );
	};
	ActionAssignmentInd = (0, _pure2.default)(ActionAssignmentInd);
	ActionAssignmentInd.displayName = 'ActionAssignmentInd';
	ActionAssignmentInd.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentInd;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentLate = function ActionAssignmentLate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	ActionAssignmentLate = (0, _pure2.default)(ActionAssignmentLate);
	ActionAssignmentLate.displayName = 'ActionAssignmentLate';
	ActionAssignmentLate.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentLate;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentReturn = function ActionAssignmentReturn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z' })
	  );
	};
	ActionAssignmentReturn = (0, _pure2.default)(ActionAssignmentReturn);
	ActionAssignmentReturn.displayName = 'ActionAssignmentReturn';
	ActionAssignmentReturn.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentReturn;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentReturned = function ActionAssignmentReturned(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z' })
	  );
	};
	ActionAssignmentReturned = (0, _pure2.default)(ActionAssignmentReturned);
	ActionAssignmentReturned.displayName = 'ActionAssignmentReturned';
	ActionAssignmentReturned.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentReturned;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentTurnedIn = function ActionAssignmentTurnedIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
	  );
	};
	ActionAssignmentTurnedIn = (0, _pure2.default)(ActionAssignmentTurnedIn);
	ActionAssignmentTurnedIn.displayName = 'ActionAssignmentTurnedIn';
	ActionAssignmentTurnedIn.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentTurnedIn;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignment = function ActionAssignment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z' })
	  );
	};
	ActionAssignment = (0, _pure2.default)(ActionAssignment);
	ActionAssignment.displayName = 'ActionAssignment';
	ActionAssignment.muiName = 'SvgIcon';
	
	exports.default = ActionAssignment;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAutorenew = function ActionAutorenew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z' })
	  );
	};
	ActionAutorenew = (0, _pure2.default)(ActionAutorenew);
	ActionAutorenew.displayName = 'ActionAutorenew';
	ActionAutorenew.muiName = 'SvgIcon';
	
	exports.default = ActionAutorenew;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBackup = function ActionBackup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
	  );
	};
	ActionBackup = (0, _pure2.default)(ActionBackup);
	ActionBackup.displayName = 'ActionBackup';
	ActionBackup.muiName = 'SvgIcon';
	
	exports.default = ActionBackup;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBook = function ActionBook(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
	  );
	};
	ActionBook = (0, _pure2.default)(ActionBook);
	ActionBook.displayName = 'ActionBook';
	ActionBook.muiName = 'SvgIcon';
	
	exports.default = ActionBook;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBookmarkBorder = function ActionBookmarkBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
	  );
	};
	ActionBookmarkBorder = (0, _pure2.default)(ActionBookmarkBorder);
	ActionBookmarkBorder.displayName = 'ActionBookmarkBorder';
	ActionBookmarkBorder.muiName = 'SvgIcon';
	
	exports.default = ActionBookmarkBorder;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBookmark = function ActionBookmark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionBookmark = (0, _pure2.default)(ActionBookmark);
	ActionBookmark.displayName = 'ActionBookmark';
	ActionBookmark.muiName = 'SvgIcon';
	
	exports.default = ActionBookmark;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBugReport = function ActionBugReport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z' })
	  );
	};
	ActionBugReport = (0, _pure2.default)(ActionBugReport);
	ActionBugReport.displayName = 'ActionBugReport';
	ActionBugReport.muiName = 'SvgIcon';
	
	exports.default = ActionBugReport;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBuild = function ActionBuild(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z' })
	  );
	};
	ActionBuild = (0, _pure2.default)(ActionBuild);
	ActionBuild.displayName = 'ActionBuild';
	ActionBuild.muiName = 'SvgIcon';
	
	exports.default = ActionBuild;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCached = function ActionCached(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z' })
	  );
	};
	ActionCached = (0, _pure2.default)(ActionCached);
	ActionCached.displayName = 'ActionCached';
	ActionCached.muiName = 'SvgIcon';
	
	exports.default = ActionCached;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCameraEnhance = function ActionCameraEnhance(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z' })
	  );
	};
	ActionCameraEnhance = (0, _pure2.default)(ActionCameraEnhance);
	ActionCameraEnhance.displayName = 'ActionCameraEnhance';
	ActionCameraEnhance.muiName = 'SvgIcon';
	
	exports.default = ActionCameraEnhance;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardGiftcard = function ActionCardGiftcard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
	  );
	};
	ActionCardGiftcard = (0, _pure2.default)(ActionCardGiftcard);
	ActionCardGiftcard.displayName = 'ActionCardGiftcard';
	ActionCardGiftcard.muiName = 'SvgIcon';
	
	exports.default = ActionCardGiftcard;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardMembership = function ActionCardMembership(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z' })
	  );
	};
	ActionCardMembership = (0, _pure2.default)(ActionCardMembership);
	ActionCardMembership.displayName = 'ActionCardMembership';
	ActionCardMembership.muiName = 'SvgIcon';
	
	exports.default = ActionCardMembership;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardTravel = function ActionCardTravel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z' })
	  );
	};
	ActionCardTravel = (0, _pure2.default)(ActionCardTravel);
	ActionCardTravel.displayName = 'ActionCardTravel';
	ActionCardTravel.muiName = 'SvgIcon';
	
	exports.default = ActionCardTravel;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionChangeHistory = function ActionChangeHistory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z' })
	  );
	};
	ActionChangeHistory = (0, _pure2.default)(ActionChangeHistory);
	ActionChangeHistory.displayName = 'ActionChangeHistory';
	ActionChangeHistory.muiName = 'SvgIcon';
	
	exports.default = ActionChangeHistory;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionChromeReaderMode = function ActionChromeReaderMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z' })
	  );
	};
	ActionChromeReaderMode = (0, _pure2.default)(ActionChromeReaderMode);
	ActionChromeReaderMode.displayName = 'ActionChromeReaderMode';
	ActionChromeReaderMode.muiName = 'SvgIcon';
	
	exports.default = ActionChromeReaderMode;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionClass = function ActionClass(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
	  );
	};
	ActionClass = (0, _pure2.default)(ActionClass);
	ActionClass.displayName = 'ActionClass';
	ActionClass.muiName = 'SvgIcon';
	
	exports.default = ActionClass;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCode = function ActionCode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' })
	  );
	};
	ActionCode = (0, _pure2.default)(ActionCode);
	ActionCode.displayName = 'ActionCode';
	ActionCode.muiName = 'SvgIcon';
	
	exports.default = ActionCode;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCompareArrows = function ActionCompareArrows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z' })
	  );
	};
	ActionCompareArrows = (0, _pure2.default)(ActionCompareArrows);
	ActionCompareArrows.displayName = 'ActionCompareArrows';
	ActionCompareArrows.muiName = 'SvgIcon';
	
	exports.default = ActionCompareArrows;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCopyright = function ActionCopyright(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ActionCopyright = (0, _pure2.default)(ActionCopyright);
	ActionCopyright.displayName = 'ActionCopyright';
	ActionCopyright.muiName = 'SvgIcon';
	
	exports.default = ActionCopyright;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCreditCard = function ActionCreditCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
	  );
	};
	ActionCreditCard = (0, _pure2.default)(ActionCreditCard);
	ActionCreditCard.displayName = 'ActionCreditCard';
	ActionCreditCard.muiName = 'SvgIcon';
	
	exports.default = ActionCreditCard;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDashboard = function ActionDashboard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' })
	  );
	};
	ActionDashboard = (0, _pure2.default)(ActionDashboard);
	ActionDashboard.displayName = 'ActionDashboard';
	ActionDashboard.muiName = 'SvgIcon';
	
	exports.default = ActionDashboard;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDateRange = function ActionDateRange(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z' })
	  );
	};
	ActionDateRange = (0, _pure2.default)(ActionDateRange);
	ActionDateRange.displayName = 'ActionDateRange';
	ActionDateRange.muiName = 'SvgIcon';
	
	exports.default = ActionDateRange;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDeleteForever = function ActionDeleteForever(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z' })
	  );
	};
	ActionDeleteForever = (0, _pure2.default)(ActionDeleteForever);
	ActionDeleteForever.displayName = 'ActionDeleteForever';
	ActionDeleteForever.muiName = 'SvgIcon';
	
	exports.default = ActionDeleteForever;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDelete = function ActionDelete(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
	  );
	};
	ActionDelete = (0, _pure2.default)(ActionDelete);
	ActionDelete.displayName = 'ActionDelete';
	ActionDelete.muiName = 'SvgIcon';
	
	exports.default = ActionDelete;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDescription = function ActionDescription(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z' })
	  );
	};
	ActionDescription = (0, _pure2.default)(ActionDescription);
	ActionDescription.displayName = 'ActionDescription';
	ActionDescription.muiName = 'SvgIcon';
	
	exports.default = ActionDescription;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDns = function ActionDns(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ActionDns = (0, _pure2.default)(ActionDns);
	ActionDns.displayName = 'ActionDns';
	ActionDns.muiName = 'SvgIcon';
	
	exports.default = ActionDns;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDoneAll = function ActionDoneAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z' })
	  );
	};
	ActionDoneAll = (0, _pure2.default)(ActionDoneAll);
	ActionDoneAll.displayName = 'ActionDoneAll';
	ActionDoneAll.muiName = 'SvgIcon';
	
	exports.default = ActionDoneAll;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDone = function ActionDone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
	  );
	};
	ActionDone = (0, _pure2.default)(ActionDone);
	ActionDone.displayName = 'ActionDone';
	ActionDone.muiName = 'SvgIcon';
	
	exports.default = ActionDone;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDonutLarge = function ActionDonutLarge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z' })
	  );
	};
	ActionDonutLarge = (0, _pure2.default)(ActionDonutLarge);
	ActionDonutLarge.displayName = 'ActionDonutLarge';
	ActionDonutLarge.muiName = 'SvgIcon';
	
	exports.default = ActionDonutLarge;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDonutSmall = function ActionDonutSmall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z' })
	  );
	};
	ActionDonutSmall = (0, _pure2.default)(ActionDonutSmall);
	ActionDonutSmall.displayName = 'ActionDonutSmall';
	ActionDonutSmall.muiName = 'SvgIcon';
	
	exports.default = ActionDonutSmall;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEject = function ActionEject(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17h14v2H5zm7-12L5.33 15h13.34z' })
	  );
	};
	ActionEject = (0, _pure2.default)(ActionEject);
	ActionEject.displayName = 'ActionEject';
	ActionEject.muiName = 'SvgIcon';
	
	exports.default = ActionEject;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEuroSymbol = function ActionEuroSymbol(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z' })
	  );
	};
	ActionEuroSymbol = (0, _pure2.default)(ActionEuroSymbol);
	ActionEuroSymbol.displayName = 'ActionEuroSymbol';
	ActionEuroSymbol.muiName = 'SvgIcon';
	
	exports.default = ActionEuroSymbol;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEventSeat = function ActionEventSeat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z' })
	  );
	};
	ActionEventSeat = (0, _pure2.default)(ActionEventSeat);
	ActionEventSeat.displayName = 'ActionEventSeat';
	ActionEventSeat.muiName = 'SvgIcon';
	
	exports.default = ActionEventSeat;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEvent = function ActionEvent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
	  );
	};
	ActionEvent = (0, _pure2.default)(ActionEvent);
	ActionEvent.displayName = 'ActionEvent';
	ActionEvent.muiName = 'SvgIcon';
	
	exports.default = ActionEvent;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExitToApp = function ActionExitToApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionExitToApp = (0, _pure2.default)(ActionExitToApp);
	ActionExitToApp.displayName = 'ActionExitToApp';
	ActionExitToApp.muiName = 'SvgIcon';
	
	exports.default = ActionExitToApp;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExplore = function ActionExplore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z' })
	  );
	};
	ActionExplore = (0, _pure2.default)(ActionExplore);
	ActionExplore.displayName = 'ActionExplore';
	ActionExplore.muiName = 'SvgIcon';
	
	exports.default = ActionExplore;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExtension = function ActionExtension(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' })
	  );
	};
	ActionExtension = (0, _pure2.default)(ActionExtension);
	ActionExtension.displayName = 'ActionExtension';
	ActionExtension.muiName = 'SvgIcon';
	
	exports.default = ActionExtension;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFace = function ActionFace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z' })
	  );
	};
	ActionFace = (0, _pure2.default)(ActionFace);
	ActionFace.displayName = 'ActionFace';
	ActionFace.muiName = 'SvgIcon';
	
	exports.default = ActionFace;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFavoriteBorder = function ActionFavoriteBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z' })
	  );
	};
	ActionFavoriteBorder = (0, _pure2.default)(ActionFavoriteBorder);
	ActionFavoriteBorder.displayName = 'ActionFavoriteBorder';
	ActionFavoriteBorder.muiName = 'SvgIcon';
	
	exports.default = ActionFavoriteBorder;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFavorite = function ActionFavorite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z' })
	  );
	};
	ActionFavorite = (0, _pure2.default)(ActionFavorite);
	ActionFavorite.displayName = 'ActionFavorite';
	ActionFavorite.muiName = 'SvgIcon';
	
	exports.default = ActionFavorite;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFeedback = function ActionFeedback(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
	  );
	};
	ActionFeedback = (0, _pure2.default)(ActionFeedback);
	ActionFeedback.displayName = 'ActionFeedback';
	ActionFeedback.muiName = 'SvgIcon';
	
	exports.default = ActionFeedback;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFindInPage = function ActionFindInPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z' })
	  );
	};
	ActionFindInPage = (0, _pure2.default)(ActionFindInPage);
	ActionFindInPage.displayName = 'ActionFindInPage';
	ActionFindInPage.muiName = 'SvgIcon';
	
	exports.default = ActionFindInPage;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFindReplace = function ActionFindReplace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z' })
	  );
	};
	ActionFindReplace = (0, _pure2.default)(ActionFindReplace);
	ActionFindReplace.displayName = 'ActionFindReplace';
	ActionFindReplace.muiName = 'SvgIcon';
	
	exports.default = ActionFindReplace;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFingerprint = function ActionFingerprint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z' })
	  );
	};
	ActionFingerprint = (0, _pure2.default)(ActionFingerprint);
	ActionFingerprint.displayName = 'ActionFingerprint';
	ActionFingerprint.muiName = 'SvgIcon';
	
	exports.default = ActionFingerprint;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlightLand = function ActionFlightLand(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z' })
	  );
	};
	ActionFlightLand = (0, _pure2.default)(ActionFlightLand);
	ActionFlightLand.displayName = 'ActionFlightLand';
	ActionFlightLand.muiName = 'SvgIcon';
	
	exports.default = ActionFlightLand;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlightTakeoff = function ActionFlightTakeoff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z' })
	  );
	};
	ActionFlightTakeoff = (0, _pure2.default)(ActionFlightTakeoff);
	ActionFlightTakeoff.displayName = 'ActionFlightTakeoff';
	ActionFlightTakeoff.muiName = 'SvgIcon';
	
	exports.default = ActionFlightTakeoff;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlipToBack = function ActionFlipToBack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z' })
	  );
	};
	ActionFlipToBack = (0, _pure2.default)(ActionFlipToBack);
	ActionFlipToBack.displayName = 'ActionFlipToBack';
	ActionFlipToBack.muiName = 'SvgIcon';
	
	exports.default = ActionFlipToBack;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlipToFront = function ActionFlipToFront(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z' })
	  );
	};
	ActionFlipToFront = (0, _pure2.default)(ActionFlipToFront);
	ActionFlipToFront.displayName = 'ActionFlipToFront';
	ActionFlipToFront.muiName = 'SvgIcon';
	
	exports.default = ActionFlipToFront;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGTranslate = function ActionGTranslate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z' })
	  );
	};
	ActionGTranslate = (0, _pure2.default)(ActionGTranslate);
	ActionGTranslate.displayName = 'ActionGTranslate';
	ActionGTranslate.muiName = 'SvgIcon';
	
	exports.default = ActionGTranslate;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGavel = function ActionGavel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z' })
	  );
	};
	ActionGavel = (0, _pure2.default)(ActionGavel);
	ActionGavel.displayName = 'ActionGavel';
	ActionGavel.muiName = 'SvgIcon';
	
	exports.default = ActionGavel;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGetApp = function ActionGetApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
	  );
	};
	ActionGetApp = (0, _pure2.default)(ActionGetApp);
	ActionGetApp.displayName = 'ActionGetApp';
	ActionGetApp.muiName = 'SvgIcon';
	
	exports.default = ActionGetApp;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGif = function ActionGif(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z' })
	  );
	};
	ActionGif = (0, _pure2.default)(ActionGif);
	ActionGif.displayName = 'ActionGif';
	ActionGif.muiName = 'SvgIcon';
	
	exports.default = ActionGif;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGrade = function ActionGrade(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
	  );
	};
	ActionGrade = (0, _pure2.default)(ActionGrade);
	ActionGrade.displayName = 'ActionGrade';
	ActionGrade.muiName = 'SvgIcon';
	
	exports.default = ActionGrade;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGroupWork = function ActionGroupWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	ActionGroupWork = (0, _pure2.default)(ActionGroupWork);
	ActionGroupWork.displayName = 'ActionGroupWork';
	ActionGroupWork.muiName = 'SvgIcon';
	
	exports.default = ActionGroupWork;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHelpOutline = function ActionHelpOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' })
	  );
	};
	ActionHelpOutline = (0, _pure2.default)(ActionHelpOutline);
	ActionHelpOutline.displayName = 'ActionHelpOutline';
	ActionHelpOutline.muiName = 'SvgIcon';
	
	exports.default = ActionHelpOutline;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHelp = function ActionHelp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
	  );
	};
	ActionHelp = (0, _pure2.default)(ActionHelp);
	ActionHelp.displayName = 'ActionHelp';
	ActionHelp.muiName = 'SvgIcon';
	
	exports.default = ActionHelp;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHighlightOff = function ActionHighlightOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ActionHighlightOff = (0, _pure2.default)(ActionHighlightOff);
	ActionHighlightOff.displayName = 'ActionHighlightOff';
	ActionHighlightOff.muiName = 'SvgIcon';
	
	exports.default = ActionHighlightOff;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHistory = function ActionHistory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
	  );
	};
	ActionHistory = (0, _pure2.default)(ActionHistory);
	ActionHistory.displayName = 'ActionHistory';
	ActionHistory.muiName = 'SvgIcon';
	
	exports.default = ActionHistory;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHome = function ActionHome(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
	  );
	};
	ActionHome = (0, _pure2.default)(ActionHome);
	ActionHome.displayName = 'ActionHome';
	ActionHome.muiName = 'SvgIcon';
	
	exports.default = ActionHome;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHourglassEmpty = function ActionHourglassEmpty(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z' })
	  );
	};
	ActionHourglassEmpty = (0, _pure2.default)(ActionHourglassEmpty);
	ActionHourglassEmpty.displayName = 'ActionHourglassEmpty';
	ActionHourglassEmpty.muiName = 'SvgIcon';
	
	exports.default = ActionHourglassEmpty;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHourglassFull = function ActionHourglassFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z' })
	  );
	};
	ActionHourglassFull = (0, _pure2.default)(ActionHourglassFull);
	ActionHourglassFull.displayName = 'ActionHourglassFull';
	ActionHourglassFull.muiName = 'SvgIcon';
	
	exports.default = ActionHourglassFull;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHttp = function ActionHttp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z' })
	  );
	};
	ActionHttp = (0, _pure2.default)(ActionHttp);
	ActionHttp.displayName = 'ActionHttp';
	ActionHttp.muiName = 'SvgIcon';
	
	exports.default = ActionHttp;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHttps = function ActionHttps(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
	  );
	};
	ActionHttps = (0, _pure2.default)(ActionHttps);
	ActionHttps.displayName = 'ActionHttps';
	ActionHttps.muiName = 'SvgIcon';
	
	exports.default = ActionHttps;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionImportantDevices = function ActionImportantDevices(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z' })
	  );
	};
	ActionImportantDevices = (0, _pure2.default)(ActionImportantDevices);
	ActionImportantDevices.displayName = 'ActionImportantDevices';
	ActionImportantDevices.muiName = 'SvgIcon';
	
	exports.default = ActionImportantDevices;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInfoOutline = function ActionInfoOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z' })
	  );
	};
	ActionInfoOutline = (0, _pure2.default)(ActionInfoOutline);
	ActionInfoOutline.displayName = 'ActionInfoOutline';
	ActionInfoOutline.muiName = 'SvgIcon';
	
	exports.default = ActionInfoOutline;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInfo = function ActionInfo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
	  );
	};
	ActionInfo = (0, _pure2.default)(ActionInfo);
	ActionInfo.displayName = 'ActionInfo';
	ActionInfo.muiName = 'SvgIcon';
	
	exports.default = ActionInfo;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInput = function ActionInput(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z' })
	  );
	};
	ActionInput = (0, _pure2.default)(ActionInput);
	ActionInput.displayName = 'ActionInput';
	ActionInput.muiName = 'SvgIcon';
	
	exports.default = ActionInput;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInvertColors = function ActionInvertColors(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z' })
	  );
	};
	ActionInvertColors = (0, _pure2.default)(ActionInvertColors);
	ActionInvertColors.displayName = 'ActionInvertColors';
	ActionInvertColors.muiName = 'SvgIcon';
	
	exports.default = ActionInvertColors;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLabelOutline = function ActionLabelOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z' })
	  );
	};
	ActionLabelOutline = (0, _pure2.default)(ActionLabelOutline);
	ActionLabelOutline.displayName = 'ActionLabelOutline';
	ActionLabelOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLabelOutline;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLabel = function ActionLabel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z' })
	  );
	};
	ActionLabel = (0, _pure2.default)(ActionLabel);
	ActionLabel.displayName = 'ActionLabel';
	ActionLabel.muiName = 'SvgIcon';
	
	exports.default = ActionLabel;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLanguage = function ActionLanguage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z' })
	  );
	};
	ActionLanguage = (0, _pure2.default)(ActionLanguage);
	ActionLanguage.displayName = 'ActionLanguage';
	ActionLanguage.muiName = 'SvgIcon';
	
	exports.default = ActionLanguage;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLaunch = function ActionLaunch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
	  );
	};
	ActionLaunch = (0, _pure2.default)(ActionLaunch);
	ActionLaunch.displayName = 'ActionLaunch';
	ActionLaunch.muiName = 'SvgIcon';
	
	exports.default = ActionLaunch;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLightbulbOutline = function ActionLightbulbOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z' })
	  );
	};
	ActionLightbulbOutline = (0, _pure2.default)(ActionLightbulbOutline);
	ActionLightbulbOutline.displayName = 'ActionLightbulbOutline';
	ActionLightbulbOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLightbulbOutline;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLineStyle = function ActionLineStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z' })
	  );
	};
	ActionLineStyle = (0, _pure2.default)(ActionLineStyle);
	ActionLineStyle.displayName = 'ActionLineStyle';
	ActionLineStyle.muiName = 'SvgIcon';
	
	exports.default = ActionLineStyle;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLineWeight = function ActionLineWeight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z' })
	  );
	};
	ActionLineWeight = (0, _pure2.default)(ActionLineWeight);
	ActionLineWeight.displayName = 'ActionLineWeight';
	ActionLineWeight.muiName = 'SvgIcon';
	
	exports.default = ActionLineWeight;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionList = function ActionList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z' })
	  );
	};
	ActionList = (0, _pure2.default)(ActionList);
	ActionList.displayName = 'ActionList';
	ActionList.muiName = 'SvgIcon';
	
	exports.default = ActionList;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLockOpen = function ActionLockOpen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z' })
	  );
	};
	ActionLockOpen = (0, _pure2.default)(ActionLockOpen);
	ActionLockOpen.displayName = 'ActionLockOpen';
	ActionLockOpen.muiName = 'SvgIcon';
	
	exports.default = ActionLockOpen;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLockOutline = function ActionLockOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z' })
	  );
	};
	ActionLockOutline = (0, _pure2.default)(ActionLockOutline);
	ActionLockOutline.displayName = 'ActionLockOutline';
	ActionLockOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLockOutline;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLock = function ActionLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
	  );
	};
	ActionLock = (0, _pure2.default)(ActionLock);
	ActionLock.displayName = 'ActionLock';
	ActionLock.muiName = 'SvgIcon';
	
	exports.default = ActionLock;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLoyalty = function ActionLoyalty(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z' })
	  );
	};
	ActionLoyalty = (0, _pure2.default)(ActionLoyalty);
	ActionLoyalty.displayName = 'ActionLoyalty';
	ActionLoyalty.muiName = 'SvgIcon';
	
	exports.default = ActionLoyalty;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionMarkunreadMailbox = function ActionMarkunreadMailbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionMarkunreadMailbox = (0, _pure2.default)(ActionMarkunreadMailbox);
	ActionMarkunreadMailbox.displayName = 'ActionMarkunreadMailbox';
	ActionMarkunreadMailbox.muiName = 'SvgIcon';
	
	exports.default = ActionMarkunreadMailbox;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionMotorcycle = function ActionMotorcycle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z' })
	  );
	};
	ActionMotorcycle = (0, _pure2.default)(ActionMotorcycle);
	ActionMotorcycle.displayName = 'ActionMotorcycle';
	ActionMotorcycle.muiName = 'SvgIcon';
	
	exports.default = ActionMotorcycle;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionNoteAdd = function ActionNoteAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z' })
	  );
	};
	ActionNoteAdd = (0, _pure2.default)(ActionNoteAdd);
	ActionNoteAdd.displayName = 'ActionNoteAdd';
	ActionNoteAdd.muiName = 'SvgIcon';
	
	exports.default = ActionNoteAdd;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOfflinePin = function ActionOfflinePin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z' })
	  );
	};
	ActionOfflinePin = (0, _pure2.default)(ActionOfflinePin);
	ActionOfflinePin.displayName = 'ActionOfflinePin';
	ActionOfflinePin.muiName = 'SvgIcon';
	
	exports.default = ActionOfflinePin;

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpacity = function ActionOpacity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z' })
	  );
	};
	ActionOpacity = (0, _pure2.default)(ActionOpacity);
	ActionOpacity.displayName = 'ActionOpacity';
	ActionOpacity.muiName = 'SvgIcon';
	
	exports.default = ActionOpacity;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenInBrowser = function ActionOpenInBrowser(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z' })
	  );
	};
	ActionOpenInBrowser = (0, _pure2.default)(ActionOpenInBrowser);
	ActionOpenInBrowser.displayName = 'ActionOpenInBrowser';
	ActionOpenInBrowser.muiName = 'SvgIcon';
	
	exports.default = ActionOpenInBrowser;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenInNew = function ActionOpenInNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
	  );
	};
	ActionOpenInNew = (0, _pure2.default)(ActionOpenInNew);
	ActionOpenInNew.displayName = 'ActionOpenInNew';
	ActionOpenInNew.muiName = 'SvgIcon';
	
	exports.default = ActionOpenInNew;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenWith = function ActionOpenWith(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z' })
	  );
	};
	ActionOpenWith = (0, _pure2.default)(ActionOpenWith);
	ActionOpenWith.displayName = 'ActionOpenWith';
	ActionOpenWith.muiName = 'SvgIcon';
	
	exports.default = ActionOpenWith;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPageview = function ActionPageview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z' })
	  );
	};
	ActionPageview = (0, _pure2.default)(ActionPageview);
	ActionPageview.displayName = 'ActionPageview';
	ActionPageview.muiName = 'SvgIcon';
	
	exports.default = ActionPageview;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPanTool = function ActionPanTool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z' })
	  );
	};
	ActionPanTool = (0, _pure2.default)(ActionPanTool);
	ActionPanTool.displayName = 'ActionPanTool';
	ActionPanTool.muiName = 'SvgIcon';
	
	exports.default = ActionPanTool;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPayment = function ActionPayment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
	  );
	};
	ActionPayment = (0, _pure2.default)(ActionPayment);
	ActionPayment.displayName = 'ActionPayment';
	ActionPayment.muiName = 'SvgIcon';
	
	exports.default = ActionPayment;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermCameraMic = function ActionPermCameraMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z' })
	  );
	};
	ActionPermCameraMic = (0, _pure2.default)(ActionPermCameraMic);
	ActionPermCameraMic.displayName = 'ActionPermCameraMic';
	ActionPermCameraMic.muiName = 'SvgIcon';
	
	exports.default = ActionPermCameraMic;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermContactCalendar = function ActionPermContactCalendar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z' })
	  );
	};
	ActionPermContactCalendar = (0, _pure2.default)(ActionPermContactCalendar);
	ActionPermContactCalendar.displayName = 'ActionPermContactCalendar';
	ActionPermContactCalendar.muiName = 'SvgIcon';
	
	exports.default = ActionPermContactCalendar;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermDataSetting = function ActionPermDataSetting(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ActionPermDataSetting = (0, _pure2.default)(ActionPermDataSetting);
	ActionPermDataSetting.displayName = 'ActionPermDataSetting';
	ActionPermDataSetting.muiName = 'SvgIcon';
	
	exports.default = ActionPermDataSetting;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermDeviceInformation = function ActionPermDeviceInformation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	ActionPermDeviceInformation = (0, _pure2.default)(ActionPermDeviceInformation);
	ActionPermDeviceInformation.displayName = 'ActionPermDeviceInformation';
	ActionPermDeviceInformation.muiName = 'SvgIcon';
	
	exports.default = ActionPermDeviceInformation;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermIdentity = function ActionPermIdentity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
	  );
	};
	ActionPermIdentity = (0, _pure2.default)(ActionPermIdentity);
	ActionPermIdentity.displayName = 'ActionPermIdentity';
	ActionPermIdentity.muiName = 'SvgIcon';
	
	exports.default = ActionPermIdentity;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermMedia = function ActionPermMedia(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z' })
	  );
	};
	ActionPermMedia = (0, _pure2.default)(ActionPermMedia);
	ActionPermMedia.displayName = 'ActionPermMedia';
	ActionPermMedia.muiName = 'SvgIcon';
	
	exports.default = ActionPermMedia;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermPhoneMsg = function ActionPermPhoneMsg(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z' })
	  );
	};
	ActionPermPhoneMsg = (0, _pure2.default)(ActionPermPhoneMsg);
	ActionPermPhoneMsg.displayName = 'ActionPermPhoneMsg';
	ActionPermPhoneMsg.muiName = 'SvgIcon';
	
	exports.default = ActionPermPhoneMsg;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermScanWifi = function ActionPermScanWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z' })
	  );
	};
	ActionPermScanWifi = (0, _pure2.default)(ActionPermScanWifi);
	ActionPermScanWifi.displayName = 'ActionPermScanWifi';
	ActionPermScanWifi.muiName = 'SvgIcon';
	
	exports.default = ActionPermScanWifi;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPets = function ActionPets(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '4.5', cy: '9.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '9', cy: '5.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '15', cy: '5.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '19.5', cy: '9.5', r: '2.5' }),
	    _react2.default.createElement('path', { d: 'M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z' })
	  );
	};
	ActionPets = (0, _pure2.default)(ActionPets);
	ActionPets.displayName = 'ActionPets';
	ActionPets.muiName = 'SvgIcon';
	
	exports.default = ActionPets;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPictureInPictureAlt = function ActionPictureInPictureAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z' })
	  );
	};
	ActionPictureInPictureAlt = (0, _pure2.default)(ActionPictureInPictureAlt);
	ActionPictureInPictureAlt.displayName = 'ActionPictureInPictureAlt';
	ActionPictureInPictureAlt.muiName = 'SvgIcon';
	
	exports.default = ActionPictureInPictureAlt;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPictureInPicture = function ActionPictureInPicture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z' })
	  );
	};
	ActionPictureInPicture = (0, _pure2.default)(ActionPictureInPicture);
	ActionPictureInPicture.displayName = 'ActionPictureInPicture';
	ActionPictureInPicture.muiName = 'SvgIcon';
	
	exports.default = ActionPictureInPicture;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPlayForWork = function ActionPlayForWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z' })
	  );
	};
	ActionPlayForWork = (0, _pure2.default)(ActionPlayForWork);
	ActionPlayForWork.displayName = 'ActionPlayForWork';
	ActionPlayForWork.muiName = 'SvgIcon';
	
	exports.default = ActionPlayForWork;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPolymer = function ActionPolymer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z' })
	  );
	};
	ActionPolymer = (0, _pure2.default)(ActionPolymer);
	ActionPolymer.displayName = 'ActionPolymer';
	ActionPolymer.muiName = 'SvgIcon';
	
	exports.default = ActionPolymer;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPowerSettingsNew = function ActionPowerSettingsNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z' })
	  );
	};
	ActionPowerSettingsNew = (0, _pure2.default)(ActionPowerSettingsNew);
	ActionPowerSettingsNew.displayName = 'ActionPowerSettingsNew';
	ActionPowerSettingsNew.muiName = 'SvgIcon';
	
	exports.default = ActionPowerSettingsNew;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPregnantWoman = function ActionPregnantWoman(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z' })
	  );
	};
	ActionPregnantWoman = (0, _pure2.default)(ActionPregnantWoman);
	ActionPregnantWoman.displayName = 'ActionPregnantWoman';
	ActionPregnantWoman.muiName = 'SvgIcon';
	
	exports.default = ActionPregnantWoman;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPrint = function ActionPrint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
	  );
	};
	ActionPrint = (0, _pure2.default)(ActionPrint);
	ActionPrint.displayName = 'ActionPrint';
	ActionPrint.muiName = 'SvgIcon';
	
	exports.default = ActionPrint;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionQueryBuilder = function ActionQueryBuilder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	ActionQueryBuilder = (0, _pure2.default)(ActionQueryBuilder);
	ActionQueryBuilder.displayName = 'ActionQueryBuilder';
	ActionQueryBuilder.muiName = 'SvgIcon';
	
	exports.default = ActionQueryBuilder;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionQuestionAnswer = function ActionQuestionAnswer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
	  );
	};
	ActionQuestionAnswer = (0, _pure2.default)(ActionQuestionAnswer);
	ActionQuestionAnswer.displayName = 'ActionQuestionAnswer';
	ActionQuestionAnswer.muiName = 'SvgIcon';
	
	exports.default = ActionQuestionAnswer;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReceipt = function ActionReceipt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z' })
	  );
	};
	ActionReceipt = (0, _pure2.default)(ActionReceipt);
	ActionReceipt.displayName = 'ActionReceipt';
	ActionReceipt.muiName = 'SvgIcon';
	
	exports.default = ActionReceipt;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRecordVoiceOver = function ActionRecordVoiceOver(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '9', cy: '9', r: '4' }),
	    _react2.default.createElement('path', { d: 'M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z' })
	  );
	};
	ActionRecordVoiceOver = (0, _pure2.default)(ActionRecordVoiceOver);
	ActionRecordVoiceOver.displayName = 'ActionRecordVoiceOver';
	ActionRecordVoiceOver.muiName = 'SvgIcon';
	
	exports.default = ActionRecordVoiceOver;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRedeem = function ActionRedeem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
	  );
	};
	ActionRedeem = (0, _pure2.default)(ActionRedeem);
	ActionRedeem.displayName = 'ActionRedeem';
	ActionRedeem.muiName = 'SvgIcon';
	
	exports.default = ActionRedeem;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRemoveShoppingCart = function ActionRemoveShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ActionRemoveShoppingCart = (0, _pure2.default)(ActionRemoveShoppingCart);
	ActionRemoveShoppingCart.displayName = 'ActionRemoveShoppingCart';
	ActionRemoveShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionRemoveShoppingCart;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReorder = function ActionReorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z' })
	  );
	};
	ActionReorder = (0, _pure2.default)(ActionReorder);
	ActionReorder.displayName = 'ActionReorder';
	ActionReorder.muiName = 'SvgIcon';
	
	exports.default = ActionReorder;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReportProblem = function ActionReportProblem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
	  );
	};
	ActionReportProblem = (0, _pure2.default)(ActionReportProblem);
	ActionReportProblem.displayName = 'ActionReportProblem';
	ActionReportProblem.muiName = 'SvgIcon';
	
	exports.default = ActionReportProblem;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRestorePage = function ActionRestorePage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z' })
	  );
	};
	ActionRestorePage = (0, _pure2.default)(ActionRestorePage);
	ActionRestorePage.displayName = 'ActionRestorePage';
	ActionRestorePage.muiName = 'SvgIcon';
	
	exports.default = ActionRestorePage;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRestore = function ActionRestore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
	  );
	};
	ActionRestore = (0, _pure2.default)(ActionRestore);
	ActionRestore.displayName = 'ActionRestore';
	ActionRestore.muiName = 'SvgIcon';
	
	exports.default = ActionRestore;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRoom = function ActionRoom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	ActionRoom = (0, _pure2.default)(ActionRoom);
	ActionRoom.displayName = 'ActionRoom';
	ActionRoom.muiName = 'SvgIcon';
	
	exports.default = ActionRoom;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRoundedCorner = function ActionRoundedCorner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z' })
	  );
	};
	ActionRoundedCorner = (0, _pure2.default)(ActionRoundedCorner);
	ActionRoundedCorner.displayName = 'ActionRoundedCorner';
	ActionRoundedCorner.muiName = 'SvgIcon';
	
	exports.default = ActionRoundedCorner;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRowing = function ActionRowing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z' })
	  );
	};
	ActionRowing = (0, _pure2.default)(ActionRowing);
	ActionRowing.displayName = 'ActionRowing';
	ActionRowing.muiName = 'SvgIcon';
	
	exports.default = ActionRowing;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSchedule = function ActionSchedule(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	ActionSchedule = (0, _pure2.default)(ActionSchedule);
	ActionSchedule.displayName = 'ActionSchedule';
	ActionSchedule.muiName = 'SvgIcon';
	
	exports.default = ActionSchedule;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSearch = function ActionSearch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })
	  );
	};
	ActionSearch = (0, _pure2.default)(ActionSearch);
	ActionSearch.displayName = 'ActionSearch';
	ActionSearch.muiName = 'SvgIcon';
	
	exports.default = ActionSearch;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsApplications = function ActionSettingsApplications(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z' })
	  );
	};
	ActionSettingsApplications = (0, _pure2.default)(ActionSettingsApplications);
	ActionSettingsApplications.displayName = 'ActionSettingsApplications';
	ActionSettingsApplications.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsApplications;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBackupRestore = function ActionSettingsBackupRestore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z' })
	  );
	};
	ActionSettingsBackupRestore = (0, _pure2.default)(ActionSettingsBackupRestore);
	ActionSettingsBackupRestore.displayName = 'ActionSettingsBackupRestore';
	ActionSettingsBackupRestore.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBackupRestore;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBluetooth = function ActionSettingsBluetooth(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z' })
	  );
	};
	ActionSettingsBluetooth = (0, _pure2.default)(ActionSettingsBluetooth);
	ActionSettingsBluetooth.displayName = 'ActionSettingsBluetooth';
	ActionSettingsBluetooth.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBluetooth;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBrightness = function ActionSettingsBrightness(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z' })
	  );
	};
	ActionSettingsBrightness = (0, _pure2.default)(ActionSettingsBrightness);
	ActionSettingsBrightness.displayName = 'ActionSettingsBrightness';
	ActionSettingsBrightness.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBrightness;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsCell = function ActionSettingsCell(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z' })
	  );
	};
	ActionSettingsCell = (0, _pure2.default)(ActionSettingsCell);
	ActionSettingsCell.displayName = 'ActionSettingsCell';
	ActionSettingsCell.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsCell;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsEthernet = function ActionSettingsEthernet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z' })
	  );
	};
	ActionSettingsEthernet = (0, _pure2.default)(ActionSettingsEthernet);
	ActionSettingsEthernet.displayName = 'ActionSettingsEthernet';
	ActionSettingsEthernet.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsEthernet;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputAntenna = function ActionSettingsInputAntenna(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z' })
	  );
	};
	ActionSettingsInputAntenna = (0, _pure2.default)(ActionSettingsInputAntenna);
	ActionSettingsInputAntenna.displayName = 'ActionSettingsInputAntenna';
	ActionSettingsInputAntenna.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputAntenna;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputComponent = function ActionSettingsInputComponent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
	  );
	};
	ActionSettingsInputComponent = (0, _pure2.default)(ActionSettingsInputComponent);
	ActionSettingsInputComponent.displayName = 'ActionSettingsInputComponent';
	ActionSettingsInputComponent.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputComponent;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputComposite = function ActionSettingsInputComposite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
	  );
	};
	ActionSettingsInputComposite = (0, _pure2.default)(ActionSettingsInputComposite);
	ActionSettingsInputComposite.displayName = 'ActionSettingsInputComposite';
	ActionSettingsInputComposite.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputComposite;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputHdmi = function ActionSettingsInputHdmi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z' })
	  );
	};
	ActionSettingsInputHdmi = (0, _pure2.default)(ActionSettingsInputHdmi);
	ActionSettingsInputHdmi.displayName = 'ActionSettingsInputHdmi';
	ActionSettingsInputHdmi.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputHdmi;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputSvideo = function ActionSettingsInputSvideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
	  );
	};
	ActionSettingsInputSvideo = (0, _pure2.default)(ActionSettingsInputSvideo);
	ActionSettingsInputSvideo.displayName = 'ActionSettingsInputSvideo';
	ActionSettingsInputSvideo.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputSvideo;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsOverscan = function ActionSettingsOverscan(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	ActionSettingsOverscan = (0, _pure2.default)(ActionSettingsOverscan);
	ActionSettingsOverscan.displayName = 'ActionSettingsOverscan';
	ActionSettingsOverscan.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsOverscan;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsPhone = function ActionSettingsPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z' })
	  );
	};
	ActionSettingsPhone = (0, _pure2.default)(ActionSettingsPhone);
	ActionSettingsPhone.displayName = 'ActionSettingsPhone';
	ActionSettingsPhone.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsPhone;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsPower = function ActionSettingsPower(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z' })
	  );
	};
	ActionSettingsPower = (0, _pure2.default)(ActionSettingsPower);
	ActionSettingsPower.displayName = 'ActionSettingsPower';
	ActionSettingsPower.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsPower;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsRemote = function ActionSettingsRemote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z' })
	  );
	};
	ActionSettingsRemote = (0, _pure2.default)(ActionSettingsRemote);
	ActionSettingsRemote.displayName = 'ActionSettingsRemote';
	ActionSettingsRemote.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsRemote;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsVoice = function ActionSettingsVoice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z' })
	  );
	};
	ActionSettingsVoice = (0, _pure2.default)(ActionSettingsVoice);
	ActionSettingsVoice.displayName = 'ActionSettingsVoice';
	ActionSettingsVoice.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsVoice;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettings = function ActionSettings(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z' })
	  );
	};
	ActionSettings = (0, _pure2.default)(ActionSettings);
	ActionSettings.displayName = 'ActionSettings';
	ActionSettings.muiName = 'SvgIcon';
	
	exports.default = ActionSettings;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShopTwo = function ActionShopTwo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z' })
	  );
	};
	ActionShopTwo = (0, _pure2.default)(ActionShopTwo);
	ActionShopTwo.displayName = 'ActionShopTwo';
	ActionShopTwo.muiName = 'SvgIcon';
	
	exports.default = ActionShopTwo;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShop = function ActionShop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z' })
	  );
	};
	ActionShop = (0, _pure2.default)(ActionShop);
	ActionShop.displayName = 'ActionShop';
	ActionShop.muiName = 'SvgIcon';
	
	exports.default = ActionShop;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShoppingBasket = function ActionShoppingBasket(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ActionShoppingBasket = (0, _pure2.default)(ActionShoppingBasket);
	ActionShoppingBasket.displayName = 'ActionShoppingBasket';
	ActionShoppingBasket.muiName = 'SvgIcon';
	
	exports.default = ActionShoppingBasket;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShoppingCart = function ActionShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ActionShoppingCart = (0, _pure2.default)(ActionShoppingCart);
	ActionShoppingCart.displayName = 'ActionShoppingCart';
	ActionShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionShoppingCart;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpeakerNotesOff = function ActionSpeakerNotesOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionSpeakerNotesOff = (0, _pure2.default)(ActionSpeakerNotesOff);
	ActionSpeakerNotesOff.displayName = 'ActionSpeakerNotesOff';
	ActionSpeakerNotesOff.muiName = 'SvgIcon';
	
	exports.default = ActionSpeakerNotesOff;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpeakerNotes = function ActionSpeakerNotes(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z' })
	  );
	};
	ActionSpeakerNotes = (0, _pure2.default)(ActionSpeakerNotes);
	ActionSpeakerNotes.displayName = 'ActionSpeakerNotes';
	ActionSpeakerNotes.muiName = 'SvgIcon';
	
	exports.default = ActionSpeakerNotes;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpellcheck = function ActionSpellcheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z' })
	  );
	};
	ActionSpellcheck = (0, _pure2.default)(ActionSpellcheck);
	ActionSpellcheck.displayName = 'ActionSpellcheck';
	ActionSpellcheck.muiName = 'SvgIcon';
	
	exports.default = ActionSpellcheck;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionStars = function ActionStars(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z' })
	  );
	};
	ActionStars = (0, _pure2.default)(ActionStars);
	ActionStars.displayName = 'ActionStars';
	ActionStars.muiName = 'SvgIcon';
	
	exports.default = ActionStars;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionStore = function ActionStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
	  );
	};
	ActionStore = (0, _pure2.default)(ActionStore);
	ActionStore.displayName = 'ActionStore';
	ActionStore.muiName = 'SvgIcon';
	
	exports.default = ActionStore;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSubject = function ActionSubject(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' })
	  );
	};
	ActionSubject = (0, _pure2.default)(ActionSubject);
	ActionSubject.displayName = 'ActionSubject';
	ActionSubject.muiName = 'SvgIcon';
	
	exports.default = ActionSubject;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSupervisorAccount = function ActionSupervisorAccount(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z' })
	  );
	};
	ActionSupervisorAccount = (0, _pure2.default)(ActionSupervisorAccount);
	ActionSupervisorAccount.displayName = 'ActionSupervisorAccount';
	ActionSupervisorAccount.muiName = 'SvgIcon';
	
	exports.default = ActionSupervisorAccount;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapHoriz = function ActionSwapHoriz(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' })
	  );
	};
	ActionSwapHoriz = (0, _pure2.default)(ActionSwapHoriz);
	ActionSwapHoriz.displayName = 'ActionSwapHoriz';
	ActionSwapHoriz.muiName = 'SvgIcon';
	
	exports.default = ActionSwapHoriz;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapVert = function ActionSwapVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z' })
	  );
	};
	ActionSwapVert = (0, _pure2.default)(ActionSwapVert);
	ActionSwapVert.displayName = 'ActionSwapVert';
	ActionSwapVert.muiName = 'SvgIcon';
	
	exports.default = ActionSwapVert;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapVerticalCircle = function ActionSwapVerticalCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z' })
	  );
	};
	ActionSwapVerticalCircle = (0, _pure2.default)(ActionSwapVerticalCircle);
	ActionSwapVerticalCircle.displayName = 'ActionSwapVerticalCircle';
	ActionSwapVerticalCircle.muiName = 'SvgIcon';
	
	exports.default = ActionSwapVerticalCircle;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSystemUpdateAlt = function ActionSystemUpdateAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionSystemUpdateAlt = (0, _pure2.default)(ActionSystemUpdateAlt);
	ActionSystemUpdateAlt.displayName = 'ActionSystemUpdateAlt';
	ActionSystemUpdateAlt.muiName = 'SvgIcon';
	
	exports.default = ActionSystemUpdateAlt;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTabUnselected = function ActionTabUnselected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z' })
	  );
	};
	ActionTabUnselected = (0, _pure2.default)(ActionTabUnselected);
	ActionTabUnselected.displayName = 'ActionTabUnselected';
	ActionTabUnselected.muiName = 'SvgIcon';
	
	exports.default = ActionTabUnselected;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTab = function ActionTab(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z' })
	  );
	};
	ActionTab = (0, _pure2.default)(ActionTab);
	ActionTab.displayName = 'ActionTab';
	ActionTab.muiName = 'SvgIcon';
	
	exports.default = ActionTab;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTheaters = function ActionTheaters(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
	  );
	};
	ActionTheaters = (0, _pure2.default)(ActionTheaters);
	ActionTheaters.displayName = 'ActionTheaters';
	ActionTheaters.muiName = 'SvgIcon';
	
	exports.default = ActionTheaters;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThreeDRotation = function ActionThreeDRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z' })
	  );
	};
	ActionThreeDRotation = (0, _pure2.default)(ActionThreeDRotation);
	ActionThreeDRotation.displayName = 'ActionThreeDRotation';
	ActionThreeDRotation.muiName = 'SvgIcon';
	
	exports.default = ActionThreeDRotation;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbDown = function ActionThumbDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z' })
	  );
	};
	ActionThumbDown = (0, _pure2.default)(ActionThumbDown);
	ActionThumbDown.displayName = 'ActionThumbDown';
	ActionThumbDown.muiName = 'SvgIcon';
	
	exports.default = ActionThumbDown;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbUp = function ActionThumbUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z' })
	  );
	};
	ActionThumbUp = (0, _pure2.default)(ActionThumbUp);
	ActionThumbUp.displayName = 'ActionThumbUp';
	ActionThumbUp.muiName = 'SvgIcon';
	
	exports.default = ActionThumbUp;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbsUpDown = function ActionThumbsUpDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z' })
	  );
	};
	ActionThumbsUpDown = (0, _pure2.default)(ActionThumbsUpDown);
	ActionThumbsUpDown.displayName = 'ActionThumbsUpDown';
	ActionThumbsUpDown.muiName = 'SvgIcon';
	
	exports.default = ActionThumbsUpDown;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTimeline = function ActionTimeline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z' })
	  );
	};
	ActionTimeline = (0, _pure2.default)(ActionTimeline);
	ActionTimeline.displayName = 'ActionTimeline';
	ActionTimeline.muiName = 'SvgIcon';
	
	exports.default = ActionTimeline;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToc = function ActionToc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z' })
	  );
	};
	ActionToc = (0, _pure2.default)(ActionToc);
	ActionToc.displayName = 'ActionToc';
	ActionToc.muiName = 'SvgIcon';
	
	exports.default = ActionToc;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToday = function ActionToday(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z' })
	  );
	};
	ActionToday = (0, _pure2.default)(ActionToday);
	ActionToday.displayName = 'ActionToday';
	ActionToday.muiName = 'SvgIcon';
	
	exports.default = ActionToday;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToll = function ActionToll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z' })
	  );
	};
	ActionToll = (0, _pure2.default)(ActionToll);
	ActionToll.displayName = 'ActionToll';
	ActionToll.muiName = 'SvgIcon';
	
	exports.default = ActionToll;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTouchApp = function ActionTouchApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z' })
	  );
	};
	ActionTouchApp = (0, _pure2.default)(ActionTouchApp);
	ActionTouchApp.displayName = 'ActionTouchApp';
	ActionTouchApp.muiName = 'SvgIcon';
	
	exports.default = ActionTouchApp;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrackChanges = function ActionTrackChanges(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z' })
	  );
	};
	ActionTrackChanges = (0, _pure2.default)(ActionTrackChanges);
	ActionTrackChanges.displayName = 'ActionTrackChanges';
	ActionTrackChanges.muiName = 'SvgIcon';
	
	exports.default = ActionTrackChanges;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTranslate = function ActionTranslate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z' })
	  );
	};
	ActionTranslate = (0, _pure2.default)(ActionTranslate);
	ActionTranslate.displayName = 'ActionTranslate';
	ActionTranslate.muiName = 'SvgIcon';
	
	exports.default = ActionTranslate;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingDown = function ActionTrendingDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z' })
	  );
	};
	ActionTrendingDown = (0, _pure2.default)(ActionTrendingDown);
	ActionTrendingDown.displayName = 'ActionTrendingDown';
	ActionTrendingDown.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingDown;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingFlat = function ActionTrendingFlat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 12l-4-4v3H3v2h15v3z' })
	  );
	};
	ActionTrendingFlat = (0, _pure2.default)(ActionTrendingFlat);
	ActionTrendingFlat.displayName = 'ActionTrendingFlat';
	ActionTrendingFlat.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingFlat;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingUp = function ActionTrendingUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z' })
	  );
	};
	ActionTrendingUp = (0, _pure2.default)(ActionTrendingUp);
	ActionTrendingUp.displayName = 'ActionTrendingUp';
	ActionTrendingUp.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingUp;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTurnedInNot = function ActionTurnedInNot(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
	  );
	};
	ActionTurnedInNot = (0, _pure2.default)(ActionTurnedInNot);
	ActionTurnedInNot.displayName = 'ActionTurnedInNot';
	ActionTurnedInNot.muiName = 'SvgIcon';
	
	exports.default = ActionTurnedInNot;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTurnedIn = function ActionTurnedIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionTurnedIn = (0, _pure2.default)(ActionTurnedIn);
	ActionTurnedIn.displayName = 'ActionTurnedIn';
	ActionTurnedIn.muiName = 'SvgIcon';
	
	exports.default = ActionTurnedIn;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionUpdate = function ActionUpdate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z' })
	  );
	};
	ActionUpdate = (0, _pure2.default)(ActionUpdate);
	ActionUpdate.displayName = 'ActionUpdate';
	ActionUpdate.muiName = 'SvgIcon';
	
	exports.default = ActionUpdate;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVerifiedUser = function ActionVerifiedUser(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
	  );
	};
	ActionVerifiedUser = (0, _pure2.default)(ActionVerifiedUser);
	ActionVerifiedUser.displayName = 'ActionVerifiedUser';
	ActionVerifiedUser.muiName = 'SvgIcon';
	
	exports.default = ActionVerifiedUser;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewAgenda = function ActionViewAgenda(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z' })
	  );
	};
	ActionViewAgenda = (0, _pure2.default)(ActionViewAgenda);
	ActionViewAgenda.displayName = 'ActionViewAgenda';
	ActionViewAgenda.muiName = 'SvgIcon';
	
	exports.default = ActionViewAgenda;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewArray = function ActionViewArray(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z' })
	  );
	};
	ActionViewArray = (0, _pure2.default)(ActionViewArray);
	ActionViewArray.displayName = 'ActionViewArray';
	ActionViewArray.muiName = 'SvgIcon';
	
	exports.default = ActionViewArray;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewCarousel = function ActionViewCarousel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z' })
	  );
	};
	ActionViewCarousel = (0, _pure2.default)(ActionViewCarousel);
	ActionViewCarousel.displayName = 'ActionViewCarousel';
	ActionViewCarousel.muiName = 'SvgIcon';
	
	exports.default = ActionViewCarousel;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewColumn = function ActionViewColumn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z' })
	  );
	};
	ActionViewColumn = (0, _pure2.default)(ActionViewColumn);
	ActionViewColumn.displayName = 'ActionViewColumn';
	ActionViewColumn.muiName = 'SvgIcon';
	
	exports.default = ActionViewColumn;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewDay = function ActionViewDay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z' })
	  );
	};
	ActionViewDay = (0, _pure2.default)(ActionViewDay);
	ActionViewDay.displayName = 'ActionViewDay';
	ActionViewDay.muiName = 'SvgIcon';
	
	exports.default = ActionViewDay;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewHeadline = function ActionViewHeadline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z' })
	  );
	};
	ActionViewHeadline = (0, _pure2.default)(ActionViewHeadline);
	ActionViewHeadline.displayName = 'ActionViewHeadline';
	ActionViewHeadline.muiName = 'SvgIcon';
	
	exports.default = ActionViewHeadline;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewList = function ActionViewList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z' })
	  );
	};
	ActionViewList = (0, _pure2.default)(ActionViewList);
	ActionViewList.displayName = 'ActionViewList';
	ActionViewList.muiName = 'SvgIcon';
	
	exports.default = ActionViewList;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewModule = function ActionViewModule(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z' })
	  );
	};
	ActionViewModule = (0, _pure2.default)(ActionViewModule);
	ActionViewModule.displayName = 'ActionViewModule';
	ActionViewModule.muiName = 'SvgIcon';
	
	exports.default = ActionViewModule;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewQuilt = function ActionViewQuilt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z' })
	  );
	};
	ActionViewQuilt = (0, _pure2.default)(ActionViewQuilt);
	ActionViewQuilt.displayName = 'ActionViewQuilt';
	ActionViewQuilt.muiName = 'SvgIcon';
	
	exports.default = ActionViewQuilt;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewStream = function ActionViewStream(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z' })
	  );
	};
	ActionViewStream = (0, _pure2.default)(ActionViewStream);
	ActionViewStream.displayName = 'ActionViewStream';
	ActionViewStream.muiName = 'SvgIcon';
	
	exports.default = ActionViewStream;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewWeek = function ActionViewWeek(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z' })
	  );
	};
	ActionViewWeek = (0, _pure2.default)(ActionViewWeek);
	ActionViewWeek.displayName = 'ActionViewWeek';
	ActionViewWeek.muiName = 'SvgIcon';
	
	exports.default = ActionViewWeek;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVisibilityOff = function ActionVisibilityOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z' })
	  );
	};
	ActionVisibilityOff = (0, _pure2.default)(ActionVisibilityOff);
	ActionVisibilityOff.displayName = 'ActionVisibilityOff';
	ActionVisibilityOff.muiName = 'SvgIcon';
	
	exports.default = ActionVisibilityOff;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVisibility = function ActionVisibility(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ActionVisibility = (0, _pure2.default)(ActionVisibility);
	ActionVisibility.displayName = 'ActionVisibility';
	ActionVisibility.muiName = 'SvgIcon';
	
	exports.default = ActionVisibility;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionWatchLater = function ActionWatchLater(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z' })
	  );
	};
	ActionWatchLater = (0, _pure2.default)(ActionWatchLater);
	ActionWatchLater.displayName = 'ActionWatchLater';
	ActionWatchLater.muiName = 'SvgIcon';
	
	exports.default = ActionWatchLater;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionWork = function ActionWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z' })
	  );
	};
	ActionWork = (0, _pure2.default)(ActionWork);
	ActionWork.displayName = 'ActionWork';
	ActionWork.muiName = 'SvgIcon';
	
	exports.default = ActionWork;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionYoutubeSearchedFor = function ActionYoutubeSearchedFor(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z' })
	  );
	};
	ActionYoutubeSearchedFor = (0, _pure2.default)(ActionYoutubeSearchedFor);
	ActionYoutubeSearchedFor.displayName = 'ActionYoutubeSearchedFor';
	ActionYoutubeSearchedFor.muiName = 'SvgIcon';
	
	exports.default = ActionYoutubeSearchedFor;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionZoomIn = function ActionZoomIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z' })
	  );
	};
	ActionZoomIn = (0, _pure2.default)(ActionZoomIn);
	ActionZoomIn.displayName = 'ActionZoomIn';
	ActionZoomIn.muiName = 'SvgIcon';
	
	exports.default = ActionZoomIn;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionZoomOut = function ActionZoomOut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z' })
	  );
	};
	ActionZoomOut = (0, _pure2.default)(ActionZoomOut);
	ActionZoomOut.displayName = 'ActionZoomOut';
	ActionZoomOut.muiName = 'SvgIcon';
	
	exports.default = ActionZoomOut;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertAddAlert = function AlertAddAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z' })
	  );
	};
	AlertAddAlert = (0, _pure2.default)(AlertAddAlert);
	AlertAddAlert.displayName = 'AlertAddAlert';
	AlertAddAlert.muiName = 'SvgIcon';
	
	exports.default = AlertAddAlert;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertErrorOutline = function AlertErrorOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	AlertErrorOutline = (0, _pure2.default)(AlertErrorOutline);
	AlertErrorOutline.displayName = 'AlertErrorOutline';
	AlertErrorOutline.muiName = 'SvgIcon';
	
	exports.default = AlertErrorOutline;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertError = function AlertError(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
	  );
	};
	AlertError = (0, _pure2.default)(AlertError);
	AlertError.displayName = 'AlertError';
	AlertError.muiName = 'SvgIcon';
	
	exports.default = AlertError;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertWarning = function AlertWarning(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
	  );
	};
	AlertWarning = (0, _pure2.default)(AlertWarning);
	AlertWarning.displayName = 'AlertWarning';
	AlertWarning.muiName = 'SvgIcon';
	
	exports.default = AlertWarning;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAddToQueue = function AvAddToQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z' })
	  );
	};
	AvAddToQueue = (0, _pure2.default)(AvAddToQueue);
	AvAddToQueue.displayName = 'AvAddToQueue';
	AvAddToQueue.muiName = 'SvgIcon';
	
	exports.default = AvAddToQueue;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAirplay = function AvAirplay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	AvAirplay = (0, _pure2.default)(AvAirplay);
	AvAirplay.displayName = 'AvAirplay';
	AvAirplay.muiName = 'SvgIcon';
	
	exports.default = AvAirplay;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAlbum = function AvAlbum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
	  );
	};
	AvAlbum = (0, _pure2.default)(AvAlbum);
	AvAlbum.displayName = 'AvAlbum';
	AvAlbum.muiName = 'SvgIcon';
	
	exports.default = AvAlbum;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvArtTrack = function AvArtTrack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z' })
	  );
	};
	AvArtTrack = (0, _pure2.default)(AvArtTrack);
	AvArtTrack.displayName = 'AvArtTrack';
	AvArtTrack.muiName = 'SvgIcon';
	
	exports.default = AvArtTrack;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAvTimer = function AvAvTimer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z' })
	  );
	};
	AvAvTimer = (0, _pure2.default)(AvAvTimer);
	AvAvTimer.displayName = 'AvAvTimer';
	AvAvTimer.muiName = 'SvgIcon';
	
	exports.default = AvAvTimer;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvBrandingWatermark = function AvBrandingWatermark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z' })
	  );
	};
	AvBrandingWatermark = (0, _pure2.default)(AvBrandingWatermark);
	AvBrandingWatermark.displayName = 'AvBrandingWatermark';
	AvBrandingWatermark.muiName = 'SvgIcon';
	
	exports.default = AvBrandingWatermark;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvCallToAction = function AvCallToAction(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z' })
	  );
	};
	AvCallToAction = (0, _pure2.default)(AvCallToAction);
	AvCallToAction.displayName = 'AvCallToAction';
	AvCallToAction.muiName = 'SvgIcon';
	
	exports.default = AvCallToAction;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvClosedCaption = function AvClosedCaption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z' })
	  );
	};
	AvClosedCaption = (0, _pure2.default)(AvClosedCaption);
	AvClosedCaption.displayName = 'AvClosedCaption';
	AvClosedCaption.muiName = 'SvgIcon';
	
	exports.default = AvClosedCaption;

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvEqualizer = function AvEqualizer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z' })
	  );
	};
	AvEqualizer = (0, _pure2.default)(AvEqualizer);
	AvEqualizer.displayName = 'AvEqualizer';
	AvEqualizer.muiName = 'SvgIcon';
	
	exports.default = AvEqualizer;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvExplicit = function AvExplicit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z' })
	  );
	};
	AvExplicit = (0, _pure2.default)(AvExplicit);
	AvExplicit.displayName = 'AvExplicit';
	AvExplicit.muiName = 'SvgIcon';
	
	exports.default = AvExplicit;

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFastForward = function AvFastForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z' })
	  );
	};
	AvFastForward = (0, _pure2.default)(AvFastForward);
	AvFastForward.displayName = 'AvFastForward';
	AvFastForward.muiName = 'SvgIcon';
	
	exports.default = AvFastForward;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFastRewind = function AvFastRewind(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z' })
	  );
	};
	AvFastRewind = (0, _pure2.default)(AvFastRewind);
	AvFastRewind.displayName = 'AvFastRewind';
	AvFastRewind.muiName = 'SvgIcon';
	
	exports.default = AvFastRewind;

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFeaturedPlayList = function AvFeaturedPlayList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z' })
	  );
	};
	AvFeaturedPlayList = (0, _pure2.default)(AvFeaturedPlayList);
	AvFeaturedPlayList.displayName = 'AvFeaturedPlayList';
	AvFeaturedPlayList.muiName = 'SvgIcon';
	
	exports.default = AvFeaturedPlayList;

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFeaturedVideo = function AvFeaturedVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z' })
	  );
	};
	AvFeaturedVideo = (0, _pure2.default)(AvFeaturedVideo);
	AvFeaturedVideo.displayName = 'AvFeaturedVideo';
	AvFeaturedVideo.muiName = 'SvgIcon';
	
	exports.default = AvFeaturedVideo;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberDvr = function AvFiberDvr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z' })
	  );
	};
	AvFiberDvr = (0, _pure2.default)(AvFiberDvr);
	AvFiberDvr.displayName = 'AvFiberDvr';
	AvFiberDvr.muiName = 'SvgIcon';
	
	exports.default = AvFiberDvr;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberManualRecord = function AvFiberManualRecord(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '8' })
	  );
	};
	AvFiberManualRecord = (0, _pure2.default)(AvFiberManualRecord);
	AvFiberManualRecord.displayName = 'AvFiberManualRecord';
	AvFiberManualRecord.muiName = 'SvgIcon';
	
	exports.default = AvFiberManualRecord;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberNew = function AvFiberNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z' })
	  );
	};
	AvFiberNew = (0, _pure2.default)(AvFiberNew);
	AvFiberNew.displayName = 'AvFiberNew';
	AvFiberNew.muiName = 'SvgIcon';
	
	exports.default = AvFiberNew;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberPin = function AvFiberPin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z' })
	  );
	};
	AvFiberPin = (0, _pure2.default)(AvFiberPin);
	AvFiberPin.displayName = 'AvFiberPin';
	AvFiberPin.muiName = 'SvgIcon';
	
	exports.default = AvFiberPin;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberSmartRecord = function AvFiberSmartRecord(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('circle', { cx: '9', cy: '12', r: '8' }),
	      _react2.default.createElement('path', { d: 'M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z' })
	    )
	  );
	};
	AvFiberSmartRecord = (0, _pure2.default)(AvFiberSmartRecord);
	AvFiberSmartRecord.displayName = 'AvFiberSmartRecord';
	AvFiberSmartRecord.muiName = 'SvgIcon';
	
	exports.default = AvFiberSmartRecord;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward10 = function AvForward10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvForward10 = (0, _pure2.default)(AvForward10);
	AvForward10.displayName = 'AvForward10';
	AvForward10.muiName = 'SvgIcon';
	
	exports.default = AvForward10;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward30 = function AvForward30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z' })
	  );
	};
	AvForward30 = (0, _pure2.default)(AvForward30);
	AvForward30.displayName = 'AvForward30';
	AvForward30.muiName = 'SvgIcon';
	
	exports.default = AvForward30;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward5 = function AvForward5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z' })
	  );
	};
	AvForward5 = (0, _pure2.default)(AvForward5);
	AvForward5.displayName = 'AvForward5';
	AvForward5.muiName = 'SvgIcon';
	
	exports.default = AvForward5;

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvGames = function AvGames(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
	  );
	};
	AvGames = (0, _pure2.default)(AvGames);
	AvGames.displayName = 'AvGames';
	AvGames.muiName = 'SvgIcon';
	
	exports.default = AvGames;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHd = function AvHd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z' })
	  );
	};
	AvHd = (0, _pure2.default)(AvHd);
	AvHd.displayName = 'AvHd';
	AvHd.muiName = 'SvgIcon';
	
	exports.default = AvHd;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHearing = function AvHearing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z' })
	  );
	};
	AvHearing = (0, _pure2.default)(AvHearing);
	AvHearing.displayName = 'AvHearing';
	AvHearing.muiName = 'SvgIcon';
	
	exports.default = AvHearing;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHighQuality = function AvHighQuality(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z' })
	  );
	};
	AvHighQuality = (0, _pure2.default)(AvHighQuality);
	AvHighQuality.displayName = 'AvHighQuality';
	AvHighQuality.muiName = 'SvgIcon';
	
	exports.default = AvHighQuality;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryAdd = function AvLibraryAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	AvLibraryAdd = (0, _pure2.default)(AvLibraryAdd);
	AvLibraryAdd.displayName = 'AvLibraryAdd';
	AvLibraryAdd.muiName = 'SvgIcon';
	
	exports.default = AvLibraryAdd;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryBooks = function AvLibraryBooks(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z' })
	  );
	};
	AvLibraryBooks = (0, _pure2.default)(AvLibraryBooks);
	AvLibraryBooks.displayName = 'AvLibraryBooks';
	AvLibraryBooks.muiName = 'SvgIcon';
	
	exports.default = AvLibraryBooks;

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryMusic = function AvLibraryMusic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z' })
	  );
	};
	AvLibraryMusic = (0, _pure2.default)(AvLibraryMusic);
	AvLibraryMusic.displayName = 'AvLibraryMusic';
	AvLibraryMusic.muiName = 'SvgIcon';
	
	exports.default = AvLibraryMusic;

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLoop = function AvLoop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
	  );
	};
	AvLoop = (0, _pure2.default)(AvLoop);
	AvLoop.displayName = 'AvLoop';
	AvLoop.muiName = 'SvgIcon';
	
	exports.default = AvLoop;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMicNone = function AvMicNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	AvMicNone = (0, _pure2.default)(AvMicNone);
	AvMicNone.displayName = 'AvMicNone';
	AvMicNone.muiName = 'SvgIcon';
	
	exports.default = AvMicNone;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMicOff = function AvMicOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z' })
	  );
	};
	AvMicOff = (0, _pure2.default)(AvMicOff);
	AvMicOff.displayName = 'AvMicOff';
	AvMicOff.muiName = 'SvgIcon';
	
	exports.default = AvMicOff;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMic = function AvMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	AvMic = (0, _pure2.default)(AvMic);
	AvMic.displayName = 'AvMic';
	AvMic.muiName = 'SvgIcon';
	
	exports.default = AvMic;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMovie = function AvMovie(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
	  );
	};
	AvMovie = (0, _pure2.default)(AvMovie);
	AvMovie.displayName = 'AvMovie';
	AvMovie.muiName = 'SvgIcon';
	
	exports.default = AvMovie;

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMusicVideo = function AvMusicVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z' })
	  );
	};
	AvMusicVideo = (0, _pure2.default)(AvMusicVideo);
	AvMusicVideo.displayName = 'AvMusicVideo';
	AvMusicVideo.muiName = 'SvgIcon';
	
	exports.default = AvMusicVideo;

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNewReleases = function AvNewReleases(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z' })
	  );
	};
	AvNewReleases = (0, _pure2.default)(AvNewReleases);
	AvNewReleases.displayName = 'AvNewReleases';
	AvNewReleases.muiName = 'SvgIcon';
	
	exports.default = AvNewReleases;

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNotInterested = function AvNotInterested(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
	  );
	};
	AvNotInterested = (0, _pure2.default)(AvNotInterested);
	AvNotInterested.displayName = 'AvNotInterested';
	AvNotInterested.muiName = 'SvgIcon';
	
	exports.default = AvNotInterested;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNote = function AvNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z' })
	  );
	};
	AvNote = (0, _pure2.default)(AvNote);
	AvNote.displayName = 'AvNote';
	AvNote.muiName = 'SvgIcon';
	
	exports.default = AvNote;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPauseCircleFilled = function AvPauseCircleFilled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z' })
	  );
	};
	AvPauseCircleFilled = (0, _pure2.default)(AvPauseCircleFilled);
	AvPauseCircleFilled.displayName = 'AvPauseCircleFilled';
	AvPauseCircleFilled.muiName = 'SvgIcon';
	
	exports.default = AvPauseCircleFilled;

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPauseCircleOutline = function AvPauseCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z' })
	  );
	};
	AvPauseCircleOutline = (0, _pure2.default)(AvPauseCircleOutline);
	AvPauseCircleOutline.displayName = 'AvPauseCircleOutline';
	AvPauseCircleOutline.muiName = 'SvgIcon';
	
	exports.default = AvPauseCircleOutline;

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPause = function AvPause(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z' })
	  );
	};
	AvPause = (0, _pure2.default)(AvPause);
	AvPause.displayName = 'AvPause';
	AvPause.muiName = 'SvgIcon';
	
	exports.default = AvPause;

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayArrow = function AvPlayArrow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 5v14l11-7z' })
	  );
	};
	AvPlayArrow = (0, _pure2.default)(AvPlayArrow);
	AvPlayArrow.displayName = 'AvPlayArrow';
	AvPlayArrow.muiName = 'SvgIcon';
	
	exports.default = AvPlayArrow;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayCircleFilled = function AvPlayCircleFilled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z' })
	  );
	};
	AvPlayCircleFilled = (0, _pure2.default)(AvPlayCircleFilled);
	AvPlayCircleFilled.displayName = 'AvPlayCircleFilled';
	AvPlayCircleFilled.muiName = 'SvgIcon';
	
	exports.default = AvPlayCircleFilled;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayCircleOutline = function AvPlayCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	AvPlayCircleOutline = (0, _pure2.default)(AvPlayCircleOutline);
	AvPlayCircleOutline.displayName = 'AvPlayCircleOutline';
	AvPlayCircleOutline.muiName = 'SvgIcon';
	
	exports.default = AvPlayCircleOutline;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistAddCheck = function AvPlaylistAddCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z' })
	  );
	};
	AvPlaylistAddCheck = (0, _pure2.default)(AvPlaylistAddCheck);
	AvPlaylistAddCheck.displayName = 'AvPlaylistAddCheck';
	AvPlaylistAddCheck.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistAddCheck;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistAdd = function AvPlaylistAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z' })
	  );
	};
	AvPlaylistAdd = (0, _pure2.default)(AvPlaylistAdd);
	AvPlaylistAdd.displayName = 'AvPlaylistAdd';
	AvPlaylistAdd.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistAdd;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistPlay = function AvPlaylistPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z' })
	  );
	};
	AvPlaylistPlay = (0, _pure2.default)(AvPlaylistPlay);
	AvPlaylistPlay.displayName = 'AvPlaylistPlay';
	AvPlaylistPlay.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistPlay;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueueMusic = function AvQueueMusic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z' })
	  );
	};
	AvQueueMusic = (0, _pure2.default)(AvQueueMusic);
	AvQueueMusic.displayName = 'AvQueueMusic';
	AvQueueMusic.muiName = 'SvgIcon';
	
	exports.default = AvQueueMusic;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueuePlayNext = function AvQueuePlayNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z' })
	  );
	};
	AvQueuePlayNext = (0, _pure2.default)(AvQueuePlayNext);
	AvQueuePlayNext.displayName = 'AvQueuePlayNext';
	AvQueuePlayNext.muiName = 'SvgIcon';
	
	exports.default = AvQueuePlayNext;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueue = function AvQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	AvQueue = (0, _pure2.default)(AvQueue);
	AvQueue.displayName = 'AvQueue';
	AvQueue.muiName = 'SvgIcon';
	
	exports.default = AvQueue;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRadio = function AvRadio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z' })
	  );
	};
	AvRadio = (0, _pure2.default)(AvRadio);
	AvRadio.displayName = 'AvRadio';
	AvRadio.muiName = 'SvgIcon';
	
	exports.default = AvRadio;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRecentActors = function AvRecentActors(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z' })
	  );
	};
	AvRecentActors = (0, _pure2.default)(AvRecentActors);
	AvRecentActors.displayName = 'AvRecentActors';
	AvRecentActors.muiName = 'SvgIcon';
	
	exports.default = AvRecentActors;

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRemoveFromQueue = function AvRemoveFromQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z' })
	  );
	};
	AvRemoveFromQueue = (0, _pure2.default)(AvRemoveFromQueue);
	AvRemoveFromQueue.displayName = 'AvRemoveFromQueue';
	AvRemoveFromQueue.muiName = 'SvgIcon';
	
	exports.default = AvRemoveFromQueue;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRepeatOne = function AvRepeatOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z' })
	  );
	};
	AvRepeatOne = (0, _pure2.default)(AvRepeatOne);
	AvRepeatOne.displayName = 'AvRepeatOne';
	AvRepeatOne.muiName = 'SvgIcon';
	
	exports.default = AvRepeatOne;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRepeat = function AvRepeat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z' })
	  );
	};
	AvRepeat = (0, _pure2.default)(AvRepeat);
	AvRepeat.displayName = 'AvRepeat';
	AvRepeat.muiName = 'SvgIcon';
	
	exports.default = AvRepeat;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay10 = function AvReplay10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvReplay10 = (0, _pure2.default)(AvReplay10);
	AvReplay10.displayName = 'AvReplay10';
	AvReplay10.muiName = 'SvgIcon';
	
	exports.default = AvReplay10;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay30 = function AvReplay30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvReplay30 = (0, _pure2.default)(AvReplay30);
	AvReplay30.displayName = 'AvReplay30';
	AvReplay30.muiName = 'SvgIcon';
	
	exports.default = AvReplay30;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay5 = function AvReplay5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z' })
	  );
	};
	AvReplay5 = (0, _pure2.default)(AvReplay5);
	AvReplay5.displayName = 'AvReplay5';
	AvReplay5.muiName = 'SvgIcon';
	
	exports.default = AvReplay5;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay = function AvReplay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z' })
	  );
	};
	AvReplay = (0, _pure2.default)(AvReplay);
	AvReplay.displayName = 'AvReplay';
	AvReplay.muiName = 'SvgIcon';
	
	exports.default = AvReplay;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvShuffle = function AvShuffle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z' })
	  );
	};
	AvShuffle = (0, _pure2.default)(AvShuffle);
	AvShuffle.displayName = 'AvShuffle';
	AvShuffle.muiName = 'SvgIcon';
	
	exports.default = AvShuffle;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSkipNext = function AvSkipNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z' })
	  );
	};
	AvSkipNext = (0, _pure2.default)(AvSkipNext);
	AvSkipNext.displayName = 'AvSkipNext';
	AvSkipNext.muiName = 'SvgIcon';
	
	exports.default = AvSkipNext;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSkipPrevious = function AvSkipPrevious(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' })
	  );
	};
	AvSkipPrevious = (0, _pure2.default)(AvSkipPrevious);
	AvSkipPrevious.displayName = 'AvSkipPrevious';
	AvSkipPrevious.muiName = 'SvgIcon';
	
	exports.default = AvSkipPrevious;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSlowMotionVideo = function AvSlowMotionVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z' })
	  );
	};
	AvSlowMotionVideo = (0, _pure2.default)(AvSlowMotionVideo);
	AvSlowMotionVideo.displayName = 'AvSlowMotionVideo';
	AvSlowMotionVideo.muiName = 'SvgIcon';
	
	exports.default = AvSlowMotionVideo;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSnooze = function AvSnooze(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z' })
	  );
	};
	AvSnooze = (0, _pure2.default)(AvSnooze);
	AvSnooze.displayName = 'AvSnooze';
	AvSnooze.muiName = 'SvgIcon';
	
	exports.default = AvSnooze;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSortByAlpha = function AvSortByAlpha(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z' })
	  );
	};
	AvSortByAlpha = (0, _pure2.default)(AvSortByAlpha);
	AvSortByAlpha.displayName = 'AvSortByAlpha';
	AvSortByAlpha.muiName = 'SvgIcon';
	
	exports.default = AvSortByAlpha;

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvStop = function AvStop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 6h12v12H6z' })
	  );
	};
	AvStop = (0, _pure2.default)(AvStop);
	AvStop.displayName = 'AvStop';
	AvStop.muiName = 'SvgIcon';
	
	exports.default = AvStop;

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSubscriptions = function AvSubscriptions(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z' })
	  );
	};
	AvSubscriptions = (0, _pure2.default)(AvSubscriptions);
	AvSubscriptions.displayName = 'AvSubscriptions';
	AvSubscriptions.muiName = 'SvgIcon';
	
	exports.default = AvSubscriptions;

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSubtitles = function AvSubtitles(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z' })
	  );
	};
	AvSubtitles = (0, _pure2.default)(AvSubtitles);
	AvSubtitles.displayName = 'AvSubtitles';
	AvSubtitles.muiName = 'SvgIcon';
	
	exports.default = AvSubtitles;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSurroundSound = function AvSurroundSound(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	AvSurroundSound = (0, _pure2.default)(AvSurroundSound);
	AvSurroundSound.displayName = 'AvSurroundSound';
	AvSurroundSound.muiName = 'SvgIcon';
	
	exports.default = AvSurroundSound;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoCall = function AvVideoCall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z' })
	  );
	};
	AvVideoCall = (0, _pure2.default)(AvVideoCall);
	AvVideoCall.displayName = 'AvVideoCall';
	AvVideoCall.muiName = 'SvgIcon';
	
	exports.default = AvVideoCall;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoLabel = function AvVideoLabel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z' })
	  );
	};
	AvVideoLabel = (0, _pure2.default)(AvVideoLabel);
	AvVideoLabel.displayName = 'AvVideoLabel';
	AvVideoLabel.muiName = 'SvgIcon';
	
	exports.default = AvVideoLabel;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoLibrary = function AvVideoLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z' })
	  );
	};
	AvVideoLibrary = (0, _pure2.default)(AvVideoLibrary);
	AvVideoLibrary.displayName = 'AvVideoLibrary';
	AvVideoLibrary.muiName = 'SvgIcon';
	
	exports.default = AvVideoLibrary;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideocamOff = function AvVideocamOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z' })
	  );
	};
	AvVideocamOff = (0, _pure2.default)(AvVideocamOff);
	AvVideocamOff.displayName = 'AvVideocamOff';
	AvVideocamOff.muiName = 'SvgIcon';
	
	exports.default = AvVideocamOff;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideocam = function AvVideocam(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z' })
	  );
	};
	AvVideocam = (0, _pure2.default)(AvVideocam);
	AvVideocam.displayName = 'AvVideocam';
	AvVideocam.muiName = 'SvgIcon';
	
	exports.default = AvVideocam;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeDown = function AvVolumeDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z' })
	  );
	};
	AvVolumeDown = (0, _pure2.default)(AvVolumeDown);
	AvVolumeDown.displayName = 'AvVolumeDown';
	AvVolumeDown.muiName = 'SvgIcon';
	
	exports.default = AvVolumeDown;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeMute = function AvVolumeMute(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 9v6h4l5 5V4l-5 5H7z' })
	  );
	};
	AvVolumeMute = (0, _pure2.default)(AvVolumeMute);
	AvVolumeMute.displayName = 'AvVolumeMute';
	AvVolumeMute.muiName = 'SvgIcon';
	
	exports.default = AvVolumeMute;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeOff = function AvVolumeOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z' })
	  );
	};
	AvVolumeOff = (0, _pure2.default)(AvVolumeOff);
	AvVolumeOff.displayName = 'AvVolumeOff';
	AvVolumeOff.muiName = 'SvgIcon';
	
	exports.default = AvVolumeOff;

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeUp = function AvVolumeUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' })
	  );
	};
	AvVolumeUp = (0, _pure2.default)(AvVolumeUp);
	AvVolumeUp.displayName = 'AvVolumeUp';
	AvVolumeUp.muiName = 'SvgIcon';
	
	exports.default = AvVolumeUp;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvWebAsset = function AvWebAsset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z' })
	  );
	};
	AvWebAsset = (0, _pure2.default)(AvWebAsset);
	AvWebAsset.displayName = 'AvWebAsset';
	AvWebAsset.muiName = 'SvgIcon';
	
	exports.default = AvWebAsset;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvWeb = function AvWeb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z' })
	  );
	};
	AvWeb = (0, _pure2.default)(AvWeb);
	AvWeb.displayName = 'AvWeb';
	AvWeb.muiName = 'SvgIcon';
	
	exports.default = AvWeb;

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationBusiness = function CommunicationBusiness(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
	  );
	};
	CommunicationBusiness = (0, _pure2.default)(CommunicationBusiness);
	CommunicationBusiness.displayName = 'CommunicationBusiness';
	CommunicationBusiness.muiName = 'SvgIcon';
	
	exports.default = CommunicationBusiness;

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallEnd = function CommunicationCallEnd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z' })
	  );
	};
	CommunicationCallEnd = (0, _pure2.default)(CommunicationCallEnd);
	CommunicationCallEnd.displayName = 'CommunicationCallEnd';
	CommunicationCallEnd.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallEnd;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMade = function CommunicationCallMade(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z' })
	  );
	};
	CommunicationCallMade = (0, _pure2.default)(CommunicationCallMade);
	CommunicationCallMade.displayName = 'CommunicationCallMade';
	CommunicationCallMade.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMade;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMerge = function CommunicationCallMerge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
	  );
	};
	CommunicationCallMerge = (0, _pure2.default)(CommunicationCallMerge);
	CommunicationCallMerge.displayName = 'CommunicationCallMerge';
	CommunicationCallMerge.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMerge;

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMissedOutgoing = function CommunicationCallMissedOutgoing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z' })
	  );
	};
	CommunicationCallMissedOutgoing = (0, _pure2.default)(CommunicationCallMissedOutgoing);
	CommunicationCallMissedOutgoing.displayName = 'CommunicationCallMissedOutgoing';
	CommunicationCallMissedOutgoing.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMissedOutgoing;

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMissed = function CommunicationCallMissed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z' })
	  );
	};
	CommunicationCallMissed = (0, _pure2.default)(CommunicationCallMissed);
	CommunicationCallMissed.displayName = 'CommunicationCallMissed';
	CommunicationCallMissed.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMissed;

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallReceived = function CommunicationCallReceived(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z' })
	  );
	};
	CommunicationCallReceived = (0, _pure2.default)(CommunicationCallReceived);
	CommunicationCallReceived.displayName = 'CommunicationCallReceived';
	CommunicationCallReceived.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallReceived;

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallSplit = function CommunicationCallSplit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z' })
	  );
	};
	CommunicationCallSplit = (0, _pure2.default)(CommunicationCallSplit);
	CommunicationCallSplit.displayName = 'CommunicationCallSplit';
	CommunicationCallSplit.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallSplit;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCall = function CommunicationCall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	CommunicationCall = (0, _pure2.default)(CommunicationCall);
	CommunicationCall.displayName = 'CommunicationCall';
	CommunicationCall.muiName = 'SvgIcon';
	
	exports.default = CommunicationCall;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChatBubbleOutline = function CommunicationChatBubbleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z' })
	  );
	};
	CommunicationChatBubbleOutline = (0, _pure2.default)(CommunicationChatBubbleOutline);
	CommunicationChatBubbleOutline.displayName = 'CommunicationChatBubbleOutline';
	CommunicationChatBubbleOutline.muiName = 'SvgIcon';
	
	exports.default = CommunicationChatBubbleOutline;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChatBubble = function CommunicationChatBubble(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationChatBubble = (0, _pure2.default)(CommunicationChatBubble);
	CommunicationChatBubble.displayName = 'CommunicationChatBubble';
	CommunicationChatBubble.muiName = 'SvgIcon';
	
	exports.default = CommunicationChatBubble;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChat = function CommunicationChat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z' })
	  );
	};
	CommunicationChat = (0, _pure2.default)(CommunicationChat);
	CommunicationChat.displayName = 'CommunicationChat';
	CommunicationChat.muiName = 'SvgIcon';
	
	exports.default = CommunicationChat;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationClearAll = function CommunicationClearAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z' })
	  );
	};
	CommunicationClearAll = (0, _pure2.default)(CommunicationClearAll);
	CommunicationClearAll.displayName = 'CommunicationClearAll';
	CommunicationClearAll.muiName = 'SvgIcon';
	
	exports.default = CommunicationClearAll;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationComment = function CommunicationComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	CommunicationComment = (0, _pure2.default)(CommunicationComment);
	CommunicationComment.displayName = 'CommunicationComment';
	CommunicationComment.muiName = 'SvgIcon';
	
	exports.default = CommunicationComment;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContactMail = function CommunicationContactMail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z' })
	  );
	};
	CommunicationContactMail = (0, _pure2.default)(CommunicationContactMail);
	CommunicationContactMail.displayName = 'CommunicationContactMail';
	CommunicationContactMail.muiName = 'SvgIcon';
	
	exports.default = CommunicationContactMail;

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContactPhone = function CommunicationContactPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z' })
	  );
	};
	CommunicationContactPhone = (0, _pure2.default)(CommunicationContactPhone);
	CommunicationContactPhone.displayName = 'CommunicationContactPhone';
	CommunicationContactPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationContactPhone;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContacts = function CommunicationContacts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z' })
	  );
	};
	CommunicationContacts = (0, _pure2.default)(CommunicationContacts);
	CommunicationContacts.displayName = 'CommunicationContacts';
	CommunicationContacts.muiName = 'SvgIcon';
	
	exports.default = CommunicationContacts;

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationDialerSip = function CommunicationDialerSip(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	CommunicationDialerSip = (0, _pure2.default)(CommunicationDialerSip);
	CommunicationDialerSip.displayName = 'CommunicationDialerSip';
	CommunicationDialerSip.muiName = 'SvgIcon';
	
	exports.default = CommunicationDialerSip;

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationDialpad = function CommunicationDialpad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	CommunicationDialpad = (0, _pure2.default)(CommunicationDialpad);
	CommunicationDialpad.displayName = 'CommunicationDialpad';
	CommunicationDialpad.muiName = 'SvgIcon';
	
	exports.default = CommunicationDialpad;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationEmail = function CommunicationEmail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	CommunicationEmail = (0, _pure2.default)(CommunicationEmail);
	CommunicationEmail.displayName = 'CommunicationEmail';
	CommunicationEmail.muiName = 'SvgIcon';
	
	exports.default = CommunicationEmail;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationForum = function CommunicationForum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
	  );
	};
	CommunicationForum = (0, _pure2.default)(CommunicationForum);
	CommunicationForum.displayName = 'CommunicationForum';
	CommunicationForum.muiName = 'SvgIcon';
	
	exports.default = CommunicationForum;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationImportContacts = function CommunicationImportContacts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z' })
	  );
	};
	CommunicationImportContacts = (0, _pure2.default)(CommunicationImportContacts);
	CommunicationImportContacts.displayName = 'CommunicationImportContacts';
	CommunicationImportContacts.muiName = 'SvgIcon';
	
	exports.default = CommunicationImportContacts;

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationImportExport = function CommunicationImportExport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z' })
	  );
	};
	CommunicationImportExport = (0, _pure2.default)(CommunicationImportExport);
	CommunicationImportExport.displayName = 'CommunicationImportExport';
	CommunicationImportExport.muiName = 'SvgIcon';
	
	exports.default = CommunicationImportExport;

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationInvertColorsOff = function CommunicationInvertColorsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z' })
	  );
	};
	CommunicationInvertColorsOff = (0, _pure2.default)(CommunicationInvertColorsOff);
	CommunicationInvertColorsOff.displayName = 'CommunicationInvertColorsOff';
	CommunicationInvertColorsOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationInvertColorsOff;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLiveHelp = function CommunicationLiveHelp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
	  );
	};
	CommunicationLiveHelp = (0, _pure2.default)(CommunicationLiveHelp);
	CommunicationLiveHelp.displayName = 'CommunicationLiveHelp';
	CommunicationLiveHelp.muiName = 'SvgIcon';
	
	exports.default = CommunicationLiveHelp;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLocationOff = function CommunicationLocationOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z' })
	  );
	};
	CommunicationLocationOff = (0, _pure2.default)(CommunicationLocationOff);
	CommunicationLocationOff.displayName = 'CommunicationLocationOff';
	CommunicationLocationOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationLocationOff;

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLocationOn = function CommunicationLocationOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	CommunicationLocationOn = (0, _pure2.default)(CommunicationLocationOn);
	CommunicationLocationOn.displayName = 'CommunicationLocationOn';
	CommunicationLocationOn.muiName = 'SvgIcon';
	
	exports.default = CommunicationLocationOn;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationMailOutline = function CommunicationMailOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z' })
	  );
	};
	CommunicationMailOutline = (0, _pure2.default)(CommunicationMailOutline);
	CommunicationMailOutline.displayName = 'CommunicationMailOutline';
	CommunicationMailOutline.muiName = 'SvgIcon';
	
	exports.default = CommunicationMailOutline;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationMessage = function CommunicationMessage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	CommunicationMessage = (0, _pure2.default)(CommunicationMessage);
	CommunicationMessage.displayName = 'CommunicationMessage';
	CommunicationMessage.muiName = 'SvgIcon';
	
	exports.default = CommunicationMessage;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationNoSim = function CommunicationNoSim(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
	  );
	};
	CommunicationNoSim = (0, _pure2.default)(CommunicationNoSim);
	CommunicationNoSim.displayName = 'CommunicationNoSim';
	CommunicationNoSim.muiName = 'SvgIcon';
	
	exports.default = CommunicationNoSim;

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhone = function CommunicationPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	CommunicationPhone = (0, _pure2.default)(CommunicationPhone);
	CommunicationPhone.displayName = 'CommunicationPhone';
	CommunicationPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhone;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkErase = function CommunicationPhonelinkErase(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationPhonelinkErase = (0, _pure2.default)(CommunicationPhonelinkErase);
	CommunicationPhonelinkErase.displayName = 'CommunicationPhonelinkErase';
	CommunicationPhonelinkErase.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkErase;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkLock = function CommunicationPhonelinkLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z' })
	  );
	};
	CommunicationPhonelinkLock = (0, _pure2.default)(CommunicationPhonelinkLock);
	CommunicationPhonelinkLock.displayName = 'CommunicationPhonelinkLock';
	CommunicationPhonelinkLock.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkLock;

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkRing = function CommunicationPhonelinkRing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z' })
	  );
	};
	CommunicationPhonelinkRing = (0, _pure2.default)(CommunicationPhonelinkRing);
	CommunicationPhonelinkRing.displayName = 'CommunicationPhonelinkRing';
	CommunicationPhonelinkRing.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkRing;

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkSetup = function CommunicationPhonelinkSetup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationPhonelinkSetup = (0, _pure2.default)(CommunicationPhonelinkSetup);
	CommunicationPhonelinkSetup.displayName = 'CommunicationPhonelinkSetup';
	CommunicationPhonelinkSetup.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkSetup;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPortableWifiOff = function CommunicationPortableWifiOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z' })
	  );
	};
	CommunicationPortableWifiOff = (0, _pure2.default)(CommunicationPortableWifiOff);
	CommunicationPortableWifiOff.displayName = 'CommunicationPortableWifiOff';
	CommunicationPortableWifiOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationPortableWifiOff;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPresentToAll = function CommunicationPresentToAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z' })
	  );
	};
	CommunicationPresentToAll = (0, _pure2.default)(CommunicationPresentToAll);
	CommunicationPresentToAll.displayName = 'CommunicationPresentToAll';
	CommunicationPresentToAll.muiName = 'SvgIcon';
	
	exports.default = CommunicationPresentToAll;

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationRingVolume = function CommunicationRingVolume(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z' })
	  );
	};
	CommunicationRingVolume = (0, _pure2.default)(CommunicationRingVolume);
	CommunicationRingVolume.displayName = 'CommunicationRingVolume';
	CommunicationRingVolume.muiName = 'SvgIcon';
	
	exports.default = CommunicationRingVolume;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationRssFeed = function CommunicationRssFeed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '6.18', cy: '17.82', r: '2.18' }),
	    _react2.default.createElement('path', { d: 'M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z' })
	  );
	};
	CommunicationRssFeed = (0, _pure2.default)(CommunicationRssFeed);
	CommunicationRssFeed.displayName = 'CommunicationRssFeed';
	CommunicationRssFeed.muiName = 'SvgIcon';
	
	exports.default = CommunicationRssFeed;

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationScreenShare = function CommunicationScreenShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z' })
	  );
	};
	CommunicationScreenShare = (0, _pure2.default)(CommunicationScreenShare);
	CommunicationScreenShare.displayName = 'CommunicationScreenShare';
	CommunicationScreenShare.muiName = 'SvgIcon';
	
	exports.default = CommunicationScreenShare;

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationSpeakerPhone = function CommunicationSpeakerPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z' })
	  );
	};
	CommunicationSpeakerPhone = (0, _pure2.default)(CommunicationSpeakerPhone);
	CommunicationSpeakerPhone.displayName = 'CommunicationSpeakerPhone';
	CommunicationSpeakerPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationSpeakerPhone;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayCurrentLandscape = function CommunicationStayCurrentLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
	  );
	};
	CommunicationStayCurrentLandscape = (0, _pure2.default)(CommunicationStayCurrentLandscape);
	CommunicationStayCurrentLandscape.displayName = 'CommunicationStayCurrentLandscape';
	CommunicationStayCurrentLandscape.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayCurrentLandscape;

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayCurrentPortrait = function CommunicationStayCurrentPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	CommunicationStayCurrentPortrait = (0, _pure2.default)(CommunicationStayCurrentPortrait);
	CommunicationStayCurrentPortrait.displayName = 'CommunicationStayCurrentPortrait';
	CommunicationStayCurrentPortrait.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayCurrentPortrait;

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayPrimaryLandscape = function CommunicationStayPrimaryLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
	  );
	};
	CommunicationStayPrimaryLandscape = (0, _pure2.default)(CommunicationStayPrimaryLandscape);
	CommunicationStayPrimaryLandscape.displayName = 'CommunicationStayPrimaryLandscape';
	CommunicationStayPrimaryLandscape.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayPrimaryLandscape;

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayPrimaryPortrait = function CommunicationStayPrimaryPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	CommunicationStayPrimaryPortrait = (0, _pure2.default)(CommunicationStayPrimaryPortrait);
	CommunicationStayPrimaryPortrait.displayName = 'CommunicationStayPrimaryPortrait';
	CommunicationStayPrimaryPortrait.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayPrimaryPortrait;

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStopScreenShare = function CommunicationStopScreenShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z' })
	  );
	};
	CommunicationStopScreenShare = (0, _pure2.default)(CommunicationStopScreenShare);
	CommunicationStopScreenShare.displayName = 'CommunicationStopScreenShare';
	CommunicationStopScreenShare.muiName = 'SvgIcon';
	
	exports.default = CommunicationStopScreenShare;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationSwapCalls = function CommunicationSwapCalls(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z' })
	  );
	};
	CommunicationSwapCalls = (0, _pure2.default)(CommunicationSwapCalls);
	CommunicationSwapCalls.displayName = 'CommunicationSwapCalls';
	CommunicationSwapCalls.muiName = 'SvgIcon';
	
	exports.default = CommunicationSwapCalls;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationTextsms = function CommunicationTextsms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
	  );
	};
	CommunicationTextsms = (0, _pure2.default)(CommunicationTextsms);
	CommunicationTextsms.displayName = 'CommunicationTextsms';
	CommunicationTextsms.muiName = 'SvgIcon';
	
	exports.default = CommunicationTextsms;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationVoicemail = function CommunicationVoicemail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z' })
	  );
	};
	CommunicationVoicemail = (0, _pure2.default)(CommunicationVoicemail);
	CommunicationVoicemail.displayName = 'CommunicationVoicemail';
	CommunicationVoicemail.muiName = 'SvgIcon';
	
	exports.default = CommunicationVoicemail;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationVpnKey = function CommunicationVpnKey(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	CommunicationVpnKey = (0, _pure2.default)(CommunicationVpnKey);
	CommunicationVpnKey.displayName = 'CommunicationVpnKey';
	CommunicationVpnKey.muiName = 'SvgIcon';
	
	exports.default = CommunicationVpnKey;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddBox = function ContentAddBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
	  );
	};
	ContentAddBox = (0, _pure2.default)(ContentAddBox);
	ContentAddBox.displayName = 'ContentAddBox';
	ContentAddBox.muiName = 'SvgIcon';
	
	exports.default = ContentAddBox;

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddCircleOutline = function ContentAddCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ContentAddCircleOutline = (0, _pure2.default)(ContentAddCircleOutline);
	ContentAddCircleOutline.displayName = 'ContentAddCircleOutline';
	ContentAddCircleOutline.muiName = 'SvgIcon';
	
	exports.default = ContentAddCircleOutline;

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddCircle = function ContentAddCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
	  );
	};
	ContentAddCircle = (0, _pure2.default)(ContentAddCircle);
	ContentAddCircle.displayName = 'ContentAddCircle';
	ContentAddCircle.muiName = 'SvgIcon';
	
	exports.default = ContentAddCircle;

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAdd = function ContentAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
	  );
	};
	ContentAdd = (0, _pure2.default)(ContentAdd);
	ContentAdd.displayName = 'ContentAdd';
	ContentAdd.muiName = 'SvgIcon';
	
	exports.default = ContentAdd;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentArchive = function ContentArchive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z' })
	  );
	};
	ContentArchive = (0, _pure2.default)(ContentArchive);
	ContentArchive.displayName = 'ContentArchive';
	ContentArchive.muiName = 'SvgIcon';
	
	exports.default = ContentArchive;

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentBackspace = function ContentBackspace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z' })
	  );
	};
	ContentBackspace = (0, _pure2.default)(ContentBackspace);
	ContentBackspace.displayName = 'ContentBackspace';
	ContentBackspace.muiName = 'SvgIcon';
	
	exports.default = ContentBackspace;

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentBlock = function ContentBlock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z' })
	  );
	};
	ContentBlock = (0, _pure2.default)(ContentBlock);
	ContentBlock.displayName = 'ContentBlock';
	ContentBlock.muiName = 'SvgIcon';
	
	exports.default = ContentBlock;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentClear = function ContentClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	ContentClear = (0, _pure2.default)(ContentClear);
	ContentClear.displayName = 'ContentClear';
	ContentClear.muiName = 'SvgIcon';
	
	exports.default = ContentClear;

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentCopy = function ContentContentCopy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
	  );
	};
	ContentContentCopy = (0, _pure2.default)(ContentContentCopy);
	ContentContentCopy.displayName = 'ContentContentCopy';
	ContentContentCopy.muiName = 'SvgIcon';
	
	exports.default = ContentContentCopy;

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentCut = function ContentContentCut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z' })
	  );
	};
	ContentContentCut = (0, _pure2.default)(ContentContentCut);
	ContentContentCut.displayName = 'ContentContentCut';
	ContentContentCut.muiName = 'SvgIcon';
	
	exports.default = ContentContentCut;

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentPaste = function ContentContentPaste(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z' })
	  );
	};
	ContentContentPaste = (0, _pure2.default)(ContentContentPaste);
	ContentContentPaste.displayName = 'ContentContentPaste';
	ContentContentPaste.muiName = 'SvgIcon';
	
	exports.default = ContentContentPaste;

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentCreate = function ContentCreate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	ContentCreate = (0, _pure2.default)(ContentCreate);
	ContentCreate.displayName = 'ContentCreate';
	ContentCreate.muiName = 'SvgIcon';
	
	exports.default = ContentCreate;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentDeleteSweep = function ContentDeleteSweep(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z' })
	  );
	};
	ContentDeleteSweep = (0, _pure2.default)(ContentDeleteSweep);
	ContentDeleteSweep.displayName = 'ContentDeleteSweep';
	ContentDeleteSweep.muiName = 'SvgIcon';
	
	exports.default = ContentDeleteSweep;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentDrafts = function ContentDrafts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z' })
	  );
	};
	ContentDrafts = (0, _pure2.default)(ContentDrafts);
	ContentDrafts.displayName = 'ContentDrafts';
	ContentDrafts.muiName = 'SvgIcon';
	
	exports.default = ContentDrafts;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFilterList = function ContentFilterList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' })
	  );
	};
	ContentFilterList = (0, _pure2.default)(ContentFilterList);
	ContentFilterList.displayName = 'ContentFilterList';
	ContentFilterList.muiName = 'SvgIcon';
	
	exports.default = ContentFilterList;

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFlag = function ContentFlag(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
	  );
	};
	ContentFlag = (0, _pure2.default)(ContentFlag);
	ContentFlag.displayName = 'ContentFlag';
	ContentFlag.muiName = 'SvgIcon';
	
	exports.default = ContentFlag;

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFontDownload = function ContentFontDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
	  );
	};
	ContentFontDownload = (0, _pure2.default)(ContentFontDownload);
	ContentFontDownload.displayName = 'ContentFontDownload';
	ContentFontDownload.muiName = 'SvgIcon';
	
	exports.default = ContentFontDownload;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentForward = function ContentForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8V4l8 8-8 8v-4H4V8z' })
	  );
	};
	ContentForward = (0, _pure2.default)(ContentForward);
	ContentForward.displayName = 'ContentForward';
	ContentForward.muiName = 'SvgIcon';
	
	exports.default = ContentForward;

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentGesture = function ContentGesture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z' })
	  );
	};
	ContentGesture = (0, _pure2.default)(ContentGesture);
	ContentGesture.displayName = 'ContentGesture';
	ContentGesture.muiName = 'SvgIcon';
	
	exports.default = ContentGesture;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentInbox = function ContentInbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z' })
	  );
	};
	ContentInbox = (0, _pure2.default)(ContentInbox);
	ContentInbox.displayName = 'ContentInbox';
	ContentInbox.muiName = 'SvgIcon';
	
	exports.default = ContentInbox;

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLink = function ContentLink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	  );
	};
	ContentLink = (0, _pure2.default)(ContentLink);
	ContentLink.displayName = 'ContentLink';
	ContentLink.muiName = 'SvgIcon';
	
	exports.default = ContentLink;

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLowPriority = function ContentLowPriority(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z' })
	  );
	};
	ContentLowPriority = (0, _pure2.default)(ContentLowPriority);
	ContentLowPriority.displayName = 'ContentLowPriority';
	ContentLowPriority.muiName = 'SvgIcon';
	
	exports.default = ContentLowPriority;

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMail = function ContentMail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	ContentMail = (0, _pure2.default)(ContentMail);
	ContentMail.displayName = 'ContentMail';
	ContentMail.muiName = 'SvgIcon';
	
	exports.default = ContentMail;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMarkunread = function ContentMarkunread(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	ContentMarkunread = (0, _pure2.default)(ContentMarkunread);
	ContentMarkunread.displayName = 'ContentMarkunread';
	ContentMarkunread.muiName = 'SvgIcon';
	
	exports.default = ContentMarkunread;

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMoveToInbox = function ContentMoveToInbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z' })
	  );
	};
	ContentMoveToInbox = (0, _pure2.default)(ContentMoveToInbox);
	ContentMoveToInbox.displayName = 'ContentMoveToInbox';
	ContentMoveToInbox.muiName = 'SvgIcon';
	
	exports.default = ContentMoveToInbox;

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentNextWeek = function ContentNextWeek(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z' })
	  );
	};
	ContentNextWeek = (0, _pure2.default)(ContentNextWeek);
	ContentNextWeek.displayName = 'ContentNextWeek';
	ContentNextWeek.muiName = 'SvgIcon';
	
	exports.default = ContentNextWeek;

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRedo = function ContentRedo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z' })
	  );
	};
	ContentRedo = (0, _pure2.default)(ContentRedo);
	ContentRedo.displayName = 'ContentRedo';
	ContentRedo.muiName = 'SvgIcon';
	
	exports.default = ContentRedo;

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemoveCircleOutline = function ContentRemoveCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ContentRemoveCircleOutline = (0, _pure2.default)(ContentRemoveCircleOutline);
	ContentRemoveCircleOutline.displayName = 'ContentRemoveCircleOutline';
	ContentRemoveCircleOutline.muiName = 'SvgIcon';
	
	exports.default = ContentRemoveCircleOutline;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemoveCircle = function ContentRemoveCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
	  );
	};
	ContentRemoveCircle = (0, _pure2.default)(ContentRemoveCircle);
	ContentRemoveCircle.displayName = 'ContentRemoveCircle';
	ContentRemoveCircle.muiName = 'SvgIcon';
	
	exports.default = ContentRemoveCircle;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemove = function ContentRemove(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13H5v-2h14v2z' })
	  );
	};
	ContentRemove = (0, _pure2.default)(ContentRemove);
	ContentRemove.displayName = 'ContentRemove';
	ContentRemove.muiName = 'SvgIcon';
	
	exports.default = ContentRemove;

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReplyAll = function ContentReplyAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
	  );
	};
	ContentReplyAll = (0, _pure2.default)(ContentReplyAll);
	ContentReplyAll.displayName = 'ContentReplyAll';
	ContentReplyAll.muiName = 'SvgIcon';
	
	exports.default = ContentReplyAll;

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReply = function ContentReply(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
	  );
	};
	ContentReply = (0, _pure2.default)(ContentReply);
	ContentReply.displayName = 'ContentReply';
	ContentReply.muiName = 'SvgIcon';
	
	exports.default = ContentReply;

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReport = function ContentReport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z' })
	  );
	};
	ContentReport = (0, _pure2.default)(ContentReport);
	ContentReport.displayName = 'ContentReport';
	ContentReport.muiName = 'SvgIcon';
	
	exports.default = ContentReport;

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSave = function ContentSave(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z' })
	  );
	};
	ContentSave = (0, _pure2.default)(ContentSave);
	ContentSave.displayName = 'ContentSave';
	ContentSave.muiName = 'SvgIcon';
	
	exports.default = ContentSave;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSelectAll = function ContentSelectAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z' })
	  );
	};
	ContentSelectAll = (0, _pure2.default)(ContentSelectAll);
	ContentSelectAll.displayName = 'ContentSelectAll';
	ContentSelectAll.muiName = 'SvgIcon';
	
	exports.default = ContentSelectAll;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSend = function ContentSend(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' })
	  );
	};
	ContentSend = (0, _pure2.default)(ContentSend);
	ContentSend.displayName = 'ContentSend';
	ContentSend.muiName = 'SvgIcon';
	
	exports.default = ContentSend;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSort = function ContentSort(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z' })
	  );
	};
	ContentSort = (0, _pure2.default)(ContentSort);
	ContentSort.displayName = 'ContentSort';
	ContentSort.muiName = 'SvgIcon';
	
	exports.default = ContentSort;

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentTextFormat = function ContentTextFormat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z' })
	  );
	};
	ContentTextFormat = (0, _pure2.default)(ContentTextFormat);
	ContentTextFormat.displayName = 'ContentTextFormat';
	ContentTextFormat.muiName = 'SvgIcon';
	
	exports.default = ContentTextFormat;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentUnarchive = function ContentUnarchive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z' })
	  );
	};
	ContentUnarchive = (0, _pure2.default)(ContentUnarchive);
	ContentUnarchive.displayName = 'ContentUnarchive';
	ContentUnarchive.muiName = 'SvgIcon';
	
	exports.default = ContentUnarchive;

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentUndo = function ContentUndo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z' })
	  );
	};
	ContentUndo = (0, _pure2.default)(ContentUndo);
	ContentUndo.displayName = 'ContentUndo';
	ContentUndo.muiName = 'SvgIcon';
	
	exports.default = ContentUndo;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentWeekend = function ContentWeekend(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z' })
	  );
	};
	ContentWeekend = (0, _pure2.default)(ContentWeekend);
	ContentWeekend.displayName = 'ContentWeekend';
	ContentWeekend.muiName = 'SvgIcon';
	
	exports.default = ContentWeekend;

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessAlarm = function DeviceAccessAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceAccessAlarm = (0, _pure2.default)(DeviceAccessAlarm);
	DeviceAccessAlarm.displayName = 'DeviceAccessAlarm';
	DeviceAccessAlarm.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessAlarm;

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessAlarms = function DeviceAccessAlarms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z' })
	  );
	};
	DeviceAccessAlarms = (0, _pure2.default)(DeviceAccessAlarms);
	DeviceAccessAlarms.displayName = 'DeviceAccessAlarms';
	DeviceAccessAlarms.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessAlarms;

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessTime = function DeviceAccessTime(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	DeviceAccessTime = (0, _pure2.default)(DeviceAccessTime);
	DeviceAccessTime.displayName = 'DeviceAccessTime';
	DeviceAccessTime.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessTime;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAddAlarm = function DeviceAddAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
	  );
	};
	DeviceAddAlarm = (0, _pure2.default)(DeviceAddAlarm);
	DeviceAddAlarm.displayName = 'DeviceAddAlarm';
	DeviceAddAlarm.muiName = 'SvgIcon';
	
	exports.default = DeviceAddAlarm;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAirplanemodeActive = function DeviceAirplanemodeActive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.18 9' }),
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	DeviceAirplanemodeActive = (0, _pure2.default)(DeviceAirplanemodeActive);
	DeviceAirplanemodeActive.displayName = 'DeviceAirplanemodeActive';
	DeviceAirplanemodeActive.muiName = 'SvgIcon';
	
	exports.default = DeviceAirplanemodeActive;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAirplanemodeInactive = function DeviceAirplanemodeInactive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z' })
	  );
	};
	DeviceAirplanemodeInactive = (0, _pure2.default)(DeviceAirplanemodeInactive);
	DeviceAirplanemodeInactive.displayName = 'DeviceAirplanemodeInactive';
	DeviceAirplanemodeInactive.muiName = 'SvgIcon';
	
	exports.default = DeviceAirplanemodeInactive;

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery20 = function DeviceBattery20(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z' })
	  );
	};
	DeviceBattery20 = (0, _pure2.default)(DeviceBattery20);
	DeviceBattery20.displayName = 'DeviceBattery20';
	DeviceBattery20.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery20;

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery30 = function DeviceBattery30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z' })
	  );
	};
	DeviceBattery30 = (0, _pure2.default)(DeviceBattery30);
	DeviceBattery30.displayName = 'DeviceBattery30';
	DeviceBattery30.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery30;

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery50 = function DeviceBattery50(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z' })
	  );
	};
	DeviceBattery50 = (0, _pure2.default)(DeviceBattery50);
	DeviceBattery50.displayName = 'DeviceBattery50';
	DeviceBattery50.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery50;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery60 = function DeviceBattery60(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z' })
	  );
	};
	DeviceBattery60 = (0, _pure2.default)(DeviceBattery60);
	DeviceBattery60.displayName = 'DeviceBattery60';
	DeviceBattery60.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery60;

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery80 = function DeviceBattery80(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z' })
	  );
	};
	DeviceBattery80 = (0, _pure2.default)(DeviceBattery80);
	DeviceBattery80.displayName = 'DeviceBattery80';
	DeviceBattery80.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery80;

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery90 = function DeviceBattery90(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z' })
	  );
	};
	DeviceBattery90 = (0, _pure2.default)(DeviceBattery90);
	DeviceBattery90.displayName = 'DeviceBattery90';
	DeviceBattery90.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery90;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryAlert = function DeviceBatteryAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z' })
	  );
	};
	DeviceBatteryAlert = (0, _pure2.default)(DeviceBatteryAlert);
	DeviceBatteryAlert.displayName = 'DeviceBatteryAlert';
	DeviceBatteryAlert.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryAlert;

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging20 = function DeviceBatteryCharging20(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryCharging20 = (0, _pure2.default)(DeviceBatteryCharging20);
	DeviceBatteryCharging20.displayName = 'DeviceBatteryCharging20';
	DeviceBatteryCharging20.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging20;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging30 = function DeviceBatteryCharging30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z' })
	  );
	};
	DeviceBatteryCharging30 = (0, _pure2.default)(DeviceBatteryCharging30);
	DeviceBatteryCharging30.displayName = 'DeviceBatteryCharging30';
	DeviceBatteryCharging30.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging30;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging50 = function DeviceBatteryCharging50(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryCharging50 = (0, _pure2.default)(DeviceBatteryCharging50);
	DeviceBatteryCharging50.displayName = 'DeviceBatteryCharging50';
	DeviceBatteryCharging50.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging50;

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging60 = function DeviceBatteryCharging60(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z' })
	  );
	};
	DeviceBatteryCharging60 = (0, _pure2.default)(DeviceBatteryCharging60);
	DeviceBatteryCharging60.displayName = 'DeviceBatteryCharging60';
	DeviceBatteryCharging60.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging60;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging80 = function DeviceBatteryCharging80(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z' })
	  );
	};
	DeviceBatteryCharging80 = (0, _pure2.default)(DeviceBatteryCharging80);
	DeviceBatteryCharging80.displayName = 'DeviceBatteryCharging80';
	DeviceBatteryCharging80.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging80;

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging90 = function DeviceBatteryCharging90(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z' })
	  );
	};
	DeviceBatteryCharging90 = (0, _pure2.default)(DeviceBatteryCharging90);
	DeviceBatteryCharging90.displayName = 'DeviceBatteryCharging90';
	DeviceBatteryCharging90.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging90;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryChargingFull = function DeviceBatteryChargingFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z' })
	  );
	};
	DeviceBatteryChargingFull = (0, _pure2.default)(DeviceBatteryChargingFull);
	DeviceBatteryChargingFull.displayName = 'DeviceBatteryChargingFull';
	DeviceBatteryChargingFull.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryChargingFull;

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryFull = function DeviceBatteryFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryFull = (0, _pure2.default)(DeviceBatteryFull);
	DeviceBatteryFull.displayName = 'DeviceBatteryFull';
	DeviceBatteryFull.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryFull;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryStd = function DeviceBatteryStd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryStd = (0, _pure2.default)(DeviceBatteryStd);
	DeviceBatteryStd.displayName = 'DeviceBatteryStd';
	DeviceBatteryStd.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryStd;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryUnknown = function DeviceBatteryUnknown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z' })
	  );
	};
	DeviceBatteryUnknown = (0, _pure2.default)(DeviceBatteryUnknown);
	DeviceBatteryUnknown.displayName = 'DeviceBatteryUnknown';
	DeviceBatteryUnknown.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryUnknown;

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothConnected = function DeviceBluetoothConnected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z' })
	  );
	};
	DeviceBluetoothConnected = (0, _pure2.default)(DeviceBluetoothConnected);
	DeviceBluetoothConnected.displayName = 'DeviceBluetoothConnected';
	DeviceBluetoothConnected.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothConnected;

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothDisabled = function DeviceBluetoothDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z' })
	  );
	};
	DeviceBluetoothDisabled = (0, _pure2.default)(DeviceBluetoothDisabled);
	DeviceBluetoothDisabled.displayName = 'DeviceBluetoothDisabled';
	DeviceBluetoothDisabled.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothDisabled;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothSearching = function DeviceBluetoothSearching(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
	  );
	};
	DeviceBluetoothSearching = (0, _pure2.default)(DeviceBluetoothSearching);
	DeviceBluetoothSearching.displayName = 'DeviceBluetoothSearching';
	DeviceBluetoothSearching.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothSearching;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetooth = function DeviceBluetooth(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z' })
	  );
	};
	DeviceBluetooth = (0, _pure2.default)(DeviceBluetooth);
	DeviceBluetooth.displayName = 'DeviceBluetooth';
	DeviceBluetooth.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetooth;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessAuto = function DeviceBrightnessAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z' })
	  );
	};
	DeviceBrightnessAuto = (0, _pure2.default)(DeviceBrightnessAuto);
	DeviceBrightnessAuto.displayName = 'DeviceBrightnessAuto';
	DeviceBrightnessAuto.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessAuto;

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessHigh = function DeviceBrightnessHigh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
	  );
	};
	DeviceBrightnessHigh = (0, _pure2.default)(DeviceBrightnessHigh);
	DeviceBrightnessHigh.displayName = 'DeviceBrightnessHigh';
	DeviceBrightnessHigh.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessHigh;

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessLow = function DeviceBrightnessLow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	DeviceBrightnessLow = (0, _pure2.default)(DeviceBrightnessLow);
	DeviceBrightnessLow.displayName = 'DeviceBrightnessLow';
	DeviceBrightnessLow.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessLow;

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessMedium = function DeviceBrightnessMedium(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	DeviceBrightnessMedium = (0, _pure2.default)(DeviceBrightnessMedium);
	DeviceBrightnessMedium.displayName = 'DeviceBrightnessMedium';
	DeviceBrightnessMedium.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessMedium;

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDataUsage = function DeviceDataUsage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z' })
	  );
	};
	DeviceDataUsage = (0, _pure2.default)(DeviceDataUsage);
	DeviceDataUsage.displayName = 'DeviceDataUsage';
	DeviceDataUsage.muiName = 'SvgIcon';
	
	exports.default = DeviceDataUsage;

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDeveloperMode = function DeviceDeveloperMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z' })
	  );
	};
	DeviceDeveloperMode = (0, _pure2.default)(DeviceDeveloperMode);
	DeviceDeveloperMode.displayName = 'DeviceDeveloperMode';
	DeviceDeveloperMode.muiName = 'SvgIcon';
	
	exports.default = DeviceDeveloperMode;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDevices = function DeviceDevices(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
	  );
	};
	DeviceDevices = (0, _pure2.default)(DeviceDevices);
	DeviceDevices.displayName = 'DeviceDevices';
	DeviceDevices.muiName = 'SvgIcon';
	
	exports.default = DeviceDevices;

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDvr = function DeviceDvr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z' })
	  );
	};
	DeviceDvr = (0, _pure2.default)(DeviceDvr);
	DeviceDvr.displayName = 'DeviceDvr';
	DeviceDvr.muiName = 'SvgIcon';
	
	exports.default = DeviceDvr;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsFixed = function DeviceGpsFixed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceGpsFixed = (0, _pure2.default)(DeviceGpsFixed);
	DeviceGpsFixed.displayName = 'DeviceGpsFixed';
	DeviceGpsFixed.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsFixed;

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsNotFixed = function DeviceGpsNotFixed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceGpsNotFixed = (0, _pure2.default)(DeviceGpsNotFixed);
	DeviceGpsNotFixed.displayName = 'DeviceGpsNotFixed';
	DeviceGpsNotFixed.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsNotFixed;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsOff = function DeviceGpsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
	  );
	};
	DeviceGpsOff = (0, _pure2.default)(DeviceGpsOff);
	DeviceGpsOff.displayName = 'DeviceGpsOff';
	DeviceGpsOff.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsOff;

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGraphicEq = function DeviceGraphicEq(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z' })
	  );
	};
	DeviceGraphicEq = (0, _pure2.default)(DeviceGraphicEq);
	DeviceGraphicEq.displayName = 'DeviceGraphicEq';
	DeviceGraphicEq.muiName = 'SvgIcon';
	
	exports.default = DeviceGraphicEq;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceLocationDisabled = function DeviceLocationDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
	  );
	};
	DeviceLocationDisabled = (0, _pure2.default)(DeviceLocationDisabled);
	DeviceLocationDisabled.displayName = 'DeviceLocationDisabled';
	DeviceLocationDisabled.muiName = 'SvgIcon';
	
	exports.default = DeviceLocationDisabled;

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceLocationSearching = function DeviceLocationSearching(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceLocationSearching = (0, _pure2.default)(DeviceLocationSearching);
	DeviceLocationSearching.displayName = 'DeviceLocationSearching';
	DeviceLocationSearching.muiName = 'SvgIcon';
	
	exports.default = DeviceLocationSearching;

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNetworkCell = function DeviceNetworkCell(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M17 7L2 22h15z' })
	  );
	};
	DeviceNetworkCell = (0, _pure2.default)(DeviceNetworkCell);
	DeviceNetworkCell.displayName = 'DeviceNetworkCell';
	DeviceNetworkCell.muiName = 'SvgIcon';
	
	exports.default = DeviceNetworkCell;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNetworkWifi = function DeviceNetworkWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
	  );
	};
	DeviceNetworkWifi = (0, _pure2.default)(DeviceNetworkWifi);
	DeviceNetworkWifi.displayName = 'DeviceNetworkWifi';
	DeviceNetworkWifi.muiName = 'SvgIcon';
	
	exports.default = DeviceNetworkWifi;

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNfc = function DeviceNfc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z' })
	  );
	};
	DeviceNfc = (0, _pure2.default)(DeviceNfc);
	DeviceNfc.displayName = 'DeviceNfc';
	DeviceNfc.muiName = 'SvgIcon';
	
	exports.default = DeviceNfc;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockLandscape = function DeviceScreenLockLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z' })
	  );
	};
	DeviceScreenLockLandscape = (0, _pure2.default)(DeviceScreenLockLandscape);
	DeviceScreenLockLandscape.displayName = 'DeviceScreenLockLandscape';
	DeviceScreenLockLandscape.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockLandscape;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockPortrait = function DeviceScreenLockPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z' })
	  );
	};
	DeviceScreenLockPortrait = (0, _pure2.default)(DeviceScreenLockPortrait);
	DeviceScreenLockPortrait.displayName = 'DeviceScreenLockPortrait';
	DeviceScreenLockPortrait.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockPortrait;

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockRotation = function DeviceScreenLockRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z' })
	  );
	};
	DeviceScreenLockRotation = (0, _pure2.default)(DeviceScreenLockRotation);
	DeviceScreenLockRotation.displayName = 'DeviceScreenLockRotation';
	DeviceScreenLockRotation.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockRotation;

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenRotation = function DeviceScreenRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z' })
	  );
	};
	DeviceScreenRotation = (0, _pure2.default)(DeviceScreenRotation);
	DeviceScreenRotation.displayName = 'DeviceScreenRotation';
	DeviceScreenRotation.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenRotation;

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSdStorage = function DeviceSdStorage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
	  );
	};
	DeviceSdStorage = (0, _pure2.default)(DeviceSdStorage);
	DeviceSdStorage.displayName = 'DeviceSdStorage';
	DeviceSdStorage.muiName = 'SvgIcon';
	
	exports.default = DeviceSdStorage;

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSettingsSystemDaydream = function DeviceSettingsSystemDaydream(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	DeviceSettingsSystemDaydream = (0, _pure2.default)(DeviceSettingsSystemDaydream);
	DeviceSettingsSystemDaydream.displayName = 'DeviceSettingsSystemDaydream';
	DeviceSettingsSystemDaydream.muiName = 'SvgIcon';
	
	exports.default = DeviceSettingsSystemDaydream;

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular0Bar = function DeviceSignalCellular0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' })
	  );
	};
	DeviceSignalCellular0Bar = (0, _pure2.default)(DeviceSignalCellular0Bar);
	DeviceSignalCellular0Bar.displayName = 'DeviceSignalCellular0Bar';
	DeviceSignalCellular0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular0Bar;

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular1Bar = function DeviceSignalCellular1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M12 12L2 22h10z' })
	  );
	};
	DeviceSignalCellular1Bar = (0, _pure2.default)(DeviceSignalCellular1Bar);
	DeviceSignalCellular1Bar.displayName = 'DeviceSignalCellular1Bar';
	DeviceSignalCellular1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular1Bar;

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular2Bar = function DeviceSignalCellular2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M14 10L2 22h12z' })
	  );
	};
	DeviceSignalCellular2Bar = (0, _pure2.default)(DeviceSignalCellular2Bar);
	DeviceSignalCellular2Bar.displayName = 'DeviceSignalCellular2Bar';
	DeviceSignalCellular2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular2Bar;

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular3Bar = function DeviceSignalCellular3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M17 7L2 22h15z' })
	  );
	};
	DeviceSignalCellular3Bar = (0, _pure2.default)(DeviceSignalCellular3Bar);
	DeviceSignalCellular3Bar.displayName = 'DeviceSignalCellular3Bar';
	DeviceSignalCellular3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular3Bar;

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular4Bar = function DeviceSignalCellular4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 22h20V2z' })
	  );
	};
	DeviceSignalCellular4Bar = (0, _pure2.default)(DeviceSignalCellular4Bar);
	DeviceSignalCellular4Bar.displayName = 'DeviceSignalCellular4Bar';
	DeviceSignalCellular4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular4Bar;

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet0Bar = function DeviceSignalCellularConnectedNoInternet0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet0Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet0Bar);
	DeviceSignalCellularConnectedNoInternet0Bar.displayName = 'DeviceSignalCellularConnectedNoInternet0Bar';
	DeviceSignalCellularConnectedNoInternet0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet0Bar;

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet1Bar = function DeviceSignalCellularConnectedNoInternet1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet1Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet1Bar);
	DeviceSignalCellularConnectedNoInternet1Bar.displayName = 'DeviceSignalCellularConnectedNoInternet1Bar';
	DeviceSignalCellularConnectedNoInternet1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet1Bar;

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet2Bar = function DeviceSignalCellularConnectedNoInternet2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet2Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet2Bar);
	DeviceSignalCellularConnectedNoInternet2Bar.displayName = 'DeviceSignalCellularConnectedNoInternet2Bar';
	DeviceSignalCellularConnectedNoInternet2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet2Bar;

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet3Bar = function DeviceSignalCellularConnectedNoInternet3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet3Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet3Bar);
	DeviceSignalCellularConnectedNoInternet3Bar.displayName = 'DeviceSignalCellularConnectedNoInternet3Bar';
	DeviceSignalCellularConnectedNoInternet3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet3Bar;

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet4Bar = function DeviceSignalCellularConnectedNoInternet4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet4Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet4Bar);
	DeviceSignalCellularConnectedNoInternet4Bar.displayName = 'DeviceSignalCellularConnectedNoInternet4Bar';
	DeviceSignalCellularConnectedNoInternet4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet4Bar;

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularNoSim = function DeviceSignalCellularNoSim(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
	  );
	};
	DeviceSignalCellularNoSim = (0, _pure2.default)(DeviceSignalCellularNoSim);
	DeviceSignalCellularNoSim.displayName = 'DeviceSignalCellularNoSim';
	DeviceSignalCellularNoSim.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularNoSim;

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularNull = function DeviceSignalCellularNull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z' })
	  );
	};
	DeviceSignalCellularNull = (0, _pure2.default)(DeviceSignalCellularNull);
	DeviceSignalCellularNull.displayName = 'DeviceSignalCellularNull';
	DeviceSignalCellularNull.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularNull;

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularOff = function DeviceSignalCellularOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z' })
	  );
	};
	DeviceSignalCellularOff = (0, _pure2.default)(DeviceSignalCellularOff);
	DeviceSignalCellularOff.displayName = 'DeviceSignalCellularOff';
	DeviceSignalCellularOff.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularOff;

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi0Bar = function DeviceSignalWifi0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
	  );
	};
	DeviceSignalWifi0Bar = (0, _pure2.default)(DeviceSignalWifi0Bar);
	DeviceSignalWifi0Bar.displayName = 'DeviceSignalWifi0Bar';
	DeviceSignalWifi0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi0Bar;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi1BarLock = function DeviceSignalWifi1BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
	    _react2.default.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
	    _react2.default.createElement('path', { d: 'M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z' })
	  );
	};
	DeviceSignalWifi1BarLock = (0, _pure2.default)(DeviceSignalWifi1BarLock);
	DeviceSignalWifi1BarLock.displayName = 'DeviceSignalWifi1BarLock';
	DeviceSignalWifi1BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi1BarLock;

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi1Bar = function DeviceSignalWifi1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z' })
	  );
	};
	DeviceSignalWifi1Bar = (0, _pure2.default)(DeviceSignalWifi1Bar);
	DeviceSignalWifi1Bar.displayName = 'DeviceSignalWifi1Bar';
	DeviceSignalWifi1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi1Bar;

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi2BarLock = function DeviceSignalWifi2BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
	    _react2.default.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
	    _react2.default.createElement('path', { d: 'M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z' })
	  );
	};
	DeviceSignalWifi2BarLock = (0, _pure2.default)(DeviceSignalWifi2BarLock);
	DeviceSignalWifi2BarLock.displayName = 'DeviceSignalWifi2BarLock';
	DeviceSignalWifi2BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi2BarLock;

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi2Bar = function DeviceSignalWifi2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z' })
	  );
	};
	DeviceSignalWifi2Bar = (0, _pure2.default)(DeviceSignalWifi2Bar);
	DeviceSignalWifi2Bar.displayName = 'DeviceSignalWifi2Bar';
	DeviceSignalWifi2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi2Bar;

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi3BarLock = function DeviceSignalWifi3BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { opacity: '.3', d: 'M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z' }),
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9' })
	  );
	};
	DeviceSignalWifi3BarLock = (0, _pure2.default)(DeviceSignalWifi3BarLock);
	DeviceSignalWifi3BarLock.displayName = 'DeviceSignalWifi3BarLock';
	DeviceSignalWifi3BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi3BarLock;

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi3Bar = function DeviceSignalWifi3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
	  );
	};
	DeviceSignalWifi3Bar = (0, _pure2.default)(DeviceSignalWifi3Bar);
	DeviceSignalWifi3Bar.displayName = 'DeviceSignalWifi3Bar';
	DeviceSignalWifi3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi3Bar;

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi4BarLock = function DeviceSignalWifi4BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z' })
	  );
	};
	DeviceSignalWifi4BarLock = (0, _pure2.default)(DeviceSignalWifi4BarLock);
	DeviceSignalWifi4BarLock.displayName = 'DeviceSignalWifi4BarLock';
	DeviceSignalWifi4BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi4BarLock;

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi4Bar = function DeviceSignalWifi4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
	  );
	};
	DeviceSignalWifi4Bar = (0, _pure2.default)(DeviceSignalWifi4Bar);
	DeviceSignalWifi4Bar.displayName = 'DeviceSignalWifi4Bar';
	DeviceSignalWifi4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi4Bar;

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifiOff = function DeviceSignalWifiOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z' })
	  );
	};
	DeviceSignalWifiOff = (0, _pure2.default)(DeviceSignalWifiOff);
	DeviceSignalWifiOff.displayName = 'DeviceSignalWifiOff';
	DeviceSignalWifiOff.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifiOff;

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceStorage = function DeviceStorage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' })
	  );
	};
	DeviceStorage = (0, _pure2.default)(DeviceStorage);
	DeviceStorage.displayName = 'DeviceStorage';
	DeviceStorage.muiName = 'SvgIcon';
	
	exports.default = DeviceStorage;

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceUsb = function DeviceUsb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z' })
	  );
	};
	DeviceUsb = (0, _pure2.default)(DeviceUsb);
	DeviceUsb.displayName = 'DeviceUsb';
	DeviceUsb.muiName = 'SvgIcon';
	
	exports.default = DeviceUsb;

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWallpaper = function DeviceWallpaper(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z' })
	  );
	};
	DeviceWallpaper = (0, _pure2.default)(DeviceWallpaper);
	DeviceWallpaper.displayName = 'DeviceWallpaper';
	DeviceWallpaper.muiName = 'SvgIcon';
	
	exports.default = DeviceWallpaper;

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWidgets = function DeviceWidgets(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z' })
	  );
	};
	DeviceWidgets = (0, _pure2.default)(DeviceWidgets);
	DeviceWidgets.displayName = 'DeviceWidgets';
	DeviceWidgets.muiName = 'SvgIcon';
	
	exports.default = DeviceWidgets;

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWifiLock = function DeviceWifiLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
	  );
	};
	DeviceWifiLock = (0, _pure2.default)(DeviceWifiLock);
	DeviceWifiLock.displayName = 'DeviceWifiLock';
	DeviceWifiLock.muiName = 'SvgIcon';
	
	exports.default = DeviceWifiLock;

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWifiTethering = function DeviceWifiTethering(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z' })
	  );
	};
	DeviceWifiTethering = (0, _pure2.default)(DeviceWifiTethering);
	DeviceWifiTethering.displayName = 'DeviceWifiTethering';
	DeviceWifiTethering.muiName = 'SvgIcon';
	
	exports.default = DeviceWifiTethering;

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorAttachFile = function EditorAttachFile(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z' })
	  );
	};
	EditorAttachFile = (0, _pure2.default)(EditorAttachFile);
	EditorAttachFile.displayName = 'EditorAttachFile';
	EditorAttachFile.muiName = 'SvgIcon';
	
	exports.default = EditorAttachFile;

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorAttachMoney = function EditorAttachMoney(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z' })
	  );
	};
	EditorAttachMoney = (0, _pure2.default)(EditorAttachMoney);
	EditorAttachMoney.displayName = 'EditorAttachMoney';
	EditorAttachMoney.muiName = 'SvgIcon';
	
	exports.default = EditorAttachMoney;

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderAll = function EditorBorderAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z' })
	  );
	};
	EditorBorderAll = (0, _pure2.default)(EditorBorderAll);
	EditorBorderAll.displayName = 'EditorBorderAll';
	EditorBorderAll.muiName = 'SvgIcon';
	
	exports.default = EditorBorderAll;

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderBottom = function EditorBorderBottom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z' })
	  );
	};
	EditorBorderBottom = (0, _pure2.default)(EditorBorderBottom);
	EditorBorderBottom.displayName = 'EditorBorderBottom';
	EditorBorderBottom.muiName = 'SvgIcon';
	
	exports.default = EditorBorderBottom;

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderClear = function EditorBorderClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
	  );
	};
	EditorBorderClear = (0, _pure2.default)(EditorBorderClear);
	EditorBorderClear.displayName = 'EditorBorderClear';
	EditorBorderClear.muiName = 'SvgIcon';
	
	exports.default = EditorBorderClear;

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderColor = function EditorBorderColor(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z' }),
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
	  );
	};
	EditorBorderColor = (0, _pure2.default)(EditorBorderColor);
	EditorBorderColor.displayName = 'EditorBorderColor';
	EditorBorderColor.muiName = 'SvgIcon';
	
	exports.default = EditorBorderColor;

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderHorizontal = function EditorBorderHorizontal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z' })
	  );
	};
	EditorBorderHorizontal = (0, _pure2.default)(EditorBorderHorizontal);
	EditorBorderHorizontal.displayName = 'EditorBorderHorizontal';
	EditorBorderHorizontal.muiName = 'SvgIcon';
	
	exports.default = EditorBorderHorizontal;

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderInner = function EditorBorderInner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z' })
	  );
	};
	EditorBorderInner = (0, _pure2.default)(EditorBorderInner);
	EditorBorderInner.displayName = 'EditorBorderInner';
	EditorBorderInner.muiName = 'SvgIcon';
	
	exports.default = EditorBorderInner;

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderLeft = function EditorBorderLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
	  );
	};
	EditorBorderLeft = (0, _pure2.default)(EditorBorderLeft);
	EditorBorderLeft.displayName = 'EditorBorderLeft';
	EditorBorderLeft.muiName = 'SvgIcon';
	
	exports.default = EditorBorderLeft;

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderOuter = function EditorBorderOuter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z' })
	  );
	};
	EditorBorderOuter = (0, _pure2.default)(EditorBorderOuter);
	EditorBorderOuter.displayName = 'EditorBorderOuter';
	EditorBorderOuter.muiName = 'SvgIcon';
	
	exports.default = EditorBorderOuter;

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderRight = function EditorBorderRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z' })
	  );
	};
	EditorBorderRight = (0, _pure2.default)(EditorBorderRight);
	EditorBorderRight.displayName = 'EditorBorderRight';
	EditorBorderRight.muiName = 'SvgIcon';
	
	exports.default = EditorBorderRight;

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderStyle = function EditorBorderStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z' })
	  );
	};
	EditorBorderStyle = (0, _pure2.default)(EditorBorderStyle);
	EditorBorderStyle.displayName = 'EditorBorderStyle';
	EditorBorderStyle.muiName = 'SvgIcon';
	
	exports.default = EditorBorderStyle;

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderTop = function EditorBorderTop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z' })
	  );
	};
	EditorBorderTop = (0, _pure2.default)(EditorBorderTop);
	EditorBorderTop.displayName = 'EditorBorderTop';
	EditorBorderTop.muiName = 'SvgIcon';
	
	exports.default = EditorBorderTop;

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderVertical = function EditorBorderVertical(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z' })
	  );
	};
	EditorBorderVertical = (0, _pure2.default)(EditorBorderVertical);
	EditorBorderVertical.displayName = 'EditorBorderVertical';
	EditorBorderVertical.muiName = 'SvgIcon';
	
	exports.default = EditorBorderVertical;

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBubbleChart = function EditorBubbleChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '7.2', cy: '14.4', r: '3.2' }),
	    _react2.default.createElement('circle', { cx: '14.8', cy: '18', r: '2' }),
	    _react2.default.createElement('circle', { cx: '15.2', cy: '8.8', r: '4.8' })
	  );
	};
	EditorBubbleChart = (0, _pure2.default)(EditorBubbleChart);
	EditorBubbleChart.displayName = 'EditorBubbleChart';
	EditorBubbleChart.muiName = 'SvgIcon';
	
	exports.default = EditorBubbleChart;

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorDragHandle = function EditorDragHandle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z' })
	  );
	};
	EditorDragHandle = (0, _pure2.default)(EditorDragHandle);
	EditorDragHandle.displayName = 'EditorDragHandle';
	EditorDragHandle.muiName = 'SvgIcon';
	
	exports.default = EditorDragHandle;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignCenter = function EditorFormatAlignCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignCenter = (0, _pure2.default)(EditorFormatAlignCenter);
	EditorFormatAlignCenter.displayName = 'EditorFormatAlignCenter';
	EditorFormatAlignCenter.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignCenter;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignJustify = function EditorFormatAlignJustify(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z' })
	  );
	};
	EditorFormatAlignJustify = (0, _pure2.default)(EditorFormatAlignJustify);
	EditorFormatAlignJustify.displayName = 'EditorFormatAlignJustify';
	EditorFormatAlignJustify.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignJustify;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignLeft = function EditorFormatAlignLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignLeft = (0, _pure2.default)(EditorFormatAlignLeft);
	EditorFormatAlignLeft.displayName = 'EditorFormatAlignLeft';
	EditorFormatAlignLeft.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignLeft;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignRight = function EditorFormatAlignRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignRight = (0, _pure2.default)(EditorFormatAlignRight);
	EditorFormatAlignRight.displayName = 'EditorFormatAlignRight';
	EditorFormatAlignRight.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignRight;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatBold = function EditorFormatBold(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z' })
	  );
	};
	EditorFormatBold = (0, _pure2.default)(EditorFormatBold);
	EditorFormatBold.displayName = 'EditorFormatBold';
	EditorFormatBold.muiName = 'SvgIcon';
	
	exports.default = EditorFormatBold;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatClear = function EditorFormatClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z' })
	  );
	};
	EditorFormatClear = (0, _pure2.default)(EditorFormatClear);
	EditorFormatClear.displayName = 'EditorFormatClear';
	EditorFormatClear.muiName = 'SvgIcon';
	
	exports.default = EditorFormatClear;

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorFill = function EditorFormatColorFill(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z' }),
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
	  );
	};
	EditorFormatColorFill = (0, _pure2.default)(EditorFormatColorFill);
	EditorFormatColorFill.displayName = 'EditorFormatColorFill';
	EditorFormatColorFill.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorFill;

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorReset = function EditorFormatColorReset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z' })
	  );
	};
	EditorFormatColorReset = (0, _pure2.default)(EditorFormatColorReset);
	EditorFormatColorReset.displayName = 'EditorFormatColorReset';
	EditorFormatColorReset.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorReset;

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorText = function EditorFormatColorText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' }),
	    _react2.default.createElement('path', { d: 'M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z' })
	  );
	};
	EditorFormatColorText = (0, _pure2.default)(EditorFormatColorText);
	EditorFormatColorText.displayName = 'EditorFormatColorText';
	EditorFormatColorText.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorText;

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatIndentDecrease = function EditorFormatIndentDecrease(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
	  );
	};
	EditorFormatIndentDecrease = (0, _pure2.default)(EditorFormatIndentDecrease);
	EditorFormatIndentDecrease.displayName = 'EditorFormatIndentDecrease';
	EditorFormatIndentDecrease.muiName = 'SvgIcon';
	
	exports.default = EditorFormatIndentDecrease;

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatIndentIncrease = function EditorFormatIndentIncrease(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
	  );
	};
	EditorFormatIndentIncrease = (0, _pure2.default)(EditorFormatIndentIncrease);
	EditorFormatIndentIncrease.displayName = 'EditorFormatIndentIncrease';
	EditorFormatIndentIncrease.muiName = 'SvgIcon';
	
	exports.default = EditorFormatIndentIncrease;

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatItalic = function EditorFormatItalic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z' })
	  );
	};
	EditorFormatItalic = (0, _pure2.default)(EditorFormatItalic);
	EditorFormatItalic.displayName = 'EditorFormatItalic';
	EditorFormatItalic.muiName = 'SvgIcon';
	
	exports.default = EditorFormatItalic;

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatLineSpacing = function EditorFormatLineSpacing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z' })
	  );
	};
	EditorFormatLineSpacing = (0, _pure2.default)(EditorFormatLineSpacing);
	EditorFormatLineSpacing.displayName = 'EditorFormatLineSpacing';
	EditorFormatLineSpacing.muiName = 'SvgIcon';
	
	exports.default = EditorFormatLineSpacing;

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatListBulleted = function EditorFormatListBulleted(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' })
	  );
	};
	EditorFormatListBulleted = (0, _pure2.default)(EditorFormatListBulleted);
	EditorFormatListBulleted.displayName = 'EditorFormatListBulleted';
	EditorFormatListBulleted.muiName = 'SvgIcon';
	
	exports.default = EditorFormatListBulleted;

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatListNumbered = function EditorFormatListNumbered(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z' })
	  );
	};
	EditorFormatListNumbered = (0, _pure2.default)(EditorFormatListNumbered);
	EditorFormatListNumbered.displayName = 'EditorFormatListNumbered';
	EditorFormatListNumbered.muiName = 'SvgIcon';
	
	exports.default = EditorFormatListNumbered;

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatPaint = function EditorFormatPaint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z' })
	  );
	};
	EditorFormatPaint = (0, _pure2.default)(EditorFormatPaint);
	EditorFormatPaint.displayName = 'EditorFormatPaint';
	EditorFormatPaint.muiName = 'SvgIcon';
	
	exports.default = EditorFormatPaint;

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatQuote = function EditorFormatQuote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z' })
	  );
	};
	EditorFormatQuote = (0, _pure2.default)(EditorFormatQuote);
	EditorFormatQuote.displayName = 'EditorFormatQuote';
	EditorFormatQuote.muiName = 'SvgIcon';
	
	exports.default = EditorFormatQuote;

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatShapes = function EditorFormatShapes(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z' })
	  );
	};
	EditorFormatShapes = (0, _pure2.default)(EditorFormatShapes);
	EditorFormatShapes.displayName = 'EditorFormatShapes';
	EditorFormatShapes.muiName = 'SvgIcon';
	
	exports.default = EditorFormatShapes;

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatSize = function EditorFormatSize(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z' })
	  );
	};
	EditorFormatSize = (0, _pure2.default)(EditorFormatSize);
	EditorFormatSize.displayName = 'EditorFormatSize';
	EditorFormatSize.muiName = 'SvgIcon';
	
	exports.default = EditorFormatSize;

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatStrikethrough = function EditorFormatStrikethrough(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z' })
	  );
	};
	EditorFormatStrikethrough = (0, _pure2.default)(EditorFormatStrikethrough);
	EditorFormatStrikethrough.displayName = 'EditorFormatStrikethrough';
	EditorFormatStrikethrough.muiName = 'SvgIcon';
	
	exports.default = EditorFormatStrikethrough;

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatTextdirectionLToR = function EditorFormatTextdirectionLToR(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z' })
	  );
	};
	EditorFormatTextdirectionLToR = (0, _pure2.default)(EditorFormatTextdirectionLToR);
	EditorFormatTextdirectionLToR.displayName = 'EditorFormatTextdirectionLToR';
	EditorFormatTextdirectionLToR.muiName = 'SvgIcon';
	
	exports.default = EditorFormatTextdirectionLToR;

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatTextdirectionRToL = function EditorFormatTextdirectionRToL(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z' })
	  );
	};
	EditorFormatTextdirectionRToL = (0, _pure2.default)(EditorFormatTextdirectionRToL);
	EditorFormatTextdirectionRToL.displayName = 'EditorFormatTextdirectionRToL';
	EditorFormatTextdirectionRToL.muiName = 'SvgIcon';
	
	exports.default = EditorFormatTextdirectionRToL;

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatUnderlined = function EditorFormatUnderlined(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z' })
	  );
	};
	EditorFormatUnderlined = (0, _pure2.default)(EditorFormatUnderlined);
	EditorFormatUnderlined.displayName = 'EditorFormatUnderlined';
	EditorFormatUnderlined.muiName = 'SvgIcon';
	
	exports.default = EditorFormatUnderlined;

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFunctions = function EditorFunctions(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z' })
	  );
	};
	EditorFunctions = (0, _pure2.default)(EditorFunctions);
	EditorFunctions.displayName = 'EditorFunctions';
	EditorFunctions.muiName = 'SvgIcon';
	
	exports.default = EditorFunctions;

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorHighlight = function EditorHighlight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z' })
	  );
	};
	EditorHighlight = (0, _pure2.default)(EditorHighlight);
	EditorHighlight.displayName = 'EditorHighlight';
	EditorHighlight.muiName = 'SvgIcon';
	
	exports.default = EditorHighlight;

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertChart = function EditorInsertChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	EditorInsertChart = (0, _pure2.default)(EditorInsertChart);
	EditorInsertChart.displayName = 'EditorInsertChart';
	EditorInsertChart.muiName = 'SvgIcon';
	
	exports.default = EditorInsertChart;

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertComment = function EditorInsertComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	EditorInsertComment = (0, _pure2.default)(EditorInsertComment);
	EditorInsertComment.displayName = 'EditorInsertComment';
	EditorInsertComment.muiName = 'SvgIcon';
	
	exports.default = EditorInsertComment;

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertDriveFile = function EditorInsertDriveFile(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z' })
	  );
	};
	EditorInsertDriveFile = (0, _pure2.default)(EditorInsertDriveFile);
	EditorInsertDriveFile.displayName = 'EditorInsertDriveFile';
	EditorInsertDriveFile.muiName = 'SvgIcon';
	
	exports.default = EditorInsertDriveFile;

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertEmoticon = function EditorInsertEmoticon(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	EditorInsertEmoticon = (0, _pure2.default)(EditorInsertEmoticon);
	EditorInsertEmoticon.displayName = 'EditorInsertEmoticon';
	EditorInsertEmoticon.muiName = 'SvgIcon';
	
	exports.default = EditorInsertEmoticon;

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertInvitation = function EditorInsertInvitation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
	  );
	};
	EditorInsertInvitation = (0, _pure2.default)(EditorInsertInvitation);
	EditorInsertInvitation.displayName = 'EditorInsertInvitation';
	EditorInsertInvitation.muiName = 'SvgIcon';
	
	exports.default = EditorInsertInvitation;

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertLink = function EditorInsertLink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	  );
	};
	EditorInsertLink = (0, _pure2.default)(EditorInsertLink);
	EditorInsertLink.displayName = 'EditorInsertLink';
	EditorInsertLink.muiName = 'SvgIcon';
	
	exports.default = EditorInsertLink;

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertPhoto = function EditorInsertPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	EditorInsertPhoto = (0, _pure2.default)(EditorInsertPhoto);
	EditorInsertPhoto.displayName = 'EditorInsertPhoto';
	EditorInsertPhoto.muiName = 'SvgIcon';
	
	exports.default = EditorInsertPhoto;

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorLinearScale = function EditorLinearScale(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z' })
	  );
	};
	EditorLinearScale = (0, _pure2.default)(EditorLinearScale);
	EditorLinearScale.displayName = 'EditorLinearScale';
	EditorLinearScale.muiName = 'SvgIcon';
	
	exports.default = EditorLinearScale;

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMergeType = function EditorMergeType(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
	  );
	};
	EditorMergeType = (0, _pure2.default)(EditorMergeType);
	EditorMergeType.displayName = 'EditorMergeType';
	EditorMergeType.muiName = 'SvgIcon';
	
	exports.default = EditorMergeType;

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorModeComment = function EditorModeComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z' })
	  );
	};
	EditorModeComment = (0, _pure2.default)(EditorModeComment);
	EditorModeComment.displayName = 'EditorModeComment';
	EditorModeComment.muiName = 'SvgIcon';
	
	exports.default = EditorModeComment;

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorModeEdit = function EditorModeEdit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	EditorModeEdit = (0, _pure2.default)(EditorModeEdit);
	EditorModeEdit.displayName = 'EditorModeEdit';
	EditorModeEdit.muiName = 'SvgIcon';
	
	exports.default = EditorModeEdit;

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMonetizationOn = function EditorMonetizationOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z' })
	  );
	};
	EditorMonetizationOn = (0, _pure2.default)(EditorMonetizationOn);
	EditorMonetizationOn.displayName = 'EditorMonetizationOn';
	EditorMonetizationOn.muiName = 'SvgIcon';
	
	exports.default = EditorMonetizationOn;

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMoneyOff = function EditorMoneyOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z' })
	  );
	};
	EditorMoneyOff = (0, _pure2.default)(EditorMoneyOff);
	EditorMoneyOff.displayName = 'EditorMoneyOff';
	EditorMoneyOff.muiName = 'SvgIcon';
	
	exports.default = EditorMoneyOff;

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMultilineChart = function EditorMultilineChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z' })
	  );
	};
	EditorMultilineChart = (0, _pure2.default)(EditorMultilineChart);
	EditorMultilineChart.displayName = 'EditorMultilineChart';
	EditorMultilineChart.muiName = 'SvgIcon';
	
	exports.default = EditorMultilineChart;

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPieChartOutlined = function EditorPieChartOutlined(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z' })
	  );
	};
	EditorPieChartOutlined = (0, _pure2.default)(EditorPieChartOutlined);
	EditorPieChartOutlined.displayName = 'EditorPieChartOutlined';
	EditorPieChartOutlined.muiName = 'SvgIcon';
	
	exports.default = EditorPieChartOutlined;

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPieChart = function EditorPieChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z' })
	  );
	};
	EditorPieChart = (0, _pure2.default)(EditorPieChart);
	EditorPieChart.displayName = 'EditorPieChart';
	EditorPieChart.muiName = 'SvgIcon';
	
	exports.default = EditorPieChart;

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPublish = function EditorPublish(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z' })
	  );
	};
	EditorPublish = (0, _pure2.default)(EditorPublish);
	EditorPublish.displayName = 'EditorPublish';
	EditorPublish.muiName = 'SvgIcon';
	
	exports.default = EditorPublish;

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorShortText = function EditorShortText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 9h16v2H4zm0 4h10v2H4z' })
	  );
	};
	EditorShortText = (0, _pure2.default)(EditorShortText);
	EditorShortText.displayName = 'EditorShortText';
	EditorShortText.muiName = 'SvgIcon';
	
	exports.default = EditorShortText;

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorShowChart = function EditorShowChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z' })
	  );
	};
	EditorShowChart = (0, _pure2.default)(EditorShowChart);
	EditorShowChart.displayName = 'EditorShowChart';
	EditorShowChart.muiName = 'SvgIcon';
	
	exports.default = EditorShowChart;

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorSpaceBar = function EditorSpaceBar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 9v4H6V9H4v6h16V9z' })
	  );
	};
	EditorSpaceBar = (0, _pure2.default)(EditorSpaceBar);
	EditorSpaceBar.displayName = 'EditorSpaceBar';
	EditorSpaceBar.muiName = 'SvgIcon';
	
	exports.default = EditorSpaceBar;

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorStrikethroughS = function EditorStrikethroughS(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z' })
	  );
	};
	EditorStrikethroughS = (0, _pure2.default)(EditorStrikethroughS);
	EditorStrikethroughS.displayName = 'EditorStrikethroughS';
	EditorStrikethroughS.muiName = 'SvgIcon';
	
	exports.default = EditorStrikethroughS;

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorTextFields = function EditorTextFields(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z' })
	  );
	};
	EditorTextFields = (0, _pure2.default)(EditorTextFields);
	EditorTextFields.displayName = 'EditorTextFields';
	EditorTextFields.muiName = 'SvgIcon';
	
	exports.default = EditorTextFields;

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorTitle = function EditorTitle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 4v3h5.5v12h3V7H19V4z' })
	  );
	};
	EditorTitle = (0, _pure2.default)(EditorTitle);
	EditorTitle.displayName = 'EditorTitle';
	EditorTitle.muiName = 'SvgIcon';
	
	exports.default = EditorTitle;

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignBottom = function EditorVerticalAlignBottom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z' })
	  );
	};
	EditorVerticalAlignBottom = (0, _pure2.default)(EditorVerticalAlignBottom);
	EditorVerticalAlignBottom.displayName = 'EditorVerticalAlignBottom';
	EditorVerticalAlignBottom.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignBottom;

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignCenter = function EditorVerticalAlignCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z' })
	  );
	};
	EditorVerticalAlignCenter = (0, _pure2.default)(EditorVerticalAlignCenter);
	EditorVerticalAlignCenter.displayName = 'EditorVerticalAlignCenter';
	EditorVerticalAlignCenter.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignCenter;

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignTop = function EditorVerticalAlignTop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z' })
	  );
	};
	EditorVerticalAlignTop = (0, _pure2.default)(EditorVerticalAlignTop);
	EditorVerticalAlignTop.displayName = 'EditorVerticalAlignTop';
	EditorVerticalAlignTop.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignTop;

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorWrapText = function EditorWrapText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z' })
	  );
	};
	EditorWrapText = (0, _pure2.default)(EditorWrapText);
	EditorWrapText.displayName = 'EditorWrapText';
	EditorWrapText.muiName = 'SvgIcon';
	
	exports.default = EditorWrapText;

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileAttachment = function FileAttachment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z' })
	  );
	};
	FileAttachment = (0, _pure2.default)(FileAttachment);
	FileAttachment.displayName = 'FileAttachment';
	FileAttachment.muiName = 'SvgIcon';
	
	exports.default = FileAttachment;

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudCircle = function FileCloudCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z' })
	  );
	};
	FileCloudCircle = (0, _pure2.default)(FileCloudCircle);
	FileCloudCircle.displayName = 'FileCloudCircle';
	FileCloudCircle.muiName = 'SvgIcon';
	
	exports.default = FileCloudCircle;

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudDone = function FileCloudDone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z' })
	  );
	};
	FileCloudDone = (0, _pure2.default)(FileCloudDone);
	FileCloudDone.displayName = 'FileCloudDone';
	FileCloudDone.muiName = 'SvgIcon';
	
	exports.default = FileCloudDone;

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudDownload = function FileCloudDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z' })
	  );
	};
	FileCloudDownload = (0, _pure2.default)(FileCloudDownload);
	FileCloudDownload.displayName = 'FileCloudDownload';
	FileCloudDownload.muiName = 'SvgIcon';
	
	exports.default = FileCloudDownload;

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudOff = function FileCloudOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z' })
	  );
	};
	FileCloudOff = (0, _pure2.default)(FileCloudOff);
	FileCloudOff.displayName = 'FileCloudOff';
	FileCloudOff.muiName = 'SvgIcon';
	
	exports.default = FileCloudOff;

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudQueue = function FileCloudQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z' })
	  );
	};
	FileCloudQueue = (0, _pure2.default)(FileCloudQueue);
	FileCloudQueue.displayName = 'FileCloudQueue';
	FileCloudQueue.muiName = 'SvgIcon';
	
	exports.default = FileCloudQueue;

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudUpload = function FileCloudUpload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
	  );
	};
	FileCloudUpload = (0, _pure2.default)(FileCloudUpload);
	FileCloudUpload.displayName = 'FileCloudUpload';
	FileCloudUpload.muiName = 'SvgIcon';
	
	exports.default = FileCloudUpload;

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloud = function FileCloud(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z' })
	  );
	};
	FileCloud = (0, _pure2.default)(FileCloud);
	FileCloud.displayName = 'FileCloud';
	FileCloud.muiName = 'SvgIcon';
	
	exports.default = FileCloud;

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCreateNewFolder = function FileCreateNewFolder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z' })
	  );
	};
	FileCreateNewFolder = (0, _pure2.default)(FileCreateNewFolder);
	FileCreateNewFolder.displayName = 'FileCreateNewFolder';
	FileCreateNewFolder.muiName = 'SvgIcon';
	
	exports.default = FileCreateNewFolder;

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFileDownload = function FileFileDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
	  );
	};
	FileFileDownload = (0, _pure2.default)(FileFileDownload);
	FileFileDownload.displayName = 'FileFileDownload';
	FileFileDownload.muiName = 'SvgIcon';
	
	exports.default = FileFileDownload;

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFileUpload = function FileFileUpload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z' })
	  );
	};
	FileFileUpload = (0, _pure2.default)(FileFileUpload);
	FileFileUpload.displayName = 'FileFileUpload';
	FileFileUpload.muiName = 'SvgIcon';
	
	exports.default = FileFileUpload;

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolderOpen = function FileFolderOpen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z' })
	  );
	};
	FileFolderOpen = (0, _pure2.default)(FileFolderOpen);
	FileFolderOpen.displayName = 'FileFolderOpen';
	FileFolderOpen.muiName = 'SvgIcon';
	
	exports.default = FileFolderOpen;

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolderShared = function FileFolderShared(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z' })
	  );
	};
	FileFolderShared = (0, _pure2.default)(FileFolderShared);
	FileFolderShared.displayName = 'FileFolderShared';
	FileFolderShared.muiName = 'SvgIcon';
	
	exports.default = FileFolderShared;

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolder = function FileFolder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' })
	  );
	};
	FileFolder = (0, _pure2.default)(FileFolder);
	FileFolder.displayName = 'FileFolder';
	FileFolder.muiName = 'SvgIcon';
	
	exports.default = FileFolder;

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareCastConnected = function HardwareCastConnected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	HardwareCastConnected = (0, _pure2.default)(HardwareCastConnected);
	HardwareCastConnected.displayName = 'HardwareCastConnected';
	HardwareCastConnected.muiName = 'SvgIcon';
	
	exports.default = HardwareCastConnected;

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareCast = function HardwareCast(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z' })
	  );
	};
	HardwareCast = (0, _pure2.default)(HardwareCast);
	HardwareCast.displayName = 'HardwareCast';
	HardwareCast.muiName = 'SvgIcon';
	
	exports.default = HardwareCast;

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareComputer = function HardwareComputer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
	  );
	};
	HardwareComputer = (0, _pure2.default)(HardwareComputer);
	HardwareComputer.displayName = 'HardwareComputer';
	HardwareComputer.muiName = 'SvgIcon';
	
	exports.default = HardwareComputer;

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDesktopMac = function HardwareDesktopMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z' })
	  );
	};
	HardwareDesktopMac = (0, _pure2.default)(HardwareDesktopMac);
	HardwareDesktopMac.displayName = 'HardwareDesktopMac';
	HardwareDesktopMac.muiName = 'SvgIcon';
	
	exports.default = HardwareDesktopMac;

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDesktopWindows = function HardwareDesktopWindows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z' })
	  );
	};
	HardwareDesktopWindows = (0, _pure2.default)(HardwareDesktopWindows);
	HardwareDesktopWindows.displayName = 'HardwareDesktopWindows';
	HardwareDesktopWindows.muiName = 'SvgIcon';
	
	exports.default = HardwareDesktopWindows;

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDeveloperBoard = function HardwareDeveloperBoard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z' })
	  );
	};
	HardwareDeveloperBoard = (0, _pure2.default)(HardwareDeveloperBoard);
	HardwareDeveloperBoard.displayName = 'HardwareDeveloperBoard';
	HardwareDeveloperBoard.muiName = 'SvgIcon';
	
	exports.default = HardwareDeveloperBoard;

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDeviceHub = function HardwareDeviceHub(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z' })
	  );
	};
	HardwareDeviceHub = (0, _pure2.default)(HardwareDeviceHub);
	HardwareDeviceHub.displayName = 'HardwareDeviceHub';
	HardwareDeviceHub.muiName = 'SvgIcon';
	
	exports.default = HardwareDeviceHub;

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDevicesOther = function HardwareDevicesOther(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z' })
	  );
	};
	HardwareDevicesOther = (0, _pure2.default)(HardwareDevicesOther);
	HardwareDevicesOther.displayName = 'HardwareDevicesOther';
	HardwareDevicesOther.muiName = 'SvgIcon';
	
	exports.default = HardwareDevicesOther;

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDock = function HardwareDock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z' })
	  );
	};
	HardwareDock = (0, _pure2.default)(HardwareDock);
	HardwareDock.displayName = 'HardwareDock';
	HardwareDock.muiName = 'SvgIcon';
	
	exports.default = HardwareDock;

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareGamepad = function HardwareGamepad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
	  );
	};
	HardwareGamepad = (0, _pure2.default)(HardwareGamepad);
	HardwareGamepad.displayName = 'HardwareGamepad';
	HardwareGamepad.muiName = 'SvgIcon';
	
	exports.default = HardwareGamepad;

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareHeadsetMic = function HardwareHeadsetMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z' })
	  );
	};
	HardwareHeadsetMic = (0, _pure2.default)(HardwareHeadsetMic);
	HardwareHeadsetMic.displayName = 'HardwareHeadsetMic';
	HardwareHeadsetMic.muiName = 'SvgIcon';
	
	exports.default = HardwareHeadsetMic;

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareHeadset = function HardwareHeadset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z' })
	  );
	};
	HardwareHeadset = (0, _pure2.default)(HardwareHeadset);
	HardwareHeadset.displayName = 'HardwareHeadset';
	HardwareHeadset.muiName = 'SvgIcon';
	
	exports.default = HardwareHeadset;

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowLeft = function HardwareKeyboardArrowLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' })
	  );
	};
	HardwareKeyboardArrowLeft = (0, _pure2.default)(HardwareKeyboardArrowLeft);
	HardwareKeyboardArrowLeft.displayName = 'HardwareKeyboardArrowLeft';
	HardwareKeyboardArrowLeft.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowLeft;

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowRight = function HardwareKeyboardArrowRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' })
	  );
	};
	HardwareKeyboardArrowRight = (0, _pure2.default)(HardwareKeyboardArrowRight);
	HardwareKeyboardArrowRight.displayName = 'HardwareKeyboardArrowRight';
	HardwareKeyboardArrowRight.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowRight;

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardBackspace = function HardwareKeyboardBackspace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z' })
	  );
	};
	HardwareKeyboardBackspace = (0, _pure2.default)(HardwareKeyboardBackspace);
	HardwareKeyboardBackspace.displayName = 'HardwareKeyboardBackspace';
	HardwareKeyboardBackspace.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardBackspace;

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardCapslock = function HardwareKeyboardCapslock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z' })
	  );
	};
	HardwareKeyboardCapslock = (0, _pure2.default)(HardwareKeyboardCapslock);
	HardwareKeyboardCapslock.displayName = 'HardwareKeyboardCapslock';
	HardwareKeyboardCapslock.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardCapslock;

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardHide = function HardwareKeyboardHide(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z' })
	  );
	};
	HardwareKeyboardHide = (0, _pure2.default)(HardwareKeyboardHide);
	HardwareKeyboardHide.displayName = 'HardwareKeyboardHide';
	HardwareKeyboardHide.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardHide;

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardReturn = function HardwareKeyboardReturn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z' })
	  );
	};
	HardwareKeyboardReturn = (0, _pure2.default)(HardwareKeyboardReturn);
	HardwareKeyboardReturn.displayName = 'HardwareKeyboardReturn';
	HardwareKeyboardReturn.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardReturn;

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardTab = function HardwareKeyboardTab(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z' })
	  );
	};
	HardwareKeyboardTab = (0, _pure2.default)(HardwareKeyboardTab);
	HardwareKeyboardTab.displayName = 'HardwareKeyboardTab';
	HardwareKeyboardTab.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardTab;

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardVoice = function HardwareKeyboardVoice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	HardwareKeyboardVoice = (0, _pure2.default)(HardwareKeyboardVoice);
	HardwareKeyboardVoice.displayName = 'HardwareKeyboardVoice';
	HardwareKeyboardVoice.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardVoice;

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboard = function HardwareKeyboard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z' })
	  );
	};
	HardwareKeyboard = (0, _pure2.default)(HardwareKeyboard);
	HardwareKeyboard.displayName = 'HardwareKeyboard';
	HardwareKeyboard.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboard;

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopChromebook = function HardwareLaptopChromebook(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z' })
	  );
	};
	HardwareLaptopChromebook = (0, _pure2.default)(HardwareLaptopChromebook);
	HardwareLaptopChromebook.displayName = 'HardwareLaptopChromebook';
	HardwareLaptopChromebook.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopChromebook;

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopMac = function HardwareLaptopMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	HardwareLaptopMac = (0, _pure2.default)(HardwareLaptopMac);
	HardwareLaptopMac.displayName = 'HardwareLaptopMac';
	HardwareLaptopMac.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopMac;

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopWindows = function HardwareLaptopWindows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z' })
	  );
	};
	HardwareLaptopWindows = (0, _pure2.default)(HardwareLaptopWindows);
	HardwareLaptopWindows.displayName = 'HardwareLaptopWindows';
	HardwareLaptopWindows.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopWindows;

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptop = function HardwareLaptop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
	  );
	};
	HardwareLaptop = (0, _pure2.default)(HardwareLaptop);
	HardwareLaptop.displayName = 'HardwareLaptop';
	HardwareLaptop.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptop;

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareMemory = function HardwareMemory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z' })
	  );
	};
	HardwareMemory = (0, _pure2.default)(HardwareMemory);
	HardwareMemory.displayName = 'HardwareMemory';
	HardwareMemory.muiName = 'SvgIcon';
	
	exports.default = HardwareMemory;

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareMouse = function HardwareMouse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z' })
	  );
	};
	HardwareMouse = (0, _pure2.default)(HardwareMouse);
	HardwareMouse.displayName = 'HardwareMouse';
	HardwareMouse.muiName = 'SvgIcon';
	
	exports.default = HardwareMouse;

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhoneAndroid = function HardwarePhoneAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z' })
	  );
	};
	HardwarePhoneAndroid = (0, _pure2.default)(HardwarePhoneAndroid);
	HardwarePhoneAndroid.displayName = 'HardwarePhoneAndroid';
	HardwarePhoneAndroid.muiName = 'SvgIcon';
	
	exports.default = HardwarePhoneAndroid;

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhoneIphone = function HardwarePhoneIphone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z' })
	  );
	};
	HardwarePhoneIphone = (0, _pure2.default)(HardwarePhoneIphone);
	HardwarePhoneIphone.displayName = 'HardwarePhoneIphone';
	HardwarePhoneIphone.muiName = 'SvgIcon';
	
	exports.default = HardwarePhoneIphone;

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhonelinkOff = function HardwarePhonelinkOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z' })
	  );
	};
	HardwarePhonelinkOff = (0, _pure2.default)(HardwarePhonelinkOff);
	HardwarePhonelinkOff.displayName = 'HardwarePhonelinkOff';
	HardwarePhonelinkOff.muiName = 'SvgIcon';
	
	exports.default = HardwarePhonelinkOff;

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhonelink = function HardwarePhonelink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
	  );
	};
	HardwarePhonelink = (0, _pure2.default)(HardwarePhonelink);
	HardwarePhonelink.displayName = 'HardwarePhonelink';
	HardwarePhonelink.muiName = 'SvgIcon';
	
	exports.default = HardwarePhonelink;

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePowerInput = function HardwarePowerInput(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z' })
	  );
	};
	HardwarePowerInput = (0, _pure2.default)(HardwarePowerInput);
	HardwarePowerInput.displayName = 'HardwarePowerInput';
	HardwarePowerInput.muiName = 'SvgIcon';
	
	exports.default = HardwarePowerInput;

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareRouter = function HardwareRouter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z' })
	  );
	};
	HardwareRouter = (0, _pure2.default)(HardwareRouter);
	HardwareRouter.displayName = 'HardwareRouter';
	HardwareRouter.muiName = 'SvgIcon';
	
	exports.default = HardwareRouter;

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareScanner = function HardwareScanner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z' })
	  );
	};
	HardwareScanner = (0, _pure2.default)(HardwareScanner);
	HardwareScanner.displayName = 'HardwareScanner';
	HardwareScanner.muiName = 'SvgIcon';
	
	exports.default = HardwareScanner;

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSecurity = function HardwareSecurity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z' })
	  );
	};
	HardwareSecurity = (0, _pure2.default)(HardwareSecurity);
	HardwareSecurity.displayName = 'HardwareSecurity';
	HardwareSecurity.muiName = 'SvgIcon';
	
	exports.default = HardwareSecurity;

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSimCard = function HardwareSimCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z' })
	  );
	};
	HardwareSimCard = (0, _pure2.default)(HardwareSimCard);
	HardwareSimCard.displayName = 'HardwareSimCard';
	HardwareSimCard.muiName = 'SvgIcon';
	
	exports.default = HardwareSimCard;

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSmartphone = function HardwareSmartphone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	HardwareSmartphone = (0, _pure2.default)(HardwareSmartphone);
	HardwareSmartphone.displayName = 'HardwareSmartphone';
	HardwareSmartphone.muiName = 'SvgIcon';
	
	exports.default = HardwareSmartphone;

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSpeakerGroup = function HardwareSpeakerGroup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' }),
	    _react2.default.createElement('circle', { cx: '14', cy: '12.5', r: '2.5' }),
	    _react2.default.createElement('path', { d: 'M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z' })
	  );
	};
	HardwareSpeakerGroup = (0, _pure2.default)(HardwareSpeakerGroup);
	HardwareSpeakerGroup.displayName = 'HardwareSpeakerGroup';
	HardwareSpeakerGroup.muiName = 'SvgIcon';
	
	exports.default = HardwareSpeakerGroup;

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSpeaker = function HardwareSpeaker(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	HardwareSpeaker = (0, _pure2.default)(HardwareSpeaker);
	HardwareSpeaker.displayName = 'HardwareSpeaker';
	HardwareSpeaker.muiName = 'SvgIcon';
	
	exports.default = HardwareSpeaker;

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTabletAndroid = function HardwareTabletAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z' })
	  );
	};
	HardwareTabletAndroid = (0, _pure2.default)(HardwareTabletAndroid);
	HardwareTabletAndroid.displayName = 'HardwareTabletAndroid';
	HardwareTabletAndroid.muiName = 'SvgIcon';
	
	exports.default = HardwareTabletAndroid;

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTabletMac = function HardwareTabletMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z' })
	  );
	};
	HardwareTabletMac = (0, _pure2.default)(HardwareTabletMac);
	HardwareTabletMac.displayName = 'HardwareTabletMac';
	HardwareTabletMac.muiName = 'SvgIcon';
	
	exports.default = HardwareTabletMac;

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTablet = function HardwareTablet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z' })
	  );
	};
	HardwareTablet = (0, _pure2.default)(HardwareTablet);
	HardwareTablet.displayName = 'HardwareTablet';
	HardwareTablet.muiName = 'SvgIcon';
	
	exports.default = HardwareTablet;

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareToys = function HardwareToys(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z' })
	  );
	};
	HardwareToys = (0, _pure2.default)(HardwareToys);
	HardwareToys.displayName = 'HardwareToys';
	HardwareToys.muiName = 'SvgIcon';
	
	exports.default = HardwareToys;

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTv = function HardwareTv(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z' })
	  );
	};
	HardwareTv = (0, _pure2.default)(HardwareTv);
	HardwareTv.displayName = 'HardwareTv';
	HardwareTv.muiName = 'SvgIcon';
	
	exports.default = HardwareTv;

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareVideogameAsset = function HardwareVideogameAsset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	HardwareVideogameAsset = (0, _pure2.default)(HardwareVideogameAsset);
	HardwareVideogameAsset.displayName = 'HardwareVideogameAsset';
	HardwareVideogameAsset.muiName = 'SvgIcon';
	
	exports.default = HardwareVideogameAsset;

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareWatch = function HardwareWatch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z' })
	  );
	};
	HardwareWatch = (0, _pure2.default)(HardwareWatch);
	HardwareWatch.displayName = 'HardwareWatch';
	HardwareWatch.muiName = 'SvgIcon';
	
	exports.default = HardwareWatch;

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAddAPhoto = function ImageAddAPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z' })
	  );
	};
	ImageAddAPhoto = (0, _pure2.default)(ImageAddAPhoto);
	ImageAddAPhoto.displayName = 'ImageAddAPhoto';
	ImageAddAPhoto.muiName = 'SvgIcon';
	
	exports.default = ImageAddAPhoto;

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAddToPhotos = function ImageAddToPhotos(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	ImageAddToPhotos = (0, _pure2.default)(ImageAddToPhotos);
	ImageAddToPhotos.displayName = 'ImageAddToPhotos';
	ImageAddToPhotos.muiName = 'SvgIcon';
	
	exports.default = ImageAddToPhotos;

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAdjust = function ImageAdjust(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z' })
	  );
	};
	ImageAdjust = (0, _pure2.default)(ImageAdjust);
	ImageAdjust.displayName = 'ImageAdjust';
	ImageAdjust.muiName = 'SvgIcon';
	
	exports.default = ImageAdjust;

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAssistantPhoto = function ImageAssistantPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
	  );
	};
	ImageAssistantPhoto = (0, _pure2.default)(ImageAssistantPhoto);
	ImageAssistantPhoto.displayName = 'ImageAssistantPhoto';
	ImageAssistantPhoto.muiName = 'SvgIcon';
	
	exports.default = ImageAssistantPhoto;

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAssistant = function ImageAssistant(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z' })
	  );
	};
	ImageAssistant = (0, _pure2.default)(ImageAssistant);
	ImageAssistant.displayName = 'ImageAssistant';
	ImageAssistant.muiName = 'SvgIcon';
	
	exports.default = ImageAssistant;

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAudiotrack = function ImageAudiotrack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z' })
	  );
	};
	ImageAudiotrack = (0, _pure2.default)(ImageAudiotrack);
	ImageAudiotrack.displayName = 'ImageAudiotrack';
	ImageAudiotrack.muiName = 'SvgIcon';
	
	exports.default = ImageAudiotrack;

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurCircular = function ImageBlurCircular(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
	  );
	};
	ImageBlurCircular = (0, _pure2.default)(ImageBlurCircular);
	ImageBlurCircular.displayName = 'ImageBlurCircular';
	ImageBlurCircular.muiName = 'SvgIcon';
	
	exports.default = ImageBlurCircular;

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurLinear = function ImageBlurLinear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z' })
	  );
	};
	ImageBlurLinear = (0, _pure2.default)(ImageBlurLinear);
	ImageBlurLinear.displayName = 'ImageBlurLinear';
	ImageBlurLinear.muiName = 'SvgIcon';
	
	exports.default = ImageBlurLinear;

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurOff = function ImageBlurOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z' })
	  );
	};
	ImageBlurOff = (0, _pure2.default)(ImageBlurOff);
	ImageBlurOff.displayName = 'ImageBlurOff';
	ImageBlurOff.muiName = 'SvgIcon';
	
	exports.default = ImageBlurOff;

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurOn = function ImageBlurOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
	  );
	};
	ImageBlurOn = (0, _pure2.default)(ImageBlurOn);
	ImageBlurOn.displayName = 'ImageBlurOn';
	ImageBlurOn.muiName = 'SvgIcon';
	
	exports.default = ImageBlurOn;

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness1 = function ImageBrightness1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' })
	  );
	};
	ImageBrightness1 = (0, _pure2.default)(ImageBrightness1);
	ImageBrightness1.displayName = 'ImageBrightness1';
	ImageBrightness1.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness1;

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness2 = function ImageBrightness2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z' })
	  );
	};
	ImageBrightness2 = (0, _pure2.default)(ImageBrightness2);
	ImageBrightness2.displayName = 'ImageBrightness2';
	ImageBrightness2.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness2;

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness3 = function ImageBrightness3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z' })
	  );
	};
	ImageBrightness3 = (0, _pure2.default)(ImageBrightness3);
	ImageBrightness3.displayName = 'ImageBrightness3';
	ImageBrightness3.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness3;

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness4 = function ImageBrightness4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	ImageBrightness4 = (0, _pure2.default)(ImageBrightness4);
	ImageBrightness4.displayName = 'ImageBrightness4';
	ImageBrightness4.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness4;

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness5 = function ImageBrightness5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	ImageBrightness5 = (0, _pure2.default)(ImageBrightness5);
	ImageBrightness5.displayName = 'ImageBrightness5';
	ImageBrightness5.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness5;

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness6 = function ImageBrightness6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	ImageBrightness6 = (0, _pure2.default)(ImageBrightness6);
	ImageBrightness6.displayName = 'ImageBrightness6';
	ImageBrightness6.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness6;

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness7 = function ImageBrightness7(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
	  );
	};
	ImageBrightness7 = (0, _pure2.default)(ImageBrightness7);
	ImageBrightness7.displayName = 'ImageBrightness7';
	ImageBrightness7.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness7;

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrokenImage = function ImageBrokenImage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z' })
	  );
	};
	ImageBrokenImage = (0, _pure2.default)(ImageBrokenImage);
	ImageBrokenImage.displayName = 'ImageBrokenImage';
	ImageBrokenImage.muiName = 'SvgIcon';
	
	exports.default = ImageBrokenImage;

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrush = function ImageBrush(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z' })
	  );
	};
	ImageBrush = (0, _pure2.default)(ImageBrush);
	ImageBrush.displayName = 'ImageBrush';
	ImageBrush.muiName = 'SvgIcon';
	
	exports.default = ImageBrush;

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBurstMode = function ImageBurstMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z' })
	  );
	};
	ImageBurstMode = (0, _pure2.default)(ImageBurstMode);
	ImageBurstMode.displayName = 'ImageBurstMode';
	ImageBurstMode.muiName = 'SvgIcon';
	
	exports.default = ImageBurstMode;

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraAlt = function ImageCameraAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImageCameraAlt = (0, _pure2.default)(ImageCameraAlt);
	ImageCameraAlt.displayName = 'ImageCameraAlt';
	ImageCameraAlt.muiName = 'SvgIcon';
	
	exports.default = ImageCameraAlt;

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraFront = function ImageCameraFront(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z' })
	  );
	};
	ImageCameraFront = (0, _pure2.default)(ImageCameraFront);
	ImageCameraFront.displayName = 'ImageCameraFront';
	ImageCameraFront.muiName = 'SvgIcon';
	
	exports.default = ImageCameraFront;

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraRear = function ImageCameraRear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z' })
	  );
	};
	ImageCameraRear = (0, _pure2.default)(ImageCameraRear);
	ImageCameraRear.displayName = 'ImageCameraRear';
	ImageCameraRear.muiName = 'SvgIcon';
	
	exports.default = ImageCameraRear;

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraRoll = function ImageCameraRoll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z' })
	  );
	};
	ImageCameraRoll = (0, _pure2.default)(ImageCameraRoll);
	ImageCameraRoll.displayName = 'ImageCameraRoll';
	ImageCameraRoll.muiName = 'SvgIcon';
	
	exports.default = ImageCameraRoll;

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCamera = function ImageCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z' })
	  );
	};
	ImageCamera = (0, _pure2.default)(ImageCamera);
	ImageCamera.displayName = 'ImageCamera';
	ImageCamera.muiName = 'SvgIcon';
	
	exports.default = ImageCamera;

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCenterFocusStrong = function ImageCenterFocusStrong(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z' })
	  );
	};
	ImageCenterFocusStrong = (0, _pure2.default)(ImageCenterFocusStrong);
	ImageCenterFocusStrong.displayName = 'ImageCenterFocusStrong';
	ImageCenterFocusStrong.muiName = 'SvgIcon';
	
	exports.default = ImageCenterFocusStrong;

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCenterFocusWeak = function ImageCenterFocusWeak(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ImageCenterFocusWeak = (0, _pure2.default)(ImageCenterFocusWeak);
	ImageCenterFocusWeak.displayName = 'ImageCenterFocusWeak';
	ImageCenterFocusWeak.muiName = 'SvgIcon';
	
	exports.default = ImageCenterFocusWeak;

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCollectionsBookmark = function ImageCollectionsBookmark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z' })
	  );
	};
	ImageCollectionsBookmark = (0, _pure2.default)(ImageCollectionsBookmark);
	ImageCollectionsBookmark.displayName = 'ImageCollectionsBookmark';
	ImageCollectionsBookmark.muiName = 'SvgIcon';
	
	exports.default = ImageCollectionsBookmark;

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCollections = function ImageCollections(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
	  );
	};
	ImageCollections = (0, _pure2.default)(ImageCollections);
	ImageCollections.displayName = 'ImageCollections';
	ImageCollections.muiName = 'SvgIcon';
	
	exports.default = ImageCollections;

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageColorLens = function ImageColorLens(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ImageColorLens = (0, _pure2.default)(ImageColorLens);
	ImageColorLens.displayName = 'ImageColorLens';
	ImageColorLens.muiName = 'SvgIcon';
	
	exports.default = ImageColorLens;

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageColorize = function ImageColorize(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z' })
	  );
	};
	ImageColorize = (0, _pure2.default)(ImageColorize);
	ImageColorize.displayName = 'ImageColorize';
	ImageColorize.muiName = 'SvgIcon';
	
	exports.default = ImageColorize;

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCompare = function ImageCompare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ImageCompare = (0, _pure2.default)(ImageCompare);
	ImageCompare.displayName = 'ImageCompare';
	ImageCompare.muiName = 'SvgIcon';
	
	exports.default = ImageCompare;

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageControlPointDuplicate = function ImageControlPointDuplicate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z' })
	  );
	};
	ImageControlPointDuplicate = (0, _pure2.default)(ImageControlPointDuplicate);
	ImageControlPointDuplicate.displayName = 'ImageControlPointDuplicate';
	ImageControlPointDuplicate.muiName = 'SvgIcon';
	
	exports.default = ImageControlPointDuplicate;

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageControlPoint = function ImageControlPoint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImageControlPoint = (0, _pure2.default)(ImageControlPoint);
	ImageControlPoint.displayName = 'ImageControlPoint';
	ImageControlPoint.muiName = 'SvgIcon';
	
	exports.default = ImageControlPoint;

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop169 = function ImageCrop169(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z' })
	  );
	};
	ImageCrop169 = (0, _pure2.default)(ImageCrop169);
	ImageCrop169.displayName = 'ImageCrop169';
	ImageCrop169.muiName = 'SvgIcon';
	
	exports.default = ImageCrop169;

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop32 = function ImageCrop32(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z' })
	  );
	};
	ImageCrop32 = (0, _pure2.default)(ImageCrop32);
	ImageCrop32.displayName = 'ImageCrop32';
	ImageCrop32.muiName = 'SvgIcon';
	
	exports.default = ImageCrop32;

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop54 = function ImageCrop54(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
	  );
	};
	ImageCrop54 = (0, _pure2.default)(ImageCrop54);
	ImageCrop54.displayName = 'ImageCrop54';
	ImageCrop54.muiName = 'SvgIcon';
	
	exports.default = ImageCrop54;

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop75 = function ImageCrop75(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z' })
	  );
	};
	ImageCrop75 = (0, _pure2.default)(ImageCrop75);
	ImageCrop75.displayName = 'ImageCrop75';
	ImageCrop75.muiName = 'SvgIcon';
	
	exports.default = ImageCrop75;

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropDin = function ImageCropDin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImageCropDin = (0, _pure2.default)(ImageCropDin);
	ImageCropDin.displayName = 'ImageCropDin';
	ImageCropDin.muiName = 'SvgIcon';
	
	exports.default = ImageCropDin;

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropFree = function ImageCropFree(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ImageCropFree = (0, _pure2.default)(ImageCropFree);
	ImageCropFree.displayName = 'ImageCropFree';
	ImageCropFree.muiName = 'SvgIcon';
	
	exports.default = ImageCropFree;

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropLandscape = function ImageCropLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
	  );
	};
	ImageCropLandscape = (0, _pure2.default)(ImageCropLandscape);
	ImageCropLandscape.displayName = 'ImageCropLandscape';
	ImageCropLandscape.muiName = 'SvgIcon';
	
	exports.default = ImageCropLandscape;

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropOriginal = function ImageCropOriginal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z' })
	  );
	};
	ImageCropOriginal = (0, _pure2.default)(ImageCropOriginal);
	ImageCropOriginal.displayName = 'ImageCropOriginal';
	ImageCropOriginal.muiName = 'SvgIcon';
	
	exports.default = ImageCropOriginal;

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropPortrait = function ImageCropPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z' })
	  );
	};
	ImageCropPortrait = (0, _pure2.default)(ImageCropPortrait);
	ImageCropPortrait.displayName = 'ImageCropPortrait';
	ImageCropPortrait.muiName = 'SvgIcon';
	
	exports.default = ImageCropPortrait;

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropRotate = function ImageCropRotate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z' })
	  );
	};
	ImageCropRotate = (0, _pure2.default)(ImageCropRotate);
	ImageCropRotate.displayName = 'ImageCropRotate';
	ImageCropRotate.muiName = 'SvgIcon';
	
	exports.default = ImageCropRotate;

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropSquare = function ImageCropSquare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z' })
	  );
	};
	ImageCropSquare = (0, _pure2.default)(ImageCropSquare);
	ImageCropSquare.displayName = 'ImageCropSquare';
	ImageCropSquare.muiName = 'SvgIcon';
	
	exports.default = ImageCropSquare;

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop = function ImageCrop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z' })
	  );
	};
	ImageCrop = (0, _pure2.default)(ImageCrop);
	ImageCrop.displayName = 'ImageCrop';
	ImageCrop.muiName = 'SvgIcon';
	
	exports.default = ImageCrop;

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageDehaze = function ImageDehaze(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z' })
	  );
	};
	ImageDehaze = (0, _pure2.default)(ImageDehaze);
	ImageDehaze.displayName = 'ImageDehaze';
	ImageDehaze.muiName = 'SvgIcon';
	
	exports.default = ImageDehaze;

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageDetails = function ImageDetails(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z' })
	  );
	};
	ImageDetails = (0, _pure2.default)(ImageDetails);
	ImageDetails.displayName = 'ImageDetails';
	ImageDetails.muiName = 'SvgIcon';
	
	exports.default = ImageDetails;

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageEdit = function ImageEdit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	ImageEdit = (0, _pure2.default)(ImageEdit);
	ImageEdit.displayName = 'ImageEdit';
	ImageEdit.muiName = 'SvgIcon';
	
	exports.default = ImageEdit;

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureNeg1 = function ImageExposureNeg1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z' })
	  );
	};
	ImageExposureNeg1 = (0, _pure2.default)(ImageExposureNeg1);
	ImageExposureNeg1.displayName = 'ImageExposureNeg1';
	ImageExposureNeg1.muiName = 'SvgIcon';
	
	exports.default = ImageExposureNeg1;

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureNeg2 = function ImageExposureNeg2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z' })
	  );
	};
	ImageExposureNeg2 = (0, _pure2.default)(ImageExposureNeg2);
	ImageExposureNeg2.displayName = 'ImageExposureNeg2';
	ImageExposureNeg2.muiName = 'SvgIcon';
	
	exports.default = ImageExposureNeg2;

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposurePlus1 = function ImageExposurePlus1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z' })
	  );
	};
	ImageExposurePlus1 = (0, _pure2.default)(ImageExposurePlus1);
	ImageExposurePlus1.displayName = 'ImageExposurePlus1';
	ImageExposurePlus1.muiName = 'SvgIcon';
	
	exports.default = ImageExposurePlus1;

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposurePlus2 = function ImageExposurePlus2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z' })
	  );
	};
	ImageExposurePlus2 = (0, _pure2.default)(ImageExposurePlus2);
	ImageExposurePlus2.displayName = 'ImageExposurePlus2';
	ImageExposurePlus2.muiName = 'SvgIcon';
	
	exports.default = ImageExposurePlus2;

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureZero = function ImageExposureZero(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z' })
	  );
	};
	ImageExposureZero = (0, _pure2.default)(ImageExposureZero);
	ImageExposureZero.displayName = 'ImageExposureZero';
	ImageExposureZero.muiName = 'SvgIcon';
	
	exports.default = ImageExposureZero;

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposure = function ImageExposure(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z' })
	  );
	};
	ImageExposure = (0, _pure2.default)(ImageExposure);
	ImageExposure.displayName = 'ImageExposure';
	ImageExposure.muiName = 'SvgIcon';
	
	exports.default = ImageExposure;

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter1 = function ImageFilter1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter1 = (0, _pure2.default)(ImageFilter1);
	ImageFilter1.displayName = 'ImageFilter1';
	ImageFilter1.muiName = 'SvgIcon';
	
	exports.default = ImageFilter1;

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter2 = function ImageFilter2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z' })
	  );
	};
	ImageFilter2 = (0, _pure2.default)(ImageFilter2);
	ImageFilter2.displayName = 'ImageFilter2';
	ImageFilter2.muiName = 'SvgIcon';
	
	exports.default = ImageFilter2;

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter3 = function ImageFilter3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z' })
	  );
	};
	ImageFilter3 = (0, _pure2.default)(ImageFilter3);
	ImageFilter3.displayName = 'ImageFilter3';
	ImageFilter3.muiName = 'SvgIcon';
	
	exports.default = ImageFilter3;

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter4 = function ImageFilter4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter4 = (0, _pure2.default)(ImageFilter4);
	ImageFilter4.displayName = 'ImageFilter4';
	ImageFilter4.muiName = 'SvgIcon';
	
	exports.default = ImageFilter4;

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter5 = function ImageFilter5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z' })
	  );
	};
	ImageFilter5 = (0, _pure2.default)(ImageFilter5);
	ImageFilter5.displayName = 'ImageFilter5';
	ImageFilter5.muiName = 'SvgIcon';
	
	exports.default = ImageFilter5;

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter6 = function ImageFilter6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z' })
	  );
	};
	ImageFilter6 = (0, _pure2.default)(ImageFilter6);
	ImageFilter6.displayName = 'ImageFilter6';
	ImageFilter6.muiName = 'SvgIcon';
	
	exports.default = ImageFilter6;

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter7 = function ImageFilter7(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z' })
	  );
	};
	ImageFilter7 = (0, _pure2.default)(ImageFilter7);
	ImageFilter7.displayName = 'ImageFilter7';
	ImageFilter7.muiName = 'SvgIcon';
	
	exports.default = ImageFilter7;

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter8 = function ImageFilter8(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z' })
	  );
	};
	ImageFilter8 = (0, _pure2.default)(ImageFilter8);
	ImageFilter8.displayName = 'ImageFilter8';
	ImageFilter8.muiName = 'SvgIcon';
	
	exports.default = ImageFilter8;

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter9Plus = function ImageFilter9Plus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z' })
	  );
	};
	ImageFilter9Plus = (0, _pure2.default)(ImageFilter9Plus);
	ImageFilter9Plus.displayName = 'ImageFilter9Plus';
	ImageFilter9Plus.muiName = 'SvgIcon';
	
	exports.default = ImageFilter9Plus;

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter9 = function ImageFilter9(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z' })
	  );
	};
	ImageFilter9 = (0, _pure2.default)(ImageFilter9);
	ImageFilter9.displayName = 'ImageFilter9';
	ImageFilter9.muiName = 'SvgIcon';
	
	exports.default = ImageFilter9;

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterBAndW = function ImageFilterBAndW(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z' })
	  );
	};
	ImageFilterBAndW = (0, _pure2.default)(ImageFilterBAndW);
	ImageFilterBAndW.displayName = 'ImageFilterBAndW';
	ImageFilterBAndW.muiName = 'SvgIcon';
	
	exports.default = ImageFilterBAndW;

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterCenterFocus = function ImageFilterCenterFocus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ImageFilterCenterFocus = (0, _pure2.default)(ImageFilterCenterFocus);
	ImageFilterCenterFocus.displayName = 'ImageFilterCenterFocus';
	ImageFilterCenterFocus.muiName = 'SvgIcon';
	
	exports.default = ImageFilterCenterFocus;

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterDrama = function ImageFilterDrama(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z' })
	  );
	};
	ImageFilterDrama = (0, _pure2.default)(ImageFilterDrama);
	ImageFilterDrama.displayName = 'ImageFilterDrama';
	ImageFilterDrama.muiName = 'SvgIcon';
	
	exports.default = ImageFilterDrama;

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterFrames = function ImageFilterFrames(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12' })
	  );
	};
	ImageFilterFrames = (0, _pure2.default)(ImageFilterFrames);
	ImageFilterFrames.displayName = 'ImageFilterFrames';
	ImageFilterFrames.muiName = 'SvgIcon';
	
	exports.default = ImageFilterFrames;

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterHdr = function ImageFilterHdr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	ImageFilterHdr = (0, _pure2.default)(ImageFilterHdr);
	ImageFilterHdr.displayName = 'ImageFilterHdr';
	ImageFilterHdr.muiName = 'SvgIcon';
	
	exports.default = ImageFilterHdr;

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterNone = function ImageFilterNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilterNone = (0, _pure2.default)(ImageFilterNone);
	ImageFilterNone.displayName = 'ImageFilterNone';
	ImageFilterNone.muiName = 'SvgIcon';
	
	exports.default = ImageFilterNone;

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterTiltShift = function ImageFilterTiltShift(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z' })
	  );
	};
	ImageFilterTiltShift = (0, _pure2.default)(ImageFilterTiltShift);
	ImageFilterTiltShift.displayName = 'ImageFilterTiltShift';
	ImageFilterTiltShift.muiName = 'SvgIcon';
	
	exports.default = ImageFilterTiltShift;

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterVintage = function ImageFilterVintage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
	  );
	};
	ImageFilterVintage = (0, _pure2.default)(ImageFilterVintage);
	ImageFilterVintage.displayName = 'ImageFilterVintage';
	ImageFilterVintage.muiName = 'SvgIcon';
	
	exports.default = ImageFilterVintage;

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter = function ImageFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter = (0, _pure2.default)(ImageFilter);
	ImageFilter.displayName = 'ImageFilter';
	ImageFilter.muiName = 'SvgIcon';
	
	exports.default = ImageFilter;

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlare = function ImageFlare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z' })
	  );
	};
	ImageFlare = (0, _pure2.default)(ImageFlare);
	ImageFlare.displayName = 'ImageFlare';
	ImageFlare.muiName = 'SvgIcon';
	
	exports.default = ImageFlare;

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashAuto = function ImageFlashAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z' })
	  );
	};
	ImageFlashAuto = (0, _pure2.default)(ImageFlashAuto);
	ImageFlashAuto.displayName = 'ImageFlashAuto';
	ImageFlashAuto.muiName = 'SvgIcon';
	
	exports.default = ImageFlashAuto;

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashOff = function ImageFlashOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z' })
	  );
	};
	ImageFlashOff = (0, _pure2.default)(ImageFlashOff);
	ImageFlashOff.displayName = 'ImageFlashOff';
	ImageFlashOff.muiName = 'SvgIcon';
	
	exports.default = ImageFlashOff;

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashOn = function ImageFlashOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 2v11h3v9l7-12h-4l4-8z' })
	  );
	};
	ImageFlashOn = (0, _pure2.default)(ImageFlashOn);
	ImageFlashOn.displayName = 'ImageFlashOn';
	ImageFlashOn.muiName = 'SvgIcon';
	
	exports.default = ImageFlashOn;

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlip = function ImageFlip(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z' })
	  );
	};
	ImageFlip = (0, _pure2.default)(ImageFlip);
	ImageFlip.displayName = 'ImageFlip';
	ImageFlip.muiName = 'SvgIcon';
	
	exports.default = ImageFlip;

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGradient = function ImageGradient(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z' })
	  );
	};
	ImageGradient = (0, _pure2.default)(ImageGradient);
	ImageGradient.displayName = 'ImageGradient';
	ImageGradient.muiName = 'SvgIcon';
	
	exports.default = ImageGradient;

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGrain = function ImageGrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ImageGrain = (0, _pure2.default)(ImageGrain);
	ImageGrain.displayName = 'ImageGrain';
	ImageGrain.muiName = 'SvgIcon';
	
	exports.default = ImageGrain;

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGridOff = function ImageGridOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z' })
	  );
	};
	ImageGridOff = (0, _pure2.default)(ImageGridOff);
	ImageGridOff.displayName = 'ImageGridOff';
	ImageGridOff.muiName = 'SvgIcon';
	
	exports.default = ImageGridOff;

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGridOn = function ImageGridOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z' })
	  );
	};
	ImageGridOn = (0, _pure2.default)(ImageGridOn);
	ImageGridOn.displayName = 'ImageGridOn';
	ImageGridOn.muiName = 'SvgIcon';
	
	exports.default = ImageGridOn;

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrOff = function ImageHdrOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z' })
	  );
	};
	ImageHdrOff = (0, _pure2.default)(ImageHdrOff);
	ImageHdrOff.displayName = 'ImageHdrOff';
	ImageHdrOff.muiName = 'SvgIcon';
	
	exports.default = ImageHdrOff;

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrOn = function ImageHdrOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z' })
	  );
	};
	ImageHdrOn = (0, _pure2.default)(ImageHdrOn);
	ImageHdrOn.displayName = 'ImageHdrOn';
	ImageHdrOn.muiName = 'SvgIcon';
	
	exports.default = ImageHdrOn;

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrStrong = function ImageHdrStrong(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ImageHdrStrong = (0, _pure2.default)(ImageHdrStrong);
	ImageHdrStrong.displayName = 'ImageHdrStrong';
	ImageHdrStrong.muiName = 'SvgIcon';
	
	exports.default = ImageHdrStrong;

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrWeak = function ImageHdrWeak(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
	  );
	};
	ImageHdrWeak = (0, _pure2.default)(ImageHdrWeak);
	ImageHdrWeak.displayName = 'ImageHdrWeak';
	ImageHdrWeak.muiName = 'SvgIcon';
	
	exports.default = ImageHdrWeak;

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHealing = function ImageHealing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z' })
	  );
	};
	ImageHealing = (0, _pure2.default)(ImageHealing);
	ImageHealing.displayName = 'ImageHealing';
	ImageHealing.muiName = 'SvgIcon';
	
	exports.default = ImageHealing;

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageImageAspectRatio = function ImageImageAspectRatio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z' })
	  );
	};
	ImageImageAspectRatio = (0, _pure2.default)(ImageImageAspectRatio);
	ImageImageAspectRatio.displayName = 'ImageImageAspectRatio';
	ImageImageAspectRatio.muiName = 'SvgIcon';
	
	exports.default = ImageImageAspectRatio;

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageImage = function ImageImage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImageImage = (0, _pure2.default)(ImageImage);
	ImageImage.displayName = 'ImageImage';
	ImageImage.muiName = 'SvgIcon';
	
	exports.default = ImageImage;

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageIso = function ImageIso(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z' })
	  );
	};
	ImageIso = (0, _pure2.default)(ImageIso);
	ImageIso.displayName = 'ImageIso';
	ImageIso.muiName = 'SvgIcon';
	
	exports.default = ImageIso;

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLandscape = function ImageLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	ImageLandscape = (0, _pure2.default)(ImageLandscape);
	ImageLandscape.displayName = 'ImageLandscape';
	ImageLandscape.muiName = 'SvgIcon';
	
	exports.default = ImageLandscape;

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLeakAdd = function ImageLeakAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z' })
	  );
	};
	ImageLeakAdd = (0, _pure2.default)(ImageLeakAdd);
	ImageLeakAdd.displayName = 'ImageLeakAdd';
	ImageLeakAdd.muiName = 'SvgIcon';
	
	exports.default = ImageLeakAdd;

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLeakRemove = function ImageLeakRemove(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z' })
	  );
	};
	ImageLeakRemove = (0, _pure2.default)(ImageLeakRemove);
	ImageLeakRemove.displayName = 'ImageLeakRemove';
	ImageLeakRemove.muiName = 'SvgIcon';
	
	exports.default = ImageLeakRemove;

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLens = function ImageLens(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z' })
	  );
	};
	ImageLens = (0, _pure2.default)(ImageLens);
	ImageLens.displayName = 'ImageLens';
	ImageLens.muiName = 'SvgIcon';
	
	exports.default = ImageLens;

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLinkedCamera = function ImageLinkedCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '14', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6' }),
	    _react2.default.createElement('path', { d: 'M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImageLinkedCamera = (0, _pure2.default)(ImageLinkedCamera);
	ImageLinkedCamera.displayName = 'ImageLinkedCamera';
	ImageLinkedCamera.muiName = 'SvgIcon';
	
	exports.default = ImageLinkedCamera;

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks3 = function ImageLooks3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z' })
	  );
	};
	ImageLooks3 = (0, _pure2.default)(ImageLooks3);
	ImageLooks3.displayName = 'ImageLooks3';
	ImageLooks3.muiName = 'SvgIcon';
	
	exports.default = ImageLooks3;

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks4 = function ImageLooks4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z' })
	  );
	};
	ImageLooks4 = (0, _pure2.default)(ImageLooks4);
	ImageLooks4.displayName = 'ImageLooks4';
	ImageLooks4.muiName = 'SvgIcon';
	
	exports.default = ImageLooks4;

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks5 = function ImageLooks5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z' })
	  );
	};
	ImageLooks5 = (0, _pure2.default)(ImageLooks5);
	ImageLooks5.displayName = 'ImageLooks5';
	ImageLooks5.muiName = 'SvgIcon';
	
	exports.default = ImageLooks5;

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks6 = function ImageLooks6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z' })
	  );
	};
	ImageLooks6 = (0, _pure2.default)(ImageLooks6);
	ImageLooks6.displayName = 'ImageLooks6';
	ImageLooks6.muiName = 'SvgIcon';
	
	exports.default = ImageLooks6;

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooksOne = function ImageLooksOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z' })
	  );
	};
	ImageLooksOne = (0, _pure2.default)(ImageLooksOne);
	ImageLooksOne.displayName = 'ImageLooksOne';
	ImageLooksOne.muiName = 'SvgIcon';
	
	exports.default = ImageLooksOne;

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooksTwo = function ImageLooksTwo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z' })
	  );
	};
	ImageLooksTwo = (0, _pure2.default)(ImageLooksTwo);
	ImageLooksTwo.displayName = 'ImageLooksTwo';
	ImageLooksTwo.muiName = 'SvgIcon';
	
	exports.default = ImageLooksTwo;

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks = function ImageLooks(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z' })
	  );
	};
	ImageLooks = (0, _pure2.default)(ImageLooks);
	ImageLooks.displayName = 'ImageLooks';
	ImageLooks.muiName = 'SvgIcon';
	
	exports.default = ImageLooks;

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLoupe = function ImageLoupe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImageLoupe = (0, _pure2.default)(ImageLoupe);
	ImageLoupe.displayName = 'ImageLoupe';
	ImageLoupe.muiName = 'SvgIcon';
	
	exports.default = ImageLoupe;

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMonochromePhotos = function ImageMonochromePhotos(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z' })
	  );
	};
	ImageMonochromePhotos = (0, _pure2.default)(ImageMonochromePhotos);
	ImageMonochromePhotos.displayName = 'ImageMonochromePhotos';
	ImageMonochromePhotos.muiName = 'SvgIcon';
	
	exports.default = ImageMonochromePhotos;

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMovieCreation = function ImageMovieCreation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
	  );
	};
	ImageMovieCreation = (0, _pure2.default)(ImageMovieCreation);
	ImageMovieCreation.displayName = 'ImageMovieCreation';
	ImageMovieCreation.muiName = 'SvgIcon';
	
	exports.default = ImageMovieCreation;

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMovieFilter = function ImageMovieFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z' })
	  );
	};
	ImageMovieFilter = (0, _pure2.default)(ImageMovieFilter);
	ImageMovieFilter.displayName = 'ImageMovieFilter';
	ImageMovieFilter.muiName = 'SvgIcon';
	
	exports.default = ImageMovieFilter;

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMusicNote = function ImageMusicNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z' })
	  );
	};
	ImageMusicNote = (0, _pure2.default)(ImageMusicNote);
	ImageMusicNote.displayName = 'ImageMusicNote';
	ImageMusicNote.muiName = 'SvgIcon';
	
	exports.default = ImageMusicNote;

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNaturePeople = function ImageNaturePeople(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z' })
	  );
	};
	ImageNaturePeople = (0, _pure2.default)(ImageNaturePeople);
	ImageNaturePeople.displayName = 'ImageNaturePeople';
	ImageNaturePeople.muiName = 'SvgIcon';
	
	exports.default = ImageNaturePeople;

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNature = function ImageNature(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z' })
	  );
	};
	ImageNature = (0, _pure2.default)(ImageNature);
	ImageNature.displayName = 'ImageNature';
	ImageNature.muiName = 'SvgIcon';
	
	exports.default = ImageNature;

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNavigateBefore = function ImageNavigateBefore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	ImageNavigateBefore = (0, _pure2.default)(ImageNavigateBefore);
	ImageNavigateBefore.displayName = 'ImageNavigateBefore';
	ImageNavigateBefore.muiName = 'SvgIcon';
	
	exports.default = ImageNavigateBefore;

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNavigateNext = function ImageNavigateNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	ImageNavigateNext = (0, _pure2.default)(ImageNavigateNext);
	ImageNavigateNext.displayName = 'ImageNavigateNext';
	ImageNavigateNext.muiName = 'SvgIcon';
	
	exports.default = ImageNavigateNext;

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePalette = function ImagePalette(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ImagePalette = (0, _pure2.default)(ImagePalette);
	ImagePalette.displayName = 'ImagePalette';
	ImagePalette.muiName = 'SvgIcon';
	
	exports.default = ImagePalette;

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaFishEye = function ImagePanoramaFishEye(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImagePanoramaFishEye = (0, _pure2.default)(ImagePanoramaFishEye);
	ImagePanoramaFishEye.displayName = 'ImagePanoramaFishEye';
	ImagePanoramaFishEye.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaFishEye;

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaHorizontal = function ImagePanoramaHorizontal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z' })
	  );
	};
	ImagePanoramaHorizontal = (0, _pure2.default)(ImagePanoramaHorizontal);
	ImagePanoramaHorizontal.displayName = 'ImagePanoramaHorizontal';
	ImagePanoramaHorizontal.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaHorizontal;

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaVertical = function ImagePanoramaVertical(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z' })
	  );
	};
	ImagePanoramaVertical = (0, _pure2.default)(ImagePanoramaVertical);
	ImagePanoramaVertical.displayName = 'ImagePanoramaVertical';
	ImagePanoramaVertical.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaVertical;

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaWideAngle = function ImagePanoramaWideAngle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z' })
	  );
	};
	ImagePanoramaWideAngle = (0, _pure2.default)(ImagePanoramaWideAngle);
	ImagePanoramaWideAngle.displayName = 'ImagePanoramaWideAngle';
	ImagePanoramaWideAngle.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaWideAngle;

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanorama = function ImagePanorama(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImagePanorama = (0, _pure2.default)(ImagePanorama);
	ImagePanorama.displayName = 'ImagePanorama';
	ImagePanorama.muiName = 'SvgIcon';
	
	exports.default = ImagePanorama;

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoAlbum = function ImagePhotoAlbum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z' })
	  );
	};
	ImagePhotoAlbum = (0, _pure2.default)(ImagePhotoAlbum);
	ImagePhotoAlbum.displayName = 'ImagePhotoAlbum';
	ImagePhotoAlbum.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoAlbum;

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoCamera = function ImagePhotoCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImagePhotoCamera = (0, _pure2.default)(ImagePhotoCamera);
	ImagePhotoCamera.displayName = 'ImagePhotoCamera';
	ImagePhotoCamera.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoCamera;

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoFilter = function ImagePhotoFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z' })
	  );
	};
	ImagePhotoFilter = (0, _pure2.default)(ImagePhotoFilter);
	ImagePhotoFilter.displayName = 'ImagePhotoFilter';
	ImagePhotoFilter.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoFilter;

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoLibrary = function ImagePhotoLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
	  );
	};
	ImagePhotoLibrary = (0, _pure2.default)(ImagePhotoLibrary);
	ImagePhotoLibrary.displayName = 'ImagePhotoLibrary';
	ImagePhotoLibrary.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoLibrary;

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectActual = function ImagePhotoSizeSelectActual(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z' })
	  );
	};
	ImagePhotoSizeSelectActual = (0, _pure2.default)(ImagePhotoSizeSelectActual);
	ImagePhotoSizeSelectActual.displayName = 'ImagePhotoSizeSelectActual';
	ImagePhotoSizeSelectActual.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectActual;

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectLarge = function ImagePhotoSizeSelectLarge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z' })
	  );
	};
	ImagePhotoSizeSelectLarge = (0, _pure2.default)(ImagePhotoSizeSelectLarge);
	ImagePhotoSizeSelectLarge.displayName = 'ImagePhotoSizeSelectLarge';
	ImagePhotoSizeSelectLarge.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectLarge;

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectSmall = function ImagePhotoSizeSelectSmall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z' })
	  );
	};
	ImagePhotoSizeSelectSmall = (0, _pure2.default)(ImagePhotoSizeSelectSmall);
	ImagePhotoSizeSelectSmall.displayName = 'ImagePhotoSizeSelectSmall';
	ImagePhotoSizeSelectSmall.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectSmall;

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhoto = function ImagePhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImagePhoto = (0, _pure2.default)(ImagePhoto);
	ImagePhoto.displayName = 'ImagePhoto';
	ImagePhoto.muiName = 'SvgIcon';
	
	exports.default = ImagePhoto;

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePictureAsPdf = function ImagePictureAsPdf(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z' })
	  );
	};
	ImagePictureAsPdf = (0, _pure2.default)(ImagePictureAsPdf);
	ImagePictureAsPdf.displayName = 'ImagePictureAsPdf';
	ImagePictureAsPdf.muiName = 'SvgIcon';
	
	exports.default = ImagePictureAsPdf;

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePortrait = function ImagePortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImagePortrait = (0, _pure2.default)(ImagePortrait);
	ImagePortrait.displayName = 'ImagePortrait';
	ImagePortrait.muiName = 'SvgIcon';
	
	exports.default = ImagePortrait;

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRemoveRedEye = function ImageRemoveRedEye(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ImageRemoveRedEye = (0, _pure2.default)(ImageRemoveRedEye);
	ImageRemoveRedEye.displayName = 'ImageRemoveRedEye';
	ImageRemoveRedEye.muiName = 'SvgIcon';
	
	exports.default = ImageRemoveRedEye;

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotate90DegreesCcw = function ImageRotate90DegreesCcw(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z' })
	  );
	};
	ImageRotate90DegreesCcw = (0, _pure2.default)(ImageRotate90DegreesCcw);
	ImageRotate90DegreesCcw.displayName = 'ImageRotate90DegreesCcw';
	ImageRotate90DegreesCcw.muiName = 'SvgIcon';
	
	exports.default = ImageRotate90DegreesCcw;

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotateLeft = function ImageRotateLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z' })
	  );
	};
	ImageRotateLeft = (0, _pure2.default)(ImageRotateLeft);
	ImageRotateLeft.displayName = 'ImageRotateLeft';
	ImageRotateLeft.muiName = 'SvgIcon';
	
	exports.default = ImageRotateLeft;

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotateRight = function ImageRotateRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z' })
	  );
	};
	ImageRotateRight = (0, _pure2.default)(ImageRotateRight);
	ImageRotateRight.displayName = 'ImageRotateRight';
	ImageRotateRight.muiName = 'SvgIcon';
	
	exports.default = ImageRotateRight;

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSlideshow = function ImageSlideshow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImageSlideshow = (0, _pure2.default)(ImageSlideshow);
	ImageSlideshow.displayName = 'ImageSlideshow';
	ImageSlideshow.muiName = 'SvgIcon';
	
	exports.default = ImageSlideshow;

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageStraighten = function ImageStraighten(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z' })
	  );
	};
	ImageStraighten = (0, _pure2.default)(ImageStraighten);
	ImageStraighten.displayName = 'ImageStraighten';
	ImageStraighten.muiName = 'SvgIcon';
	
	exports.default = ImageStraighten;

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageStyle = function ImageStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z' })
	  );
	};
	ImageStyle = (0, _pure2.default)(ImageStyle);
	ImageStyle.displayName = 'ImageStyle';
	ImageStyle.muiName = 'SvgIcon';
	
	exports.default = ImageStyle;

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSwitchCamera = function ImageSwitchCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	ImageSwitchCamera = (0, _pure2.default)(ImageSwitchCamera);
	ImageSwitchCamera.displayName = 'ImageSwitchCamera';
	ImageSwitchCamera.muiName = 'SvgIcon';
	
	exports.default = ImageSwitchCamera;

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSwitchVideo = function ImageSwitchVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	ImageSwitchVideo = (0, _pure2.default)(ImageSwitchVideo);
	ImageSwitchVideo.displayName = 'ImageSwitchVideo';
	ImageSwitchVideo.muiName = 'SvgIcon';
	
	exports.default = ImageSwitchVideo;

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTagFaces = function ImageTagFaces(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	ImageTagFaces = (0, _pure2.default)(ImageTagFaces);
	ImageTagFaces.displayName = 'ImageTagFaces';
	ImageTagFaces.muiName = 'SvgIcon';
	
	exports.default = ImageTagFaces;

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTexture = function ImageTexture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z' })
	  );
	};
	ImageTexture = (0, _pure2.default)(ImageTexture);
	ImageTexture.displayName = 'ImageTexture';
	ImageTexture.muiName = 'SvgIcon';
	
	exports.default = ImageTexture;

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimelapse = function ImageTimelapse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ImageTimelapse = (0, _pure2.default)(ImageTimelapse);
	ImageTimelapse.displayName = 'ImageTimelapse';
	ImageTimelapse.muiName = 'SvgIcon';
	
	exports.default = ImageTimelapse;

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer10 = function ImageTimer10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z' })
	  );
	};
	ImageTimer10 = (0, _pure2.default)(ImageTimer10);
	ImageTimer10.displayName = 'ImageTimer10';
	ImageTimer10.muiName = 'SvgIcon';
	
	exports.default = ImageTimer10;

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer3 = function ImageTimer3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z' })
	  );
	};
	ImageTimer3 = (0, _pure2.default)(ImageTimer3);
	ImageTimer3.displayName = 'ImageTimer3';
	ImageTimer3.muiName = 'SvgIcon';
	
	exports.default = ImageTimer3;

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimerOff = function ImageTimerOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z' })
	  );
	};
	ImageTimerOff = (0, _pure2.default)(ImageTimerOff);
	ImageTimerOff.displayName = 'ImageTimerOff';
	ImageTimerOff.muiName = 'SvgIcon';
	
	exports.default = ImageTimerOff;

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer = function ImageTimer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	ImageTimer = (0, _pure2.default)(ImageTimer);
	ImageTimer.displayName = 'ImageTimer';
	ImageTimer.muiName = 'SvgIcon';
	
	exports.default = ImageTimer;

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTonality = function ImageTonality(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z' })
	  );
	};
	ImageTonality = (0, _pure2.default)(ImageTonality);
	ImageTonality.displayName = 'ImageTonality';
	ImageTonality.muiName = 'SvgIcon';
	
	exports.default = ImageTonality;

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTransform = function ImageTransform(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z' })
	  );
	};
	ImageTransform = (0, _pure2.default)(ImageTransform);
	ImageTransform.displayName = 'ImageTransform';
	ImageTransform.muiName = 'SvgIcon';
	
	exports.default = ImageTransform;

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTune = function ImageTune(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z' })
	  );
	};
	ImageTune = (0, _pure2.default)(ImageTune);
	ImageTune.displayName = 'ImageTune';
	ImageTune.muiName = 'SvgIcon';
	
	exports.default = ImageTune;

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageViewComfy = function ImageViewComfy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z' })
	  );
	};
	ImageViewComfy = (0, _pure2.default)(ImageViewComfy);
	ImageViewComfy.displayName = 'ImageViewComfy';
	ImageViewComfy.muiName = 'SvgIcon';
	
	exports.default = ImageViewComfy;

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageViewCompact = function ImageViewCompact(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z' })
	  );
	};
	ImageViewCompact = (0, _pure2.default)(ImageViewCompact);
	ImageViewCompact.displayName = 'ImageViewCompact';
	ImageViewCompact.muiName = 'SvgIcon';
	
	exports.default = ImageViewCompact;

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageVignette = function ImageVignette(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z' })
	  );
	};
	ImageVignette = (0, _pure2.default)(ImageVignette);
	ImageVignette.displayName = 'ImageVignette';
	ImageVignette.muiName = 'SvgIcon';
	
	exports.default = ImageVignette;

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbAuto = function ImageWbAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z' })
	  );
	};
	ImageWbAuto = (0, _pure2.default)(ImageWbAuto);
	ImageWbAuto.displayName = 'ImageWbAuto';
	ImageWbAuto.muiName = 'SvgIcon';
	
	exports.default = ImageWbAuto;

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbCloudy = function ImageWbCloudy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z' })
	  );
	};
	ImageWbCloudy = (0, _pure2.default)(ImageWbCloudy);
	ImageWbCloudy.displayName = 'ImageWbCloudy';
	ImageWbCloudy.muiName = 'SvgIcon';
	
	exports.default = ImageWbCloudy;

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbIncandescent = function ImageWbIncandescent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z' })
	  );
	};
	ImageWbIncandescent = (0, _pure2.default)(ImageWbIncandescent);
	ImageWbIncandescent.displayName = 'ImageWbIncandescent';
	ImageWbIncandescent.muiName = 'SvgIcon';
	
	exports.default = ImageWbIncandescent;

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbIridescent = function ImageWbIridescent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z' })
	  );
	};
	ImageWbIridescent = (0, _pure2.default)(ImageWbIridescent);
	ImageWbIridescent.displayName = 'ImageWbIridescent';
	ImageWbIridescent.muiName = 'SvgIcon';
	
	exports.default = ImageWbIridescent;

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbSunny = function ImageWbSunny(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z' })
	  );
	};
	ImageWbSunny = (0, _pure2.default)(ImageWbSunny);
	ImageWbSunny.displayName = 'ImageWbSunny';
	ImageWbSunny.muiName = 'SvgIcon';
	
	exports.default = ImageWbSunny;

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleStar = exports.ToggleStarHalf = exports.ToggleStarBorder = exports.ToggleRadioButtonUnchecked = exports.ToggleRadioButtonChecked = exports.ToggleIndeterminateCheckBox = exports.ToggleCheckBox = exports.ToggleCheckBoxOutlineBlank = exports.SocialWhatshot = exports.SocialShare = exports.SocialSentimentVerySatisfied = exports.SocialSentimentVeryDissatisfied = exports.SocialSentimentSatisfied = exports.SocialSentimentNeutral = exports.SocialSentimentDissatisfied = exports.SocialSchool = exports.SocialPublic = exports.SocialPoll = exports.SocialPlusOne = exports.SocialPerson = exports.SocialPersonOutline = exports.SocialPersonAdd = exports.SocialPeople = exports.SocialPeopleOutline = exports.SocialPartyMode = exports.SocialPages = exports.SocialNotifications = exports.SocialNotificationsPaused = exports.SocialNotificationsOff = exports.SocialNotificationsNone = exports.SocialNotificationsActive = exports.SocialMood = exports.SocialMoodBad = exports.SocialLocationCity = exports.SocialGroup = exports.SocialGroupAdd = exports.SocialDomain = exports.SocialCake = exports.PlacesSpa = exports.PlacesSmokingRooms = exports.PlacesSmokeFree = exports.PlacesRvHookup = exports.PlacesRoomService = exports.PlacesPool = exports.PlacesKitchen = exports.PlacesHotTub = exports.PlacesGolfCourse = exports.PlacesFreeBreakfast = exports.PlacesFitnessCenter = exports.PlacesChildFriendly = exports.PlacesChildCare = exports.PlacesCasino = exports.PlacesBusinessCenter = exports.PlacesBeachAccess = exports.PlacesAllInclusive = exports.PlacesAirportShuttle = exports.PlacesAcUnit = exports.NotificationWifi = exports.NotificationWc = exports.NotificationVpnLock = exports.NotificationVoiceChat = exports.NotificationVibration = exports.NotificationTimeToLeave = exports.NotificationTapAndPlay = exports.NotificationSystemUpdate = exports.NotificationSync = exports.NotificationSyncProblem = exports.NotificationSyncDisabled = exports.NotificationSms = exports.NotificationSmsFailed = exports.NotificationSimCardAlert = exports.NotificationSdCard = exports.NotificationRvHookup = exports.NotificationPriorityHigh = exports.NotificationPower = exports.NotificationPhonePaused = exports.NotificationPhoneMissed = exports.NotificationPhoneLocked = exports.NotificationPhoneInTalk = exports.NotificationPhoneForwarded = exports.NotificationPhoneBluetoothSpeaker = exports.NotificationPersonalVideo = exports.NotificationOndemandVideo = exports.NotificationNoEncryption = exports.NotificationNetworkLocked = exports.NotificationNetworkCheck = exports.NotificationMore = exports.NotificationMms = exports.NotificationLiveTv = exports.NotificationFolderSpecial = exports.NotificationEventNote = exports.NotificationEventBusy = exports.NotificationEventAvailable = exports.NotificationEnhancedEncryption = exports.NotificationDriveEta = exports.NotificationDoNotDisturb = exports.NotificationDoNotDisturbOn = exports.NotificationDoNotDisturbOff = exports.NotificationDoNotDisturbAlt = exports.NotificationDiscFull = exports.NotificationConfirmationNumber = exports.NotificationBluetoothAudio = exports.NotificationAirlineSeatReclineNormal = exports.NotificationAirlineSeatReclineExtra = exports.NotificationAirlineSeatLegroomReduced = exports.NotificationAirlineSeatLegroomNormal = exports.NotificationAirlineSeatLegroomExtra = exports.NotificationAirlineSeatIndividualSuite = exports.NotificationAirlineSeatFlat = exports.NotificationAirlineSeatFlatAngled = exports.NotificationAdb = exports.NavigationArrowDropRight = exports.NavigationUnfoldMore = exports.NavigationUnfoldLess = exports.NavigationSubdirectoryArrowRight = exports.NavigationSubdirectoryArrowLeft = exports.NavigationRefresh = exports.NavigationMoreVert = exports.NavigationMoreHoriz = exports.NavigationMenu = exports.NavigationLastPage = exports.NavigationFullscreen = exports.NavigationFullscreenExit = exports.NavigationFirstPage = exports.NavigationExpandMore = exports.NavigationExpandLess = exports.NavigationClose = exports.NavigationChevronRight = exports.NavigationChevronLeft = exports.NavigationCheck = exports.NavigationCancel = exports.NavigationArrowUpward = exports.NavigationArrowForward = exports.NavigationArrowDropUp = exports.NavigationArrowDropDown = exports.NavigationArrowDropDownCircle = exports.NavigationArrowDownward = exports.NavigationArrowBack = exports.NavigationApps = exports.MapsZoomOutMap = exports.MapsTransferWithinAStation = exports.MapsTram = exports.MapsTrain = exports.MapsTraffic = exports.MapsTerrain = exports.MapsSubway = exports.MapsStreetview = exports.MapsStoreMallDirectory = exports.MapsSatellite = exports.MapsRestaurant = exports.MapsRestaurantMenu = exports.MapsRateReview = exports.MapsPlace = exports.MapsPinDrop = exports.MapsPersonPin = exports.MapsPersonPinCircle = exports.MapsNearMe = exports.MapsNavigation = exports.MapsMyLocation = exports.MapsMap = exports.MapsLocalTaxi = exports.MapsLocalShipping = exports.MapsLocalSee = exports.MapsLocalPrintshop = exports.MapsLocalPostOffice = exports.MapsLocalPlay = exports.MapsLocalPizza = exports.MapsLocalPhone = exports.MapsLocalPharmacy = exports.MapsLocalParking = exports.MapsLocalOffer = exports.MapsLocalMovies = exports.MapsLocalMall = exports.MapsLocalLibrary = exports.MapsLocalLaundryService = exports.MapsLocalHotel = exports.MapsLocalHospital = exports.MapsLocalGroceryStore = exports.MapsLocalGasStation = exports.MapsLocalFlorist = exports.MapsLocalDrink = exports.MapsLocalDining = exports.MapsLocalConvenienceStore = exports.MapsLocalCarWash = exports.MapsLocalCafe = exports.MapsLocalBar = exports.MapsLocalAtm = exports.MapsLocalAirport = exports.MapsLocalActivity = exports.MapsLayers = exports.MapsLayersClear = exports.MapsHotel = exports.MapsFlight = exports.MapsEvStation = exports.MapsEditLocation = exports.MapsDirections = exports.MapsDirectionsWalk = exports.MapsDirectionsTransit = exports.MapsDirectionsSubway = exports.MapsDirectionsRun = exports.MapsDirectionsRailway = exports.MapsDirectionsCar = exports.MapsDirectionsBus = exports.MapsDirectionsBoat = exports.MapsDirectionsBike = exports.MapsBeenhere = exports.MapsAddLocation = exports.ImageWbSunny = exports.ImageWbIridescent = exports.ImageWbIncandescent = exports.ImageWbCloudy = exports.ImageWbAuto = exports.ImageVignette = exports.ImageViewCompact = exports.ImageViewComfy = exports.ImageTune = exports.ImageTransform = exports.ImageTonality = exports.ImageTimer = exports.ImageTimerOff = exports.ImageTimer3 = exports.ImageTimer10 = exports.ImageTimelapse = exports.ImageTexture = exports.ImageTagFaces = exports.ImageSwitchVideo = exports.ImageSwitchCamera = exports.ImageStyle = exports.ImageStraighten = exports.ImageSlideshow = exports.ImageRotateRight = exports.ImageRotateLeft = exports.ImageRotate90DegreesCcw = exports.ImageRemoveRedEye = exports.ImagePortrait = exports.ImagePictureAsPdf = exports.ImagePhoto = exports.ImagePhotoSizeSelectSmall = exports.ImagePhotoSizeSelectLarge = exports.ImagePhotoSizeSelectActual = exports.ImagePhotoLibrary = exports.ImagePhotoFilter = exports.ImagePhotoCamera = exports.ImagePhotoAlbum = exports.ImagePanorama = exports.ImagePanoramaWideAngle = exports.ImagePanoramaVertical = exports.ImagePanoramaHorizontal = exports.ImagePanoramaFishEye = exports.ImagePalette = exports.ImageNavigateNext = exports.ImageNavigateBefore = exports.ImageNature = exports.ImageNaturePeople = exports.ImageMusicNote = exports.ImageMovieFilter = exports.ImageMovieCreation = exports.ImageMonochromePhotos = exports.ImageLoupe = exports.ImageLooks = exports.ImageLooksTwo = exports.ImageLooksOne = exports.ImageLooks6 = exports.ImageLooks5 = exports.ImageLooks4 = exports.ImageLooks3 = exports.ImageLinkedCamera = exports.ImageLens = exports.ImageLeakRemove = exports.ImageLeakAdd = exports.ImageLandscape = exports.ImageIso = exports.ImageImage = exports.ImageImageAspectRatio = exports.ImageHealing = exports.ImageHdrWeak = exports.ImageHdrStrong = exports.ImageHdrOn = exports.ImageHdrOff = exports.ImageGridOn = exports.ImageGridOff = exports.ImageGrain = exports.ImageGradient = exports.ImageFlip = exports.ImageFlashOn = exports.ImageFlashOff = exports.ImageFlashAuto = exports.ImageFlare = exports.ImageFilter = exports.ImageFilterVintage = exports.ImageFilterTiltShift = exports.ImageFilterNone = exports.ImageFilterHdr = exports.ImageFilterFrames = exports.ImageFilterDrama = exports.ImageFilterCenterFocus = exports.ImageFilterBAndW = exports.ImageFilter9 = exports.ImageFilter9Plus = exports.ImageFilter8 = exports.ImageFilter7 = exports.ImageFilter6 = exports.ImageFilter5 = exports.ImageFilter4 = exports.ImageFilter3 = exports.ImageFilter2 = exports.ImageFilter1 = exports.ImageExposure = exports.ImageExposureZero = exports.ImageExposurePlus2 = exports.ImageExposurePlus1 = exports.ImageExposureNeg2 = exports.ImageExposureNeg1 = exports.ImageEdit = exports.ImageDetails = exports.ImageDehaze = exports.ImageCrop = exports.ImageCropSquare = exports.ImageCropRotate = exports.ImageCropPortrait = exports.ImageCropOriginal = exports.ImageCropLandscape = exports.ImageCropFree = exports.ImageCropDin = exports.ImageCrop75 = exports.ImageCrop54 = exports.ImageCrop32 = exports.ImageCrop169 = exports.ImageControlPoint = exports.ImageControlPointDuplicate = exports.ImageCompare = exports.ImageColorize = exports.ImageColorLens = exports.ImageCollections = exports.ImageCollectionsBookmark = exports.ImageCenterFocusWeak = exports.ImageCenterFocusStrong = exports.ImageCamera = exports.ImageCameraRoll = exports.ImageCameraRear = exports.ImageCameraFront = exports.ImageCameraAlt = exports.ImageBurstMode = exports.ImageBrush = exports.ImageBrokenImage = exports.ImageBrightness7 = exports.ImageBrightness6 = exports.ImageBrightness5 = exports.ImageBrightness4 = exports.ImageBrightness3 = exports.ImageBrightness2 = exports.ImageBrightness1 = exports.ImageBlurOn = exports.ImageBlurOff = exports.ImageBlurLinear = exports.ImageBlurCircular = exports.ImageAudiotrack = exports.ImageAssistant = exports.ImageAssistantPhoto = exports.ImageAdjust = exports.ImageAddToPhotos = exports.ImageAddAPhoto = exports.HardwareWatch = exports.HardwareVideogameAsset = exports.HardwareTv = exports.HardwareToys = exports.HardwareTablet = exports.HardwareTabletMac = exports.HardwareTabletAndroid = exports.HardwareSpeaker = exports.HardwareSpeakerGroup = exports.HardwareSmartphone = exports.HardwareSimCard = exports.HardwareSecurity = exports.HardwareScanner = exports.HardwareRouter = exports.HardwarePowerInput = exports.HardwarePhonelink = exports.HardwarePhonelinkOff = exports.HardwarePhoneIphone = exports.HardwarePhoneAndroid = exports.HardwareMouse = exports.HardwareMemory = exports.HardwareLaptop = exports.HardwareLaptopWindows = exports.HardwareLaptopMac = exports.HardwareLaptopChromebook = exports.HardwareKeyboard = exports.HardwareKeyboardVoice = exports.HardwareKeyboardTab = exports.HardwareKeyboardReturn = exports.HardwareKeyboardHide = exports.HardwareKeyboardCapslock = exports.HardwareKeyboardBackspace = exports.HardwareKeyboardArrowUp = exports.HardwareKeyboardArrowRight = exports.HardwareKeyboardArrowLeft = exports.HardwareKeyboardArrowDown = exports.HardwareHeadset = exports.HardwareHeadsetMic = exports.HardwareGamepad = exports.HardwareDock = exports.HardwareDevicesOther = exports.HardwareDeviceHub = exports.HardwareDeveloperBoard = exports.HardwareDesktopWindows = exports.HardwareDesktopMac = exports.HardwareComputer = exports.HardwareCast = exports.HardwareCastConnected = exports.FileFolder = exports.FileFolderShared = exports.FileFolderOpen = exports.FileFileUpload = exports.FileFileDownload = exports.FileCreateNewFolder = exports.FileCloud = exports.FileCloudUpload = exports.FileCloudQueue = exports.FileCloudOff = exports.FileCloudDownload = exports.FileCloudDone = exports.FileCloudCircle = exports.FileAttachment = exports.EditorWrapText = exports.EditorVerticalAlignTop = exports.EditorVerticalAlignCenter = exports.EditorVerticalAlignBottom = exports.EditorTitle = exports.EditorTextFields = exports.EditorStrikethroughS = exports.EditorSpaceBar = exports.EditorShowChart = exports.EditorShortText = exports.EditorPublish = exports.EditorPieChart = exports.EditorPieChartOutlined = exports.EditorMultilineChart = exports.EditorMoneyOff = exports.EditorMonetizationOn = exports.EditorModeEdit = exports.EditorModeComment = exports.EditorMergeType = exports.EditorLinearScale = exports.EditorInsertPhoto = exports.EditorInsertLink = exports.EditorInsertInvitation = exports.EditorInsertEmoticon = exports.EditorInsertDriveFile = exports.EditorInsertComment = exports.EditorInsertChart = exports.EditorHighlight = exports.EditorFunctions = exports.EditorFormatUnderlined = exports.EditorFormatTextdirectionRToL = exports.EditorFormatTextdirectionLToR = exports.EditorFormatStrikethrough = exports.EditorFormatSize = exports.EditorFormatShapes = exports.EditorFormatQuote = exports.EditorFormatPaint = exports.EditorFormatListNumbered = exports.EditorFormatListBulleted = exports.EditorFormatLineSpacing = exports.EditorFormatItalic = exports.EditorFormatIndentIncrease = exports.EditorFormatIndentDecrease = exports.EditorFormatColorText = exports.EditorFormatColorReset = exports.EditorFormatColorFill = exports.EditorFormatClear = exports.EditorFormatBold = exports.EditorFormatAlignRight = exports.EditorFormatAlignLeft = exports.EditorFormatAlignJustify = exports.EditorFormatAlignCenter = exports.EditorDragHandle = exports.EditorBubbleChart = exports.EditorBorderVertical = exports.EditorBorderTop = exports.EditorBorderStyle = exports.EditorBorderRight = exports.EditorBorderOuter = exports.EditorBorderLeft = exports.EditorBorderInner = exports.EditorBorderHorizontal = exports.EditorBorderColor = exports.EditorBorderClear = exports.EditorBorderBottom = exports.EditorBorderAll = exports.EditorAttachMoney = exports.EditorAttachFile = exports.DeviceWifiTethering = exports.DeviceWifiLock = exports.DeviceWidgets = exports.DeviceWallpaper = exports.DeviceUsb = exports.DeviceStorage = exports.DeviceSignalWifiOff = exports.DeviceSignalWifi4Bar = exports.DeviceSignalWifi4BarLock = exports.DeviceSignalWifi3Bar = exports.DeviceSignalWifi3BarLock = exports.DeviceSignalWifi2Bar = exports.DeviceSignalWifi2BarLock = exports.DeviceSignalWifi1Bar = exports.DeviceSignalWifi1BarLock = exports.DeviceSignalWifi0Bar = exports.DeviceSignalCellularOff = exports.DeviceSignalCellularNull = exports.DeviceSignalCellularNoSim = exports.DeviceSignalCellularConnectedNoInternet4Bar = exports.DeviceSignalCellularConnectedNoInternet3Bar = exports.DeviceSignalCellularConnectedNoInternet2Bar = exports.DeviceSignalCellularConnectedNoInternet1Bar = exports.DeviceSignalCellularConnectedNoInternet0Bar = exports.DeviceSignalCellular4Bar = exports.DeviceSignalCellular3Bar = exports.DeviceSignalCellular2Bar = exports.DeviceSignalCellular1Bar = exports.DeviceSignalCellular0Bar = exports.DeviceSettingsSystemDaydream = exports.DeviceSdStorage = exports.DeviceScreenRotation = exports.DeviceScreenLockRotation = exports.DeviceScreenLockPortrait = exports.DeviceScreenLockLandscape = exports.DeviceNfc = exports.DeviceNetworkWifi = exports.DeviceNetworkCell = exports.DeviceLocationSearching = exports.DeviceLocationDisabled = exports.DeviceGraphicEq = exports.DeviceGpsOff = exports.DeviceGpsNotFixed = exports.DeviceGpsFixed = exports.DeviceDvr = exports.DeviceDevices = exports.DeviceDeveloperMode = exports.DeviceDataUsage = exports.DeviceBrightnessMedium = exports.DeviceBrightnessLow = exports.DeviceBrightnessHigh = exports.DeviceBrightnessAuto = exports.DeviceBluetooth = exports.DeviceBluetoothSearching = exports.DeviceBluetoothDisabled = exports.DeviceBluetoothConnected = exports.DeviceBatteryUnknown = exports.DeviceBatteryStd = exports.DeviceBatteryFull = exports.DeviceBatteryChargingFull = exports.DeviceBatteryCharging90 = exports.DeviceBatteryCharging80 = exports.DeviceBatteryCharging60 = exports.DeviceBatteryCharging50 = exports.DeviceBatteryCharging30 = exports.DeviceBatteryCharging20 = exports.DeviceBatteryAlert = exports.DeviceBattery90 = exports.DeviceBattery80 = exports.DeviceBattery60 = exports.DeviceBattery50 = exports.DeviceBattery30 = exports.DeviceBattery20 = exports.DeviceAirplanemodeInactive = exports.DeviceAirplanemodeActive = exports.DeviceAddAlarm = exports.DeviceAccessTime = exports.DeviceAccessAlarms = exports.DeviceAccessAlarm = exports.ContentWeekend = exports.ContentUndo = exports.ContentUnarchive = exports.ContentTextFormat = exports.ContentSort = exports.ContentSend = exports.ContentSelectAll = exports.ContentSave = exports.ContentReport = exports.ContentReply = exports.ContentReplyAll = exports.ContentRemove = exports.ContentRemoveCircle = exports.ContentRemoveCircleOutline = exports.ContentRedo = exports.ContentNextWeek = exports.ContentMoveToInbox = exports.ContentMarkunread = exports.ContentMail = exports.ContentLowPriority = exports.ContentLink = exports.ContentInbox = exports.ContentGesture = exports.ContentForward = exports.ContentFontDownload = exports.ContentFlag = exports.ContentFilterList = exports.ContentDrafts = exports.ContentDeleteSweep = exports.ContentCreate = exports.ContentContentPaste = exports.ContentContentCut = exports.ContentContentCopy = exports.ContentClear = exports.ContentBlock = exports.ContentBackspace = exports.ContentArchive = exports.ContentAdd = exports.ContentAddCircle = exports.ContentAddCircleOutline = exports.ContentAddBox = exports.CommunicationVpnKey = exports.CommunicationVoicemail = exports.CommunicationTextsms = exports.CommunicationSwapCalls = exports.CommunicationStopScreenShare = exports.CommunicationStayPrimaryPortrait = exports.CommunicationStayPrimaryLandscape = exports.CommunicationStayCurrentPortrait = exports.CommunicationStayCurrentLandscape = exports.CommunicationSpeakerPhone = exports.CommunicationScreenShare = exports.CommunicationRssFeed = exports.CommunicationRingVolume = exports.CommunicationPresentToAll = exports.CommunicationPortableWifiOff = exports.CommunicationPhonelinkSetup = exports.CommunicationPhonelinkRing = exports.CommunicationPhonelinkLock = exports.CommunicationPhonelinkErase = exports.CommunicationPhone = exports.CommunicationNoSim = exports.CommunicationMessage = exports.CommunicationMailOutline = exports.CommunicationLocationOn = exports.CommunicationLocationOff = exports.CommunicationLiveHelp = exports.CommunicationInvertColorsOff = exports.CommunicationImportExport = exports.CommunicationImportContacts = exports.CommunicationForum = exports.CommunicationEmail = exports.CommunicationDialpad = exports.CommunicationDialerSip = exports.CommunicationContacts = exports.CommunicationContactPhone = exports.CommunicationContactMail = exports.CommunicationComment = exports.CommunicationClearAll = exports.CommunicationChat = exports.CommunicationChatBubble = exports.CommunicationChatBubbleOutline = exports.CommunicationCall = exports.CommunicationCallSplit = exports.CommunicationCallReceived = exports.CommunicationCallMissed = exports.CommunicationCallMissedOutgoing = exports.CommunicationCallMerge = exports.CommunicationCallMade = exports.CommunicationCallEnd = exports.CommunicationBusiness = exports.AvWeb = exports.AvWebAsset = exports.AvVolumeUp = exports.AvVolumeOff = exports.AvVolumeMute = exports.AvVolumeDown = exports.AvVideocam = exports.AvVideocamOff = exports.AvVideoLibrary = exports.AvVideoLabel = exports.AvVideoCall = exports.AvSurroundSound = exports.AvSubtitles = exports.AvSubscriptions = exports.AvStop = exports.AvSortByAlpha = exports.AvSnooze = exports.AvSlowMotionVideo = exports.AvSkipPrevious = exports.AvSkipNext = exports.AvShuffle = exports.AvReplay = exports.AvReplay5 = exports.AvReplay30 = exports.AvReplay10 = exports.AvRepeat = exports.AvRepeatOne = exports.AvRemoveFromQueue = exports.AvRecentActors = exports.AvRadio = exports.AvQueue = exports.AvQueuePlayNext = exports.AvQueueMusic = exports.AvPlaylistPlay = exports.AvPlaylistAdd = exports.AvPlaylistAddCheck = exports.AvPlayCircleOutline = exports.AvPlayCircleFilled = exports.AvPlayArrow = exports.AvPause = exports.AvPauseCircleOutline = exports.AvPauseCircleFilled = exports.AvNote = exports.AvNotInterested = exports.AvNewReleases = exports.AvMusicVideo = exports.AvMovie = exports.AvMic = exports.AvMicOff = exports.AvMicNone = exports.AvLoop = exports.AvLibraryMusic = exports.AvLibraryBooks = exports.AvLibraryAdd = exports.AvHighQuality = exports.AvHearing = exports.AvHd = exports.AvGames = exports.AvForward5 = exports.AvForward30 = exports.AvForward10 = exports.AvFiberSmartRecord = exports.AvFiberPin = exports.AvFiberNew = exports.AvFiberManualRecord = exports.AvFiberDvr = exports.AvFeaturedVideo = exports.AvFeaturedPlayList = exports.AvFastRewind = exports.AvFastForward = exports.AvExplicit = exports.AvEqualizer = exports.AvClosedCaption = exports.AvCallToAction = exports.AvBrandingWatermark = exports.AvAvTimer = exports.AvArtTrack = exports.AvAlbum = exports.AvAirplay = exports.AvAddToQueue = exports.AlertWarning = exports.AlertError = exports.AlertErrorOutline = exports.AlertAddAlert = exports.ActionZoomOut = exports.ActionZoomIn = exports.ActionYoutubeSearchedFor = exports.ActionWork = exports.ActionWatchLater = exports.ActionVisibility = exports.ActionVisibilityOff = exports.ActionViewWeek = exports.ActionViewStream = exports.ActionViewQuilt = exports.ActionViewModule = exports.ActionViewList = exports.ActionViewHeadline = exports.ActionViewDay = exports.ActionViewColumn = exports.ActionViewCarousel = exports.ActionViewArray = exports.ActionViewAgenda = exports.ActionVerifiedUser = exports.ActionUpdate = exports.ActionTurnedIn = exports.ActionTurnedInNot = exports.ActionTrendingUp = exports.ActionTrendingFlat = exports.ActionTrendingDown = exports.ActionTranslate = exports.ActionTrackChanges = exports.ActionTouchApp = exports.ActionToll = exports.ActionToday = exports.ActionToc = exports.ActionTimeline = exports.ActionThumbsUpDown = exports.ActionThumbUp = exports.ActionThumbDown = exports.ActionThreeDRotation = exports.ActionTheaters = exports.ActionTab = exports.ActionTabUnselected = exports.ActionSystemUpdateAlt = exports.ActionSwapVerticalCircle = exports.ActionSwapVert = exports.ActionSwapHoriz = exports.ActionSupervisorAccount = exports.ActionSubject = exports.ActionStore = exports.ActionStars = exports.ActionSpellcheck = exports.ActionSpeakerNotes = exports.ActionSpeakerNotesOff = exports.ActionShoppingCart = exports.ActionShoppingBasket = exports.ActionShop = exports.ActionShopTwo = exports.ActionSettings = exports.ActionSettingsVoice = exports.ActionSettingsRemote = exports.ActionSettingsPower = exports.ActionSettingsPhone = exports.ActionSettingsOverscan = exports.ActionSettingsInputSvideo = exports.ActionSettingsInputHdmi = exports.ActionSettingsInputComposite = exports.ActionSettingsInputComponent = exports.ActionSettingsInputAntenna = exports.ActionSettingsEthernet = exports.ActionSettingsCell = exports.ActionSettingsBrightness = exports.ActionSettingsBluetooth = exports.ActionSettingsBackupRestore = exports.ActionSettingsApplications = exports.ActionSearch = exports.ActionSchedule = exports.ActionRowing = exports.ActionRoundedCorner = exports.ActionRoom = exports.ActionRestore = exports.ActionRestorePage = exports.ActionReportProblem = exports.ActionReorder = exports.ActionRemoveShoppingCart = exports.ActionRedeem = exports.ActionRecordVoiceOver = exports.ActionReceipt = exports.ActionQuestionAnswer = exports.ActionQueryBuilder = exports.ActionPrint = exports.ActionPregnantWoman = exports.ActionPowerSettingsNew = exports.ActionPolymer = exports.ActionPlayForWork = exports.ActionPictureInPicture = exports.ActionPictureInPictureAlt = exports.ActionPets = exports.ActionPermScanWifi = exports.ActionPermPhoneMsg = exports.ActionPermMedia = exports.ActionPermIdentity = exports.ActionPermDeviceInformation = exports.ActionPermDataSetting = exports.ActionPermContactCalendar = exports.ActionPermCameraMic = exports.ActionPayment = exports.ActionPanTool = exports.ActionPageview = exports.ActionOpenWith = exports.ActionOpenInNew = exports.ActionOpenInBrowser = exports.ActionOpacity = exports.ActionOfflinePin = exports.ActionNoteAdd = exports.ActionMotorcycle = exports.ActionMarkunreadMailbox = exports.ActionLoyalty = exports.ActionLock = exports.ActionLockOutline = exports.ActionLockOpen = exports.ActionList = exports.ActionLineWeight = exports.ActionLineStyle = exports.ActionLightbulbOutline = exports.ActionLaunch = exports.ActionLanguage = exports.ActionLabel = exports.ActionLabelOutline = exports.ActionInvertColors = exports.ActionInput = exports.ActionInfo = exports.ActionInfoOutline = exports.ActionImportantDevices = exports.ActionHttps = exports.ActionHttp = exports.ActionHourglassFull = exports.ActionHourglassEmpty = exports.ActionHome = exports.ActionHistory = exports.ActionHighlightOff = exports.ActionHelp = exports.ActionHelpOutline = exports.ActionGroupWork = exports.ActionGrade = exports.ActionGif = exports.ActionGetApp = exports.ActionGavel = exports.ActionGTranslate = exports.ActionFlipToFront = exports.ActionFlipToBack = exports.ActionFlightTakeoff = exports.ActionFlightLand = exports.ActionFingerprint = exports.ActionFindReplace = exports.ActionFindInPage = exports.ActionFeedback = exports.ActionFavorite = exports.ActionFavoriteBorder = exports.ActionFace = exports.ActionExtension = exports.ActionExplore = exports.ActionExitToApp = exports.ActionEvent = exports.ActionEventSeat = exports.ActionEuroSymbol = exports.ActionEject = exports.ActionDonutSmall = exports.ActionDonutLarge = exports.ActionDone = exports.ActionDoneAll = exports.ActionDns = exports.ActionDescription = exports.ActionDelete = exports.ActionDeleteForever = exports.ActionDateRange = exports.ActionDashboard = exports.ActionCreditCard = exports.ActionCopyright = exports.ActionCompareArrows = exports.ActionCode = exports.ActionClass = exports.ActionChromeReaderMode = exports.ActionCheckCircle = exports.ActionChangeHistory = exports.ActionCardTravel = exports.ActionCardMembership = exports.ActionCardGiftcard = exports.ActionCameraEnhance = exports.ActionCached = exports.ActionBuild = exports.ActionBugReport = exports.ActionBookmark = exports.ActionBookmarkBorder = exports.ActionBook = exports.ActionBackup = exports.ActionAutorenew = exports.ActionAssignment = exports.ActionAssignmentTurnedIn = exports.ActionAssignmentReturned = exports.ActionAssignmentReturn = exports.ActionAssignmentLate = exports.ActionAssignmentInd = exports.ActionAssessment = exports.ActionAspectRatio = exports.ActionAnnouncement = exports.ActionAndroid = exports.ActionAllOut = exports.ActionAlarm = exports.ActionAlarmOn = exports.ActionAlarmOff = exports.ActionAlarmAdd = exports.ActionAddShoppingCart = exports.ActionAccountCircle = exports.ActionAccountBox = exports.ActionAccountBalance = exports.ActionAccountBalanceWallet = exports.ActionAccessible = exports.ActionAccessibility = undefined;
	
	var _accessibility = __webpack_require__(1794);
	
	var _accessibility2 = _interopRequireDefault(_accessibility);
	
	var _accessible = __webpack_require__(1795);
	
	var _accessible2 = _interopRequireDefault(_accessible);
	
	var _accountBalanceWallet = __webpack_require__(1796);
	
	var _accountBalanceWallet2 = _interopRequireDefault(_accountBalanceWallet);
	
	var _accountBalance = __webpack_require__(1797);
	
	var _accountBalance2 = _interopRequireDefault(_accountBalance);
	
	var _accountBox = __webpack_require__(1798);
	
	var _accountBox2 = _interopRequireDefault(_accountBox);
	
	var _accountCircle = __webpack_require__(1799);
	
	var _accountCircle2 = _interopRequireDefault(_accountCircle);
	
	var _addShoppingCart = __webpack_require__(1800);
	
	var _addShoppingCart2 = _interopRequireDefault(_addShoppingCart);
	
	var _alarmAdd = __webpack_require__(1801);
	
	var _alarmAdd2 = _interopRequireDefault(_alarmAdd);
	
	var _alarmOff = __webpack_require__(1802);
	
	var _alarmOff2 = _interopRequireDefault(_alarmOff);
	
	var _alarmOn = __webpack_require__(1803);
	
	var _alarmOn2 = _interopRequireDefault(_alarmOn);
	
	var _alarm = __webpack_require__(1804);
	
	var _alarm2 = _interopRequireDefault(_alarm);
	
	var _allOut = __webpack_require__(1805);
	
	var _allOut2 = _interopRequireDefault(_allOut);
	
	var _android = __webpack_require__(1806);
	
	var _android2 = _interopRequireDefault(_android);
	
	var _announcement = __webpack_require__(1807);
	
	var _announcement2 = _interopRequireDefault(_announcement);
	
	var _aspectRatio = __webpack_require__(1808);
	
	var _aspectRatio2 = _interopRequireDefault(_aspectRatio);
	
	var _assessment = __webpack_require__(1809);
	
	var _assessment2 = _interopRequireDefault(_assessment);
	
	var _assignmentInd = __webpack_require__(1810);
	
	var _assignmentInd2 = _interopRequireDefault(_assignmentInd);
	
	var _assignmentLate = __webpack_require__(1811);
	
	var _assignmentLate2 = _interopRequireDefault(_assignmentLate);
	
	var _assignmentReturn = __webpack_require__(1812);
	
	var _assignmentReturn2 = _interopRequireDefault(_assignmentReturn);
	
	var _assignmentReturned = __webpack_require__(1813);
	
	var _assignmentReturned2 = _interopRequireDefault(_assignmentReturned);
	
	var _assignmentTurnedIn = __webpack_require__(1814);
	
	var _assignmentTurnedIn2 = _interopRequireDefault(_assignmentTurnedIn);
	
	var _assignment = __webpack_require__(1815);
	
	var _assignment2 = _interopRequireDefault(_assignment);
	
	var _autorenew = __webpack_require__(1816);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _backup = __webpack_require__(1817);
	
	var _backup2 = _interopRequireDefault(_backup);
	
	var _book = __webpack_require__(1818);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _bookmarkBorder = __webpack_require__(1819);
	
	var _bookmarkBorder2 = _interopRequireDefault(_bookmarkBorder);
	
	var _bookmark = __webpack_require__(1820);
	
	var _bookmark2 = _interopRequireDefault(_bookmark);
	
	var _bugReport = __webpack_require__(1821);
	
	var _bugReport2 = _interopRequireDefault(_bugReport);
	
	var _build = __webpack_require__(1822);
	
	var _build2 = _interopRequireDefault(_build);
	
	var _cached = __webpack_require__(1823);
	
	var _cached2 = _interopRequireDefault(_cached);
	
	var _cameraEnhance = __webpack_require__(1824);
	
	var _cameraEnhance2 = _interopRequireDefault(_cameraEnhance);
	
	var _cardGiftcard = __webpack_require__(1825);
	
	var _cardGiftcard2 = _interopRequireDefault(_cardGiftcard);
	
	var _cardMembership = __webpack_require__(1826);
	
	var _cardMembership2 = _interopRequireDefault(_cardMembership);
	
	var _cardTravel = __webpack_require__(1827);
	
	var _cardTravel2 = _interopRequireDefault(_cardTravel);
	
	var _changeHistory = __webpack_require__(1828);
	
	var _changeHistory2 = _interopRequireDefault(_changeHistory);
	
	var _checkCircle = __webpack_require__(619);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _chromeReaderMode = __webpack_require__(1829);
	
	var _chromeReaderMode2 = _interopRequireDefault(_chromeReaderMode);
	
	var _class = __webpack_require__(1830);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _code = __webpack_require__(1831);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _compareArrows = __webpack_require__(1832);
	
	var _compareArrows2 = _interopRequireDefault(_compareArrows);
	
	var _copyright = __webpack_require__(1833);
	
	var _copyright2 = _interopRequireDefault(_copyright);
	
	var _creditCard = __webpack_require__(1834);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _dashboard = __webpack_require__(1835);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dateRange = __webpack_require__(1836);
	
	var _dateRange2 = _interopRequireDefault(_dateRange);
	
	var _deleteForever = __webpack_require__(1837);
	
	var _deleteForever2 = _interopRequireDefault(_deleteForever);
	
	var _delete = __webpack_require__(1838);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _description = __webpack_require__(1839);
	
	var _description2 = _interopRequireDefault(_description);
	
	var _dns = __webpack_require__(1840);
	
	var _dns2 = _interopRequireDefault(_dns);
	
	var _doneAll = __webpack_require__(1841);
	
	var _doneAll2 = _interopRequireDefault(_doneAll);
	
	var _done = __webpack_require__(1842);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _donutLarge = __webpack_require__(1843);
	
	var _donutLarge2 = _interopRequireDefault(_donutLarge);
	
	var _donutSmall = __webpack_require__(1844);
	
	var _donutSmall2 = _interopRequireDefault(_donutSmall);
	
	var _eject = __webpack_require__(1845);
	
	var _eject2 = _interopRequireDefault(_eject);
	
	var _euroSymbol = __webpack_require__(1846);
	
	var _euroSymbol2 = _interopRequireDefault(_euroSymbol);
	
	var _eventSeat = __webpack_require__(1847);
	
	var _eventSeat2 = _interopRequireDefault(_eventSeat);
	
	var _event = __webpack_require__(1848);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _exitToApp = __webpack_require__(1849);
	
	var _exitToApp2 = _interopRequireDefault(_exitToApp);
	
	var _explore = __webpack_require__(1850);
	
	var _explore2 = _interopRequireDefault(_explore);
	
	var _extension = __webpack_require__(1851);
	
	var _extension2 = _interopRequireDefault(_extension);
	
	var _face = __webpack_require__(1852);
	
	var _face2 = _interopRequireDefault(_face);
	
	var _favoriteBorder = __webpack_require__(1853);
	
	var _favoriteBorder2 = _interopRequireDefault(_favoriteBorder);
	
	var _favorite = __webpack_require__(1854);
	
	var _favorite2 = _interopRequireDefault(_favorite);
	
	var _feedback = __webpack_require__(1855);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _findInPage = __webpack_require__(1856);
	
	var _findInPage2 = _interopRequireDefault(_findInPage);
	
	var _findReplace = __webpack_require__(1857);
	
	var _findReplace2 = _interopRequireDefault(_findReplace);
	
	var _fingerprint = __webpack_require__(1858);
	
	var _fingerprint2 = _interopRequireDefault(_fingerprint);
	
	var _flightLand = __webpack_require__(1859);
	
	var _flightLand2 = _interopRequireDefault(_flightLand);
	
	var _flightTakeoff = __webpack_require__(1860);
	
	var _flightTakeoff2 = _interopRequireDefault(_flightTakeoff);
	
	var _flipToBack = __webpack_require__(1861);
	
	var _flipToBack2 = _interopRequireDefault(_flipToBack);
	
	var _flipToFront = __webpack_require__(1862);
	
	var _flipToFront2 = _interopRequireDefault(_flipToFront);
	
	var _gTranslate = __webpack_require__(1863);
	
	var _gTranslate2 = _interopRequireDefault(_gTranslate);
	
	var _gavel = __webpack_require__(1864);
	
	var _gavel2 = _interopRequireDefault(_gavel);
	
	var _getApp = __webpack_require__(1865);
	
	var _getApp2 = _interopRequireDefault(_getApp);
	
	var _gif = __webpack_require__(1866);
	
	var _gif2 = _interopRequireDefault(_gif);
	
	var _grade = __webpack_require__(1867);
	
	var _grade2 = _interopRequireDefault(_grade);
	
	var _groupWork = __webpack_require__(1868);
	
	var _groupWork2 = _interopRequireDefault(_groupWork);
	
	var _helpOutline = __webpack_require__(1869);
	
	var _helpOutline2 = _interopRequireDefault(_helpOutline);
	
	var _help = __webpack_require__(1870);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _highlightOff = __webpack_require__(1871);
	
	var _highlightOff2 = _interopRequireDefault(_highlightOff);
	
	var _history = __webpack_require__(1872);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _home = __webpack_require__(1873);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _hourglassEmpty = __webpack_require__(1874);
	
	var _hourglassEmpty2 = _interopRequireDefault(_hourglassEmpty);
	
	var _hourglassFull = __webpack_require__(1875);
	
	var _hourglassFull2 = _interopRequireDefault(_hourglassFull);
	
	var _http = __webpack_require__(1876);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _https = __webpack_require__(1877);
	
	var _https2 = _interopRequireDefault(_https);
	
	var _importantDevices = __webpack_require__(1878);
	
	var _importantDevices2 = _interopRequireDefault(_importantDevices);
	
	var _infoOutline = __webpack_require__(1879);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _info = __webpack_require__(1880);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _input = __webpack_require__(1881);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _invertColors = __webpack_require__(1882);
	
	var _invertColors2 = _interopRequireDefault(_invertColors);
	
	var _labelOutline = __webpack_require__(1883);
	
	var _labelOutline2 = _interopRequireDefault(_labelOutline);
	
	var _label = __webpack_require__(1884);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _language = __webpack_require__(1885);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _launch = __webpack_require__(1886);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _lightbulbOutline = __webpack_require__(1887);
	
	var _lightbulbOutline2 = _interopRequireDefault(_lightbulbOutline);
	
	var _lineStyle = __webpack_require__(1888);
	
	var _lineStyle2 = _interopRequireDefault(_lineStyle);
	
	var _lineWeight = __webpack_require__(1889);
	
	var _lineWeight2 = _interopRequireDefault(_lineWeight);
	
	var _list = __webpack_require__(1890);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _lockOpen = __webpack_require__(1891);
	
	var _lockOpen2 = _interopRequireDefault(_lockOpen);
	
	var _lockOutline = __webpack_require__(1892);
	
	var _lockOutline2 = _interopRequireDefault(_lockOutline);
	
	var _lock = __webpack_require__(1893);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _loyalty = __webpack_require__(1894);
	
	var _loyalty2 = _interopRequireDefault(_loyalty);
	
	var _markunreadMailbox = __webpack_require__(1895);
	
	var _markunreadMailbox2 = _interopRequireDefault(_markunreadMailbox);
	
	var _motorcycle = __webpack_require__(1896);
	
	var _motorcycle2 = _interopRequireDefault(_motorcycle);
	
	var _noteAdd = __webpack_require__(1897);
	
	var _noteAdd2 = _interopRequireDefault(_noteAdd);
	
	var _offlinePin = __webpack_require__(1898);
	
	var _offlinePin2 = _interopRequireDefault(_offlinePin);
	
	var _opacity = __webpack_require__(1899);
	
	var _opacity2 = _interopRequireDefault(_opacity);
	
	var _openInBrowser = __webpack_require__(1900);
	
	var _openInBrowser2 = _interopRequireDefault(_openInBrowser);
	
	var _openInNew = __webpack_require__(1901);
	
	var _openInNew2 = _interopRequireDefault(_openInNew);
	
	var _openWith = __webpack_require__(1902);
	
	var _openWith2 = _interopRequireDefault(_openWith);
	
	var _pageview = __webpack_require__(1903);
	
	var _pageview2 = _interopRequireDefault(_pageview);
	
	var _panTool = __webpack_require__(1904);
	
	var _panTool2 = _interopRequireDefault(_panTool);
	
	var _payment = __webpack_require__(1905);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _permCameraMic = __webpack_require__(1906);
	
	var _permCameraMic2 = _interopRequireDefault(_permCameraMic);
	
	var _permContactCalendar = __webpack_require__(1907);
	
	var _permContactCalendar2 = _interopRequireDefault(_permContactCalendar);
	
	var _permDataSetting = __webpack_require__(1908);
	
	var _permDataSetting2 = _interopRequireDefault(_permDataSetting);
	
	var _permDeviceInformation = __webpack_require__(1909);
	
	var _permDeviceInformation2 = _interopRequireDefault(_permDeviceInformation);
	
	var _permIdentity = __webpack_require__(1910);
	
	var _permIdentity2 = _interopRequireDefault(_permIdentity);
	
	var _permMedia = __webpack_require__(1911);
	
	var _permMedia2 = _interopRequireDefault(_permMedia);
	
	var _permPhoneMsg = __webpack_require__(1912);
	
	var _permPhoneMsg2 = _interopRequireDefault(_permPhoneMsg);
	
	var _permScanWifi = __webpack_require__(1913);
	
	var _permScanWifi2 = _interopRequireDefault(_permScanWifi);
	
	var _pets = __webpack_require__(1914);
	
	var _pets2 = _interopRequireDefault(_pets);
	
	var _pictureInPictureAlt = __webpack_require__(1915);
	
	var _pictureInPictureAlt2 = _interopRequireDefault(_pictureInPictureAlt);
	
	var _pictureInPicture = __webpack_require__(1916);
	
	var _pictureInPicture2 = _interopRequireDefault(_pictureInPicture);
	
	var _playForWork = __webpack_require__(1917);
	
	var _playForWork2 = _interopRequireDefault(_playForWork);
	
	var _polymer = __webpack_require__(1918);
	
	var _polymer2 = _interopRequireDefault(_polymer);
	
	var _powerSettingsNew = __webpack_require__(1919);
	
	var _powerSettingsNew2 = _interopRequireDefault(_powerSettingsNew);
	
	var _pregnantWoman = __webpack_require__(1920);
	
	var _pregnantWoman2 = _interopRequireDefault(_pregnantWoman);
	
	var _print = __webpack_require__(1921);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _queryBuilder = __webpack_require__(1922);
	
	var _queryBuilder2 = _interopRequireDefault(_queryBuilder);
	
	var _questionAnswer = __webpack_require__(1923);
	
	var _questionAnswer2 = _interopRequireDefault(_questionAnswer);
	
	var _receipt = __webpack_require__(1924);
	
	var _receipt2 = _interopRequireDefault(_receipt);
	
	var _recordVoiceOver = __webpack_require__(1925);
	
	var _recordVoiceOver2 = _interopRequireDefault(_recordVoiceOver);
	
	var _redeem = __webpack_require__(1926);
	
	var _redeem2 = _interopRequireDefault(_redeem);
	
	var _removeShoppingCart = __webpack_require__(1927);
	
	var _removeShoppingCart2 = _interopRequireDefault(_removeShoppingCart);
	
	var _reorder = __webpack_require__(1928);
	
	var _reorder2 = _interopRequireDefault(_reorder);
	
	var _reportProblem = __webpack_require__(1929);
	
	var _reportProblem2 = _interopRequireDefault(_reportProblem);
	
	var _restorePage = __webpack_require__(1930);
	
	var _restorePage2 = _interopRequireDefault(_restorePage);
	
	var _restore = __webpack_require__(1931);
	
	var _restore2 = _interopRequireDefault(_restore);
	
	var _room = __webpack_require__(1932);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _roundedCorner = __webpack_require__(1933);
	
	var _roundedCorner2 = _interopRequireDefault(_roundedCorner);
	
	var _rowing = __webpack_require__(1934);
	
	var _rowing2 = _interopRequireDefault(_rowing);
	
	var _schedule = __webpack_require__(1935);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _search = __webpack_require__(1936);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _settingsApplications = __webpack_require__(1937);
	
	var _settingsApplications2 = _interopRequireDefault(_settingsApplications);
	
	var _settingsBackupRestore = __webpack_require__(1938);
	
	var _settingsBackupRestore2 = _interopRequireDefault(_settingsBackupRestore);
	
	var _settingsBluetooth = __webpack_require__(1939);
	
	var _settingsBluetooth2 = _interopRequireDefault(_settingsBluetooth);
	
	var _settingsBrightness = __webpack_require__(1940);
	
	var _settingsBrightness2 = _interopRequireDefault(_settingsBrightness);
	
	var _settingsCell = __webpack_require__(1941);
	
	var _settingsCell2 = _interopRequireDefault(_settingsCell);
	
	var _settingsEthernet = __webpack_require__(1942);
	
	var _settingsEthernet2 = _interopRequireDefault(_settingsEthernet);
	
	var _settingsInputAntenna = __webpack_require__(1943);
	
	var _settingsInputAntenna2 = _interopRequireDefault(_settingsInputAntenna);
	
	var _settingsInputComponent = __webpack_require__(1944);
	
	var _settingsInputComponent2 = _interopRequireDefault(_settingsInputComponent);
	
	var _settingsInputComposite = __webpack_require__(1945);
	
	var _settingsInputComposite2 = _interopRequireDefault(_settingsInputComposite);
	
	var _settingsInputHdmi = __webpack_require__(1946);
	
	var _settingsInputHdmi2 = _interopRequireDefault(_settingsInputHdmi);
	
	var _settingsInputSvideo = __webpack_require__(1947);
	
	var _settingsInputSvideo2 = _interopRequireDefault(_settingsInputSvideo);
	
	var _settingsOverscan = __webpack_require__(1948);
	
	var _settingsOverscan2 = _interopRequireDefault(_settingsOverscan);
	
	var _settingsPhone = __webpack_require__(1949);
	
	var _settingsPhone2 = _interopRequireDefault(_settingsPhone);
	
	var _settingsPower = __webpack_require__(1950);
	
	var _settingsPower2 = _interopRequireDefault(_settingsPower);
	
	var _settingsRemote = __webpack_require__(1951);
	
	var _settingsRemote2 = _interopRequireDefault(_settingsRemote);
	
	var _settingsVoice = __webpack_require__(1952);
	
	var _settingsVoice2 = _interopRequireDefault(_settingsVoice);
	
	var _settings = __webpack_require__(1953);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _shopTwo = __webpack_require__(1954);
	
	var _shopTwo2 = _interopRequireDefault(_shopTwo);
	
	var _shop = __webpack_require__(1955);
	
	var _shop2 = _interopRequireDefault(_shop);
	
	var _shoppingBasket = __webpack_require__(1956);
	
	var _shoppingBasket2 = _interopRequireDefault(_shoppingBasket);
	
	var _shoppingCart = __webpack_require__(1957);
	
	var _shoppingCart2 = _interopRequireDefault(_shoppingCart);
	
	var _speakerNotesOff = __webpack_require__(1958);
	
	var _speakerNotesOff2 = _interopRequireDefault(_speakerNotesOff);
	
	var _speakerNotes = __webpack_require__(1959);
	
	var _speakerNotes2 = _interopRequireDefault(_speakerNotes);
	
	var _spellcheck = __webpack_require__(1960);
	
	var _spellcheck2 = _interopRequireDefault(_spellcheck);
	
	var _stars = __webpack_require__(1961);
	
	var _stars2 = _interopRequireDefault(_stars);
	
	var _store = __webpack_require__(1962);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _subject = __webpack_require__(1963);
	
	var _subject2 = _interopRequireDefault(_subject);
	
	var _supervisorAccount = __webpack_require__(1964);
	
	var _supervisorAccount2 = _interopRequireDefault(_supervisorAccount);
	
	var _swapHoriz = __webpack_require__(1965);
	
	var _swapHoriz2 = _interopRequireDefault(_swapHoriz);
	
	var _swapVert = __webpack_require__(1966);
	
	var _swapVert2 = _interopRequireDefault(_swapVert);
	
	var _swapVerticalCircle = __webpack_require__(1967);
	
	var _swapVerticalCircle2 = _interopRequireDefault(_swapVerticalCircle);
	
	var _systemUpdateAlt = __webpack_require__(1968);
	
	var _systemUpdateAlt2 = _interopRequireDefault(_systemUpdateAlt);
	
	var _tabUnselected = __webpack_require__(1969);
	
	var _tabUnselected2 = _interopRequireDefault(_tabUnselected);
	
	var _tab = __webpack_require__(1970);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _theaters = __webpack_require__(1971);
	
	var _theaters2 = _interopRequireDefault(_theaters);
	
	var _threeDRotation = __webpack_require__(1972);
	
	var _threeDRotation2 = _interopRequireDefault(_threeDRotation);
	
	var _thumbDown = __webpack_require__(1973);
	
	var _thumbDown2 = _interopRequireDefault(_thumbDown);
	
	var _thumbUp = __webpack_require__(1974);
	
	var _thumbUp2 = _interopRequireDefault(_thumbUp);
	
	var _thumbsUpDown = __webpack_require__(1975);
	
	var _thumbsUpDown2 = _interopRequireDefault(_thumbsUpDown);
	
	var _timeline = __webpack_require__(1976);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _toc = __webpack_require__(1977);
	
	var _toc2 = _interopRequireDefault(_toc);
	
	var _today = __webpack_require__(1978);
	
	var _today2 = _interopRequireDefault(_today);
	
	var _toll = __webpack_require__(1979);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _touchApp = __webpack_require__(1980);
	
	var _touchApp2 = _interopRequireDefault(_touchApp);
	
	var _trackChanges = __webpack_require__(1981);
	
	var _trackChanges2 = _interopRequireDefault(_trackChanges);
	
	var _translate = __webpack_require__(1982);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _trendingDown = __webpack_require__(1983);
	
	var _trendingDown2 = _interopRequireDefault(_trendingDown);
	
	var _trendingFlat = __webpack_require__(1984);
	
	var _trendingFlat2 = _interopRequireDefault(_trendingFlat);
	
	var _trendingUp = __webpack_require__(1985);
	
	var _trendingUp2 = _interopRequireDefault(_trendingUp);
	
	var _turnedInNot = __webpack_require__(1986);
	
	var _turnedInNot2 = _interopRequireDefault(_turnedInNot);
	
	var _turnedIn = __webpack_require__(1987);
	
	var _turnedIn2 = _interopRequireDefault(_turnedIn);
	
	var _update = __webpack_require__(1988);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _verifiedUser = __webpack_require__(1989);
	
	var _verifiedUser2 = _interopRequireDefault(_verifiedUser);
	
	var _viewAgenda = __webpack_require__(1990);
	
	var _viewAgenda2 = _interopRequireDefault(_viewAgenda);
	
	var _viewArray = __webpack_require__(1991);
	
	var _viewArray2 = _interopRequireDefault(_viewArray);
	
	var _viewCarousel = __webpack_require__(1992);
	
	var _viewCarousel2 = _interopRequireDefault(_viewCarousel);
	
	var _viewColumn = __webpack_require__(1993);
	
	var _viewColumn2 = _interopRequireDefault(_viewColumn);
	
	var _viewDay = __webpack_require__(1994);
	
	var _viewDay2 = _interopRequireDefault(_viewDay);
	
	var _viewHeadline = __webpack_require__(1995);
	
	var _viewHeadline2 = _interopRequireDefault(_viewHeadline);
	
	var _viewList = __webpack_require__(1996);
	
	var _viewList2 = _interopRequireDefault(_viewList);
	
	var _viewModule = __webpack_require__(1997);
	
	var _viewModule2 = _interopRequireDefault(_viewModule);
	
	var _viewQuilt = __webpack_require__(1998);
	
	var _viewQuilt2 = _interopRequireDefault(_viewQuilt);
	
	var _viewStream = __webpack_require__(1999);
	
	var _viewStream2 = _interopRequireDefault(_viewStream);
	
	var _viewWeek = __webpack_require__(2000);
	
	var _viewWeek2 = _interopRequireDefault(_viewWeek);
	
	var _visibilityOff = __webpack_require__(2001);
	
	var _visibilityOff2 = _interopRequireDefault(_visibilityOff);
	
	var _visibility = __webpack_require__(2002);
	
	var _visibility2 = _interopRequireDefault(_visibility);
	
	var _watchLater = __webpack_require__(2003);
	
	var _watchLater2 = _interopRequireDefault(_watchLater);
	
	var _work = __webpack_require__(2004);
	
	var _work2 = _interopRequireDefault(_work);
	
	var _youtubeSearchedFor = __webpack_require__(2005);
	
	var _youtubeSearchedFor2 = _interopRequireDefault(_youtubeSearchedFor);
	
	var _zoomIn = __webpack_require__(2006);
	
	var _zoomIn2 = _interopRequireDefault(_zoomIn);
	
	var _zoomOut = __webpack_require__(2007);
	
	var _zoomOut2 = _interopRequireDefault(_zoomOut);
	
	var _addAlert = __webpack_require__(2008);
	
	var _addAlert2 = _interopRequireDefault(_addAlert);
	
	var _errorOutline = __webpack_require__(2009);
	
	var _errorOutline2 = _interopRequireDefault(_errorOutline);
	
	var _error = __webpack_require__(2010);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _warning = __webpack_require__(2011);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _addToQueue = __webpack_require__(2012);
	
	var _addToQueue2 = _interopRequireDefault(_addToQueue);
	
	var _airplay = __webpack_require__(2013);
	
	var _airplay2 = _interopRequireDefault(_airplay);
	
	var _album = __webpack_require__(2014);
	
	var _album2 = _interopRequireDefault(_album);
	
	var _artTrack = __webpack_require__(2015);
	
	var _artTrack2 = _interopRequireDefault(_artTrack);
	
	var _avTimer = __webpack_require__(2016);
	
	var _avTimer2 = _interopRequireDefault(_avTimer);
	
	var _brandingWatermark = __webpack_require__(2017);
	
	var _brandingWatermark2 = _interopRequireDefault(_brandingWatermark);
	
	var _callToAction = __webpack_require__(2018);
	
	var _callToAction2 = _interopRequireDefault(_callToAction);
	
	var _closedCaption = __webpack_require__(2019);
	
	var _closedCaption2 = _interopRequireDefault(_closedCaption);
	
	var _equalizer = __webpack_require__(2020);
	
	var _equalizer2 = _interopRequireDefault(_equalizer);
	
	var _explicit = __webpack_require__(2021);
	
	var _explicit2 = _interopRequireDefault(_explicit);
	
	var _fastForward = __webpack_require__(2022);
	
	var _fastForward2 = _interopRequireDefault(_fastForward);
	
	var _fastRewind = __webpack_require__(2023);
	
	var _fastRewind2 = _interopRequireDefault(_fastRewind);
	
	var _featuredPlayList = __webpack_require__(2024);
	
	var _featuredPlayList2 = _interopRequireDefault(_featuredPlayList);
	
	var _featuredVideo = __webpack_require__(2025);
	
	var _featuredVideo2 = _interopRequireDefault(_featuredVideo);
	
	var _fiberDvr = __webpack_require__(2026);
	
	var _fiberDvr2 = _interopRequireDefault(_fiberDvr);
	
	var _fiberManualRecord = __webpack_require__(2027);
	
	var _fiberManualRecord2 = _interopRequireDefault(_fiberManualRecord);
	
	var _fiberNew = __webpack_require__(2028);
	
	var _fiberNew2 = _interopRequireDefault(_fiberNew);
	
	var _fiberPin = __webpack_require__(2029);
	
	var _fiberPin2 = _interopRequireDefault(_fiberPin);
	
	var _fiberSmartRecord = __webpack_require__(2030);
	
	var _fiberSmartRecord2 = _interopRequireDefault(_fiberSmartRecord);
	
	var _forward = __webpack_require__(2031);
	
	var _forward2 = _interopRequireDefault(_forward);
	
	var _forward3 = __webpack_require__(2032);
	
	var _forward4 = _interopRequireDefault(_forward3);
	
	var _forward5 = __webpack_require__(2033);
	
	var _forward6 = _interopRequireDefault(_forward5);
	
	var _games = __webpack_require__(2034);
	
	var _games2 = _interopRequireDefault(_games);
	
	var _hd = __webpack_require__(2035);
	
	var _hd2 = _interopRequireDefault(_hd);
	
	var _hearing = __webpack_require__(2036);
	
	var _hearing2 = _interopRequireDefault(_hearing);
	
	var _highQuality = __webpack_require__(2037);
	
	var _highQuality2 = _interopRequireDefault(_highQuality);
	
	var _libraryAdd = __webpack_require__(2038);
	
	var _libraryAdd2 = _interopRequireDefault(_libraryAdd);
	
	var _libraryBooks = __webpack_require__(2039);
	
	var _libraryBooks2 = _interopRequireDefault(_libraryBooks);
	
	var _libraryMusic = __webpack_require__(2040);
	
	var _libraryMusic2 = _interopRequireDefault(_libraryMusic);
	
	var _loop = __webpack_require__(2041);
	
	var _loop2 = _interopRequireDefault(_loop);
	
	var _micNone = __webpack_require__(2042);
	
	var _micNone2 = _interopRequireDefault(_micNone);
	
	var _micOff = __webpack_require__(2043);
	
	var _micOff2 = _interopRequireDefault(_micOff);
	
	var _mic = __webpack_require__(2044);
	
	var _mic2 = _interopRequireDefault(_mic);
	
	var _movie = __webpack_require__(2045);
	
	var _movie2 = _interopRequireDefault(_movie);
	
	var _musicVideo = __webpack_require__(2046);
	
	var _musicVideo2 = _interopRequireDefault(_musicVideo);
	
	var _newReleases = __webpack_require__(2047);
	
	var _newReleases2 = _interopRequireDefault(_newReleases);
	
	var _notInterested = __webpack_require__(2048);
	
	var _notInterested2 = _interopRequireDefault(_notInterested);
	
	var _note = __webpack_require__(2049);
	
	var _note2 = _interopRequireDefault(_note);
	
	var _pauseCircleFilled = __webpack_require__(2050);
	
	var _pauseCircleFilled2 = _interopRequireDefault(_pauseCircleFilled);
	
	var _pauseCircleOutline = __webpack_require__(2051);
	
	var _pauseCircleOutline2 = _interopRequireDefault(_pauseCircleOutline);
	
	var _pause = __webpack_require__(2052);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _playArrow = __webpack_require__(2053);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _playCircleFilled = __webpack_require__(2054);
	
	var _playCircleFilled2 = _interopRequireDefault(_playCircleFilled);
	
	var _playCircleOutline = __webpack_require__(2055);
	
	var _playCircleOutline2 = _interopRequireDefault(_playCircleOutline);
	
	var _playlistAddCheck = __webpack_require__(2056);
	
	var _playlistAddCheck2 = _interopRequireDefault(_playlistAddCheck);
	
	var _playlistAdd = __webpack_require__(2057);
	
	var _playlistAdd2 = _interopRequireDefault(_playlistAdd);
	
	var _playlistPlay = __webpack_require__(2058);
	
	var _playlistPlay2 = _interopRequireDefault(_playlistPlay);
	
	var _queueMusic = __webpack_require__(2059);
	
	var _queueMusic2 = _interopRequireDefault(_queueMusic);
	
	var _queuePlayNext = __webpack_require__(2060);
	
	var _queuePlayNext2 = _interopRequireDefault(_queuePlayNext);
	
	var _queue = __webpack_require__(2061);
	
	var _queue2 = _interopRequireDefault(_queue);
	
	var _radio = __webpack_require__(2062);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _recentActors = __webpack_require__(2063);
	
	var _recentActors2 = _interopRequireDefault(_recentActors);
	
	var _removeFromQueue = __webpack_require__(2064);
	
	var _removeFromQueue2 = _interopRequireDefault(_removeFromQueue);
	
	var _repeatOne = __webpack_require__(2065);
	
	var _repeatOne2 = _interopRequireDefault(_repeatOne);
	
	var _repeat = __webpack_require__(2066);
	
	var _repeat2 = _interopRequireDefault(_repeat);
	
	var _replay = __webpack_require__(2067);
	
	var _replay2 = _interopRequireDefault(_replay);
	
	var _replay3 = __webpack_require__(2068);
	
	var _replay4 = _interopRequireDefault(_replay3);
	
	var _replay5 = __webpack_require__(2069);
	
	var _replay6 = _interopRequireDefault(_replay5);
	
	var _replay7 = __webpack_require__(2070);
	
	var _replay8 = _interopRequireDefault(_replay7);
	
	var _shuffle = __webpack_require__(2071);
	
	var _shuffle2 = _interopRequireDefault(_shuffle);
	
	var _skipNext = __webpack_require__(2072);
	
	var _skipNext2 = _interopRequireDefault(_skipNext);
	
	var _skipPrevious = __webpack_require__(2073);
	
	var _skipPrevious2 = _interopRequireDefault(_skipPrevious);
	
	var _slowMotionVideo = __webpack_require__(2074);
	
	var _slowMotionVideo2 = _interopRequireDefault(_slowMotionVideo);
	
	var _snooze = __webpack_require__(2075);
	
	var _snooze2 = _interopRequireDefault(_snooze);
	
	var _sortByAlpha = __webpack_require__(2076);
	
	var _sortByAlpha2 = _interopRequireDefault(_sortByAlpha);
	
	var _stop = __webpack_require__(2077);
	
	var _stop2 = _interopRequireDefault(_stop);
	
	var _subscriptions = __webpack_require__(2078);
	
	var _subscriptions2 = _interopRequireDefault(_subscriptions);
	
	var _subtitles = __webpack_require__(2079);
	
	var _subtitles2 = _interopRequireDefault(_subtitles);
	
	var _surroundSound = __webpack_require__(2080);
	
	var _surroundSound2 = _interopRequireDefault(_surroundSound);
	
	var _videoCall = __webpack_require__(2081);
	
	var _videoCall2 = _interopRequireDefault(_videoCall);
	
	var _videoLabel = __webpack_require__(2082);
	
	var _videoLabel2 = _interopRequireDefault(_videoLabel);
	
	var _videoLibrary = __webpack_require__(2083);
	
	var _videoLibrary2 = _interopRequireDefault(_videoLibrary);
	
	var _videocamOff = __webpack_require__(2084);
	
	var _videocamOff2 = _interopRequireDefault(_videocamOff);
	
	var _videocam = __webpack_require__(2085);
	
	var _videocam2 = _interopRequireDefault(_videocam);
	
	var _volumeDown = __webpack_require__(2086);
	
	var _volumeDown2 = _interopRequireDefault(_volumeDown);
	
	var _volumeMute = __webpack_require__(2087);
	
	var _volumeMute2 = _interopRequireDefault(_volumeMute);
	
	var _volumeOff = __webpack_require__(2088);
	
	var _volumeOff2 = _interopRequireDefault(_volumeOff);
	
	var _volumeUp = __webpack_require__(2089);
	
	var _volumeUp2 = _interopRequireDefault(_volumeUp);
	
	var _webAsset = __webpack_require__(2090);
	
	var _webAsset2 = _interopRequireDefault(_webAsset);
	
	var _web = __webpack_require__(2091);
	
	var _web2 = _interopRequireDefault(_web);
	
	var _business = __webpack_require__(2092);
	
	var _business2 = _interopRequireDefault(_business);
	
	var _callEnd = __webpack_require__(2093);
	
	var _callEnd2 = _interopRequireDefault(_callEnd);
	
	var _callMade = __webpack_require__(2094);
	
	var _callMade2 = _interopRequireDefault(_callMade);
	
	var _callMerge = __webpack_require__(2095);
	
	var _callMerge2 = _interopRequireDefault(_callMerge);
	
	var _callMissedOutgoing = __webpack_require__(2096);
	
	var _callMissedOutgoing2 = _interopRequireDefault(_callMissedOutgoing);
	
	var _callMissed = __webpack_require__(2097);
	
	var _callMissed2 = _interopRequireDefault(_callMissed);
	
	var _callReceived = __webpack_require__(2098);
	
	var _callReceived2 = _interopRequireDefault(_callReceived);
	
	var _callSplit = __webpack_require__(2099);
	
	var _callSplit2 = _interopRequireDefault(_callSplit);
	
	var _call = __webpack_require__(2100);
	
	var _call2 = _interopRequireDefault(_call);
	
	var _chatBubbleOutline = __webpack_require__(2101);
	
	var _chatBubbleOutline2 = _interopRequireDefault(_chatBubbleOutline);
	
	var _chatBubble = __webpack_require__(2102);
	
	var _chatBubble2 = _interopRequireDefault(_chatBubble);
	
	var _chat = __webpack_require__(2103);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	var _clearAll = __webpack_require__(2104);
	
	var _clearAll2 = _interopRequireDefault(_clearAll);
	
	var _comment = __webpack_require__(2105);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _contactMail = __webpack_require__(2106);
	
	var _contactMail2 = _interopRequireDefault(_contactMail);
	
	var _contactPhone = __webpack_require__(2107);
	
	var _contactPhone2 = _interopRequireDefault(_contactPhone);
	
	var _contacts = __webpack_require__(2108);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _dialerSip = __webpack_require__(2109);
	
	var _dialerSip2 = _interopRequireDefault(_dialerSip);
	
	var _dialpad = __webpack_require__(2110);
	
	var _dialpad2 = _interopRequireDefault(_dialpad);
	
	var _email = __webpack_require__(2111);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _forum = __webpack_require__(2112);
	
	var _forum2 = _interopRequireDefault(_forum);
	
	var _importContacts = __webpack_require__(2113);
	
	var _importContacts2 = _interopRequireDefault(_importContacts);
	
	var _importExport = __webpack_require__(2114);
	
	var _importExport2 = _interopRequireDefault(_importExport);
	
	var _invertColorsOff = __webpack_require__(2115);
	
	var _invertColorsOff2 = _interopRequireDefault(_invertColorsOff);
	
	var _liveHelp = __webpack_require__(2116);
	
	var _liveHelp2 = _interopRequireDefault(_liveHelp);
	
	var _locationOff = __webpack_require__(2117);
	
	var _locationOff2 = _interopRequireDefault(_locationOff);
	
	var _locationOn = __webpack_require__(2118);
	
	var _locationOn2 = _interopRequireDefault(_locationOn);
	
	var _mailOutline = __webpack_require__(2119);
	
	var _mailOutline2 = _interopRequireDefault(_mailOutline);
	
	var _message = __webpack_require__(2120);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _noSim = __webpack_require__(2121);
	
	var _noSim2 = _interopRequireDefault(_noSim);
	
	var _phone = __webpack_require__(2122);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _phonelinkErase = __webpack_require__(2123);
	
	var _phonelinkErase2 = _interopRequireDefault(_phonelinkErase);
	
	var _phonelinkLock = __webpack_require__(2124);
	
	var _phonelinkLock2 = _interopRequireDefault(_phonelinkLock);
	
	var _phonelinkRing = __webpack_require__(2125);
	
	var _phonelinkRing2 = _interopRequireDefault(_phonelinkRing);
	
	var _phonelinkSetup = __webpack_require__(2126);
	
	var _phonelinkSetup2 = _interopRequireDefault(_phonelinkSetup);
	
	var _portableWifiOff = __webpack_require__(2127);
	
	var _portableWifiOff2 = _interopRequireDefault(_portableWifiOff);
	
	var _presentToAll = __webpack_require__(2128);
	
	var _presentToAll2 = _interopRequireDefault(_presentToAll);
	
	var _ringVolume = __webpack_require__(2129);
	
	var _ringVolume2 = _interopRequireDefault(_ringVolume);
	
	var _rssFeed = __webpack_require__(2130);
	
	var _rssFeed2 = _interopRequireDefault(_rssFeed);
	
	var _screenShare = __webpack_require__(2131);
	
	var _screenShare2 = _interopRequireDefault(_screenShare);
	
	var _speakerPhone = __webpack_require__(2132);
	
	var _speakerPhone2 = _interopRequireDefault(_speakerPhone);
	
	var _stayCurrentLandscape = __webpack_require__(2133);
	
	var _stayCurrentLandscape2 = _interopRequireDefault(_stayCurrentLandscape);
	
	var _stayCurrentPortrait = __webpack_require__(2134);
	
	var _stayCurrentPortrait2 = _interopRequireDefault(_stayCurrentPortrait);
	
	var _stayPrimaryLandscape = __webpack_require__(2135);
	
	var _stayPrimaryLandscape2 = _interopRequireDefault(_stayPrimaryLandscape);
	
	var _stayPrimaryPortrait = __webpack_require__(2136);
	
	var _stayPrimaryPortrait2 = _interopRequireDefault(_stayPrimaryPortrait);
	
	var _stopScreenShare = __webpack_require__(2137);
	
	var _stopScreenShare2 = _interopRequireDefault(_stopScreenShare);
	
	var _swapCalls = __webpack_require__(2138);
	
	var _swapCalls2 = _interopRequireDefault(_swapCalls);
	
	var _textsms = __webpack_require__(2139);
	
	var _textsms2 = _interopRequireDefault(_textsms);
	
	var _voicemail = __webpack_require__(2140);
	
	var _voicemail2 = _interopRequireDefault(_voicemail);
	
	var _vpnKey = __webpack_require__(2141);
	
	var _vpnKey2 = _interopRequireDefault(_vpnKey);
	
	var _addBox = __webpack_require__(2142);
	
	var _addBox2 = _interopRequireDefault(_addBox);
	
	var _addCircleOutline = __webpack_require__(2143);
	
	var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);
	
	var _addCircle = __webpack_require__(2144);
	
	var _addCircle2 = _interopRequireDefault(_addCircle);
	
	var _add = __webpack_require__(2145);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _archive = __webpack_require__(2146);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _backspace = __webpack_require__(2147);
	
	var _backspace2 = _interopRequireDefault(_backspace);
	
	var _block = __webpack_require__(2148);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _clear = __webpack_require__(2149);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _contentCopy = __webpack_require__(2150);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _contentCut = __webpack_require__(2151);
	
	var _contentCut2 = _interopRequireDefault(_contentCut);
	
	var _contentPaste = __webpack_require__(2152);
	
	var _contentPaste2 = _interopRequireDefault(_contentPaste);
	
	var _create = __webpack_require__(2153);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _deleteSweep = __webpack_require__(2154);
	
	var _deleteSweep2 = _interopRequireDefault(_deleteSweep);
	
	var _drafts = __webpack_require__(2155);
	
	var _drafts2 = _interopRequireDefault(_drafts);
	
	var _filterList = __webpack_require__(2156);
	
	var _filterList2 = _interopRequireDefault(_filterList);
	
	var _flag = __webpack_require__(2157);
	
	var _flag2 = _interopRequireDefault(_flag);
	
	var _fontDownload = __webpack_require__(2158);
	
	var _fontDownload2 = _interopRequireDefault(_fontDownload);
	
	var _forward7 = __webpack_require__(2159);
	
	var _forward8 = _interopRequireDefault(_forward7);
	
	var _gesture = __webpack_require__(2160);
	
	var _gesture2 = _interopRequireDefault(_gesture);
	
	var _inbox = __webpack_require__(2161);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	var _link = __webpack_require__(2162);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _lowPriority = __webpack_require__(2163);
	
	var _lowPriority2 = _interopRequireDefault(_lowPriority);
	
	var _mail = __webpack_require__(2164);
	
	var _mail2 = _interopRequireDefault(_mail);
	
	var _markunread = __webpack_require__(2165);
	
	var _markunread2 = _interopRequireDefault(_markunread);
	
	var _moveToInbox = __webpack_require__(2166);
	
	var _moveToInbox2 = _interopRequireDefault(_moveToInbox);
	
	var _nextWeek = __webpack_require__(2167);
	
	var _nextWeek2 = _interopRequireDefault(_nextWeek);
	
	var _redo = __webpack_require__(2168);
	
	var _redo2 = _interopRequireDefault(_redo);
	
	var _removeCircleOutline = __webpack_require__(2169);
	
	var _removeCircleOutline2 = _interopRequireDefault(_removeCircleOutline);
	
	var _removeCircle = __webpack_require__(2170);
	
	var _removeCircle2 = _interopRequireDefault(_removeCircle);
	
	var _remove = __webpack_require__(2171);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _replyAll = __webpack_require__(2172);
	
	var _replyAll2 = _interopRequireDefault(_replyAll);
	
	var _reply = __webpack_require__(2173);
	
	var _reply2 = _interopRequireDefault(_reply);
	
	var _report = __webpack_require__(2174);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _save = __webpack_require__(2175);
	
	var _save2 = _interopRequireDefault(_save);
	
	var _selectAll = __webpack_require__(2176);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	var _send = __webpack_require__(2177);
	
	var _send2 = _interopRequireDefault(_send);
	
	var _sort = __webpack_require__(2178);
	
	var _sort2 = _interopRequireDefault(_sort);
	
	var _textFormat = __webpack_require__(2179);
	
	var _textFormat2 = _interopRequireDefault(_textFormat);
	
	var _unarchive = __webpack_require__(2180);
	
	var _unarchive2 = _interopRequireDefault(_unarchive);
	
	var _undo = __webpack_require__(2181);
	
	var _undo2 = _interopRequireDefault(_undo);
	
	var _weekend = __webpack_require__(2182);
	
	var _weekend2 = _interopRequireDefault(_weekend);
	
	var _accessAlarm = __webpack_require__(2183);
	
	var _accessAlarm2 = _interopRequireDefault(_accessAlarm);
	
	var _accessAlarms = __webpack_require__(2184);
	
	var _accessAlarms2 = _interopRequireDefault(_accessAlarms);
	
	var _accessTime = __webpack_require__(2185);
	
	var _accessTime2 = _interopRequireDefault(_accessTime);
	
	var _addAlarm = __webpack_require__(2186);
	
	var _addAlarm2 = _interopRequireDefault(_addAlarm);
	
	var _airplanemodeActive = __webpack_require__(2187);
	
	var _airplanemodeActive2 = _interopRequireDefault(_airplanemodeActive);
	
	var _airplanemodeInactive = __webpack_require__(2188);
	
	var _airplanemodeInactive2 = _interopRequireDefault(_airplanemodeInactive);
	
	var _battery = __webpack_require__(2189);
	
	var _battery2 = _interopRequireDefault(_battery);
	
	var _battery3 = __webpack_require__(2190);
	
	var _battery4 = _interopRequireDefault(_battery3);
	
	var _battery5 = __webpack_require__(2191);
	
	var _battery6 = _interopRequireDefault(_battery5);
	
	var _battery7 = __webpack_require__(2192);
	
	var _battery8 = _interopRequireDefault(_battery7);
	
	var _battery9 = __webpack_require__(2193);
	
	var _battery10 = _interopRequireDefault(_battery9);
	
	var _battery11 = __webpack_require__(2194);
	
	var _battery12 = _interopRequireDefault(_battery11);
	
	var _batteryAlert = __webpack_require__(2195);
	
	var _batteryAlert2 = _interopRequireDefault(_batteryAlert);
	
	var _batteryCharging = __webpack_require__(2196);
	
	var _batteryCharging2 = _interopRequireDefault(_batteryCharging);
	
	var _batteryCharging3 = __webpack_require__(2197);
	
	var _batteryCharging4 = _interopRequireDefault(_batteryCharging3);
	
	var _batteryCharging5 = __webpack_require__(2198);
	
	var _batteryCharging6 = _interopRequireDefault(_batteryCharging5);
	
	var _batteryCharging7 = __webpack_require__(2199);
	
	var _batteryCharging8 = _interopRequireDefault(_batteryCharging7);
	
	var _batteryCharging9 = __webpack_require__(2200);
	
	var _batteryCharging10 = _interopRequireDefault(_batteryCharging9);
	
	var _batteryCharging11 = __webpack_require__(2201);
	
	var _batteryCharging12 = _interopRequireDefault(_batteryCharging11);
	
	var _batteryChargingFull = __webpack_require__(2202);
	
	var _batteryChargingFull2 = _interopRequireDefault(_batteryChargingFull);
	
	var _batteryFull = __webpack_require__(2203);
	
	var _batteryFull2 = _interopRequireDefault(_batteryFull);
	
	var _batteryStd = __webpack_require__(2204);
	
	var _batteryStd2 = _interopRequireDefault(_batteryStd);
	
	var _batteryUnknown = __webpack_require__(2205);
	
	var _batteryUnknown2 = _interopRequireDefault(_batteryUnknown);
	
	var _bluetoothConnected = __webpack_require__(2206);
	
	var _bluetoothConnected2 = _interopRequireDefault(_bluetoothConnected);
	
	var _bluetoothDisabled = __webpack_require__(2207);
	
	var _bluetoothDisabled2 = _interopRequireDefault(_bluetoothDisabled);
	
	var _bluetoothSearching = __webpack_require__(2208);
	
	var _bluetoothSearching2 = _interopRequireDefault(_bluetoothSearching);
	
	var _bluetooth = __webpack_require__(2209);
	
	var _bluetooth2 = _interopRequireDefault(_bluetooth);
	
	var _brightnessAuto = __webpack_require__(2210);
	
	var _brightnessAuto2 = _interopRequireDefault(_brightnessAuto);
	
	var _brightnessHigh = __webpack_require__(2211);
	
	var _brightnessHigh2 = _interopRequireDefault(_brightnessHigh);
	
	var _brightnessLow = __webpack_require__(2212);
	
	var _brightnessLow2 = _interopRequireDefault(_brightnessLow);
	
	var _brightnessMedium = __webpack_require__(2213);
	
	var _brightnessMedium2 = _interopRequireDefault(_brightnessMedium);
	
	var _dataUsage = __webpack_require__(2214);
	
	var _dataUsage2 = _interopRequireDefault(_dataUsage);
	
	var _developerMode = __webpack_require__(2215);
	
	var _developerMode2 = _interopRequireDefault(_developerMode);
	
	var _devices = __webpack_require__(2216);
	
	var _devices2 = _interopRequireDefault(_devices);
	
	var _dvr = __webpack_require__(2217);
	
	var _dvr2 = _interopRequireDefault(_dvr);
	
	var _gpsFixed = __webpack_require__(2218);
	
	var _gpsFixed2 = _interopRequireDefault(_gpsFixed);
	
	var _gpsNotFixed = __webpack_require__(2219);
	
	var _gpsNotFixed2 = _interopRequireDefault(_gpsNotFixed);
	
	var _gpsOff = __webpack_require__(2220);
	
	var _gpsOff2 = _interopRequireDefault(_gpsOff);
	
	var _graphicEq = __webpack_require__(2221);
	
	var _graphicEq2 = _interopRequireDefault(_graphicEq);
	
	var _locationDisabled = __webpack_require__(2222);
	
	var _locationDisabled2 = _interopRequireDefault(_locationDisabled);
	
	var _locationSearching = __webpack_require__(2223);
	
	var _locationSearching2 = _interopRequireDefault(_locationSearching);
	
	var _networkCell = __webpack_require__(2224);
	
	var _networkCell2 = _interopRequireDefault(_networkCell);
	
	var _networkWifi = __webpack_require__(2225);
	
	var _networkWifi2 = _interopRequireDefault(_networkWifi);
	
	var _nfc = __webpack_require__(2226);
	
	var _nfc2 = _interopRequireDefault(_nfc);
	
	var _screenLockLandscape = __webpack_require__(2227);
	
	var _screenLockLandscape2 = _interopRequireDefault(_screenLockLandscape);
	
	var _screenLockPortrait = __webpack_require__(2228);
	
	var _screenLockPortrait2 = _interopRequireDefault(_screenLockPortrait);
	
	var _screenLockRotation = __webpack_require__(2229);
	
	var _screenLockRotation2 = _interopRequireDefault(_screenLockRotation);
	
	var _screenRotation = __webpack_require__(2230);
	
	var _screenRotation2 = _interopRequireDefault(_screenRotation);
	
	var _sdStorage = __webpack_require__(2231);
	
	var _sdStorage2 = _interopRequireDefault(_sdStorage);
	
	var _settingsSystemDaydream = __webpack_require__(2232);
	
	var _settingsSystemDaydream2 = _interopRequireDefault(_settingsSystemDaydream);
	
	var _signalCellular0Bar = __webpack_require__(2233);
	
	var _signalCellular0Bar2 = _interopRequireDefault(_signalCellular0Bar);
	
	var _signalCellular1Bar = __webpack_require__(2234);
	
	var _signalCellular1Bar2 = _interopRequireDefault(_signalCellular1Bar);
	
	var _signalCellular2Bar = __webpack_require__(2235);
	
	var _signalCellular2Bar2 = _interopRequireDefault(_signalCellular2Bar);
	
	var _signalCellular3Bar = __webpack_require__(2236);
	
	var _signalCellular3Bar2 = _interopRequireDefault(_signalCellular3Bar);
	
	var _signalCellular4Bar = __webpack_require__(2237);
	
	var _signalCellular4Bar2 = _interopRequireDefault(_signalCellular4Bar);
	
	var _signalCellularConnectedNoInternet0Bar = __webpack_require__(2238);
	
	var _signalCellularConnectedNoInternet0Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet0Bar);
	
	var _signalCellularConnectedNoInternet1Bar = __webpack_require__(2239);
	
	var _signalCellularConnectedNoInternet1Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet1Bar);
	
	var _signalCellularConnectedNoInternet2Bar = __webpack_require__(2240);
	
	var _signalCellularConnectedNoInternet2Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet2Bar);
	
	var _signalCellularConnectedNoInternet3Bar = __webpack_require__(2241);
	
	var _signalCellularConnectedNoInternet3Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet3Bar);
	
	var _signalCellularConnectedNoInternet4Bar = __webpack_require__(2242);
	
	var _signalCellularConnectedNoInternet4Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet4Bar);
	
	var _signalCellularNoSim = __webpack_require__(2243);
	
	var _signalCellularNoSim2 = _interopRequireDefault(_signalCellularNoSim);
	
	var _signalCellularNull = __webpack_require__(2244);
	
	var _signalCellularNull2 = _interopRequireDefault(_signalCellularNull);
	
	var _signalCellularOff = __webpack_require__(2245);
	
	var _signalCellularOff2 = _interopRequireDefault(_signalCellularOff);
	
	var _signalWifi0Bar = __webpack_require__(2246);
	
	var _signalWifi0Bar2 = _interopRequireDefault(_signalWifi0Bar);
	
	var _signalWifi1BarLock = __webpack_require__(2247);
	
	var _signalWifi1BarLock2 = _interopRequireDefault(_signalWifi1BarLock);
	
	var _signalWifi1Bar = __webpack_require__(2248);
	
	var _signalWifi1Bar2 = _interopRequireDefault(_signalWifi1Bar);
	
	var _signalWifi2BarLock = __webpack_require__(2249);
	
	var _signalWifi2BarLock2 = _interopRequireDefault(_signalWifi2BarLock);
	
	var _signalWifi2Bar = __webpack_require__(2250);
	
	var _signalWifi2Bar2 = _interopRequireDefault(_signalWifi2Bar);
	
	var _signalWifi3BarLock = __webpack_require__(2251);
	
	var _signalWifi3BarLock2 = _interopRequireDefault(_signalWifi3BarLock);
	
	var _signalWifi3Bar = __webpack_require__(2252);
	
	var _signalWifi3Bar2 = _interopRequireDefault(_signalWifi3Bar);
	
	var _signalWifi4BarLock = __webpack_require__(2253);
	
	var _signalWifi4BarLock2 = _interopRequireDefault(_signalWifi4BarLock);
	
	var _signalWifi4Bar = __webpack_require__(2254);
	
	var _signalWifi4Bar2 = _interopRequireDefault(_signalWifi4Bar);
	
	var _signalWifiOff = __webpack_require__(2255);
	
	var _signalWifiOff2 = _interopRequireDefault(_signalWifiOff);
	
	var _storage = __webpack_require__(2256);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _usb = __webpack_require__(2257);
	
	var _usb2 = _interopRequireDefault(_usb);
	
	var _wallpaper = __webpack_require__(2258);
	
	var _wallpaper2 = _interopRequireDefault(_wallpaper);
	
	var _widgets = __webpack_require__(2259);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	var _wifiLock = __webpack_require__(2260);
	
	var _wifiLock2 = _interopRequireDefault(_wifiLock);
	
	var _wifiTethering = __webpack_require__(2261);
	
	var _wifiTethering2 = _interopRequireDefault(_wifiTethering);
	
	var _attachFile = __webpack_require__(2262);
	
	var _attachFile2 = _interopRequireDefault(_attachFile);
	
	var _attachMoney = __webpack_require__(2263);
	
	var _attachMoney2 = _interopRequireDefault(_attachMoney);
	
	var _borderAll = __webpack_require__(2264);
	
	var _borderAll2 = _interopRequireDefault(_borderAll);
	
	var _borderBottom = __webpack_require__(2265);
	
	var _borderBottom2 = _interopRequireDefault(_borderBottom);
	
	var _borderClear = __webpack_require__(2266);
	
	var _borderClear2 = _interopRequireDefault(_borderClear);
	
	var _borderColor = __webpack_require__(2267);
	
	var _borderColor2 = _interopRequireDefault(_borderColor);
	
	var _borderHorizontal = __webpack_require__(2268);
	
	var _borderHorizontal2 = _interopRequireDefault(_borderHorizontal);
	
	var _borderInner = __webpack_require__(2269);
	
	var _borderInner2 = _interopRequireDefault(_borderInner);
	
	var _borderLeft = __webpack_require__(2270);
	
	var _borderLeft2 = _interopRequireDefault(_borderLeft);
	
	var _borderOuter = __webpack_require__(2271);
	
	var _borderOuter2 = _interopRequireDefault(_borderOuter);
	
	var _borderRight = __webpack_require__(2272);
	
	var _borderRight2 = _interopRequireDefault(_borderRight);
	
	var _borderStyle = __webpack_require__(2273);
	
	var _borderStyle2 = _interopRequireDefault(_borderStyle);
	
	var _borderTop = __webpack_require__(2274);
	
	var _borderTop2 = _interopRequireDefault(_borderTop);
	
	var _borderVertical = __webpack_require__(2275);
	
	var _borderVertical2 = _interopRequireDefault(_borderVertical);
	
	var _bubbleChart = __webpack_require__(2276);
	
	var _bubbleChart2 = _interopRequireDefault(_bubbleChart);
	
	var _dragHandle = __webpack_require__(2277);
	
	var _dragHandle2 = _interopRequireDefault(_dragHandle);
	
	var _formatAlignCenter = __webpack_require__(2278);
	
	var _formatAlignCenter2 = _interopRequireDefault(_formatAlignCenter);
	
	var _formatAlignJustify = __webpack_require__(2279);
	
	var _formatAlignJustify2 = _interopRequireDefault(_formatAlignJustify);
	
	var _formatAlignLeft = __webpack_require__(2280);
	
	var _formatAlignLeft2 = _interopRequireDefault(_formatAlignLeft);
	
	var _formatAlignRight = __webpack_require__(2281);
	
	var _formatAlignRight2 = _interopRequireDefault(_formatAlignRight);
	
	var _formatBold = __webpack_require__(2282);
	
	var _formatBold2 = _interopRequireDefault(_formatBold);
	
	var _formatClear = __webpack_require__(2283);
	
	var _formatClear2 = _interopRequireDefault(_formatClear);
	
	var _formatColorFill = __webpack_require__(2284);
	
	var _formatColorFill2 = _interopRequireDefault(_formatColorFill);
	
	var _formatColorReset = __webpack_require__(2285);
	
	var _formatColorReset2 = _interopRequireDefault(_formatColorReset);
	
	var _formatColorText = __webpack_require__(2286);
	
	var _formatColorText2 = _interopRequireDefault(_formatColorText);
	
	var _formatIndentDecrease = __webpack_require__(2287);
	
	var _formatIndentDecrease2 = _interopRequireDefault(_formatIndentDecrease);
	
	var _formatIndentIncrease = __webpack_require__(2288);
	
	var _formatIndentIncrease2 = _interopRequireDefault(_formatIndentIncrease);
	
	var _formatItalic = __webpack_require__(2289);
	
	var _formatItalic2 = _interopRequireDefault(_formatItalic);
	
	var _formatLineSpacing = __webpack_require__(2290);
	
	var _formatLineSpacing2 = _interopRequireDefault(_formatLineSpacing);
	
	var _formatListBulleted = __webpack_require__(2291);
	
	var _formatListBulleted2 = _interopRequireDefault(_formatListBulleted);
	
	var _formatListNumbered = __webpack_require__(2292);
	
	var _formatListNumbered2 = _interopRequireDefault(_formatListNumbered);
	
	var _formatPaint = __webpack_require__(2293);
	
	var _formatPaint2 = _interopRequireDefault(_formatPaint);
	
	var _formatQuote = __webpack_require__(2294);
	
	var _formatQuote2 = _interopRequireDefault(_formatQuote);
	
	var _formatShapes = __webpack_require__(2295);
	
	var _formatShapes2 = _interopRequireDefault(_formatShapes);
	
	var _formatSize = __webpack_require__(2296);
	
	var _formatSize2 = _interopRequireDefault(_formatSize);
	
	var _formatStrikethrough = __webpack_require__(2297);
	
	var _formatStrikethrough2 = _interopRequireDefault(_formatStrikethrough);
	
	var _formatTextdirectionLToR = __webpack_require__(2298);
	
	var _formatTextdirectionLToR2 = _interopRequireDefault(_formatTextdirectionLToR);
	
	var _formatTextdirectionRToL = __webpack_require__(2299);
	
	var _formatTextdirectionRToL2 = _interopRequireDefault(_formatTextdirectionRToL);
	
	var _formatUnderlined = __webpack_require__(2300);
	
	var _formatUnderlined2 = _interopRequireDefault(_formatUnderlined);
	
	var _functions = __webpack_require__(2301);
	
	var _functions2 = _interopRequireDefault(_functions);
	
	var _highlight = __webpack_require__(2302);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _insertChart = __webpack_require__(2303);
	
	var _insertChart2 = _interopRequireDefault(_insertChart);
	
	var _insertComment = __webpack_require__(2304);
	
	var _insertComment2 = _interopRequireDefault(_insertComment);
	
	var _insertDriveFile = __webpack_require__(2305);
	
	var _insertDriveFile2 = _interopRequireDefault(_insertDriveFile);
	
	var _insertEmoticon = __webpack_require__(2306);
	
	var _insertEmoticon2 = _interopRequireDefault(_insertEmoticon);
	
	var _insertInvitation = __webpack_require__(2307);
	
	var _insertInvitation2 = _interopRequireDefault(_insertInvitation);
	
	var _insertLink = __webpack_require__(2308);
	
	var _insertLink2 = _interopRequireDefault(_insertLink);
	
	var _insertPhoto = __webpack_require__(2309);
	
	var _insertPhoto2 = _interopRequireDefault(_insertPhoto);
	
	var _linearScale = __webpack_require__(2310);
	
	var _linearScale2 = _interopRequireDefault(_linearScale);
	
	var _mergeType = __webpack_require__(2311);
	
	var _mergeType2 = _interopRequireDefault(_mergeType);
	
	var _modeComment = __webpack_require__(2312);
	
	var _modeComment2 = _interopRequireDefault(_modeComment);
	
	var _modeEdit = __webpack_require__(2313);
	
	var _modeEdit2 = _interopRequireDefault(_modeEdit);
	
	var _monetizationOn = __webpack_require__(2314);
	
	var _monetizationOn2 = _interopRequireDefault(_monetizationOn);
	
	var _moneyOff = __webpack_require__(2315);
	
	var _moneyOff2 = _interopRequireDefault(_moneyOff);
	
	var _multilineChart = __webpack_require__(2316);
	
	var _multilineChart2 = _interopRequireDefault(_multilineChart);
	
	var _pieChartOutlined = __webpack_require__(2317);
	
	var _pieChartOutlined2 = _interopRequireDefault(_pieChartOutlined);
	
	var _pieChart = __webpack_require__(2318);
	
	var _pieChart2 = _interopRequireDefault(_pieChart);
	
	var _publish = __webpack_require__(2319);
	
	var _publish2 = _interopRequireDefault(_publish);
	
	var _shortText = __webpack_require__(2320);
	
	var _shortText2 = _interopRequireDefault(_shortText);
	
	var _showChart = __webpack_require__(2321);
	
	var _showChart2 = _interopRequireDefault(_showChart);
	
	var _spaceBar = __webpack_require__(2322);
	
	var _spaceBar2 = _interopRequireDefault(_spaceBar);
	
	var _strikethroughS = __webpack_require__(2323);
	
	var _strikethroughS2 = _interopRequireDefault(_strikethroughS);
	
	var _textFields = __webpack_require__(2324);
	
	var _textFields2 = _interopRequireDefault(_textFields);
	
	var _title = __webpack_require__(2325);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _verticalAlignBottom = __webpack_require__(2326);
	
	var _verticalAlignBottom2 = _interopRequireDefault(_verticalAlignBottom);
	
	var _verticalAlignCenter = __webpack_require__(2327);
	
	var _verticalAlignCenter2 = _interopRequireDefault(_verticalAlignCenter);
	
	var _verticalAlignTop = __webpack_require__(2328);
	
	var _verticalAlignTop2 = _interopRequireDefault(_verticalAlignTop);
	
	var _wrapText = __webpack_require__(2329);
	
	var _wrapText2 = _interopRequireDefault(_wrapText);
	
	var _attachment = __webpack_require__(2330);
	
	var _attachment2 = _interopRequireDefault(_attachment);
	
	var _cloudCircle = __webpack_require__(2331);
	
	var _cloudCircle2 = _interopRequireDefault(_cloudCircle);
	
	var _cloudDone = __webpack_require__(2332);
	
	var _cloudDone2 = _interopRequireDefault(_cloudDone);
	
	var _cloudDownload = __webpack_require__(2333);
	
	var _cloudDownload2 = _interopRequireDefault(_cloudDownload);
	
	var _cloudOff = __webpack_require__(2334);
	
	var _cloudOff2 = _interopRequireDefault(_cloudOff);
	
	var _cloudQueue = __webpack_require__(2335);
	
	var _cloudQueue2 = _interopRequireDefault(_cloudQueue);
	
	var _cloudUpload = __webpack_require__(2336);
	
	var _cloudUpload2 = _interopRequireDefault(_cloudUpload);
	
	var _cloud = __webpack_require__(2337);
	
	var _cloud2 = _interopRequireDefault(_cloud);
	
	var _createNewFolder = __webpack_require__(2338);
	
	var _createNewFolder2 = _interopRequireDefault(_createNewFolder);
	
	var _fileDownload = __webpack_require__(2339);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _fileUpload = __webpack_require__(2340);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _folderOpen = __webpack_require__(2341);
	
	var _folderOpen2 = _interopRequireDefault(_folderOpen);
	
	var _folderShared = __webpack_require__(2342);
	
	var _folderShared2 = _interopRequireDefault(_folderShared);
	
	var _folder = __webpack_require__(2343);
	
	var _folder2 = _interopRequireDefault(_folder);
	
	var _castConnected = __webpack_require__(2344);
	
	var _castConnected2 = _interopRequireDefault(_castConnected);
	
	var _cast = __webpack_require__(2345);
	
	var _cast2 = _interopRequireDefault(_cast);
	
	var _computer = __webpack_require__(2346);
	
	var _computer2 = _interopRequireDefault(_computer);
	
	var _desktopMac = __webpack_require__(2347);
	
	var _desktopMac2 = _interopRequireDefault(_desktopMac);
	
	var _desktopWindows = __webpack_require__(2348);
	
	var _desktopWindows2 = _interopRequireDefault(_desktopWindows);
	
	var _developerBoard = __webpack_require__(2349);
	
	var _developerBoard2 = _interopRequireDefault(_developerBoard);
	
	var _deviceHub = __webpack_require__(2350);
	
	var _deviceHub2 = _interopRequireDefault(_deviceHub);
	
	var _devicesOther = __webpack_require__(2351);
	
	var _devicesOther2 = _interopRequireDefault(_devicesOther);
	
	var _dock = __webpack_require__(2352);
	
	var _dock2 = _interopRequireDefault(_dock);
	
	var _gamepad = __webpack_require__(2353);
	
	var _gamepad2 = _interopRequireDefault(_gamepad);
	
	var _headsetMic = __webpack_require__(2354);
	
	var _headsetMic2 = _interopRequireDefault(_headsetMic);
	
	var _headset = __webpack_require__(2355);
	
	var _headset2 = _interopRequireDefault(_headset);
	
	var _keyboardArrowDown = __webpack_require__(620);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _keyboardArrowLeft = __webpack_require__(2356);
	
	var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);
	
	var _keyboardArrowRight = __webpack_require__(2357);
	
	var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);
	
	var _keyboardArrowUp = __webpack_require__(621);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardBackspace = __webpack_require__(2358);
	
	var _keyboardBackspace2 = _interopRequireDefault(_keyboardBackspace);
	
	var _keyboardCapslock = __webpack_require__(2359);
	
	var _keyboardCapslock2 = _interopRequireDefault(_keyboardCapslock);
	
	var _keyboardHide = __webpack_require__(2360);
	
	var _keyboardHide2 = _interopRequireDefault(_keyboardHide);
	
	var _keyboardReturn = __webpack_require__(2361);
	
	var _keyboardReturn2 = _interopRequireDefault(_keyboardReturn);
	
	var _keyboardTab = __webpack_require__(2362);
	
	var _keyboardTab2 = _interopRequireDefault(_keyboardTab);
	
	var _keyboardVoice = __webpack_require__(2363);
	
	var _keyboardVoice2 = _interopRequireDefault(_keyboardVoice);
	
	var _keyboard = __webpack_require__(2364);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _laptopChromebook = __webpack_require__(2365);
	
	var _laptopChromebook2 = _interopRequireDefault(_laptopChromebook);
	
	var _laptopMac = __webpack_require__(2366);
	
	var _laptopMac2 = _interopRequireDefault(_laptopMac);
	
	var _laptopWindows = __webpack_require__(2367);
	
	var _laptopWindows2 = _interopRequireDefault(_laptopWindows);
	
	var _laptop = __webpack_require__(2368);
	
	var _laptop2 = _interopRequireDefault(_laptop);
	
	var _memory = __webpack_require__(2369);
	
	var _memory2 = _interopRequireDefault(_memory);
	
	var _mouse = __webpack_require__(2370);
	
	var _mouse2 = _interopRequireDefault(_mouse);
	
	var _phoneAndroid = __webpack_require__(2371);
	
	var _phoneAndroid2 = _interopRequireDefault(_phoneAndroid);
	
	var _phoneIphone = __webpack_require__(2372);
	
	var _phoneIphone2 = _interopRequireDefault(_phoneIphone);
	
	var _phonelinkOff = __webpack_require__(2373);
	
	var _phonelinkOff2 = _interopRequireDefault(_phonelinkOff);
	
	var _phonelink = __webpack_require__(2374);
	
	var _phonelink2 = _interopRequireDefault(_phonelink);
	
	var _powerInput = __webpack_require__(2375);
	
	var _powerInput2 = _interopRequireDefault(_powerInput);
	
	var _router = __webpack_require__(2376);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _scanner = __webpack_require__(2377);
	
	var _scanner2 = _interopRequireDefault(_scanner);
	
	var _security = __webpack_require__(2378);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _simCard = __webpack_require__(2379);
	
	var _simCard2 = _interopRequireDefault(_simCard);
	
	var _smartphone = __webpack_require__(2380);
	
	var _smartphone2 = _interopRequireDefault(_smartphone);
	
	var _speakerGroup = __webpack_require__(2381);
	
	var _speakerGroup2 = _interopRequireDefault(_speakerGroup);
	
	var _speaker = __webpack_require__(2382);
	
	var _speaker2 = _interopRequireDefault(_speaker);
	
	var _tabletAndroid = __webpack_require__(2383);
	
	var _tabletAndroid2 = _interopRequireDefault(_tabletAndroid);
	
	var _tabletMac = __webpack_require__(2384);
	
	var _tabletMac2 = _interopRequireDefault(_tabletMac);
	
	var _tablet = __webpack_require__(2385);
	
	var _tablet2 = _interopRequireDefault(_tablet);
	
	var _toys = __webpack_require__(2386);
	
	var _toys2 = _interopRequireDefault(_toys);
	
	var _tv = __webpack_require__(2387);
	
	var _tv2 = _interopRequireDefault(_tv);
	
	var _videogameAsset = __webpack_require__(2388);
	
	var _videogameAsset2 = _interopRequireDefault(_videogameAsset);
	
	var _watch = __webpack_require__(2389);
	
	var _watch2 = _interopRequireDefault(_watch);
	
	var _addAPhoto = __webpack_require__(2390);
	
	var _addAPhoto2 = _interopRequireDefault(_addAPhoto);
	
	var _addToPhotos = __webpack_require__(2391);
	
	var _addToPhotos2 = _interopRequireDefault(_addToPhotos);
	
	var _adjust = __webpack_require__(2392);
	
	var _adjust2 = _interopRequireDefault(_adjust);
	
	var _assistantPhoto = __webpack_require__(2393);
	
	var _assistantPhoto2 = _interopRequireDefault(_assistantPhoto);
	
	var _assistant = __webpack_require__(2394);
	
	var _assistant2 = _interopRequireDefault(_assistant);
	
	var _audiotrack = __webpack_require__(2395);
	
	var _audiotrack2 = _interopRequireDefault(_audiotrack);
	
	var _blurCircular = __webpack_require__(2396);
	
	var _blurCircular2 = _interopRequireDefault(_blurCircular);
	
	var _blurLinear = __webpack_require__(2397);
	
	var _blurLinear2 = _interopRequireDefault(_blurLinear);
	
	var _blurOff = __webpack_require__(2398);
	
	var _blurOff2 = _interopRequireDefault(_blurOff);
	
	var _blurOn = __webpack_require__(2399);
	
	var _blurOn2 = _interopRequireDefault(_blurOn);
	
	var _brightness = __webpack_require__(2400);
	
	var _brightness2 = _interopRequireDefault(_brightness);
	
	var _brightness3 = __webpack_require__(2401);
	
	var _brightness4 = _interopRequireDefault(_brightness3);
	
	var _brightness5 = __webpack_require__(2402);
	
	var _brightness6 = _interopRequireDefault(_brightness5);
	
	var _brightness7 = __webpack_require__(2403);
	
	var _brightness8 = _interopRequireDefault(_brightness7);
	
	var _brightness9 = __webpack_require__(2404);
	
	var _brightness10 = _interopRequireDefault(_brightness9);
	
	var _brightness11 = __webpack_require__(2405);
	
	var _brightness12 = _interopRequireDefault(_brightness11);
	
	var _brightness13 = __webpack_require__(2406);
	
	var _brightness14 = _interopRequireDefault(_brightness13);
	
	var _brokenImage = __webpack_require__(2407);
	
	var _brokenImage2 = _interopRequireDefault(_brokenImage);
	
	var _brush = __webpack_require__(2408);
	
	var _brush2 = _interopRequireDefault(_brush);
	
	var _burstMode = __webpack_require__(2409);
	
	var _burstMode2 = _interopRequireDefault(_burstMode);
	
	var _cameraAlt = __webpack_require__(2410);
	
	var _cameraAlt2 = _interopRequireDefault(_cameraAlt);
	
	var _cameraFront = __webpack_require__(2411);
	
	var _cameraFront2 = _interopRequireDefault(_cameraFront);
	
	var _cameraRear = __webpack_require__(2412);
	
	var _cameraRear2 = _interopRequireDefault(_cameraRear);
	
	var _cameraRoll = __webpack_require__(2413);
	
	var _cameraRoll2 = _interopRequireDefault(_cameraRoll);
	
	var _camera = __webpack_require__(2414);
	
	var _camera2 = _interopRequireDefault(_camera);
	
	var _centerFocusStrong = __webpack_require__(2415);
	
	var _centerFocusStrong2 = _interopRequireDefault(_centerFocusStrong);
	
	var _centerFocusWeak = __webpack_require__(2416);
	
	var _centerFocusWeak2 = _interopRequireDefault(_centerFocusWeak);
	
	var _collectionsBookmark = __webpack_require__(2417);
	
	var _collectionsBookmark2 = _interopRequireDefault(_collectionsBookmark);
	
	var _collections = __webpack_require__(2418);
	
	var _collections2 = _interopRequireDefault(_collections);
	
	var _colorLens = __webpack_require__(2419);
	
	var _colorLens2 = _interopRequireDefault(_colorLens);
	
	var _colorize = __webpack_require__(2420);
	
	var _colorize2 = _interopRequireDefault(_colorize);
	
	var _compare = __webpack_require__(2421);
	
	var _compare2 = _interopRequireDefault(_compare);
	
	var _controlPointDuplicate = __webpack_require__(2422);
	
	var _controlPointDuplicate2 = _interopRequireDefault(_controlPointDuplicate);
	
	var _controlPoint = __webpack_require__(2423);
	
	var _controlPoint2 = _interopRequireDefault(_controlPoint);
	
	var _crop = __webpack_require__(2424);
	
	var _crop2 = _interopRequireDefault(_crop);
	
	var _crop3 = __webpack_require__(2425);
	
	var _crop4 = _interopRequireDefault(_crop3);
	
	var _crop5 = __webpack_require__(2426);
	
	var _crop6 = _interopRequireDefault(_crop5);
	
	var _crop7 = __webpack_require__(2427);
	
	var _crop8 = _interopRequireDefault(_crop7);
	
	var _cropDin = __webpack_require__(2428);
	
	var _cropDin2 = _interopRequireDefault(_cropDin);
	
	var _cropFree = __webpack_require__(2429);
	
	var _cropFree2 = _interopRequireDefault(_cropFree);
	
	var _cropLandscape = __webpack_require__(2430);
	
	var _cropLandscape2 = _interopRequireDefault(_cropLandscape);
	
	var _cropOriginal = __webpack_require__(2431);
	
	var _cropOriginal2 = _interopRequireDefault(_cropOriginal);
	
	var _cropPortrait = __webpack_require__(2432);
	
	var _cropPortrait2 = _interopRequireDefault(_cropPortrait);
	
	var _cropRotate = __webpack_require__(2433);
	
	var _cropRotate2 = _interopRequireDefault(_cropRotate);
	
	var _cropSquare = __webpack_require__(2434);
	
	var _cropSquare2 = _interopRequireDefault(_cropSquare);
	
	var _crop9 = __webpack_require__(2435);
	
	var _crop10 = _interopRequireDefault(_crop9);
	
	var _dehaze = __webpack_require__(2436);
	
	var _dehaze2 = _interopRequireDefault(_dehaze);
	
	var _details = __webpack_require__(2437);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _edit = __webpack_require__(2438);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _exposureNeg = __webpack_require__(2439);
	
	var _exposureNeg2 = _interopRequireDefault(_exposureNeg);
	
	var _exposureNeg3 = __webpack_require__(2440);
	
	var _exposureNeg4 = _interopRequireDefault(_exposureNeg3);
	
	var _exposurePlus = __webpack_require__(2441);
	
	var _exposurePlus2 = _interopRequireDefault(_exposurePlus);
	
	var _exposurePlus3 = __webpack_require__(2442);
	
	var _exposurePlus4 = _interopRequireDefault(_exposurePlus3);
	
	var _exposureZero = __webpack_require__(2443);
	
	var _exposureZero2 = _interopRequireDefault(_exposureZero);
	
	var _exposure = __webpack_require__(2444);
	
	var _exposure2 = _interopRequireDefault(_exposure);
	
	var _filter = __webpack_require__(2445);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _filter3 = __webpack_require__(2446);
	
	var _filter4 = _interopRequireDefault(_filter3);
	
	var _filter5 = __webpack_require__(2447);
	
	var _filter6 = _interopRequireDefault(_filter5);
	
	var _filter7 = __webpack_require__(2448);
	
	var _filter8 = _interopRequireDefault(_filter7);
	
	var _filter9 = __webpack_require__(2449);
	
	var _filter10 = _interopRequireDefault(_filter9);
	
	var _filter11 = __webpack_require__(2450);
	
	var _filter12 = _interopRequireDefault(_filter11);
	
	var _filter13 = __webpack_require__(2451);
	
	var _filter14 = _interopRequireDefault(_filter13);
	
	var _filter15 = __webpack_require__(2452);
	
	var _filter16 = _interopRequireDefault(_filter15);
	
	var _filter9Plus = __webpack_require__(2453);
	
	var _filter9Plus2 = _interopRequireDefault(_filter9Plus);
	
	var _filter17 = __webpack_require__(2454);
	
	var _filter18 = _interopRequireDefault(_filter17);
	
	var _filterBAndW = __webpack_require__(2455);
	
	var _filterBAndW2 = _interopRequireDefault(_filterBAndW);
	
	var _filterCenterFocus = __webpack_require__(2456);
	
	var _filterCenterFocus2 = _interopRequireDefault(_filterCenterFocus);
	
	var _filterDrama = __webpack_require__(2457);
	
	var _filterDrama2 = _interopRequireDefault(_filterDrama);
	
	var _filterFrames = __webpack_require__(2458);
	
	var _filterFrames2 = _interopRequireDefault(_filterFrames);
	
	var _filterHdr = __webpack_require__(2459);
	
	var _filterHdr2 = _interopRequireDefault(_filterHdr);
	
	var _filterNone = __webpack_require__(2460);
	
	var _filterNone2 = _interopRequireDefault(_filterNone);
	
	var _filterTiltShift = __webpack_require__(2461);
	
	var _filterTiltShift2 = _interopRequireDefault(_filterTiltShift);
	
	var _filterVintage = __webpack_require__(2462);
	
	var _filterVintage2 = _interopRequireDefault(_filterVintage);
	
	var _filter19 = __webpack_require__(2463);
	
	var _filter20 = _interopRequireDefault(_filter19);
	
	var _flare = __webpack_require__(2464);
	
	var _flare2 = _interopRequireDefault(_flare);
	
	var _flashAuto = __webpack_require__(2465);
	
	var _flashAuto2 = _interopRequireDefault(_flashAuto);
	
	var _flashOff = __webpack_require__(2466);
	
	var _flashOff2 = _interopRequireDefault(_flashOff);
	
	var _flashOn = __webpack_require__(2467);
	
	var _flashOn2 = _interopRequireDefault(_flashOn);
	
	var _flip = __webpack_require__(2468);
	
	var _flip2 = _interopRequireDefault(_flip);
	
	var _gradient = __webpack_require__(2469);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _grain = __webpack_require__(2470);
	
	var _grain2 = _interopRequireDefault(_grain);
	
	var _gridOff = __webpack_require__(2471);
	
	var _gridOff2 = _interopRequireDefault(_gridOff);
	
	var _gridOn = __webpack_require__(2472);
	
	var _gridOn2 = _interopRequireDefault(_gridOn);
	
	var _hdrOff = __webpack_require__(2473);
	
	var _hdrOff2 = _interopRequireDefault(_hdrOff);
	
	var _hdrOn = __webpack_require__(2474);
	
	var _hdrOn2 = _interopRequireDefault(_hdrOn);
	
	var _hdrStrong = __webpack_require__(2475);
	
	var _hdrStrong2 = _interopRequireDefault(_hdrStrong);
	
	var _hdrWeak = __webpack_require__(2476);
	
	var _hdrWeak2 = _interopRequireDefault(_hdrWeak);
	
	var _healing = __webpack_require__(2477);
	
	var _healing2 = _interopRequireDefault(_healing);
	
	var _imageAspectRatio = __webpack_require__(2478);
	
	var _imageAspectRatio2 = _interopRequireDefault(_imageAspectRatio);
	
	var _image = __webpack_require__(2479);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _iso = __webpack_require__(2480);
	
	var _iso2 = _interopRequireDefault(_iso);
	
	var _landscape = __webpack_require__(2481);
	
	var _landscape2 = _interopRequireDefault(_landscape);
	
	var _leakAdd = __webpack_require__(2482);
	
	var _leakAdd2 = _interopRequireDefault(_leakAdd);
	
	var _leakRemove = __webpack_require__(2483);
	
	var _leakRemove2 = _interopRequireDefault(_leakRemove);
	
	var _lens = __webpack_require__(2484);
	
	var _lens2 = _interopRequireDefault(_lens);
	
	var _linkedCamera = __webpack_require__(2485);
	
	var _linkedCamera2 = _interopRequireDefault(_linkedCamera);
	
	var _looks = __webpack_require__(2486);
	
	var _looks2 = _interopRequireDefault(_looks);
	
	var _looks3 = __webpack_require__(2487);
	
	var _looks4 = _interopRequireDefault(_looks3);
	
	var _looks5 = __webpack_require__(2488);
	
	var _looks6 = _interopRequireDefault(_looks5);
	
	var _looks7 = __webpack_require__(2489);
	
	var _looks8 = _interopRequireDefault(_looks7);
	
	var _looksOne = __webpack_require__(2490);
	
	var _looksOne2 = _interopRequireDefault(_looksOne);
	
	var _looksTwo = __webpack_require__(2491);
	
	var _looksTwo2 = _interopRequireDefault(_looksTwo);
	
	var _looks9 = __webpack_require__(2492);
	
	var _looks10 = _interopRequireDefault(_looks9);
	
	var _loupe = __webpack_require__(2493);
	
	var _loupe2 = _interopRequireDefault(_loupe);
	
	var _monochromePhotos = __webpack_require__(2494);
	
	var _monochromePhotos2 = _interopRequireDefault(_monochromePhotos);
	
	var _movieCreation = __webpack_require__(2495);
	
	var _movieCreation2 = _interopRequireDefault(_movieCreation);
	
	var _movieFilter = __webpack_require__(2496);
	
	var _movieFilter2 = _interopRequireDefault(_movieFilter);
	
	var _musicNote = __webpack_require__(2497);
	
	var _musicNote2 = _interopRequireDefault(_musicNote);
	
	var _naturePeople = __webpack_require__(2498);
	
	var _naturePeople2 = _interopRequireDefault(_naturePeople);
	
	var _nature = __webpack_require__(2499);
	
	var _nature2 = _interopRequireDefault(_nature);
	
	var _navigateBefore = __webpack_require__(2500);
	
	var _navigateBefore2 = _interopRequireDefault(_navigateBefore);
	
	var _navigateNext = __webpack_require__(2501);
	
	var _navigateNext2 = _interopRequireDefault(_navigateNext);
	
	var _palette = __webpack_require__(2502);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _panoramaFishEye = __webpack_require__(2503);
	
	var _panoramaFishEye2 = _interopRequireDefault(_panoramaFishEye);
	
	var _panoramaHorizontal = __webpack_require__(2504);
	
	var _panoramaHorizontal2 = _interopRequireDefault(_panoramaHorizontal);
	
	var _panoramaVertical = __webpack_require__(2505);
	
	var _panoramaVertical2 = _interopRequireDefault(_panoramaVertical);
	
	var _panoramaWideAngle = __webpack_require__(2506);
	
	var _panoramaWideAngle2 = _interopRequireDefault(_panoramaWideAngle);
	
	var _panorama = __webpack_require__(2507);
	
	var _panorama2 = _interopRequireDefault(_panorama);
	
	var _photoAlbum = __webpack_require__(2508);
	
	var _photoAlbum2 = _interopRequireDefault(_photoAlbum);
	
	var _photoCamera = __webpack_require__(2509);
	
	var _photoCamera2 = _interopRequireDefault(_photoCamera);
	
	var _photoFilter = __webpack_require__(2510);
	
	var _photoFilter2 = _interopRequireDefault(_photoFilter);
	
	var _photoLibrary = __webpack_require__(2511);
	
	var _photoLibrary2 = _interopRequireDefault(_photoLibrary);
	
	var _photoSizeSelectActual = __webpack_require__(2512);
	
	var _photoSizeSelectActual2 = _interopRequireDefault(_photoSizeSelectActual);
	
	var _photoSizeSelectLarge = __webpack_require__(2513);
	
	var _photoSizeSelectLarge2 = _interopRequireDefault(_photoSizeSelectLarge);
	
	var _photoSizeSelectSmall = __webpack_require__(2514);
	
	var _photoSizeSelectSmall2 = _interopRequireDefault(_photoSizeSelectSmall);
	
	var _photo = __webpack_require__(2515);
	
	var _photo2 = _interopRequireDefault(_photo);
	
	var _pictureAsPdf = __webpack_require__(2516);
	
	var _pictureAsPdf2 = _interopRequireDefault(_pictureAsPdf);
	
	var _portrait = __webpack_require__(2517);
	
	var _portrait2 = _interopRequireDefault(_portrait);
	
	var _removeRedEye = __webpack_require__(2518);
	
	var _removeRedEye2 = _interopRequireDefault(_removeRedEye);
	
	var _rotate90DegreesCcw = __webpack_require__(2519);
	
	var _rotate90DegreesCcw2 = _interopRequireDefault(_rotate90DegreesCcw);
	
	var _rotateLeft = __webpack_require__(2520);
	
	var _rotateLeft2 = _interopRequireDefault(_rotateLeft);
	
	var _rotateRight = __webpack_require__(2521);
	
	var _rotateRight2 = _interopRequireDefault(_rotateRight);
	
	var _slideshow = __webpack_require__(2522);
	
	var _slideshow2 = _interopRequireDefault(_slideshow);
	
	var _straighten = __webpack_require__(2523);
	
	var _straighten2 = _interopRequireDefault(_straighten);
	
	var _style = __webpack_require__(2524);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _switchCamera = __webpack_require__(2525);
	
	var _switchCamera2 = _interopRequireDefault(_switchCamera);
	
	var _switchVideo = __webpack_require__(2526);
	
	var _switchVideo2 = _interopRequireDefault(_switchVideo);
	
	var _tagFaces = __webpack_require__(2527);
	
	var _tagFaces2 = _interopRequireDefault(_tagFaces);
	
	var _texture = __webpack_require__(2528);
	
	var _texture2 = _interopRequireDefault(_texture);
	
	var _timelapse = __webpack_require__(2529);
	
	var _timelapse2 = _interopRequireDefault(_timelapse);
	
	var _timer = __webpack_require__(2530);
	
	var _timer2 = _interopRequireDefault(_timer);
	
	var _timer3 = __webpack_require__(2531);
	
	var _timer4 = _interopRequireDefault(_timer3);
	
	var _timerOff = __webpack_require__(2532);
	
	var _timerOff2 = _interopRequireDefault(_timerOff);
	
	var _timer5 = __webpack_require__(2533);
	
	var _timer6 = _interopRequireDefault(_timer5);
	
	var _tonality = __webpack_require__(2534);
	
	var _tonality2 = _interopRequireDefault(_tonality);
	
	var _transform = __webpack_require__(2535);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	var _tune = __webpack_require__(2536);
	
	var _tune2 = _interopRequireDefault(_tune);
	
	var _viewComfy = __webpack_require__(2537);
	
	var _viewComfy2 = _interopRequireDefault(_viewComfy);
	
	var _viewCompact = __webpack_require__(2538);
	
	var _viewCompact2 = _interopRequireDefault(_viewCompact);
	
	var _vignette = __webpack_require__(2539);
	
	var _vignette2 = _interopRequireDefault(_vignette);
	
	var _wbAuto = __webpack_require__(2540);
	
	var _wbAuto2 = _interopRequireDefault(_wbAuto);
	
	var _wbCloudy = __webpack_require__(2541);
	
	var _wbCloudy2 = _interopRequireDefault(_wbCloudy);
	
	var _wbIncandescent = __webpack_require__(2542);
	
	var _wbIncandescent2 = _interopRequireDefault(_wbIncandescent);
	
	var _wbIridescent = __webpack_require__(2543);
	
	var _wbIridescent2 = _interopRequireDefault(_wbIridescent);
	
	var _wbSunny = __webpack_require__(2544);
	
	var _wbSunny2 = _interopRequireDefault(_wbSunny);
	
	var _addLocation = __webpack_require__(2546);
	
	var _addLocation2 = _interopRequireDefault(_addLocation);
	
	var _beenhere = __webpack_require__(2547);
	
	var _beenhere2 = _interopRequireDefault(_beenhere);
	
	var _directionsBike = __webpack_require__(2548);
	
	var _directionsBike2 = _interopRequireDefault(_directionsBike);
	
	var _directionsBoat = __webpack_require__(2549);
	
	var _directionsBoat2 = _interopRequireDefault(_directionsBoat);
	
	var _directionsBus = __webpack_require__(2550);
	
	var _directionsBus2 = _interopRequireDefault(_directionsBus);
	
	var _directionsCar = __webpack_require__(2551);
	
	var _directionsCar2 = _interopRequireDefault(_directionsCar);
	
	var _directionsRailway = __webpack_require__(2552);
	
	var _directionsRailway2 = _interopRequireDefault(_directionsRailway);
	
	var _directionsRun = __webpack_require__(2553);
	
	var _directionsRun2 = _interopRequireDefault(_directionsRun);
	
	var _directionsSubway = __webpack_require__(2554);
	
	var _directionsSubway2 = _interopRequireDefault(_directionsSubway);
	
	var _directionsTransit = __webpack_require__(2555);
	
	var _directionsTransit2 = _interopRequireDefault(_directionsTransit);
	
	var _directionsWalk = __webpack_require__(2556);
	
	var _directionsWalk2 = _interopRequireDefault(_directionsWalk);
	
	var _directions = __webpack_require__(2557);
	
	var _directions2 = _interopRequireDefault(_directions);
	
	var _editLocation = __webpack_require__(2558);
	
	var _editLocation2 = _interopRequireDefault(_editLocation);
	
	var _evStation = __webpack_require__(2559);
	
	var _evStation2 = _interopRequireDefault(_evStation);
	
	var _flight = __webpack_require__(2560);
	
	var _flight2 = _interopRequireDefault(_flight);
	
	var _hotel = __webpack_require__(2561);
	
	var _hotel2 = _interopRequireDefault(_hotel);
	
	var _layersClear = __webpack_require__(2562);
	
	var _layersClear2 = _interopRequireDefault(_layersClear);
	
	var _layers = __webpack_require__(2563);
	
	var _layers2 = _interopRequireDefault(_layers);
	
	var _localActivity = __webpack_require__(2564);
	
	var _localActivity2 = _interopRequireDefault(_localActivity);
	
	var _localAirport = __webpack_require__(2565);
	
	var _localAirport2 = _interopRequireDefault(_localAirport);
	
	var _localAtm = __webpack_require__(2566);
	
	var _localAtm2 = _interopRequireDefault(_localAtm);
	
	var _localBar = __webpack_require__(2567);
	
	var _localBar2 = _interopRequireDefault(_localBar);
	
	var _localCafe = __webpack_require__(2568);
	
	var _localCafe2 = _interopRequireDefault(_localCafe);
	
	var _localCarWash = __webpack_require__(2569);
	
	var _localCarWash2 = _interopRequireDefault(_localCarWash);
	
	var _localConvenienceStore = __webpack_require__(2570);
	
	var _localConvenienceStore2 = _interopRequireDefault(_localConvenienceStore);
	
	var _localDining = __webpack_require__(2571);
	
	var _localDining2 = _interopRequireDefault(_localDining);
	
	var _localDrink = __webpack_require__(2572);
	
	var _localDrink2 = _interopRequireDefault(_localDrink);
	
	var _localFlorist = __webpack_require__(2573);
	
	var _localFlorist2 = _interopRequireDefault(_localFlorist);
	
	var _localGasStation = __webpack_require__(2574);
	
	var _localGasStation2 = _interopRequireDefault(_localGasStation);
	
	var _localGroceryStore = __webpack_require__(2575);
	
	var _localGroceryStore2 = _interopRequireDefault(_localGroceryStore);
	
	var _localHospital = __webpack_require__(2576);
	
	var _localHospital2 = _interopRequireDefault(_localHospital);
	
	var _localHotel = __webpack_require__(2577);
	
	var _localHotel2 = _interopRequireDefault(_localHotel);
	
	var _localLaundryService = __webpack_require__(2578);
	
	var _localLaundryService2 = _interopRequireDefault(_localLaundryService);
	
	var _localLibrary = __webpack_require__(2579);
	
	var _localLibrary2 = _interopRequireDefault(_localLibrary);
	
	var _localMall = __webpack_require__(2580);
	
	var _localMall2 = _interopRequireDefault(_localMall);
	
	var _localMovies = __webpack_require__(2581);
	
	var _localMovies2 = _interopRequireDefault(_localMovies);
	
	var _localOffer = __webpack_require__(2582);
	
	var _localOffer2 = _interopRequireDefault(_localOffer);
	
	var _localParking = __webpack_require__(2583);
	
	var _localParking2 = _interopRequireDefault(_localParking);
	
	var _localPharmacy = __webpack_require__(2584);
	
	var _localPharmacy2 = _interopRequireDefault(_localPharmacy);
	
	var _localPhone = __webpack_require__(2585);
	
	var _localPhone2 = _interopRequireDefault(_localPhone);
	
	var _localPizza = __webpack_require__(2586);
	
	var _localPizza2 = _interopRequireDefault(_localPizza);
	
	var _localPlay = __webpack_require__(2587);
	
	var _localPlay2 = _interopRequireDefault(_localPlay);
	
	var _localPostOffice = __webpack_require__(2588);
	
	var _localPostOffice2 = _interopRequireDefault(_localPostOffice);
	
	var _localPrintshop = __webpack_require__(2589);
	
	var _localPrintshop2 = _interopRequireDefault(_localPrintshop);
	
	var _localSee = __webpack_require__(2590);
	
	var _localSee2 = _interopRequireDefault(_localSee);
	
	var _localShipping = __webpack_require__(2591);
	
	var _localShipping2 = _interopRequireDefault(_localShipping);
	
	var _localTaxi = __webpack_require__(2592);
	
	var _localTaxi2 = _interopRequireDefault(_localTaxi);
	
	var _map = __webpack_require__(2593);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _myLocation = __webpack_require__(2594);
	
	var _myLocation2 = _interopRequireDefault(_myLocation);
	
	var _navigation = __webpack_require__(2595);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _nearMe = __webpack_require__(2596);
	
	var _nearMe2 = _interopRequireDefault(_nearMe);
	
	var _personPinCircle = __webpack_require__(2597);
	
	var _personPinCircle2 = _interopRequireDefault(_personPinCircle);
	
	var _personPin = __webpack_require__(2598);
	
	var _personPin2 = _interopRequireDefault(_personPin);
	
	var _pinDrop = __webpack_require__(2599);
	
	var _pinDrop2 = _interopRequireDefault(_pinDrop);
	
	var _place = __webpack_require__(2600);
	
	var _place2 = _interopRequireDefault(_place);
	
	var _rateReview = __webpack_require__(2601);
	
	var _rateReview2 = _interopRequireDefault(_rateReview);
	
	var _restaurantMenu = __webpack_require__(2602);
	
	var _restaurantMenu2 = _interopRequireDefault(_restaurantMenu);
	
	var _restaurant = __webpack_require__(2603);
	
	var _restaurant2 = _interopRequireDefault(_restaurant);
	
	var _satellite = __webpack_require__(2604);
	
	var _satellite2 = _interopRequireDefault(_satellite);
	
	var _storeMallDirectory = __webpack_require__(2605);
	
	var _storeMallDirectory2 = _interopRequireDefault(_storeMallDirectory);
	
	var _streetview = __webpack_require__(2606);
	
	var _streetview2 = _interopRequireDefault(_streetview);
	
	var _subway = __webpack_require__(2607);
	
	var _subway2 = _interopRequireDefault(_subway);
	
	var _terrain = __webpack_require__(2608);
	
	var _terrain2 = _interopRequireDefault(_terrain);
	
	var _traffic = __webpack_require__(2609);
	
	var _traffic2 = _interopRequireDefault(_traffic);
	
	var _train = __webpack_require__(2610);
	
	var _train2 = _interopRequireDefault(_train);
	
	var _tram = __webpack_require__(2611);
	
	var _tram2 = _interopRequireDefault(_tram);
	
	var _transferWithinAStation = __webpack_require__(2612);
	
	var _transferWithinAStation2 = _interopRequireDefault(_transferWithinAStation);
	
	var _zoomOutMap = __webpack_require__(2613);
	
	var _zoomOutMap2 = _interopRequireDefault(_zoomOutMap);
	
	var _apps = __webpack_require__(2615);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _arrowBack = __webpack_require__(2616);
	
	var _arrowBack2 = _interopRequireDefault(_arrowBack);
	
	var _arrowDownward = __webpack_require__(2617);
	
	var _arrowDownward2 = _interopRequireDefault(_arrowDownward);
	
	var _arrowDropDownCircle = __webpack_require__(2618);
	
	var _arrowDropDownCircle2 = _interopRequireDefault(_arrowDropDownCircle);
	
	var _arrowDropDown = __webpack_require__(395);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(2619);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _arrowForward = __webpack_require__(2620);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _arrowUpward = __webpack_require__(2621);
	
	var _arrowUpward2 = _interopRequireDefault(_arrowUpward);
	
	var _cancel = __webpack_require__(622);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	var _check = __webpack_require__(623);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _chevronLeft = __webpack_require__(624);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(625);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _close = __webpack_require__(2622);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _expandLess = __webpack_require__(626);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(627);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _firstPage = __webpack_require__(2623);
	
	var _firstPage2 = _interopRequireDefault(_firstPage);
	
	var _fullscreenExit = __webpack_require__(2624);
	
	var _fullscreenExit2 = _interopRequireDefault(_fullscreenExit);
	
	var _fullscreen = __webpack_require__(2625);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _lastPage = __webpack_require__(2626);
	
	var _lastPage2 = _interopRequireDefault(_lastPage);
	
	var _menu = __webpack_require__(628);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _moreHoriz = __webpack_require__(2627);
	
	var _moreHoriz2 = _interopRequireDefault(_moreHoriz);
	
	var _moreVert = __webpack_require__(2628);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _refresh = __webpack_require__(2629);
	
	var _refresh2 = _interopRequireDefault(_refresh);
	
	var _subdirectoryArrowLeft = __webpack_require__(2630);
	
	var _subdirectoryArrowLeft2 = _interopRequireDefault(_subdirectoryArrowLeft);
	
	var _subdirectoryArrowRight = __webpack_require__(2631);
	
	var _subdirectoryArrowRight2 = _interopRequireDefault(_subdirectoryArrowRight);
	
	var _unfoldLess = __webpack_require__(2632);
	
	var _unfoldLess2 = _interopRequireDefault(_unfoldLess);
	
	var _unfoldMore = __webpack_require__(2633);
	
	var _unfoldMore2 = _interopRequireDefault(_unfoldMore);
	
	var _navigationArrowDropRight = __webpack_require__(2614);
	
	var _navigationArrowDropRight2 = _interopRequireDefault(_navigationArrowDropRight);
	
	var _adb = __webpack_require__(2634);
	
	var _adb2 = _interopRequireDefault(_adb);
	
	var _airlineSeatFlatAngled = __webpack_require__(2635);
	
	var _airlineSeatFlatAngled2 = _interopRequireDefault(_airlineSeatFlatAngled);
	
	var _airlineSeatFlat = __webpack_require__(2636);
	
	var _airlineSeatFlat2 = _interopRequireDefault(_airlineSeatFlat);
	
	var _airlineSeatIndividualSuite = __webpack_require__(2637);
	
	var _airlineSeatIndividualSuite2 = _interopRequireDefault(_airlineSeatIndividualSuite);
	
	var _airlineSeatLegroomExtra = __webpack_require__(2638);
	
	var _airlineSeatLegroomExtra2 = _interopRequireDefault(_airlineSeatLegroomExtra);
	
	var _airlineSeatLegroomNormal = __webpack_require__(2639);
	
	var _airlineSeatLegroomNormal2 = _interopRequireDefault(_airlineSeatLegroomNormal);
	
	var _airlineSeatLegroomReduced = __webpack_require__(2640);
	
	var _airlineSeatLegroomReduced2 = _interopRequireDefault(_airlineSeatLegroomReduced);
	
	var _airlineSeatReclineExtra = __webpack_require__(2641);
	
	var _airlineSeatReclineExtra2 = _interopRequireDefault(_airlineSeatReclineExtra);
	
	var _airlineSeatReclineNormal = __webpack_require__(2642);
	
	var _airlineSeatReclineNormal2 = _interopRequireDefault(_airlineSeatReclineNormal);
	
	var _bluetoothAudio = __webpack_require__(2643);
	
	var _bluetoothAudio2 = _interopRequireDefault(_bluetoothAudio);
	
	var _confirmationNumber = __webpack_require__(2644);
	
	var _confirmationNumber2 = _interopRequireDefault(_confirmationNumber);
	
	var _discFull = __webpack_require__(2645);
	
	var _discFull2 = _interopRequireDefault(_discFull);
	
	var _doNotDisturbAlt = __webpack_require__(2646);
	
	var _doNotDisturbAlt2 = _interopRequireDefault(_doNotDisturbAlt);
	
	var _doNotDisturbOff = __webpack_require__(2647);
	
	var _doNotDisturbOff2 = _interopRequireDefault(_doNotDisturbOff);
	
	var _doNotDisturbOn = __webpack_require__(2648);
	
	var _doNotDisturbOn2 = _interopRequireDefault(_doNotDisturbOn);
	
	var _doNotDisturb = __webpack_require__(2649);
	
	var _doNotDisturb2 = _interopRequireDefault(_doNotDisturb);
	
	var _driveEta = __webpack_require__(2650);
	
	var _driveEta2 = _interopRequireDefault(_driveEta);
	
	var _enhancedEncryption = __webpack_require__(2651);
	
	var _enhancedEncryption2 = _interopRequireDefault(_enhancedEncryption);
	
	var _eventAvailable = __webpack_require__(2652);
	
	var _eventAvailable2 = _interopRequireDefault(_eventAvailable);
	
	var _eventBusy = __webpack_require__(2653);
	
	var _eventBusy2 = _interopRequireDefault(_eventBusy);
	
	var _eventNote = __webpack_require__(2654);
	
	var _eventNote2 = _interopRequireDefault(_eventNote);
	
	var _folderSpecial = __webpack_require__(2655);
	
	var _folderSpecial2 = _interopRequireDefault(_folderSpecial);
	
	var _liveTv = __webpack_require__(2656);
	
	var _liveTv2 = _interopRequireDefault(_liveTv);
	
	var _mms = __webpack_require__(2657);
	
	var _mms2 = _interopRequireDefault(_mms);
	
	var _more = __webpack_require__(2658);
	
	var _more2 = _interopRequireDefault(_more);
	
	var _networkCheck = __webpack_require__(2659);
	
	var _networkCheck2 = _interopRequireDefault(_networkCheck);
	
	var _networkLocked = __webpack_require__(2660);
	
	var _networkLocked2 = _interopRequireDefault(_networkLocked);
	
	var _noEncryption = __webpack_require__(2661);
	
	var _noEncryption2 = _interopRequireDefault(_noEncryption);
	
	var _ondemandVideo = __webpack_require__(2662);
	
	var _ondemandVideo2 = _interopRequireDefault(_ondemandVideo);
	
	var _personalVideo = __webpack_require__(2663);
	
	var _personalVideo2 = _interopRequireDefault(_personalVideo);
	
	var _phoneBluetoothSpeaker = __webpack_require__(2664);
	
	var _phoneBluetoothSpeaker2 = _interopRequireDefault(_phoneBluetoothSpeaker);
	
	var _phoneForwarded = __webpack_require__(2665);
	
	var _phoneForwarded2 = _interopRequireDefault(_phoneForwarded);
	
	var _phoneInTalk = __webpack_require__(2666);
	
	var _phoneInTalk2 = _interopRequireDefault(_phoneInTalk);
	
	var _phoneLocked = __webpack_require__(2667);
	
	var _phoneLocked2 = _interopRequireDefault(_phoneLocked);
	
	var _phoneMissed = __webpack_require__(2668);
	
	var _phoneMissed2 = _interopRequireDefault(_phoneMissed);
	
	var _phonePaused = __webpack_require__(2669);
	
	var _phonePaused2 = _interopRequireDefault(_phonePaused);
	
	var _power = __webpack_require__(2670);
	
	var _power2 = _interopRequireDefault(_power);
	
	var _priorityHigh = __webpack_require__(2671);
	
	var _priorityHigh2 = _interopRequireDefault(_priorityHigh);
	
	var _rvHookup = __webpack_require__(2672);
	
	var _rvHookup2 = _interopRequireDefault(_rvHookup);
	
	var _sdCard = __webpack_require__(2673);
	
	var _sdCard2 = _interopRequireDefault(_sdCard);
	
	var _simCardAlert = __webpack_require__(2674);
	
	var _simCardAlert2 = _interopRequireDefault(_simCardAlert);
	
	var _smsFailed = __webpack_require__(2675);
	
	var _smsFailed2 = _interopRequireDefault(_smsFailed);
	
	var _sms = __webpack_require__(2676);
	
	var _sms2 = _interopRequireDefault(_sms);
	
	var _syncDisabled = __webpack_require__(2677);
	
	var _syncDisabled2 = _interopRequireDefault(_syncDisabled);
	
	var _syncProblem = __webpack_require__(2678);
	
	var _syncProblem2 = _interopRequireDefault(_syncProblem);
	
	var _sync = __webpack_require__(2679);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _systemUpdate = __webpack_require__(2680);
	
	var _systemUpdate2 = _interopRequireDefault(_systemUpdate);
	
	var _tapAndPlay = __webpack_require__(2681);
	
	var _tapAndPlay2 = _interopRequireDefault(_tapAndPlay);
	
	var _timeToLeave = __webpack_require__(2682);
	
	var _timeToLeave2 = _interopRequireDefault(_timeToLeave);
	
	var _vibration = __webpack_require__(2683);
	
	var _vibration2 = _interopRequireDefault(_vibration);
	
	var _voiceChat = __webpack_require__(2684);
	
	var _voiceChat2 = _interopRequireDefault(_voiceChat);
	
	var _vpnLock = __webpack_require__(2685);
	
	var _vpnLock2 = _interopRequireDefault(_vpnLock);
	
	var _wc = __webpack_require__(2686);
	
	var _wc2 = _interopRequireDefault(_wc);
	
	var _wifi = __webpack_require__(2687);
	
	var _wifi2 = _interopRequireDefault(_wifi);
	
	var _acUnit = __webpack_require__(2688);
	
	var _acUnit2 = _interopRequireDefault(_acUnit);
	
	var _airportShuttle = __webpack_require__(2689);
	
	var _airportShuttle2 = _interopRequireDefault(_airportShuttle);
	
	var _allInclusive = __webpack_require__(2690);
	
	var _allInclusive2 = _interopRequireDefault(_allInclusive);
	
	var _beachAccess = __webpack_require__(2691);
	
	var _beachAccess2 = _interopRequireDefault(_beachAccess);
	
	var _businessCenter = __webpack_require__(2692);
	
	var _businessCenter2 = _interopRequireDefault(_businessCenter);
	
	var _casino = __webpack_require__(2693);
	
	var _casino2 = _interopRequireDefault(_casino);
	
	var _childCare = __webpack_require__(2694);
	
	var _childCare2 = _interopRequireDefault(_childCare);
	
	var _childFriendly = __webpack_require__(2695);
	
	var _childFriendly2 = _interopRequireDefault(_childFriendly);
	
	var _fitnessCenter = __webpack_require__(2696);
	
	var _fitnessCenter2 = _interopRequireDefault(_fitnessCenter);
	
	var _freeBreakfast = __webpack_require__(2697);
	
	var _freeBreakfast2 = _interopRequireDefault(_freeBreakfast);
	
	var _golfCourse = __webpack_require__(2698);
	
	var _golfCourse2 = _interopRequireDefault(_golfCourse);
	
	var _hotTub = __webpack_require__(2699);
	
	var _hotTub2 = _interopRequireDefault(_hotTub);
	
	var _kitchen = __webpack_require__(2700);
	
	var _kitchen2 = _interopRequireDefault(_kitchen);
	
	var _pool = __webpack_require__(2701);
	
	var _pool2 = _interopRequireDefault(_pool);
	
	var _roomService = __webpack_require__(2702);
	
	var _roomService2 = _interopRequireDefault(_roomService);
	
	var _rvHookup3 = __webpack_require__(2703);
	
	var _rvHookup4 = _interopRequireDefault(_rvHookup3);
	
	var _smokeFree = __webpack_require__(2704);
	
	var _smokeFree2 = _interopRequireDefault(_smokeFree);
	
	var _smokingRooms = __webpack_require__(2705);
	
	var _smokingRooms2 = _interopRequireDefault(_smokingRooms);
	
	var _spa = __webpack_require__(2706);
	
	var _spa2 = _interopRequireDefault(_spa);
	
	var _cake = __webpack_require__(2707);
	
	var _cake2 = _interopRequireDefault(_cake);
	
	var _domain = __webpack_require__(2708);
	
	var _domain2 = _interopRequireDefault(_domain);
	
	var _groupAdd = __webpack_require__(2709);
	
	var _groupAdd2 = _interopRequireDefault(_groupAdd);
	
	var _group = __webpack_require__(2710);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _locationCity = __webpack_require__(2711);
	
	var _locationCity2 = _interopRequireDefault(_locationCity);
	
	var _moodBad = __webpack_require__(2712);
	
	var _moodBad2 = _interopRequireDefault(_moodBad);
	
	var _mood = __webpack_require__(2713);
	
	var _mood2 = _interopRequireDefault(_mood);
	
	var _notificationsActive = __webpack_require__(2714);
	
	var _notificationsActive2 = _interopRequireDefault(_notificationsActive);
	
	var _notificationsNone = __webpack_require__(2715);
	
	var _notificationsNone2 = _interopRequireDefault(_notificationsNone);
	
	var _notificationsOff = __webpack_require__(2716);
	
	var _notificationsOff2 = _interopRequireDefault(_notificationsOff);
	
	var _notificationsPaused = __webpack_require__(2717);
	
	var _notificationsPaused2 = _interopRequireDefault(_notificationsPaused);
	
	var _notifications = __webpack_require__(2718);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _pages = __webpack_require__(2719);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _partyMode = __webpack_require__(2720);
	
	var _partyMode2 = _interopRequireDefault(_partyMode);
	
	var _peopleOutline = __webpack_require__(2721);
	
	var _peopleOutline2 = _interopRequireDefault(_peopleOutline);
	
	var _people = __webpack_require__(2722);
	
	var _people2 = _interopRequireDefault(_people);
	
	var _personAdd = __webpack_require__(2723);
	
	var _personAdd2 = _interopRequireDefault(_personAdd);
	
	var _personOutline = __webpack_require__(2724);
	
	var _personOutline2 = _interopRequireDefault(_personOutline);
	
	var _person = __webpack_require__(2725);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _plusOne = __webpack_require__(2726);
	
	var _plusOne2 = _interopRequireDefault(_plusOne);
	
	var _poll = __webpack_require__(2727);
	
	var _poll2 = _interopRequireDefault(_poll);
	
	var _public = __webpack_require__(2728);
	
	var _public2 = _interopRequireDefault(_public);
	
	var _school = __webpack_require__(2729);
	
	var _school2 = _interopRequireDefault(_school);
	
	var _sentimentDissatisfied = __webpack_require__(2730);
	
	var _sentimentDissatisfied2 = _interopRequireDefault(_sentimentDissatisfied);
	
	var _sentimentNeutral = __webpack_require__(2731);
	
	var _sentimentNeutral2 = _interopRequireDefault(_sentimentNeutral);
	
	var _sentimentSatisfied = __webpack_require__(2732);
	
	var _sentimentSatisfied2 = _interopRequireDefault(_sentimentSatisfied);
	
	var _sentimentVeryDissatisfied = __webpack_require__(2733);
	
	var _sentimentVeryDissatisfied2 = _interopRequireDefault(_sentimentVeryDissatisfied);
	
	var _sentimentVerySatisfied = __webpack_require__(2734);
	
	var _sentimentVerySatisfied2 = _interopRequireDefault(_sentimentVerySatisfied);
	
	var _share = __webpack_require__(2735);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _whatshot = __webpack_require__(2736);
	
	var _whatshot2 = _interopRequireDefault(_whatshot);
	
	var _checkBoxOutlineBlank = __webpack_require__(629);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(630);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	var _indeterminateCheckBox = __webpack_require__(2737);
	
	var _indeterminateCheckBox2 = _interopRequireDefault(_indeterminateCheckBox);
	
	var _radioButtonChecked = __webpack_require__(631);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	var _radioButtonUnchecked = __webpack_require__(632);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _starBorder = __webpack_require__(2738);
	
	var _starBorder2 = _interopRequireDefault(_starBorder);
	
	var _starHalf = __webpack_require__(2739);
	
	var _starHalf2 = _interopRequireDefault(_starHalf);
	
	var _star = __webpack_require__(2740);
	
	var _star2 = _interopRequireDefault(_star);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ActionAccessibility = _accessibility2.default;
	exports.ActionAccessible = _accessible2.default;
	exports.ActionAccountBalanceWallet = _accountBalanceWallet2.default;
	exports.ActionAccountBalance = _accountBalance2.default;
	exports.ActionAccountBox = _accountBox2.default;
	exports.ActionAccountCircle = _accountCircle2.default;
	exports.ActionAddShoppingCart = _addShoppingCart2.default;
	exports.ActionAlarmAdd = _alarmAdd2.default;
	exports.ActionAlarmOff = _alarmOff2.default;
	exports.ActionAlarmOn = _alarmOn2.default;
	exports.ActionAlarm = _alarm2.default;
	exports.ActionAllOut = _allOut2.default;
	exports.ActionAndroid = _android2.default;
	exports.ActionAnnouncement = _announcement2.default;
	exports.ActionAspectRatio = _aspectRatio2.default;
	exports.ActionAssessment = _assessment2.default;
	exports.ActionAssignmentInd = _assignmentInd2.default;
	exports.ActionAssignmentLate = _assignmentLate2.default;
	exports.ActionAssignmentReturn = _assignmentReturn2.default;
	exports.ActionAssignmentReturned = _assignmentReturned2.default;
	exports.ActionAssignmentTurnedIn = _assignmentTurnedIn2.default;
	exports.ActionAssignment = _assignment2.default;
	exports.ActionAutorenew = _autorenew2.default;
	exports.ActionBackup = _backup2.default;
	exports.ActionBook = _book2.default;
	exports.ActionBookmarkBorder = _bookmarkBorder2.default;
	exports.ActionBookmark = _bookmark2.default;
	exports.ActionBugReport = _bugReport2.default;
	exports.ActionBuild = _build2.default;
	exports.ActionCached = _cached2.default;
	exports.ActionCameraEnhance = _cameraEnhance2.default;
	exports.ActionCardGiftcard = _cardGiftcard2.default;
	exports.ActionCardMembership = _cardMembership2.default;
	exports.ActionCardTravel = _cardTravel2.default;
	exports.ActionChangeHistory = _changeHistory2.default;
	exports.ActionCheckCircle = _checkCircle2.default;
	exports.ActionChromeReaderMode = _chromeReaderMode2.default;
	exports.ActionClass = _class2.default;
	exports.ActionCode = _code2.default;
	exports.ActionCompareArrows = _compareArrows2.default;
	exports.ActionCopyright = _copyright2.default;
	exports.ActionCreditCard = _creditCard2.default;
	exports.ActionDashboard = _dashboard2.default;
	exports.ActionDateRange = _dateRange2.default;
	exports.ActionDeleteForever = _deleteForever2.default;
	exports.ActionDelete = _delete2.default;
	exports.ActionDescription = _description2.default;
	exports.ActionDns = _dns2.default;
	exports.ActionDoneAll = _doneAll2.default;
	exports.ActionDone = _done2.default;
	exports.ActionDonutLarge = _donutLarge2.default;
	exports.ActionDonutSmall = _donutSmall2.default;
	exports.ActionEject = _eject2.default;
	exports.ActionEuroSymbol = _euroSymbol2.default;
	exports.ActionEventSeat = _eventSeat2.default;
	exports.ActionEvent = _event2.default;
	exports.ActionExitToApp = _exitToApp2.default;
	exports.ActionExplore = _explore2.default;
	exports.ActionExtension = _extension2.default;
	exports.ActionFace = _face2.default;
	exports.ActionFavoriteBorder = _favoriteBorder2.default;
	exports.ActionFavorite = _favorite2.default;
	exports.ActionFeedback = _feedback2.default;
	exports.ActionFindInPage = _findInPage2.default;
	exports.ActionFindReplace = _findReplace2.default;
	exports.ActionFingerprint = _fingerprint2.default;
	exports.ActionFlightLand = _flightLand2.default;
	exports.ActionFlightTakeoff = _flightTakeoff2.default;
	exports.ActionFlipToBack = _flipToBack2.default;
	exports.ActionFlipToFront = _flipToFront2.default;
	exports.ActionGTranslate = _gTranslate2.default;
	exports.ActionGavel = _gavel2.default;
	exports.ActionGetApp = _getApp2.default;
	exports.ActionGif = _gif2.default;
	exports.ActionGrade = _grade2.default;
	exports.ActionGroupWork = _groupWork2.default;
	exports.ActionHelpOutline = _helpOutline2.default;
	exports.ActionHelp = _help2.default;
	exports.ActionHighlightOff = _highlightOff2.default;
	exports.ActionHistory = _history2.default;
	exports.ActionHome = _home2.default;
	exports.ActionHourglassEmpty = _hourglassEmpty2.default;
	exports.ActionHourglassFull = _hourglassFull2.default;
	exports.ActionHttp = _http2.default;
	exports.ActionHttps = _https2.default;
	exports.ActionImportantDevices = _importantDevices2.default;
	exports.ActionInfoOutline = _infoOutline2.default;
	exports.ActionInfo = _info2.default;
	exports.ActionInput = _input2.default;
	exports.ActionInvertColors = _invertColors2.default;
	exports.ActionLabelOutline = _labelOutline2.default;
	exports.ActionLabel = _label2.default;
	exports.ActionLanguage = _language2.default;
	exports.ActionLaunch = _launch2.default;
	exports.ActionLightbulbOutline = _lightbulbOutline2.default;
	exports.ActionLineStyle = _lineStyle2.default;
	exports.ActionLineWeight = _lineWeight2.default;
	exports.ActionList = _list2.default;
	exports.ActionLockOpen = _lockOpen2.default;
	exports.ActionLockOutline = _lockOutline2.default;
	exports.ActionLock = _lock2.default;
	exports.ActionLoyalty = _loyalty2.default;
	exports.ActionMarkunreadMailbox = _markunreadMailbox2.default;
	exports.ActionMotorcycle = _motorcycle2.default;
	exports.ActionNoteAdd = _noteAdd2.default;
	exports.ActionOfflinePin = _offlinePin2.default;
	exports.ActionOpacity = _opacity2.default;
	exports.ActionOpenInBrowser = _openInBrowser2.default;
	exports.ActionOpenInNew = _openInNew2.default;
	exports.ActionOpenWith = _openWith2.default;
	exports.ActionPageview = _pageview2.default;
	exports.ActionPanTool = _panTool2.default;
	exports.ActionPayment = _payment2.default;
	exports.ActionPermCameraMic = _permCameraMic2.default;
	exports.ActionPermContactCalendar = _permContactCalendar2.default;
	exports.ActionPermDataSetting = _permDataSetting2.default;
	exports.ActionPermDeviceInformation = _permDeviceInformation2.default;
	exports.ActionPermIdentity = _permIdentity2.default;
	exports.ActionPermMedia = _permMedia2.default;
	exports.ActionPermPhoneMsg = _permPhoneMsg2.default;
	exports.ActionPermScanWifi = _permScanWifi2.default;
	exports.ActionPets = _pets2.default;
	exports.ActionPictureInPictureAlt = _pictureInPictureAlt2.default;
	exports.ActionPictureInPicture = _pictureInPicture2.default;
	exports.ActionPlayForWork = _playForWork2.default;
	exports.ActionPolymer = _polymer2.default;
	exports.ActionPowerSettingsNew = _powerSettingsNew2.default;
	exports.ActionPregnantWoman = _pregnantWoman2.default;
	exports.ActionPrint = _print2.default;
	exports.ActionQueryBuilder = _queryBuilder2.default;
	exports.ActionQuestionAnswer = _questionAnswer2.default;
	exports.ActionReceipt = _receipt2.default;
	exports.ActionRecordVoiceOver = _recordVoiceOver2.default;
	exports.ActionRedeem = _redeem2.default;
	exports.ActionRemoveShoppingCart = _removeShoppingCart2.default;
	exports.ActionReorder = _reorder2.default;
	exports.ActionReportProblem = _reportProblem2.default;
	exports.ActionRestorePage = _restorePage2.default;
	exports.ActionRestore = _restore2.default;
	exports.ActionRoom = _room2.default;
	exports.ActionRoundedCorner = _roundedCorner2.default;
	exports.ActionRowing = _rowing2.default;
	exports.ActionSchedule = _schedule2.default;
	exports.ActionSearch = _search2.default;
	exports.ActionSettingsApplications = _settingsApplications2.default;
	exports.ActionSettingsBackupRestore = _settingsBackupRestore2.default;
	exports.ActionSettingsBluetooth = _settingsBluetooth2.default;
	exports.ActionSettingsBrightness = _settingsBrightness2.default;
	exports.ActionSettingsCell = _settingsCell2.default;
	exports.ActionSettingsEthernet = _settingsEthernet2.default;
	exports.ActionSettingsInputAntenna = _settingsInputAntenna2.default;
	exports.ActionSettingsInputComponent = _settingsInputComponent2.default;
	exports.ActionSettingsInputComposite = _settingsInputComposite2.default;
	exports.ActionSettingsInputHdmi = _settingsInputHdmi2.default;
	exports.ActionSettingsInputSvideo = _settingsInputSvideo2.default;
	exports.ActionSettingsOverscan = _settingsOverscan2.default;
	exports.ActionSettingsPhone = _settingsPhone2.default;
	exports.ActionSettingsPower = _settingsPower2.default;
	exports.ActionSettingsRemote = _settingsRemote2.default;
	exports.ActionSettingsVoice = _settingsVoice2.default;
	exports.ActionSettings = _settings2.default;
	exports.ActionShopTwo = _shopTwo2.default;
	exports.ActionShop = _shop2.default;
	exports.ActionShoppingBasket = _shoppingBasket2.default;
	exports.ActionShoppingCart = _shoppingCart2.default;
	exports.ActionSpeakerNotesOff = _speakerNotesOff2.default;
	exports.ActionSpeakerNotes = _speakerNotes2.default;
	exports.ActionSpellcheck = _spellcheck2.default;
	exports.ActionStars = _stars2.default;
	exports.ActionStore = _store2.default;
	exports.ActionSubject = _subject2.default;
	exports.ActionSupervisorAccount = _supervisorAccount2.default;
	exports.ActionSwapHoriz = _swapHoriz2.default;
	exports.ActionSwapVert = _swapVert2.default;
	exports.ActionSwapVerticalCircle = _swapVerticalCircle2.default;
	exports.ActionSystemUpdateAlt = _systemUpdateAlt2.default;
	exports.ActionTabUnselected = _tabUnselected2.default;
	exports.ActionTab = _tab2.default;
	exports.ActionTheaters = _theaters2.default;
	exports.ActionThreeDRotation = _threeDRotation2.default;
	exports.ActionThumbDown = _thumbDown2.default;
	exports.ActionThumbUp = _thumbUp2.default;
	exports.ActionThumbsUpDown = _thumbsUpDown2.default;
	exports.ActionTimeline = _timeline2.default;
	exports.ActionToc = _toc2.default;
	exports.ActionToday = _today2.default;
	exports.ActionToll = _toll2.default;
	exports.ActionTouchApp = _touchApp2.default;
	exports.ActionTrackChanges = _trackChanges2.default;
	exports.ActionTranslate = _translate2.default;
	exports.ActionTrendingDown = _trendingDown2.default;
	exports.ActionTrendingFlat = _trendingFlat2.default;
	exports.ActionTrendingUp = _trendingUp2.default;
	exports.ActionTurnedInNot = _turnedInNot2.default;
	exports.ActionTurnedIn = _turnedIn2.default;
	exports.ActionUpdate = _update2.default;
	exports.ActionVerifiedUser = _verifiedUser2.default;
	exports.ActionViewAgenda = _viewAgenda2.default;
	exports.ActionViewArray = _viewArray2.default;
	exports.ActionViewCarousel = _viewCarousel2.default;
	exports.ActionViewColumn = _viewColumn2.default;
	exports.ActionViewDay = _viewDay2.default;
	exports.ActionViewHeadline = _viewHeadline2.default;
	exports.ActionViewList = _viewList2.default;
	exports.ActionViewModule = _viewModule2.default;
	exports.ActionViewQuilt = _viewQuilt2.default;
	exports.ActionViewStream = _viewStream2.default;
	exports.ActionViewWeek = _viewWeek2.default;
	exports.ActionVisibilityOff = _visibilityOff2.default;
	exports.ActionVisibility = _visibility2.default;
	exports.ActionWatchLater = _watchLater2.default;
	exports.ActionWork = _work2.default;
	exports.ActionYoutubeSearchedFor = _youtubeSearchedFor2.default;
	exports.ActionZoomIn = _zoomIn2.default;
	exports.ActionZoomOut = _zoomOut2.default;
	exports.AlertAddAlert = _addAlert2.default;
	exports.AlertErrorOutline = _errorOutline2.default;
	exports.AlertError = _error2.default;
	exports.AlertWarning = _warning2.default;
	exports.AvAddToQueue = _addToQueue2.default;
	exports.AvAirplay = _airplay2.default;
	exports.AvAlbum = _album2.default;
	exports.AvArtTrack = _artTrack2.default;
	exports.AvAvTimer = _avTimer2.default;
	exports.AvBrandingWatermark = _brandingWatermark2.default;
	exports.AvCallToAction = _callToAction2.default;
	exports.AvClosedCaption = _closedCaption2.default;
	exports.AvEqualizer = _equalizer2.default;
	exports.AvExplicit = _explicit2.default;
	exports.AvFastForward = _fastForward2.default;
	exports.AvFastRewind = _fastRewind2.default;
	exports.AvFeaturedPlayList = _featuredPlayList2.default;
	exports.AvFeaturedVideo = _featuredVideo2.default;
	exports.AvFiberDvr = _fiberDvr2.default;
	exports.AvFiberManualRecord = _fiberManualRecord2.default;
	exports.AvFiberNew = _fiberNew2.default;
	exports.AvFiberPin = _fiberPin2.default;
	exports.AvFiberSmartRecord = _fiberSmartRecord2.default;
	exports.AvForward10 = _forward2.default;
	exports.AvForward30 = _forward4.default;
	exports.AvForward5 = _forward6.default;
	exports.AvGames = _games2.default;
	exports.AvHd = _hd2.default;
	exports.AvHearing = _hearing2.default;
	exports.AvHighQuality = _highQuality2.default;
	exports.AvLibraryAdd = _libraryAdd2.default;
	exports.AvLibraryBooks = _libraryBooks2.default;
	exports.AvLibraryMusic = _libraryMusic2.default;
	exports.AvLoop = _loop2.default;
	exports.AvMicNone = _micNone2.default;
	exports.AvMicOff = _micOff2.default;
	exports.AvMic = _mic2.default;
	exports.AvMovie = _movie2.default;
	exports.AvMusicVideo = _musicVideo2.default;
	exports.AvNewReleases = _newReleases2.default;
	exports.AvNotInterested = _notInterested2.default;
	exports.AvNote = _note2.default;
	exports.AvPauseCircleFilled = _pauseCircleFilled2.default;
	exports.AvPauseCircleOutline = _pauseCircleOutline2.default;
	exports.AvPause = _pause2.default;
	exports.AvPlayArrow = _playArrow2.default;
	exports.AvPlayCircleFilled = _playCircleFilled2.default;
	exports.AvPlayCircleOutline = _playCircleOutline2.default;
	exports.AvPlaylistAddCheck = _playlistAddCheck2.default;
	exports.AvPlaylistAdd = _playlistAdd2.default;
	exports.AvPlaylistPlay = _playlistPlay2.default;
	exports.AvQueueMusic = _queueMusic2.default;
	exports.AvQueuePlayNext = _queuePlayNext2.default;
	exports.AvQueue = _queue2.default;
	exports.AvRadio = _radio2.default;
	exports.AvRecentActors = _recentActors2.default;
	exports.AvRemoveFromQueue = _removeFromQueue2.default;
	exports.AvRepeatOne = _repeatOne2.default;
	exports.AvRepeat = _repeat2.default;
	exports.AvReplay10 = _replay2.default;
	exports.AvReplay30 = _replay4.default;
	exports.AvReplay5 = _replay6.default;
	exports.AvReplay = _replay8.default;
	exports.AvShuffle = _shuffle2.default;
	exports.AvSkipNext = _skipNext2.default;
	exports.AvSkipPrevious = _skipPrevious2.default;
	exports.AvSlowMotionVideo = _slowMotionVideo2.default;
	exports.AvSnooze = _snooze2.default;
	exports.AvSortByAlpha = _sortByAlpha2.default;
	exports.AvStop = _stop2.default;
	exports.AvSubscriptions = _subscriptions2.default;
	exports.AvSubtitles = _subtitles2.default;
	exports.AvSurroundSound = _surroundSound2.default;
	exports.AvVideoCall = _videoCall2.default;
	exports.AvVideoLabel = _videoLabel2.default;
	exports.AvVideoLibrary = _videoLibrary2.default;
	exports.AvVideocamOff = _videocamOff2.default;
	exports.AvVideocam = _videocam2.default;
	exports.AvVolumeDown = _volumeDown2.default;
	exports.AvVolumeMute = _volumeMute2.default;
	exports.AvVolumeOff = _volumeOff2.default;
	exports.AvVolumeUp = _volumeUp2.default;
	exports.AvWebAsset = _webAsset2.default;
	exports.AvWeb = _web2.default;
	exports.CommunicationBusiness = _business2.default;
	exports.CommunicationCallEnd = _callEnd2.default;
	exports.CommunicationCallMade = _callMade2.default;
	exports.CommunicationCallMerge = _callMerge2.default;
	exports.CommunicationCallMissedOutgoing = _callMissedOutgoing2.default;
	exports.CommunicationCallMissed = _callMissed2.default;
	exports.CommunicationCallReceived = _callReceived2.default;
	exports.CommunicationCallSplit = _callSplit2.default;
	exports.CommunicationCall = _call2.default;
	exports.CommunicationChatBubbleOutline = _chatBubbleOutline2.default;
	exports.CommunicationChatBubble = _chatBubble2.default;
	exports.CommunicationChat = _chat2.default;
	exports.CommunicationClearAll = _clearAll2.default;
	exports.CommunicationComment = _comment2.default;
	exports.CommunicationContactMail = _contactMail2.default;
	exports.CommunicationContactPhone = _contactPhone2.default;
	exports.CommunicationContacts = _contacts2.default;
	exports.CommunicationDialerSip = _dialerSip2.default;
	exports.CommunicationDialpad = _dialpad2.default;
	exports.CommunicationEmail = _email2.default;
	exports.CommunicationForum = _forum2.default;
	exports.CommunicationImportContacts = _importContacts2.default;
	exports.CommunicationImportExport = _importExport2.default;
	exports.CommunicationInvertColorsOff = _invertColorsOff2.default;
	exports.CommunicationLiveHelp = _liveHelp2.default;
	exports.CommunicationLocationOff = _locationOff2.default;
	exports.CommunicationLocationOn = _locationOn2.default;
	exports.CommunicationMailOutline = _mailOutline2.default;
	exports.CommunicationMessage = _message2.default;
	exports.CommunicationNoSim = _noSim2.default;
	exports.CommunicationPhone = _phone2.default;
	exports.CommunicationPhonelinkErase = _phonelinkErase2.default;
	exports.CommunicationPhonelinkLock = _phonelinkLock2.default;
	exports.CommunicationPhonelinkRing = _phonelinkRing2.default;
	exports.CommunicationPhonelinkSetup = _phonelinkSetup2.default;
	exports.CommunicationPortableWifiOff = _portableWifiOff2.default;
	exports.CommunicationPresentToAll = _presentToAll2.default;
	exports.CommunicationRingVolume = _ringVolume2.default;
	exports.CommunicationRssFeed = _rssFeed2.default;
	exports.CommunicationScreenShare = _screenShare2.default;
	exports.CommunicationSpeakerPhone = _speakerPhone2.default;
	exports.CommunicationStayCurrentLandscape = _stayCurrentLandscape2.default;
	exports.CommunicationStayCurrentPortrait = _stayCurrentPortrait2.default;
	exports.CommunicationStayPrimaryLandscape = _stayPrimaryLandscape2.default;
	exports.CommunicationStayPrimaryPortrait = _stayPrimaryPortrait2.default;
	exports.CommunicationStopScreenShare = _stopScreenShare2.default;
	exports.CommunicationSwapCalls = _swapCalls2.default;
	exports.CommunicationTextsms = _textsms2.default;
	exports.CommunicationVoicemail = _voicemail2.default;
	exports.CommunicationVpnKey = _vpnKey2.default;
	exports.ContentAddBox = _addBox2.default;
	exports.ContentAddCircleOutline = _addCircleOutline2.default;
	exports.ContentAddCircle = _addCircle2.default;
	exports.ContentAdd = _add2.default;
	exports.ContentArchive = _archive2.default;
	exports.ContentBackspace = _backspace2.default;
	exports.ContentBlock = _block2.default;
	exports.ContentClear = _clear2.default;
	exports.ContentContentCopy = _contentCopy2.default;
	exports.ContentContentCut = _contentCut2.default;
	exports.ContentContentPaste = _contentPaste2.default;
	exports.ContentCreate = _create2.default;
	exports.ContentDeleteSweep = _deleteSweep2.default;
	exports.ContentDrafts = _drafts2.default;
	exports.ContentFilterList = _filterList2.default;
	exports.ContentFlag = _flag2.default;
	exports.ContentFontDownload = _fontDownload2.default;
	exports.ContentForward = _forward8.default;
	exports.ContentGesture = _gesture2.default;
	exports.ContentInbox = _inbox2.default;
	exports.ContentLink = _link2.default;
	exports.ContentLowPriority = _lowPriority2.default;
	exports.ContentMail = _mail2.default;
	exports.ContentMarkunread = _markunread2.default;
	exports.ContentMoveToInbox = _moveToInbox2.default;
	exports.ContentNextWeek = _nextWeek2.default;
	exports.ContentRedo = _redo2.default;
	exports.ContentRemoveCircleOutline = _removeCircleOutline2.default;
	exports.ContentRemoveCircle = _removeCircle2.default;
	exports.ContentRemove = _remove2.default;
	exports.ContentReplyAll = _replyAll2.default;
	exports.ContentReply = _reply2.default;
	exports.ContentReport = _report2.default;
	exports.ContentSave = _save2.default;
	exports.ContentSelectAll = _selectAll2.default;
	exports.ContentSend = _send2.default;
	exports.ContentSort = _sort2.default;
	exports.ContentTextFormat = _textFormat2.default;
	exports.ContentUnarchive = _unarchive2.default;
	exports.ContentUndo = _undo2.default;
	exports.ContentWeekend = _weekend2.default;
	exports.DeviceAccessAlarm = _accessAlarm2.default;
	exports.DeviceAccessAlarms = _accessAlarms2.default;
	exports.DeviceAccessTime = _accessTime2.default;
	exports.DeviceAddAlarm = _addAlarm2.default;
	exports.DeviceAirplanemodeActive = _airplanemodeActive2.default;
	exports.DeviceAirplanemodeInactive = _airplanemodeInactive2.default;
	exports.DeviceBattery20 = _battery2.default;
	exports.DeviceBattery30 = _battery4.default;
	exports.DeviceBattery50 = _battery6.default;
	exports.DeviceBattery60 = _battery8.default;
	exports.DeviceBattery80 = _battery10.default;
	exports.DeviceBattery90 = _battery12.default;
	exports.DeviceBatteryAlert = _batteryAlert2.default;
	exports.DeviceBatteryCharging20 = _batteryCharging2.default;
	exports.DeviceBatteryCharging30 = _batteryCharging4.default;
	exports.DeviceBatteryCharging50 = _batteryCharging6.default;
	exports.DeviceBatteryCharging60 = _batteryCharging8.default;
	exports.DeviceBatteryCharging80 = _batteryCharging10.default;
	exports.DeviceBatteryCharging90 = _batteryCharging12.default;
	exports.DeviceBatteryChargingFull = _batteryChargingFull2.default;
	exports.DeviceBatteryFull = _batteryFull2.default;
	exports.DeviceBatteryStd = _batteryStd2.default;
	exports.DeviceBatteryUnknown = _batteryUnknown2.default;
	exports.DeviceBluetoothConnected = _bluetoothConnected2.default;
	exports.DeviceBluetoothDisabled = _bluetoothDisabled2.default;
	exports.DeviceBluetoothSearching = _bluetoothSearching2.default;
	exports.DeviceBluetooth = _bluetooth2.default;
	exports.DeviceBrightnessAuto = _brightnessAuto2.default;
	exports.DeviceBrightnessHigh = _brightnessHigh2.default;
	exports.DeviceBrightnessLow = _brightnessLow2.default;
	exports.DeviceBrightnessMedium = _brightnessMedium2.default;
	exports.DeviceDataUsage = _dataUsage2.default;
	exports.DeviceDeveloperMode = _developerMode2.default;
	exports.DeviceDevices = _devices2.default;
	exports.DeviceDvr = _dvr2.default;
	exports.DeviceGpsFixed = _gpsFixed2.default;
	exports.DeviceGpsNotFixed = _gpsNotFixed2.default;
	exports.DeviceGpsOff = _gpsOff2.default;
	exports.DeviceGraphicEq = _graphicEq2.default;
	exports.DeviceLocationDisabled = _locationDisabled2.default;
	exports.DeviceLocationSearching = _locationSearching2.default;
	exports.DeviceNetworkCell = _networkCell2.default;
	exports.DeviceNetworkWifi = _networkWifi2.default;
	exports.DeviceNfc = _nfc2.default;
	exports.DeviceScreenLockLandscape = _screenLockLandscape2.default;
	exports.DeviceScreenLockPortrait = _screenLockPortrait2.default;
	exports.DeviceScreenLockRotation = _screenLockRotation2.default;
	exports.DeviceScreenRotation = _screenRotation2.default;
	exports.DeviceSdStorage = _sdStorage2.default;
	exports.DeviceSettingsSystemDaydream = _settingsSystemDaydream2.default;
	exports.DeviceSignalCellular0Bar = _signalCellular0Bar2.default;
	exports.DeviceSignalCellular1Bar = _signalCellular1Bar2.default;
	exports.DeviceSignalCellular2Bar = _signalCellular2Bar2.default;
	exports.DeviceSignalCellular3Bar = _signalCellular3Bar2.default;
	exports.DeviceSignalCellular4Bar = _signalCellular4Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet0Bar = _signalCellularConnectedNoInternet0Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet1Bar = _signalCellularConnectedNoInternet1Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet2Bar = _signalCellularConnectedNoInternet2Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet3Bar = _signalCellularConnectedNoInternet3Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet4Bar = _signalCellularConnectedNoInternet4Bar2.default;
	exports.DeviceSignalCellularNoSim = _signalCellularNoSim2.default;
	exports.DeviceSignalCellularNull = _signalCellularNull2.default;
	exports.DeviceSignalCellularOff = _signalCellularOff2.default;
	exports.DeviceSignalWifi0Bar = _signalWifi0Bar2.default;
	exports.DeviceSignalWifi1BarLock = _signalWifi1BarLock2.default;
	exports.DeviceSignalWifi1Bar = _signalWifi1Bar2.default;
	exports.DeviceSignalWifi2BarLock = _signalWifi2BarLock2.default;
	exports.DeviceSignalWifi2Bar = _signalWifi2Bar2.default;
	exports.DeviceSignalWifi3BarLock = _signalWifi3BarLock2.default;
	exports.DeviceSignalWifi3Bar = _signalWifi3Bar2.default;
	exports.DeviceSignalWifi4BarLock = _signalWifi4BarLock2.default;
	exports.DeviceSignalWifi4Bar = _signalWifi4Bar2.default;
	exports.DeviceSignalWifiOff = _signalWifiOff2.default;
	exports.DeviceStorage = _storage2.default;
	exports.DeviceUsb = _usb2.default;
	exports.DeviceWallpaper = _wallpaper2.default;
	exports.DeviceWidgets = _widgets2.default;
	exports.DeviceWifiLock = _wifiLock2.default;
	exports.DeviceWifiTethering = _wifiTethering2.default;
	exports.EditorAttachFile = _attachFile2.default;
	exports.EditorAttachMoney = _attachMoney2.default;
	exports.EditorBorderAll = _borderAll2.default;
	exports.EditorBorderBottom = _borderBottom2.default;
	exports.EditorBorderClear = _borderClear2.default;
	exports.EditorBorderColor = _borderColor2.default;
	exports.EditorBorderHorizontal = _borderHorizontal2.default;
	exports.EditorBorderInner = _borderInner2.default;
	exports.EditorBorderLeft = _borderLeft2.default;
	exports.EditorBorderOuter = _borderOuter2.default;
	exports.EditorBorderRight = _borderRight2.default;
	exports.EditorBorderStyle = _borderStyle2.default;
	exports.EditorBorderTop = _borderTop2.default;
	exports.EditorBorderVertical = _borderVertical2.default;
	exports.EditorBubbleChart = _bubbleChart2.default;
	exports.EditorDragHandle = _dragHandle2.default;
	exports.EditorFormatAlignCenter = _formatAlignCenter2.default;
	exports.EditorFormatAlignJustify = _formatAlignJustify2.default;
	exports.EditorFormatAlignLeft = _formatAlignLeft2.default;
	exports.EditorFormatAlignRight = _formatAlignRight2.default;
	exports.EditorFormatBold = _formatBold2.default;
	exports.EditorFormatClear = _formatClear2.default;
	exports.EditorFormatColorFill = _formatColorFill2.default;
	exports.EditorFormatColorReset = _formatColorReset2.default;
	exports.EditorFormatColorText = _formatColorText2.default;
	exports.EditorFormatIndentDecrease = _formatIndentDecrease2.default;
	exports.EditorFormatIndentIncrease = _formatIndentIncrease2.default;
	exports.EditorFormatItalic = _formatItalic2.default;
	exports.EditorFormatLineSpacing = _formatLineSpacing2.default;
	exports.EditorFormatListBulleted = _formatListBulleted2.default;
	exports.EditorFormatListNumbered = _formatListNumbered2.default;
	exports.EditorFormatPaint = _formatPaint2.default;
	exports.EditorFormatQuote = _formatQuote2.default;
	exports.EditorFormatShapes = _formatShapes2.default;
	exports.EditorFormatSize = _formatSize2.default;
	exports.EditorFormatStrikethrough = _formatStrikethrough2.default;
	exports.EditorFormatTextdirectionLToR = _formatTextdirectionLToR2.default;
	exports.EditorFormatTextdirectionRToL = _formatTextdirectionRToL2.default;
	exports.EditorFormatUnderlined = _formatUnderlined2.default;
	exports.EditorFunctions = _functions2.default;
	exports.EditorHighlight = _highlight2.default;
	exports.EditorInsertChart = _insertChart2.default;
	exports.EditorInsertComment = _insertComment2.default;
	exports.EditorInsertDriveFile = _insertDriveFile2.default;
	exports.EditorInsertEmoticon = _insertEmoticon2.default;
	exports.EditorInsertInvitation = _insertInvitation2.default;
	exports.EditorInsertLink = _insertLink2.default;
	exports.EditorInsertPhoto = _insertPhoto2.default;
	exports.EditorLinearScale = _linearScale2.default;
	exports.EditorMergeType = _mergeType2.default;
	exports.EditorModeComment = _modeComment2.default;
	exports.EditorModeEdit = _modeEdit2.default;
	exports.EditorMonetizationOn = _monetizationOn2.default;
	exports.EditorMoneyOff = _moneyOff2.default;
	exports.EditorMultilineChart = _multilineChart2.default;
	exports.EditorPieChartOutlined = _pieChartOutlined2.default;
	exports.EditorPieChart = _pieChart2.default;
	exports.EditorPublish = _publish2.default;
	exports.EditorShortText = _shortText2.default;
	exports.EditorShowChart = _showChart2.default;
	exports.EditorSpaceBar = _spaceBar2.default;
	exports.EditorStrikethroughS = _strikethroughS2.default;
	exports.EditorTextFields = _textFields2.default;
	exports.EditorTitle = _title2.default;
	exports.EditorVerticalAlignBottom = _verticalAlignBottom2.default;
	exports.EditorVerticalAlignCenter = _verticalAlignCenter2.default;
	exports.EditorVerticalAlignTop = _verticalAlignTop2.default;
	exports.EditorWrapText = _wrapText2.default;
	exports.FileAttachment = _attachment2.default;
	exports.FileCloudCircle = _cloudCircle2.default;
	exports.FileCloudDone = _cloudDone2.default;
	exports.FileCloudDownload = _cloudDownload2.default;
	exports.FileCloudOff = _cloudOff2.default;
	exports.FileCloudQueue = _cloudQueue2.default;
	exports.FileCloudUpload = _cloudUpload2.default;
	exports.FileCloud = _cloud2.default;
	exports.FileCreateNewFolder = _createNewFolder2.default;
	exports.FileFileDownload = _fileDownload2.default;
	exports.FileFileUpload = _fileUpload2.default;
	exports.FileFolderOpen = _folderOpen2.default;
	exports.FileFolderShared = _folderShared2.default;
	exports.FileFolder = _folder2.default;
	exports.HardwareCastConnected = _castConnected2.default;
	exports.HardwareCast = _cast2.default;
	exports.HardwareComputer = _computer2.default;
	exports.HardwareDesktopMac = _desktopMac2.default;
	exports.HardwareDesktopWindows = _desktopWindows2.default;
	exports.HardwareDeveloperBoard = _developerBoard2.default;
	exports.HardwareDeviceHub = _deviceHub2.default;
	exports.HardwareDevicesOther = _devicesOther2.default;
	exports.HardwareDock = _dock2.default;
	exports.HardwareGamepad = _gamepad2.default;
	exports.HardwareHeadsetMic = _headsetMic2.default;
	exports.HardwareHeadset = _headset2.default;
	exports.HardwareKeyboardArrowDown = _keyboardArrowDown2.default;
	exports.HardwareKeyboardArrowLeft = _keyboardArrowLeft2.default;
	exports.HardwareKeyboardArrowRight = _keyboardArrowRight2.default;
	exports.HardwareKeyboardArrowUp = _keyboardArrowUp2.default;
	exports.HardwareKeyboardBackspace = _keyboardBackspace2.default;
	exports.HardwareKeyboardCapslock = _keyboardCapslock2.default;
	exports.HardwareKeyboardHide = _keyboardHide2.default;
	exports.HardwareKeyboardReturn = _keyboardReturn2.default;
	exports.HardwareKeyboardTab = _keyboardTab2.default;
	exports.HardwareKeyboardVoice = _keyboardVoice2.default;
	exports.HardwareKeyboard = _keyboard2.default;
	exports.HardwareLaptopChromebook = _laptopChromebook2.default;
	exports.HardwareLaptopMac = _laptopMac2.default;
	exports.HardwareLaptopWindows = _laptopWindows2.default;
	exports.HardwareLaptop = _laptop2.default;
	exports.HardwareMemory = _memory2.default;
	exports.HardwareMouse = _mouse2.default;
	exports.HardwarePhoneAndroid = _phoneAndroid2.default;
	exports.HardwarePhoneIphone = _phoneIphone2.default;
	exports.HardwarePhonelinkOff = _phonelinkOff2.default;
	exports.HardwarePhonelink = _phonelink2.default;
	exports.HardwarePowerInput = _powerInput2.default;
	exports.HardwareRouter = _router2.default;
	exports.HardwareScanner = _scanner2.default;
	exports.HardwareSecurity = _security2.default;
	exports.HardwareSimCard = _simCard2.default;
	exports.HardwareSmartphone = _smartphone2.default;
	exports.HardwareSpeakerGroup = _speakerGroup2.default;
	exports.HardwareSpeaker = _speaker2.default;
	exports.HardwareTabletAndroid = _tabletAndroid2.default;
	exports.HardwareTabletMac = _tabletMac2.default;
	exports.HardwareTablet = _tablet2.default;
	exports.HardwareToys = _toys2.default;
	exports.HardwareTv = _tv2.default;
	exports.HardwareVideogameAsset = _videogameAsset2.default;
	exports.HardwareWatch = _watch2.default;
	exports.ImageAddAPhoto = _addAPhoto2.default;
	exports.ImageAddToPhotos = _addToPhotos2.default;
	exports.ImageAdjust = _adjust2.default;
	exports.ImageAssistantPhoto = _assistantPhoto2.default;
	exports.ImageAssistant = _assistant2.default;
	exports.ImageAudiotrack = _audiotrack2.default;
	exports.ImageBlurCircular = _blurCircular2.default;
	exports.ImageBlurLinear = _blurLinear2.default;
	exports.ImageBlurOff = _blurOff2.default;
	exports.ImageBlurOn = _blurOn2.default;
	exports.ImageBrightness1 = _brightness2.default;
	exports.ImageBrightness2 = _brightness4.default;
	exports.ImageBrightness3 = _brightness6.default;
	exports.ImageBrightness4 = _brightness8.default;
	exports.ImageBrightness5 = _brightness10.default;
	exports.ImageBrightness6 = _brightness12.default;
	exports.ImageBrightness7 = _brightness14.default;
	exports.ImageBrokenImage = _brokenImage2.default;
	exports.ImageBrush = _brush2.default;
	exports.ImageBurstMode = _burstMode2.default;
	exports.ImageCameraAlt = _cameraAlt2.default;
	exports.ImageCameraFront = _cameraFront2.default;
	exports.ImageCameraRear = _cameraRear2.default;
	exports.ImageCameraRoll = _cameraRoll2.default;
	exports.ImageCamera = _camera2.default;
	exports.ImageCenterFocusStrong = _centerFocusStrong2.default;
	exports.ImageCenterFocusWeak = _centerFocusWeak2.default;
	exports.ImageCollectionsBookmark = _collectionsBookmark2.default;
	exports.ImageCollections = _collections2.default;
	exports.ImageColorLens = _colorLens2.default;
	exports.ImageColorize = _colorize2.default;
	exports.ImageCompare = _compare2.default;
	exports.ImageControlPointDuplicate = _controlPointDuplicate2.default;
	exports.ImageControlPoint = _controlPoint2.default;
	exports.ImageCrop169 = _crop2.default;
	exports.ImageCrop32 = _crop4.default;
	exports.ImageCrop54 = _crop6.default;
	exports.ImageCrop75 = _crop8.default;
	exports.ImageCropDin = _cropDin2.default;
	exports.ImageCropFree = _cropFree2.default;
	exports.ImageCropLandscape = _cropLandscape2.default;
	exports.ImageCropOriginal = _cropOriginal2.default;
	exports.ImageCropPortrait = _cropPortrait2.default;
	exports.ImageCropRotate = _cropRotate2.default;
	exports.ImageCropSquare = _cropSquare2.default;
	exports.ImageCrop = _crop10.default;
	exports.ImageDehaze = _dehaze2.default;
	exports.ImageDetails = _details2.default;
	exports.ImageEdit = _edit2.default;
	exports.ImageExposureNeg1 = _exposureNeg2.default;
	exports.ImageExposureNeg2 = _exposureNeg4.default;
	exports.ImageExposurePlus1 = _exposurePlus2.default;
	exports.ImageExposurePlus2 = _exposurePlus4.default;
	exports.ImageExposureZero = _exposureZero2.default;
	exports.ImageExposure = _exposure2.default;
	exports.ImageFilter1 = _filter2.default;
	exports.ImageFilter2 = _filter4.default;
	exports.ImageFilter3 = _filter6.default;
	exports.ImageFilter4 = _filter8.default;
	exports.ImageFilter5 = _filter10.default;
	exports.ImageFilter6 = _filter12.default;
	exports.ImageFilter7 = _filter14.default;
	exports.ImageFilter8 = _filter16.default;
	exports.ImageFilter9Plus = _filter9Plus2.default;
	exports.ImageFilter9 = _filter18.default;
	exports.ImageFilterBAndW = _filterBAndW2.default;
	exports.ImageFilterCenterFocus = _filterCenterFocus2.default;
	exports.ImageFilterDrama = _filterDrama2.default;
	exports.ImageFilterFrames = _filterFrames2.default;
	exports.ImageFilterHdr = _filterHdr2.default;
	exports.ImageFilterNone = _filterNone2.default;
	exports.ImageFilterTiltShift = _filterTiltShift2.default;
	exports.ImageFilterVintage = _filterVintage2.default;
	exports.ImageFilter = _filter20.default;
	exports.ImageFlare = _flare2.default;
	exports.ImageFlashAuto = _flashAuto2.default;
	exports.ImageFlashOff = _flashOff2.default;
	exports.ImageFlashOn = _flashOn2.default;
	exports.ImageFlip = _flip2.default;
	exports.ImageGradient = _gradient2.default;
	exports.ImageGrain = _grain2.default;
	exports.ImageGridOff = _gridOff2.default;
	exports.ImageGridOn = _gridOn2.default;
	exports.ImageHdrOff = _hdrOff2.default;
	exports.ImageHdrOn = _hdrOn2.default;
	exports.ImageHdrStrong = _hdrStrong2.default;
	exports.ImageHdrWeak = _hdrWeak2.default;
	exports.ImageHealing = _healing2.default;
	exports.ImageImageAspectRatio = _imageAspectRatio2.default;
	exports.ImageImage = _image2.default;
	exports.ImageIso = _iso2.default;
	exports.ImageLandscape = _landscape2.default;
	exports.ImageLeakAdd = _leakAdd2.default;
	exports.ImageLeakRemove = _leakRemove2.default;
	exports.ImageLens = _lens2.default;
	exports.ImageLinkedCamera = _linkedCamera2.default;
	exports.ImageLooks3 = _looks2.default;
	exports.ImageLooks4 = _looks4.default;
	exports.ImageLooks5 = _looks6.default;
	exports.ImageLooks6 = _looks8.default;
	exports.ImageLooksOne = _looksOne2.default;
	exports.ImageLooksTwo = _looksTwo2.default;
	exports.ImageLooks = _looks10.default;
	exports.ImageLoupe = _loupe2.default;
	exports.ImageMonochromePhotos = _monochromePhotos2.default;
	exports.ImageMovieCreation = _movieCreation2.default;
	exports.ImageMovieFilter = _movieFilter2.default;
	exports.ImageMusicNote = _musicNote2.default;
	exports.ImageNaturePeople = _naturePeople2.default;
	exports.ImageNature = _nature2.default;
	exports.ImageNavigateBefore = _navigateBefore2.default;
	exports.ImageNavigateNext = _navigateNext2.default;
	exports.ImagePalette = _palette2.default;
	exports.ImagePanoramaFishEye = _panoramaFishEye2.default;
	exports.ImagePanoramaHorizontal = _panoramaHorizontal2.default;
	exports.ImagePanoramaVertical = _panoramaVertical2.default;
	exports.ImagePanoramaWideAngle = _panoramaWideAngle2.default;
	exports.ImagePanorama = _panorama2.default;
	exports.ImagePhotoAlbum = _photoAlbum2.default;
	exports.ImagePhotoCamera = _photoCamera2.default;
	exports.ImagePhotoFilter = _photoFilter2.default;
	exports.ImagePhotoLibrary = _photoLibrary2.default;
	exports.ImagePhotoSizeSelectActual = _photoSizeSelectActual2.default;
	exports.ImagePhotoSizeSelectLarge = _photoSizeSelectLarge2.default;
	exports.ImagePhotoSizeSelectSmall = _photoSizeSelectSmall2.default;
	exports.ImagePhoto = _photo2.default;
	exports.ImagePictureAsPdf = _pictureAsPdf2.default;
	exports.ImagePortrait = _portrait2.default;
	exports.ImageRemoveRedEye = _removeRedEye2.default;
	exports.ImageRotate90DegreesCcw = _rotate90DegreesCcw2.default;
	exports.ImageRotateLeft = _rotateLeft2.default;
	exports.ImageRotateRight = _rotateRight2.default;
	exports.ImageSlideshow = _slideshow2.default;
	exports.ImageStraighten = _straighten2.default;
	exports.ImageStyle = _style2.default;
	exports.ImageSwitchCamera = _switchCamera2.default;
	exports.ImageSwitchVideo = _switchVideo2.default;
	exports.ImageTagFaces = _tagFaces2.default;
	exports.ImageTexture = _texture2.default;
	exports.ImageTimelapse = _timelapse2.default;
	exports.ImageTimer10 = _timer2.default;
	exports.ImageTimer3 = _timer4.default;
	exports.ImageTimerOff = _timerOff2.default;
	exports.ImageTimer = _timer6.default;
	exports.ImageTonality = _tonality2.default;
	exports.ImageTransform = _transform2.default;
	exports.ImageTune = _tune2.default;
	exports.ImageViewComfy = _viewComfy2.default;
	exports.ImageViewCompact = _viewCompact2.default;
	exports.ImageVignette = _vignette2.default;
	exports.ImageWbAuto = _wbAuto2.default;
	exports.ImageWbCloudy = _wbCloudy2.default;
	exports.ImageWbIncandescent = _wbIncandescent2.default;
	exports.ImageWbIridescent = _wbIridescent2.default;
	exports.ImageWbSunny = _wbSunny2.default;
	exports.MapsAddLocation = _addLocation2.default;
	exports.MapsBeenhere = _beenhere2.default;
	exports.MapsDirectionsBike = _directionsBike2.default;
	exports.MapsDirectionsBoat = _directionsBoat2.default;
	exports.MapsDirectionsBus = _directionsBus2.default;
	exports.MapsDirectionsCar = _directionsCar2.default;
	exports.MapsDirectionsRailway = _directionsRailway2.default;
	exports.MapsDirectionsRun = _directionsRun2.default;
	exports.MapsDirectionsSubway = _directionsSubway2.default;
	exports.MapsDirectionsTransit = _directionsTransit2.default;
	exports.MapsDirectionsWalk = _directionsWalk2.default;
	exports.MapsDirections = _directions2.default;
	exports.MapsEditLocation = _editLocation2.default;
	exports.MapsEvStation = _evStation2.default;
	exports.MapsFlight = _flight2.default;
	exports.MapsHotel = _hotel2.default;
	exports.MapsLayersClear = _layersClear2.default;
	exports.MapsLayers = _layers2.default;
	exports.MapsLocalActivity = _localActivity2.default;
	exports.MapsLocalAirport = _localAirport2.default;
	exports.MapsLocalAtm = _localAtm2.default;
	exports.MapsLocalBar = _localBar2.default;
	exports.MapsLocalCafe = _localCafe2.default;
	exports.MapsLocalCarWash = _localCarWash2.default;
	exports.MapsLocalConvenienceStore = _localConvenienceStore2.default;
	exports.MapsLocalDining = _localDining2.default;
	exports.MapsLocalDrink = _localDrink2.default;
	exports.MapsLocalFlorist = _localFlorist2.default;
	exports.MapsLocalGasStation = _localGasStation2.default;
	exports.MapsLocalGroceryStore = _localGroceryStore2.default;
	exports.MapsLocalHospital = _localHospital2.default;
	exports.MapsLocalHotel = _localHotel2.default;
	exports.MapsLocalLaundryService = _localLaundryService2.default;
	exports.MapsLocalLibrary = _localLibrary2.default;
	exports.MapsLocalMall = _localMall2.default;
	exports.MapsLocalMovies = _localMovies2.default;
	exports.MapsLocalOffer = _localOffer2.default;
	exports.MapsLocalParking = _localParking2.default;
	exports.MapsLocalPharmacy = _localPharmacy2.default;
	exports.MapsLocalPhone = _localPhone2.default;
	exports.MapsLocalPizza = _localPizza2.default;
	exports.MapsLocalPlay = _localPlay2.default;
	exports.MapsLocalPostOffice = _localPostOffice2.default;
	exports.MapsLocalPrintshop = _localPrintshop2.default;
	exports.MapsLocalSee = _localSee2.default;
	exports.MapsLocalShipping = _localShipping2.default;
	exports.MapsLocalTaxi = _localTaxi2.default;
	exports.MapsMap = _map2.default;
	exports.MapsMyLocation = _myLocation2.default;
	exports.MapsNavigation = _navigation2.default;
	exports.MapsNearMe = _nearMe2.default;
	exports.MapsPersonPinCircle = _personPinCircle2.default;
	exports.MapsPersonPin = _personPin2.default;
	exports.MapsPinDrop = _pinDrop2.default;
	exports.MapsPlace = _place2.default;
	exports.MapsRateReview = _rateReview2.default;
	exports.MapsRestaurantMenu = _restaurantMenu2.default;
	exports.MapsRestaurant = _restaurant2.default;
	exports.MapsSatellite = _satellite2.default;
	exports.MapsStoreMallDirectory = _storeMallDirectory2.default;
	exports.MapsStreetview = _streetview2.default;
	exports.MapsSubway = _subway2.default;
	exports.MapsTerrain = _terrain2.default;
	exports.MapsTraffic = _traffic2.default;
	exports.MapsTrain = _train2.default;
	exports.MapsTram = _tram2.default;
	exports.MapsTransferWithinAStation = _transferWithinAStation2.default;
	exports.MapsZoomOutMap = _zoomOutMap2.default;
	exports.NavigationApps = _apps2.default;
	exports.NavigationArrowBack = _arrowBack2.default;
	exports.NavigationArrowDownward = _arrowDownward2.default;
	exports.NavigationArrowDropDownCircle = _arrowDropDownCircle2.default;
	exports.NavigationArrowDropDown = _arrowDropDown2.default;
	exports.NavigationArrowDropUp = _arrowDropUp2.default;
	exports.NavigationArrowForward = _arrowForward2.default;
	exports.NavigationArrowUpward = _arrowUpward2.default;
	exports.NavigationCancel = _cancel2.default;
	exports.NavigationCheck = _check2.default;
	exports.NavigationChevronLeft = _chevronLeft2.default;
	exports.NavigationChevronRight = _chevronRight2.default;
	exports.NavigationClose = _close2.default;
	exports.NavigationExpandLess = _expandLess2.default;
	exports.NavigationExpandMore = _expandMore2.default;
	exports.NavigationFirstPage = _firstPage2.default;
	exports.NavigationFullscreenExit = _fullscreenExit2.default;
	exports.NavigationFullscreen = _fullscreen2.default;
	exports.NavigationLastPage = _lastPage2.default;
	exports.NavigationMenu = _menu2.default;
	exports.NavigationMoreHoriz = _moreHoriz2.default;
	exports.NavigationMoreVert = _moreVert2.default;
	exports.NavigationRefresh = _refresh2.default;
	exports.NavigationSubdirectoryArrowLeft = _subdirectoryArrowLeft2.default;
	exports.NavigationSubdirectoryArrowRight = _subdirectoryArrowRight2.default;
	exports.NavigationUnfoldLess = _unfoldLess2.default;
	exports.NavigationUnfoldMore = _unfoldMore2.default;
	exports.NavigationArrowDropRight = _navigationArrowDropRight2.default;
	exports.NotificationAdb = _adb2.default;
	exports.NotificationAirlineSeatFlatAngled = _airlineSeatFlatAngled2.default;
	exports.NotificationAirlineSeatFlat = _airlineSeatFlat2.default;
	exports.NotificationAirlineSeatIndividualSuite = _airlineSeatIndividualSuite2.default;
	exports.NotificationAirlineSeatLegroomExtra = _airlineSeatLegroomExtra2.default;
	exports.NotificationAirlineSeatLegroomNormal = _airlineSeatLegroomNormal2.default;
	exports.NotificationAirlineSeatLegroomReduced = _airlineSeatLegroomReduced2.default;
	exports.NotificationAirlineSeatReclineExtra = _airlineSeatReclineExtra2.default;
	exports.NotificationAirlineSeatReclineNormal = _airlineSeatReclineNormal2.default;
	exports.NotificationBluetoothAudio = _bluetoothAudio2.default;
	exports.NotificationConfirmationNumber = _confirmationNumber2.default;
	exports.NotificationDiscFull = _discFull2.default;
	exports.NotificationDoNotDisturbAlt = _doNotDisturbAlt2.default;
	exports.NotificationDoNotDisturbOff = _doNotDisturbOff2.default;
	exports.NotificationDoNotDisturbOn = _doNotDisturbOn2.default;
	exports.NotificationDoNotDisturb = _doNotDisturb2.default;
	exports.NotificationDriveEta = _driveEta2.default;
	exports.NotificationEnhancedEncryption = _enhancedEncryption2.default;
	exports.NotificationEventAvailable = _eventAvailable2.default;
	exports.NotificationEventBusy = _eventBusy2.default;
	exports.NotificationEventNote = _eventNote2.default;
	exports.NotificationFolderSpecial = _folderSpecial2.default;
	exports.NotificationLiveTv = _liveTv2.default;
	exports.NotificationMms = _mms2.default;
	exports.NotificationMore = _more2.default;
	exports.NotificationNetworkCheck = _networkCheck2.default;
	exports.NotificationNetworkLocked = _networkLocked2.default;
	exports.NotificationNoEncryption = _noEncryption2.default;
	exports.NotificationOndemandVideo = _ondemandVideo2.default;
	exports.NotificationPersonalVideo = _personalVideo2.default;
	exports.NotificationPhoneBluetoothSpeaker = _phoneBluetoothSpeaker2.default;
	exports.NotificationPhoneForwarded = _phoneForwarded2.default;
	exports.NotificationPhoneInTalk = _phoneInTalk2.default;
	exports.NotificationPhoneLocked = _phoneLocked2.default;
	exports.NotificationPhoneMissed = _phoneMissed2.default;
	exports.NotificationPhonePaused = _phonePaused2.default;
	exports.NotificationPower = _power2.default;
	exports.NotificationPriorityHigh = _priorityHigh2.default;
	exports.NotificationRvHookup = _rvHookup2.default;
	exports.NotificationSdCard = _sdCard2.default;
	exports.NotificationSimCardAlert = _simCardAlert2.default;
	exports.NotificationSmsFailed = _smsFailed2.default;
	exports.NotificationSms = _sms2.default;
	exports.NotificationSyncDisabled = _syncDisabled2.default;
	exports.NotificationSyncProblem = _syncProblem2.default;
	exports.NotificationSync = _sync2.default;
	exports.NotificationSystemUpdate = _systemUpdate2.default;
	exports.NotificationTapAndPlay = _tapAndPlay2.default;
	exports.NotificationTimeToLeave = _timeToLeave2.default;
	exports.NotificationVibration = _vibration2.default;
	exports.NotificationVoiceChat = _voiceChat2.default;
	exports.NotificationVpnLock = _vpnLock2.default;
	exports.NotificationWc = _wc2.default;
	exports.NotificationWifi = _wifi2.default;
	exports.PlacesAcUnit = _acUnit2.default;
	exports.PlacesAirportShuttle = _airportShuttle2.default;
	exports.PlacesAllInclusive = _allInclusive2.default;
	exports.PlacesBeachAccess = _beachAccess2.default;
	exports.PlacesBusinessCenter = _businessCenter2.default;
	exports.PlacesCasino = _casino2.default;
	exports.PlacesChildCare = _childCare2.default;
	exports.PlacesChildFriendly = _childFriendly2.default;
	exports.PlacesFitnessCenter = _fitnessCenter2.default;
	exports.PlacesFreeBreakfast = _freeBreakfast2.default;
	exports.PlacesGolfCourse = _golfCourse2.default;
	exports.PlacesHotTub = _hotTub2.default;
	exports.PlacesKitchen = _kitchen2.default;
	exports.PlacesPool = _pool2.default;
	exports.PlacesRoomService = _roomService2.default;
	exports.PlacesRvHookup = _rvHookup4.default;
	exports.PlacesSmokeFree = _smokeFree2.default;
	exports.PlacesSmokingRooms = _smokingRooms2.default;
	exports.PlacesSpa = _spa2.default;
	exports.SocialCake = _cake2.default;
	exports.SocialDomain = _domain2.default;
	exports.SocialGroupAdd = _groupAdd2.default;
	exports.SocialGroup = _group2.default;
	exports.SocialLocationCity = _locationCity2.default;
	exports.SocialMoodBad = _moodBad2.default;
	exports.SocialMood = _mood2.default;
	exports.SocialNotificationsActive = _notificationsActive2.default;
	exports.SocialNotificationsNone = _notificationsNone2.default;
	exports.SocialNotificationsOff = _notificationsOff2.default;
	exports.SocialNotificationsPaused = _notificationsPaused2.default;
	exports.SocialNotifications = _notifications2.default;
	exports.SocialPages = _pages2.default;
	exports.SocialPartyMode = _partyMode2.default;
	exports.SocialPeopleOutline = _peopleOutline2.default;
	exports.SocialPeople = _people2.default;
	exports.SocialPersonAdd = _personAdd2.default;
	exports.SocialPersonOutline = _personOutline2.default;
	exports.SocialPerson = _person2.default;
	exports.SocialPlusOne = _plusOne2.default;
	exports.SocialPoll = _poll2.default;
	exports.SocialPublic = _public2.default;
	exports.SocialSchool = _school2.default;
	exports.SocialSentimentDissatisfied = _sentimentDissatisfied2.default;
	exports.SocialSentimentNeutral = _sentimentNeutral2.default;
	exports.SocialSentimentSatisfied = _sentimentSatisfied2.default;
	exports.SocialSentimentVeryDissatisfied = _sentimentVeryDissatisfied2.default;
	exports.SocialSentimentVerySatisfied = _sentimentVerySatisfied2.default;
	exports.SocialShare = _share2.default;
	exports.SocialWhatshot = _whatshot2.default;
	exports.ToggleCheckBoxOutlineBlank = _checkBoxOutlineBlank2.default;
	exports.ToggleCheckBox = _checkBox2.default;
	exports.ToggleIndeterminateCheckBox = _indeterminateCheckBox2.default;
	exports.ToggleRadioButtonChecked = _radioButtonChecked2.default;
	exports.ToggleRadioButtonUnchecked = _radioButtonUnchecked2.default;
	exports.ToggleStarBorder = _starBorder2.default;
	exports.ToggleStarHalf = _starHalf2.default;
	exports.ToggleStar = _star2.default;

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsAddLocation = function MapsAddLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z' })
	  );
	};
	MapsAddLocation = (0, _pure2.default)(MapsAddLocation);
	MapsAddLocation.displayName = 'MapsAddLocation';
	MapsAddLocation.muiName = 'SvgIcon';
	
	exports.default = MapsAddLocation;

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsBeenhere = function MapsBeenhere(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z' })
	  );
	};
	MapsBeenhere = (0, _pure2.default)(MapsBeenhere);
	MapsBeenhere.displayName = 'MapsBeenhere';
	MapsBeenhere.muiName = 'SvgIcon';
	
	exports.default = MapsBeenhere;

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBike = function MapsDirectionsBike(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z' })
	  );
	};
	MapsDirectionsBike = (0, _pure2.default)(MapsDirectionsBike);
	MapsDirectionsBike.displayName = 'MapsDirectionsBike';
	MapsDirectionsBike.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBike;

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBoat = function MapsDirectionsBoat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z' })
	  );
	};
	MapsDirectionsBoat = (0, _pure2.default)(MapsDirectionsBoat);
	MapsDirectionsBoat.displayName = 'MapsDirectionsBoat';
	MapsDirectionsBoat.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBoat;

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBus = function MapsDirectionsBus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z' })
	  );
	};
	MapsDirectionsBus = (0, _pure2.default)(MapsDirectionsBus);
	MapsDirectionsBus.displayName = 'MapsDirectionsBus';
	MapsDirectionsBus.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBus;

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsCar = function MapsDirectionsCar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
	  );
	};
	MapsDirectionsCar = (0, _pure2.default)(MapsDirectionsCar);
	MapsDirectionsCar.displayName = 'MapsDirectionsCar';
	MapsDirectionsCar.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsCar;

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsRailway = function MapsDirectionsRailway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z' })
	  );
	};
	MapsDirectionsRailway = (0, _pure2.default)(MapsDirectionsRailway);
	MapsDirectionsRailway.displayName = 'MapsDirectionsRailway';
	MapsDirectionsRailway.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsRailway;

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsRun = function MapsDirectionsRun(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z' })
	  );
	};
	MapsDirectionsRun = (0, _pure2.default)(MapsDirectionsRun);
	MapsDirectionsRun.displayName = 'MapsDirectionsRun';
	MapsDirectionsRun.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsRun;

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsSubway = function MapsDirectionsSubway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
	  );
	};
	MapsDirectionsSubway = (0, _pure2.default)(MapsDirectionsSubway);
	MapsDirectionsSubway.displayName = 'MapsDirectionsSubway';
	MapsDirectionsSubway.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsSubway;

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsTransit = function MapsDirectionsTransit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
	  );
	};
	MapsDirectionsTransit = (0, _pure2.default)(MapsDirectionsTransit);
	MapsDirectionsTransit.displayName = 'MapsDirectionsTransit';
	MapsDirectionsTransit.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsTransit;

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsWalk = function MapsDirectionsWalk(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7' })
	  );
	};
	MapsDirectionsWalk = (0, _pure2.default)(MapsDirectionsWalk);
	MapsDirectionsWalk.displayName = 'MapsDirectionsWalk';
	MapsDirectionsWalk.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsWalk;

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirections = function MapsDirections(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	MapsDirections = (0, _pure2.default)(MapsDirections);
	MapsDirections.displayName = 'MapsDirections';
	MapsDirections.muiName = 'SvgIcon';
	
	exports.default = MapsDirections;

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsEditLocation = function MapsEditLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z' })
	  );
	};
	MapsEditLocation = (0, _pure2.default)(MapsEditLocation);
	MapsEditLocation.displayName = 'MapsEditLocation';
	MapsEditLocation.muiName = 'SvgIcon';
	
	exports.default = MapsEditLocation;

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsEvStation = function MapsEvStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z' })
	  );
	};
	MapsEvStation = (0, _pure2.default)(MapsEvStation);
	MapsEvStation.displayName = 'MapsEvStation';
	MapsEvStation.muiName = 'SvgIcon';
	
	exports.default = MapsEvStation;

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsFlight = function MapsFlight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.18 9' }),
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	MapsFlight = (0, _pure2.default)(MapsFlight);
	MapsFlight.displayName = 'MapsFlight';
	MapsFlight.muiName = 'SvgIcon';
	
	exports.default = MapsFlight;

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsHotel = function MapsHotel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
	  );
	};
	MapsHotel = (0, _pure2.default)(MapsHotel);
	MapsHotel.displayName = 'MapsHotel';
	MapsHotel.muiName = 'SvgIcon';
	
	exports.default = MapsHotel;

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLayersClear = function MapsLayersClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z' })
	  );
	};
	MapsLayersClear = (0, _pure2.default)(MapsLayersClear);
	MapsLayersClear.displayName = 'MapsLayersClear';
	MapsLayersClear.muiName = 'SvgIcon';
	
	exports.default = MapsLayersClear;

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLayers = function MapsLayers(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' })
	  );
	};
	MapsLayers = (0, _pure2.default)(MapsLayers);
	MapsLayers.displayName = 'MapsLayers';
	MapsLayers.muiName = 'SvgIcon';
	
	exports.default = MapsLayers;

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalActivity = function MapsLocalActivity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
	  );
	};
	MapsLocalActivity = (0, _pure2.default)(MapsLocalActivity);
	MapsLocalActivity.displayName = 'MapsLocalActivity';
	MapsLocalActivity.muiName = 'SvgIcon';
	
	exports.default = MapsLocalActivity;

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalAirport = function MapsLocalAirport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	MapsLocalAirport = (0, _pure2.default)(MapsLocalAirport);
	MapsLocalAirport.displayName = 'MapsLocalAirport';
	MapsLocalAirport.muiName = 'SvgIcon';
	
	exports.default = MapsLocalAirport;

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalAtm = function MapsLocalAtm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z' })
	  );
	};
	MapsLocalAtm = (0, _pure2.default)(MapsLocalAtm);
	MapsLocalAtm.displayName = 'MapsLocalAtm';
	MapsLocalAtm.muiName = 'SvgIcon';
	
	exports.default = MapsLocalAtm;

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalBar = function MapsLocalBar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z' })
	  );
	};
	MapsLocalBar = (0, _pure2.default)(MapsLocalBar);
	MapsLocalBar.displayName = 'MapsLocalBar';
	MapsLocalBar.muiName = 'SvgIcon';
	
	exports.default = MapsLocalBar;

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalCafe = function MapsLocalCafe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z' })
	  );
	};
	MapsLocalCafe = (0, _pure2.default)(MapsLocalCafe);
	MapsLocalCafe.displayName = 'MapsLocalCafe';
	MapsLocalCafe.muiName = 'SvgIcon';
	
	exports.default = MapsLocalCafe;

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalCarWash = function MapsLocalCarWash(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z' })
	  );
	};
	MapsLocalCarWash = (0, _pure2.default)(MapsLocalCarWash);
	MapsLocalCarWash.displayName = 'MapsLocalCarWash';
	MapsLocalCarWash.muiName = 'SvgIcon';
	
	exports.default = MapsLocalCarWash;

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalConvenienceStore = function MapsLocalConvenienceStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z' })
	  );
	};
	MapsLocalConvenienceStore = (0, _pure2.default)(MapsLocalConvenienceStore);
	MapsLocalConvenienceStore.displayName = 'MapsLocalConvenienceStore';
	MapsLocalConvenienceStore.muiName = 'SvgIcon';
	
	exports.default = MapsLocalConvenienceStore;

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalDining = function MapsLocalDining(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
	  );
	};
	MapsLocalDining = (0, _pure2.default)(MapsLocalDining);
	MapsLocalDining.displayName = 'MapsLocalDining';
	MapsLocalDining.muiName = 'SvgIcon';
	
	exports.default = MapsLocalDining;

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalDrink = function MapsLocalDrink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z' })
	  );
	};
	MapsLocalDrink = (0, _pure2.default)(MapsLocalDrink);
	MapsLocalDrink.displayName = 'MapsLocalDrink';
	MapsLocalDrink.muiName = 'SvgIcon';
	
	exports.default = MapsLocalDrink;

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalFlorist = function MapsLocalFlorist(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z' })
	  );
	};
	MapsLocalFlorist = (0, _pure2.default)(MapsLocalFlorist);
	MapsLocalFlorist.displayName = 'MapsLocalFlorist';
	MapsLocalFlorist.muiName = 'SvgIcon';
	
	exports.default = MapsLocalFlorist;

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalGasStation = function MapsLocalGasStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	MapsLocalGasStation = (0, _pure2.default)(MapsLocalGasStation);
	MapsLocalGasStation.displayName = 'MapsLocalGasStation';
	MapsLocalGasStation.muiName = 'SvgIcon';
	
	exports.default = MapsLocalGasStation;

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalGroceryStore = function MapsLocalGroceryStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	MapsLocalGroceryStore = (0, _pure2.default)(MapsLocalGroceryStore);
	MapsLocalGroceryStore.displayName = 'MapsLocalGroceryStore';
	MapsLocalGroceryStore.muiName = 'SvgIcon';
	
	exports.default = MapsLocalGroceryStore;

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalHospital = function MapsLocalHospital(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z' })
	  );
	};
	MapsLocalHospital = (0, _pure2.default)(MapsLocalHospital);
	MapsLocalHospital.displayName = 'MapsLocalHospital';
	MapsLocalHospital.muiName = 'SvgIcon';
	
	exports.default = MapsLocalHospital;

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalHotel = function MapsLocalHotel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
	  );
	};
	MapsLocalHotel = (0, _pure2.default)(MapsLocalHotel);
	MapsLocalHotel.displayName = 'MapsLocalHotel';
	MapsLocalHotel.muiName = 'SvgIcon';
	
	exports.default = MapsLocalHotel;

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalLaundryService = function MapsLocalLaundryService(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	MapsLocalLaundryService = (0, _pure2.default)(MapsLocalLaundryService);
	MapsLocalLaundryService.displayName = 'MapsLocalLaundryService';
	MapsLocalLaundryService.muiName = 'SvgIcon';
	
	exports.default = MapsLocalLaundryService;

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalLibrary = function MapsLocalLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z' })
	  );
	};
	MapsLocalLibrary = (0, _pure2.default)(MapsLocalLibrary);
	MapsLocalLibrary.displayName = 'MapsLocalLibrary';
	MapsLocalLibrary.muiName = 'SvgIcon';
	
	exports.default = MapsLocalLibrary;

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalMall = function MapsLocalMall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z' })
	  );
	};
	MapsLocalMall = (0, _pure2.default)(MapsLocalMall);
	MapsLocalMall.displayName = 'MapsLocalMall';
	MapsLocalMall.muiName = 'SvgIcon';
	
	exports.default = MapsLocalMall;

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalMovies = function MapsLocalMovies(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
	  );
	};
	MapsLocalMovies = (0, _pure2.default)(MapsLocalMovies);
	MapsLocalMovies.displayName = 'MapsLocalMovies';
	MapsLocalMovies.muiName = 'SvgIcon';
	
	exports.default = MapsLocalMovies;

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalOffer = function MapsLocalOffer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z' })
	  );
	};
	MapsLocalOffer = (0, _pure2.default)(MapsLocalOffer);
	MapsLocalOffer.displayName = 'MapsLocalOffer';
	MapsLocalOffer.muiName = 'SvgIcon';
	
	exports.default = MapsLocalOffer;

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalParking = function MapsLocalParking(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z' })
	  );
	};
	MapsLocalParking = (0, _pure2.default)(MapsLocalParking);
	MapsLocalParking.displayName = 'MapsLocalParking';
	MapsLocalParking.muiName = 'SvgIcon';
	
	exports.default = MapsLocalParking;

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPharmacy = function MapsLocalPharmacy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z' })
	  );
	};
	MapsLocalPharmacy = (0, _pure2.default)(MapsLocalPharmacy);
	MapsLocalPharmacy.displayName = 'MapsLocalPharmacy';
	MapsLocalPharmacy.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPharmacy;

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPhone = function MapsLocalPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	MapsLocalPhone = (0, _pure2.default)(MapsLocalPhone);
	MapsLocalPhone.displayName = 'MapsLocalPhone';
	MapsLocalPhone.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPhone;

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPizza = function MapsLocalPizza(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	MapsLocalPizza = (0, _pure2.default)(MapsLocalPizza);
	MapsLocalPizza.displayName = 'MapsLocalPizza';
	MapsLocalPizza.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPizza;

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPlay = function MapsLocalPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
	  );
	};
	MapsLocalPlay = (0, _pure2.default)(MapsLocalPlay);
	MapsLocalPlay.displayName = 'MapsLocalPlay';
	MapsLocalPlay.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPlay;

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPostOffice = function MapsLocalPostOffice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	MapsLocalPostOffice = (0, _pure2.default)(MapsLocalPostOffice);
	MapsLocalPostOffice.displayName = 'MapsLocalPostOffice';
	MapsLocalPostOffice.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPostOffice;

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPrintshop = function MapsLocalPrintshop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
	  );
	};
	MapsLocalPrintshop = (0, _pure2.default)(MapsLocalPrintshop);
	MapsLocalPrintshop.displayName = 'MapsLocalPrintshop';
	MapsLocalPrintshop.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPrintshop;

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalSee = function MapsLocalSee(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	MapsLocalSee = (0, _pure2.default)(MapsLocalSee);
	MapsLocalSee.displayName = 'MapsLocalSee';
	MapsLocalSee.muiName = 'SvgIcon';
	
	exports.default = MapsLocalSee;

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalShipping = function MapsLocalShipping(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	MapsLocalShipping = (0, _pure2.default)(MapsLocalShipping);
	MapsLocalShipping.displayName = 'MapsLocalShipping';
	MapsLocalShipping.muiName = 'SvgIcon';
	
	exports.default = MapsLocalShipping;

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalTaxi = function MapsLocalTaxi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
	  );
	};
	MapsLocalTaxi = (0, _pure2.default)(MapsLocalTaxi);
	MapsLocalTaxi.displayName = 'MapsLocalTaxi';
	MapsLocalTaxi.muiName = 'SvgIcon';
	
	exports.default = MapsLocalTaxi;

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsMap = function MapsMap(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z' })
	  );
	};
	MapsMap = (0, _pure2.default)(MapsMap);
	MapsMap.displayName = 'MapsMap';
	MapsMap.muiName = 'SvgIcon';
	
	exports.default = MapsMap;

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsMyLocation = function MapsMyLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	MapsMyLocation = (0, _pure2.default)(MapsMyLocation);
	MapsMyLocation.displayName = 'MapsMyLocation';
	MapsMyLocation.muiName = 'SvgIcon';
	
	exports.default = MapsMyLocation;

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsNavigation = function MapsNavigation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z' })
	  );
	};
	MapsNavigation = (0, _pure2.default)(MapsNavigation);
	MapsNavigation.displayName = 'MapsNavigation';
	MapsNavigation.muiName = 'SvgIcon';
	
	exports.default = MapsNavigation;

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsNearMe = function MapsNearMe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z' })
	  );
	};
	MapsNearMe = (0, _pure2.default)(MapsNearMe);
	MapsNearMe.displayName = 'MapsNearMe';
	MapsNearMe.muiName = 'SvgIcon';
	
	exports.default = MapsNearMe;

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPersonPinCircle = function MapsPersonPinCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z' })
	  );
	};
	MapsPersonPinCircle = (0, _pure2.default)(MapsPersonPinCircle);
	MapsPersonPinCircle.displayName = 'MapsPersonPinCircle';
	MapsPersonPinCircle.muiName = 'SvgIcon';
	
	exports.default = MapsPersonPinCircle;

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPersonPin = function MapsPersonPin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z' })
	  );
	};
	MapsPersonPin = (0, _pure2.default)(MapsPersonPin);
	MapsPersonPin.displayName = 'MapsPersonPin';
	MapsPersonPin.muiName = 'SvgIcon';
	
	exports.default = MapsPersonPin;

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPinDrop = function MapsPinDrop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z' })
	  );
	};
	MapsPinDrop = (0, _pure2.default)(MapsPinDrop);
	MapsPinDrop.displayName = 'MapsPinDrop';
	MapsPinDrop.muiName = 'SvgIcon';
	
	exports.default = MapsPinDrop;

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPlace = function MapsPlace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	MapsPlace = (0, _pure2.default)(MapsPlace);
	MapsPlace.displayName = 'MapsPlace';
	MapsPlace.muiName = 'SvgIcon';
	
	exports.default = MapsPlace;

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRateReview = function MapsRateReview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z' })
	  );
	};
	MapsRateReview = (0, _pure2.default)(MapsRateReview);
	MapsRateReview.displayName = 'MapsRateReview';
	MapsRateReview.muiName = 'SvgIcon';
	
	exports.default = MapsRateReview;

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRestaurantMenu = function MapsRestaurantMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
	  );
	};
	MapsRestaurantMenu = (0, _pure2.default)(MapsRestaurantMenu);
	MapsRestaurantMenu.displayName = 'MapsRestaurantMenu';
	MapsRestaurantMenu.muiName = 'SvgIcon';
	
	exports.default = MapsRestaurantMenu;

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRestaurant = function MapsRestaurant(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z' })
	  );
	};
	MapsRestaurant = (0, _pure2.default)(MapsRestaurant);
	MapsRestaurant.displayName = 'MapsRestaurant';
	MapsRestaurant.muiName = 'SvgIcon';
	
	exports.default = MapsRestaurant;

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsSatellite = function MapsSatellite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z' })
	  );
	};
	MapsSatellite = (0, _pure2.default)(MapsSatellite);
	MapsSatellite.displayName = 'MapsSatellite';
	MapsSatellite.muiName = 'SvgIcon';
	
	exports.default = MapsSatellite;

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsStoreMallDirectory = function MapsStoreMallDirectory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
	  );
	};
	MapsStoreMallDirectory = (0, _pure2.default)(MapsStoreMallDirectory);
	MapsStoreMallDirectory.displayName = 'MapsStoreMallDirectory';
	MapsStoreMallDirectory.muiName = 'SvgIcon';
	
	exports.default = MapsStoreMallDirectory;

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsStreetview = function MapsStreetview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z' }),
	    _react2.default.createElement('circle', { cx: '18', cy: '6', r: '5' }),
	    _react2.default.createElement('path', { d: 'M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z' })
	  );
	};
	MapsStreetview = (0, _pure2.default)(MapsStreetview);
	MapsStreetview.displayName = 'MapsStreetview';
	MapsStreetview.muiName = 'SvgIcon';
	
	exports.default = MapsStreetview;

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsSubway = function MapsSubway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '16', r: '1' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '16', r: '1' }),
	    _react2.default.createElement('path', { d: 'M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z' })
	  );
	};
	MapsSubway = (0, _pure2.default)(MapsSubway);
	MapsSubway.displayName = 'MapsSubway';
	MapsSubway.muiName = 'SvgIcon';
	
	exports.default = MapsSubway;

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTerrain = function MapsTerrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	MapsTerrain = (0, _pure2.default)(MapsTerrain);
	MapsTerrain.displayName = 'MapsTerrain';
	MapsTerrain.muiName = 'SvgIcon';
	
	exports.default = MapsTerrain;

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTraffic = function MapsTraffic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z' })
	  );
	};
	MapsTraffic = (0, _pure2.default)(MapsTraffic);
	MapsTraffic.displayName = 'MapsTraffic';
	MapsTraffic.muiName = 'SvgIcon';
	
	exports.default = MapsTraffic;

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTrain = function MapsTrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	MapsTrain = (0, _pure2.default)(MapsTrain);
	MapsTrain.displayName = 'MapsTrain';
	MapsTrain.muiName = 'SvgIcon';
	
	exports.default = MapsTrain;

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTram = function MapsTram(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z' })
	  );
	};
	MapsTram = (0, _pure2.default)(MapsTram);
	MapsTram.displayName = 'MapsTram';
	MapsTram.muiName = 'SvgIcon';
	
	exports.default = MapsTram;

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTransferWithinAStation = function MapsTransferWithinAStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75' })
	  );
	};
	MapsTransferWithinAStation = (0, _pure2.default)(MapsTransferWithinAStation);
	MapsTransferWithinAStation.displayName = 'MapsTransferWithinAStation';
	MapsTransferWithinAStation.muiName = 'SvgIcon';
	
	exports.default = MapsTransferWithinAStation;

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsZoomOutMap = function MapsZoomOutMap(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z' })
	  );
	};
	MapsZoomOutMap = (0, _pure2.default)(MapsZoomOutMap);
	MapsZoomOutMap.displayName = 'MapsZoomOutMap';
	MapsZoomOutMap.muiName = 'SvgIcon';
	
	exports.default = MapsZoomOutMap;

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropRight = function NavigationArrowDropRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.5,7l5,5l-5,5V7z' })
	  );
	};
	
	NavigationArrowDropRight = (0, _pure2.default)(NavigationArrowDropRight);
	NavigationArrowDropRight.displayName = 'NavigationArrowDropRight';
	NavigationArrowDropRight.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropRight;

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationApps = function NavigationApps(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z' })
	  );
	};
	NavigationApps = (0, _pure2.default)(NavigationApps);
	NavigationApps.displayName = 'NavigationApps';
	NavigationApps.muiName = 'SvgIcon';
	
	exports.default = NavigationApps;

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowBack = function NavigationArrowBack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
	  );
	};
	NavigationArrowBack = (0, _pure2.default)(NavigationArrowBack);
	NavigationArrowBack.displayName = 'NavigationArrowBack';
	NavigationArrowBack.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowBack;

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDownward = function NavigationArrowDownward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' })
	  );
	};
	NavigationArrowDownward = (0, _pure2.default)(NavigationArrowDownward);
	NavigationArrowDownward.displayName = 'NavigationArrowDownward';
	NavigationArrowDownward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDownward;

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDownCircle = function NavigationArrowDropDownCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z' })
	  );
	};
	NavigationArrowDropDownCircle = (0, _pure2.default)(NavigationArrowDropDownCircle);
	NavigationArrowDropDownCircle.displayName = 'NavigationArrowDropDownCircle';
	NavigationArrowDropDownCircle.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDownCircle;

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropUp = function NavigationArrowDropUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' })
	  );
	};
	NavigationArrowDropUp = (0, _pure2.default)(NavigationArrowDropUp);
	NavigationArrowDropUp.displayName = 'NavigationArrowDropUp';
	NavigationArrowDropUp.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropUp;

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowForward = function NavigationArrowForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z' })
	  );
	};
	NavigationArrowForward = (0, _pure2.default)(NavigationArrowForward);
	NavigationArrowForward.displayName = 'NavigationArrowForward';
	NavigationArrowForward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowForward;

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowUpward = function NavigationArrowUpward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z' })
	  );
	};
	NavigationArrowUpward = (0, _pure2.default)(NavigationArrowUpward);
	NavigationArrowUpward.displayName = 'NavigationArrowUpward';
	NavigationArrowUpward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowUpward;

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationClose = function NavigationClose(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	NavigationClose = (0, _pure2.default)(NavigationClose);
	NavigationClose.displayName = 'NavigationClose';
	NavigationClose.muiName = 'SvgIcon';
	
	exports.default = NavigationClose;

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFirstPage = function NavigationFirstPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z' })
	  );
	};
	NavigationFirstPage = (0, _pure2.default)(NavigationFirstPage);
	NavigationFirstPage.displayName = 'NavigationFirstPage';
	NavigationFirstPage.muiName = 'SvgIcon';
	
	exports.default = NavigationFirstPage;

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFullscreenExit = function NavigationFullscreenExit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z' })
	  );
	};
	NavigationFullscreenExit = (0, _pure2.default)(NavigationFullscreenExit);
	NavigationFullscreenExit.displayName = 'NavigationFullscreenExit';
	NavigationFullscreenExit.muiName = 'SvgIcon';
	
	exports.default = NavigationFullscreenExit;

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFullscreen = function NavigationFullscreen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z' })
	  );
	};
	NavigationFullscreen = (0, _pure2.default)(NavigationFullscreen);
	NavigationFullscreen.displayName = 'NavigationFullscreen';
	NavigationFullscreen.muiName = 'SvgIcon';
	
	exports.default = NavigationFullscreen;

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationLastPage = function NavigationLastPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z' })
	  );
	};
	NavigationLastPage = (0, _pure2.default)(NavigationLastPage);
	NavigationLastPage.displayName = 'NavigationLastPage';
	NavigationLastPage.muiName = 'SvgIcon';
	
	exports.default = NavigationLastPage;

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreHoriz = function NavigationMoreHoriz(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreHoriz = (0, _pure2.default)(NavigationMoreHoriz);
	NavigationMoreHoriz.displayName = 'NavigationMoreHoriz';
	NavigationMoreHoriz.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreHoriz;

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreVert = function NavigationMoreVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
	NavigationMoreVert.displayName = 'NavigationMoreVert';
	NavigationMoreVert.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreVert;

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationRefresh = function NavigationRefresh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' })
	  );
	};
	NavigationRefresh = (0, _pure2.default)(NavigationRefresh);
	NavigationRefresh.displayName = 'NavigationRefresh';
	NavigationRefresh.muiName = 'SvgIcon';
	
	exports.default = NavigationRefresh;

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationSubdirectoryArrowLeft = function NavigationSubdirectoryArrowLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z' })
	  );
	};
	NavigationSubdirectoryArrowLeft = (0, _pure2.default)(NavigationSubdirectoryArrowLeft);
	NavigationSubdirectoryArrowLeft.displayName = 'NavigationSubdirectoryArrowLeft';
	NavigationSubdirectoryArrowLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationSubdirectoryArrowLeft;

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationSubdirectoryArrowRight = function NavigationSubdirectoryArrowRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z' })
	  );
	};
	NavigationSubdirectoryArrowRight = (0, _pure2.default)(NavigationSubdirectoryArrowRight);
	NavigationSubdirectoryArrowRight.displayName = 'NavigationSubdirectoryArrowRight';
	NavigationSubdirectoryArrowRight.muiName = 'SvgIcon';
	
	exports.default = NavigationSubdirectoryArrowRight;

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationUnfoldLess = function NavigationUnfoldLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z' })
	  );
	};
	NavigationUnfoldLess = (0, _pure2.default)(NavigationUnfoldLess);
	NavigationUnfoldLess.displayName = 'NavigationUnfoldLess';
	NavigationUnfoldLess.muiName = 'SvgIcon';
	
	exports.default = NavigationUnfoldLess;

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationUnfoldMore = function NavigationUnfoldMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z' })
	  );
	};
	NavigationUnfoldMore = (0, _pure2.default)(NavigationUnfoldMore);
	NavigationUnfoldMore.displayName = 'NavigationUnfoldMore';
	NavigationUnfoldMore.muiName = 'SvgIcon';
	
	exports.default = NavigationUnfoldMore;

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAdb = function NotificationAdb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	NotificationAdb = (0, _pure2.default)(NotificationAdb);
	NotificationAdb.displayName = 'NotificationAdb';
	NotificationAdb.muiName = 'SvgIcon';
	
	exports.default = NotificationAdb;

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatFlatAngled = function NotificationAirlineSeatFlatAngled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z' })
	  );
	};
	NotificationAirlineSeatFlatAngled = (0, _pure2.default)(NotificationAirlineSeatFlatAngled);
	NotificationAirlineSeatFlatAngled.displayName = 'NotificationAirlineSeatFlatAngled';
	NotificationAirlineSeatFlatAngled.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatFlatAngled;

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatFlat = function NotificationAirlineSeatFlat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z' })
	  );
	};
	NotificationAirlineSeatFlat = (0, _pure2.default)(NotificationAirlineSeatFlat);
	NotificationAirlineSeatFlat.displayName = 'NotificationAirlineSeatFlat';
	NotificationAirlineSeatFlat.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatFlat;

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatIndividualSuite = function NotificationAirlineSeatIndividualSuite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z' })
	  );
	};
	NotificationAirlineSeatIndividualSuite = (0, _pure2.default)(NotificationAirlineSeatIndividualSuite);
	NotificationAirlineSeatIndividualSuite.displayName = 'NotificationAirlineSeatIndividualSuite';
	NotificationAirlineSeatIndividualSuite.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatIndividualSuite;

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomExtra = function NotificationAirlineSeatLegroomExtra(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z' })
	  );
	};
	NotificationAirlineSeatLegroomExtra = (0, _pure2.default)(NotificationAirlineSeatLegroomExtra);
	NotificationAirlineSeatLegroomExtra.displayName = 'NotificationAirlineSeatLegroomExtra';
	NotificationAirlineSeatLegroomExtra.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomExtra;

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomNormal = function NotificationAirlineSeatLegroomNormal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z' })
	  );
	};
	NotificationAirlineSeatLegroomNormal = (0, _pure2.default)(NotificationAirlineSeatLegroomNormal);
	NotificationAirlineSeatLegroomNormal.displayName = 'NotificationAirlineSeatLegroomNormal';
	NotificationAirlineSeatLegroomNormal.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomNormal;

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomReduced = function NotificationAirlineSeatLegroomReduced(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z' })
	  );
	};
	NotificationAirlineSeatLegroomReduced = (0, _pure2.default)(NotificationAirlineSeatLegroomReduced);
	NotificationAirlineSeatLegroomReduced.displayName = 'NotificationAirlineSeatLegroomReduced';
	NotificationAirlineSeatLegroomReduced.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomReduced;

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatReclineExtra = function NotificationAirlineSeatReclineExtra(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z' })
	  );
	};
	NotificationAirlineSeatReclineExtra = (0, _pure2.default)(NotificationAirlineSeatReclineExtra);
	NotificationAirlineSeatReclineExtra.displayName = 'NotificationAirlineSeatReclineExtra';
	NotificationAirlineSeatReclineExtra.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatReclineExtra;

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatReclineNormal = function NotificationAirlineSeatReclineNormal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z' })
	  );
	};
	NotificationAirlineSeatReclineNormal = (0, _pure2.default)(NotificationAirlineSeatReclineNormal);
	NotificationAirlineSeatReclineNormal.displayName = 'NotificationAirlineSeatReclineNormal';
	NotificationAirlineSeatReclineNormal.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatReclineNormal;

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationBluetoothAudio = function NotificationBluetoothAudio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
	  );
	};
	NotificationBluetoothAudio = (0, _pure2.default)(NotificationBluetoothAudio);
	NotificationBluetoothAudio.displayName = 'NotificationBluetoothAudio';
	NotificationBluetoothAudio.muiName = 'SvgIcon';
	
	exports.default = NotificationBluetoothAudio;

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationConfirmationNumber = function NotificationConfirmationNumber(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z' })
	  );
	};
	NotificationConfirmationNumber = (0, _pure2.default)(NotificationConfirmationNumber);
	NotificationConfirmationNumber.displayName = 'NotificationConfirmationNumber';
	NotificationConfirmationNumber.muiName = 'SvgIcon';
	
	exports.default = NotificationConfirmationNumber;

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDiscFull = function NotificationDiscFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	NotificationDiscFull = (0, _pure2.default)(NotificationDiscFull);
	NotificationDiscFull.displayName = 'NotificationDiscFull';
	NotificationDiscFull.muiName = 'SvgIcon';
	
	exports.default = NotificationDiscFull;

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbAlt = function NotificationDoNotDisturbAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z' })
	  );
	};
	NotificationDoNotDisturbAlt = (0, _pure2.default)(NotificationDoNotDisturbAlt);
	NotificationDoNotDisturbAlt.displayName = 'NotificationDoNotDisturbAlt';
	NotificationDoNotDisturbAlt.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbAlt;

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbOff = function NotificationDoNotDisturbOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z' })
	  );
	};
	NotificationDoNotDisturbOff = (0, _pure2.default)(NotificationDoNotDisturbOff);
	NotificationDoNotDisturbOff.displayName = 'NotificationDoNotDisturbOff';
	NotificationDoNotDisturbOff.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbOff;

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbOn = function NotificationDoNotDisturbOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
	  );
	};
	NotificationDoNotDisturbOn = (0, _pure2.default)(NotificationDoNotDisturbOn);
	NotificationDoNotDisturbOn.displayName = 'NotificationDoNotDisturbOn';
	NotificationDoNotDisturbOn.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbOn;

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturb = function NotificationDoNotDisturb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
	  );
	};
	NotificationDoNotDisturb = (0, _pure2.default)(NotificationDoNotDisturb);
	NotificationDoNotDisturb.displayName = 'NotificationDoNotDisturb';
	NotificationDoNotDisturb.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturb;

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDriveEta = function NotificationDriveEta(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
	  );
	};
	NotificationDriveEta = (0, _pure2.default)(NotificationDriveEta);
	NotificationDriveEta.displayName = 'NotificationDriveEta';
	NotificationDriveEta.muiName = 'SvgIcon';
	
	exports.default = NotificationDriveEta;

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEnhancedEncryption = function NotificationEnhancedEncryption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z' })
	  );
	};
	NotificationEnhancedEncryption = (0, _pure2.default)(NotificationEnhancedEncryption);
	NotificationEnhancedEncryption.displayName = 'NotificationEnhancedEncryption';
	NotificationEnhancedEncryption.muiName = 'SvgIcon';
	
	exports.default = NotificationEnhancedEncryption;

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventAvailable = function NotificationEventAvailable(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
	  );
	};
	NotificationEventAvailable = (0, _pure2.default)(NotificationEventAvailable);
	NotificationEventAvailable.displayName = 'NotificationEventAvailable';
	NotificationEventAvailable.muiName = 'SvgIcon';
	
	exports.default = NotificationEventAvailable;

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventBusy = function NotificationEventBusy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
	  );
	};
	NotificationEventBusy = (0, _pure2.default)(NotificationEventBusy);
	NotificationEventBusy.displayName = 'NotificationEventBusy';
	NotificationEventBusy.muiName = 'SvgIcon';
	
	exports.default = NotificationEventBusy;

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventNote = function NotificationEventNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z' })
	  );
	};
	NotificationEventNote = (0, _pure2.default)(NotificationEventNote);
	NotificationEventNote.displayName = 'NotificationEventNote';
	NotificationEventNote.muiName = 'SvgIcon';
	
	exports.default = NotificationEventNote;

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationFolderSpecial = function NotificationFolderSpecial(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z' })
	  );
	};
	NotificationFolderSpecial = (0, _pure2.default)(NotificationFolderSpecial);
	NotificationFolderSpecial.displayName = 'NotificationFolderSpecial';
	NotificationFolderSpecial.muiName = 'SvgIcon';
	
	exports.default = NotificationFolderSpecial;

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationLiveTv = function NotificationLiveTv(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z' })
	  );
	};
	NotificationLiveTv = (0, _pure2.default)(NotificationLiveTv);
	NotificationLiveTv.displayName = 'NotificationLiveTv';
	NotificationLiveTv.muiName = 'SvgIcon';
	
	exports.default = NotificationLiveTv;

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationMms = function NotificationMms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z' })
	  );
	};
	NotificationMms = (0, _pure2.default)(NotificationMms);
	NotificationMms.displayName = 'NotificationMms';
	NotificationMms.muiName = 'SvgIcon';
	
	exports.default = NotificationMms;

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationMore = function NotificationMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	NotificationMore = (0, _pure2.default)(NotificationMore);
	NotificationMore.displayName = 'NotificationMore';
	NotificationMore.muiName = 'SvgIcon';
	
	exports.default = NotificationMore;

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNetworkCheck = function NotificationNetworkCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z' })
	  );
	};
	NotificationNetworkCheck = (0, _pure2.default)(NotificationNetworkCheck);
	NotificationNetworkCheck.displayName = 'NotificationNetworkCheck';
	NotificationNetworkCheck.muiName = 'SvgIcon';
	
	exports.default = NotificationNetworkCheck;

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNetworkLocked = function NotificationNetworkLocked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
	  );
	};
	NotificationNetworkLocked = (0, _pure2.default)(NotificationNetworkLocked);
	NotificationNetworkLocked.displayName = 'NotificationNetworkLocked';
	NotificationNetworkLocked.muiName = 'SvgIcon';
	
	exports.default = NotificationNetworkLocked;

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNoEncryption = function NotificationNoEncryption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z' })
	  );
	};
	NotificationNoEncryption = (0, _pure2.default)(NotificationNoEncryption);
	NotificationNoEncryption.displayName = 'NotificationNoEncryption';
	NotificationNoEncryption.muiName = 'SvgIcon';
	
	exports.default = NotificationNoEncryption;

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationOndemandVideo = function NotificationOndemandVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z' })
	  );
	};
	NotificationOndemandVideo = (0, _pure2.default)(NotificationOndemandVideo);
	NotificationOndemandVideo.displayName = 'NotificationOndemandVideo';
	NotificationOndemandVideo.muiName = 'SvgIcon';
	
	exports.default = NotificationOndemandVideo;

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPersonalVideo = function NotificationPersonalVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z' })
	  );
	};
	NotificationPersonalVideo = (0, _pure2.default)(NotificationPersonalVideo);
	NotificationPersonalVideo.displayName = 'NotificationPersonalVideo';
	NotificationPersonalVideo.muiName = 'SvgIcon';
	
	exports.default = NotificationPersonalVideo;

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneBluetoothSpeaker = function NotificationPhoneBluetoothSpeaker(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	NotificationPhoneBluetoothSpeaker = (0, _pure2.default)(NotificationPhoneBluetoothSpeaker);
	NotificationPhoneBluetoothSpeaker.displayName = 'NotificationPhoneBluetoothSpeaker';
	NotificationPhoneBluetoothSpeaker.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneBluetoothSpeaker;

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneForwarded = function NotificationPhoneForwarded(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	NotificationPhoneForwarded = (0, _pure2.default)(NotificationPhoneForwarded);
	NotificationPhoneForwarded.displayName = 'NotificationPhoneForwarded';
	NotificationPhoneForwarded.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneForwarded;

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneInTalk = function NotificationPhoneInTalk(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z' })
	  );
	};
	NotificationPhoneInTalk = (0, _pure2.default)(NotificationPhoneInTalk);
	NotificationPhoneInTalk.displayName = 'NotificationPhoneInTalk';
	NotificationPhoneInTalk.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneInTalk;

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneLocked = function NotificationPhoneLocked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z' })
	  );
	};
	NotificationPhoneLocked = (0, _pure2.default)(NotificationPhoneLocked);
	NotificationPhoneLocked.displayName = 'NotificationPhoneLocked';
	NotificationPhoneLocked.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneLocked;

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneMissed = function NotificationPhoneMissed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z' })
	  );
	};
	NotificationPhoneMissed = (0, _pure2.default)(NotificationPhoneMissed);
	NotificationPhoneMissed.displayName = 'NotificationPhoneMissed';
	NotificationPhoneMissed.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneMissed;

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhonePaused = function NotificationPhonePaused(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z' })
	  );
	};
	NotificationPhonePaused = (0, _pure2.default)(NotificationPhonePaused);
	NotificationPhonePaused.displayName = 'NotificationPhonePaused';
	NotificationPhonePaused.muiName = 'SvgIcon';
	
	exports.default = NotificationPhonePaused;

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPower = function NotificationPower(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z' })
	  );
	};
	NotificationPower = (0, _pure2.default)(NotificationPower);
	NotificationPower.displayName = 'NotificationPower';
	NotificationPower.muiName = 'SvgIcon';
	
	exports.default = NotificationPower;

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPriorityHigh = function NotificationPriorityHigh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '19', r: '2' }),
	    _react2.default.createElement('path', { d: 'M10 3h4v12h-4z' })
	  );
	};
	NotificationPriorityHigh = (0, _pure2.default)(NotificationPriorityHigh);
	NotificationPriorityHigh.displayName = 'NotificationPriorityHigh';
	NotificationPriorityHigh.muiName = 'SvgIcon';
	
	exports.default = NotificationPriorityHigh;

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationRvHookup = function NotificationRvHookup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
	  );
	};
	NotificationRvHookup = (0, _pure2.default)(NotificationRvHookup);
	NotificationRvHookup.displayName = 'NotificationRvHookup';
	NotificationRvHookup.muiName = 'SvgIcon';
	
	exports.default = NotificationRvHookup;

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSdCard = function NotificationSdCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
	  );
	};
	NotificationSdCard = (0, _pure2.default)(NotificationSdCard);
	NotificationSdCard.displayName = 'NotificationSdCard';
	NotificationSdCard.muiName = 'SvgIcon';
	
	exports.default = NotificationSdCard;

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSimCardAlert = function NotificationSimCardAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z' })
	  );
	};
	NotificationSimCardAlert = (0, _pure2.default)(NotificationSimCardAlert);
	NotificationSimCardAlert.displayName = 'NotificationSimCardAlert';
	NotificationSimCardAlert.muiName = 'SvgIcon';
	
	exports.default = NotificationSimCardAlert;

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSmsFailed = function NotificationSmsFailed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
	  );
	};
	NotificationSmsFailed = (0, _pure2.default)(NotificationSmsFailed);
	NotificationSmsFailed.displayName = 'NotificationSmsFailed';
	NotificationSmsFailed.muiName = 'SvgIcon';
	
	exports.default = NotificationSmsFailed;

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSms = function NotificationSms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
	  );
	};
	NotificationSms = (0, _pure2.default)(NotificationSms);
	NotificationSms.displayName = 'NotificationSms';
	NotificationSms.muiName = 'SvgIcon';
	
	exports.default = NotificationSms;

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSyncDisabled = function NotificationSyncDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z' })
	  );
	};
	NotificationSyncDisabled = (0, _pure2.default)(NotificationSyncDisabled);
	NotificationSyncDisabled.displayName = 'NotificationSyncDisabled';
	NotificationSyncDisabled.muiName = 'SvgIcon';
	
	exports.default = NotificationSyncDisabled;

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSyncProblem = function NotificationSyncProblem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z' })
	  );
	};
	NotificationSyncProblem = (0, _pure2.default)(NotificationSyncProblem);
	NotificationSyncProblem.displayName = 'NotificationSyncProblem';
	NotificationSyncProblem.muiName = 'SvgIcon';
	
	exports.default = NotificationSyncProblem;

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSync = function NotificationSync(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
	  );
	};
	NotificationSync = (0, _pure2.default)(NotificationSync);
	NotificationSync.displayName = 'NotificationSync';
	NotificationSync.muiName = 'SvgIcon';
	
	exports.default = NotificationSync;

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSystemUpdate = function NotificationSystemUpdate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z' })
	  );
	};
	NotificationSystemUpdate = (0, _pure2.default)(NotificationSystemUpdate);
	NotificationSystemUpdate.displayName = 'NotificationSystemUpdate';
	NotificationSystemUpdate.muiName = 'SvgIcon';
	
	exports.default = NotificationSystemUpdate;

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationTapAndPlay = function NotificationTapAndPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z' })
	  );
	};
	NotificationTapAndPlay = (0, _pure2.default)(NotificationTapAndPlay);
	NotificationTapAndPlay.displayName = 'NotificationTapAndPlay';
	NotificationTapAndPlay.muiName = 'SvgIcon';
	
	exports.default = NotificationTapAndPlay;

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationTimeToLeave = function NotificationTimeToLeave(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
	  );
	};
	NotificationTimeToLeave = (0, _pure2.default)(NotificationTimeToLeave);
	NotificationTimeToLeave.displayName = 'NotificationTimeToLeave';
	NotificationTimeToLeave.muiName = 'SvgIcon';
	
	exports.default = NotificationTimeToLeave;

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVibration = function NotificationVibration(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z' })
	  );
	};
	NotificationVibration = (0, _pure2.default)(NotificationVibration);
	NotificationVibration.displayName = 'NotificationVibration';
	NotificationVibration.muiName = 'SvgIcon';
	
	exports.default = NotificationVibration;

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVoiceChat = function NotificationVoiceChat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z' })
	  );
	};
	NotificationVoiceChat = (0, _pure2.default)(NotificationVoiceChat);
	NotificationVoiceChat.displayName = 'NotificationVoiceChat';
	NotificationVoiceChat.muiName = 'SvgIcon';
	
	exports.default = NotificationVoiceChat;

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVpnLock = function NotificationVpnLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z' })
	  );
	};
	NotificationVpnLock = (0, _pure2.default)(NotificationVpnLock);
	NotificationVpnLock.displayName = 'NotificationVpnLock';
	NotificationVpnLock.muiName = 'SvgIcon';
	
	exports.default = NotificationVpnLock;

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationWc = function NotificationWc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z' })
	  );
	};
	NotificationWc = (0, _pure2.default)(NotificationWc);
	NotificationWc.displayName = 'NotificationWc';
	NotificationWc.muiName = 'SvgIcon';
	
	exports.default = NotificationWc;

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationWifi = function NotificationWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z' })
	  );
	};
	NotificationWifi = (0, _pure2.default)(NotificationWifi);
	NotificationWifi.displayName = 'NotificationWifi';
	NotificationWifi.muiName = 'SvgIcon';
	
	exports.default = NotificationWifi;

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAcUnit = function PlacesAcUnit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z' })
	  );
	};
	PlacesAcUnit = (0, _pure2.default)(PlacesAcUnit);
	PlacesAcUnit.displayName = 'PlacesAcUnit';
	PlacesAcUnit.muiName = 'SvgIcon';
	
	exports.default = PlacesAcUnit;

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAirportShuttle = function PlacesAirportShuttle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z' })
	  );
	};
	PlacesAirportShuttle = (0, _pure2.default)(PlacesAirportShuttle);
	PlacesAirportShuttle.displayName = 'PlacesAirportShuttle';
	PlacesAirportShuttle.muiName = 'SvgIcon';
	
	exports.default = PlacesAirportShuttle;

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAllInclusive = function PlacesAllInclusive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z' })
	  );
	};
	PlacesAllInclusive = (0, _pure2.default)(PlacesAllInclusive);
	PlacesAllInclusive.displayName = 'PlacesAllInclusive';
	PlacesAllInclusive.muiName = 'SvgIcon';
	
	exports.default = PlacesAllInclusive;

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesBeachAccess = function PlacesBeachAccess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z' })
	  );
	};
	PlacesBeachAccess = (0, _pure2.default)(PlacesBeachAccess);
	PlacesBeachAccess.displayName = 'PlacesBeachAccess';
	PlacesBeachAccess.muiName = 'SvgIcon';
	
	exports.default = PlacesBeachAccess;

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesBusinessCenter = function PlacesBusinessCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z' })
	  );
	};
	PlacesBusinessCenter = (0, _pure2.default)(PlacesBusinessCenter);
	PlacesBusinessCenter.displayName = 'PlacesBusinessCenter';
	PlacesBusinessCenter.muiName = 'SvgIcon';
	
	exports.default = PlacesBusinessCenter;

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesCasino = function PlacesCasino(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z' })
	  );
	};
	PlacesCasino = (0, _pure2.default)(PlacesCasino);
	PlacesCasino.displayName = 'PlacesCasino';
	PlacesCasino.muiName = 'SvgIcon';
	
	exports.default = PlacesCasino;

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesChildCare = function PlacesChildCare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '14.5', cy: '10.5', r: '1.25' }),
	    _react2.default.createElement('circle', { cx: '9.5', cy: '10.5', r: '1.25' }),
	    _react2.default.createElement('path', { d: 'M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z' })
	  );
	};
	PlacesChildCare = (0, _pure2.default)(PlacesChildCare);
	PlacesChildCare.displayName = 'PlacesChildCare';
	PlacesChildCare.muiName = 'SvgIcon';
	
	exports.default = PlacesChildCare;

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesChildFriendly = function PlacesChildFriendly(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z' })
	  );
	};
	PlacesChildFriendly = (0, _pure2.default)(PlacesChildFriendly);
	PlacesChildFriendly.displayName = 'PlacesChildFriendly';
	PlacesChildFriendly.muiName = 'SvgIcon';
	
	exports.default = PlacesChildFriendly;

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesFitnessCenter = function PlacesFitnessCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z' })
	  );
	};
	PlacesFitnessCenter = (0, _pure2.default)(PlacesFitnessCenter);
	PlacesFitnessCenter.displayName = 'PlacesFitnessCenter';
	PlacesFitnessCenter.muiName = 'SvgIcon';
	
	exports.default = PlacesFitnessCenter;

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesFreeBreakfast = function PlacesFreeBreakfast(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z' })
	  );
	};
	PlacesFreeBreakfast = (0, _pure2.default)(PlacesFreeBreakfast);
	PlacesFreeBreakfast.displayName = 'PlacesFreeBreakfast';
	PlacesFreeBreakfast.muiName = 'SvgIcon';
	
	exports.default = PlacesFreeBreakfast;

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesGolfCourse = function PlacesGolfCourse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '19.5', cy: '19.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z' })
	  );
	};
	PlacesGolfCourse = (0, _pure2.default)(PlacesGolfCourse);
	PlacesGolfCourse.displayName = 'PlacesGolfCourse';
	PlacesGolfCourse.muiName = 'SvgIcon';
	
	exports.default = PlacesGolfCourse;

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesHotTub = function PlacesHotTub(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '7', cy: '6', r: '2' }),
	    _react2.default.createElement('path', { d: 'M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z' })
	  );
	};
	PlacesHotTub = (0, _pure2.default)(PlacesHotTub);
	PlacesHotTub.displayName = 'PlacesHotTub';
	PlacesHotTub.muiName = 'SvgIcon';
	
	exports.default = PlacesHotTub;

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesKitchen = function PlacesKitchen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z' })
	  );
	};
	PlacesKitchen = (0, _pure2.default)(PlacesKitchen);
	PlacesKitchen.displayName = 'PlacesKitchen';
	PlacesKitchen.muiName = 'SvgIcon';
	
	exports.default = PlacesKitchen;

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesPool = function PlacesPool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z' }),
	    _react2.default.createElement('circle', { cx: '16.5', cy: '5.5', r: '2.5' })
	  );
	};
	PlacesPool = (0, _pure2.default)(PlacesPool);
	PlacesPool.displayName = 'PlacesPool';
	PlacesPool.muiName = 'SvgIcon';
	
	exports.default = PlacesPool;

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesRoomService = function PlacesRoomService(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z' })
	  );
	};
	PlacesRoomService = (0, _pure2.default)(PlacesRoomService);
	PlacesRoomService.displayName = 'PlacesRoomService';
	PlacesRoomService.muiName = 'SvgIcon';
	
	exports.default = PlacesRoomService;

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesRvHookup = function PlacesRvHookup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
	  );
	};
	PlacesRvHookup = (0, _pure2.default)(PlacesRvHookup);
	PlacesRvHookup.displayName = 'PlacesRvHookup';
	PlacesRvHookup.muiName = 'SvgIcon';
	
	exports.default = PlacesRvHookup;

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSmokeFree = function PlacesSmokeFree(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z' })
	  );
	};
	PlacesSmokeFree = (0, _pure2.default)(PlacesSmokeFree);
	PlacesSmokeFree.displayName = 'PlacesSmokeFree';
	PlacesSmokeFree.muiName = 'SvgIcon';
	
	exports.default = PlacesSmokeFree;

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSmokingRooms = function PlacesSmokingRooms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z' })
	  );
	};
	PlacesSmokingRooms = (0, _pure2.default)(PlacesSmokingRooms);
	PlacesSmokingRooms.displayName = 'PlacesSmokingRooms';
	PlacesSmokingRooms.muiName = 'SvgIcon';
	
	exports.default = PlacesSmokingRooms;

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSpa = function PlacesSpa(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z' }),
	    _react2.default.createElement('path', { d: 'M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z' })
	  );
	};
	PlacesSpa = (0, _pure2.default)(PlacesSpa);
	PlacesSpa.displayName = 'PlacesSpa';
	PlacesSpa.muiName = 'SvgIcon';
	
	exports.default = PlacesSpa;

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialCake = function SocialCake(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z' })
	  );
	};
	SocialCake = (0, _pure2.default)(SocialCake);
	SocialCake.displayName = 'SocialCake';
	SocialCake.muiName = 'SvgIcon';
	
	exports.default = SocialCake;

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialDomain = function SocialDomain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
	  );
	};
	SocialDomain = (0, _pure2.default)(SocialDomain);
	SocialDomain.displayName = 'SocialDomain';
	SocialDomain.muiName = 'SvgIcon';
	
	exports.default = SocialDomain;

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialGroupAdd = function SocialGroupAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z' })
	  );
	};
	SocialGroupAdd = (0, _pure2.default)(SocialGroupAdd);
	SocialGroupAdd.displayName = 'SocialGroupAdd';
	SocialGroupAdd.muiName = 'SvgIcon';
	
	exports.default = SocialGroupAdd;

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialGroup = function SocialGroup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
	  );
	};
	SocialGroup = (0, _pure2.default)(SocialGroup);
	SocialGroup.displayName = 'SocialGroup';
	SocialGroup.muiName = 'SvgIcon';
	
	exports.default = SocialGroup;

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialLocationCity = function SocialLocationCity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z' })
	  );
	};
	SocialLocationCity = (0, _pure2.default)(SocialLocationCity);
	SocialLocationCity.displayName = 'SocialLocationCity';
	SocialLocationCity.muiName = 'SvgIcon';
	
	exports.default = SocialLocationCity;

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMoodBad = function SocialMoodBad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
	  );
	};
	SocialMoodBad = (0, _pure2.default)(SocialMoodBad);
	SocialMoodBad.displayName = 'SocialMoodBad';
	SocialMoodBad.muiName = 'SvgIcon';
	
	exports.default = SocialMoodBad;

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMood = function SocialMood(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	SocialMood = (0, _pure2.default)(SocialMood);
	SocialMood.displayName = 'SocialMood';
	SocialMood.muiName = 'SvgIcon';
	
	exports.default = SocialMood;

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsActive = function SocialNotificationsActive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z' })
	  );
	};
	SocialNotificationsActive = (0, _pure2.default)(SocialNotificationsActive);
	SocialNotificationsActive.displayName = 'SocialNotificationsActive';
	SocialNotificationsActive.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsActive;

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsNone = function SocialNotificationsNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z' })
	  );
	};
	SocialNotificationsNone = (0, _pure2.default)(SocialNotificationsNone);
	SocialNotificationsNone.displayName = 'SocialNotificationsNone';
	SocialNotificationsNone.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsNone;

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsOff = function SocialNotificationsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z' })
	  );
	};
	SocialNotificationsOff = (0, _pure2.default)(SocialNotificationsOff);
	SocialNotificationsOff.displayName = 'SocialNotificationsOff';
	SocialNotificationsOff.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsOff;

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsPaused = function SocialNotificationsPaused(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z' })
	  );
	};
	SocialNotificationsPaused = (0, _pure2.default)(SocialNotificationsPaused);
	SocialNotificationsPaused.displayName = 'SocialNotificationsPaused';
	SocialNotificationsPaused.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsPaused;

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotifications = function SocialNotifications(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' })
	  );
	};
	SocialNotifications = (0, _pure2.default)(SocialNotifications);
	SocialNotifications.displayName = 'SocialNotifications';
	SocialNotifications.muiName = 'SvgIcon';
	
	exports.default = SocialNotifications;

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPages = function SocialPages(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z' })
	  );
	};
	SocialPages = (0, _pure2.default)(SocialPages);
	SocialPages.displayName = 'SocialPages';
	SocialPages.muiName = 'SvgIcon';
	
	exports.default = SocialPages;

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPartyMode = function SocialPartyMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z' })
	  );
	};
	SocialPartyMode = (0, _pure2.default)(SocialPartyMode);
	SocialPartyMode.displayName = 'SocialPartyMode';
	SocialPartyMode.muiName = 'SvgIcon';
	
	exports.default = SocialPartyMode;

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPeopleOutline = function SocialPeopleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z' })
	  );
	};
	SocialPeopleOutline = (0, _pure2.default)(SocialPeopleOutline);
	SocialPeopleOutline.displayName = 'SocialPeopleOutline';
	SocialPeopleOutline.muiName = 'SvgIcon';
	
	exports.default = SocialPeopleOutline;

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPeople = function SocialPeople(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
	  );
	};
	SocialPeople = (0, _pure2.default)(SocialPeople);
	SocialPeople.displayName = 'SocialPeople';
	SocialPeople.muiName = 'SvgIcon';
	
	exports.default = SocialPeople;

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPersonAdd = function SocialPersonAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPersonAdd = (0, _pure2.default)(SocialPersonAdd);
	SocialPersonAdd.displayName = 'SocialPersonAdd';
	SocialPersonAdd.muiName = 'SvgIcon';
	
	exports.default = SocialPersonAdd;

/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPersonOutline = function SocialPersonOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPersonOutline = (0, _pure2.default)(SocialPersonOutline);
	SocialPersonOutline.displayName = 'SocialPersonOutline';
	SocialPersonOutline.muiName = 'SvgIcon';
	
	exports.default = SocialPersonOutline;

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPerson = function SocialPerson(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPerson = (0, _pure2.default)(SocialPerson);
	SocialPerson.displayName = 'SocialPerson';
	SocialPerson.muiName = 'SvgIcon';
	
	exports.default = SocialPerson;

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPlusOne = function SocialPlusOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z' })
	  );
	};
	SocialPlusOne = (0, _pure2.default)(SocialPlusOne);
	SocialPlusOne.displayName = 'SocialPlusOne';
	SocialPlusOne.muiName = 'SvgIcon';
	
	exports.default = SocialPlusOne;

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPoll = function SocialPoll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	SocialPoll = (0, _pure2.default)(SocialPoll);
	SocialPoll.displayName = 'SocialPoll';
	SocialPoll.muiName = 'SvgIcon';
	
	exports.default = SocialPoll;

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPublic = function SocialPublic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' })
	  );
	};
	SocialPublic = (0, _pure2.default)(SocialPublic);
	SocialPublic.displayName = 'SocialPublic';
	SocialPublic.muiName = 'SvgIcon';
	
	exports.default = SocialPublic;

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSchool = function SocialSchool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z' })
	  );
	};
	SocialSchool = (0, _pure2.default)(SocialSchool);
	SocialSchool.displayName = 'SocialSchool';
	SocialSchool.muiName = 'SvgIcon';
	
	exports.default = SocialSchool;

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentDissatisfied = function SocialSentimentDissatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z' })
	  );
	};
	SocialSentimentDissatisfied = (0, _pure2.default)(SocialSentimentDissatisfied);
	SocialSentimentDissatisfied.displayName = 'SocialSentimentDissatisfied';
	SocialSentimentDissatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentDissatisfied;

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentNeutral = function SocialSentimentNeutral(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 14h6v1.5H9z' }),
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	SocialSentimentNeutral = (0, _pure2.default)(SocialSentimentNeutral);
	SocialSentimentNeutral.displayName = 'SocialSentimentNeutral';
	SocialSentimentNeutral.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentNeutral;

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentSatisfied = function SocialSentimentSatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z' })
	  );
	};
	SocialSentimentSatisfied = (0, _pure2.default)(SocialSentimentSatisfied);
	SocialSentimentSatisfied.displayName = 'SocialSentimentSatisfied';
	SocialSentimentSatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentSatisfied;

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentVeryDissatisfied = function SocialSentimentVeryDissatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
	  );
	};
	SocialSentimentVeryDissatisfied = (0, _pure2.default)(SocialSentimentVeryDissatisfied);
	SocialSentimentVeryDissatisfied.displayName = 'SocialSentimentVeryDissatisfied';
	SocialSentimentVeryDissatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentVeryDissatisfied;

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentVerySatisfied = function SocialSentimentVerySatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	SocialSentimentVerySatisfied = (0, _pure2.default)(SocialSentimentVerySatisfied);
	SocialSentimentVerySatisfied.displayName = 'SocialSentimentVerySatisfied';
	SocialSentimentVerySatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentVerySatisfied;

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialShare = function SocialShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z' })
	  );
	};
	SocialShare = (0, _pure2.default)(SocialShare);
	SocialShare.displayName = 'SocialShare';
	SocialShare.muiName = 'SvgIcon';
	
	exports.default = SocialShare;

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialWhatshot = function SocialWhatshot(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z' })
	  );
	};
	SocialWhatshot = (0, _pure2.default)(SocialWhatshot);
	SocialWhatshot.displayName = 'SocialWhatshot';
	SocialWhatshot.muiName = 'SvgIcon';
	
	exports.default = SocialWhatshot;

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleIndeterminateCheckBox = function ToggleIndeterminateCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' })
	  );
	};
	ToggleIndeterminateCheckBox = (0, _pure2.default)(ToggleIndeterminateCheckBox);
	ToggleIndeterminateCheckBox.displayName = 'ToggleIndeterminateCheckBox';
	ToggleIndeterminateCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleIndeterminateCheckBox;

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStarBorder = function ToggleStarBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
	  );
	};
	ToggleStarBorder = (0, _pure2.default)(ToggleStarBorder);
	ToggleStarBorder.displayName = 'ToggleStarBorder';
	ToggleStarBorder.muiName = 'SvgIcon';
	
	exports.default = ToggleStarBorder;

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStarHalf = function ToggleStarHalf(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
	  );
	};
	ToggleStarHalf = (0, _pure2.default)(ToggleStarHalf);
	ToggleStarHalf.displayName = 'ToggleStarHalf';
	ToggleStarHalf.muiName = 'SvgIcon';
	
	exports.default = ToggleStarHalf;

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStar = function ToggleStar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
	  );
	};
	ToggleStar = (0, _pure2.default)(ToggleStar);
	ToggleStar.displayName = 'ToggleStar';
	ToggleStar.muiName = 'SvgIcon';
	
	exports.default = ToggleStar;

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(126);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = _inlineStylePrefixer2.default.prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var _ret = function () {
	      var prefixer = new _inlineStylePrefixer2.default({
	        userAgent: userAgent
	      });
	
	      return {
	        v: function v(style) {
	          return prefixer.prefix(style);
	        }
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	  }
	};
	
	var _inlineStylePrefixer = __webpack_require__(1552);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(66);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {}; /**
	                  * This module is taken from https://github.com/react-bootstrap/react-prop-types.
	                  * It's not a dependency to reduce build size / install time.
	                  * It should be pretty stable.
	                  */
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	       false ? (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason)) : void 0;
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 2744 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	* Returns a number of pixels from the top of the screen for given dom element.
	*
	* @param {object} dom element
	* @returns {number} A position from the top of the screen in pixels
	*/
	var getOffsetTop = exports.getOffsetTop = function getOffsetTop(elem) {
	  var yPos = elem.offsetTop;
	  var tempEl = elem.offsetParent;
	
	  while (tempEl != null) {
	    yPos += tempEl.offsetTop;
	    tempEl = tempEl.offsetParent;
	  }
	
	  return yPos;
	};
	
	var isIOS = exports.isIOS = function isIOS() {
	  return (/iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
	  );
	};

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(142);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(12);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(11);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(118);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SMALL = exports.SMALL = 1;
	var MEDIUM = exports.MEDIUM = 2;
	var LARGE = exports.LARGE = 3;
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$largeWidth = options.largeWidth,
	      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
	      _options$mediumWidth = options.mediumWidth,
	      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
	      _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  return function (MyComponent) {
	    return function (_Component) {
	      (0, _inherits3.default)(WithWidth, _Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: null
	        }, _this.handleResize = function () {
	          clearTimeout(_this.deferTimer);
	          _this.deferTimer = setTimeout(function () {
	            _this.updateWidth();
	          }, resizeInterval);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.deferTimer);
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth() {
	          var innerWidth = window.innerWidth;
	          var width = void 0;
	
	          if (innerWidth >= largeWidth) {
	            width = LARGE;
	          } else if (innerWidth >= mediumWidth) {
	            width = MEDIUM;
	          } else {
	            // innerWidth < 768
	            width = SMALL;
	          }
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var width = this.state.width;
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the screen width.
	           * In order to prevent blinks and help the reconciliation
	           * we are not rendering the component.
	           *
	           * A better alternative would be to send client hints.
	           * But the browser support of this API is low:
	           * http://caniuse.com/#search=client%20hint
	           */
	          if (width === null) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(MyComponent, (0, _extends3.default)({
	              width: width
	            }, this.props))
	          );
	        }
	      }]);
	      return WithWidth;
	    }(_react.Component);
	  };
	}

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 634,
		"./af.js": 634,
		"./ar": 641,
		"./ar-dz": 635,
		"./ar-dz.js": 635,
		"./ar-kw": 636,
		"./ar-kw.js": 636,
		"./ar-ly": 637,
		"./ar-ly.js": 637,
		"./ar-ma": 638,
		"./ar-ma.js": 638,
		"./ar-sa": 639,
		"./ar-sa.js": 639,
		"./ar-tn": 640,
		"./ar-tn.js": 640,
		"./ar.js": 641,
		"./az": 642,
		"./az.js": 642,
		"./be": 643,
		"./be.js": 643,
		"./bg": 644,
		"./bg.js": 644,
		"./bn": 645,
		"./bn.js": 645,
		"./bo": 646,
		"./bo.js": 646,
		"./br": 647,
		"./br.js": 647,
		"./bs": 648,
		"./bs.js": 648,
		"./ca": 649,
		"./ca.js": 649,
		"./cs": 650,
		"./cs.js": 650,
		"./cv": 651,
		"./cv.js": 651,
		"./cy": 652,
		"./cy.js": 652,
		"./da": 653,
		"./da.js": 653,
		"./de": 656,
		"./de-at": 654,
		"./de-at.js": 654,
		"./de-ch": 655,
		"./de-ch.js": 655,
		"./de.js": 656,
		"./dv": 657,
		"./dv.js": 657,
		"./el": 658,
		"./el.js": 658,
		"./en-au": 659,
		"./en-au.js": 659,
		"./en-ca": 660,
		"./en-ca.js": 660,
		"./en-gb": 661,
		"./en-gb.js": 661,
		"./en-ie": 662,
		"./en-ie.js": 662,
		"./en-nz": 663,
		"./en-nz.js": 663,
		"./eo": 664,
		"./eo.js": 664,
		"./es": 666,
		"./es-do": 665,
		"./es-do.js": 665,
		"./es.js": 666,
		"./et": 667,
		"./et.js": 667,
		"./eu": 668,
		"./eu.js": 668,
		"./fa": 669,
		"./fa.js": 669,
		"./fi": 670,
		"./fi.js": 670,
		"./fo": 671,
		"./fo.js": 671,
		"./fr": 674,
		"./fr-ca": 672,
		"./fr-ca.js": 672,
		"./fr-ch": 673,
		"./fr-ch.js": 673,
		"./fr.js": 674,
		"./fy": 675,
		"./fy.js": 675,
		"./gd": 676,
		"./gd.js": 676,
		"./gl": 677,
		"./gl.js": 677,
		"./gom-latn": 678,
		"./gom-latn.js": 678,
		"./he": 679,
		"./he.js": 679,
		"./hi": 680,
		"./hi.js": 680,
		"./hr": 681,
		"./hr.js": 681,
		"./hu": 682,
		"./hu.js": 682,
		"./hy-am": 683,
		"./hy-am.js": 683,
		"./id": 684,
		"./id.js": 684,
		"./is": 685,
		"./is.js": 685,
		"./it": 686,
		"./it.js": 686,
		"./ja": 687,
		"./ja.js": 687,
		"./jv": 688,
		"./jv.js": 688,
		"./ka": 689,
		"./ka.js": 689,
		"./kk": 690,
		"./kk.js": 690,
		"./km": 691,
		"./km.js": 691,
		"./kn": 692,
		"./kn.js": 692,
		"./ko": 693,
		"./ko.js": 693,
		"./ky": 694,
		"./ky.js": 694,
		"./lb": 695,
		"./lb.js": 695,
		"./lo": 696,
		"./lo.js": 696,
		"./lt": 697,
		"./lt.js": 697,
		"./lv": 698,
		"./lv.js": 698,
		"./me": 699,
		"./me.js": 699,
		"./mi": 700,
		"./mi.js": 700,
		"./mk": 701,
		"./mk.js": 701,
		"./ml": 702,
		"./ml.js": 702,
		"./mr": 703,
		"./mr.js": 703,
		"./ms": 705,
		"./ms-my": 704,
		"./ms-my.js": 704,
		"./ms.js": 705,
		"./my": 706,
		"./my.js": 706,
		"./nb": 707,
		"./nb.js": 707,
		"./ne": 708,
		"./ne.js": 708,
		"./nl": 710,
		"./nl-be": 709,
		"./nl-be.js": 709,
		"./nl.js": 710,
		"./nn": 711,
		"./nn.js": 711,
		"./pa-in": 712,
		"./pa-in.js": 712,
		"./pl": 713,
		"./pl.js": 713,
		"./pt": 715,
		"./pt-br": 714,
		"./pt-br.js": 714,
		"./pt.js": 715,
		"./ro": 716,
		"./ro.js": 716,
		"./ru": 717,
		"./ru.js": 717,
		"./sd": 718,
		"./sd.js": 718,
		"./se": 719,
		"./se.js": 719,
		"./si": 720,
		"./si.js": 720,
		"./sk": 721,
		"./sk.js": 721,
		"./sl": 722,
		"./sl.js": 722,
		"./sq": 723,
		"./sq.js": 723,
		"./sr": 725,
		"./sr-cyrl": 724,
		"./sr-cyrl.js": 724,
		"./sr.js": 725,
		"./ss": 726,
		"./ss.js": 726,
		"./sv": 727,
		"./sv.js": 727,
		"./sw": 728,
		"./sw.js": 728,
		"./ta": 729,
		"./ta.js": 729,
		"./te": 730,
		"./te.js": 730,
		"./tet": 731,
		"./tet.js": 731,
		"./th": 732,
		"./th.js": 732,
		"./tl-ph": 733,
		"./tl-ph.js": 733,
		"./tlh": 734,
		"./tlh.js": 734,
		"./tr": 735,
		"./tr.js": 735,
		"./tzl": 736,
		"./tzl.js": 736,
		"./tzm": 738,
		"./tzm-latn": 737,
		"./tzm-latn.js": 737,
		"./tzm.js": 738,
		"./uk": 739,
		"./uk.js": 739,
		"./ur": 740,
		"./ur.js": 740,
		"./uz": 742,
		"./uz-latn": 741,
		"./uz-latn.js": 741,
		"./uz.js": 742,
		"./vi": 743,
		"./vi.js": 743,
		"./x-pseudo": 744,
		"./x-pseudo.js": 744,
		"./yo": 745,
		"./yo.js": 745,
		"./zh-cn": 746,
		"./zh-cn.js": 746,
		"./zh-hk": 747,
		"./zh-hk.js": 747,
		"./zh-tw": 748,
		"./zh-tw.js": 748
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2747;


/***/ }),
/* 2748 */
/***/ (function(module, exports) {

	// Most of these are according to this table: http://www.ssicom.org/js/x171166.htm
	// However where nodejs readline diverges, they are adjusted to conform to it
	module.exports = {
	  nomod: {
	      escape: '\u001b'
	    , space: ' ' // actually '\u0020'
	    }
	  , ctrl: {
	        ' ': '\u0000'
	      , 'a': '\u0001'
	      , 'b': '\u0002'
	      , 'c': '\u0003'
	      , 'd': '\u0004'
	      , 'e': '\u0005'
	      , 'f': '\u0006'
	      , 'g': '\u0007'
	      , 'h': '\u0008'
	      , 'i': '\u0009'
	      , 'j': '\u000a'
	      , 'k': '\u000b'
	      , 'm': '\u000c'
	      , 'n': '\u000d'
	      , 'l': '\u000e'
	      , 'o': '\u000f'
	      , 'p': '\u0010'
	      , 'q': '\u0011'
	      , 'r': '\u0012'
	      , 's': '\u0013'
	      , 't': '\u0014'
	      , 'u': '\u0015'
	      , 'v': '\u0016'
	      , 'w': '\u0017'
	      , 'x': '\u0018'
	      , 'y': '\u0019'
	      , 'z': '\u001a'
	      , '[': '\u001b'
	      , '\\':'\u001c'
	      , ']': '\u001d'
	      , '^': '\u001e'
	      , '_': '\u001f'
	
	      , 'space': '\u0000'
	    }
	};


/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keycodes = __webpack_require__(2748);
	
	function assertKeyString(s) {
	  if (!/^(ctrl-|shift-|alt-|meta-){0,4}\w+$/.test(s))
	    throw new Error('The string to parse needs to be of the format "c", "ctrl-c", "shift-ctrl-c".');
	}
	
	module.exports = function parse(s) {
	  var keyString = s.trim().toLowerCase();
	
	  assertKeyString(keyString);
	
	  var key = {
	      name     :  undefined
	    , ctrl     :  false
	    , meta     :  false
	    , shift    :  false
	    , alt      :  false
	    , sequence :  undefined
	  }
	  , parts = keyString.split('-')
	  , c;
	
	  key.name = parts.pop();
	  while((c = parts.pop())) key[c] = true;
	  key.sequence = key.ctrl 
	    ? keycodes.ctrl[key.name] || key.name
	    : keycodes.nomod[key.name] || key.name;
	
	  // uppercase sequence for single chars when shift was pressed
	  if (key.shift && key.sequence && key.sequence.length === 1)
	    key.sequence = key.sequence.toUpperCase();
	
	  return key;
	};


/***/ }),
/* 2750 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(2754);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	var invariant = __webpack_require__(22);
	var ReactPropTypesSecret = __webpack_require__(751);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	var ReactPropTypesSecret = __webpack_require__(751);
	var checkPropTypes = __webpack_require__(2751);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 2755 */
/***/ (function(module, exports) {

	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	module.exports = hsl2rgb;

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

	var clamp = __webpack_require__(398);
	
	function componentToHex(c) {
	  var value = Math.round(clamp(c, 0, 255));
	  var hex   = value.toString(16);
	
	  return hex.length == 1 ? "0" + hex : hex;
	}
	
	function rgb2hex(rgb) {
	  var alpha = rgb.length === 4 ? componentToHex(rgb[3] * 255) : "";
	
	  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]) + alpha;
	}
	
	module.exports = rgb2hex;

/***/ }),
/* 2757 */
/***/ (function(module, exports) {

	function expand(hex) {
	  var result = "#";
	
	  for (var i = 1; i < hex.length; i++) {
	    var val = hex.charAt(i);
	    result += val + val;
	  }
	
	  return result;
	}
	
	function hex(hex) {
	  // #RGB or #RGBA
	  if(hex.length === 4 || hex.length === 5) {
	    hex = expand(hex);
	  }
	
	  var rgb = [
	    parseInt(hex.substring(1,3), 16),
	    parseInt(hex.substring(3,5), 16),
	    parseInt(hex.substring(5,7), 16)
	  ];
	
	  // #RRGGBBAA
	  if (hex.length === 9) {
	    var alpha = parseFloat((parseInt(hex.substring(7,9), 16) / 255).toFixed(2));
	    rgb.push(alpha);
	  }
	
	  return rgb;
	}
	
	module.exports = hex;

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

	var extractComponents = __webpack_require__(752);
	var clamp = __webpack_require__(398);
	
	function parseHslComponent(component, i) {
	  component = parseFloat(component);
	
	  switch(i) {
	    case 0:
	      return clamp(component, 0, 360);
	    case 1:
	    case 2:
	      return clamp(component, 0, 100);
	    case 3:
	      return clamp(component, 0, 1);
	  }
	}
	
	function hsl(color) {
	  return extractComponents(color).map(parseHslComponent);
	}
	
	module.exports = hsl;

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

	var hsl = __webpack_require__(2758);
	var hex = __webpack_require__(2757);
	var rgb = __webpack_require__(2760);
	var hsl2rgb = __webpack_require__(2755);
	
	function hsl2rgbParse(color) {
	  var h = hsl(color);
	  var r = hsl2rgb(h);
	
	  // handle alpha since hsl2rgb doesn't know (or care!) about it
	  if(h.length === 4) {
	    r.push(h[3]);
	  }
	
	  return r;
	}
	
	var space2parser = {
	  "#" : hex,
	  "hsl" : hsl2rgbParse,
	  "rgb" : rgb
	};
	
	function parse(color) {
	  for(var scheme in space2parser) {
	    if(color.indexOf(scheme) === 0) {
	      return space2parser[scheme](color);
	    }
	  }
	}
	
	parse.rgb = rgb;
	parse.hsl = hsl;
	parse.hex = hex;
	
	module.exports = parse;

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

	var extractComponents = __webpack_require__(752);
	var clamp = __webpack_require__(398);
	
	function parseRgbComponent(component, i) {
	  if (i < 3) {
	    if (component.indexOf('%') != -1) {
	      return Math.round(255 * clamp(parseInt(component, 10), 0, 100)/100);
	    } else {
	      return clamp(parseInt(component, 10), 0, 255);
	    }
	  } else {
	    return clamp(parseFloat(component), 0, 1);
	  } 
	}
	
	function rgb(color) {
	  return extractComponents(color).map(parseRgbComponent);
	}
	
	module.exports = rgb;

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(3044);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 2762 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 2763 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var PagerItem = (function (_React$Component) {
	  function PagerItem() {
	    _classCallCheck(this, PagerItem);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(PagerItem, _React$Component);
	
	  _createClass(PagerItem, [{
	    key: 'handleClick',
	    value: function handleClick(ev) {
	      ev.preventDefault();
	      if (!this.props.active && !this.props.disabled) {
	        this.props.skipTo(this.props.page);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.props.active ? 'rc-pager-item-active' : '';
	      if (this.props.disabled) {
	        status += ' rc-pager-item-disabled';
	      }
	      return React.createElement(
	        'li',
	        { onClick: this.handleClick.bind(this), className: status },
	        React.createElement(
	          'a',
	          { href: '#' },
	          this.props.text
	        )
	      );
	    }
	  }]);
	
	  return PagerItem;
	})(React.Component);
	
	/**
	 * @private
	 * 命令子项
	 */
	
	var CmdItem = (function (_React$Component2) {
	  function CmdItem() {
	    _classCallCheck(this, CmdItem);
	
	    if (_React$Component2 != null) {
	      _React$Component2.apply(this, arguments);
	    }
	  }
	
	  _inherits(CmdItem, _React$Component2);
	
	  _createClass(CmdItem, [{
	    key: 'handleClick',
	    value: function handleClick(ev) {
	      ev.preventDefault();
	      if (!this.props.disabled) {
	        this.props.skipTo(this.props.page);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var disabled = this.props.disabled ? 'rc-pager-item-disabled' : '';
	      return React.createElement(
	        'li',
	        { onClick: this.handleClick.bind(this), className: disabled },
	        React.createElement(
	          'a',
	          { href: '#' },
	          React.createElement(
	            'span',
	            { 'aria-hidden': 'true' },
	            this.props.text
	          )
	        )
	      );
	    }
	  }]);
	
	  return CmdItem;
	})(React.Component);
	
	//分页栏
	
	var Pager = (function (_React$Component3) {
	  function Pager(props) {
	    _classCallCheck(this, Pager);
	
	    _get(Object.getPrototypeOf(Pager.prototype), 'constructor', this).call(this, props);
	    this.skipTo = this.skipTo.bind(this);
	  }
	
	  _inherits(Pager, _React$Component3);
	
	  _createClass(Pager, [{
	    key: '_getFirstItem',
	
	    //获取首页按钮
	    value: function _getFirstItem() {
	      var self = this,
	          props = self.props,
	          current = props.current,
	          disabled = current === 0,
	          label = props.previousLabel || '«';
	
	      return React.createElement(CmdItem, { disabled: disabled, text: label, skipTo: this.skipTo, page: current - 1 });
	    }
	  }, {
	    key: '_getLastItem',
	
	    //获取最后一页按钮
	    value: function _getLastItem() {
	      var self = this,
	          total = self.props.total,
	          current = self.props.current,
	          disabled = current === total - 1,
	          label = self.props.nextLabel || '»';
	
	      return React.createElement(CmdItem, { disabled: disabled, text: label, skipTo: this.skipTo, page: current + 1 });
	    }
	  }, {
	    key: '_getItems',
	
	    //获取所有数字按钮
	    value: function _getItems() {
	      var self = this,
	          total = self.props.total,
	          current = self.props.current,
	          rst = [],
	          from = 0,
	          active,
	          skip = 2,
	          to = total - 1;
	
	      if (current > skip) {
	        from = current - skip;
	      }
	      if (total - current > skip) {
	        to = current + skip;
	      }
	      if (from !== 0) {
	        rst.push(React.createElement(PagerItem, { text: 1, skipTo: this.skipTo, page: 0 }));
	        if (from > 1) {
	          rst.push(React.createElement(PagerItem, { text: '...', disabled: true }));
	        }
	      }
	
	      for (var i = from; i <= to; i++) {
	        active = current === i;
	        rst.push(React.createElement(PagerItem, { text: i + 1, active: active, skipTo: this.skipTo, page: i }));
	      }
	
	      if (to < total - 1) {
	        active = current === total - 1;
	        if (to < total - 2) {
	          rst.push(React.createElement(PagerItem, { text: '...', disabled: true }));
	        }
	        rst.push(React.createElement(PagerItem, { text: total, skipTo: this.skipTo, page: total - 1 }));
	      }
	      return rst;
	    }
	  }, {
	    key: 'skipTo',
	
	    /**
	     * 跳转到对应的节点
	     * @param  {Number} page 页码
	     */
	    value: function skipTo(page) {
	      var handler = this.props.onSkipTo;
	      if (handler) {
	        handler(page);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var self = this,
	          first = self._getFirstItem(),
	          last = self._getLastItem(),
	          items = self._getItems();
	
	      var className = 'rc-pager';
	      if (this.props.className) {
	        className += ' ' + this.props.className;
	      }
	
	      return React.createElement(
	        'ul',
	        { className: className },
	        first,
	        items,
	        last
	      );
	    }
	  }]);
	
	  return Pager;
	})(React.Component);
	
	module.exports = Pager;

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var REACT_ELEMENT_TYPE =
	  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
	  0xeac7;
	
	var emptyFunction = __webpack_require__(65);
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	var didWarnAboutMaps = false;
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	function getIteratorFn(maybeIterable) {
	  var iteratorFn =
	    maybeIterable &&
	    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
	      maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function(match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (
	    children === null ||
	    type === 'string' ||
	    type === 'number' ||
	    // The following is inlined from ReactElement. This means we can optimize
	    // some checks. React Fiber also inlines this logic for similar purposes.
	    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
	  ) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
	    );
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      if (false) {
	        // Warn about using Maps as children
	        if (iteratorFn === children.entries) {
	          warning(
	            didWarnAboutMaps,
	            'Using Maps as children is unsupported and will likely yield ' +
	              'unexpected results. Convert it to a sequence/iterable of keyed ' +
	              'ReactElements instead.'
	          );
	          didWarnAboutMaps = true;
	        }
	      }
	
	      var iterator = iteratorFn.call(children);
	      var step;
	      var ii = 0;
	      while (!(step = iterator.next()).done) {
	        child = step.value;
	        nextName = nextNamePrefix + getComponentKey(child, ii++);
	        subtreeCount += traverseAllChildrenImpl(
	          child,
	          nextName,
	          callback,
	          traverseContext
	        );
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum =
	          ' If you meant to render a collection of children, use an array ' +
	          'instead or wrap the object using createFragment(object) from the ' +
	          'React add-ons.';
	      }
	      var childrenString = '' + children;
	      invariant(
	        false,
	        'Objects are not valid as a React child (found: %s).%s',
	        childrenString === '[object Object]'
	          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
	          : childrenString,
	        addendum
	      );
	    }
	  }
	
	  return subtreeCount;
	}
	
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	function cloneAndReplaceKey(oldElement, newKey) {
	  return React.cloneElement(
	    oldElement,
	    {key: newKey},
	    oldElement.props !== undefined ? oldElement.props.children : undefined
	  );
	}
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  );
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function() {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(
	      mappedChild,
	      result,
	      childKey,
	      emptyFunction.thatReturnsArgument
	    );
	  } else if (mappedChild != null) {
	    if (React.isValidElement(mappedChild)) {
	      mappedChild = cloneAndReplaceKey(
	        mappedChild,
	        // Keep both the (mapped) and old keys if they differ, just as
	        // traverseAllChildren used to do for objects as children
	        keyPrefix +
	          (mappedChild.key && (!child || child.key !== mappedChild.key)
	            ? escapeUserProvidedKey(mappedChild.key) + '/'
	            : '') +
	          childKey
	      );
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(
	    array,
	    escapedPrefix,
	    func,
	    context
	  );
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	function createReactFragment(object) {
	  if (typeof object !== 'object' || !object || Array.isArray(object)) {
	    warning(
	      false,
	      'React.addons.createFragment only accepts a single object. Got: %s',
	      object
	    );
	    return object;
	  }
	  if (React.isValidElement(object)) {
	    warning(
	      false,
	      'React.addons.createFragment does not accept a ReactElement ' +
	        'without a wrapper object.'
	    );
	    return object;
	  }
	
	  invariant(
	    object.nodeType !== 1,
	    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
	      'elements are not valid children of React components.'
	  );
	
	  var result = [];
	
	  for (var key in object) {
	    if (false) {
	      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	        warning(
	          false,
	          'React.addons.createFragment(...): Child objects should have ' +
	            'non-numeric keys so ordering is preserved.'
	        );
	        warnedAboutNumeric = true;
	      }
	    }
	    mapIntoWithKeyPrefixInternal(
	      object[key],
	      result,
	      key,
	      emptyFunction.thatReturnsArgument
	    );
	  }
	
	  return result;
	}
	
	module.exports = createReactFragment;


/***/ }),
/* 2766 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.yuv2rgb = yuv2rgb;
	exports.rgb2yuv = rgb2yuv;
	function yuv2rgb(yuv) {
	  var y = yuv[0],
	      u = yuv[1],
	      v = yuv[2],
	      r,
	      g,
	      b;
	
	  r = y * 1 + u * 0 + v * 1.13983;
	  g = y * 1 + u * -0.39465 + v * -0.58060;
	  b = y * 1 + u * 2.02311 + v * 0;
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function rgb2yuv(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  var y = r * 0.299 + g * 0.587 + b * 0.114;
	  var u = r * -0.14713 + g * -0.28886 + b * 0.436;
	  var v = r * 0.615 + g * -0.51499 + b * -0.10001;
	
	  return [y, u, v];
	};

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(1592);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _autoprefix = __webpack_require__(2768);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function autoprefixes(styles) {
	  return Object.keys(styles).reduce(function (obj, key) {
	    return obj[key] = (0, _autoprefix2.default)(styles[key]), obj;
	  }, {});
	}
	
	var styles = autoprefixes({
	  wrapper: {
	    position: 'fixed',
	    width: 0,
	    height: 0,
	    top: 0,
	    left: 0
	  },
	
	  dim: {
	    position: 'fixed',
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    zIndex: 0,
	    background: 'rgba(0, 0, 0, 0.2)',
	    opacity: 1
	  },
	
	  dimAppear: {
	    opacity: 0
	  },
	
	  dimTransparent: {
	    pointerEvents: 'none'
	  },
	
	  dimHidden: {
	    opacity: 0
	  },
	
	  dock: {
	    position: 'fixed',
	    zIndex: 1,
	    boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
	    background: 'white',
	    left: 0,
	    top: 0,
	    width: '100%',
	    height: '100%'
	  },
	
	  dockHidden: {
	    opacity: 0
	  },
	
	  dockResizing: {
	    transition: 'none'
	  },
	
	  dockContent: {
	    width: '100%',
	    height: '100%',
	    overflow: 'auto'
	  },
	
	  resizer: {
	    position: 'absolute',
	    zIndex: 2,
	    opacity: 0
	  }
	});
	
	function getTransitions(duration) {
	  return ['left', 'top', 'width', 'height'].map(function (p) {
	    return p + ' ' + duration / 1000 + 's ease-out';
	  });
	}
	
	function getDockStyles(_ref, _ref2) {
	  var fluid = _ref.fluid;
	  var dockStyle = _ref.dockStyle;
	  var dockHiddenStyle = _ref.dockHiddenStyle;
	  var duration = _ref.duration;
	  var position = _ref.position;
	  var isVisible = _ref.isVisible;
	  var size = _ref2.size;
	  var isResizing = _ref2.isResizing;
	  var fullWidth = _ref2.fullWidth;
	  var fullHeight = _ref2.fullHeight;
	
	  var posStyle = void 0;
	  var absSize = fluid ? size * 100 + '%' : size + 'px';
	
	  function getRestSize(fullSize) {
	    return fluid ? 100 - size * 100 + '%' : fullSize - size + 'px';
	  }
	
	  switch (position) {
	    case 'left':
	      posStyle = {
	        width: absSize,
	        left: isVisible ? 0 : '-' + absSize
	      };
	      break;
	    case 'right':
	      posStyle = {
	        left: isVisible ? getRestSize(fullWidth) : fullWidth,
	        width: absSize
	      };
	      break;
	    case 'top':
	      posStyle = {
	        top: isVisible ? 0 : '-' + absSize,
	        height: absSize
	      };
	      break;
	    case 'bottom':
	      posStyle = {
	        top: isVisible ? getRestSize(fullHeight) : fullHeight,
	        height: absSize
	      };
	      break;
	  }
	
	  var transitions = getTransitions(duration);
	
	  return [styles.dock, (0, _autoprefix2.default)({
	    transition: [].concat(_toConsumableArray(transitions), [!isVisible && 'opacity 0.01s linear ' + duration / 1000 + 's']).filter(function (t) {
	      return t;
	    }).join(',')
	  }), dockStyle, (0, _autoprefix2.default)(posStyle), isResizing && styles.dockResizing, !isVisible && styles.dockHidden, !isVisible && dockHiddenStyle];
	}
	
	function getDimStyles(_ref3, _ref4) {
	  var dimMode = _ref3.dimMode;
	  var dimStyle = _ref3.dimStyle;
	  var duration = _ref3.duration;
	  var isVisible = _ref3.isVisible;
	  var isTransitionStarted = _ref4.isTransitionStarted;
	
	  return [styles.dim, (0, _autoprefix2.default)({
	    transition: 'opacity ' + duration / 1000 + 's ease-out'
	  }), dimStyle, dimMode === 'transparent' && styles.dimTransparent, !isVisible && styles.dimHidden, isTransitionStarted && isVisible && styles.dimAppear, isTransitionStarted && !isVisible && styles.dimDisappear];
	}
	
	function getResizerStyles(position) {
	  var resizerStyle = void 0;
	  var size = 10;
	
	  switch (position) {
	    case 'left':
	      resizerStyle = {
	        right: -size / 2,
	        width: size,
	        top: 0,
	        height: '100%',
	        cursor: 'col-resize'
	      };
	      break;
	    case 'right':
	      resizerStyle = {
	        left: -size / 2,
	        width: size,
	        top: 0,
	        height: '100%',
	        cursor: 'col-resize'
	      };
	      break;
	    case 'top':
	      resizerStyle = {
	        bottom: -size / 2,
	        height: size,
	        left: 0,
	        width: '100%',
	        cursor: 'row-resize'
	      };
	      break;
	    case 'bottom':
	      resizerStyle = {
	        top: -size / 2,
	        height: size,
	        left: 0,
	        width: '100%',
	        cursor: 'row-resize'
	      };
	      break;
	  }
	
	  return [styles.resizer, (0, _autoprefix2.default)(resizerStyle)];
	}
	
	function getFullSize(position, fullWidth, fullHeight) {
	  return position === 'left' || position === 'right' ? fullWidth : fullHeight;
	}
	
	var Dock = (_temp = _class = function (_Component) {
	  _inherits(Dock, _Component);
	
	  function Dock(props) {
	    _classCallCheck(this, Dock);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dock).call(this, props));
	
	    _this.transitionEnd = function () {
	      _this.setState({ isTransitionStarted: false });
	    };
	
	    _this.hideDim = function () {
	      if (!_this.props.isVisible) {
	        _this.setState({ isDimHidden: true });
	      }
	    };
	
	    _this.handleDimClick = function () {
	      if (_this.props.dimMode === 'opaque') {
	        _this.props.onVisibleChange && _this.props.onVisibleChange(false);
	      }
	    };
	
	    _this.handleResize = function () {
	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(_this.updateWindowSize.bind(_this, true));
	      } else {
	        _this.updateWindowSize(true);
	      }
	    };
	
	    _this.updateWindowSize = function (windowResize) {
	      var sizeState = {
	        fullWidth: window.innerWidth,
	        fullHeight: window.innerHeight
	      };
	
	      if (windowResize) {
	        _this.setState(_extends({}, sizeState, {
	          isResizing: true,
	          isWindowResizing: windowResize
	        }));
	
	        _this.debouncedUpdateWindowSizeEnd();
	      } else {
	        _this.setState(sizeState);
	      }
	    };
	
	    _this.updateWindowSizeEnd = function () {
	      _this.setState({
	        isResizing: false,
	        isWindowResizing: false
	      });
	    };
	
	    _this.debouncedUpdateWindowSizeEnd = (0, _lodash2.default)(_this.updateWindowSizeEnd, 30);
	
	    _this.handleWrapperLeave = function () {
	      _this.setState({ isResizing: false });
	    };
	
	    _this.handleMouseDown = function () {
	      _this.setState({ isResizing: true });
	    };
	
	    _this.handleMouseUp = function () {
	      _this.setState({ isResizing: false });
	    };
	
	    _this.handleMouseMove = function (e) {
	      if (!_this.state.isResizing || _this.state.isWindowResizing) return;
	      e.preventDefault();
	
	      var _this$props = _this.props;
	      var position = _this$props.position;
	      var fluid = _this$props.fluid;
	      var _this$state = _this.state;
	      var fullWidth = _this$state.fullWidth;
	      var fullHeight = _this$state.fullHeight;
	      var isControlled = _this$state.isControlled;
	      var x = e.clientX;
	      var y = e.clientY;
	
	      var size = void 0;
	
	      switch (position) {
	        case 'left':
	          size = fluid ? x / fullWidth : x;
	          break;
	        case 'right':
	          size = fluid ? (fullWidth - x) / fullWidth : fullWidth - x;
	          break;
	        case 'top':
	          size = fluid ? y / fullHeight : y;
	          break;
	        case 'bottom':
	          size = fluid ? (fullHeight - y) / fullHeight : fullHeight - y;
	          break;
	      }
	
	      _this.props.onSizeChange && _this.props.onSizeChange(size);
	
	      if (!isControlled) {
	        _this.setState({ size: size });
	      }
	    };
	
	    _this.state = {
	      isControlled: typeof props.size !== 'undefined',
	      size: props.size || props.defaultSize,
	      isDimHidden: !props.isVisible,
	      fullWidth: typeof window !== 'undefined' && window.innerWidth,
	      fullHeight: typeof window !== 'undefined' && window.innerHeight,
	      isTransitionStarted: false,
	      isWindowResizing: false
	    };
	    return _this;
	  }
	
	  _createClass(Dock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('mouseup', this.handleMouseUp);
	      window.addEventListener('mousemove', this.handleMouseMove);
	      window.addEventListener('resize', this.handleResize);
	
	      if (!window.fullWidth) {
	        this.updateWindowSize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('mouseup', this.handleMouseUp);
	      window.removeEventListener('mousemove', this.handleMouseMove);
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isControlled = typeof nextProps.size !== 'undefined';
	
	      this.setState({ isControlled: isControlled });
	
	      if (isControlled && this.props.size !== nextProps.size) {
	        this.setState({ size: nextProps.size });
	      } else if (this.props.fluid !== nextProps.fluid) {
	        this.updateSize(nextProps);
	      }
	
	      if (this.props.isVisible !== nextProps.isVisible) {
	        this.setState({
	          isTransitionStarted: true
	        });
	      }
	    }
	  }, {
	    key: 'updateSize',
	    value: function updateSize(props) {
	      var _state = this.state;
	      var fullWidth = _state.fullWidth;
	      var fullHeight = _state.fullHeight;
	
	
	      this.setState({
	        size: props.fluid ? this.state.size / getFullSize(props.position, fullWidth, fullHeight) : getFullSize(props.position, fullWidth, fullHeight) * this.state.size
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.isVisible !== prevProps.isVisible) {
	        if (!this.props.isVisible) {
	          window.setTimeout(function () {
	            return _this2.hideDim();
	          }, this.props.duration);
	        } else {
	          this.setState({ isDimHidden: false });
	        }
	
	        window.setTimeout(function () {
	          return _this2.setState({ isTransitionStarted: false });
	        }, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var zIndex = _props.zIndex;
	      var dimMode = _props.dimMode;
	      var position = _props.position;
	      var isVisible = _props.isVisible;
	      var _state2 = this.state;
	      var isResizing = _state2.isResizing;
	      var size = _state2.size;
	      var isDimHidden = _state2.isDimHidden;
	
	
	      var dimStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDimStyles(this.props, this.state))));
	      var dockStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDockStyles(this.props, this.state))));
	      var resizerStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getResizerStyles(position))));
	
	      return _react2.default.createElement(
	        'div',
	        { style: Object.assign({}, styles.wrapper, { zIndex: zIndex }) },
	        dimMode !== 'none' && !isDimHidden && _react2.default.createElement('div', { style: dimStyles, onClick: this.handleDimClick }),
	        _react2.default.createElement(
	          'div',
	          { style: dockStyles },
	          _react2.default.createElement('div', { style: resizerStyles,
	            onMouseDown: this.handleMouseDown }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.dockContent },
	            typeof children === 'function' ? children({
	              position: position,
	              isResizing: isResizing,
	              size: size,
	              isVisible: isVisible
	            }) : children
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dock;
	}(_react.Component), _class.propTypes = {
	  position: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']),
	  zIndex: _propTypes2.default.number,
	  fluid: _propTypes2.default.bool,
	  size: _propTypes2.default.number,
	  defaultSize: _propTypes2.default.number,
	  dimMode: _propTypes2.default.oneOf(['none', 'transparent', 'opaque']),
	  isVisible: _propTypes2.default.bool,
	  onVisibleChange: _propTypes2.default.func,
	  onSizeChange: _propTypes2.default.func,
	  dimStyle: _propTypes2.default.object,
	  dockStyle: _propTypes2.default.object,
	  duration: _propTypes2.default.number
	}, _class.defaultProps = {
	  position: 'left',
	  zIndex: 99999999,
	  fluid: true,
	  defaultSize: 0.3,
	  dimMode: 'opaque',
	  duration: 200
	}, _temp);
	exports.default = Dock;

/***/ }),
/* 2768 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = autoprefix;
	// Same as https://github.com/SimenB/react-vendor-prefixes/blob/master/src/index.js,
	// but dumber
	
	var vendorSpecificProperties = ['animation', 'animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction', 'appearance', 'backfaceVisibility', 'backgroundClip', 'borderImage', 'borderImageSlice', 'boxSizing', 'boxShadow', 'contentColumns', 'transform', 'transformOrigin', 'transformStyle', 'transition', 'transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction', 'perspective', 'perspectiveOrigin', 'userSelect'];
	
	var prefixes = ['Moz', 'Webkit', 'ms', 'O'];
	
	function prefixProp(key, value) {
	  return prefixes.reduce(function (obj, pre) {
	    return obj[pre + key[0].toUpperCase() + key.substr(1)] = value, obj;
	  }, {});
	}
	
	function autoprefix(style) {
	  return Object.keys(style).reduce(function (obj, key) {
	    return vendorSpecificProperties.indexOf(key) !== -1 ? _extends({}, obj, prefixProp(key, style[key])) : obj;
	  }, style);
	}

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dock = __webpack_require__(2767);
	
	var _Dock2 = _interopRequireDefault(_Dock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dock2.default;

/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(320);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(2770);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ }),
/* 2772 */
66,
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = undefined;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONArrow = __webpack_require__(756);
	
	var _JSONArrow2 = _interopRequireDefault(_JSONArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ItemRange = (_temp = _class = function (_React$Component) {
	  (0, _inherits3['default'])(ItemRange, _React$Component);
	
	  function ItemRange(props) {
	    (0, _classCallCheck3['default'])(this, ItemRange);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.state = { expanded: false };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  ItemRange.prototype.render = function render() {
	    var _props = this.props,
	        styling = _props.styling,
	        from = _props.from,
	        to = _props.to,
	        renderChildNodes = _props.renderChildNodes,
	        nodeType = _props.nodeType;
	
	
	    return this.state.expanded ? _react2['default'].createElement(
	      'div',
	      styling('itemRange', this.state.expanded),
	      renderChildNodes(this.props, from, to)
	    ) : _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, styling('itemRange', this.state.expanded), {
	        onClick: this.handleClick
	      }),
	      _react2['default'].createElement(_JSONArrow2['default'], {
	        nodeType: nodeType,
	        styling: styling,
	        expanded: false,
	        onClick: this.handleClick,
	        arrowStyle: 'double'
	      }),
	      from + ' ... ' + to
	    );
	  };
	
	  ItemRange.prototype.handleClick = function handleClick() {
	    this.setState({ expanded: !this.state.expanded });
	  };
	
	  return ItemRange;
	}(_react2['default'].Component), _class.propTypes = {
	  styling: _propTypes2['default'].func.isRequired,
	  from: _propTypes2['default'].number.isRequired,
	  to: _propTypes2['default'].number.isRequired,
	  renderChildNodes: _propTypes2['default'].func.isRequired,
	  nodeType: _propTypes2['default'].string.isRequired
	}, _temp);
	exports['default'] = ItemRange;

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONNestedNode = __webpack_require__(400);
	
	var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Returns the "n Items" string for this node,
	// generating and caching it if it hasn't been created yet.
	function createItemString(data) {
	  return data.length + ' ' + (data.length !== 1 ? 'items' : 'item');
	}
	
	// Configures <JSONNestedNode> to render an Array
	var JSONArrayNode = function JSONArrayNode(_ref) {
	  var data = _ref.data,
	      props = (0, _objectWithoutProperties3['default'])(_ref, ['data']);
	  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
	    data: data,
	    nodeType: 'Array',
	    nodeTypeIndicator: '[]',
	    createItemString: createItemString,
	    expandable: data.length > 0
	  }));
	};
	
	JSONArrayNode.propTypes = {
	  data: _propTypes2['default'].array
	};
	
	exports['default'] = JSONArrayNode;

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getIterator2 = __webpack_require__(239);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _isSafeInteger = __webpack_require__(1183);
	
	var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);
	
	exports['default'] = JSONIterableNode;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JSONNestedNode = __webpack_require__(400);
	
	var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Returns the "n Items" string for this node,
	// generating and caching it if it hasn't been created yet.
	function createItemString(data, limit) {
	  var count = 0;
	  var hasMore = false;
	  if ((0, _isSafeInteger2['default'])(data.size)) {
	    count = data.size;
	  } else {
	    for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3['default'])(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var entry = _ref;
	      // eslint-disable-line no-unused-vars
	      if (limit && count + 1 > limit) {
	        hasMore = true;
	        break;
	      }
	      count += 1;
	    }
	  }
	  return '' + (hasMore ? '>' : '') + count + ' ' + (count !== 1 ? 'entries' : 'entry');
	}
	
	// Configures <JSONNestedNode> to render an iterable
	function JSONIterableNode(_ref2) {
	  var props = (0, _objectWithoutProperties3['default'])(_ref2, []);
	
	  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
	    nodeType: 'Iterable',
	    nodeTypeIndicator: '()',
	    createItemString: createItemString
	  }));
	}

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getOwnPropertyNames = __webpack_require__(487);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONNestedNode = __webpack_require__(400);
	
	var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Returns the "n Items" string for this node,
	// generating and caching it if it hasn't been created yet.
	function createItemString(data) {
	  var len = (0, _getOwnPropertyNames2['default'])(data).length;
	  return len + ' ' + (len !== 1 ? 'keys' : 'key');
	}
	
	// Configures <JSONNestedNode> to render an Object
	var JSONObjectNode = function JSONObjectNode(_ref) {
	  var data = _ref.data,
	      props = (0, _objectWithoutProperties3['default'])(_ref, ['data']);
	  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
	    data: data,
	    nodeType: 'Object',
	    nodeTypeIndicator: props.nodeType === 'Error' ? 'Error()' : '{}',
	    createItemString: createItemString,
	    expandable: (0, _getOwnPropertyNames2['default'])(data).length > 0
	  }));
	};
	
	JSONObjectNode.propTypes = {
	  data: _propTypes2['default'].object,
	  nodeType: _propTypes2['default'].string
	};
	
	exports['default'] = JSONObjectNode;

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Renders simple values (eg. strings, numbers, booleans, etc)
	 */
	
	var JSONValueNode = function JSONValueNode(_ref) {
	  var nodeType = _ref.nodeType,
	      styling = _ref.styling,
	      labelRenderer = _ref.labelRenderer,
	      keyPath = _ref.keyPath,
	      valueRenderer = _ref.valueRenderer,
	      value = _ref.value,
	      valueGetter = _ref.valueGetter;
	  return _react2['default'].createElement(
	    'li',
	    styling('value', nodeType, keyPath),
	    _react2['default'].createElement(
	      'label',
	      styling(['label', 'valueLabel'], nodeType, keyPath),
	      labelRenderer(keyPath, nodeType, false, false)
	    ),
	    _react2['default'].createElement(
	      'span',
	      styling('valueText', nodeType, keyPath),
	      valueRenderer.apply(undefined, [valueGetter(value), value].concat(keyPath))
	    )
	  );
	};
	
	JSONValueNode.propTypes = {
	  nodeType: _propTypes2['default'].string.isRequired,
	  styling: _propTypes2['default'].func.isRequired,
	  labelRenderer: _propTypes2['default'].func.isRequired,
	  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
	  valueRenderer: _propTypes2['default'].func.isRequired,
	  value: _propTypes2['default'].any,
	  valueGetter: _propTypes2['default'].func
	};
	
	JSONValueNode.defaultProps = {
	  valueGetter: function valueGetter(value) {
	    return value;
	  }
	};
	
	exports['default'] = JSONValueNode;

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(13);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _solarized = __webpack_require__(2781);
	
	var _solarized2 = _interopRequireDefault(_solarized);
	
	var _reactBase16Styling = __webpack_require__(755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var colorMap = function colorMap(theme) {
	  return {
	    BACKGROUND_COLOR: theme.base00,
	    TEXT_COLOR: theme.base07,
	    STRING_COLOR: theme.base0B,
	    DATE_COLOR: theme.base0B,
	    NUMBER_COLOR: theme.base09,
	    BOOLEAN_COLOR: theme.base09,
	    NULL_COLOR: theme.base08,
	    UNDEFINED_COLOR: theme.base08,
	    FUNCTION_COLOR: theme.base08,
	    SYMBOL_COLOR: theme.base08,
	    LABEL_COLOR: theme.base0D,
	    ARROW_COLOR: theme.base0D,
	    ITEM_STRING_COLOR: theme.base0B,
	    ITEM_STRING_EXPANDED_COLOR: theme.base03
	  };
	};
	
	var valueColorMap = function valueColorMap(colors) {
	  return {
	    String: colors.STRING_COLOR,
	    Date: colors.DATE_COLOR,
	    Number: colors.NUMBER_COLOR,
	    Boolean: colors.BOOLEAN_COLOR,
	    Null: colors.NULL_COLOR,
	    Undefined: colors.UNDEFINED_COLOR,
	    Function: colors.FUNCTION_COLOR,
	    Symbol: colors.SYMBOL_COLOR
	  };
	};
	
	var getDefaultThemeStyling = function getDefaultThemeStyling(theme) {
	  var colors = colorMap(theme);
	
	  return {
	    tree: {
	      border: 0,
	      padding: 0,
	      marginTop: '0.5em',
	      marginBottom: '0.5em',
	      marginLeft: '0.125em',
	      marginRight: 0,
	      listStyle: 'none',
	      MozUserSelect: 'none',
	      WebkitUserSelect: 'none',
	      backgroundColor: colors.BACKGROUND_COLOR
	    },
	
	    value: function value(_ref, nodeType, keyPath) {
	      var style = _ref.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          paddingTop: '0.25em',
	          paddingRight: 0,
	          marginLeft: '0.875em',
	          WebkitUserSelect: 'text',
	          MozUserSelect: 'text',
	          wordWrap: 'break-word',
	          paddingLeft: keyPath.length > 1 ? '2.125em' : '1.25em',
	          textIndent: '-0.5em',
	          wordBreak: 'break-all'
	        })
	      };
	    },
	
	    label: {
	      display: 'inline-block',
	      color: colors.LABEL_COLOR
	    },
	
	    valueLabel: {
	      margin: '0 0.5em 0 0'
	    },
	
	    valueText: function valueText(_ref2, nodeType) {
	      var style = _ref2.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          color: valueColorMap(colors)[nodeType]
	        })
	      };
	    },
	
	    itemRange: function itemRange(_ref3, expanded) {
	      var style = _ref3.style;
	      return {
	        style: {
	          paddingTop: expanded ? 0 : '0.25em',
	          cursor: 'pointer',
	          color: colors.LABEL_COLOR
	        }
	      };
	    },
	
	    arrow: function arrow(_ref4, nodeType, expanded) {
	      var style = _ref4.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          marginLeft: 0,
	          transition: '150ms',
	          WebkitTransition: '150ms',
	          MozTransition: '150ms',
	          WebkitTransform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
	          MozTransform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
	          transform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
	          transformOrigin: '45% 50%',
	          WebkitTransformOrigin: '45% 50%',
	          MozTransformOrigin: '45% 50%',
	          position: 'relative',
	          lineHeight: '1.1em',
	          fontSize: '0.75em'
	        })
	      };
	    },
	
	    arrowContainer: function arrowContainer(_ref5, arrowStyle) {
	      var style = _ref5.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          display: 'inline-block',
	          paddingRight: '0.5em',
	          paddingLeft: arrowStyle === 'double' ? '1em' : 0,
	          cursor: 'pointer'
	        })
	      };
	    },
	
	    arrowSign: {
	      color: colors.ARROW_COLOR
	    },
	
	    arrowSignInner: {
	      position: 'absolute',
	      top: 0,
	      left: '-0.4em'
	    },
	
	    nestedNode: function nestedNode(_ref6, keyPath, nodeType, expanded, expandable) {
	      var style = _ref6.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          position: 'relative',
	          paddingTop: '0.25em',
	          marginLeft: keyPath.length > 1 ? '0.875em' : 0,
	          paddingLeft: !expandable ? '1.125em' : 0
	        })
	      };
	    },
	
	    rootNode: {
	      padding: 0,
	      margin: 0
	    },
	
	    nestedNodeLabel: function nestedNodeLabel(_ref7, keyPath, nodeType, expanded, expandable) {
	      var style = _ref7.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          margin: 0,
	          padding: 0,
	          WebkitUserSelect: expandable ? 'inherit' : 'text',
	          MozUserSelect: expandable ? 'inherit' : 'text',
	          cursor: expandable ? 'pointer' : 'default'
	        })
	      };
	    },
	
	    nestedNodeItemString: function nestedNodeItemString(_ref8, keyPath, nodeType, expanded) {
	      var style = _ref8.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          paddingLeft: '0.5em',
	          cursor: 'default',
	          color: expanded ? colors.ITEM_STRING_EXPANDED_COLOR : colors.ITEM_STRING_COLOR
	        })
	      };
	    },
	
	    nestedNodeItemType: {
	      marginLeft: '0.3em',
	      marginRight: '0.3em'
	    },
	
	    nestedNodeChildren: function nestedNodeChildren(_ref9, nodeType, expanded) {
	      var style = _ref9.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          padding: 0,
	          margin: 0,
	          listStyle: 'none',
	          display: expanded ? 'block' : 'none'
	        })
	      };
	    },
	
	    rootNodeChildren: {
	      padding: 0,
	      margin: 0,
	      listStyle: 'none'
	    }
	  };
	};
	
	exports['default'] = (0, _reactBase16Styling.createStyling)(getDefaultThemeStyling, {
	  defaultBase16: _solarized2['default']
	});

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(239);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getOwnPropertyNames = __webpack_require__(487);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _keys = __webpack_require__(142);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports['default'] = getCollectionEntries;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getLength(type, collection) {
	  if (type === 'Object') {
	    return (0, _keys2['default'])(collection).length;
	  } else if (type === 'Array') {
	    return collection.length;
	  }
	
	  return Infinity;
	}
	
	function isIterableMap(collection) {
	  return typeof collection.set === 'function';
	}
	
	function getEntries(type, collection, sortObjectKeys) {
	  var from = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	  var to = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;
	
	  var res = void 0;
	
	  if (type === 'Object') {
	    var keys = (0, _getOwnPropertyNames2['default'])(collection);
	
	    if (typeof sortObjectKeys !== 'undefined') {
	      keys.sort(sortObjectKeys);
	    }
	
	    keys = keys.slice(from, to + 1);
	
	    res = {
	      entries: keys.map(function (key) {
	        return { key: key, value: collection[key] };
	      })
	    };
	  } else if (type === 'Array') {
	    res = {
	      entries: collection.slice(from, to + 1).map(function (val, idx) {
	        return { key: idx + from, value: val };
	      })
	    };
	  } else {
	    var idx = 0;
	    var entries = [];
	    var done = true;
	
	    var isMap = isIterableMap(collection);
	
	    for (var _iterator = collection, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3['default'])(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var item = _ref;
	
	      if (idx > to) {
	        done = false;
	        break;
	      }if (from <= idx) {
	        if (isMap && Array.isArray(item)) {
	          if (typeof item[0] === 'string' || typeof item[0] === 'number') {
	            entries.push({ key: item[0], value: item[1] });
	          } else {
	            entries.push({ key: '[entry ' + idx + ']', value: {
	                '[key]': item[0],
	                '[value]': item[1]
	              } });
	          }
	        } else {
	          entries.push({ key: idx, value: item });
	        }
	      }
	      idx++;
	    }
	
	    res = {
	      hasMore: !done,
	      entries: entries
	    };
	  }
	
	  return res;
	}
	
	function getRanges(from, to, limit) {
	  var ranges = [];
	  while (to - from > limit * limit) {
	    limit = limit * limit;
	  }
	  for (var i = from; i <= to; i += limit) {
	    ranges.push({ from: i, to: Math.min(to, i + limit - 1) });
	  }
	
	  return ranges;
	}
	
	function getCollectionEntries(type, collection, sortObjectKeys, limit) {
	  var from = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	  var to = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Infinity;
	
	  var getEntriesBound = getEntries.bind(null, type, collection, sortObjectKeys);
	
	  if (!limit) {
	    return getEntriesBound().entries;
	  }
	
	  var isSubset = to < Infinity;
	  var length = Math.min(to - from, getLength(type, collection));
	
	  if (type !== 'Iterable') {
	    if (length <= limit || limit < 7) {
	      return getEntriesBound(from, to).entries;
	    }
	  } else {
	    if (length <= limit && !isSubset) {
	      return getEntriesBound(from, to).entries;
	    }
	  }
	
	  var limitedEntries = void 0;
	  if (type === 'Iterable') {
	    var _getEntriesBound = getEntriesBound(from, from + limit - 1),
	        hasMore = _getEntriesBound.hasMore,
	        entries = _getEntriesBound.entries;
	
	    limitedEntries = hasMore ? [].concat(entries, getRanges(from + limit, from + 2 * limit - 1, limit)) : entries;
	  } else {
	    limitedEntries = isSubset ? getRanges(from, to, limit) : [].concat(getEntriesBound(0, limit - 5).entries, getRanges(limit - 4, length - 5, limit), getEntriesBound(length - 4, length - 1).entries);
	  }
	
	  return limitedEntries;
	}

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(488);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	exports['default'] = objType;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function objType(obj) {
	  var type = Object.prototype.toString.call(obj).slice(8, -1);
	  if (type === 'Object' && typeof obj[_iterator2['default']] === 'function') {
	    return 'Iterable';
	  }
	
	  return type;
	}

/***/ }),
/* 2781 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'solarized',
	  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
	  base00: '#002b36',
	  base01: '#073642',
	  base02: '#586e75',
	  base03: '#657b83',
	  base04: '#839496',
	  base05: '#93a1a1',
	  base06: '#eee8d5',
	  base07: '#fdf6e3',
	  base08: '#dc322f',
	  base09: '#cb4b16',
	  base0A: '#b58900',
	  base0B: '#859900',
	  base0C: '#2aa198',
	  base0D: '#268bd2',
	  base0E: '#6c71c4',
	  base0F: '#d33682'
	};

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var xtend = __webpack_require__(139);
	
	function astToReact(node, options) {
	  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  if (node.type === 'text') {
	    return node.value;
	  }
	
	  var renderer = options.renderers[node.type];
	  if (typeof renderer !== 'function' && typeof renderer !== 'string') {
	    throw new Error('Renderer for type `' + node.type + '` not defined or is not renderable');
	  }
	
	  var pos = node.position.start;
	  var key = [node.type, pos.line, pos.column].join('-');
	  var nodeProps = getNodeProps(node, key, options, renderer, parent, index);
	
	  return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);
	
	  function resolveChildren() {
	    return node.children && node.children.map(function (childNode, i) {
	      return astToReact(childNode, options, { node: node, props: nodeProps }, i);
	    });
	  }
	}
	
	// eslint-disable-next-line max-params, complexity
	function getNodeProps(node, key, opts, renderer, parent, index) {
	  var props = { key: key
	
	    // `sourcePos` is true if the user wants source information (line/column info from markdown source)
	  };if (opts.sourcePos && node.position) {
	    props['data-sourcepos'] = flattenPosition(node.position);
	  }
	
	  var ref = node.identifier ? opts.definitions[node.identifier] || {} : null;
	
	  switch (node.type) {
	    case 'root':
	      assignDefined(props, { className: opts.className });
	      break;
	    case 'heading':
	      props.level = node.depth;
	      break;
	    case 'list':
	      props.start = node.start;
	      props.ordered = node.ordered;
	      props.tight = !node.loose;
	      break;
	    case 'listItem':
	      props.checked = node.checked;
	      props.tight = !node.loose;
	      props.children = (props.tight ? unwrapParagraphs(node) : node.children).map(function (childNode, i) {
	        return astToReact(childNode, opts, { node: node, props: props }, i);
	      });
	      break;
	    case 'definition':
	      assignDefined(props, { identifier: node.identifier, title: node.title, url: node.url });
	      break;
	    case 'code':
	      assignDefined(props, { language: node.lang });
	      break;
	    case 'inlineCode':
	      props.children = node.value;
	      props.inline = true;
	      break;
	    case 'link':
	      assignDefined(props, {
	        title: node.title || undefined,
	        href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
	      });
	      break;
	    case 'image':
	      assignDefined(props, {
	        alt: node.alt || undefined,
	        title: node.title || undefined,
	        src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
	      });
	      break;
	    case 'linkReference':
	      assignDefined(props, xtend(ref, {
	        href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
	      }));
	      break;
	    case 'imageReference':
	      assignDefined(props, {
	        src: ref.href,
	        title: ref.title || undefined,
	        alt: node.alt || undefined
	      });
	      break;
	    case 'table':
	    case 'tableHead':
	    case 'tableBody':
	      props.columnAlignment = node.align;
	      break;
	    case 'tableRow':
	      props.isHeader = parent.node.type === 'tableHead';
	      props.columnAlignment = parent.props.columnAlignment;
	      break;
	    case 'tableCell':
	      assignDefined(props, {
	        isHeader: parent.props.isHeader,
	        align: parent.props.columnAlignment[index]
	      });
	      break;
	    case 'virtualHtml':
	      props.tag = node.tag;
	      break;
	    case 'html':
	      // @todo find a better way than this
	      props.isBlock = node.position.start.line !== node.position.end.line;
	      props.escapeHtml = opts.escapeHtml;
	      props.skipHtml = opts.skipHtml;
	      break;
	    default:
	  }
	
	  if (typeof renderer !== 'string' && node.value) {
	    props.value = node.value;
	  }
	
	  return props;
	}
	
	function assignDefined(target, attrs) {
	  for (var key in attrs) {
	    if (typeof attrs[key] !== 'undefined') {
	      target[key] = attrs[key];
	    }
	  }
	}
	
	function flattenPosition(pos) {
	  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(String).join('');
	}
	
	function unwrapParagraphs(node) {
	  return node.children.reduce(function (array, child) {
	    return array.concat(child.type === 'paragraph' ? child.children || [] : [child]);
	  }, []);
	}
	
	module.exports = astToReact;

/***/ }),
/* 2783 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getDefinitions(node) {
	  var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (node.children || []).reduce(function (definitions, child) {
	    if (child.type === 'definition') {
	      definitions[child.identifier] = {
	        href: child.url,
	        title: child.title
	      };
	    }
	
	    return getDefinitions(child, definitions);
	  }, defs);
	};

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(294);
	
	exports.ofType = function (types, mode) {
	  return function (node) {
	    types.forEach(function (type) {
	      return visit(node, type, disallow, true);
	    });
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	exports.ifNotMatch = function (allowNode, mode) {
	  return function (node) {
	    visit(node, disallow, true);
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent && !allowNode(node, index, parent)) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	function untangle(node, index, parent, mode) {
	  if (mode === 'remove') {
	    parent.children.splice(index, 1);
	  } else if (mode === 'unwrap') {
	    var args = [index, 1].concat(node.children);
	    Array.prototype.splice.apply(parent.children, args);
	  }
	}

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Naive, simple plugin to match inline nodes without attributes
	 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
	 * For proper HTML support, you'll want a different plugin
	 **/
	var visit = __webpack_require__(294);
	
	var type = 'virtualHtml';
	var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
	var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
	
	module.exports = function (tree) {
	  var open = void 0;
	  var currentParent = void 0;
	  visit(tree, 'html', function (node, index, parent) {
	    if (currentParent !== parent) {
	      open = [];
	      currentParent = parent;
	    }
	
	    var selfClosing = getSelfClosing(node);
	    if (selfClosing) {
	      parent.children.splice(index, 1, {
	        type: type,
	        tag: selfClosing,
	        position: node.position
	      });
	      return true;
	    }
	
	    var current = getSimpleTag(node, parent);
	    if (!current) {
	      return true;
	    }
	
	    var matching = findAndPull(open, current.tag);
	
	    if (matching) {
	      parent.children.splice(index, 0, virtual(current, matching, parent));
	    } else if (!current.opening) {
	      open.push(current);
	    }
	
	    return true;
	  }, true // Iterate in reverse
	  );
	
	  return tree;
	};
	
	function findAndPull(open, matchingTag) {
	  var i = open.length;
	  while (i--) {
	    if (open[i].tag === matchingTag) {
	      return open.splice(i, 1)[0];
	    }
	  }
	
	  return false;
	}
	
	function getSimpleTag(node, parent) {
	  var match = node.value.match(simpleTagRe);
	  return match ? { tag: match[2], opening: !match[1], node: node } : false;
	}
	
	function getSelfClosing(node) {
	  var match = node.value.match(selfClosingRe);
	  return match ? match[1] : false;
	}
	
	function virtual(fromNode, toNode, parent) {
	  var fromIndex = parent.children.indexOf(fromNode.node);
	  var toIndex = parent.children.indexOf(toNode.node);
	
	  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
	  var children = extracted.slice(1, -1);
	  return {
	    type: type,
	    children: children,
	    tag: fromNode.tag,
	    position: {
	      start: fromNode.node.position.start,
	      end: toNode.node.position.end,
	      indent: []
	    }
	  };
	}

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(139);
	var unified = __webpack_require__(3053);
	var parse = __webpack_require__(2986);
	var PropTypes = __webpack_require__(2793);
	var naiveHtml = __webpack_require__(2785);
	var disallowNode = __webpack_require__(2784);
	var astToReact = __webpack_require__(2782);
	var wrapTableRows = __webpack_require__(2789);
	var getDefinitions = __webpack_require__(2783);
	var uriTransformer = __webpack_require__(2788);
	var defaultRenderers = __webpack_require__(2787);
	
	var allTypes = Object.keys(defaultRenderers);
	
	var ReactMarkdown = function ReactMarkdown(props) {
	  var src = props.source || props.children || '';
	
	  if (props.allowedTypes && props.disallowedTypes) {
	    throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
	  }
	
	  var renderers = xtend(defaultRenderers, props.renderers);
	
	  var plugins = [parse].concat(props.plugins || []);
	  var parser = plugins.reduce(applyParserPlugin, unified());
	
	  var rawAst = parser.parse(src);
	  var renderProps = xtend(props, {
	    renderers: renderers,
	    definitions: getDefinitions(rawAst)
	  });
	
	  var astPlugins = determineAstPlugins(props);
	  var ast = astPlugins.reduce(function (node, plugin) {
	    return plugin(node, renderProps);
	  }, rawAst);
	
	  return astToReact(ast, renderProps);
	};
	
	function applyParserPlugin(parser, plugin) {
	  return Array.isArray(plugin) ? parser.use(plugin[0], plugin[1]) : parser.use(plugin);
	}
	
	function determineAstPlugins(props) {
	  var plugins = [wrapTableRows];
	
	  var disallowedTypes = props.disallowedTypes;
	  if (props.allowedTypes) {
	    disallowedTypes = allTypes.filter(function (type) {
	      return type !== 'root' && props.allowedTypes.indexOf(type) === -1;
	    });
	  }
	
	  var removalMethod = props.unwrapDisallowed ? 'unwrap' : 'remove';
	  if (disallowedTypes && disallowedTypes.length > 0) {
	    plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
	  }
	
	  if (props.allowNode) {
	    plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
	  }
	
	  var renderHtml = !props.escapeHtml && !props.skipHtml;
	  if (renderHtml) {
	    plugins.push(naiveHtml);
	  }
	
	  return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
	}
	
	ReactMarkdown.defaultProps = {
	  renderers: {},
	  escapeHtml: true,
	  skipHtml: false,
	  transformLinkUri: uriTransformer
	};
	
	ReactMarkdown.propTypes = {
	  className: PropTypes.string,
	  source: PropTypes.string,
	  children: PropTypes.string,
	  sourcePos: PropTypes.bool,
	  escapeHtml: PropTypes.bool,
	  skipHtml: PropTypes.bool,
	  allowNode: PropTypes.func,
	  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	  transformImageUri: PropTypes.func,
	  astPlugins: PropTypes.arrayOf(PropTypes.func),
	  unwrapDisallowed: PropTypes.bool,
	  renderers: PropTypes.object
	};
	
	ReactMarkdown.types = allTypes;
	ReactMarkdown.renderers = defaultRenderers;
	ReactMarkdown.uriTransformer = uriTransformer;
	
	module.exports = ReactMarkdown;

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types, react/no-multi-comp */
	'use strict';
	
	var xtend = __webpack_require__(139);
	var React = __webpack_require__(1);
	var createElement = React.createElement;
	
	module.exports = {
	  root: 'div',
	  break: 'br',
	  paragraph: 'p',
	  emphasis: 'em',
	  strong: 'strong',
	  thematicBreak: 'hr',
	  blockquote: 'blockquote',
	  delete: 'del',
	  link: 'a',
	  image: 'img',
	  linkReference: 'a',
	  imageReference: 'img',
	  table: SimpleRenderer.bind(null, 'table'),
	  tableHead: SimpleRenderer.bind(null, 'thead'),
	  tableBody: SimpleRenderer.bind(null, 'tbody'),
	  tableRow: SimpleRenderer.bind(null, 'tr'),
	  tableCell: TableCell,
	
	  list: List,
	  listItem: ListItem,
	  definition: NullRenderer,
	  heading: Heading,
	  inlineCode: InlineCode,
	  code: CodeBlock,
	  html: Html,
	  virtualHtml: VirtualHtml
	};
	
	function SimpleRenderer(tag, props) {
	  return createElement(tag, getCoreProps(props), props.children);
	}
	
	function TableCell(props) {
	  var style = props.align ? { textAlign: props.align } : undefined;
	  var coreProps = getCoreProps(props);
	  return createElement(props.isHeader ? 'th' : 'td', style ? xtend({ style: style }, coreProps) : coreProps, props.children);
	}
	
	function Heading(props) {
	  return createElement('h' + props.level, getCoreProps(props), props.children);
	}
	
	function List(props) {
	  var attrs = getCoreProps(props);
	  if (props.start !== null && props.start !== 1) {
	    attrs.start = props.start.toString();
	  }
	
	  return createElement(props.ordered ? 'ol' : 'ul', attrs, props.children);
	}
	
	function ListItem(props) {
	  return createElement('li', getCoreProps(props), props.children);
	}
	
	function CodeBlock(props) {
	  var className = props.language && 'language-' + props.language;
	  var code = createElement('code', className ? { className: className } : null, props.value);
	  return createElement('pre', getCoreProps(props), code);
	}
	
	function InlineCode(props) {
	  return createElement('code', getCoreProps(props), props.children);
	}
	
	function Html(props) {
	  if (props.skipHtml) {
	    return null;
	  }
	
	  var tag = props.isBlock ? 'div' : 'span';
	  if (props.escapeHtml) {
	    // @todo when fiber lands, we can simply render props.value
	    return createElement(tag, null, props.value);
	  }
	
	  var nodeProps = { dangerouslySetInnerHTML: { __html: props.value } };
	  return createElement(tag, nodeProps);
	}
	
	function VirtualHtml(props) {
	  return createElement(props.tag, getCoreProps(props), props.children);
	}
	
	function NullRenderer() {
	  return null;
	}
	
	function getCoreProps(props) {
	  return props['data-sourcepos'] ? { 'data-sourcepos': props['data-sourcepos'] } : {};
	}

/***/ }),
/* 2788 */
/***/ (function(module, exports) {

	'use strict';
	
	var protocols = ['http', 'https', 'mailto', 'tel'];
	
	module.exports = function uriTransformer(uri) {
	  var url = (uri || '').trim();
	  var first = url.charAt(0);
	
	  if (first === '#' || first === '/') {
	    return url;
	  }
	
	  var colon = url.indexOf(':');
	  if (colon === -1) {
	    return url;
	  }
	
	  var length = protocols.length;
	  var index = -1;
	
	  while (++index < length) {
	    var protocol = protocols[index];
	
	    if (colon === protocol.length && url.slice(0, protocol.length) === protocol) {
	      return url;
	    }
	  }
	
	  index = url.indexOf('?');
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  index = url.indexOf('#');
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  // eslint-disable-next-line no-script-url
	  return 'javascript:void(0)';
	};

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(294);
	
	module.exports = function (node) {
	  visit(node, 'table', wrap);
	  return node;
	};
	
	function wrap(table) {
	  var children = table.children;
	  table.children = [{
	    type: 'tableHead',
	    align: table.align,
	    children: [children[0]],
	    position: children[0].position
	  }, {
	    type: 'tableBody',
	    align: table.align,
	    children: children.slice(1),
	    position: {
	      start: children[1].position.start,
	      end: children[children.length - 1].position.end
	    }
	  }];
	}

/***/ }),
/* 2790 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2790);
	var invariant = __webpack_require__(2791);
	var ReactPropTypesSecret = __webpack_require__(2794);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2792)();
	}


/***/ }),
/* 2794 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _exenv = __webpack_require__(547);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _cssKeyframer = __webpack_require__(543);
	
	var _cssKeyframer2 = _interopRequireDefault(_cssKeyframer);
	
	var _styles = __webpack_require__(759);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var canUseDOM = _exenv2.default.canUseDOM;
	
	var MDSpinner = function (_Component) {
	  _inherits(MDSpinner, _Component);
	
	  function MDSpinner(props, context) {
	    _classCallCheck(this, MDSpinner);
	
	    var _this = _possibleConstructorReturn(this, (MDSpinner.__proto__ || Object.getPrototypeOf(MDSpinner)).call(this, props, context));
	
	    _this.keyframer = new _cssKeyframer2.default({
	      userAgent: props.userAgent
	    });
	    return _this;
	  }
	
	  _createClass(MDSpinner, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.registerKeyframesIfNeeded();
	
	      MDSpinner.mountedInstanceCount++;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      MDSpinner.mountedInstanceCount--;
	
	      this.unregisterKeyframesIfNeeded();
	      this.keyframer = null;
	    }
	  }, {
	    key: "registerKeyframesIfNeeded",
	    value: function registerKeyframesIfNeeded() {
	      var _this2 = this;
	
	      if (MDSpinner.mountedInstanceCount > 0) return;
	      if (!this.keyframer) return;
	
	      Object.keys(_styles.keyframes).forEach(function (key) {
	        return _this2.keyframer.register(key, _styles.keyframes[key]);
	      });
	    }
	  }, {
	    key: "unregisterKeyframesIfNeeded",
	    value: function unregisterKeyframesIfNeeded() {
	      if (!canUseDOM) return;
	      if (MDSpinner.mountedInstanceCount > 0) return;
	      if (!this.keyframer) return;
	
	      Object.keys(_styles.keyframes).forEach(function (key) {
	        var $style = document.querySelector("style[data-keyframes=\"" + key + "\"]");
	        if ($style) {
	          $style.parentNode.removeChild($style);
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var className = props.className,
	          style = props.style;
	
	      var _getStyles = (0, _styles.getStyles)(props),
	          rootStyle = _getStyles.rootStyle,
	          layerStyles = _getStyles.layerStyles,
	          layerAfterStyle = _getStyles.layerAfterStyle,
	          clipStyle = _getStyles.clipStyle,
	          clip1AfterStyles = _getStyles.clip1AfterStyles,
	          clip2AfterStyles = _getStyles.clip2AfterStyles;
	
	      var layers = [];
	
	      for (var i = 0; i < 4; i++) {
	        layers.push(_react2.default.createElement(
	          "span",
	          { key: i, style: layerStyles[i] },
	          _react2.default.createElement(
	            "span",
	            { style: clipStyle },
	            _react2.default.createElement("span", { style: clip1AfterStyles[i] })
	          ),
	          _react2.default.createElement(
	            "span",
	            { style: clipStyle },
	            _react2.default.createElement("span", { style: clip2AfterStyles[i] })
	          ),
	          _react2.default.createElement("span", { style: layerAfterStyle })
	        ));
	      }
	
	      return _react2.default.createElement(
	        "span",
	        {
	          className: className,
	          style: _extends({}, rootStyle, style || {})
	        },
	        layers
	      );
	    }
	  }]);
	
	  return MDSpinner;
	}(_react.Component);
	
	MDSpinner.propTypes = {
	  className: _propTypes2.default.string,
	  userAgent: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  singleColor: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  duration: _propTypes2.default.number,
	  color1: _propTypes2.default.string,
	  color2: _propTypes2.default.string,
	  color3: _propTypes2.default.string,
	  color4: _propTypes2.default.string
	};
	MDSpinner.defaultProps = {
	  size: 28,
	  duration: 1333,
	  color1: "rgb(66, 165, 245)",
	  color2: "rgb(239, 83, 80)",
	  color3: "rgb(253, 216, 53)",
	  color4: "rgb(76, 175, 80)"
	};
	MDSpinner.mountedInstanceCount = 0;
	exports.default = MDSpinner;

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ssrBehavior = undefined;
	
	var _ssrBehavior2 = __webpack_require__(2797);
	
	var _ssrBehavior = _interopRequireWildcard(_ssrBehavior2);
	
	var _MDSpinner = __webpack_require__(2795);
	
	var _MDSpinner2 = _interopRequireDefault(_MDSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.ssrBehavior = _ssrBehavior;
	exports.default = _MDSpinner2.default;

/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStylesheetComponent = exports.getStylesheetString = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cssKeyframer = __webpack_require__(543);
	
	var _cssKeyframer2 = _interopRequireDefault(_cssKeyframer);
	
	var _styles = __webpack_require__(759);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keyframerFactory = function keyframerFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new _cssKeyframer2.default(options);
	};
	
	var mapKeyframes = function mapKeyframes(iteratee) {
	  return Object.keys(_styles.keyframes).map(function (key) {
	    return iteratee(_styles.keyframes[key], key);
	  });
	};
	
	var getStylesheetString = exports.getStylesheetString = function getStylesheetString(userAgent) {
	  var keyframer = keyframerFactory({ userAgent: userAgent });
	
	  return mapKeyframes(function (keyframe, key) {
	    return keyframer.getKeyframesStylesheet(key, keyframe);
	  }).join("");
	};
	
	var getStylesheetComponent = exports.getStylesheetComponent = function getStylesheetComponent(userAgent) {
	  var keyframer = keyframerFactory({ userAgent: userAgent });
	
	  return mapKeyframes(function (keyframe, key) {
	    return _react2.default.createElement("style", {
	      key: key,
	      type: "text/css",
	      "data-keyframes": key,
	      dangerouslySetInnerHTML: {
	        __html: keyframer.getKeyframesString(key, keyframe)
	      }
	    });
	  });
	};

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createPrefixer;
	
	var _getBrowserInformation = __webpack_require__(2824);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(2825);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(401);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _addNewValuesOnly = __webpack_require__(760);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(761);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _prefixValue = __webpack_require__(762);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
	    return style;
	  };
	
	  return function () {
	    /**
	    * Instantiante a new prefixer
	    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	    * @param {string} keepUnprefixed - keeps unprefixed properties and values
	    */
	    function Prefixer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _classCallCheck(this, Prefixer);
	
	      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	      this._userAgent = options.userAgent || defaultUserAgent;
	      this._keepUnprefixed = options.keepUnprefixed || false;
	
	      if (this._userAgent) {
	        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	      }
	
	      // Checks if the userAgent was resolved correctly
	      if (this._browserInfo && this._browserInfo.cssPrefix) {
	        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
	      } else {
	        this._useFallback = true;
	        return false;
	      }
	
	      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
	      if (prefixData) {
	        this._requiresPrefix = {};
	
	        for (var property in prefixData) {
	          if (prefixData[property] >= this._browserInfo.browserVersion) {
	            this._requiresPrefix[property] = true;
	          }
	        }
	
	        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	      } else {
	        this._useFallback = true;
	      }
	
	      this._metaData = {
	        browserVersion: this._browserInfo.browserVersion,
	        browserName: this._browserInfo.browserName,
	        cssPrefix: this._browserInfo.cssPrefix,
	        jsPrefix: this._browserInfo.jsPrefix,
	        keepUnprefixed: this._keepUnprefixed,
	        requiresPrefix: this._requiresPrefix
	      };
	    }
	
	    _createClass(Prefixer, [{
	      key: 'prefix',
	      value: function prefix(style) {
	        // use static prefixer as fallback if userAgent can not be resolved
	        if (this._useFallback) {
	          return fallback(style);
	        }
	
	        // only add prefixes if needed
	        if (!this._hasPropsRequiringPrefix) {
	          return style;
	        }
	
	        return this._prefixStyle(style);
	      }
	    }, {
	      key: '_prefixStyle',
	      value: function _prefixStyle(style) {
	        for (var property in style) {
	          var value = style[property];
	
	          // handle nested objects
	          if ((0, _isObject2.default)(value)) {
	            style[property] = this.prefix(value
	            // handle array values
	            );
	          } else if (Array.isArray(value)) {
	            var combinedValue = [];
	
	            for (var i = 0, len = value.length; i < len; ++i) {
	              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
	              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	            }
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (combinedValue.length > 0) {
	              style[property] = combinedValue;
	            }
	          } else {
	            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            );if (_processedValue) {
	              style[property] = _processedValue;
	            }
	
	            // add prefixes to properties
	            if (this._requiresPrefix.hasOwnProperty(property)) {
	              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	              if (!this._keepUnprefixed) {
	                delete style[property];
	              }
	            }
	          }
	        }
	
	        return style;
	      }
	
	      /**
	      * Returns a prefixed version of the style object using all vendor prefixes
	      * @param {Object} styles - Style object that gets prefixed properties added
	      * @returns {Object} - Style object with prefixed properties and values
	      */
	
	    }], [{
	      key: 'prefixAll',
	      value: function prefixAll(styles) {
	        return fallback(styles);
	      }
	    }]);
	
	    return Prefixer;
	  }();
	}
	module.exports = exports['default'];

/***/ }),
/* 2799 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  plugins: [],
	  prefixMap: { "chrome": { "appearance": 62, "userSelect": 53, "textEmphasisPosition": 62, "textEmphasis": 62, "textEmphasisStyle": 62, "textEmphasisColor": 62, "boxDecorationBreak": 62, "clipPath": 54, "maskImage": 62, "maskMode": 62, "maskRepeat": 62, "maskPosition": 62, "maskClip": 62, "maskOrigin": 62, "maskSize": 62, "maskComposite": 62, "mask": 62, "maskBorderSource": 62, "maskBorderMode": 62, "maskBorderSlice": 62, "maskBorderWidth": 62, "maskBorderOutset": 62, "maskBorderRepeat": 62, "maskBorder": 62, "maskType": 62, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 11, "userSelect": 11, "backdropFilter": 11, "fontKerning": 9, "scrollSnapType": 10.1, "scrollSnapPointsX": 10.1, "scrollSnapPointsY": 10.1, "scrollSnapDestination": 10.1, "scrollSnapCoordinate": 10.1, "boxDecorationBreak": 11, "clipPath": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textDecorationStyle": 11, "textDecorationSkip": 11, "textDecorationLine": 11, "textDecorationColor": 11, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 11, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 56, "userSelect": 56, "textAlignLast": 48, "tabSize": 56, "hyphens": 42, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 47, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 47, "textEmphasis": 47, "textEmphasisStyle": 47, "textEmphasisColor": 47, "boxDecorationBreak": 47, "clipPath": 41, "maskImage": 47, "maskMode": 47, "maskRepeat": 47, "maskPosition": 47, "maskClip": 47, "maskOrigin": 47, "maskSize": 47, "maskComposite": 47, "mask": 47, "maskBorderSource": 47, "maskBorderMode": 47, "maskBorderSlice": 47, "maskBorderWidth": 47, "maskBorderOutset": 47, "maskBorderRepeat": 47, "maskBorder": 47, "maskType": 47, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 16, "wrapFlow": 16, "wrapThrough": 16, "wrapMargin": 16, "scrollSnapType": 16, "scrollSnapPointsX": 16, "scrollSnapPointsY": 16, "scrollSnapDestination": 16, "scrollSnapCoordinate": 16, "hyphens": 16, "flowInto": 16, "flowFrom": 16, "breakBefore": 16, "breakAfter": 16, "breakInside": 16, "regionFragment": 16, "gridTemplateColumns": 16, "gridTemplateRows": 16, "gridTemplateAreas": 16, "gridTemplate": 16, "gridAutoColumns": 16, "gridAutoRows": 16, "gridAutoFlow": 16, "grid": 16, "gridRowStart": 16, "gridColumnStart": 16, "gridRowEnd": 16, "gridRow": 16, "gridColumn": 16, "gridColumnEnd": 16, "gridColumnGap": 16, "gridRowGap": 16, "gridArea": 16, "gridGap": 16 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 11, "userSelect": 11, "backdropFilter": 11, "fontKerning": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "boxDecorationBreak": 11, "clipPath": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "textDecorationStyle": 11, "textDecorationSkip": 11, "textDecorationLine": 11, "textDecorationColor": 11, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 11, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 56, "userSelect": 4.4, "fontKerning": 4.4, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "clipPath": 4.4, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 56, "breakBefore": 56, "breakInside": 56, "columnCount": 56, "columnFill": 56, "columnGap": 56, "columnRule": 56, "columnRuleColor": 56, "columnRuleStyle": 56, "columnRuleWidth": 56, "columns": 56, "columnSpan": 56, "columnWidth": 56 }, "and_chr": { "appearance": 59, "textEmphasisPosition": 59, "textEmphasis": 59, "textEmphasisStyle": 59, "textEmphasisColor": 59, "boxDecorationBreak": 59, "maskImage": 59, "maskMode": 59, "maskRepeat": 59, "maskPosition": 59, "maskClip": 59, "maskOrigin": 59, "maskSize": 59, "maskComposite": 59, "mask": 59, "maskBorderSource": 59, "maskBorderMode": 59, "maskBorderSlice": 59, "maskBorderWidth": 59, "maskBorderOutset": 59, "maskBorderRepeat": 59, "maskBorder": 59, "maskType": 59 }, "and_uc": { "flex": 11.4, "flexBasis": 11.4, "flexDirection": 11.4, "flexGrow": 11.4, "flexFlow": 11.4, "flexShrink": 11.4, "flexWrap": 11.4, "alignContent": 11.4, "alignItems": 11.4, "alignSelf": 11.4, "justifyContent": 11.4, "order": 11.4, "transform": 11.4, "transformOrigin": 11.4, "transformOriginX": 11.4, "transformOriginY": 11.4, "backfaceVisibility": 11.4, "perspective": 11.4, "perspectiveOrigin": 11.4, "transformStyle": 11.4, "transformOriginZ": 11.4, "animation": 11.4, "animationDelay": 11.4, "animationDirection": 11.4, "animationFillMode": 11.4, "animationDuration": 11.4, "animationIterationCount": 11.4, "animationName": 11.4, "animationPlayState": 11.4, "animationTimingFunction": 11.4, "appearance": 11.4, "userSelect": 11.4, "textEmphasisPosition": 11.4, "textEmphasis": 11.4, "textEmphasisStyle": 11.4, "textEmphasisColor": 11.4, "clipPath": 11.4, "maskImage": 11.4, "maskMode": 11.4, "maskRepeat": 11.4, "maskPosition": 11.4, "maskClip": 11.4, "maskOrigin": 11.4, "maskSize": 11.4, "maskComposite": 11.4, "mask": 11.4, "maskBorderSource": 11.4, "maskBorderMode": 11.4, "maskBorderSlice": 11.4, "maskBorderWidth": 11.4, "maskBorderOutset": 11.4, "maskBorderRepeat": 11.4, "maskBorder": 11.4, "maskType": 11.4, "textSizeAdjust": 11.4, "filter": 11.4, "hyphens": 11.4, "fontFeatureSettings": 11.4, "breakAfter": 11.4, "breakBefore": 11.4, "breakInside": 11.4, "columnCount": 11.4, "columnFill": 11.4, "columnGap": 11.4, "columnRule": 11.4, "columnRuleColor": 11.4, "columnRuleStyle": 11.4, "columnRuleWidth": 11.4, "columns": 11.4, "columnSpan": 11.4, "columnWidth": 11.4 }, "op_mini": {} }
	};
	module.exports = exports["default"];

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createPrefixer = __webpack_require__(2798);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _cursor = __webpack_require__(2802);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _crossFade = __webpack_require__(2801);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _filter = __webpack_require__(2803);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(2804);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxOld = __webpack_require__(2805);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(2806);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(2807);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(2808);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(2809);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(2810);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _static = __webpack_require__(2812);
	
	var _static2 = _interopRequireDefault(_static);
	
	var _dynamicData = __webpack_require__(2799);
	
	var _dynamicData2 = _interopRequireDefault(_dynamicData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default];
	
	var Prefixer = (0, _createPrefixer2.default)({
	  prefixMap: _dynamicData2.default.prefixMap,
	  plugins: plugins
	}, _static2.default);
	exports.default = Prefixer;
	module.exports = exports['default'];

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function crossFade(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('cross-fade(') > -1 && (browserName === 'chrome' || browserName === 'opera' || browserName === 'and_chr' || (browserName === 'ios_saf' || browserName === 'safari') && browserVersion < 10)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/cross-fade\(/g, cssPrefix + 'cross-fade('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var grabValues = {
	  grab: true,
	  grabbing: true
	};
	
	
	var zoomValues = {
	  'zoom-in': true,
	  'zoom-out': true
	};
	
	function cursor(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of
	  // version until a reliable browser support info can be found
	  // see: https://github.com/rofrischmann/inline-style-prefixer/issues/79
	  if (property === 'cursor' && grabValues[value] && (browserName === 'firefox' || browserName === 'chrome' || browserName === 'safari' || browserName === 'opera')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	
	  if (property === 'cursor' && zoomValues[value] && (browserName === 'firefox' && browserVersion < 24 || browserName === 'chrome' && browserVersion < 37 || browserName === 'safari' && browserVersion < 9 || browserName === 'opera' && browserVersion < 24)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filter(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('filter(') > -1 && (browserName === 'ios_saf' || browserName === 'safari' && browserVersion < 9.1)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/filter\(/g, cssPrefix + 'filter('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	function flex(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      if (value.indexOf('column') > -1) {
	        style.WebkitBoxOrient = 'vertical';
	      } else {
	        style.WebkitBoxOrient = 'horizontal';
	      }
	      if (value.indexOf('reverse') > -1) {
	        style.WebkitBoxDirection = 'reverse';
	      } else {
	        style.WebkitBoxDirection = 'normal';
	      }
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	function gradient(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function imageSet(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('image-set(') > -1 && (browserName === 'chrome' || browserName === 'opera' || browserName === 'and_chr' || browserName === 'and_uc' || browserName === 'ios_saf' || browserName === 'safari')) {
	    return (0, _getPrefixedValue2.default)(value.replace(/image-set\(/g, cssPrefix + 'image-set('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function position(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browserName === 'safari' || browserName === 'ios_saf')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(119);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	
	  // TODO: chrome & opera support it
	};function sizing(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(542);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var requiresPrefixDashCased = void 0;
	
	function transition(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    // memoize the prefix array for later use
	    if (!requiresPrefixDashCased) {
	      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateProperty2.default)(prop);
	      });
	    }
	
	    // only split multi values, not cubic beziers
	    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	    requiresPrefixDashCased.forEach(function (prop) {
	      multipleValues.forEach(function (val, index) {
	        if (val.indexOf(prop) > -1 && prop !== 'order') {
	          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
	        }
	      });
	    });
	
	    return multipleValues.join(',');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(2826);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(762);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(760);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(761);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value
	        // handle array values
	        );
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        );if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createPrefixer = __webpack_require__(2811);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _staticData = __webpack_require__(2823);
	
	var _staticData2 = _interopRequireDefault(_staticData);
	
	var _cursor = __webpack_require__(2814);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _crossFade = __webpack_require__(2813);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _filter = __webpack_require__(2815);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(2816);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxOld = __webpack_require__(2817);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(2818);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(2819);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(2820);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(2821);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(2822);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default];
	
	exports.default = (0, _createPrefixer2.default)({
	  prefixMap: _staticData2.default.prefixMap,
	  plugins: plugins
	});
	module.exports = exports['default'];

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(220);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2814 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(220);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2816 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2817 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(220);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(220);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2820 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2821 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(542);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(220);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(401);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap
	    // if the property is already prefixed
	    );var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2823 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	
	exports.default = {
	  plugins: [],
	  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
	};
	module.exports = exports["default"];

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBrowserInformation;
	
	var _bowser = __webpack_require__(494);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixByBrowser = {
	  chrome: 'Webkit',
	  safari: 'Webkit',
	  ios: 'Webkit',
	  android: 'Webkit',
	  phantom: 'Webkit',
	  opera: 'Webkit',
	  webos: 'Webkit',
	  blackberry: 'Webkit',
	  bada: 'Webkit',
	  tizen: 'Webkit',
	  chromium: 'Webkit',
	  vivaldi: 'Webkit',
	  firefox: 'Moz',
	  seamoney: 'Moz',
	  sailfish: 'Moz',
	  msie: 'ms',
	  msedge: 'ms'
	};
	
	
	var browserByCanIuseAlias = {
	  chrome: 'chrome',
	  chromium: 'chrome',
	  safari: 'safari',
	  firfox: 'firefox',
	  msedge: 'edge',
	  opera: 'opera',
	  vivaldi: 'opera',
	  msie: 'ie'
	};
	
	function getBrowserName(browserInfo) {
	  if (browserInfo.firefox) {
	    return 'firefox';
	  }
	
	  if (browserInfo.mobile || browserInfo.tablet) {
	    if (browserInfo.ios) {
	      return 'ios_saf';
	    } else if (browserInfo.android) {
	      return 'android';
	    } else if (browserInfo.opera) {
	      return 'op_mini';
	    }
	  }
	
	  for (var browser in browserByCanIuseAlias) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      return browserByCanIuseAlias[browser];
	    }
	  }
	}
	
	/**
	 * Uses bowser to get default browser browserInformation such as version and name
	 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	function getBrowserInformation(userAgent) {
	  var browserInfo = _bowser2.default._detect(userAgent);
	
	  if (browserInfo.yandexbrowser) {
	    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
	  }
	
	  for (var browser in prefixByBrowser) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      var prefix = prefixByBrowser[browser];
	
	      browserInfo.jsPrefix = prefix;
	      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
	      break;
	    }
	  }
	
	  browserInfo.browserName = getBrowserName(browserInfo
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  );if (browserInfo.version) {
	    browserInfo.browserVersion = parseFloat(browserInfo.version);
	  } else {
	    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
	  }
	
	  browserInfo.osVersion = parseFloat(browserInfo.osversion
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  );if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
	    browserInfo.browserName = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // Samsung browser are basically build on Chrome > 44
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
	  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
	    browserInfo.browserName = 'and_chr';
	    browserInfo.browserVersion = 44;
	  }
	
	  return browserInfo;
	}
	module.exports = exports['default'];

/***/ }),
/* 2825 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedKeyframes;
	function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
	  var prefixedKeyframes = 'keyframes';
	
	  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
	    return cssPrefix + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	}
	module.exports = exports['default'];

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(401);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2827 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(763);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(764);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(763);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(2830);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(2831);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(764);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(270);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(552);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 2830 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(434);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(765);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(766);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(767);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(768);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(135);
	
	var _InternalPropTypes = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(135);
	
	var _InternalPropTypes = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(776);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(284);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(404);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(163);
	
	var _RouterContext = __webpack_require__(281);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(135);
	
	var _RouterUtils = __webpack_require__(769);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(281);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(402);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(281);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(2856);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(771);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(189);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(402);
	
	var _makeStateWithLocation = __webpack_require__(772);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(189);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(776);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(771);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(189);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(190);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(770);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(404);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(135);
	
	var _RouterUtils = __webpack_require__(769);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(402);
	
	var _makeStateWithLocation = __webpack_require__(772);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(189);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(284);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(404);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(56);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(552);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 2855 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(190);
	
	var _PathUtils = __webpack_require__(164);
	
	var _ExecutionEnvironment = __webpack_require__(283);
	
	var _DOMUtils = __webpack_require__(405);
	
	var _DOMStateStorage = __webpack_require__(774);
	
	var _createDOMHistory = __webpack_require__(775);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(190);
	
	var _PathUtils = __webpack_require__(164);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(106);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(164);
	
	var _Actions = __webpack_require__(190);
	
	var _createHistory = __webpack_require__(777);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 2859 */
66,
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2873);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StarRatingComponent = function (_Component) {
	  _inherits(StarRatingComponent, _Component);
	
	  function StarRatingComponent(props) {
	    _classCallCheck(this, StarRatingComponent);
	
	    var _this = _possibleConstructorReturn(this, (StarRatingComponent.__proto__ || Object.getPrototypeOf(StarRatingComponent)).call(this));
	
	    _this.state = {
	      value: props.value
	    };
	    return _this;
	  }
	
	  _createClass(StarRatingComponent, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value;
	
	
	      if (value != null && value !== this.state.value) {
	        this.setState({ value: value });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(value) {
	      var editing = this.props.editing;
	
	
	      if (!editing) {
	        return;
	      }
	
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'onStarClick',
	    value: function onStarClick(index, value, name) {
	      var _props = this.props,
	          onStarClick = _props.onStarClick,
	          editing = _props.editing;
	
	
	      if (!editing) {
	        return;
	      }
	
	      onStarClick && onStarClick(index, value, name);
	    }
	  }, {
	    key: 'renderStars',
	    value: function renderStars() {
	      var _props2 = this.props,
	          name = _props2.name,
	          starCount = _props2.starCount,
	          starColor = _props2.starColor,
	          emptyStarColor = _props2.emptyStarColor,
	          editing = _props2.editing;
	      var value = this.state.value;
	
	      var starStyles = function starStyles(i, value) {
	        return {
	          float: 'right',
	          cursor: editing ? 'pointer' : 'default',
	          color: value >= i ? starColor : emptyStarColor
	        };
	      };
	      var radioStyles = {
	        display: 'none',
	        position: 'absolute',
	        marginLeft: -9999
	      };
	
	      // populate stars
	      var starNodes = [];
	
	      for (var i = starCount; i > 0; i--) {
	        var id = name + '_' + i;
	        var starNodeInput = _react2.default.createElement('input', {
	          key: 'input_' + id,
	          style: radioStyles,
	          className: 'dv-star-rating-input',
	          type: 'radio',
	          name: name,
	          id: id,
	          value: i,
	          checked: value === i,
	          onChange: this.onChange.bind(this, i, name)
	        });
	        var starNodeLabel = _react2.default.createElement(
	          'label',
	          {
	            key: 'label_' + id,
	            style: starStyles(i, value),
	            className: 'dv-star-rating-star ' + (value >= i ? 'dv-star-rating-full-star' : 'dv-star-rating-empty-star'),
	            htmlFor: id,
	            onClick: this.onStarClick.bind(this, i, value, name)
	          },
	          this.renderIcon(i, value, name)
	        );
	
	        starNodes.push(starNodeInput);
	        starNodes.push(starNodeLabel);
	      }
	
	      return starNodes;
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(index, value, name) {
	      var _props3 = this.props,
	          renderStarIcon = _props3.renderStarIcon,
	          renderStarIconHalf = _props3.renderStarIconHalf;
	
	
	      if (typeof renderStarIconHalf === 'function' && Math.ceil(value) === index && value % 1 !== 0) {
	        return renderStarIconHalf(index, value, name);
	      }
	
	      if (typeof renderStarIcon === 'function') {
	        return renderStarIcon(index, value, name);
	      }
	
	      return _react2.default.createElement(
	        'i',
	        { style: { fontStyle: 'normal' } },
	        '\u2605'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          editing = _props4.editing,
	          className = _props4.className;
	
	      var classes = (0, _classnames2.default)('dv-star-rating', {
	        'dv-star-rating-non-editable': !editing
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'inline-block', position: 'relative' }, className: classes },
	        this.renderStars()
	      );
	    }
	  }]);
	
	  return StarRatingComponent;
	}(_react.Component);
	
	StarRatingComponent.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.number,
	  editing: _propTypes2.default.bool,
	  starCount: _propTypes2.default.number,
	  starColor: _propTypes2.default.string,
	  onStarClick: _propTypes2.default.func,
	  renderStarIcon: _propTypes2.default.func,
	  renderStarIconHalf: _propTypes2.default.func
	};
	StarRatingComponent.defaultProps = {
	  starCount: 5,
	  value: 0,
	  editing: true,
	  starColor: '#ffb400',
	  emptyStarColor: '#333'
	};
	exports.default = StarRatingComponent;
	module.exports = exports['default'];


/***/ }),
/* 2861 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(285);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactBaseClasses = __webpack_require__(779);
	var ReactChildren = __webpack_require__(2864);
	var ReactDOMFactories = __webpack_require__(2865);
	var ReactElement = __webpack_require__(191);
	var ReactPropTypes = __webpack_require__(2866);
	var ReactVersion = __webpack_require__(2867);
	
	var createReactClass = __webpack_require__(2868);
	var onlyChild = __webpack_require__(2871);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(2862);
	var ReactElement = __webpack_require__(191);
	
	var emptyFunction = __webpack_require__(65);
	var traverseAllChildren = __webpack_require__(2872);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(191);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(191),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(2752);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 2867 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(779),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(191),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(782);
	var factory = __webpack_require__(1514);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 2869 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(285);
	
	var ReactElement = __webpack_require__(191);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(285);
	
	var ReactCurrentOwner = __webpack_require__(780);
	var REACT_ELEMENT_TYPE = __webpack_require__(781);
	
	var getIteratorFn = __webpack_require__(2869);
	var invariant = __webpack_require__(22);
	var KeyEscapeUtils = __webpack_require__(2861);
	var warning = __webpack_require__(25);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 2873 */
[3180, 2863],
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ }),
/* 2875 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(107);
	var EventPluginUtils = __webpack_require__(287);
	var EventPropagators = __webpack_require__(195);
	var SyntheticUIEvent = __webpack_require__(197);
	var TouchEventUtils = __webpack_require__(2877);
	var ViewportMetrics = __webpack_require__(424);
	
	var keyOf = __webpack_require__(2875);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    topLevelTypes.topTouchCancel,
	    topLevelTypes.topTouchEnd,
	    topLevelTypes.topTouchStart,
	    topLevelTypes.topTouchMove
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  topLevelTypes.topTouchStart,
	  topLevelTypes.topTouchCancel,
	  topLevelTypes.topTouchEnd,
	  topLevelTypes.topTouchMove,
	];
	
	var dependencies = [
	  topLevelTypes.topMouseDown,
	  topLevelTypes.topMouseMove,
	  topLevelTypes.topMouseUp,
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ }),
/* 2877 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ }),
/* 2878 */
/***/ (function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(2874);
	var defaultClickRejectionStrategy = __webpack_require__(2878);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(194).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(2876)(shouldRejectClick)
	  });
	};


/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsUpdate = __webpack_require__(754);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _ToastMessage = __webpack_require__(784);
	
	var _ToastMessage2 = _interopRequireDefault(_ToastMessage);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToastContainer = function (_Component) {
	  _inherits(ToastContainer, _Component);
	
	  function ToastContainer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ToastContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ToastContainer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      toasts: [],
	      toastId: 0,
	      messageList: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ToastContainer, [{
	    key: "error",
	    value: function error(message, title, optionsOverride) {
	      this._notify(this.props.toastType.error, message, title, optionsOverride);
	    }
	  }, {
	    key: "info",
	    value: function info(message, title, optionsOverride) {
	      this._notify(this.props.toastType.info, message, title, optionsOverride);
	    }
	  }, {
	    key: "success",
	    value: function success(message, title, optionsOverride) {
	      this._notify(this.props.toastType.success, message, title, optionsOverride);
	    }
	  }, {
	    key: "warning",
	    value: function warning(message, title, optionsOverride) {
	      this._notify(this.props.toastType.warning, message, title, optionsOverride);
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      var _this2 = this;
	
	      Object.keys(this.refs).forEach(function (key) {
	        _this2.refs[key].hideToast(false);
	      });
	    }
	  }, {
	    key: "_notify",
	    value: function _notify(type, message, title) {
	      var _this3 = this;
	
	      var optionsOverride = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      if (this.props.preventDuplicates) {
	        if (_lodash2.default.includes(this.state.messageList, message)) {
	          return;
	        }
	      }
	      var key = this.state.toastId++;
	      var toastId = key;
	      var newToast = (0, _reactAddonsUpdate2.default)(optionsOverride, {
	        $merge: {
	          type: type,
	          title: title,
	          message: message,
	          toastId: toastId,
	          key: key,
	          ref: "toasts__" + key,
	          handleOnClick: function handleOnClick(e) {
	            if ("function" === typeof optionsOverride.handleOnClick) {
	              optionsOverride.handleOnClick();
	            }
	            return _this3._handle_toast_on_click(e);
	          },
	          handleRemove: this._handle_toast_remove.bind(this)
	        }
	      });
	      var toastOperation = _defineProperty({}, "" + (this.props.newestOnTop ? "$unshift" : "$push"), [newToast]);
	
	      var messageOperation = _defineProperty({}, "" + (this.props.newestOnTop ? "$unshift" : "$push"), [message]);
	
	      var nextState = (0, _reactAddonsUpdate2.default)(this.state, {
	        toasts: toastOperation,
	        messageList: messageOperation
	      });
	      this.setState(nextState);
	    }
	  }, {
	    key: "_handle_toast_on_click",
	    value: function _handle_toast_on_click(event) {
	      this.props.onClick(event);
	      if (event.defaultPrevented) {
	        return;
	      }
	      event.preventDefault();
	      event.stopPropagation();
	    }
	  }, {
	    key: "_handle_toast_remove",
	    value: function _handle_toast_remove(toastId) {
	      var _this4 = this;
	
	      if (this.props.preventDuplicates) {
	        this.state.previousMessage = "";
	      }
	      var operationName = "" + (this.props.newestOnTop ? "reduceRight" : "reduce");
	      this.state.toasts[operationName](function (found, toast, index) {
	        if (found || toast.toastId !== toastId) {
	          return false;
	        }
	        _this4.setState((0, _reactAddonsUpdate2.default)(_this4.state, {
	          toasts: { $splice: [[index, 1]] },
	          messageList: { $splice: [[index, 1]] }
	        }));
	        return true;
	      }, false);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var divProps = _lodash2.default.omit(this.props, ["toastType", "toastMessageFactory", "preventDuplicates", "newestOnTop"]);
	
	      return _react2.default.createElement(
	        "div",
	        _extends({}, divProps, { "aria-live": "polite", role: "alert" }),
	        this.state.toasts.map(function (toast) {
	          return _this5.props.toastMessageFactory(toast);
	        })
	      );
	    }
	  }]);
	
	  return ToastContainer;
	}(_react.Component);
	
	ToastContainer.propTypes = {
	  toastType: _react.PropTypes.shape({
	    error: _react.PropTypes.string,
	    info: _react.PropTypes.string,
	    success: _react.PropTypes.string,
	    warning: _react.PropTypes.string
	  }).isRequired,
	  id: _react.PropTypes.string.isRequired,
	  toastMessageFactory: _react.PropTypes.func.isRequired,
	  preventDuplicates: _react.PropTypes.bool.isRequired,
	  newestOnTop: _react.PropTypes.bool.isRequired,
	  onClick: _react.PropTypes.func.isRequired
	};
	ToastContainer.defaultProps = {
	  toastType: {
	    error: "error",
	    info: "info",
	    success: "success",
	    warning: "warning"
	  },
	  id: "toast-container",
	  toastMessageFactory: _react2.default.createFactory(_ToastMessage2.default.animation),
	  preventDuplicates: true,
	  newestOnTop: true,
	  onClick: function onClick() {}
	};
	exports.default = ToastContainer;

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ReactTransitionEvents = __webpack_require__(2939);
	
	var _ReactTransitionEvents2 = _interopRequireDefault(_ReactTransitionEvents);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _elementClass = __webpack_require__(1523);
	
	var _elementClass2 = _interopRequireDefault(_elementClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TICK = 17;
	var toString = Object.prototype.toString;
	exports.default = {
	  getDefaultProps: function getDefaultProps() {
	    return {
	      transition: null, // some examples defined in index.scss (scale, fadeInOut, rotate)
	      showAnimation: "animated bounceIn", // or other animations from animate.css
	      hideAnimation: "animated bounceOut",
	      timeOut: 5000,
	      extendedTimeOut: 1000
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.classNameQueue = [];
	    this.isHiding = false;
	    this.intervalId = null;
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this._is_mounted = true;
	    this._show();
	    var node = _reactDom2.default.findDOMNode(this);
	
	    var onHideComplete = function onHideComplete() {
	      if (_this.isHiding) {
	        _this._set_is_hiding(false);
	        _ReactTransitionEvents2.default.removeEndEventListener(node, onHideComplete);
	        _this._handle_remove();
	      }
	    };
	    _ReactTransitionEvents2.default.addEndEventListener(node, onHideComplete);
	
	    if (this.props.timeOut > 0) {
	      this._set_interval_id(setTimeout(this.hideToast, this.props.timeOut));
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._is_mounted = false;
	    if (this.intervalId) {
	      clearTimeout(this.intervalId);
	    }
	  },
	  _set_transition: function _set_transition(hide) {
	    var animationType = hide ? "leave" : "enter";
	    var node = _reactDom2.default.findDOMNode(this);
	    var className = this.props.transition + "-" + animationType;
	    var activeClassName = className + "-active";
	
	    var endListener = function endListener(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      var classList = (0, _elementClass2.default)(node);
	      classList.remove(className);
	      classList.remove(activeClassName);
	
	      _ReactTransitionEvents2.default.removeEndEventListener(node, endListener);
	    };
	
	    _ReactTransitionEvents2.default.addEndEventListener(node, endListener);
	
	    (0, _elementClass2.default)(node).add(className);
	
	    // Need to do this to actually trigger a transition.
	    this._queue_class(activeClassName);
	  },
	  _clear_transition: function _clear_transition(hide) {
	    var node = _reactDom2.default.findDOMNode(this);
	    var animationType = hide ? "leave" : "enter";
	    var className = this.props.transition + "-" + animationType;
	    var activeClassName = className + "-active";
	
	    var classList = (0, _elementClass2.default)(node);
	    classList.remove(className);
	    classList.remove(activeClassName);
	  },
	  _set_animation: function _set_animation(hide) {
	    var node = _reactDom2.default.findDOMNode(this);
	    var animations = this._get_animation_classes(hide);
	    var endListener = function endListener(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      animations.forEach(function (anim) {
	        return (0, _elementClass2.default)(node).remove(anim);
	      });
	
	      _ReactTransitionEvents2.default.removeEndEventListener(node, endListener);
	    };
	
	    _ReactTransitionEvents2.default.addEndEventListener(node, endListener);
	
	    animations.forEach(function (anim) {
	      return (0, _elementClass2.default)(node).add(anim);
	    });
	  },
	  _get_animation_classes: function _get_animation_classes(hide) {
	    var animations = hide ? this.props.hideAnimation : this.props.showAnimation;
	    if ("[object Array]" === toString.call(animations)) {
	      return animations;
	    } else if ("string" === typeof animations) {
	      return animations.split(" ");
	    }
	  },
	  _clear_animation: function _clear_animation(hide) {
	    var node = _reactDom2.default.findDOMNode(this);
	    var animations = this._get_animation_classes(hide);
	    animations.forEach(function (animation) {
	      return (0, _elementClass2.default)(node).remove(animation);
	    });
	  },
	  _queue_class: function _queue_class(className) {
	    this.classNameQueue.push(className);
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this._flush_class_name_queue, TICK);
	    }
	  },
	  _flush_class_name_queue: function _flush_class_name_queue() {
	    var _this2 = this;
	
	    if (this._is_mounted) {
	      (function () {
	        var node = _reactDom2.default.findDOMNode(_this2);
	        _this2.classNameQueue.forEach(function (className) {
	          return (0, _elementClass2.default)(node).add(className);
	        });
	      })();
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },
	  _show: function _show() {
	    if (this.props.transition) {
	      this._set_transition();
	    } else if (this.props.showAnimation) {
	      this._set_animation();
	    }
	  },
	  handleMouseEnter: function handleMouseEnter() {
	    clearTimeout(this.intervalId);
	    this._set_interval_id(null);
	    if (this.isHiding) {
	      this._set_is_hiding(false);
	
	      if (this.props.hideAnimation) {
	        this._clear_animation(true);
	      } else if (this.props.transition) {
	        this._clear_transition(true);
	      }
	    }
	  },
	  handleMouseLeave: function handleMouseLeave() {
	    if (!this.isHiding && (this.props.timeOut > 0 || this.props.extendedTimeOut > 0)) {
	      this._set_interval_id(setTimeout(this.hideToast, this.props.extendedTimeOut));
	    }
	  },
	  hideToast: function hideToast(override) {
	    if (this.isHiding || this.intervalId === null && !override) {
	      return;
	    }
	
	    this._set_is_hiding(true);
	    if (this.props.transition) {
	      this._set_transition(true);
	    } else if (this.props.hideAnimation) {
	      this._set_animation(true);
	    } else {
	      this._handle_remove();
	    }
	  },
	  _set_interval_id: function _set_interval_id(intervalId) {
	    this.intervalId = intervalId;
	  },
	  _set_is_hiding: function _set_is_hiding(isHiding) {
	    this.isHiding = isHiding;
	  }
	};

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function call_show_method($node, props) {
	  $node[props.showMethod]({
	    duration: props.showDuration,
	    easing: props.showEasing
	  });
	}
	
	exports.default = {
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {
	        display: "none" },
	      // effective $.hide()
	      showMethod: "fadeIn", // slideDown, and show are built into jQuery
	      showDuration: 300,
	      showEasing: "swing", // and linear are built into jQuery
	      hideMethod: "fadeOut",
	      hideDuration: 1000,
	      hideEasing: "swing",
	      //
	      timeOut: 5000,
	      extendedTimeOut: 1000
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      intervalId: null,
	      isHiding: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    call_show_method(this._get_$_node(), this.props);
	    if (this.props.timeOut > 0) {
	      this._set_interval_id(setTimeout(this.hideToast, this.props.timeOut));
	    }
	  },
	  handleMouseEnter: function handleMouseEnter() {
	    clearTimeout(this.state.intervalId);
	    this._set_interval_id(null);
	    this._set_is_hiding(false);
	
	    call_show_method(this._get_$_node().stop(true, true), this.props);
	  },
	  handleMouseLeave: function handleMouseLeave() {
	    if (!this.state.isHiding && (this.props.timeOut > 0 || this.props.extendedTimeOut > 0)) {
	      this._set_interval_id(setTimeout(this.hideToast, this.props.extendedTimeOut));
	    }
	  },
	  hideToast: function hideToast(override) {
	    if (this.state.isHiding || this.state.intervalId === null && !override) {
	      return;
	    }
	    this.setState({ isHiding: true });
	
	    this._get_$_node()[this.props.hideMethod]({
	      duration: this.props.hideDuration,
	      easing: this.props.hideEasing,
	      complete: this._handle_remove
	    });
	  },
	  _get_$_node: function _get_$_node() {
	    /* eslint-disable no-undef */
	    return jQuery(_reactDom2.default.findDOMNode(this));
	    /* eslint-enable no-undef */
	  },
	  _set_interval_id: function _set_interval_id(intervalId) {
	    this.setState({
	      intervalId: intervalId
	    });
	  },
	  _set_is_hiding: function _set_is_hiding(isHiding) {
	    this.setState({
	      isHiding: isHiding
	    });
	  }
	};

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToastMessage = exports.ToastContainer = undefined;
	
	var _ToastContainer = __webpack_require__(2880);
	
	var _ToastContainer2 = _interopRequireDefault(_ToastContainer);
	
	var _ToastMessage = __webpack_require__(784);
	
	var _ToastMessage2 = _interopRequireDefault(_ToastMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ToastContainer = _ToastContainer2.default;
	exports.ToastMessage = _ToastMessage2.default;

/***/ }),
/* 2884 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListener);
	      customListener = checkStatus.bind(_this, dataEventOff);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListener);
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
	  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListener = void 0;

/***/ }),
/* 2885 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ }),
/* 2886 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
	    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
	  };
	};

/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__(785);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatibale with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ }),
/* 2888 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var mutation = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = mutation.removedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var element = _step2.value;
	
	              if (element === _this.state.currentTarget) {
	                _this.hideTooltip();
	                return;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's nessesary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__(785);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2890 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),
/* 2891 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ }),
/* 2892 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, effect, offset) {
	  var tipWidth = node.clientWidth;
	  var tipHeight = node.clientHeight;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, target.clientWidth, target.clientHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  // Judge if the tooltip has over the window(screen)
	  var outsideVertical = function outsideVertical() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideLeft = function outsideLeft() {
	    var _outsideVertical = outsideVertical(),
	        result = _outsideVertical.result,
	        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority
	
	
	    if (result && outsideHorizontal().result) {
	      return { result: false }; // No need to change, if change to vertical will out of space
	    }
	    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
	      result = true; // If vertical ok, but let out of side and right won't out of side
	      newPlace = 'right';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideRight = function outsideRight() {
	    var _outsideVertical2 = outsideVertical(),
	        result = _outsideVertical2.result,
	        newPlace = _outsideVertical2.newPlace;
	
	    if (result && outsideHorizontal().result) {
	      return { result: false }; // No need to change, if change to vertical will out of space
	    }
	    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  var outsideHorizontal = function outsideHorizontal() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
	      result = true;
	      newPlace = 'right';
	    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideTop = function outsideTop() {
	    var _outsideHorizontal = outsideHorizontal(),
	        result = _outsideHorizontal.result,
	        newPlace = _outsideHorizontal.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideBottom = function outsideBottom() {
	    var _outsideHorizontal2 = outsideHorizontal(),
	        result = _outsideHorizontal2.result,
	        newPlace = _outsideHorizontal2.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  // Return new state to change the placement to the reverse if possible
	  var outsideLeftResult = outsideLeft();
	  var outsideRightResult = outsideRight();
	  var outsideTopResult = outsideTop();
	  var outsideBottomResult = outsideBottom();
	
	  if (place === 'left' && outsideLeftResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideLeftResult.newPlace }
	    };
	  } else if (place === 'right' && outsideRightResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideRightResult.newPlace }
	    };
	  } else if (place === 'top' && outsideTopResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideTopResult.newPlace }
	    };
	  } else if (place === 'bottom' && outsideBottomResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideBottomResult.newPlace }
	    };
	  }
	
	  // Return tooltip offset position
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	// Get current mouse offset
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	  var targetWidth = currentTarget.clientWidth;
	  var targetHeight = currentTarget.clientHeight;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {OBject} {left: {Number}, top: {Number}}
	 */
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and childern is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2894 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(786);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(2896);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(787);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(1518);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(1520);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(1522);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(1521);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(35);
	
	var _PropTypes = __webpack_require__(787);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 2897 */
66,
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(48);
	
	var focusNode = __webpack_require__(549);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(107);
	var EventPropagators = __webpack_require__(195);
	var ExecutionEnvironment = __webpack_require__(64);
	var FallbackCompositionState = __webpack_require__(2906);
	var SyntheticCompositionEvent = __webpack_require__(2945);
	var SyntheticInputEvent = __webpack_require__(2948);
	
	var keyOf = __webpack_require__(133);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(788);
	var ExecutionEnvironment = __webpack_require__(64);
	var ReactInstrumentation = __webpack_require__(82);
	
	var camelizeStyleName = __webpack_require__(1535);
	var dangerousStyleValue = __webpack_require__(2955);
	var hyphenateStyleName = __webpack_require__(1542);
	var memoizeStringOnly = __webpack_require__(1546);
	var warning = __webpack_require__(25);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(107);
	var EventPluginHub = __webpack_require__(194);
	var EventPropagators = __webpack_require__(195);
	var ExecutionEnvironment = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(109);
	var SyntheticEvent = __webpack_require__(120);
	
	var getEventTarget = __webpack_require__(428);
	var isEventSupported = __webpack_require__(429);
	var isTextInputElement = __webpack_require__(813);
	var keyOf = __webpack_require__(133);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var DOMLazyTree = __webpack_require__(192);
	var ExecutionEnvironment = __webpack_require__(64);
	
	var createNodesFromMarkup = __webpack_require__(1538);
	var emptyFunction = __webpack_require__(65);
	var invariant = __webpack_require__(22);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(133);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(107);
	var EventPropagators = __webpack_require__(195);
	var ReactDOMComponentTree = __webpack_require__(48);
	var SyntheticMouseEvent = __webpack_require__(289);
	
	var keyOf = __webpack_require__(133);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(136);
	
	var getTextContentAccessor = __webpack_require__(810);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(193);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactChildren = __webpack_require__(791);
	var ReactComponent = __webpack_require__(415);
	var ReactPureComponent = __webpack_require__(2934);
	var ReactClass = __webpack_require__(792);
	var ReactDOMFactories = __webpack_require__(2916);
	var ReactElement = __webpack_require__(108);
	var ReactPropTypes = __webpack_require__(803);
	var ReactVersion = __webpack_require__(804);
	
	var onlyChild = __webpack_require__(2960);
	var warning = __webpack_require__(25);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(196);
	
	var instantiateReactComponent = __webpack_require__(812);
	var KeyEscapeUtils = __webpack_require__(413);
	var shouldUpdateReactComponent = __webpack_require__(430);
	var traverseAllChildren = __webpack_require__(431);
	var warning = __webpack_require__(25);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(417);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeDevtool) {
	      ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	    }
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // __DEV__ only
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var ReactComponentEnvironment = __webpack_require__(416);
	var ReactCurrentOwner = __webpack_require__(137);
	var ReactElement = __webpack_require__(108);
	var ReactErrorUtils = __webpack_require__(418);
	var ReactInstanceMap = __webpack_require__(225);
	var ReactInstrumentation = __webpack_require__(82);
	var ReactNodeTypes = __webpack_require__(802);
	var ReactPropTypeLocations = __webpack_require__(421);
	var ReactReconciler = __webpack_require__(196);
	
	var checkReactTypeSpec = __webpack_require__(2954);
	var emptyObject = __webpack_require__(157);
	var invariant = __webpack_require__(22);
	var shallowEqual = __webpack_require__(184);
	var shouldUpdateReactComponent = __webpack_require__(430);
	var warning = __webpack_require__(25);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function invokeComponentDidMountWithTimer() {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	  publicInstance.componentDidMount();
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	}
	
	function invokeComponentDidUpdateWithTimer(prevProps, prevState, prevContext) {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	  publicInstance.componentDidUpdate(prevProps, prevState, prevContext);
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidMountWithTimer, this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function (component) {
	          return ReactInstrumentation.debugTool.onComponentHasMounted(_this._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	    var instanceOrElement;
	    if (doConstruct) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	      instanceOrElement = new Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	    } else {
	      // This can still be an instance in case of factory components
	      // but we'll count this as time spent rendering as the more common case.
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	      instanceOrElement = Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	    }
	    return instanceOrElement;
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onError();
	        }
	      }
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      inst.componentWillMount();
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	    if (false) {
	      if (child._debugID !== 0 && this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	      }
	    }
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context));
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	      inst.componentWillReceiveProps(nextProps, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          if (this._debugID !== 0) {
	            ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	          }
	        }
	        shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        if (false) {
	          if (this._debugID !== 0) {
	            ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	          }
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidUpdateWithTimer.bind(this, prevProps, prevState, prevContext), this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasUpdated(_this2._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	      if (false) {
	        if (child._debugID !== 0 && this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	        }
	      }
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context));
	
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	    var renderedComponent = inst.render();
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactDefaultInjection = __webpack_require__(2927);
	var ReactMount = __webpack_require__(800);
	var ReactReconciler = __webpack_require__(196);
	var ReactUpdates = __webpack_require__(109);
	var ReactVersion = __webpack_require__(804);
	
	var findDOMNode = __webpack_require__(2956);
	var getHostComponentFromComposite = __webpack_require__(808);
	var renderSubtreeIntoContainer = __webpack_require__(2962);
	var warning = __webpack_require__(25);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(286);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var AutoFocusUtils = __webpack_require__(2899);
	var CSSPropertyOperations = __webpack_require__(2901);
	var DOMLazyTree = __webpack_require__(192);
	var DOMNamespaces = __webpack_require__(411);
	var DOMProperty = __webpack_require__(193);
	var DOMPropertyOperations = __webpack_require__(790);
	var EventConstants = __webpack_require__(107);
	var EventPluginHub = __webpack_require__(194);
	var EventPluginRegistry = __webpack_require__(412);
	var ReactBrowserEventEmitter = __webpack_require__(288);
	var ReactComponentBrowserEnvironment = __webpack_require__(793);
	var ReactDOMButton = __webpack_require__(2912);
	var ReactDOMComponentFlags = __webpack_require__(794);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactDOMInput = __webpack_require__(2919);
	var ReactDOMOption = __webpack_require__(2921);
	var ReactDOMSelect = __webpack_require__(795);
	var ReactDOMTextarea = __webpack_require__(2924);
	var ReactInstrumentation = __webpack_require__(82);
	var ReactMultiChild = __webpack_require__(2932);
	var ReactServerRenderingTransaction = __webpack_require__(2937);
	
	var emptyFunction = __webpack_require__(65);
	var escapeTextContentForBrowser = __webpack_require__(290);
	var invariant = __webpack_require__(22);
	var isEventSupported = __webpack_require__(429);
	var keyOf = __webpack_require__(133);
	var shallowEqual = __webpack_require__(184);
	var validateDOMNesting = __webpack_require__(432);
	var warning = __webpack_require__(25);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setContentChildForInstrumentation = emptyFunction;
	if (false) {
	  setContentChildForInstrumentation = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    var contentDebugID = debugID + '#text';
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    this._contentDebugID = contentDebugID;
	    var text = '' + content;
	
	    ReactInstrumentation.debugTool.onSetDisplayName(contentDebugID, '#text');
	    ReactInstrumentation.debugTool.onSetParent(contentDebugID, debugID);
	    ReactInstrumentation.debugTool.onSetText(contentDebugID, text);
	
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = null;
	  this._domID = null;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setContentChildForInstrumentation.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the containing DOM component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasMounted(_this._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var _this2 = this;
	
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasUpdated(_this2._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setContentChildForInstrumentation.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setContentChildForInstrumentation.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._domID = null;
	    this._wrapperState = null;
	
	    if (false) {
	      setContentChildForInstrumentation.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(432);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var DOMLazyTree = __webpack_require__(192);
	var ReactDOMComponentTree = __webpack_require__(48);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = null;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(108);
	
	var mapObject = __webpack_require__(1545);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    var ReactElementValidator = require('./ReactElementValidator');
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 2917 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(410);
	var ReactDOMComponentTree = __webpack_require__(48);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var DisabledInputUtils = __webpack_require__(286);
	var DOMPropertyOperations = __webpack_require__(790);
	var LinkedValueUtils = __webpack_require__(414);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(109);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked !== undefined : props.value !== undefined;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	    if (props.type !== 'submit' && props.type !== 'reset') {
	      node.value = node.value;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDOMDebugTool = require('./ReactDOMDebugTool');
	  debugTool = ReactDOMDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactChildren = __webpack_require__(791);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactDOMSelect = __webpack_require__(795);
	
	var warning = __webpack_require__(25);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var getNodeForCharacterOffset = __webpack_require__(2959);
	var getTextContentAccessor = __webpack_require__(810);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var DOMChildrenOperations = __webpack_require__(410);
	var DOMLazyTree = __webpack_require__(192);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(82);
	
	var escapeTextContentForBrowser = __webpack_require__(290);
	var invariant = __webpack_require__(22);
	var validateDOMNesting = __webpack_require__(432);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = null;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetText(this._debugID, this._stringText);
	
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	
	        if (false) {
	          ReactInstrumentation.debugTool.onSetText(this._debugID, nextStringText);
	        }
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(36);
	
	var DisabledInputUtils = __webpack_require__(286);
	var LinkedValueUtils = __webpack_require__(414);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(109);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactUpdates = __webpack_require__(109);
	var Transaction = __webpack_require__(226);
	
	var emptyFunction = __webpack_require__(65);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(2900);
	var ChangeEventPlugin = __webpack_require__(2902);
	var DefaultEventPluginOrder = __webpack_require__(2904);
	var EnterLeaveEventPlugin = __webpack_require__(2905);
	var HTMLDOMPropertyConfig = __webpack_require__(2907);
	var ReactComponentBrowserEnvironment = __webpack_require__(793);
	var ReactDOMComponent = __webpack_require__(2913);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactDOMEmptyComponent = __webpack_require__(2915);
	var ReactDOMTreeTraversal = __webpack_require__(2925);
	var ReactDOMTextComponent = __webpack_require__(2923);
	var ReactDefaultBatchingStrategy = __webpack_require__(2926);
	var ReactEventListener = __webpack_require__(2929);
	var ReactInjection = __webpack_require__(2930);
	var ReactReconcileTransaction = __webpack_require__(2935);
	var SVGDOMPropertyConfig = __webpack_require__(2940);
	var SelectEventPlugin = __webpack_require__(2941);
	var SimpleEventPlugin = __webpack_require__(2942);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(194);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var EventListener = __webpack_require__(548);
	var ExecutionEnvironment = __webpack_require__(64);
	var PooledClass = __webpack_require__(136);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(109);
	
	var getEventTarget = __webpack_require__(428);
	var getUnboundedScrollPosition = __webpack_require__(1540);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(193);
	var EventPluginHub = __webpack_require__(194);
	var EventPluginUtils = __webpack_require__(287);
	var ReactComponentEnvironment = __webpack_require__(416);
	var ReactClass = __webpack_require__(792);
	var ReactEmptyComponent = __webpack_require__(796);
	var ReactBrowserEventEmitter = __webpack_require__(288);
	var ReactHostComponent = __webpack_require__(798);
	var ReactUpdates = __webpack_require__(109);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(2953);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactComponentEnvironment = __webpack_require__(416);
	var ReactInstanceMap = __webpack_require__(225);
	var ReactInstrumentation = __webpack_require__(82);
	var ReactMultiChildUpdateTypes = __webpack_require__(801);
	
	var ReactCurrentOwner = __webpack_require__(137);
	var ReactReconciler = __webpack_require__(196);
	var ReactChildReconciler = __webpack_require__(2909);
	
	var emptyFunction = __webpack_require__(65);
	var flattenChildren = __webpack_require__(2957);
	var invariant = __webpack_require__(22);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setParentForInstrumentation = emptyFunction;
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setParentForInstrumentation = function (child) {
	    if (child._debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetParent(child._debugID, getDebugID(this));
	    }
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          if (false) {
	            setParentForInstrumentation.call(this, child);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var ReactComponent = __webpack_require__(415);
	var ReactNoopUpdateQueue = __webpack_require__(419);
	
	var emptyObject = __webpack_require__(157);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var CallbackQueue = __webpack_require__(789);
	var PooledClass = __webpack_require__(136);
	var ReactBrowserEventEmitter = __webpack_require__(288);
	var ReactInputSelection = __webpack_require__(799);
	var ReactInstrumentation = __webpack_require__(82);
	var Transaction = __webpack_require__(226);
	var ReactUpdateQueue = __webpack_require__(423);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(2933);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
	    // If owner changes but we have an unchanged function ref, don't update refs
	    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(36);
	
	var PooledClass = __webpack_require__(136);
	var Transaction = __webpack_require__(226);
	var ReactInstrumentation = __webpack_require__(82);
	var ReactServerUpdateQueue = __webpack_require__(2938);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(423);
	var Transaction = __webpack_require__(226);
	var warning = __webpack_require__(25);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(64);
	
	var getVendorPrefixedEventName = __webpack_require__(811);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ }),
/* 2940 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(107);
	var EventPropagators = __webpack_require__(195);
	var ExecutionEnvironment = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactInputSelection = __webpack_require__(799);
	var SyntheticEvent = __webpack_require__(120);
	
	var getActiveElement = __webpack_require__(550);
	var isTextInputElement = __webpack_require__(813);
	var keyOf = __webpack_require__(133);
	var shallowEqual = __webpack_require__(184);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var EventConstants = __webpack_require__(107);
	var EventListener = __webpack_require__(548);
	var EventPropagators = __webpack_require__(195);
	var ReactDOMComponentTree = __webpack_require__(48);
	var SyntheticAnimationEvent = __webpack_require__(2943);
	var SyntheticClipboardEvent = __webpack_require__(2944);
	var SyntheticEvent = __webpack_require__(120);
	var SyntheticFocusEvent = __webpack_require__(2947);
	var SyntheticKeyboardEvent = __webpack_require__(2949);
	var SyntheticMouseEvent = __webpack_require__(289);
	var SyntheticDragEvent = __webpack_require__(2946);
	var SyntheticTouchEvent = __webpack_require__(2950);
	var SyntheticTransitionEvent = __webpack_require__(2951);
	var SyntheticUIEvent = __webpack_require__(197);
	var SyntheticWheelEvent = __webpack_require__(2952);
	
	var emptyFunction = __webpack_require__(65);
	var getEventCharCode = __webpack_require__(426);
	var invariant = __webpack_require__(22);
	var keyOf = __webpack_require__(133);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  return '.' + inst._rootNodeID;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(120);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(120);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(120);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(289);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(197);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(120);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(197);
	
	var getEventCharCode = __webpack_require__(426);
	var getEventKey = __webpack_require__(2958);
	var getEventModifierState = __webpack_require__(427);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(197);
	
	var getEventModifierState = __webpack_require__(427);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(120);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(289);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 2953 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactPropTypeLocationNames = __webpack_require__(420);
	var ReactPropTypesSecret = __webpack_require__(422);
	
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(417);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeDevtool) {
	            ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(788);
	var warning = __webpack_require__(25);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactCurrentOwner = __webpack_require__(137);
	var ReactDOMComponentTree = __webpack_require__(48);
	var ReactInstanceMap = __webpack_require__(225);
	
	var getHostComponentFromComposite = __webpack_require__(808);
	var invariant = __webpack_require__(22);
	var warning = __webpack_require__(25);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(413);
	var traverseAllChildren = __webpack_require__(431);
	var warning = __webpack_require__(25);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(417);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeDevtool) {
	        ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	      }
	      process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(426);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 2959 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactElement = __webpack_require__(108);
	
	var invariant = __webpack_require__(22);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : _prodInvariant('23') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(290);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(800);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 2963 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = shallowEqual;
	// Copied from https://github.com/facebook/fbjs/blob/master/src/core/shallowEqual.js
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDock = __webpack_require__(2769);
	
	var _reactDock2 = _interopRequireDefault(_reactDock);
	
	var _constants = __webpack_require__(816);
	
	var _actions = __webpack_require__(815);
	
	var _reducers = __webpack_require__(2966);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _parseKey = __webpack_require__(2749);
	
	var _parseKey2 = _interopRequireDefault(_parseKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DockMonitor = function (_Component) {
	  _inherits(DockMonitor, _Component);
	
	  function DockMonitor(props) {
	    _classCallCheck(this, DockMonitor);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleSizeChange = _this.handleSizeChange.bind(_this);
	
	    var childrenCount = _react.Children.count(props.children);
	    if (childrenCount === 0) {
	      console.error('<DockMonitor> requires at least one monitor inside. ' + 'Why don’t you try <LogMonitor>? You can get it at ' + 'https://github.com/gaearon/redux-devtools-log-monitor.');
	    } else if (childrenCount > 1 && !props.changeMonitorKey) {
	      console.error('You specified multiple monitors inside <DockMonitor> ' + 'but did not provide `changeMonitorKey` prop to change them. ' + 'Try specifying <DockMonitor changeMonitorKey="ctrl-m" /> ' + 'and then press Ctrl-M.');
	    }
	    return _this;
	  }
	
	  DockMonitor.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('keydown', this.handleKeyDown);
	  };
	
	  DockMonitor.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('keydown', this.handleKeyDown);
	  };
	
	  DockMonitor.prototype.matchesKey = function matchesKey(key, event) {
	    if (!key) {
	      return false;
	    }
	
	    var charCode = event.keyCode || event.which;
	    var char = String.fromCharCode(charCode);
	    return key.name.toUpperCase() === char.toUpperCase() && key.alt === event.altKey && key.ctrl === event.ctrlKey && key.meta === event.metaKey && key.shift === event.shiftKey;
	  };
	
	  DockMonitor.prototype.handleKeyDown = function handleKeyDown(e) {
	    // Ignore regular keys when focused on a field
	    // and no modifiers are active.
	    if (!e.ctrlKey && !e.metaKey && !e.altKey && (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable)) {
	      return;
	    }
	
	    var visibilityKey = (0, _parseKey2.default)(this.props.toggleVisibilityKey);
	    var positionKey = (0, _parseKey2.default)(this.props.changePositionKey);
	
	    var monitorKey = void 0;
	    if (this.props.changeMonitorKey) {
	      monitorKey = (0, _parseKey2.default)(this.props.changeMonitorKey);
	    }
	
	    if (this.matchesKey(visibilityKey, e)) {
	      e.preventDefault();
	      this.props.dispatch((0, _actions.toggleVisibility)());
	    } else if (this.matchesKey(positionKey, e)) {
	      e.preventDefault();
	      this.props.dispatch((0, _actions.changePosition)());
	    } else if (this.matchesKey(monitorKey, e)) {
	      e.preventDefault();
	      this.props.dispatch((0, _actions.changeMonitor)());
	    }
	  };
	
	  DockMonitor.prototype.handleSizeChange = function handleSizeChange(requestedSize) {
	    this.props.dispatch((0, _actions.changeSize)(requestedSize));
	  };
	
	  DockMonitor.prototype.renderChild = function renderChild(child, index, otherProps) {
	    var monitorState = this.props.monitorState;
	    var childMonitorIndex = monitorState.childMonitorIndex,
	        childMonitorStates = monitorState.childMonitorStates;
	
	
	    if (index !== childMonitorIndex) {
	      return null;
	    }
	
	    return (0, _react.cloneElement)(child, _extends({
	      monitorState: childMonitorStates[index]
	    }, otherProps));
	  };
	
	  DockMonitor.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        monitorState = _props.monitorState,
	        children = _props.children,
	        fluid = _props.fluid,
	        rest = _objectWithoutProperties(_props, ['monitorState', 'children', 'fluid']);
	
	    var position = monitorState.position,
	        isVisible = monitorState.isVisible,
	        size = monitorState.size;
	
	
	    return _react2.default.createElement(
	      _reactDock2.default,
	      { position: position,
	        isVisible: isVisible,
	        size: size,
	        fluid: fluid,
	        onSizeChange: this.handleSizeChange,
	        dimMode: 'none' },
	      _react.Children.map(children, function (child, index) {
	        return _this2.renderChild(child, index, rest);
	      })
	    );
	  };
	
	  return DockMonitor;
	}(_react.Component);
	
	DockMonitor.update = _reducers2.default;
	DockMonitor.propTypes = {
	  defaultPosition: _propTypes2.default.oneOf(_constants.POSITIONS),
	  defaultIsVisible: _propTypes2.default.bool.isRequired,
	  defaultSize: _propTypes2.default.number.isRequired,
	  toggleVisibilityKey: _propTypes2.default.string.isRequired,
	  changePositionKey: _propTypes2.default.string.isRequired,
	  changeMonitorKey: _propTypes2.default.string,
	  fluid: _propTypes2.default.bool,
	
	  dispatch: _propTypes2.default.func,
	  monitorState: _propTypes2.default.shape({
	    position: _propTypes2.default.oneOf(_constants.POSITIONS).isRequired,
	    size: _propTypes2.default.number.isRequired,
	    isVisible: _propTypes2.default.bool.isRequired,
	    childMonitorState: _propTypes2.default.any
	  })
	};
	DockMonitor.defaultProps = {
	  defaultIsVisible: true,
	  defaultPosition: 'right',
	  defaultSize: 0.3,
	  fluid: true
	};
	exports.default = DockMonitor;

/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _DockMonitor = __webpack_require__(2964);
	
	var _DockMonitor2 = _interopRequireDefault(_DockMonitor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DockMonitor2.default;

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = reducer;
	
	var _actions = __webpack_require__(815);
	
	var _constants = __webpack_require__(816);
	
	var _react = __webpack_require__(1);
	
	function position(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultPosition;
	  var action = arguments[2];
	
	  return action.type === _actions.CHANGE_POSITION ? _constants.POSITIONS[(_constants.POSITIONS.indexOf(state) + 1) % _constants.POSITIONS.length] : state;
	}
	
	function size(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultSize;
	  var action = arguments[2];
	
	  return action.type === _actions.CHANGE_SIZE ? action.size : state;
	}
	
	function isVisible(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultIsVisible;
	  var action = arguments[2];
	
	  return action.type === _actions.TOGGLE_VISIBILITY ? !state : state;
	}
	
	function childMonitorStates(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var action = arguments[2];
	
	  return _react.Children.map(props.children, function (child, index) {
	    return child.type.update(child.props, state[index], action);
	  });
	}
	
	function childMonitorIndex(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var action = arguments[2];
	
	  switch (action.type) {
	    case _actions.CHANGE_MONITOR:
	      return (state + 1) % _react.Children.count(props.children);
	    default:
	      return state;
	  }
	}
	
	function reducer(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var action = arguments[2];
	
	  if (!state.childMonitorStates) {
	    _react.Children.forEach(props.children, function (child, index) {
	      if (typeof child.type.update !== 'function') {
	        console.error('Child of <DockMonitor> with the index ' + index + ' ' + ('(' + (child.type.displayName || child.type.name || child.type) + ') ') + 'does not appear to be a valid Redux DevTools monitor.');
	      }
	    });
	  }
	
	  return {
	    position: position(props, state.position, action),
	    isVisible: isVisible(props, state.isVisible, action),
	    size: size(props, state.size, action),
	    childMonitorIndex: childMonitorIndex(props, state.childMonitorIndex, action),
	    childMonitorStates: childMonitorStates(props, state.childMonitorStates, action)
	  };
	}

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _function = __webpack_require__(224);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _reduxDevtoolsThemes = __webpack_require__(2977);
	
	var themes = _interopRequireWildcard(_reduxDevtoolsThemes);
	
	var _reduxDevtools = __webpack_require__(433);
	
	var _actions = __webpack_require__(818);
	
	var _reducers = __webpack_require__(2975);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _LogMonitorButtonBar = __webpack_require__(2969);
	
	var _LogMonitorButtonBar2 = _interopRequireDefault(_LogMonitorButtonBar);
	
	var _LogMonitorEntryList = __webpack_require__(2972);
	
	var _LogMonitorEntryList2 = _interopRequireDefault(_LogMonitorEntryList);
	
	var _lodash = __webpack_require__(2976);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toggleAction = _reduxDevtools.ActionCreators.toggleAction;
	var setActionsActive = _reduxDevtools.ActionCreators.setActionsActive;
	
	
	var styles = {
	  container: {
	    fontFamily: 'monaco, Consolas, Lucida Console, monospace',
	    position: 'relative',
	    overflowY: 'hidden',
	    width: '100%',
	    height: '100%',
	    minWidth: 300,
	    direction: 'ltr'
	  },
	  elements: {
	    position: 'absolute',
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    overflowX: 'hidden',
	    overflowY: 'auto'
	  }
	};
	
	var LogMonitor = function (_Component) {
	  _inherits(LogMonitor, _Component);
	
	  function LogMonitor(props) {
	    _classCallCheck(this, LogMonitor);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.shouldComponentUpdate = _function2.default;
	    _this.updateScrollTop = (0, _lodash2.default)(function () {
	      var node = _this.node;
	      _this.props.dispatch((0, _actions.updateScrollTop)(node ? node.scrollTop : 0));
	    }, 500);
	
	    _this.handleToggleAction = _this.handleToggleAction.bind(_this);
	    _this.handleToggleConsecutiveAction = _this.handleToggleConsecutiveAction.bind(_this);
	    _this.getRef = _this.getRef.bind(_this);
	    return _this;
	  }
	
	  LogMonitor.prototype.scroll = function scroll() {
	    var node = this.node;
	    if (!node) {
	      return;
	    }
	    if (this.scrollDown) {
	      var offsetHeight = node.offsetHeight;
	      var scrollHeight = node.scrollHeight;
	
	      node.scrollTop = scrollHeight - offsetHeight;
	      this.scrollDown = false;
	    }
	  };
	
	  LogMonitor.prototype.componentDidMount = function componentDidMount() {
	    var node = this.node;
	    if (!node || !this.props.monitorState) {
	      return;
	    }
	
	    if (this.props.preserveScrollTop) {
	      node.scrollTop = this.props.monitorState.initialScrollTop;
	      node.addEventListener('scroll', this.updateScrollTop);
	    } else {
	      this.scrollDown = true;
	      this.scroll();
	    }
	  };
	
	  LogMonitor.prototype.componentWillUnmount = function componentWillUnmount() {
	    var node = this.node;
	    if (node && this.props.preserveScrollTop) {
	      node.removeEventListener('scroll', this.updateScrollTop);
	    }
	  };
	
	  LogMonitor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var node = this.node;
	    if (!node) {
	      this.scrollDown = true;
	    } else if (this.props.stagedActionIds.length < nextProps.stagedActionIds.length) {
	      var scrollTop = node.scrollTop;
	      var offsetHeight = node.offsetHeight;
	      var scrollHeight = node.scrollHeight;
	
	
	      this.scrollDown = Math.abs(scrollHeight - (scrollTop + offsetHeight)) < 20;
	    } else {
	      this.scrollDown = false;
	    }
	  };
	
	  LogMonitor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.scroll();
	  };
	
	  LogMonitor.prototype.handleToggleAction = function handleToggleAction(id) {
	    this.props.dispatch(toggleAction(id));
	  };
	
	  LogMonitor.prototype.handleToggleConsecutiveAction = function handleToggleConsecutiveAction(id) {
	    var _props = this.props;
	    var monitorState = _props.monitorState;
	    var actionsById = _props.actionsById;
	    var consecutiveToggleStartId = monitorState.consecutiveToggleStartId;
	
	    if (consecutiveToggleStartId && actionsById[consecutiveToggleStartId]) {
	      var skippedActionIds = this.props.skippedActionIds;
	
	      var start = Math.min(consecutiveToggleStartId, id);
	      var end = Math.max(consecutiveToggleStartId, id);
	      var active = skippedActionIds.indexOf(consecutiveToggleStartId) > -1;
	      this.props.dispatch(setActionsActive(start, end + 1, active));
	      this.props.dispatch((0, _actions.startConsecutiveToggle)(null));
	    } else if (id > 0) {
	      this.props.dispatch((0, _actions.startConsecutiveToggle)(id));
	    }
	  };
	
	  LogMonitor.prototype.getTheme = function getTheme() {
	    var theme = this.props.theme;
	
	    if (typeof theme !== 'string') {
	      return theme;
	    }
	
	    if (typeof themes[theme] !== 'undefined') {
	      return themes[theme];
	    }
	
	    console.warn('DevTools theme ' + theme + ' not found, defaulting to nicinabox');
	    return themes.nicinabox;
	  };
	
	  LogMonitor.prototype.getRef = function getRef(node) {
	    this.node = node;
	  };
	
	  LogMonitor.prototype.render = function render() {
	    var theme = this.getTheme();
	    var consecutiveToggleStartId = this.props.monitorState.consecutiveToggleStartId;
	    var _props2 = this.props;
	    var dispatch = _props2.dispatch;
	    var actionsById = _props2.actionsById;
	    var skippedActionIds = _props2.skippedActionIds;
	    var stagedActionIds = _props2.stagedActionIds;
	    var computedStates = _props2.computedStates;
	    var currentStateIndex = _props2.currentStateIndex;
	    var select = _props2.select;
	    var expandActionRoot = _props2.expandActionRoot;
	    var expandStateRoot = _props2.expandStateRoot;
	    var markStateDiff = _props2.markStateDiff;
	
	
	    var entryListProps = {
	      theme: theme,
	      actionsById: actionsById,
	      skippedActionIds: skippedActionIds,
	      stagedActionIds: stagedActionIds,
	      computedStates: computedStates,
	      currentStateIndex: currentStateIndex,
	      consecutiveToggleStartId: consecutiveToggleStartId,
	      select: select,
	      expandActionRoot: expandActionRoot,
	      expandStateRoot: expandStateRoot,
	      markStateDiff: markStateDiff,
	      onActionClick: this.handleToggleAction,
	      onActionShiftClick: this.handleToggleConsecutiveAction
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: _extends({}, styles.container, { backgroundColor: theme.base00 }) },
	      !this.props.hideMainButtons && _react2.default.createElement(_LogMonitorButtonBar2.default, {
	        theme: theme,
	        dispatch: dispatch,
	        hasStates: computedStates.length > 1,
	        hasSkippedActions: skippedActionIds.length > 0
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: this.props.hideMainButtons ? styles.elements : _extends({}, styles.elements, { top: 30 }),
	          ref: this.getRef
	        },
	        _react2.default.createElement(_LogMonitorEntryList2.default, entryListProps)
	      )
	    );
	  };
	
	  return LogMonitor;
	}(_react.Component);
	
	LogMonitor.update = _reducers2.default;
	LogMonitor.propTypes = {
	  dispatch: _propTypes2.default.func,
	  computedStates: _propTypes2.default.array,
	  actionsById: _propTypes2.default.object,
	  stagedActionIds: _propTypes2.default.array,
	  skippedActionIds: _propTypes2.default.array,
	  monitorState: _propTypes2.default.shape({
	    initialScrollTop: _propTypes2.default.number,
	    consecutiveToggleStartId: _propTypes2.default.number
	  }),
	
	  preserveScrollTop: _propTypes2.default.bool,
	  select: _propTypes2.default.func,
	  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  expandActionRoot: _propTypes2.default.bool,
	  expandStateRoot: _propTypes2.default.bool,
	  markStateDiff: _propTypes2.default.bool,
	  hideMainButtons: _propTypes2.default.bool
	};
	LogMonitor.defaultProps = {
	  select: function select(state) {
	    return state;
	  },
	  theme: 'nicinabox',
	  preserveScrollTop: true,
	  expandActionRoot: true,
	  expandStateRoot: true,
	  markStateDiff: false
	};
	exports.default = LogMonitor;

/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _brighten = __webpack_require__(2973);
	
	var _brighten2 = _interopRequireDefault(_brighten);
	
	var _function = __webpack_require__(224);
	
	var _function2 = _interopRequireDefault(_function);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  base: {
	    cursor: 'pointer',
	    fontWeight: 'bold',
	    borderRadius: 3,
	    padding: 4,
	    marginLeft: 3,
	    marginRight: 3,
	    marginTop: 5,
	    marginBottom: 5,
	    flexGrow: 1,
	    display: 'inline-block',
	    fontSize: '0.8em',
	    color: 'white',
	    textDecoration: 'none'
	  }
	};
	
	var LogMonitorButton = function (_React$Component) {
	  _inherits(LogMonitorButton, _React$Component);
	
	  function LogMonitorButton(props) {
	    _classCallCheck(this, LogMonitorButton);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.shouldComponentUpdate = _function2.default;
	
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	
	    _this.state = {
	      hovered: false,
	      active: false
	    };
	    return _this;
	  }
	
	  LogMonitorButton.prototype.handleMouseEnter = function handleMouseEnter() {
	    this.setState({ hovered: true });
	  };
	
	  LogMonitorButton.prototype.handleMouseLeave = function handleMouseLeave() {
	    this.setState({ hovered: false });
	  };
	
	  LogMonitorButton.prototype.handleMouseDown = function handleMouseDown() {
	    this.setState({ active: true });
	  };
	
	  LogMonitorButton.prototype.handleMouseUp = function handleMouseUp() {
	    this.setState({ active: false });
	  };
	
	  LogMonitorButton.prototype.onClick = function onClick() {
	    if (!this.props.enabled) {
	      return;
	    }
	    if (this.props.onClick) {
	      this.props.onClick();
	    }
	  };
	
	  LogMonitorButton.prototype.render = function render() {
	    var style = _extends({}, styles.base, {
	      backgroundColor: this.props.theme.base02
	    });
	    if (this.props.enabled && this.state.hovered) {
	      style = _extends({}, style, {
	        backgroundColor: (0, _brighten2.default)(this.props.theme.base02, 0.2)
	      });
	    }
	    if (!this.props.enabled) {
	      style = _extends({}, style, {
	        opacity: 0.2,
	        cursor: 'text',
	        backgroundColor: 'transparent'
	      });
	    }
	    return _react2.default.createElement(
	      'a',
	      { onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onClick: this.onClick,
	        style: style },
	      this.props.children
	    );
	  };
	
	  return LogMonitorButton;
	}(_react2.default.Component);
	
	exports.default = LogMonitorButton;

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _function = __webpack_require__(224);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _reduxDevtools = __webpack_require__(433);
	
	var _LogMonitorButton = __webpack_require__(2968);
	
	var _LogMonitorButton2 = _interopRequireDefault(_LogMonitorButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var reset = _reduxDevtools.ActionCreators.reset;
	var rollback = _reduxDevtools.ActionCreators.rollback;
	var commit = _reduxDevtools.ActionCreators.commit;
	var sweep = _reduxDevtools.ActionCreators.sweep;
	
	
	var style = {
	  textAlign: 'center',
	  borderBottomWidth: 1,
	  borderBottomStyle: 'solid',
	  borderColor: 'transparent',
	  zIndex: 1,
	  display: 'flex',
	  flexDirection: 'row'
	};
	
	var LogMonitorButtonBar = function (_Component) {
	  _inherits(LogMonitorButtonBar, _Component);
	
	  function LogMonitorButtonBar(props) {
	    _classCallCheck(this, LogMonitorButtonBar);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.shouldComponentUpdate = _function2.default;
	
	    _this.handleReset = _this.handleReset.bind(_this);
	    _this.handleRollback = _this.handleRollback.bind(_this);
	    _this.handleSweep = _this.handleSweep.bind(_this);
	    _this.handleCommit = _this.handleCommit.bind(_this);
	    return _this;
	  }
	
	  LogMonitorButtonBar.prototype.handleRollback = function handleRollback() {
	    this.props.dispatch(rollback());
	  };
	
	  LogMonitorButtonBar.prototype.handleSweep = function handleSweep() {
	    this.props.dispatch(sweep());
	  };
	
	  LogMonitorButtonBar.prototype.handleCommit = function handleCommit() {
	    this.props.dispatch(commit());
	  };
	
	  LogMonitorButtonBar.prototype.handleReset = function handleReset() {
	    this.props.dispatch(reset());
	  };
	
	  LogMonitorButtonBar.prototype.render = function render() {
	    var _props = this.props;
	    var theme = _props.theme;
	    var hasStates = _props.hasStates;
	    var hasSkippedActions = _props.hasSkippedActions;
	
	    return _react2.default.createElement(
	      'div',
	      { style: _extends({}, style, { borderColor: theme.base02 }) },
	      _react2.default.createElement(
	        _LogMonitorButton2.default,
	        {
	          theme: theme,
	          onClick: this.handleReset,
	          enabled: true },
	        'Reset'
	      ),
	      _react2.default.createElement(
	        _LogMonitorButton2.default,
	        {
	          theme: theme,
	          onClick: this.handleRollback,
	          enabled: hasStates },
	        'Revert'
	      ),
	      _react2.default.createElement(
	        _LogMonitorButton2.default,
	        {
	          theme: theme,
	          onClick: this.handleSweep,
	          enabled: hasSkippedActions },
	        'Sweep'
	      ),
	      _react2.default.createElement(
	        _LogMonitorButton2.default,
	        {
	          theme: theme,
	          onClick: this.handleCommit,
	          enabled: hasStates },
	        'Commit'
	      )
	    );
	  };
	
	  return LogMonitorButtonBar;
	}(_react.Component);
	
	LogMonitorButtonBar.propTypes = {
	  dispatch: _propTypes2.default.func,
	  theme: _propTypes2.default.object
	};
	exports.default = LogMonitorButtonBar;

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJsonTree = __webpack_require__(758);
	
	var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);
	
	var _LogMonitorEntryAction = __webpack_require__(2971);
	
	var _LogMonitorEntryAction2 = _interopRequireDefault(_LogMonitorEntryAction);
	
	var _function = __webpack_require__(224);
	
	var _function2 = _interopRequireDefault(_function);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  entry: {
	    display: 'block',
	    WebkitUserSelect: 'none'
	  },
	
	  root: {
	    marginLeft: 0
	  }
	};
	
	var getDeepItem = function getDeepItem(data, path) {
	  return path.reduce(function (obj, key) {
	    return obj && obj[key];
	  }, data);
	};
	var dataIsEqual = function dataIsEqual(data, previousData, keyPath) {
	  var path = [].concat(keyPath).reverse().slice(1);
	
	  return getDeepItem(data, path) === getDeepItem(previousData, path);
	};
	
	var LogMonitorEntry = function (_Component) {
	  _inherits(LogMonitorEntry, _Component);
	
	  function LogMonitorEntry(props) {
	    _classCallCheck(this, LogMonitorEntry);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.shouldComponentUpdate = _function2.default;
	
	    _this.handleActionClick = _this.handleActionClick.bind(_this);
	    _this.shouldExpandNode = _this.shouldExpandNode.bind(_this);
	    return _this;
	  }
	
	  LogMonitorEntry.prototype.printState = function printState(state, error) {
	    var _this2 = this;
	
	    var errorText = error;
	    if (!errorText) {
	      try {
	        var _ret = function () {
	          var data = _this2.props.select(state);
	          var theme = void 0;
	
	          if (_this2.props.markStateDiff) {
	            (function () {
	              var previousData = typeof _this2.props.previousState !== 'undefined' ? _this2.props.select(_this2.props.previousState) : undefined;
	              var getValueStyle = function getValueStyle(_ref, nodeType, keyPath) {
	                var style = _ref.style;
	                return {
	                  style: _extends({}, style, {
	                    backgroundColor: dataIsEqual(data, previousData, keyPath) ? 'transparent' : _this2.props.theme.base01
	                  })
	                };
	              };
	              var getNestedNodeStyle = function getNestedNodeStyle(_ref2, keyPath) {
	                var style = _ref2.style;
	                return {
	                  style: _extends({}, style, keyPath.length > 1 ? {} : styles.root)
	                };
	              };
	              theme = {
	                extend: _this2.props.theme,
	                tree: styles.tree,
	                value: getValueStyle,
	                nestedNode: getNestedNodeStyle
	              };
	            })();
	          } else {
	            theme = _this2.props.theme;
	          }
	
	          return {
	            v: _react2.default.createElement(_reactJsonTree2.default, {
	              theme: theme,
	              data: data,
	              invertTheme: false,
	              keyPath: ['state'],
	              shouldExpandNode: _this2.shouldExpandNode })
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      } catch (err) {
	        errorText = 'Error selecting state.';
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: {
	          color: this.props.theme.base08,
	          paddingTop: 20,
	          paddingLeft: 30,
	          paddingRight: 30,
	          paddingBottom: 35
	        } },
	      errorText
	    );
	  };
	
	  LogMonitorEntry.prototype.handleActionClick = function handleActionClick(e) {
	    var _props = this.props;
	    var actionId = _props.actionId;
	    var onActionClick = _props.onActionClick;
	    var onActionShiftClick = _props.onActionShiftClick;
	
	    if (actionId > 0) {
	      if (e.shiftKey) {
	        onActionShiftClick(actionId);
	      } else {
	        onActionClick(actionId);
	      }
	    }
	  };
	
	  LogMonitorEntry.prototype.shouldExpandNode = function shouldExpandNode(keyName, data, level) {
	    return this.props.expandStateRoot && level === 0;
	  };
	
	  LogMonitorEntry.prototype.render = function render() {
	    var _props2 = this.props;
	    var actionId = _props2.actionId;
	    var error = _props2.error;
	    var action = _props2.action;
	    var state = _props2.state;
	    var collapsed = _props2.collapsed;
	    var selected = _props2.selected;
	    var inFuture = _props2.inFuture;
	
	    var styleEntry = {
	      opacity: collapsed ? 0.5 : 1,
	      cursor: actionId > 0 ? 'pointer' : 'default'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: {
	          opacity: selected ? 0.4 : inFuture ? 0.6 : 1, // eslint-disable-line no-nested-ternary
	          textDecoration: collapsed ? 'line-through' : 'none',
	          color: this.props.theme.base06
	        } },
	      _react2.default.createElement(_LogMonitorEntryAction2.default, {
	        theme: this.props.theme,
	        collapsed: collapsed,
	        action: action,
	        expandActionRoot: this.props.expandActionRoot,
	        onClick: this.handleActionClick,
	        style: _extends({}, styles.entry, styleEntry) }),
	      !collapsed && _react2.default.createElement(
	        'div',
	        { style: { paddingLeft: 16 } },
	        this.printState(state, error)
	      )
	    );
	  };
	
	  return LogMonitorEntry;
	}(_react.Component);
	
	LogMonitorEntry.propTypes = {
	  state: _propTypes2.default.object.isRequired,
	  action: _propTypes2.default.object.isRequired,
	  actionId: _propTypes2.default.number.isRequired,
	  select: _propTypes2.default.func.isRequired,
	  inFuture: _propTypes2.default.bool,
	  error: _propTypes2.default.string,
	  onActionClick: _propTypes2.default.func.isRequired,
	  onActionShiftClick: _propTypes2.default.func.isRequired,
	  collapsed: _propTypes2.default.bool,
	  selected: _propTypes2.default.bool,
	  expandActionRoot: _propTypes2.default.bool,
	  expandStateRoot: _propTypes2.default.bool
	};
	exports.default = LogMonitorEntry;

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJsonTree = __webpack_require__(758);
	
	var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  actionBar: {
	    paddingTop: 8,
	    paddingBottom: 7,
	    paddingLeft: 16
	  },
	  payload: {
	    margin: 0,
	    paddingLeft: 16,
	    overflow: 'auto'
	  }
	};
	
	var LogMonitorAction = function (_Component) {
	  _inherits(LogMonitorAction, _Component);
	
	  function LogMonitorAction(props) {
	    _classCallCheck(this, LogMonitorAction);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.shouldExpandNode = _this.shouldExpandNode.bind(_this);
	    return _this;
	  }
	
	  LogMonitorAction.prototype.renderPayload = function renderPayload(payload) {
	    return _react2.default.createElement(
	      'div',
	      { style: _extends({}, styles.payload, {
	          backgroundColor: this.props.theme.base00
	        }) },
	      Object.keys(payload).length > 0 ? _react2.default.createElement(_reactJsonTree2.default, { theme: this.props.theme,
	        invertTheme: false,
	        keyPath: ['action'],
	        data: payload,
	        shouldExpandNode: this.shouldExpandNode }) : ''
	    );
	  };
	
	  LogMonitorAction.prototype.shouldExpandNode = function shouldExpandNode(keyName, data, level) {
	    return this.props.expandActionRoot && level === 0;
	  };
	
	  LogMonitorAction.prototype.render = function render() {
	    var _props$action = this.props.action;
	    var type = _props$action.type;
	
	    var payload = _objectWithoutProperties(_props$action, ['type']);
	
	    return _react2.default.createElement(
	      'div',
	      { style: _extends({
	          backgroundColor: this.props.theme.base02,
	          color: this.props.theme.base06
	        }, this.props.style) },
	      _react2.default.createElement(
	        'div',
	        { style: styles.actionBar,
	          onClick: this.props.onClick },
	        type !== null && type.toString()
	      ),
	      !this.props.collapsed ? this.renderPayload(payload) : ''
	    );
	  };
	
	  return LogMonitorAction;
	}(_react.Component);
	
	exports.default = LogMonitorAction;

/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LogMonitorEntry = __webpack_require__(2970);
	
	var _LogMonitorEntry2 = _interopRequireDefault(_LogMonitorEntry);
	
	var _function = __webpack_require__(224);
	
	var _function2 = _interopRequireDefault(_function);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogMonitorEntryList = function (_Component) {
	  _inherits(LogMonitorEntryList, _Component);
	
	  function LogMonitorEntryList() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LogMonitorEntryList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LogMonitorEntryList.prototype.render = function render() {
	    var elements = [];
	    var _props = this.props;
	    var theme = _props.theme;
	    var actionsById = _props.actionsById;
	    var computedStates = _props.computedStates;
	    var currentStateIndex = _props.currentStateIndex;
	    var consecutiveToggleStartId = _props.consecutiveToggleStartId;
	    var select = _props.select;
	    var skippedActionIds = _props.skippedActionIds;
	    var stagedActionIds = _props.stagedActionIds;
	    var expandActionRoot = _props.expandActionRoot;
	    var expandStateRoot = _props.expandStateRoot;
	    var markStateDiff = _props.markStateDiff;
	    var onActionClick = _props.onActionClick;
	    var onActionShiftClick = _props.onActionShiftClick;
	
	
	    for (var i = 0; i < stagedActionIds.length; i++) {
	      var actionId = stagedActionIds[i];
	      var action = actionsById[actionId].action;
	      var _computedStates$i = computedStates[i];
	      var state = _computedStates$i.state;
	      var error = _computedStates$i.error;
	
	      var previousState = void 0;
	      if (i > 0) {
	        previousState = computedStates[i - 1].state;
	      }
	      elements.push(_react2.default.createElement(_LogMonitorEntry2.default, { key: actionId,
	        theme: theme,
	        select: select,
	        action: action,
	        actionId: actionId,
	        state: state,
	        previousState: previousState,
	        collapsed: skippedActionIds.indexOf(actionId) > -1,
	        inFuture: i > currentStateIndex,
	        selected: consecutiveToggleStartId === i,
	        error: error,
	        expandActionRoot: expandActionRoot,
	        expandStateRoot: expandStateRoot,
	        markStateDiff: markStateDiff,
	        onActionClick: onActionClick,
	        onActionShiftClick: onActionShiftClick }));
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      elements
	    );
	  };
	
	  return LogMonitorEntryList;
	}(_react.Component);
	
	LogMonitorEntryList.propTypes = {
	  actionsById: _propTypes2.default.object,
	  computedStates: _propTypes2.default.array,
	  stagedActionIds: _propTypes2.default.array,
	  skippedActionIds: _propTypes2.default.array,
	  currentStateIndex: _propTypes2.default.number,
	  consecutiveToggleStartId: _propTypes2.default.number,
	
	  select: _propTypes2.default.func.isRequired,
	  onActionClick: _propTypes2.default.func.isRequired,
	  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  expandActionRoot: _propTypes2.default.bool,
	  expandStateRoot: _propTypes2.default.bool
	};
	exports.default = LogMonitorEntryList;

/***/ }),
/* 2973 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (hexColor, lightness) {
	  var hex = String(hexColor).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex.replace(/(.)/g, '$1$1');
	  }
	  var lum = lightness || 0;
	
	  var rgb = '#';
	  var c = void 0;
	  for (var i = 0; i < 3; ++i) {
	    c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	  return rgb;
	};

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _LogMonitor = __webpack_require__(2967);
	
	var _LogMonitor2 = _interopRequireDefault(_LogMonitor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LogMonitor2.default;

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = reducer;
	
	var _actions = __webpack_require__(818);
	
	function initialScrollTop(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var action = arguments[2];
	
	  if (!props.preserveScrollTop) {
	    return 0;
	  }
	
	  return action.type === _actions.UPDATE_SCROLL_TOP ? action.scrollTop : state;
	}
	
	function startConsecutiveToggle(props, state, action) {
	  return action.type === _actions.START_CONSECUTIVE_TOGGLE ? action.id : state;
	}
	
	function reducer(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var action = arguments[2];
	
	  return {
	    initialScrollTop: initialScrollTop(props, state.initialScrollTop, action),
	    consecutiveToggleStartId: startConsecutiveToggle(props, state.consecutiveToggleStartId, action)
	  };
	}

/***/ }),
/* 2976 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	var _base16 = __webpack_require__(491);
	
	_defaults(exports, _interopExportWildcard(_base16, _defaults));
	
	var _nicinabox = __webpack_require__(2978);
	
	exports.nicinabox = _interopRequire(_nicinabox);

/***/ }),
/* 2978 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'nicinabox',
	  author: 'nicinabox (http://github.com/nicinabox)',
	  base00: '#2A2F3A',
	  base01: '#3C444F',
	  base02: '#4F5A65',
	  base03: '#BEBEBE',
	  base04: '#b0b0b0', // based on ocean theme
	  base05: '#d0d0d0', // based on ocean theme
	  base06: '#FFFFFF',
	  base07: '#f5f5f5', // based on ocean theme
	  base08: '#fb9fb1', // based on ocean theme
	  base09: '#FC6D24',
	  base0A: '#ddb26f', // based on ocean theme
	  base0B: '#A1C659',
	  base0C: '#12cfc0', // based on ocean theme
	  base0D: '#6FB3D2',
	  base0E: '#D381C3',
	  base0F: '#deaf8f' // based on ocean theme
	};
	module.exports = exports['default'];

/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createDevTools;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(42);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reduxDevtoolsInstrument = __webpack_require__(817);
	
	var _reduxDevtoolsInstrument2 = _interopRequireDefault(_reduxDevtoolsInstrument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createDevTools(children) {
	  var _class, _temp;
	
	  var monitorElement = _react.Children.only(children);
	  var monitorProps = monitorElement.props;
	  var Monitor = monitorElement.type;
	  var ConnectedMonitor = (0, _reactRedux.connect)(function (state) {
	    return state;
	  })(Monitor);
	
	  return _temp = _class = function (_Component) {
	    _inherits(DevTools, _Component);
	
	    function DevTools(props, context) {
	      _classCallCheck(this, DevTools);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      if (!props.store && !context.store) {
	        console.error('Redux DevTools could not render. You must pass the Redux store ' + 'to <DevTools> either as a "store" prop or by wrapping it in a ' + '<Provider store={store}>.');
	        return _possibleConstructorReturn(_this);
	      }
	
	      if (context.store) {
	        _this.liftedStore = context.store.liftedStore;
	      } else {
	        _this.liftedStore = props.store.liftedStore;
	      }
	
	      if (!_this.liftedStore) {
	        console.error('Redux DevTools could not render. Did you forget to include ' + 'DevTools.instrument() in your store enhancer chain before ' + 'using createStore()?');
	      }
	      return _this;
	    }
	
	    DevTools.prototype.render = function render() {
	      if (!this.liftedStore) {
	        return null;
	      }
	
	      return _react2.default.createElement(ConnectedMonitor, _extends({}, monitorProps, {
	        store: this.liftedStore }));
	    };
	
	    return DevTools;
	  }(_react.Component), _class.contextTypes = {
	    store: _propTypes2.default.object
	  }, _class.propTypes = {
	    store: _propTypes2.default.object
	  }, _class.instrument = function (options) {
	    return (0, _reduxDevtoolsInstrument2.default)(function (state, action) {
	      return Monitor.update(monitorProps, state, action);
	    }, options);
	  }, _temp;
	}

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = persistState;
	
	var _mapValues = __webpack_require__(1682);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _identity = __webpack_require__(269);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function persistState(sessionId) {
	  var deserializeState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	  var deserializeAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity2.default;
	
	  if (!sessionId) {
	    return function (next) {
	      return function () {
	        return next.apply(undefined, arguments);
	      };
	    };
	  }
	
	  function deserialize(state) {
	    return _extends({}, state, {
	      actionsById: (0, _mapValues2.default)(state.actionsById, function (liftedAction) {
	        return _extends({}, liftedAction, {
	          action: deserializeAction(liftedAction.action)
	        });
	      }),
	      committedState: deserializeState(state.committedState),
	      computedStates: state.computedStates.map(function (computedState) {
	        return _extends({}, computedState, {
	          state: deserializeState(computedState.state)
	        });
	      })
	    });
	  }
	
	  return function (next) {
	    return function (reducer, initialState, enhancer) {
	      var key = 'redux-dev-session-' + sessionId;
	
	      var finalInitialState = void 0;
	      try {
	        var json = localStorage.getItem(key);
	        if (json) {
	          finalInitialState = deserialize(JSON.parse(json)) || initialState;
	          next(reducer, initialState);
	        }
	      } catch (e) {
	        console.warn('Could not read debug session from localStorage:', e);
	        try {
	          localStorage.removeItem(key);
	        } finally {
	          finalInitialState = undefined;
	        }
	      }
	
	      var store = next(reducer, finalInitialState, enhancer);
	
	      return _extends({}, store, {
	        dispatch: function dispatch(action) {
	          store.dispatch(action);
	
	          try {
	            localStorage.setItem(key, JSON.stringify(store.getState()));
	          } catch (e) {
	            console.warn('Could not write debug session to localStorage:', e);
	          }
	
	          return action;
	        }
	      });
	    };
	  };
	}

/***/ }),
/* 2981 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function isFunction(obj) {
	  return !!(obj && obj.constructor && obj.call && obj.apply);
	}
	
	function createActionHandler(ignore) {
	  // redux-ignore higher order reducer
	  return function handleAction(reducer) {
	    var actions = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	    var predicate = isFunction(actions) ? actions : function (action) {
	      return actions.indexOf(action.type) >= 0;
	    };
	
	    var initialState = reducer(undefined, {});
	
	    return function () {
	      var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	      var action = arguments[1];
	
	      if (predicate(action)) {
	        return ignore ? state : reducer(state, action);
	      }
	
	      return ignore ? reducer(state, action) : state;
	    };
	  };
	}
	
	var ignoreActions = exports.ignoreActions = createActionHandler(true);
	var filterActions = exports.filterActions = createActionHandler(false);
	
	exports.default = ignoreActions;
	// /redux-ignore

/***/ }),
/* 2982 */
/***/ (function(module, exports) {

	'use strict';
	
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      return typeof action === 'function' ? action(dispatch, getState) : next(action);
	    };
	  };
	}
	
	module.exports = thunkMiddleware;

/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(819);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 2984 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(820);
	
	var _isPlainObject = __webpack_require__(270);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(821);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(3052);
	var xtend = __webpack_require__(139);
	var Parser = __webpack_require__(2996);
	
	module.exports = parse;
	parse.Parser = Parser;
	
	function parse(options) {
	  var Local = unherit(Parser);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Parser = Local;
	}


/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var entities = __webpack_require__(396);
	
	module.exports = factory;
	
	/* Factory to create an entity decoder. */
	function factory(ctx) {
	  decoder.raw = decodeRaw;
	
	  return decoder;
	
	  /* Normalize `position` to add an `indent`. */
	  function normalize(position) {
	    var offsets = ctx.offset;
	    var line = position.line;
	    var result = [];
	
	    while (++line) {
	      if (!(line in offsets)) {
	        break;
	      }
	
	      result.push((offsets[line] || 0) + 1);
	    }
	
	    return {
	      start: position,
	      indent: result
	    };
	  }
	
	  /* Handle a warning.
	   * See https://github.com/wooorm/parse-entities
	   * for the warnings. */
	  function handleWarning(reason, position, code) {
	    if (code === 3) {
	      return;
	    }
	
	    ctx.file.message(reason, position);
	  }
	
	  /* Decode `value` (at `position`) into text-nodes. */
	  function decoder(value, position, handler) {
	    entities(value, {
	      position: normalize(position),
	      warning: handleWarning,
	      text: handler,
	      reference: handler,
	      textContext: ctx,
	      referenceContext: ctx
	    });
	  }
	
	  /* Decode `value` (at `position`) into a string. */
	  function decodeRaw(value, position) {
	    return entities(value, {
	      position: normalize(position),
	      warning: handleWarning
	    });
	  }
	}


/***/ }),
/* 2988 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var index = value.indexOf('\n', fromIndex);
	
	  while (index > fromIndex) {
	    if (value.charAt(index - 1) !== ' ') {
	      break;
	    }
	
	    index--;
	  }
	
	  return index;
	}


/***/ }),
/* 2989 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('`', fromIndex);
	}


/***/ }),
/* 2990 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('~~', fromIndex);
	}


/***/ }),
/* 2991 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('*', fromIndex);
	  var underscore = value.indexOf('_', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 2992 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('\\', fromIndex);
	}


/***/ }),
/* 2993 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('**', fromIndex);
	  var underscore = value.indexOf('__', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 2994 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	var PROTOCOLS = ['https://', 'http://', 'mailto:'];
	
	function locate(value, fromIndex) {
	  var length = PROTOCOLS.length;
	  var index = -1;
	  var min = -1;
	  var position;
	
	  if (!this.options.gfm) {
	    return -1;
	  }
	
	  while (++index < length) {
	    position = value.indexOf(PROTOCOLS[index], fromIndex);
	
	    if (position !== -1 && (position < min || min === -1)) {
	      min = position;
	    }
	  }
	
	  return min;
	}


/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(139);
	var removePosition = __webpack_require__(3055);
	
	module.exports = parse;
	
	var C_NEWLINE = '\n';
	var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
	
	/* Parse the bound file. */
	function parse() {
	  var self = this;
	  var value = String(self.file);
	  var start = {line: 1, column: 1, offset: 0};
	  var content = xtend(start);
	  var node;
	
	  /* Clean non-unix newlines: `\r\n` and `\r` are all
	   * changed to `\n`.  This should not affect positional
	   * information. */
	  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
	
	  if (value.charCodeAt(0) === 0xFEFF) {
	    value = value.slice(1);
	
	    content.column++;
	    content.offset++;
	  }
	
	  node = {
	    type: 'root',
	    children: self.tokenizeBlock(value, content),
	    position: {
	      start: start,
	      end: self.eof || xtend(start)
	    }
	  };
	
	  if (!self.options.position) {
	    removePosition(node, true);
	  }
	
	  return node;
	}


/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(139);
	var toggle = __webpack_require__(3043);
	var vfileLocation = __webpack_require__(3106);
	var unescape = __webpack_require__(3024);
	var decode = __webpack_require__(2987);
	var tokenizer = __webpack_require__(3023);
	
	module.exports = Parser;
	
	function Parser(doc, file) {
	  this.file = file;
	  this.offset = {};
	  this.options = xtend(this.options);
	  this.setOptions({});
	
	  this.inList = false;
	  this.inBlock = false;
	  this.inLink = false;
	  this.atStart = true;
	
	  this.toOffset = vfileLocation(file).toOffset;
	  this.unescape = unescape(this, 'escape');
	  this.decode = decode(this);
	}
	
	var proto = Parser.prototype;
	
	/* Expose core. */
	proto.setOptions = __webpack_require__(2997);
	proto.parse = __webpack_require__(2995);
	
	/* Expose `defaults`. */
	proto.options = __webpack_require__(822);
	
	/* Enter and exit helpers. */
	proto.exitStart = toggle('atStart', true);
	proto.enterList = toggle('inList', false);
	proto.enterLink = toggle('inLink', false);
	proto.enterBlock = toggle('inBlock', false);
	
	/* Nodes that can interupt a paragraph:
	 *
	 * ```markdown
	 * A paragraph, followed by a thematic break.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the paragraph. */
	proto.interruptParagraph = [
	  ['thematicBreak'],
	  ['atxHeading'],
	  ['fencedCode'],
	  ['blockquote'],
	  ['html'],
	  ['setextHeading', {commonmark: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a list:
	 *
	 * ```markdown
	 * - One
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the list. */
	proto.interruptList = [
	  ['fencedCode', {pedantic: false}],
	  ['thematicBreak', {pedantic: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a blockquote:
	 *
	 * ```markdown
	 * > A paragraph.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the blockquote. */
	proto.interruptBlockquote = [
	  ['indentedCode', {commonmark: true}],
	  ['fencedCode', {commonmark: true}],
	  ['atxHeading', {commonmark: true}],
	  ['setextHeading', {commonmark: true}],
	  ['thematicBreak', {commonmark: true}],
	  ['html', {commonmark: true}],
	  ['list', {commonmark: true}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Handlers. */
	proto.blockTokenizers = {
	  newline: __webpack_require__(3015),
	  indentedCode: __webpack_require__(3002),
	  fencedCode: __webpack_require__(3001),
	  blockquote: __webpack_require__(2999),
	  atxHeading: __webpack_require__(3009),
	  thematicBreak: __webpack_require__(3021),
	  list: __webpack_require__(3014),
	  setextHeading: __webpack_require__(3010),
	  html: __webpack_require__(3011),
	  footnote: __webpack_require__(3008),
	  definition: __webpack_require__(3004),
	  table: __webpack_require__(3019),
	  paragraph: __webpack_require__(3016)
	};
	
	proto.inlineTokenizers = {
	  escape: __webpack_require__(3007),
	  autoLink: __webpack_require__(2998),
	  url: __webpack_require__(3022),
	  html: __webpack_require__(3012),
	  link: __webpack_require__(3013),
	  reference: __webpack_require__(3017),
	  strong: __webpack_require__(3018),
	  emphasis: __webpack_require__(3006),
	  deletion: __webpack_require__(3005),
	  code: __webpack_require__(3003),
	  break: __webpack_require__(3000),
	  text: __webpack_require__(3020)
	};
	
	/* Expose precedence. */
	proto.blockMethods = keys(proto.blockTokenizers);
	proto.inlineMethods = keys(proto.inlineTokenizers);
	
	/* Tokenizers. */
	proto.tokenizeBlock = tokenizer('block');
	proto.tokenizeInline = tokenizer('inline');
	proto.tokenizeFactory = tokenizer;
	
	/* Get all keys in `value`. */
	function keys(value) {
	  var result = [];
	  var key;
	
	  for (key in value) {
	    result.push(key);
	  }
	
	  return result;
	}


/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(139);
	var escapes = __webpack_require__(1690);
	var defaults = __webpack_require__(822);
	
	module.exports = setOptions;
	
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var key;
	  var value;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error(
	      'Invalid value `' + options + '` ' +
	      'for setting `options`'
	    );
	  }
	
	  for (key in defaults) {
	    value = options[key];
	
	    if (value == null) {
	      value = current[key];
	    }
	
	    if (
	      (key !== 'blocks' && typeof value !== 'boolean') ||
	      (key === 'blocks' && typeof value !== 'object')
	    ) {
	      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
	    }
	
	    options[key] = value;
	  }
	
	  self.options = options;
	  self.escape = escapes(options);
	
	  return self;
	}


/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	var decode = __webpack_require__(396);
	var locate = __webpack_require__(824);
	
	module.exports = autoLink;
	autoLink.locator = locate;
	autoLink.notInLink = true;
	
	var C_LT = '<';
	var C_GT = '>';
	var C_AT_SIGN = '@';
	var C_SLASH = '/';
	var MAILTO = 'mailto:';
	var MAILTO_LENGTH = MAILTO.length;
	
	/* Tokenise a link. */
	function autoLink(eat, value, silent) {
	  var self;
	  var subvalue;
	  var length;
	  var index;
	  var queue;
	  var character;
	  var hasAtCharacter;
	  var link;
	  var now;
	  var content;
	  var tokenize;
	  var exit;
	
	  if (value.charAt(0) !== C_LT) {
	    return;
	  }
	
	  self = this;
	  subvalue = '';
	  length = value.length;
	  index = 0;
	  queue = '';
	  hasAtCharacter = false;
	  link = '';
	
	  index++;
	  subvalue = C_LT;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      whitespace(character) ||
	      character === C_GT ||
	      character === C_AT_SIGN ||
	      (character === ':' && value.charAt(index + 1) === C_SLASH)
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  link += queue;
	  queue = '';
	
	  character = value.charAt(index);
	  link += character;
	  index++;
	
	  if (character === C_AT_SIGN) {
	    hasAtCharacter = true;
	  } else {
	    if (
	      character !== ':' ||
	      value.charAt(index + 1) !== C_SLASH
	    ) {
	      return;
	    }
	
	    link += C_SLASH;
	    index++;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_GT) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!queue || character !== C_GT) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  link += queue;
	  content = link;
	  subvalue += link + character;
	  now = eat.now();
	  now.column++;
	  now.offset++;
	
	  if (hasAtCharacter) {
	    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
	      content = content.substr(MAILTO_LENGTH);
	      now.column += MAILTO_LENGTH;
	      now.offset += MAILTO_LENGTH;
	    } else {
	      link = MAILTO + link;
	    }
	  }
	
	  /* Temporarily remove support for escapes in autolinks. */
	  tokenize = self.inlineTokenizers.escape;
	  self.inlineTokenizers.escape = null;
	  exit = self.enterLink();
	
	  content = self.tokenizeInline(content, now);
	
	  self.inlineTokenizers.escape = tokenize;
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(link),
	    children: content
	  });
	}


/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(198);
	var interrupt = __webpack_require__(435);
	
	module.exports = blockquote;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_GT = '>';
	
	/* Tokenise a blockquote. */
	function blockquote(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptBlockquote;
	  var now = eat.now();
	  var currentLine = now.line;
	  var length = value.length;
	  var values = [];
	  var contents = [];
	  var indents = [];
	  var add;
	  var index = 0;
	  var character;
	  var rest;
	  var nextIndex;
	  var content;
	  var line;
	  var startIndex;
	  var prefixed;
	  var exit;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_GT) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      index++;
	    }
	
	    if (value.charAt(index) === C_GT) {
	      index++;
	      prefixed = true;
	
	      if (value.charAt(index) === C_SPACE) {
	        index++;
	      }
	    } else {
	      index = startIndex;
	    }
	
	    content = value.slice(index, nextIndex);
	
	    if (!prefixed && !trim(content)) {
	      index = startIndex;
	      break;
	    }
	
	    if (!prefixed) {
	      rest = value.slice(index);
	
	      /* Check if the following code contains a possible
	       * block. */
	      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
	        break;
	      }
	    }
	
	    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
	
	    indents.push(index - startIndex);
	    values.push(line);
	    contents.push(content);
	
	    index = nextIndex + 1;
	  }
	
	  index = -1;
	  length = indents.length;
	  add = eat(values.join(C_NEWLINE));
	
	  while (++index < length) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
	    currentLine++;
	  }
	
	  exit = self.enterBlock();
	  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
	  exit();
	
	  return add({
	    type: 'blockquote',
	    children: contents
	  });
	}


/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(2988);
	
	module.exports = hardBreak;
	hardBreak.locator = locate;
	
	var MIN_BREAK_LENGTH = 2;
	
	function hardBreak(eat, value, silent) {
	  var length = value.length;
	  var index = -1;
	  var queue = '';
	  var character;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === '\n') {
	      if (index < MIN_BREAK_LENGTH) {
	        return;
	      }
	
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      queue += character;
	
	      return eat(queue)({type: 'break'});
	    }
	
	    if (character !== ' ') {
	      return;
	    }
	
	    queue += character;
	  }
	}


/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(441);
	
	module.exports = fencedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_TILDE = '~';
	var C_TICK = '`';
	
	var MIN_FENCE_COUNT = 3;
	var CODE_INDENT_COUNT = 4;
	
	function fencedCode(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = 0;
	  var subvalue = '';
	  var fenceCount;
	  var marker;
	  var character;
	  var flag;
	  var queue;
	  var content;
	  var exdentedContent;
	  var closing;
	  var exdentedClosing;
	  var indent;
	  var now;
	
	  if (!settings.gfm) {
	    return;
	  }
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  indent = index;
	
	  /* Eat the fence. */
	  character = value.charAt(index);
	
	  if (character !== C_TILDE && character !== C_TICK) {
	    return;
	  }
	
	  index++;
	  marker = character;
	  fenceCount = 1;
	  subvalue += character;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      break;
	    }
	
	    subvalue += character;
	    fenceCount++;
	    index++;
	  }
	
	  if (fenceCount < MIN_FENCE_COUNT) {
	    return;
	  }
	
	  /* Eat spacing before flag. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat flag. */
	  flag = '';
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_NEWLINE ||
	      character === C_TILDE ||
	      character === C_TICK
	    ) {
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      flag += queue + character;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character && character !== C_NEWLINE) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	
	  subvalue += flag;
	  flag = self.decode.raw(self.unescape(flag), now);
	
	  if (queue) {
	    subvalue += queue;
	  }
	
	  queue = '';
	  closing = '';
	  exdentedClosing = '';
	  content = '';
	  exdentedContent = '';
	
	  /* Eat content. */
	  while (index < length) {
	    character = value.charAt(index);
	    content += closing;
	    exdentedContent += exdentedClosing;
	    closing = '';
	    exdentedClosing = '';
	
	    if (character !== C_NEWLINE) {
	      content += character;
	      exdentedClosing += character;
	      index++;
	      continue;
	    }
	
	    /* Add the newline to `subvalue` if its the first
	     * character.  Otherwise, add it to the `closing`
	     * queue. */
	    if (content) {
	      closing += character;
	      exdentedClosing += character;
	    } else {
	      subvalue += character;
	    }
	
	    queue = '';
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue.slice(indent);
	
	    if (queue.length >= CODE_INDENT_COUNT) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue;
	
	    if (queue.length < fenceCount) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      closing += character;
	      exdentedClosing += character;
	      index++;
	    }
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	  }
	
	  subvalue += content + closing;
	
	  return eat(subvalue)({
	    type: 'code',
	    lang: flag || null,
	    value: trim(exdentedContent)
	  });
	}


/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(437);
	var trim = __webpack_require__(441);
	
	module.exports = indentedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var CODE_INDENT_COUNT = 4;
	var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
	
	/* Tokenise indented code. */
	function indentedCode(eat, value, silent) {
	  var index = -1;
	  var length = value.length;
	  var subvalue = '';
	  var content = '';
	  var subvalueQueue = '';
	  var contentQueue = '';
	  var character;
	  var blankQueue;
	  var indent;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (indent) {
	      indent = false;
	
	      subvalue += subvalueQueue;
	      content += contentQueue;
	      subvalueQueue = '';
	      contentQueue = '';
	
	      if (character === C_NEWLINE) {
	        subvalueQueue = character;
	        contentQueue = character;
	      } else {
	        subvalue += character;
	        content += character;
	
	        while (++index < length) {
	          character = value.charAt(index);
	
	          if (!character || character === C_NEWLINE) {
	            contentQueue = character;
	            subvalueQueue = character;
	            break;
	          }
	
	          subvalue += character;
	          content += character;
	        }
	      }
	    } else if (
	      character === C_SPACE &&
	      value.charAt(index + 1) === character &&
	      value.charAt(index + 2) === character &&
	      value.charAt(index + 3) === character
	    ) {
	      subvalueQueue += CODE_INDENT;
	      index += 3;
	      indent = true;
	    } else if (character === C_TAB) {
	      subvalueQueue += character;
	      indent = true;
	    } else {
	      blankQueue = '';
	
	      while (character === C_TAB || character === C_SPACE) {
	        blankQueue += character;
	        character = value.charAt(++index);
	      }
	
	      if (character !== C_NEWLINE) {
	        break;
	      }
	
	      subvalueQueue += blankQueue + character;
	      contentQueue += character;
	    }
	  }
	
	  if (content) {
	    if (silent) {
	      return true;
	    }
	
	    return eat(subvalue)({
	      type: 'code',
	      lang: null,
	      value: trim(content)
	    });
	  }
	}


/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	var locate = __webpack_require__(2989);
	
	module.exports = inlineCode;
	inlineCode.locator = locate;
	
	var C_TICK = '`';
	
	/* Tokenise inline code. */
	function inlineCode(eat, value, silent) {
	  var length = value.length;
	  var index = 0;
	  var queue = '';
	  var tickQueue = '';
	  var contentQueue;
	  var subqueue;
	  var count;
	  var openingCount;
	  var subvalue;
	  var character;
	  var found;
	  var next;
	
	  while (index < length) {
	    if (value.charAt(index) !== C_TICK) {
	      break;
	    }
	
	    queue += C_TICK;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue = queue;
	  openingCount = index;
	  queue = '';
	  next = value.charAt(index);
	  count = 0;
	
	  while (index < length) {
	    character = next;
	    next = value.charAt(index + 1);
	
	    if (character === C_TICK) {
	      count++;
	      tickQueue += character;
	    } else {
	      count = 0;
	      queue += character;
	    }
	
	    if (count && next !== C_TICK) {
	      if (count === openingCount) {
	        subvalue += queue + tickQueue;
	        found = true;
	        break;
	      }
	
	      queue += tickQueue;
	      tickQueue = '';
	    }
	
	    index++;
	  }
	
	  if (!found) {
	    if (openingCount % 2 !== 0) {
	      return;
	    }
	
	    queue = '';
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  contentQueue = '';
	  subqueue = '';
	  length = queue.length;
	  index = -1;
	
	  while (++index < length) {
	    character = queue.charAt(index);
	
	    if (whitespace(character)) {
	      subqueue += character;
	      continue;
	    }
	
	    if (subqueue) {
	      if (contentQueue) {
	        contentQueue += subqueue;
	      }
	
	      subqueue = '';
	    }
	
	    contentQueue += character;
	  }
	
	  return eat(subvalue)({
	    type: 'inlineCode',
	    value: contentQueue
	  });
	}


/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	var normalize = __webpack_require__(436);
	
	module.exports = definition;
	definition.notInList = true;
	definition.notInBlock = true;
	
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_COLON = ':';
	var C_LT = '<';
	var C_GT = '>';
	
	function definition(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var beforeURL;
	  var beforeTitle;
	  var queue;
	  var character;
	  var test;
	  var identifier;
	  var url;
	  var title;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  identifier = queue;
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isEnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === isEnclosedURLCharacter.delimiter) {
	      subvalue += C_LT + queue + character;
	      index++;
	    } else {
	      if (commonmark) {
	        return;
	      }
	
	      index -= queue.length + 1;
	      queue = '';
	    }
	  }
	
	  if (!queue) {
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isUnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    subvalue += queue;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  url = queue;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  test = null;
	
	  if (character === C_DOUBLE_QUOTE) {
	    test = C_DOUBLE_QUOTE;
	  } else if (character === C_SINGLE_QUOTE) {
	    test = C_SINGLE_QUOTE;
	  } else if (character === C_PAREN_OPEN) {
	    test = C_PAREN_CLOSE;
	  }
	
	  if (!test) {
	    queue = '';
	    index = subvalue.length;
	  } else if (queue) {
	    subvalue += queue + character;
	    index = subvalue.length;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === test) {
	        break;
	      }
	
	      if (character === C_NEWLINE) {
	        index++;
	        character = value.charAt(index);
	
	        if (character === C_NEWLINE || character === test) {
	          return;
	        }
	
	        queue += C_NEWLINE;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character !== test) {
	      return;
	    }
	
	    beforeTitle = subvalue;
	    subvalue += queue + character;
	    index++;
	    title = queue;
	    queue = '';
	  } else {
	    return;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!character || character === C_NEWLINE) {
	    if (silent) {
	      return true;
	    }
	
	    beforeURL = eat(beforeURL).test().end;
	    url = self.decode.raw(self.unescape(url), beforeURL);
	
	    if (title) {
	      beforeTitle = eat(beforeTitle).test().end;
	      title = self.decode.raw(self.unescape(title), beforeTitle);
	    }
	
	    return eat(subvalue)({
	      type: 'definition',
	      identifier: normalize(identifier),
	      title: title || null,
	      url: url
	    });
	  }
	}
	
	/* Check if `character` can be inside an enclosed URI. */
	function isEnclosedURLCharacter(character) {
	  return character !== C_GT &&
	    character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE;
	}
	
	isEnclosedURLCharacter.delimiter = C_GT;
	
	/* Check if `character` can be inside an unclosed URI. */
	function isUnclosedURLCharacter(character) {
	  return character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE &&
	    !whitespace(character);
	}


/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	var locate = __webpack_require__(2990);
	
	module.exports = strikethrough;
	strikethrough.locator = locate;
	
	var C_TILDE = '~';
	var DOUBLE = '~~';
	
	function strikethrough(eat, value, silent) {
	  var self = this;
	  var character = '';
	  var previous = '';
	  var preceding = '';
	  var subvalue = '';
	  var index;
	  var length;
	  var now;
	
	  if (
	    !self.options.gfm ||
	    value.charAt(0) !== C_TILDE ||
	    value.charAt(1) !== C_TILDE ||
	    whitespace(value.charAt(2))
	  ) {
	    return;
	  }
	
	  index = 1;
	  length = value.length;
	  now = eat.now();
	  now.column += 2;
	  now.offset += 2;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_TILDE &&
	      previous === C_TILDE &&
	      (!preceding || !whitespace(preceding))
	    ) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      return eat(DOUBLE + subvalue + DOUBLE)({
	        type: 'delete',
	        children: self.tokenizeInline(subvalue, now)
	      });
	    }
	
	    subvalue += previous;
	    preceding = previous;
	    previous = character;
	  }
	}


/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(198);
	var word = __webpack_require__(1582);
	var whitespace = __webpack_require__(87);
	var locate = __webpack_require__(2991);
	
	module.exports = emphasis;
	emphasis.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function emphasis(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  subvalue = character;
	  marker = character;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (character === marker && (!pedantic || !whitespace(prev))) {
	      character = value.charAt(++index);
	
	      if (character !== marker) {
	        if (!trim(queue) || prev === marker) {
	          return;
	        }
	
	        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
	          queue += marker;
	          continue;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column++;
	        now.offset++;
	
	        return eat(subvalue + queue + marker)({
	          type: 'emphasis',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	
	      queue += marker;
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(2992);
	
	module.exports = escape;
	escape.locator = locate;
	
	function escape(eat, value, silent) {
	  var self = this;
	  var character;
	  var node;
	
	  if (value.charAt(0) === '\\') {
	    character = value.charAt(1);
	
	    if (self.escape.indexOf(character) !== -1) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      if (character === '\n') {
	        node = {type: 'break'};
	      } else {
	        node = {
	          type: 'text',
	          value: character
	        };
	      }
	
	      return eat('\\' + character)(node);
	    }
	  }
	}


/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	var normalize = __webpack_require__(436);
	
	module.exports = footnoteDefinition;
	footnoteDefinition.notInList = true;
	footnoteDefinition.notInBlock = true;
	
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_CARET = '^';
	var C_COLON = ':';
	
	var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
	
	function footnoteDefinition(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var index;
	  var length;
	  var subvalue;
	  var now;
	  var currentLine;
	  var content;
	  var queue;
	  var subqueue;
	  var character;
	  var identifier;
	  var add;
	  var exit;
	
	  if (!self.options.footnotes) {
	    return;
	  }
	
	  index = 0;
	  length = value.length;
	  subvalue = '';
	  now = eat.now();
	  currentLine = now.line;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  if (
	    value.charAt(index) !== C_BRACKET_OPEN ||
	    value.charAt(index + 1) !== C_CARET
	  ) {
	    return;
	  }
	
	  subvalue += C_BRACKET_OPEN + C_CARET;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  identifier = normalize(queue);
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  queue = '';
	  content = '';
	  subqueue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      subqueue = character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_NEWLINE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      queue += subqueue;
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_SPACE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      if (subqueue.length === 0) {
	        break;
	      }
	
	      queue += subqueue;
	    }
	
	    if (queue) {
	      content += queue;
	      queue = '';
	    }
	
	    content += character;
	    index++;
	  }
	
	  subvalue += content;
	
	  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
	    currentLine++;
	
	    return '';
	  });
	
	  add = eat(subvalue);
	
	  exit = self.enterBlock();
	  content = self.tokenizeBlock(content, now);
	  exit();
	
	  return add({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: content
	  });
	}


/***/ }),
/* 3009 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = atxHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_HASH = '#';
	
	var MAX_ATX_COUNT = 6;
	
	function atxHeading(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = -1;
	  var now = eat.now();
	  var subvalue = '';
	  var content = '';
	  var character;
	  var queue;
	  var depth;
	
	  /* Eat initial spacing. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat hashes. */
	  depth = 0;
	
	  while (++index <= length) {
	    character = value.charAt(index);
	
	    if (character !== C_HASH) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	    depth++;
	  }
	
	  if (depth > MAX_ATX_COUNT) {
	    return;
	  }
	
	  if (
	    !depth ||
	    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
	  ) {
	    return;
	  }
	
	  length = value.length + 1;
	
	  /* Eat intermediate white-space. */
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  /* Exit when not in pedantic mode without spacing. */
	  if (
	    !settings.pedantic &&
	    queue.length === 0 &&
	    character &&
	    character !== C_NEWLINE
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  /* Eat content. */
	  subvalue += queue;
	  queue = '';
	  content = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	
	    if (
	      character !== C_SPACE &&
	      character !== C_TAB &&
	      character !== C_HASH
	    ) {
	      content += queue + character;
	      queue = '';
	      continue;
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_HASH) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    index--;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  return eat(subvalue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 3010 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = setextHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_EQUALS = '=';
	var C_DASH = '-';
	
	var MAX_HEADING_INDENT = 3;
	
	/* Map of characters which can be used to mark setext
	 * headers, mapping to their corresponding depth. */
	var SETEXT_MARKERS = {};
	
	SETEXT_MARKERS[C_EQUALS] = 1;
	SETEXT_MARKERS[C_DASH] = 2;
	
	function setextHeading(eat, value, silent) {
	  var self = this;
	  var now = eat.now();
	  var length = value.length;
	  var index = -1;
	  var subvalue = '';
	  var content;
	  var queue;
	  var character;
	  var marker;
	  var depth;
	
	  /* Eat initial indentation. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat content. */
	  content = '';
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      index--;
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      content += queue + character;
	      queue = '';
	    }
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  /* Ensure the content is followed by a newline and a
	   * valid marker. */
	  character = value.charAt(++index);
	  marker = value.charAt(++index);
	
	  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
	    return;
	  }
	
	  subvalue += character;
	
	  /* Eat Setext-line. */
	  queue = marker;
	  depth = SETEXT_MARKERS[marker];
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      if (character !== C_NEWLINE) {
	        return;
	      }
	
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  return eat(subvalue + queue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var openCloseTag = __webpack_require__(826).openCloseTag;
	
	module.exports = blockHTML;
	
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_LT = '<';
	
	function blockHTML(eat, value, silent) {
	  var self = this;
	  var blocks = self.options.blocks;
	  var length = value.length;
	  var index = 0;
	  var next;
	  var line;
	  var offset;
	  var character;
	  var count;
	  var sequence;
	  var subvalue;
	
	  var sequences = [
	    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
	    [/^<!--/, /-->/, true],
	    [/^<\?/, /\?>/, true],
	    [/^<![A-Za-z]/, />/, true],
	    [/^<!\[CDATA\[/, /\]\]>/, true],
	    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
	    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
	  ];
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_LT) {
	    return;
	  }
	
	  next = value.indexOf(C_NEWLINE, index + 1);
	  next = next === -1 ? length : next;
	  line = value.slice(index, next);
	  offset = -1;
	  count = sequences.length;
	
	  while (++offset < count) {
	    if (sequences[offset][0].test(line)) {
	      sequence = sequences[offset];
	      break;
	    }
	  }
	
	  if (!sequence) {
	    return;
	  }
	
	  if (silent) {
	    return sequence[2];
	  }
	
	  index = next;
	
	  if (!sequence[1].test(line)) {
	    while (index < length) {
	      next = value.indexOf(C_NEWLINE, index + 1);
	      next = next === -1 ? length : next;
	      line = value.slice(index + 1, next);
	
	      if (sequence[1].test(line)) {
	        if (line) {
	          index = next;
	        }
	
	        break;
	      }
	
	      index = next;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabetical = __webpack_require__(556);
	var locate = __webpack_require__(824);
	var tag = __webpack_require__(826).tag;
	
	module.exports = inlineHTML;
	inlineHTML.locator = locate;
	
	var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
	var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
	
	function inlineHTML(eat, value, silent) {
	  var self = this;
	  var length = value.length;
	  var character;
	  var subvalue;
	
	  if (value.charAt(0) !== '<' || length < 3) {
	    return;
	  }
	
	  character = value.charAt(1);
	
	  if (
	    !alphabetical(character) &&
	    character !== '?' &&
	    character !== '!' &&
	    character !== '/'
	  ) {
	    return;
	  }
	
	  subvalue = value.match(tag);
	
	  if (!subvalue) {
	    return;
	  }
	
	  /* istanbul ignore if - not used yet. */
	  if (silent) {
	    return true;
	  }
	
	  subvalue = subvalue[0];
	
	  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
	    self.inLink = true;
	  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
	    self.inLink = false;
	  }
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	var locate = __webpack_require__(823);
	
	module.exports = link;
	link.locator = locate;
	
	var own = {}.hasOwnProperty;
	
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_GT = '>';
	var C_TICK = '`';
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	
	/* Map of characters, which can be used to mark link
	 * and image titles. */
	var LINK_MARKERS = {};
	
	LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	
	/* Map of characters, which can be used to mark link
	 * and image titles in commonmark-mode. */
	var COMMONMARK_LINK_MARKERS = {};
	
	COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
	
	function link(eat, value, silent) {
	  var self = this;
	  var subvalue = '';
	  var index = 0;
	  var character = value.charAt(0);
	  var pedantic = self.options.pedantic;
	  var commonmark = self.options.commonmark;
	  var gfm = self.options.gfm;
	  var closed;
	  var count;
	  var opening;
	  var beforeURL;
	  var beforeTitle;
	  var subqueue;
	  var hasMarker;
	  var markers;
	  var isImage;
	  var content;
	  var marker;
	  var length;
	  var title;
	  var depth;
	  var queue;
	  var url;
	  var now;
	  var exit;
	  var node;
	
	  /* Detect whether this is an image. */
	  if (character === '!') {
	    isImage = true;
	    subvalue = character;
	    character = value.charAt(++index);
	  }
	
	  /* Eat the opening. */
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  /* Exit when this is a link and we’re already inside
	   * a link. */
	  if (!isImage && self.inLink) {
	    return;
	  }
	
	  subvalue += character;
	  queue = '';
	  index++;
	
	  /* Eat the content. */
	  length = value.length;
	  now = eat.now();
	  depth = 0;
	
	  now.column += index;
	  now.offset += index;
	
	  while (index < length) {
	    character = value.charAt(index);
	    subqueue = character;
	
	    if (character === C_TICK) {
	      /* Inline-code in link content. */
	      count = 1;
	
	      while (value.charAt(index + 1) === C_TICK) {
	        subqueue += character;
	        index++;
	        count++;
	      }
	
	      if (!opening) {
	        opening = count;
	      } else if (count >= opening) {
	        opening = 0;
	      }
	    } else if (character === C_BACKSLASH) {
	      /* Allow brackets to be escaped. */
	      index++;
	      subqueue += value.charAt(index);
	    /* In GFM mode, brackets in code still count.
	     * In all other modes, they don’t.  This empty
	     * block prevents the next statements are
	     * entered. */
	    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
	      depth++;
	    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
	      if (depth) {
	        depth--;
	      } else {
	        /* Allow white-space between content and
	         * url in GFM mode. */
	        if (!pedantic) {
	          while (index < length) {
	            character = value.charAt(index + 1);
	
	            if (!whitespace(character)) {
	              break;
	            }
	
	            subqueue += character;
	            index++;
	          }
	        }
	
	        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
	          return;
	        }
	
	        subqueue += C_PAREN_OPEN;
	        closed = true;
	        index++;
	
	        break;
	      }
	    }
	
	    queue += subqueue;
	    subqueue = '';
	    index++;
	  }
	
	  /* Eat the content closing. */
	  if (!closed) {
	    return;
	  }
	
	  content = queue;
	  subvalue += queue + subqueue;
	  index++;
	
	  /* Eat white-space. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat the URL. */
	  character = value.charAt(index);
	  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	    beforeURL += C_LT;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_GT) {
	        break;
	      }
	
	      if (commonmark && character === '\n') {
	        return;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    if (value.charAt(index) !== C_GT) {
	      return;
	    }
	
	    subvalue += C_LT + queue + C_GT;
	    url = queue;
	    index++;
	  } else {
	    character = null;
	    subqueue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (subqueue && own.call(markers, character)) {
	        break;
	      }
	
	      if (whitespace(character)) {
	        if (!pedantic) {
	          break;
	        }
	
	        subqueue += character;
	      } else {
	        if (character === C_PAREN_OPEN) {
	          depth++;
	        } else if (character === C_PAREN_CLOSE) {
	          if (depth === 0) {
	            break;
	          }
	
	          depth--;
	        }
	
	        queue += subqueue;
	        subqueue = '';
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        queue += character;
	      }
	
	      index++;
	    }
	
	    subvalue += queue;
	    url = queue;
	    index = subvalue.length;
	  }
	
	  /* Eat white-space. */
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  subvalue += queue;
	
	  /* Eat the title. */
	  if (queue && own.call(markers, character)) {
	    index++;
	    subvalue += character;
	    queue = '';
	    marker = markers[character];
	    beforeTitle = subvalue;
	
	    /* In commonmark-mode, things are pretty easy: the
	     * marker cannot occur inside the title.
	     *
	     * Non-commonmark does, however, support nested
	     * delimiters. */
	    if (commonmark) {
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          break;
	        }
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        index++;
	        queue += character;
	      }
	
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        return;
	      }
	
	      title = queue;
	      subvalue += queue + character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (!whitespace(character)) {
	          break;
	        }
	
	        subvalue += character;
	        index++;
	      }
	    } else {
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          if (hasMarker) {
	            queue += marker + subqueue;
	            subqueue = '';
	          }
	
	          hasMarker = true;
	        } else if (!hasMarker) {
	          queue += character;
	        } else if (character === C_PAREN_CLOSE) {
	          subvalue += queue + marker + subqueue;
	          title = queue;
	          break;
	        } else if (whitespace(character)) {
	          subqueue += character;
	        } else {
	          queue += marker + subqueue + character;
	          subqueue = '';
	          hasMarker = false;
	        }
	
	        index++;
	      }
	    }
	  }
	
	  if (value.charAt(index) !== C_PAREN_CLOSE) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  subvalue += C_PAREN_CLOSE;
	
	  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end);
	
	  if (title) {
	    beforeTitle = eat(beforeTitle).test().end;
	    title = self.decode.raw(self.unescape(title), beforeTitle);
	  }
	
	  node = {
	    type: isImage ? 'image' : 'link',
	    title: title || null,
	    url: url
	  };
	
	  if (isImage) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  } else {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable max-params */
	
	var trim = __webpack_require__(198);
	var repeat = __webpack_require__(437);
	var decimal = __webpack_require__(263);
	var getIndent = __webpack_require__(825);
	var removeIndent = __webpack_require__(3025);
	var interrupt = __webpack_require__(435);
	
	module.exports = list;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_PLUS = '+';
	var C_DASH = '-';
	var C_DOT = '.';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_PAREN_CLOSE = ')';
	var C_X_LOWER = 'x';
	
	var TAB_SIZE = 4;
	var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
	var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
	var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
	var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
	var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
	
	/* Map of characters which can be used to mark
	 * list-items. */
	var LIST_UNORDERED_MARKERS = {};
	
	LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
	LIST_UNORDERED_MARKERS[C_PLUS] = true;
	LIST_UNORDERED_MARKERS[C_DASH] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_MARKERS = {};
	
	LIST_ORDERED_MARKERS[C_DOT] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_COMMONMARK_MARKERS = {};
	
	LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
	LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
	
	function list(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var pedantic = self.options.pedantic;
	  var tokenizers = self.blockTokenizers;
	  var interuptors = self.interruptList;
	  var markers;
	  var index = 0;
	  var length = value.length;
	  var start = null;
	  var size = 0;
	  var queue;
	  var ordered;
	  var character;
	  var marker;
	  var nextIndex;
	  var startIndex;
	  var prefixed;
	  var currentMarker;
	  var content;
	  var line;
	  var prevEmpty;
	  var empty;
	  var items;
	  var allLines;
	  var emptyLines;
	  var item;
	  var enterTop;
	  var exitBlockquote;
	  var isLoose;
	  var node;
	  var now;
	  var end;
	  var indented;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_TAB) {
	      size += TAB_SIZE - (size % TAB_SIZE);
	    } else if (character === C_SPACE) {
	      size++;
	    } else {
	      break;
	    }
	
	    index++;
	  }
	
	  if (size >= TAB_SIZE) {
	    return;
	  }
	
	  character = value.charAt(index);
	
	  markers = commonmark ?
	    LIST_ORDERED_COMMONMARK_MARKERS :
	    LIST_ORDERED_MARKERS;
	
	  if (LIST_UNORDERED_MARKERS[character] === true) {
	    marker = character;
	    ordered = false;
	  } else {
	    ordered = true;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!decimal(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (!queue || markers[character] !== true) {
	      return;
	    }
	
	    start = parseInt(queue, 10);
	    marker = character;
	  }
	
	  character = value.charAt(++index);
	
	  if (character !== C_SPACE && character !== C_TAB) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	  items = [];
	  allLines = [];
	  emptyLines = [];
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	    indented = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    end = index + TAB_SIZE;
	    size = 0;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_TAB) {
	        size += TAB_SIZE - (size % TAB_SIZE);
	      } else if (character === C_SPACE) {
	        size++;
	      } else {
	        break;
	      }
	
	      index++;
	    }
	
	    if (size >= TAB_SIZE) {
	      indented = true;
	    }
	
	    if (item && size >= item.indent) {
	      indented = true;
	    }
	
	    character = value.charAt(index);
	    currentMarker = null;
	
	    if (!indented) {
	      if (LIST_UNORDERED_MARKERS[character] === true) {
	        currentMarker = character;
	        index++;
	        size++;
	      } else {
	        queue = '';
	
	        while (index < length) {
	          character = value.charAt(index);
	
	          if (!decimal(character)) {
	            break;
	          }
	
	          queue += character;
	          index++;
	        }
	
	        character = value.charAt(index);
	        index++;
	
	        if (queue && markers[character] === true) {
	          currentMarker = character;
	          size += queue.length + 1;
	        }
	      }
	
	      if (currentMarker) {
	        character = value.charAt(index);
	
	        if (character === C_TAB) {
	          size += TAB_SIZE - (size % TAB_SIZE);
	          index++;
	        } else if (character === C_SPACE) {
	          end = index + TAB_SIZE;
	
	          while (index < end) {
	            if (value.charAt(index) !== C_SPACE) {
	              break;
	            }
	
	            index++;
	            size++;
	          }
	
	          if (index === end && value.charAt(index) === C_SPACE) {
	            index -= TAB_SIZE - 1;
	            size -= TAB_SIZE - 1;
	          }
	        } else if (character !== C_NEWLINE && character !== '') {
	          currentMarker = null;
	        }
	      }
	    }
	
	    if (currentMarker) {
	      if (!pedantic && marker !== currentMarker) {
	        break;
	      }
	
	      prefixed = true;
	    } else {
	      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
	        indented = true;
	      } else if (commonmark && item) {
	        indented = size >= item.indent || size > TAB_SIZE;
	      }
	
	      prefixed = false;
	      index = startIndex;
	    }
	
	    line = value.slice(startIndex, nextIndex);
	    content = startIndex === index ? line : value.slice(index, nextIndex);
	
	    if (
	      currentMarker === C_ASTERISK ||
	      currentMarker === C_UNDERSCORE ||
	      currentMarker === C_DASH
	    ) {
	      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
	        break;
	      }
	    }
	
	    prevEmpty = empty;
	    empty = !trim(content).length;
	
	    if (indented && item) {
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (prefixed) {
	      if (emptyLines.length !== 0) {
	        item.value.push('');
	        item.trail = emptyLines.concat();
	      }
	
	      item = {
	        value: [line],
	        indent: size,
	        trail: []
	      };
	
	      items.push(item);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (empty) {
	      if (prevEmpty) {
	        break;
	      }
	
	      emptyLines.push(line);
	    } else {
	      if (prevEmpty) {
	        break;
	      }
	
	      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
	        break;
	      }
	
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    }
	
	    index = nextIndex + 1;
	  }
	
	  node = eat(allLines.join(C_NEWLINE)).reset({
	    type: 'list',
	    ordered: ordered,
	    start: start,
	    loose: null,
	    children: []
	  });
	
	  enterTop = self.enterList();
	  exitBlockquote = self.enterBlock();
	  isLoose = false;
	  index = -1;
	  length = items.length;
	
	  while (++index < length) {
	    item = items[index].value.join(C_NEWLINE);
	    now = eat.now();
	
	    item = eat(item)(listItem(self, item, now), node);
	
	    if (item.loose) {
	      isLoose = true;
	    }
	
	    item = items[index].trail.join(C_NEWLINE);
	
	    if (index !== length - 1) {
	      item += C_NEWLINE;
	    }
	
	    eat(item);
	  }
	
	  enterTop();
	  exitBlockquote();
	
	  node.loose = isLoose;
	
	  return node;
	}
	
	function listItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
	  var checked = null;
	  var task;
	  var indent;
	
	  value = fn.apply(null, arguments);
	
	  if (ctx.options.gfm) {
	    task = value.match(EXPRESSION_TASK_ITEM);
	
	    if (task) {
	      indent = task[0].length;
	      checked = task[1].toLowerCase() === C_X_LOWER;
	      offsets[position.line] += indent;
	      value = value.slice(indent);
	    }
	  }
	
	  return {
	    type: 'listItem',
	    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
	      value.charAt(value.length - 1) === C_NEWLINE,
	    checked: checked,
	    children: ctx.tokenizeBlock(value, position)
	  };
	}
	
	/* Create a list-item using overly simple mechanics. */
	function pedanticListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
	
	  /* The initial line was also matched by the below, so
	   * we reset the `line`. */
	  line = position.line;
	
	  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
	
	  /* A simple replacer which removed all matches,
	   * and adds their length to `offset`. */
	  function replacer($0) {
	    offsets[line] = (offsets[line] || 0) + $0.length;
	    line++;
	
	    return '';
	  }
	}
	
	/* Create a list-item using sane mechanics. */
	function normalListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	  var max;
	  var bullet;
	  var rest;
	  var lines;
	  var trimmedLines;
	  var index;
	  var length;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_BULLET, replacer);
	
	  lines = value.split(C_NEWLINE);
	
	  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);
	
	  /* We replaced the initial bullet with something
	   * else above, which was used to trick
	   * `removeIndentation` into removing some more
	   * characters when possible.  However, that could
	   * result in the initial line to be stripped more
	   * than it should be. */
	  trimmedLines[0] = rest;
	
	  offsets[line] = (offsets[line] || 0) + bullet.length;
	  line++;
	
	  index = 0;
	  length = lines.length;
	
	  while (++index < length) {
	    offsets[line] = (offsets[line] || 0) +
	      lines[index].length - trimmedLines[index].length;
	    line++;
	  }
	
	  return trimmedLines.join(C_NEWLINE);
	
	  function replacer($0, $1, $2, $3, $4) {
	    bullet = $1 + $2 + $3;
	    rest = $4;
	
	    /* Make sure that the first nine numbered list items
	     * can indent with an extra space.  That is, when
	     * the bullet did not receive an extra final space. */
	    if (Number($2) < 10 && bullet.length % 2 === 1) {
	      $2 = C_SPACE + $2;
	    }
	
	    max = $1 + repeat(C_SPACE, $2.length) + $3;
	
	    return max + rest;
	  }
	}


/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	
	module.exports = newline;
	
	/* Tokenise newline. */
	function newline(eat, value, silent) {
	  var character = value.charAt(0);
	  var length;
	  var subvalue;
	  var queue;
	  var index;
	
	  if (character !== '\n') {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  index = 1;
	  length = value.length;
	  subvalue = character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	
	    if (character === '\n') {
	      subvalue += queue;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  eat(subvalue);
	}


/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(198);
	var decimal = __webpack_require__(263);
	var trimTrailingLines = __webpack_require__(441);
	var interrupt = __webpack_require__(435);
	
	module.exports = paragraph;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var TAB_SIZE = 4;
	
	/* Tokenise paragraph. */
	function paragraph(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var commonmark = settings.commonmark;
	  var gfm = settings.gfm;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptParagraph;
	  var index = value.indexOf(C_NEWLINE);
	  var length = value.length;
	  var position;
	  var subvalue;
	  var character;
	  var size;
	  var now;
	
	  while (index < length) {
	    /* Eat everything if there’s no following newline. */
	    if (index === -1) {
	      index = length;
	      break;
	    }
	
	    /* Stop if the next character is NEWLINE. */
	    if (value.charAt(index + 1) === C_NEWLINE) {
	      break;
	    }
	
	    /* In commonmark-mode, following indented lines
	     * are part of the paragraph. */
	    if (commonmark) {
	      size = 0;
	      position = index + 1;
	
	      while (position < length) {
	        character = value.charAt(position);
	
	        if (character === C_TAB) {
	          size = TAB_SIZE;
	          break;
	        } else if (character === C_SPACE) {
	          size++;
	        } else {
	          break;
	        }
	
	        position++;
	      }
	
	      if (size >= TAB_SIZE) {
	        index = value.indexOf(C_NEWLINE, index + 1);
	        continue;
	      }
	    }
	
	    subvalue = value.slice(index + 1);
	
	    /* Check if the following code contains a possible
	     * block. */
	    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
	      break;
	    }
	
	    /* Break if the following line starts a list, when
	     * already in a list, or when in commonmark, or when
	     * in gfm mode and the bullet is *not* numeric. */
	    if (
	      tokenizers.list.call(self, eat, subvalue, true) &&
	      (
	        self.inList ||
	        commonmark ||
	        (gfm && !decimal(trim.left(subvalue).charAt(0)))
	      )
	    ) {
	      break;
	    }
	
	    position = index;
	    index = value.indexOf(C_NEWLINE, index + 1);
	
	    if (index !== -1 && trim(value.slice(position, index)) === '') {
	      index = position;
	      break;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  if (trim(subvalue) === '') {
	    eat(subvalue);
	
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  subvalue = trimTrailingLines(subvalue);
	
	  return eat(subvalue)({
	    type: 'paragraph',
	    children: self.tokenizeInline(subvalue, now)
	  });
	}


/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	var locate = __webpack_require__(823);
	var normalize = __webpack_require__(436);
	
	module.exports = reference;
	reference.locator = locate;
	
	var T_LINK = 'link';
	var T_IMAGE = 'image';
	var T_FOOTNOTE = 'footnote';
	var REFERENCE_TYPE_SHORTCUT = 'shortcut';
	var REFERENCE_TYPE_COLLAPSED = 'collapsed';
	var REFERENCE_TYPE_FULL = 'full';
	var C_CARET = '^';
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	
	function reference(eat, value, silent) {
	  var self = this;
	  var character = value.charAt(0);
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var intro = '';
	  var type = T_LINK;
	  var referenceType = REFERENCE_TYPE_SHORTCUT;
	  var content;
	  var identifier;
	  var now;
	  var node;
	  var exit;
	  var queue;
	  var bracketed;
	  var depth;
	
	  /* Check whether we’re eating an image. */
	  if (character === '!') {
	    type = T_IMAGE;
	    intro = character;
	    character = value.charAt(++index);
	  }
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  intro += character;
	  queue = '';
	
	  /* Check whether we’re eating a footnote. */
	  if (
	    self.options.footnotes &&
	    type === T_LINK &&
	    value.charAt(index) === C_CARET
	  ) {
	    intro += C_CARET;
	    index++;
	    type = T_FOOTNOTE;
	  }
	
	  /* Eat the text. */
	  depth = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_OPEN) {
	      bracketed = true;
	      depth++;
	    } else if (character === C_BRACKET_CLOSE) {
	      if (!depth) {
	        break;
	      }
	
	      depth--;
	    }
	
	    if (character === C_BACKSLASH) {
	      queue += C_BACKSLASH;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  subvalue = queue;
	  content = queue;
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_CLOSE) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  /* Inline footnotes cannot have an identifier. */
	  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
	    identifier = '';
	    queue += character;
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
	        break;
	      }
	
	      if (character === C_BACKSLASH) {
	        identifier += C_BACKSLASH;
	        character = value.charAt(++index);
	      }
	
	      identifier += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
	      queue += identifier + character;
	      index++;
	    } else {
	      identifier = '';
	    }
	
	    subvalue += queue;
	    queue = '';
	  } else {
	    if (!content) {
	      return;
	    }
	
	    identifier = content;
	  }
	
	  /* Brackets cannot be inside the identifier. */
	  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
	    return;
	  }
	
	  subvalue = intro + subvalue;
	
	  if (type === T_LINK && self.inLink) {
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
	    return eat(subvalue)({
	      type: 'footnote',
	      children: this.tokenizeInline(content, eat.now())
	    });
	  }
	
	  now = eat.now();
	  now.column += intro.length;
	  now.offset += intro.length;
	  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
	
	  node = {
	    type: type + 'Reference',
	    identifier: normalize(identifier)
	  };
	
	  if (type === T_LINK || type === T_IMAGE) {
	    node.referenceType = referenceType;
	  }
	
	  if (type === T_LINK) {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  } else if (type === T_IMAGE) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(198);
	var whitespace = __webpack_require__(87);
	var locate = __webpack_require__(2993);
	
	module.exports = strong;
	strong.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function strong(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (
	    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
	    value.charAt(++index) !== character
	  ) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  marker = character;
	  subvalue = marker + marker;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (
	      character === marker &&
	      value.charAt(index + 1) === marker &&
	      (!pedantic || !whitespace(prev))
	    ) {
	      character = value.charAt(index + 2);
	
	      if (character !== marker) {
	        if (!trim(queue)) {
	          return;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column += 2;
	        now.offset += 2;
	
	        return eat(subvalue + queue + subvalue)({
	          type: 'strong',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(87);
	
	module.exports = table;
	
	var C_BACKSLASH = '\\';
	var C_TICK = '`';
	var C_DASH = '-';
	var C_PIPE = '|';
	var C_COLON = ':';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	var MIN_TABLE_COLUMNS = 1;
	var MIN_TABLE_ROWS = 2;
	
	var TABLE_ALIGN_LEFT = 'left';
	var TABLE_ALIGN_CENTER = 'center';
	var TABLE_ALIGN_RIGHT = 'right';
	var TABLE_ALIGN_NONE = null;
	
	function table(eat, value, silent) {
	  var self = this;
	  var index;
	  var alignments;
	  var alignment;
	  var subvalue;
	  var row;
	  var length;
	  var lines;
	  var queue;
	  var character;
	  var hasDash;
	  var align;
	  var cell;
	  var preamble;
	  var count;
	  var opening;
	  var now;
	  var position;
	  var lineCount;
	  var line;
	  var rows;
	  var table;
	  var lineIndex;
	  var pipeIndex;
	  var first;
	
	  /* Exit when not in gfm-mode. */
	  if (!self.options.gfm) {
	    return;
	  }
	
	  /* Get the rows.
	   * Detecting tables soon is hard, so there are some
	   * checks for performance here, such as the minimum
	   * number of rows, and allowed characters in the
	   * alignment row. */
	  index = 0;
	  lineCount = 0;
	  length = value.length + 1;
	  lines = [];
	
	  while (index < length) {
	    lineIndex = value.indexOf(C_NEWLINE, index);
	    pipeIndex = value.indexOf(C_PIPE, index + 1);
	
	    if (lineIndex === -1) {
	      lineIndex = value.length;
	    }
	
	    if (pipeIndex === -1 || pipeIndex > lineIndex) {
	      if (lineCount < MIN_TABLE_ROWS) {
	        return;
	      }
	
	      break;
	    }
	
	    lines.push(value.slice(index, lineIndex));
	    lineCount++;
	    index = lineIndex + 1;
	  }
	
	  /* Parse the alignment row. */
	  subvalue = lines.join(C_NEWLINE);
	  alignments = lines.splice(1, 1)[0] || [];
	  index = 0;
	  length = alignments.length;
	  lineCount--;
	  alignment = false;
	  align = [];
	
	  while (index < length) {
	    character = alignments.charAt(index);
	
	    if (character === C_PIPE) {
	      hasDash = null;
	
	      if (alignment === false) {
	        if (first === false) {
	          return;
	        }
	      } else {
	        align.push(alignment);
	        alignment = false;
	      }
	
	      first = false;
	    } else if (character === C_DASH) {
	      hasDash = true;
	      alignment = alignment || TABLE_ALIGN_NONE;
	    } else if (character === C_COLON) {
	      if (alignment === TABLE_ALIGN_LEFT) {
	        alignment = TABLE_ALIGN_CENTER;
	      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
	        alignment = TABLE_ALIGN_RIGHT;
	      } else {
	        alignment = TABLE_ALIGN_LEFT;
	      }
	    } else if (!whitespace(character)) {
	      return;
	    }
	
	    index++;
	  }
	
	  if (alignment !== false) {
	    align.push(alignment);
	  }
	
	  /* Exit when without enough columns. */
	  if (align.length < MIN_TABLE_COLUMNS) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  /* Parse the rows. */
	  position = -1;
	  rows = [];
	
	  table = eat(subvalue).reset({
	    type: 'table',
	    align: align,
	    children: rows
	  });
	
	  while (++position < lineCount) {
	    line = lines[position];
	    row = {type: 'tableRow', children: []};
	
	    /* Eat a newline character when this is not the
	     * first row. */
	    if (position) {
	      eat(C_NEWLINE);
	    }
	
	    /* Eat the row. */
	    eat(line).reset(row, table);
	
	    length = line.length + 1;
	    index = 0;
	    queue = '';
	    cell = '';
	    preamble = true;
	    count = null;
	    opening = null;
	
	    while (index < length) {
	      character = line.charAt(index);
	
	      if (character === C_TAB || character === C_SPACE) {
	        if (cell) {
	          queue += character;
	        } else {
	          eat(character);
	        }
	
	        index++;
	        continue;
	      }
	
	      if (character === '' || character === C_PIPE) {
	        if (preamble) {
	          eat(character);
	        } else {
	          if (character && opening) {
	            queue += character;
	            index++;
	            continue;
	          }
	
	          if ((cell || character) && !preamble) {
	            subvalue = cell;
	
	            if (queue.length > 1) {
	              if (character) {
	                subvalue += queue.slice(0, queue.length - 1);
	                queue = queue.charAt(queue.length - 1);
	              } else {
	                subvalue += queue;
	                queue = '';
	              }
	            }
	
	            now = eat.now();
	
	            eat(subvalue)({
	              type: 'tableCell',
	              children: self.tokenizeInline(cell, now)
	            }, row);
	          }
	
	          eat(queue + character);
	
	          queue = '';
	          cell = '';
	        }
	      } else {
	        if (queue) {
	          cell += queue;
	          queue = '';
	        }
	
	        cell += character;
	
	        if (character === C_BACKSLASH && index !== length - 2) {
	          cell += line.charAt(index + 1);
	          index++;
	        }
	
	        if (character === C_TICK) {
	          count = 1;
	
	          while (line.charAt(index + 1) === character) {
	            cell += character;
	            index++;
	            count++;
	          }
	
	          if (!opening) {
	            opening = count;
	          } else if (count >= opening) {
	            opening = 0;
	          }
	        }
	      }
	
	      preamble = false;
	      index++;
	    }
	
	    /* Eat the alignment row. */
	    if (!position) {
	      eat(C_NEWLINE + alignments);
	    }
	  }
	
	  return table;
	}


/***/ }),
/* 3020 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = text;
	
	function text(eat, value, silent) {
	  var self = this;
	  var methods;
	  var tokenizers;
	  var index;
	  var length;
	  var subvalue;
	  var position;
	  var tokenizer;
	  var name;
	  var min;
	  var now;
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  methods = self.inlineMethods;
	  length = methods.length;
	  tokenizers = self.inlineTokenizers;
	  index = -1;
	  min = value.length;
	
	  while (++index < length) {
	    name = methods[index];
	
	    if (name === 'text' || !tokenizers[name]) {
	      continue;
	    }
	
	    tokenizer = tokenizers[name].locator;
	
	    if (!tokenizer) {
	      eat.file.fail('Missing locator: `' + name + '`');
	    }
	
	    position = tokenizer.call(self, value, 1);
	
	    if (position !== -1 && position < min) {
	      min = position;
	    }
	  }
	
	  subvalue = value.slice(0, min);
	  now = eat.now();
	
	  self.decode(subvalue, now, function (content, position, source) {
	    eat(source || content)({
	      type: 'text',
	      value: content
	    });
	  });
	}


/***/ }),
/* 3021 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = thematicBreak;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_DASH = '-';
	
	var THEMATIC_BREAK_MARKER_COUNT = 3;
	
	function thematicBreak(eat, value, silent) {
	  var index = -1;
	  var length = value.length + 1;
	  var subvalue = '';
	  var character;
	  var marker;
	  var markerCount;
	  var queue;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  if (
	    character !== C_ASTERISK &&
	    character !== C_DASH &&
	    character !== C_UNDERSCORE
	  ) {
	    return;
	  }
	
	  marker = character;
	  subvalue += character;
	  markerCount = 1;
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === marker) {
	      markerCount++;
	      subvalue += queue + marker;
	      queue = '';
	    } else if (character === C_SPACE) {
	      queue += character;
	    } else if (
	      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
	      (!character || character === C_NEWLINE)
	    ) {
	      subvalue += queue;
	
	      if (silent) {
	        return true;
	      }
	
	      return eat(subvalue)({type: 'thematicBreak'});
	    } else {
	      return;
	    }
	  }
	}


/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var decode = __webpack_require__(396);
	var whitespace = __webpack_require__(87);
	var locate = __webpack_require__(2994);
	
	module.exports = url;
	url.locator = locate;
	url.notInLink = true;
	
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_AT_SIGN = '@';
	
	var HTTP_PROTOCOL = 'http://';
	var HTTPS_PROTOCOL = 'https://';
	var MAILTO_PROTOCOL = 'mailto:';
	
	var PROTOCOLS = [
	  HTTP_PROTOCOL,
	  HTTPS_PROTOCOL,
	  MAILTO_PROTOCOL
	];
	
	var PROTOCOLS_LENGTH = PROTOCOLS.length;
	
	function url(eat, value, silent) {
	  var self = this;
	  var subvalue;
	  var content;
	  var character;
	  var index;
	  var position;
	  var protocol;
	  var match;
	  var length;
	  var queue;
	  var parenCount;
	  var nextCharacter;
	  var exit;
	
	  if (!self.options.gfm) {
	    return;
	  }
	
	  subvalue = '';
	  index = -1;
	  length = PROTOCOLS_LENGTH;
	
	  while (++index < length) {
	    protocol = PROTOCOLS[index];
	    match = value.slice(0, protocol.length);
	
	    if (match.toLowerCase() === protocol) {
	      subvalue = match;
	      break;
	    }
	  }
	
	  if (!subvalue) {
	    return;
	  }
	
	  index = subvalue.length;
	  length = value.length;
	  queue = '';
	  parenCount = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_LT) {
	      break;
	    }
	
	    if (
	      character === '.' ||
	      character === ',' ||
	      character === ':' ||
	      character === ';' ||
	      character === '"' ||
	      character === '\'' ||
	      character === ')' ||
	      character === ']'
	    ) {
	      nextCharacter = value.charAt(index + 1);
	
	      if (!nextCharacter || whitespace(nextCharacter)) {
	        break;
	      }
	    }
	
	    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
	      parenCount++;
	    }
	
	    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
	      parenCount--;
	
	      if (parenCount < 0) {
	        break;
	      }
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue += queue;
	  content = subvalue;
	
	  if (protocol === MAILTO_PROTOCOL) {
	    position = queue.indexOf(C_AT_SIGN);
	
	    if (position === -1 || position === length - 1) {
	      return;
	    }
	
	    content = content.substr(MAILTO_PROTOCOL.length);
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  exit = self.enterLink();
	  content = self.tokenizeInline(content, eat.now());
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(subvalue),
	    children: content
	  });
	}


/***/ }),
/* 3023 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	var MERGEABLE_NODES = {
	  text: mergeText,
	  blockquote: mergeBlockquote
	};
	
	/* Check whether a node is mergeable with adjacent nodes. */
	function mergeable(node) {
	  var start;
	  var end;
	
	  if (node.type !== 'text' || !node.position) {
	    return true;
	  }
	
	  start = node.position.start;
	  end = node.position.end;
	
	  /* Only merge nodes which occupy the same size as their
	   * `value`. */
	  return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	}
	
	/* Merge two text nodes: `node` into `prev`. */
	function mergeText(prev, node) {
	  prev.value += node.value;
	
	  return prev;
	}
	
	/* Merge two blockquotes: `node` into `prev`, unless in
	 * CommonMark mode. */
	function mergeBlockquote(prev, node) {
	  if (this.options.commonmark) {
	    return node;
	  }
	
	  prev.children = prev.children.concat(node.children);
	
	  return prev;
	}
	
	/* Construct a tokenizer.  This creates both
	 * `tokenizeInline` and `tokenizeBlock`. */
	function factory(type) {
	  return tokenize;
	
	  /* Tokenizer for a bound `type`. */
	  function tokenize(value, location) {
	    var self = this;
	    var offset = self.offset;
	    var tokens = [];
	    var methods = self[type + 'Methods'];
	    var tokenizers = self[type + 'Tokenizers'];
	    var line = location.line;
	    var column = location.column;
	    var index;
	    var length;
	    var method;
	    var name;
	    var matched;
	    var valueLength;
	
	    /* Trim white space only lines. */
	    if (!value) {
	      return tokens;
	    }
	
	    /* Expose on `eat`. */
	    eat.now = now;
	    eat.file = self.file;
	
	    /* Sync initial offset. */
	    updatePosition('');
	
	    /* Iterate over `value`, and iterate over all
	     * tokenizers.  When one eats something, re-iterate
	     * with the remaining value.  If no tokenizer eats,
	     * something failed (should not happen) and an
	     * exception is thrown. */
	    while (value) {
	      index = -1;
	      length = methods.length;
	      matched = false;
	
	      while (++index < length) {
	        name = methods[index];
	        method = tokenizers[name];
	
	        if (
	          method &&
	          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
	          (!method.notInList || !self.inList) &&
	          (!method.notInBlock || !self.inBlock) &&
	          (!method.notInLink || !self.inLink)
	        ) {
	          valueLength = value.length;
	
	          method.apply(self, [eat, value]);
	
	          matched = valueLength !== value.length;
	
	          if (matched) {
	            break;
	          }
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!matched) {
	        self.file.fail(new Error('Infinite loop'), eat.now());
	      }
	    }
	
	    self.eof = now();
	
	    return tokens;
	
	    /* Update line, column, and offset based on
	     * `value`. */
	    function updatePosition(subvalue) {
	      var lastIndex = -1;
	      var index = subvalue.indexOf('\n');
	
	      while (index !== -1) {
	        line++;
	        lastIndex = index;
	        index = subvalue.indexOf('\n', index + 1);
	      }
	
	      if (lastIndex === -1) {
	        column += subvalue.length;
	      } else {
	        column = subvalue.length - lastIndex;
	      }
	
	      if (line in offset) {
	        if (lastIndex !== -1) {
	          column += offset[line];
	        } else if (column <= offset[line]) {
	          column = offset[line] + 1;
	        }
	      }
	    }
	
	    /* Get offset.  Called before the first character is
	     * eaten to retrieve the range's offsets. */
	    function getOffset() {
	      var indentation = [];
	      var pos = line + 1;
	
	      /* Done.  Called when the last character is
	       * eaten to retrieve the range’s offsets. */
	      return function () {
	        var last = line + 1;
	
	        while (pos < last) {
	          indentation.push((offset[pos] || 0) + 1);
	
	          pos++;
	        }
	
	        return indentation;
	      };
	    }
	
	    /* Get the current position. */
	    function now() {
	      var pos = {line: line, column: column};
	
	      pos.offset = self.toOffset(pos);
	
	      return pos;
	    }
	
	    /* Store position information for a node. */
	    function Position(start) {
	      this.start = start;
	      this.end = now();
	    }
	
	    /* Throw when a value is incorrectly eaten.
	     * This shouldn’t happen but will throw on new,
	     * incorrect rules. */
	    function validateEat(subvalue) {
	      /* istanbul ignore if */
	      if (value.substring(0, subvalue.length) !== subvalue) {
	        /* Capture stack-trace. */
	        self.file.fail(
	          new Error(
	            'Incorrectly eaten value: please report this ' +
	            'warning on http://git.io/vg5Ft'
	          ),
	          now()
	        );
	      }
	    }
	
	    /* Mark position and patch `node.position`. */
	    function position() {
	      var before = now();
	
	      return update;
	
	      /* Add the position to a node. */
	      function update(node, indent) {
	        var prev = node.position;
	        var start = prev ? prev.start : before;
	        var combined = [];
	        var n = prev && prev.end.line;
	        var l = before.line;
	
	        node.position = new Position(start);
	
	        /* If there was already a `position`, this
	         * node was merged.  Fixing `start` wasn’t
	         * hard, but the indent is different.
	         * Especially because some information, the
	         * indent between `n` and `l` wasn’t
	         * tracked.  Luckily, that space is
	         * (should be?) empty, so we can safely
	         * check for it now. */
	        if (prev && indent && prev.indent) {
	          combined = prev.indent;
	
	          if (n < l) {
	            while (++n < l) {
	              combined.push((offset[n] || 0) + 1);
	            }
	
	            combined.push(before.column);
	          }
	
	          indent = combined.concat(indent);
	        }
	
	        node.position.indent = indent || [];
	
	        return node;
	      }
	    }
	
	    /* Add `node` to `parent`s children or to `tokens`.
	     * Performs merges where possible. */
	    function add(node, parent) {
	      var children = parent ? parent.children : tokens;
	      var prev = children[children.length - 1];
	
	      if (
	        prev &&
	        node.type === prev.type &&
	        node.type in MERGEABLE_NODES &&
	        mergeable(prev) &&
	        mergeable(node)
	      ) {
	        node = MERGEABLE_NODES[node.type].call(self, prev, node);
	      }
	
	      if (node !== prev) {
	        children.push(node);
	      }
	
	      if (self.atStart && tokens.length !== 0) {
	        self.exitStart();
	      }
	
	      return node;
	    }
	
	    /* Remove `subvalue` from `value`.
	     * `subvalue` must be at the start of `value`. */
	    function eat(subvalue) {
	      var indent = getOffset();
	      var pos = position();
	      var current = now();
	
	      validateEat(subvalue);
	
	      apply.reset = reset;
	      reset.test = test;
	      apply.test = test;
	
	      value = value.substring(subvalue.length);
	
	      updatePosition(subvalue);
	
	      indent = indent();
	
	      return apply;
	
	      /* Add the given arguments, add `position` to
	       * the returned node, and return the node. */
	      function apply(node, parent) {
	        return pos(add(pos(node), parent), indent);
	      }
	
	      /* Functions just like apply, but resets the
	       * content:  the line and column are reversed,
	       * and the eaten value is re-added.
	       * This is useful for nodes with a single
	       * type of content, such as lists and tables.
	       * See `apply` above for what parameters are
	       * expected. */
	      function reset() {
	        var node = apply.apply(null, arguments);
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return node;
	      }
	
	      /* Test the position, after eating, and reverse
	       * to a not-eaten state. */
	      function test() {
	        var result = pos({});
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return result.position;
	      }
	    }
	  }
	}


/***/ }),
/* 3024 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	/* Factory to de-escape a value, based on a list at `key`
	 * in `ctx`. */
	function factory(ctx, key) {
	  return unescape;
	
	  /* De-escape a string using the expression at `key`
	   * in `ctx`. */
	  function unescape(value) {
	    var prev = 0;
	    var index = value.indexOf('\\');
	    var escape = ctx[key];
	    var queue = [];
	    var character;
	
	    while (index !== -1) {
	      queue.push(value.slice(prev, index));
	      prev = index + 1;
	      character = value.charAt(prev);
	
	      /* If the following character is not a valid escape,
	       * add the slash. */
	      if (!character || escape.indexOf(character) === -1) {
	        queue.push('\\');
	      }
	
	      index = value.indexOf('\\', prev);
	    }
	
	    queue.push(value.slice(prev));
	
	    return queue.join('');
	  }
	}


/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(198);
	var repeat = __webpack_require__(437);
	var getIndent = __webpack_require__(825);
	
	module.exports = indentation;
	
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	/* Remove the minimum indent from every line in `value`.
	 * Supports both tab, spaced, and mixed indentation (as
	 * well as possible). */
	function indentation(value, maximum) {
	  var values = value.split(C_NEWLINE);
	  var position = values.length + 1;
	  var minIndent = Infinity;
	  var matrix = [];
	  var index;
	  var indentation;
	  var stops;
	  var padding;
	
	  values.unshift(repeat(C_SPACE, maximum) + '!');
	
	  while (position--) {
	    indentation = getIndent(values[position]);
	
	    matrix[position] = indentation.stops;
	
	    if (trim(values[position]).length === 0) {
	      continue;
	    }
	
	    if (indentation.indent) {
	      if (indentation.indent > 0 && indentation.indent < minIndent) {
	        minIndent = indentation.indent;
	      }
	    } else {
	      minIndent = Infinity;
	
	      break;
	    }
	  }
	
	  if (minIndent !== Infinity) {
	    position = values.length;
	
	    while (position--) {
	      stops = matrix[position];
	      index = minIndent;
	
	      while (index && !(index in stops)) {
	        index--;
	      }
	
	      if (
	        trim(values[position]).length !== 0 &&
	        minIndent &&
	        index !== minIndent
	      ) {
	        padding = C_TAB;
	      } else {
	        padding = '';
	      }
	
	      values[position] = padding + values[position].slice(
	        index in stops ? stops[index] + 1 : 0
	      );
	    }
	  }
	
	  values.shift();
	
	  return values.join(C_NEWLINE);
	}


/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(61)))

/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var encode = __webpack_require__(827);
	var alphabet = __webpack_require__(292);
	
	// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
	// This number should be updated every year or so to keep the generated id short.
	// To regenerate `new Date() - 0` and bump the version. Always bump the version!
	var REDUCE_TIME = 1459707606518;
	
	// don't change unless we change the algos or REDUCE_TIME
	// must be an integer and less than 16
	var version = 6;
	
	// Counter is used when shortid is called multiple times in one second.
	var counter;
	
	// Remember the last time shortid was called in case counter is needed.
	var previousSeconds;
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function build(clusterWorkerId) {
	
	    var str = '';
	
	    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);
	
	    if (seconds === previousSeconds) {
	        counter++;
	    } else {
	        counter = 0;
	        previousSeconds = seconds;
	    }
	
	    str = str + encode(alphabet.lookup, version);
	    str = str + encode(alphabet.lookup, clusterWorkerId);
	    if (counter > 0) {
	        str = str + encode(alphabet.lookup, counter);
	    }
	    str = str + encode(alphabet.lookup, seconds);
	
	    return str;
	}
	
	module.exports = build;


/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(292);
	
	/**
	 * Decode the id to get the version and worker
	 * Mainly for debugging and testing.
	 * @param id - the shortid-generated id.
	 */
	function decode(id) {
	    var characters = alphabet.shuffled();
	    return {
	        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
	        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
	    };
	}
	
	module.exports = decode;


/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabet = __webpack_require__(292);
	var encode = __webpack_require__(827);
	var decode = __webpack_require__(3028);
	var build = __webpack_require__(3027);
	var isValid = __webpack_require__(3030);
	
	// if you are using cluster or multiple servers use this to make each instance
	// has a unique value for worker
	// Note: I don't know if this is automatically set when using third
	// party cluster solutions such as pm2.
	var clusterWorkerId = __webpack_require__(3033) || 0;
	
	/**
	 * Set the seed.
	 * Highly recommended if you don't want people to try to figure out your id schema.
	 * exposed as shortid.seed(int)
	 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
	 */
	function seed(seedValue) {
	    alphabet.seed(seedValue);
	    return module.exports;
	}
	
	/**
	 * Set the cluster worker or machine id
	 * exposed as shortid.worker(int)
	 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
	 * returns shortid module so it can be chained.
	 */
	function worker(workerId) {
	    clusterWorkerId = workerId;
	    return module.exports;
	}
	
	/**
	 *
	 * sets new characters to use in the alphabet
	 * returns the shuffled alphabet
	 */
	function characters(newCharacters) {
	    if (newCharacters !== undefined) {
	        alphabet.characters(newCharacters);
	    }
	
	    return alphabet.shuffled();
	}
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function generate() {
	  return build(clusterWorkerId);
	}
	
	// Export all other functions as properties of the generate function
	module.exports = generate;
	module.exports.generate = generate;
	module.exports.seed = seed;
	module.exports.worker = worker;
	module.exports.characters = characters;
	module.exports.decode = decode;
	module.exports.isValid = isValid;


/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(292);
	
	function isShortId(id) {
	    if (!id || typeof id !== 'string' || id.length < 6 ) {
	        return false;
	    }
	
	    var characters = alphabet.characters();
	    var len = id.length;
	    for(var i = 0; i < len;i++) {
	        if (characters.indexOf(id[i]) === -1) {
	            return false;
	        }
	    }
	    return true;
	}
	
	module.exports = isShortId;


/***/ }),
/* 3031 */
/***/ (function(module, exports) {

	'use strict';
	
	var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
	
	function randomByte() {
	    if (!crypto || !crypto.getRandomValues) {
	        return Math.floor(Math.random() * 256) & 0x30;
	    }
	    var dest = new Uint8Array(1);
	    crypto.getRandomValues(dest);
	    return dest[0] & 0x30;
	}
	
	module.exports = randomByte;


/***/ }),
/* 3032 */
/***/ (function(module, exports) {

	'use strict';
	
	// Found this seed-based random generator somewhere
	// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
	
	var seed = 1;
	
	/**
	 * return a random number based on a seed
	 * @param seed
	 * @returns {number}
	 */
	function getNextValue() {
	    seed = (seed * 9301 + 49297) % 233280;
	    return seed/(233280.0);
	}
	
	function setSeed(_seed_) {
	    seed = _seed_;
	}
	
	module.exports = {
	    nextValue: getNextValue,
	    seed: setSeed
	};


/***/ }),
/* 3033 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = 0;


/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(749);
	var debug = __webpack_require__(293)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3035 */
[3179, 3036],
/* 3036 */
1531,
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(3041);
	var isBuf = __webpack_require__(831);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3038 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(3040);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(3042);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 3041 */
1548,
/* 3042 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 3043 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2016 Titus Wormer
	 * @license MIT
	 * @module state-toggle
	 * @fileoverview Enter/exit a state.
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/* Expose. */
	module.exports = factory;
	
	/**
	 * Construct a state `toggler`: a function which inverses
	 * `property` in context based on its current value.
	 * The by `toggler` returned function restores that value.
	 *
	 * @param {string} key - Property to toggle.
	 * @param {boolean} state - Default state.
	 * @param {Object?} [ctx] - Context object.
	 * @return {Function} - Enter.
	 */
	function factory(key, state, ctx) {
	  /**
	   * Enter a state.
	   *
	   * @return {Function} - Exit state.
	   */
	  return function () {
	    var context = ctx || this;
	    var current = context[key];
	
	    context[key] = !state;
	
	    /**
	     * Cancel state to its value before entering.
	     */
	    return function () {
	      context[key] = current;
	    };
	  };
	}


/***/ }),
/* 3044 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(832);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
	      self.end(function(err, res){
	        if (err) innerReject(err); else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	}
	
	exports.catch = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	
	  // name should be either a string or an object.
	  if (null === name ||  undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	exports.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	exports.withCredentials = function(){
	  // This is browser-only functionality. Node side is no-op.
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	exports.toJSON = function(){
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header
	  };
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	exports._isHost = function _isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || this._isHost(data)) return this;
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};


/***/ }),
/* 3046 */
/***/ (function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(3048);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(138)(module)))

/***/ }),
/* 3048 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(3026);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 3050 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 3051 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = trough;
	
	/* Methods. */
	var slice = [].slice;
	
	/* Create new middleware. */
	function trough() {
	  var fns = [];
	  var middleware = {};
	
	  middleware.run = run;
	  middleware.use = use;
	
	  return middleware;
	
	  /* Run `fns`.  Last argument must be
	   * a completion handler. */
	  function run() {
	    var index = -1;
	    var input = slice.call(arguments, 0, -1);
	    var done = arguments[arguments.length - 1];
	
	    if (typeof done !== 'function') {
	      throw new Error('Expected function as last argument, not ' + done);
	    }
	
	    next.apply(null, [null].concat(input));
	
	    /* Run the next `fn`, if any. */
	    function next(err) {
	      var fn = fns[++index];
	      var params = slice.call(arguments, 0);
	      var values = params.slice(1);
	      var length = input.length;
	      var pos = -1;
	
	      if (err) {
	        done(err);
	        return;
	      }
	
	      /* Copy non-nully input into values. */
	      while (++pos < length) {
	        if (values[pos] === null || values[pos] === undefined) {
	          values[pos] = input[pos];
	        }
	      }
	
	      input = values;
	
	      /* Next or done. */
	      if (fn) {
	        wrap(fn, next).apply(null, input);
	      } else {
	        done.apply(null, [null].concat(input));
	      }
	    }
	  }
	
	  /* Add `fn` to the list. */
	  function use(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Expected `fn` to be a function, not ' + fn);
	    }
	
	    fns.push(fn);
	
	    return middleware;
	  }
	}
	
	/* Wrap `fn`.  Can be sync or async; return a promise,
	 * receive a completion handler, return new values and
	 * errors. */
	function wrap(fn, next) {
	  var invoked;
	
	  return wrapped;
	
	  function wrapped() {
	    var params = slice.call(arguments, 0);
	    var callback = fn.length > params.length;
	    var result;
	
	    if (callback) {
	      params.push(done);
	    }
	
	    try {
	      result = fn.apply(null, params);
	    } catch (err) {
	      /* Well, this is quite the pickle.  `fn` received
	       * a callback and invoked it (thus continuing the
	       * pipeline), but later also threw an error.
	       * We’re not about to restart the pipeline again,
	       * so the only thing left to do is to throw the
	       * thing instea. */
	      if (callback && invoked) {
	        throw err;
	      }
	
	      return done(err);
	    }
	
	    if (!callback) {
	      if (result && typeof result.then === 'function') {
	        result.then(then, done);
	      } else if (result instanceof Error) {
	        done(result);
	      } else {
	        then(result);
	      }
	    }
	  }
	
	  /* Invoke `next`, only once. */
	  function done() {
	    if (!invoked) {
	      invoked = true;
	
	      next.apply(null, arguments);
	    }
	  }
	
	  /* Invoke `done` with one value.
	   * Tracks if an error is passed, too. */
	  function then(value) {
	    done(null, value);
	  }
	}


/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module unherit
	 * @fileoverview Create a custom constructor which can be modified
	 *   without affecting the original class.
	 */
	
	'use strict';
	
	/* Dependencies. */
	var xtend = __webpack_require__(139);
	var inherits = __webpack_require__(1551);
	
	/* Expose. */
	module.exports = unherit;
	
	/**
	 * Create a custom constructor which can be modified
	 * without affecting the original class.
	 *
	 * @param {Function} Super - Super-class.
	 * @return {Function} - Constructor acting like `Super`,
	 *   which can be modified without affecting the original
	 *   class.
	 */
	function unherit(Super) {
	  var result;
	  var key;
	  var value;
	
	  inherits(Of, Super);
	  inherits(From, Of);
	
	  /* Clone values. */
	  result = Of.prototype;
	
	  for (key in result) {
	    value = result[key];
	
	    if (value && typeof value === 'object') {
	      result[key] = 'concat' in value ? value.concat() : xtend(value);
	    }
	  }
	
	  return Of;
	
	  /**
	   * Constructor accepting a single argument,
	   * which itself is an `arguments` object.
	   */
	  function From(parameters) {
	    return Super.apply(this, parameters);
	  }
	
	  /**
	   * Constructor accepting variadic arguments.
	   */
	  function Of() {
	    if (!(this instanceof Of)) {
	      return new From(arguments);
	    }
	
	    return Super.apply(this, arguments);
	  }
	}


/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/* Dependencies. */
	var extend = __webpack_require__(1533);
	var bail = __webpack_require__(1188);
	var vfile = __webpack_require__(3109);
	var trough = __webpack_require__(3051);
	var string = __webpack_require__(3116);
	var func = __webpack_require__(3115);
	var plain = __webpack_require__(1581);
	
	/* Expose a frozen processor. */
	module.exports = unified().freeze();
	
	var slice = [].slice;
	var own = {}.hasOwnProperty;
	
	/* Process pipeline. */
	var pipeline = trough().use(pipelineParse).use(pipelineRun).use(pipelineStringify);
	
	function pipelineParse(p, ctx) {
	  ctx.tree = p.parse(ctx.file);
	}
	
	function pipelineRun(p, ctx, next) {
	  p.run(ctx.tree, ctx.file, done);
	
	  function done(err, tree, file) {
	    if (err) {
	      next(err);
	    } else {
	      ctx.tree = tree;
	      ctx.file = file;
	      next();
	    }
	  }
	}
	
	function pipelineStringify(p, ctx) {
	  ctx.file.contents = p.stringify(ctx.tree, ctx.file);
	}
	
	/* Function to create the first processor. */
	function unified() {
	  var attachers = [];
	  var transformers = trough();
	  var namespace = {};
	  var frozen = false;
	  var freezeIndex = -1;
	
	  /* Data management. */
	  processor.data = data;
	
	  /* Lock. */
	  processor.freeze = freeze;
	
	  /* Plug-ins. */
	  processor.attachers = attachers;
	  processor.use = use;
	
	  /* API. */
	  processor.parse = parse;
	  processor.stringify = stringify;
	  processor.run = run;
	  processor.runSync = runSync;
	  processor.process = process;
	  processor.processSync = processSync;
	
	  /* Expose. */
	  return processor;
	
	  /* Create a new processor based on the processor
	   * in the current scope. */
	  function processor() {
	    var destination = unified();
	    var length = attachers.length;
	    var index = -1;
	
	    while (++index < length) {
	      destination.use.apply(null, attachers[index]);
	    }
	
	    destination.data(extend(true, {}, namespace));
	
	    return destination;
	  }
	
	  /* Freeze: used to signal a processor that has finished
	   * configuration.
	   *
	   * For example, take unified itself.  It’s frozen.
	   * Plug-ins should not be added to it.  Rather, it should
	   * be extended, by invoking it, before modifying it.
	   *
	   * In essence, always invoke this when exporting a
	   * processor. */
	  function freeze() {
	    var values;
	    var plugin;
	    var options;
	    var transformer;
	
	    if (frozen) {
	      return processor;
	    }
	
	    while (++freezeIndex < attachers.length) {
	      values = attachers[freezeIndex];
	      plugin = values[0];
	      options = values[1];
	      transformer = null;
	
	      if (options === false) {
	        continue;
	      }
	
	      if (options === true) {
	        values[1] = undefined;
	      }
	
	      transformer = plugin.apply(processor, values.slice(1));
	
	      if (func(transformer)) {
	        transformers.use(transformer);
	      }
	    }
	
	    frozen = true;
	    freezeIndex = Infinity;
	
	    return processor;
	  }
	
	  /* Data management.
	   * Getter / setter for processor-specific informtion. */
	  function data(key, value) {
	    if (string(key)) {
	      /* Set `key`. */
	      if (arguments.length === 2) {
	        assertUnfrozen('data', frozen);
	
	        namespace[key] = value;
	
	        return processor;
	      }
	
	      /* Get `key`. */
	      return (own.call(namespace, key) && namespace[key]) || null;
	    }
	
	    /* Set space. */
	    if (key) {
	      assertUnfrozen('data', frozen);
	      namespace = key;
	      return processor;
	    }
	
	    /* Get space. */
	    return namespace;
	  }
	
	  /* Plug-in management.
	   *
	   * Pass it:
	   * *   an attacher and options,
	   * *   a preset,
	   * *   a list of presets, attachers, and arguments (list
	   *     of attachers and options). */
	  function use(value) {
	    var settings;
	
	    assertUnfrozen('use', frozen);
	
	    if (value === null || value === undefined) {
	      /* Empty */
	    } else if (func(value)) {
	      addPlugin.apply(null, arguments);
	    } else if (typeof value === 'object') {
	      if ('length' in value) {
	        addList(value);
	      } else {
	        addPreset(value);
	      }
	    } else {
	      throw new Error('Expected usable value, not `' + value + '`');
	    }
	
	    if (settings) {
	      namespace.settings = extend(namespace.settings || {}, settings);
	    }
	
	    return processor;
	
	    function addPreset(result) {
	      addList(result.plugins);
	
	      if (result.settings) {
	        settings = extend(settings || {}, result.settings);
	      }
	    }
	
	    function add(value) {
	      if (func(value)) {
	        addPlugin(value);
	      } else if (typeof value === 'object') {
	        if ('length' in value) {
	          addPlugin.apply(null, value);
	        } else {
	          addPreset(value);
	        }
	      } else {
	        throw new Error('Expected usable value, not `' + value + '`');
	      }
	    }
	
	    function addList(plugins) {
	      var length;
	      var index;
	
	      if (plugins === null || plugins === undefined) {
	        /* Empty */
	      } else if (typeof plugins === 'object' && 'length' in plugins) {
	        length = plugins.length;
	        index = -1;
	
	        while (++index < length) {
	          add(plugins[index]);
	        }
	      } else {
	        throw new Error('Expected a list of plugins, not `' + plugins + '`');
	      }
	    }
	
	    function addPlugin(plugin, value) {
	      var entry = find(plugin);
	
	      if (entry) {
	        if (plain(entry[1]) && plain(value)) {
	          value = extend(entry[1], value);
	        }
	
	        entry[1] = value;
	      } else {
	        attachers.push(slice.call(arguments));
	      }
	    }
	  }
	
	  function find(plugin) {
	    var length = attachers.length;
	    var index = -1;
	    var entry;
	
	    while (++index < length) {
	      entry = attachers[index];
	
	      if (entry[0] === plugin) {
	        return entry;
	      }
	    }
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the
	   * processor. */
	  function parse(doc) {
	    var file = vfile(doc);
	    var Parser;
	
	    freeze();
	    Parser = processor.Parser;
	    assertParser('parse', Parser);
	
	    if (newable(Parser)) {
	      return new Parser(String(file), file).parse();
	    }
	
	    return Parser(String(file), file); // eslint-disable-line new-cap
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), async. */
	  function run(node, file, cb) {
	    assertNode(node);
	    freeze();
	
	    if (!cb && func(file)) {
	      cb = file;
	      file = null;
	    }
	
	    if (!cb) {
	      return new Promise(executor);
	    }
	
	    executor(null, cb);
	
	    function executor(resolve, reject) {
	      transformers.run(node, vfile(file), done);
	
	      function done(err, tree, file) {
	        tree = tree || node;
	        if (err) {
	          reject(err);
	        } else if (resolve) {
	          resolve(tree);
	        } else {
	          cb(null, tree, file);
	        }
	      }
	    }
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), sync. */
	  function runSync(node, file) {
	    var complete = false;
	    var result;
	
	    run(node, file, done);
	
	    assertDone('runSync', 'run', complete);
	
	    return result;
	
	    function done(err, tree) {
	      complete = true;
	      bail(err);
	      result = tree;
	    }
	  }
	
	  /* Stringify a Unist node representation of a file
	   * (in string or VFile representation) into a string
	   * using the `Compiler` on the processor. */
	  function stringify(node, doc) {
	    var file = vfile(doc);
	    var Compiler;
	
	    freeze();
	    Compiler = processor.Compiler;
	    assertCompiler('stringify', Compiler);
	    assertNode(node);
	
	    if (newable(Compiler)) {
	      return new Compiler(node, file).compile();
	    }
	
	    return Compiler(node, file); // eslint-disable-line new-cap
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the processor,
	   * then run transforms on that node, and compile the
	   * resulting node using the `Compiler` on the processor,
	   * and store that result on the VFile. */
	  function process(doc, cb) {
	    freeze();
	    assertParser('process', processor.Parser);
	    assertCompiler('process', processor.Compiler);
	
	    if (!cb) {
	      return new Promise(executor);
	    }
	
	    executor(null, cb);
	
	    function executor(resolve, reject) {
	      var file = vfile(doc);
	
	      pipeline.run(processor, {file: file}, done);
	
	      function done(err) {
	        if (err) {
	          reject(err);
	        } else if (resolve) {
	          resolve(file);
	        } else {
	          cb(null, file);
	        }
	      }
	    }
	  }
	
	  /* Process the given document (in string or VFile
	   * representation), sync. */
	  function processSync(doc) {
	    var complete = false;
	    var file;
	
	    freeze();
	    assertParser('processSync', processor.Parser);
	    assertCompiler('processSync', processor.Compiler);
	    file = vfile(doc);
	
	    process(file, done);
	
	    assertDone('processSync', 'process', complete);
	
	    return file;
	
	    function done(err) {
	      complete = true;
	      bail(err);
	    }
	  }
	}
	
	/* Check if `func` is a constructor. */
	function newable(value) {
	  return func(value) && keys(value.prototype);
	}
	
	/* Check if `value` is an object with keys. */
	function keys(value) {
	  var key;
	  for (key in value) {
	    return true;
	  }
	  return false;
	}
	
	/* Assert a parser is available. */
	function assertParser(name, Parser) {
	  if (!func(Parser)) {
	    throw new Error('Cannot `' + name + '` without `Parser`');
	  }
	}
	
	/* Assert a compiler is available. */
	function assertCompiler(name, Compiler) {
	  if (!func(Compiler)) {
	    throw new Error('Cannot `' + name + '` without `Compiler`');
	  }
	}
	
	/* Assert the processor is not frozen. */
	function assertUnfrozen(name, frozen) {
	  if (frozen) {
	    throw new Error(
	      'Cannot invoke `' + name + '` on a frozen processor.\n' +
	      'Create a new processor first, by invoking it: ' +
	      'use `processor()` instead of `processor`.'
	    );
	  }
	}
	
	/* Assert `node` is a Unist node. */
	function assertNode(node) {
	  if (!node || !string(node.type)) {
	    throw new Error('Expected node, got `' + node + '`');
	  }
	}
	
	/* Assert that `complete` is `true`. */
	function assertDone(name, asyncName, complete) {
	  if (!complete) {
	    throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 3054 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable max-params */
	
	/* Expose. */
	module.exports = is;
	
	/* Assert if `test` passes for `node`.
	 * When a `parent` node is known the `index` of node */
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined;
	  var hasIndex = index !== null && index !== undefined;
	  var check = convert(test);
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node');
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node');
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false;
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index');
	  }
	
	  return Boolean(check.call(context, node, index, parent));
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test);
	  }
	
	  if (test === null || test === undefined) {
	    return ok;
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test);
	  }
	
	  if (typeof test === 'function') {
	    return test;
	  }
	
	  throw new Error('Expected function, string, or object as test');
	}
	
	function convertAll(tests) {
	  var results = [];
	  var length = tests.length;
	  var index = -1;
	
	  while (++index < length) {
	    results[index] = convert(tests[index]);
	  }
	
	  return results;
	}
	
	/* Utility assert each property in `test` is represented
	 * in `node`, and each values are strictly equal. */
	function matchesFactory(test) {
	  return matches;
	
	  function matches(node) {
	    var key;
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests);
	  var length = checks.length;
	
	  return matches;
	
	  function matches() {
	    var index = -1;
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	}
	
	/* Utility to convert a string into a function which checks
	 * a given node’s type for said string. */
	function typeFactory(test) {
	  return type;
	
	  function type(node) {
	    return Boolean(node && node.type === test);
	  }
	}
	
	/* Utility to return true. */
	function ok() {
	  return true;
	}


/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(294);
	
	module.exports = removePosition;
	
	/* Remove `position`s from `tree`. */
	function removePosition(node, force) {
	  visit(node, force ? hard : soft);
	  return node;
	}
	
	function hard(node) {
	  delete node.position;
	}
	
	function soft(node) {
	  node.position = undefined;
	}


/***/ }),
/* 3056 */
/***/ (function(module, exports) {

	'use strict';
	
	var own = {}.hasOwnProperty;
	
	module.exports = stringify;
	
	function stringify(value) {
	  /* Nothing. */
	  if (!value || typeof value !== 'object') {
	    return null;
	  }
	
	  /* Node. */
	  if (own.call(value, 'position') || own.call(value, 'type')) {
	    return location(value.position);
	  }
	
	  /* Location. */
	  if (own.call(value, 'start') || own.call(value, 'end')) {
	    return location(value);
	  }
	
	  /* Position. */
	  if (own.call(value, 'line') || own.call(value, 'column')) {
	    return position(value);
	  }
	
	  /* ? */
	  return null;
	}
	
	function position(pos) {
	  if (!pos || typeof pos !== 'object') {
	    pos = {};
	  }
	
	  return index(pos.line) + ':' + index(pos.column);
	}
	
	function location(loc) {
	  if (!loc || typeof loc !== 'object') {
	    loc = {};
	  }
	
	  return position(loc.start) + '-' + position(loc.end);
	}
	
	function index(value) {
	  return value && typeof value === 'number' ? value : 1;
	}


/***/ }),
/* 3057 */
1551,
/* 3058 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(3058);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(3057);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(61)))

/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(444);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function contains(str, elem) {
	  (0, _assertString2.default)(str);
	  return str.indexOf((0, _toString2.default)(elem)) >= 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equals;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equals(str, comparison) {
	  (0, _assertString2.default)(str);
	  return str === comparison;
	}
	module.exports = exports['default'];

/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.default = escape;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escape(str) {
	      (0, _assertString2.default)(str);
	      return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/`/g, '&#96;');
	}
	module.exports = exports['default'];

/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(443);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAfter(str) {
	  var date = arguments.length <= 1 || arguments[1] === undefined ? String(new Date()) : arguments[1];
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original > comparison);
	}
	module.exports = exports['default'];

/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlpha;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(835);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlpha(str) {
	  var locale = arguments.length <= 1 || arguments[1] === undefined ? 'en-US' : arguments[1];
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alpha) {
	    return _alpha.alpha[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlphanumeric;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(835);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlphanumeric(str) {
	  var locale = arguments.length <= 1 || arguments[1] === undefined ? 'en-US' : arguments[1];
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAscii;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var ascii = /^[\x00-\x7F]+$/;
	/* eslint-enable no-control-regex */
	
	function isAscii(str) {
	  (0, _assertString2.default)(str);
	  return ascii.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase64;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notBase64 = /[^A-Z0-9+\/=]/i;
	
	function isBase64(str) {
	  (0, _assertString2.default)(str);
	  var len = str.length;
	  if (!len || len % 4 !== 0 || notBase64.test(str)) {
	    return false;
	  }
	  var firstPaddingChar = str.indexOf('=');
	  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
	}
	module.exports = exports['default'];

/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(443);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBefore(str) {
	  var date = arguments.length <= 1 || arguments[1] === undefined ? String(new Date()) : arguments[1];
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original < comparison);
	}
	module.exports = exports['default'];

/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBoolean;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBoolean(str) {
	  (0, _assertString2.default)(str);
	  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})|62[0-9]{14}$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString2.default)(str);
	  var sanitized = str.replace(/[^0-9]+/g, '');
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = void 0;
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	module.exports = exports['default'];

/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCurrency;
	
	var _merge = __webpack_require__(228);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currencyRegex(options) {
	  var symbol = '(\\' + options.symbol.replace(/\./g, '\\.') + ')' + (options.require_symbol ? '' : '?'),
	      negative = '-?',
	      whole_dollar_amount_without_sep = '[1-9]\\d*',
	      whole_dollar_amount_with_sep = '[1-9]\\d{0,2}(\\' + options.thousands_separator + '\\d{3})*',
	      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
	      whole_dollar_amount = '(' + valid_whole_dollar_amounts.join('|') + ')?',
	      decimal_amount = '(\\' + options.decimal_separator + '\\d{2})?';
	  var pattern = whole_dollar_amount + decimal_amount;
	
	  // default is negative sign before symbol, but there are two other options (besides parens)
	  if (options.allow_negatives && !options.parens_for_negatives) {
	    if (options.negative_sign_after_digits) {
	      pattern += negative;
	    } else if (options.negative_sign_before_digits) {
	      pattern = negative + pattern;
	    }
	  }
	
	  // South African Rand, for example, uses R 123 (space) and R-123 (no space)
	  if (options.allow_negative_sign_placeholder) {
	    pattern = '( (?!\\-))?' + pattern;
	  } else if (options.allow_space_after_symbol) {
	    pattern = ' ?' + pattern;
	  } else if (options.allow_space_after_digits) {
	    pattern += '( (?!$))?';
	  }
	
	  if (options.symbol_after_digits) {
	    pattern += symbol;
	  } else {
	    pattern = symbol + pattern;
	  }
	
	  if (options.allow_negatives) {
	    if (options.parens_for_negatives) {
	      pattern = '(\\(' + pattern + '\\)|' + pattern + ')';
	    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
	      pattern = negative + pattern;
	    }
	  }
	
	  /* eslint-disable prefer-template */
	  return new RegExp('^' +
	  // ensure there's a dollar and/or decimal amount, and that
	  // it doesn't start with a space or a negative sign followed by a space
	  '(?!-? )(?=.*\\d)' + pattern + '$');
	  /* eslint-enable prefer-template */
	}
	
	var default_currency_options = {
	  symbol: '$',
	  require_symbol: false,
	  allow_space_after_symbol: false,
	  symbol_after_digits: false,
	  allow_negatives: true,
	  parens_for_negatives: false,
	  negative_sign_before_digits: false,
	  negative_sign_after_digits: false,
	  allow_negative_sign_placeholder: false,
	  thousands_separator: ',',
	  decimal_separator: '.',
	  allow_space_after_digits: false
	};
	
	function isCurrency(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_currency_options);
	  return currencyRegex(options).test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDataURI;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataURI = /^\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9!\$&',\(\)\*\+,;=\-\._~:@\/\?%\s]*\s*$/i; // eslint-disable-line max-len
	
	function isDataURI(str) {
	  (0, _assertString2.default)(str);
	  return dataURI.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isISO = __webpack_require__(843);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTimezoneOffset(str) {
	  var iso8601Parts = str.match(_isISO.iso8601);
	  var timezone = void 0,
	      sign = void 0,
	      hours = void 0,
	      minutes = void 0;
	  if (!iso8601Parts) {
	    str = str.toLowerCase();
	    timezone = str.match(/(?:\s|gmt\s*)(-|\+)(\d{1,4})(\s|$)/);
	    if (!timezone) {
	      return str.indexOf('gmt') !== -1 ? 0 : null;
	    }
	    sign = timezone[1];
	    var offset = timezone[2];
	    if (offset.length === 3) {
	      offset = '0' + offset;
	    }
	    if (offset.length <= 2) {
	      hours = 0;
	      minutes = parseInt(offset, 10);
	    } else {
	      hours = parseInt(offset.slice(0, 2), 10);
	      minutes = parseInt(offset.slice(2, 4), 10);
	    }
	  } else {
	    timezone = iso8601Parts[21];
	    if (!timezone) {
	      // if no hour/minute was provided, the date is GMT
	      return !iso8601Parts[12] ? 0 : null;
	    }
	    if (timezone === 'z' || timezone === 'Z') {
	      return 0;
	    }
	    sign = iso8601Parts[22];
	    if (timezone.indexOf(':') !== -1) {
	      hours = parseInt(iso8601Parts[23], 10);
	      minutes = parseInt(iso8601Parts[24], 10);
	    } else {
	      hours = 0;
	      minutes = parseInt(iso8601Parts[23], 10);
	    }
	  }
	  return (hours * 60 + minutes) * (sign === '-' ? 1 : -1);
	}
	
	function isDate(str) {
	  (0, _assertString2.default)(str);
	  var normalizedDate = new Date(Date.parse(str));
	  if (isNaN(normalizedDate)) {
	    return false;
	  }
	
	  // normalizedDate is in the user's timezone. Apply the input
	  // timezone offset to the date so that the year and day match
	  // the input
	  var timezoneOffset = getTimezoneOffset(str);
	  if (timezoneOffset !== null) {
	    var timezoneDifference = normalizedDate.getTimezoneOffset() - timezoneOffset;
	    normalizedDate = new Date(normalizedDate.getTime() + 60000 * timezoneDifference);
	  }
	
	  var day = String(normalizedDate.getDate());
	  var dayOrYear = void 0,
	      dayOrYearMatches = void 0,
	      year = void 0;
	  // check for valid double digits that could be late days
	  // check for all matches since a string like '12/23' is a valid date
	  // ignore everything with nearby colons
	  dayOrYearMatches = str.match(/(^|[^:\d])[23]\d([^T:\d]|$)/g);
	  if (!dayOrYearMatches) {
	    return true;
	  }
	  dayOrYear = dayOrYearMatches.map(function (digitString) {
	    return digitString.match(/\d+/g)[0];
	  }).join('/');
	
	  year = String(normalizedDate.getFullYear()).slice(-2);
	  if (dayOrYear === day || dayOrYear === year) {
	    return true;
	  } else if (dayOrYear === '' + day / year || dayOrYear === '' + year / day) {
	    return true;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDecimal;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var decimal = /^[-+]?([0-9]+|\.[0-9]+|[0-9]+\.[0-9]+)$/;
	
	function isDecimal(str) {
	  (0, _assertString2.default)(str);
	  return str !== '' && decimal.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDivisibleBy;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toFloat = __webpack_require__(846);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDivisibleBy(str, num) {
	  (0, _assertString2.default)(str);
	  return (0, _toFloat2.default)(str) % parseInt(num, 10) === 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFloat;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var float = /^(?:[-+]?(?:[0-9]+))?(?:\.[0-9]*)?(?:[eE][\+\-]?(?:[0-9]+))?$/;
	
	function isFloat(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	  if (str === '' || str === '.') {
	    return false;
	  }
	  return float.test(str) && (!options.hasOwnProperty('min') || str >= options.min) && (!options.hasOwnProperty('max') || str <= options.max);
	}
	module.exports = exports['default'];

/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexColor;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
	
	function isHexColor(str) {
	  (0, _assertString2.default)(str);
	  return hexcolor.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISBN;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
	var isbn13Maybe = /^(?:[0-9]{13})$/;
	var factor = [1, 3];
	
	function isISBN(str) {
	  var version = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isISBN(str, 10) || isISBN(str, 13);
	  }
	  var sanitized = str.replace(/[\s-]+/g, '');
	  var checksum = 0;
	  var i = void 0;
	  if (version === '10') {
	    if (!isbn10Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 9; i++) {
	      checksum += (i + 1) * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(9) === 'X') {
	      checksum += 10 * 10;
	    } else {
	      checksum += 10 * sanitized.charAt(9);
	    }
	    if (checksum % 11 === 0) {
	      return !!sanitized;
	    }
	  } else if (version === '13') {
	    if (!isbn13Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 12; i++) {
	      checksum += factor[i % 2] * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
	      return !!sanitized;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISIN;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
	
	function isISIN(str) {
	  (0, _assertString2.default)(str);
	  if (!isin.test(str)) {
	    return false;
	  }
	
	  var checksumStr = str.replace(/[A-Z]/g, function (character) {
	    return parseInt(character, 36);
	  });
	
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = true;
	  for (var i = checksumStr.length - 2; i >= 0; i--) {
	    digit = checksumStr.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	
	  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
	}
	module.exports = exports['default'];

/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isIn;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(444);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isIn(str, options) {
	  (0, _assertString2.default)(str);
	  var i = void 0;
	  if (Object.prototype.toString.call(options) === '[object Array]') {
	    var array = [];
	    for (i in options) {
	      if ({}.hasOwnProperty.call(options, i)) {
	        array[i] = (0, _toString2.default)(options[i]);
	      }
	    }
	    return array.indexOf(str) >= 0;
	  } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    return options.hasOwnProperty(str);
	  } else if (options && typeof options.indexOf === 'function') {
	    return options.indexOf(str) >= 0;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInt;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	var intLeadingZeroes = /^[-+]?[0-9]+$/;
	
	function isInt(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	
	  // Get the regex to use for testing, based on whether
	  // leading zeroes are allowed or not.
	  var regex = options.hasOwnProperty('allow_leading_zeroes') && options.allow_leading_zeroes ? intLeadingZeroes : int;
	
	  // Check min/max
	  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
	  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
	
	  return regex.test(str) && minCheckPassed && maxCheckPassed;
	}
	module.exports = exports['default'];

/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isJSON;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isJSON(str) {
	  (0, _assertString2.default)(str);
	  try {
	    var obj = JSON.parse(str);
	    return !!obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  } catch (e) {/* ignore */}
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isLength;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
	  var len = str.length - surrogatePairs.length;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLowercase;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLowercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toLowerCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMACAddress;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
	
	function isMACAddress(str) {
	  (0, _assertString2.default)(str);
	  return macAddress.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMD5;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md5 = /^[a-f0-9]{32}$/;
	
	function isMD5(str) {
	  (0, _assertString2.default)(str);
	  return md5.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobilePhone;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var phones = {
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
	  'da-DK': /^(\+?45)?(\d{8})$/,
	  'el-GR': /^(\+?30)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-HK': /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/,
	  'en-IN': /^(\+?91|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5)?|50)\s?(\d\s?){4,8}\d$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'ja-JP': /^(\+?81|0)\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/,
	  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'nl-BE': /^(\+?32|0)4?\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
	  'zh-CN': /^(\+?0?86\-?)?1[345789]\d{9}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
	};
	/* eslint-enable max-len */
	
	// aliases
	phones['en-CA'] = phones['en-US'];
	phones['fr-BE'] = phones['nl-BE'];
	
	function isMobilePhone(str, locale) {
	  (0, _assertString2.default)(str);
	  if (locale in phones) {
	    return phones[locale].test(str);
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMongoId;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isHexadecimal = __webpack_require__(841);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMongoId(str) {
	  (0, _assertString2.default)(str);
	  return (0, _isHexadecimal2.default)(str) && str.length === 24;
	}
	module.exports = exports['default'];

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMultibyte;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var multibyte = /[^\x00-\x7F]/;
	/* eslint-enable no-control-regex */
	
	function isMultibyte(str) {
	  (0, _assertString2.default)(str);
	  return multibyte.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNull;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isNull(str) {
	  (0, _assertString2.default)(str);
	  return str.length === 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumeric;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numeric = /^[-+]?[0-9]+$/;
	
	function isNumeric(str) {
	  (0, _assertString2.default)(str);
	  return numeric.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSurrogatePair;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
	
	function isSurrogatePair(str) {
	  (0, _assertString2.default)(str);
	  return surrogatePair.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFQDN = __webpack_require__(442);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isIP = __webpack_require__(842);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _merge = __webpack_require__(228);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString2.default)(url);
	  if (!url || url.length >= 2083 || /\s/.test(url)) {
	    return false;
	  }
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	  options = (0, _merge2.default)(options, default_url_options);
	  var protocol = void 0,
	      auth = void 0,
	      host = void 0,
	      hostname = void 0,
	      port = void 0,
	      port_str = void 0,
	      split = void 0,
	      ipv6 = void 0;
	
	  split = url.split('#');
	  url = split.shift();
	
	  split = url.split('?');
	  url = split.shift();
	
	  split = url.split('://');
	  if (split.length > 1) {
	    protocol = split.shift();
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
	    split[0] = url.substr(2);
	  }
	  url = split.join('://');
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	  if (split.length > 1) {
	    auth = split.shift();
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	  hostname = split.join('@');
	
	  port_str = ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6)) && host !== 'localhost') {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUUID;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uuid = {
	  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
	  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	
	function isUUID(str) {
	  var version = arguments.length <= 1 || arguments[1] === undefined ? 'all' : arguments[1];
	
	  (0, _assertString2.default)(str);
	  var pattern = uuid[version];
	  return pattern && pattern.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUppercase;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUppercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toUpperCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isVariableWidth;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFullWidth = __webpack_require__(839);
	
	var _isHalfWidth = __webpack_require__(840);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVariableWidth(str) {
	  (0, _assertString2.default)(str);
	  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWhitelisted;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWhitelisted(str, chars) {
	  (0, _assertString2.default)(str);
	  for (var i = str.length - 1; i >= 0; i--) {
	    if (chars.indexOf(str[i]) === -1) {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matches(str, pattern, modifiers) {
	  (0, _assertString2.default)(str);
	  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
	    pattern = new RegExp(pattern, modifiers);
	  }
	  return pattern.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeEmail;
	
	var _isEmail = __webpack_require__(838);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _merge = __webpack_require__(228);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_normalize_email_options = {
	  lowercase: true,
	  remove_dots: true,
	  remove_extension: true
	};
	
	function normalizeEmail(email, options) {
	  options = (0, _merge2.default)(options, default_normalize_email_options);
	  if (!(0, _isEmail2.default)(email)) {
	    return false;
	  }
	  var parts = email.split('@', 2);
	  parts[1] = parts[1].toLowerCase();
	  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
	    if (options.remove_extension) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (options.remove_dots) {
	      parts[0] = parts[0].replace(/\./g, '');
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    parts[0] = parts[0].toLowerCase();
	    parts[1] = 'gmail.com';
	  } else if (options.lowercase) {
	    parts[0] = parts[0].toLowerCase();
	  }
	  return parts.join('@');
	}
	module.exports = exports['default'];

/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripLow;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _blacklist = __webpack_require__(836);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripLow(str, keep_new_lines) {
	  (0, _assertString2.default)(str);
	  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
	  return (0, _blacklist2.default)(str, chars);
	}
	module.exports = exports['default'];

/***/ }),
/* 3101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toBoolean;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toBoolean(str, strict) {
	  (0, _assertString2.default)(str);
	  if (strict) {
	    return str === '1' || str === 'true';
	  }
	  return str !== '0' && str !== 'false' && str !== '';
	}
	module.exports = exports['default'];

/***/ }),
/* 3102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInt;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toInt(str, radix) {
	  (0, _assertString2.default)(str);
	  return parseInt(str, radix || 10);
	}
	module.exports = exports['default'];

/***/ }),
/* 3103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	var _rtrim = __webpack_require__(845);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _ltrim = __webpack_require__(844);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trim(str, chars) {
	  return (0, _rtrim2.default)((0, _ltrim2.default)(str, chars), chars);
	}
	module.exports = exports['default'];

/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.default = unescape;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unescape(str) {
	      (0, _assertString2.default)(str);
	      return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#96;/g, '`');
	}
	module.exports = exports['default'];

/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = whitelist;
	
	var _assertString = __webpack_require__(18);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whitelist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[^' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ }),
/* 3106 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = factory;
	
	/* Factory. */
	function factory(file) {
	  var contents = indices(String(file));
	
	  return {
	    toPosition: offsetToPositionFactory(contents),
	    toOffset: positionToOffsetFactory(contents)
	  };
	}
	
	/* Factory to get the line and column-based `position` for
	 * `offset` in the bound indices. */
	function offsetToPositionFactory(indices) {
	  return offsetToPosition;
	
	  /* Get the line and column-based `position` for
	   * `offset` in the bound indices. */
	  function offsetToPosition(offset) {
	    var index = -1;
	    var length = indices.length;
	
	    if (offset < 0) {
	      return {};
	    }
	
	    while (++index < length) {
	      if (indices[index] > offset) {
	        return {
	          line: index + 1,
	          column: (offset - (indices[index - 1] || 0)) + 1,
	          offset: offset
	        };
	      }
	    }
	
	    return {};
	  }
	}
	
	/* Factory to get the `offset` for a line and column-based
	 * `position` in the bound indices. */
	function positionToOffsetFactory(indices) {
	  return positionToOffset;
	
	  /* Get the `offset` for a line and column-based
	   * `position` in the bound indices. */
	  function positionToOffset(position) {
	    var line = position && position.line;
	    var column = position && position.column;
	
	    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
	      return ((indices[line - 2] || 0) + column - 1) || 0;
	    }
	
	    return -1;
	  }
	}
	
	/* Get indices of line-breaks in `value`. */
	function indices(value) {
	  var result = [];
	  var index = value.indexOf('\n');
	
	  while (index !== -1) {
	    result.push(index + 1);
	    index = value.indexOf('\n', index + 1);
	  }
	
	  result.push(value.length + 1);
	
	  return result;
	}


/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(3056);
	
	module.exports = VMessage;
	
	/* Inherit from `Error#`. */
	function VMessagePrototype() {}
	VMessagePrototype.prototype = Error.prototype;
	VMessage.prototype = new VMessagePrototype();
	
	/* Message properties. */
	var proto = VMessage.prototype;
	
	proto.file = '';
	proto.name = '';
	proto.reason = '';
	proto.message = '';
	proto.stack = '';
	proto.fatal = null;
	proto.column = null;
	proto.line = null;
	
	/* Construct a new VMessage.
	 *
	 * Note: We cannot invoke `Error` on the created context,
	 * as that adds readonly `line` and `column` attributes on
	 * Safari 9, thus throwing and failing the data. */
	function VMessage(reason, position, origin) {
	  var parts;
	  var range;
	  var location;
	
	  if (typeof position === 'string') {
	    origin = position;
	    position = null;
	  }
	
	  parts = parseOrigin(origin);
	  range = stringify(position) || '1:1';
	
	  location = {
	    start: {line: null, column: null},
	    end: {line: null, column: null}
	  };
	
	  /* Node. */
	  if (position && position.position) {
	    position = position.position;
	  }
	
	  if (position) {
	    /* Position. */
	    if (position.start) {
	      location = position;
	      position = position.start;
	    } else {
	      /* Point. */
	      location.start = position;
	    }
	  }
	
	  if (reason.stack) {
	    this.stack = reason.stack;
	    reason = reason.message;
	  }
	
	  this.message = reason;
	  this.name = range;
	  this.reason = reason;
	  this.line = position ? position.line : null;
	  this.column = position ? position.column : null;
	  this.location = location;
	  this.source = parts[0];
	  this.ruleId = parts[1];
	}
	
	function parseOrigin(origin) {
	  var result = [null, null];
	  var index;
	
	  if (typeof origin === 'string') {
	    index = origin.indexOf(':');
	
	    if (index === -1) {
	      result[1] = origin;
	    } else {
	      result[0] = origin.slice(0, index);
	      result[1] = origin.slice(index + 1);
	    }
	  }
	
	  return result;
	}


/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var path = __webpack_require__(750);
	var replace = __webpack_require__(3110);
	var buffer = __webpack_require__(1579);
	
	module.exports = VFile;
	
	var own = {}.hasOwnProperty;
	var proto = VFile.prototype;
	
	proto.toString = toString;
	
	/* Order of setting (least specific to most), we need this because
	 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
	 * is needed before a stem can be set. */
	var order = [
	  'history',
	  'path',
	  'basename',
	  'stem',
	  'extname',
	  'dirname'
	];
	
	/* Construct a new file. */
	function VFile(options) {
	  var prop;
	  var index;
	  var length;
	
	  if (!options) {
	    options = {};
	  } else if (typeof options === 'string' || buffer(options)) {
	    options = {contents: options};
	  } else if ('message' in options && 'messages' in options) {
	    return options;
	  }
	
	  if (!(this instanceof VFile)) {
	    return new VFile(options);
	  }
	
	  this.data = {};
	  this.messages = [];
	  this.history = [];
	  this.cwd = process.cwd();
	
	  /* Set path related properties in the correct order. */
	  index = -1;
	  length = order.length;
	
	  while (++index < length) {
	    prop = order[index];
	
	    if (own.call(options, prop)) {
	      this[prop] = options[prop];
	    }
	  }
	
	  /* Set non-path related properties. */
	  for (prop in options) {
	    if (order.indexOf(prop) === -1) {
	      this[prop] = options[prop];
	    }
	  }
	}
	
	/* Access full path (`~/index.min.js`). */
	Object.defineProperty(proto, 'path', {
	  get: function () {
	    return this.history[this.history.length - 1];
	  },
	  set: function (path) {
	    assertNonEmpty(path, 'path');
	
	    if (path !== this.path) {
	      this.history.push(path);
	    }
	  }
	});
	
	/* Access parent path (`~`). */
	Object.defineProperty(proto, 'dirname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
	  },
	  set: function (dirname) {
	    assertPath(this.path, 'dirname');
	    this.path = path.join(dirname || '', this.basename);
	  }
	});
	
	/* Access basename (`index.min.js`). */
	Object.defineProperty(proto, 'basename', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
	  },
	  set: function (basename) {
	    assertNonEmpty(basename, 'basename');
	    assertPart(basename, 'basename');
	    this.path = path.join(this.dirname || '', basename);
	  }
	});
	
	/* Access extname (`.js`). */
	Object.defineProperty(proto, 'extname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
	  },
	  set: function (extname) {
	    var ext = extname || '';
	
	    assertPart(ext, 'extname');
	    assertPath(this.path, 'extname');
	
	    if (ext) {
	      if (ext.charAt(0) !== '.') {
	        throw new Error('`extname` must start with `.`');
	      }
	
	      if (ext.indexOf('.', 1) !== -1) {
	        throw new Error('`extname` cannot contain multiple dots');
	      }
	    }
	
	    this.path = replace(this.path, ext);
	  }
	});
	
	/* Access stem (`index.min`). */
	Object.defineProperty(proto, 'stem', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
	  },
	  set: function (stem) {
	    assertNonEmpty(stem, 'stem');
	    assertPart(stem, 'stem');
	    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
	  }
	});
	
	/* Get the value of the file. */
	function toString(encoding) {
	  var value = this.contents || '';
	  return buffer(value) ? value.toString(encoding) : String(value);
	}
	
	/* Assert that `part` is not a path (i.e., does
	 * not contain `path.sep`). */
	function assertPart(part, name) {
	  if (part.indexOf(path.sep) !== -1) {
	    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
	  }
	}
	
	/* Assert that `part` is not empty. */
	function assertNonEmpty(part, name) {
	  if (!part) {
	    throw new Error('`' + name + '` cannot be empty');
	  }
	}
	
	/* Assert `path` exists. */
	function assertPath(path, name) {
	  if (!path) {
	    throw new Error('Setting `' + name + '` requires `path` to be set too');
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var VMessage = __webpack_require__(3107);
	var VFile = __webpack_require__(3108);
	
	module.exports = VFile;
	
	var proto = VFile.prototype;
	
	proto.message = message;
	proto.info = info;
	proto.fail = fail;
	
	/* Slight backwards compatibility.  Remove in the future. */
	proto.warn = message;
	
	/* Create a message with `reason` at `position`.
	 * When an error is passed in as `reason`, copies the stack. */
	function message(reason, position, origin) {
	  var filePath = this.path;
	  var message = new VMessage(reason, position, origin);
	
	  if (filePath) {
	    message.name = filePath + ':' + message.name;
	    message.file = filePath;
	  }
	
	  message.fatal = false;
	
	  this.messages.push(message);
	
	  return message;
	}
	
	/* Fail. Creates a vmessage, associates it with the file,
	 * and throws it. */
	function fail() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = true;
	
	  throw message;
	}
	
	/* Info. Creates a vmessage, associates it with the file,
	 * and marks the fatality as null. */
	function info() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = null;
	
	  return message;
	}


/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(750);
	
	function replaceExt(npath, ext) {
	  if (typeof npath !== 'string') {
	    return npath;
	  }
	
	  if (npath.length === 0) {
	    return npath;
	  }
	
	  var nFileName = path.basename(npath, path.extname(npath)) + ext;
	  return path.join(path.dirname(npath), nFileName);
	}
	
	module.exports = replaceExt;


/***/ }),
/* 3111 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 3112 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 3113 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 3114 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module), (function() { return this; }())))

/***/ }),
/* 3115 */
/***/ (function(module, exports) {

	module.exports = function isFunction (fn) {
	  return Object.prototype.toString.call(fn) === '[object Function]'
	}


/***/ }),
/* 3116 */
/***/ (function(module, exports) {

	var toString = Object.prototype.toString
	
	module.exports = isString
	
	function isString(obj) {
	    return toString.call(obj) === "[object String]"
	}


/***/ }),
/* 3117 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 3118 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 3119 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 3120 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 3121 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 3122 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 3124 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 3128 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 3131 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 3132 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_5__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_6__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_7__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_8__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_9__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 3136 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 3137 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (object, el) {
	  var O = toIObject(object);
	  var keys = getKeys(O);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) if (O[key = keys[index++]] === el) return key;
	};


/***/ }),
/* 3138 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 3139 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	var toObject = __webpack_require__(__webpack_module_template_argument_3__);
	var IObject = __webpack_require__(__webpack_module_template_argument_4__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_5__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 3140 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 3141 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 3142 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 3143 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 3144 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 3145 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 3146 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 3147 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 3148 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 3149 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 3150 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 3151 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 3152 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 3153 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 3154 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 3155 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 3165 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 3166 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var isInteger = __webpack_require__(__webpack_module_template_argument_1__);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 3167 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f });


/***/ }),
/* 3170 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(__webpack_module_template_argument_0__)('getOwnPropertyNames', function () {
	  return __webpack_require__(__webpack_module_template_argument_1__).f;
	});


/***/ }),
/* 3171 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getPrototypeOf = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 3172 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 3173 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ }),
/* 3174 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 3175 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var keyOf = __webpack_require__(__webpack_module_template_argument_13__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_14__);
	var isArray = __webpack_require__(__webpack_module_template_argument_15__);
	var anObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_18__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_19__);
	var _create = __webpack_require__(__webpack_module_template_argument_20__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_21__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_22__);
	var $DP = __webpack_require__(__webpack_module_template_argument_23__);
	var $keys = __webpack_require__(__webpack_module_template_argument_24__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_25__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_26__).f = $propertyIsEnumerable;
	  __webpack_require__(__webpack_module_template_argument_27__).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_28__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key) {
	    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_29__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 3176 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ }),
/* 3177 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ }),
/* 3178 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production","CLIENT":true,"PORT":3000,"GIT_INFO":"Branch: release-4.53.0\nCommit: 568e257fa"}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 3179 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 3180 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ })
]);


// WEBPACK FOOTER //
// bundle.js